// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 width=%278%27 height=%278%27 viewBox=%270 0 8 8%27%3e%3cpath fill=%27%23fff%27 d=%27M6.564.75l-3.59 3.612-1.538-1.55L0 4.26l2.974 2.99L8 2.193z%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 width=%274%27 height=%274%27 viewBox=%270 0 4 4%27%3e%3cpath stroke=%27%23fff%27 d=%27M0 2h4%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_2___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 width=%2712%27 height=%2712%27 viewBox=%27-4 -4 8 8%27%3e%3ccircle r=%273%27 fill=%27%23fff%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_3___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 width=%274%27 height=%275%27 viewBox=%270 0 4 5%27%3e%3cpath fill=%27%2332325d%27 d=%27M2 0L0 2h4zm0 5L0 3h4z%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_4___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 width=%2730%27 height=%2730%27 viewBox=%270 0 30 30%27%3e%3cpath stroke=%27rgba%280, 0, 0, 0.5%29%27 stroke-linecap=%27round%27 stroke-miterlimit=%2710%27 stroke-width=%272%27 d=%27M4 7h22M4 15h22M4 23h22%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_5___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 width=%2730%27 height=%2730%27 viewBox=%270 0 30 30%27%3e%3cpath stroke=%27rgba%28255, 255, 255, 0.95%29%27 stroke-linecap=%27round%27 stroke-miterlimit=%2710%27 stroke-width=%272%27 d=%27M4 7h22M4 15h22M4 23h22%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_6___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 fill=%27%23fff%27 width=%278%27 height=%278%27 viewBox=%270 0 8 8%27%3e%3cpath d=%27M5.25 0l-4 4 4 4 1.5-1.5L4.25 4l2.5-2.5L5.25 0z%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_7___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 fill=%27%23fff%27 width=%278%27 height=%278%27 viewBox=%270 0 8 8%27%3e%3cpath d=%27M2.75 0l-1.5 1.5L3.75 4l-2.5 2.5L2.75 8l4-4-4-4z%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_8___ = new URL("data:image/svg+xml,<svg xmlns=%27http://www.w3.org/2000/svg%27 width=%278%27 height=%278%27 viewBox=%270 0 8 8%27><path fill=%27#fff%27 d=%27M6.564.75l-3.59 3.612-1.538-1.55L0 4.26l2.974 2.99L8 2.193z%27/></svg>", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_9___ = new URL("data:image/svg+xml,<svg xmlns=%27http://www.w3.org/2000/svg%27 width=%2712%27 height=%2712%27 viewBox=%27-4 -4 8 8%27><circle r=%273%27 fill=%27#fff%27/></svg>", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_10___ = new URL("data:image/svg+xml,<svg xmlns=%27http://www.w3.org/2000/svg%27 width=%2730%27 height=%2730%27 viewBox=%270 0 30 30%27><path stroke=%27rgba%28255, 255, 255, 0.95%29%27 stroke-linecap=%27round%27 stroke-miterlimit=%2710%27 stroke-width=%272%27 d=%27M4 7h22M4 15h22M4 23h22%27/></svg>", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_11___ = new URL("data:image/svg+xml;charset=utf8,%3Csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%270 0 8 8%27%3E%3Cpath fill=%27%23292b2c%27 d=%27M2.3 6.73L.6 4.53c-.4-1.04.46-1.4 1.1-.8l1.1 1.4 3.4-3.8c.6-.63 1.6-.27 1.2.7l-4 4.6c-.43.5-.8.4-1.1.1z%27/%3E%3C/svg%3E", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
var ___CSS_LOADER_URL_REPLACEMENT_2___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_2___);
var ___CSS_LOADER_URL_REPLACEMENT_3___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_3___);
var ___CSS_LOADER_URL_REPLACEMENT_4___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_4___);
var ___CSS_LOADER_URL_REPLACEMENT_5___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_5___);
var ___CSS_LOADER_URL_REPLACEMENT_6___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_6___);
var ___CSS_LOADER_URL_REPLACEMENT_7___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_7___);
var ___CSS_LOADER_URL_REPLACEMENT_8___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_8___);
var ___CSS_LOADER_URL_REPLACEMENT_9___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_9___);
var ___CSS_LOADER_URL_REPLACEMENT_10___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_10___);
var ___CSS_LOADER_URL_REPLACEMENT_11___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_11___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@charset "UTF-8";
:root {
  --blue: #3ba371;
  --indigo: #5603ad;
  --purple: #8965e0;
  --pink: #f3a4b5;
  --red: #f5365c;
  --orange: #fb6340;
  --yellow: #ffd600;
  --green: #3aa170;
  --teal: #278e69;
  --cyan: #2bffc6;
  --white: #fff;
  --gray: #8898aa;
  --gray-dark: #32325d;
  --light: #ced4da;
  --lighter: #e9ecef;
  --primary: #3ba371;
  --secondary: #f7fafc;
  --success: #3aa170;
  --info: #278e69;
  --warning: #fb6340;
  --danger: #f5365c;
  --light: #adb5bd;
  --dark: #212529;
  --default: #ffd88c;
  --white: #fff;
  --neutral: #fff;
  --darker: black;
  --breakpoint-xs: 0;
  --breakpoint-sm: 576px;
  --breakpoint-md: 768px;
  --breakpoint-lg: 992px;
  --breakpoint-xl: 1200px;
  --font-family-sans-serif: Open Sans, sans-serif;
  --font-family-monospace: SFMono-Regular, Menlo, Monaco, Consolas, "Liberation Mono", "Courier New", monospace;
}

*,
*::before,
*::after {
  box-sizing: border-box;
}

html {
  font-family: sans-serif;
  line-height: 1.15;
  -webkit-text-size-adjust: 100%;
  -webkit-tap-highlight-color: rgba(0, 0, 0, 0);
}

article, aside, figcaption, figure, footer, header, hgroup, main, nav, section {
  display: block;
}

body {
  margin: 0;
  font-family: Open Sans, sans-serif;
  font-size: 1rem;
  font-weight: 400;
  line-height: 1.5;
  color: #525f7f;
  text-align: left;
  background-color: #f8f9fe;
}

[tabindex="-1"]:focus:not(:focus-visible) {
  outline: 0 !important;
}

hr {
  box-sizing: content-box;
  height: 0;
  overflow: visible;
}

h1, h2, h3, h4, h5, h6 {
  margin-top: 0;
  margin-bottom: 0.5rem;
}

p {
  margin-top: 0;
  margin-bottom: 1rem;
}

abbr[title],
abbr[data-original-title] {
  text-decoration: underline;
  -webkit-text-decoration: underline dotted;
          text-decoration: underline dotted;
  cursor: help;
  border-bottom: 0;
  text-decoration-skip-ink: none;
}

address {
  margin-bottom: 1rem;
  font-style: normal;
  line-height: inherit;
}

ol,
ul,
dl {
  margin-top: 0;
  margin-bottom: 1rem;
}

ol ol,
ul ul,
ol ul,
ul ol {
  margin-bottom: 0;
}

dt {
  font-weight: 600;
}

dd {
  margin-bottom: 0.5rem;
  margin-left: 0;
}

blockquote {
  margin: 0 0 1rem;
}

b,
strong {
  font-weight: bolder;
}

small {
  font-size: 80%;
}

sub,
sup {
  position: relative;
  font-size: 75%;
  line-height: 0;
  vertical-align: baseline;
}

sub {
  bottom: -0.25em;
}

sup {
  top: -0.5em;
}

a {
  color: #3ba371;
  text-decoration: none;
  background-color: transparent;
}
a:hover {
  color: rgb(38.6689189189, 106.8310810811, 74.0608108108);
  text-decoration: none;
}

a:not([href]):not([class]) {
  color: inherit;
  text-decoration: none;
}
a:not([href]):not([class]):hover {
  color: inherit;
  text-decoration: none;
}

pre,
code,
kbd,
samp {
  font-family: SFMono-Regular, Menlo, Monaco, Consolas, "Liberation Mono", "Courier New", monospace;
  font-size: 1em;
}

pre {
  margin-top: 0;
  margin-bottom: 1rem;
  overflow: auto;
  -ms-overflow-style: scrollbar;
}

figure {
  margin: 0 0 1rem;
}

img {
  vertical-align: middle;
  border-style: none;
}

svg {
  overflow: hidden;
  vertical-align: middle;
}

table {
  border-collapse: collapse;
}

caption {
  padding-top: 1rem;
  padding-bottom: 1rem;
  color: #8898aa;
  text-align: left;
  caption-side: bottom;
}

th {
  text-align: inherit;
  text-align: -webkit-match-parent;
}

label {
  display: inline-block;
  margin-bottom: 0.5rem;
}

button {
  border-radius: 0;
}

button:focus:not(:focus-visible) {
  outline: 0;
}

input,
button,
select,
optgroup,
textarea {
  margin: 0;
  font-family: inherit;
  font-size: inherit;
  line-height: inherit;
}

button,
input {
  overflow: visible;
}

button,
select {
  text-transform: none;
}

[role=button] {
  cursor: pointer;
}

select {
  word-wrap: normal;
}

button,
[type=button],
[type=reset],
[type=submit] {
  -webkit-appearance: button;
}

button:not(:disabled),
[type=button]:not(:disabled),
[type=reset]:not(:disabled),
[type=submit]:not(:disabled) {
  cursor: pointer;
}

button::-moz-focus-inner,
[type=button]::-moz-focus-inner,
[type=reset]::-moz-focus-inner,
[type=submit]::-moz-focus-inner {
  padding: 0;
  border-style: none;
}

input[type=radio],
input[type=checkbox] {
  box-sizing: border-box;
  padding: 0;
}

textarea {
  overflow: auto;
  resize: vertical;
}

fieldset {
  min-width: 0;
  padding: 0;
  margin: 0;
  border: 0;
}

legend {
  display: block;
  width: 100%;
  max-width: 100%;
  padding: 0;
  margin-bottom: 0.5rem;
  font-size: 1.5rem;
  line-height: inherit;
  color: inherit;
  white-space: normal;
}

progress {
  vertical-align: baseline;
}

[type=number]::-webkit-inner-spin-button,
[type=number]::-webkit-outer-spin-button {
  height: auto;
}

[type=search] {
  outline-offset: -2px;
  -webkit-appearance: none;
}

[type=search]::-webkit-search-decoration {
  -webkit-appearance: none;
}

::-webkit-file-upload-button {
  font: inherit;
  -webkit-appearance: button;
}

output {
  display: inline-block;
}

summary {
  display: list-item;
  cursor: pointer;
}

template {
  display: none;
}

[hidden] {
  display: none !important;
}

h1, h2, h3, h4, h5, h6,
.h1, .h2, .h3, .h4, .h5, .h6 {
  margin-bottom: 0.5rem;
  font-family: inherit;
  font-weight: 600;
  line-height: 1.5;
  color: #32325d;
}

h1, .h1 {
  font-size: 1.625rem;
}

h2, .h2 {
  font-size: 1.25rem;
}

h3, .h3 {
  font-size: 1.0625rem;
}

h4, .h4 {
  font-size: 0.9375rem;
}

h5, .h5 {
  font-size: 0.8125rem;
}

h6, .h6 {
  font-size: 0.625rem;
}

.lead {
  font-size: 1.25rem;
  font-weight: 300;
}

.display-1 {
  font-size: 3.3rem;
  font-weight: 600;
  line-height: 1.5;
}

.display-2 {
  font-size: 2.75rem;
  font-weight: 600;
  line-height: 1.5;
}

.display-3 {
  font-size: 2.1875rem;
  font-weight: 600;
  line-height: 1.5;
}

.display-4 {
  font-size: 1.6275rem;
  font-weight: 600;
  line-height: 1.5;
}

hr {
  margin-top: 2rem;
  margin-bottom: 2rem;
  border: 0;
  border-top: 1px solid rgba(0, 0, 0, 0.1);
}

small,
.small {
  font-size: 80%;
  font-weight: 400;
}

mark,
.mark {
  padding: 0.2em;
  background-color: #fcf8e3;
}

.list-unstyled {
  padding-left: 0;
  list-style: none;
}

.list-inline {
  padding-left: 0;
  list-style: none;
}

.list-inline-item {
  display: inline-block;
}
.list-inline-item:not(:last-child) {
  margin-right: 0.5rem;
}

.initialism {
  font-size: 90%;
  text-transform: uppercase;
}

.blockquote {
  margin-bottom: 1rem;
  font-size: 1.25rem;
}

.blockquote-footer {
  display: block;
  font-size: 80%;
  color: #8898aa;
}
.blockquote-footer::before {
  content: "— ";
}

.img-fluid {
  max-width: 100%;
  height: auto;
}

.img-thumbnail {
  padding: 0.25rem;
  background-color: #f8f9fe;
  border: 1px solid #dee2e6;
  border-radius: 0.375rem;
  box-shadow: 0 1px 2px rgba(0, 0, 0, 0.075);
  max-width: 100%;
  height: auto;
}

.figure {
  display: inline-block;
}

.figure-img {
  margin-bottom: 0.5rem;
  line-height: 1;
}

.figure-caption {
  font-size: 90%;
  color: #8898aa;
}

code {
  font-size: 87.5%;
  color: #f3a4b5;
  word-wrap: break-word;
}
a > code {
  color: inherit;
}

kbd {
  padding: 0.2rem 0.4rem;
  font-size: 87.5%;
  color: #fff;
  background-color: #212529;
  border-radius: 0.25rem;
  box-shadow: inset 0 -0.1rem 0 rgba(0, 0, 0, 0.25);
}
kbd kbd {
  padding: 0;
  font-size: 100%;
  font-weight: 600;
  box-shadow: none;
}

pre {
  display: block;
  font-size: 87.5%;
  color: #212529;
}
pre code {
  font-size: inherit;
  color: inherit;
  word-break: normal;
}

.pre-scrollable {
  max-height: 340px;
  overflow-y: scroll;
}

.container,
.container-fluid,
.container-xl,
.container-lg,
.container-md,
.container-sm {
  width: 100%;
  padding-right: 15px;
  padding-left: 15px;
  margin-right: auto;
  margin-left: auto;
}

@media (min-width: 576px) {
  .container-sm, .container {
    max-width: 540px;
  }
}
@media (min-width: 768px) {
  .container-md, .container-sm, .container {
    max-width: 720px;
  }
}
@media (min-width: 992px) {
  .container-lg, .container-md, .container-sm, .container {
    max-width: 960px;
  }
}
@media (min-width: 1200px) {
  .container-xl, .container-lg, .container-md, .container-sm, .container {
    max-width: 1140px;
  }
}
.row {
  display: flex;
  flex-wrap: wrap;
  margin-right: -15px;
  margin-left: -15px;
}

.no-gutters {
  margin-right: 0;
  margin-left: 0;
}
.no-gutters > .col,
.no-gutters > [class*=col-] {
  padding-right: 0;
  padding-left: 0;
}

.col-xl,
.col-xl-auto, .col-xl-12, .col-xl-11, .col-xl-10, .col-xl-9, .col-xl-8, .col-xl-7, .col-xl-6, .col-xl-5, .col-xl-4, .col-xl-3, .col-xl-2, .col-xl-1, .col-lg,
.col-lg-auto, .col-lg-12, .col-lg-11, .col-lg-10, .col-lg-9, .col-lg-8, .col-lg-7, .col-lg-6, .col-lg-5, .col-lg-4, .col-lg-3, .col-lg-2, .col-lg-1, .col-md,
.col-md-auto, .col-md-12, .col-md-11, .col-md-10, .col-md-9, .col-md-8, .col-md-7, .col-md-6, .col-md-5, .col-md-4, .col-md-3, .col-md-2, .col-md-1, .col-sm,
.col-sm-auto, .col-sm-12, .col-sm-11, .col-sm-10, .col-sm-9, .col-sm-8, .col-sm-7, .col-sm-6, .col-sm-5, .col-sm-4, .col-sm-3, .col-sm-2, .col-sm-1, .col,
.col-auto, .col-12, .col-11, .col-10, .col-9, .col-8, .col-7, .col-6, .col-5, .col-4, .col-3, .col-2, .col-1 {
  position: relative;
  width: 100%;
  padding-right: 15px;
  padding-left: 15px;
}

.col {
  flex-basis: 0;
  flex-grow: 1;
  max-width: 100%;
}

.row-cols-1 > * {
  flex: 0 0 100%;
  max-width: 100%;
}

.row-cols-2 > * {
  flex: 0 0 50%;
  max-width: 50%;
}

.row-cols-3 > * {
  flex: 0 0 33.3333333333%;
  max-width: 33.3333333333%;
}

.row-cols-4 > * {
  flex: 0 0 25%;
  max-width: 25%;
}

.row-cols-5 > * {
  flex: 0 0 20%;
  max-width: 20%;
}

.row-cols-6 > * {
  flex: 0 0 16.6666666667%;
  max-width: 16.6666666667%;
}

.col-auto {
  flex: 0 0 auto;
  width: auto;
  max-width: 100%;
}

.col-1 {
  flex: 0 0 8.3333333333%;
  max-width: 8.3333333333%;
}

.col-2 {
  flex: 0 0 16.6666666667%;
  max-width: 16.6666666667%;
}

.col-3 {
  flex: 0 0 25%;
  max-width: 25%;
}

.col-4 {
  flex: 0 0 33.3333333333%;
  max-width: 33.3333333333%;
}

.col-5 {
  flex: 0 0 41.6666666667%;
  max-width: 41.6666666667%;
}

.col-6 {
  flex: 0 0 50%;
  max-width: 50%;
}

.col-7 {
  flex: 0 0 58.3333333333%;
  max-width: 58.3333333333%;
}

.col-8 {
  flex: 0 0 66.6666666667%;
  max-width: 66.6666666667%;
}

.col-9 {
  flex: 0 0 75%;
  max-width: 75%;
}

.col-10 {
  flex: 0 0 83.3333333333%;
  max-width: 83.3333333333%;
}

.col-11 {
  flex: 0 0 91.6666666667%;
  max-width: 91.6666666667%;
}

.col-12 {
  flex: 0 0 100%;
  max-width: 100%;
}

.order-first {
  order: -1;
}

.order-last {
  order: 13;
}

.order-0 {
  order: 0;
}

.order-1 {
  order: 1;
}

.order-2 {
  order: 2;
}

.order-3 {
  order: 3;
}

.order-4 {
  order: 4;
}

.order-5 {
  order: 5;
}

.order-6 {
  order: 6;
}

.order-7 {
  order: 7;
}

.order-8 {
  order: 8;
}

.order-9 {
  order: 9;
}

.order-10 {
  order: 10;
}

.order-11 {
  order: 11;
}

.order-12 {
  order: 12;
}

.offset-1 {
  margin-left: 8.3333333333%;
}

.offset-2 {
  margin-left: 16.6666666667%;
}

.offset-3 {
  margin-left: 25%;
}

.offset-4 {
  margin-left: 33.3333333333%;
}

.offset-5 {
  margin-left: 41.6666666667%;
}

.offset-6 {
  margin-left: 50%;
}

.offset-7 {
  margin-left: 58.3333333333%;
}

.offset-8 {
  margin-left: 66.6666666667%;
}

.offset-9 {
  margin-left: 75%;
}

.offset-10 {
  margin-left: 83.3333333333%;
}

.offset-11 {
  margin-left: 91.6666666667%;
}

@media (min-width: 576px) {
  .col-sm {
    flex-basis: 0;
    flex-grow: 1;
    max-width: 100%;
  }
  .row-cols-sm-1 > * {
    flex: 0 0 100%;
    max-width: 100%;
  }
  .row-cols-sm-2 > * {
    flex: 0 0 50%;
    max-width: 50%;
  }
  .row-cols-sm-3 > * {
    flex: 0 0 33.3333333333%;
    max-width: 33.3333333333%;
  }
  .row-cols-sm-4 > * {
    flex: 0 0 25%;
    max-width: 25%;
  }
  .row-cols-sm-5 > * {
    flex: 0 0 20%;
    max-width: 20%;
  }
  .row-cols-sm-6 > * {
    flex: 0 0 16.6666666667%;
    max-width: 16.6666666667%;
  }
  .col-sm-auto {
    flex: 0 0 auto;
    width: auto;
    max-width: 100%;
  }
  .col-sm-1 {
    flex: 0 0 8.3333333333%;
    max-width: 8.3333333333%;
  }
  .col-sm-2 {
    flex: 0 0 16.6666666667%;
    max-width: 16.6666666667%;
  }
  .col-sm-3 {
    flex: 0 0 25%;
    max-width: 25%;
  }
  .col-sm-4 {
    flex: 0 0 33.3333333333%;
    max-width: 33.3333333333%;
  }
  .col-sm-5 {
    flex: 0 0 41.6666666667%;
    max-width: 41.6666666667%;
  }
  .col-sm-6 {
    flex: 0 0 50%;
    max-width: 50%;
  }
  .col-sm-7 {
    flex: 0 0 58.3333333333%;
    max-width: 58.3333333333%;
  }
  .col-sm-8 {
    flex: 0 0 66.6666666667%;
    max-width: 66.6666666667%;
  }
  .col-sm-9 {
    flex: 0 0 75%;
    max-width: 75%;
  }
  .col-sm-10 {
    flex: 0 0 83.3333333333%;
    max-width: 83.3333333333%;
  }
  .col-sm-11 {
    flex: 0 0 91.6666666667%;
    max-width: 91.6666666667%;
  }
  .col-sm-12 {
    flex: 0 0 100%;
    max-width: 100%;
  }
  .order-sm-first {
    order: -1;
  }
  .order-sm-last {
    order: 13;
  }
  .order-sm-0 {
    order: 0;
  }
  .order-sm-1 {
    order: 1;
  }
  .order-sm-2 {
    order: 2;
  }
  .order-sm-3 {
    order: 3;
  }
  .order-sm-4 {
    order: 4;
  }
  .order-sm-5 {
    order: 5;
  }
  .order-sm-6 {
    order: 6;
  }
  .order-sm-7 {
    order: 7;
  }
  .order-sm-8 {
    order: 8;
  }
  .order-sm-9 {
    order: 9;
  }
  .order-sm-10 {
    order: 10;
  }
  .order-sm-11 {
    order: 11;
  }
  .order-sm-12 {
    order: 12;
  }
  .offset-sm-0 {
    margin-left: 0;
  }
  .offset-sm-1 {
    margin-left: 8.3333333333%;
  }
  .offset-sm-2 {
    margin-left: 16.6666666667%;
  }
  .offset-sm-3 {
    margin-left: 25%;
  }
  .offset-sm-4 {
    margin-left: 33.3333333333%;
  }
  .offset-sm-5 {
    margin-left: 41.6666666667%;
  }
  .offset-sm-6 {
    margin-left: 50%;
  }
  .offset-sm-7 {
    margin-left: 58.3333333333%;
  }
  .offset-sm-8 {
    margin-left: 66.6666666667%;
  }
  .offset-sm-9 {
    margin-left: 75%;
  }
  .offset-sm-10 {
    margin-left: 83.3333333333%;
  }
  .offset-sm-11 {
    margin-left: 91.6666666667%;
  }
}
@media (min-width: 768px) {
  .col-md {
    flex-basis: 0;
    flex-grow: 1;
    max-width: 100%;
  }
  .row-cols-md-1 > * {
    flex: 0 0 100%;
    max-width: 100%;
  }
  .row-cols-md-2 > * {
    flex: 0 0 50%;
    max-width: 50%;
  }
  .row-cols-md-3 > * {
    flex: 0 0 33.3333333333%;
    max-width: 33.3333333333%;
  }
  .row-cols-md-4 > * {
    flex: 0 0 25%;
    max-width: 25%;
  }
  .row-cols-md-5 > * {
    flex: 0 0 20%;
    max-width: 20%;
  }
  .row-cols-md-6 > * {
    flex: 0 0 16.6666666667%;
    max-width: 16.6666666667%;
  }
  .col-md-auto {
    flex: 0 0 auto;
    width: auto;
    max-width: 100%;
  }
  .col-md-1 {
    flex: 0 0 8.3333333333%;
    max-width: 8.3333333333%;
  }
  .col-md-2 {
    flex: 0 0 16.6666666667%;
    max-width: 16.6666666667%;
  }
  .col-md-3 {
    flex: 0 0 25%;
    max-width: 25%;
  }
  .col-md-4 {
    flex: 0 0 33.3333333333%;
    max-width: 33.3333333333%;
  }
  .col-md-5 {
    flex: 0 0 41.6666666667%;
    max-width: 41.6666666667%;
  }
  .col-md-6 {
    flex: 0 0 50%;
    max-width: 50%;
  }
  .col-md-7 {
    flex: 0 0 58.3333333333%;
    max-width: 58.3333333333%;
  }
  .col-md-8 {
    flex: 0 0 66.6666666667%;
    max-width: 66.6666666667%;
  }
  .col-md-9 {
    flex: 0 0 75%;
    max-width: 75%;
  }
  .col-md-10 {
    flex: 0 0 83.3333333333%;
    max-width: 83.3333333333%;
  }
  .col-md-11 {
    flex: 0 0 91.6666666667%;
    max-width: 91.6666666667%;
  }
  .col-md-12 {
    flex: 0 0 100%;
    max-width: 100%;
  }
  .order-md-first {
    order: -1;
  }
  .order-md-last {
    order: 13;
  }
  .order-md-0 {
    order: 0;
  }
  .order-md-1 {
    order: 1;
  }
  .order-md-2 {
    order: 2;
  }
  .order-md-3 {
    order: 3;
  }
  .order-md-4 {
    order: 4;
  }
  .order-md-5 {
    order: 5;
  }
  .order-md-6 {
    order: 6;
  }
  .order-md-7 {
    order: 7;
  }
  .order-md-8 {
    order: 8;
  }
  .order-md-9 {
    order: 9;
  }
  .order-md-10 {
    order: 10;
  }
  .order-md-11 {
    order: 11;
  }
  .order-md-12 {
    order: 12;
  }
  .offset-md-0 {
    margin-left: 0;
  }
  .offset-md-1 {
    margin-left: 8.3333333333%;
  }
  .offset-md-2 {
    margin-left: 16.6666666667%;
  }
  .offset-md-3 {
    margin-left: 25%;
  }
  .offset-md-4 {
    margin-left: 33.3333333333%;
  }
  .offset-md-5 {
    margin-left: 41.6666666667%;
  }
  .offset-md-6 {
    margin-left: 50%;
  }
  .offset-md-7 {
    margin-left: 58.3333333333%;
  }
  .offset-md-8 {
    margin-left: 66.6666666667%;
  }
  .offset-md-9 {
    margin-left: 75%;
  }
  .offset-md-10 {
    margin-left: 83.3333333333%;
  }
  .offset-md-11 {
    margin-left: 91.6666666667%;
  }
}
@media (min-width: 992px) {
  .col-lg {
    flex-basis: 0;
    flex-grow: 1;
    max-width: 100%;
  }
  .row-cols-lg-1 > * {
    flex: 0 0 100%;
    max-width: 100%;
  }
  .row-cols-lg-2 > * {
    flex: 0 0 50%;
    max-width: 50%;
  }
  .row-cols-lg-3 > * {
    flex: 0 0 33.3333333333%;
    max-width: 33.3333333333%;
  }
  .row-cols-lg-4 > * {
    flex: 0 0 25%;
    max-width: 25%;
  }
  .row-cols-lg-5 > * {
    flex: 0 0 20%;
    max-width: 20%;
  }
  .row-cols-lg-6 > * {
    flex: 0 0 16.6666666667%;
    max-width: 16.6666666667%;
  }
  .col-lg-auto {
    flex: 0 0 auto;
    width: auto;
    max-width: 100%;
  }
  .col-lg-1 {
    flex: 0 0 8.3333333333%;
    max-width: 8.3333333333%;
  }
  .col-lg-2 {
    flex: 0 0 16.6666666667%;
    max-width: 16.6666666667%;
  }
  .col-lg-3 {
    flex: 0 0 25%;
    max-width: 25%;
  }
  .col-lg-4 {
    flex: 0 0 33.3333333333%;
    max-width: 33.3333333333%;
  }
  .col-lg-5 {
    flex: 0 0 41.6666666667%;
    max-width: 41.6666666667%;
  }
  .col-lg-6 {
    flex: 0 0 50%;
    max-width: 50%;
  }
  .col-lg-7 {
    flex: 0 0 58.3333333333%;
    max-width: 58.3333333333%;
  }
  .col-lg-8 {
    flex: 0 0 66.6666666667%;
    max-width: 66.6666666667%;
  }
  .col-lg-9 {
    flex: 0 0 75%;
    max-width: 75%;
  }
  .col-lg-10 {
    flex: 0 0 83.3333333333%;
    max-width: 83.3333333333%;
  }
  .col-lg-11 {
    flex: 0 0 91.6666666667%;
    max-width: 91.6666666667%;
  }
  .col-lg-12 {
    flex: 0 0 100%;
    max-width: 100%;
  }
  .order-lg-first {
    order: -1;
  }
  .order-lg-last {
    order: 13;
  }
  .order-lg-0 {
    order: 0;
  }
  .order-lg-1 {
    order: 1;
  }
  .order-lg-2 {
    order: 2;
  }
  .order-lg-3 {
    order: 3;
  }
  .order-lg-4 {
    order: 4;
  }
  .order-lg-5 {
    order: 5;
  }
  .order-lg-6 {
    order: 6;
  }
  .order-lg-7 {
    order: 7;
  }
  .order-lg-8 {
    order: 8;
  }
  .order-lg-9 {
    order: 9;
  }
  .order-lg-10 {
    order: 10;
  }
  .order-lg-11 {
    order: 11;
  }
  .order-lg-12 {
    order: 12;
  }
  .offset-lg-0 {
    margin-left: 0;
  }
  .offset-lg-1 {
    margin-left: 8.3333333333%;
  }
  .offset-lg-2 {
    margin-left: 16.6666666667%;
  }
  .offset-lg-3 {
    margin-left: 25%;
  }
  .offset-lg-4 {
    margin-left: 33.3333333333%;
  }
  .offset-lg-5 {
    margin-left: 41.6666666667%;
  }
  .offset-lg-6 {
    margin-left: 50%;
  }
  .offset-lg-7 {
    margin-left: 58.3333333333%;
  }
  .offset-lg-8 {
    margin-left: 66.6666666667%;
  }
  .offset-lg-9 {
    margin-left: 75%;
  }
  .offset-lg-10 {
    margin-left: 83.3333333333%;
  }
  .offset-lg-11 {
    margin-left: 91.6666666667%;
  }
}
@media (min-width: 1200px) {
  .col-xl {
    flex-basis: 0;
    flex-grow: 1;
    max-width: 100%;
  }
  .row-cols-xl-1 > * {
    flex: 0 0 100%;
    max-width: 100%;
  }
  .row-cols-xl-2 > * {
    flex: 0 0 50%;
    max-width: 50%;
  }
  .row-cols-xl-3 > * {
    flex: 0 0 33.3333333333%;
    max-width: 33.3333333333%;
  }
  .row-cols-xl-4 > * {
    flex: 0 0 25%;
    max-width: 25%;
  }
  .row-cols-xl-5 > * {
    flex: 0 0 20%;
    max-width: 20%;
  }
  .row-cols-xl-6 > * {
    flex: 0 0 16.6666666667%;
    max-width: 16.6666666667%;
  }
  .col-xl-auto {
    flex: 0 0 auto;
    width: auto;
    max-width: 100%;
  }
  .col-xl-1 {
    flex: 0 0 8.3333333333%;
    max-width: 8.3333333333%;
  }
  .col-xl-2 {
    flex: 0 0 16.6666666667%;
    max-width: 16.6666666667%;
  }
  .col-xl-3 {
    flex: 0 0 25%;
    max-width: 25%;
  }
  .col-xl-4 {
    flex: 0 0 33.3333333333%;
    max-width: 33.3333333333%;
  }
  .col-xl-5 {
    flex: 0 0 41.6666666667%;
    max-width: 41.6666666667%;
  }
  .col-xl-6 {
    flex: 0 0 50%;
    max-width: 50%;
  }
  .col-xl-7 {
    flex: 0 0 58.3333333333%;
    max-width: 58.3333333333%;
  }
  .col-xl-8 {
    flex: 0 0 66.6666666667%;
    max-width: 66.6666666667%;
  }
  .col-xl-9 {
    flex: 0 0 75%;
    max-width: 75%;
  }
  .col-xl-10 {
    flex: 0 0 83.3333333333%;
    max-width: 83.3333333333%;
  }
  .col-xl-11 {
    flex: 0 0 91.6666666667%;
    max-width: 91.6666666667%;
  }
  .col-xl-12 {
    flex: 0 0 100%;
    max-width: 100%;
  }
  .order-xl-first {
    order: -1;
  }
  .order-xl-last {
    order: 13;
  }
  .order-xl-0 {
    order: 0;
  }
  .order-xl-1 {
    order: 1;
  }
  .order-xl-2 {
    order: 2;
  }
  .order-xl-3 {
    order: 3;
  }
  .order-xl-4 {
    order: 4;
  }
  .order-xl-5 {
    order: 5;
  }
  .order-xl-6 {
    order: 6;
  }
  .order-xl-7 {
    order: 7;
  }
  .order-xl-8 {
    order: 8;
  }
  .order-xl-9 {
    order: 9;
  }
  .order-xl-10 {
    order: 10;
  }
  .order-xl-11 {
    order: 11;
  }
  .order-xl-12 {
    order: 12;
  }
  .offset-xl-0 {
    margin-left: 0;
  }
  .offset-xl-1 {
    margin-left: 8.3333333333%;
  }
  .offset-xl-2 {
    margin-left: 16.6666666667%;
  }
  .offset-xl-3 {
    margin-left: 25%;
  }
  .offset-xl-4 {
    margin-left: 33.3333333333%;
  }
  .offset-xl-5 {
    margin-left: 41.6666666667%;
  }
  .offset-xl-6 {
    margin-left: 50%;
  }
  .offset-xl-7 {
    margin-left: 58.3333333333%;
  }
  .offset-xl-8 {
    margin-left: 66.6666666667%;
  }
  .offset-xl-9 {
    margin-left: 75%;
  }
  .offset-xl-10 {
    margin-left: 83.3333333333%;
  }
  .offset-xl-11 {
    margin-left: 91.6666666667%;
  }
}
.table {
  width: 100%;
  margin-bottom: 1rem;
  color: #525f7f;
  background-color: transparent;
}
.table th,
.table td {
  padding: 1rem;
  vertical-align: top;
  border-top: 1px solid #e9ecef;
}
.table thead th {
  vertical-align: bottom;
  border-bottom: 2px solid #e9ecef;
}
.table tbody + tbody {
  border-top: 2px solid #e9ecef;
}

.table-sm th,
.table-sm td {
  padding: 0.5rem;
}

.table-bordered {
  border: 1px solid #e9ecef;
}
.table-bordered th,
.table-bordered td {
  border: 1px solid #e9ecef;
}
.table-bordered thead th,
.table-bordered thead td {
  border-bottom-width: 2px;
}

.table-borderless th,
.table-borderless td,
.table-borderless thead th,
.table-borderless tbody + tbody {
  border: 0;
}

.table-striped tbody tr:nth-of-type(odd) {
  background-color: rgba(0, 0, 0, 0.05);
}

.table-hover tbody tr:hover {
  color: #525f7f;
  background-color: #f6f9fc;
}

.table-primary,
.table-primary > th,
.table-primary > td {
  background-color: rgb(200.12, 229.24, 215.24);
}
.table-primary th,
.table-primary td,
.table-primary thead th,
.table-primary tbody + tbody {
  border-color: rgb(153.08, 207.16, 181.16);
}

.table-hover .table-primary:hover {
  background-color: rgb(182.7658333333, 221.0941666667, 202.6670833333);
}
.table-hover .table-primary:hover > td,
.table-hover .table-primary:hover > th {
  background-color: rgb(182.7658333333, 221.0941666667, 202.6670833333);
}

.table-secondary,
.table-secondary > th,
.table-secondary > td {
  background-color: rgb(252.76, 253.6, 254.16);
}
.table-secondary th,
.table-secondary td,
.table-secondary thead th,
.table-secondary tbody + tbody {
  border-color: rgb(250.84, 252.4, 253.44);
}

.table-hover .table-secondary:hover {
  background-color: rgb(234.2145454545, 242.0090909091, 247.2054545455);
}
.table-hover .table-secondary:hover > td,
.table-hover .table-secondary:hover > th {
  background-color: rgb(234.2145454545, 242.0090909091, 247.2054545455);
}

.table-success,
.table-success > th,
.table-success > td {
  background-color: rgb(199.84, 228.68, 214.96);
}
.table-success th,
.table-success td,
.table-success thead th,
.table-success tbody + tbody {
  border-color: rgb(152.56, 206.12, 180.64);
}

.table-hover .table-success:hover {
  background-color: rgb(182.5771134021, 220.4428865979, 202.4290721649);
}
.table-hover .table-success:hover > td,
.table-hover .table-success:hover > th {
  background-color: rgb(182.5771134021, 220.4428865979, 202.4290721649);
}

.table-info,
.table-info > th,
.table-info > td {
  background-color: rgb(194.52, 223.36, 213);
}
.table-info th,
.table-info td,
.table-info thead th,
.table-info tbody + tbody {
  border-color: rgb(142.68, 196.24, 177);
}

.table-hover .table-info:hover {
  background-color: rgb(177.7783586626, 214.6016413374, 201.3738601824);
}
.table-hover .table-info:hover > td,
.table-hover .table-info:hover > th {
  background-color: rgb(177.7783586626, 214.6016413374, 201.3738601824);
}

.table-warning,
.table-warning > th,
.table-warning > td {
  background-color: rgb(253.88, 211.32, 201.52);
}
.table-warning th,
.table-warning td,
.table-warning thead th,
.table-warning tbody + tbody {
  border-color: rgb(252.92, 173.88, 155.68);
}

.table-hover .table-warning:hover {
  background-color: rgb(253.3569230769, 190.92, 176.5430769231);
}
.table-hover .table-warning:hover > td,
.table-hover .table-warning:hover > th {
  background-color: rgb(253.3569230769, 190.92, 176.5430769231);
}

.table-danger,
.table-danger > th,
.table-danger > td {
  background-color: rgb(252.2, 198.72, 209.36);
}
.table-danger th,
.table-danger td,
.table-danger thead th,
.table-danger tbody + tbody {
  border-color: rgb(249.8, 150.48, 170.24);
}

.table-hover .table-danger:hover {
  background-color: rgb(250.9914691943, 174.4285308057, 189.6609478673);
}
.table-hover .table-danger:hover > td,
.table-hover .table-danger:hover > th {
  background-color: rgb(250.9914691943, 174.4285308057, 189.6609478673);
}

.table-light,
.table-light > th,
.table-light > td {
  background-color: rgb(232.04, 234.28, 236.52);
}
.table-light th,
.table-light td,
.table-light thead th,
.table-light tbody + tbody {
  border-color: rgb(212.36, 216.52, 220.68);
}

.table-hover .table-light:hover {
  background-color: rgb(217.9116216216, 221.53, 225.1483783784);
}
.table-hover .table-light:hover > td,
.table-hover .table-light:hover > th {
  background-color: rgb(217.9116216216, 221.53, 225.1483783784);
}

.table-dark,
.table-dark > th,
.table-dark > td {
  background-color: rgb(192.84, 193.96, 195.08);
}
.table-dark th,
.table-dark td,
.table-dark thead th,
.table-dark tbody + tbody {
  border-color: rgb(139.56, 141.64, 143.72);
}

.table-hover .table-dark:hover {
  background-color: rgb(179.8560550459, 181.21, 182.5639449541);
}
.table-hover .table-dark:hover > td,
.table-hover .table-dark:hover > th {
  background-color: rgb(179.8560550459, 181.21, 182.5639449541);
}

.table-default,
.table-default > th,
.table-default > td {
  background-color: rgb(255, 244.08, 222.8);
}
.table-default th,
.table-default td,
.table-default thead th,
.table-default tbody + tbody {
  border-color: rgb(255, 234.72, 195.2);
}

.table-hover .table-default:hover {
  background-color: rgb(255, 235.432173913, 197.3);
}
.table-hover .table-default:hover > td,
.table-hover .table-default:hover > th {
  background-color: rgb(255, 235.432173913, 197.3);
}

.table-white,
.table-white > th,
.table-white > td {
  background-color: white;
}
.table-white th,
.table-white td,
.table-white thead th,
.table-white tbody + tbody {
  border-color: white;
}

.table-hover .table-white:hover {
  background-color: rgb(242.25, 242.25, 242.25);
}
.table-hover .table-white:hover > td,
.table-hover .table-white:hover > th {
  background-color: rgb(242.25, 242.25, 242.25);
}

.table-neutral,
.table-neutral > th,
.table-neutral > td {
  background-color: white;
}
.table-neutral th,
.table-neutral td,
.table-neutral thead th,
.table-neutral tbody + tbody {
  border-color: white;
}

.table-hover .table-neutral:hover {
  background-color: rgb(242.25, 242.25, 242.25);
}
.table-hover .table-neutral:hover > td,
.table-hover .table-neutral:hover > th {
  background-color: rgb(242.25, 242.25, 242.25);
}

.table-darker,
.table-darker > th,
.table-darker > td {
  background-color: rgb(183.6, 183.6, 183.6);
}
.table-darker th,
.table-darker td,
.table-darker thead th,
.table-darker tbody + tbody {
  border-color: rgb(122.4, 122.4, 122.4);
}

.table-hover .table-darker:hover {
  background-color: rgb(170.85, 170.85, 170.85);
}
.table-hover .table-darker:hover > td,
.table-hover .table-darker:hover > th {
  background-color: rgb(170.85, 170.85, 170.85);
}

.table-active,
.table-active > th,
.table-active > td {
  background-color: #f6f9fc;
}

.table-hover .table-active:hover {
  background-color: rgb(226.875, 236.25, 245.625);
}
.table-hover .table-active:hover > td,
.table-hover .table-active:hover > th {
  background-color: rgb(226.875, 236.25, 245.625);
}

.table .thead-dark th {
  color: #f8f9fe;
  background-color: #ffd88c;
  border-color: rgb(255, 228.1069565217, 175.7);
}
.table .thead-light th {
  color: #8898aa;
  background-color: #f6f9fc;
  border-color: #e9ecef;
}

.table-dark {
  color: #f8f9fe;
  background-color: #ffd88c;
}
.table-dark th,
.table-dark td,
.table-dark thead th {
  border-color: rgb(255, 228.1069565217, 175.7);
}
.table-dark.table-bordered {
  border: 0;
}
.table-dark.table-striped tbody tr:nth-of-type(odd) {
  background-color: rgba(255, 255, 255, 0.05);
}
.table-dark.table-hover tbody tr:hover {
  color: #f8f9fe;
  background-color: rgba(255, 255, 255, 0.075);
}

@media (max-width: 575.98px) {
  .table-responsive-sm {
    display: block;
    width: 100%;
    overflow-x: auto;
    -webkit-overflow-scrolling: touch;
  }
  .table-responsive-sm > .table-bordered {
    border: 0;
  }
}
@media (max-width: 767.98px) {
  .table-responsive-md {
    display: block;
    width: 100%;
    overflow-x: auto;
    -webkit-overflow-scrolling: touch;
  }
  .table-responsive-md > .table-bordered {
    border: 0;
  }
}
@media (max-width: 991.98px) {
  .table-responsive-lg {
    display: block;
    width: 100%;
    overflow-x: auto;
    -webkit-overflow-scrolling: touch;
  }
  .table-responsive-lg > .table-bordered {
    border: 0;
  }
}
@media (max-width: 1199.98px) {
  .table-responsive-xl {
    display: block;
    width: 100%;
    overflow-x: auto;
    -webkit-overflow-scrolling: touch;
  }
  .table-responsive-xl > .table-bordered {
    border: 0;
  }
}
.table-responsive {
  display: block;
  width: 100%;
  overflow-x: auto;
  -webkit-overflow-scrolling: touch;
}
.table-responsive > .table-bordered {
  border: 0;
}

.form-control {
  display: block;
  width: 100%;
  height: calc(1.5em + 1.25rem + 2px);
  padding: 0.625rem 0.75rem;
  font-size: 0.875rem;
  font-weight: 400;
  line-height: 1.5;
  color: #8898aa;
  background-color: #fff;
  background-clip: padding-box;
  border: 1px solid #cad1d7;
  border-radius: 0.375rem;
  box-shadow: none;
  transition: all 0.2s cubic-bezier(0.68, -0.55, 0.265, 1.55);
}
@media (prefers-reduced-motion: reduce) {
  .form-control {
    transition: none;
  }
}
.form-control::-ms-expand {
  background-color: transparent;
  border: 0;
}
.form-control:-moz-focusring {
  color: transparent;
  text-shadow: 0 0 0 #8898aa;
}
.form-control:focus {
  color: #8898aa;
  background-color: #fff;
  border-color: rgba(50, 151, 211, 0.25);
  outline: 0;
  box-shadow: none, none;
}
.form-control::placeholder {
  color: #adb5bd;
  opacity: 1;
}
.form-control:disabled, .form-control[readonly] {
  background-color: #e9ecef;
  opacity: 1;
}

input[type=date].form-control,
input[type=time].form-control,
input[type=datetime-local].form-control,
input[type=month].form-control {
  appearance: none;
}

select.form-control:focus::-ms-value {
  color: #8898aa;
  background-color: #fff;
}

.form-control-file,
.form-control-range {
  display: block;
  width: 100%;
}

.col-form-label {
  padding-top: calc(0.625rem + 1px);
  padding-bottom: calc(0.625rem + 1px);
  margin-bottom: 0;
  font-size: inherit;
  line-height: 1.5;
}

.col-form-label-lg {
  padding-top: calc(0.875rem + 1px);
  padding-bottom: calc(0.875rem + 1px);
  font-size: 0.875rem;
  line-height: 1.5;
}

.col-form-label-sm {
  padding-top: calc(0.25rem + 1px);
  padding-bottom: calc(0.25rem + 1px);
  font-size: 0.75rem;
  line-height: 1.5;
}

.form-control-plaintext {
  display: block;
  width: 100%;
  padding: 0.625rem 0;
  margin-bottom: 0;
  font-size: 0.875rem;
  line-height: 1.5;
  color: #525f7f;
  background-color: transparent;
  border: solid transparent;
  border-width: 1px 0;
}
.form-control-plaintext.form-control-sm, .form-control-plaintext.form-control-lg {
  padding-right: 0;
  padding-left: 0;
}

.form-control-sm {
  height: calc(1.5em + 0.5rem + 2px);
  padding: 0.25rem 0.5rem;
  font-size: 0.75rem;
  line-height: 1.5;
  border-radius: 0.25rem;
}

.form-control-lg {
  height: calc(1.5em + 1.75rem + 2px);
  padding: 0.875rem 1rem;
  font-size: 0.875rem;
  line-height: 1.5;
  border-radius: 0.4375rem;
}

select.form-control[size], select.form-control[multiple] {
  height: auto;
}

textarea.form-control {
  height: auto;
}

.form-group {
  margin-bottom: 1.5rem;
}

.form-text {
  display: block;
  margin-top: 0.25rem;
}

.form-row {
  display: flex;
  flex-wrap: wrap;
  margin-right: -5px;
  margin-left: -5px;
}
.form-row > .col,
.form-row > [class*=col-] {
  padding-right: 5px;
  padding-left: 5px;
}

.form-check {
  position: relative;
  display: block;
  padding-left: 1.25rem;
}

.form-check-input {
  position: absolute;
  margin-top: 0.3rem;
  margin-left: -1.25rem;
}
.form-check-input[disabled] ~ .form-check-label, .form-check-input:disabled ~ .form-check-label {
  color: #8898aa;
}

.form-check-label {
  margin-bottom: 0;
}

.form-check-inline {
  display: inline-flex;
  align-items: center;
  padding-left: 0;
  margin-right: 0.75rem;
}
.form-check-inline .form-check-input {
  position: static;
  margin-top: 0;
  margin-right: 0.3125rem;
  margin-left: 0;
}

.valid-feedback {
  display: none;
  width: 100%;
  margin-top: 0.25rem;
  font-size: 80%;
  color: #3aa170;
}

.valid-tooltip {
  position: absolute;
  top: 100%;
  z-index: 5;
  display: none;
  max-width: 100%;
  padding: 0.5rem;
  margin-top: 0.1rem;
  font-size: 0.875rem;
  line-height: 1;
  color: #fff;
  background-color: rgba(58, 161, 112, 0.8);
  border-radius: 0.2rem;
}

.was-validated .form-control:valid, .form-control.is-valid,
.was-validated .custom-select:valid,
.custom-select.is-valid {
  border-color: #3aa170;
}
.was-validated .form-control:valid:focus, .form-control.is-valid:focus,
.was-validated .custom-select:valid:focus,
.custom-select.is-valid:focus {
  border-color: #3aa170;
}
.was-validated .form-control:valid ~ .valid-feedback,
.was-validated .form-control:valid ~ .valid-tooltip, .form-control.is-valid ~ .valid-feedback,
.form-control.is-valid ~ .valid-tooltip,
.was-validated .custom-select:valid ~ .valid-feedback,
.was-validated .custom-select:valid ~ .valid-tooltip,
.custom-select.is-valid ~ .valid-feedback,
.custom-select.is-valid ~ .valid-tooltip {
  display: block;
}

.was-validated .form-check-input:valid ~ .form-check-label, .form-check-input.is-valid ~ .form-check-label {
  color: #3aa170;
}
.was-validated .form-check-input:valid ~ .valid-feedback,
.was-validated .form-check-input:valid ~ .valid-tooltip, .form-check-input.is-valid ~ .valid-feedback,
.form-check-input.is-valid ~ .valid-tooltip {
  display: block;
}

.was-validated .custom-control-input:valid ~ .custom-control-label, .custom-control-input.is-valid ~ .custom-control-label {
  color: #3aa170;
}
.was-validated .custom-control-input:valid ~ .custom-control-label::before, .custom-control-input.is-valid ~ .custom-control-label::before {
  background-color: rgb(134.801369863, 211.698630137, 175.1164383562);
  border-color: rgb(134.801369863, 211.698630137, 175.1164383562);
}
.was-validated .custom-control-input:valid ~ .valid-feedback,
.was-validated .custom-control-input:valid ~ .valid-tooltip, .custom-control-input.is-valid ~ .valid-feedback,
.custom-control-input.is-valid ~ .valid-tooltip {
  display: block;
}
.was-validated .custom-control-input:valid:checked ~ .custom-control-label::before, .custom-control-input.is-valid:checked ~ .custom-control-label::before {
  background-color: rgb(78.5616438356, 191.4383561644, 137.7397260274);
  border-color: rgb(134.801369863, 211.698630137, 175.1164383562);
}
.was-validated .custom-control-input:valid:focus ~ .custom-control-label::before, .custom-control-input.is-valid:focus ~ .custom-control-label::before {
  box-shadow: 0 0 0 1px #f8f9fe, 0 0 0 0 rgba(58, 161, 112, 0.25);
}

.was-validated .custom-file-input:valid ~ .custom-file-label, .custom-file-input.is-valid ~ .custom-file-label {
  border-color: #3aa170;
}
.was-validated .custom-file-input:valid ~ .custom-file-label::before, .custom-file-input.is-valid ~ .custom-file-label::before {
  border-color: inherit;
}
.was-validated .custom-file-input:valid ~ .valid-feedback,
.was-validated .custom-file-input:valid ~ .valid-tooltip, .custom-file-input.is-valid ~ .valid-feedback,
.custom-file-input.is-valid ~ .valid-tooltip {
  display: block;
}
.was-validated .custom-file-input:valid:focus ~ .custom-file-label, .custom-file-input.is-valid:focus ~ .custom-file-label {
  box-shadow: 0 0 0 0 rgba(58, 161, 112, 0.25);
}

.invalid-feedback {
  display: none;
  width: 100%;
  margin-top: 0.25rem;
  font-size: 80%;
  color: #fb6340;
}

.invalid-tooltip {
  position: absolute;
  top: 100%;
  z-index: 5;
  display: none;
  max-width: 100%;
  padding: 0.5rem;
  margin-top: 0.1rem;
  font-size: 0.875rem;
  line-height: 1;
  color: #fff;
  background-color: rgba(251, 99, 64, 0.8);
  border-radius: 0.2rem;
}

.was-validated .form-control:invalid, .form-control.is-invalid,
.was-validated .custom-select:invalid,
.custom-select.is-invalid {
  border-color: #fb6340;
}
.was-validated .form-control:invalid:focus, .form-control.is-invalid:focus,
.was-validated .custom-select:invalid:focus,
.custom-select.is-invalid:focus {
  border-color: #fb6340;
}
.was-validated .form-control:invalid ~ .invalid-feedback,
.was-validated .form-control:invalid ~ .invalid-tooltip, .form-control.is-invalid ~ .invalid-feedback,
.form-control.is-invalid ~ .invalid-tooltip,
.was-validated .custom-select:invalid ~ .invalid-feedback,
.was-validated .custom-select:invalid ~ .invalid-tooltip,
.custom-select.is-invalid ~ .invalid-feedback,
.custom-select.is-invalid ~ .invalid-tooltip {
  display: block;
}

.was-validated .form-check-input:invalid ~ .form-check-label, .form-check-input.is-invalid ~ .form-check-label {
  color: #fb6340;
}
.was-validated .form-check-input:invalid ~ .invalid-feedback,
.was-validated .form-check-input:invalid ~ .invalid-tooltip, .form-check-input.is-invalid ~ .invalid-feedback,
.form-check-input.is-invalid ~ .invalid-tooltip {
  display: block;
}

.was-validated .custom-control-input:invalid ~ .custom-control-label, .custom-control-input.is-invalid ~ .custom-control-label {
  color: #fb6340;
}
.was-validated .custom-control-input:invalid ~ .custom-control-label::before, .custom-control-input.is-invalid ~ .custom-control-label::before {
  background-color: rgb(253.6153846154, 201, 188.8846153846);
  border-color: rgb(253.6153846154, 201, 188.8846153846);
}
.was-validated .custom-control-input:invalid ~ .invalid-feedback,
.was-validated .custom-control-input:invalid ~ .invalid-tooltip, .custom-control-input.is-invalid ~ .invalid-feedback,
.custom-control-input.is-invalid ~ .invalid-tooltip {
  display: block;
}
.was-validated .custom-control-input:invalid:checked ~ .custom-control-label::before, .custom-control-input.is-invalid:checked ~ .custom-control-label::before {
  background-color: rgb(252.0461538462, 139.8, 113.9538461538);
  border-color: rgb(253.6153846154, 201, 188.8846153846);
}
.was-validated .custom-control-input:invalid:focus ~ .custom-control-label::before, .custom-control-input.is-invalid:focus ~ .custom-control-label::before {
  box-shadow: 0 0 0 1px #f8f9fe, 0 0 0 0 rgba(251, 99, 64, 0.25);
}

.was-validated .custom-file-input:invalid ~ .custom-file-label, .custom-file-input.is-invalid ~ .custom-file-label {
  border-color: #fb6340;
}
.was-validated .custom-file-input:invalid ~ .custom-file-label::before, .custom-file-input.is-invalid ~ .custom-file-label::before {
  border-color: inherit;
}
.was-validated .custom-file-input:invalid ~ .invalid-feedback,
.was-validated .custom-file-input:invalid ~ .invalid-tooltip, .custom-file-input.is-invalid ~ .invalid-feedback,
.custom-file-input.is-invalid ~ .invalid-tooltip {
  display: block;
}
.was-validated .custom-file-input:invalid:focus ~ .custom-file-label, .custom-file-input.is-invalid:focus ~ .custom-file-label {
  box-shadow: 0 0 0 0 rgba(251, 99, 64, 0.25);
}

.form-inline {
  display: flex;
  flex-flow: row wrap;
  align-items: center;
}
.form-inline .form-check {
  width: 100%;
}
@media (min-width: 576px) {
  .form-inline label {
    display: flex;
    align-items: center;
    justify-content: center;
    margin-bottom: 0;
  }
  .form-inline .form-group {
    display: flex;
    flex: 0 0 auto;
    flex-flow: row wrap;
    align-items: center;
    margin-bottom: 0;
  }
  .form-inline .form-control {
    display: inline-block;
    width: auto;
    vertical-align: middle;
  }
  .form-inline .form-control-plaintext {
    display: inline-block;
  }
  .form-inline .input-group,
  .form-inline .custom-select {
    width: auto;
  }
  .form-inline .form-check {
    display: flex;
    align-items: center;
    justify-content: center;
    width: auto;
    padding-left: 0;
  }
  .form-inline .form-check-input {
    position: relative;
    flex-shrink: 0;
    margin-top: 0;
    margin-right: 0.25rem;
    margin-left: 0;
  }
  .form-inline .custom-control {
    align-items: center;
    justify-content: center;
  }
  .form-inline .custom-control-label {
    margin-bottom: 0;
  }
}

.btn {
  display: inline-block;
  font-weight: 600;
  color: #525f7f;
  text-align: center;
  vertical-align: middle;
  -webkit-user-select: none;
          user-select: none;
  background-color: transparent;
  border: 1px solid transparent;
  padding: 0.625rem 1.25rem;
  font-size: 0.875rem;
  line-height: 1.5;
  border-radius: 0.375rem;
  transition: color 0.15s ease-in-out, background-color 0.15s ease-in-out, border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;
}
@media (prefers-reduced-motion: reduce) {
  .btn {
    transition: none;
  }
}
.btn:hover {
  color: #525f7f;
  text-decoration: none;
}
.btn:focus, .btn.focus {
  outline: 0;
  box-shadow: 0 7px 14px rgba(50, 50, 93, 0.1), 0 3px 6px rgba(0, 0, 0, 0.08);
}
.btn.disabled, .btn:disabled {
  opacity: 0.65;
  box-shadow: none;
}
.btn:not(:disabled):not(.disabled) {
  cursor: pointer;
}
.btn:not(:disabled):not(.disabled):active, .btn:not(:disabled):not(.disabled).active {
  box-shadow: none;
}
.btn:not(:disabled):not(.disabled):active:focus, .btn:not(:disabled):not(.disabled).active:focus {
  box-shadow: 0 7px 14px rgba(50, 50, 93, 0.1), 0 3px 6px rgba(0, 0, 0, 0.08);
}

a.btn.disabled,
fieldset:disabled a.btn {
  pointer-events: none;
}

.btn-primary {
  color: #fff;
  background-color: #3ba371;
  border-color: #3ba371;
  box-shadow: 0 4px 6px rgba(50, 50, 93, 0.11), 0 1px 3px rgba(0, 0, 0, 0.08);
}
.btn-primary:hover {
  color: #fff;
  background-color: #3ba371;
  border-color: #3ba371;
}
.btn-primary:focus, .btn-primary.focus {
  box-shadow: 0 4px 6px rgba(50, 50, 93, 0.11), 0 1px 3px rgba(0, 0, 0, 0.08), 0 0 0 0 rgba(59, 163, 113, 0.5);
}
.btn-primary.disabled, .btn-primary:disabled {
  color: #fff;
  background-color: #3ba371;
  border-color: #3ba371;
}
.btn-primary:not(:disabled):not(.disabled):active, .btn-primary:not(:disabled):not(.disabled).active, .show > .btn-primary.dropdown-toggle {
  color: #fff;
  background-color: rgb(45.4459459459, 125.5540540541, 87.0405405405);
  border-color: #3ba371;
}
.btn-primary:not(:disabled):not(.disabled):active:focus, .btn-primary:not(:disabled):not(.disabled).active:focus, .show > .btn-primary.dropdown-toggle:focus {
  box-shadow: none, 0 0 0 0 rgba(59, 163, 113, 0.5);
}

.btn-secondary {
  color: #212529;
  background-color: #f7fafc;
  border-color: #f7fafc;
  box-shadow: 0 4px 6px rgba(50, 50, 93, 0.11), 0 1px 3px rgba(0, 0, 0, 0.08);
}
.btn-secondary:hover {
  color: #212529;
  background-color: #f7fafc;
  border-color: #f7fafc;
}
.btn-secondary:focus, .btn-secondary.focus {
  box-shadow: 0 4px 6px rgba(50, 50, 93, 0.11), 0 1px 3px rgba(0, 0, 0, 0.08), 0 0 0 0 rgba(247, 250, 252, 0.5);
}
.btn-secondary.disabled, .btn-secondary:disabled {
  color: #212529;
  background-color: #f7fafc;
  border-color: #f7fafc;
}
.btn-secondary:not(:disabled):not(.disabled):active, .btn-secondary:not(:disabled):not(.disabled).active, .show > .btn-secondary.dropdown-toggle {
  color: #212529;
  background-color: rgb(209.9090909091, 226.8181818182, 238.0909090909);
  border-color: #f7fafc;
}
.btn-secondary:not(:disabled):not(.disabled):active:focus, .btn-secondary:not(:disabled):not(.disabled).active:focus, .show > .btn-secondary.dropdown-toggle:focus {
  box-shadow: none, 0 0 0 0 rgba(247, 250, 252, 0.5);
}

.btn-success {
  color: #fff;
  background-color: #3aa170;
  border-color: #3aa170;
  box-shadow: 0 4px 6px rgba(50, 50, 93, 0.11), 0 1px 3px rgba(0, 0, 0, 0.08);
}
.btn-success:hover {
  color: #fff;
  background-color: #3aa170;
  border-color: #3aa170;
}
.btn-success:focus, .btn-success.focus {
  box-shadow: 0 4px 6px rgba(50, 50, 93, 0.11), 0 1px 3px rgba(0, 0, 0, 0.08), 0 0 0 0 rgba(58, 161, 112, 0.5);
}
.btn-success.disabled, .btn-success:disabled {
  color: #fff;
  background-color: #3aa170;
  border-color: #3aa170;
}
.btn-success:not(:disabled):not(.disabled):active, .btn-success:not(:disabled):not(.disabled).active, .show > .btn-success.dropdown-toggle {
  color: #fff;
  background-color: rgb(44.4931506849, 123.5068493151, 85.9178082192);
  border-color: #3aa170;
}
.btn-success:not(:disabled):not(.disabled):active:focus, .btn-success:not(:disabled):not(.disabled).active:focus, .show > .btn-success.dropdown-toggle:focus {
  box-shadow: none, 0 0 0 0 rgba(58, 161, 112, 0.5);
}

.btn-info {
  color: #fff;
  background-color: #278e69;
  border-color: #278e69;
  box-shadow: 0 4px 6px rgba(50, 50, 93, 0.11), 0 1px 3px rgba(0, 0, 0, 0.08);
}
.btn-info:hover {
  color: #fff;
  background-color: #278e69;
  border-color: #278e69;
}
.btn-info:focus, .btn-info.focus {
  box-shadow: 0 4px 6px rgba(50, 50, 93, 0.11), 0 1px 3px rgba(0, 0, 0, 0.08), 0 0 0 0 rgba(39, 142, 105, 0.5);
}
.btn-info.disabled, .btn-info:disabled {
  color: #fff;
  background-color: #278e69;
  border-color: #278e69;
}
.btn-info:not(:disabled):not(.disabled):active, .btn-info:not(:disabled):not(.disabled).active, .show > .btn-info.dropdown-toggle {
  color: #fff;
  background-color: rgb(28.0110497238, 101.9889502762, 75.4143646409);
  border-color: #278e69;
}
.btn-info:not(:disabled):not(.disabled):active:focus, .btn-info:not(:disabled):not(.disabled).active:focus, .show > .btn-info.dropdown-toggle:focus {
  box-shadow: none, 0 0 0 0 rgba(39, 142, 105, 0.5);
}

.btn-warning {
  color: #fff;
  background-color: #fb6340;
  border-color: #fb6340;
  box-shadow: 0 4px 6px rgba(50, 50, 93, 0.11), 0 1px 3px rgba(0, 0, 0, 0.08);
}
.btn-warning:hover {
  color: #fff;
  background-color: #fb6340;
  border-color: #fb6340;
}
.btn-warning:focus, .btn-warning.focus {
  box-shadow: 0 4px 6px rgba(50, 50, 93, 0.11), 0 1px 3px rgba(0, 0, 0, 0.08), 0 0 0 0 rgba(251, 99, 64, 0.5);
}
.btn-warning.disabled, .btn-warning:disabled {
  color: #fff;
  background-color: #fb6340;
  border-color: #fb6340;
}
.btn-warning:not(:disabled):not(.disabled):active, .btn-warning:not(:disabled):not(.disabled).active, .show > .btn-warning.dropdown-toggle {
  color: #fff;
  background-color: rgb(249.9538461538, 58.2, 14.0461538462);
  border-color: #fb6340;
}
.btn-warning:not(:disabled):not(.disabled):active:focus, .btn-warning:not(:disabled):not(.disabled).active:focus, .show > .btn-warning.dropdown-toggle:focus {
  box-shadow: none, 0 0 0 0 rgba(251, 99, 64, 0.5);
}

.btn-danger {
  color: #fff;
  background-color: #f5365c;
  border-color: #f5365c;
  box-shadow: 0 4px 6px rgba(50, 50, 93, 0.11), 0 1px 3px rgba(0, 0, 0, 0.08);
}
.btn-danger:hover {
  color: #fff;
  background-color: #f5365c;
  border-color: #f5365c;
}
.btn-danger:focus, .btn-danger.focus {
  box-shadow: 0 4px 6px rgba(50, 50, 93, 0.11), 0 1px 3px rgba(0, 0, 0, 0.08), 0 0 0 0 rgba(245, 54, 92, 0.5);
}
.btn-danger.disabled, .btn-danger:disabled {
  color: #fff;
  background-color: #f5365c;
  border-color: #f5365c;
}
.btn-danger:not(:disabled):not(.disabled):active, .btn-danger:not(:disabled):not(.disabled).active, .show > .btn-danger.dropdown-toggle {
  color: #fff;
  background-color: rgb(236.2464454976, 11.7535545024, 56.4170616114);
  border-color: #f5365c;
}
.btn-danger:not(:disabled):not(.disabled):active:focus, .btn-danger:not(:disabled):not(.disabled).active:focus, .show > .btn-danger.dropdown-toggle:focus {
  box-shadow: none, 0 0 0 0 rgba(245, 54, 92, 0.5);
}

.btn-light {
  color: #fff;
  background-color: #adb5bd;
  border-color: #adb5bd;
  box-shadow: 0 4px 6px rgba(50, 50, 93, 0.11), 0 1px 3px rgba(0, 0, 0, 0.08);
}
.btn-light:hover {
  color: #fff;
  background-color: #adb5bd;
  border-color: #adb5bd;
}
.btn-light:focus, .btn-light.focus {
  box-shadow: 0 4px 6px rgba(50, 50, 93, 0.11), 0 1px 3px rgba(0, 0, 0, 0.08), 0 0 0 0 rgba(173, 181, 189, 0.5);
}
.btn-light.disabled, .btn-light:disabled {
  color: #fff;
  background-color: #adb5bd;
  border-color: #adb5bd;
}
.btn-light:not(:disabled):not(.disabled):active, .btn-light:not(:disabled):not(.disabled).active, .show > .btn-light.dropdown-toggle {
  color: #fff;
  background-color: rgb(144.7432432432, 155.5, 166.2567567568);
  border-color: #adb5bd;
}
.btn-light:not(:disabled):not(.disabled):active:focus, .btn-light:not(:disabled):not(.disabled).active:focus, .show > .btn-light.dropdown-toggle:focus {
  box-shadow: none, 0 0 0 0 rgba(173, 181, 189, 0.5);
}

.btn-dark {
  color: #fff;
  background-color: #212529;
  border-color: #212529;
  box-shadow: 0 4px 6px rgba(50, 50, 93, 0.11), 0 1px 3px rgba(0, 0, 0, 0.08);
}
.btn-dark:hover {
  color: #fff;
  background-color: #212529;
  border-color: #212529;
}
.btn-dark:focus, .btn-dark.focus {
  box-shadow: 0 4px 6px rgba(50, 50, 93, 0.11), 0 1px 3px rgba(0, 0, 0, 0.08), 0 0 0 0 rgba(33, 37, 41, 0.5);
}
.btn-dark.disabled, .btn-dark:disabled {
  color: #fff;
  background-color: #212529;
  border-color: #212529;
}
.btn-dark:not(:disabled):not(.disabled):active, .btn-dark:not(:disabled):not(.disabled).active, .show > .btn-dark.dropdown-toggle {
  color: #fff;
  background-color: rgb(10.2567567568, 11.5, 12.7432432432);
  border-color: #212529;
}
.btn-dark:not(:disabled):not(.disabled):active:focus, .btn-dark:not(:disabled):not(.disabled).active:focus, .show > .btn-dark.dropdown-toggle:focus {
  box-shadow: none, 0 0 0 0 rgba(33, 37, 41, 0.5);
}

.btn-default {
  color: #212529;
  background-color: #ffd88c;
  border-color: #ffd88c;
  box-shadow: 0 4px 6px rgba(50, 50, 93, 0.11), 0 1px 3px rgba(0, 0, 0, 0.08);
}
.btn-default:hover {
  color: #212529;
  background-color: #ffd88c;
  border-color: #ffd88c;
}
.btn-default:focus, .btn-default.focus {
  box-shadow: 0 4px 6px rgba(50, 50, 93, 0.11), 0 1px 3px rgba(0, 0, 0, 0.08), 0 0 0 0 rgba(255, 216, 140, 0.5);
}
.btn-default.disabled, .btn-default:disabled {
  color: #212529;
  background-color: #ffd88c;
  border-color: #ffd88c;
}
.btn-default:not(:disabled):not(.disabled):active, .btn-default:not(:disabled):not(.disabled).active, .show > .btn-default.dropdown-toggle {
  color: #212529;
  background-color: rgb(255, 198.7043478261, 89);
  border-color: #ffd88c;
}
.btn-default:not(:disabled):not(.disabled):active:focus, .btn-default:not(:disabled):not(.disabled).active:focus, .show > .btn-default.dropdown-toggle:focus {
  box-shadow: none, 0 0 0 0 rgba(255, 216, 140, 0.5);
}

.btn-white {
  color: #212529;
  background-color: #fff;
  border-color: #fff;
  box-shadow: 0 4px 6px rgba(50, 50, 93, 0.11), 0 1px 3px rgba(0, 0, 0, 0.08);
}
.btn-white:hover {
  color: #212529;
  background-color: white;
  border-color: white;
}
.btn-white:focus, .btn-white.focus {
  box-shadow: 0 4px 6px rgba(50, 50, 93, 0.11), 0 1px 3px rgba(0, 0, 0, 0.08), 0 0 0 0 rgba(255, 255, 255, 0.5);
}
.btn-white.disabled, .btn-white:disabled {
  color: #212529;
  background-color: #fff;
  border-color: #fff;
}
.btn-white:not(:disabled):not(.disabled):active, .btn-white:not(:disabled):not(.disabled).active, .show > .btn-white.dropdown-toggle {
  color: #212529;
  background-color: rgb(229.5, 229.5, 229.5);
  border-color: white;
}
.btn-white:not(:disabled):not(.disabled):active:focus, .btn-white:not(:disabled):not(.disabled).active:focus, .show > .btn-white.dropdown-toggle:focus {
  box-shadow: none, 0 0 0 0 rgba(255, 255, 255, 0.5);
}

.btn-neutral {
  color: #212529;
  background-color: #fff;
  border-color: #fff;
  box-shadow: 0 4px 6px rgba(50, 50, 93, 0.11), 0 1px 3px rgba(0, 0, 0, 0.08);
}
.btn-neutral:hover {
  color: #212529;
  background-color: white;
  border-color: white;
}
.btn-neutral:focus, .btn-neutral.focus {
  box-shadow: 0 4px 6px rgba(50, 50, 93, 0.11), 0 1px 3px rgba(0, 0, 0, 0.08), 0 0 0 0 rgba(255, 255, 255, 0.5);
}
.btn-neutral.disabled, .btn-neutral:disabled {
  color: #212529;
  background-color: #fff;
  border-color: #fff;
}
.btn-neutral:not(:disabled):not(.disabled):active, .btn-neutral:not(:disabled):not(.disabled).active, .show > .btn-neutral.dropdown-toggle {
  color: #212529;
  background-color: rgb(229.5, 229.5, 229.5);
  border-color: white;
}
.btn-neutral:not(:disabled):not(.disabled):active:focus, .btn-neutral:not(:disabled):not(.disabled).active:focus, .show > .btn-neutral.dropdown-toggle:focus {
  box-shadow: none, 0 0 0 0 rgba(255, 255, 255, 0.5);
}

.btn-darker {
  color: #fff;
  background-color: black;
  border-color: black;
  box-shadow: 0 4px 6px rgba(50, 50, 93, 0.11), 0 1px 3px rgba(0, 0, 0, 0.08);
}
.btn-darker:hover {
  color: #fff;
  background-color: black;
  border-color: black;
}
.btn-darker:focus, .btn-darker.focus {
  box-shadow: 0 4px 6px rgba(50, 50, 93, 0.11), 0 1px 3px rgba(0, 0, 0, 0.08), 0 0 0 0 rgba(0, 0, 0, 0.5);
}
.btn-darker.disabled, .btn-darker:disabled {
  color: #fff;
  background-color: black;
  border-color: black;
}
.btn-darker:not(:disabled):not(.disabled):active, .btn-darker:not(:disabled):not(.disabled).active, .show > .btn-darker.dropdown-toggle {
  color: #fff;
  background-color: black;
  border-color: black;
}
.btn-darker:not(:disabled):not(.disabled):active:focus, .btn-darker:not(:disabled):not(.disabled).active:focus, .show > .btn-darker.dropdown-toggle:focus {
  box-shadow: none, 0 0 0 0 rgba(0, 0, 0, 0.5);
}

.btn-outline-primary {
  color: #3ba371;
  background-color: transparent;
  background-image: none;
  border-color: #3ba371;
}
.btn-outline-primary:hover {
  color: #fff;
  background-color: #3ba371;
  border-color: #3ba371;
}
.btn-outline-primary:focus, .btn-outline-primary.focus {
  box-shadow: 0 0 0 0 rgba(59, 163, 113, 0.5);
}
.btn-outline-primary.disabled, .btn-outline-primary:disabled {
  color: #3ba371;
  background-color: transparent;
}
.btn-outline-primary:not(:disabled):not(.disabled):active, .btn-outline-primary:not(:disabled):not(.disabled).active, .show > .btn-outline-primary.dropdown-toggle {
  color: #fff;
  background-color: #3ba371;
  border-color: #3ba371;
}
.btn-outline-primary:not(:disabled):not(.disabled):active:focus, .btn-outline-primary:not(:disabled):not(.disabled).active:focus, .show > .btn-outline-primary.dropdown-toggle:focus {
  box-shadow: 0 0 0 0 rgba(59, 163, 113, 0.5);
}

.btn-outline-secondary {
  color: #f7fafc;
  background-color: transparent;
  background-image: none;
  border-color: #f7fafc;
}
.btn-outline-secondary:hover {
  color: #212529;
  background-color: #f7fafc;
  border-color: #f7fafc;
}
.btn-outline-secondary:focus, .btn-outline-secondary.focus {
  box-shadow: 0 0 0 0 rgba(247, 250, 252, 0.5);
}
.btn-outline-secondary.disabled, .btn-outline-secondary:disabled {
  color: #f7fafc;
  background-color: transparent;
}
.btn-outline-secondary:not(:disabled):not(.disabled):active, .btn-outline-secondary:not(:disabled):not(.disabled).active, .show > .btn-outline-secondary.dropdown-toggle {
  color: #212529;
  background-color: #f7fafc;
  border-color: #f7fafc;
}
.btn-outline-secondary:not(:disabled):not(.disabled):active:focus, .btn-outline-secondary:not(:disabled):not(.disabled).active:focus, .show > .btn-outline-secondary.dropdown-toggle:focus {
  box-shadow: 0 0 0 0 rgba(247, 250, 252, 0.5);
}

.btn-outline-success {
  color: #3aa170;
  background-color: transparent;
  background-image: none;
  border-color: #3aa170;
}
.btn-outline-success:hover {
  color: #fff;
  background-color: #3aa170;
  border-color: #3aa170;
}
.btn-outline-success:focus, .btn-outline-success.focus {
  box-shadow: 0 0 0 0 rgba(58, 161, 112, 0.5);
}
.btn-outline-success.disabled, .btn-outline-success:disabled {
  color: #3aa170;
  background-color: transparent;
}
.btn-outline-success:not(:disabled):not(.disabled):active, .btn-outline-success:not(:disabled):not(.disabled).active, .show > .btn-outline-success.dropdown-toggle {
  color: #fff;
  background-color: #3aa170;
  border-color: #3aa170;
}
.btn-outline-success:not(:disabled):not(.disabled):active:focus, .btn-outline-success:not(:disabled):not(.disabled).active:focus, .show > .btn-outline-success.dropdown-toggle:focus {
  box-shadow: 0 0 0 0 rgba(58, 161, 112, 0.5);
}

.btn-outline-info {
  color: #278e69;
  background-color: transparent;
  background-image: none;
  border-color: #278e69;
}
.btn-outline-info:hover {
  color: #fff;
  background-color: #278e69;
  border-color: #278e69;
}
.btn-outline-info:focus, .btn-outline-info.focus {
  box-shadow: 0 0 0 0 rgba(39, 142, 105, 0.5);
}
.btn-outline-info.disabled, .btn-outline-info:disabled {
  color: #278e69;
  background-color: transparent;
}
.btn-outline-info:not(:disabled):not(.disabled):active, .btn-outline-info:not(:disabled):not(.disabled).active, .show > .btn-outline-info.dropdown-toggle {
  color: #fff;
  background-color: #278e69;
  border-color: #278e69;
}
.btn-outline-info:not(:disabled):not(.disabled):active:focus, .btn-outline-info:not(:disabled):not(.disabled).active:focus, .show > .btn-outline-info.dropdown-toggle:focus {
  box-shadow: 0 0 0 0 rgba(39, 142, 105, 0.5);
}

.btn-outline-warning {
  color: #fb6340;
  background-color: transparent;
  background-image: none;
  border-color: #fb6340;
}
.btn-outline-warning:hover {
  color: #fff;
  background-color: #fb6340;
  border-color: #fb6340;
}
.btn-outline-warning:focus, .btn-outline-warning.focus {
  box-shadow: 0 0 0 0 rgba(251, 99, 64, 0.5);
}
.btn-outline-warning.disabled, .btn-outline-warning:disabled {
  color: #fb6340;
  background-color: transparent;
}
.btn-outline-warning:not(:disabled):not(.disabled):active, .btn-outline-warning:not(:disabled):not(.disabled).active, .show > .btn-outline-warning.dropdown-toggle {
  color: #fff;
  background-color: #fb6340;
  border-color: #fb6340;
}
.btn-outline-warning:not(:disabled):not(.disabled):active:focus, .btn-outline-warning:not(:disabled):not(.disabled).active:focus, .show > .btn-outline-warning.dropdown-toggle:focus {
  box-shadow: 0 0 0 0 rgba(251, 99, 64, 0.5);
}

.btn-outline-danger {
  color: #f5365c;
  background-color: transparent;
  background-image: none;
  border-color: #f5365c;
}
.btn-outline-danger:hover {
  color: #fff;
  background-color: #f5365c;
  border-color: #f5365c;
}
.btn-outline-danger:focus, .btn-outline-danger.focus {
  box-shadow: 0 0 0 0 rgba(245, 54, 92, 0.5);
}
.btn-outline-danger.disabled, .btn-outline-danger:disabled {
  color: #f5365c;
  background-color: transparent;
}
.btn-outline-danger:not(:disabled):not(.disabled):active, .btn-outline-danger:not(:disabled):not(.disabled).active, .show > .btn-outline-danger.dropdown-toggle {
  color: #fff;
  background-color: #f5365c;
  border-color: #f5365c;
}
.btn-outline-danger:not(:disabled):not(.disabled):active:focus, .btn-outline-danger:not(:disabled):not(.disabled).active:focus, .show > .btn-outline-danger.dropdown-toggle:focus {
  box-shadow: 0 0 0 0 rgba(245, 54, 92, 0.5);
}

.btn-outline-light {
  color: #adb5bd;
  background-color: transparent;
  background-image: none;
  border-color: #adb5bd;
}
.btn-outline-light:hover {
  color: #fff;
  background-color: #adb5bd;
  border-color: #adb5bd;
}
.btn-outline-light:focus, .btn-outline-light.focus {
  box-shadow: 0 0 0 0 rgba(173, 181, 189, 0.5);
}
.btn-outline-light.disabled, .btn-outline-light:disabled {
  color: #adb5bd;
  background-color: transparent;
}
.btn-outline-light:not(:disabled):not(.disabled):active, .btn-outline-light:not(:disabled):not(.disabled).active, .show > .btn-outline-light.dropdown-toggle {
  color: #fff;
  background-color: #adb5bd;
  border-color: #adb5bd;
}
.btn-outline-light:not(:disabled):not(.disabled):active:focus, .btn-outline-light:not(:disabled):not(.disabled).active:focus, .show > .btn-outline-light.dropdown-toggle:focus {
  box-shadow: 0 0 0 0 rgba(173, 181, 189, 0.5);
}

.btn-outline-dark {
  color: #212529;
  background-color: transparent;
  background-image: none;
  border-color: #212529;
}
.btn-outline-dark:hover {
  color: #fff;
  background-color: #212529;
  border-color: #212529;
}
.btn-outline-dark:focus, .btn-outline-dark.focus {
  box-shadow: 0 0 0 0 rgba(33, 37, 41, 0.5);
}
.btn-outline-dark.disabled, .btn-outline-dark:disabled {
  color: #212529;
  background-color: transparent;
}
.btn-outline-dark:not(:disabled):not(.disabled):active, .btn-outline-dark:not(:disabled):not(.disabled).active, .show > .btn-outline-dark.dropdown-toggle {
  color: #fff;
  background-color: #212529;
  border-color: #212529;
}
.btn-outline-dark:not(:disabled):not(.disabled):active:focus, .btn-outline-dark:not(:disabled):not(.disabled).active:focus, .show > .btn-outline-dark.dropdown-toggle:focus {
  box-shadow: 0 0 0 0 rgba(33, 37, 41, 0.5);
}

.btn-outline-default {
  color: #ffd88c;
  background-color: transparent;
  background-image: none;
  border-color: #ffd88c;
}
.btn-outline-default:hover {
  color: #212529;
  background-color: #ffd88c;
  border-color: #ffd88c;
}
.btn-outline-default:focus, .btn-outline-default.focus {
  box-shadow: 0 0 0 0 rgba(255, 216, 140, 0.5);
}
.btn-outline-default.disabled, .btn-outline-default:disabled {
  color: #ffd88c;
  background-color: transparent;
}
.btn-outline-default:not(:disabled):not(.disabled):active, .btn-outline-default:not(:disabled):not(.disabled).active, .show > .btn-outline-default.dropdown-toggle {
  color: #212529;
  background-color: #ffd88c;
  border-color: #ffd88c;
}
.btn-outline-default:not(:disabled):not(.disabled):active:focus, .btn-outline-default:not(:disabled):not(.disabled).active:focus, .show > .btn-outline-default.dropdown-toggle:focus {
  box-shadow: 0 0 0 0 rgba(255, 216, 140, 0.5);
}

.btn-outline-white {
  color: #fff;
  background-color: transparent;
  background-image: none;
  border-color: #fff;
}
.btn-outline-white:hover {
  color: #212529;
  background-color: #fff;
  border-color: #fff;
}
.btn-outline-white:focus, .btn-outline-white.focus {
  box-shadow: 0 0 0 0 rgba(255, 255, 255, 0.5);
}
.btn-outline-white.disabled, .btn-outline-white:disabled {
  color: #fff;
  background-color: transparent;
}
.btn-outline-white:not(:disabled):not(.disabled):active, .btn-outline-white:not(:disabled):not(.disabled).active, .show > .btn-outline-white.dropdown-toggle {
  color: #212529;
  background-color: #fff;
  border-color: #fff;
}
.btn-outline-white:not(:disabled):not(.disabled):active:focus, .btn-outline-white:not(:disabled):not(.disabled).active:focus, .show > .btn-outline-white.dropdown-toggle:focus {
  box-shadow: 0 0 0 0 rgba(255, 255, 255, 0.5);
}

.btn-outline-neutral {
  color: #fff;
  background-color: transparent;
  background-image: none;
  border-color: #fff;
}
.btn-outline-neutral:hover {
  color: #212529;
  background-color: #fff;
  border-color: #fff;
}
.btn-outline-neutral:focus, .btn-outline-neutral.focus {
  box-shadow: 0 0 0 0 rgba(255, 255, 255, 0.5);
}
.btn-outline-neutral.disabled, .btn-outline-neutral:disabled {
  color: #fff;
  background-color: transparent;
}
.btn-outline-neutral:not(:disabled):not(.disabled):active, .btn-outline-neutral:not(:disabled):not(.disabled).active, .show > .btn-outline-neutral.dropdown-toggle {
  color: #212529;
  background-color: #fff;
  border-color: #fff;
}
.btn-outline-neutral:not(:disabled):not(.disabled):active:focus, .btn-outline-neutral:not(:disabled):not(.disabled).active:focus, .show > .btn-outline-neutral.dropdown-toggle:focus {
  box-shadow: 0 0 0 0 rgba(255, 255, 255, 0.5);
}

.btn-outline-darker {
  color: black;
  background-color: transparent;
  background-image: none;
  border-color: black;
}
.btn-outline-darker:hover {
  color: #fff;
  background-color: black;
  border-color: black;
}
.btn-outline-darker:focus, .btn-outline-darker.focus {
  box-shadow: 0 0 0 0 rgba(0, 0, 0, 0.5);
}
.btn-outline-darker.disabled, .btn-outline-darker:disabled {
  color: black;
  background-color: transparent;
}
.btn-outline-darker:not(:disabled):not(.disabled):active, .btn-outline-darker:not(:disabled):not(.disabled).active, .show > .btn-outline-darker.dropdown-toggle {
  color: #fff;
  background-color: black;
  border-color: black;
}
.btn-outline-darker:not(:disabled):not(.disabled):active:focus, .btn-outline-darker:not(:disabled):not(.disabled).active:focus, .show > .btn-outline-darker.dropdown-toggle:focus {
  box-shadow: 0 0 0 0 rgba(0, 0, 0, 0.5);
}

.btn-link {
  font-weight: 400;
  color: #3ba371;
  text-decoration: none;
}
.btn-link:hover {
  color: rgb(38.6689189189, 106.8310810811, 74.0608108108);
  text-decoration: none;
}
.btn-link:focus, .btn-link.focus {
  text-decoration: none;
}
.btn-link:disabled, .btn-link.disabled {
  color: #8898aa;
  pointer-events: none;
}

.btn-lg, .btn-group-lg > .btn {
  padding: 0.875rem 1rem;
  font-size: 0.875rem;
  line-height: 1.5;
  border-radius: 0.4375rem;
}

.btn-sm, .btn-group-sm > .btn {
  padding: 0.25rem 0.5rem;
  font-size: 0.75rem;
  line-height: 1.5;
  border-radius: 0.375rem;
}

.btn-block {
  display: block;
  width: 100%;
}
.btn-block + .btn-block {
  margin-top: 0.5rem;
}

input[type=submit].btn-block,
input[type=reset].btn-block,
input[type=button].btn-block {
  width: 100%;
}

.fade {
  transition: opacity 0.15s linear;
}
@media (prefers-reduced-motion: reduce) {
  .fade {
    transition: none;
  }
}
.fade:not(.show) {
  opacity: 0;
}

.collapse:not(.show) {
  display: none;
}

.collapsing {
  position: relative;
  height: 0;
  overflow: hidden;
  transition: height 0.35s ease;
}
@media (prefers-reduced-motion: reduce) {
  .collapsing {
    transition: none;
  }
}

.dropup,
.dropright,
.dropdown,
.dropleft {
  position: relative;
}

.dropdown-toggle {
  white-space: nowrap;
}
.dropdown-toggle::after {
  display: inline-block;
  margin-left: 0.255em;
  vertical-align: 0.255em;
  content: "";
  border-top: 0.3em solid;
  border-right: 0.3em solid transparent;
  border-bottom: 0;
  border-left: 0.3em solid transparent;
}
.dropdown-toggle:empty::after {
  margin-left: 0;
}

.dropdown-menu {
  position: absolute;
  top: 100%;
  left: 0;
  z-index: 1000;
  display: none;
  float: left;
  min-width: 10rem;
  padding: 0.5rem 0;
  margin: 0.125rem 0 0;
  font-size: 1rem;
  color: #525f7f;
  text-align: left;
  list-style: none;
  background-color: #fff;
  background-clip: padding-box;
  border: 0 solid rgba(0, 0, 0, 0.15);
  border-radius: 0.4375rem;
  box-shadow: 0 50px 100px rgba(50, 50, 93, 0.1), 0 15px 35px rgba(50, 50, 93, 0.15), 0 5px 15px rgba(0, 0, 0, 0.1);
}

.dropdown-menu-left {
  right: auto;
  left: 0;
}

.dropdown-menu-right {
  right: 0;
  left: auto;
}

@media (min-width: 576px) {
  .dropdown-menu-sm-left {
    right: auto;
    left: 0;
  }
  .dropdown-menu-sm-right {
    right: 0;
    left: auto;
  }
}
@media (min-width: 768px) {
  .dropdown-menu-md-left {
    right: auto;
    left: 0;
  }
  .dropdown-menu-md-right {
    right: 0;
    left: auto;
  }
}
@media (min-width: 992px) {
  .dropdown-menu-lg-left {
    right: auto;
    left: 0;
  }
  .dropdown-menu-lg-right {
    right: 0;
    left: auto;
  }
}
@media (min-width: 1200px) {
  .dropdown-menu-xl-left {
    right: auto;
    left: 0;
  }
  .dropdown-menu-xl-right {
    right: 0;
    left: auto;
  }
}
.dropup .dropdown-menu {
  top: auto;
  bottom: 100%;
  margin-top: 0;
  margin-bottom: 0.125rem;
}
.dropup .dropdown-toggle::after {
  display: inline-block;
  margin-left: 0.255em;
  vertical-align: 0.255em;
  content: "";
  border-top: 0;
  border-right: 0.3em solid transparent;
  border-bottom: 0.3em solid;
  border-left: 0.3em solid transparent;
}
.dropup .dropdown-toggle:empty::after {
  margin-left: 0;
}

.dropright .dropdown-menu {
  top: 0;
  right: auto;
  left: 100%;
  margin-top: 0;
  margin-left: 0.125rem;
}
.dropright .dropdown-toggle::after {
  display: inline-block;
  margin-left: 0.255em;
  vertical-align: 0.255em;
  content: "";
  border-top: 0.3em solid transparent;
  border-right: 0;
  border-bottom: 0.3em solid transparent;
  border-left: 0.3em solid;
}
.dropright .dropdown-toggle:empty::after {
  margin-left: 0;
}
.dropright .dropdown-toggle::after {
  vertical-align: 0;
}

.dropleft .dropdown-menu {
  top: 0;
  right: 100%;
  left: auto;
  margin-top: 0;
  margin-right: 0.125rem;
}
.dropleft .dropdown-toggle::after {
  display: inline-block;
  margin-left: 0.255em;
  vertical-align: 0.255em;
  content: "";
}
.dropleft .dropdown-toggle::after {
  display: none;
}
.dropleft .dropdown-toggle::before {
  display: inline-block;
  margin-right: 0.255em;
  vertical-align: 0.255em;
  content: "";
  border-top: 0.3em solid transparent;
  border-right: 0.3em solid;
  border-bottom: 0.3em solid transparent;
}
.dropleft .dropdown-toggle:empty::after {
  margin-left: 0;
}
.dropleft .dropdown-toggle::before {
  vertical-align: 0;
}

.dropdown-menu[x-placement^=top], .dropdown-menu[x-placement^=right], .dropdown-menu[x-placement^=bottom], .dropdown-menu[x-placement^=left] {
  right: auto;
  bottom: auto;
}

.dropdown-divider {
  height: 0;
  margin: 0.5rem 0;
  overflow: hidden;
  border-top: 1px solid #e9ecef;
}

.dropdown-item {
  display: block;
  width: 100%;
  padding: 0.25rem 1.5rem;
  clear: both;
  font-weight: 400;
  color: #212529;
  text-align: inherit;
  white-space: nowrap;
  background-color: transparent;
  border: 0;
}
.dropdown-item:hover, .dropdown-item:focus {
  color: rgb(21.6283783784, 24.25, 26.8716216216);
  text-decoration: none;
  background-color: #e9ecef;
}
.dropdown-item.active, .dropdown-item:active {
  color: #fff;
  text-decoration: none;
  background-color: #3ba371;
}
.dropdown-item.disabled, .dropdown-item:disabled {
  color: #adb5bd;
  pointer-events: none;
  background-color: transparent;
}

.dropdown-menu.show {
  display: block;
}

.dropdown-header {
  display: block;
  padding: 0.5rem 1.5rem;
  margin-bottom: 0;
  font-size: 0.875rem;
  color: #8898aa;
  white-space: nowrap;
}

.dropdown-item-text {
  display: block;
  padding: 0.25rem 1.5rem;
  color: #212529;
}

.btn-group,
.btn-group-vertical {
  position: relative;
  display: inline-flex;
  vertical-align: middle;
}
.btn-group > .btn,
.btn-group-vertical > .btn {
  position: relative;
  flex: 1 1 auto;
}
.btn-group > .btn:hover,
.btn-group-vertical > .btn:hover {
  z-index: 1;
}
.btn-group > .btn:focus, .btn-group > .btn:active, .btn-group > .btn.active,
.btn-group-vertical > .btn:focus,
.btn-group-vertical > .btn:active,
.btn-group-vertical > .btn.active {
  z-index: 1;
}

.btn-toolbar {
  display: flex;
  flex-wrap: wrap;
  justify-content: flex-start;
}
.btn-toolbar .input-group {
  width: auto;
}

.btn-group > .btn:not(:first-child),
.btn-group > .btn-group:not(:first-child) {
  margin-left: -1px;
}
.btn-group > .btn:not(:last-child):not(.dropdown-toggle),
.btn-group > .btn-group:not(:last-child) > .btn {
  border-top-right-radius: 0;
  border-bottom-right-radius: 0;
}
.btn-group > .btn:not(:first-child),
.btn-group > .btn-group:not(:first-child) > .btn {
  border-top-left-radius: 0;
  border-bottom-left-radius: 0;
}

.dropdown-toggle-split {
  padding-right: 0.9375rem;
  padding-left: 0.9375rem;
}
.dropdown-toggle-split::after, .dropup .dropdown-toggle-split::after, .dropright .dropdown-toggle-split::after {
  margin-left: 0;
}
.dropleft .dropdown-toggle-split::before {
  margin-right: 0;
}

.btn-sm + .dropdown-toggle-split, .btn-group-sm > .btn + .dropdown-toggle-split {
  padding-right: 0.375rem;
  padding-left: 0.375rem;
}

.btn-lg + .dropdown-toggle-split, .btn-group-lg > .btn + .dropdown-toggle-split {
  padding-right: 0.75rem;
  padding-left: 0.75rem;
}

.btn-group.show .dropdown-toggle {
  box-shadow: none;
}
.btn-group.show .dropdown-toggle.btn-link {
  box-shadow: none;
}

.btn-group-vertical {
  flex-direction: column;
  align-items: flex-start;
  justify-content: center;
}
.btn-group-vertical > .btn,
.btn-group-vertical > .btn-group {
  width: 100%;
}
.btn-group-vertical > .btn:not(:first-child),
.btn-group-vertical > .btn-group:not(:first-child) {
  margin-top: -1px;
}
.btn-group-vertical > .btn:not(:last-child):not(.dropdown-toggle),
.btn-group-vertical > .btn-group:not(:last-child) > .btn {
  border-bottom-right-radius: 0;
  border-bottom-left-radius: 0;
}
.btn-group-vertical > .btn:not(:first-child),
.btn-group-vertical > .btn-group:not(:first-child) > .btn {
  border-top-left-radius: 0;
  border-top-right-radius: 0;
}

.btn-group-toggle > .btn,
.btn-group-toggle > .btn-group > .btn {
  margin-bottom: 0;
}
.btn-group-toggle > .btn input[type=radio],
.btn-group-toggle > .btn input[type=checkbox],
.btn-group-toggle > .btn-group > .btn input[type=radio],
.btn-group-toggle > .btn-group > .btn input[type=checkbox] {
  position: absolute;
  clip: rect(0, 0, 0, 0);
  pointer-events: none;
}

.input-group {
  position: relative;
  display: flex;
  flex-wrap: wrap;
  align-items: stretch;
  width: 100%;
}
.input-group > .form-control,
.input-group > .form-control-plaintext,
.input-group > .custom-select,
.input-group > .custom-file {
  position: relative;
  flex: 1 1 auto;
  width: 1%;
  min-width: 0;
  margin-bottom: 0;
}
.input-group > .form-control + .form-control,
.input-group > .form-control + .custom-select,
.input-group > .form-control + .custom-file,
.input-group > .form-control-plaintext + .form-control,
.input-group > .form-control-plaintext + .custom-select,
.input-group > .form-control-plaintext + .custom-file,
.input-group > .custom-select + .form-control,
.input-group > .custom-select + .custom-select,
.input-group > .custom-select + .custom-file,
.input-group > .custom-file + .form-control,
.input-group > .custom-file + .custom-select,
.input-group > .custom-file + .custom-file {
  margin-left: -1px;
}
.input-group > .form-control:focus,
.input-group > .custom-select:focus,
.input-group > .custom-file .custom-file-input:focus ~ .custom-file-label {
  z-index: 3;
}
.input-group > .custom-file .custom-file-input:focus {
  z-index: 4;
}
.input-group > .form-control:not(:first-child),
.input-group > .custom-select:not(:first-child) {
  border-top-left-radius: 0;
  border-bottom-left-radius: 0;
}
.input-group > .custom-file {
  display: flex;
  align-items: center;
}
.input-group > .custom-file:not(:last-child) .custom-file-label, .input-group > .custom-file:not(:first-child) .custom-file-label {
  border-top-left-radius: 0;
  border-bottom-left-radius: 0;
}
.input-group:not(.has-validation) > .form-control:not(:last-child),
.input-group:not(.has-validation) > .custom-select:not(:last-child),
.input-group:not(.has-validation) > .custom-file:not(:last-child) .custom-file-label::after {
  border-top-right-radius: 0;
  border-bottom-right-radius: 0;
}
.input-group.has-validation > .form-control:nth-last-child(n+3),
.input-group.has-validation > .custom-select:nth-last-child(n+3),
.input-group.has-validation > .custom-file:nth-last-child(n+3) .custom-file-label::after {
  border-top-right-radius: 0;
  border-bottom-right-radius: 0;
}

.input-group-prepend,
.input-group-append {
  display: flex;
}
.input-group-prepend .btn,
.input-group-append .btn {
  position: relative;
  z-index: 2;
}
.input-group-prepend .btn:focus,
.input-group-append .btn:focus {
  z-index: 3;
}
.input-group-prepend .btn + .btn,
.input-group-prepend .btn + .input-group-text,
.input-group-prepend .input-group-text + .input-group-text,
.input-group-prepend .input-group-text + .btn,
.input-group-append .btn + .btn,
.input-group-append .btn + .input-group-text,
.input-group-append .input-group-text + .input-group-text,
.input-group-append .input-group-text + .btn {
  margin-left: -1px;
}

.input-group-prepend {
  margin-right: -1px;
}

.input-group-append {
  margin-left: -1px;
}

.input-group-text {
  display: flex;
  align-items: center;
  padding: 0.625rem 0.75rem;
  margin-bottom: 0;
  font-size: 0.875rem;
  font-weight: 400;
  line-height: 1.5;
  color: #adb5bd;
  text-align: center;
  white-space: nowrap;
  background-color: #fff;
  border: 1px solid #cad1d7;
  border-radius: 0.375rem;
}
.input-group-text input[type=radio],
.input-group-text input[type=checkbox] {
  margin-top: 0;
}

.input-group-lg > .form-control:not(textarea),
.input-group-lg > .custom-select {
  height: calc(1.5em + 1.75rem + 2px);
}

.input-group-lg > .form-control,
.input-group-lg > .custom-select,
.input-group-lg > .input-group-prepend > .input-group-text,
.input-group-lg > .input-group-append > .input-group-text,
.input-group-lg > .input-group-prepend > .btn,
.input-group-lg > .input-group-append > .btn {
  padding: 0.875rem 1rem;
  font-size: 0.875rem;
  line-height: 1.5;
  border-radius: 0.4375rem;
}

.input-group-sm > .form-control:not(textarea),
.input-group-sm > .custom-select {
  height: calc(1.5em + 0.5rem + 2px);
}

.input-group-sm > .form-control,
.input-group-sm > .custom-select,
.input-group-sm > .input-group-prepend > .input-group-text,
.input-group-sm > .input-group-append > .input-group-text,
.input-group-sm > .input-group-prepend > .btn,
.input-group-sm > .input-group-append > .btn {
  padding: 0.25rem 0.5rem;
  font-size: 0.75rem;
  line-height: 1.5;
  border-radius: 0.25rem;
}

.input-group-lg > .custom-select,
.input-group-sm > .custom-select {
  padding-right: 1.75rem;
}

.input-group > .input-group-prepend > .btn,
.input-group > .input-group-prepend > .input-group-text,
.input-group:not(.has-validation) > .input-group-append:not(:last-child) > .btn,
.input-group:not(.has-validation) > .input-group-append:not(:last-child) > .input-group-text,
.input-group.has-validation > .input-group-append:nth-last-child(n+3) > .btn,
.input-group.has-validation > .input-group-append:nth-last-child(n+3) > .input-group-text,
.input-group > .input-group-append:last-child > .btn:not(:last-child):not(.dropdown-toggle),
.input-group > .input-group-append:last-child > .input-group-text:not(:last-child) {
  border-top-right-radius: 0;
  border-bottom-right-radius: 0;
}

.input-group > .input-group-append > .btn,
.input-group > .input-group-append > .input-group-text,
.input-group > .input-group-prepend:not(:first-child) > .btn,
.input-group > .input-group-prepend:not(:first-child) > .input-group-text,
.input-group > .input-group-prepend:first-child > .btn:not(:first-child),
.input-group > .input-group-prepend:first-child > .input-group-text:not(:first-child) {
  border-top-left-radius: 0;
  border-bottom-left-radius: 0;
}

.custom-control {
  position: relative;
  z-index: 1;
  display: block;
  min-height: 1.5rem;
  padding-left: 3rem;
  color-adjust: exact;
}

.custom-control-inline {
  display: inline-flex;
  margin-right: 1rem;
}

.custom-control-input {
  position: absolute;
  left: 0;
  z-index: -1;
  width: 1.25rem;
  height: 1.375rem;
  opacity: 0;
}
.custom-control-input:checked ~ .custom-control-label::before {
  color: #fff;
  border-color: #3ba371;
  background-color: #3ba371;
  box-shadow: none;
}
.custom-control-input:focus ~ .custom-control-label::before {
  box-shadow: none, none;
}
.custom-control-input:focus:not(:checked) ~ .custom-control-label::before {
  border-color: rgba(50, 151, 211, 0.25);
}
.custom-control-input:not(:disabled):active ~ .custom-control-label::before {
  color: #fff;
  background-color: #3ba371;
  border-color: #3ba371;
  box-shadow: none;
}
.custom-control-input[disabled] ~ .custom-control-label, .custom-control-input:disabled ~ .custom-control-label {
  color: #8898aa;
}
.custom-control-input[disabled] ~ .custom-control-label::before, .custom-control-input:disabled ~ .custom-control-label::before {
  background-color: #e9ecef;
}

.custom-control-label {
  position: relative;
  margin-bottom: 0;
  vertical-align: top;
}
.custom-control-label::before {
  position: absolute;
  top: 0.125rem;
  left: -3rem;
  display: block;
  width: 1.25rem;
  height: 1.25rem;
  pointer-events: none;
  content: "";
  background-color: #fff;
  border: #cad1d7 solid 1px;
  box-shadow: none;
}
.custom-control-label::after {
  position: absolute;
  top: 0.125rem;
  left: -3rem;
  display: block;
  width: 1.25rem;
  height: 1.25rem;
  content: "";
  background: 50%/50% 50% no-repeat;
}

.custom-checkbox .custom-control-label::before {
  border-radius: 0.25rem;
}
.custom-checkbox .custom-control-input:checked ~ .custom-control-label::after {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
}
.custom-checkbox .custom-control-input:indeterminate ~ .custom-control-label::before {
  border-color: #3ba371;
  background-color: #3ba371;
}
.custom-checkbox .custom-control-input:indeterminate ~ .custom-control-label::after {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_1___});
}
.custom-checkbox .custom-control-input:disabled:checked ~ .custom-control-label::before {
  background-color: rgba(59, 163, 113, 0.5);
}
.custom-checkbox .custom-control-input:disabled:indeterminate ~ .custom-control-label::before {
  background-color: rgba(59, 163, 113, 0.5);
}

.custom-radio .custom-control-label::before {
  border-radius: 50%;
}
.custom-radio .custom-control-input:checked ~ .custom-control-label::after {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_2___});
}
.custom-radio .custom-control-input:disabled:checked ~ .custom-control-label::before {
  background-color: rgba(59, 163, 113, 0.5);
}

.custom-switch {
  padding-left: 3.9375rem;
}
.custom-switch .custom-control-label::before {
  left: -3.9375rem;
  width: 2.1875rem;
  pointer-events: all;
  border-radius: 0.625rem;
}
.custom-switch .custom-control-label::after {
  top: calc(0.125rem + 2px);
  left: calc(-3.9375rem + 2px);
  width: calc(1.25rem - 4px);
  height: calc(1.25rem - 4px);
  background-color: #cad1d7;
  border-radius: 0.625rem;
  transition: transform 0.15s ease-in-out, background-color 0.15s ease-in-out, border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;
}
@media (prefers-reduced-motion: reduce) {
  .custom-switch .custom-control-label::after {
    transition: none;
  }
}
.custom-switch .custom-control-input:checked ~ .custom-control-label::after {
  background-color: #fff;
  transform: translateX(0.9375rem);
}
.custom-switch .custom-control-input:disabled:checked ~ .custom-control-label::before {
  background-color: rgba(59, 163, 113, 0.5);
}

.custom-select {
  display: inline-block;
  width: 100%;
  height: calc(1.5em + 1.25rem + 2px);
  padding: 0.625rem 1.75rem 0.625rem 0.75rem;
  font-size: 0.875rem;
  font-weight: 400;
  line-height: 1.5;
  color: #8898aa;
  vertical-align: middle;
  background: #fff url(${___CSS_LOADER_URL_REPLACEMENT_3___}) right 0.75rem center/8px 10px no-repeat;
  border: 1px solid #cad1d7;
  border-radius: 0.375rem;
  box-shadow: inset 0 1px 2px rgba(0, 0, 0, 0.075);
  appearance: none;
}
.custom-select:focus {
  border-color: rgba(50, 151, 211, 0.25);
  outline: 0;
  box-shadow: inset 0 1px 2px rgba(0, 0, 0, 0.075), 0 0 0 0 #3ba371;
}
.custom-select:focus::-ms-value {
  color: #8898aa;
  background-color: #fff;
}
.custom-select[multiple], .custom-select[size]:not([size="1"]) {
  height: auto;
  padding-right: 0.75rem;
  background-image: none;
}
.custom-select:disabled {
  color: #8898aa;
  background-color: #e9ecef;
}
.custom-select::-ms-expand {
  display: none;
}
.custom-select:-moz-focusring {
  color: transparent;
  text-shadow: 0 0 0 #8898aa;
}

.custom-select-sm {
  height: calc(1.5em + 0.5rem + 2px);
  padding-top: 0.25rem;
  padding-bottom: 0.25rem;
  padding-left: 0.5rem;
  font-size: 0.75rem;
}

.custom-select-lg {
  height: calc(1.5em + 1.75rem + 2px);
  padding-top: 0.875rem;
  padding-bottom: 0.875rem;
  padding-left: 1rem;
  font-size: 0.875rem;
}

.custom-file {
  position: relative;
  display: inline-block;
  width: 100%;
  height: calc(1.5em + 1.25rem + 2px);
  margin-bottom: 0;
}

.custom-file-input {
  position: relative;
  z-index: 2;
  width: 100%;
  height: calc(1.5em + 1.25rem + 2px);
  margin: 0;
  overflow: hidden;
  opacity: 0;
}
.custom-file-input:focus ~ .custom-file-label {
  border-color: rgba(50, 151, 211, 0.25);
  box-shadow: none;
}
.custom-file-input[disabled] ~ .custom-file-label, .custom-file-input:disabled ~ .custom-file-label {
  background-color: #e9ecef;
}
.custom-file-input:lang(en) ~ .custom-file-label::after {
  content: "Browse";
}
.custom-file-input ~ .custom-file-label[data-browse]::after {
  content: attr(data-browse);
}

.custom-file-label {
  position: absolute;
  top: 0;
  right: 0;
  left: 0;
  z-index: 1;
  height: calc(1.5em + 1.25rem + 2px);
  padding: 0.625rem 0.75rem;
  overflow: hidden;
  font-weight: 400;
  line-height: 1.5;
  color: #8898aa;
  background-color: #fff;
  border: 1px solid #cad1d7;
  border-radius: 0.375rem;
  box-shadow: none;
}
.custom-file-label::after {
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  z-index: 3;
  display: block;
  height: calc(1.5em + 1.25rem);
  padding: 0.625rem 0.75rem;
  line-height: 1.5;
  color: #8898aa;
  content: "Browse";
  background-color: #fff;
  border-left: inherit;
  border-radius: 0 0.375rem 0.375rem 0;
}

.custom-range {
  width: 100%;
  height: 1rem;
  padding: 0;
  background-color: transparent;
  appearance: none;
}
.custom-range:focus {
  outline: 0;
}
.custom-range:focus::-webkit-slider-thumb {
  box-shadow: 0 0 0 1px #f8f9fe, none;
}
.custom-range:focus::-moz-range-thumb {
  box-shadow: 0 0 0 1px #f8f9fe, none;
}
.custom-range:focus::-ms-thumb {
  box-shadow: 0 0 0 1px #f8f9fe, none;
}
.custom-range::-moz-focus-outer {
  border: 0;
}
.custom-range::-webkit-slider-thumb {
  width: 1rem;
  height: 1rem;
  margin-top: -0.25rem;
  background-color: #3ba371;
  border: 0;
  border-radius: 1rem;
  box-shadow: 0 0.1rem 0.25rem rgba(0, 0, 0, 0.1);
  -webkit-transition: background-color 0.15s ease-in-out, border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;
  transition: background-color 0.15s ease-in-out, border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;
  appearance: none;
}
@media (prefers-reduced-motion: reduce) {
  .custom-range::-webkit-slider-thumb {
    -webkit-transition: none;
    transition: none;
  }
}
.custom-range::-webkit-slider-thumb:active {
  background-color: rgb(174.6013513514, 225.8986486486, 201.2364864865);
}
.custom-range::-webkit-slider-runnable-track {
  width: 100%;
  height: 0.5rem;
  color: transparent;
  cursor: pointer;
  background-color: #dee2e6;
  border-color: transparent;
  border-radius: 1rem;
  box-shadow: inset 0 0.25rem 0.25rem rgba(0, 0, 0, 0.1);
}
.custom-range::-moz-range-thumb {
  width: 1rem;
  height: 1rem;
  background-color: #3ba371;
  border: 0;
  border-radius: 1rem;
  box-shadow: 0 0.1rem 0.25rem rgba(0, 0, 0, 0.1);
  -moz-transition: background-color 0.15s ease-in-out, border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;
  transition: background-color 0.15s ease-in-out, border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;
  appearance: none;
}
@media (prefers-reduced-motion: reduce) {
  .custom-range::-moz-range-thumb {
    -moz-transition: none;
    transition: none;
  }
}
.custom-range::-moz-range-thumb:active {
  background-color: rgb(174.6013513514, 225.8986486486, 201.2364864865);
}
.custom-range::-moz-range-track {
  width: 100%;
  height: 0.5rem;
  color: transparent;
  cursor: pointer;
  background-color: #dee2e6;
  border-color: transparent;
  border-radius: 1rem;
  box-shadow: inset 0 0.25rem 0.25rem rgba(0, 0, 0, 0.1);
}
.custom-range::-ms-thumb {
  width: 1rem;
  height: 1rem;
  margin-top: 0;
  margin-right: 0;
  margin-left: 0;
  background-color: #3ba371;
  border: 0;
  border-radius: 1rem;
  box-shadow: 0 0.1rem 0.25rem rgba(0, 0, 0, 0.1);
  -ms-transition: background-color 0.15s ease-in-out, border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;
  transition: background-color 0.15s ease-in-out, border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;
  appearance: none;
}
@media (prefers-reduced-motion: reduce) {
  .custom-range::-ms-thumb {
    -ms-transition: none;
    transition: none;
  }
}
.custom-range::-ms-thumb:active {
  background-color: rgb(174.6013513514, 225.8986486486, 201.2364864865);
}
.custom-range::-ms-track {
  width: 100%;
  height: 0.5rem;
  color: transparent;
  cursor: pointer;
  background-color: transparent;
  border-color: transparent;
  border-width: 0.5rem;
  box-shadow: inset 0 0.25rem 0.25rem rgba(0, 0, 0, 0.1);
}
.custom-range::-ms-fill-lower {
  background-color: #dee2e6;
  border-radius: 1rem;
}
.custom-range::-ms-fill-upper {
  margin-right: 15px;
  background-color: #dee2e6;
  border-radius: 1rem;
}
.custom-range:disabled::-webkit-slider-thumb {
  background-color: #adb5bd;
}
.custom-range:disabled::-webkit-slider-runnable-track {
  cursor: default;
}
.custom-range:disabled::-moz-range-thumb {
  background-color: #adb5bd;
}
.custom-range:disabled::-moz-range-track {
  cursor: default;
}
.custom-range:disabled::-ms-thumb {
  background-color: #adb5bd;
}

.custom-control-label::before,
.custom-file-label,
.custom-select {
  transition: background-color 0.15s ease-in-out, border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;
}
@media (prefers-reduced-motion: reduce) {
  .custom-control-label::before,
  .custom-file-label,
  .custom-select {
    transition: none;
  }
}

.nav {
  display: flex;
  flex-wrap: wrap;
  padding-left: 0;
  margin-bottom: 0;
  list-style: none;
}

.nav-link {
  display: block;
  padding: 0.25rem 0.75rem;
}
.nav-link:hover, .nav-link:focus {
  text-decoration: none;
}
.nav-link.disabled {
  color: #8898aa;
  pointer-events: none;
  cursor: default;
}

.nav-tabs {
  border-bottom: 1px solid #dee2e6;
}
.nav-tabs .nav-link {
  margin-bottom: -1px;
  border: 1px solid transparent;
  border-top-left-radius: 0.375rem;
  border-top-right-radius: 0.375rem;
}
.nav-tabs .nav-link:hover, .nav-tabs .nav-link:focus {
  border-color: #e9ecef #e9ecef #dee2e6;
}
.nav-tabs .nav-link.disabled {
  color: #8898aa;
  background-color: transparent;
  border-color: transparent;
}
.nav-tabs .nav-link.active,
.nav-tabs .nav-item.show .nav-link {
  color: #525f7f;
  background-color: #f8f9fe;
  border-color: #dee2e6 #dee2e6 #f8f9fe;
}
.nav-tabs .dropdown-menu {
  margin-top: -1px;
  border-top-left-radius: 0;
  border-top-right-radius: 0;
}

.nav-pills .nav-link {
  border-radius: 0.375rem;
}
.nav-pills .nav-link.active,
.nav-pills .show > .nav-link {
  color: #fff;
  background-color: #3ba371;
}

.nav-fill > .nav-link,
.nav-fill .nav-item {
  flex: 1 1 auto;
  text-align: center;
}

.nav-justified > .nav-link,
.nav-justified .nav-item {
  flex-basis: 0;
  flex-grow: 1;
  text-align: center;
}

.tab-content > .tab-pane {
  display: none;
}
.tab-content > .active {
  display: block;
}

.navbar {
  position: relative;
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  justify-content: space-between;
  padding: 1rem 1rem;
}
.navbar .container,
.navbar .container-fluid,
.navbar .container-sm,
.navbar .container-md,
.navbar .container-lg,
.navbar .container-xl {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  justify-content: space-between;
}
.navbar-brand {
  display: inline-block;
  padding-top: 0.0625rem;
  padding-bottom: 0.0625rem;
  margin-right: 1rem;
  font-size: 1.25rem;
  line-height: inherit;
  white-space: nowrap;
}
.navbar-brand:hover, .navbar-brand:focus {
  text-decoration: none;
}

.navbar-nav {
  display: flex;
  flex-direction: column;
  padding-left: 0;
  margin-bottom: 0;
  list-style: none;
}
.navbar-nav .nav-link {
  padding-right: 0;
  padding-left: 0;
}
.navbar-nav .dropdown-menu {
  position: static;
  float: none;
}

.navbar-text {
  display: inline-block;
  padding-top: 0.25rem;
  padding-bottom: 0.25rem;
}

.navbar-collapse {
  flex-basis: 100%;
  flex-grow: 1;
  align-items: center;
}

.navbar-toggler {
  padding: 0.25rem 0.75rem;
  font-size: 1.25rem;
  line-height: 1;
  background-color: transparent;
  border: 1px solid transparent;
  border-radius: 0.375rem;
}
.navbar-toggler:hover, .navbar-toggler:focus {
  text-decoration: none;
}

.navbar-toggler-icon {
  display: inline-block;
  width: 1.5em;
  height: 1.5em;
  vertical-align: middle;
  content: "";
  background: 50%/100% 100% no-repeat;
}

.navbar-nav-scroll {
  max-height: 75vh;
  overflow-y: auto;
}

@media (max-width: 575.98px) {
  .navbar-expand-sm > .container,
  .navbar-expand-sm > .container-fluid,
  .navbar-expand-sm > .container-sm,
  .navbar-expand-sm > .container-md,
  .navbar-expand-sm > .container-lg,
  .navbar-expand-sm > .container-xl {
    padding-right: 0;
    padding-left: 0;
  }
}
@media (min-width: 576px) {
  .navbar-expand-sm {
    flex-flow: row nowrap;
    justify-content: flex-start;
  }
  .navbar-expand-sm .navbar-nav {
    flex-direction: row;
  }
  .navbar-expand-sm .navbar-nav .dropdown-menu {
    position: absolute;
  }
  .navbar-expand-sm .navbar-nav .nav-link {
    padding-right: 1rem;
    padding-left: 1rem;
  }
  .navbar-expand-sm > .container,
  .navbar-expand-sm > .container-fluid,
  .navbar-expand-sm > .container-sm,
  .navbar-expand-sm > .container-md,
  .navbar-expand-sm > .container-lg,
  .navbar-expand-sm > .container-xl {
    flex-wrap: nowrap;
  }
  .navbar-expand-sm .navbar-nav-scroll {
    overflow: visible;
  }
  .navbar-expand-sm .navbar-collapse {
    display: flex !important;
    flex-basis: auto;
  }
  .navbar-expand-sm .navbar-toggler {
    display: none;
  }
}
@media (max-width: 767.98px) {
  .navbar-expand-md > .container,
  .navbar-expand-md > .container-fluid,
  .navbar-expand-md > .container-sm,
  .navbar-expand-md > .container-md,
  .navbar-expand-md > .container-lg,
  .navbar-expand-md > .container-xl {
    padding-right: 0;
    padding-left: 0;
  }
}
@media (min-width: 768px) {
  .navbar-expand-md {
    flex-flow: row nowrap;
    justify-content: flex-start;
  }
  .navbar-expand-md .navbar-nav {
    flex-direction: row;
  }
  .navbar-expand-md .navbar-nav .dropdown-menu {
    position: absolute;
  }
  .navbar-expand-md .navbar-nav .nav-link {
    padding-right: 1rem;
    padding-left: 1rem;
  }
  .navbar-expand-md > .container,
  .navbar-expand-md > .container-fluid,
  .navbar-expand-md > .container-sm,
  .navbar-expand-md > .container-md,
  .navbar-expand-md > .container-lg,
  .navbar-expand-md > .container-xl {
    flex-wrap: nowrap;
  }
  .navbar-expand-md .navbar-nav-scroll {
    overflow: visible;
  }
  .navbar-expand-md .navbar-collapse {
    display: flex !important;
    flex-basis: auto;
  }
  .navbar-expand-md .navbar-toggler {
    display: none;
  }
}
@media (max-width: 991.98px) {
  .navbar-expand-lg > .container,
  .navbar-expand-lg > .container-fluid,
  .navbar-expand-lg > .container-sm,
  .navbar-expand-lg > .container-md,
  .navbar-expand-lg > .container-lg,
  .navbar-expand-lg > .container-xl {
    padding-right: 0;
    padding-left: 0;
  }
}
@media (min-width: 992px) {
  .navbar-expand-lg {
    flex-flow: row nowrap;
    justify-content: flex-start;
  }
  .navbar-expand-lg .navbar-nav {
    flex-direction: row;
  }
  .navbar-expand-lg .navbar-nav .dropdown-menu {
    position: absolute;
  }
  .navbar-expand-lg .navbar-nav .nav-link {
    padding-right: 1rem;
    padding-left: 1rem;
  }
  .navbar-expand-lg > .container,
  .navbar-expand-lg > .container-fluid,
  .navbar-expand-lg > .container-sm,
  .navbar-expand-lg > .container-md,
  .navbar-expand-lg > .container-lg,
  .navbar-expand-lg > .container-xl {
    flex-wrap: nowrap;
  }
  .navbar-expand-lg .navbar-nav-scroll {
    overflow: visible;
  }
  .navbar-expand-lg .navbar-collapse {
    display: flex !important;
    flex-basis: auto;
  }
  .navbar-expand-lg .navbar-toggler {
    display: none;
  }
}
@media (max-width: 1199.98px) {
  .navbar-expand-xl > .container,
  .navbar-expand-xl > .container-fluid,
  .navbar-expand-xl > .container-sm,
  .navbar-expand-xl > .container-md,
  .navbar-expand-xl > .container-lg,
  .navbar-expand-xl > .container-xl {
    padding-right: 0;
    padding-left: 0;
  }
}
@media (min-width: 1200px) {
  .navbar-expand-xl {
    flex-flow: row nowrap;
    justify-content: flex-start;
  }
  .navbar-expand-xl .navbar-nav {
    flex-direction: row;
  }
  .navbar-expand-xl .navbar-nav .dropdown-menu {
    position: absolute;
  }
  .navbar-expand-xl .navbar-nav .nav-link {
    padding-right: 1rem;
    padding-left: 1rem;
  }
  .navbar-expand-xl > .container,
  .navbar-expand-xl > .container-fluid,
  .navbar-expand-xl > .container-sm,
  .navbar-expand-xl > .container-md,
  .navbar-expand-xl > .container-lg,
  .navbar-expand-xl > .container-xl {
    flex-wrap: nowrap;
  }
  .navbar-expand-xl .navbar-nav-scroll {
    overflow: visible;
  }
  .navbar-expand-xl .navbar-collapse {
    display: flex !important;
    flex-basis: auto;
  }
  .navbar-expand-xl .navbar-toggler {
    display: none;
  }
}
.navbar-expand {
  flex-flow: row nowrap;
  justify-content: flex-start;
}
.navbar-expand > .container,
.navbar-expand > .container-fluid,
.navbar-expand > .container-sm,
.navbar-expand > .container-md,
.navbar-expand > .container-lg,
.navbar-expand > .container-xl {
  padding-right: 0;
  padding-left: 0;
}
.navbar-expand .navbar-nav {
  flex-direction: row;
}
.navbar-expand .navbar-nav .dropdown-menu {
  position: absolute;
}
.navbar-expand .navbar-nav .nav-link {
  padding-right: 1rem;
  padding-left: 1rem;
}
.navbar-expand > .container,
.navbar-expand > .container-fluid,
.navbar-expand > .container-sm,
.navbar-expand > .container-md,
.navbar-expand > .container-lg,
.navbar-expand > .container-xl {
  flex-wrap: nowrap;
}
.navbar-expand .navbar-nav-scroll {
  overflow: visible;
}
.navbar-expand .navbar-collapse {
  display: flex !important;
  flex-basis: auto;
}
.navbar-expand .navbar-toggler {
  display: none;
}

.navbar-light .navbar-brand {
  color: rgba(0, 0, 0, 0.9);
}
.navbar-light .navbar-brand:hover, .navbar-light .navbar-brand:focus {
  color: rgba(0, 0, 0, 0.9);
}
.navbar-light .navbar-nav .nav-link {
  color: rgba(0, 0, 0, 0.5);
}
.navbar-light .navbar-nav .nav-link:hover, .navbar-light .navbar-nav .nav-link:focus {
  color: rgba(0, 0, 0, 0.7);
}
.navbar-light .navbar-nav .nav-link.disabled {
  color: rgba(0, 0, 0, 0.3);
}
.navbar-light .navbar-nav .show > .nav-link,
.navbar-light .navbar-nav .active > .nav-link,
.navbar-light .navbar-nav .nav-link.show,
.navbar-light .navbar-nav .nav-link.active {
  color: rgba(0, 0, 0, 0.9);
}
.navbar-light .navbar-toggler {
  color: rgba(0, 0, 0, 0.5);
  border-color: transparent;
}
.navbar-light .navbar-toggler-icon {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_4___});
}
.navbar-light .navbar-text {
  color: rgba(0, 0, 0, 0.5);
}
.navbar-light .navbar-text a {
  color: rgba(0, 0, 0, 0.9);
}
.navbar-light .navbar-text a:hover, .navbar-light .navbar-text a:focus {
  color: rgba(0, 0, 0, 0.9);
}

.navbar-dark .navbar-brand {
  color: rgba(255, 255, 255, 0.65);
}
.navbar-dark .navbar-brand:hover, .navbar-dark .navbar-brand:focus {
  color: rgba(255, 255, 255, 0.65);
}
.navbar-dark .navbar-nav .nav-link {
  color: rgba(255, 255, 255, 0.95);
}
.navbar-dark .navbar-nav .nav-link:hover, .navbar-dark .navbar-nav .nav-link:focus {
  color: rgba(255, 255, 255, 0.65);
}
.navbar-dark .navbar-nav .nav-link.disabled {
  color: rgba(255, 255, 255, 0.25);
}
.navbar-dark .navbar-nav .show > .nav-link,
.navbar-dark .navbar-nav .active > .nav-link,
.navbar-dark .navbar-nav .nav-link.show,
.navbar-dark .navbar-nav .nav-link.active {
  color: rgba(255, 255, 255, 0.65);
}
.navbar-dark .navbar-toggler {
  color: rgba(255, 255, 255, 0.95);
  border-color: transparent;
}
.navbar-dark .navbar-toggler-icon {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_5___});
}
.navbar-dark .navbar-text {
  color: rgba(255, 255, 255, 0.95);
}
.navbar-dark .navbar-text a {
  color: rgba(255, 255, 255, 0.65);
}
.navbar-dark .navbar-text a:hover, .navbar-dark .navbar-text a:focus {
  color: rgba(255, 255, 255, 0.65);
}

.card {
  position: relative;
  display: flex;
  flex-direction: column;
  min-width: 0;
  word-wrap: break-word;
  background-color: #fff;
  background-clip: border-box;
  border: 1px solid rgba(0, 0, 0, 0.05);
  border-radius: 0.375rem;
}
.card > hr {
  margin-right: 0;
  margin-left: 0;
}
.card > .list-group {
  border-top: inherit;
  border-bottom: inherit;
}
.card > .list-group:first-child {
  border-top-width: 0;
  border-top-left-radius: calc(0.375rem - 1px);
  border-top-right-radius: calc(0.375rem - 1px);
}
.card > .list-group:last-child {
  border-bottom-width: 0;
  border-bottom-right-radius: calc(0.375rem - 1px);
  border-bottom-left-radius: calc(0.375rem - 1px);
}
.card > .card-header + .list-group,
.card > .list-group + .card-footer {
  border-top: 0;
}

.card-body {
  flex: 1 1 auto;
  min-height: 1px;
  padding: 1.5rem;
}

.card-title {
  margin-bottom: 1.25rem;
}

.card-subtitle {
  margin-top: -0.625rem;
  margin-bottom: 0;
}

.card-text:last-child {
  margin-bottom: 0;
}

.card-link:hover {
  text-decoration: none;
}
.card-link + .card-link {
  margin-left: 1.5rem;
}

.card-header {
  padding: 1.25rem 1.5rem;
  margin-bottom: 0;
  background-color: #fff;
  border-bottom: 1px solid rgba(0, 0, 0, 0.05);
}
.card-header:first-child {
  border-radius: calc(0.375rem - 1px) calc(0.375rem - 1px) 0 0;
}

.card-footer {
  padding: 1.25rem 1.5rem;
  background-color: #fff;
  border-top: 1px solid rgba(0, 0, 0, 0.05);
}
.card-footer:last-child {
  border-radius: 0 0 calc(0.375rem - 1px) calc(0.375rem - 1px);
}

.card-header-tabs {
  margin-right: -0.75rem;
  margin-bottom: -1.25rem;
  margin-left: -0.75rem;
  border-bottom: 0;
}

.card-header-pills {
  margin-right: -0.75rem;
  margin-left: -0.75rem;
}

.card-img-overlay {
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  padding: 1.25rem;
  border-radius: calc(0.375rem - 1px);
}

.card-img,
.card-img-top,
.card-img-bottom {
  flex-shrink: 0;
  width: 100%;
}

.card-img,
.card-img-top {
  border-top-left-radius: calc(0.375rem - 1px);
  border-top-right-radius: calc(0.375rem - 1px);
}

.card-img,
.card-img-bottom {
  border-bottom-right-radius: calc(0.375rem - 1px);
  border-bottom-left-radius: calc(0.375rem - 1px);
}

.card-deck .card {
  margin-bottom: 15px;
}
@media (min-width: 576px) {
  .card-deck {
    display: flex;
    flex-flow: row wrap;
    margin-right: -15px;
    margin-left: -15px;
  }
  .card-deck .card {
    flex: 1 0;
    margin-right: 15px;
    margin-bottom: 0;
    margin-left: 15px;
  }
}

.card-group > .card {
  margin-bottom: 15px;
}
@media (min-width: 576px) {
  .card-group {
    display: flex;
    flex-flow: row wrap;
  }
  .card-group > .card {
    flex: 1 0;
    margin-bottom: 0;
  }
  .card-group > .card + .card {
    margin-left: 0;
    border-left: 0;
  }
  .card-group > .card:not(:last-child) {
    border-top-right-radius: 0;
    border-bottom-right-radius: 0;
  }
  .card-group > .card:not(:last-child) .card-img-top,
  .card-group > .card:not(:last-child) .card-header {
    border-top-right-radius: 0;
  }
  .card-group > .card:not(:last-child) .card-img-bottom,
  .card-group > .card:not(:last-child) .card-footer {
    border-bottom-right-radius: 0;
  }
  .card-group > .card:not(:first-child) {
    border-top-left-radius: 0;
    border-bottom-left-radius: 0;
  }
  .card-group > .card:not(:first-child) .card-img-top,
  .card-group > .card:not(:first-child) .card-header {
    border-top-left-radius: 0;
  }
  .card-group > .card:not(:first-child) .card-img-bottom,
  .card-group > .card:not(:first-child) .card-footer {
    border-bottom-left-radius: 0;
  }
}

.card-columns .card {
  margin-bottom: 1.25rem;
}
@media (min-width: 576px) {
  .card-columns {
    column-count: 3;
    column-gap: 1.25rem;
    orphans: 1;
    widows: 1;
  }
  .card-columns .card {
    display: inline-block;
    width: 100%;
  }
}

.accordion {
  overflow-anchor: none;
}
.accordion > .card {
  overflow: hidden;
}
.accordion > .card:not(:last-of-type) {
  border-bottom: 0;
  border-bottom-right-radius: 0;
  border-bottom-left-radius: 0;
}
.accordion > .card:not(:first-of-type) {
  border-top-left-radius: 0;
  border-top-right-radius: 0;
}
.accordion > .card > .card-header {
  border-radius: 0;
  margin-bottom: -1px;
}

.breadcrumb {
  display: flex;
  flex-wrap: wrap;
  padding: 0.75rem 1rem;
  margin-bottom: 1rem;
  list-style: none;
  background-color: #e9ecef;
  border-radius: 0.375rem;
}

.breadcrumb-item + .breadcrumb-item {
  padding-left: 0.5rem;
}
.breadcrumb-item + .breadcrumb-item::before {
  float: left;
  padding-right: 0.5rem;
  color: #8898aa;
  content: "/";
}
.breadcrumb-item + .breadcrumb-item:hover::before {
  text-decoration: underline;
}
.breadcrumb-item + .breadcrumb-item:hover::before {
  text-decoration: none;
}
.breadcrumb-item.active {
  color: #8898aa;
}

.pagination {
  display: flex;
  padding-left: 0;
  list-style: none;
  border-radius: 0.375rem;
}

.page-link {
  position: relative;
  display: block;
  padding: 0.5rem 0.75rem;
  margin-left: -1px;
  line-height: 1.25;
  color: #8898aa;
  background-color: #fff;
  border: 1px solid #dee2e6;
}
.page-link:hover {
  z-index: 2;
  color: #8898aa;
  text-decoration: none;
  background-color: #dee2e6;
  border-color: #dee2e6;
}
.page-link:focus {
  z-index: 3;
  outline: 0;
  box-shadow: none;
}

.page-item:first-child .page-link {
  margin-left: 0;
  border-top-left-radius: 0.375rem;
  border-bottom-left-radius: 0.375rem;
}
.page-item:last-child .page-link {
  border-top-right-radius: 0.375rem;
  border-bottom-right-radius: 0.375rem;
}
.page-item.active .page-link {
  z-index: 3;
  color: #fff;
  background-color: #3ba371;
  border-color: #3ba371;
}
.page-item.disabled .page-link {
  color: #8898aa;
  pointer-events: none;
  cursor: auto;
  background-color: #fff;
  border-color: #dee2e6;
}

.pagination-lg .page-link {
  padding: 0.75rem 1.5rem;
  font-size: 1.25rem;
  line-height: 1.5;
}
.pagination-lg .page-item:first-child .page-link {
  border-top-left-radius: 0.4375rem;
  border-bottom-left-radius: 0.4375rem;
}
.pagination-lg .page-item:last-child .page-link {
  border-top-right-radius: 0.4375rem;
  border-bottom-right-radius: 0.4375rem;
}

.pagination-sm .page-link {
  padding: 0.25rem 0.5rem;
  font-size: 0.875rem;
  line-height: 1.5;
}
.pagination-sm .page-item:first-child .page-link {
  border-top-left-radius: 0.25rem;
  border-bottom-left-radius: 0.25rem;
}
.pagination-sm .page-item:last-child .page-link {
  border-top-right-radius: 0.25rem;
  border-bottom-right-radius: 0.25rem;
}

.badge {
  display: inline-block;
  padding: 0.35rem 0.375rem;
  font-size: 66%;
  font-weight: 600;
  line-height: 1;
  text-align: center;
  white-space: nowrap;
  vertical-align: baseline;
  border-radius: 0.375rem;
  transition: color 0.15s ease-in-out, background-color 0.15s ease-in-out, border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;
}
@media (prefers-reduced-motion: reduce) {
  .badge {
    transition: none;
  }
}
a.badge:hover, a.badge:focus {
  text-decoration: none;
}

.badge:empty {
  display: none;
}

.btn .badge {
  position: relative;
  top: -1px;
}

.badge-pill {
  padding-right: 0.875em;
  padding-left: 0.875em;
  border-radius: 10rem;
}

.badge-primary {
  color: rgb(36.8959459459, 134.1040540541, 87.3693866944);
  background-color: rgba(137.1554054054, 212.3445945946, 176.1959459459, 0.5);
}
.badge-primary[href]:hover, .badge-primary[href]:focus {
  color: #fff;
  text-decoration: none;
  background-color: rgb(45.4459459459, 125.5540540541, 87.0405405405);
}

.badge-secondary {
  color: rgb(206.8090909091, 227.4381818182, 241.1909090909);
  background-color: rgba(255, 255, 255, 0.5);
}
.badge-secondary[href]:hover, .badge-secondary[href]:focus {
  color: #212529;
  text-decoration: none;
  background-color: rgb(209.9090909091, 226.8181818182, 238.0909090909);
}

.badge-success {
  color: rgb(36.0931506849, 131.9068493151, 86.3255752095);
  background-color: rgba(134.801369863, 211.698630137, 175.1164383562, 0.5);
}
.badge-success[href]:hover, .badge-success[href]:focus {
  color: #fff;
  text-decoration: none;
  background-color: rgb(44.4931506849, 123.5068493151, 85.9178082192);
}

.badge-info {
  color: rgb(21.5110497238, 108.4889502762, 77.2444617283);
  background-color: rgba(96.9171270718, 211.5828729282, 170.3922651934, 0.5);
}
.badge-info[href]:hover, .badge-info[href]:focus {
  color: #fff;
  text-decoration: none;
  background-color: rgb(28.0110497238, 101.9889502762, 75.4143646409);
}

.badge-warning {
  color: rgb(255, 55.0427807487, 9);
  background-color: rgba(253.6153846154, 201, 188.8846153846, 0.5);
}
.badge-warning[href]:hover, .badge-warning[href]:focus {
  color: #fff;
  text-decoration: none;
  background-color: rgb(249.9538461538, 58.2, 14.0461538462);
}

.badge-danger {
  color: rgb(248, 0, 49.3403141361);
  background-color: rgba(251.0426540284, 175.4573459716, 190.4952606635, 0.5);
}
.badge-danger[href]:hover, .badge-danger[href]:focus {
  color: #fff;
  text-decoration: none;
  background-color: rgb(236.2464454976, 11.7535545024, 56.4170616114);
}

.badge-light {
  color: rgb(134.7932432432, 155.5, 176.2067567568);
  background-color: rgba(243.6418918919, 244.75, 245.8581081081, 0.5);
}
.badge-light[href]:hover, .badge-light[href]:focus {
  color: #fff;
  text-decoration: none;
  background-color: rgb(144.7432432432, 155.5, 166.2567567568);
}

.badge-dark {
  color: rgb(9.1067567568, 11.5, 13.8932432432);
  background-color: rgba(89.8581081081, 100.75, 111.6418918919, 0.5);
}
.badge-dark[href]:hover, .badge-dark[href]:focus {
  color: #fff;
  text-decoration: none;
  background-color: rgb(10.2567567568, 11.5, 12.7432432432);
}

.badge-default {
  color: rgb(255, 198.7043478261, 89);
  background-color: rgba(255, 255, 255, 0.5);
}
.badge-default[href]:hover, .badge-default[href]:focus {
  color: #212529;
  text-decoration: none;
  background-color: rgb(255, 198.7043478261, 89);
}

.badge-white {
  color: rgb(232.05, 226.95, 226.95);
  background-color: rgba(255, 255, 255, 0.5);
}
.badge-white[href]:hover, .badge-white[href]:focus {
  color: #212529;
  text-decoration: none;
  background-color: rgb(229.5, 229.5, 229.5);
}

.badge-neutral {
  color: rgb(232.05, 226.95, 226.95);
  background-color: rgba(255, 255, 255, 0.5);
}
.badge-neutral[href]:hover, .badge-neutral[href]:focus {
  color: #212529;
  text-decoration: none;
  background-color: rgb(229.5, 229.5, 229.5);
}

.badge-darker {
  color: black;
  background-color: rgba(63.75, 63.75, 63.75, 0.5);
}
.badge-darker[href]:hover, .badge-darker[href]:focus {
  color: #fff;
  text-decoration: none;
  background-color: black;
}

.jumbotron {
  padding: 2rem 1rem;
  margin-bottom: 2rem;
  background-color: #e9ecef;
  border-radius: 0.4375rem;
}
@media (min-width: 576px) {
  .jumbotron {
    padding: 4rem 2rem;
  }
}

.jumbotron-fluid {
  padding-right: 0;
  padding-left: 0;
  border-radius: 0;
}

.alert {
  position: relative;
  padding: 1rem 1.5rem;
  margin-bottom: 1rem;
  border: 1px solid transparent;
  border-radius: 0.375rem;
}

.alert-heading {
  color: inherit;
}

.alert-link {
  font-weight: 600;
}

.alert-dismissible {
  padding-right: 4.5rem;
}
.alert-dismissible .close {
  position: absolute;
  top: 0;
  right: 0;
  z-index: 2;
  padding: 1rem 1.5rem;
  color: inherit;
}

.alert-primary {
  color: #fff;
  background-color: rgb(90.36, 177.72, 135.72);
  border-color: rgb(90.36, 177.72, 135.72);
}
.alert-primary hr {
  border-top-color: rgb(77.4908333333, 165.0891666667, 122.9745833333);
}
.alert-primary .alert-link {
  color: rgb(45.4459459459, 125.5540540541, 87.0405405405);
}

.alert-secondary {
  color: #212529;
  background-color: rgb(248.28, 250.8, 252.48);
  border-color: rgb(248.28, 250.8, 252.48);
}
.alert-secondary hr {
  border-top-color: rgb(229.7345454545, 239.2090909091, 245.5254545455);
}
.alert-secondary .alert-link {
  color: rgb(209.9090909091, 226.8181818182, 238.0909090909);
}

.alert-success {
  color: #fff;
  background-color: rgb(89.52, 176.04, 134.88);
  border-color: rgb(89.52, 176.04, 134.88);
}
.alert-success hr {
  border-top-color: rgb(77.5451546392, 162.5148453608, 122.092371134);
}
.alert-success .alert-link {
  color: rgb(44.4931506849, 123.5068493151, 85.9178082192);
}

.alert-info {
  color: #fff;
  background-color: rgb(73.56, 160.08, 129);
  border-color: rgb(73.56, 160.08, 129);
}
.alert-info hr {
  border-top-color: rgb(65.5314946071, 142.6085053929, 114.9206471495);
}
.alert-info .alert-link {
  color: rgb(28.0110497238, 101.9889502762, 75.4143646409);
}

.alert-warning {
  color: #fff;
  background-color: rgb(251.64, 123.96, 94.56);
  border-color: rgb(251.64, 123.96, 94.56);
}
.alert-warning hr {
  border-top-color: rgb(251.1169230769, 103.56, 69.5830769231);
}
.alert-warning .alert-link {
  color: rgb(249.9538461538, 58.2, 14.0461538462);
}

.alert-danger {
  color: #fff;
  background-color: rgb(246.6, 86.16, 118.08);
  border-color: rgb(246.6, 86.16, 118.08);
}
.alert-danger hr {
  border-top-color: rgb(245.3914691943, 61.8685308057, 98.3809478673);
}
.alert-danger .alert-link {
  color: rgb(236.2464454976, 11.7535545024, 56.4170616114);
}

.alert-light {
  color: #fff;
  background-color: rgb(186.12, 192.84, 199.56);
  border-color: rgb(186.12, 192.84, 199.56);
}
.alert-light hr {
  border-top-color: rgb(171.9916216216, 180.09, 188.1883783784);
}
.alert-light .alert-link {
  color: rgb(144.7432432432, 155.5, 166.2567567568);
}

.alert-dark {
  color: #fff;
  background-color: rgb(68.52, 71.88, 75.24);
  border-color: rgb(68.52, 71.88, 75.24);
}
.alert-dark hr {
  border-top-color: rgb(56.3659933222, 59.13, 61.8940066778);
}
.alert-dark .alert-link {
  color: rgb(10.2567567568, 11.5, 12.7432432432);
}

.alert-default {
  color: #212529;
  background-color: rgb(255, 222.24, 158.4);
  border-color: rgb(255, 222.24, 158.4);
}
.alert-default hr {
  border-top-color: rgb(255, 213.592173913, 132.9);
}
.alert-default .alert-link {
  color: rgb(255, 198.7043478261, 89);
}

.alert-white {
  color: #212529;
  background-color: white;
  border-color: white;
}
.alert-white hr {
  border-top-color: rgb(242.25, 242.25, 242.25);
}
.alert-white .alert-link {
  color: rgb(229.5, 229.5, 229.5);
}

.alert-neutral {
  color: #212529;
  background-color: white;
  border-color: white;
}
.alert-neutral hr {
  border-top-color: rgb(242.25, 242.25, 242.25);
}
.alert-neutral .alert-link {
  color: rgb(229.5, 229.5, 229.5);
}

.alert-darker {
  color: #fff;
  background-color: rgb(40.8, 40.8, 40.8);
  border-color: rgb(40.8, 40.8, 40.8);
}
.alert-darker hr {
  border-top-color: rgb(28.05, 28.05, 28.05);
}
.alert-darker .alert-link {
  color: black;
}

@keyframes progress-bar-stripes {
  from {
    background-position: 1rem 0;
  }
  to {
    background-position: 0 0;
  }
}
.progress {
  display: flex;
  height: 1rem;
  overflow: hidden;
  line-height: 0;
  font-size: 0.75rem;
  background-color: #e9ecef;
  border-radius: 0.375rem;
  box-shadow: inset 0 0.1rem 0.1rem rgba(0, 0, 0, 0.1);
}

.progress-bar {
  display: flex;
  flex-direction: column;
  justify-content: center;
  overflow: hidden;
  color: #fff;
  text-align: center;
  white-space: nowrap;
  background-color: #3ba371;
  transition: width 0.6s ease;
}
@media (prefers-reduced-motion: reduce) {
  .progress-bar {
    transition: none;
  }
}

.progress-bar-striped {
  background-image: linear-gradient(45deg, rgba(255, 255, 255, 0.15) 25%, transparent 25%, transparent 50%, rgba(255, 255, 255, 0.15) 50%, rgba(255, 255, 255, 0.15) 75%, transparent 75%, transparent);
  background-size: 1rem 1rem;
}

.progress-bar-animated {
  animation: 1s linear infinite progress-bar-stripes;
}
@media (prefers-reduced-motion: reduce) {
  .progress-bar-animated {
    animation: none;
  }
}

.media {
  display: flex;
  align-items: flex-start;
}

.media-body {
  flex: 1 1;
}

.list-group {
  display: flex;
  flex-direction: column;
  padding-left: 0;
  margin-bottom: 0;
  border-radius: 0.375rem;
}

.list-group-item-action {
  width: 100%;
  color: #525f7f;
  text-align: inherit;
}
.list-group-item-action:hover, .list-group-item-action:focus {
  z-index: 1;
  color: #525f7f;
  text-decoration: none;
  background-color: #f6f9fc;
}
.list-group-item-action:active {
  color: #525f7f;
  background-color: #e9ecef;
}

.list-group-item {
  position: relative;
  display: block;
  padding: 1rem 1rem;
  background-color: #fff;
  border: 1px solid #e9ecef;
}
.list-group-item:first-child {
  border-top-left-radius: inherit;
  border-top-right-radius: inherit;
}
.list-group-item:last-child {
  border-bottom-right-radius: inherit;
  border-bottom-left-radius: inherit;
}
.list-group-item.disabled, .list-group-item:disabled {
  color: #8898aa;
  pointer-events: none;
  background-color: #fff;
}
.list-group-item.active {
  z-index: 2;
  color: #fff;
  background-color: #3ba371;
  border-color: #3ba371;
}
.list-group-item + .list-group-item {
  border-top-width: 0;
}
.list-group-item + .list-group-item.active {
  margin-top: -1px;
  border-top-width: 1px;
}

.list-group-horizontal {
  flex-direction: row;
}
.list-group-horizontal > .list-group-item:first-child {
  border-bottom-left-radius: 0.375rem;
  border-top-right-radius: 0;
}
.list-group-horizontal > .list-group-item:last-child {
  border-top-right-radius: 0.375rem;
  border-bottom-left-radius: 0;
}
.list-group-horizontal > .list-group-item.active {
  margin-top: 0;
}
.list-group-horizontal > .list-group-item + .list-group-item {
  border-top-width: 1px;
  border-left-width: 0;
}
.list-group-horizontal > .list-group-item + .list-group-item.active {
  margin-left: -1px;
  border-left-width: 1px;
}

@media (min-width: 576px) {
  .list-group-horizontal-sm {
    flex-direction: row;
  }
  .list-group-horizontal-sm > .list-group-item:first-child {
    border-bottom-left-radius: 0.375rem;
    border-top-right-radius: 0;
  }
  .list-group-horizontal-sm > .list-group-item:last-child {
    border-top-right-radius: 0.375rem;
    border-bottom-left-radius: 0;
  }
  .list-group-horizontal-sm > .list-group-item.active {
    margin-top: 0;
  }
  .list-group-horizontal-sm > .list-group-item + .list-group-item {
    border-top-width: 1px;
    border-left-width: 0;
  }
  .list-group-horizontal-sm > .list-group-item + .list-group-item.active {
    margin-left: -1px;
    border-left-width: 1px;
  }
}
@media (min-width: 768px) {
  .list-group-horizontal-md {
    flex-direction: row;
  }
  .list-group-horizontal-md > .list-group-item:first-child {
    border-bottom-left-radius: 0.375rem;
    border-top-right-radius: 0;
  }
  .list-group-horizontal-md > .list-group-item:last-child {
    border-top-right-radius: 0.375rem;
    border-bottom-left-radius: 0;
  }
  .list-group-horizontal-md > .list-group-item.active {
    margin-top: 0;
  }
  .list-group-horizontal-md > .list-group-item + .list-group-item {
    border-top-width: 1px;
    border-left-width: 0;
  }
  .list-group-horizontal-md > .list-group-item + .list-group-item.active {
    margin-left: -1px;
    border-left-width: 1px;
  }
}
@media (min-width: 992px) {
  .list-group-horizontal-lg {
    flex-direction: row;
  }
  .list-group-horizontal-lg > .list-group-item:first-child {
    border-bottom-left-radius: 0.375rem;
    border-top-right-radius: 0;
  }
  .list-group-horizontal-lg > .list-group-item:last-child {
    border-top-right-radius: 0.375rem;
    border-bottom-left-radius: 0;
  }
  .list-group-horizontal-lg > .list-group-item.active {
    margin-top: 0;
  }
  .list-group-horizontal-lg > .list-group-item + .list-group-item {
    border-top-width: 1px;
    border-left-width: 0;
  }
  .list-group-horizontal-lg > .list-group-item + .list-group-item.active {
    margin-left: -1px;
    border-left-width: 1px;
  }
}
@media (min-width: 1200px) {
  .list-group-horizontal-xl {
    flex-direction: row;
  }
  .list-group-horizontal-xl > .list-group-item:first-child {
    border-bottom-left-radius: 0.375rem;
    border-top-right-radius: 0;
  }
  .list-group-horizontal-xl > .list-group-item:last-child {
    border-top-right-radius: 0.375rem;
    border-bottom-left-radius: 0;
  }
  .list-group-horizontal-xl > .list-group-item.active {
    margin-top: 0;
  }
  .list-group-horizontal-xl > .list-group-item + .list-group-item {
    border-top-width: 1px;
    border-left-width: 0;
  }
  .list-group-horizontal-xl > .list-group-item + .list-group-item.active {
    margin-left: -1px;
    border-left-width: 1px;
  }
}
.list-group-flush {
  border-radius: 0;
}
.list-group-flush > .list-group-item {
  border-width: 0 0 1px;
}
.list-group-flush > .list-group-item:last-child {
  border-bottom-width: 0;
}

.list-group-item-primary {
  color: rgb(30.68, 84.76, 58.76);
  background-color: rgb(200.12, 229.24, 215.24);
}
.list-group-item-primary.list-group-item-action:hover, .list-group-item-primary.list-group-item-action:focus {
  color: rgb(30.68, 84.76, 58.76);
  background-color: rgb(182.7658333333, 221.0941666667, 202.6670833333);
}
.list-group-item-primary.list-group-item-action.active {
  color: #fff;
  background-color: rgb(30.68, 84.76, 58.76);
  border-color: rgb(30.68, 84.76, 58.76);
}

.list-group-item-secondary {
  color: rgb(128.44, 130, 131.04);
  background-color: rgb(252.76, 253.6, 254.16);
}
.list-group-item-secondary.list-group-item-action:hover, .list-group-item-secondary.list-group-item-action:focus {
  color: rgb(128.44, 130, 131.04);
  background-color: rgb(234.2145454545, 242.0090909091, 247.2054545455);
}
.list-group-item-secondary.list-group-item-action.active {
  color: #fff;
  background-color: rgb(128.44, 130, 131.04);
  border-color: rgb(128.44, 130, 131.04);
}

.list-group-item-success {
  color: rgb(30.16, 83.72, 58.24);
  background-color: rgb(199.84, 228.68, 214.96);
}
.list-group-item-success.list-group-item-action:hover, .list-group-item-success.list-group-item-action:focus {
  color: rgb(30.16, 83.72, 58.24);
  background-color: rgb(182.5771134021, 220.4428865979, 202.4290721649);
}
.list-group-item-success.list-group-item-action.active {
  color: #fff;
  background-color: rgb(30.16, 83.72, 58.24);
  border-color: rgb(30.16, 83.72, 58.24);
}

.list-group-item-info {
  color: rgb(20.28, 73.84, 54.6);
  background-color: rgb(194.52, 223.36, 213);
}
.list-group-item-info.list-group-item-action:hover, .list-group-item-info.list-group-item-action:focus {
  color: rgb(20.28, 73.84, 54.6);
  background-color: rgb(177.7783586626, 214.6016413374, 201.3738601824);
}
.list-group-item-info.list-group-item-action.active {
  color: #fff;
  background-color: rgb(20.28, 73.84, 54.6);
  border-color: rgb(20.28, 73.84, 54.6);
}

.list-group-item-warning {
  color: rgb(130.52, 51.48, 33.28);
  background-color: rgb(253.88, 211.32, 201.52);
}
.list-group-item-warning.list-group-item-action:hover, .list-group-item-warning.list-group-item-action:focus {
  color: rgb(130.52, 51.48, 33.28);
  background-color: rgb(253.3569230769, 190.92, 176.5430769231);
}
.list-group-item-warning.list-group-item-action.active {
  color: #fff;
  background-color: rgb(130.52, 51.48, 33.28);
  border-color: rgb(130.52, 51.48, 33.28);
}

.list-group-item-danger {
  color: rgb(127.4, 28.08, 47.84);
  background-color: rgb(252.2, 198.72, 209.36);
}
.list-group-item-danger.list-group-item-action:hover, .list-group-item-danger.list-group-item-action:focus {
  color: rgb(127.4, 28.08, 47.84);
  background-color: rgb(250.9914691943, 174.4285308057, 189.6609478673);
}
.list-group-item-danger.list-group-item-action.active {
  color: #fff;
  background-color: rgb(127.4, 28.08, 47.84);
  border-color: rgb(127.4, 28.08, 47.84);
}

.list-group-item-light {
  color: rgb(89.96, 94.12, 98.28);
  background-color: rgb(232.04, 234.28, 236.52);
}
.list-group-item-light.list-group-item-action:hover, .list-group-item-light.list-group-item-action:focus {
  color: rgb(89.96, 94.12, 98.28);
  background-color: rgb(217.9116216216, 221.53, 225.1483783784);
}
.list-group-item-light.list-group-item-action.active {
  color: #fff;
  background-color: rgb(89.96, 94.12, 98.28);
  border-color: rgb(89.96, 94.12, 98.28);
}

.list-group-item-dark {
  color: rgb(17.16, 19.24, 21.32);
  background-color: rgb(192.84, 193.96, 195.08);
}
.list-group-item-dark.list-group-item-action:hover, .list-group-item-dark.list-group-item-action:focus {
  color: rgb(17.16, 19.24, 21.32);
  background-color: rgb(179.8560550459, 181.21, 182.5639449541);
}
.list-group-item-dark.list-group-item-action.active {
  color: #fff;
  background-color: rgb(17.16, 19.24, 21.32);
  border-color: rgb(17.16, 19.24, 21.32);
}

.list-group-item-default {
  color: rgb(132.6, 112.32, 72.8);
  background-color: rgb(255, 244.08, 222.8);
}
.list-group-item-default.list-group-item-action:hover, .list-group-item-default.list-group-item-action:focus {
  color: rgb(132.6, 112.32, 72.8);
  background-color: rgb(255, 235.432173913, 197.3);
}
.list-group-item-default.list-group-item-action.active {
  color: #fff;
  background-color: rgb(132.6, 112.32, 72.8);
  border-color: rgb(132.6, 112.32, 72.8);
}

.list-group-item-white {
  color: rgb(132.6, 132.6, 132.6);
  background-color: white;
}
.list-group-item-white.list-group-item-action:hover, .list-group-item-white.list-group-item-action:focus {
  color: rgb(132.6, 132.6, 132.6);
  background-color: rgb(242.25, 242.25, 242.25);
}
.list-group-item-white.list-group-item-action.active {
  color: #fff;
  background-color: rgb(132.6, 132.6, 132.6);
  border-color: rgb(132.6, 132.6, 132.6);
}

.list-group-item-neutral {
  color: rgb(132.6, 132.6, 132.6);
  background-color: white;
}
.list-group-item-neutral.list-group-item-action:hover, .list-group-item-neutral.list-group-item-action:focus {
  color: rgb(132.6, 132.6, 132.6);
  background-color: rgb(242.25, 242.25, 242.25);
}
.list-group-item-neutral.list-group-item-action.active {
  color: #fff;
  background-color: rgb(132.6, 132.6, 132.6);
  border-color: rgb(132.6, 132.6, 132.6);
}

.list-group-item-darker {
  color: black;
  background-color: rgb(183.6, 183.6, 183.6);
}
.list-group-item-darker.list-group-item-action:hover, .list-group-item-darker.list-group-item-action:focus {
  color: black;
  background-color: rgb(170.85, 170.85, 170.85);
}
.list-group-item-darker.list-group-item-action.active {
  color: #fff;
  background-color: black;
  border-color: black;
}

.close {
  float: right;
  font-size: 1.5rem;
  font-weight: 600;
  line-height: 1;
  color: rgba(0, 0, 0, 0.6);
  text-shadow: none;
  opacity: 0.5;
}
.close:hover {
  color: rgba(0, 0, 0, 0.6);
  text-decoration: none;
}
.close:not(:disabled):not(.disabled):hover, .close:not(:disabled):not(.disabled):focus {
  opacity: 0.75;
}

button.close {
  padding: 0;
  background-color: transparent;
  border: 0;
}

a.close.disabled {
  pointer-events: none;
}

.modal-open {
  overflow: hidden;
}
.modal-open .modal {
  overflow-x: hidden;
  overflow-y: auto;
}

.modal {
  position: fixed;
  top: 0;
  left: 0;
  z-index: 1050;
  display: none;
  width: 100%;
  height: 100%;
  overflow: hidden;
  outline: 0;
}

.modal-dialog {
  position: relative;
  width: auto;
  margin: 0.5rem;
  pointer-events: none;
}
.modal.fade .modal-dialog {
  transition: transform 0.3s ease-out;
  transform: translate(0, -50px);
}
@media (prefers-reduced-motion: reduce) {
  .modal.fade .modal-dialog {
    transition: none;
  }
}
.modal.show .modal-dialog {
  transform: none;
}
.modal.modal-static .modal-dialog {
  transform: scale(1.02);
}

.modal-dialog-scrollable {
  display: flex;
  max-height: calc(100% - 1rem);
}
.modal-dialog-scrollable .modal-content {
  max-height: calc(100vh - 1rem);
  overflow: hidden;
}
.modal-dialog-scrollable .modal-header,
.modal-dialog-scrollable .modal-footer {
  flex-shrink: 0;
}
.modal-dialog-scrollable .modal-body {
  overflow-y: auto;
}

.modal-dialog-centered {
  display: flex;
  align-items: center;
  min-height: calc(100% - 1rem);
}
.modal-dialog-centered::before {
  display: block;
  height: calc(100vh - 1rem);
  height: min-content;
  content: "";
}
.modal-dialog-centered.modal-dialog-scrollable {
  flex-direction: column;
  justify-content: center;
  height: 100%;
}
.modal-dialog-centered.modal-dialog-scrollable .modal-content {
  max-height: none;
}
.modal-dialog-centered.modal-dialog-scrollable::before {
  content: none;
}

.modal-content {
  position: relative;
  display: flex;
  flex-direction: column;
  width: 100%;
  pointer-events: auto;
  background-color: #fff;
  background-clip: padding-box;
  border: 0 solid rgba(0, 0, 0, 0.2);
  border-radius: 0.4375rem;
  box-shadow: 0 15px 35px rgba(50, 50, 93, 0.2), 0 5px 15px rgba(0, 0, 0, 0.17);
  outline: 0;
}

.modal-backdrop {
  position: fixed;
  top: 0;
  left: 0;
  z-index: 1040;
  width: 100vw;
  height: 100vh;
  background-color: #000;
}
.modal-backdrop.fade {
  opacity: 0;
}
.modal-backdrop.show {
  opacity: 0.16;
}

.modal-header {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  padding: 1.25rem;
  border-bottom: 0 solid #e9ecef;
  border-top-left-radius: 0.4375rem;
  border-top-right-radius: 0.4375rem;
}
.modal-header .close {
  padding: 1.25rem;
  margin: -1rem -1rem -1rem auto;
}

.modal-title {
  margin-bottom: 0;
  line-height: 1.1;
}

.modal-body {
  position: relative;
  flex: 1 1 auto;
  padding: 1.5rem;
}

.modal-footer {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  justify-content: flex-end;
  padding: 1.25rem;
  border-top: 0 solid #e9ecef;
  border-bottom-right-radius: 0.4375rem;
  border-bottom-left-radius: 0.4375rem;
}
.modal-footer > * {
  margin: 0.25rem;
}

.modal-scrollbar-measure {
  position: absolute;
  top: -9999px;
  width: 50px;
  height: 50px;
  overflow: scroll;
}

@media (min-width: 576px) {
  .modal-dialog {
    max-width: 500px;
    margin: 1.75rem auto;
  }
  .modal-dialog-scrollable {
    max-height: calc(100% - 3.5rem);
  }
  .modal-dialog-scrollable .modal-content {
    max-height: calc(100vh - 3.5rem);
  }
  .modal-dialog-centered {
    min-height: calc(100% - 3.5rem);
  }
  .modal-dialog-centered::before {
    height: calc(100vh - 3.5rem);
    height: min-content;
  }
  .modal-content {
    box-shadow: 0 15px 35px rgba(50, 50, 93, 0.2), 0 5px 15px rgba(0, 0, 0, 0.17);
  }
  .modal-sm {
    max-width: 380px;
  }
}
@media (min-width: 992px) {
  .modal-lg,
  .modal-xl {
    max-width: 800px;
  }
}
@media (min-width: 1200px) {
  .modal-xl {
    max-width: 1140px;
  }
}
.tooltip {
  position: absolute;
  z-index: 1070;
  display: block;
  margin: 0;
  font-family: Open Sans, sans-serif;
  font-style: normal;
  font-weight: 400;
  line-height: 1.5;
  text-align: left;
  text-align: start;
  text-decoration: none;
  text-shadow: none;
  text-transform: none;
  letter-spacing: normal;
  word-break: normal;
  word-spacing: normal;
  white-space: normal;
  line-break: auto;
  font-size: 0.875rem;
  word-wrap: break-word;
  opacity: 0;
}
.tooltip.show {
  opacity: 0.9;
}
.tooltip .arrow {
  position: absolute;
  display: block;
  width: 0.8rem;
  height: 0.4rem;
}
.tooltip .arrow::before {
  position: absolute;
  content: "";
  border-color: transparent;
  border-style: solid;
}

.bs-tooltip-top, .bs-tooltip-auto[x-placement^=top] {
  padding: 0.4rem 0;
}
.bs-tooltip-top .arrow, .bs-tooltip-auto[x-placement^=top] .arrow {
  bottom: 0;
}
.bs-tooltip-top .arrow::before, .bs-tooltip-auto[x-placement^=top] .arrow::before {
  top: 0;
  border-width: 0.4rem 0.4rem 0;
  border-top-color: #000;
}

.bs-tooltip-right, .bs-tooltip-auto[x-placement^=right] {
  padding: 0 0.4rem;
}
.bs-tooltip-right .arrow, .bs-tooltip-auto[x-placement^=right] .arrow {
  left: 0;
  width: 0.4rem;
  height: 0.8rem;
}
.bs-tooltip-right .arrow::before, .bs-tooltip-auto[x-placement^=right] .arrow::before {
  right: 0;
  border-width: 0.4rem 0.4rem 0.4rem 0;
  border-right-color: #000;
}

.bs-tooltip-bottom, .bs-tooltip-auto[x-placement^=bottom] {
  padding: 0.4rem 0;
}
.bs-tooltip-bottom .arrow, .bs-tooltip-auto[x-placement^=bottom] .arrow {
  top: 0;
}
.bs-tooltip-bottom .arrow::before, .bs-tooltip-auto[x-placement^=bottom] .arrow::before {
  bottom: 0;
  border-width: 0 0.4rem 0.4rem;
  border-bottom-color: #000;
}

.bs-tooltip-left, .bs-tooltip-auto[x-placement^=left] {
  padding: 0 0.4rem;
}
.bs-tooltip-left .arrow, .bs-tooltip-auto[x-placement^=left] .arrow {
  right: 0;
  width: 0.4rem;
  height: 0.8rem;
}
.bs-tooltip-left .arrow::before, .bs-tooltip-auto[x-placement^=left] .arrow::before {
  left: 0;
  border-width: 0.4rem 0 0.4rem 0.4rem;
  border-left-color: #000;
}

.tooltip-inner {
  max-width: 200px;
  padding: 0.25rem 0.5rem;
  color: #fff;
  text-align: center;
  background-color: #000;
  border-radius: 0.375rem;
}

.popover {
  position: absolute;
  top: 0;
  left: 0;
  z-index: 1060;
  display: block;
  max-width: 276px;
  font-family: Open Sans, sans-serif;
  font-style: normal;
  font-weight: 400;
  line-height: 1.5;
  text-align: left;
  text-align: start;
  text-decoration: none;
  text-shadow: none;
  text-transform: none;
  letter-spacing: normal;
  word-break: normal;
  word-spacing: normal;
  white-space: normal;
  line-break: auto;
  font-size: 0.875rem;
  word-wrap: break-word;
  background-color: #fff;
  background-clip: padding-box;
  border: 1px solid rgba(0, 0, 0, 0.05);
  border-radius: 0.4375rem;
  box-shadow: 0px 0.5rem 2rem 0px rgba(0, 0, 0, 0.2);
}
.popover .arrow {
  position: absolute;
  display: block;
  width: 1.5rem;
  height: 0.75rem;
  margin: 0 0.4375rem;
}
.popover .arrow::before, .popover .arrow::after {
  position: absolute;
  display: block;
  content: "";
  border-color: transparent;
  border-style: solid;
}

.bs-popover-top, .bs-popover-auto[x-placement^=top] {
  margin-bottom: 0.75rem;
}
.bs-popover-top > .arrow, .bs-popover-auto[x-placement^=top] > .arrow {
  bottom: calc(-0.75rem - 1px);
}
.bs-popover-top > .arrow::before, .bs-popover-auto[x-placement^=top] > .arrow::before {
  bottom: 0;
  border-width: 0.75rem 0.75rem 0;
  border-top-color: transparent;
}
.bs-popover-top > .arrow::after, .bs-popover-auto[x-placement^=top] > .arrow::after {
  bottom: 1px;
  border-width: 0.75rem 0.75rem 0;
  border-top-color: #fff;
}

.bs-popover-right, .bs-popover-auto[x-placement^=right] {
  margin-left: 0.75rem;
}
.bs-popover-right > .arrow, .bs-popover-auto[x-placement^=right] > .arrow {
  left: calc(-0.75rem - 1px);
  width: 0.75rem;
  height: 1.5rem;
  margin: 0.4375rem 0;
}
.bs-popover-right > .arrow::before, .bs-popover-auto[x-placement^=right] > .arrow::before {
  left: 0;
  border-width: 0.75rem 0.75rem 0.75rem 0;
  border-right-color: transparent;
}
.bs-popover-right > .arrow::after, .bs-popover-auto[x-placement^=right] > .arrow::after {
  left: 1px;
  border-width: 0.75rem 0.75rem 0.75rem 0;
  border-right-color: #fff;
}

.bs-popover-bottom, .bs-popover-auto[x-placement^=bottom] {
  margin-top: 0.75rem;
}
.bs-popover-bottom > .arrow, .bs-popover-auto[x-placement^=bottom] > .arrow {
  top: calc(-0.75rem - 1px);
}
.bs-popover-bottom > .arrow::before, .bs-popover-auto[x-placement^=bottom] > .arrow::before {
  top: 0;
  border-width: 0 0.75rem 0.75rem 0.75rem;
  border-bottom-color: transparent;
}
.bs-popover-bottom > .arrow::after, .bs-popover-auto[x-placement^=bottom] > .arrow::after {
  top: 1px;
  border-width: 0 0.75rem 0.75rem 0.75rem;
  border-bottom-color: #fff;
}
.bs-popover-bottom .popover-header::before, .bs-popover-auto[x-placement^=bottom] .popover-header::before {
  position: absolute;
  top: 0;
  left: 50%;
  display: block;
  width: 1.5rem;
  margin-left: -0.75rem;
  content: "";
  border-bottom: 1px solid #fff;
}

.bs-popover-left, .bs-popover-auto[x-placement^=left] {
  margin-right: 0.75rem;
}
.bs-popover-left > .arrow, .bs-popover-auto[x-placement^=left] > .arrow {
  right: calc(-0.75rem - 1px);
  width: 0.75rem;
  height: 1.5rem;
  margin: 0.4375rem 0;
}
.bs-popover-left > .arrow::before, .bs-popover-auto[x-placement^=left] > .arrow::before {
  right: 0;
  border-width: 0.75rem 0 0.75rem 0.75rem;
  border-left-color: transparent;
}
.bs-popover-left > .arrow::after, .bs-popover-auto[x-placement^=left] > .arrow::after {
  right: 1px;
  border-width: 0.75rem 0 0.75rem 0.75rem;
  border-left-color: #fff;
}

.popover-header {
  padding: 0.5rem 0.95rem;
  margin-bottom: 0;
  font-size: 1rem;
  color: #32325d;
  background-color: #fff;
  border-bottom: 1px solid rgb(242.25, 242.25, 242.25);
  border-top-left-radius: calc(0.4375rem - 1px);
  border-top-right-radius: calc(0.4375rem - 1px);
}
.popover-header:empty {
  display: none;
}

.popover-body {
  padding: 0.5rem 0.95rem;
  color: #525f7f;
}

.carousel {
  position: relative;
}

.carousel.pointer-event {
  touch-action: pan-y;
}

.carousel-inner {
  position: relative;
  width: 100%;
  overflow: hidden;
}
.carousel-inner::after {
  display: block;
  clear: both;
  content: "";
}

.carousel-item {
  position: relative;
  display: none;
  float: left;
  width: 100%;
  margin-right: -100%;
  backface-visibility: hidden;
  transition: transform 0.6s ease-in-out;
}
@media (prefers-reduced-motion: reduce) {
  .carousel-item {
    transition: none;
  }
}

.carousel-item.active,
.carousel-item-next,
.carousel-item-prev {
  display: block;
}

.carousel-item-next:not(.carousel-item-left),
.active.carousel-item-right {
  transform: translateX(100%);
}

.carousel-item-prev:not(.carousel-item-right),
.active.carousel-item-left {
  transform: translateX(-100%);
}

.carousel-fade .carousel-item {
  opacity: 0;
  transition-property: opacity;
  transform: none;
}
.carousel-fade .carousel-item.active,
.carousel-fade .carousel-item-next.carousel-item-left,
.carousel-fade .carousel-item-prev.carousel-item-right {
  z-index: 1;
  opacity: 1;
}
.carousel-fade .active.carousel-item-left,
.carousel-fade .active.carousel-item-right {
  z-index: 0;
  opacity: 0;
  transition: opacity 0s 0.6s;
}
@media (prefers-reduced-motion: reduce) {
  .carousel-fade .active.carousel-item-left,
  .carousel-fade .active.carousel-item-right {
    transition: none;
  }
}

.carousel-control-prev,
.carousel-control-next {
  position: absolute;
  top: 0;
  bottom: 0;
  z-index: 1;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 15%;
  color: #fff;
  text-align: center;
  opacity: 0.5;
  transition: opacity 0.15s ease;
}
@media (prefers-reduced-motion: reduce) {
  .carousel-control-prev,
  .carousel-control-next {
    transition: none;
  }
}
.carousel-control-prev:hover, .carousel-control-prev:focus,
.carousel-control-next:hover,
.carousel-control-next:focus {
  color: #fff;
  text-decoration: none;
  outline: 0;
  opacity: 0.9;
}

.carousel-control-prev {
  left: 0;
}

.carousel-control-next {
  right: 0;
}

.carousel-control-prev-icon,
.carousel-control-next-icon {
  display: inline-block;
  width: 20px;
  height: 20px;
  background: 50%/100% 100% no-repeat;
}

.carousel-control-prev-icon {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_6___});
}

.carousel-control-next-icon {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_7___});
}

.carousel-indicators {
  position: absolute;
  right: 0;
  bottom: 0;
  left: 0;
  z-index: 15;
  display: flex;
  justify-content: center;
  padding-left: 0;
  margin-right: 15%;
  margin-left: 15%;
  list-style: none;
}
.carousel-indicators li {
  box-sizing: content-box;
  flex: 0 1 auto;
  width: 30px;
  height: 3px;
  margin-right: 3px;
  margin-left: 3px;
  text-indent: -999px;
  cursor: pointer;
  background-color: #fff;
  background-clip: padding-box;
  border-top: 10px solid transparent;
  border-bottom: 10px solid transparent;
  opacity: 0.5;
  transition: opacity 0.6s ease;
}
@media (prefers-reduced-motion: reduce) {
  .carousel-indicators li {
    transition: none;
  }
}
.carousel-indicators .active {
  opacity: 1;
}

.carousel-caption {
  position: absolute;
  right: 15%;
  bottom: 20px;
  left: 15%;
  z-index: 10;
  padding-top: 20px;
  padding-bottom: 20px;
  color: #fff;
  text-align: center;
}

.align-baseline {
  vertical-align: baseline !important;
}

.align-top {
  vertical-align: top !important;
}

.align-middle {
  vertical-align: middle !important;
}

.align-bottom {
  vertical-align: bottom !important;
}

.align-text-bottom {
  vertical-align: text-bottom !important;
}

.align-text-top {
  vertical-align: text-top !important;
}

.bg-primary {
  background-color: #3ba371 !important;
}

a.bg-primary:hover, a.bg-primary:focus,
button.bg-primary:hover,
button.bg-primary:focus {
  background-color: rgb(45.4459459459, 125.5540540541, 87.0405405405) !important;
}

.bg-secondary {
  background-color: #f7fafc !important;
}

a.bg-secondary:hover, a.bg-secondary:focus,
button.bg-secondary:hover,
button.bg-secondary:focus {
  background-color: rgb(209.9090909091, 226.8181818182, 238.0909090909) !important;
}

.bg-success {
  background-color: #3aa170 !important;
}

a.bg-success:hover, a.bg-success:focus,
button.bg-success:hover,
button.bg-success:focus {
  background-color: rgb(44.4931506849, 123.5068493151, 85.9178082192) !important;
}

.bg-info {
  background-color: #278e69 !important;
}

a.bg-info:hover, a.bg-info:focus,
button.bg-info:hover,
button.bg-info:focus {
  background-color: rgb(28.0110497238, 101.9889502762, 75.4143646409) !important;
}

.bg-warning {
  background-color: #fb6340 !important;
}

a.bg-warning:hover, a.bg-warning:focus,
button.bg-warning:hover,
button.bg-warning:focus {
  background-color: rgb(249.9538461538, 58.2, 14.0461538462) !important;
}

.bg-danger {
  background-color: #f5365c !important;
}

a.bg-danger:hover, a.bg-danger:focus,
button.bg-danger:hover,
button.bg-danger:focus {
  background-color: rgb(236.2464454976, 11.7535545024, 56.4170616114) !important;
}

.bg-light {
  background-color: #adb5bd !important;
}

a.bg-light:hover, a.bg-light:focus,
button.bg-light:hover,
button.bg-light:focus {
  background-color: rgb(144.7432432432, 155.5, 166.2567567568) !important;
}

.bg-dark {
  background-color: #212529 !important;
}

a.bg-dark:hover, a.bg-dark:focus,
button.bg-dark:hover,
button.bg-dark:focus {
  background-color: rgb(10.2567567568, 11.5, 12.7432432432) !important;
}

.bg-default {
  background-color: #ffd88c !important;
}

a.bg-default:hover, a.bg-default:focus,
button.bg-default:hover,
button.bg-default:focus {
  background-color: rgb(255, 198.7043478261, 89) !important;
}

.bg-white {
  background-color: #fff !important;
}

a.bg-white:hover, a.bg-white:focus,
button.bg-white:hover,
button.bg-white:focus {
  background-color: rgb(229.5, 229.5, 229.5) !important;
}

.bg-neutral {
  background-color: #fff !important;
}

a.bg-neutral:hover, a.bg-neutral:focus,
button.bg-neutral:hover,
button.bg-neutral:focus {
  background-color: rgb(229.5, 229.5, 229.5) !important;
}

.bg-darker {
  background-color: black !important;
}

a.bg-darker:hover, a.bg-darker:focus,
button.bg-darker:hover,
button.bg-darker:focus {
  background-color: black !important;
}

.bg-white {
  background-color: #fff !important;
}

.bg-transparent {
  background-color: transparent !important;
}

.border {
  border: 1px solid #b1b1b1 !important;
}

.border-top {
  border-top: 1px solid #b1b1b1 !important;
}

.border-right {
  border-right: 1px solid #b1b1b1 !important;
}

.border-bottom {
  border-bottom: 1px solid #b1b1b1 !important;
}

.border-left {
  border-left: 1px solid #b1b1b1 !important;
}

.border-0 {
  border: 0 !important;
}

.border-top-0 {
  border-top: 0 !important;
}

.border-right-0 {
  border-right: 0 !important;
}

.border-bottom-0 {
  border-bottom: 0 !important;
}

.border-left-0 {
  border-left: 0 !important;
}

.border-primary {
  border-color: #3ba371 !important;
}

.border-secondary {
  border-color: #f7fafc !important;
}

.border-success {
  border-color: #3aa170 !important;
}

.border-info {
  border-color: #278e69 !important;
}

.border-warning {
  border-color: #fb6340 !important;
}

.border-danger {
  border-color: #f5365c !important;
}

.border-light {
  border-color: #adb5bd !important;
}

.border-dark {
  border-color: #212529 !important;
}

.border-default {
  border-color: #ffd88c !important;
}

.border-white {
  border-color: #fff !important;
}

.border-neutral {
  border-color: #fff !important;
}

.border-darker {
  border-color: black !important;
}

.border-white {
  border-color: #fff !important;
}

.rounded-sm {
  border-radius: 0.25rem !important;
}

.rounded {
  border-radius: 0.375rem !important;
}

.rounded-top {
  border-top-left-radius: 0.375rem !important;
  border-top-right-radius: 0.375rem !important;
}

.rounded-right {
  border-top-right-radius: 0.375rem !important;
  border-bottom-right-radius: 0.375rem !important;
}

.rounded-bottom {
  border-bottom-right-radius: 0.375rem !important;
  border-bottom-left-radius: 0.375rem !important;
}

.rounded-left {
  border-top-left-radius: 0.375rem !important;
  border-bottom-left-radius: 0.375rem !important;
}

.rounded-lg {
  border-radius: 0.4375rem !important;
}

.rounded-circle {
  border-radius: 50% !important;
}

.rounded-pill {
  border-radius: 50rem !important;
}

.rounded-0 {
  border-radius: 0 !important;
}

.clearfix::after {
  display: block;
  clear: both;
  content: "";
}

.d-none {
  display: none !important;
}

.d-inline {
  display: inline !important;
}

.d-inline-block {
  display: inline-block !important;
}

.d-block {
  display: block !important;
}

.d-table {
  display: table !important;
}

.d-table-row {
  display: table-row !important;
}

.d-table-cell {
  display: table-cell !important;
}

.d-flex {
  display: flex !important;
}

.d-inline-flex {
  display: inline-flex !important;
}

@media (min-width: 576px) {
  .d-sm-none {
    display: none !important;
  }
  .d-sm-inline {
    display: inline !important;
  }
  .d-sm-inline-block {
    display: inline-block !important;
  }
  .d-sm-block {
    display: block !important;
  }
  .d-sm-table {
    display: table !important;
  }
  .d-sm-table-row {
    display: table-row !important;
  }
  .d-sm-table-cell {
    display: table-cell !important;
  }
  .d-sm-flex {
    display: flex !important;
  }
  .d-sm-inline-flex {
    display: inline-flex !important;
  }
}
@media (min-width: 768px) {
  .d-md-none {
    display: none !important;
  }
  .d-md-inline {
    display: inline !important;
  }
  .d-md-inline-block {
    display: inline-block !important;
  }
  .d-md-block {
    display: block !important;
  }
  .d-md-table {
    display: table !important;
  }
  .d-md-table-row {
    display: table-row !important;
  }
  .d-md-table-cell {
    display: table-cell !important;
  }
  .d-md-flex {
    display: flex !important;
  }
  .d-md-inline-flex {
    display: inline-flex !important;
  }
}
@media (min-width: 992px) {
  .d-lg-none {
    display: none !important;
  }
  .d-lg-inline {
    display: inline !important;
  }
  .d-lg-inline-block {
    display: inline-block !important;
  }
  .d-lg-block {
    display: block !important;
  }
  .d-lg-table {
    display: table !important;
  }
  .d-lg-table-row {
    display: table-row !important;
  }
  .d-lg-table-cell {
    display: table-cell !important;
  }
  .d-lg-flex {
    display: flex !important;
  }
  .d-lg-inline-flex {
    display: inline-flex !important;
  }
}
@media (min-width: 1200px) {
  .d-xl-none {
    display: none !important;
  }
  .d-xl-inline {
    display: inline !important;
  }
  .d-xl-inline-block {
    display: inline-block !important;
  }
  .d-xl-block {
    display: block !important;
  }
  .d-xl-table {
    display: table !important;
  }
  .d-xl-table-row {
    display: table-row !important;
  }
  .d-xl-table-cell {
    display: table-cell !important;
  }
  .d-xl-flex {
    display: flex !important;
  }
  .d-xl-inline-flex {
    display: inline-flex !important;
  }
}
@media print {
  .d-print-none {
    display: none !important;
  }
  .d-print-inline {
    display: inline !important;
  }
  .d-print-inline-block {
    display: inline-block !important;
  }
  .d-print-block {
    display: block !important;
  }
  .d-print-table {
    display: table !important;
  }
  .d-print-table-row {
    display: table-row !important;
  }
  .d-print-table-cell {
    display: table-cell !important;
  }
  .d-print-flex {
    display: flex !important;
  }
  .d-print-inline-flex {
    display: inline-flex !important;
  }
}
.embed-responsive {
  position: relative;
  display: block;
  width: 100%;
  padding: 0;
  overflow: hidden;
}
.embed-responsive::before {
  display: block;
  content: "";
}
.embed-responsive .embed-responsive-item,
.embed-responsive iframe,
.embed-responsive embed,
.embed-responsive object,
.embed-responsive video {
  position: absolute;
  top: 0;
  bottom: 0;
  left: 0;
  width: 100%;
  height: 100%;
  border: 0;
}

.embed-responsive-21by9::before {
  padding-top: 42.8571428571%;
}

.embed-responsive-16by9::before {
  padding-top: 56.25%;
}

.embed-responsive-4by3::before {
  padding-top: 75%;
}

.embed-responsive-1by1::before {
  padding-top: 100%;
}

.flex-row {
  flex-direction: row !important;
}

.flex-column {
  flex-direction: column !important;
}

.flex-row-reverse {
  flex-direction: row-reverse !important;
}

.flex-column-reverse {
  flex-direction: column-reverse !important;
}

.flex-wrap {
  flex-wrap: wrap !important;
}

.flex-nowrap {
  flex-wrap: nowrap !important;
}

.flex-wrap-reverse {
  flex-wrap: wrap-reverse !important;
}

.flex-fill {
  flex: 1 1 auto !important;
}

.flex-grow-0 {
  flex-grow: 0 !important;
}

.flex-grow-1 {
  flex-grow: 1 !important;
}

.flex-shrink-0 {
  flex-shrink: 0 !important;
}

.flex-shrink-1 {
  flex-shrink: 1 !important;
}

.justify-content-start {
  justify-content: flex-start !important;
}

.justify-content-end {
  justify-content: flex-end !important;
}

.justify-content-center {
  justify-content: center !important;
}

.justify-content-between {
  justify-content: space-between !important;
}

.justify-content-around {
  justify-content: space-around !important;
}

.align-items-start {
  align-items: flex-start !important;
}

.align-items-end {
  align-items: flex-end !important;
}

.align-items-center {
  align-items: center !important;
}

.align-items-baseline {
  align-items: baseline !important;
}

.align-items-stretch {
  align-items: stretch !important;
}

.align-content-start {
  align-content: flex-start !important;
}

.align-content-end {
  align-content: flex-end !important;
}

.align-content-center {
  align-content: center !important;
}

.align-content-between {
  align-content: space-between !important;
}

.align-content-around {
  align-content: space-around !important;
}

.align-content-stretch {
  align-content: stretch !important;
}

.align-self-auto {
  align-self: auto !important;
}

.align-self-start {
  align-self: flex-start !important;
}

.align-self-end {
  align-self: flex-end !important;
}

.align-self-center {
  align-self: center !important;
}

.align-self-baseline {
  align-self: baseline !important;
}

.align-self-stretch {
  align-self: stretch !important;
}

@media (min-width: 576px) {
  .flex-sm-row {
    flex-direction: row !important;
  }
  .flex-sm-column {
    flex-direction: column !important;
  }
  .flex-sm-row-reverse {
    flex-direction: row-reverse !important;
  }
  .flex-sm-column-reverse {
    flex-direction: column-reverse !important;
  }
  .flex-sm-wrap {
    flex-wrap: wrap !important;
  }
  .flex-sm-nowrap {
    flex-wrap: nowrap !important;
  }
  .flex-sm-wrap-reverse {
    flex-wrap: wrap-reverse !important;
  }
  .flex-sm-fill {
    flex: 1 1 auto !important;
  }
  .flex-sm-grow-0 {
    flex-grow: 0 !important;
  }
  .flex-sm-grow-1 {
    flex-grow: 1 !important;
  }
  .flex-sm-shrink-0 {
    flex-shrink: 0 !important;
  }
  .flex-sm-shrink-1 {
    flex-shrink: 1 !important;
  }
  .justify-content-sm-start {
    justify-content: flex-start !important;
  }
  .justify-content-sm-end {
    justify-content: flex-end !important;
  }
  .justify-content-sm-center {
    justify-content: center !important;
  }
  .justify-content-sm-between {
    justify-content: space-between !important;
  }
  .justify-content-sm-around {
    justify-content: space-around !important;
  }
  .align-items-sm-start {
    align-items: flex-start !important;
  }
  .align-items-sm-end {
    align-items: flex-end !important;
  }
  .align-items-sm-center {
    align-items: center !important;
  }
  .align-items-sm-baseline {
    align-items: baseline !important;
  }
  .align-items-sm-stretch {
    align-items: stretch !important;
  }
  .align-content-sm-start {
    align-content: flex-start !important;
  }
  .align-content-sm-end {
    align-content: flex-end !important;
  }
  .align-content-sm-center {
    align-content: center !important;
  }
  .align-content-sm-between {
    align-content: space-between !important;
  }
  .align-content-sm-around {
    align-content: space-around !important;
  }
  .align-content-sm-stretch {
    align-content: stretch !important;
  }
  .align-self-sm-auto {
    align-self: auto !important;
  }
  .align-self-sm-start {
    align-self: flex-start !important;
  }
  .align-self-sm-end {
    align-self: flex-end !important;
  }
  .align-self-sm-center {
    align-self: center !important;
  }
  .align-self-sm-baseline {
    align-self: baseline !important;
  }
  .align-self-sm-stretch {
    align-self: stretch !important;
  }
}
@media (min-width: 768px) {
  .flex-md-row {
    flex-direction: row !important;
  }
  .flex-md-column {
    flex-direction: column !important;
  }
  .flex-md-row-reverse {
    flex-direction: row-reverse !important;
  }
  .flex-md-column-reverse {
    flex-direction: column-reverse !important;
  }
  .flex-md-wrap {
    flex-wrap: wrap !important;
  }
  .flex-md-nowrap {
    flex-wrap: nowrap !important;
  }
  .flex-md-wrap-reverse {
    flex-wrap: wrap-reverse !important;
  }
  .flex-md-fill {
    flex: 1 1 auto !important;
  }
  .flex-md-grow-0 {
    flex-grow: 0 !important;
  }
  .flex-md-grow-1 {
    flex-grow: 1 !important;
  }
  .flex-md-shrink-0 {
    flex-shrink: 0 !important;
  }
  .flex-md-shrink-1 {
    flex-shrink: 1 !important;
  }
  .justify-content-md-start {
    justify-content: flex-start !important;
  }
  .justify-content-md-end {
    justify-content: flex-end !important;
  }
  .justify-content-md-center {
    justify-content: center !important;
  }
  .justify-content-md-between {
    justify-content: space-between !important;
  }
  .justify-content-md-around {
    justify-content: space-around !important;
  }
  .align-items-md-start {
    align-items: flex-start !important;
  }
  .align-items-md-end {
    align-items: flex-end !important;
  }
  .align-items-md-center {
    align-items: center !important;
  }
  .align-items-md-baseline {
    align-items: baseline !important;
  }
  .align-items-md-stretch {
    align-items: stretch !important;
  }
  .align-content-md-start {
    align-content: flex-start !important;
  }
  .align-content-md-end {
    align-content: flex-end !important;
  }
  .align-content-md-center {
    align-content: center !important;
  }
  .align-content-md-between {
    align-content: space-between !important;
  }
  .align-content-md-around {
    align-content: space-around !important;
  }
  .align-content-md-stretch {
    align-content: stretch !important;
  }
  .align-self-md-auto {
    align-self: auto !important;
  }
  .align-self-md-start {
    align-self: flex-start !important;
  }
  .align-self-md-end {
    align-self: flex-end !important;
  }
  .align-self-md-center {
    align-self: center !important;
  }
  .align-self-md-baseline {
    align-self: baseline !important;
  }
  .align-self-md-stretch {
    align-self: stretch !important;
  }
}
@media (min-width: 992px) {
  .flex-lg-row {
    flex-direction: row !important;
  }
  .flex-lg-column {
    flex-direction: column !important;
  }
  .flex-lg-row-reverse {
    flex-direction: row-reverse !important;
  }
  .flex-lg-column-reverse {
    flex-direction: column-reverse !important;
  }
  .flex-lg-wrap {
    flex-wrap: wrap !important;
  }
  .flex-lg-nowrap {
    flex-wrap: nowrap !important;
  }
  .flex-lg-wrap-reverse {
    flex-wrap: wrap-reverse !important;
  }
  .flex-lg-fill {
    flex: 1 1 auto !important;
  }
  .flex-lg-grow-0 {
    flex-grow: 0 !important;
  }
  .flex-lg-grow-1 {
    flex-grow: 1 !important;
  }
  .flex-lg-shrink-0 {
    flex-shrink: 0 !important;
  }
  .flex-lg-shrink-1 {
    flex-shrink: 1 !important;
  }
  .justify-content-lg-start {
    justify-content: flex-start !important;
  }
  .justify-content-lg-end {
    justify-content: flex-end !important;
  }
  .justify-content-lg-center {
    justify-content: center !important;
  }
  .justify-content-lg-between {
    justify-content: space-between !important;
  }
  .justify-content-lg-around {
    justify-content: space-around !important;
  }
  .align-items-lg-start {
    align-items: flex-start !important;
  }
  .align-items-lg-end {
    align-items: flex-end !important;
  }
  .align-items-lg-center {
    align-items: center !important;
  }
  .align-items-lg-baseline {
    align-items: baseline !important;
  }
  .align-items-lg-stretch {
    align-items: stretch !important;
  }
  .align-content-lg-start {
    align-content: flex-start !important;
  }
  .align-content-lg-end {
    align-content: flex-end !important;
  }
  .align-content-lg-center {
    align-content: center !important;
  }
  .align-content-lg-between {
    align-content: space-between !important;
  }
  .align-content-lg-around {
    align-content: space-around !important;
  }
  .align-content-lg-stretch {
    align-content: stretch !important;
  }
  .align-self-lg-auto {
    align-self: auto !important;
  }
  .align-self-lg-start {
    align-self: flex-start !important;
  }
  .align-self-lg-end {
    align-self: flex-end !important;
  }
  .align-self-lg-center {
    align-self: center !important;
  }
  .align-self-lg-baseline {
    align-self: baseline !important;
  }
  .align-self-lg-stretch {
    align-self: stretch !important;
  }
}
@media (min-width: 1200px) {
  .flex-xl-row {
    flex-direction: row !important;
  }
  .flex-xl-column {
    flex-direction: column !important;
  }
  .flex-xl-row-reverse {
    flex-direction: row-reverse !important;
  }
  .flex-xl-column-reverse {
    flex-direction: column-reverse !important;
  }
  .flex-xl-wrap {
    flex-wrap: wrap !important;
  }
  .flex-xl-nowrap {
    flex-wrap: nowrap !important;
  }
  .flex-xl-wrap-reverse {
    flex-wrap: wrap-reverse !important;
  }
  .flex-xl-fill {
    flex: 1 1 auto !important;
  }
  .flex-xl-grow-0 {
    flex-grow: 0 !important;
  }
  .flex-xl-grow-1 {
    flex-grow: 1 !important;
  }
  .flex-xl-shrink-0 {
    flex-shrink: 0 !important;
  }
  .flex-xl-shrink-1 {
    flex-shrink: 1 !important;
  }
  .justify-content-xl-start {
    justify-content: flex-start !important;
  }
  .justify-content-xl-end {
    justify-content: flex-end !important;
  }
  .justify-content-xl-center {
    justify-content: center !important;
  }
  .justify-content-xl-between {
    justify-content: space-between !important;
  }
  .justify-content-xl-around {
    justify-content: space-around !important;
  }
  .align-items-xl-start {
    align-items: flex-start !important;
  }
  .align-items-xl-end {
    align-items: flex-end !important;
  }
  .align-items-xl-center {
    align-items: center !important;
  }
  .align-items-xl-baseline {
    align-items: baseline !important;
  }
  .align-items-xl-stretch {
    align-items: stretch !important;
  }
  .align-content-xl-start {
    align-content: flex-start !important;
  }
  .align-content-xl-end {
    align-content: flex-end !important;
  }
  .align-content-xl-center {
    align-content: center !important;
  }
  .align-content-xl-between {
    align-content: space-between !important;
  }
  .align-content-xl-around {
    align-content: space-around !important;
  }
  .align-content-xl-stretch {
    align-content: stretch !important;
  }
  .align-self-xl-auto {
    align-self: auto !important;
  }
  .align-self-xl-start {
    align-self: flex-start !important;
  }
  .align-self-xl-end {
    align-self: flex-end !important;
  }
  .align-self-xl-center {
    align-self: center !important;
  }
  .align-self-xl-baseline {
    align-self: baseline !important;
  }
  .align-self-xl-stretch {
    align-self: stretch !important;
  }
}
.float-left {
  float: left !important;
}

.float-right {
  float: right !important;
}

.float-none {
  float: none !important;
}

@media (min-width: 576px) {
  .float-sm-left {
    float: left !important;
  }
  .float-sm-right {
    float: right !important;
  }
  .float-sm-none {
    float: none !important;
  }
}
@media (min-width: 768px) {
  .float-md-left {
    float: left !important;
  }
  .float-md-right {
    float: right !important;
  }
  .float-md-none {
    float: none !important;
  }
}
@media (min-width: 992px) {
  .float-lg-left {
    float: left !important;
  }
  .float-lg-right {
    float: right !important;
  }
  .float-lg-none {
    float: none !important;
  }
}
@media (min-width: 1200px) {
  .float-xl-left {
    float: left !important;
  }
  .float-xl-right {
    float: right !important;
  }
  .float-xl-none {
    float: none !important;
  }
}
.user-select-all {
  -webkit-user-select: all !important;
          user-select: all !important;
}

.user-select-auto {
  -webkit-user-select: auto !important;
          user-select: auto !important;
}

.user-select-none {
  -webkit-user-select: none !important;
          user-select: none !important;
}

.overflow-auto {
  overflow: auto !important;
}

.overflow-hidden {
  overflow: hidden !important;
}

.position-static {
  position: static !important;
}

.position-relative {
  position: relative !important;
}

.position-absolute {
  position: absolute !important;
}

.position-fixed {
  position: fixed !important;
}

.position-sticky {
  position: sticky !important;
}

.fixed-top {
  position: fixed;
  top: 0;
  right: 0;
  left: 0;
  z-index: 1030;
}

.fixed-bottom {
  position: fixed;
  right: 0;
  bottom: 0;
  left: 0;
  z-index: 1030;
}

@supports (position: sticky) {
  .sticky-top {
    position: sticky;
    top: 0;
    z-index: 1020;
  }
}

.sr-only {
  position: absolute;
  width: 1px;
  height: 1px;
  padding: 0;
  margin: -1px;
  overflow: hidden;
  clip: rect(0, 0, 0, 0);
  white-space: nowrap;
  border: 0;
}

.sr-only-focusable:active, .sr-only-focusable:focus {
  position: static;
  width: auto;
  height: auto;
  overflow: visible;
  clip: auto;
  white-space: normal;
}

.shadow-sm {
  box-shadow: 0 0 0.5rem rgba(136, 152, 170, 0.075) !important;
}

.shadow, .card-profile-image img {
  box-shadow: 0 0 2rem 0 rgba(136, 152, 170, 0.15) !important;
}

.shadow-lg {
  box-shadow: 0 0 3rem rgba(136, 152, 170, 0.175) !important;
}

.shadow-none {
  box-shadow: none !important;
}

.w-25 {
  width: 25% !important;
}

.w-50 {
  width: 50% !important;
}

.w-75 {
  width: 75% !important;
}

.w-100 {
  width: 100% !important;
}

.w-auto {
  width: auto !important;
}

.h-25 {
  height: 25% !important;
}

.h-50 {
  height: 50% !important;
}

.h-75 {
  height: 75% !important;
}

.h-100 {
  height: 100% !important;
}

.h-auto {
  height: auto !important;
}

.mw-100 {
  max-width: 100% !important;
}

.mh-100 {
  max-height: 100% !important;
}

.min-vw-100 {
  min-width: 100vw !important;
}

.min-vh-100 {
  min-height: 100vh !important;
}

.vw-100 {
  width: 100vw !important;
}

.vh-100 {
  height: 100vh !important;
}

.m-0 {
  margin: 0 !important;
}

.mt-0,
.my-0 {
  margin-top: 0 !important;
}

.mr-0,
.mx-0 {
  margin-right: 0 !important;
}

.mb-0,
.my-0 {
  margin-bottom: 0 !important;
}

.ml-0,
.mx-0 {
  margin-left: 0 !important;
}

.m-1 {
  margin: 0.25rem !important;
}

.mt-1,
.my-1 {
  margin-top: 0.25rem !important;
}

.mr-1,
.mx-1 {
  margin-right: 0.25rem !important;
}

.mb-1,
.my-1 {
  margin-bottom: 0.25rem !important;
}

.ml-1,
.mx-1 {
  margin-left: 0.25rem !important;
}

.m-2 {
  margin: 0.5rem !important;
}

.mt-2,
.my-2 {
  margin-top: 0.5rem !important;
}

.mr-2,
.mx-2 {
  margin-right: 0.5rem !important;
}

.mb-2,
.my-2 {
  margin-bottom: 0.5rem !important;
}

.ml-2,
.mx-2 {
  margin-left: 0.5rem !important;
}

.m-3 {
  margin: 1rem !important;
}

.mt-3,
.my-3 {
  margin-top: 1rem !important;
}

.mr-3,
.mx-3 {
  margin-right: 1rem !important;
}

.mb-3,
.my-3 {
  margin-bottom: 1rem !important;
}

.ml-3,
.mx-3 {
  margin-left: 1rem !important;
}

.m-4 {
  margin: 1.5rem !important;
}

.mt-4,
.my-4 {
  margin-top: 1.5rem !important;
}

.mr-4,
.mx-4 {
  margin-right: 1.5rem !important;
}

.mb-4,
.my-4 {
  margin-bottom: 1.5rem !important;
}

.ml-4,
.mx-4 {
  margin-left: 1.5rem !important;
}

.m-5 {
  margin: 3rem !important;
}

.mt-5,
.my-5 {
  margin-top: 3rem !important;
}

.mr-5,
.mx-5 {
  margin-right: 3rem !important;
}

.mb-5,
.my-5 {
  margin-bottom: 3rem !important;
}

.ml-5,
.mx-5 {
  margin-left: 3rem !important;
}

.m--9 {
  margin: -10rem !important;
}

.mt--9,
.my--9 {
  margin-top: -10rem !important;
}

.mr--9,
.mx--9 {
  margin-right: -10rem !important;
}

.mb--9,
.my--9 {
  margin-bottom: -10rem !important;
}

.ml--9,
.mx--9 {
  margin-left: -10rem !important;
}

.m--8 {
  margin: -8rem !important;
}

.mt--8,
.my--8 {
  margin-top: -8rem !important;
}

.mr--8,
.mx--8 {
  margin-right: -8rem !important;
}

.mb--8,
.my--8 {
  margin-bottom: -8rem !important;
}

.ml--8,
.mx--8 {
  margin-left: -8rem !important;
}

.m--7 {
  margin: -6rem !important;
}

.mt--7,
.my--7 {
  margin-top: -6rem !important;
}

.mr--7,
.mx--7 {
  margin-right: -6rem !important;
}

.mb--7,
.my--7 {
  margin-bottom: -6rem !important;
}

.ml--7,
.mx--7 {
  margin-left: -6rem !important;
}

.m--6 {
  margin: -4.5rem !important;
}

.mt--6,
.my--6 {
  margin-top: -4.5rem !important;
}

.mr--6,
.mx--6 {
  margin-right: -4.5rem !important;
}

.mb--6,
.my--6 {
  margin-bottom: -4.5rem !important;
}

.ml--6,
.mx--6 {
  margin-left: -4.5rem !important;
}

.m--5 {
  margin: -3rem !important;
}

.mt--5,
.my--5 {
  margin-top: -3rem !important;
}

.mr--5,
.mx--5 {
  margin-right: -3rem !important;
}

.mb--5,
.my--5 {
  margin-bottom: -3rem !important;
}

.ml--5,
.mx--5 {
  margin-left: -3rem !important;
}

.m--4 {
  margin: -1.5rem !important;
}

.mt--4,
.my--4 {
  margin-top: -1.5rem !important;
}

.mr--4,
.mx--4 {
  margin-right: -1.5rem !important;
}

.mb--4,
.my--4 {
  margin-bottom: -1.5rem !important;
}

.ml--4,
.mx--4 {
  margin-left: -1.5rem !important;
}

.m--3 {
  margin: -1rem !important;
}

.mt--3,
.my--3 {
  margin-top: -1rem !important;
}

.mr--3,
.mx--3 {
  margin-right: -1rem !important;
}

.mb--3,
.my--3 {
  margin-bottom: -1rem !important;
}

.ml--3,
.mx--3 {
  margin-left: -1rem !important;
}

.m--2 {
  margin: -0.5rem !important;
}

.mt--2,
.my--2 {
  margin-top: -0.5rem !important;
}

.mr--2,
.mx--2 {
  margin-right: -0.5rem !important;
}

.mb--2,
.my--2 {
  margin-bottom: -0.5rem !important;
}

.ml--2,
.mx--2 {
  margin-left: -0.5rem !important;
}

.m--1 {
  margin: -0.25rem !important;
}

.mt--1,
.my--1 {
  margin-top: -0.25rem !important;
}

.mr--1,
.mx--1 {
  margin-right: -0.25rem !important;
}

.mb--1,
.my--1 {
  margin-bottom: -0.25rem !important;
}

.ml--1,
.mx--1 {
  margin-left: -0.25rem !important;
}

.m-6 {
  margin: 4.5rem !important;
}

.mt-6,
.my-6 {
  margin-top: 4.5rem !important;
}

.mr-6,
.mx-6 {
  margin-right: 4.5rem !important;
}

.mb-6,
.my-6 {
  margin-bottom: 4.5rem !important;
}

.ml-6,
.mx-6 {
  margin-left: 4.5rem !important;
}

.m-7 {
  margin: 6rem !important;
}

.mt-7,
.my-7 {
  margin-top: 6rem !important;
}

.mr-7,
.mx-7 {
  margin-right: 6rem !important;
}

.mb-7,
.my-7 {
  margin-bottom: 6rem !important;
}

.ml-7,
.mx-7 {
  margin-left: 6rem !important;
}

.m-8 {
  margin: 8rem !important;
}

.mt-8,
.my-8 {
  margin-top: 8rem !important;
}

.mr-8,
.mx-8 {
  margin-right: 8rem !important;
}

.mb-8,
.my-8 {
  margin-bottom: 8rem !important;
}

.ml-8,
.mx-8 {
  margin-left: 8rem !important;
}

.m-9 {
  margin: 10rem !important;
}

.mt-9,
.my-9 {
  margin-top: 10rem !important;
}

.mr-9,
.mx-9 {
  margin-right: 10rem !important;
}

.mb-9,
.my-9 {
  margin-bottom: 10rem !important;
}

.ml-9,
.mx-9 {
  margin-left: 10rem !important;
}

.p-0 {
  padding: 0 !important;
}

.pt-0,
.py-0 {
  padding-top: 0 !important;
}

.pr-0,
.px-0 {
  padding-right: 0 !important;
}

.pb-0,
.py-0 {
  padding-bottom: 0 !important;
}

.pl-0,
.px-0 {
  padding-left: 0 !important;
}

.p-1 {
  padding: 0.25rem !important;
}

.pt-1,
.py-1 {
  padding-top: 0.25rem !important;
}

.pr-1,
.px-1 {
  padding-right: 0.25rem !important;
}

.pb-1,
.py-1 {
  padding-bottom: 0.25rem !important;
}

.pl-1,
.px-1 {
  padding-left: 0.25rem !important;
}

.p-2 {
  padding: 0.5rem !important;
}

.pt-2,
.py-2 {
  padding-top: 0.5rem !important;
}

.pr-2,
.px-2 {
  padding-right: 0.5rem !important;
}

.pb-2,
.py-2 {
  padding-bottom: 0.5rem !important;
}

.pl-2,
.px-2 {
  padding-left: 0.5rem !important;
}

.p-3 {
  padding: 1rem !important;
}

.pt-3,
.py-3 {
  padding-top: 1rem !important;
}

.pr-3,
.px-3 {
  padding-right: 1rem !important;
}

.pb-3,
.py-3 {
  padding-bottom: 1rem !important;
}

.pl-3,
.px-3 {
  padding-left: 1rem !important;
}

.p-4 {
  padding: 1.5rem !important;
}

.pt-4,
.py-4 {
  padding-top: 1.5rem !important;
}

.pr-4,
.px-4 {
  padding-right: 1.5rem !important;
}

.pb-4,
.py-4 {
  padding-bottom: 1.5rem !important;
}

.pl-4,
.px-4 {
  padding-left: 1.5rem !important;
}

.p-5 {
  padding: 3rem !important;
}

.pt-5,
.py-5 {
  padding-top: 3rem !important;
}

.pr-5,
.px-5 {
  padding-right: 3rem !important;
}

.pb-5,
.py-5 {
  padding-bottom: 3rem !important;
}

.pl-5,
.px-5 {
  padding-left: 3rem !important;
}

.p--9 {
  padding: -10rem !important;
}

.pt--9,
.py--9 {
  padding-top: -10rem !important;
}

.pr--9,
.px--9 {
  padding-right: -10rem !important;
}

.pb--9,
.py--9 {
  padding-bottom: -10rem !important;
}

.pl--9,
.px--9 {
  padding-left: -10rem !important;
}

.p--8 {
  padding: -8rem !important;
}

.pt--8,
.py--8 {
  padding-top: -8rem !important;
}

.pr--8,
.px--8 {
  padding-right: -8rem !important;
}

.pb--8,
.py--8 {
  padding-bottom: -8rem !important;
}

.pl--8,
.px--8 {
  padding-left: -8rem !important;
}

.p--7 {
  padding: -6rem !important;
}

.pt--7,
.py--7 {
  padding-top: -6rem !important;
}

.pr--7,
.px--7 {
  padding-right: -6rem !important;
}

.pb--7,
.py--7 {
  padding-bottom: -6rem !important;
}

.pl--7,
.px--7 {
  padding-left: -6rem !important;
}

.p--6 {
  padding: -4.5rem !important;
}

.pt--6,
.py--6 {
  padding-top: -4.5rem !important;
}

.pr--6,
.px--6 {
  padding-right: -4.5rem !important;
}

.pb--6,
.py--6 {
  padding-bottom: -4.5rem !important;
}

.pl--6,
.px--6 {
  padding-left: -4.5rem !important;
}

.p--5 {
  padding: -3rem !important;
}

.pt--5,
.py--5 {
  padding-top: -3rem !important;
}

.pr--5,
.px--5 {
  padding-right: -3rem !important;
}

.pb--5,
.py--5 {
  padding-bottom: -3rem !important;
}

.pl--5,
.px--5 {
  padding-left: -3rem !important;
}

.p--4 {
  padding: -1.5rem !important;
}

.pt--4,
.py--4 {
  padding-top: -1.5rem !important;
}

.pr--4,
.px--4 {
  padding-right: -1.5rem !important;
}

.pb--4,
.py--4 {
  padding-bottom: -1.5rem !important;
}

.pl--4,
.px--4 {
  padding-left: -1.5rem !important;
}

.p--3 {
  padding: -1rem !important;
}

.pt--3,
.py--3 {
  padding-top: -1rem !important;
}

.pr--3,
.px--3 {
  padding-right: -1rem !important;
}

.pb--3,
.py--3 {
  padding-bottom: -1rem !important;
}

.pl--3,
.px--3 {
  padding-left: -1rem !important;
}

.p--2 {
  padding: -0.5rem !important;
}

.pt--2,
.py--2 {
  padding-top: -0.5rem !important;
}

.pr--2,
.px--2 {
  padding-right: -0.5rem !important;
}

.pb--2,
.py--2 {
  padding-bottom: -0.5rem !important;
}

.pl--2,
.px--2 {
  padding-left: -0.5rem !important;
}

.p--1 {
  padding: -0.25rem !important;
}

.pt--1,
.py--1 {
  padding-top: -0.25rem !important;
}

.pr--1,
.px--1 {
  padding-right: -0.25rem !important;
}

.pb--1,
.py--1 {
  padding-bottom: -0.25rem !important;
}

.pl--1,
.px--1 {
  padding-left: -0.25rem !important;
}

.p-6 {
  padding: 4.5rem !important;
}

.pt-6,
.py-6 {
  padding-top: 4.5rem !important;
}

.pr-6,
.px-6 {
  padding-right: 4.5rem !important;
}

.pb-6,
.py-6 {
  padding-bottom: 4.5rem !important;
}

.pl-6,
.px-6 {
  padding-left: 4.5rem !important;
}

.p-7 {
  padding: 6rem !important;
}

.pt-7,
.py-7 {
  padding-top: 6rem !important;
}

.pr-7,
.px-7 {
  padding-right: 6rem !important;
}

.pb-7,
.py-7 {
  padding-bottom: 6rem !important;
}

.pl-7,
.px-7 {
  padding-left: 6rem !important;
}

.p-8 {
  padding: 8rem !important;
}

.pt-8,
.py-8 {
  padding-top: 8rem !important;
}

.pr-8,
.px-8 {
  padding-right: 8rem !important;
}

.pb-8,
.py-8 {
  padding-bottom: 8rem !important;
}

.pl-8,
.px-8 {
  padding-left: 8rem !important;
}

.p-9 {
  padding: 10rem !important;
}

.pt-9,
.py-9 {
  padding-top: 10rem !important;
}

.pr-9,
.px-9 {
  padding-right: 10rem !important;
}

.pb-9,
.py-9 {
  padding-bottom: 10rem !important;
}

.pl-9,
.px-9 {
  padding-left: 10rem !important;
}

.m-n1 {
  margin: -0.25rem !important;
}

.mt-n1,
.my-n1 {
  margin-top: -0.25rem !important;
}

.mr-n1,
.mx-n1 {
  margin-right: -0.25rem !important;
}

.mb-n1,
.my-n1 {
  margin-bottom: -0.25rem !important;
}

.ml-n1,
.mx-n1 {
  margin-left: -0.25rem !important;
}

.m-n2 {
  margin: -0.5rem !important;
}

.mt-n2,
.my-n2 {
  margin-top: -0.5rem !important;
}

.mr-n2,
.mx-n2 {
  margin-right: -0.5rem !important;
}

.mb-n2,
.my-n2 {
  margin-bottom: -0.5rem !important;
}

.ml-n2,
.mx-n2 {
  margin-left: -0.5rem !important;
}

.m-n3 {
  margin: -1rem !important;
}

.mt-n3,
.my-n3 {
  margin-top: -1rem !important;
}

.mr-n3,
.mx-n3 {
  margin-right: -1rem !important;
}

.mb-n3,
.my-n3 {
  margin-bottom: -1rem !important;
}

.ml-n3,
.mx-n3 {
  margin-left: -1rem !important;
}

.m-n4 {
  margin: -1.5rem !important;
}

.mt-n4,
.my-n4 {
  margin-top: -1.5rem !important;
}

.mr-n4,
.mx-n4 {
  margin-right: -1.5rem !important;
}

.mb-n4,
.my-n4 {
  margin-bottom: -1.5rem !important;
}

.ml-n4,
.mx-n4 {
  margin-left: -1.5rem !important;
}

.m-n5 {
  margin: -3rem !important;
}

.mt-n5,
.my-n5 {
  margin-top: -3rem !important;
}

.mr-n5,
.mx-n5 {
  margin-right: -3rem !important;
}

.mb-n5,
.my-n5 {
  margin-bottom: -3rem !important;
}

.ml-n5,
.mx-n5 {
  margin-left: -3rem !important;
}

.m-n-9 {
  margin: 10rem !important;
}

.mt-n-9,
.my-n-9 {
  margin-top: 10rem !important;
}

.mr-n-9,
.mx-n-9 {
  margin-right: 10rem !important;
}

.mb-n-9,
.my-n-9 {
  margin-bottom: 10rem !important;
}

.ml-n-9,
.mx-n-9 {
  margin-left: 10rem !important;
}

.m-n-8 {
  margin: 8rem !important;
}

.mt-n-8,
.my-n-8 {
  margin-top: 8rem !important;
}

.mr-n-8,
.mx-n-8 {
  margin-right: 8rem !important;
}

.mb-n-8,
.my-n-8 {
  margin-bottom: 8rem !important;
}

.ml-n-8,
.mx-n-8 {
  margin-left: 8rem !important;
}

.m-n-7 {
  margin: 6rem !important;
}

.mt-n-7,
.my-n-7 {
  margin-top: 6rem !important;
}

.mr-n-7,
.mx-n-7 {
  margin-right: 6rem !important;
}

.mb-n-7,
.my-n-7 {
  margin-bottom: 6rem !important;
}

.ml-n-7,
.mx-n-7 {
  margin-left: 6rem !important;
}

.m-n-6 {
  margin: 4.5rem !important;
}

.mt-n-6,
.my-n-6 {
  margin-top: 4.5rem !important;
}

.mr-n-6,
.mx-n-6 {
  margin-right: 4.5rem !important;
}

.mb-n-6,
.my-n-6 {
  margin-bottom: 4.5rem !important;
}

.ml-n-6,
.mx-n-6 {
  margin-left: 4.5rem !important;
}

.m-n-5 {
  margin: 3rem !important;
}

.mt-n-5,
.my-n-5 {
  margin-top: 3rem !important;
}

.mr-n-5,
.mx-n-5 {
  margin-right: 3rem !important;
}

.mb-n-5,
.my-n-5 {
  margin-bottom: 3rem !important;
}

.ml-n-5,
.mx-n-5 {
  margin-left: 3rem !important;
}

.m-n-4 {
  margin: 1.5rem !important;
}

.mt-n-4,
.my-n-4 {
  margin-top: 1.5rem !important;
}

.mr-n-4,
.mx-n-4 {
  margin-right: 1.5rem !important;
}

.mb-n-4,
.my-n-4 {
  margin-bottom: 1.5rem !important;
}

.ml-n-4,
.mx-n-4 {
  margin-left: 1.5rem !important;
}

.m-n-3 {
  margin: 1rem !important;
}

.mt-n-3,
.my-n-3 {
  margin-top: 1rem !important;
}

.mr-n-3,
.mx-n-3 {
  margin-right: 1rem !important;
}

.mb-n-3,
.my-n-3 {
  margin-bottom: 1rem !important;
}

.ml-n-3,
.mx-n-3 {
  margin-left: 1rem !important;
}

.m-n-2 {
  margin: 0.5rem !important;
}

.mt-n-2,
.my-n-2 {
  margin-top: 0.5rem !important;
}

.mr-n-2,
.mx-n-2 {
  margin-right: 0.5rem !important;
}

.mb-n-2,
.my-n-2 {
  margin-bottom: 0.5rem !important;
}

.ml-n-2,
.mx-n-2 {
  margin-left: 0.5rem !important;
}

.m-n-1 {
  margin: 0.25rem !important;
}

.mt-n-1,
.my-n-1 {
  margin-top: 0.25rem !important;
}

.mr-n-1,
.mx-n-1 {
  margin-right: 0.25rem !important;
}

.mb-n-1,
.my-n-1 {
  margin-bottom: 0.25rem !important;
}

.ml-n-1,
.mx-n-1 {
  margin-left: 0.25rem !important;
}

.m-n6 {
  margin: -4.5rem !important;
}

.mt-n6,
.my-n6 {
  margin-top: -4.5rem !important;
}

.mr-n6,
.mx-n6 {
  margin-right: -4.5rem !important;
}

.mb-n6,
.my-n6 {
  margin-bottom: -4.5rem !important;
}

.ml-n6,
.mx-n6 {
  margin-left: -4.5rem !important;
}

.m-n7 {
  margin: -6rem !important;
}

.mt-n7,
.my-n7 {
  margin-top: -6rem !important;
}

.mr-n7,
.mx-n7 {
  margin-right: -6rem !important;
}

.mb-n7,
.my-n7 {
  margin-bottom: -6rem !important;
}

.ml-n7,
.mx-n7 {
  margin-left: -6rem !important;
}

.m-n8 {
  margin: -8rem !important;
}

.mt-n8,
.my-n8 {
  margin-top: -8rem !important;
}

.mr-n8,
.mx-n8 {
  margin-right: -8rem !important;
}

.mb-n8,
.my-n8 {
  margin-bottom: -8rem !important;
}

.ml-n8,
.mx-n8 {
  margin-left: -8rem !important;
}

.m-n9 {
  margin: -10rem !important;
}

.mt-n9,
.my-n9 {
  margin-top: -10rem !important;
}

.mr-n9,
.mx-n9 {
  margin-right: -10rem !important;
}

.mb-n9,
.my-n9 {
  margin-bottom: -10rem !important;
}

.ml-n9,
.mx-n9 {
  margin-left: -10rem !important;
}

.m-auto {
  margin: auto !important;
}

.mt-auto,
.my-auto {
  margin-top: auto !important;
}

.mr-auto,
.mx-auto {
  margin-right: auto !important;
}

.mb-auto,
.my-auto {
  margin-bottom: auto !important;
}

.ml-auto,
.mx-auto {
  margin-left: auto !important;
}

@media (min-width: 576px) {
  .m-sm-0 {
    margin: 0 !important;
  }
  .mt-sm-0,
  .my-sm-0 {
    margin-top: 0 !important;
  }
  .mr-sm-0,
  .mx-sm-0 {
    margin-right: 0 !important;
  }
  .mb-sm-0,
  .my-sm-0 {
    margin-bottom: 0 !important;
  }
  .ml-sm-0,
  .mx-sm-0 {
    margin-left: 0 !important;
  }
  .m-sm-1 {
    margin: 0.25rem !important;
  }
  .mt-sm-1,
  .my-sm-1 {
    margin-top: 0.25rem !important;
  }
  .mr-sm-1,
  .mx-sm-1 {
    margin-right: 0.25rem !important;
  }
  .mb-sm-1,
  .my-sm-1 {
    margin-bottom: 0.25rem !important;
  }
  .ml-sm-1,
  .mx-sm-1 {
    margin-left: 0.25rem !important;
  }
  .m-sm-2 {
    margin: 0.5rem !important;
  }
  .mt-sm-2,
  .my-sm-2 {
    margin-top: 0.5rem !important;
  }
  .mr-sm-2,
  .mx-sm-2 {
    margin-right: 0.5rem !important;
  }
  .mb-sm-2,
  .my-sm-2 {
    margin-bottom: 0.5rem !important;
  }
  .ml-sm-2,
  .mx-sm-2 {
    margin-left: 0.5rem !important;
  }
  .m-sm-3 {
    margin: 1rem !important;
  }
  .mt-sm-3,
  .my-sm-3 {
    margin-top: 1rem !important;
  }
  .mr-sm-3,
  .mx-sm-3 {
    margin-right: 1rem !important;
  }
  .mb-sm-3,
  .my-sm-3 {
    margin-bottom: 1rem !important;
  }
  .ml-sm-3,
  .mx-sm-3 {
    margin-left: 1rem !important;
  }
  .m-sm-4 {
    margin: 1.5rem !important;
  }
  .mt-sm-4,
  .my-sm-4 {
    margin-top: 1.5rem !important;
  }
  .mr-sm-4,
  .mx-sm-4 {
    margin-right: 1.5rem !important;
  }
  .mb-sm-4,
  .my-sm-4 {
    margin-bottom: 1.5rem !important;
  }
  .ml-sm-4,
  .mx-sm-4 {
    margin-left: 1.5rem !important;
  }
  .m-sm-5 {
    margin: 3rem !important;
  }
  .mt-sm-5,
  .my-sm-5 {
    margin-top: 3rem !important;
  }
  .mr-sm-5,
  .mx-sm-5 {
    margin-right: 3rem !important;
  }
  .mb-sm-5,
  .my-sm-5 {
    margin-bottom: 3rem !important;
  }
  .ml-sm-5,
  .mx-sm-5 {
    margin-left: 3rem !important;
  }
  .m-sm--9 {
    margin: -10rem !important;
  }
  .mt-sm--9,
  .my-sm--9 {
    margin-top: -10rem !important;
  }
  .mr-sm--9,
  .mx-sm--9 {
    margin-right: -10rem !important;
  }
  .mb-sm--9,
  .my-sm--9 {
    margin-bottom: -10rem !important;
  }
  .ml-sm--9,
  .mx-sm--9 {
    margin-left: -10rem !important;
  }
  .m-sm--8 {
    margin: -8rem !important;
  }
  .mt-sm--8,
  .my-sm--8 {
    margin-top: -8rem !important;
  }
  .mr-sm--8,
  .mx-sm--8 {
    margin-right: -8rem !important;
  }
  .mb-sm--8,
  .my-sm--8 {
    margin-bottom: -8rem !important;
  }
  .ml-sm--8,
  .mx-sm--8 {
    margin-left: -8rem !important;
  }
  .m-sm--7 {
    margin: -6rem !important;
  }
  .mt-sm--7,
  .my-sm--7 {
    margin-top: -6rem !important;
  }
  .mr-sm--7,
  .mx-sm--7 {
    margin-right: -6rem !important;
  }
  .mb-sm--7,
  .my-sm--7 {
    margin-bottom: -6rem !important;
  }
  .ml-sm--7,
  .mx-sm--7 {
    margin-left: -6rem !important;
  }
  .m-sm--6 {
    margin: -4.5rem !important;
  }
  .mt-sm--6,
  .my-sm--6 {
    margin-top: -4.5rem !important;
  }
  .mr-sm--6,
  .mx-sm--6 {
    margin-right: -4.5rem !important;
  }
  .mb-sm--6,
  .my-sm--6 {
    margin-bottom: -4.5rem !important;
  }
  .ml-sm--6,
  .mx-sm--6 {
    margin-left: -4.5rem !important;
  }
  .m-sm--5 {
    margin: -3rem !important;
  }
  .mt-sm--5,
  .my-sm--5 {
    margin-top: -3rem !important;
  }
  .mr-sm--5,
  .mx-sm--5 {
    margin-right: -3rem !important;
  }
  .mb-sm--5,
  .my-sm--5 {
    margin-bottom: -3rem !important;
  }
  .ml-sm--5,
  .mx-sm--5 {
    margin-left: -3rem !important;
  }
  .m-sm--4 {
    margin: -1.5rem !important;
  }
  .mt-sm--4,
  .my-sm--4 {
    margin-top: -1.5rem !important;
  }
  .mr-sm--4,
  .mx-sm--4 {
    margin-right: -1.5rem !important;
  }
  .mb-sm--4,
  .my-sm--4 {
    margin-bottom: -1.5rem !important;
  }
  .ml-sm--4,
  .mx-sm--4 {
    margin-left: -1.5rem !important;
  }
  .m-sm--3 {
    margin: -1rem !important;
  }
  .mt-sm--3,
  .my-sm--3 {
    margin-top: -1rem !important;
  }
  .mr-sm--3,
  .mx-sm--3 {
    margin-right: -1rem !important;
  }
  .mb-sm--3,
  .my-sm--3 {
    margin-bottom: -1rem !important;
  }
  .ml-sm--3,
  .mx-sm--3 {
    margin-left: -1rem !important;
  }
  .m-sm--2 {
    margin: -0.5rem !important;
  }
  .mt-sm--2,
  .my-sm--2 {
    margin-top: -0.5rem !important;
  }
  .mr-sm--2,
  .mx-sm--2 {
    margin-right: -0.5rem !important;
  }
  .mb-sm--2,
  .my-sm--2 {
    margin-bottom: -0.5rem !important;
  }
  .ml-sm--2,
  .mx-sm--2 {
    margin-left: -0.5rem !important;
  }
  .m-sm--1 {
    margin: -0.25rem !important;
  }
  .mt-sm--1,
  .my-sm--1 {
    margin-top: -0.25rem !important;
  }
  .mr-sm--1,
  .mx-sm--1 {
    margin-right: -0.25rem !important;
  }
  .mb-sm--1,
  .my-sm--1 {
    margin-bottom: -0.25rem !important;
  }
  .ml-sm--1,
  .mx-sm--1 {
    margin-left: -0.25rem !important;
  }
  .m-sm-6 {
    margin: 4.5rem !important;
  }
  .mt-sm-6,
  .my-sm-6 {
    margin-top: 4.5rem !important;
  }
  .mr-sm-6,
  .mx-sm-6 {
    margin-right: 4.5rem !important;
  }
  .mb-sm-6,
  .my-sm-6 {
    margin-bottom: 4.5rem !important;
  }
  .ml-sm-6,
  .mx-sm-6 {
    margin-left: 4.5rem !important;
  }
  .m-sm-7 {
    margin: 6rem !important;
  }
  .mt-sm-7,
  .my-sm-7 {
    margin-top: 6rem !important;
  }
  .mr-sm-7,
  .mx-sm-7 {
    margin-right: 6rem !important;
  }
  .mb-sm-7,
  .my-sm-7 {
    margin-bottom: 6rem !important;
  }
  .ml-sm-7,
  .mx-sm-7 {
    margin-left: 6rem !important;
  }
  .m-sm-8 {
    margin: 8rem !important;
  }
  .mt-sm-8,
  .my-sm-8 {
    margin-top: 8rem !important;
  }
  .mr-sm-8,
  .mx-sm-8 {
    margin-right: 8rem !important;
  }
  .mb-sm-8,
  .my-sm-8 {
    margin-bottom: 8rem !important;
  }
  .ml-sm-8,
  .mx-sm-8 {
    margin-left: 8rem !important;
  }
  .m-sm-9 {
    margin: 10rem !important;
  }
  .mt-sm-9,
  .my-sm-9 {
    margin-top: 10rem !important;
  }
  .mr-sm-9,
  .mx-sm-9 {
    margin-right: 10rem !important;
  }
  .mb-sm-9,
  .my-sm-9 {
    margin-bottom: 10rem !important;
  }
  .ml-sm-9,
  .mx-sm-9 {
    margin-left: 10rem !important;
  }
  .p-sm-0 {
    padding: 0 !important;
  }
  .pt-sm-0,
  .py-sm-0 {
    padding-top: 0 !important;
  }
  .pr-sm-0,
  .px-sm-0 {
    padding-right: 0 !important;
  }
  .pb-sm-0,
  .py-sm-0 {
    padding-bottom: 0 !important;
  }
  .pl-sm-0,
  .px-sm-0 {
    padding-left: 0 !important;
  }
  .p-sm-1 {
    padding: 0.25rem !important;
  }
  .pt-sm-1,
  .py-sm-1 {
    padding-top: 0.25rem !important;
  }
  .pr-sm-1,
  .px-sm-1 {
    padding-right: 0.25rem !important;
  }
  .pb-sm-1,
  .py-sm-1 {
    padding-bottom: 0.25rem !important;
  }
  .pl-sm-1,
  .px-sm-1 {
    padding-left: 0.25rem !important;
  }
  .p-sm-2 {
    padding: 0.5rem !important;
  }
  .pt-sm-2,
  .py-sm-2 {
    padding-top: 0.5rem !important;
  }
  .pr-sm-2,
  .px-sm-2 {
    padding-right: 0.5rem !important;
  }
  .pb-sm-2,
  .py-sm-2 {
    padding-bottom: 0.5rem !important;
  }
  .pl-sm-2,
  .px-sm-2 {
    padding-left: 0.5rem !important;
  }
  .p-sm-3 {
    padding: 1rem !important;
  }
  .pt-sm-3,
  .py-sm-3 {
    padding-top: 1rem !important;
  }
  .pr-sm-3,
  .px-sm-3 {
    padding-right: 1rem !important;
  }
  .pb-sm-3,
  .py-sm-3 {
    padding-bottom: 1rem !important;
  }
  .pl-sm-3,
  .px-sm-3 {
    padding-left: 1rem !important;
  }
  .p-sm-4 {
    padding: 1.5rem !important;
  }
  .pt-sm-4,
  .py-sm-4 {
    padding-top: 1.5rem !important;
  }
  .pr-sm-4,
  .px-sm-4 {
    padding-right: 1.5rem !important;
  }
  .pb-sm-4,
  .py-sm-4 {
    padding-bottom: 1.5rem !important;
  }
  .pl-sm-4,
  .px-sm-4 {
    padding-left: 1.5rem !important;
  }
  .p-sm-5 {
    padding: 3rem !important;
  }
  .pt-sm-5,
  .py-sm-5 {
    padding-top: 3rem !important;
  }
  .pr-sm-5,
  .px-sm-5 {
    padding-right: 3rem !important;
  }
  .pb-sm-5,
  .py-sm-5 {
    padding-bottom: 3rem !important;
  }
  .pl-sm-5,
  .px-sm-5 {
    padding-left: 3rem !important;
  }
  .p-sm--9 {
    padding: -10rem !important;
  }
  .pt-sm--9,
  .py-sm--9 {
    padding-top: -10rem !important;
  }
  .pr-sm--9,
  .px-sm--9 {
    padding-right: -10rem !important;
  }
  .pb-sm--9,
  .py-sm--9 {
    padding-bottom: -10rem !important;
  }
  .pl-sm--9,
  .px-sm--9 {
    padding-left: -10rem !important;
  }
  .p-sm--8 {
    padding: -8rem !important;
  }
  .pt-sm--8,
  .py-sm--8 {
    padding-top: -8rem !important;
  }
  .pr-sm--8,
  .px-sm--8 {
    padding-right: -8rem !important;
  }
  .pb-sm--8,
  .py-sm--8 {
    padding-bottom: -8rem !important;
  }
  .pl-sm--8,
  .px-sm--8 {
    padding-left: -8rem !important;
  }
  .p-sm--7 {
    padding: -6rem !important;
  }
  .pt-sm--7,
  .py-sm--7 {
    padding-top: -6rem !important;
  }
  .pr-sm--7,
  .px-sm--7 {
    padding-right: -6rem !important;
  }
  .pb-sm--7,
  .py-sm--7 {
    padding-bottom: -6rem !important;
  }
  .pl-sm--7,
  .px-sm--7 {
    padding-left: -6rem !important;
  }
  .p-sm--6 {
    padding: -4.5rem !important;
  }
  .pt-sm--6,
  .py-sm--6 {
    padding-top: -4.5rem !important;
  }
  .pr-sm--6,
  .px-sm--6 {
    padding-right: -4.5rem !important;
  }
  .pb-sm--6,
  .py-sm--6 {
    padding-bottom: -4.5rem !important;
  }
  .pl-sm--6,
  .px-sm--6 {
    padding-left: -4.5rem !important;
  }
  .p-sm--5 {
    padding: -3rem !important;
  }
  .pt-sm--5,
  .py-sm--5 {
    padding-top: -3rem !important;
  }
  .pr-sm--5,
  .px-sm--5 {
    padding-right: -3rem !important;
  }
  .pb-sm--5,
  .py-sm--5 {
    padding-bottom: -3rem !important;
  }
  .pl-sm--5,
  .px-sm--5 {
    padding-left: -3rem !important;
  }
  .p-sm--4 {
    padding: -1.5rem !important;
  }
  .pt-sm--4,
  .py-sm--4 {
    padding-top: -1.5rem !important;
  }
  .pr-sm--4,
  .px-sm--4 {
    padding-right: -1.5rem !important;
  }
  .pb-sm--4,
  .py-sm--4 {
    padding-bottom: -1.5rem !important;
  }
  .pl-sm--4,
  .px-sm--4 {
    padding-left: -1.5rem !important;
  }
  .p-sm--3 {
    padding: -1rem !important;
  }
  .pt-sm--3,
  .py-sm--3 {
    padding-top: -1rem !important;
  }
  .pr-sm--3,
  .px-sm--3 {
    padding-right: -1rem !important;
  }
  .pb-sm--3,
  .py-sm--3 {
    padding-bottom: -1rem !important;
  }
  .pl-sm--3,
  .px-sm--3 {
    padding-left: -1rem !important;
  }
  .p-sm--2 {
    padding: -0.5rem !important;
  }
  .pt-sm--2,
  .py-sm--2 {
    padding-top: -0.5rem !important;
  }
  .pr-sm--2,
  .px-sm--2 {
    padding-right: -0.5rem !important;
  }
  .pb-sm--2,
  .py-sm--2 {
    padding-bottom: -0.5rem !important;
  }
  .pl-sm--2,
  .px-sm--2 {
    padding-left: -0.5rem !important;
  }
  .p-sm--1 {
    padding: -0.25rem !important;
  }
  .pt-sm--1,
  .py-sm--1 {
    padding-top: -0.25rem !important;
  }
  .pr-sm--1,
  .px-sm--1 {
    padding-right: -0.25rem !important;
  }
  .pb-sm--1,
  .py-sm--1 {
    padding-bottom: -0.25rem !important;
  }
  .pl-sm--1,
  .px-sm--1 {
    padding-left: -0.25rem !important;
  }
  .p-sm-6 {
    padding: 4.5rem !important;
  }
  .pt-sm-6,
  .py-sm-6 {
    padding-top: 4.5rem !important;
  }
  .pr-sm-6,
  .px-sm-6 {
    padding-right: 4.5rem !important;
  }
  .pb-sm-6,
  .py-sm-6 {
    padding-bottom: 4.5rem !important;
  }
  .pl-sm-6,
  .px-sm-6 {
    padding-left: 4.5rem !important;
  }
  .p-sm-7 {
    padding: 6rem !important;
  }
  .pt-sm-7,
  .py-sm-7 {
    padding-top: 6rem !important;
  }
  .pr-sm-7,
  .px-sm-7 {
    padding-right: 6rem !important;
  }
  .pb-sm-7,
  .py-sm-7 {
    padding-bottom: 6rem !important;
  }
  .pl-sm-7,
  .px-sm-7 {
    padding-left: 6rem !important;
  }
  .p-sm-8 {
    padding: 8rem !important;
  }
  .pt-sm-8,
  .py-sm-8 {
    padding-top: 8rem !important;
  }
  .pr-sm-8,
  .px-sm-8 {
    padding-right: 8rem !important;
  }
  .pb-sm-8,
  .py-sm-8 {
    padding-bottom: 8rem !important;
  }
  .pl-sm-8,
  .px-sm-8 {
    padding-left: 8rem !important;
  }
  .p-sm-9 {
    padding: 10rem !important;
  }
  .pt-sm-9,
  .py-sm-9 {
    padding-top: 10rem !important;
  }
  .pr-sm-9,
  .px-sm-9 {
    padding-right: 10rem !important;
  }
  .pb-sm-9,
  .py-sm-9 {
    padding-bottom: 10rem !important;
  }
  .pl-sm-9,
  .px-sm-9 {
    padding-left: 10rem !important;
  }
  .m-sm-n1 {
    margin: -0.25rem !important;
  }
  .mt-sm-n1,
  .my-sm-n1 {
    margin-top: -0.25rem !important;
  }
  .mr-sm-n1,
  .mx-sm-n1 {
    margin-right: -0.25rem !important;
  }
  .mb-sm-n1,
  .my-sm-n1 {
    margin-bottom: -0.25rem !important;
  }
  .ml-sm-n1,
  .mx-sm-n1 {
    margin-left: -0.25rem !important;
  }
  .m-sm-n2 {
    margin: -0.5rem !important;
  }
  .mt-sm-n2,
  .my-sm-n2 {
    margin-top: -0.5rem !important;
  }
  .mr-sm-n2,
  .mx-sm-n2 {
    margin-right: -0.5rem !important;
  }
  .mb-sm-n2,
  .my-sm-n2 {
    margin-bottom: -0.5rem !important;
  }
  .ml-sm-n2,
  .mx-sm-n2 {
    margin-left: -0.5rem !important;
  }
  .m-sm-n3 {
    margin: -1rem !important;
  }
  .mt-sm-n3,
  .my-sm-n3 {
    margin-top: -1rem !important;
  }
  .mr-sm-n3,
  .mx-sm-n3 {
    margin-right: -1rem !important;
  }
  .mb-sm-n3,
  .my-sm-n3 {
    margin-bottom: -1rem !important;
  }
  .ml-sm-n3,
  .mx-sm-n3 {
    margin-left: -1rem !important;
  }
  .m-sm-n4 {
    margin: -1.5rem !important;
  }
  .mt-sm-n4,
  .my-sm-n4 {
    margin-top: -1.5rem !important;
  }
  .mr-sm-n4,
  .mx-sm-n4 {
    margin-right: -1.5rem !important;
  }
  .mb-sm-n4,
  .my-sm-n4 {
    margin-bottom: -1.5rem !important;
  }
  .ml-sm-n4,
  .mx-sm-n4 {
    margin-left: -1.5rem !important;
  }
  .m-sm-n5 {
    margin: -3rem !important;
  }
  .mt-sm-n5,
  .my-sm-n5 {
    margin-top: -3rem !important;
  }
  .mr-sm-n5,
  .mx-sm-n5 {
    margin-right: -3rem !important;
  }
  .mb-sm-n5,
  .my-sm-n5 {
    margin-bottom: -3rem !important;
  }
  .ml-sm-n5,
  .mx-sm-n5 {
    margin-left: -3rem !important;
  }
  .m-sm-n-9 {
    margin: 10rem !important;
  }
  .mt-sm-n-9,
  .my-sm-n-9 {
    margin-top: 10rem !important;
  }
  .mr-sm-n-9,
  .mx-sm-n-9 {
    margin-right: 10rem !important;
  }
  .mb-sm-n-9,
  .my-sm-n-9 {
    margin-bottom: 10rem !important;
  }
  .ml-sm-n-9,
  .mx-sm-n-9 {
    margin-left: 10rem !important;
  }
  .m-sm-n-8 {
    margin: 8rem !important;
  }
  .mt-sm-n-8,
  .my-sm-n-8 {
    margin-top: 8rem !important;
  }
  .mr-sm-n-8,
  .mx-sm-n-8 {
    margin-right: 8rem !important;
  }
  .mb-sm-n-8,
  .my-sm-n-8 {
    margin-bottom: 8rem !important;
  }
  .ml-sm-n-8,
  .mx-sm-n-8 {
    margin-left: 8rem !important;
  }
  .m-sm-n-7 {
    margin: 6rem !important;
  }
  .mt-sm-n-7,
  .my-sm-n-7 {
    margin-top: 6rem !important;
  }
  .mr-sm-n-7,
  .mx-sm-n-7 {
    margin-right: 6rem !important;
  }
  .mb-sm-n-7,
  .my-sm-n-7 {
    margin-bottom: 6rem !important;
  }
  .ml-sm-n-7,
  .mx-sm-n-7 {
    margin-left: 6rem !important;
  }
  .m-sm-n-6 {
    margin: 4.5rem !important;
  }
  .mt-sm-n-6,
  .my-sm-n-6 {
    margin-top: 4.5rem !important;
  }
  .mr-sm-n-6,
  .mx-sm-n-6 {
    margin-right: 4.5rem !important;
  }
  .mb-sm-n-6,
  .my-sm-n-6 {
    margin-bottom: 4.5rem !important;
  }
  .ml-sm-n-6,
  .mx-sm-n-6 {
    margin-left: 4.5rem !important;
  }
  .m-sm-n-5 {
    margin: 3rem !important;
  }
  .mt-sm-n-5,
  .my-sm-n-5 {
    margin-top: 3rem !important;
  }
  .mr-sm-n-5,
  .mx-sm-n-5 {
    margin-right: 3rem !important;
  }
  .mb-sm-n-5,
  .my-sm-n-5 {
    margin-bottom: 3rem !important;
  }
  .ml-sm-n-5,
  .mx-sm-n-5 {
    margin-left: 3rem !important;
  }
  .m-sm-n-4 {
    margin: 1.5rem !important;
  }
  .mt-sm-n-4,
  .my-sm-n-4 {
    margin-top: 1.5rem !important;
  }
  .mr-sm-n-4,
  .mx-sm-n-4 {
    margin-right: 1.5rem !important;
  }
  .mb-sm-n-4,
  .my-sm-n-4 {
    margin-bottom: 1.5rem !important;
  }
  .ml-sm-n-4,
  .mx-sm-n-4 {
    margin-left: 1.5rem !important;
  }
  .m-sm-n-3 {
    margin: 1rem !important;
  }
  .mt-sm-n-3,
  .my-sm-n-3 {
    margin-top: 1rem !important;
  }
  .mr-sm-n-3,
  .mx-sm-n-3 {
    margin-right: 1rem !important;
  }
  .mb-sm-n-3,
  .my-sm-n-3 {
    margin-bottom: 1rem !important;
  }
  .ml-sm-n-3,
  .mx-sm-n-3 {
    margin-left: 1rem !important;
  }
  .m-sm-n-2 {
    margin: 0.5rem !important;
  }
  .mt-sm-n-2,
  .my-sm-n-2 {
    margin-top: 0.5rem !important;
  }
  .mr-sm-n-2,
  .mx-sm-n-2 {
    margin-right: 0.5rem !important;
  }
  .mb-sm-n-2,
  .my-sm-n-2 {
    margin-bottom: 0.5rem !important;
  }
  .ml-sm-n-2,
  .mx-sm-n-2 {
    margin-left: 0.5rem !important;
  }
  .m-sm-n-1 {
    margin: 0.25rem !important;
  }
  .mt-sm-n-1,
  .my-sm-n-1 {
    margin-top: 0.25rem !important;
  }
  .mr-sm-n-1,
  .mx-sm-n-1 {
    margin-right: 0.25rem !important;
  }
  .mb-sm-n-1,
  .my-sm-n-1 {
    margin-bottom: 0.25rem !important;
  }
  .ml-sm-n-1,
  .mx-sm-n-1 {
    margin-left: 0.25rem !important;
  }
  .m-sm-n6 {
    margin: -4.5rem !important;
  }
  .mt-sm-n6,
  .my-sm-n6 {
    margin-top: -4.5rem !important;
  }
  .mr-sm-n6,
  .mx-sm-n6 {
    margin-right: -4.5rem !important;
  }
  .mb-sm-n6,
  .my-sm-n6 {
    margin-bottom: -4.5rem !important;
  }
  .ml-sm-n6,
  .mx-sm-n6 {
    margin-left: -4.5rem !important;
  }
  .m-sm-n7 {
    margin: -6rem !important;
  }
  .mt-sm-n7,
  .my-sm-n7 {
    margin-top: -6rem !important;
  }
  .mr-sm-n7,
  .mx-sm-n7 {
    margin-right: -6rem !important;
  }
  .mb-sm-n7,
  .my-sm-n7 {
    margin-bottom: -6rem !important;
  }
  .ml-sm-n7,
  .mx-sm-n7 {
    margin-left: -6rem !important;
  }
  .m-sm-n8 {
    margin: -8rem !important;
  }
  .mt-sm-n8,
  .my-sm-n8 {
    margin-top: -8rem !important;
  }
  .mr-sm-n8,
  .mx-sm-n8 {
    margin-right: -8rem !important;
  }
  .mb-sm-n8,
  .my-sm-n8 {
    margin-bottom: -8rem !important;
  }
  .ml-sm-n8,
  .mx-sm-n8 {
    margin-left: -8rem !important;
  }
  .m-sm-n9 {
    margin: -10rem !important;
  }
  .mt-sm-n9,
  .my-sm-n9 {
    margin-top: -10rem !important;
  }
  .mr-sm-n9,
  .mx-sm-n9 {
    margin-right: -10rem !important;
  }
  .mb-sm-n9,
  .my-sm-n9 {
    margin-bottom: -10rem !important;
  }
  .ml-sm-n9,
  .mx-sm-n9 {
    margin-left: -10rem !important;
  }
  .m-sm-auto {
    margin: auto !important;
  }
  .mt-sm-auto,
  .my-sm-auto {
    margin-top: auto !important;
  }
  .mr-sm-auto,
  .mx-sm-auto {
    margin-right: auto !important;
  }
  .mb-sm-auto,
  .my-sm-auto {
    margin-bottom: auto !important;
  }
  .ml-sm-auto,
  .mx-sm-auto {
    margin-left: auto !important;
  }
}
@media (min-width: 768px) {
  .m-md-0 {
    margin: 0 !important;
  }
  .mt-md-0,
  .my-md-0 {
    margin-top: 0 !important;
  }
  .mr-md-0,
  .mx-md-0 {
    margin-right: 0 !important;
  }
  .mb-md-0,
  .my-md-0 {
    margin-bottom: 0 !important;
  }
  .ml-md-0,
  .mx-md-0 {
    margin-left: 0 !important;
  }
  .m-md-1 {
    margin: 0.25rem !important;
  }
  .mt-md-1,
  .my-md-1 {
    margin-top: 0.25rem !important;
  }
  .mr-md-1,
  .mx-md-1 {
    margin-right: 0.25rem !important;
  }
  .mb-md-1,
  .my-md-1 {
    margin-bottom: 0.25rem !important;
  }
  .ml-md-1,
  .mx-md-1 {
    margin-left: 0.25rem !important;
  }
  .m-md-2 {
    margin: 0.5rem !important;
  }
  .mt-md-2,
  .my-md-2 {
    margin-top: 0.5rem !important;
  }
  .mr-md-2,
  .mx-md-2 {
    margin-right: 0.5rem !important;
  }
  .mb-md-2,
  .my-md-2 {
    margin-bottom: 0.5rem !important;
  }
  .ml-md-2,
  .mx-md-2 {
    margin-left: 0.5rem !important;
  }
  .m-md-3 {
    margin: 1rem !important;
  }
  .mt-md-3,
  .my-md-3 {
    margin-top: 1rem !important;
  }
  .mr-md-3,
  .mx-md-3 {
    margin-right: 1rem !important;
  }
  .mb-md-3,
  .my-md-3 {
    margin-bottom: 1rem !important;
  }
  .ml-md-3,
  .mx-md-3 {
    margin-left: 1rem !important;
  }
  .m-md-4 {
    margin: 1.5rem !important;
  }
  .mt-md-4,
  .my-md-4 {
    margin-top: 1.5rem !important;
  }
  .mr-md-4,
  .mx-md-4 {
    margin-right: 1.5rem !important;
  }
  .mb-md-4,
  .my-md-4 {
    margin-bottom: 1.5rem !important;
  }
  .ml-md-4,
  .mx-md-4 {
    margin-left: 1.5rem !important;
  }
  .m-md-5 {
    margin: 3rem !important;
  }
  .mt-md-5,
  .my-md-5 {
    margin-top: 3rem !important;
  }
  .mr-md-5,
  .mx-md-5 {
    margin-right: 3rem !important;
  }
  .mb-md-5,
  .my-md-5 {
    margin-bottom: 3rem !important;
  }
  .ml-md-5,
  .mx-md-5 {
    margin-left: 3rem !important;
  }
  .m-md--9 {
    margin: -10rem !important;
  }
  .mt-md--9,
  .my-md--9 {
    margin-top: -10rem !important;
  }
  .mr-md--9,
  .mx-md--9 {
    margin-right: -10rem !important;
  }
  .mb-md--9,
  .my-md--9 {
    margin-bottom: -10rem !important;
  }
  .ml-md--9,
  .mx-md--9 {
    margin-left: -10rem !important;
  }
  .m-md--8 {
    margin: -8rem !important;
  }
  .mt-md--8,
  .my-md--8 {
    margin-top: -8rem !important;
  }
  .mr-md--8,
  .mx-md--8 {
    margin-right: -8rem !important;
  }
  .mb-md--8,
  .my-md--8 {
    margin-bottom: -8rem !important;
  }
  .ml-md--8,
  .mx-md--8 {
    margin-left: -8rem !important;
  }
  .m-md--7 {
    margin: -6rem !important;
  }
  .mt-md--7,
  .my-md--7 {
    margin-top: -6rem !important;
  }
  .mr-md--7,
  .mx-md--7 {
    margin-right: -6rem !important;
  }
  .mb-md--7,
  .my-md--7 {
    margin-bottom: -6rem !important;
  }
  .ml-md--7,
  .mx-md--7 {
    margin-left: -6rem !important;
  }
  .m-md--6 {
    margin: -4.5rem !important;
  }
  .mt-md--6,
  .my-md--6 {
    margin-top: -4.5rem !important;
  }
  .mr-md--6,
  .mx-md--6 {
    margin-right: -4.5rem !important;
  }
  .mb-md--6,
  .my-md--6 {
    margin-bottom: -4.5rem !important;
  }
  .ml-md--6,
  .mx-md--6 {
    margin-left: -4.5rem !important;
  }
  .m-md--5 {
    margin: -3rem !important;
  }
  .mt-md--5,
  .my-md--5 {
    margin-top: -3rem !important;
  }
  .mr-md--5,
  .mx-md--5 {
    margin-right: -3rem !important;
  }
  .mb-md--5,
  .my-md--5 {
    margin-bottom: -3rem !important;
  }
  .ml-md--5,
  .mx-md--5 {
    margin-left: -3rem !important;
  }
  .m-md--4 {
    margin: -1.5rem !important;
  }
  .mt-md--4,
  .my-md--4 {
    margin-top: -1.5rem !important;
  }
  .mr-md--4,
  .mx-md--4 {
    margin-right: -1.5rem !important;
  }
  .mb-md--4,
  .my-md--4 {
    margin-bottom: -1.5rem !important;
  }
  .ml-md--4,
  .mx-md--4 {
    margin-left: -1.5rem !important;
  }
  .m-md--3 {
    margin: -1rem !important;
  }
  .mt-md--3,
  .my-md--3 {
    margin-top: -1rem !important;
  }
  .mr-md--3,
  .mx-md--3 {
    margin-right: -1rem !important;
  }
  .mb-md--3,
  .my-md--3 {
    margin-bottom: -1rem !important;
  }
  .ml-md--3,
  .mx-md--3 {
    margin-left: -1rem !important;
  }
  .m-md--2 {
    margin: -0.5rem !important;
  }
  .mt-md--2,
  .my-md--2 {
    margin-top: -0.5rem !important;
  }
  .mr-md--2,
  .mx-md--2 {
    margin-right: -0.5rem !important;
  }
  .mb-md--2,
  .my-md--2 {
    margin-bottom: -0.5rem !important;
  }
  .ml-md--2,
  .mx-md--2 {
    margin-left: -0.5rem !important;
  }
  .m-md--1 {
    margin: -0.25rem !important;
  }
  .mt-md--1,
  .my-md--1 {
    margin-top: -0.25rem !important;
  }
  .mr-md--1,
  .mx-md--1 {
    margin-right: -0.25rem !important;
  }
  .mb-md--1,
  .my-md--1 {
    margin-bottom: -0.25rem !important;
  }
  .ml-md--1,
  .mx-md--1 {
    margin-left: -0.25rem !important;
  }
  .m-md-6 {
    margin: 4.5rem !important;
  }
  .mt-md-6,
  .my-md-6 {
    margin-top: 4.5rem !important;
  }
  .mr-md-6,
  .mx-md-6 {
    margin-right: 4.5rem !important;
  }
  .mb-md-6,
  .my-md-6 {
    margin-bottom: 4.5rem !important;
  }
  .ml-md-6,
  .mx-md-6 {
    margin-left: 4.5rem !important;
  }
  .m-md-7 {
    margin: 6rem !important;
  }
  .mt-md-7,
  .my-md-7 {
    margin-top: 6rem !important;
  }
  .mr-md-7,
  .mx-md-7 {
    margin-right: 6rem !important;
  }
  .mb-md-7,
  .my-md-7 {
    margin-bottom: 6rem !important;
  }
  .ml-md-7,
  .mx-md-7 {
    margin-left: 6rem !important;
  }
  .m-md-8 {
    margin: 8rem !important;
  }
  .mt-md-8,
  .my-md-8 {
    margin-top: 8rem !important;
  }
  .mr-md-8,
  .mx-md-8 {
    margin-right: 8rem !important;
  }
  .mb-md-8,
  .my-md-8 {
    margin-bottom: 8rem !important;
  }
  .ml-md-8,
  .mx-md-8 {
    margin-left: 8rem !important;
  }
  .m-md-9 {
    margin: 10rem !important;
  }
  .mt-md-9,
  .my-md-9 {
    margin-top: 10rem !important;
  }
  .mr-md-9,
  .mx-md-9 {
    margin-right: 10rem !important;
  }
  .mb-md-9,
  .my-md-9 {
    margin-bottom: 10rem !important;
  }
  .ml-md-9,
  .mx-md-9 {
    margin-left: 10rem !important;
  }
  .p-md-0 {
    padding: 0 !important;
  }
  .pt-md-0,
  .py-md-0 {
    padding-top: 0 !important;
  }
  .pr-md-0,
  .px-md-0 {
    padding-right: 0 !important;
  }
  .pb-md-0,
  .py-md-0 {
    padding-bottom: 0 !important;
  }
  .pl-md-0,
  .px-md-0 {
    padding-left: 0 !important;
  }
  .p-md-1 {
    padding: 0.25rem !important;
  }
  .pt-md-1,
  .py-md-1 {
    padding-top: 0.25rem !important;
  }
  .pr-md-1,
  .px-md-1 {
    padding-right: 0.25rem !important;
  }
  .pb-md-1,
  .py-md-1 {
    padding-bottom: 0.25rem !important;
  }
  .pl-md-1,
  .px-md-1 {
    padding-left: 0.25rem !important;
  }
  .p-md-2 {
    padding: 0.5rem !important;
  }
  .pt-md-2,
  .py-md-2 {
    padding-top: 0.5rem !important;
  }
  .pr-md-2,
  .px-md-2 {
    padding-right: 0.5rem !important;
  }
  .pb-md-2,
  .py-md-2 {
    padding-bottom: 0.5rem !important;
  }
  .pl-md-2,
  .px-md-2 {
    padding-left: 0.5rem !important;
  }
  .p-md-3 {
    padding: 1rem !important;
  }
  .pt-md-3,
  .py-md-3 {
    padding-top: 1rem !important;
  }
  .pr-md-3,
  .px-md-3 {
    padding-right: 1rem !important;
  }
  .pb-md-3,
  .py-md-3 {
    padding-bottom: 1rem !important;
  }
  .pl-md-3,
  .px-md-3 {
    padding-left: 1rem !important;
  }
  .p-md-4 {
    padding: 1.5rem !important;
  }
  .pt-md-4,
  .py-md-4 {
    padding-top: 1.5rem !important;
  }
  .pr-md-4,
  .px-md-4 {
    padding-right: 1.5rem !important;
  }
  .pb-md-4,
  .py-md-4 {
    padding-bottom: 1.5rem !important;
  }
  .pl-md-4,
  .px-md-4 {
    padding-left: 1.5rem !important;
  }
  .p-md-5 {
    padding: 3rem !important;
  }
  .pt-md-5,
  .py-md-5 {
    padding-top: 3rem !important;
  }
  .pr-md-5,
  .px-md-5 {
    padding-right: 3rem !important;
  }
  .pb-md-5,
  .py-md-5 {
    padding-bottom: 3rem !important;
  }
  .pl-md-5,
  .px-md-5 {
    padding-left: 3rem !important;
  }
  .p-md--9 {
    padding: -10rem !important;
  }
  .pt-md--9,
  .py-md--9 {
    padding-top: -10rem !important;
  }
  .pr-md--9,
  .px-md--9 {
    padding-right: -10rem !important;
  }
  .pb-md--9,
  .py-md--9 {
    padding-bottom: -10rem !important;
  }
  .pl-md--9,
  .px-md--9 {
    padding-left: -10rem !important;
  }
  .p-md--8 {
    padding: -8rem !important;
  }
  .pt-md--8,
  .py-md--8 {
    padding-top: -8rem !important;
  }
  .pr-md--8,
  .px-md--8 {
    padding-right: -8rem !important;
  }
  .pb-md--8,
  .py-md--8 {
    padding-bottom: -8rem !important;
  }
  .pl-md--8,
  .px-md--8 {
    padding-left: -8rem !important;
  }
  .p-md--7 {
    padding: -6rem !important;
  }
  .pt-md--7,
  .py-md--7 {
    padding-top: -6rem !important;
  }
  .pr-md--7,
  .px-md--7 {
    padding-right: -6rem !important;
  }
  .pb-md--7,
  .py-md--7 {
    padding-bottom: -6rem !important;
  }
  .pl-md--7,
  .px-md--7 {
    padding-left: -6rem !important;
  }
  .p-md--6 {
    padding: -4.5rem !important;
  }
  .pt-md--6,
  .py-md--6 {
    padding-top: -4.5rem !important;
  }
  .pr-md--6,
  .px-md--6 {
    padding-right: -4.5rem !important;
  }
  .pb-md--6,
  .py-md--6 {
    padding-bottom: -4.5rem !important;
  }
  .pl-md--6,
  .px-md--6 {
    padding-left: -4.5rem !important;
  }
  .p-md--5 {
    padding: -3rem !important;
  }
  .pt-md--5,
  .py-md--5 {
    padding-top: -3rem !important;
  }
  .pr-md--5,
  .px-md--5 {
    padding-right: -3rem !important;
  }
  .pb-md--5,
  .py-md--5 {
    padding-bottom: -3rem !important;
  }
  .pl-md--5,
  .px-md--5 {
    padding-left: -3rem !important;
  }
  .p-md--4 {
    padding: -1.5rem !important;
  }
  .pt-md--4,
  .py-md--4 {
    padding-top: -1.5rem !important;
  }
  .pr-md--4,
  .px-md--4 {
    padding-right: -1.5rem !important;
  }
  .pb-md--4,
  .py-md--4 {
    padding-bottom: -1.5rem !important;
  }
  .pl-md--4,
  .px-md--4 {
    padding-left: -1.5rem !important;
  }
  .p-md--3 {
    padding: -1rem !important;
  }
  .pt-md--3,
  .py-md--3 {
    padding-top: -1rem !important;
  }
  .pr-md--3,
  .px-md--3 {
    padding-right: -1rem !important;
  }
  .pb-md--3,
  .py-md--3 {
    padding-bottom: -1rem !important;
  }
  .pl-md--3,
  .px-md--3 {
    padding-left: -1rem !important;
  }
  .p-md--2 {
    padding: -0.5rem !important;
  }
  .pt-md--2,
  .py-md--2 {
    padding-top: -0.5rem !important;
  }
  .pr-md--2,
  .px-md--2 {
    padding-right: -0.5rem !important;
  }
  .pb-md--2,
  .py-md--2 {
    padding-bottom: -0.5rem !important;
  }
  .pl-md--2,
  .px-md--2 {
    padding-left: -0.5rem !important;
  }
  .p-md--1 {
    padding: -0.25rem !important;
  }
  .pt-md--1,
  .py-md--1 {
    padding-top: -0.25rem !important;
  }
  .pr-md--1,
  .px-md--1 {
    padding-right: -0.25rem !important;
  }
  .pb-md--1,
  .py-md--1 {
    padding-bottom: -0.25rem !important;
  }
  .pl-md--1,
  .px-md--1 {
    padding-left: -0.25rem !important;
  }
  .p-md-6 {
    padding: 4.5rem !important;
  }
  .pt-md-6,
  .py-md-6 {
    padding-top: 4.5rem !important;
  }
  .pr-md-6,
  .px-md-6 {
    padding-right: 4.5rem !important;
  }
  .pb-md-6,
  .py-md-6 {
    padding-bottom: 4.5rem !important;
  }
  .pl-md-6,
  .px-md-6 {
    padding-left: 4.5rem !important;
  }
  .p-md-7 {
    padding: 6rem !important;
  }
  .pt-md-7,
  .py-md-7 {
    padding-top: 6rem !important;
  }
  .pr-md-7,
  .px-md-7 {
    padding-right: 6rem !important;
  }
  .pb-md-7,
  .py-md-7 {
    padding-bottom: 6rem !important;
  }
  .pl-md-7,
  .px-md-7 {
    padding-left: 6rem !important;
  }
  .p-md-8 {
    padding: 8rem !important;
  }
  .pt-md-8,
  .py-md-8 {
    padding-top: 8rem !important;
  }
  .pr-md-8,
  .px-md-8 {
    padding-right: 8rem !important;
  }
  .pb-md-8,
  .py-md-8 {
    padding-bottom: 8rem !important;
  }
  .pl-md-8,
  .px-md-8 {
    padding-left: 8rem !important;
  }
  .p-md-9 {
    padding: 10rem !important;
  }
  .pt-md-9,
  .py-md-9 {
    padding-top: 10rem !important;
  }
  .pr-md-9,
  .px-md-9 {
    padding-right: 10rem !important;
  }
  .pb-md-9,
  .py-md-9 {
    padding-bottom: 10rem !important;
  }
  .pl-md-9,
  .px-md-9 {
    padding-left: 10rem !important;
  }
  .m-md-n1 {
    margin: -0.25rem !important;
  }
  .mt-md-n1,
  .my-md-n1 {
    margin-top: -0.25rem !important;
  }
  .mr-md-n1,
  .mx-md-n1 {
    margin-right: -0.25rem !important;
  }
  .mb-md-n1,
  .my-md-n1 {
    margin-bottom: -0.25rem !important;
  }
  .ml-md-n1,
  .mx-md-n1 {
    margin-left: -0.25rem !important;
  }
  .m-md-n2 {
    margin: -0.5rem !important;
  }
  .mt-md-n2,
  .my-md-n2 {
    margin-top: -0.5rem !important;
  }
  .mr-md-n2,
  .mx-md-n2 {
    margin-right: -0.5rem !important;
  }
  .mb-md-n2,
  .my-md-n2 {
    margin-bottom: -0.5rem !important;
  }
  .ml-md-n2,
  .mx-md-n2 {
    margin-left: -0.5rem !important;
  }
  .m-md-n3 {
    margin: -1rem !important;
  }
  .mt-md-n3,
  .my-md-n3 {
    margin-top: -1rem !important;
  }
  .mr-md-n3,
  .mx-md-n3 {
    margin-right: -1rem !important;
  }
  .mb-md-n3,
  .my-md-n3 {
    margin-bottom: -1rem !important;
  }
  .ml-md-n3,
  .mx-md-n3 {
    margin-left: -1rem !important;
  }
  .m-md-n4 {
    margin: -1.5rem !important;
  }
  .mt-md-n4,
  .my-md-n4 {
    margin-top: -1.5rem !important;
  }
  .mr-md-n4,
  .mx-md-n4 {
    margin-right: -1.5rem !important;
  }
  .mb-md-n4,
  .my-md-n4 {
    margin-bottom: -1.5rem !important;
  }
  .ml-md-n4,
  .mx-md-n4 {
    margin-left: -1.5rem !important;
  }
  .m-md-n5 {
    margin: -3rem !important;
  }
  .mt-md-n5,
  .my-md-n5 {
    margin-top: -3rem !important;
  }
  .mr-md-n5,
  .mx-md-n5 {
    margin-right: -3rem !important;
  }
  .mb-md-n5,
  .my-md-n5 {
    margin-bottom: -3rem !important;
  }
  .ml-md-n5,
  .mx-md-n5 {
    margin-left: -3rem !important;
  }
  .m-md-n-9 {
    margin: 10rem !important;
  }
  .mt-md-n-9,
  .my-md-n-9 {
    margin-top: 10rem !important;
  }
  .mr-md-n-9,
  .mx-md-n-9 {
    margin-right: 10rem !important;
  }
  .mb-md-n-9,
  .my-md-n-9 {
    margin-bottom: 10rem !important;
  }
  .ml-md-n-9,
  .mx-md-n-9 {
    margin-left: 10rem !important;
  }
  .m-md-n-8 {
    margin: 8rem !important;
  }
  .mt-md-n-8,
  .my-md-n-8 {
    margin-top: 8rem !important;
  }
  .mr-md-n-8,
  .mx-md-n-8 {
    margin-right: 8rem !important;
  }
  .mb-md-n-8,
  .my-md-n-8 {
    margin-bottom: 8rem !important;
  }
  .ml-md-n-8,
  .mx-md-n-8 {
    margin-left: 8rem !important;
  }
  .m-md-n-7 {
    margin: 6rem !important;
  }
  .mt-md-n-7,
  .my-md-n-7 {
    margin-top: 6rem !important;
  }
  .mr-md-n-7,
  .mx-md-n-7 {
    margin-right: 6rem !important;
  }
  .mb-md-n-7,
  .my-md-n-7 {
    margin-bottom: 6rem !important;
  }
  .ml-md-n-7,
  .mx-md-n-7 {
    margin-left: 6rem !important;
  }
  .m-md-n-6 {
    margin: 4.5rem !important;
  }
  .mt-md-n-6,
  .my-md-n-6 {
    margin-top: 4.5rem !important;
  }
  .mr-md-n-6,
  .mx-md-n-6 {
    margin-right: 4.5rem !important;
  }
  .mb-md-n-6,
  .my-md-n-6 {
    margin-bottom: 4.5rem !important;
  }
  .ml-md-n-6,
  .mx-md-n-6 {
    margin-left: 4.5rem !important;
  }
  .m-md-n-5 {
    margin: 3rem !important;
  }
  .mt-md-n-5,
  .my-md-n-5 {
    margin-top: 3rem !important;
  }
  .mr-md-n-5,
  .mx-md-n-5 {
    margin-right: 3rem !important;
  }
  .mb-md-n-5,
  .my-md-n-5 {
    margin-bottom: 3rem !important;
  }
  .ml-md-n-5,
  .mx-md-n-5 {
    margin-left: 3rem !important;
  }
  .m-md-n-4 {
    margin: 1.5rem !important;
  }
  .mt-md-n-4,
  .my-md-n-4 {
    margin-top: 1.5rem !important;
  }
  .mr-md-n-4,
  .mx-md-n-4 {
    margin-right: 1.5rem !important;
  }
  .mb-md-n-4,
  .my-md-n-4 {
    margin-bottom: 1.5rem !important;
  }
  .ml-md-n-4,
  .mx-md-n-4 {
    margin-left: 1.5rem !important;
  }
  .m-md-n-3 {
    margin: 1rem !important;
  }
  .mt-md-n-3,
  .my-md-n-3 {
    margin-top: 1rem !important;
  }
  .mr-md-n-3,
  .mx-md-n-3 {
    margin-right: 1rem !important;
  }
  .mb-md-n-3,
  .my-md-n-3 {
    margin-bottom: 1rem !important;
  }
  .ml-md-n-3,
  .mx-md-n-3 {
    margin-left: 1rem !important;
  }
  .m-md-n-2 {
    margin: 0.5rem !important;
  }
  .mt-md-n-2,
  .my-md-n-2 {
    margin-top: 0.5rem !important;
  }
  .mr-md-n-2,
  .mx-md-n-2 {
    margin-right: 0.5rem !important;
  }
  .mb-md-n-2,
  .my-md-n-2 {
    margin-bottom: 0.5rem !important;
  }
  .ml-md-n-2,
  .mx-md-n-2 {
    margin-left: 0.5rem !important;
  }
  .m-md-n-1 {
    margin: 0.25rem !important;
  }
  .mt-md-n-1,
  .my-md-n-1 {
    margin-top: 0.25rem !important;
  }
  .mr-md-n-1,
  .mx-md-n-1 {
    margin-right: 0.25rem !important;
  }
  .mb-md-n-1,
  .my-md-n-1 {
    margin-bottom: 0.25rem !important;
  }
  .ml-md-n-1,
  .mx-md-n-1 {
    margin-left: 0.25rem !important;
  }
  .m-md-n6 {
    margin: -4.5rem !important;
  }
  .mt-md-n6,
  .my-md-n6 {
    margin-top: -4.5rem !important;
  }
  .mr-md-n6,
  .mx-md-n6 {
    margin-right: -4.5rem !important;
  }
  .mb-md-n6,
  .my-md-n6 {
    margin-bottom: -4.5rem !important;
  }
  .ml-md-n6,
  .mx-md-n6 {
    margin-left: -4.5rem !important;
  }
  .m-md-n7 {
    margin: -6rem !important;
  }
  .mt-md-n7,
  .my-md-n7 {
    margin-top: -6rem !important;
  }
  .mr-md-n7,
  .mx-md-n7 {
    margin-right: -6rem !important;
  }
  .mb-md-n7,
  .my-md-n7 {
    margin-bottom: -6rem !important;
  }
  .ml-md-n7,
  .mx-md-n7 {
    margin-left: -6rem !important;
  }
  .m-md-n8 {
    margin: -8rem !important;
  }
  .mt-md-n8,
  .my-md-n8 {
    margin-top: -8rem !important;
  }
  .mr-md-n8,
  .mx-md-n8 {
    margin-right: -8rem !important;
  }
  .mb-md-n8,
  .my-md-n8 {
    margin-bottom: -8rem !important;
  }
  .ml-md-n8,
  .mx-md-n8 {
    margin-left: -8rem !important;
  }
  .m-md-n9 {
    margin: -10rem !important;
  }
  .mt-md-n9,
  .my-md-n9 {
    margin-top: -10rem !important;
  }
  .mr-md-n9,
  .mx-md-n9 {
    margin-right: -10rem !important;
  }
  .mb-md-n9,
  .my-md-n9 {
    margin-bottom: -10rem !important;
  }
  .ml-md-n9,
  .mx-md-n9 {
    margin-left: -10rem !important;
  }
  .m-md-auto {
    margin: auto !important;
  }
  .mt-md-auto,
  .my-md-auto {
    margin-top: auto !important;
  }
  .mr-md-auto,
  .mx-md-auto {
    margin-right: auto !important;
  }
  .mb-md-auto,
  .my-md-auto {
    margin-bottom: auto !important;
  }
  .ml-md-auto,
  .mx-md-auto {
    margin-left: auto !important;
  }
}
@media (min-width: 992px) {
  .m-lg-0 {
    margin: 0 !important;
  }
  .mt-lg-0,
  .my-lg-0 {
    margin-top: 0 !important;
  }
  .mr-lg-0,
  .mx-lg-0 {
    margin-right: 0 !important;
  }
  .mb-lg-0,
  .my-lg-0 {
    margin-bottom: 0 !important;
  }
  .ml-lg-0,
  .mx-lg-0 {
    margin-left: 0 !important;
  }
  .m-lg-1 {
    margin: 0.25rem !important;
  }
  .mt-lg-1,
  .my-lg-1 {
    margin-top: 0.25rem !important;
  }
  .mr-lg-1,
  .mx-lg-1 {
    margin-right: 0.25rem !important;
  }
  .mb-lg-1,
  .my-lg-1 {
    margin-bottom: 0.25rem !important;
  }
  .ml-lg-1,
  .mx-lg-1 {
    margin-left: 0.25rem !important;
  }
  .m-lg-2 {
    margin: 0.5rem !important;
  }
  .mt-lg-2,
  .my-lg-2 {
    margin-top: 0.5rem !important;
  }
  .mr-lg-2,
  .mx-lg-2 {
    margin-right: 0.5rem !important;
  }
  .mb-lg-2,
  .my-lg-2 {
    margin-bottom: 0.5rem !important;
  }
  .ml-lg-2,
  .mx-lg-2 {
    margin-left: 0.5rem !important;
  }
  .m-lg-3 {
    margin: 1rem !important;
  }
  .mt-lg-3,
  .my-lg-3 {
    margin-top: 1rem !important;
  }
  .mr-lg-3,
  .mx-lg-3 {
    margin-right: 1rem !important;
  }
  .mb-lg-3,
  .my-lg-3 {
    margin-bottom: 1rem !important;
  }
  .ml-lg-3,
  .mx-lg-3 {
    margin-left: 1rem !important;
  }
  .m-lg-4 {
    margin: 1.5rem !important;
  }
  .mt-lg-4,
  .my-lg-4 {
    margin-top: 1.5rem !important;
  }
  .mr-lg-4,
  .mx-lg-4 {
    margin-right: 1.5rem !important;
  }
  .mb-lg-4,
  .my-lg-4 {
    margin-bottom: 1.5rem !important;
  }
  .ml-lg-4,
  .mx-lg-4 {
    margin-left: 1.5rem !important;
  }
  .m-lg-5 {
    margin: 3rem !important;
  }
  .mt-lg-5,
  .my-lg-5 {
    margin-top: 3rem !important;
  }
  .mr-lg-5,
  .mx-lg-5 {
    margin-right: 3rem !important;
  }
  .mb-lg-5,
  .my-lg-5 {
    margin-bottom: 3rem !important;
  }
  .ml-lg-5,
  .mx-lg-5 {
    margin-left: 3rem !important;
  }
  .m-lg--9 {
    margin: -10rem !important;
  }
  .mt-lg--9,
  .my-lg--9 {
    margin-top: -10rem !important;
  }
  .mr-lg--9,
  .mx-lg--9 {
    margin-right: -10rem !important;
  }
  .mb-lg--9,
  .my-lg--9 {
    margin-bottom: -10rem !important;
  }
  .ml-lg--9,
  .mx-lg--9 {
    margin-left: -10rem !important;
  }
  .m-lg--8 {
    margin: -8rem !important;
  }
  .mt-lg--8,
  .my-lg--8 {
    margin-top: -8rem !important;
  }
  .mr-lg--8,
  .mx-lg--8 {
    margin-right: -8rem !important;
  }
  .mb-lg--8,
  .my-lg--8 {
    margin-bottom: -8rem !important;
  }
  .ml-lg--8,
  .mx-lg--8 {
    margin-left: -8rem !important;
  }
  .m-lg--7 {
    margin: -6rem !important;
  }
  .mt-lg--7,
  .my-lg--7 {
    margin-top: -6rem !important;
  }
  .mr-lg--7,
  .mx-lg--7 {
    margin-right: -6rem !important;
  }
  .mb-lg--7,
  .my-lg--7 {
    margin-bottom: -6rem !important;
  }
  .ml-lg--7,
  .mx-lg--7 {
    margin-left: -6rem !important;
  }
  .m-lg--6 {
    margin: -4.5rem !important;
  }
  .mt-lg--6,
  .my-lg--6 {
    margin-top: -4.5rem !important;
  }
  .mr-lg--6,
  .mx-lg--6 {
    margin-right: -4.5rem !important;
  }
  .mb-lg--6,
  .my-lg--6 {
    margin-bottom: -4.5rem !important;
  }
  .ml-lg--6,
  .mx-lg--6 {
    margin-left: -4.5rem !important;
  }
  .m-lg--5 {
    margin: -3rem !important;
  }
  .mt-lg--5,
  .my-lg--5 {
    margin-top: -3rem !important;
  }
  .mr-lg--5,
  .mx-lg--5 {
    margin-right: -3rem !important;
  }
  .mb-lg--5,
  .my-lg--5 {
    margin-bottom: -3rem !important;
  }
  .ml-lg--5,
  .mx-lg--5 {
    margin-left: -3rem !important;
  }
  .m-lg--4 {
    margin: -1.5rem !important;
  }
  .mt-lg--4,
  .my-lg--4 {
    margin-top: -1.5rem !important;
  }
  .mr-lg--4,
  .mx-lg--4 {
    margin-right: -1.5rem !important;
  }
  .mb-lg--4,
  .my-lg--4 {
    margin-bottom: -1.5rem !important;
  }
  .ml-lg--4,
  .mx-lg--4 {
    margin-left: -1.5rem !important;
  }
  .m-lg--3 {
    margin: -1rem !important;
  }
  .mt-lg--3,
  .my-lg--3 {
    margin-top: -1rem !important;
  }
  .mr-lg--3,
  .mx-lg--3 {
    margin-right: -1rem !important;
  }
  .mb-lg--3,
  .my-lg--3 {
    margin-bottom: -1rem !important;
  }
  .ml-lg--3,
  .mx-lg--3 {
    margin-left: -1rem !important;
  }
  .m-lg--2 {
    margin: -0.5rem !important;
  }
  .mt-lg--2,
  .my-lg--2 {
    margin-top: -0.5rem !important;
  }
  .mr-lg--2,
  .mx-lg--2 {
    margin-right: -0.5rem !important;
  }
  .mb-lg--2,
  .my-lg--2 {
    margin-bottom: -0.5rem !important;
  }
  .ml-lg--2,
  .mx-lg--2 {
    margin-left: -0.5rem !important;
  }
  .m-lg--1 {
    margin: -0.25rem !important;
  }
  .mt-lg--1,
  .my-lg--1 {
    margin-top: -0.25rem !important;
  }
  .mr-lg--1,
  .mx-lg--1 {
    margin-right: -0.25rem !important;
  }
  .mb-lg--1,
  .my-lg--1 {
    margin-bottom: -0.25rem !important;
  }
  .ml-lg--1,
  .mx-lg--1 {
    margin-left: -0.25rem !important;
  }
  .m-lg-6 {
    margin: 4.5rem !important;
  }
  .mt-lg-6,
  .my-lg-6 {
    margin-top: 4.5rem !important;
  }
  .mr-lg-6,
  .mx-lg-6 {
    margin-right: 4.5rem !important;
  }
  .mb-lg-6,
  .my-lg-6 {
    margin-bottom: 4.5rem !important;
  }
  .ml-lg-6,
  .mx-lg-6 {
    margin-left: 4.5rem !important;
  }
  .m-lg-7 {
    margin: 6rem !important;
  }
  .mt-lg-7,
  .my-lg-7 {
    margin-top: 6rem !important;
  }
  .mr-lg-7,
  .mx-lg-7 {
    margin-right: 6rem !important;
  }
  .mb-lg-7,
  .my-lg-7 {
    margin-bottom: 6rem !important;
  }
  .ml-lg-7,
  .mx-lg-7 {
    margin-left: 6rem !important;
  }
  .m-lg-8 {
    margin: 8rem !important;
  }
  .mt-lg-8,
  .my-lg-8 {
    margin-top: 8rem !important;
  }
  .mr-lg-8,
  .mx-lg-8 {
    margin-right: 8rem !important;
  }
  .mb-lg-8,
  .my-lg-8 {
    margin-bottom: 8rem !important;
  }
  .ml-lg-8,
  .mx-lg-8 {
    margin-left: 8rem !important;
  }
  .m-lg-9 {
    margin: 10rem !important;
  }
  .mt-lg-9,
  .my-lg-9 {
    margin-top: 10rem !important;
  }
  .mr-lg-9,
  .mx-lg-9 {
    margin-right: 10rem !important;
  }
  .mb-lg-9,
  .my-lg-9 {
    margin-bottom: 10rem !important;
  }
  .ml-lg-9,
  .mx-lg-9 {
    margin-left: 10rem !important;
  }
  .p-lg-0 {
    padding: 0 !important;
  }
  .pt-lg-0,
  .py-lg-0 {
    padding-top: 0 !important;
  }
  .pr-lg-0,
  .px-lg-0 {
    padding-right: 0 !important;
  }
  .pb-lg-0,
  .py-lg-0 {
    padding-bottom: 0 !important;
  }
  .pl-lg-0,
  .px-lg-0 {
    padding-left: 0 !important;
  }
  .p-lg-1 {
    padding: 0.25rem !important;
  }
  .pt-lg-1,
  .py-lg-1 {
    padding-top: 0.25rem !important;
  }
  .pr-lg-1,
  .px-lg-1 {
    padding-right: 0.25rem !important;
  }
  .pb-lg-1,
  .py-lg-1 {
    padding-bottom: 0.25rem !important;
  }
  .pl-lg-1,
  .px-lg-1 {
    padding-left: 0.25rem !important;
  }
  .p-lg-2 {
    padding: 0.5rem !important;
  }
  .pt-lg-2,
  .py-lg-2 {
    padding-top: 0.5rem !important;
  }
  .pr-lg-2,
  .px-lg-2 {
    padding-right: 0.5rem !important;
  }
  .pb-lg-2,
  .py-lg-2 {
    padding-bottom: 0.5rem !important;
  }
  .pl-lg-2,
  .px-lg-2 {
    padding-left: 0.5rem !important;
  }
  .p-lg-3 {
    padding: 1rem !important;
  }
  .pt-lg-3,
  .py-lg-3 {
    padding-top: 1rem !important;
  }
  .pr-lg-3,
  .px-lg-3 {
    padding-right: 1rem !important;
  }
  .pb-lg-3,
  .py-lg-3 {
    padding-bottom: 1rem !important;
  }
  .pl-lg-3,
  .px-lg-3 {
    padding-left: 1rem !important;
  }
  .p-lg-4 {
    padding: 1.5rem !important;
  }
  .pt-lg-4,
  .py-lg-4 {
    padding-top: 1.5rem !important;
  }
  .pr-lg-4,
  .px-lg-4 {
    padding-right: 1.5rem !important;
  }
  .pb-lg-4,
  .py-lg-4 {
    padding-bottom: 1.5rem !important;
  }
  .pl-lg-4,
  .px-lg-4 {
    padding-left: 1.5rem !important;
  }
  .p-lg-5 {
    padding: 3rem !important;
  }
  .pt-lg-5,
  .py-lg-5 {
    padding-top: 3rem !important;
  }
  .pr-lg-5,
  .px-lg-5 {
    padding-right: 3rem !important;
  }
  .pb-lg-5,
  .py-lg-5 {
    padding-bottom: 3rem !important;
  }
  .pl-lg-5,
  .px-lg-5 {
    padding-left: 3rem !important;
  }
  .p-lg--9 {
    padding: -10rem !important;
  }
  .pt-lg--9,
  .py-lg--9 {
    padding-top: -10rem !important;
  }
  .pr-lg--9,
  .px-lg--9 {
    padding-right: -10rem !important;
  }
  .pb-lg--9,
  .py-lg--9 {
    padding-bottom: -10rem !important;
  }
  .pl-lg--9,
  .px-lg--9 {
    padding-left: -10rem !important;
  }
  .p-lg--8 {
    padding: -8rem !important;
  }
  .pt-lg--8,
  .py-lg--8 {
    padding-top: -8rem !important;
  }
  .pr-lg--8,
  .px-lg--8 {
    padding-right: -8rem !important;
  }
  .pb-lg--8,
  .py-lg--8 {
    padding-bottom: -8rem !important;
  }
  .pl-lg--8,
  .px-lg--8 {
    padding-left: -8rem !important;
  }
  .p-lg--7 {
    padding: -6rem !important;
  }
  .pt-lg--7,
  .py-lg--7 {
    padding-top: -6rem !important;
  }
  .pr-lg--7,
  .px-lg--7 {
    padding-right: -6rem !important;
  }
  .pb-lg--7,
  .py-lg--7 {
    padding-bottom: -6rem !important;
  }
  .pl-lg--7,
  .px-lg--7 {
    padding-left: -6rem !important;
  }
  .p-lg--6 {
    padding: -4.5rem !important;
  }
  .pt-lg--6,
  .py-lg--6 {
    padding-top: -4.5rem !important;
  }
  .pr-lg--6,
  .px-lg--6 {
    padding-right: -4.5rem !important;
  }
  .pb-lg--6,
  .py-lg--6 {
    padding-bottom: -4.5rem !important;
  }
  .pl-lg--6,
  .px-lg--6 {
    padding-left: -4.5rem !important;
  }
  .p-lg--5 {
    padding: -3rem !important;
  }
  .pt-lg--5,
  .py-lg--5 {
    padding-top: -3rem !important;
  }
  .pr-lg--5,
  .px-lg--5 {
    padding-right: -3rem !important;
  }
  .pb-lg--5,
  .py-lg--5 {
    padding-bottom: -3rem !important;
  }
  .pl-lg--5,
  .px-lg--5 {
    padding-left: -3rem !important;
  }
  .p-lg--4 {
    padding: -1.5rem !important;
  }
  .pt-lg--4,
  .py-lg--4 {
    padding-top: -1.5rem !important;
  }
  .pr-lg--4,
  .px-lg--4 {
    padding-right: -1.5rem !important;
  }
  .pb-lg--4,
  .py-lg--4 {
    padding-bottom: -1.5rem !important;
  }
  .pl-lg--4,
  .px-lg--4 {
    padding-left: -1.5rem !important;
  }
  .p-lg--3 {
    padding: -1rem !important;
  }
  .pt-lg--3,
  .py-lg--3 {
    padding-top: -1rem !important;
  }
  .pr-lg--3,
  .px-lg--3 {
    padding-right: -1rem !important;
  }
  .pb-lg--3,
  .py-lg--3 {
    padding-bottom: -1rem !important;
  }
  .pl-lg--3,
  .px-lg--3 {
    padding-left: -1rem !important;
  }
  .p-lg--2 {
    padding: -0.5rem !important;
  }
  .pt-lg--2,
  .py-lg--2 {
    padding-top: -0.5rem !important;
  }
  .pr-lg--2,
  .px-lg--2 {
    padding-right: -0.5rem !important;
  }
  .pb-lg--2,
  .py-lg--2 {
    padding-bottom: -0.5rem !important;
  }
  .pl-lg--2,
  .px-lg--2 {
    padding-left: -0.5rem !important;
  }
  .p-lg--1 {
    padding: -0.25rem !important;
  }
  .pt-lg--1,
  .py-lg--1 {
    padding-top: -0.25rem !important;
  }
  .pr-lg--1,
  .px-lg--1 {
    padding-right: -0.25rem !important;
  }
  .pb-lg--1,
  .py-lg--1 {
    padding-bottom: -0.25rem !important;
  }
  .pl-lg--1,
  .px-lg--1 {
    padding-left: -0.25rem !important;
  }
  .p-lg-6 {
    padding: 4.5rem !important;
  }
  .pt-lg-6,
  .py-lg-6 {
    padding-top: 4.5rem !important;
  }
  .pr-lg-6,
  .px-lg-6 {
    padding-right: 4.5rem !important;
  }
  .pb-lg-6,
  .py-lg-6 {
    padding-bottom: 4.5rem !important;
  }
  .pl-lg-6,
  .px-lg-6 {
    padding-left: 4.5rem !important;
  }
  .p-lg-7 {
    padding: 6rem !important;
  }
  .pt-lg-7,
  .py-lg-7 {
    padding-top: 6rem !important;
  }
  .pr-lg-7,
  .px-lg-7 {
    padding-right: 6rem !important;
  }
  .pb-lg-7,
  .py-lg-7 {
    padding-bottom: 6rem !important;
  }
  .pl-lg-7,
  .px-lg-7 {
    padding-left: 6rem !important;
  }
  .p-lg-8 {
    padding: 8rem !important;
  }
  .pt-lg-8,
  .py-lg-8 {
    padding-top: 8rem !important;
  }
  .pr-lg-8,
  .px-lg-8 {
    padding-right: 8rem !important;
  }
  .pb-lg-8,
  .py-lg-8 {
    padding-bottom: 8rem !important;
  }
  .pl-lg-8,
  .px-lg-8 {
    padding-left: 8rem !important;
  }
  .p-lg-9 {
    padding: 10rem !important;
  }
  .pt-lg-9,
  .py-lg-9 {
    padding-top: 10rem !important;
  }
  .pr-lg-9,
  .px-lg-9 {
    padding-right: 10rem !important;
  }
  .pb-lg-9,
  .py-lg-9 {
    padding-bottom: 10rem !important;
  }
  .pl-lg-9,
  .px-lg-9 {
    padding-left: 10rem !important;
  }
  .m-lg-n1 {
    margin: -0.25rem !important;
  }
  .mt-lg-n1,
  .my-lg-n1 {
    margin-top: -0.25rem !important;
  }
  .mr-lg-n1,
  .mx-lg-n1 {
    margin-right: -0.25rem !important;
  }
  .mb-lg-n1,
  .my-lg-n1 {
    margin-bottom: -0.25rem !important;
  }
  .ml-lg-n1,
  .mx-lg-n1 {
    margin-left: -0.25rem !important;
  }
  .m-lg-n2 {
    margin: -0.5rem !important;
  }
  .mt-lg-n2,
  .my-lg-n2 {
    margin-top: -0.5rem !important;
  }
  .mr-lg-n2,
  .mx-lg-n2 {
    margin-right: -0.5rem !important;
  }
  .mb-lg-n2,
  .my-lg-n2 {
    margin-bottom: -0.5rem !important;
  }
  .ml-lg-n2,
  .mx-lg-n2 {
    margin-left: -0.5rem !important;
  }
  .m-lg-n3 {
    margin: -1rem !important;
  }
  .mt-lg-n3,
  .my-lg-n3 {
    margin-top: -1rem !important;
  }
  .mr-lg-n3,
  .mx-lg-n3 {
    margin-right: -1rem !important;
  }
  .mb-lg-n3,
  .my-lg-n3 {
    margin-bottom: -1rem !important;
  }
  .ml-lg-n3,
  .mx-lg-n3 {
    margin-left: -1rem !important;
  }
  .m-lg-n4 {
    margin: -1.5rem !important;
  }
  .mt-lg-n4,
  .my-lg-n4 {
    margin-top: -1.5rem !important;
  }
  .mr-lg-n4,
  .mx-lg-n4 {
    margin-right: -1.5rem !important;
  }
  .mb-lg-n4,
  .my-lg-n4 {
    margin-bottom: -1.5rem !important;
  }
  .ml-lg-n4,
  .mx-lg-n4 {
    margin-left: -1.5rem !important;
  }
  .m-lg-n5 {
    margin: -3rem !important;
  }
  .mt-lg-n5,
  .my-lg-n5 {
    margin-top: -3rem !important;
  }
  .mr-lg-n5,
  .mx-lg-n5 {
    margin-right: -3rem !important;
  }
  .mb-lg-n5,
  .my-lg-n5 {
    margin-bottom: -3rem !important;
  }
  .ml-lg-n5,
  .mx-lg-n5 {
    margin-left: -3rem !important;
  }
  .m-lg-n-9 {
    margin: 10rem !important;
  }
  .mt-lg-n-9,
  .my-lg-n-9 {
    margin-top: 10rem !important;
  }
  .mr-lg-n-9,
  .mx-lg-n-9 {
    margin-right: 10rem !important;
  }
  .mb-lg-n-9,
  .my-lg-n-9 {
    margin-bottom: 10rem !important;
  }
  .ml-lg-n-9,
  .mx-lg-n-9 {
    margin-left: 10rem !important;
  }
  .m-lg-n-8 {
    margin: 8rem !important;
  }
  .mt-lg-n-8,
  .my-lg-n-8 {
    margin-top: 8rem !important;
  }
  .mr-lg-n-8,
  .mx-lg-n-8 {
    margin-right: 8rem !important;
  }
  .mb-lg-n-8,
  .my-lg-n-8 {
    margin-bottom: 8rem !important;
  }
  .ml-lg-n-8,
  .mx-lg-n-8 {
    margin-left: 8rem !important;
  }
  .m-lg-n-7 {
    margin: 6rem !important;
  }
  .mt-lg-n-7,
  .my-lg-n-7 {
    margin-top: 6rem !important;
  }
  .mr-lg-n-7,
  .mx-lg-n-7 {
    margin-right: 6rem !important;
  }
  .mb-lg-n-7,
  .my-lg-n-7 {
    margin-bottom: 6rem !important;
  }
  .ml-lg-n-7,
  .mx-lg-n-7 {
    margin-left: 6rem !important;
  }
  .m-lg-n-6 {
    margin: 4.5rem !important;
  }
  .mt-lg-n-6,
  .my-lg-n-6 {
    margin-top: 4.5rem !important;
  }
  .mr-lg-n-6,
  .mx-lg-n-6 {
    margin-right: 4.5rem !important;
  }
  .mb-lg-n-6,
  .my-lg-n-6 {
    margin-bottom: 4.5rem !important;
  }
  .ml-lg-n-6,
  .mx-lg-n-6 {
    margin-left: 4.5rem !important;
  }
  .m-lg-n-5 {
    margin: 3rem !important;
  }
  .mt-lg-n-5,
  .my-lg-n-5 {
    margin-top: 3rem !important;
  }
  .mr-lg-n-5,
  .mx-lg-n-5 {
    margin-right: 3rem !important;
  }
  .mb-lg-n-5,
  .my-lg-n-5 {
    margin-bottom: 3rem !important;
  }
  .ml-lg-n-5,
  .mx-lg-n-5 {
    margin-left: 3rem !important;
  }
  .m-lg-n-4 {
    margin: 1.5rem !important;
  }
  .mt-lg-n-4,
  .my-lg-n-4 {
    margin-top: 1.5rem !important;
  }
  .mr-lg-n-4,
  .mx-lg-n-4 {
    margin-right: 1.5rem !important;
  }
  .mb-lg-n-4,
  .my-lg-n-4 {
    margin-bottom: 1.5rem !important;
  }
  .ml-lg-n-4,
  .mx-lg-n-4 {
    margin-left: 1.5rem !important;
  }
  .m-lg-n-3 {
    margin: 1rem !important;
  }
  .mt-lg-n-3,
  .my-lg-n-3 {
    margin-top: 1rem !important;
  }
  .mr-lg-n-3,
  .mx-lg-n-3 {
    margin-right: 1rem !important;
  }
  .mb-lg-n-3,
  .my-lg-n-3 {
    margin-bottom: 1rem !important;
  }
  .ml-lg-n-3,
  .mx-lg-n-3 {
    margin-left: 1rem !important;
  }
  .m-lg-n-2 {
    margin: 0.5rem !important;
  }
  .mt-lg-n-2,
  .my-lg-n-2 {
    margin-top: 0.5rem !important;
  }
  .mr-lg-n-2,
  .mx-lg-n-2 {
    margin-right: 0.5rem !important;
  }
  .mb-lg-n-2,
  .my-lg-n-2 {
    margin-bottom: 0.5rem !important;
  }
  .ml-lg-n-2,
  .mx-lg-n-2 {
    margin-left: 0.5rem !important;
  }
  .m-lg-n-1 {
    margin: 0.25rem !important;
  }
  .mt-lg-n-1,
  .my-lg-n-1 {
    margin-top: 0.25rem !important;
  }
  .mr-lg-n-1,
  .mx-lg-n-1 {
    margin-right: 0.25rem !important;
  }
  .mb-lg-n-1,
  .my-lg-n-1 {
    margin-bottom: 0.25rem !important;
  }
  .ml-lg-n-1,
  .mx-lg-n-1 {
    margin-left: 0.25rem !important;
  }
  .m-lg-n6 {
    margin: -4.5rem !important;
  }
  .mt-lg-n6,
  .my-lg-n6 {
    margin-top: -4.5rem !important;
  }
  .mr-lg-n6,
  .mx-lg-n6 {
    margin-right: -4.5rem !important;
  }
  .mb-lg-n6,
  .my-lg-n6 {
    margin-bottom: -4.5rem !important;
  }
  .ml-lg-n6,
  .mx-lg-n6 {
    margin-left: -4.5rem !important;
  }
  .m-lg-n7 {
    margin: -6rem !important;
  }
  .mt-lg-n7,
  .my-lg-n7 {
    margin-top: -6rem !important;
  }
  .mr-lg-n7,
  .mx-lg-n7 {
    margin-right: -6rem !important;
  }
  .mb-lg-n7,
  .my-lg-n7 {
    margin-bottom: -6rem !important;
  }
  .ml-lg-n7,
  .mx-lg-n7 {
    margin-left: -6rem !important;
  }
  .m-lg-n8 {
    margin: -8rem !important;
  }
  .mt-lg-n8,
  .my-lg-n8 {
    margin-top: -8rem !important;
  }
  .mr-lg-n8,
  .mx-lg-n8 {
    margin-right: -8rem !important;
  }
  .mb-lg-n8,
  .my-lg-n8 {
    margin-bottom: -8rem !important;
  }
  .ml-lg-n8,
  .mx-lg-n8 {
    margin-left: -8rem !important;
  }
  .m-lg-n9 {
    margin: -10rem !important;
  }
  .mt-lg-n9,
  .my-lg-n9 {
    margin-top: -10rem !important;
  }
  .mr-lg-n9,
  .mx-lg-n9 {
    margin-right: -10rem !important;
  }
  .mb-lg-n9,
  .my-lg-n9 {
    margin-bottom: -10rem !important;
  }
  .ml-lg-n9,
  .mx-lg-n9 {
    margin-left: -10rem !important;
  }
  .m-lg-auto {
    margin: auto !important;
  }
  .mt-lg-auto,
  .my-lg-auto {
    margin-top: auto !important;
  }
  .mr-lg-auto,
  .mx-lg-auto {
    margin-right: auto !important;
  }
  .mb-lg-auto,
  .my-lg-auto {
    margin-bottom: auto !important;
  }
  .ml-lg-auto,
  .mx-lg-auto {
    margin-left: auto !important;
  }
}
@media (min-width: 1200px) {
  .m-xl-0 {
    margin: 0 !important;
  }
  .mt-xl-0,
  .my-xl-0 {
    margin-top: 0 !important;
  }
  .mr-xl-0,
  .mx-xl-0 {
    margin-right: 0 !important;
  }
  .mb-xl-0,
  .my-xl-0 {
    margin-bottom: 0 !important;
  }
  .ml-xl-0,
  .mx-xl-0 {
    margin-left: 0 !important;
  }
  .m-xl-1 {
    margin: 0.25rem !important;
  }
  .mt-xl-1,
  .my-xl-1 {
    margin-top: 0.25rem !important;
  }
  .mr-xl-1,
  .mx-xl-1 {
    margin-right: 0.25rem !important;
  }
  .mb-xl-1,
  .my-xl-1 {
    margin-bottom: 0.25rem !important;
  }
  .ml-xl-1,
  .mx-xl-1 {
    margin-left: 0.25rem !important;
  }
  .m-xl-2 {
    margin: 0.5rem !important;
  }
  .mt-xl-2,
  .my-xl-2 {
    margin-top: 0.5rem !important;
  }
  .mr-xl-2,
  .mx-xl-2 {
    margin-right: 0.5rem !important;
  }
  .mb-xl-2,
  .my-xl-2 {
    margin-bottom: 0.5rem !important;
  }
  .ml-xl-2,
  .mx-xl-2 {
    margin-left: 0.5rem !important;
  }
  .m-xl-3 {
    margin: 1rem !important;
  }
  .mt-xl-3,
  .my-xl-3 {
    margin-top: 1rem !important;
  }
  .mr-xl-3,
  .mx-xl-3 {
    margin-right: 1rem !important;
  }
  .mb-xl-3,
  .my-xl-3 {
    margin-bottom: 1rem !important;
  }
  .ml-xl-3,
  .mx-xl-3 {
    margin-left: 1rem !important;
  }
  .m-xl-4 {
    margin: 1.5rem !important;
  }
  .mt-xl-4,
  .my-xl-4 {
    margin-top: 1.5rem !important;
  }
  .mr-xl-4,
  .mx-xl-4 {
    margin-right: 1.5rem !important;
  }
  .mb-xl-4,
  .my-xl-4 {
    margin-bottom: 1.5rem !important;
  }
  .ml-xl-4,
  .mx-xl-4 {
    margin-left: 1.5rem !important;
  }
  .m-xl-5 {
    margin: 3rem !important;
  }
  .mt-xl-5,
  .my-xl-5 {
    margin-top: 3rem !important;
  }
  .mr-xl-5,
  .mx-xl-5 {
    margin-right: 3rem !important;
  }
  .mb-xl-5,
  .my-xl-5 {
    margin-bottom: 3rem !important;
  }
  .ml-xl-5,
  .mx-xl-5 {
    margin-left: 3rem !important;
  }
  .m-xl--9 {
    margin: -10rem !important;
  }
  .mt-xl--9,
  .my-xl--9 {
    margin-top: -10rem !important;
  }
  .mr-xl--9,
  .mx-xl--9 {
    margin-right: -10rem !important;
  }
  .mb-xl--9,
  .my-xl--9 {
    margin-bottom: -10rem !important;
  }
  .ml-xl--9,
  .mx-xl--9 {
    margin-left: -10rem !important;
  }
  .m-xl--8 {
    margin: -8rem !important;
  }
  .mt-xl--8,
  .my-xl--8 {
    margin-top: -8rem !important;
  }
  .mr-xl--8,
  .mx-xl--8 {
    margin-right: -8rem !important;
  }
  .mb-xl--8,
  .my-xl--8 {
    margin-bottom: -8rem !important;
  }
  .ml-xl--8,
  .mx-xl--8 {
    margin-left: -8rem !important;
  }
  .m-xl--7 {
    margin: -6rem !important;
  }
  .mt-xl--7,
  .my-xl--7 {
    margin-top: -6rem !important;
  }
  .mr-xl--7,
  .mx-xl--7 {
    margin-right: -6rem !important;
  }
  .mb-xl--7,
  .my-xl--7 {
    margin-bottom: -6rem !important;
  }
  .ml-xl--7,
  .mx-xl--7 {
    margin-left: -6rem !important;
  }
  .m-xl--6 {
    margin: -4.5rem !important;
  }
  .mt-xl--6,
  .my-xl--6 {
    margin-top: -4.5rem !important;
  }
  .mr-xl--6,
  .mx-xl--6 {
    margin-right: -4.5rem !important;
  }
  .mb-xl--6,
  .my-xl--6 {
    margin-bottom: -4.5rem !important;
  }
  .ml-xl--6,
  .mx-xl--6 {
    margin-left: -4.5rem !important;
  }
  .m-xl--5 {
    margin: -3rem !important;
  }
  .mt-xl--5,
  .my-xl--5 {
    margin-top: -3rem !important;
  }
  .mr-xl--5,
  .mx-xl--5 {
    margin-right: -3rem !important;
  }
  .mb-xl--5,
  .my-xl--5 {
    margin-bottom: -3rem !important;
  }
  .ml-xl--5,
  .mx-xl--5 {
    margin-left: -3rem !important;
  }
  .m-xl--4 {
    margin: -1.5rem !important;
  }
  .mt-xl--4,
  .my-xl--4 {
    margin-top: -1.5rem !important;
  }
  .mr-xl--4,
  .mx-xl--4 {
    margin-right: -1.5rem !important;
  }
  .mb-xl--4,
  .my-xl--4 {
    margin-bottom: -1.5rem !important;
  }
  .ml-xl--4,
  .mx-xl--4 {
    margin-left: -1.5rem !important;
  }
  .m-xl--3 {
    margin: -1rem !important;
  }
  .mt-xl--3,
  .my-xl--3 {
    margin-top: -1rem !important;
  }
  .mr-xl--3,
  .mx-xl--3 {
    margin-right: -1rem !important;
  }
  .mb-xl--3,
  .my-xl--3 {
    margin-bottom: -1rem !important;
  }
  .ml-xl--3,
  .mx-xl--3 {
    margin-left: -1rem !important;
  }
  .m-xl--2 {
    margin: -0.5rem !important;
  }
  .mt-xl--2,
  .my-xl--2 {
    margin-top: -0.5rem !important;
  }
  .mr-xl--2,
  .mx-xl--2 {
    margin-right: -0.5rem !important;
  }
  .mb-xl--2,
  .my-xl--2 {
    margin-bottom: -0.5rem !important;
  }
  .ml-xl--2,
  .mx-xl--2 {
    margin-left: -0.5rem !important;
  }
  .m-xl--1 {
    margin: -0.25rem !important;
  }
  .mt-xl--1,
  .my-xl--1 {
    margin-top: -0.25rem !important;
  }
  .mr-xl--1,
  .mx-xl--1 {
    margin-right: -0.25rem !important;
  }
  .mb-xl--1,
  .my-xl--1 {
    margin-bottom: -0.25rem !important;
  }
  .ml-xl--1,
  .mx-xl--1 {
    margin-left: -0.25rem !important;
  }
  .m-xl-6 {
    margin: 4.5rem !important;
  }
  .mt-xl-6,
  .my-xl-6 {
    margin-top: 4.5rem !important;
  }
  .mr-xl-6,
  .mx-xl-6 {
    margin-right: 4.5rem !important;
  }
  .mb-xl-6,
  .my-xl-6 {
    margin-bottom: 4.5rem !important;
  }
  .ml-xl-6,
  .mx-xl-6 {
    margin-left: 4.5rem !important;
  }
  .m-xl-7 {
    margin: 6rem !important;
  }
  .mt-xl-7,
  .my-xl-7 {
    margin-top: 6rem !important;
  }
  .mr-xl-7,
  .mx-xl-7 {
    margin-right: 6rem !important;
  }
  .mb-xl-7,
  .my-xl-7 {
    margin-bottom: 6rem !important;
  }
  .ml-xl-7,
  .mx-xl-7 {
    margin-left: 6rem !important;
  }
  .m-xl-8 {
    margin: 8rem !important;
  }
  .mt-xl-8,
  .my-xl-8 {
    margin-top: 8rem !important;
  }
  .mr-xl-8,
  .mx-xl-8 {
    margin-right: 8rem !important;
  }
  .mb-xl-8,
  .my-xl-8 {
    margin-bottom: 8rem !important;
  }
  .ml-xl-8,
  .mx-xl-8 {
    margin-left: 8rem !important;
  }
  .m-xl-9 {
    margin: 10rem !important;
  }
  .mt-xl-9,
  .my-xl-9 {
    margin-top: 10rem !important;
  }
  .mr-xl-9,
  .mx-xl-9 {
    margin-right: 10rem !important;
  }
  .mb-xl-9,
  .my-xl-9 {
    margin-bottom: 10rem !important;
  }
  .ml-xl-9,
  .mx-xl-9 {
    margin-left: 10rem !important;
  }
  .p-xl-0 {
    padding: 0 !important;
  }
  .pt-xl-0,
  .py-xl-0 {
    padding-top: 0 !important;
  }
  .pr-xl-0,
  .px-xl-0 {
    padding-right: 0 !important;
  }
  .pb-xl-0,
  .py-xl-0 {
    padding-bottom: 0 !important;
  }
  .pl-xl-0,
  .px-xl-0 {
    padding-left: 0 !important;
  }
  .p-xl-1 {
    padding: 0.25rem !important;
  }
  .pt-xl-1,
  .py-xl-1 {
    padding-top: 0.25rem !important;
  }
  .pr-xl-1,
  .px-xl-1 {
    padding-right: 0.25rem !important;
  }
  .pb-xl-1,
  .py-xl-1 {
    padding-bottom: 0.25rem !important;
  }
  .pl-xl-1,
  .px-xl-1 {
    padding-left: 0.25rem !important;
  }
  .p-xl-2 {
    padding: 0.5rem !important;
  }
  .pt-xl-2,
  .py-xl-2 {
    padding-top: 0.5rem !important;
  }
  .pr-xl-2,
  .px-xl-2 {
    padding-right: 0.5rem !important;
  }
  .pb-xl-2,
  .py-xl-2 {
    padding-bottom: 0.5rem !important;
  }
  .pl-xl-2,
  .px-xl-2 {
    padding-left: 0.5rem !important;
  }
  .p-xl-3 {
    padding: 1rem !important;
  }
  .pt-xl-3,
  .py-xl-3 {
    padding-top: 1rem !important;
  }
  .pr-xl-3,
  .px-xl-3 {
    padding-right: 1rem !important;
  }
  .pb-xl-3,
  .py-xl-3 {
    padding-bottom: 1rem !important;
  }
  .pl-xl-3,
  .px-xl-3 {
    padding-left: 1rem !important;
  }
  .p-xl-4 {
    padding: 1.5rem !important;
  }
  .pt-xl-4,
  .py-xl-4 {
    padding-top: 1.5rem !important;
  }
  .pr-xl-4,
  .px-xl-4 {
    padding-right: 1.5rem !important;
  }
  .pb-xl-4,
  .py-xl-4 {
    padding-bottom: 1.5rem !important;
  }
  .pl-xl-4,
  .px-xl-4 {
    padding-left: 1.5rem !important;
  }
  .p-xl-5 {
    padding: 3rem !important;
  }
  .pt-xl-5,
  .py-xl-5 {
    padding-top: 3rem !important;
  }
  .pr-xl-5,
  .px-xl-5 {
    padding-right: 3rem !important;
  }
  .pb-xl-5,
  .py-xl-5 {
    padding-bottom: 3rem !important;
  }
  .pl-xl-5,
  .px-xl-5 {
    padding-left: 3rem !important;
  }
  .p-xl--9 {
    padding: -10rem !important;
  }
  .pt-xl--9,
  .py-xl--9 {
    padding-top: -10rem !important;
  }
  .pr-xl--9,
  .px-xl--9 {
    padding-right: -10rem !important;
  }
  .pb-xl--9,
  .py-xl--9 {
    padding-bottom: -10rem !important;
  }
  .pl-xl--9,
  .px-xl--9 {
    padding-left: -10rem !important;
  }
  .p-xl--8 {
    padding: -8rem !important;
  }
  .pt-xl--8,
  .py-xl--8 {
    padding-top: -8rem !important;
  }
  .pr-xl--8,
  .px-xl--8 {
    padding-right: -8rem !important;
  }
  .pb-xl--8,
  .py-xl--8 {
    padding-bottom: -8rem !important;
  }
  .pl-xl--8,
  .px-xl--8 {
    padding-left: -8rem !important;
  }
  .p-xl--7 {
    padding: -6rem !important;
  }
  .pt-xl--7,
  .py-xl--7 {
    padding-top: -6rem !important;
  }
  .pr-xl--7,
  .px-xl--7 {
    padding-right: -6rem !important;
  }
  .pb-xl--7,
  .py-xl--7 {
    padding-bottom: -6rem !important;
  }
  .pl-xl--7,
  .px-xl--7 {
    padding-left: -6rem !important;
  }
  .p-xl--6 {
    padding: -4.5rem !important;
  }
  .pt-xl--6,
  .py-xl--6 {
    padding-top: -4.5rem !important;
  }
  .pr-xl--6,
  .px-xl--6 {
    padding-right: -4.5rem !important;
  }
  .pb-xl--6,
  .py-xl--6 {
    padding-bottom: -4.5rem !important;
  }
  .pl-xl--6,
  .px-xl--6 {
    padding-left: -4.5rem !important;
  }
  .p-xl--5 {
    padding: -3rem !important;
  }
  .pt-xl--5,
  .py-xl--5 {
    padding-top: -3rem !important;
  }
  .pr-xl--5,
  .px-xl--5 {
    padding-right: -3rem !important;
  }
  .pb-xl--5,
  .py-xl--5 {
    padding-bottom: -3rem !important;
  }
  .pl-xl--5,
  .px-xl--5 {
    padding-left: -3rem !important;
  }
  .p-xl--4 {
    padding: -1.5rem !important;
  }
  .pt-xl--4,
  .py-xl--4 {
    padding-top: -1.5rem !important;
  }
  .pr-xl--4,
  .px-xl--4 {
    padding-right: -1.5rem !important;
  }
  .pb-xl--4,
  .py-xl--4 {
    padding-bottom: -1.5rem !important;
  }
  .pl-xl--4,
  .px-xl--4 {
    padding-left: -1.5rem !important;
  }
  .p-xl--3 {
    padding: -1rem !important;
  }
  .pt-xl--3,
  .py-xl--3 {
    padding-top: -1rem !important;
  }
  .pr-xl--3,
  .px-xl--3 {
    padding-right: -1rem !important;
  }
  .pb-xl--3,
  .py-xl--3 {
    padding-bottom: -1rem !important;
  }
  .pl-xl--3,
  .px-xl--3 {
    padding-left: -1rem !important;
  }
  .p-xl--2 {
    padding: -0.5rem !important;
  }
  .pt-xl--2,
  .py-xl--2 {
    padding-top: -0.5rem !important;
  }
  .pr-xl--2,
  .px-xl--2 {
    padding-right: -0.5rem !important;
  }
  .pb-xl--2,
  .py-xl--2 {
    padding-bottom: -0.5rem !important;
  }
  .pl-xl--2,
  .px-xl--2 {
    padding-left: -0.5rem !important;
  }
  .p-xl--1 {
    padding: -0.25rem !important;
  }
  .pt-xl--1,
  .py-xl--1 {
    padding-top: -0.25rem !important;
  }
  .pr-xl--1,
  .px-xl--1 {
    padding-right: -0.25rem !important;
  }
  .pb-xl--1,
  .py-xl--1 {
    padding-bottom: -0.25rem !important;
  }
  .pl-xl--1,
  .px-xl--1 {
    padding-left: -0.25rem !important;
  }
  .p-xl-6 {
    padding: 4.5rem !important;
  }
  .pt-xl-6,
  .py-xl-6 {
    padding-top: 4.5rem !important;
  }
  .pr-xl-6,
  .px-xl-6 {
    padding-right: 4.5rem !important;
  }
  .pb-xl-6,
  .py-xl-6 {
    padding-bottom: 4.5rem !important;
  }
  .pl-xl-6,
  .px-xl-6 {
    padding-left: 4.5rem !important;
  }
  .p-xl-7 {
    padding: 6rem !important;
  }
  .pt-xl-7,
  .py-xl-7 {
    padding-top: 6rem !important;
  }
  .pr-xl-7,
  .px-xl-7 {
    padding-right: 6rem !important;
  }
  .pb-xl-7,
  .py-xl-7 {
    padding-bottom: 6rem !important;
  }
  .pl-xl-7,
  .px-xl-7 {
    padding-left: 6rem !important;
  }
  .p-xl-8 {
    padding: 8rem !important;
  }
  .pt-xl-8,
  .py-xl-8 {
    padding-top: 8rem !important;
  }
  .pr-xl-8,
  .px-xl-8 {
    padding-right: 8rem !important;
  }
  .pb-xl-8,
  .py-xl-8 {
    padding-bottom: 8rem !important;
  }
  .pl-xl-8,
  .px-xl-8 {
    padding-left: 8rem !important;
  }
  .p-xl-9 {
    padding: 10rem !important;
  }
  .pt-xl-9,
  .py-xl-9 {
    padding-top: 10rem !important;
  }
  .pr-xl-9,
  .px-xl-9 {
    padding-right: 10rem !important;
  }
  .pb-xl-9,
  .py-xl-9 {
    padding-bottom: 10rem !important;
  }
  .pl-xl-9,
  .px-xl-9 {
    padding-left: 10rem !important;
  }
  .m-xl-n1 {
    margin: -0.25rem !important;
  }
  .mt-xl-n1,
  .my-xl-n1 {
    margin-top: -0.25rem !important;
  }
  .mr-xl-n1,
  .mx-xl-n1 {
    margin-right: -0.25rem !important;
  }
  .mb-xl-n1,
  .my-xl-n1 {
    margin-bottom: -0.25rem !important;
  }
  .ml-xl-n1,
  .mx-xl-n1 {
    margin-left: -0.25rem !important;
  }
  .m-xl-n2 {
    margin: -0.5rem !important;
  }
  .mt-xl-n2,
  .my-xl-n2 {
    margin-top: -0.5rem !important;
  }
  .mr-xl-n2,
  .mx-xl-n2 {
    margin-right: -0.5rem !important;
  }
  .mb-xl-n2,
  .my-xl-n2 {
    margin-bottom: -0.5rem !important;
  }
  .ml-xl-n2,
  .mx-xl-n2 {
    margin-left: -0.5rem !important;
  }
  .m-xl-n3 {
    margin: -1rem !important;
  }
  .mt-xl-n3,
  .my-xl-n3 {
    margin-top: -1rem !important;
  }
  .mr-xl-n3,
  .mx-xl-n3 {
    margin-right: -1rem !important;
  }
  .mb-xl-n3,
  .my-xl-n3 {
    margin-bottom: -1rem !important;
  }
  .ml-xl-n3,
  .mx-xl-n3 {
    margin-left: -1rem !important;
  }
  .m-xl-n4 {
    margin: -1.5rem !important;
  }
  .mt-xl-n4,
  .my-xl-n4 {
    margin-top: -1.5rem !important;
  }
  .mr-xl-n4,
  .mx-xl-n4 {
    margin-right: -1.5rem !important;
  }
  .mb-xl-n4,
  .my-xl-n4 {
    margin-bottom: -1.5rem !important;
  }
  .ml-xl-n4,
  .mx-xl-n4 {
    margin-left: -1.5rem !important;
  }
  .m-xl-n5 {
    margin: -3rem !important;
  }
  .mt-xl-n5,
  .my-xl-n5 {
    margin-top: -3rem !important;
  }
  .mr-xl-n5,
  .mx-xl-n5 {
    margin-right: -3rem !important;
  }
  .mb-xl-n5,
  .my-xl-n5 {
    margin-bottom: -3rem !important;
  }
  .ml-xl-n5,
  .mx-xl-n5 {
    margin-left: -3rem !important;
  }
  .m-xl-n-9 {
    margin: 10rem !important;
  }
  .mt-xl-n-9,
  .my-xl-n-9 {
    margin-top: 10rem !important;
  }
  .mr-xl-n-9,
  .mx-xl-n-9 {
    margin-right: 10rem !important;
  }
  .mb-xl-n-9,
  .my-xl-n-9 {
    margin-bottom: 10rem !important;
  }
  .ml-xl-n-9,
  .mx-xl-n-9 {
    margin-left: 10rem !important;
  }
  .m-xl-n-8 {
    margin: 8rem !important;
  }
  .mt-xl-n-8,
  .my-xl-n-8 {
    margin-top: 8rem !important;
  }
  .mr-xl-n-8,
  .mx-xl-n-8 {
    margin-right: 8rem !important;
  }
  .mb-xl-n-8,
  .my-xl-n-8 {
    margin-bottom: 8rem !important;
  }
  .ml-xl-n-8,
  .mx-xl-n-8 {
    margin-left: 8rem !important;
  }
  .m-xl-n-7 {
    margin: 6rem !important;
  }
  .mt-xl-n-7,
  .my-xl-n-7 {
    margin-top: 6rem !important;
  }
  .mr-xl-n-7,
  .mx-xl-n-7 {
    margin-right: 6rem !important;
  }
  .mb-xl-n-7,
  .my-xl-n-7 {
    margin-bottom: 6rem !important;
  }
  .ml-xl-n-7,
  .mx-xl-n-7 {
    margin-left: 6rem !important;
  }
  .m-xl-n-6 {
    margin: 4.5rem !important;
  }
  .mt-xl-n-6,
  .my-xl-n-6 {
    margin-top: 4.5rem !important;
  }
  .mr-xl-n-6,
  .mx-xl-n-6 {
    margin-right: 4.5rem !important;
  }
  .mb-xl-n-6,
  .my-xl-n-6 {
    margin-bottom: 4.5rem !important;
  }
  .ml-xl-n-6,
  .mx-xl-n-6 {
    margin-left: 4.5rem !important;
  }
  .m-xl-n-5 {
    margin: 3rem !important;
  }
  .mt-xl-n-5,
  .my-xl-n-5 {
    margin-top: 3rem !important;
  }
  .mr-xl-n-5,
  .mx-xl-n-5 {
    margin-right: 3rem !important;
  }
  .mb-xl-n-5,
  .my-xl-n-5 {
    margin-bottom: 3rem !important;
  }
  .ml-xl-n-5,
  .mx-xl-n-5 {
    margin-left: 3rem !important;
  }
  .m-xl-n-4 {
    margin: 1.5rem !important;
  }
  .mt-xl-n-4,
  .my-xl-n-4 {
    margin-top: 1.5rem !important;
  }
  .mr-xl-n-4,
  .mx-xl-n-4 {
    margin-right: 1.5rem !important;
  }
  .mb-xl-n-4,
  .my-xl-n-4 {
    margin-bottom: 1.5rem !important;
  }
  .ml-xl-n-4,
  .mx-xl-n-4 {
    margin-left: 1.5rem !important;
  }
  .m-xl-n-3 {
    margin: 1rem !important;
  }
  .mt-xl-n-3,
  .my-xl-n-3 {
    margin-top: 1rem !important;
  }
  .mr-xl-n-3,
  .mx-xl-n-3 {
    margin-right: 1rem !important;
  }
  .mb-xl-n-3,
  .my-xl-n-3 {
    margin-bottom: 1rem !important;
  }
  .ml-xl-n-3,
  .mx-xl-n-3 {
    margin-left: 1rem !important;
  }
  .m-xl-n-2 {
    margin: 0.5rem !important;
  }
  .mt-xl-n-2,
  .my-xl-n-2 {
    margin-top: 0.5rem !important;
  }
  .mr-xl-n-2,
  .mx-xl-n-2 {
    margin-right: 0.5rem !important;
  }
  .mb-xl-n-2,
  .my-xl-n-2 {
    margin-bottom: 0.5rem !important;
  }
  .ml-xl-n-2,
  .mx-xl-n-2 {
    margin-left: 0.5rem !important;
  }
  .m-xl-n-1 {
    margin: 0.25rem !important;
  }
  .mt-xl-n-1,
  .my-xl-n-1 {
    margin-top: 0.25rem !important;
  }
  .mr-xl-n-1,
  .mx-xl-n-1 {
    margin-right: 0.25rem !important;
  }
  .mb-xl-n-1,
  .my-xl-n-1 {
    margin-bottom: 0.25rem !important;
  }
  .ml-xl-n-1,
  .mx-xl-n-1 {
    margin-left: 0.25rem !important;
  }
  .m-xl-n6 {
    margin: -4.5rem !important;
  }
  .mt-xl-n6,
  .my-xl-n6 {
    margin-top: -4.5rem !important;
  }
  .mr-xl-n6,
  .mx-xl-n6 {
    margin-right: -4.5rem !important;
  }
  .mb-xl-n6,
  .my-xl-n6 {
    margin-bottom: -4.5rem !important;
  }
  .ml-xl-n6,
  .mx-xl-n6 {
    margin-left: -4.5rem !important;
  }
  .m-xl-n7 {
    margin: -6rem !important;
  }
  .mt-xl-n7,
  .my-xl-n7 {
    margin-top: -6rem !important;
  }
  .mr-xl-n7,
  .mx-xl-n7 {
    margin-right: -6rem !important;
  }
  .mb-xl-n7,
  .my-xl-n7 {
    margin-bottom: -6rem !important;
  }
  .ml-xl-n7,
  .mx-xl-n7 {
    margin-left: -6rem !important;
  }
  .m-xl-n8 {
    margin: -8rem !important;
  }
  .mt-xl-n8,
  .my-xl-n8 {
    margin-top: -8rem !important;
  }
  .mr-xl-n8,
  .mx-xl-n8 {
    margin-right: -8rem !important;
  }
  .mb-xl-n8,
  .my-xl-n8 {
    margin-bottom: -8rem !important;
  }
  .ml-xl-n8,
  .mx-xl-n8 {
    margin-left: -8rem !important;
  }
  .m-xl-n9 {
    margin: -10rem !important;
  }
  .mt-xl-n9,
  .my-xl-n9 {
    margin-top: -10rem !important;
  }
  .mr-xl-n9,
  .mx-xl-n9 {
    margin-right: -10rem !important;
  }
  .mb-xl-n9,
  .my-xl-n9 {
    margin-bottom: -10rem !important;
  }
  .ml-xl-n9,
  .mx-xl-n9 {
    margin-left: -10rem !important;
  }
  .m-xl-auto {
    margin: auto !important;
  }
  .mt-xl-auto,
  .my-xl-auto {
    margin-top: auto !important;
  }
  .mr-xl-auto,
  .mx-xl-auto {
    margin-right: auto !important;
  }
  .mb-xl-auto,
  .my-xl-auto {
    margin-bottom: auto !important;
  }
  .ml-xl-auto,
  .mx-xl-auto {
    margin-left: auto !important;
  }
}
.stretched-link::after {
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  z-index: 1;
  pointer-events: auto;
  content: "";
  background-color: rgba(0, 0, 0, 0);
}

.text-monospace {
  font-family: SFMono-Regular, Menlo, Monaco, Consolas, "Liberation Mono", "Courier New", monospace !important;
}

.text-justify {
  text-align: justify !important;
}

.text-wrap {
  white-space: normal !important;
}

.text-nowrap {
  white-space: nowrap !important;
}

.text-truncate {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.text-left {
  text-align: left !important;
}

.text-right {
  text-align: right !important;
}

.text-center {
  text-align: center !important;
}

@media (min-width: 576px) {
  .text-sm-left {
    text-align: left !important;
  }
  .text-sm-right {
    text-align: right !important;
  }
  .text-sm-center {
    text-align: center !important;
  }
}
@media (min-width: 768px) {
  .text-md-left {
    text-align: left !important;
  }
  .text-md-right {
    text-align: right !important;
  }
  .text-md-center {
    text-align: center !important;
  }
}
@media (min-width: 992px) {
  .text-lg-left {
    text-align: left !important;
  }
  .text-lg-right {
    text-align: right !important;
  }
  .text-lg-center {
    text-align: center !important;
  }
}
@media (min-width: 1200px) {
  .text-xl-left {
    text-align: left !important;
  }
  .text-xl-right {
    text-align: right !important;
  }
  .text-xl-center {
    text-align: center !important;
  }
}
.text-lowercase {
  text-transform: lowercase !important;
}

.text-uppercase {
  text-transform: uppercase !important;
}

.text-capitalize {
  text-transform: capitalize !important;
}

.font-weight-light {
  font-weight: 300 !important;
}

.font-weight-lighter {
  font-weight: lighter !important;
}

.font-weight-normal {
  font-weight: 400 !important;
}

.font-weight-bold {
  font-weight: 600 !important;
}

.font-weight-bolder {
  font-weight: bolder !important;
}

.font-italic {
  font-style: italic !important;
}

.text-white {
  color: #fff !important;
}

.text-primary {
  color: #3ba371 !important;
}

a.text-primary:hover, a.text-primary:focus {
  color: rgb(38.6689189189, 106.8310810811, 74.0608108108) !important;
}

.text-secondary {
  color: #f7fafc !important;
}

a.text-secondary:hover, a.text-secondary:focus {
  color: rgb(191.3636363636, 215.2272727273, 231.1363636364) !important;
}

.text-success {
  color: #3aa170 !important;
}

a.text-success:hover, a.text-success:focus {
  color: rgb(37.7397260274, 104.7602739726, 72.8767123288) !important;
}

.text-info {
  color: #278e69 !important;
}

a.text-info:hover, a.text-info:focus {
  color: rgb(22.5165745856, 81.9834254144, 60.6215469613) !important;
}

.text-warning {
  color: #fb6340 !important;
}

a.text-warning:hover, a.text-warning:focus {
  color: rgb(233.6076923077, 47.7, 4.8923076923) !important;
}

.text-danger {
  color: #f5365c !important;
}

a.text-danger:hover, a.text-danger:focus {
  color: rgb(211.9549763033, 10.5450236967, 50.6161137441) !important;
}

.text-light {
  color: #adb5bd !important;
}

a.text-light:hover, a.text-light:focus {
  color: rgb(130.6148648649, 142.75, 154.8851351351) !important;
}

.text-dark {
  color: #212529 !important;
}

a.text-dark:hover, a.text-dark:focus {
  color: black !important;
}

.text-default {
  color: #ffd88c !important;
}

a.text-default:hover, a.text-default:focus {
  color: rgb(255, 190.0565217391, 63.5) !important;
}

.text-white {
  color: #fff !important;
}

a.text-white:hover, a.text-white:focus {
  color: rgb(216.75, 216.75, 216.75) !important;
}

.text-neutral {
  color: #fff !important;
}

a.text-neutral:hover, a.text-neutral:focus {
  color: rgb(216.75, 216.75, 216.75) !important;
}

.text-darker {
  color: black !important;
}

a.text-darker:hover, a.text-darker:focus {
  color: black !important;
}

.text-body {
  color: #525f7f !important;
}

.text-muted {
  color: #8898aa !important;
}

.text-black-50 {
  color: rgba(0, 0, 0, 0.5) !important;
}

.text-white-50 {
  color: rgba(255, 255, 255, 0.5) !important;
}

.text-hide {
  font: 0/0 a;
  color: transparent;
  text-shadow: none;
  background-color: transparent;
  border: 0;
}

.text-decoration-none {
  text-decoration: none !important;
}

.text-break {
  word-break: break-word !important;
  word-wrap: break-word !important;
}

.text-reset {
  color: inherit !important;
}

.visible {
  visibility: visible !important;
}

.invisible {
  visibility: hidden !important;
}

@media print {
  *,
  *::before,
  *::after {
    text-shadow: none !important;
    box-shadow: none !important;
  }
  a:not(.btn) {
    text-decoration: underline;
  }
  abbr[title]::after {
    content: " (" attr(title) ")";
  }
  pre {
    white-space: pre-wrap !important;
  }
  pre,
  blockquote {
    border: 1px solid #adb5bd;
    page-break-inside: avoid;
  }
  thead {
    display: table-header-group;
  }
  tr,
  img {
    page-break-inside: avoid;
  }
  p,
  h2,
  h3 {
    orphans: 3;
    widows: 3;
  }
  h2,
  h3 {
    page-break-after: avoid;
  }
  @page {
    size: a3;
  }
  body {
    min-width: 992px !important;
  }
  .container {
    min-width: 992px !important;
  }
  .navbar {
    display: none;
  }
  .badge {
    border: 1px solid #000;
  }
  .table {
    border-collapse: collapse !important;
  }
  .table td,
  .table th {
    background-color: #fff !important;
  }
  .table-bordered th,
  .table-bordered td {
    border: 1px solid #dee2e6 !important;
  }
  .table-dark {
    color: inherit;
  }
  .table-dark th,
  .table-dark td,
  .table-dark thead th,
  .table-dark tbody + tbody {
    border-color: #e9ecef;
  }
  .table .thead-dark th {
    color: inherit;
    border-color: #e9ecef;
  }
}
iframe {
  border: 0;
}

figcaption,
figure,
main {
  display: block;
}

main {
  overflow: hidden;
}

.bg-blue {
  background-color: #3ba371 !important;
}

a.bg-blue:hover, a.bg-blue:focus,
button.bg-blue:hover,
button.bg-blue:focus {
  background-color: rgb(45.4459459459, 125.5540540541, 87.0405405405) !important;
}

.bg-indigo {
  background-color: #5603ad !important;
}

a.bg-indigo:hover, a.bg-indigo:focus,
button.bg-indigo:hover,
button.bg-indigo:focus {
  background-color: rgb(61.0795454545, 2.1306818182, 122.8693181818) !important;
}

.bg-purple {
  background-color: #8965e0 !important;
}

a.bg-purple:hover, a.bg-purple:focus,
button.bg-purple:hover,
button.bg-purple:focus {
  background-color: rgb(104.4702702703, 58.5459459459, 215.4540540541) !important;
}

.bg-pink {
  background-color: #f3a4b5 !important;
}

a.bg-pink:hover, a.bg-pink:focus,
button.bg-pink:hover,
button.bg-pink:focus {
  background-color: rgb(237.0582524272, 118.9417475728, 144.359223301) !important;
}

.bg-red {
  background-color: #f5365c !important;
}

a.bg-red:hover, a.bg-red:focus,
button.bg-red:hover,
button.bg-red:focus {
  background-color: rgb(236.2464454976, 11.7535545024, 56.4170616114) !important;
}

.bg-orange {
  background-color: #fb6340 !important;
}

a.bg-orange:hover, a.bg-orange:focus,
button.bg-orange:hover,
button.bg-orange:focus {
  background-color: rgb(249.9538461538, 58.2, 14.0461538462) !important;
}

.bg-yellow {
  background-color: #ffd600 !important;
}

a.bg-yellow:hover, a.bg-yellow:focus,
button.bg-yellow:hover,
button.bg-yellow:focus {
  background-color: rgb(204, 171.2, 0) !important;
}

.bg-green {
  background-color: #3aa170 !important;
}

a.bg-green:hover, a.bg-green:focus,
button.bg-green:hover,
button.bg-green:focus {
  background-color: rgb(44.4931506849, 123.5068493151, 85.9178082192) !important;
}

.bg-teal {
  background-color: #278e69 !important;
}

a.bg-teal:hover, a.bg-teal:focus,
button.bg-teal:hover,
button.bg-teal:focus {
  background-color: rgb(28.0110497238, 101.9889502762, 75.4143646409) !important;
}

.bg-cyan {
  background-color: #2bffc6 !important;
}

a.bg-cyan:hover, a.bg-cyan:focus,
button.bg-cyan:hover,
button.bg-cyan:focus {
  background-color: rgb(0, 247, 180.5896226415) !important;
}

.bg-white {
  background-color: #fff !important;
}

a.bg-white:hover, a.bg-white:focus,
button.bg-white:hover,
button.bg-white:focus {
  background-color: rgb(229.5, 229.5, 229.5) !important;
}

.bg-gray {
  background-color: #8898aa !important;
}

a.bg-gray:hover, a.bg-gray:focus,
button.bg-gray:hover,
button.bg-gray:focus {
  background-color: rgb(106.25, 126.25, 148.75) !important;
}

.bg-gray-dark {
  background-color: #32325d !important;
}

a.bg-gray-dark:hover, a.bg-gray-dark:focus,
button.bg-gray-dark:hover,
button.bg-gray-dark:focus {
  background-color: rgb(32.1678321678, 32.1678321678, 59.8321678322) !important;
}

.bg-light {
  background-color: #ced4da !important;
}

a.bg-light:hover, a.bg-light:focus,
button.bg-light:hover,
button.bg-light:focus {
  background-color: rgb(176.9418604651, 186.5, 196.0581395349) !important;
}

.bg-lighter {
  background-color: #e9ecef !important;
}

a.bg-lighter:hover, a.bg-lighter:focus,
button.bg-lighter:hover,
button.bg-lighter:focus {
  background-color: rgb(203.4736842105, 210.5, 217.5263157895) !important;
}

.bg-gradient-primary {
  background: linear-gradient(87deg, #3ba371 0, #3ba371 100%) !important;
}

.bg-gradient-secondary {
  background: linear-gradient(87deg, #f7fafc 0, #f7fafc 100%) !important;
}

.bg-gradient-success {
  background: linear-gradient(87deg, #3aa170 0, #3aa170 100%) !important;
}

.bg-gradient-info {
  background: linear-gradient(87deg, #278e69 0, #278e69 100%) !important;
}

.bg-gradient-warning {
  background: linear-gradient(87deg, #fb6340 0, #fb6340 100%) !important;
}

.bg-gradient-danger {
  background: linear-gradient(87deg, #f5365c 0, #f5365c 100%) !important;
}

.bg-gradient-light {
  background: linear-gradient(87deg, #adb5bd 0, #adb5bd 100%) !important;
}

.bg-gradient-dark {
  background: linear-gradient(87deg, #212529 0, #212529 100%) !important;
}

.bg-gradient-default {
  background: linear-gradient(87deg, #ffd88c 0, #ffd88c 100%) !important;
}

.bg-gradient-white {
  background: linear-gradient(87deg, #fff 0, white 100%) !important;
}

.bg-gradient-neutral {
  background: linear-gradient(87deg, #fff 0, white 100%) !important;
}

.bg-gradient-darker {
  background: linear-gradient(87deg, black 0, black 100%) !important;
}

.bg-gradient-blue {
  background: linear-gradient(87deg, #3ba371 0, #3ba371 100%) !important;
}

.bg-gradient-indigo {
  background: linear-gradient(87deg, #5603ad 0, #5603ad 100%) !important;
}

.bg-gradient-purple {
  background: linear-gradient(87deg, #8965e0 0, #8965e0 100%) !important;
}

.bg-gradient-pink {
  background: linear-gradient(87deg, #f3a4b5 0, #f3a4b5 100%) !important;
}

.bg-gradient-red {
  background: linear-gradient(87deg, #f5365c 0, #f5365c 100%) !important;
}

.bg-gradient-orange {
  background: linear-gradient(87deg, #fb6340 0, #fb6340 100%) !important;
}

.bg-gradient-yellow {
  background: linear-gradient(87deg, #ffd600 0, #ffd600 100%) !important;
}

.bg-gradient-green {
  background: linear-gradient(87deg, #3aa170 0, #3aa170 100%) !important;
}

.bg-gradient-teal {
  background: linear-gradient(87deg, #278e69 0, #278e69 100%) !important;
}

.bg-gradient-cyan {
  background: linear-gradient(87deg, #2bffc6 0, #2bffc6 100%) !important;
}

.bg-gradient-white {
  background: linear-gradient(87deg, #fff 0, white 100%) !important;
}

.bg-gradient-gray {
  background: linear-gradient(87deg, #8898aa 0, #8898aa 100%) !important;
}

.bg-gradient-gray-dark {
  background: linear-gradient(87deg, #32325d 0, #32325d 100%) !important;
}

.bg-gradient-light {
  background: linear-gradient(87deg, #ced4da 0, #ced4da 100%) !important;
}

.bg-gradient-lighter {
  background: linear-gradient(87deg, #e9ecef 0, #e9ecef 100%) !important;
}

.bg-translucent-primary {
  fill: #3ba371 !important;
}

.bg-translucent-secondary {
  fill: #f7fafc !important;
}

.bg-translucent-success {
  fill: #3aa170 !important;
}

.bg-translucent-info {
  fill: #278e69 !important;
}

.bg-translucent-warning {
  fill: #fb6340 !important;
}

.bg-translucent-danger {
  fill: #f5365c !important;
}

.bg-translucent-light {
  fill: #adb5bd !important;
}

.bg-translucent-dark {
  fill: #212529 !important;
}

.bg-translucent-default {
  fill: #ffd88c !important;
}

.bg-translucent-white {
  fill: #fff !important;
}

.bg-translucent-neutral {
  fill: #fff !important;
}

.bg-translucent-darker {
  fill: black !important;
}

.section-primary {
  background-color: #f8f9fe !important;
}

a.section-primary:hover, a.section-primary:focus,
button.section-primary:hover,
button.section-primary:focus {
  background-color: rgb(203.375, 210.75, 247.625) !important;
}

.section-secondary {
  background-color: #f7fafc !important;
}

a.section-secondary:hover, a.section-secondary:focus,
button.section-secondary:hover,
button.section-secondary:focus {
  background-color: rgb(209.9090909091, 226.8181818182, 238.0909090909) !important;
}

.section-light {
  background-color: #ced4da !important;
}

a.section-light:hover, a.section-light:focus,
button.section-light:hover,
button.section-light:focus {
  background-color: rgb(176.9418604651, 186.5, 196.0581395349) !important;
}

.section-dark {
  background-color: #212529 !important;
}

a.section-dark:hover, a.section-dark:focus,
button.section-dark:hover,
button.section-dark:focus {
  background-color: rgb(10.2567567568, 11.5, 12.7432432432) !important;
}

.section-darker {
  background-color: black !important;
}

a.section-darker:hover, a.section-darker:focus,
button.section-darker:hover,
button.section-darker:focus {
  background-color: black !important;
}

.bg-gradient-primary {
  background: linear-gradient(87deg, #3ba371 0, #3ba371 100%) !important;
}

.bg-gradient-secondary {
  background: linear-gradient(87deg, #f7fafc 0, #f7fafc 100%) !important;
}

.bg-gradient-success {
  background: linear-gradient(87deg, #3aa170 0, #3aa170 100%) !important;
}

.bg-gradient-info {
  background: linear-gradient(87deg, #278e69 0, #278e69 100%) !important;
}

.bg-gradient-warning {
  background: linear-gradient(87deg, #fb6340 0, #fb6340 100%) !important;
}

.bg-gradient-danger {
  background: linear-gradient(87deg, #f5365c 0, #f5365c 100%) !important;
}

.bg-gradient-light {
  background: linear-gradient(87deg, #adb5bd 0, #adb5bd 100%) !important;
}

.bg-gradient-dark {
  background: linear-gradient(87deg, #212529 0, #212529 100%) !important;
}

.bg-gradient-default {
  background: linear-gradient(87deg, #ffd88c 0, #ffd88c 100%) !important;
}

.bg-gradient-white {
  background: linear-gradient(87deg, #fff 0, white 100%) !important;
}

.bg-gradient-neutral {
  background: linear-gradient(87deg, #fff 0, white 100%) !important;
}

.bg-gradient-darker {
  background: linear-gradient(87deg, black 0, black 100%) !important;
}

.fill-primary {
  fill: #3ba371;
}

.stroke-primary {
  stroke: #3ba371;
}

.fill-secondary {
  fill: #f7fafc;
}

.stroke-secondary {
  stroke: #f7fafc;
}

.fill-success {
  fill: #3aa170;
}

.stroke-success {
  stroke: #3aa170;
}

.fill-info {
  fill: #278e69;
}

.stroke-info {
  stroke: #278e69;
}

.fill-warning {
  fill: #fb6340;
}

.stroke-warning {
  stroke: #fb6340;
}

.fill-danger {
  fill: #f5365c;
}

.stroke-danger {
  stroke: #f5365c;
}

.fill-light {
  fill: #adb5bd;
}

.stroke-light {
  stroke: #adb5bd;
}

.fill-dark {
  fill: #212529;
}

.stroke-dark {
  stroke: #212529;
}

.fill-default {
  fill: #ffd88c;
}

.stroke-default {
  stroke: #ffd88c;
}

.fill-white {
  fill: #fff;
}

.stroke-white {
  stroke: #fff;
}

.fill-neutral {
  fill: #fff;
}

.stroke-neutral {
  stroke: #fff;
}

.fill-darker {
  fill: black;
}

.stroke-darker {
  stroke: black;
}

.fill-opacity-8 {
  fill-opacity: 0.8;
}

.floating {
  animation: floating 3s ease infinite;
  will-change: transform;
}
.floating:hover {
  animation-play-state: paused;
}

.floating-lg {
  animation: floating-lg 3s ease infinite;
}

.floating-sm {
  animation: floating-sm 3s ease infinite;
}

@keyframes floating-lg {
  0% {
    transform: translateY(0px);
  }
  50% {
    transform: translateY(15px);
  }
  100% {
    transform: translateY(0px);
  }
}
@keyframes floating {
  0% {
    transform: translateY(0px);
  }
  50% {
    transform: translateY(10px);
  }
  100% {
    transform: translateY(0px);
  }
}
@keyframes floating-sm {
  0% {
    transform: translateY(0px);
  }
  50% {
    transform: translateY(5px);
  }
  100% {
    transform: translateY(0px);
  }
}
.floatfix:before, .floatfix:after {
  content: "";
  display: table;
}
.floatfix:after {
  clear: both;
}

.img-center {
  display: block;
  margin-left: auto;
  margin-right: auto;
}

.opacity-1 {
  opacity: 0.1 !important;
}

.opacity-2 {
  opacity: 0.2 !important;
}

.opacity-3 {
  opacity: 0.3 !important;
}

.opacity-4 {
  opacity: 0.4 !important;
}

.opacity-5 {
  opacity: 0.5 !important;
}

.opacity-6 {
  opacity: 0.6 !important;
}

.opacity-7 {
  opacity: 0.7 !important;
}

.opacity-8 {
  opacity: 0.8 !important;
}

.opacity-8 {
  opacity: 0.9 !important;
}

.opacity-10 {
  opacity: 1 !important;
}

.overflow-visible {
  overflow: visible !important;
}

.overflow-hidden {
  overflow: hidden !important;
}

.top-0 {
  top: 0;
}

.right-0 {
  right: 0;
}

.bottom-0 {
  bottom: 0;
}

.left-0 {
  left: 0;
}

.top-1 {
  top: 0.25rem;
}

.right-1 {
  right: 0.25rem;
}

.bottom-1 {
  bottom: 0.25rem;
}

.left-1 {
  left: 0.25rem;
}

.top-2 {
  top: 0.5rem;
}

.right-2 {
  right: 0.5rem;
}

.bottom-2 {
  bottom: 0.5rem;
}

.left-2 {
  left: 0.5rem;
}

.top-3 {
  top: 1rem;
}

.right-3 {
  right: 1rem;
}

.bottom-3 {
  bottom: 1rem;
}

.left-3 {
  left: 1rem;
}

.top-4 {
  top: 1.5rem;
}

.right-4 {
  right: 1.5rem;
}

.bottom-4 {
  bottom: 1.5rem;
}

.left-4 {
  left: 1.5rem;
}

.top-5 {
  top: 3rem;
}

.right-5 {
  right: 3rem;
}

.bottom-5 {
  bottom: 3rem;
}

.left-5 {
  left: 3rem;
}

.top--9 {
  top: -10rem;
}

.right--9 {
  right: -10rem;
}

.bottom--9 {
  bottom: -10rem;
}

.left--9 {
  left: -10rem;
}

.top--8 {
  top: -8rem;
}

.right--8 {
  right: -8rem;
}

.bottom--8 {
  bottom: -8rem;
}

.left--8 {
  left: -8rem;
}

.top--7 {
  top: -6rem;
}

.right--7 {
  right: -6rem;
}

.bottom--7 {
  bottom: -6rem;
}

.left--7 {
  left: -6rem;
}

.top--6 {
  top: -4.5rem;
}

.right--6 {
  right: -4.5rem;
}

.bottom--6 {
  bottom: -4.5rem;
}

.left--6 {
  left: -4.5rem;
}

.top--5 {
  top: -3rem;
}

.right--5 {
  right: -3rem;
}

.bottom--5 {
  bottom: -3rem;
}

.left--5 {
  left: -3rem;
}

.top--4 {
  top: -1.5rem;
}

.right--4 {
  right: -1.5rem;
}

.bottom--4 {
  bottom: -1.5rem;
}

.left--4 {
  left: -1.5rem;
}

.top--3 {
  top: -1rem;
}

.right--3 {
  right: -1rem;
}

.bottom--3 {
  bottom: -1rem;
}

.left--3 {
  left: -1rem;
}

.top--2 {
  top: -0.5rem;
}

.right--2 {
  right: -0.5rem;
}

.bottom--2 {
  bottom: -0.5rem;
}

.left--2 {
  left: -0.5rem;
}

.top--1 {
  top: -0.25rem;
}

.right--1 {
  right: -0.25rem;
}

.bottom--1 {
  bottom: -0.25rem;
}

.left--1 {
  left: -0.25rem;
}

.top-6 {
  top: 4.5rem;
}

.right-6 {
  right: 4.5rem;
}

.bottom-6 {
  bottom: 4.5rem;
}

.left-6 {
  left: 4.5rem;
}

.top-7 {
  top: 6rem;
}

.right-7 {
  right: 6rem;
}

.bottom-7 {
  bottom: 6rem;
}

.left-7 {
  left: 6rem;
}

.top-8 {
  top: 8rem;
}

.right-8 {
  right: 8rem;
}

.bottom-8 {
  bottom: 8rem;
}

.left-8 {
  left: 8rem;
}

.top-9 {
  top: 10rem;
}

.right-9 {
  right: 10rem;
}

.bottom-9 {
  bottom: 10rem;
}

.left-9 {
  left: 10rem;
}

.center {
  left: 50%;
  transform: translateX(-50%);
}

.h-100vh {
  height: 100vh !important;
}

.row.row-grid > [class*=col-] + [class*=col-] {
  margin-top: 3rem;
}

@media (min-width: 992px) {
  .row.row-grid > [class*=col-lg-] + [class*=col-lg-] {
    margin-top: 0;
  }
}
@media (min-width: 768px) {
  .row.row-grid > [class*=col-md-] + [class*=col-md-] {
    margin-top: 0;
  }
}
@media (min-width: 576px) {
  .row.row-grid > [class*=col-sm-] + [class*=col-sm-] {
    margin-top: 0;
  }
}
.row-grid + .row-grid {
  margin-top: 3rem;
}

@media (min-width: 992px) {
  .mt--100 {
    margin-top: -100px !important;
  }
  .mr--100 {
    margin-right: -100px !important;
  }
  .mb--100 {
    margin-bottom: -100px !important;
  }
  .ml--100 {
    margin-left: -100px !important;
  }
  .mt--150 {
    margin-top: -150px !important;
  }
  .mb--150 {
    margin-bottom: -150px !important;
  }
  .mt--200 {
    margin-top: -200px !important;
  }
  .mb--200 {
    margin-bottom: -200px !important;
  }
  .mt--300 {
    margin-top: -300px !important;
  }
  .mb--300 {
    margin-bottom: -300px !important;
  }
  .pt-100 {
    padding-top: 100px !important;
  }
  .pb-100 {
    padding-bottom: 100px !important;
  }
  .pt-150 {
    padding-top: 150px !important;
  }
  .pb-150 {
    padding-bottom: 150px !important;
  }
  .pt-200 {
    padding-top: 200px !important;
  }
  .pb-200 {
    padding-bottom: 200px !important;
  }
  .pt-250 {
    padding-top: 250px !important;
  }
  .pb-250 {
    padding-bottom: 250px !important;
  }
  .pt-300 {
    padding-top: 300px !important;
  }
  .pb-300 {
    padding-bottom: 300px !important;
  }
}
[class*=shadow] {
  transition: all 0.15s ease;
}

.shadow-sm--hover:hover {
  box-shadow: 0 0 0.5rem rgba(136, 152, 170, 0.075) !important;
}

.shadow--hover:hover {
  box-shadow: 0 0 2rem 0 rgba(136, 152, 170, 0.15) !important;
}

.shadow-lg--hover:hover {
  box-shadow: 0 0 3rem rgba(136, 152, 170, 0.175) !important;
}

.shadow-none--hover:hover {
  box-shadow: none !important;
}

.font-weight-300 {
  font-weight: 300 !important;
}

.font-weight-400 {
  font-weight: 400 !important;
}

.font-weight-500 {
  font-weight: 500 !important;
}

.font-weight-600 {
  font-weight: 600 !important;
}

.font-weight-700 {
  font-weight: 700 !important;
}

.font-weight-800 {
  font-weight: 800 !important;
}

.font-weight-900 {
  font-weight: 900 !important;
}

.text-underline {
  text-decoration: underline;
}

.text-through {
  text-decoration: line-through;
}

.text-xs {
  font-size: 0.75rem !important;
}

.text-sm {
  font-size: 0.875rem !important;
}

.text-lg {
  font-size: 1.25rem !important;
}

.text-xl {
  font-size: 1.5rem !important;
}

.lh-100 {
  line-height: 1;
}

.lh-110 {
  line-height: 1.1;
}

.lh-120 {
  line-height: 1.2;
}

.lh-130 {
  line-height: 1.3;
}

.lh-140 {
  line-height: 1.4;
}

.lh-150 {
  line-height: 1.5;
}

.lh-160 {
  line-height: 1.6;
}

.lh-170 {
  line-height: 1.7;
}

.lh-180 {
  line-height: 1.8;
}

.ls-1 {
  letter-spacing: 0.0625rem;
}

.ls-15 {
  letter-spacing: 0.09375rem;
}

.ls-2 {
  letter-spacing: 0.125rem;
}

.text-blue {
  color: #3ba371 !important;
}

a.text-blue:hover, a.text-blue:focus {
  color: rgb(38.6689189189, 106.8310810811, 74.0608108108) !important;
}

.text-indigo {
  color: #5603ad !important;
}

a.text-indigo:hover, a.text-indigo:focus {
  color: rgb(48.6193181818, 1.6960227273, 97.8039772727) !important;
}

.text-purple {
  color: #8965e0 !important;
}

a.text-purple:hover, a.text-purple:focus {
  color: rgb(89.9972972973, 41.6405405405, 206.8594594595) !important;
}

.text-pink {
  color: #f3a4b5 !important;
}

a.text-pink:hover, a.text-pink:focus {
  color: rgb(234.0873786408, 96.4126213592, 126.0388349515) !important;
}

.text-red {
  color: #f5365c !important;
}

a.text-red:hover, a.text-red:focus {
  color: rgb(211.9549763033, 10.5450236967, 50.6161137441) !important;
}

.text-orange {
  color: #fb6340 !important;
}

a.text-orange:hover, a.text-orange:focus {
  color: rgb(233.6076923077, 47.7, 4.8923076923) !important;
}

.text-yellow {
  color: #ffd600 !important;
}

a.text-yellow:hover, a.text-yellow:focus {
  color: rgb(178.5, 149.8, 0) !important;
}

.text-green {
  color: #3aa170 !important;
}

a.text-green:hover, a.text-green:focus {
  color: rgb(37.7397260274, 104.7602739726, 72.8767123288) !important;
}

.text-teal {
  color: #278e69 !important;
}

a.text-teal:hover, a.text-teal:focus {
  color: rgb(22.5165745856, 81.9834254144, 60.6215469613) !important;
}

.text-cyan {
  color: #2bffc6 !important;
}

a.text-cyan:hover, a.text-cyan:focus {
  color: rgb(0, 221.5, 161.945754717) !important;
}

.text-white {
  color: #fff !important;
}

a.text-white:hover, a.text-white:focus {
  color: rgb(216.75, 216.75, 216.75) !important;
}

.text-gray {
  color: #8898aa !important;
}

a.text-gray:hover, a.text-gray:focus {
  color: rgb(95.625, 113.625, 133.875) !important;
}

.text-gray-dark {
  color: #32325d !important;
}

a.text-gray-dark:hover, a.text-gray-dark:focus {
  color: rgb(23.2517482517, 23.2517482517, 43.2482517483) !important;
}

.text-light {
  color: #ced4da !important;
}

a.text-light:hover, a.text-light:focus {
  color: rgb(162.4127906977, 173.75, 185.0872093023) !important;
}

.text-lighter {
  color: #e9ecef !important;
}

a.text-lighter:hover, a.text-lighter:focus {
  color: rgb(188.7105263158, 197.75, 206.7894736842) !important;
}

@media (min-width: 992px) {
  .transform-perspective-right {
    transform: scale(1) perspective(1040px) rotateY(-11deg) rotateX(2deg) rotate(2deg);
  }
  .transform-perspective-left {
    transform: scale(1) perspective(2000px) rotateY(11deg) rotateX(2deg) rotate(-2deg);
  }
}
.alert {
  font-size: 0.875rem;
}

.alert-heading {
  font-weight: 600;
  font-size: 0.9375rem;
  margin-top: 0.15rem;
}

.alert-icon {
  font-size: 1.25rem;
  margin-right: 1.25rem;
  display: inline-block;
  vertical-align: middle;
}
.alert-icon i.ni {
  position: relative;
  top: 1px;
}

.alert-text {
  display: inline-block;
  vertical-align: middle;
}

[class*=alert-] .alert-link {
  color: #fff;
  border-bottom: 1px dotted rgba(255, 255, 255, 0.5);
}

.alert-dismissible .close {
  top: 50%;
  right: 1.5rem;
  padding: 0;
  transform: translateY(-50%);
  color: rgba(255, 255, 255, 0.6);
  opacity: 1;
}
.alert-dismissible .close:hover, .alert-dismissible .close:focus {
  color: rgba(255, 255, 255, 0.9);
  opacity: 1 !important;
}
@media (max-width: 575.98px) {
  .alert-dismissible .close {
    top: 1rem;
    right: 0.5rem;
  }
}
.alert-dismissible .close > span:not(.sr-only) {
  font-size: 1.5rem;
  background-color: transparent;
  color: rgba(255, 255, 255, 0.6);
}
.alert-dismissible .close:hover > span:not(.sr-only), .alert-dismissible .close:focus > span:not(.sr-only) {
  background-color: transparent;
  color: rgba(255, 255, 255, 0.9);
}

.avatar {
  width: 34px;
  height: 34px;
  border-radius: 50%;
  border: 2px solid #42826c;
  overflow: hidden;
}
.avatar img {
  width: 100%;
  height: 100%;
}

.badge {
  text-transform: uppercase;
}
.badge a {
  color: #fff;
}

.badge-md {
  padding: 0.65em 1em;
}

.badge-lg {
  padding: 0.85em 1.375em;
}

.badge-inline {
  margin-right: 0.625rem;
}
.badge-inline + span {
  top: 2px;
  position: relative;
}
.badge-inline + span > a {
  text-decoration: underline;
}

.btn .badge:not(:first-child) {
  margin-left: 0.5rem;
}
.btn .badge:not(:last-child) {
  margin-right: 0.5rem;
}

.badge-circle {
  text-align: center;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  border-radius: 50%;
  width: 2rem;
  height: 2rem;
  font-size: 0.875rem;
}

.badge-dot {
  padding-left: 0;
  padding-right: 0;
  background: transparent;
  font-weight: 400;
  font-size: 0.875rem;
  text-transform: none;
}
.badge-dot strong {
  color: #32325d;
}
.badge-dot i {
  display: inline-block;
  vertical-align: middle;
  width: 0.375rem;
  height: 0.375rem;
  border-radius: 50%;
  margin-right: 0.375rem;
}
.badge-dot.badge-md i {
  width: 0.5rem;
  height: 0.5rem;
}
.badge-dot.badge-lg i {
  width: 0.625rem;
  height: 0.625rem;
}

.btn {
  position: relative;
  text-transform: none;
  transition: all 0.15s ease;
  letter-spacing: 0.025em;
  font-size: 0.875rem;
  will-change: transform;
}
.btn:hover {
  box-shadow: 0 7px 14px rgba(50, 50, 93, 0.1), 0 3px 6px rgba(0, 0, 0, 0.08);
}
.btn:not(:last-child) {
  margin-right: 0.5rem;
}
.btn i:not(:first-child),
.btn svg:not(:first-child) {
  margin-left: 0.5rem;
}
.btn i:not(:last-child),
.btn svg:not(:last-child) {
  margin-right: 0.5rem;
}

.btn-group .btn,
.input-group .btn {
  margin-right: 0;
  transform: translateY(0);
}

.btn-sm, .btn-group-sm > .btn {
  font-size: 0.75rem;
}

.btn-lg, .btn-group-lg > .btn {
  font-size: 0.875rem;
}

[class*=btn-outline-] {
  border-width: 1px;
}

.btn-outline-secondary {
  color: rgb(66.5454545455, 133.0909090909, 177.4545454545);
}

.btn-inner--icon i:not(.fa) {
  position: relative;
  top: 2px;
}

.btn-link {
  font-weight: 600;
  box-shadow: none;
}
.btn-link:hover {
  box-shadow: none;
  transform: none;
}

.btn-neutral {
  color: #3ba371;
}

.btn-icon .btn-inner--icon img {
  width: 20px;
}
.btn-icon .btn-inner--text:not(:first-child) {
  margin-left: 0.75em;
}
.btn-icon .btn-inner--text:not(:last-child) {
  margin-right: 0.75em;
}

.btn-icon-only {
  width: 2.375rem;
  height: 2.375rem;
  padding: 0;
}

a.btn-icon-only {
  line-height: 2.5;
}

.btn-icon-only.btn-sm, .btn-group-sm > .btn-icon-only.btn {
  width: 2rem;
  height: 2rem;
}

.btn-icon-clipboard {
  margin: 0;
  padding: 1.5rem;
  font-size: 1rem;
  font-weight: 400;
  line-height: 1.25;
  color: #32325d;
  background-color: #f6f9fc;
  border-radius: 0.375rem;
  border: 0;
  text-align: left;
  font-family: inherit;
  display: inline-block;
  vertical-align: middle;
  text-decoration: none;
  -moz-appearance: none;
  cursor: pointer;
  width: 100%;
  margin: 0.5rem 0;
}
.btn-icon-clipboard:hover {
  background-color: #fff;
  box-shadow: rgba(0, 0, 0, 0.1) 0 0 0 1px, rgba(0, 0, 0, 0.1) 0 4px 16px;
}
.btn-icon-clipboard > div {
  align-items: center;
  display: flex;
}
.btn-icon-clipboard i {
  box-sizing: content-box;
  color: #3ba371;
  vertical-align: middle;
  font-size: 1.5rem;
}
.btn-icon-clipboard span {
  display: inline-block;
  font-size: 0.875rem;
  line-height: 1.5;
  margin-left: 16px;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
  vertical-align: middle;
}

.btn-facebook {
  color: #fff;
  background-color: #3b5999;
  border-color: #3b5999;
  box-shadow: 0 4px 6px rgba(50, 50, 93, 0.11), 0 1px 3px rgba(0, 0, 0, 0.08);
}
.btn-facebook:hover {
  color: #fff;
  background-color: #3b5999;
  border-color: #3b5999;
}
.btn-facebook:focus, .btn-facebook.focus {
  box-shadow: 0 4px 6px rgba(50, 50, 93, 0.11), 0 1px 3px rgba(0, 0, 0, 0.08), 0 0 0 0 rgba(59, 89, 153, 0.5);
}
.btn-facebook.disabled, .btn-facebook:disabled {
  color: #fff;
  background-color: #3b5999;
  border-color: #3b5999;
}
.btn-facebook:not(:disabled):not(.disabled):active, .btn-facebook:not(:disabled):not(.disabled).active, .show > .btn-facebook.dropdown-toggle {
  color: #fff;
  background-color: rgb(44.8066037736, 67.5896226415, 116.1933962264);
  border-color: #3b5999;
}
.btn-facebook:not(:disabled):not(.disabled):active:focus, .btn-facebook:not(:disabled):not(.disabled).active:focus, .show > .btn-facebook.dropdown-toggle:focus {
  box-shadow: none, 0 0 0 0 rgba(59, 89, 153, 0.5);
}

.btn-twitter {
  color: #fff;
  background-color: #1da1f2;
  border-color: #1da1f2;
  box-shadow: 0 4px 6px rgba(50, 50, 93, 0.11), 0 1px 3px rgba(0, 0, 0, 0.08);
}
.btn-twitter:hover {
  color: #fff;
  background-color: #1da1f2;
  border-color: #1da1f2;
}
.btn-twitter:focus, .btn-twitter.focus {
  box-shadow: 0 4px 6px rgba(50, 50, 93, 0.11), 0 1px 3px rgba(0, 0, 0, 0.08), 0 0 0 0 rgba(29, 161, 242, 0.5);
}
.btn-twitter.disabled, .btn-twitter:disabled {
  color: #fff;
  background-color: #1da1f2;
  border-color: #1da1f2;
}
.btn-twitter:not(:disabled):not(.disabled):active, .btn-twitter:not(:disabled):not(.disabled).active, .show > .btn-twitter.dropdown-toggle {
  color: #fff;
  background-color: rgb(11.9665271967, 133.4728033473, 208.0334728033);
  border-color: #1da1f2;
}
.btn-twitter:not(:disabled):not(.disabled):active:focus, .btn-twitter:not(:disabled):not(.disabled).active:focus, .show > .btn-twitter.dropdown-toggle:focus {
  box-shadow: none, 0 0 0 0 rgba(29, 161, 242, 0.5);
}

.btn-google-plus {
  color: #fff;
  background-color: #dd4b39;
  border-color: #dd4b39;
  box-shadow: 0 4px 6px rgba(50, 50, 93, 0.11), 0 1px 3px rgba(0, 0, 0, 0.08);
}
.btn-google-plus:hover {
  color: #fff;
  background-color: #dd4b39;
  border-color: #dd4b39;
}
.btn-google-plus:focus, .btn-google-plus.focus {
  box-shadow: 0 4px 6px rgba(50, 50, 93, 0.11), 0 1px 3px rgba(0, 0, 0, 0.08), 0 0 0 0 rgba(221, 75, 57, 0.5);
}
.btn-google-plus.disabled, .btn-google-plus:disabled {
  color: #fff;
  background-color: #dd4b39;
  border-color: #dd4b39;
}
.btn-google-plus:not(:disabled):not(.disabled):active, .btn-google-plus:not(:disabled):not(.disabled).active, .show > .btn-google-plus.dropdown-toggle {
  color: #fff;
  background-color: rgb(193.7327586207, 50.8793103448, 33.2672413793);
  border-color: #dd4b39;
}
.btn-google-plus:not(:disabled):not(.disabled):active:focus, .btn-google-plus:not(:disabled):not(.disabled).active:focus, .show > .btn-google-plus.dropdown-toggle:focus {
  box-shadow: none, 0 0 0 0 rgba(221, 75, 57, 0.5);
}

.btn-instagram {
  color: #fff;
  background-color: #e4405f;
  border-color: #e4405f;
  box-shadow: 0 4px 6px rgba(50, 50, 93, 0.11), 0 1px 3px rgba(0, 0, 0, 0.08);
}
.btn-instagram:hover {
  color: #fff;
  background-color: #e4405f;
  border-color: #e4405f;
}
.btn-instagram:focus, .btn-instagram.focus {
  box-shadow: 0 4px 6px rgba(50, 50, 93, 0.11), 0 1px 3px rgba(0, 0, 0, 0.08), 0 0 0 0 rgba(228, 64, 95, 0.5);
}
.btn-instagram.disabled, .btn-instagram:disabled {
  color: #fff;
  background-color: #e4405f;
  border-color: #e4405f;
}
.btn-instagram:not(:disabled):not(.disabled):active, .btn-instagram:not(:disabled):not(.disabled).active, .show > .btn-instagram.dropdown-toggle {
  color: #fff;
  background-color: rgb(211.1513761468, 29.8486238532, 64.119266055);
  border-color: #e4405f;
}
.btn-instagram:not(:disabled):not(.disabled):active:focus, .btn-instagram:not(:disabled):not(.disabled).active:focus, .show > .btn-instagram.dropdown-toggle:focus {
  box-shadow: none, 0 0 0 0 rgba(228, 64, 95, 0.5);
}

.btn-pinterest {
  color: #fff;
  background-color: #bd081c;
  border-color: #bd081c;
  box-shadow: 0 4px 6px rgba(50, 50, 93, 0.11), 0 1px 3px rgba(0, 0, 0, 0.08);
}
.btn-pinterest:hover {
  color: #fff;
  background-color: #bd081c;
  border-color: #bd081c;
}
.btn-pinterest:focus, .btn-pinterest.focus {
  box-shadow: 0 4px 6px rgba(50, 50, 93, 0.11), 0 1px 3px rgba(0, 0, 0, 0.08), 0 0 0 0 rgba(189, 8, 28, 0.5);
}
.btn-pinterest.disabled, .btn-pinterest:disabled {
  color: #fff;
  background-color: #bd081c;
  border-color: #bd081c;
}
.btn-pinterest:not(:disabled):not(.disabled):active, .btn-pinterest:not(:disabled):not(.disabled).active, .show > .btn-pinterest.dropdown-toggle {
  color: #fff;
  background-color: rgb(140.0710659898, 5.9289340102, 20.7512690355);
  border-color: #bd081c;
}
.btn-pinterest:not(:disabled):not(.disabled):active:focus, .btn-pinterest:not(:disabled):not(.disabled).active:focus, .show > .btn-pinterest.dropdown-toggle:focus {
  box-shadow: none, 0 0 0 0 rgba(189, 8, 28, 0.5);
}

.btn-youtube {
  color: #fff;
  background-color: #cd201f;
  border-color: #cd201f;
  box-shadow: 0 4px 6px rgba(50, 50, 93, 0.11), 0 1px 3px rgba(0, 0, 0, 0.08);
}
.btn-youtube:hover {
  color: #fff;
  background-color: #cd201f;
  border-color: #cd201f;
}
.btn-youtube:focus, .btn-youtube.focus {
  box-shadow: 0 4px 6px rgba(50, 50, 93, 0.11), 0 1px 3px rgba(0, 0, 0, 0.08), 0 0 0 0 rgba(205, 32, 31, 0.5);
}
.btn-youtube.disabled, .btn-youtube:disabled {
  color: #fff;
  background-color: #cd201f;
  border-color: #cd201f;
}
.btn-youtube:not(:disabled):not(.disabled):active, .btn-youtube:not(:disabled):not(.disabled).active, .show > .btn-youtube.dropdown-toggle {
  color: #fff;
  background-color: rgb(160.6991525424, 25.0847457627, 24.3008474576);
  border-color: #cd201f;
}
.btn-youtube:not(:disabled):not(.disabled):active:focus, .btn-youtube:not(:disabled):not(.disabled).active:focus, .show > .btn-youtube.dropdown-toggle:focus {
  box-shadow: none, 0 0 0 0 rgba(205, 32, 31, 0.5);
}

.btn-slack {
  color: #fff;
  background-color: #3aaf85;
  border-color: #3aaf85;
  box-shadow: 0 4px 6px rgba(50, 50, 93, 0.11), 0 1px 3px rgba(0, 0, 0, 0.08);
}
.btn-slack:hover {
  color: #fff;
  background-color: #3aaf85;
  border-color: #3aaf85;
}
.btn-slack:focus, .btn-slack.focus {
  box-shadow: 0 4px 6px rgba(50, 50, 93, 0.11), 0 1px 3px rgba(0, 0, 0, 0.08), 0 0 0 0 rgba(58, 175, 133, 0.5);
}
.btn-slack.disabled, .btn-slack:disabled {
  color: #fff;
  background-color: #3aaf85;
  border-color: #3aaf85;
}
.btn-slack:not(:disabled):not(.disabled):active, .btn-slack:not(:disabled):not(.disabled).active, .show > .btn-slack.dropdown-toggle {
  color: #fff;
  background-color: rgb(45.30472103, 136.69527897, 103.8884120172);
  border-color: #3aaf85;
}
.btn-slack:not(:disabled):not(.disabled):active:focus, .btn-slack:not(:disabled):not(.disabled).active:focus, .show > .btn-slack.dropdown-toggle:focus {
  box-shadow: none, 0 0 0 0 rgba(58, 175, 133, 0.5);
}

.btn-dribbble {
  color: #fff;
  background-color: #ea4c89;
  border-color: #ea4c89;
  box-shadow: 0 4px 6px rgba(50, 50, 93, 0.11), 0 1px 3px rgba(0, 0, 0, 0.08);
}
.btn-dribbble:hover {
  color: #fff;
  background-color: #ea4c89;
  border-color: #ea4c89;
}
.btn-dribbble:focus, .btn-dribbble.focus {
  box-shadow: 0 4px 6px rgba(50, 50, 93, 0.11), 0 1px 3px rgba(0, 0, 0, 0.08), 0 0 0 0 rgba(234, 76, 137, 0.5);
}
.btn-dribbble.disabled, .btn-dribbble:disabled {
  color: #fff;
  background-color: #ea4c89;
  border-color: #ea4c89;
}
.btn-dribbble:not(:disabled):not(.disabled):active, .btn-dribbble:not(:disabled):not(.disabled).active, .show > .btn-dribbble.dropdown-toggle {
  color: #fff;
  background-color: rgb(228.645, 30.355, 106.91);
  border-color: #ea4c89;
}
.btn-dribbble:not(:disabled):not(.disabled):active:focus, .btn-dribbble:not(:disabled):not(.disabled).active:focus, .show > .btn-dribbble.dropdown-toggle:focus {
  box-shadow: none, 0 0 0 0 rgba(234, 76, 137, 0.5);
}

.btn-github {
  color: #fff;
  background-color: #222222;
  border-color: #222222;
  box-shadow: 0 4px 6px rgba(50, 50, 93, 0.11), 0 1px 3px rgba(0, 0, 0, 0.08);
}
.btn-github:hover {
  color: #fff;
  background-color: #222222;
  border-color: #222222;
}
.btn-github:focus, .btn-github.focus {
  box-shadow: 0 4px 6px rgba(50, 50, 93, 0.11), 0 1px 3px rgba(0, 0, 0, 0.08), 0 0 0 0 rgba(34, 34, 34, 0.5);
}
.btn-github.disabled, .btn-github:disabled {
  color: #fff;
  background-color: #222222;
  border-color: #222222;
}
.btn-github:not(:disabled):not(.disabled):active, .btn-github:not(:disabled):not(.disabled).active, .show > .btn-github.dropdown-toggle {
  color: #fff;
  background-color: rgb(8.5, 8.5, 8.5);
  border-color: #222222;
}
.btn-github:not(:disabled):not(.disabled):active:focus, .btn-github:not(:disabled):not(.disabled).active:focus, .show > .btn-github.dropdown-toggle:focus {
  box-shadow: none, 0 0 0 0 rgba(34, 34, 34, 0.5);
}

.card-translucent {
  background-color: rgba(18, 91, 152, 0.08);
}

.card-profile-image {
  position: relative;
}
.card-profile-image img {
  max-width: 180px;
  border-radius: 0.375rem;
  transform: translate(-50%, -30%);
  position: absolute;
  left: 50%;
  transition: all 0.15s ease;
}
.card-profile-image img:hover {
  transform: translate(-50%, -33%);
}

.card-profile-stats {
  padding: 1rem 0;
}
.card-profile-stats > div {
  text-align: center;
  margin-right: 1rem;
  padding: 0.875rem;
}
.card-profile-stats > div:last-child {
  margin-right: 0;
}
.card-profile-stats > div .heading {
  font-size: 1.1rem;
  font-weight: bold;
  display: block;
}
.card-profile-stats > div .description {
  font-size: 0.875rem;
  color: #adb5bd;
}

.card-profile-actions {
  padding: 0.875rem;
}

.card-lift--hover:hover {
  transform: translateY(-20px);
  transition: all 0.15s ease;
}
@media (prefers-reduced-motion: reduce) {
  .card-lift--hover:hover {
    transition: none;
  }
}

.card-stats .card-body {
  padding: 1rem 1.5rem;
}
.card-stats .card-status-bullet {
  position: absolute;
  top: 0;
  right: 0;
  transform: translate(50%, -50%);
}

.chart {
  position: relative;
  height: 350px;
}

.chart-sm {
  height: 230px;
}

.chart-legend {
  display: flex;
  justify-content: center;
  margin-top: 2.5rem;
  font-size: 0.875rem;
  text-align: center;
  color: #8898aa;
}

.chart-legend-item {
  display: inline-flex;
  align-items: center;
}
.chart-legend-item + .chart-legend-item {
  margin-left: 1rem;
}

.chart-legend-indicator {
  display: inline-block;
  width: 0.5rem;
  height: 0.5rem;
  margin-right: 0.375rem;
  border-radius: 50%;
}

#chart-tooltip {
  z-index: 0;
}
#chart-tooltip .arrow {
  top: 100%;
  left: 50%;
  transform: translateX(-50%) translateX(-0.5rem);
}

.chart-info-overlay {
  position: absolute;
  top: 0;
  left: 5%;
  max-width: 350px;
  padding: 20px;
  z-index: 1;
}

.close {
  transition: all 0.15s ease;
}
.close > span:not(.sr-only) {
  background-color: transparent;
  color: rgba(0, 0, 0, 0.6);
  line-height: 17px;
  height: 1.25rem;
  width: 1.25rem;
  border-radius: 50%;
  font-size: 1.25rem;
  display: block;
  transition: all 0.15s ease;
}
.close:hover, .close:focus {
  background-color: transparent;
  color: rgba(0, 0, 0, 0.9);
  outline: none;
}
.close:hover span:not(.sr-only), .close:focus span:not(.sr-only) {
  background-color: transparent;
}

.checkbox-design {
  margin: 0 0 5px;
}

.styled-checkbox {
  position: absolute;
  opacity: 0;
}

.styled-checkbox + label {
  position: relative;
  cursor: pointer;
  padding: 0;
}

.styled-checkbox + label:before {
  content: "";
  margin-right: 10px;
  display: inline-block;
  vertical-align: text-top;
  width: 20px;
  height: 20px;
  background: white;
  border: 1px solid gray;
}

.styled-checkbox:hover + label:before {
  background: #f35429;
}

.styled-checkbox:checked + label:before {
  background: #f35429;
}

.styled-checkbox:disabled + label {
  color: #b8b8b8;
  cursor: auto;
}

.styled-checkbox:disabled + label:before {
  box-shadow: none;
  background: #ddd;
}

.styled-checkbox:checked + label:after {
  content: "";
  position: absolute;
  left: 5px;
  top: 9px;
  background: white;
  width: 2px;
  height: 2px;
  box-shadow: 2px 0 0 white, 4px 0 0 white, 4px -2px 0 white, 4px -4px 0 white, 4px -6px 0 white, 4px -8px 0 white;
  transform: rotate(45deg);
}

.main-content {
  position: relative;
  background-color: #fff;
  margin-left: 258px;
}
.main-content .navbar-top {
  position: absolute;
  left: 0;
  top: 0;
  width: 100%;
  z-index: 1;
  background-color: #fff;
  padding-left: 0 !important;
  padding-right: 0 !important;
}
.main-content .navbar-top .page-title {
  font-size: 25px;
  font-weight: 600;
  line-height: 37.5px;
  color: #393939;
}
.main-content .navbar-top .navbar-nav .media p {
  font-size: 13px;
  font-weight: 400;
  line-height: 24px;
  color: #393939;
}
.main-content .dashboard-card-colored {
  width: calc(50% - 30px);
  border-radius: 4px;
  margin-right: 15px;
}
.main-content .dashboard-card-colored a {
  display: block;
  overflow: hidden;
  width: 100%;
}
.main-content .dashboard-card-colored a .card-body {
  width: 100%;
}
.main-content .dashboard-card-colored a .card-body .inner-body {
  width: 100%;
  margin-left: 0;
  margin-right: 0;
}
.main-content .dashboard-card-colored.green {
  background-color: #008983;
}
.main-content .dashboard-card-colored.blue {
  background-color: #0f7db5;
}
.main-content .dashboard-card-colored .card-stats {
  background-color: transparent;
  width: 100%;
  border: 0;
}
.main-content .dashboard-card-colored .card-title {
  font-size: 14px;
  font-weight: 400;
  line-height: 21px;
  color: #fff;
}
.main-content .dashboard-card-colored .large-font {
  font-size: 50px;
  font-weight: 700;
  line-height: 75px;
  color: #fff;
}
.main-content .dashboard-card-colored .icon svg {
  fill: #fff;
  width: 50px;
  height: 50px;
}
.main-content .bordered-box {
  box-shadow: 0px 2px 8px 0px rgba(156, 156, 156, 0.25);
  border-radius: 5px;
  padding-top: 20px;
  padding-bottom: 20px;
  margin-left: 15px;
  width: calc(50% - 30px);
  margin-left: 15px;
  border: 1px solid rgba(156, 156, 156, 0.35);
}
.main-content .bordered-box .card-stats .card-body .card-title {
  font-size: 16px;
  font-weight: 400;
  line-height: 24px;
  color: #393939;
}
.main-content .bordered-box .card-stats .card-body .large-font {
  font-size: 28px;
  font-weight: 700;
  line-height: 42px;
  color: #42826c;
}
.main-content .box-50 {
  width: 50%;
}
.main-content .card {
  border: 0;
}
.main-content .dashboard-title {
  font-size: 25px;
  font-weight: 600;
  line-height: 37.5px;
  color: #393939;
}
@media (min-width: 768px) {
  .main-content .container-fluid, .main-content .container-sm, .main-content .container-md, .main-content .container-lg, .main-content .container-xl {
    padding-left: 27px !important;
    padding-right: 27px !important;
  }
}

.custom-checkbox .custom-control-input ~ .custom-control-label {
  cursor: pointer;
  font-size: 0.875rem;
}
.custom-checkbox .custom-control-input:checked ~ .custom-control-label::before {
  border-color: #3ba371;
}
.custom-checkbox .custom-control-input:checked ~ .custom-control-label::after {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_8___});
}
.custom-checkbox .custom-control-input:disabled ~ .custom-control-label::before {
  border-color: #e9ecef;
}
.custom-checkbox .custom-control-input:disabled:checked::before {
  border-color: rgba(59, 163, 113, 0.5);
}

.custom-control-label::before {
  border: 1px solid #cad1d7;
  transition: all 0.2s cubic-bezier(0.68, -0.55, 0.265, 1.55);
}
.custom-control-label span {
  position: relative;
  top: 2px;
}

.custom-control-label {
  margin-bottom: 0;
}

.custom-control-alternative .custom-control-label::before {
  border: 0;
  box-shadow: 0 1px 3px rgba(50, 50, 93, 0.15), 0 1px 0 rgba(0, 0, 0, 0.02);
}
.custom-control-alternative .custom-control-input:checked ~ .custom-control-label::before {
  box-shadow: 0 4px 6px rgba(50, 50, 93, 0.11), 0 1px 3px rgba(0, 0, 0, 0.08);
}
.custom-control-alternative .custom-control-input:active ~ .custom-control-label::before, .custom-control-alternative .custom-control-input:focus ~ .custom-control-label::before {
  box-shadow: 0 1px 3px rgba(50, 50, 93, 0.15), 0 1px 0 rgba(0, 0, 0, 0.02);
}

.custom-checkbox .custom-control-input ~ .custom-control-label {
  cursor: pointer;
  font-size: 0.875rem;
}
.custom-checkbox .custom-control-input:checked ~ .custom-control-label::before {
  border-color: #3ba371;
}
.custom-checkbox .custom-control-input:checked ~ .custom-control-label::after {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_8___});
}
.custom-checkbox .custom-control-input:disabled ~ .custom-control-label::before {
  border-color: #e9ecef;
}
.custom-checkbox .custom-control-input:disabled:checked::before {
  border-color: rgba(59, 163, 113, 0.5);
}

.custom-radio .custom-control-input ~ .custom-control-label {
  cursor: pointer;
  font-size: 0.875rem;
}
.custom-radio .custom-control-input:checked ~ .custom-control-label::before {
  border-color: #3ba371;
}
.custom-radio .custom-control-input:checked ~ .custom-control-label::after {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_9___});
}
.custom-radio .custom-control-input:disabled ~ .custom-control-label::before {
  border-color: #e9ecef;
}
.custom-radio .custom-control-input:disabled:checked::before {
  border-color: rgba(59, 163, 113, 0.5);
}

.custom-toggle {
  position: relative;
  display: inline-block;
  width: 50px;
  height: 1.5rem;
}
.custom-toggle input {
  display: none;
}
.custom-toggle input:checked + .custom-toggle-slider {
  border: 1px solid #3ba371;
}
.custom-toggle input:checked + .custom-toggle-slider:before {
  background: #3ba371;
  transform: translateX(1.625rem);
}
.custom-toggle input:disabled + .custom-toggle-slider {
  border: 1px solid #e9ecef;
}
.custom-toggle input:disabled:checked + .custom-toggle-slider {
  border: 1px solid #e9ecef;
}
.custom-toggle input:disabled:checked + .custom-toggle-slider:before {
  background-color: rgb(80.9864864865, 192.0135135135, 138.6351351351);
}

.custom-toggle-slider {
  position: absolute;
  cursor: pointer;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  border: 1px solid #cad1d7;
  border-radius: 34px !important;
  background-color: transparent;
}
.custom-toggle-slider:before {
  position: absolute;
  content: "";
  height: 18px;
  width: 18px;
  left: 2px;
  bottom: 2px;
  border-radius: 50% !important;
  background-color: #e9ecef;
  transition: all 0.2s cubic-bezier(0.68, -0.55, 0.265, 1.55);
}

.dropdown,
.dropup,
.dropright,
.dropleft {
  display: inline-block;
}

.dropdown-menu {
  min-width: 12rem;
}
.dropdown-menu .dropdown-item {
  padding: 0.5rem 1rem;
  font-size: 0.875rem;
}
.dropdown-menu .dropdown-item > i,
.dropdown-menu .dropdown-item > svg {
  margin-right: 1rem;
  font-size: 1rem;
  vertical-align: -17%;
}

.dropdown-header {
  padding-left: 1rem;
  padding-right: 1rem;
  color: #f6f9fc;
  font-size: 0.625rem;
  text-transform: uppercase;
  font-weight: 700;
}

.dropdown-menu a.media > div:first-child {
  line-height: 1;
}
.dropdown-menu a.media p {
  color: #8898aa;
}
.dropdown-menu a.media:hover .heading,
.dropdown-menu a.media:hover p {
  color: #ffd88c !important;
}

.dropdown-menu-sm {
  min-width: 100px;
  border: 0.4375rem;
}

.dropdown-menu-lg {
  min-width: 260px;
  border-radius: 0.4375rem;
}

.dropdown-menu-xl {
  min-width: 450px;
  border-radius: 0.4375rem;
}

.footer {
  padding: 2.5rem 0;
}
.footer .col-footer .heading {
  color: #8898aa;
  letter-spacing: 0;
  font-size: 0.875rem;
  text-transform: uppercase;
  font-weight: 600;
  margin-bottom: 1rem;
}
.footer .nav .nav-item .nav-link,
.footer .footer-link {
  color: #8898aa !important;
}
.footer .nav .nav-item .nav-link:hover,
.footer .footer-link:hover {
  color: #525f7f !important;
}
.footer .list-unstyled li a {
  display: inline-block;
  padding: 0.125rem 0;
  color: #8898aa;
  font-size: 0.85rem;
}
.footer .list-unstyled li a:hover {
  color: #525f7f;
}
.footer .copyright {
  font-size: 0.875rem;
}

.footer-dark .col-footer .heading {
  color: #fff;
}

.nav-footer .nav-link {
  font-size: 0.875rem;
}
.nav-footer .nav-item:last-child .nav-link {
  padding-right: 0;
}

.footer.has-cards {
  overflow: hidden;
  padding-top: 500px;
  margin-top: -420px;
  position: relative;
  background: transparent;
  pointer-events: none;
}
.footer.has-cards:before {
  content: "";
  position: absolute;
  left: 0;
  right: 0;
  top: 600px;
  height: 2000px;
  background: #f7fafc;
  transform: skew(0, -8deg);
}
.footer.has-cards .container {
  pointer-events: auto;
  position: relative;
}

.form-control-label {
  color: #525f7f;
  font-size: 0.875rem;
  font-weight: 600;
}

.form-control {
  font-size: 0.875rem;
}
.form-control:focus::placeholder {
  color: #adb5bd;
}

textarea[resize=none] {
  resize: none !important;
}

textarea[resize=both] {
  resize: both !important;
}

textarea[resize=vertical] {
  resize: vertical !important;
}

textarea[resize=horizontal] {
  resize: horizontal !important;
}

.form-control-muted {
  background-color: #f7fafe;
  border-color: #f7fafe;
  box-shadow: none;
}
.form-control-muted:focus {
  background-color: rgb(251.5333333333, 252.8333333333, 254.5666666667);
}

.form-control-alternative {
  box-shadow: 0 1px 3px rgba(50, 50, 93, 0.15), 0 1px 0 rgba(0, 0, 0, 0.02);
  border: 0;
  transition: box-shadow 0.15s ease;
}
.form-control-alternative:focus {
  box-shadow: 0 4px 6px rgba(50, 50, 93, 0.11), 0 1px 3px rgba(0, 0, 0, 0.08);
}

.form-control-lg {
  font-size: 1rem;
}

.has-success,
.has-danger {
  position: relative;
}
.has-success:after,
.has-danger:after {
  width: 19px;
  height: 19px;
  line-height: 19px;
  text-align: center;
  font-family: "NucleoIcons";
  display: inline-block;
  position: absolute;
  right: 15px;
  top: 2px;
  transform: translateY(50%);
  border-radius: 50%;
  font-size: 9px;
  opacity: 1;
}

.has-success:after {
  content: "\\ea26";
  color: daken(#3aa170, 18%);
  background-color: rgb(97.3082191781, 198.1917808219, 150.198630137);
}
.has-success .form-control {
  background-color: #fff;
}
.has-success .form-control:focus {
  border-color: rgba(50, 151, 211, 0.25);
}
.has-success .form-control::placeholder {
  color: #3aa170;
}

.has-danger:after {
  content: "\\ea53";
  color: daken(#fb6340, 18%);
  background-color: rgb(252.5692307692, 160.2, 138.9307692308);
}
.has-danger .form-control {
  background-color: #fff;
}
.has-danger .form-control:focus {
  border-color: rgba(50, 151, 211, 0.25);
}
.has-danger .form-control::placeholder {
  color: #fb6340;
}

.input-group {
  box-shadow: none;
  border-radius: 0.375rem;
  transition: all 0.15s ease;
}
.input-group .form-control {
  box-shadow: none;
}
.input-group .form-control:not(:first-child) {
  border-left: 0;
  padding-left: 0;
}
.input-group .form-control:not(:last-child) {
  border-right: 0;
  padding-right: 0;
}
.input-group .form-control:focus {
  box-shadow: none;
}

.input-group-text {
  transition: all 0.2s cubic-bezier(0.68, -0.55, 0.265, 1.55);
}

.input-group-alternative {
  box-shadow: 0 1px 3px rgba(50, 50, 93, 0.15), 0 1px 0 rgba(0, 0, 0, 0.02);
  border: 0;
  transition: box-shadow 0.15s ease;
}
.input-group-alternative .form-control,
.input-group-alternative .input-group-text {
  border: 0;
  box-shadow: none;
}

.focused .input-group-alternative {
  box-shadow: 0 4px 6px rgba(50, 50, 93, 0.11), 0 1px 3px rgba(0, 0, 0, 0.08) !important;
}

.focused .input-group {
  box-shadow: none;
}
.focused .input-group-text {
  color: #8898aa;
  background-color: #fff;
  border-color: rgba(50, 151, 211, 0.25);
}
.focused .form-control {
  border-color: rgba(50, 151, 211, 0.25);
}

.header {
  position: relative;
}

.icon {
  width: 3rem;
  height: 3rem;
}
.icon i,
.icon svg {
  font-size: 2.25rem;
}
.icon + .icon-text {
  padding-left: 1rem;
  width: calc(100% - 3rem - 1);
}

.icon-xl {
  width: 5rem;
  height: 5rem;
}
.icon-xl i,
.icon-xl svg {
  font-size: 4.25rem;
}
.icon-xl + .icon-text {
  width: calc(100% - 5rem - 1);
}

.icon-lg {
  width: 4rem;
  height: 4rem;
}
.icon-lg i,
.icon-lg svg {
  font-size: 3.25rem;
}
.icon-lg + .icon-text {
  width: calc(100% - 4rem - 1);
}

.icon-sm {
  width: 2rem;
  height: 2rem;
}
.icon-sm i,
.icon-sm svg {
  font-size: 1.25rem;
}
.icon-sm + .icon-text {
  width: calc(100% - 2rem - 1);
}

.icon-shape {
  padding: 12px;
  text-align: center;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  border-radius: 50%;
}
.icon-shape i,
.icon-shape svg {
  font-size: 1.25rem;
}
.icon-shape.icon-lg i,
.icon-shape.icon-lg svg {
  font-size: 1.625rem;
}
.icon-shape.icon-sm i,
.icon-shape.icon-sm svg {
  font-size: 0.875rem;
}
.icon-shape svg {
  width: 30px;
  height: 30px;
}

.icon-shape-primary {
  color: rgb(36.8959459459, 134.1040540541, 87.3693866944);
  background-color: rgba(80.9864864865, 192.0135135135, 138.6351351351, 0.5);
}

.icon-shape-secondary {
  color: rgb(206.8090909091, 227.4381818182, 241.1909090909);
  background-color: rgba(255, 255, 255, 0.5);
}

.icon-shape-success {
  color: rgb(36.0931506849, 131.9068493151, 86.3255752095);
  background-color: rgba(78.5616438356, 191.4383561644, 137.7397260274, 0.5);
}

.icon-shape-info {
  color: rgb(21.5110497238, 108.4889502762, 77.2444617283);
  background-color: rgba(49.9889502762, 182.0110497238, 134.5856353591, 0.5);
}

.icon-shape-warning {
  color: rgb(255, 55.0427807487, 9);
  background-color: rgba(252.0461538462, 139.8, 113.9538461538, 0.5);
}

.icon-shape-danger {
  color: rgb(248, 0, 49.3403141361);
  background-color: rgba(247.4170616114, 102.5829383886, 131.3981042654, 0.5);
}

.icon-shape-light {
  color: rgb(134.7932432432, 155.5, 176.2067567568);
  background-color: rgba(201.2567567568, 206.5, 211.7432432432, 0.5);
}

.icon-shape-dark {
  color: rgb(9.1067567568, 11.5, 13.8932432432);
  background-color: rgba(55.7432432432, 62.5, 69.2567567568, 0.5);
}

.icon-shape-default {
  color: rgb(255, 198.7043478261, 89);
  background-color: rgba(255, 233.2956521739, 191, 0.5);
}

.icon-shape-white {
  color: rgb(232.05, 226.95, 226.95);
  background-color: rgba(255, 255, 255, 0.5);
}

.icon-shape-neutral {
  color: rgb(232.05, 226.95, 226.95);
  background-color: rgba(255, 255, 255, 0.5);
}

.icon-shape-darker {
  color: black;
  background-color: rgba(25.5, 25.5, 25.5, 0.5);
}

.input-group {
  box-shadow: none;
  border-radius: 0.375rem;
  transition: all 0.15s ease;
}
.input-group .form-control {
  box-shadow: none;
}
.input-group .form-control:not(:first-child) {
  border-left: 0;
  padding-left: 0;
}
.input-group .form-control:not(:last-child) {
  border-right: 0;
  padding-right: 0;
}
.input-group .form-control:focus {
  box-shadow: none;
}

.input-group-text {
  transition: all 0.2s cubic-bezier(0.68, -0.55, 0.265, 1.55);
}

.input-group-alternative {
  box-shadow: 0 1px 3px rgba(50, 50, 93, 0.15), 0 1px 0 rgba(0, 0, 0, 0.02);
  border: 0;
  transition: box-shadow 0.15s ease;
}
.input-group-alternative .form-control,
.input-group-alternative .input-group-text {
  border: 0;
  box-shadow: none;
}

.focused .input-group-alternative {
  box-shadow: 0 4px 6px rgba(50, 50, 93, 0.11), 0 1px 3px rgba(0, 0, 0, 0.08) !important;
}

.focused .input-group {
  box-shadow: none;
}
.focused .input-group-text {
  color: #8898aa;
  background-color: #fff;
  border-color: rgba(50, 151, 211, 0.25);
}
.focused .form-control {
  border-color: rgba(50, 151, 211, 0.25);
}

.list-group-space .list-group-item {
  margin-bottom: 1.5rem;
  border-radius: 0.375rem;
}

.list-group-img {
  width: 3rem;
  height: 3rem;
  border-radius: 50%;
  vertical-align: top;
  margin: -0.1rem 1.2rem 0 -0.2rem;
}

.list-group-content {
  flex: 1 1;
  min-width: 0;
}
.list-group-content > p {
  color: #adb5bd;
  line-height: 1.5;
  margin: 0.2rem 0 0;
}

.list-group-heading {
  font-size: 1rem;
  color: #32325d;
}
.list-group-heading > small {
  float: right;
  color: #adb5bd;
  font-weight: 500;
}

.map-canvas {
  position: relative;
  width: 100%;
  height: 500px;
  border-radius: 0.375rem;
}

.mask {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  transition: all 0.15s ease;
}
@media (prefers-reduced-motion: reduce) {
  .mask {
    transition: none;
  }
}

.modal-fluid .modal-dialog {
  margin-top: 0;
  margin-bottom: 0;
}
.modal-fluid .modal-content {
  border-radius: 0;
}

.modal-primary .modal-title {
  color: #fff;
}
.modal-primary .modal-header,
.modal-primary .modal-footer {
  border-color: rgba(255, 255, 255, 0.075);
}
.modal-primary .modal-content {
  background-color: #3ba371;
  color: #fff;
}
.modal-primary .modal-content .heading {
  color: #fff;
}
.modal-primary .close > span:not(.sr-only) {
  color: #fff;
}

.modal-secondary .modal-title {
  color: #212529;
}
.modal-secondary .modal-header,
.modal-secondary .modal-footer {
  border-color: rgba(33, 37, 41, 0.075);
}
.modal-secondary .modal-content {
  background-color: #f7fafc;
  color: #212529;
}
.modal-secondary .modal-content .heading {
  color: #212529;
}
.modal-secondary .close > span:not(.sr-only) {
  color: #fff;
}

.modal-success .modal-title {
  color: #fff;
}
.modal-success .modal-header,
.modal-success .modal-footer {
  border-color: rgba(255, 255, 255, 0.075);
}
.modal-success .modal-content {
  background-color: #3aa170;
  color: #fff;
}
.modal-success .modal-content .heading {
  color: #fff;
}
.modal-success .close > span:not(.sr-only) {
  color: #fff;
}

.modal-info .modal-title {
  color: #fff;
}
.modal-info .modal-header,
.modal-info .modal-footer {
  border-color: rgba(255, 255, 255, 0.075);
}
.modal-info .modal-content {
  background-color: #278e69;
  color: #fff;
}
.modal-info .modal-content .heading {
  color: #fff;
}
.modal-info .close > span:not(.sr-only) {
  color: #fff;
}

.modal-warning .modal-title {
  color: #fff;
}
.modal-warning .modal-header,
.modal-warning .modal-footer {
  border-color: rgba(255, 255, 255, 0.075);
}
.modal-warning .modal-content {
  background-color: #fb6340;
  color: #fff;
}
.modal-warning .modal-content .heading {
  color: #fff;
}
.modal-warning .close > span:not(.sr-only) {
  color: #fff;
}

.modal-danger .modal-title {
  color: #fff;
}
.modal-danger .modal-header,
.modal-danger .modal-footer {
  border-color: rgba(255, 255, 255, 0.075);
}
.modal-danger .modal-content {
  background-color: #f5365c;
  color: #fff;
}
.modal-danger .modal-content .heading {
  color: #fff;
}
.modal-danger .close > span:not(.sr-only) {
  color: #fff;
}

.modal-light .modal-title {
  color: #fff;
}
.modal-light .modal-header,
.modal-light .modal-footer {
  border-color: rgba(255, 255, 255, 0.075);
}
.modal-light .modal-content {
  background-color: #adb5bd;
  color: #fff;
}
.modal-light .modal-content .heading {
  color: #fff;
}
.modal-light .close > span:not(.sr-only) {
  color: #fff;
}

.modal-dark .modal-title {
  color: #fff;
}
.modal-dark .modal-header,
.modal-dark .modal-footer {
  border-color: rgba(255, 255, 255, 0.075);
}
.modal-dark .modal-content {
  background-color: #212529;
  color: #fff;
}
.modal-dark .modal-content .heading {
  color: #fff;
}
.modal-dark .close > span:not(.sr-only) {
  color: #fff;
}

.modal-default .modal-title {
  color: #212529;
}
.modal-default .modal-header,
.modal-default .modal-footer {
  border-color: rgba(33, 37, 41, 0.075);
}
.modal-default .modal-content {
  background-color: #ffd88c;
  color: #212529;
}
.modal-default .modal-content .heading {
  color: #212529;
}
.modal-default .close > span:not(.sr-only) {
  color: #fff;
}

.modal-white .modal-title {
  color: #212529;
}
.modal-white .modal-header,
.modal-white .modal-footer {
  border-color: rgba(33, 37, 41, 0.075);
}
.modal-white .modal-content {
  background-color: #fff;
  color: #212529;
}
.modal-white .modal-content .heading {
  color: #212529;
}
.modal-white .close > span:not(.sr-only) {
  color: #fff;
}

.modal-neutral .modal-title {
  color: #212529;
}
.modal-neutral .modal-header,
.modal-neutral .modal-footer {
  border-color: rgba(33, 37, 41, 0.075);
}
.modal-neutral .modal-content {
  background-color: #fff;
  color: #212529;
}
.modal-neutral .modal-content .heading {
  color: #212529;
}
.modal-neutral .close > span:not(.sr-only) {
  color: #fff;
}

.modal-darker .modal-title {
  color: #fff;
}
.modal-darker .modal-header,
.modal-darker .modal-footer {
  border-color: rgba(255, 255, 255, 0.075);
}
.modal-darker .modal-content {
  background-color: black;
  color: #fff;
}
.modal-darker .modal-content .heading {
  color: #fff;
}
.modal-darker .close > span:not(.sr-only) {
  color: #fff;
}

.nav-wrapper {
  padding: 1rem 0;
  border-top-left-radius: 0.375rem;
  border-top-right-radius: 0.375rem;
}
.nav-wrapper + .card {
  border-top-left-radius: 0;
  border-top-right-radius: 0;
  border-bottom-right-radius: 0.375rem;
  border-bottom-left-radius: 0.375rem;
}

.nav-link {
  color: #525f7f;
}
.nav-link:hover {
  color: #3ba371;
}
.nav-link i.ni {
  position: relative;
  top: 2px;
}

@media (min-width: 992px) {
  .nav-item.active-pro {
    position: absolute;
    width: 100%;
    bottom: 10px;
    background: #f6f9fc;
  }
}
.nav-pills .nav-item:not(:last-child) {
  padding-right: 1rem;
}
.nav-pills .nav-link {
  padding: 0.75rem 1rem;
  color: #3ba371;
  font-weight: 500;
  font-size: 0.875rem;
  box-shadow: 0 4px 6px rgba(50, 50, 93, 0.11), 0 1px 3px rgba(0, 0, 0, 0.08);
  background-color: #fff;
  transition: all 0.15s ease;
}
.nav-pills .nav-link:hover {
  color: rgb(52.222972973, 144.277027027, 100.0202702703);
}
.nav-pills .nav-link.active,
.nav-pills .show > .nav-link {
  color: #fff;
  background-color: #3ba371;
}
@media (max-width: 575.98px) {
  .nav-pills .nav-item {
    margin-bottom: 1rem;
  }
}

@media (max-width: 767.98px) {
  .nav-pills:not(.nav-pills-circle) .nav-item {
    padding-right: 0;
  }
}
.nav-pills-circle .nav-link {
  text-align: center;
  height: 60px;
  width: 60px;
  padding: 0;
  line-height: 60px;
  border-radius: 50%;
}
.nav-pills-circle .nav-link-icon i,
.nav-pills-circle .nav-link-icon svg {
  font-size: 1rem;
}

.navbar-horizontal .navbar-nav .nav-link {
  font-size: 0.9rem;
  font-weight: 400;
  text-transform: normal;
  letter-spacing: 0;
  transition: all 0.15s linear;
}
@media (prefers-reduced-motion: reduce) {
  .navbar-horizontal .navbar-nav .nav-link {
    transition: none;
  }
}
.navbar-horizontal .navbar-nav .nav-link .nav-link-inner--text {
  margin-left: 0.25rem;
}
.navbar-horizontal .navbar-brand {
  font-size: 0.875rem;
  font-weight: 600;
  text-transform: uppercase;
  font-size: 0.875rem;
  letter-spacing: 0.05px;
}
.navbar-horizontal .navbar-brand img {
  height: 30px;
}
.navbar-horizontal .navbar-dark .navbar-brand {
  color: #fff;
}
.navbar-horizontal .navbar-light .navbar-brand {
  color: #32325d;
}
.navbar-horizontal .navbar-nav .nav-item .media:not(:last-child) {
  margin-bottom: 1.5rem;
}
@media (min-width: 992px) {
  .navbar-horizontal .navbar-nav .nav-item {
    margin-right: 0.5rem;
  }
  .navbar-horizontal .navbar-nav .nav-item [data-toggle=dropdown]::after {
    transition: all 0.15s ease;
  }
  .navbar-horizontal .navbar-nav .nav-item.show [data-toggle=dropdown]::after {
    transform: rotate(180deg);
  }
  .navbar-horizontal .navbar-nav .nav-link {
    padding-top: 1rem;
    padding-bottom: 1rem;
    border-radius: 0.375rem;
  }
  .navbar-horizontal .navbar-nav .nav-link i {
    margin-right: 0.625rem;
  }
  .navbar-horizontal .navbar-nav .nav-link-icon {
    padding-left: 0.5rem !important;
    padding-right: 0.5rem !important;
    font-size: 1rem;
    border-radius: 0.375rem;
  }
  .navbar-horizontal .navbar-nav .nav-link-icon i {
    margin-right: 0;
  }
}
.navbar-horizontal .navbar-transparent {
  position: absolute;
  top: 0;
  width: 100%;
  z-index: 100;
  background-color: transparent;
  border: 0;
  box-shadow: none;
}
.navbar-horizontal .navbar-transparent .navbar-brand {
  color: rgb(255, 255, 255);
}
.navbar-horizontal .navbar-transparent .navbar-toggler {
  color: rgb(255, 255, 255);
}
.navbar-horizontal .navbar-transparent .navbar-toggler-icon {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_10___});
}
@media (min-width: 768px) {
  .navbar-horizontal .navbar-transparent .navbar-nav .nav-link {
    color: rgba(255, 255, 255, 0.95);
  }
  .navbar-horizontal .navbar-transparent .navbar-nav .nav-link:hover, .navbar-horizontal .navbar-transparent .navbar-nav .nav-link:focus {
    color: rgba(255, 255, 255, 0.65);
  }
  .navbar-horizontal .navbar-transparent .navbar-nav .nav-link.disabled {
    color: rgba(255, 255, 255, 0.25);
  }
  .navbar-horizontal .navbar-transparent .navbar-nav .show > .nav-link,
  .navbar-horizontal .navbar-transparent .navbar-nav .active > .nav-link,
  .navbar-horizontal .navbar-transparent .navbar-nav .nav-link.show,
  .navbar-horizontal .navbar-transparent .navbar-nav .nav-link.active {
    color: rgba(255, 255, 255, 0.65);
  }
  .navbar-horizontal .navbar-transparent .navbar-brand {
    color: rgba(255, 255, 255, 0.95);
  }
  .navbar-horizontal .navbar-transparent .navbar-brand:hover, .navbar-horizontal .navbar-transparent .navbar-brand:focus {
    color: rgba(255, 255, 255, 0.95);
  }
}

@media (min-width: 768px) {
  .navbar-vertical {
    background-color: #42826c;
    width: 258px;
    position: fixed;
    height: 100vh;
    padding: 0;
    padding-top: 8px;
    overflow-y: hidden;
  }
  .navbar-vertical .navbar-brand {
    margin-right: 0;
    width: 123px;
    display: flex;
    justify-content: center;
    align-items: flex-start;
  }
  .navbar-vertical .navbar-brand img {
    min-height: unset;
    max-width: 123px;
    width: 100%;
    height: auto;
  }
  .navbar-vertical .container-fluid, .navbar-vertical .container-sm, .navbar-vertical .container-md, .navbar-vertical .container-lg, .navbar-vertical .container-xl {
    display: flex;
    flex-direction: column;
    justify-content: center;
    width: 100%;
    height: 100%;
  }
  .navbar-vertical .navbar-collapse {
    flex-direction: column;
    align-items: start;
    width: 100%;
    overflow: scroll;
    padding-bottom: 15px;
  }
  .navbar-vertical .navbar-collapse .navbar-nav {
    padding-bottom: 30px;
    width: 100%;
    padding: 14px 8px;
    font-size: 15px;
    font-weight: 400;
    line-height: 24px;
    color: #fff;
    background-color: transparent;
  }
  .navbar-vertical .navbar-collapse .navbar-nav i {
    color: #fff;
  }
  .navbar-vertical .navbar-collapse .navbar-nav.bg-green-color {
    background-color: #36745e;
  }
  .navbar-vertical .navbar-collapse .navbar-nav.bg-green-color i {
    color: #eed7b9;
  }
}
.navbar-search .input-group {
  border-radius: 2rem;
  border: 2px solid;
  background-color: transparent;
}
.navbar-search .input-group .input-group-text {
  background-color: transparent;
  padding-left: 1rem;
}
.navbar-search .form-control {
  width: 270px;
  background-color: transparent;
}

.navbar-search-dark .input-group {
  border-color: rgba(255, 255, 255, 0.6);
}
.navbar-search-dark .input-group-text {
  color: rgba(255, 255, 255, 0.6);
}
.navbar-search-dark .form-control {
  color: rgba(255, 255, 255, 0.9);
}
.navbar-search-dark .form-control::placeholder {
  color: rgba(255, 255, 255, 0.6);
}
.navbar-search-dark .focused .input-group {
  border-color: rgba(255, 255, 255, 0.9);
}

.navbar-search-light .input-group {
  border-color: rgba(0, 0, 0, 0.6);
}
.navbar-search-light .input-group-text {
  color: rgba(0, 0, 0, 0.6);
}
.navbar-search-light .form-control {
  color: rgba(0, 0, 0, 0.9);
}
.navbar-search-light .form-control::placeholder {
  color: rgba(0, 0, 0, 0.6);
}
.navbar-search-light .focused .input-group {
  border-color: rgba(0, 0, 0, 0.9);
}

@media (min-width: 768px) {
  .navbar .dropdown-menu {
    opacity: 0;
    pointer-events: none;
    margin: 0;
  }
  .navbar .dropdown-menu-arrow:before {
    background: #fff;
    box-shadow: none;
    content: "";
    display: block;
    height: 12px;
    width: 12px;
    right: 20px;
    position: absolute;
    bottom: 100%;
    transform: rotate(-45deg) translateY(12px);
    z-index: -5;
    border-radius: 2px;
  }
  .navbar .dropdown-menu-right:before {
    right: 20px;
    left: auto;
  }
  .navbar:not(.navbar-nav-hover) .dropdown-menu.show {
    opacity: 1;
    pointer-events: auto;
    animation: show-navbar-dropdown 0.25s ease forwards;
  }
  .navbar:not(.navbar-nav-hover) .dropdown-menu.close {
    display: block;
    animation: hide-navbar-dropdown 0.15s ease backwards;
  }
  .navbar.navbar-nav-hover .dropdown-menu {
    opacity: 0;
    display: block;
    pointer-events: none;
    transform: translate(0, 10px) perspective(200px) rotateX(-2deg);
    transition: visibility 0.25s, opacity 0.25s, transform 0.25s;
  }
  .navbar.navbar-nav-hover .nav-item.dropdown:hover > .dropdown-menu {
    display: block;
    opacity: 1;
    pointer-events: auto;
    visibility: visible;
    transform: translate(0, 0);
    animation: none;
  }
  .navbar .dropdown-menu-inner {
    position: relative;
    padding: 1rem;
  }
  @keyframes show-navbar-dropdown {
    0% {
      opacity: 0;
      transform: translate(0, 10px) perspective(200px) rotateX(-2deg);
      transition: visibility 0.25s, opacity 0.25s, transform 0.25s;
    }
    100% {
      transform: translate(0, 0);
      opacity: 1;
    }
  }
  @keyframes hide-navbar-dropdown {
    from {
      opacity: 1;
    }
    to {
      opacity: 0;
      transform: translate(0, 10px);
    }
  }
}
.navbar-collapse-header {
  display: none;
}

@media (max-width: 767.98px) {
  .navbar-nav .nav-link {
    padding: 0.625rem 0;
    color: #ffd88c !important;
  }
  .navbar-nav .dropdown-menu {
    box-shadow: none;
    min-width: auto;
  }
  .navbar-nav .dropdown-menu .media svg {
    width: 30px;
  }
  .navbar-collapse {
    width: calc(100% - 1.4rem);
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    z-index: 1050;
    margin: 0.7rem;
    overflow-y: auto;
    height: auto !important;
    opacity: 0;
  }
  .navbar-collapse .navbar-toggler {
    width: 20px;
    height: 20px;
    position: relative;
    cursor: pointer;
    display: inline-block;
    padding: 0;
  }
  .navbar-collapse .navbar-toggler span {
    display: block;
    position: absolute;
    width: 100%;
    height: 2px;
    border-radius: 2px;
    opacity: 1;
    background: #283448;
  }
  .navbar-collapse .navbar-toggler :nth-child(1) {
    transform: rotate(135deg);
  }
  .navbar-collapse .navbar-toggler :nth-child(2) {
    transform: rotate(-135deg);
  }
  .navbar-collapse .navbar-collapse-header {
    display: block;
    padding-bottom: 1rem;
    margin-bottom: 1rem;
    border-bottom: 1px solid rgba(0, 0, 0, 0.1);
  }
  .navbar-collapse .collapse-brand img {
    height: 36px;
  }
  .navbar-collapse .collapse-close {
    text-align: right;
  }
  .navbar-collapse.collapsing,
  .navbar-collapse.show {
    padding: 1.5rem;
    border-radius: 0.375rem;
    background: #fff;
    box-shadow: 0 50px 100px rgba(50, 50, 93, 0.1), 0 15px 35px rgba(50, 50, 93, 0.15), 0 5px 15px rgba(0, 0, 0, 0.1);
    animation: show-navbar-collapse 0.2s ease forwards;
  }
  .navbar-collapse.collapsing-out {
    animation: hide-navbar-collapse 0.2s ease forwards;
  }
}
@keyframes show-navbar-collapse {
  0% {
    opacity: 0;
    transform: scale(0.95);
    transform-origin: 100% 0;
  }
  100% {
    opacity: 1;
    transform: scale(1);
  }
}
@keyframes hide-navbar-collapse {
  from {
    opacity: 1;
    transform: scale(1);
    transform-origin: 100% 0;
  }
  to {
    opacity: 0;
    transform: scale(0.95);
  }
}
.page-item.active .page-link {
  box-shadow: 0 7px 14px rgba(50, 50, 93, 0.1), 0 3px 6px rgba(0, 0, 0, 0.08);
}
.page-item .page-link,
.page-item span {
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 0;
  margin: 0 3px;
  border-radius: 50% !important;
  width: 36px;
  height: 36px;
  font-size: 0.875rem;
}

.pagination-lg .page-item .page-link,
.pagination-lg .page-item span {
  width: 46px;
  height: 46px;
  line-height: 46px;
}

.pagination-sm .page-item .page-link,
.pagination-sm .page-item span {
  width: 30px;
  height: 30px;
  line-height: 30px;
}

.popover {
  border: 0;
}

.popover-header {
  font-weight: 600;
}

.popover-primary {
  background-color: #3ba371;
}
.popover-primary .popover-header {
  background-color: #3ba371;
  color: #fff;
}
.popover-primary .popover-body {
  color: #fff;
}
.popover-primary .popover-header {
  border-color: rgba(255, 255, 255, 0.2);
}
.popover-primary.bs-popover-top .arrow::after, .popover-primary.bs-popover-auto[x-placement^=top] .arrow::after {
  border-top-color: #3ba371;
}
.popover-primary.bs-popover-right .arrow::after, .popover-primary.bs-popover-auto[x-placement^=right] .arrow::after {
  border-right-color: #3ba371;
}
.popover-primary.bs-popover-bottom .arrow::after, .popover-primary.bs-popover-auto[x-placement^=bottom] .arrow::after {
  border-bottom-color: #3ba371;
}
.popover-primary.bs-popover-left .arrow::after, .popover-primary.bs-popover-auto[x-placement^=left] .arrow::after {
  border-left-color: #3ba371;
}

.popover-secondary {
  background-color: #f7fafc;
}
.popover-secondary .popover-header {
  background-color: #f7fafc;
  color: #212529;
}
.popover-secondary .popover-body {
  color: #212529;
}
.popover-secondary .popover-header {
  border-color: rgba(33, 37, 41, 0.2);
}
.popover-secondary.bs-popover-top .arrow::after, .popover-secondary.bs-popover-auto[x-placement^=top] .arrow::after {
  border-top-color: #f7fafc;
}
.popover-secondary.bs-popover-right .arrow::after, .popover-secondary.bs-popover-auto[x-placement^=right] .arrow::after {
  border-right-color: #f7fafc;
}
.popover-secondary.bs-popover-bottom .arrow::after, .popover-secondary.bs-popover-auto[x-placement^=bottom] .arrow::after {
  border-bottom-color: #f7fafc;
}
.popover-secondary.bs-popover-left .arrow::after, .popover-secondary.bs-popover-auto[x-placement^=left] .arrow::after {
  border-left-color: #f7fafc;
}

.popover-success {
  background-color: #3aa170;
}
.popover-success .popover-header {
  background-color: #3aa170;
  color: #fff;
}
.popover-success .popover-body {
  color: #fff;
}
.popover-success .popover-header {
  border-color: rgba(255, 255, 255, 0.2);
}
.popover-success.bs-popover-top .arrow::after, .popover-success.bs-popover-auto[x-placement^=top] .arrow::after {
  border-top-color: #3aa170;
}
.popover-success.bs-popover-right .arrow::after, .popover-success.bs-popover-auto[x-placement^=right] .arrow::after {
  border-right-color: #3aa170;
}
.popover-success.bs-popover-bottom .arrow::after, .popover-success.bs-popover-auto[x-placement^=bottom] .arrow::after {
  border-bottom-color: #3aa170;
}
.popover-success.bs-popover-left .arrow::after, .popover-success.bs-popover-auto[x-placement^=left] .arrow::after {
  border-left-color: #3aa170;
}

.popover-info {
  background-color: #278e69;
}
.popover-info .popover-header {
  background-color: #278e69;
  color: #fff;
}
.popover-info .popover-body {
  color: #fff;
}
.popover-info .popover-header {
  border-color: rgba(255, 255, 255, 0.2);
}
.popover-info.bs-popover-top .arrow::after, .popover-info.bs-popover-auto[x-placement^=top] .arrow::after {
  border-top-color: #278e69;
}
.popover-info.bs-popover-right .arrow::after, .popover-info.bs-popover-auto[x-placement^=right] .arrow::after {
  border-right-color: #278e69;
}
.popover-info.bs-popover-bottom .arrow::after, .popover-info.bs-popover-auto[x-placement^=bottom] .arrow::after {
  border-bottom-color: #278e69;
}
.popover-info.bs-popover-left .arrow::after, .popover-info.bs-popover-auto[x-placement^=left] .arrow::after {
  border-left-color: #278e69;
}

.popover-warning {
  background-color: #fb6340;
}
.popover-warning .popover-header {
  background-color: #fb6340;
  color: #fff;
}
.popover-warning .popover-body {
  color: #fff;
}
.popover-warning .popover-header {
  border-color: rgba(255, 255, 255, 0.2);
}
.popover-warning.bs-popover-top .arrow::after, .popover-warning.bs-popover-auto[x-placement^=top] .arrow::after {
  border-top-color: #fb6340;
}
.popover-warning.bs-popover-right .arrow::after, .popover-warning.bs-popover-auto[x-placement^=right] .arrow::after {
  border-right-color: #fb6340;
}
.popover-warning.bs-popover-bottom .arrow::after, .popover-warning.bs-popover-auto[x-placement^=bottom] .arrow::after {
  border-bottom-color: #fb6340;
}
.popover-warning.bs-popover-left .arrow::after, .popover-warning.bs-popover-auto[x-placement^=left] .arrow::after {
  border-left-color: #fb6340;
}

.popover-danger {
  background-color: #f5365c;
}
.popover-danger .popover-header {
  background-color: #f5365c;
  color: #fff;
}
.popover-danger .popover-body {
  color: #fff;
}
.popover-danger .popover-header {
  border-color: rgba(255, 255, 255, 0.2);
}
.popover-danger.bs-popover-top .arrow::after, .popover-danger.bs-popover-auto[x-placement^=top] .arrow::after {
  border-top-color: #f5365c;
}
.popover-danger.bs-popover-right .arrow::after, .popover-danger.bs-popover-auto[x-placement^=right] .arrow::after {
  border-right-color: #f5365c;
}
.popover-danger.bs-popover-bottom .arrow::after, .popover-danger.bs-popover-auto[x-placement^=bottom] .arrow::after {
  border-bottom-color: #f5365c;
}
.popover-danger.bs-popover-left .arrow::after, .popover-danger.bs-popover-auto[x-placement^=left] .arrow::after {
  border-left-color: #f5365c;
}

.popover-light {
  background-color: #adb5bd;
}
.popover-light .popover-header {
  background-color: #adb5bd;
  color: #fff;
}
.popover-light .popover-body {
  color: #fff;
}
.popover-light .popover-header {
  border-color: rgba(255, 255, 255, 0.2);
}
.popover-light.bs-popover-top .arrow::after, .popover-light.bs-popover-auto[x-placement^=top] .arrow::after {
  border-top-color: #adb5bd;
}
.popover-light.bs-popover-right .arrow::after, .popover-light.bs-popover-auto[x-placement^=right] .arrow::after {
  border-right-color: #adb5bd;
}
.popover-light.bs-popover-bottom .arrow::after, .popover-light.bs-popover-auto[x-placement^=bottom] .arrow::after {
  border-bottom-color: #adb5bd;
}
.popover-light.bs-popover-left .arrow::after, .popover-light.bs-popover-auto[x-placement^=left] .arrow::after {
  border-left-color: #adb5bd;
}

.popover-dark {
  background-color: #212529;
}
.popover-dark .popover-header {
  background-color: #212529;
  color: #fff;
}
.popover-dark .popover-body {
  color: #fff;
}
.popover-dark .popover-header {
  border-color: rgba(255, 255, 255, 0.2);
}
.popover-dark.bs-popover-top .arrow::after, .popover-dark.bs-popover-auto[x-placement^=top] .arrow::after {
  border-top-color: #212529;
}
.popover-dark.bs-popover-right .arrow::after, .popover-dark.bs-popover-auto[x-placement^=right] .arrow::after {
  border-right-color: #212529;
}
.popover-dark.bs-popover-bottom .arrow::after, .popover-dark.bs-popover-auto[x-placement^=bottom] .arrow::after {
  border-bottom-color: #212529;
}
.popover-dark.bs-popover-left .arrow::after, .popover-dark.bs-popover-auto[x-placement^=left] .arrow::after {
  border-left-color: #212529;
}

.popover-default {
  background-color: #ffd88c;
}
.popover-default .popover-header {
  background-color: #ffd88c;
  color: #212529;
}
.popover-default .popover-body {
  color: #212529;
}
.popover-default .popover-header {
  border-color: rgba(33, 37, 41, 0.2);
}
.popover-default.bs-popover-top .arrow::after, .popover-default.bs-popover-auto[x-placement^=top] .arrow::after {
  border-top-color: #ffd88c;
}
.popover-default.bs-popover-right .arrow::after, .popover-default.bs-popover-auto[x-placement^=right] .arrow::after {
  border-right-color: #ffd88c;
}
.popover-default.bs-popover-bottom .arrow::after, .popover-default.bs-popover-auto[x-placement^=bottom] .arrow::after {
  border-bottom-color: #ffd88c;
}
.popover-default.bs-popover-left .arrow::after, .popover-default.bs-popover-auto[x-placement^=left] .arrow::after {
  border-left-color: #ffd88c;
}

.popover-white {
  background-color: #fff;
}
.popover-white .popover-header {
  background-color: #fff;
  color: #212529;
}
.popover-white .popover-body {
  color: #212529;
}
.popover-white .popover-header {
  border-color: rgba(33, 37, 41, 0.2);
}
.popover-white.bs-popover-top .arrow::after, .popover-white.bs-popover-auto[x-placement^=top] .arrow::after {
  border-top-color: #fff;
}
.popover-white.bs-popover-right .arrow::after, .popover-white.bs-popover-auto[x-placement^=right] .arrow::after {
  border-right-color: #fff;
}
.popover-white.bs-popover-bottom .arrow::after, .popover-white.bs-popover-auto[x-placement^=bottom] .arrow::after {
  border-bottom-color: #fff;
}
.popover-white.bs-popover-left .arrow::after, .popover-white.bs-popover-auto[x-placement^=left] .arrow::after {
  border-left-color: #fff;
}

.popover-neutral {
  background-color: #fff;
}
.popover-neutral .popover-header {
  background-color: #fff;
  color: #212529;
}
.popover-neutral .popover-body {
  color: #212529;
}
.popover-neutral .popover-header {
  border-color: rgba(33, 37, 41, 0.2);
}
.popover-neutral.bs-popover-top .arrow::after, .popover-neutral.bs-popover-auto[x-placement^=top] .arrow::after {
  border-top-color: #fff;
}
.popover-neutral.bs-popover-right .arrow::after, .popover-neutral.bs-popover-auto[x-placement^=right] .arrow::after {
  border-right-color: #fff;
}
.popover-neutral.bs-popover-bottom .arrow::after, .popover-neutral.bs-popover-auto[x-placement^=bottom] .arrow::after {
  border-bottom-color: #fff;
}
.popover-neutral.bs-popover-left .arrow::after, .popover-neutral.bs-popover-auto[x-placement^=left] .arrow::after {
  border-left-color: #fff;
}

.popover-darker {
  background-color: black;
}
.popover-darker .popover-header {
  background-color: black;
  color: #fff;
}
.popover-darker .popover-body {
  color: #fff;
}
.popover-darker .popover-header {
  border-color: rgba(255, 255, 255, 0.2);
}
.popover-darker.bs-popover-top .arrow::after, .popover-darker.bs-popover-auto[x-placement^=top] .arrow::after {
  border-top-color: black;
}
.popover-darker.bs-popover-right .arrow::after, .popover-darker.bs-popover-auto[x-placement^=right] .arrow::after {
  border-right-color: black;
}
.popover-darker.bs-popover-bottom .arrow::after, .popover-darker.bs-popover-auto[x-placement^=bottom] .arrow::after {
  border-bottom-color: black;
}
.popover-darker.bs-popover-left .arrow::after, .popover-darker.bs-popover-auto[x-placement^=left] .arrow::after {
  border-left-color: black;
}

.progress-wrapper {
  position: relative;
  padding-top: 1.5rem;
}

.progress {
  height: 8px;
  margin-bottom: 1rem;
  overflow: hidden;
  border-radius: 0.25rem;
  background-color: #e9ecef;
  box-shadow: inset 0 1px 2px rgba(0, 0, 0, 0.1);
}
.progress .sr-only {
  width: auto;
  height: 20px;
  margin: 0 0 0 30px;
  left: 0;
  clip: auto;
  line-height: 20px;
  font-size: 13px;
}

.progress-heading {
  font-size: 14px;
  font-weight: 500;
  margin: 0 0 2px;
  padding: 0;
}

.progress-bar {
  box-shadow: none;
  border-radius: 0;
  height: auto;
}

.progress-info {
  margin-bottom: 0.5rem;
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.progress-label span {
  display: inline-block;
  color: #3ba371;
  font-size: 0.625rem;
  font-weight: 600;
  text-transform: uppercase;
  background: rgba(59, 163, 113, 0.1);
  padding: 0.25rem 1rem;
  border-radius: 30px;
}

.progress-percentage {
  text-align: right;
}
.progress-percentage span {
  display: inline-block;
  color: #8898aa;
  font-size: 0.875rem;
  font-weight: 600;
}

.separator {
  position: absolute;
  top: auto;
  left: 0;
  right: 0;
  width: 100%;
  height: 150px;
  transform: translateZ(0);
  overflow: hidden;
  pointer-events: none;
}
.separator svg {
  position: absolute;
  pointer-events: none;
}

.separator-top {
  top: 0;
  bottom: auto;
}
.separator-top svg {
  top: 0;
}

.separator-bottom {
  top: auto;
  bottom: 0;
}
.separator-bottom svg {
  bottom: 0;
}

.separator-inverse {
  transform: rotate(180deg);
}

.separator-skew {
  height: 60px;
}
@media (min-width: 1200px) {
  .separator-skew {
    height: 70px;
  }
}

.table thead th {
  cursor: pointer;
  padding-top: 0.75rem;
  padding-bottom: 0.75rem;
  font-size: 0.65rem;
  text-transform: uppercase;
  letter-spacing: 1px;
  border-bottom: 1px solid #e9ecef;
}
.table th {
  font-weight: 600;
}
.table td .progress {
  height: 3px;
  width: 120px;
  margin: 0;
}
.table td,
.table th {
  font-size: 0.8125rem;
  white-space: nowrap;
}
.table.align-items-center td,
.table.align-items-center th {
  vertical-align: middle;
}
.table .thead-dark th {
  background-color: rgb(255, 222.9182608696, 160.4);
  color: white;
}
.table .thead-light th {
  background-color: #f6f9fc;
  color: #8898aa;
}

.table-hover tr {
  transition: all 0.15s ease;
}
@media (prefers-reduced-motion: reduce) {
  .table-hover tr {
    transition: none;
  }
}

.table-flush td,
.table-flush th {
  border-left: 0;
  border-right: 0;
}
.table-flush tbody tr:first-child td,
.table-flush tbody tr:first-child th {
  border-top: 0;
}
.table-flush tbody tr:last-child td,
.table-flush tbody tr:last-child th {
  border-bottom: 0;
}

.card .table {
  margin-bottom: 0;
  cursor: pointer;
}
.card .table td,
.card .table th {
  padding-left: 1.5rem;
  padding-right: 1.5rem;
}

p {
  font-size: 1rem;
  font-weight: 300;
  line-height: 1.7;
}

.lead {
  font-size: 1.25rem;
  font-weight: 300;
  line-height: 1.7;
  margin-top: 1.5rem;
}
.lead + .btn-wrapper {
  margin-top: 3rem;
}

.description {
  font-size: 0.875rem;
}

.heading {
  letter-spacing: 0.025em;
  font-size: 0.95rem;
  text-transform: uppercase;
  font-weight: 600;
}

.heading-small {
  padding-top: 0.25rem;
  padding-bottom: 0.25rem;
  font-size: 0.75rem;
  text-transform: uppercase;
  letter-spacing: 0.04em;
}

.heading-title {
  letter-spacing: 0.025em;
  font-size: 1.375rem;
  font-weight: 600;
  text-transform: uppercase;
}

.heading-section {
  letter-spacing: 0.025em;
  font-size: 1.375rem;
  font-weight: 600;
  text-transform: uppercase;
}
.heading-section img {
  display: block;
  width: 72px;
  height: 72px;
  margin-bottom: 1.5rem;
}
.heading-section.text-center img {
  margin-left: auto;
  margin-right: auto;
}

.display-1 span,
.display-2 span,
.display-3 span,
.display-4 span {
  display: block;
  font-weight: 300;
}

article h4:not(:first-child),
article h5:not(:first-child) {
  margin-top: 3rem;
}
article h4,
article h5 {
  margin-bottom: 1.5rem;
}
article figure {
  margin: 3rem 0;
}
article h5 + figure {
  margin-top: 0;
}

.datepicker {
  border-radius: 0.375rem;
  direction: ltr;
}
.datepicker-inline {
  width: 220px;
}
.datepicker-rtl {
  direction: rtl;
}
.datepicker-rtl.dropdown-menu {
  left: auto;
}
.datepicker-rtl table tr td span {
  float: right;
}
.datepicker-dropdown {
  top: 0;
  left: 0;
  padding: 20px 22px;
  box-shadow: 0 50px 100px rgba(50, 50, 93, 0.1), 0 15px 35px rgba(50, 50, 93, 0.15), 0 5px 15px rgba(0, 0, 0, 0.1);
}
.datepicker-dropdown.datepicker-orient-left:before {
  left: 6px;
}
.datepicker-dropdown.datepicker-orient-left:after {
  left: 7px;
}
.datepicker-dropdown.datepicker-orient-right:before {
  right: 6px;
}
.datepicker-dropdown.datepicker-orient-right:after {
  right: 7px;
}
.datepicker-dropdown.datepicker-orient-bottom:before {
  top: -7px;
}
.datepicker-dropdown.datepicker-orient-bottom:after {
  top: -6px;
}
.datepicker-dropdown.datepicker-orient-top:before {
  bottom: -7px;
  border-bottom: 0;
  border-top: 7px solid white;
}
.datepicker-dropdown.datepicker-orient-top:after {
  bottom: -6px;
  border-bottom: 0;
  border-top: 6px solid #fff;
}
.datepicker table {
  margin: 0;
  -webkit-touch-callout: none;
  -webkit-user-select: none;
          user-select: none;
}
.datepicker table tr td {
  border-radius: 50%;
}
.datepicker table tr th {
  border-radius: 0.375rem;
  font-weight: 500;
}
.datepicker table tr td,
.datepicker table tr th {
  transition: all 0.15s ease;
  width: 36px;
  height: 36px;
  border: none;
  text-align: center;
  font-size: 0.875rem;
}
.table-striped .datepicker table tr td,
.table-striped .datepicker table tr th {
  background-color: transparent;
}
.datepicker table tr td.old, .datepicker table tr td.new {
  color: #adb5bd;
}
.datepicker table tr td.day:hover, .datepicker table tr td.focused {
  background: white;
  cursor: pointer;
}
.datepicker table tr td.disabled, .datepicker table tr td.disabled:hover {
  background: none;
  color: #dee2e6;
  cursor: default;
}
.datepicker table tr td.highlighted {
  border-radius: 0;
}
.datepicker table tr td.highlighted.focused {
  background: #3ba371;
}
.datepicker table tr td.highlighted.disabled, .datepicker table tr td.highlighted.disabled:active {
  background: #3ba371;
  color: #ced4da;
}
.datepicker table tr td.today {
  background: rgb(212.0472972973, 239.4527027027, 226.277027027);
}
.datepicker table tr td.today.focused {
  background: white;
}
.datepicker table tr td.today.disabled, .datepicker table tr td.today.disabled:active {
  background: white;
  color: #8898aa;
}
.datepicker table tr td.range {
  background: #3ba371;
  color: #fff;
  border-radius: 0;
}
.datepicker table tr td.range.focused {
  background: rgb(48.1567567568, 133.0432432432, 92.2324324324);
}
.datepicker table tr td.range.disabled, .datepicker table tr td.range.disabled:active, .datepicker table tr td.range.day.disabled:hover {
  background: rgb(45.4459459459, 125.5540540541, 87.0405405405);
  color: rgb(80.9864864865, 192.0135135135, 138.6351351351);
}
.datepicker table tr td.range.highlighted.focused {
  background: rgb(203.4736842105, 210.5, 217.5263157895);
}
.datepicker table tr td.range.highlighted.disabled, .datepicker table tr td.range.highlighted.disabled:active {
  background: #e9ecef;
  color: #dee2e6;
}
.datepicker table tr td.range.today.disabled, .datepicker table tr td.range.today.disabled:active {
  background: #3ba371;
  color: #fff;
}
.datepicker table tr td.day.range-start {
  border-top-right-radius: 0;
  border-bottom-right-radius: 0;
}
.datepicker table tr td.day.range-end {
  border-top-left-radius: 0;
  border-bottom-left-radius: 0;
}
.datepicker table tr td.day.range-start.range-end {
  border-radius: 50%;
}
.datepicker table tr td.selected, .datepicker table tr td.selected.highlighted, .datepicker table tr td.selected:hover, .datepicker table tr td.selected.highlighted:hover, .datepicker table tr td.day.range:hover {
  background: #3ba371;
  color: #fff;
}
.datepicker table tr td.active, .datepicker table tr td.active.highlighted, .datepicker table tr td.active:hover, .datepicker table tr td.active.highlighted:hover {
  background: #3ba371;
  color: #fff;
  box-shadow: none;
}
.datepicker table tr td span {
  display: block;
  width: 23%;
  height: 54px;
  line-height: 54px;
  float: left;
  margin: 1%;
  cursor: pointer;
  border-radius: 4px;
}
.datepicker table tr td span:hover, .datepicker table tr td span.focused {
  background: #e9ecef;
}
.datepicker table tr td span.disabled, .datepicker table tr td span.disabled:hover {
  background: none;
  color: #dee2e6;
  cursor: default;
}
.datepicker table tr td span.active, .datepicker table tr td span.active:hover, .datepicker table tr td span.active.disabled, .datepicker table tr td span.active.disabled:hover {
  text-shadow: 0 -1px 0 rgba(0, 0, 0, 0.25);
}
.datepicker table tr td span.old, .datepicker table tr td span.new {
  color: #8898aa;
}
.datepicker .datepicker-switch {
  width: 145px;
}
.datepicker .datepicker-switch,
.datepicker .prev,
.datepicker .next,
.datepicker tfoot tr th {
  cursor: pointer;
}
.datepicker .datepicker-switch:hover,
.datepicker .prev:hover,
.datepicker .next:hover,
.datepicker tfoot tr th:hover {
  background: #e9ecef;
}
.datepicker .prev.disabled,
.datepicker .next.disabled {
  visibility: hidden;
}
.datepicker .cw {
  font-size: 10px;
  width: 12px;
  padding: 0 2px 0 5px;
  vertical-align: middle;
}

/*! nouislider - 14.0.1 - 6/21/2019 */
/* Functional styling;
 * These styles are required for noUiSlider to function.
 * You don't need to change these rules to apply your design.
 */
.noUi-target,
.noUi-target * {
  -webkit-touch-callout: none;
  -webkit-tap-highlight-color: rgba(0, 0, 0, 0);
  -webkit-user-select: none;
  touch-action: none;
  user-select: none;
  box-sizing: border-box;
}

.noUi-target {
  position: relative;
  direction: ltr;
}

.noUi-base,
.noUi-connects {
  width: 100%;
  height: 100%;
  position: relative;
  z-index: 1;
}

/* Wrapper for all connect elements.
 */
.noUi-connects {
  overflow: hidden;
  z-index: 0;
}

.noUi-connect,
.noUi-origin {
  will-change: transform;
  position: absolute;
  z-index: 1;
  top: 0;
  left: 0;
  -ms-transform-origin: 0 0;
  -webkit-transform-origin: 0 0;
  -webkit-transform-style: preserve-3d;
  transform-origin: 0 0;
  transform-style: flat;
}

.noUi-connect {
  height: 100%;
  width: 100%;
}

.noUi-origin {
  height: 10%;
  width: 10%;
}

/* Offset direction
 */
html:not([dir=rtl]) .noUi-horizontal .noUi-origin {
  left: auto;
  right: 0;
}

/* Give origins 0 height/width so they don't interfere with clicking the
 * connect elements.
 */
.noUi-vertical .noUi-origin {
  width: 0;
}

.noUi-horizontal .noUi-origin {
  height: 0;
}

.noUi-handle {
  backface-visibility: hidden;
  position: absolute;
}

.noUi-touch-area {
  height: 100%;
  width: 100%;
}

.noUi-state-tap .noUi-connect,
.noUi-state-tap .noUi-origin {
  transition: transform 0.3s;
}

.noUi-state-drag * {
  cursor: inherit !important;
}

/* Slider size and handle placement;
 */
.noUi-horizontal {
  height: 18px;
}

.noUi-horizontal .noUi-handle {
  width: 34px;
  height: 28px;
  left: -17px;
  top: -6px;
}

.noUi-vertical {
  width: 18px;
}

.noUi-vertical .noUi-handle {
  width: 28px;
  height: 34px;
  left: -6px;
  top: -17px;
}

html:not([dir=rtl]) .noUi-horizontal .noUi-handle {
  right: -17px;
  left: auto;
}

/* Styling;
 * Giving the connect element a border radius causes issues with using transform: scale
 */
.noUi-target {
  background: #fafafa;
  border-radius: 4px;
  border: 1px solid #d3d3d3;
  box-shadow: inset 0 1px 1px #f0f0f0, 0 3px 6px -5px #bbb;
}

.noUi-connects {
  border-radius: 3px;
}

.noUi-connect {
  background: #3fb8af;
}

/* Handles and cursors;
 */
.noUi-draggable {
  cursor: ew-resize;
}

.noUi-vertical .noUi-draggable {
  cursor: ns-resize;
}

.noUi-handle {
  border: 1px solid #d9d9d9;
  border-radius: 3px;
  background: #fff;
  cursor: default;
  box-shadow: inset 0 0 1px #fff, inset 0 1px 7px #ebebeb, 0 3px 6px -3px #bbb;
}

.noUi-active {
  box-shadow: inset 0 0 1px #fff, inset 0 1px 7px #ddd, 0 3px 6px -3px #bbb;
}

/* Handle stripes;
 */
.noUi-handle:before,
.noUi-handle:after {
  content: "";
  display: block;
  position: absolute;
  height: 14px;
  width: 1px;
  background: #e8e7e6;
  left: 14px;
  top: 6px;
}

.noUi-handle:after {
  left: 17px;
}

.noUi-vertical .noUi-handle:before,
.noUi-vertical .noUi-handle:after {
  width: 14px;
  height: 1px;
  left: 6px;
  top: 14px;
}

.noUi-vertical .noUi-handle:after {
  top: 17px;
}

/* Disabled state;
 */
[disabled] .noUi-connect {
  background: #b8b8b8;
}

[disabled].noUi-target,
[disabled].noUi-handle,
[disabled] .noUi-handle {
  cursor: not-allowed;
}

/* Base;
 *
 */
.noUi-pips,
.noUi-pips * {
  box-sizing: border-box;
}

.noUi-pips {
  position: absolute;
  color: #999;
}

/* Values;
 *
 */
.noUi-value {
  position: absolute;
  white-space: nowrap;
  text-align: center;
}

.noUi-value-sub {
  color: #ccc;
  font-size: 10px;
}

/* Markings;
 *
 */
.noUi-marker {
  position: absolute;
  background: #ccc;
}

.noUi-marker-sub {
  background: #aaa;
}

.noUi-marker-large {
  background: #aaa;
}

/* Horizontal layout;
 *
 */
.noUi-pips-horizontal {
  padding: 10px 0;
  height: 80px;
  top: 100%;
  left: 0;
  width: 100%;
}

.noUi-value-horizontal {
  transform: translate(-50%, 50%);
}

.noUi-rtl .noUi-value-horizontal {
  transform: translate(50%, 50%);
}

.noUi-marker-horizontal.noUi-marker {
  margin-left: -1px;
  width: 2px;
  height: 5px;
}

.noUi-marker-horizontal.noUi-marker-sub {
  height: 10px;
}

.noUi-marker-horizontal.noUi-marker-large {
  height: 15px;
}

/* Vertical layout;
 *
 */
.noUi-pips-vertical {
  padding: 0 10px;
  height: 100%;
  top: 0;
  left: 100%;
}

.noUi-value-vertical {
  transform: translate(0, -50%);
  padding-left: 25px;
}

.noUi-rtl .noUi-value-vertical {
  transform: translate(0, 50%);
}

.noUi-marker-vertical.noUi-marker {
  width: 5px;
  height: 2px;
  margin-top: -1px;
}

.noUi-marker-vertical.noUi-marker-sub {
  width: 10px;
}

.noUi-marker-vertical.noUi-marker-large {
  width: 15px;
}

.noUi-tooltip {
  display: block;
  position: absolute;
  border: 1px solid #d9d9d9;
  border-radius: 3px;
  background: #fff;
  color: #000;
  padding: 5px;
  text-align: center;
  white-space: nowrap;
}

.noUi-horizontal .noUi-tooltip {
  transform: translate(-50%, 0);
  left: 50%;
  bottom: 120%;
}

.noUi-vertical .noUi-tooltip {
  transform: translate(0, -50%);
  top: 50%;
  right: 120%;
}

.noUi-target {
  background: #eceeef;
  border-radius: 5px;
  border: 0;
  box-shadow: inset 0 1px 2px rgba(90, 97, 105, 0.1);
  margin: 15px 0;
  cursor: pointer;
}

.noUi-horizontal {
  height: 5px;
}

html:not([dir=rtl]) .noUi-horizontal .noUi-handle {
  right: -10px;
}

.noUi-vertical {
  width: 5px;
}

.noUi-connect {
  background: #3ba371;
  box-shadow: none;
}

.noUi-handle:after, .noUi-handle:before {
  content: none;
}
.noUi-handle:focus {
  outline: none;
}

.noUi-horizontal .noUi-handle,
.noUi-vertical .noUi-handle {
  top: -5px;
  width: 15px;
  height: 15px;
  border-radius: 100%;
  box-shadow: none;
  cursor: pointer;
  background-color: #3ba371;
  border: 0;
  transition: box-shadow 0.15s, transform 0.15s;
}

.noUi-horizontal .noUi-handle.noUi-active,
.noUi-vertical .noUi-handle.noUi-active {
  box-shadow: 0px 0px 0px 2px #3ba371;
}

.input-slider--cyan .noUi-connect {
  background: #2bffc6;
}

/* Disabled state */
[disabled] .noUi-connect,
[disabled].noUi-connect {
  background: #b2b2b2;
}

[disabled] .noUi-handle,
[disabled].noUi-origin {
  cursor: not-allowed;
}

/* Range slider value labels */
.range-slider-value {
  font-size: 0.75rem;
  font-weight: 500;
  background-color: rgba(33, 37, 41, 0.7);
  color: #fff;
  border-radius: 10px;
  padding: 0.4em 0.8em 0.3em 0.85em;
}

.range-slider-wrapper .upper-info {
  font-weight: 400;
  margin-bottom: 5px;
}

.input-slider-value-output {
  background: #333;
  color: #fff;
  padding: 4px 8px;
  position: relative;
  top: 12px;
  font-size: 11px;
  border-radius: 2px;
}

.input-slider-value-output:after {
  bottom: 100%;
  left: 10px;
  border: solid transparent;
  content: " ";
  height: 0;
  width: 0;
  position: absolute;
  pointer-events: none;
  border-color: rgba(136, 183, 213, 0);
  border-bottom-color: #333;
  border-width: 4px;
  margin-left: -4px;
}

.input-slider-value-output.left:after {
  left: 10px;
  right: auto;
}

.input-slider-value-output.right:after {
  right: 10px;
  left: auto;
}

.scrollbar-inner {
  height: 100%;
}
.scrollbar-inner:not(:hover) .scroll-element {
  opacity: 0;
}
.scrollbar-inner .scroll-element {
  transition: opacity 300ms;
  margin-right: 2px;
}
.scrollbar-inner .scroll-element .scroll-bar,
.scrollbar-inner .scroll-element .scroll-element_track {
  transition: background-color 300ms;
}
.scrollbar-inner .scroll-element .scroll-element_track {
  background-color: transparent;
}
.scrollbar-inner .scroll-element.scroll-y {
  width: 3px;
  right: 0;
}
.scrollbar-inner .scroll-element.scroll-x {
  height: 3px;
  bottom: 0;
}

.ct-navbar {
  background-color: #3ba371;
  box-shadow: rgba(116, 129, 141, 0.1) 0px 1px 1px 0px;
  padding-top: 0.5rem;
  padding-bottom: 0.5rem;
}
@media (max-width: 991.98px) {
  .ct-navbar {
    padding-right: 0.5rem;
    padding-left: 0.5rem;
  }
  .ct-navbar .navbar-nav-scroll {
    max-width: 100%;
    height: 2.5rem;
    margin-top: 0.25rem;
    overflow: hidden;
    font-size: 0.875rem;
  }
  .ct-navbar .navbar-nav-scroll .navbar-nav {
    padding-bottom: 2rem;
    overflow-x: auto;
    white-space: nowrap;
    -webkit-overflow-scrolling: touch;
  }
}
@media (min-width: 768px) {
  @supports (position: sticky) {
    .ct-navbar {
      position: sticky;
      top: 0;
      z-index: 1071;
    }
  }
}
.ct-navbar .navbar-nav .nav-link {
  padding-right: 0.5rem;
  padding-left: 0.5rem;
  color: rgba(255, 255, 255, 0.9) !important;
}
.ct-navbar .navbar-nav .nav-link.active, .ct-navbar .navbar-nav .nav-link:hover {
  color: #fff !important;
  background-color: transparent !important;
}
.ct-navbar .navbar-nav .nav-link.active {
  font-weight: 500;
}
.ct-navbar .navbar-nav-svg {
  display: inline-block;
  width: 1rem;
  height: 1rem;
  vertical-align: text-top;
}
.ct-navbar .dropdown-menu {
  font-size: 0.875rem;
}
.ct-navbar .dropdown-item.active {
  font-weight: 500;
  color: #212529;
  background-color: transparent;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_11___});
  background-repeat: no-repeat;
  background-position: 0.4rem 0.87rem;
  background-size: 0.75rem 0.75rem;
  padding-left: 25px;
}

.github-corner {
  position: fixed;
  right: 0;
  z-index: 1080;
}
.github-corner:hover .octo-arm {
  animation: octocat-wave 560ms ease-in-out;
}
.github-corner svg {
  fill: #fff;
  color: #3ba371;
}

@keyframes octocat-wave {
  0%, 100% {
    transform: rotate(0);
  }
  20%, 60% {
    transform: rotate(-25deg);
  }
  40%, 80% {
    transform: rotate(10deg);
  }
}
.ct-clipboard {
  position: relative;
  display: none;
  float: right;
}
.ct-clipboard + .highlight {
  margin-top: 0;
}

.btn-clipboard {
  position: absolute;
  top: 1rem;
  right: 1rem;
  z-index: 10;
  display: block;
  padding: 0.25rem 0.5rem;
  font-size: 75%;
  cursor: pointer;
  background-color: transparent;
  border: 0;
  border-radius: 0.25rem;
  color: #fff;
  background-color: #3ba371;
}
.btn-clipboard:hover {
  color: #fff;
  background-color: rgb(45.4459459459, 125.5540540541, 87.0405405405);
}

@media (min-width: 768px) {
  .ct-clipboard {
    display: block;
  }
}
.ct-example-row .row > .col span,
.ct-example-row .row > [class^=col-] span {
  display: block;
  padding: 0.75rem;
  color: rgb(57, 63, 73);
  background-color: rgb(255, 255, 255);
  box-shadow: rgba(0, 0, 0, 0.1) 0px 0px 0px 1px, rgba(0, 0, 0, 0.1) 0px 4px 16px;
  font-size: 0.875rem;
  border-radius: 0.25rem;
  margin: 1rem 0;
}
.ct-example-row .no-gutters > .col span,
.ct-example-row .no-gutters > [class^=col-] span {
  border-radius: 0;
}
.ct-example-row .flex-items-top,
.ct-example-row .flex-items-middle,
.ct-example-row .flex-items-bottom {
  min-height: 6rem;
  background-color: rgba(255, 0, 0, 0.1);
}

.ct-example-row-flex-cols .row {
  min-height: 10rem;
  background-color: rgba(255, 0, 0, 0.1);
}
.ct-example-row-flex-cols .row + .row {
  margin-top: 1rem;
}

.ct-highlight {
  background-color: rgba(59, 163, 113, 0.15);
  border: 1px solid rgba(59, 163, 113, 0.15);
}

.example-container {
  width: 800px;
  width: 100%;
  padding-right: 15px;
  padding-left: 15px;
  margin-right: auto;
  margin-left: auto;
}

.example-row {
  display: flex;
  flex-wrap: wrap;
  margin-right: -15px;
  margin-left: -15px;
}

.example-content-main {
  position: relative;
  width: 100%;
  padding-right: 15px;
  padding-left: 15px;
}
@media (min-width: 576px) {
  .example-content-main {
    flex: 0 0 50%;
    max-width: 50%;
  }
}
@media (min-width: 992px) {
  .example-content-main {
    flex: 0 0 66.6666666667%;
    max-width: 66.6666666667%;
  }
}

.example-content-secondary {
  position: relative;
  width: 100%;
  padding-right: 15px;
  padding-left: 15px;
}
@media (min-width: 576px) {
  .example-content-secondary {
    flex: 0 0 50%;
    max-width: 50%;
  }
}
@media (min-width: 992px) {
  .example-content-secondary {
    flex: 0 0 33.3333333333%;
    max-width: 33.3333333333%;
  }
}

.ct-example-container {
  min-width: 16rem;
  max-width: 25rem;
  margin-right: auto;
  margin-left: auto;
}

.ct-example-container-header {
  height: 3rem;
  margin-bottom: 0.5rem;
  background-color: rgb(230.7702702703, 246.2297297297, 238.7972972973);
  border-radius: 0.25rem;
}

.ct-example-container-sidebar {
  float: right;
  width: 4rem;
  height: 8rem;
  background-color: rgb(137.1554054054, 212.3445945946, 176.1959459459);
  border-radius: 0.25rem;
}

.ct-example-container-body {
  height: 8rem;
  margin-right: 4.5rem;
  background-color: rgb(137.1554054054, 212.3445945946, 176.1959459459);
  border-radius: 0.25rem;
}

.ct-example-container-fluid {
  max-width: none;
}

.ct-example {
  position: relative;
  margin: 1rem -15px 0;
}
.ct-example::after {
  display: block;
  clear: both;
  content: "";
}
@media (min-width: 576px) {
  .ct-example {
    margin-right: 0;
    margin-left: 0;
  }
}
.ct-example + .highlight,
.ct-example + .clipboard + .highlight {
  margin-top: 0;
}
.ct-example + p {
  margin-top: 2rem;
}
.ct-example .pos-f-t {
  position: relative;
  margin: -1rem;
}
@media (min-width: 576px) {
  .ct-example .pos-f-t {
    margin: -1.5rem;
  }
}
.ct-example .custom-file-input:lang(es) ~ .custom-file-label::after {
  content: "Elegir";
}
.ct-example > .form-control + .form-control {
  margin-top: 0.5rem;
}
.ct-example > .nav + .nav,
.ct-example > .alert + .alert,
.ct-example > .navbar + .navbar,
.ct-example > .progress + .progress,
.ct-example > .progress + .btn,
.ct-example .badge,
.ct-example .btn {
  margin-top: 0.5rem;
  margin-bottom: 0.5rem;
}
.ct-example .btn-group {
  margin-top: 0.5rem;
  margin-bottom: 0.5rem;
}
.ct-example .btn-group .btn {
  margin: 0;
}
.ct-example .alert {
  margin: 0;
}
.ct-example .alert + .alert {
  margin-top: 1.25rem;
}
.ct-example .badge {
  margin-right: 0.5rem;
}
.ct-example > .dropdown-menu:first-child {
  position: static;
  display: block;
}
.ct-example > .form-group:last-child {
  margin-bottom: 0;
}
.ct-example > .close {
  float: none;
}

.ct-example-type .table .type-info {
  color: #999;
  vertical-align: middle;
}
.ct-example-type .table td {
  padding: 1rem 0;
  border-color: #eee;
}
.ct-example-type .table tr:first-child td {
  border-top: 0;
}
.ct-example-type h1,
.ct-example-type h2,
.ct-example-type h3,
.ct-example-type h4,
.ct-example-type h5,
.ct-example-type h6 {
  margin-top: 0;
  margin-bottom: 0;
}

.ct-example-bg-classes p {
  padding: 1rem;
}

.ct-example > img + img {
  margin-left: 0.5rem;
}

.ct-example > .btn-group {
  margin-top: 0.25rem;
  margin-bottom: 0.25rem;
}
.ct-example > .btn-toolbar + .btn-toolbar {
  margin-top: 0.5rem;
}

.ct-example-control-sizing select,
.ct-example-control-sizing input[type=text] + input[type=text] {
  margin-top: 0.5rem;
}

.ct-example-form .input-group {
  margin-bottom: 0.5rem;
}

.ct-example > textarea.form-control {
  resize: vertical;
}

.ct-example > .list-group {
  max-width: 400px;
}

.ct-example .fixed-top,
.ct-example .sticky-top {
  position: static;
  margin: -1rem -1rem 1rem;
}
.ct-example .fixed-bottom {
  position: static;
  margin: 1rem -1rem -1rem;
}
@media (min-width: 576px) {
  .ct-example .fixed-top,
  .ct-example .sticky-top {
    margin: -1.5rem -1.5rem 1rem;
  }
  .ct-example .fixed-bottom {
    margin: 1rem -1.5rem -1.5rem;
  }
}

.ct-example .pagination {
  margin-top: 0.5rem;
  margin-bottom: 0.5rem;
}

.modal {
  z-index: 1072;
}
.modal .tooltip,
.modal .popover {
  z-index: 1073;
}

.modal-backdrop {
  z-index: 1071;
}

.ct-example-modal {
  background-color: #fafafa;
}
.ct-example-modal .modal {
  position: relative;
  top: auto;
  right: auto;
  bottom: auto;
  left: auto;
  z-index: 1;
  display: block;
}
.ct-example-modal .modal-dialog {
  left: auto;
  margin-right: auto;
  margin-left: auto;
}

.ct-example-tabs .nav-tabs {
  margin-bottom: 1rem;
}

.ct-example-popover-static {
  padding-bottom: 1.5rem;
  background-color: #f9f9f9;
}
.ct-example-popover-static .popover {
  position: relative;
  display: block;
  float: left;
  width: 260px;
  margin: 1.25rem;
}

.tooltip-demo a {
  white-space: nowrap;
}

.ct-example-tooltip-static .tooltip {
  position: relative;
  display: inline-block;
  margin: 10px 20px;
  opacity: 1;
}

.scrollspy-example {
  position: relative;
  height: 200px;
  margin-top: 0.5rem;
  overflow: auto;
}

.scrollspy-example-2 {
  position: relative;
  height: 350px;
  overflow: auto;
}

.ct-example-border-utils [class^=border] {
  display: inline-block;
  width: 5rem;
  height: 5rem;
  margin: 0.25rem;
  background-color: #f5f5f5;
}

.ct-example-border-utils-0 [class^=border] {
  border: 1px solid #b1b1b1;
}

.highlight {
  padding: 0;
  margin-top: 1rem;
  -ms-overflow-style: -ms-autohiding-scrollbar;
}
@media (min-width: 576px) {
  .highlight {
    padding: 0;
  }
}

.ct-content .highlight {
  margin-right: -15px;
  margin-left: -15px;
}
@media (min-width: 576px) {
  .ct-content .highlight {
    margin-right: 0;
    margin-left: 0;
  }
}

.ct-example {
  margin-bottom: 2rem;
  padding-bottom: 2rem;
  border-bottom: 1px solid #e9ecef;
}
.ct-example .tab-content .tab-example-result {
  background-color: #f5f7f9;
  border: 1px solid #e6ecf1;
  padding: 1.25rem;
  border-radius: 0.25rem;
}
.ct-example .nav-tabs-code {
  margin-bottom: 0.375rem;
}
.ct-example .nav-tabs-code .nav-link {
  font-size: 0.875rem;
}
.ct-example .nav-tabs-code .nav-link:active, .ct-example .nav-tabs-code .nav-link.active {
  color: #3ba371;
}

.icon-examples {
  margin-top: 1rem;
}

.btn-icon-clipboard {
  margin: 0px;
  padding: 24px;
  font-size: 16px;
  font-weight: 400;
  line-height: 1.25;
  color: rgb(57, 63, 73);
  background-color: rgb(248, 249, 250);
  border-radius: 4px;
  border: 0px none;
  text-align: left;
  font-family: inherit;
  display: inline-block;
  vertical-align: middle;
  text-decoration: none;
  -moz-appearance: none;
  cursor: pointer;
  width: 100%;
  margin: 0.5rem 0;
}
.btn-icon-clipboard:hover {
  background-color: rgb(255, 255, 255);
  box-shadow: rgba(0, 0, 0, 0.1) 0px 0px 0px 1px, rgba(0, 0, 0, 0.1) 0px 4px 16px;
}
.btn-icon-clipboard > div {
  align-items: center;
  display: flex;
}
.btn-icon-clipboard i {
  box-sizing: content-box;
  color: rgb(57, 63, 73);
  vertical-align: middle;
  font-size: 1.5rem;
}
.btn-icon-clipboard span {
  display: inline-block;
  font-size: 0.875rem;
  line-height: 1.5;
  color: rgb(57, 63, 73);
  margin-left: 16px;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
  vertical-align: middle;
}

code[class*=language-],
pre[class*=language-] {
  font-family: Consolas, Menlo, Monaco, "Andale Mono WT", "Andale Mono", "Lucida Console", "Lucida Sans Typewriter", "DejaVu Sans Mono", "Bitstream Vera Sans Mono", "Liberation Mono", "Nimbus Mono L", "Courier New", Courier, monospace;
  font-size: 14px;
  line-height: 1.375;
  direction: ltr;
  text-align: left;
  white-space: pre;
  word-spacing: normal;
  word-break: normal;
  tab-size: 4;
  hyphens: none;
  background: #f5f7ff;
  color: #5e6687;
  border-radius: 0.25rem;
}

pre[class*=language-]::selection,
pre[class*=language-] ::selection,
code[class*=language-]::selection,
code[class*=language-] ::selection {
  text-shadow: none;
  background: #dfe2f1;
}

/* Code blocks */
pre[class*=language-] {
  padding: 1.25rem;
  margin: 0;
  overflow: auto;
}

/* Inline code */
:not(pre) > code[class*=language-] {
  padding: 0.1em;
  border-radius: 0.3em;
}

.token.comment,
.token.prolog,
.token.doctype,
.token.cdata {
  color: #898ea4;
}

.token.punctuation {
  color: #5e6687;
}

.token.namespace {
  opacity: 0.7;
}

.token.operator,
.token.boolean,
.token.number {
  color: #c76b29;
}

.token.property {
  color: #c08b30;
}

.token.tag {
  color: #3d8fd1;
}

.token.string {
  color: #22a2c9;
}

.token.selector {
  color: #6679cc;
}

.token.attr-name {
  color: #c76b29;
}

.token.entity,
.token.url,
.language-css .token.string,
.style .token.string {
  color: #22a2c9;
}

.token.attr-value,
.token.keyword,
.token.control,
.token.directive,
.token.unit {
  color: #ac9739;
}

.token.statement,
.token.regex,
.token.atrule {
  color: #22a2c9;
}

.token.placeholder,
.token.variable {
  color: #3d8fd1;
}

.token.deleted {
  text-decoration: line-through;
}

.token.inserted {
  border-bottom: 1px dotted #202746;
  text-decoration: none;
}

.token.italic {
  font-style: italic;
}

.token.important,
.token.bold {
  font-weight: bold;
}

.token.important {
  color: #c94922;
}

.token.entity {
  cursor: help;
}

pre > code.highlight {
  outline: 0.4em solid #c94922;
  outline-offset: 0.4em;
}

/* overrides color-values for the Line Numbers plugin
 * http://prismjs.com/plugins/line-numbers/
 */
.line-numbers .line-numbers-rows {
  border-right-color: #dfe2f1;
}

.line-numbers-rows > span:before {
  color: #979db4;
}

/* overrides color-values for the Line Highlight plugin
 * http://prismjs.com/plugins/line-highlight/
 */
.line-highlight {
  background: rgba(107, 115, 148, 0.2);
  background: linear-gradient(to right, rgba(107, 115, 148, 0.2) 70%, rgba(107, 115, 148, 0));
}

.docs {
  background: #fff;
}
.docs h6 {
  font-size: 1rem;
  font-weight: 600;
}

.ct-content {
  order: 1;
}
.ct-content > h2[id],
.ct-content > h3[id],
.ct-content > h4[id] {
  pointer-events: none;
}
.ct-content > h2[id] > div,
.ct-content > h2[id] > a,
.ct-content > h3[id] > div,
.ct-content > h3[id] > a,
.ct-content > h4[id] > div,
.ct-content > h4[id] > a {
  pointer-events: auto;
}
.ct-content > h2[id]::before,
.ct-content > h3[id]::before,
.ct-content > h4[id]::before {
  display: block;
  height: 6rem;
  margin-top: -6rem;
  visibility: hidden;
  content: "";
}
.ct-content > table {
  width: 100%;
  max-width: 100%;
  margin-bottom: 1rem;
}
@media (max-width: 991.98px) {
  .ct-content > table {
    display: block;
    overflow-x: auto;
    -ms-overflow-style: -ms-autohiding-scrollbar;
  }
  .ct-content > table.table-bordered {
    border: 0;
  }
}
.ct-content > table > thead > tr > th,
.ct-content > table > thead > tr > td,
.ct-content > table > tbody > tr > th,
.ct-content > table > tbody > tr > td,
.ct-content > table > tfoot > tr > th,
.ct-content > table > tfoot > tr > td {
  padding: 1rem;
  vertical-align: top;
  border: 1px solid #e9ecef;
}
.ct-content > table > thead > tr > th > p:last-child,
.ct-content > table > thead > tr > td > p:last-child,
.ct-content > table > tbody > tr > th > p:last-child,
.ct-content > table > tbody > tr > td > p:last-child,
.ct-content > table > tfoot > tr > th > p:last-child,
.ct-content > table > tfoot > tr > td > p:last-child {
  margin-bottom: 0;
}
.ct-content > table td:first-child > code {
  white-space: nowrap;
}

.ct-content > h2:not(:first-child) {
  margin-top: 3rem;
  font-size: 1.5rem;
  font-weight: 600;
}
.ct-content > h3 {
  margin-top: 2.5rem;
  font-size: 1.25rem;
  font-weight: 600;
}
.ct-content > ul li,
.ct-content > ol li {
  margin-bottom: 0.25rem;
}
@media (min-width: 992px) {
  .ct-content > ul,
  .ct-content > ol,
  .ct-content > p {
    max-width: 80%;
  }
}

.ct-page-title {
  padding-left: 1.25rem;
  border-left: 2px solid #3ba371;
  margin-bottom: 1.5rem;
}

.ct-title {
  margin-top: 1rem;
  margin-bottom: 0.5rem;
  font-weight: 300;
}
@media (min-width: 576px) {
  .ct-title {
    font-size: 1.5rem;
    font-weight: 600;
  }
}

.ct-lead {
  color: rgb(59, 69, 78);
  font-weight: 500;
}
@media (min-width: 576px) {
  .ct-lead {
    max-width: 80%;
    margin-bottom: 1rem;
    font-size: 0.875rem;
  }
}

.ct-text-purple {
  color: #3ba371;
}

.ct-text-purple-bright {
  color: rgb(94.4219594595, 204.0780405405, 151.35877079);
}

.ct-tabs-example .nav-link i {
  margin-right: 5px;
}

.color-swatch {
  margin: 1rem 0;
  border-radius: 0.25rem;
  background-color: #f4f5f7;
}

.color-swatch:after {
  content: " ";
  display: table;
  clear: both;
}

.color-swatch-header {
  position: relative;
  height: 0;
  padding-bottom: 50%;
  border-radius: 0.25rem 0.25rem 0 0;
  border: 1px solid transparent;
}

.color-swatch-header.is-light {
  border-color: #c1c7d0;
}

.color-swatch-header .pass-fail {
  position: absolute;
  width: 100%;
  bottom: 0;
}

.color-swatch-header .pass-fail-item-wrap {
  position: relative;
  float: left;
  left: 50%;
  transform: translateX(-50%);
}

.color-swatch-header .pass-fail-item-group {
  display: inline-block;
  padding: 0 5px;
}

.color-swatch-header .pass-fail-item {
  float: left;
  display: inline-block;
  text-align: center;
  padding: 2px;
}

.color-swatch-header .pass-fail-item.white .example {
  color: #fff;
}

.color-swatch-header .pass-fail-item.small .example {
  font-size: 10px;
}

.color-swatch-header .pass-fail-item .lozenge {
  font-size: 11px;
  text-transform: uppercase;
  font-weight: 600;
  background: #000;
  color: #fff;
  padding: 2px 4px;
  line-height: 10px;
  border-radius: 4px;
  letter-spacing: 0.05em;
}

.color-swatch-body {
  position: relative;
  left: 50%;
  float: left;
  padding: 10px 0;
  transform: translateX(-50%);
}

.color-swatch-body .prop-item-wrap {
  float: left;
  padding: 0 15px;
  min-width: 65px;
}

.color-swatch-body .prop-item {
  padding: 15px 0;
}

.color-swatch-body .prop-item .label {
  font-size: 11px;
  color: #62748c;
  text-transform: uppercase;
  line-height: 16px;
}

.color-swatch-body .prop-item .value {
  font-size: 14px;
}

.table-colors {
  font-weight: 600;
  font-size: 16px;
  width: 100%;
}

.table-colors td,
.table-colors:first-child td,
.table-colors td:first-child,
.table-colors:first-child td:first-child,
.table-colors td:last-child,
.table-colors:first-child td:last-child {
  background: rgba(255, 255, 255, 0.9);
  border-bottom: 1px solid rgba(0, 0, 0, 0.1);
  padding: 10px;
}

.table-colors tr:last-child td,
.table-colors:first-child tr:last-child td {
  border-bottom: none;
}

.table-colors td:nth-child(1),
.table-colors:first-child td:nth-child(1) {
  line-height: 40px;
}

.table-colors .swatch,
.table-colors:first-child .swatch {
  float: left;
  height: 40px;
  width: 40px;
  margin-right: 20px;
  display: inline-block;
  border-radius: 4px;
  border: 1px solid transparent;
}

.table-colors .swatch.is-light,
.table-colors:first-child .swatch.is-light {
  border-color: #c1c7d0;
}

.table-colors .lozenge,
.table-colors:first-child .lozenge {
  float: left;
  margin: 5px 10px 0 0;
  font-size: 10px;
  display: inline-block;
  text-transform: uppercase;
  font-weight: 600;
  background: #97a0af;
  color: #042a53;
  padding: 2px 4px;
  line-height: 10px;
  border-radius: 4px;
  letter-spacing: 0.05em;
}

.ct-toc {
  order: 2;
  padding-top: 2rem;
  padding-bottom: 1.5rem;
  font-size: 0.875rem;
}
@supports (position: sticky) {
  .ct-toc {
    position: sticky;
    top: 4rem;
    height: calc(100vh - 4rem);
    overflow-y: auto;
  }
}

.section-nav {
  padding-left: 0;
  border-left: 1px solid #eee;
}
.section-nav ul {
  padding-left: 1rem;
}
.section-nav ul ul {
  display: none;
}

.toc-entry {
  display: block;
  font-size: 1rem;
}
.toc-entry a {
  display: block;
  padding: 0.125rem 1.5rem;
  color: #99979c;
  font-size: 90%;
}
.toc-entry a:hover {
  color: #3ba371;
  text-decoration: none;
}

.ct-sidebar {
  order: 0;
  border-bottom: 1px solid #e6ecf1;
  background-color: #f5f7f9;
}
@media (min-width: 768px) {
  .ct-sidebar {
    border-right: 1px solid #e6ecf1;
  }
  @supports (position: sticky) {
    .ct-sidebar {
      position: sticky;
      top: 4rem;
      z-index: 1000;
      height: calc(100vh - 4rem);
    }
  }
}
@media (min-width: 1200px) {
  .ct-sidebar {
    flex: 0 1 320px;
  }
}

.ct-links {
  padding-top: 2rem;
  padding-bottom: 1rem;
  margin-right: -15px;
  margin-left: -15px;
}
@media (min-width: 768px) {
  @supports (position: sticky) {
    .ct-links {
      max-height: calc(100vh - 5rem);
      overflow-y: auto;
    }
  }
}
@media (min-width: 768px) {
  .ct-links {
    display: block !important;
  }
}

.ct-search {
  position: relative;
  padding: 1rem 15px;
  margin-right: -15px;
  margin-left: -15px;
  border-bottom: 1px solid rgba(0, 0, 0, 0.05);
}
.ct-search .form-control:focus {
  border-color: rgb(94.4219594595, 204.0780405405, 151.35877079);
  box-shadow: 0 0 0 3px rgba(94.4219594595, 204.0780405405, 151.35877079, 0.25);
}

.ct-search-docs-toggle {
  line-height: 1;
  color: #212529;
}

.ct-sidenav {
  display: none;
}

.ct-toc-link {
  display: block;
  padding: 0.25rem 1.5rem;
  font-weight: 600;
  font-size: 0.875rem;
  color: #0d2b3e;
}
.ct-toc-link:hover {
  color: rgba(0, 0, 0, 0.85);
  text-decoration: none;
}

.ct-toc-item.active {
  margin-bottom: 1rem;
}
.ct-toc-item.active:not(:first-child) {
  margin-top: 1rem;
}
.ct-toc-item.active > .ct-toc-link {
  color: rgba(0, 0, 0, 0.85);
}
.ct-toc-item.active > .ct-toc-link:hover {
  background-color: transparent;
}
.ct-toc-item.active > .ct-sidenav {
  display: block;
}

.ct-sidebar .nav > li > a {
  display: block;
  padding: 0.25rem 1.5rem;
  font-size: 84%;
  color: #4c555a;
}

.ct-sidebar .nav > li > a:hover {
  color: rgba(0, 0, 0, 0.85);
  text-decoration: none;
  background-color: transparent;
}

.ct-sidebar .nav > .active > a {
  font-weight: 500;
  color: #0099e5;
  background-color: transparent;
  padding-left: 2rem;
  position: relative;
}
.ct-sidebar .nav > .active > a:before {
  content: "";
  position: absolute;
  height: 16px;
  width: 2px;
  background-color: #0099e5;
  top: 50%;
  left: 1.5rem;
  transform: translateY(-50%);
}

.ct-sidebar .nav > .active:hover > a {
  color: #0099e5;
}

.scrollbar-inner {
  height: 100%;
}
.scrollbar-inner:not(:hover) .scroll-element {
  opacity: 0;
}
.scrollbar-inner .scroll-element {
  transition: opacity 300ms;
  margin-right: 2px;
}
.scrollbar-inner .scroll-element .scroll-bar,
.scrollbar-inner .scroll-element .scroll-element_track {
  transition: background-color 300ms;
}
.scrollbar-inner .scroll-element .scroll-element_track {
  background-color: transparent;
}
.scrollbar-inner .scroll-element.scroll-y {
  width: 3px;
  right: 0;
}
.scrollbar-inner .scroll-element.scroll-x {
  height: 3px;
  bottom: 0;
}

.ct-footer {
  font-size: 85%;
  text-align: center;
  background-color: #f7f7f7;
}
.ct-footer a {
  font-weight: 500;
  color: #525f7f;
}
.ct-footer a:hover, .ct-footer a:focus {
  color: #3ba371;
}
.ct-footer p {
  margin-bottom: 0;
}
@media (min-width: 576px) {
  .ct-footer {
    text-align: left;
  }
}

.ct-footer-links {
  padding-left: 0;
  margin-bottom: 1rem;
}
.ct-footer-links li {
  display: inline-block;
}
.ct-footer-links li + li {
  margin-left: 1rem;
}

@keyframes spinner-border {
  to {
    transform: rotate(360deg);
  }
}
.spinner-border {
  display: inline-block;
  width: 2rem;
  height: 2rem;
  vertical-align: text-bottom;
  border: 0.25em solid currentColor;
  border-right-color: transparent;
  border-radius: 50%;
  animation: 0.75s linear infinite spinner-border;
}

.spinner-border-sm {
  width: 1rem;
  height: 1rem;
  border-width: 0.2em;
}

@keyframes spinner-grow {
  0% {
    transform: scale(0);
  }
  50% {
    opacity: 1;
    transform: none;
  }
}
.spinner-grow {
  display: inline-block;
  width: 2rem;
  height: 2rem;
  vertical-align: text-bottom;
  background-color: currentColor;
  border-radius: 50%;
  opacity: 0;
  animation: 0.75s linear infinite spinner-grow;
}

.spinner-grow-sm {
  width: 1rem;
  height: 1rem;
}

@media (prefers-reduced-motion: reduce) {
  .spinner-border,
  .spinner-grow {
    animation-duration: 1.5s;
  }
}
/*!
* https://github.com/YouCanBookMe/react-datetime
*/
.rdt {
  position: relative;
}
.rdt .rdtPicker {
  transition: all 150ms linear;
  margin-top: -20px;
  visibility: hidden;
  display: block;
  opacity: 0;
}
.rdt.rdtOpen .rdtPicker {
  opacity: 1;
  visibility: visible;
  margin-top: 0;
}

.rdtPicker {
  display: none;
  position: absolute;
  padding: 20px;
  margin-top: 1px;
  z-index: 99999 !important;
  background: #fff;
  border-radius: 0.375rem;
  box-shadow: 0px 10px 50px 0px rgba(0, 0, 0, 0.2);
  background-clip: padding-box;
  min-width: 160px;
}
.rdtPicker:before {
  display: inline-block;
  position: absolute;
  width: 0;
  height: 0;
  vertical-align: middle;
  content: "";
  top: -5px;
  left: 10px;
  right: auto;
  color: #ffffff;
  border-bottom: 0.4em solid;
  border-right: 0.4em solid transparent;
  border-left: 0.4em solid transparent;
}
.rdtPicker:after {
  border-bottom: 0.4em solid #ffffff;
  border-right: 0.4em solid transparent;
  border-left: 0.4em solid transparent;
  content: "";
  display: inline-block;
  position: absolute;
  top: -5px;
  left: 10px;
}

.rdtPicker {
  display: block;
  top: 40px;
}

.rdtStatic .rdtPicker {
  box-shadow: none;
  position: static;
}

.rdtPicker .rdtTimeToggle {
  text-align: center;
  padding: 10px;
  border-radius: 4px;
  visibility: hidden;
  position: relative;
}
.rdtPicker .rdtTimeToggle:before {
  visibility: visible;
  width: 100%;
  height: 100%;
  border-radius: 3px;
  position: absolute;
  top: 0;
  left: 0;
  display: flex;
  justify-content: center;
  align-items: center;
  font: normal normal normal 1em/1 "Nucleo";
  font-size: 18px;
  content: "\\ea5e";
}

.rdtPicker table {
  width: 100%;
  margin: 0;
  border-color: #fff !important;
}

.rdtPicker td,
.rdtPicker th {
  text-align: center;
  padding: 1px;
}

.rdtPicker td {
  cursor: pointer;
}

.rdtDay {
  font-size: 0.875rem;
  width: 36px;
  height: 36px;
  transition: all 0.15s ease;
  text-align: center;
  border: none;
  border-radius: 50%;
}
.rdtDay.rdtToday.rdtActive, .rdtDay.rdtActive, .rdtDay.rdtActive:hover, .rdtDay.start-date, .rdtDay.end-date, .rdtDay.middle-date, .rdtDay.start-date:hover, .rdtDay.end-date:hover, .rdtDay.middle-date:hover {
  background-color: #278e69 !important;
  color: #fff !important;
}
.rdtDay.start-date {
  border-top-right-radius: 0;
  border-bottom-right-radius: 0;
}
.rdtDay.middle-date {
  border-radius: 0;
}
.rdtDay.end-date {
  border-top-left-radius: 0;
  border-bottom-left-radius: 0;
}

.rdtDays tr .dow {
  text-align: center;
  font-size: 12px;
  font-weight: inherit;
  padding-bottom: 5px;
  padding-top: 10px;
  font-weight: 300;
  font-size: 0.875rem;
  width: 20px;
  height: 20px;
}
.rdtDays tr .rdtDay {
  color: #525f7f;
  font-size: 0.875rem;
}
.rdtDays tr .rdtDay.rdtOld, .rdtDays tr .rdtDay.rdtNew {
  color: #adb5bd;
  font-weight: 300;
}

.rdtPicker td.rdtDay:hover,
.rdtPicker td.rdtHour:hover,
.rdtPicker td.rdtMinute:hover,
.rdtPicker td.rdtSecond:hover,
.rdtPicker .rdtTimeToggle:hover,
.rdtPicker .rdtTimeToggle:hover:before {
  background: #eeeeee;
  cursor: pointer;
}

.rdtPicker td.rdtToday {
  position: relative;
}

.rdtPicker td.rdtActive.rdtToday:before {
  border-bottom-color: #fff;
}

.rdtPicker td.rdtDisabled,
.rdtPicker td.rdtDisabled:hover {
  background: none;
  color: #999999;
  cursor: not-allowed;
}

.rdtPicker td span.rdtOld {
  color: #999999;
}

.rdtPicker td span.rdtDisabled,
.rdtPicker td span.rdtDisabled:hover {
  background: none;
  color: #999999;
  cursor: not-allowed;
}

.rdtPicker tr .dow {
  width: 14.2857%;
  border-bottom: none;
  font-size: 0.875rem;
  width: 36px;
  height: 36px;
  transition: all 0.15s ease;
  text-align: center;
  border: none;
  font-weight: 500;
  border-radius: 0.375rem;
}

.rdtPicker th.rdtSwitch {
  font-weight: 500;
  border-radius: 0.375rem;
  font-size: 0.875rem;
  width: 145px;
  height: 36px;
  transition: all 0.15s ease;
  text-align: center;
  border: none;
}

.rdtPicker th.rdtNext,
.rdtPicker th.rdtPrev {
  font-size: 0.875rem;
  width: 36px;
  height: 36px;
  transition: all 0.15s ease;
  text-align: center;
  border: none;
  border-radius: 0.375rem;
  cursor: pointer;
}

.rdtPicker .dow,
.rdtPicker th.rdtSwitch,
.rdtPicker th.rdtNext,
.rdtPicker th.rdtPrev,
.rdtPicker .rdtTimeToggle {
  color: #525f7f;
}

.rdtPrev span,
.rdtNext span {
  display: block;
  -webkit-touch-callout: none; /* iOS Safari */
  -webkit-user-select: none; /* Chrome/Safari/Opera */ /* Konqueror */ /* Firefox */ /* Internet Explorer/Edge */
  user-select: none;
}

.rdtPicker th.rdtDisabled,
.rdtPicker th.rdtDisabled:hover {
  background: none;
  color: #999999;
  cursor: not-allowed;
}

.rdtPicker thead tr:first-child th {
  cursor: pointer;
}

.rdtPicker thead tr:first-child th:hover {
  background: #eeeeee;
}

.rdtPicker button {
  border: none;
  background: none;
  cursor: pointer;
}

.rdtPicker button:hover {
  background-color: #eee;
}

.rdtPicker thead button {
  width: 100%;
  height: 100%;
}

td.rdtMonth,
td.rdtYear {
  height: 50px;
  width: 25%;
  cursor: pointer;
}

td.rdtMonth:hover,
td.rdtYear:hover {
  background: #eee;
}

.rdtCounters {
  display: inline-block;
}

.rdtCounters > div {
  float: left;
  width: 40px;
  font-weight: inherit;
  margin: 3px;
  border-radius: 50%;
}
.rdtCounters .rdtCounterSeparator {
  width: 0;
  border: 1px solid transparent;
}

.rdtCounter {
  height: 100px;
}

.rdtCounter {
  width: 40px;
}
.rdtCounter .rdtCount {
  padding: 7px;
  height: 40px;
  border: 1px solid transparent;
}

.rdtCounters .rdtCounter:last-child .rdtCount {
  color: #278e69;
  border-radius: 50%;
  border: 1px solid #278e69;
}

.rdtCounterSeparator {
  padding: 7px;
  line-height: 100px;
}

.rdtCounter .rdtBtn {
  line-height: 40px;
  cursor: pointer;
  display: block;
  border-radius: 50%;
  color: #adb5bd;
  transition: all 60ms ease-in;
  -webkit-touch-callout: none; /* iOS Safari */
  -webkit-user-select: none; /* Chrome/Safari/Opera */ /* Konqueror */ /* Firefox */ /* Internet Explorer/Edge */
  user-select: none;
}

.rdtCounter .rdtBtn:hover {
  background: #eee;
  color: #797979;
}

.rdtCounter .rdtCount {
  font-size: inherit;
  line-height: 25px;
}

.rdtMilli {
  vertical-align: middle;
  padding-left: 8px;
  width: 48px;
}

.rdtMilli input {
  width: 100%;
  font-size: inherit;
  margin-top: 37px;
}

.rdtMonths,
.rdtYears {
  padding-bottom: 10px;
}
.rdtMonths .rdtMonth,
.rdtMonths .rdtYear,
.rdtYears .rdtMonth,
.rdtYears .rdtYear {
  display: inline-block;
  width: 56px;
  height: 56px;
  line-height: 56px;
  margin: 3px 3px;
  cursor: pointer;
  border-radius: 50%;
  text-align: center;
}
.rdtMonths .rdtMonth.rdtActive, .rdtMonths .rdtMonth.start-date, .rdtMonths .rdtMonth.end-date, .rdtMonths .rdtMonth.middle-date,
.rdtMonths .rdtYear.rdtActive,
.rdtMonths .rdtYear.start-date,
.rdtMonths .rdtYear.end-date,
.rdtMonths .rdtYear.middle-date,
.rdtYears .rdtMonth.rdtActive,
.rdtYears .rdtMonth.start-date,
.rdtYears .rdtMonth.end-date,
.rdtYears .rdtMonth.middle-date,
.rdtYears .rdtYear.rdtActive,
.rdtYears .rdtYear.start-date,
.rdtYears .rdtYear.end-date,
.rdtYears .rdtYear.middle-date {
  background-color: #278e69 !important;
  color: #fff;
}

.input-group .input-group-prepend + .rdt .form-control {
  border-top-left-radius: 0;
  border-bottom-left-radius: 0;
}

.input-group .input-group-prepend + .rdt .form-control {
  border-top-left-radius: 0;
  border-bottom-left-radius: 0;
}

.input-group > .rdt:not(:last-child) .form-control {
  border-top-right-radius: 0;
  border-bottom-right-radius: 0;
}

.form-group .rdt {
  width: 1%;
  margin-bottom: 0;
  flex: 1 1 auto;
}

.btn .btn-inner--icon {
  margin-right: 4px;
}

.btn + .btn {
  margin-left: 4px;
}

button:focus,
:focus {
  outline: none;
}

@keyframes show-navbar-dropdown {
  0% {
    opacity: 0;
    transition: visibility 0.25s, opacity 0.25s;
  }
  100% {
    opacity: 1;
  }
}
.navbar .collapsing .navbar-toggler {
  pointer-events: none;
}

.navbar .nav-item .nav-link-icon.nav-link i {
  margin-right: 4px;
}

.table .avatar-group .avatar {
  margin-right: 4px;
}
.table .badge i {
  margin-right: 10px;
}

.s-table--content-list tr:last-child {
  border-bottom: none !important;
}

.u-max-width--16 {
  max-width: 1rem;
}

.u-flex--16 {
  flex: 0 0 1rem;
}

.u-background--color-blue-1-1 {
  background: #f3f9ff;
}

.u-min-height--53 {
  min-height: 3.3125rem;
}

.u-width--5-p {
  width: 5%;
}
.u-width--95-p {
  width: 95%;
}

.u-cursor--pointer {
  cursor: pointer;
}

@media all and (max-width: 1366px) {
  ._u-font-size--12 {
    font-size: 0.75rem;
  }
}
.normal-user .left-column .left-inner {
  max-width: 749px;
  padding-top: 70px;
  padding-left: 66px;
  padding-right: 66px;
  padding-bottom: 130px;
}
@media all and (max-width: 991px) {
  .normal-user .left-column .left-inner {
    padding-top: 35px;
    padding-left: 16px;
    padding-right: 16px;
    padding-bottom: 65px;
  }
}
@media all and (max-width: 991px) {
  .normal-user .left-column .left-inner .radio-btn-wrap {
    justify-content: space-between;
  }
}
.normal-user .left-column .left-inner .radio-btn-wrap .mr-18 {
  margin-right: 18px;
}
.normal-user .left-column .left-inner .radio-btn-wrap .mr-10 {
  margin-right: 10px;
}
.normal-user .left-column .left-inner .radio-btn-wrap p {
  color: #393939;
  font-size: 15px;
  font-weight: 400;
  line-height: 22.5px;
}
.normal-user .left-column h2 {
  font-size: 45px;
  font-weight: 600;
  line-height: 57px;
  color: #393939;
}
.normal-user .left-column h2 span {
  font-size: 18px;
  font-weight: 400;
  line-height: 27px;
}
.normal-user .left-column .form-inputs .input-field .input-wrapper input {
  color: #717171;
  border: 0;
  border-bottom: 1px solid #b1b1b1;
  width: 100%;
  background: transparent;
  padding: 0 0 8px 0;
}
.normal-user .left-column .form-inputs .input-field .input-wrapper .toggle-password-btn {
  border: 0;
  border-bottom: 1px solid #b1b1b1;
  background: transparent;
  padding: 0;
  margin: 0;
}
.normal-user .left-column .form-inputs .input-field .input-wrapper .toggle-password-btn svg {
  fill: #cc9752;
}
.normal-user .left-column .form-inputs label {
  color: #393939;
  font-size: 15px;
  font-weight: 400;
  line-height: 22.5px;
}
.normal-user .left-column .form-inputs label .image-container {
  margin-left: 8px;
  width: 14px;
  height: 14px;
}
.normal-user .left-column .custom-checkbox {
  display: flex;
  align-items: center;
}
.normal-user .left-column .custom-checkbox input[type=checkbox] {
  position: absolute;
  opacity: 0;
  width: 0;
  height: 0;
}
.normal-user .left-column .custom-checkbox input[type=checkbox]:checked + .custom-checkbox-box {
  background-color: #cc9752;
  border-color: #cc9752;
}
.normal-user .left-column .custom-checkbox input[type=checkbox]:checked + .custom-checkbox-box .checkbox-icon {
  display: flex;
}
.normal-user .left-column .custom-checkbox .custom-checkbox-box {
  width: 18px;
  height: 18px;
  border: 1px solid #cc9752;
  background: #fff;
  display: flex;
  align-items: center;
  justify-content: center;
  position: relative;
  margin-right: 8px;
  border-radius: 2px;
  padding: 3px;
  box-sizing: border-box;
  transition: background-color 0.2s ease;
  cursor: pointer;
  margin-bottom: 0;
}
.normal-user .left-column .custom-checkbox .checkbox-icon {
  color: #fff;
  font-size: 14px;
  display: none;
}
.normal-user .left-column .custom-checkbox .checkbox-label {
  margin-left: 8px;
  color: #393939;
}
.normal-user .left-column .custom-checkbox .checkbox-label .highlighted-text {
  color: #cc9752;
}
.normal-user .left-column .btn.bordered {
  border: 1px solid #cc9752;
  font-size: 18px;
  font-weight: 500;
  line-height: 27px;
  cursor: pointer;
  padding-top: 13px;
  padding-bottom: 13px;
  padding-left: 50px;
  padding-right: 50px;
  border-radius: 24.5px;
  background: transparent;
  outline: 0;
  color: #cc9752;
  box-shadow: none;
}
.normal-user .left-column .btn.no-bordered.custom-btn-primary {
  font-size: 18px;
  font-weight: 500;
  line-height: 27px;
  cursor: pointer;
  padding-top: 13px;
  padding-bottom: 13px;
  padding-left: 50px;
  padding-right: 50px;
  border-radius: 24.5px;
  background: #cc9752;
  border: 0;
  outline: 0;
  transition: background-color 0.3s ease, color 0.3s ease;
  color: #fff;
  box-shadow: none;
}
.normal-user .left-column .btn.no-bordered.custom-btn-primary:hover {
  background: #cc9752;
  box-shadow: none;
}
.normal-user .left-column .signup-link p {
  font-size: 14px;
  line-height: 21px;
  font-weight: 400;
  color: #393939;
}
.normal-user .left-column .signup-link a {
  font-weight: 500;
  color: #cc9752;
}
.normal-user .right-column img {
  width: 100%;
  height: 100%;
  object-fit: cover;
}

.radio-button-container .custom-radio-input {
  display: none;
}
.radio-button-container .custom-radio-input:checked + .custom-radio-label {
  border: 2px solid #cc9752;
  background-color: transparent;
  box-shadow: none;
}
.radio-button-container .custom-radio-input:checked + .custom-radio-label .radio-button-text {
  color: #cc9752;
}
.radio-button-container .custom-radio-input:checked + .custom-radio-label .outer-circle .inner-circle {
  background-color: #cc9752;
}
.radio-button-container .custom-radio-label {
  max-width: fit-content;
  display: flex;
  align-items: center;
  background-color: #fff;
  border: 2px solid transparent;
  border-radius: 24.5px;
  padding: 10px 32px;
  box-shadow: 0 2px 4px rgba(127, 17, 224, 0.2);
  cursor: pointer;
  transition: all 0.2s ease;
  margin-bottom: 0;
}
.radio-button-container .custom-radio-label .radio-button .outer-circle {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 20px;
  height: 20px;
  border: 2px solid #cc9752;
  border-radius: 50%;
  margin-right: 8px;
  position: relative;
  transition: border-color 0.2s ease;
}
.radio-button-container .custom-radio-label .radio-button .outer-circle .inner-circle {
  width: 10px;
  height: 10px;
  border-radius: 50%;
  background-color: transparent;
  transition: background-color 0.2s ease;
}
.radio-button-container .custom-radio-label .radio-button-text {
  font-size: 15px;
  font-weight: 400;
  line-height: 22.5px;
  color: #717171;
}
.radio-button-container .custom-radio-label:hover, .radio-button-container .custom-radio-label:active {
  border: 2px solid #cc9752;
  background-color: transparent;
  box-shadow: none;
}
.radio-button-container .custom-radio-label:hover .radio-button-text, .radio-button-container .custom-radio-label:active .radio-button-text {
  color: #cc9752;
}

.password-strength-container {
  gap: 10px;
}
.password-strength-container .password-strength-indicator {
  gap: 5px;
}
.password-strength-container .password-strength-indicator label {
  display: flex;
  margin-bottom: 0;
}
.password-strength-container .password-strength-indicator .line {
  width: 40px;
  height: 5px;
  border-radius: 2px;
  background-color: #c6bdaf;
  transition: background-color 0.3s;
  margin-left: 5px;
  width: 40px;
  height: 5px;
  border-radius: 2px;
  background-color: #c6bdaf; /* Default color */
  transition: background-color 0.3s;
}
.password-strength-container .password-strength-indicator .line.filled {
  background-color: #19b25f;
}
.password-strength-container .password-strength-indicator .strength-text {
  font-weight: normal;
  color: #19b25f;
}

.progress-container {
  padding: 45px 33px;
}
.progress-container .step-wrapper {
  z-index: 1;
  position: relative;
  margin-top: -21px;
}
.progress-container .step-wrapper ul {
  list-style-type: none;
  display: flex;
}
.progress-container .step-wrapper ul li {
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 236px;
  text-align: center;
  position: relative;
}
.progress-container .step-wrapper ul li::after {
  content: "";
  position: absolute;
  width: 100%;
  height: 2px;
  background-color: #d9d9d9;
  top: 24%;
  left: -50%;
  z-index: -1;
}
.progress-container .step-wrapper ul li:first-child::after {
  content: none;
}
.progress-container .step-wrapper ul li .icon {
  width: 40px;
  height: 40px;
  background-color: #f9f5ef;
  border: 1px solid #717171;
  outline: 5px solid #f9f5ef;
  border-radius: 50%;
  display: flex;
  justify-content: center;
  align-items: center;
}
.progress-container .step-wrapper ul li .icon span {
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
}
.progress-container .step-wrapper ul li .icon span svg {
  width: 14px;
  height: auto;
}
.progress-container .step-wrapper ul li .text {
  color: #717171;
}
.progress-container .step-wrapper ul li.active::after {
  background-color: #42826c;
}
.progress-container .step-wrapper ul li.active .icon {
  background-color: #42826c;
}
.progress-container .step-wrapper ul li.active .icon span svg {
  stroke: #fff;
}
.progress-container .step-wrapper ul li.active .text {
  color: #42826c;
}
.progress-container .step-wrapper ul li:nth-child(1) .icon span svg {
  fill: #fff;
}

.dob-picker-container h2.react-datepicker__current-month {
  font-size: 16px;
}
.dob-picker-container .dob-picker-label {
  display: block;
}
.dob-picker-container .dob-picker-input-wrapper {
  position: relative;
}
.dob-picker-container .dob-picker-input-wrapper .react-datepicker-wrapper {
  width: 100%;
}
.dob-picker-container .dob-picker-input-wrapper .react-datepicker-wrapper .dob-picker-input {
  background: transparent;
  color: #717171;
  border: 0;
  border-bottom: 1px solid #b1b1b1;
  width: 100%;
  background: transparent;
  padding: 0 0 8px 0;
}
.dob-picker-container .dob-picker-input-wrapper .dob-picker-icon {
  position: absolute;
  right: 0;
  top: 45%;
  transform: translateY(-50%);
  font-size: 18px;
  cursor: pointer;
}
.dob-picker-container .dob-picker-input-wrapper svg {
  fill: #cc9752;
}

.dropdown-custom {
  display: flex;
  flex-direction: column;
  width: 200px;
}
.dropdown-custom .dropdown-title-custom {
  color: #393939;
  font-size: 15px;
  font-weight: 400;
  line-height: 22.5px;
}
.dropdown-custom .dropdown-container-custom {
  position: relative;
  display: flex;
  align-items: center;
  cursor: pointer;
  background: transparent;
  color: #717171;
  border: 0;
  border-bottom: 1px solid #b1b1b1;
  width: 100%;
  background: transparent;
  padding: 0 0 8px 0;
}
.dropdown-custom .dropdown-container-custom .dropdown-selected-custom {
  flex: 1 1;
}
.dropdown-custom .dropdown-container-custom .dropdown-arrow {
  margin-left: 8px;
  width: 18px;
  height: 18px;
}
.dropdown-custom .dropdown-container-custom .dropdown-arrow svg {
  width: 18px;
  height: 18px;
  fill: #333333;
}
.dropdown-custom .dropdown-menu-custom {
  position: absolute;
  top: 40px;
  left: 0;
  right: 0;
  border: 1px solid #ccc;
  border-top: none;
  background-color: #fff;
  box-shadow: 0px 4px 8px rgba(0, 0, 0, 0.1);
  border-radius: 4px;
  z-index: 1000;
  width: 100%;
}
.dropdown-custom .dropdown-menu-custom .dropdown-option-custom {
  padding: 8px;
  cursor: pointer;
}
.dropdown-custom .dropdown-menu-custom .dropdown-option-custom:hover {
  background-color: #f0f0f0;
}

.dropdown-numbers {
  display: flex;
  flex-direction: column;
}
.dropdown-numbers .dropdown-title-custom {
  color: #393939;
  font-size: 15px;
  font-weight: 400;
  line-height: 22.5px;
}
.dropdown-numbers .dropdown-container-custom {
  position: relative;
  display: flex;
  align-items: center;
  cursor: pointer;
  background: transparent;
  color: #717171;
  border: 0;
  border-bottom: 1px solid #b1b1b1;
  width: 100%;
  background: transparent;
  padding: 0 0 8px 0;
}
.dropdown-numbers .dropdown-container-custom .input {
  width: 100%;
  cursor: text;
}
.dropdown-numbers .dropdown-container-custom .input input {
  width: 100%;
  cursor: text;
}
.dropdown-numbers .dropdown-container-custom .dropdown-selected-custom {
  flex: 1 1;
}
.dropdown-numbers .dropdown-container-custom .dropdown-arrow {
  margin-left: 0;
  width: 18px;
  height: 18px;
}
.dropdown-numbers .dropdown-container-custom .dropdown-arrow svg {
  width: 18px;
  height: 18px;
  fill: #333333;
}
.dropdown-numbers .dropdown-menu-custom {
  position: absolute;
  top: 100%;
  left: 0;
  right: 0;
  border: 1px solid #ccc;
  border-top: none;
  background-color: #fff;
  box-shadow: 0px 4px 8px rgba(0, 0, 0, 0.1);
  border-radius: 4px;
  z-index: 1000;
}
.dropdown-numbers .dropdown-menu-custom .dropdown-option-custom {
  padding: 8px;
  cursor: pointer;
}
.dropdown-numbers .dropdown-menu-custom .dropdown-option-custom:hover {
  background-color: #f0f0f0;
}

input[type=number]::-webkit-inner-spin-button,
input[type=number]::-webkit-outer-spin-button,
input[type=number] {
  -webkit-appearance: none;
  -moz-appearance: textfield;
  margin: 0;
  border: 0;
  outline: 0;
  box-shadow: none;
  background-color: transparent;
  cursor: default;
}

.upload-btn .title {
  font-size: 15px;
  font-weight: 400;
  line-height: 22.5px;
  text-align: left;
  color: #393939;
}
.upload-btn .upload-box {
  background-image: repeating-linear-gradient(0deg, #beb5a6, #beb5a6 6px, transparent 6px, transparent 12px, #beb5a6 12px), repeating-linear-gradient(90deg, #beb5a6, #beb5a6 6px, transparent 6px, transparent 12px, #beb5a6 12px), repeating-linear-gradient(180deg, #beb5a6, #beb5a6 6px, transparent 6px, transparent 12px, #beb5a6 12px), repeating-linear-gradient(270deg, #beb5a6, #beb5a6 6px, transparent 6px, transparent 12px, #beb5a6 12px);
  background-size: 2px 100%, 100% 2px, 2px 100%, 100% 2px;
  background-position: 0 0, 0 0, 100% 0, 0 100%;
  background-repeat: no-repeat;
  border-radius: 4px;
}
.upload-btn .upload-box .upload-wrapper {
  position: relative;
}
.upload-btn .upload-box .upload-wrapper svg {
  width: 22px;
  height: 22px;
  stroke: #cc9752;
}
.upload-btn .upload-box .upload-wrapper p span {
  color: #393939;
}
.upload-btn .upload-box .upload-wrapper input.hidden-file {
  opacity: 0;
  width: 1005;
  height: 100%;
  position: absolute;
  top: 0;
  left: 0;
  cursor: pointer;
}
.upload-btn .upload-box .signature-wrap .container {
  max-height: 108px;
}
.upload-btn .upload-box .signature-wrap canvas {
  width: 100%;
  height: 100%;
}

.popup-container {
  position: fixed;
  top: 0;
  left: 0;
  left: 0;
  bottom: 0;
  width: 100vw;
  height: 100%;
  background: rgba(0, 0, 0, 0.5);
  z-index: 1000;
}
.popup-container .close {
  position: absolute;
  top: 24px;
  right: 34px;
  opacity: 1;
}
.popup-container .close svg {
  width: 34px;
  height: 34px;
  stroke: #393939;
  cursor: pointer;
}
.popup-container .popupWrapper {
  max-width: 525px;
  max-height: 422px;
  border-radius: 10px;
  background-color: #fff;
  position: relative;
}
.popup-container .popupWrapper .popup .icon {
  background-color: #42826c;
  width: 54px;
  height: 54px;
  border-radius: 50%;
  box-sizing: border-box;
}
.popup-container .popupWrapper .popup .icon svg {
  stroke: #fff;
}
.popup-container .popupWrapper .popup h2 {
  font-size: 28px;
  font-weight: 700;
  line-height: 42px;
  text-align: center;
  color: #42826c;
}
.popup-container .popupWrapper .popup .light-text {
  font-size: 15px;
  font-weight: 400;
  line-height: 26px;
  color: #717171;
  text-align: center;
}
.popup-container .popupWrapper .popup .dark-text {
  max-width: 427px;
  font-size: 15px;
  font-weight: 400;
  line-height: 26px;
  color: #393939;
  text-align: center;
}
.popup-container .popupWrapper .popup .btn.no-bordered.custom-btn-primary {
  max-width: 318px;
  font-size: 18px;
  font-weight: 500;
  line-height: 27px;
  cursor: pointer;
  padding-top: 13px;
  padding-bottom: 13px;
  border-radius: 24.5px;
  background: #cc9752;
  border: 0;
  outline: 0;
  transition: background-color 0.3s ease, color 0.3s ease;
  color: #fff;
  box-shadow: none;
  display: flex;
  justify-content: center;
  align-items: center;
}
.popup-container .popupWrapper .popup .btn.no-bordered.custom-btn-primary:hover {
  background: #cc9752;
  box-shadow: none;
}
.popup-container .popupWrapper .popup .signup-link p {
  font-size: 14px;
  line-height: 21px;
  font-weight: 400;
  color: #393939;
}
.popup-container .popupWrapper .popup .signup-link a {
  font-weight: 500;
  color: #cc9752;
}

.normal-user.signup-user .left-column .left-inner {
  padding-bottom: 70px;
}
.normal-user.signup-user .left-column .left-inner h3 {
  font-size: 18px;
  font-weight: 600;
  line-height: 27px;
  color: #393939;
}
.normal-user.signup-user .left-column .left-inner .sub-head {
  font-size: 15px;
  font-weight: 600;
  line-height: 22.5px;
  color: #333333;
}
.normal-user.signup-user .left-column .left-inner .mdl {
  padding-left: 15px;
  padding-right: 15px;
  margin-top: 35px;
}
.normal-user.signup-user .left-column .form-inputs .input-field .input-wrapper {
  position: relative;
}
.normal-user.signup-user .left-column .form-inputs .input-field .input-wrapper input[type=date]::-webkit-calendar-picker-indicator {
  visibility: visible;
  opacity: 0;
}
.normal-user.signup-user .left-column .form-inputs .input-field .input-wrapper .date-btn {
  border: 0;
  background: transparent;
  padding: 0;
  margin: 0;
  position: absolute;
  right: 0;
  top: 0;
  font-size: 18px;
  pointer-events: none;
  cursor: pointer;
}
.normal-user.signup-user .left-column .form-inputs .input-field .input-wrapper .date-btn svg {
  fill: #cc9752;
}

.bordered {
  border: 1px solid #cc9752;
  font-size: 16px;
  font-weight: 500;
  line-height: 27px;
  cursor: pointer;
  padding-top: 13px;
  padding-bottom: 13px;
  padding-left: 38px;
  padding-right: 38px;
  border-radius: 24.5px;
  background: transparent;
  outline: 0;
  color: #cc9752;
  box-shadow: none;
}
.bordered:hover {
  background: #cc9752;
  box-shadow: none;
  color: #fff;
}

.no-bordered {
  font-size: 16px;
  font-weight: 500;
  line-height: 27px;
  cursor: pointer;
  padding-top: 13px;
  padding-bottom: 13px;
  padding-left: 20px;
  padding-right: 20px;
  border-radius: 24.5px;
  background: #cc9752;
  border: 0;
  outline: 0;
  transition: background-color 0.3s ease, color 0.3s ease;
  color: #fff;
  box-shadow: none;
}
.no-bordered:hover {
  background: #cc9752;
  box-shadow: none;
  color: #fff;
}

.update {
  border: 0;
  outline: 0;
  background-color: transparent;
  padding: 0;
}
.update p {
  font-size: 15px;
  font-weight: 500;
  line-height: 22.5px;
  color: #cc9752;
}
.update svg {
  width: 14px;
  height: 14px;
  fill: #cc9752;
}

.dashboard-sidebar {
  background-color: #42826c;
  max-width: 258px;
  position: fixed;
  width: 258px;
  height: 100vh;
  padding-top: 30px;
  transition: 0.5s all;
}
.dashboard-sidebar .logo img {
  max-width: 123px;
}
.dashboard-sidebar .dashboard-items {
  height: 100%;
  overflow-y: auto;
}
.dashboard-sidebar .dashboard-items ul li {
  position: relative;
  height: 55px;
  cursor: pointer;
  color: #fff;
}
.dashboard-sidebar .dashboard-items ul li p {
  font-size: 15px;
  font-weight: 400;
  line-height: 24px;
}
.dashboard-sidebar .dashboard-items ul li svg {
  stroke: #eed7b9;
  stroke: #eed7b9;
  width: 16px;
  height: 16px;
}
.dashboard-sidebar .dashboard-items ul li .drop-icon {
  width: 20px;
  height: 20px;
  position: absolute;
  top: 18px;
  right: 5px;
}
.dashboard-sidebar .dashboard-items ul li:hover {
  background-color: #36745e;
}
.dashboard-sidebar .dashboard-items ul li:hover svg {
  stroke: #fff;
}
.dashboard-sidebar .dashboard-items ul li.active {
  background-color: #36745e;
}
.dashboard-sidebar .dashboard-items ul li.active svg {
  stroke: #fff;
}
.dashboard-sidebar .dashboard-items ul li.active ul.sub-menu {
  display: block;
  margin-top: 10px;
}
.dashboard-sidebar .dashboard-items ul li ul.sub-menu {
  display: none;
}
.dashboard-sidebar .dashboard-items ul li ul.sub-menu li {
  color: #9cdac4;
  background-color: transparent;
  padding: 0;
  height: auto;
  padding: 10px 0;
}
.dashboard-sidebar .dashboard-items ul li ul.sub-menu li p {
  font-size: 13px;
  font-weight: 400;
  line-height: 19.5px;
}
.dashboard-sidebar .dashboard-items ul li ul.sub-menu li.active {
  font-size: 13px;
  font-weight: 400;
  line-height: 19.5px;
  color: #fff;
}
.dashboard-sidebar .expand-btn {
  position: absolute;
  top: 0;
  right: 0;
  background-color: transparent !important;
  padding: 0;
  border: none;
  font-size: 26px;
  box-shadow: none;
  color: #fff !important;
}
.dashboard-sidebar .expand-btn:active {
  color: #fff;
  background-color: transparent;
  border-color: none;
}
.dashboard-sidebar.halfsidebar .dashboard-items ul li.active ul.sub-menu {
  margin-top: 5px;
}
.dashboard-sidebar.halfsidebar .dashboard-items ul li.active ul.sub-menu li {
  padding: 5px 0 !important;
}
.dashboard-sidebar.halfsidebar .dashboard-items ul li.active ul.sub-menu li p {
  display: block;
  visibility: visible;
  padding-left: 0 !important;
  text-align: center;
}

.topbar .left {
  font-size: 25px;
  font-weight: 600;
  line-height: 37.5px;
  color: #393939;
}
.topbar .right .wallet > svg {
  width: 18px;
  height: 18px;
  stroke: #393939;
}
.topbar .right .notified {
  position: relative;
}
.topbar .right .notified::after {
  content: "";
  width: 6px;
  height: 6px;
  border-radius: 50%;
  background-color: #ff0000;
  position: absolute;
  top: 5px;
  right: 3px;
  border: 1px solid #fff;
}
.topbar .right .notified svg {
  width: 18px;
  height: 18px;
  fill: #393939;
}
.topbar .right .user {
  cursor: pointer;
}
.topbar .right .user .user-pic {
  width: 34px;
  height: 34px;
  border-radius: 50%;
  border: 2px solid #42826c;
  overflow: hidden;
}
.topbar .right .user .user-pic img {
  object-fit: cover;
  width: 30px;
  height: 30px;
}
.topbar .right .user p {
  font-size: 13px;
  font-weight: 400;
  line-height: 24px;
  color: #393939;
}
.topbar .right .user .icon {
  stroke: #333333;
  width: 36px;
  height: 20px;
}

.user-bar {
  background-color: #f9f5ef;
  border-radius: 4px;
}
.user-bar .title {
  font-size: 20px;
  font-weight: 400;
  line-height: 30px;
  color: #393939;
}
.user-bar .title span {
  font-weight: 600;
}
.user-bar .item {
  margin: 0 10px 10px 0;
}
@media (min-width: 768px) {
  .user-bar .item {
    margin: 0;
  }
}
.user-bar .item .title {
  font-size: 13px;
  font-weight: 400;
  line-height: 19.5px;
  text-align: left;
  color: #717171;
}
.user-bar .item .text {
  font-size: 15px;
  font-weight: 600;
  line-height: 22.5px;
  color: #393939;
}
.user-bar .item .text.email {
  color: #cc9752;
  font-weight: 400;
}
.user-bar .buttons .bordered,
.user-bar .buttons .thick-border {
  font-size: 14px;
  font-weight: 500;
  width: 141px;
  padding: 8px 0;
  border: 2px solid #cc9752;
}
.user-bar .buttons .no-bordered {
  font-size: 15px;
  font-weight: 500;
  width: 159px;
  padding-left: 0;
  padding-right: 0;
}

.card-box {
  border-radius: 4px;
}
@media (min-width: 768px) {
  .card-box {
    max-width: 360px;
  }
}
.card-box.shade-green {
  background-color: #008983;
}
.card-box.shade-blue {
  background-color: #0f7db5;
}
.card-box .date-dropdown .date-btn {
  position: relative;
}
.card-box .date-dropdown .date-btn input {
  width: 20px;
  height: 20px;
  position: absolute;
  top: 4px;
  right: 0;
  opacity: 0;
}
.card-box .date-dropdown .date-btn .date-output p {
  color: #fff;
  font-size: 13px;
  font-weight: 500;
  line-height: 19.5px;
}
.card-box .date-dropdown .date-btn .date-output svg {
  fill: #fff;
  width: 18px;
  height: 18px;
  cursor: pointer;
}
.card-box .title {
  font-size: 14px;
  font-weight: 400;
  line-height: 21px;
  color: #fff;
}
.card-box .content {
  font-size: 30px;
  font-weight: 700;
  line-height: 1.2;
  color: #fff;
}
@media (min-width: 992px) {
  .card-box .content {
    font-size: 40px;
    line-height: 1.5;
  }
}

.chart-graph .chart-inner {
  box-shadow: 0px 2px 8px 0px rgba(156, 156, 156, 0.25);
  border-radius: 5px;
  padding-top: 20px;
  padding-bottom: 20px;
}
.chart-graph .chart-inner .title {
  font-size: 16px;
  font-weight: 400;
  line-height: 24px;
  color: #393939;
}
.chart-graph .chart-inner .ammount {
  font-size: 28px;
  font-weight: 700;
  line-height: 42px;
  color: #42826c;
}
.chart-graph .chart-inner .recharts-responsive-container .recharts-wrapper .recharts-surface {
  width: unset !important;
  max-height: 178px;
  overflow: visible;
}
.chart-graph .chart-inner .recharts-responsive-container .recharts-wrapper .recharts-surface .recharts-rectangle {
  pointer-events: none;
  fill: transparent;
}
.chart-graph .chart-inner .recharts-responsive-container .recharts-wrapper .recharts-surface .recharts-rectangle:hover {
  fill: transparent;
}
.chart-graph .chart-inner .recharts-responsive-container .recharts-wrapper .recharts-surface .recharts-layer line {
  display: none;
}
.chart-graph .chart-inner .recharts-responsive-container .recharts-wrapper .recharts-surface .recharts-layer .recharts-cartesian-axis-ticks .recharts-layer text {
  font-size: 12px;
  font-weight: 300;
  line-height: 18px;
  color: #777777;
}
.chart-graph .chart-inner .recharts-responsive-container .recharts-wrapper .recharts-surface .recharts-layer .xAxisLabel {
  fill: #353535;
  font-size: 13px;
  font-weight: 400;
  line-height: 19.5px;
  text-anchor: middle;
  transform-origin: 332px 210px;
  transform: rotate(0deg);
}
.chart-graph .chart-inner .recharts-responsive-container .recharts-wrapper .recharts-surface .recharts-layer .yAxisLabel {
  fill: #353535;
  font-size: 13px;
  font-weight: 400;
  line-height: 19.5px;
  transform: rotate(-90deg);
  transform-origin: 29px 102px;
  text-anchor: middle;
}

/* src/DatePicker.css */
.datepicker {
  position: relative;
  display: inline-block;
  font-family: Arial, sans-serif;
}

.datepicker-display {
  display: flex;
  align-items: center;
  cursor: pointer;
  padding: 10px;
  border: 1px solid #ccc;
  border-radius: 4px;
  background-color: #fff;
}

.dropdown-icon {
  margin-left: 8px;
  color: #333;
}

.datepicker-calendar {
  position: absolute;
  top: 100%;
  left: 0;
  width: 100%;
  border: 1px solid #ccc;
  border-radius: 4px;
  background-color: #fff;
  z-index: 1000;
  padding: 10px;
}

.dashboard-drop .dropdown-container-custom {
  border: 2px solid #d9d9d9;
  border-radius: 500px;
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 10px 20px;
  box-sizing: border-box;
  max-width: 169px;
  font-size: 13px;
  font-weight: 400;
  line-height: 19.5px;
  color: #717171;
}
.dashboard-drop .dropdown-container-custom .dropdown-arrow {
  display: flex;
  align-items: center;
}

.dashboard-table .dashboard-table-title p {
  font-size: 25px;
  font-weight: 600;
  line-height: 37.5px;
  color: #393939;
}
.dashboard-table .search-group {
  border: 0;
  border-bottom: 1px solid #717171;
}
@media (min-width: 1200px) {
  .dashboard-table .search-group {
    max-width: 309px;
  }
}
.dashboard-table .search-group svg {
  width: 13px;
  height: 13px;
}
.dashboard-table .search-group input {
  border: 0;
  outline: 0;
  box-shadow: none;
  width: calc(100% - 13px);
  height: 100%;
  font-size: 13px;
  font-weight: 400;
  line-height: 19.5px;
  color: #797979;
}
.dashboard-table .search-group input:focus {
  outline: 0;
  box-shadow: 0;
}
.dashboard-table .sort label {
  font-size: 13px;
  font-weight: 400;
  line-height: 23px;
  color: #393939;
}
.dashboard-table .sort .dark-text {
  max-width: fit-content;
}
.dashboard-table .sort .dark-text .dropdown-container-custom {
  padding: 8px 15px;
}
.dashboard-table .sort .dark-text .dropdown-container-custom .dropdown-selected-custom {
  font-size: 13px;
  font-weight: 700;
  line-height: 23px;
  color: #393939;
}
.dashboard-table .btn-teller .no-bordered {
  width: 119px;
  padding-left: 26px;
  padding-right: 26px;
  font-size: 13px;
  line-height: 19.5px;
  font-weight: 500;
}
.dashboard-table .table thead {
  box-shadow: 0px 2px 9px 0px rgba(154, 154, 154, 0.25);
}
.dashboard-table .table thead th {
  text-align: center;
  font-size: 15px;
  font-weight: 600;
  line-height: 22.5px;
  color: #393939;
  text-transform: capitalize;
}
.dashboard-table .table tbody tr {
  border-bottom: 1px solid #e6e6e6;
}
.dashboard-table .table tbody tr td {
  text-align: center;
  font-size: 15px;
  font-weight: 400;
  line-height: 22.5px;
  color: #393939;
  vertical-align: middle;
  border-top: none;
  padding: 10px;
}
.dashboard-table .table tbody tr td.green-color {
  color: #06b863;
}
.dashboard-table .table tbody tr td.grey-color {
  color: #717171;
}
.dashboard-table .table tbody tr td svg {
  width: 17px;
  height: 17px;
}
.dashboard-table .table tbody tr td.text-center {
  text-align: center;
  display: flex;
  justify-content: center;
}
.dashboard-table .table tbody tr td.action button {
  border: 0;
  outline: 0;
  background-color: transparent;
  cursor: pointer;
}
.dashboard-table .table tbody tr td.action button:nth-child(2) {
  margin-left: 4px;
}
.dashboard-table .teller-table img.name-img {
  width: 31px;
  height: 31px;
}
.dashboard-table .teller-table .colored {
  color: #cc9752;
}

.btn-status {
  border-radius: 500px;
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 7px 21px;
  max-width: 126px;
  min-width: 126px;
  cursor: pointer;
}
.btn-status.btn-green {
  border: 1px solid #6ab199;
  background-color: #dcf4ec;
  color: #656565;
}
.btn-status.btn-red {
  border: 1px solid #d65d43;
  background-color: #f4e3dc;
  color: #d65d43;
}
.btn-status.btn-orange {
  border: 1px solid #cc9752;
  background-color: #f4f3e5;
  color: #cc9752;
}
.btn-status.btn-olive {
  border: 1px solid #757536;
  background-color: #f2fcd3;
  color: #757536;
}

.pagination {
  display: flex;
  justify-content: flex-end;
}
.pagination .paginate-inner {
  display: flex;
  justify-content: flex-end;
}
.pagination .paginate-inner button.paginateButton {
  background-color: transparent;
  cursor: pointer;
  width: 30px;
  height: 30px;
  border: 0;
  outline: 0;
  display: flex;
  justify-content: center;
  align-items: center;
  color: #393939;
}
.pagination .paginate-inner button.paginateButton.active {
  background-color: #cc9752;
  width: 30px;
  height: 30px;
  border-radius: 3px;
  color: #fff;
}
.pagination .paginate-inner button.paginateButton svg.orange-class {
  fill: #cc9752;
}
.pagination .paginate-inner button.paginateButton svg.grey-class {
  fill: #717171;
}

.form-inputs .input-field .input-wrapper input {
  color: #717171;
  border: 0;
  border-bottom: 1px solid #b1b1b1;
  width: 100%;
  background: transparent;
  padding: 0 0 8px 0;
}
.form-inputs .input-field .input-wrapper .toggle-password-btn {
  border: 0;
  border-bottom: 1px solid #b1b1b1;
  background: transparent;
  padding: 0;
  margin: 0;
}
.form-inputs .input-field .input-wrapper .toggle-password-btn svg {
  fill: #cc9752;
}
.form-inputs label {
  color: #393939;
  font-size: 15px;
  font-weight: 400;
  line-height: 22.5px;
}
.form-inputs label .image-container {
  margin-left: 8px;
  width: 14px;
  height: 14px;
}

.card-number-input label {
  margin-bottom: 0;
}
.card-number-input .card-number-fields input {
  border: 0;
  outline: 0;
  border-bottom: 1px solid #7e8f8a;
  border-radius: 0;
  text-align: center;
  padding-bottom: 9px;
  padding-top: 0;
  font-size: 14px;
  font-weight: 400;
  line-height: 21px;
  letter-spacing: 3px;
  color: #717171;
  background: transparent;
}
.card-number-input .card-number-fields input:not(:last-child) {
  margin-right: 16px;
}
.card-number-input .card-number-fields input::placeholder {
  color: #717171;
  font-size: 14px;
}

.recharge-account {
  padding-left: 15px;
  padding-right: 15px;
}
.recharge-account .tabs {
  border-bottom: 1px solid #d8d8d8;
  padding-top: 20px;
}
.recharge-account .tabs button {
  border: 0;
  outline: 0;
  background-color: transparent;
  font-size: 15px;
  font-weight: 400;
  line-height: 22.5px;
  color: #717171;
}
.recharge-account .tabs button.active {
  color: #717171;
  color: #cc9752;
  font-weight: 500;
}
.recharge-account .recharge-bar {
  background-color: #f9f5ef;
  border-radius: 4px;
  padding: 24px 33px;
}
.recharge-account .recharge-bar .item .title {
  font-size: 20px;
  font-weight: 600;
  line-height: 30px;
  color: #393939;
}
.recharge-account .recharge-bar .item .text {
  font-size: 13px;
  font-weight: 400;
  line-height: 19.5px;
  color: #717171;
}
.recharge-account .recharge-bar .buttons .price {
  font-size: 30px;
  font-weight: 700;
  line-height: 45px;
  color: #42826c;
  margin-right: 26px;
}
.recharge-account .recharge-bar .buttons .bordered,
.recharge-account .recharge-bar .buttons .thick-border {
  font-size: 15px;
  font-weight: 500;
  width: 141px;
  padding-left: 0;
  padding-right: 0;
  border: 2px solid #cc9752;
}
.recharge-account .recharge-bar .buttons .no-bordered {
  font-size: 15px;
  font-weight: 500;
  width: 159px;
  padding-left: 0;
  padding-right: 0;
}
.recharge-account .recharge-form {
  box-shadow: 0px 2px 8px 0px rgba(156, 156, 156, 0.25);
  border: 1px solid #e3e3e3;
  padding: 40px;
  box-sizing: border-box;
  border-radius: 5px;
  margin-top: 29px;
}
.recharge-account .recharge-form p.title {
  font-size: 20px;
  font-weight: 600;
  line-height: 30px;
  color: #393939;
}
.recharge-account .recharge-form .methods {
  padding-top: 32px;
}
.recharge-account .recharge-form .methods p {
  font-size: 15px;
  font-weight: 400;
  line-height: 22.5px;
  color: #5e5e5e;
}
.recharge-account .recharge-form .methods .recharge-radio .radio-button .outer-circle {
  border: 1px solid #717171;
}
.recharge-account .recharge-form .methods .recharge-radio .radio-button .outer-circle.checked {
  border: 1px solid #cc9752;
}
.recharge-account .recharge-form .methods .green-box {
  background-color: #edf9f5;
  padding: 33px;
  padding-bottom: 44px;
  border-radius: 5px;
  margin-top: 32px;
}
.recharge-account .recharge-form .methods .green-box .sub-title {
  font-size: 18px;
  font-weight: 600;
  line-height: 27px;
  color: #393939;
}
.recharge-account .recharge-form .methods .green-box input {
  font-size: 13px;
  font-weight: 300;
  line-height: 19.5px;
  color: #717171;
  border-bottom: 1px solid #7e8f8a;
}
.recharge-account .recharge-form .methods .green-box .left {
  max-width: 75%;
}
.recharge-account .recharge-form .methods .green-box .right {
  max-width: 25%;
}
.recharge-account .recharge-form .methods .green-box .right .date-picker label {
  color: #393939;
  font-size: 15px;
  font-weight: 400;
  line-height: 22.5px;
}
.recharge-account .recharge-form .methods .green-box .right .date-picker .date-input {
  position: relative;
  border-bottom: 1px solid #7e8f8a;
}
.recharge-account .recharge-form .methods .green-box .right .date-picker .date-input .react-datepicker-wrapper {
  width: 100%;
  height: 100%;
}
.recharge-account .recharge-form .methods .green-box .right .date-picker .date-input .react-datepicker-wrapper input {
  font-size: 13px;
  font-weight: 300;
  line-height: 19.5px;
  color: #717171;
  border: 0;
  outline: 0;
  width: 100%;
  height: 100%;
  padding-bottom: 9px;
  background-color: transparent;
}
.recharge-account .recharge-form .methods .green-box .right .date-picker .date-input svg {
  width: 16px;
  height: 16px;
  position: absolute;
  top: 0;
  right: 0;
}
.recharge-account .recharge-form .buttons {
  margin-top: 33px;
}
.recharge-account .faded {
  font-size: 15px;
  font-weight: 400;
  line-height: 22.5px;
  color: #717171;
}
.recharge-account .pagination {
  display: flex;
  justify-content: flex-end;
}
.recharge-account .pagination .paginate-inner {
  display: flex;
  justify-content: flex-end;
}
.recharge-account .pagination .paginate-inner button.paginateButton {
  background-color: transparent;
  cursor: pointer;
  width: 30px;
  height: 30px;
  border: 0;
  outline: 0;
  display: flex;
  justify-content: center;
  align-items: center;
  color: #393939;
}
.recharge-account .pagination .paginate-inner button.paginateButton.active {
  background-color: #cc9752;
  width: 30px;
  height: 30px;
  border-radius: 3px;
  color: #fff;
}
.recharge-account .pagination .paginate-inner button.paginateButton svg.orange-class {
  fill: #cc9752;
}
.recharge-account .pagination .paginate-inner button.paginateButton svg.grey-class {
  fill: #717171;
}

.tabs button.active {
  border-bottom: 3px solid #cc9752;
}

.sidebar-items ul li {
  padding: 20px 18px;
  cursor: pointer;
  border-bottom: 1px solid #e6e6e6;
}
.sidebar-items ul li p {
  font-size: 15px;
  font-weight: 400;
  line-height: 22.5px;
  color: #717171;
}
.sidebar-items ul li.active {
  background-color: #eed7b9;
  border-radius: 3px;
  border-bottom: 1px solid transparent;
}
.sidebar-items ul li.active p {
  font-weight: 500;
  color: #393939;
}

.general-information .profile-box {
  border-radius: 5px;
  box-shadow: 0px 4px 30px 0px rgba(0, 0, 0, 0.08);
  border: 1px solid #e6e6e6;
}
.general-information .profile-box .header-title {
  border-bottom: 1px solid #e6e6e6;
  padding: 21px 30px;
  cursor: pointer;
}
.general-information .profile-box .header-title p {
  font-size: 18px;
  font-weight: 600;
  line-height: 27px;
  color: #333333;
}
.general-information .profile-box .content-wrapper .content {
  padding: 30px 30px 30px 30px;
}
.general-information .profile-box .content-wrapper .content .image {
  min-width: 139px;
  overflow: hidden;
  position: relative;
}
.general-information .profile-box .content-wrapper .content .image img {
  width: 139px;
  height: 139px;
  border-radius: 50%;
  object-fit: cover;
}
.general-information .profile-box .content-wrapper .content .image span {
  position: absolute;
  bottom: 4px;
  right: 5px;
  width: 35px;
  height: 35px;
  border-radius: 50%;
  background-color: #cc9752;
  display: flex;
  justify-content: center;
  align-items: center;
  cursor: pointer;
  z-index: 1;
}
.general-information .profile-box .content-wrapper .content .image span svg {
  fill: #fff;
}
.general-information .profile-box .content-wrapper .content .items {
  padding-left: 50px;
}
.general-information .profile-box .content-wrapper .content .items .col:nth-child(1) {
  min-width: 233px;
}
.general-information .profile-box .content-wrapper .content .items .col:nth-child(2) {
  min-width: 145px;
}
.general-information .profile-box .content-wrapper .content .items .item {
  margin-bottom: 28px;
}
.general-information .profile-box .content-wrapper .content .items .item.address {
  width: fit-content;
}
.general-information .profile-box .content-wrapper .content .items .item p {
  font-size: 15px;
  font-weight: 500;
  line-height: 22.5px;
  color: #393939;
  margin-bottom: 0;
}
.general-information .profile-box .content-wrapper .content .items .item p.title {
  font-size: 13px;
  font-weight: 400;
  line-height: 19.5px;
  color: #717171;
}
.general-information .profile-box .content-wrapper .content .items .item a {
  color: #cc9752;
  text-decoration: none;
}
.general-information .profile-box .content-wrapper .content .profile-form {
  padding-left: 50px;
}
.general-information .profile-box .content-wrapper .content .profile-form .form-inputs label {
  font-size: 13px;
  font-weight: 400;
  line-height: 19.5px;
  color: #717171;
}
.general-information .profile-box .content-wrapper .content .profile-form .form-inputs input {
  font-size: 14px;
  font-weight: 500;
  line-height: 22.5px;
  color: #393939;
}
.general-information .profile-box .content-wrapper .content .profile-form .form-inputs input[type=email] {
  color: #cc9752;
}
.general-information .profile-box .content-wrapper .content .profile-form button {
  max-width: 145px;
}

.password {
  padding: 30px 34px;
  border-radius: 5px;
  box-shadow: 0px 4px 30px 0px rgba(0, 0, 0, 0.08);
  border: 1px solid #e6e6e6;
}
.password .title {
  font-size: 18px;
  font-weight: 600;
  line-height: 27px;
  color: #393939;
}
.password .text {
  font-size: 13px;
  font-weight: 400;
  line-height: 19.5px;
  color: #717171;
}
.password .h-pass {
  font-size: 15px;
  font-weight: 500;
  line-height: 22.5px;
  color: #393939;
}
.password button {
  max-width: 246px;
  padding-left: 40px;
  padding-right: 40px;
}

.password-form .title {
  font-weight: 600;
}
.password-form .back-btn {
  cursor: pointer;
  fill: #cc9752;
}
.password-form .form-inputs label {
  font-size: 13px;
  color: #717171;
  position: relative;
}
.password-form .form-inputs label .tooltip {
  position: absolute;
  top: -18px;
  left: 208%;
  opacity: 1;
  display: flex;
  flex-direction: column;
  visibility: visible;
  background-color: #fff;
  width: max-content;
  height: fit-content;
}
.password-form .form-inputs label .tooltip ::before {
  content: "";
  position: absolute;
  top: 24px;
  left: 0;
  margin-left: -12px;
  border-width: 6px;
  border-style: solid;
  border-color: transparent rgb(255, 255, 255) transparent transparent;
}
.password-form .form-inputs label .tooltip p.t-title {
  color: #393939;
  font-size: 15px;
  font-weight: 500;
  line-height: 22.5px;
  text-align: left;
}
.password-form .form-inputs label .tooltip ul.list {
  padding-left: 15px;
}
.password-form .form-inputs label .tooltip ul.list li {
  color: #717171;
  font-size: 13px;
  font-weight: 400;
  line-height: 24px;
  text-align: left;
}
.password-form .form-inputs label .tooltip ul.list li span.green {
  color: #42826c;
}
.password-form .form-inputs input {
  font-size: 13px;
}
.password-form .form-inputs input::placeholder {
  color: #a7a7a7;
}
.password-form .form-inputs .icon-info {
  cursor: pointer;
}

.Availability {
  box-shadow: 0px 4px 30px 0px rgba(0, 0, 0, 0.08);
  border: 1px solid #e6e6e6;
  padding: 21px 30px;
  border-radius: 5px;
}
.Availability .title {
  font-size: 18px;
  font-weight: 600;
  line-height: 27px;
  color: #333333;
}
.Availability .time-table .sub-text p {
  font-size: 13px;
  font-weight: 400;
  line-height: 19.5px;
  color: #393939;
  margin-top: 20px;
  margin-bottom: 17px;
}
.Availability .time-table .sub-text ul li {
  width: 56px;
  height: 52px;
  border-radius: 4px;
  display: flex;
  justify-content: center;
  align-items: center;
  position: relative;
  cursor: pointer;
}
.Availability .time-table .sub-text ul li .checkbox-container {
  width: 100%;
  height: 100%;
}
.Availability .time-table .sub-text ul li .checkbox-container .checkbox-text {
  display: flex;
  justify-content: center;
  align-items: center;
  color: #1d1d1d;
  font-size: 13px;
  font-weight: 500;
  line-height: 19.5px;
  background-color: #e6e7e6;
  width: 100%;
  height: 100%;
  transition: all 0.2s;
}
.Availability .time-table .sub-text ul li .checkbox-container input {
  width: 100%;
  height: 100%;
  position: absolute;
  visibility: hidden;
}
.Availability .time-table .sub-text ul li .checkbox-container.checked .checkbox-text {
  background-color: #cc9752;
  color: #fff;
}
.Availability .time-table table {
  margin-top: 34px;
}
.Availability .time-table table th,
.Availability .time-table table td {
  padding-left: 0;
  padding-right: 0;
  border: none;
}
.Availability .time-table table th {
  border-bottom: 2px solid #e1e1e1;
}
.Availability .time-table table td {
  font-size: 13px;
  font-weight: 400;
  line-height: 19.5px;
  color: #5e5e5e;
  padding: 0;
}
.Availability .time-table table td.day {
  font-size: 15px;
  font-weight: 500;
  line-height: 50px;
  color: #393939;
  width: 200px;
}
.Availability .time-table table td.green-color {
  font-size: 15px;
  font-weight: 500;
  line-height: 50px;
  color: #42826c;
}
.Availability .time-table table td.red-color {
  font-size: 15px;
  font-weight: 500;
  line-height: 50px;
  color: #dd0303;
}
.Availability .time-table table td .dob-picker-container .dob-picker-label {
  margin-bottom: 0;
}
.Availability .time-table table td .dob-picker-container .dob-picker-input-wrapper .react-datepicker-wrapper .dob-picker-input {
  padding: 0 0 0 0;
}
.Availability .time-table table td .to {
  color: #393939;
  padding-left: 32px;
  padding-right: 32px;
}
.Availability .time-table table td .working-time-green {
  color: #42826c;
}
.Availability .time-table table td .working-time-black,
.Availability .time-table table td .working-time-text {
  color: #393939;
}
.Availability .dob-picker-input-wrapper svg {
  fill: #393939;
}

.profile-management {
  padding-top: 30px;
}

.account-type {
  border-radius: 5px;
  box-shadow: 0px 4px 30px 0px rgba(0, 0, 0, 0.08);
  border: 1px solid #e6e6e6;
  padding: 21px 30px;
}
.account-type .title {
  color: #393939;
  font-size: 18px;
  font-weight: 600;
  line-height: 27px;
}
.account-type .type p {
  color: #42826c;
  font-size: 20px;
  font-weight: 500;
  line-height: 30px;
  margin-top: 28px;
}
.account-type .popup-container .close {
  top: 20px;
  right: 22px;
}
.account-type .popup-container .popupWrapper {
  width: 592px;
  max-width: 100%;
}
.account-type .popup-container .popupWrapper .popup {
  padding: 39px 50px;
}
.account-type .popup-container .popupWrapper .popup .form-input {
  max-width: 491px;
}
.account-type .popup-container .popupWrapper .titles {
  color: #393939;
  font-size: 20px;
  font-weight: 600;
  line-height: 30px;
}
.account-type .popup-container .popupWrapper .titles span {
  color: #42826c;
}
.account-type .popup-container .popupWrapper .custom-checkbox {
  display: flex;
  align-items: center;
}
.account-type .popup-container .popupWrapper .custom-checkbox input[type=checkbox] {
  position: absolute;
  opacity: 0;
  width: 0;
  height: 0;
}
.account-type .popup-container .popupWrapper .custom-checkbox input[type=checkbox]:checked + .custom-checkbox-box {
  background-color: #cc9752;
  border-color: #cc9752;
}
.account-type .popup-container .popupWrapper .custom-checkbox input[type=checkbox]:checked + .custom-checkbox-box .checkbox-icon {
  display: flex;
}
.account-type .popup-container .popupWrapper .custom-checkbox .custom-checkbox-box {
  width: 18px;
  height: 18px;
  border: 1px solid #cc9752;
  background: #fff;
  display: flex;
  align-items: center;
  justify-content: center;
  position: relative;
  margin-right: 8px;
  border-radius: 2px;
  padding: 3px;
  box-sizing: border-box;
  transition: background-color 0.2s ease;
  cursor: pointer;
  margin-bottom: 0;
}
.account-type .popup-container .popupWrapper .custom-checkbox .checkbox-icon {
  color: #fff;
  font-size: 14px;
  display: none;
}
.account-type .popup-container .popupWrapper .custom-checkbox .checkbox-label {
  margin-left: 8px;
  color: #393939;
}
.account-type .popup-container .popupWrapper .custom-checkbox .checkbox-label .highlighted-text {
  color: #cc9752;
}
.account-type .popup-container .popupWrapper .btn-wrap button {
  width: 145px;
}
.account-type .popup-container .popupWrapper .popup .btn.no-bordered.custom-btn-primary {
  width: 145px;
}
.account-type .popup-container .popupWrapper .checkbox a {
  color: #cc9752;
  text-decoration: none;
}

.transfer-bar {
  background-color: #f9f5ef;
  border-radius: 4px;
  padding: 24px 33px;
}
.transfer-bar .item .title {
  font-size: 15px;
  font-weight: 400;
  line-height: 22.5px;
  color: #393939;
}
.transfer-bar .item .price {
  font-size: 30px;
  font-weight: 700;
  line-height: 45px;
  color: #42826c;
}

.transfer-table .filter-btn-group .btn-border {
  border: 1px solid #bfbfbf;
  border-radius: 5px;
  color: #393939;
  font-size: 13px;
  font-weight: 400;
  line-height: 23px;
  padding: 7px 17px;
  margin-left: 0;
}
.transfer-table .filter-btn-group .btn-border:not(:last-child) {
  margin-right: 4px;
}
.transfer-table .filter-btn-group .btn-border.active {
  color: #cc9752;
  border: 1px solid #cc9752;
}
.transfer-table .border-sorting {
  max-width: 200px;
  border: 2px solid #d9d9d9;
  border-radius: 500px;
  padding: 10px 7px;
  display: flex;
  justify-content: center;
  align-items: center;
  margin-left: 10px;
}
.transfer-table .border-sorting .dashboard-drop .dropdown-container-custom {
  border: 0;
  border-radius: 0;
  padding: 0;
}

.transfer-table .table-data .red {
  fill: #ff0000;
}
.transfer-table .table-data .green {
  fill: #19b25f;
}
.transfer-table .table-data .red-color {
  color: #ff0000;
}
.transfer-table .table-data .orange {
  color: #cc9752;
}
.transfer-table .counter {
  width: 18px;
  height: 18px;
  border-radius: 50%;
  background-color: #42826c;
  display: flex;
  justify-content: center;
  align-items: center;
  color: #fff;
  font-size: 13px;
  font-weight: 400;
}

.register .form-inputs {
  padding-left: 0;
  padding-right: 0;
}
.register .register-wrap {
  box-shadow: 0px 2px 8px 0px rgba(156, 156, 156, 0.25);
  border: 1px solid #e3e3e3;
  padding: 35px 20px;
  box-sizing: border-box;
  border-radius: 5px;
  margin-top: 29px;
}
.register .moneytransfer-progress {
  background-color: #f9f5ef;
  border-radius: 4px;
  padding: 44px 33px 14px 33px;
}
.register .recipient-details p {
  font-size: 18px;
  font-weight: 600;
  line-height: 27px;
  color: #393939;
}
.register .registered-user .search-group,
.register .registered-user .input-group-label {
  border: 0;
  border-bottom: 1px solid #bababa;
  max-width: none;
}
.register .registered-user .search-group svg,
.register .registered-user .input-group-label svg {
  width: 13px;
  height: 13px;
}
.register .registered-user .search-group label,
.register .registered-user .input-group-label label {
  font-size: 15px;
  font-weight: 400;
  line-height: 22.5px;
  color: #393939;
}
.register .registered-user .search-group input,
.register .registered-user .input-group-label input {
  border: 0;
  outline: 0;
  box-shadow: none;
  width: calc(100% - 13px);
  height: 100%;
  font-size: 13px;
  font-weight: 400;
  line-height: 19.5px;
  color: #797979;
}
.register .registered-user .search-group input:focus,
.register .registered-user .input-group-label input:focus {
  outline: 0;
  box-shadow: 0;
}
.register .registered-user .preview-wrapper .title-top {
  font-size: 18px;
  font-weight: 600;
  line-height: 27px;
  color: #1d1d1d;
}
.register .registered-user .preview-wrapper .item {
  padding: 0 57px;
  box-sizing: border-box;
}
.register .registered-user .preview-wrapper .item:first-child {
  padding-left: 0;
}
.register .registered-user .preview-wrapper .item:last-child {
  padding-right: 0;
}
.register .registered-user .preview-wrapper .item:not(:last-child) {
  border-right: 1px solid #dbdbdb;
}
.register .registered-user .preview-wrapper .item .title {
  width: max-content;
  font-size: 13px;
  font-weight: 400;
  line-height: 19.5px;
  color: #717171;
}
.register .registered-user .preview-wrapper .item .description {
  font-size: 15px;
  font-weight: 500;
  line-height: 22.5px;
  color: #1d1d1d;
}
.register .registered-user .preview-wrapper .item .colored {
  color: #cc9752;
}
.register .registered-user .preview-wrapper .item .mail-id {
  color: #cc9752;
  font-weight: 500;
}
.register .registered-user .no-bordered,
.register .registered-user .bordered {
  padding-left: 10px;
  padding-right: 10px;
}
.register .popupWrapper .popup {
  padding: 52px;
}
.register .popupWrapper .popup .icon {
  height: 80px;
  background-color: transparent;
  width: 100%;
}
.register .popupWrapper .popup .icon img {
  width: 80px;
  height: 80px;
}
.register .popupWrapper .popup h2 {
  font-size: 26px;
  font-weight: 600;
  line-height: 39px;
  color: #393939;
}
.register .popupWrapper .popup .light-text {
  font-size: 15px;
  font-weight: 400;
  line-height: 24px;
  color: #393939;
}
.register .popupWrapper .popup .btn-wrap .btn-mt {
  width: 274px;
}
.register .unregistered-form-preview .preview-wrapper .section {
  border-bottom: 1px solid #dbdbdb;
  padding: 20px 0;
}
.register .unregistered-form-preview .preview-wrapper .item {
  padding: 0;
}
.register .unregistered-form-preview .preview-wrapper .item:not(:last-child) {
  border-right: 0;
  padding-right: 32px;
}

.world-map {
  position: relative;
  width: 100%; /* Adjust the size as needed */
  height: 100%; /* Adjust the size as needed */
  margin: auto;
  padding: 30px 0;
}

.map {
  width: 100%;
  height: auto;
}

.pin {
  position: absolute;
  cursor: pointer;
}

.tooltip {
  visibility: hidden;
  background-color: black;
  color: white;
  text-align: center;
  border-radius: 5px;
  padding: 5px;
  position: absolute;
  z-index: 1;
  bottom: 20px; /* Positioning tooltip */
  left: 50%;
  transform: translateX(-50%);
  transition: visibility 0.2s;
}

.pin:hover .tooltip {
  visibility: visible;
}

.pin-image {
  width: 22px;
  height: 28px;
}

.invite-table .form-bar {
  background-color: #f9f5ef;
  border-radius: 4px;
  padding: 24px 33px 26px 33px;
  margin-bottom: 28px;
}
.invite-table .form-bar .title {
  font-size: 18px;
  font-weight: 600;
  line-height: 27px;
  color: #393939;
}
.invite-table .form-bar .invite-btn {
  padding-left: 11px;
  padding-right: 11px;
  font-size: 15px;
}
.invite-table .table tbody tr td.orange {
  color: #cc9752;
}
.invite-table .table tbody tr td img.pic {
  width: 31px;
  height: 31px;
  border-radius: 50%;
}

.time-picker-container .react-datepicker__time-container {
  width: 100%;
  height: 150px;
  overflow: hidden;
}
.time-picker-container .react-datepicker__time-container .react-datepicker__time .react-datepicker__time-box {
  width: 100%;
  margin: 0;
}
.time-picker-container .react-datepicker__time-container .react-datepicker__time .react-datepicker__time-box ul.react-datepicker__time-list {
  height: 100px;
}
.time-picker-container .react-datepicker-time__header {
  font-size: 11px;
}

.assoicate-user .f-w-270 {
  max-width: 270px;
}
.assoicate-user .btn-otp {
  padding: 0;
  border: 0;
  outline: 0;
  background-color: transparent;
  color: #cc9752;
  cursor: pointer;
  font-size: 13px;
  font-weight: 400;
  line-height: 19.5px;
}
.assoicate-user .search-group label {
  font-size: 15px;
  font-weight: 400;
  line-height: 22.5px;
  text-align: left;
  color: #393939;
}
.assoicate-user .search-group input {
  font-size: 13px;
  font-weight: 300;
  line-height: 19.5px;
  color: #393939;
}
.assoicate-user .search-group input::placeholder {
  font-size: 13px;
  font-weight: 300;
  line-height: 19.5px;
  color: #393939;
}
.assoicate-user .search-group svg {
  fill: #393939;
}
.assoicate-user .preview-wrapper-associate {
  margin-top: 34px;
}
.assoicate-user .preview-wrapper-associate .item:not(:last-child) {
  border-right: 1px solid;
  padding-right: 34px;
  margin: 6px;
}
.assoicate-user .preview-wrapper-associate .item .title {
  width: max-content;
  font-size: 13px;
  font-weight: 400;
  line-height: 19.5px;
  color: #656565;
}
.assoicate-user .preview-wrapper-associate .item .description {
  font-size: 15px;
  font-weight: 500;
  line-height: 22.5px;
  color: #393939;
}
.assoicate-user .associate-preview .section {
  border-bottom: 1px solid #dbdbdb;
  padding: 20px 0;
}
.assoicate-user .associate-preview .title-top {
  font-size: 18px;
  font-weight: 600;
  line-height: 27px;
  color: #1d1d1d;
}
.assoicate-user .associate-preview .item {
  padding: 0;
  margin-bottom: 16px;
}
.assoicate-user .associate-preview .item:first-child {
  padding-left: 0;
}
.assoicate-user .associate-preview .item:last-child {
  padding-right: 0;
}
.assoicate-user .associate-preview .item:not(:last-child) {
  padding-right: 95px;
}
.assoicate-user .associate-preview .item .title {
  width: max-content;
  font-size: 13px;
  font-weight: 400;
  line-height: 19.5px;
  color: #717171;
}
.assoicate-user .associate-preview .item .description {
  font-size: 15px;
  font-weight: 500;
  line-height: 22.5px;
  color: #1d1d1d;
}
.assoicate-user .associate-preview .item .colored {
  color: #cc9752;
}
.assoicate-user .associate-preview .item .mail-id {
  color: #cc9752;
  font-weight: 500;
}
.assoicate-user .green-box {
  background-color: #edf9f5;
  border-radius: 2px;
  padding: 30px 36px;
}
.assoicate-user .font-small {
  font-size: 15px;
  font-weight: 400;
  line-height: 22.5px;
  color: #393939;
}

.transfer-table .border-sorting {
  position: relative;
}
.transfer-table .border-sorting .filter .dropdown-menu-custom {
  display: none;
}
.transfer-table .border-sorting .filter-popup {
  position: absolute;
  width: 403px;
  top: 48px;
  right: 0;
  background: #fff;
  border-radius: 5px;
  box-shadow: 0px 2px 8px 0px rgba(156, 156, 156, 0.35);
  border: 1px solid #e3e3e3;
}
.transfer-table .border-sorting .filter-popup .title {
  font-size: 20px;
  font-weight: 600;
  line-height: 30px;
  color: #161616;
  border-bottom: 1px solid #cfcfcf;
  padding: 20px 30px;
}
.transfer-table .border-sorting .filter-popup .inner {
  padding: 20px 30px;
}
.transfer-table .border-sorting .filter-popup .inner .input {
  font-size: 14px;
}
.transfer-table .border-sorting .filter-popup .inner .input::placeholder {
  font-size: 14px;
}
.transfer-table .border-sorting .filter-popup .inner label,
.transfer-table .border-sorting .filter-popup .inner .dropdown-title {
  color: #3f3f3f;
}
.transfer-table .border-sorting .filter-popup .inner .form-inputs {
  margin-top: 24px;
}
.transfer-table .border-sorting .filter-popup .inner .form-inputs:first-child {
  margin-top: 0;
}
.transfer-table .border-sorting .filter-popup .inner .dob-picker-container .dob-picker-input-wrapper svg {
  font: #333333;
}
.transfer-table .border-sorting .filter-popup .close {
  position: absolute;
  top: 20px;
  right: 29px;
  opacity: 1;
}
.transfer-table .border-sorting .filter-popup .close svg {
  fill: #333333;
  width: 32px;
  height: 32px;
  stroke: #393939;
  cursor: pointer;
  opacity: 1;
}
.transfer-table .border-sorting .filter-popup .btn-group-filter {
  background-color: #fffaf4;
  padding: 15px 30px;
}

.tDetails {
  box-shadow: 0px 2px 8px 0px rgba(156, 156, 156, 0.25);
  border: 1px solid #e3e3e3;
  box-sizing: border-box;
  border-radius: 9px;
  margin-top: 29px;
  overflow: hidden;
}
.tDetails .tDetails-preview .section {
  border-bottom: 0;
  padding: 20px 0;
  padding-bottom: 10px;
}
.tDetails .tDetails-preview .title-top {
  font-size: 18px;
  font-weight: 600;
  line-height: 27px;
  color: #1d1d1d;
  border-bottom: 1px solid #dbdbdb;
  padding-bottom: 20px;
  margin-bottom: 20px;
}
.tDetails .tDetails-preview .item {
  padding: 0;
  margin-bottom: 16px;
}
.tDetails .tDetails-preview .item:first-child {
  padding-left: 0;
}
.tDetails .tDetails-preview .item:last-child {
  padding-right: 0;
}
.tDetails .tDetails-preview .item:not(:last-child) {
  padding-right: 95px;
}
.tDetails .tDetails-preview .item .title {
  width: max-content;
  font-size: 13px;
  font-weight: 400;
  line-height: 19.5px;
  color: #717171;
}
.tDetails .tDetails-preview .item .description {
  font-size: 15px;
  font-weight: 500;
  line-height: 22.5px;
  color: #1d1d1d;
}
.tDetails .tDetails-preview .item .colored {
  color: #cc9752;
}
.tDetails .tDetails-preview .item .mail-id {
  color: #cc9752;
  font-weight: 500;
}
.tDetails .form-inputs {
  padding: 9px 36px;
}
.tDetails .top-bar {
  background: #f9f5ef;
  border-top-left-radius: 9px;
  border-top-right-radius: 9px;
  border-bottom: 1px solid #dbdada;
  padding: 18px 38px;
}
.tDetails .top-bar .title {
  font-size: 18px;
  font-weight: 600;
  line-height: 27px;
  text-align: left;
  color: #161616;
  margin-left: 14px;
}
.tDetails .top-bar svg.back {
  stroke: #161616;
  width: 36px;
  height: 24px;
  cursor: pointer;
}
.tDetails .top-bar svg.download {
  width: 21px;
  height: 21px;
  stroke: #cc9752;
  margin-left: 27px;
  cursor: pointer;
}
.tDetails .tDetails-btn-group {
  background-color: #fffaf4;
  padding: 24px 36px;
  border-bottom-left-radius: 9px;
  border-bottom-right-radius: 9px;
  border-top: 1px solid #dbdada;
}
.tDetails .tDetails-btn-group .btn {
  padding-left: 38px;
  padding-right: 38px;
}
.tDetails .tDetails-popup.popup-container .close {
  top: 20px;
  right: 22px;
}
.tDetails .tDetails-popup.popup-container .popupWrapper {
  width: 459px;
  max-width: 100%;
  max-height: unset;
  overflow: hidden;
}
.tDetails .tDetails-popup.popup-container .popupWrapper .popup {
  padding: 0;
}
.tDetails .tDetails-popup.popup-container .popupWrapper .titles {
  font-size: 20px;
  font-weight: 600;
  line-height: 30px;
  color: #1d1d1d;
  border-bottom: 1px solid #cfcfcf;
}
.tDetails .tDetails-popup.popup-container .popupWrapper .titles span {
  color: #42826c;
}
.tDetails .tDetails-popup.popup-container .popupWrapper .custom-checkbox {
  display: flex;
  align-items: center;
}
.tDetails .tDetails-popup.popup-container .popupWrapper .custom-checkbox input[type=checkbox] {
  position: absolute;
  opacity: 0;
  width: 0;
  height: 0;
}
.tDetails .tDetails-popup.popup-container .popupWrapper .custom-checkbox input[type=checkbox]:checked + .custom-checkbox-box {
  background-color: #cc9752;
  border-color: #cc9752;
}
.tDetails .tDetails-popup.popup-container .popupWrapper .custom-checkbox input[type=checkbox]:checked + .custom-checkbox-box .checkbox-icon {
  display: flex;
}
.tDetails .tDetails-popup.popup-container .popupWrapper .custom-checkbox .custom-checkbox-box {
  width: 18px;
  height: 18px;
  border: 1px solid #cc9752;
  background: #fff;
  display: flex;
  align-items: center;
  justify-content: center;
  position: relative;
  margin-right: 8px;
  border-radius: 2px;
  padding: 3px;
  box-sizing: border-box;
  transition: background-color 0.2s ease;
  cursor: pointer;
  margin-bottom: 0;
}
.tDetails .tDetails-popup.popup-container .popupWrapper .custom-checkbox .checkbox-icon {
  color: #fff;
  font-size: 14px;
  display: none;
}
.tDetails .tDetails-popup.popup-container .popupWrapper .custom-checkbox .checkbox-label {
  margin-left: 8px;
  color: #393939;
}
.tDetails .tDetails-popup.popup-container .popupWrapper .custom-checkbox .checkbox-label .highlighted-text {
  color: #cc9752;
}
.tDetails .tDetails-popup.popup-container .popupWrapper .pop-btn-wrap {
  background-color: #fffaf4;
  padding: 15px 30px;
}
.tDetails .tDetails-popup.popup-container .popupWrapper .pop-btn-wrap button {
  width: "";
  max-width: unset;
}
.tDetails .tDetails-popup.popup-container .popupWrapper .popup .btn.no-bordered.custom-btn-primary {
  width: unset;
  max-width: unset;
  padding-left: 31px;
  padding-right: 31px;
}
.tDetails .tDetails-popup.popup-container .popupWrapper .checkbox a {
  color: #cc9752;
  text-decoration: none;
}
.tDetails .successful.popup-container .popupWrapper {
  max-width: 598px;
  max-height: unset;
  padding: 46px 55px;
}
.tDetails .successful.popup-container .popupWrapper .popup .icon {
  margin: 0 auto;
  background-color: transparent;
}
.tDetails .successful.popup-container .popupWrapper .popup h2 {
  color: #1d1d1d;
  font-size: 26px;
  line-height: 39px;
  font-weight: 600;
}
.tDetails .successful.popup-container .popupWrapper .popup .light-text {
  color: #333333;
  line-height: 24px;
}

.message-container .sidebar-message {
  box-shadow: 0px 4px 13px 0px rgba(0, 0, 0, 0.08);
  border: 1px solid #e6e6e6;
  padding: 40px 20px;
  width: 369px;
}
.message-container .sidebar-message .search-group {
  border: 0;
  border-bottom: 1px solid #717171;
  max-width: none;
  margin-bottom: 27px;
}
.message-container .sidebar-message .search-group svg {
  width: 13px;
  height: 13px;
}
.message-container .sidebar-message .search-group label {
  font-size: 15px;
  font-weight: 400;
  line-height: 22.5px;
  color: #393939;
}
.message-container .sidebar-message .search-group input {
  border: 0;
  outline: 0;
  box-shadow: none;
  width: calc(100% - 13px);
  height: 100%;
  font-size: 13px;
  font-weight: 400;
  line-height: 19.5px;
  color: #19b25f;
}
.message-container .sidebar-message .search-group input:focus {
  outline: 0;
  box-shadow: 0;
}
.message-container .sidebar-message ul li {
  border-bottom: 1px solid #dfdfdf;
  padding: 16px 0;
  cursor: pointer;
}
.message-container .sidebar-message ul li:first-child {
  padding-top: 0;
}
.message-container .sidebar-message ul li:last-child {
  border-bottom: 0;
}
.message-container .sidebar-message ul li .user-image img {
  width: 37px;
  height: 37px;
}
.message-container .sidebar-message ul li .user .user-name {
  font-size: 15px;
  font-weight: 500;
  line-height: 22.5px;
  color: #393939;
}
.message-container .sidebar-message ul li .user .user-message {
  font-size: 12px;
  font-weight: 300;
  line-height: 18px;
  color: #42826c;
}
.message-container .sidebar-message ul li .message-date {
  font-size: 13px;
  font-weight: 500;
  line-height: 19.5px;
  color: #42826c;
}
.message-container .chat-box {
  width: 729px;
  position: relative;
}
.message-container .chat-box .user-info {
  border-radius: 5px;
  background-color: #42826c;
  padding: 19px 17px;
}
.message-container .chat-box .user-info .user-image img {
  width: 37px;
  height: 37px;
}
.message-container .chat-box .user-info .user {
  margin-left: 13px;
}
.message-container .chat-box .user-info .user .user-name {
  font-size: 15px;
  font-weight: 500;
  line-height: 22.5px;
  color: #fff;
}
.message-container .chat-box .user-info .user .user-message {
  font-size: 12px;
  font-weight: 300;
  line-height: 18px;
  color: #fff;
}
.message-container .chat-box .message-box {
  padding-left: 20px;
}
.message-container .chat-box .message-box .left-align {
  margin: 17px 0;
}
.message-container .chat-box .message-box .left-align img {
  width: 40px;
  height: 40px;
}
.message-container .chat-box .message-box .left-align .mesg-field {
  border: 1px solid #cbcbcb;
  margin-left: 22px;
  border-radius: 10px;
  padding: 26px;
  font-size: 15px;
  font-weight: 400;
  line-height: 24px;
  color: #393939;
}
.message-container .chat-box .message-box .left-align .time {
  font-size: 13px;
  font-weight: 400;
  line-height: 19.5px;
  color: #19b25f;
  margin-left: 61px;
  margin-top: 8px;
}
.message-container .chat-box .message-box .right-align img {
  width: 40px;
  height: 40px;
  margin-left: 18px;
}
.message-container .chat-box .message-box .right-align .mesg-field {
  background-color: #eeeeee;
  border-radius: 10px;
  padding: 21px 22px;
  margin-left: 13px;
}
.message-container .chat-box .message-box .right-align svg {
  cursor: pointer;
}
.message-container .chat-box .message-box .right-align .time {
  font-size: 10px;
  font-weight: 400;
  line-height: 19.5px;
  color: #19b25f;
  margin-left: 216px;
  margin-top: 8px;
}
.message-container .chat-box .input-box {
  position: relative;
  padding: 0 20px;
}
.message-container .chat-box .input-box input {
  width: 100%;
  padding: 15px 50px 15px 18px; /* Adjust right padding for space for the send button */
  border-radius: 25px;
  border: 1px solid #bfbfbf;
  outline: none;
  color: #333333;
}
.message-container .chat-box .input-box input:focus {
  border-color: var(--green-shade-eight);
  outline: none;
}
.message-container .chat-box .input-box input::placeholder {
  color: var(--light-grey-shade-three);
}
.message-container .chat-box .input-box .send-button {
  position: absolute;
  top: 50%;
  right: 12px; /* Adjust to align perfectly inside the border */
  transform: translateY(-50%);
  width: 40px; /* Adjust size as needed */
  height: 40px;
  cursor: pointer;
}

.message-main .fa-trash {
  display: none;
}
.message-main:hover .fa-trash {
  display: block;
}

.transfer-table .table-data .red {
  fill: #ff0000;
}
.transfer-table .table-data .green {
  fill: #19b25f;
}
.transfer-table .table-data .red-color {
  color: #ff0000;
}
.transfer-table .table-data .orange {
  color: #cc9752;
}
.transfer-table .counter {
  width: 18px;
  height: 18px;
  border-radius: 50%;
  background-color: #42826c;
  display: flex;
  justify-content: center;
  align-items: center;
  color: #fff;
  font-size: 13px;
  font-weight: 400;
}

.my-account .my-account-bar {
  background-color: #f9f5ef;
  border-radius: 4px;
  padding: 24px 33px;
}
.my-account .my-account-bar .item .title {
  font-size: 20px;
  font-weight: 600;
  line-height: 30px;
  color: #393939;
}
.my-account .my-account-bar .item .text {
  font-size: 13px;
  font-weight: 600;
  line-height: 19.5px;
  color: #19b25f;
}
.my-account .my-account-bar .buttons .price {
  font-size: 30px;
  font-weight: 700;
  line-height: 45px;
  color: #42826c;
  margin-right: 26px;
}
.my-account .my-account-bar .buttons .bordered,
.my-account .my-account-bar .buttons .thick-border {
  font-size: 15px;
  font-weight: 500;
  width: 141px;
  padding-left: 0;
  padding-right: 0;
  border: 2px solid #cc9752;
}
.my-account .my-account-bar .buttons .no-bordered {
  font-size: 15px;
  font-weight: 500;
  width: 159px;
  padding-left: 0;
  padding-right: 0;
}
.my-account .dashboard-table .dashboard-table-title p {
  font-size: 15px;
  line-height: 22.5px;
}
.my-account .dashboard-table .search-group {
  width: 309px;
}
.my-account .mx-fix {
  max-width: 313px;
}

.teller-table-all .filter-btn-group {
  max-width: 275px;
  margin-right: 15px;
}
.teller-table-all .filter-btn-group .btn-border {
  padding: 7px 13px;
}
.teller-table-all .search-group-btn {
  max-width: 178px;
}
.teller-table-all .sorting-btn-group {
  width: 54%;
}
.teller-table-all .sorting-btn-group .m-10 {
  margin-right: 13px;
}
.teller-table-all .sorting-btn-group .create-btn-wrap {
  max-width: 97px;
  height: 47px;
}
.teller-table-all .sorting-btn-group .create-btn-wrap .create-btn {
  width: 100%;
  height: 100%;
  padding-left: 13px;
  padding-right: 13px;
  padding-top: 8px;
  padding-bottom: 8px;
  font-size: 13px;
  font-weight: 500;
  line-height: 19.5px;
}
.teller-table-all .details-btn {
  cursor: pointer;
}

.teller-information .profile-box .content-wrapper .content .items .item p.green-color {
  color: #42826c;
}
.teller-information .content-boxx {
  width: calc(100% - 139px);
}
.teller-information .upload-container {
  padding: 36px 30px;
}
.teller-information .upload-wrap {
  border: 1px solid #e6e6e6;
  width: calc(50% - 15px);
  border-radius: 2px;
  padding: 14px 22px;
  margin-bottom: 30px;
}
.teller-information .upload-wrap .file {
  width: 17px;
  height: 21px;
}
.teller-information .upload-wrap .delete-wrap {
  height: 16px;
  display: flex;
}
.teller-information .upload-wrap .delete-wrap .delete {
  width: 16px;
  height: 16px;
  cursor: pointer;
}
.teller-information .upload-wrap .filename {
  font-size: 15px;
  font-weight: 400;
  line-height: 22.5px;
  color: #3f3f3f;
  margin-left: 14px;
}
.teller-information .upload-wrap .view {
  width: 16px;
  height: 16px;
  margin-right: 25px;
  margin-left: 14px;
  cursor: pointer;
}
.teller-information .add-btn input {
  display: none;
}
.teller-information .add-btn .add-btn-btn {
  width: 121px;
  padding: 13px 30px;
  border: 2px solid #cc9752;
  color: #cc9752;
  font-size: 18px;
  font-weight: 500;
  line-height: 27px;
  border-radius: 100px;
  cursor: pointer;
}

.progress-container {
  padding: 45px 33px;
}
.progress-container .step-wrapper {
  z-index: 1;
  position: relative;
  margin-top: -21px;
}
.progress-container .step-wrapper ul {
  list-style-type: none;
  display: flex;
}
.progress-container .step-wrapper ul li {
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 236px;
  text-align: center;
  position: relative;
}
.progress-container .step-wrapper ul li::after {
  content: "";
  position: absolute;
  width: 100%;
  height: 2px;
  background-color: #d9d9d9;
  top: 24%;
  left: -50%;
  z-index: -1;
}
.progress-container .step-wrapper ul li:first-child::after {
  content: none;
}
.progress-container .step-wrapper ul li .icon {
  width: 40px;
  height: 40px;
  background-color: #f9f5ef;
  border: 1px solid #717171;
  outline: 5px solid #f9f5ef;
  border-radius: 50%;
  display: flex;
  justify-content: center;
  align-items: center;
}
.progress-container .step-wrapper ul li .icon span {
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
}
.progress-container .step-wrapper ul li .icon span svg {
  width: 14px;
  height: auto;
}
.progress-container .step-wrapper ul li .text {
  color: #717171;
}
.progress-container .step-wrapper ul li.active::after {
  background-color: #42826c;
}
.progress-container .step-wrapper ul li.active .icon {
  background-color: #42826c;
}
.progress-container .step-wrapper ul li.active .icon span svg {
  stroke: #fff;
}
.progress-container .step-wrapper ul li.active .text {
  color: #42826c;
}
.progress-container .step-wrapper ul li:nth-child(1) .icon span svg {
  fill: #fff;
}

.create-account-container .shadow-box {
  box-shadow: 0px 2px 8px 0px rgba(156, 156, 156, 0.25);
  border: 1px solid #e3e3e3;
  padding: 35px 20px;
  box-sizing: border-box;
  border-radius: 5px;
  margin-top: 29px;
}
.create-account-container .teller-progress {
  background-color: #f9f5ef;
  border-radius: 4px;
  padding: 64px 33px 34px;
}
.create-account-container .form-inputs h3 {
  font-size: 18px;
  font-weight: 600;
  line-height: 27px;
  color: #393939;
}
.create-account-container .btn-teller-group {
  margin-top: 34px;
}
.create-account-container .btn-teller-group .btn,
.create-account-container .btn-teller-group .bordered,
.create-account-container .btn-teller-group .no-bordered {
  padding-top: 13px;
  padding-bottom: 13px;
  padding-left: 38px;
  padding-right: 38px;
  max-width: 160px;
}
.create-account-container .popup-container .popupWrapper .popup .icon {
  background-color: transparent;
}
.create-account-container .popup-container .popupWrapper .popup h2 {
  color: #393939;
}

.normal-dashboard {
  background-color: #fff;
  min-height: 100vh;
  position: relative;
  transition: 0.5s all;
}
.normal-dashboard .p-15 {
  padding-left: 15px;
  padding-right: 15px;
}
.normal-dashboard .dashboard-main-content {
  padding-right: 15px;
  padding-left: 15px;
  width: calc(100% - 258px);
  position: absolute;
  top: 0;
  transition: 0.5s all;
  right: 0;
}
.normal-dashboard .copyright-footer {
  padding: 15px 0 12px;
  width: auto;
  position: fixed;
  bottom: 0;
  background: #fff;
}
@media (min-width: 768px) {
  .normal-dashboard .copyright-footer {
    width: 85%;
    padding: 25px 0 22px;
  }
}
.normal-dashboard .copyright-footer p {
  font-size: 12px;
  font-weight: 400;
  line-height: 1.6;
  color: #454545;
}
@media (min-width: 768px) {
  .normal-dashboard .copyright-footer p {
    font-size: 14px;
  }
}
.normal-dashboard .copyright-footer p a {
  color: #848484;
  margin: 0 5px;
}
.normal-dashboard .chat-icon {
  position: fixed;
  bottom: 30px;
  right: 30px;
  width: 66px;
  height: 66px;
  border-radius: 50%;
  cursor: pointer;
}
.normal-dashboard .dashboard-table .table tbody tr td.orange {
  color: #cc9752;
}
.normal-dashboard .table-responsive {
  overflow-x: auto;
}
.normal-dashboard .table-responsive table {
  max-width: 100%;
  width: 100%;
}

.full-width {
  transition: 0.2s all;
  width: calc(100% - 110px) !important;
}

.halfsidebar {
  transition: 0.5s all;
  max-width: 100px !important;
}

.halfsidebar p {
  visibility: hidden;
  display: none;
}

.halfsidebar svg {
  width: 25px !important;
  height: 25px !important;
}

.halfsidebar .list-box {
  justify-content: center !important;
}

.tooltip {
  padding: 24px 27px;
  border-radius: 5px;
  box-shadow: 0px 4px 20px 0px rgba(0, 0, 0, 0.2);
}

.manage-user .admin-um-multistep .form-inputs .sub-head {
  font-size: 18px;
  font-weight: 600;
  line-height: 27px;
  color: #393939;
}
.manage-user .admin-um-multistep .profile-box .content-wrapper .content .items .item .btn-red p {
  color: #d65d43;
}
.manage-user .admin-um-multistep .upload-container .doc-wrap {
  width: calc(50% - 15px);
}
.manage-user .admin-um-multistep .upload-container .doc-title {
  font-size: 15px;
  font-weight: 400;
  line-height: 22.5px;
  color: #393939;
  margin-bottom: 0;
}

.admin-um-ud .back-btn {
  font-size: 18px;
  font-weight: 600;
  line-height: 27px;
  color: #393939;
  cursor: pointer;
  padding: 20px 0;
}
.admin-um-ud .back-btn svg {
  width: 24px;
  height: 16px;
}
.admin-um-ud .content-boxx {
  width: calc(100% - 139px);
}
.admin-um-ud .upload-container {
  padding: 36px 30px;
}
.admin-um-ud .upload-wrap {
  border-bottom: 2px solid #e6e6e6;
  border-radius: 2px;
  padding: 14px 0;
  margin-bottom: 30px;
}
.admin-um-ud .upload-wrap .file {
  width: 17px;
  height: 21px;
}
.admin-um-ud .upload-wrap .delete-wrap {
  height: 16px;
  display: flex;
}
.admin-um-ud .upload-wrap .delete-wrap .delete {
  width: 16px;
  height: 16px;
  cursor: pointer;
}
.admin-um-ud .upload-wrap .filename {
  font-size: 15px;
  font-weight: 400;
  line-height: 22.5px;
  color: #3f3f3f;
  margin-left: 14px;
}
.admin-um-ud .upload-wrap .view {
  width: 16px;
  height: 16px;
  margin-right: 14px;
  margin-left: 14px;
  cursor: pointer;
}
.admin-um-ud .upload-wrap svg.download {
  margin-right: 14px;
  fill: #cc9752;
  cursor: pointer;
}
.admin-um-ud .add-btn input {
  display: none;
}
.admin-um-ud .add-btn .add-btn-btn {
  width: 121px;
  padding: 13px 30px;
  border: 2px solid #cc9752;
  color: #cc9752;
  font-size: 18px;
  font-weight: 500;
  line-height: 27px;
  border-radius: 100px;
  cursor: pointer;
}
.admin-um-ud .date {
  font-size: 15px;
  font-weight: 700;
  line-height: 22.5px;
  color: #393939;
}
.admin-um-ud table.table-activity {
  width: 100%;
}
.admin-um-ud table.table-activity tbody tr {
  display: flex;
  justify-content: space-between;
  width: 100%;
  align-items: center;
  border-bottom: 1px solid #e6e6e6;
  padding: 14px 0;
}
.admin-um-ud table.table-activity tbody tr td {
  display: flex;
}
.admin-um-ud table.table-activity tbody tr td span {
  color: #00a879;
}
.admin-um-ud table.table-activity tbody tr td img {
  width: 36px;
  height: 36px;
  border-radius: 50%;
}
.admin-um-ud table.table-activity tbody tr td .user-name p {
  font-size: 14px;
  font-weight: 400;
  line-height: 21px;
  color: #717171;
}
.admin-um-ud table.table-activity tbody tr td .user-name p.title {
  font-size: 15px;
  font-weight: 600;
  line-height: 22.5px;
  color: #393939;
}
.admin-um-ud table.table-activity tbody tr td .long-text {
  font-size: 14px;
  font-weight: 500;
  line-height: 21px;
  color: #646464;
}
.admin-um-ud table.table-activity tbody tr td .long-text b {
  color: #333333;
}
.admin-um-ud .header-title .header-btn svg {
  width: 17px;
  height: 17px;
}
.admin-um-ud .header-title .header-btn p {
  font-size: 15px;
  font-weight: 500;
  line-height: 22.5px;
  color: #cc9752;
}
.admin-um-ud .profile-box .content-wrapper .content .items .item .btn-red p {
  color: #d65d43;
}
.admin-um-ud .upload-container .doc-wrap {
  width: calc(50% - 15px);
}
.admin-um-ud .upload-container .doc-title {
  font-size: 15px;
  font-weight: 400;
  line-height: 22.5px;
  color: #393939;
  margin-bottom: 0;
}
.admin-um-ud .search-group {
  width: 209px;
}

.shadow, .card-profile-image img {
  border-bottom: 1px solid #e6e6e6;
  border: 1px solid rgba(156, 156, 156, 0.35);
  padding: 21px 30px;
  cursor: pointer;
}
.shadow .card-header h1, .card-profile-image img .card-header h1 {
  font-size: 18px;
  font-weight: 600;
  line-height: 27px;
  color: #333333;
}
.shadow .search-group, .card-profile-image img .search-group {
  border: 0;
  border-bottom: 2px solid #bababa;
  max-width: none;
  width: 230px;
}
.shadow .search-group svg, .card-profile-image img .search-group svg {
  width: 13px;
  height: 13px;
}
.shadow .search-group label, .card-profile-image img .search-group label {
  font-size: 15px;
  font-weight: 400;
  line-height: 22.5px;
  color: #393939;
}
.shadow .search-group input, .card-profile-image img .search-group input {
  border: 0;
  outline: 0;
  box-shadow: none;
  width: 100%;
  height: 100%;
  font-size: 13px;
  font-weight: 400;
  line-height: 19.5px;
  color: #797979;
}
.shadow .search-group input:focus, .card-profile-image img .search-group input:focus {
  outline: 0;
  box-shadow: 0;
}
.shadow .no-bordered, .card-profile-image img .no-bordered,
.shadow .bordered,
.card-profile-image img .bordered {
  padding-top: 10px;
  padding-bottom: 10px;
  padding-left: 20px;
  padding-right: 20px;
}
.shadow .input-field, .card-profile-image img .input-field {
  border-radius: 0;
}
.shadow .input-field input, .card-profile-image img .input-field input,
.shadow .input-field select,
.card-profile-image img .input-field select {
  color: #717171;
  border: 0;
  border-bottom: 1px solid #b1b1b1;
  width: 100%;
  background: transparent;
  padding: 0 0 8px 0;
  border-radius: 0;
  box-shadow: none;
}
.shadow .input-field label, .card-profile-image img .input-field label {
  color: #393939;
  font-size: 15px;
  font-weight: 400;
  line-height: 22.5px;
  margin-bottom: 0;
}
.shadow .custom-checkbox, .card-profile-image img .custom-checkbox {
  display: flex;
  align-items: center;
}
.shadow .custom-checkbox input[type=checkbox], .card-profile-image img .custom-checkbox input[type=checkbox] {
  position: absolute;
  opacity: 0;
  width: 18px;
  height: 18px;
  z-index: 1;
}
.shadow .custom-checkbox input[type=checkbox]:checked + .custom-checkbox-box, .card-profile-image img .custom-checkbox input[type=checkbox]:checked + .custom-checkbox-box {
  background-color: #cc9752;
  border-color: #cc9752;
}
.shadow .custom-checkbox input[type=checkbox]:checked + .custom-checkbox-box .checkbox-icon, .card-profile-image img .custom-checkbox input[type=checkbox]:checked + .custom-checkbox-box .checkbox-icon {
  display: flex;
}
.shadow .custom-checkbox .custom-checkbox-box, .card-profile-image img .custom-checkbox .custom-checkbox-box {
  width: 18px;
  height: 18px;
  border: 1px solid #cc9752;
  background: #fff;
  display: flex;
  align-items: center;
  justify-content: center;
  position: relative;
  margin-right: 8px;
  border-radius: 2px;
  padding: 3px;
  box-sizing: border-box;
  transition: background-color 0.2s ease;
  cursor: pointer;
  margin-bottom: 0;
}
.shadow .custom-checkbox .checkbox-icon, .card-profile-image img .custom-checkbox .checkbox-icon {
  color: #fff;
  font-size: 14px;
  display: none;
}
.shadow .custom-checkbox .checkbox-label, .card-profile-image img .custom-checkbox .checkbox-label {
  margin-left: 8px;
  color: #393939;
}
.shadow .custom-checkbox .checkbox-label .highlighted-text, .card-profile-image img .custom-checkbox .checkbox-label .highlighted-text {
  color: #cc9752;
}
.shadow .no-text p, .card-profile-image img .no-text p {
  display: none;
}

.modal-popup .input-field {
  border-radius: 0;
}
.modal-popup .input-field input,
.modal-popup .input-field select {
  color: #717171;
  border: 0;
  border-bottom: 1px solid #b1b1b1;
  width: 100%;
  background: transparent;
  padding: 0 0 8px 0;
  border-radius: 0;
  box-shadow: none;
}
.modal-popup .input-field label {
  color: #393939;
  font-size: 15px;
  font-weight: 400;
  line-height: 22.5px;
  margin-bottom: 0;
}
.modal-popup .modal-content {
  padding: 30px;
}
.modal-popup .modal-content .modal-title {
  font-size: 18px;
  font-weight: 600;
  line-height: 27px;
  color: #333333;
  position: relative;
  width: 100%;
}
.modal-popup .modal-content .modal-title .close {
  padding: 0;
  position: absolute;
  width: 30px;
  height: 30px;
  top: 0;
  right: 0;
  border: 0;
  box-shadow: none;
  background-color: transparent;
  opacity: 1;
}
.modal-popup .modal-content .modal-title .close svg {
  width: 20px;
  height: 20px;
  color: #393939;
}
.modal-popup .assoicate-user .associate-preview .section {
  border-bottom: 0;
  padding: 0;
  margin-left: -20px;
  margin-right: -20px;
}
.modal-popup .assoicate-user .associate-preview .item {
  width: auto;
  min-width: 25%;
  margin-right: 20px;
  margin-left: 20px;
  padding-right: 0;
}

.custom-table .table thead th,
.custom-table .table thead td,
.custom-table .table tbody th,
.custom-table .table tbody td {
  background-color: transparent;
  padding: 14px;
}
.custom-table .table tbody tr td.orange {
  color: #cc9752;
}
.custom-table .table tbody tr td {
  padding: 12px 8px;
}
.custom-table .table tbody tr td .dropdown a {
  padding: 0;
}
.custom-table .table tbody tr td .dropdown a i {
  color: #cc9752;
}
.custom-table .table tbody tr td .dropdown a:hover {
  box-shadow: none;
}
.custom-table .table tbody tr td .dropdown a.text-light:hover, .custom-table .table tbody tr td .dropdown a.text-light:focus {
  box-shadow: none;
}
.custom-table .table tbody tr td p.role-button {
  border: 2px solid #d9d9d9;
  border-radius: 500px;
  padding: 7px 12px;
  display: flex;
  justify-content: center;
  align-items: center;
}`, "",{"version":3,"sources":["webpack://./src/assets/scss/argon-dashboard-react.scss","webpack://./node_modules/bootstrap/scss/_root.scss","webpack://./node_modules/bootstrap/scss/_reboot.scss","webpack://./src/assets/scss/argon-dashboard/custom/_variables.scss","webpack://./node_modules/bootstrap/scss/vendor/_rfs.scss","webpack://./node_modules/bootstrap/scss/_variables.scss","webpack://./node_modules/bootstrap/scss/mixins/_hover.scss","webpack://./node_modules/bootstrap/scss/_type.scss","webpack://./node_modules/bootstrap/scss/mixins/_lists.scss","webpack://./node_modules/bootstrap/scss/_images.scss","webpack://./node_modules/bootstrap/scss/mixins/_image.scss","webpack://./node_modules/bootstrap/scss/mixins/_border-radius.scss","webpack://./node_modules/bootstrap/scss/mixins/_box-shadow.scss","webpack://./node_modules/bootstrap/scss/_code.scss","webpack://./node_modules/bootstrap/scss/_grid.scss","webpack://./node_modules/bootstrap/scss/mixins/_grid.scss","webpack://./node_modules/bootstrap/scss/mixins/_breakpoints.scss","webpack://./node_modules/bootstrap/scss/mixins/_grid-framework.scss","webpack://./node_modules/bootstrap/scss/_tables.scss","webpack://./node_modules/bootstrap/scss/mixins/_table-row.scss","webpack://./node_modules/bootstrap/scss/_forms.scss","webpack://./node_modules/bootstrap/scss/mixins/_transition.scss","webpack://./src/assets/scss/argon-dashboard/custom/mixins/_forms.scss","webpack://./node_modules/bootstrap/scss/mixins/_gradients.scss","webpack://./node_modules/bootstrap/scss/_buttons.scss","webpack://./src/assets/scss/argon-dashboard/custom/mixins/_buttons.scss","webpack://./node_modules/bootstrap/scss/_transitions.scss","webpack://./node_modules/bootstrap/scss/_dropdown.scss","webpack://./node_modules/bootstrap/scss/mixins/_caret.scss","webpack://./node_modules/bootstrap/scss/mixins/_nav-divider.scss","webpack://./node_modules/bootstrap/scss/_button-group.scss","webpack://./node_modules/bootstrap/scss/_input-group.scss","webpack://./node_modules/bootstrap/scss/_custom-forms.scss","webpack://./node_modules/bootstrap/scss/_nav.scss","webpack://./node_modules/bootstrap/scss/_navbar.scss","webpack://./node_modules/bootstrap/scss/_card.scss","webpack://./node_modules/bootstrap/scss/_breadcrumb.scss","webpack://./node_modules/bootstrap/scss/_pagination.scss","webpack://./node_modules/bootstrap/scss/mixins/_pagination.scss","webpack://./node_modules/bootstrap/scss/_badge.scss","webpack://./src/assets/scss/argon-dashboard/custom/mixins/_badge.scss","webpack://./node_modules/bootstrap/scss/_jumbotron.scss","webpack://./node_modules/bootstrap/scss/_alert.scss","webpack://./src/assets/scss/argon-dashboard/custom/mixins/_alert.scss","webpack://./node_modules/bootstrap/scss/_progress.scss","webpack://./node_modules/bootstrap/scss/_media.scss","webpack://./node_modules/bootstrap/scss/_list-group.scss","webpack://./node_modules/bootstrap/scss/mixins/_list-group.scss","webpack://./node_modules/bootstrap/scss/_close.scss","webpack://./node_modules/bootstrap/scss/_modal.scss","webpack://./node_modules/bootstrap/scss/_tooltip.scss","webpack://./node_modules/bootstrap/scss/mixins/_reset-text.scss","webpack://./node_modules/bootstrap/scss/_popover.scss","webpack://./node_modules/bootstrap/scss/_carousel.scss","webpack://./node_modules/bootstrap/scss/mixins/_clearfix.scss","webpack://./node_modules/bootstrap/scss/utilities/_align.scss","webpack://./src/assets/scss/argon-dashboard/custom/mixins/_background-variant.scss","webpack://./node_modules/bootstrap/scss/utilities/_background.scss","webpack://./node_modules/bootstrap/scss/utilities/_borders.scss","webpack://./node_modules/bootstrap/scss/utilities/_display.scss","webpack://./node_modules/bootstrap/scss/utilities/_embed.scss","webpack://./node_modules/bootstrap/scss/utilities/_flex.scss","webpack://./node_modules/bootstrap/scss/utilities/_float.scss","webpack://./node_modules/bootstrap/scss/utilities/_interactions.scss","webpack://./node_modules/bootstrap/scss/utilities/_overflow.scss","webpack://./node_modules/bootstrap/scss/utilities/_position.scss","webpack://./node_modules/bootstrap/scss/utilities/_screenreaders.scss","webpack://./node_modules/bootstrap/scss/mixins/_screen-reader.scss","webpack://./node_modules/bootstrap/scss/utilities/_shadows.scss","webpack://./node_modules/bootstrap/scss/utilities/_sizing.scss","webpack://./node_modules/bootstrap/scss/utilities/_spacing.scss","webpack://./node_modules/bootstrap/scss/utilities/_stretched-link.scss","webpack://./node_modules/bootstrap/scss/utilities/_text.scss","webpack://./node_modules/bootstrap/scss/mixins/_text-truncate.scss","webpack://./node_modules/bootstrap/scss/mixins/_text-emphasis.scss","webpack://./node_modules/bootstrap/scss/mixins/_text-hide.scss","webpack://./node_modules/bootstrap/scss/utilities/_visibility.scss","webpack://./node_modules/bootstrap/scss/_print.scss","webpack://./src/assets/scss/argon-dashboard/custom/_reboot.scss","webpack://./src/assets/scss/argon-dashboard/custom/utilities/_backgrounds.scss","webpack://./src/assets/scss/argon-dashboard/custom/utilities/_floating.scss","webpack://./src/assets/scss/argon-dashboard/custom/utilities/_helper.scss","webpack://./src/assets/scss/argon-dashboard/custom/utilities/_image.scss","webpack://./src/assets/scss/argon-dashboard/custom/utilities/_opacity.scss","webpack://./src/assets/scss/argon-dashboard/custom/utilities/_overflow.scss","webpack://./src/assets/scss/argon-dashboard/custom/utilities/_position.scss","webpack://./src/assets/scss/argon-dashboard/custom/utilities/_sizing.scss","webpack://./src/assets/scss/argon-dashboard/custom/utilities/_spacing.scss","webpack://./src/assets/scss/argon-dashboard/custom/utilities/_shadows.scss","webpack://./src/assets/scss/argon-dashboard/custom/utilities/_text.scss","webpack://./src/assets/scss/argon-dashboard/custom/utilities/_transform.scss","webpack://./src/assets/scss/argon-dashboard/custom/alerts/_alert.scss","webpack://./src/assets/scss/argon-dashboard/custom/alerts/_alert-dismissible.scss","webpack://./src/assets/scss/argon-dashboard/custom/avatars/_avatar.scss","webpack://./src/assets/scss/argon-dashboard/custom/badges/_badge.scss","webpack://./src/assets/scss/argon-dashboard/custom/badges/_badge-circle.scss","webpack://./src/assets/scss/argon-dashboard/custom/badges/_badge-dot.scss","webpack://./src/assets/scss/argon-dashboard/custom/buttons/_button.scss","webpack://./src/assets/scss/argon-dashboard/custom/buttons/_button-icon.scss","webpack://./src/assets/scss/argon-dashboard/custom/buttons/_button-brand.scss","webpack://./src/assets/scss/argon-dashboard/custom/cards/_card.scss","webpack://./src/assets/scss/argon-dashboard/custom/cards/_card-profile.scss","webpack://./src/assets/scss/argon-dashboard/custom/cards/_card-animations.scss","webpack://./src/assets/scss/argon-dashboard/custom/cards/_card-stats.scss","webpack://./src/assets/scss/argon-dashboard/custom/charts/_chart.scss","webpack://./src/assets/scss/argon-dashboard/custom/close/_close.scss","webpack://./src/assets/scss/argon-dashboard/custom/_content.scss","webpack://./src/assets/scss/abstracts/_variables.scss","webpack://./src/assets/scss/argon-dashboard/custom/custom-forms/_custom-form.scss","webpack://./src/assets/scss/argon-dashboard/custom/custom-forms/_custom-control.scss","webpack://./src/assets/scss/argon-dashboard/custom/custom-forms/_custom-checkbox.scss","webpack://./src/assets/scss/argon-dashboard/custom/custom-forms/_custom-radio.scss","webpack://./src/assets/scss/argon-dashboard/custom/custom-forms/_custom-toggle.scss","webpack://./src/assets/scss/argon-dashboard/custom/dropdowns/_dropdown.scss","webpack://./src/assets/scss/argon-dashboard/custom/footers/_footer.scss","webpack://./src/assets/scss/argon-dashboard/custom/forms/_form.scss","webpack://./src/assets/scss/argon-dashboard/custom/forms/_form-validation.scss","webpack://./src/assets/scss/argon-dashboard/custom/forms/_input-group.scss","webpack://./src/assets/scss/argon-dashboard/custom/headers/_header.scss","webpack://./src/assets/scss/argon-dashboard/custom/icons/_icon.scss","webpack://./src/assets/scss/argon-dashboard/custom/icons/_icon-shape.scss","webpack://./src/assets/scss/argon-dashboard/custom/mixins/_icon.scss","webpack://./src/assets/scss/argon-dashboard/custom/list-groups/_list-group.scss","webpack://./src/assets/scss/argon-dashboard/custom/maps/_map.scss","webpack://./src/assets/scss/argon-dashboard/custom/masks/_mask.scss","webpack://./src/assets/scss/argon-dashboard/custom/modals/_modal.scss","webpack://./src/assets/scss/argon-dashboard/custom/mixins/_modals.scss","webpack://./src/assets/scss/argon-dashboard/custom/navs/_nav.scss","webpack://./src/assets/scss/argon-dashboard/custom/navs/_nav-pills.scss","webpack://./src/assets/scss/argon-dashboard/custom/navbars/_navbar.scss","webpack://./src/assets/scss/argon-dashboard/custom/navbars/_navbar-vertical.scss","webpack://./src/assets/scss/argon-dashboard/custom/navbars/_navbar-search.scss","webpack://./src/assets/scss/argon-dashboard/custom/navbars/_navbar-dropdown.scss","webpack://./src/assets/scss/argon-dashboard/custom/navbars/_navbar-collapse.scss","webpack://./src/assets/scss/argon-dashboard/custom/paginations/_pagination.scss","webpack://./src/assets/scss/argon-dashboard/custom/popovers/_popover.scss","webpack://./src/assets/scss/argon-dashboard/custom/mixins/_popover.scss","webpack://./src/assets/scss/argon-dashboard/custom/progresses/_progress.scss","webpack://./src/assets/scss/argon-dashboard/custom/separators/_separator.scss","webpack://./src/assets/scss/argon-dashboard/custom/tables/_table.scss","webpack://./src/assets/scss/argon-dashboard/custom/type/_type.scss","webpack://./src/assets/scss/argon-dashboard/custom/type/_heading.scss","webpack://./src/assets/scss/argon-dashboard/custom/type/_display.scss","webpack://./src/assets/scss/argon-dashboard/custom/type/_article.scss","webpack://./src/assets/scss/argon-dashboard/custom/vendors/_bootstrap-datepicker.scss","webpack://./src/assets/scss/argon-dashboard/custom/vendors/_nouislider.scss","webpack://./src/assets/scss/argon-dashboard/custom/vendors/_scrollbar.scss","webpack://./src/assets/scss/argon-dashboard/docs/_nav.scss","webpack://./src/assets/scss/argon-dashboard/docs/_variables.scss","webpack://./src/assets/scss/argon-dashboard/docs/_clipboard-js.scss","webpack://./src/assets/scss/argon-dashboard/docs/_component-examples.scss","webpack://./src/assets/scss/argon-dashboard/docs/_prism.scss","webpack://./src/assets/scss/argon-dashboard/docs/_content.scss","webpack://./src/assets/scss/argon-dashboard/docs/_sidebar.scss","webpack://./src/assets/scss/argon-dashboard/docs/_footer.scss","webpack://./node_modules/bootstrap/scss/_spinners.scss","webpack://./src/assets/scss/react/plugins/_plugin-react-datetime.scss","webpack://./src/assets/scss/react/_buttons.scss","webpack://./src/assets/scss/react/_mixins.scss","webpack://./src/assets/scss/react/_navbar-dropdown.scss","webpack://./src/assets/scss/react/_navbar.scss","webpack://./src/assets/scss/react/_tables.scss","webpack://./src/assets/scss/scopes/_s-table.scss","webpack://./src/assets/scss/utilities/_u-max-width.scss","webpack://./src/assets/scss/utilities/_u-flex.scss","webpack://./src/assets/scss/utilities/_u-background.scss","webpack://./src/assets/scss/utilities/_u-min-height.scss","webpack://./src/assets/scss/utilities/_u-width.scss","webpack://./src/assets/scss/utilities/_u-cursor.scss","webpack://./src/assets/scss/media-queries/_responsive.scss","webpack://./src/assets/scss/Login/_login-user.scss","webpack://./src/assets/scss/abstracts/_mixins.scss","webpack://./src/assets/scss/components/_radioButton.scss","webpack://./src/assets/scss/components/_passwordStrength.scss","webpack://./src/assets/scss/components/_progress-bar.scss","webpack://./src/assets/scss/components/_date-picker.scss","webpack://./src/assets/scss/components/_dropdown-custom.scss","webpack://./src/assets/scss/components/_dropdown-numbers.scss","webpack://./src/assets/scss/components/_upload-btn.scss","webpack://./src/assets/scss/components/_popus.scss","webpack://./src/assets/scss/Signup/_signup-user.scss","webpack://./src/assets/scss/components/_buttonSubmit.scss","webpack://./src/assets/scss/components/_update-btn.scss","webpack://./src/assets/scss/components/_dashboard-sidebar.scss","webpack://./src/assets/scss/components/_dashboard-topbar.scss","webpack://./src/assets/scss/components/_dashboard-userbar.scss","webpack://./src/assets/scss/components/_dashboard-card.scss","webpack://./src/assets/scss/components/_barChart.scss","webpack://./src/assets/scss/components/_dashboarDatepicker.scss","webpack://./src/assets/scss/components/_dashboard-drop.scss","webpack://./src/assets/scss/components/_dashboard-table.scss","webpack://./src/assets/scss/components/_button-status.scss","webpack://./src/assets/scss/components/Pagination/_pagination.scss","webpack://./src/assets/scss/components/dashboar-recharge/_inputField.scss","webpack://./src/assets/scss/components/dashboar-recharge/_card-input.scss","webpack://./src/assets/scss/components/dashboar-recharge/_recharge-account.scss","webpack://./src/assets/scss/components/dashboard-profile/_sidebar.scss","webpack://./src/assets/scss/components/dashboard-profile/_accordion.scss","webpack://./src/assets/scss/components/dashboard-profile/_password.scss","webpack://./src/assets/scss/components/dashboard-profile/_availability.scss","webpack://./src/assets/scss/components/dashboard-profile/_profile-management.scss","webpack://./src/assets/scss/components/dashboard-profile/_account-type.scss","webpack://./src/assets/scss/components/DashbaordTransaction/_transfer-bar.scss","webpack://./src/assets/scss/components/DashbaordTransaction/_money-transfer.scss","webpack://./src/assets/scss/components/DashbaordTransaction/_money-transfer-table.scss","webpack://./src/assets/scss/components/DashbaordTransaction/_registered-form.scss","webpack://./src/assets/scss/components/DashboardMap/_dashboard-map.scss","webpack://./src/assets/scss/components/DashboardInviteUser/_invite-user.scss","webpack://./src/assets/scss/components/_TimePickerCustom.scss","webpack://./src/assets/scss/components/DashboardAssociateUser/_associateUser.scss","webpack://./src/assets/scss/components/DashbaordTransaction/_filter-popup.scss","webpack://./src/assets/scss/components/DashbaordTransaction/_transaction-details.scss","webpack://./src/assets/scss/components/dashboar-message/_message.scss","webpack://./src/assets/scss/components/Dashbaord-myaccount/_myaccount.scss","webpack://./src/assets/scss/components/TellerAccount/_teller-account.scss","webpack://./src/assets/scss/components/TellerAccount/_teller-info.scss","webpack://./src/assets/scss/components/TellerAccount/_create-account.scss","webpack://./src/assets/scss/components/_dashboard.scss","webpack://./src/assets/scss/components/Tooltip/_tooltip.scss","webpack://./src/assets/scss/admin/_user-management.scss","webpack://./src/assets/scss/argon-dashboard/client-management/_client-management.scss"],"names":[],"mappings":"AAAA,gBAAgB;ACAhB;EAGI,eAAA;EAAA,iBAAA;EAAA,iBAAA;EAAA,eAAA;EAAA,cAAA;EAAA,iBAAA;EAAA,iBAAA;EAAA,gBAAA;EAAA,eAAA;EAAA,eAAA;EAAA,aAAA;EAAA,eAAA;EAAA,oBAAA;EAAA,gBAAA;EAAA,kBAAA;EAIA,kBAAA;EAAA,oBAAA;EAAA,kBAAA;EAAA,eAAA;EAAA,kBAAA;EAAA,iBAAA;EAAA,gBAAA;EAAA,eAAA;EAAA,kBAAA;EAAA,aAAA;EAAA,eAAA;EAAA,eAAA;EAIA,kBAAA;EAAA,sBAAA;EAAA,sBAAA;EAAA,sBAAA;EAAA,uBAAA;EAKF,+CAAA;EACA,6GAAA;ADmBF;;AElBA;;;EAGE,sBAAA;AFqBF;;AElBA;EACE,uBAAA;EACA,iBAAA;EACA,8BAAA;EACA,6CAAA;AFqBF;;AEfA;EACE,cAAA;AFkBF;;AERA;EACE,SAAA;EACA,kCC4SA;EC5NI,eAtCa;EFxCjB,gBCqTmB;EDpTnB,gBCyTiB;EDxTjB,cC5BS;ED6BT,gBAAA;EACA,yBCgLQ;AHrKV;;AECA;EACE,qBAAA;AFEF;;AEOA;EACE,uBAAA;EACA,SAAA;EACA,iBAAA;AFJF;;AEiBA;EACE,aAAA;EACA,qBCwRuB;AHtSzB;;AEqBA;EACE,aAAA;EACA,mBGoF0B;ALtG5B;;AE6BA;;EAEE,0BAAA;EACA,yCAAA;UAAA,iCAAA;EACA,YAAA;EACA,gBAAA;EACA,8BAAA;AF1BF;;AE6BA;EACE,mBAAA;EACA,kBAAA;EACA,oBAAA;AF1BF;;AE6BA;;;EAGE,aAAA;EACA,mBAAA;AF1BF;;AE6BA;;;;EAIE,gBAAA;AF1BF;;AE6BA;EACE,gBCwNiB;AHlPnB;;AE6BA;EACE,qBAAA;EACA,cAAA;AF1BF;;AE6BA;EACE,gBAAA;AF1BF;;AE6BA;;EAEE,mBGoI4B;AL9J9B;;AE6BA;EExFI,cAAA;AJ+DJ;;AEkCA;;EAEE,kBAAA;EEnGE,cAAA;EFqGF,cAAA;EACA,wBAAA;AF/BF;;AEkCA;EAAM,eAAA;AF9BN;;AE+BA;EAAM,WAAA;AF3BN;;AEkCA;EACE,cC3GQ;ED4GR,qBC8DgB;ED7DhB,6BAAA;AF/BF;AMjJE;EJmLE,wDC2De;ED1Df,qBC2DoB;AH1FxB;;AEwCA;EACE,cAAA;EACA,qBAAA;AFrCF;AM1JE;EJkME,cAAA;EACA,qBAAA;AFrCJ;;AE8CA;;;;EAIE,iGGyD4B;ED7M1B,cAAA;AJ0GJ;;AE8CA;EAEE,aAAA;EAEA,mBAAA;EAEA,cAAA;EAGA,6BAAA;AFhDF;;AEwDA;EAEE,gBAAA;AFtDF;;AE8DA;EACE,sBAAA;EACA,kBAAA;AF3DF;;AE8DA;EAGE,gBAAA;EACA,sBAAA;AF7DF;;AEqEA;EACE,yBAAA;AFlEF;;AEqEA;EACE,iBCwKmB;EDvKnB,oBCuKmB;EDtKnB,cC7PS;ED8PT,gBAAA;EACA,oBAAA;AFlEF;;AEyEA;EAEE,mBAAA;EACA,gCAAA;AFvEF;;AE+EA;EAEE,qBAAA;EACA,qBG2JsC;ALxOxC;;AEmFA;EAEE,gBAAA;AFjFF;;AEyFA;EACE,UAAA;AFtFF;;AEyFA;;;;;EAKE,SAAA;EACA,oBAAA;EE5PE,kBAAA;EF8PF,oBAAA;AFtFF;;AEyFA;;EAEE,iBAAA;AFtFF;;AEyFA;;EAEE,oBAAA;AFtFF;;AE4FA;EACE,eAAA;AFzFF;;AE+FA;EACE,iBAAA;AF5FF;;AEmGA;;;;EAIE,0BAAA;AFhGF;;AEyGI;;;;EACE,eAAA;AFnGN;;AEyGA;;;;EAIE,UAAA;EACA,kBAAA;AFtGF;;AEyGA;;EAEE,sBAAA;EACA,UAAA;AFtGF;;AE0GA;EACE,cAAA;EAEA,gBAAA;AFxGF;;AE2GA;EAME,YAAA;EAEA,UAAA;EACA,SAAA;EACA,SAAA;AF9GF;;AEmHA;EACE,cAAA;EACA,WAAA;EACA,eAAA;EACA,UAAA;EACA,qBAAA;EEnSI,iBAtCa;EF2UjB,oBAAA;EACA,cAAA;EACA,mBAAA;AFhHF;;AEmHA;EACE,wBAAA;AFhHF;;AEoHA;;EAEE,YAAA;AFjHF;;AEoHA;EAKE,oBAAA;EACA,wBAAA;AFrHF;;AE4HA;EACE,wBAAA;AFzHF;;AEiIA;EACE,aAAA;EACA,0BAAA;AF9HF;;AEqIA;EACE,qBAAA;AFlIF;;AEqIA;EACE,kBAAA;EACA,eAAA;AFlIF;;AEqIA;EACE,aAAA;AFlIF;;AEuIA;EACE,wBAAA;AFpIF;;AOxVA;;EAEE,qBJ6WuB;EI5WvB,oBJ6WqB;EI5WrB,gBJ6ViB;EI5VjB,gBJ6WqB;EI5WrB,cJYS;AH+UX;;AOxVA;EHgHM,mBAtCa;AJkRnB;;AO3VA;EH+GM,kBAtCa;AJsRnB;;AO9VA;EH8GM,oBAtCa;AJ0RnB;;AOjWA;EH6GM,oBAtCa;AJ8RnB;;AOpWA;EH4GM,oBAtCa;AJkSnB;;AOvWA;EH2GM,mBAtCa;AJsSnB;;AOzWA;EHyGM,kBAtCa;EGjEjB,gBJkYiB;AHtBnB;;AOxWA;EHmGM,iBAtCa;EG3DjB,gBJyUiB;EIxUjB,gBJyVqB;AHkBvB;;AOzWA;EH8FM,kBAtCa;EGtDjB,gBJoUiB;EInUjB,gBJoVqB;AHwBvB;;AO1WA;EHyFM,oBAtCa;EGjDjB,gBJ+TiB;EI9TjB,gBJ+UqB;AH8BvB;;AO3WA;EHoFM,oBAtCa;EG5CjB,gBJ0TiB;EIzTjB,gBJ0UqB;AHoCvB;;AOtWA;EACE,gBJuXY;EItXZ,mBJsXY;EIrXZ,SAAA;EACA,wCAAA;APyWF;;AOjWA;;EHMI,cAAA;EGHF,gBJiSmB;AHmErB;;AOjWA;;EAEE,cJ4Va;EI3Vb,yBJiWQ;AHGV;;AO5VA;EC/EE,eAAA;EACA,gBAAA;AR+aF;;AO5VA;ECpFE,eAAA;EACA,gBAAA;ARobF;;AO9VA;EACE,qBAAA;APiWF;AO/VE;EACE,oBJ2UkB;AHsBtB;;AOvVA;EHjCI,cAAA;EGmCF,yBAAA;AP0VF;;AOtVA;EACE,mBJgKO;ECjJH,kBAtCa;AJiXnB;;AOtVA;EACE,cAAA;EH7CE,cAAA;EG+CF,cJjGS;AH0bX;AOvVE;EACE,aAAA;APyVJ;;AS5cA;ECIE,eAAA;EAGA,YAAA;AV0cF;;AS3cA;EACE,gBJmgCkC;EIlgClC,yBNsNQ;EMrNR,yBAAA;EEEE,uBAAA;ECFE,0CHEJ;ECPA,eAAA;EAGA,YAAA;AVodF;;AStcA;EAEE,qBAAA;ATwcF;;ASrcA;EACE,qBAAA;EACA,cAAA;ATwcF;;ASrcA;ELkCI,cAAA;EKhCF,cNlBS;AH0dX;;Aa/eA;ETuEI,gBAAA;ESrEF,cV4CK;EU3CL,qBAAA;AbkfF;Aa/eE;EACE,cAAA;AbifJ;;Aa5eA;EACE,sBAAA;ET0DE,gBAAA;ESxDF,WAAA;EACA,yBVQS;EQPP,sBAAA;ECFE,iDCGJ;Ab+eF;Aa7eE;EACE,UAAA;ETkDA,eAAA;EShDA,gBV+Ue;ESvVb,gBCSF;Ab+eJ;;Aa1eA;EACE,cAAA;ETyCE,gBAAA;ESvCF,cVRS;AHqfX;Aa1eE;EToCE,kBAAA;ESlCA,cAAA;EACA,kBAAA;Ab4eJ;;AaveA;EACE,iBR8jCkC;EQ7jClC,kBAAA;Ab0eF;;AclhBE;;;;;;ECDA,WAAA;EACA,mBAAA;EACA,kBAAA;EACA,kBAAA;EACA,iBAAA;Af4hBF;;AgBzeI;EFzCE;IACE,gBT8Le;ELwVrB;AACF;AgB/eI;EFzCE;IACE,gBT8Le;EL6VrB;AACF;AgBpfI;EFzCE;IACE,gBT8Le;ELkWrB;AACF;AgBzfI;EFzCE;IACE,iBT8Le;ELuWrB;AACF;Ac1gBE;ECnCA,aAAA;EACA,eAAA;EACA,mBAAA;EACA,kBAAA;AfgjBF;;Ac1gBE;EACE,eAAA;EACA,cAAA;Ad6gBJ;Ac3gBI;;EAEE,gBAAA;EACA,eAAA;Ad6gBN;;AiBnkBE;;;;;;EACE,kBAAA;EACA,WAAA;EACA,mBAAA;EACA,kBAAA;AjB2kBJ;;AiBrjBM;EACE,aAAA;EACA,YAAA;EACA,eAAA;AjBwjBR;;Ae5hBE;EACE,cAAA;EACA,eAAA;Af+hBJ;;AejiBE;EACE,aAAA;EACA,cAAA;AfoiBJ;;AetiBE;EACE,wBAAA;EACA,yBAAA;AfyiBJ;;Ae3iBE;EACE,aAAA;EACA,cAAA;Af8iBJ;;AehjBE;EACE,aAAA;EACA,cAAA;AfmjBJ;;AerjBE;EACE,wBAAA;EACA,yBAAA;AfwjBJ;;AiB3kBM;EFCJ,cAAA;EACA,WAAA;EACA,eAAA;Af8kBF;;AiB3kBU;EFbR,uBAAA;EAIA,wBAAA;AfylBF;;AiBhlBU;EFbR,wBAAA;EAIA,yBAAA;Af8lBF;;AiBrlBU;EFbR,aAAA;EAIA,cAAA;AfmmBF;;AiB1lBU;EFbR,wBAAA;EAIA,yBAAA;AfwmBF;;AiB/lBU;EFbR,wBAAA;EAIA,yBAAA;Af6mBF;;AiBpmBU;EFbR,aAAA;EAIA,cAAA;AfknBF;;AiBzmBU;EFbR,wBAAA;EAIA,yBAAA;AfunBF;;AiB9mBU;EFbR,wBAAA;EAIA,yBAAA;Af4nBF;;AiBnnBU;EFbR,aAAA;EAIA,cAAA;AfioBF;;AiBxnBU;EFbR,wBAAA;EAIA,yBAAA;AfsoBF;;AiB7nBU;EFbR,wBAAA;EAIA,yBAAA;Af2oBF;;AiBloBU;EFbR,cAAA;EAIA,eAAA;AfgpBF;;AiBjoBM;EAAwB,SAAA;AjBqoB9B;;AiBnoBM;EAAuB,SAAA;AjBuoB7B;;AiBpoBQ;EAAwB,QADb;AjByoBnB;;AiBxoBQ;EAAwB,QADb;AjB6oBnB;;AiB5oBQ;EAAwB,QADb;AjBipBnB;;AiBhpBQ;EAAwB,QADb;AjBqpBnB;;AiBppBQ;EAAwB,QADb;AjBypBnB;;AiBxpBQ;EAAwB,QADb;AjB6pBnB;;AiB5pBQ;EAAwB,QADb;AjBiqBnB;;AiBhqBQ;EAAwB,QADb;AjBqqBnB;;AiBpqBQ;EAAwB,QADb;AjByqBnB;;AiBxqBQ;EAAwB,QADb;AjB6qBnB;;AiB5qBQ;EAAwB,SADb;AjBirBnB;;AiBhrBQ;EAAwB,SADb;AjBqrBnB;;AiBprBQ;EAAwB,SADb;AjByrBnB;;AiBjrBY;EFhBV,0BAAA;AfqsBF;;AiBrrBY;EFhBV,2BAAA;AfysBF;;AiBzrBY;EFhBV,gBAAA;Af6sBF;;AiB7rBY;EFhBV,2BAAA;AfitBF;;AiBjsBY;EFhBV,2BAAA;AfqtBF;;AiBrsBY;EFhBV,gBAAA;AfytBF;;AiBzsBY;EFhBV,2BAAA;Af6tBF;;AiB7sBY;EFhBV,2BAAA;AfiuBF;;AiBjtBY;EFhBV,gBAAA;AfquBF;;AiBrtBY;EFhBV,2BAAA;AfyuBF;;AiBztBY;EFhBV,2BAAA;Af6uBF;;AgBxuBI;EC3BE;IACE,aAAA;IACA,YAAA;IACA,eAAA;EjBuwBN;Ee3uBA;IACE,cAAA;IACA,eAAA;Ef6uBF;Ee/uBA;IACE,aAAA;IACA,cAAA;EfivBF;EenvBA;IACE,wBAAA;IACA,yBAAA;EfqvBF;EevvBA;IACE,aAAA;IACA,cAAA;EfyvBF;Ee3vBA;IACE,aAAA;IACA,cAAA;Ef6vBF;Ee/vBA;IACE,wBAAA;IACA,yBAAA;EfiwBF;EiBpxBI;IFCJ,cAAA;IACA,WAAA;IACA,eAAA;EfsxBA;EiBnxBQ;IFbR,uBAAA;IAIA,wBAAA;EfgyBA;EiBvxBQ;IFbR,wBAAA;IAIA,yBAAA;EfoyBA;EiB3xBQ;IFbR,aAAA;IAIA,cAAA;EfwyBA;EiB/xBQ;IFbR,wBAAA;IAIA,yBAAA;Ef4yBA;EiBnyBQ;IFbR,wBAAA;IAIA,yBAAA;EfgzBA;EiBvyBQ;IFbR,aAAA;IAIA,cAAA;EfozBA;EiB3yBQ;IFbR,wBAAA;IAIA,yBAAA;EfwzBA;EiB/yBQ;IFbR,wBAAA;IAIA,yBAAA;Ef4zBA;EiBnzBQ;IFbR,aAAA;IAIA,cAAA;Efg0BA;EiBvzBQ;IFbR,wBAAA;IAIA,yBAAA;Efo0BA;EiB3zBQ;IFbR,wBAAA;IAIA,yBAAA;Efw0BA;EiB/zBQ;IFbR,cAAA;IAIA,eAAA;Ef40BA;EiB7zBI;IAAwB,SAAA;EjBg0B5B;EiB9zBI;IAAuB,SAAA;EjBi0B3B;EiB9zBM;IAAwB,QADb;EjBk0BjB;EiBj0BM;IAAwB,QADb;EjBq0BjB;EiBp0BM;IAAwB,QADb;EjBw0BjB;EiBv0BM;IAAwB,QADb;EjB20BjB;EiB10BM;IAAwB,QADb;EjB80BjB;EiB70BM;IAAwB,QADb;EjBi1BjB;EiBh1BM;IAAwB,QADb;EjBo1BjB;EiBn1BM;IAAwB,QADb;EjBu1BjB;EiBt1BM;IAAwB,QADb;EjB01BjB;EiBz1BM;IAAwB,QADb;EjB61BjB;EiB51BM;IAAwB,SADb;EjBg2BjB;EiB/1BM;IAAwB,SADb;EjBm2BjB;EiBl2BM;IAAwB,SADb;EjBs2BjB;EiB91BU;IFhBV,cAAA;Efi3BA;EiBj2BU;IFhBV,0BAAA;Efo3BA;EiBp2BU;IFhBV,2BAAA;Efu3BA;EiBv2BU;IFhBV,gBAAA;Ef03BA;EiB12BU;IFhBV,2BAAA;Ef63BA;EiB72BU;IFhBV,2BAAA;Efg4BA;EiBh3BU;IFhBV,gBAAA;Efm4BA;EiBn3BU;IFhBV,2BAAA;Efs4BA;EiBt3BU;IFhBV,2BAAA;Efy4BA;EiBz3BU;IFhBV,gBAAA;Ef44BA;EiB53BU;IFhBV,2BAAA;Ef+4BA;EiB/3BU;IFhBV,2BAAA;Efk5BA;AACF;AgB94BI;EC3BE;IACE,aAAA;IACA,YAAA;IACA,eAAA;EjB46BN;Eeh5BA;IACE,cAAA;IACA,eAAA;Efk5BF;Eep5BA;IACE,aAAA;IACA,cAAA;Efs5BF;Eex5BA;IACE,wBAAA;IACA,yBAAA;Ef05BF;Ee55BA;IACE,aAAA;IACA,cAAA;Ef85BF;Eeh6BA;IACE,aAAA;IACA,cAAA;Efk6BF;Eep6BA;IACE,wBAAA;IACA,yBAAA;Efs6BF;EiBz7BI;IFCJ,cAAA;IACA,WAAA;IACA,eAAA;Ef27BA;EiBx7BQ;IFbR,uBAAA;IAIA,wBAAA;Efq8BA;EiB57BQ;IFbR,wBAAA;IAIA,yBAAA;Efy8BA;EiBh8BQ;IFbR,aAAA;IAIA,cAAA;Ef68BA;EiBp8BQ;IFbR,wBAAA;IAIA,yBAAA;Efi9BA;EiBx8BQ;IFbR,wBAAA;IAIA,yBAAA;Efq9BA;EiB58BQ;IFbR,aAAA;IAIA,cAAA;Efy9BA;EiBh9BQ;IFbR,wBAAA;IAIA,yBAAA;Ef69BA;EiBp9BQ;IFbR,wBAAA;IAIA,yBAAA;Efi+BA;EiBx9BQ;IFbR,aAAA;IAIA,cAAA;Efq+BA;EiB59BQ;IFbR,wBAAA;IAIA,yBAAA;Efy+BA;EiBh+BQ;IFbR,wBAAA;IAIA,yBAAA;Ef6+BA;EiBp+BQ;IFbR,cAAA;IAIA,eAAA;Efi/BA;EiBl+BI;IAAwB,SAAA;EjBq+B5B;EiBn+BI;IAAuB,SAAA;EjBs+B3B;EiBn+BM;IAAwB,QADb;EjBu+BjB;EiBt+BM;IAAwB,QADb;EjB0+BjB;EiBz+BM;IAAwB,QADb;EjB6+BjB;EiB5+BM;IAAwB,QADb;EjBg/BjB;EiB/+BM;IAAwB,QADb;EjBm/BjB;EiBl/BM;IAAwB,QADb;EjBs/BjB;EiBr/BM;IAAwB,QADb;EjBy/BjB;EiBx/BM;IAAwB,QADb;EjB4/BjB;EiB3/BM;IAAwB,QADb;EjB+/BjB;EiB9/BM;IAAwB,QADb;EjBkgCjB;EiBjgCM;IAAwB,SADb;EjBqgCjB;EiBpgCM;IAAwB,SADb;EjBwgCjB;EiBvgCM;IAAwB,SADb;EjB2gCjB;EiBngCU;IFhBV,cAAA;EfshCA;EiBtgCU;IFhBV,0BAAA;EfyhCA;EiBzgCU;IFhBV,2BAAA;Ef4hCA;EiB5gCU;IFhBV,gBAAA;Ef+hCA;EiB/gCU;IFhBV,2BAAA;EfkiCA;EiBlhCU;IFhBV,2BAAA;EfqiCA;EiBrhCU;IFhBV,gBAAA;EfwiCA;EiBxhCU;IFhBV,2BAAA;Ef2iCA;EiB3hCU;IFhBV,2BAAA;Ef8iCA;EiB9hCU;IFhBV,gBAAA;EfijCA;EiBjiCU;IFhBV,2BAAA;EfojCA;EiBpiCU;IFhBV,2BAAA;EfujCA;AACF;AgBnjCI;EC3BE;IACE,aAAA;IACA,YAAA;IACA,eAAA;EjBilCN;EerjCA;IACE,cAAA;IACA,eAAA;EfujCF;EezjCA;IACE,aAAA;IACA,cAAA;Ef2jCF;Ee7jCA;IACE,wBAAA;IACA,yBAAA;Ef+jCF;EejkCA;IACE,aAAA;IACA,cAAA;EfmkCF;EerkCA;IACE,aAAA;IACA,cAAA;EfukCF;EezkCA;IACE,wBAAA;IACA,yBAAA;Ef2kCF;EiB9lCI;IFCJ,cAAA;IACA,WAAA;IACA,eAAA;EfgmCA;EiB7lCQ;IFbR,uBAAA;IAIA,wBAAA;Ef0mCA;EiBjmCQ;IFbR,wBAAA;IAIA,yBAAA;Ef8mCA;EiBrmCQ;IFbR,aAAA;IAIA,cAAA;EfknCA;EiBzmCQ;IFbR,wBAAA;IAIA,yBAAA;EfsnCA;EiB7mCQ;IFbR,wBAAA;IAIA,yBAAA;Ef0nCA;EiBjnCQ;IFbR,aAAA;IAIA,cAAA;Ef8nCA;EiBrnCQ;IFbR,wBAAA;IAIA,yBAAA;EfkoCA;EiBznCQ;IFbR,wBAAA;IAIA,yBAAA;EfsoCA;EiB7nCQ;IFbR,aAAA;IAIA,cAAA;Ef0oCA;EiBjoCQ;IFbR,wBAAA;IAIA,yBAAA;Ef8oCA;EiBroCQ;IFbR,wBAAA;IAIA,yBAAA;EfkpCA;EiBzoCQ;IFbR,cAAA;IAIA,eAAA;EfspCA;EiBvoCI;IAAwB,SAAA;EjB0oC5B;EiBxoCI;IAAuB,SAAA;EjB2oC3B;EiBxoCM;IAAwB,QADb;EjB4oCjB;EiB3oCM;IAAwB,QADb;EjB+oCjB;EiB9oCM;IAAwB,QADb;EjBkpCjB;EiBjpCM;IAAwB,QADb;EjBqpCjB;EiBppCM;IAAwB,QADb;EjBwpCjB;EiBvpCM;IAAwB,QADb;EjB2pCjB;EiB1pCM;IAAwB,QADb;EjB8pCjB;EiB7pCM;IAAwB,QADb;EjBiqCjB;EiBhqCM;IAAwB,QADb;EjBoqCjB;EiBnqCM;IAAwB,QADb;EjBuqCjB;EiBtqCM;IAAwB,SADb;EjB0qCjB;EiBzqCM;IAAwB,SADb;EjB6qCjB;EiB5qCM;IAAwB,SADb;EjBgrCjB;EiBxqCU;IFhBV,cAAA;Ef2rCA;EiB3qCU;IFhBV,0BAAA;Ef8rCA;EiB9qCU;IFhBV,2BAAA;EfisCA;EiBjrCU;IFhBV,gBAAA;EfosCA;EiBprCU;IFhBV,2BAAA;EfusCA;EiBvrCU;IFhBV,2BAAA;Ef0sCA;EiB1rCU;IFhBV,gBAAA;Ef6sCA;EiB7rCU;IFhBV,2BAAA;EfgtCA;EiBhsCU;IFhBV,2BAAA;EfmtCA;EiBnsCU;IFhBV,gBAAA;EfstCA;EiBtsCU;IFhBV,2BAAA;EfytCA;EiBzsCU;IFhBV,2BAAA;Ef4tCA;AACF;AgBxtCI;EC3BE;IACE,aAAA;IACA,YAAA;IACA,eAAA;EjBsvCN;Ee1tCA;IACE,cAAA;IACA,eAAA;Ef4tCF;Ee9tCA;IACE,aAAA;IACA,cAAA;EfguCF;EeluCA;IACE,wBAAA;IACA,yBAAA;EfouCF;EetuCA;IACE,aAAA;IACA,cAAA;EfwuCF;Ee1uCA;IACE,aAAA;IACA,cAAA;Ef4uCF;Ee9uCA;IACE,wBAAA;IACA,yBAAA;EfgvCF;EiBnwCI;IFCJ,cAAA;IACA,WAAA;IACA,eAAA;EfqwCA;EiBlwCQ;IFbR,uBAAA;IAIA,wBAAA;Ef+wCA;EiBtwCQ;IFbR,wBAAA;IAIA,yBAAA;EfmxCA;EiB1wCQ;IFbR,aAAA;IAIA,cAAA;EfuxCA;EiB9wCQ;IFbR,wBAAA;IAIA,yBAAA;Ef2xCA;EiBlxCQ;IFbR,wBAAA;IAIA,yBAAA;Ef+xCA;EiBtxCQ;IFbR,aAAA;IAIA,cAAA;EfmyCA;EiB1xCQ;IFbR,wBAAA;IAIA,yBAAA;EfuyCA;EiB9xCQ;IFbR,wBAAA;IAIA,yBAAA;Ef2yCA;EiBlyCQ;IFbR,aAAA;IAIA,cAAA;Ef+yCA;EiBtyCQ;IFbR,wBAAA;IAIA,yBAAA;EfmzCA;EiB1yCQ;IFbR,wBAAA;IAIA,yBAAA;EfuzCA;EiB9yCQ;IFbR,cAAA;IAIA,eAAA;Ef2zCA;EiB5yCI;IAAwB,SAAA;EjB+yC5B;EiB7yCI;IAAuB,SAAA;EjBgzC3B;EiB7yCM;IAAwB,QADb;EjBizCjB;EiBhzCM;IAAwB,QADb;EjBozCjB;EiBnzCM;IAAwB,QADb;EjBuzCjB;EiBtzCM;IAAwB,QADb;EjB0zCjB;EiBzzCM;IAAwB,QADb;EjB6zCjB;EiB5zCM;IAAwB,QADb;EjBg0CjB;EiB/zCM;IAAwB,QADb;EjBm0CjB;EiBl0CM;IAAwB,QADb;EjBs0CjB;EiBr0CM;IAAwB,QADb;EjBy0CjB;EiBx0CM;IAAwB,QADb;EjB40CjB;EiB30CM;IAAwB,SADb;EjB+0CjB;EiB90CM;IAAwB,SADb;EjBk1CjB;EiBj1CM;IAAwB,SADb;EjBq1CjB;EiB70CU;IFhBV,cAAA;Efg2CA;EiBh1CU;IFhBV,0BAAA;Efm2CA;EiBn1CU;IFhBV,2BAAA;Efs2CA;EiBt1CU;IFhBV,gBAAA;Efy2CA;EiBz1CU;IFhBV,2BAAA;Ef42CA;EiB51CU;IFhBV,2BAAA;Ef+2CA;EiB/1CU;IFhBV,gBAAA;Efk3CA;EiBl2CU;IFhBV,2BAAA;Efq3CA;EiBr2CU;IFhBV,2BAAA;Efw3CA;EiBx2CU;IFhBV,gBAAA;Ef23CA;EiB32CU;IFhBV,2BAAA;Ef83CA;EiB92CU;IFhBV,2BAAA;Efi4CA;AACF;AkBr7CA;EACE,WAAA;EACA,mBf0QO;EezQP,cfgBS;EefT,6BfobS;AHmgCX;AkBr7CE;;EAEE,af6aiB;Ee5ajB,mBAAA;EACA,6BAAA;AlBu7CJ;AkBp7CE;EACE,sBAAA;EACA,gCAAA;AlBs7CJ;AkBn7CE;EACE,6BAAA;AlBq7CJ;;AkB36CE;;EAEE,efuZoB;AHuhCxB;;AkBr6CA;EACE,yBAAA;AlBw6CF;AkBt6CE;;EAEE,yBAAA;AlBw6CJ;AkBp6CI;;EAEE,wBAAA;AlBs6CN;;AkBh6CE;;;;EAIE,SAAA;AlBm6CJ;;AkB15CE;EACE,qCfkXc;AH2iClB;;AM59CE;EY2EI,cfhEK;EeiEL,yBfvEK;AH49CX;;AmBv+CI;;;EAGE,6CD2F+B;AlB+4CrC;AmBt+CM;;;;EAIE,yCDmFyE;AlBq5CjF;;AM7+CE;EaiBM,qEAJe;AnBo+CvB;AmB99CQ;;EAEE,qEARa;AnBw+CvB;;AmB3/CI;;;EAGE,4CD2F+B;AlBm6CrC;AmB1/CM;;;;EAIE,wCDmFyE;AlBy6CjF;;AMjgDE;EaiBM,qEAJe;AnBw/CvB;AmBl/CQ;;EAEE,qEARa;AnB4/CvB;;AmB/gDI;;;EAGE,6CD2F+B;AlBu7CrC;AmB9gDM;;;;EAIE,yCDmFyE;AlB67CjF;;AMrhDE;EaiBM,qEAJe;AnB4gDvB;AmBtgDQ;;EAEE,qEARa;AnBghDvB;;AmBniDI;;;EAGE,0CD2F+B;AlB28CrC;AmBliDM;;;;EAIE,sCDmFyE;AlBi9CjF;;AMziDE;EaiBM,qEAJe;AnBgiDvB;AmB1hDQ;;EAEE,qEARa;AnBoiDvB;;AmBvjDI;;;EAGE,6CD2F+B;AlB+9CrC;AmBtjDM;;;;EAIE,yCDmFyE;AlBq+CjF;;AM7jDE;EaiBM,6DAJe;AnBojDvB;AmB9iDQ;;EAEE,6DARa;AnBwjDvB;;AmB3kDI;;;EAGE,4CD2F+B;AlBm/CrC;AmB1kDM;;;;EAIE,wCDmFyE;AlBy/CjF;;AMjlDE;EaiBM,qEAJe;AnBwkDvB;AmBlkDQ;;EAEE,qEARa;AnB4kDvB;;AmB/lDI;;;EAGE,6CD2F+B;AlBugDrC;AmB9lDM;;;;EAIE,yCDmFyE;AlB6gDjF;;AMrmDE;EaiBM,6DAJe;AnB4lDvB;AmBtlDQ;;EAEE,6DARa;AnBgmDvB;;AmBnnDI;;;EAGE,6CD2F+B;AlB2hDrC;AmBlnDM;;;;EAIE,yCDmFyE;AlBiiDjF;;AMznDE;EaiBM,6DAJe;AnBgnDvB;AmB1mDQ;;EAEE,6DARa;AnBonDvB;;AmBvoDI;;;EAGE,yCD2F+B;AlB+iDrC;AmBtoDM;;;;EAIE,qCDmFyE;AlBqjDjF;;AM7oDE;EaiBM,gDAJe;AnBooDvB;AmB9nDQ;;EAEE,gDARa;AnBwoDvB;;AmB3pDI;;;EAGE,uBD2F+B;AlBmkDrC;AmB1pDM;;;;EAIE,mBDmFyE;AlBykDjF;;AMjqDE;EaiBM,6CAJe;AnBwpDvB;AmBlpDQ;;EAEE,6CARa;AnB4pDvB;;AmB/qDI;;;EAGE,uBD2F+B;AlBulDrC;AmB9qDM;;;;EAIE,mBDmFyE;AlB6lDjF;;AMrrDE;EaiBM,6CAJe;AnB4qDvB;AmBtqDQ;;EAEE,6CARa;AnBgrDvB;;AmBnsDI;;;EAGE,0CD2F+B;AlB2mDrC;AmBlsDM;;;;EAIE,sCDmFyE;AlBinDjF;;AMzsDE;EaiBM,6CAJe;AnBgsDvB;AmB1rDQ;;EAEE,6CARa;AnBosDvB;;AmBvtDI;;;EAGE,yBhBQK;AHktDX;;AMvtDE;EaiBM,+CAJe;AnB8sDvB;AmBxsDQ;;EAEE,+CARa;AnBktDvB;;AkB1nDI;EACE,cfmHI;EelHJ,yBf4VU;Ee3VV,6Cf8VoB;AH+xC1B;AkBxnDI;EACE,cfpGK;EeqGL,yBf1GK;Ee2GL,qBf1GK;AHouDX;;AkBrnDA;EACE,cfmGQ;EelGR,yBf4Uc;AH4yChB;AkBtnDE;;;EAGE,6Cf0UsB;AH8yC1B;AkBrnDE;EACE,SAAA;AlBunDJ;AkBnnDI;EACE,2Cf+TiB;AHszCvB;AM1vDE;EY4IM,cf6EE;Ee5EF,4CfwTc;AHyzCtB;;AgBjsDI;EEiGA;IAEI,cAAA;IACA,WAAA;IACA,gBAAA;IACA,iCAAA;ElBmmDN;EkBhmDM;IACE,SAAA;ElBkmDR;AACF;AgB7sDI;EEiGA;IAEI,cAAA;IACA,WAAA;IACA,gBAAA;IACA,iCAAA;ElB8mDN;EkB3mDM;IACE,SAAA;ElB6mDR;AACF;AgBxtDI;EEiGA;IAEI,cAAA;IACA,WAAA;IACA,gBAAA;IACA,iCAAA;ElBynDN;EkBtnDM;IACE,SAAA;ElBwnDR;AACF;AgBnuDI;EEiGA;IAEI,cAAA;IACA,WAAA;IACA,gBAAA;IACA,iCAAA;ElBooDN;EkBjoDM;IACE,SAAA;ElBmoDR;AACF;AkB7oDI;EAEI,cAAA;EACA,WAAA;EACA,gBAAA;EACA,iCAAA;AlB8oDR;AkB3oDQ;EACE,SAAA;AlB6oDV;;AoB1zDA;EACE,cAAA;EACA,WAAA;EACA,mCf0esC;EezetC,yBAAA;EhBqHI,mBAtCa;EgB5EjB,gBjByVmB;EiBxVnB,gBjB8VkB;EiB7VlB,cjBOS;EiBNT,sBAAA;EACA,4BAAA;EACA,yBAAA;ETAE,uBAAA;ECFE,gBQOJ;ECPI,2DDQJ;ApByzDF;AqB7zDM;EDdN;ICeQ,gBAAA;ErBg0DN;AACF;AoB3zDE;EACE,6BAAA;EACA,SAAA;ApB6zDJ;AoBzzDE;EACE,kBAAA;EACA,0BAAA;ApB2zDJ;AsB71DE;EACE,cnBoBO;EmBnBP,sBnBaI;EmBZJ,sCnBmjBuB;EmBljBvB,UAAA;EAGE,sBAAA;AtB61DN;AoB3zDE;EACE,cjBtBO;EiBwBP,UAAA;ApB4zDJ;AoBpzDE;EAEE,yBjBrCO;EiBuCP,UAAA;ApBozDJ;;AoB5yDE;;;;EACE,gBAAA;ApBkzDJ;;AoB7yDE;EAME,cjBvDO;EiBwDP,sBjB9DI;AHy2DR;;AoBtyDA;;EAEE,cAAA;EACA,WAAA;ApByyDF;;AoB/xDA;EACE,iCAAA;EACA,oCAAA;EACA,gBAAA;EhB3BE,kBAAA;EgB6BF,gBjBuQkB;AH2hDpB;;AoB/xDA;EACE,iCAAA;EACA,oCAAA;EhBqBI,mBAtCa;EgBmBjB,gBjB+MgB;AHmlDlB;;AoB/xDA;EACE,gCAAA;EACA,mCAAA;EhBcI,kBAtCa;EgB0BjB,gBjByMgB;AHylDlB;;AoBzxDA;EACE,cAAA;EACA,WAAA;EACA,mBAAA;EACA,gBAAA;EhBDI,mBAtCa;EgByCjB,gBjB0OkB;EiBzOlB,cjB5GS;EiB6GT,6BAAA;EACA,yBAAA;EACA,mBAAA;ApB4xDF;AoB1xDE;EAEE,gBAAA;EACA,eAAA;ApB2xDJ;;AoB/wDA;EACE,kCf4VsC;Ee3VtC,uBAAA;EhB1BI,kBAtCa;EgBkEjB,gBjBiKgB;EQ1Sd,sBAAA;AX45DJ;;AoB/wDA;EACE,mCfqVsC;EepVtC,sBAAA;EhBlCI,mBAtCa;EgB0EjB,gBjBwJgB;EQzSd,wBAAA;AXo6DJ;;AoB7wDE;EAEE,YAAA;ApB+wDJ;;AoB3wDA;EACE,YAAA;ApB8wDF;;AoBtwDA;EACE,qBjBsZyB;AHm3C3B;;AoBtwDA;EACE,cAAA;EACA,mBf2TsC;AL88CxC;;AoBjwDA;EACE,aAAA;EACA,eAAA;EACA,kBAAA;EACA,iBAAA;ApBowDF;AoBlwDE;;EAEE,kBAAA;EACA,iBAAA;ApBowDJ;;AoB3vDA;EACE,kBAAA;EACA,cAAA;EACA,qBfgSsC;AL89CxC;;AoB3vDA;EACE,kBAAA;EACA,kBf4RsC;Ee3RtC,qBAAA;ApB8vDF;AoB3vDE;EAEE,cjBhNO;AH48DX;;AoBxvDA;EACE,gBAAA;ApB2vDF;;AoBxvDA;EACE,oBAAA;EACA,mBAAA;EACA,eAAA;EACA,qBf6QsC;AL8+CxC;AoBxvDE;EACE,gBAAA;EACA,aAAA;EACA,uBfwQoC;EevQpC,cAAA;ApB0vDJ;;AsBn+DE;EACE,aAAA;EACA,WAAA;EACA,mBjBseoC;EiBrepC,cnBwYc;EmBvYd,cFiPqC;ApBqvDzC;;AsBn+DE;EACE,kBAAA;EACA,SAAA;EACA,UAAA;EACA,aAAA;EACA,eAAA;EACA,eAAA;EACA,kBAAA;EACA,mBAAA;EACA,cAAA;EACA,WAAA;EACA,yCAAA;EACA,qBAAA;AtBs+DJ;;AsBj+DI;;;EAEE,qBF2NmC;ApB0wDzC;AsBn+DM;;;EACE,qBFwNiC;ApB+wDzC;AsBn+DM;;;;;;;EAEE,cAAA;AtB0+DR;;AsBl+DM;EACE,cFyMiC;ApB4xDzC;AsBl+DM;;;EAEE,cAAA;AtBq+DR;;AsB79DM;EACE,cF2LiC;ApBqyDzC;AsB99DQ;EACE,mEAAA;EACA,+DAAA;AtBg+DV;AsB59DM;;;EAEE,cAAA;AtB+9DR;AsB39DQ;ECnFJ,oEDoF2B;EACrB,+DAAA;AtB69DV;AsBx9DQ;EACE,+DACE;AtBy9DZ;;AsB98DM;EACE,qBFwJiC;ApByzDzC;AsB/8DQ;EACE,qBAAA;AtBi9DV;AsB78DM;;;EAEE,cAAA;AtBg9DR;AsB58DQ;EACE,4CAAA;AtB88DV;;AsB1jEE;EACE,aAAA;EACA,WAAA;EACA,mBjBseoC;EiBrepC,cnBwYc;EmBvYd,cFiPqC;ApB40DzC;;AsB1jEE;EACE,kBAAA;EACA,SAAA;EACA,UAAA;EACA,aAAA;EACA,eAAA;EACA,eAAA;EACA,kBAAA;EACA,mBAAA;EACA,cAAA;EACA,WAAA;EACA,wCAAA;EACA,qBAAA;AtB6jEJ;;AsBxjEI;;;EAEE,qBF2NmC;ApBi2DzC;AsB1jEM;;;EACE,qBFwNiC;ApBs2DzC;AsB1jEM;;;;;;;EAEE,cAAA;AtBikER;;AsBzjEM;EACE,cFyMiC;ApBm3DzC;AsBzjEM;;;EAEE,cAAA;AtB4jER;;AsBpjEM;EACE,cF2LiC;ApB43DzC;AsBrjEQ;EACE,0DAAA;EACA,sDAAA;AtBujEV;AsBnjEM;;;EAEE,cAAA;AtBsjER;AsBljEQ;ECnFJ,4DDoF2B;EACrB,sDAAA;AtBojEV;AsB/iEQ;EACE,8DACE;AtBgjEZ;;AsBriEM;EACE,qBFwJiC;ApBg5DzC;AsBtiEQ;EACE,qBAAA;AtBwiEV;AsBpiEM;;;EAEE,cAAA;AtBuiER;AsBniEQ;EACE,2CAAA;AtBqiEV;;AoB/4DA;EACE,aAAA;EACA,mBAAA;EACA,mBAAA;ApBk5DF;AoB74DE;EACE,WAAA;ApB+4DJ;AgB9mEI;EIoOA;IACE,aAAA;IACA,mBAAA;IACA,uBAAA;IACA,gBAAA;EpB64DJ;EoBz4DE;IACE,aAAA;IACA,cAAA;IACA,mBAAA;IACA,mBAAA;IACA,gBAAA;EpB24DJ;EoBv4DE;IACE,qBAAA;IACA,WAAA;IACA,sBAAA;EpBy4DJ;EoBr4DE;IACE,qBAAA;EpBu4DJ;EoBp4DE;;IAEE,WAAA;EpBs4DJ;EoBj4DE;IACE,aAAA;IACA,mBAAA;IACA,uBAAA;IACA,WAAA;IACA,eAAA;EpBm4DJ;EoBj4DE;IACE,kBAAA;IACA,cAAA;IACA,aAAA;IACA,qBf+KkC;Ie9KlC,cAAA;EpBm4DJ;EoBh4DE;IACE,mBAAA;IACA,uBAAA;EpBk4DJ;EoBh4DE;IACE,gBAAA;EpBk4DJ;AACF;;AwBptEA;EACE,qBAAA;EAEA,gBrBufgB;EqBtfhB,crBaS;EqBZT,kBAAA;EAGA,sBAAA;EACA,yBAAA;UAAA,iBAAA;EACA,6BAAA;EACA,6BAAA;ECmGA,yBAAA;EACA,mBtBwXoB;EsBvXpB,gBtBsPkB;EsBpPhB,uBtByMY;EkBjTV,qIGGJ;AxButEF;AqBttEM;EGdN;IHeQ,gBAAA;ErBytEN;AACF;AMnuEE;EkBUE,crBCO;EqBAP,qBAAA;AxB4tEJ;AwBztEE;EAEE,UAAA;EACA,2ErB4eF;AH8uDF;AwBttEE;EAEE,anBiZ0B;EOpaxB,gBYoBF;AxButEJ;AwBptEE;EACE,eAAA;AxBstEJ;AwBptEI;EZ1BE,gBY4BA;AxBqtEN;AwBntEM;EZ9BA,2EALa;AZyvEnB;;AwB9sEA;;EAEE,oBAAA;AxBitEF;;AwBxsEE;ECzDA,WAAA;EFFE,yBlBsEW;EoBlEb,qBpBkEa;EO5DT,2EaLJ;AzBqwEF;AMpwEE;EmBEE,WAAA;EFRA,yBEHiB;EAajB,qBAZa;AzBixEjB;AyBlwEE;EAII,4GACE;AzBgwER;AyB1vEE;EAEE,WAAA;EACA,yBpB2CW;EoB1CX,qBpB0CW;ALitEf;AyBxvEE;EAGE,WAAA;EACA,mEApCkB;EAwClB,qBAvCc;AzB4xElB;AyBnvEI;EAGI,iDACE;AzBkvEV;;AwBpuEE;ECzDA,cAAA;EFFE,yBlBsEW;EoBlEb,qBpBkEa;EO5DT,2EaLJ;AzBiyEF;AMhyEE;EmBEE,cAAA;EFRA,yBEHiB;EAajB,qBAZa;AzB6yEjB;AyB9xEE;EAII,6GACE;AzB4xER;AyBtxEE;EAEE,cAAA;EACA,yBpB2CW;EoB1CX,qBpB0CW;AL6uEf;AyBpxEE;EAGE,cAAA;EACA,qEApCkB;EAwClB,qBAvCc;AzBwzElB;AyB/wEI;EAGI,kDACE;AzB8wEV;;AwBhwEE;ECzDA,WAAA;EFFE,yBlBsEW;EoBlEb,qBpBkEa;EO5DT,2EaLJ;AzB6zEF;AM5zEE;EmBEE,WAAA;EFRA,yBEHiB;EAajB,qBAZa;AzBy0EjB;AyB1zEE;EAII,4GACE;AzBwzER;AyBlzEE;EAEE,WAAA;EACA,yBpB2CW;EoB1CX,qBpB0CW;ALywEf;AyBhzEE;EAGE,WAAA;EACA,mEApCkB;EAwClB,qBAvCc;AzBo1ElB;AyB3yEI;EAGI,iDACE;AzB0yEV;;AwB5xEE;ECzDA,WAAA;EFFE,yBlBsEW;EoBlEb,qBpBkEa;EO5DT,2EaLJ;AzBy1EF;AMx1EE;EmBEE,WAAA;EFRA,yBEHiB;EAajB,qBAZa;AzBq2EjB;AyBt1EE;EAII,4GACE;AzBo1ER;AyB90EE;EAEE,WAAA;EACA,yBpB2CW;EoB1CX,qBpB0CW;ALqyEf;AyB50EE;EAGE,WAAA;EACA,mEApCkB;EAwClB,qBAvCc;AzBg3ElB;AyBv0EI;EAGI,iDACE;AzBs0EV;;AwBxzEE;ECzDA,WAAA;EFFE,yBlBsEW;EoBlEb,qBpBkEa;EO5DT,2EaLJ;AzBq3EF;AMp3EE;EmBEE,WAAA;EFRA,yBEHiB;EAajB,qBAZa;AzBi4EjB;AyBl3EE;EAII,2GACE;AzBg3ER;AyB12EE;EAEE,WAAA;EACA,yBpB2CW;EoB1CX,qBpB0CW;ALi0Ef;AyBx2EE;EAGE,WAAA;EACA,0DApCkB;EAwClB,qBAvCc;AzB44ElB;AyBn2EI;EAGI,gDACE;AzBk2EV;;AwBp1EE;ECzDA,WAAA;EFFE,yBlBsEW;EoBlEb,qBpBkEa;EO5DT,2EaLJ;AzBi5EF;AMh5EE;EmBEE,WAAA;EFRA,yBEHiB;EAajB,qBAZa;AzB65EjB;AyB94EE;EAII,2GACE;AzB44ER;AyBt4EE;EAEE,WAAA;EACA,yBpB2CW;EoB1CX,qBpB0CW;AL61Ef;AyBp4EE;EAGE,WAAA;EACA,mEApCkB;EAwClB,qBAvCc;AzBw6ElB;AyB/3EI;EAGI,gDACE;AzB83EV;;AwBh3EE;ECzDA,WAAA;EFFE,yBlBsEW;EoBlEb,qBpBkEa;EO5DT,2EaLJ;AzB66EF;AM56EE;EmBEE,WAAA;EFRA,yBEHiB;EAajB,qBAZa;AzBy7EjB;AyB16EE;EAII,6GACE;AzBw6ER;AyBl6EE;EAEE,WAAA;EACA,yBpB2CW;EoB1CX,qBpB0CW;ALy3Ef;AyBh6EE;EAGE,WAAA;EACA,4DApCkB;EAwClB,qBAvCc;AzBo8ElB;AyB35EI;EAGI,kDACE;AzB05EV;;AwB54EE;ECzDA,WAAA;EFFE,yBlBsEW;EoBlEb,qBpBkEa;EO5DT,2EaLJ;AzBy8EF;AMx8EE;EmBEE,WAAA;EFRA,yBEHiB;EAajB,qBAZa;AzBq9EjB;AyBt8EE;EAII,0GACE;AzBo8ER;AyB97EE;EAEE,WAAA;EACA,yBpB2CW;EoB1CX,qBpB0CW;ALq5Ef;AyB57EE;EAGE,WAAA;EACA,yDApCkB;EAwClB,qBAvCc;AzBg+ElB;AyBv7EI;EAGI,+CACE;AzBs7EV;;AwBx6EE;ECzDA,cAAA;EFFE,yBlBsEW;EoBlEb,qBpBkEa;EO5DT,2EaLJ;AzBq+EF;AMp+EE;EmBEE,cAAA;EFRA,yBEHiB;EAajB,qBAZa;AzBi/EjB;AyBl+EE;EAII,6GACE;AzBg+ER;AyB19EE;EAEE,cAAA;EACA,yBpB2CW;EoB1CX,qBpB0CW;ALi7Ef;AyBx9EE;EAGE,cAAA;EACA,8CApCkB;EAwClB,qBAvCc;AzB4/ElB;AyBn9EI;EAGI,kDACE;AzBk9EV;;AwBp8EE;ECzDA,cAAA;EFFE,sBlBsEW;EoBlEb,kBpBkEa;EO5DT,2EaLJ;AzBigFF;AMhgFE;EmBEE,cAAA;EFRA,uBEHiB;EAajB,mBAZa;AzB6gFjB;AyB9/EE;EAII,6GACE;AzB4/ER;AyBt/EE;EAEE,cAAA;EACA,sBpB2CW;EoB1CX,kBpB0CW;AL68Ef;AyBp/EE;EAGE,cAAA;EACA,0CApCkB;EAwClB,mBAvCc;AzBwhFlB;AyB/+EI;EAGI,kDACE;AzB8+EV;;AwBh+EE;ECzDA,cAAA;EFFE,sBlBsEW;EoBlEb,kBpBkEa;EO5DT,2EaLJ;AzB6hFF;AM5hFE;EmBEE,cAAA;EFRA,uBEHiB;EAajB,mBAZa;AzByiFjB;AyB1hFE;EAII,6GACE;AzBwhFR;AyBlhFE;EAEE,cAAA;EACA,sBpB2CW;EoB1CX,kBpB0CW;ALy+Ef;AyBhhFE;EAGE,cAAA;EACA,0CApCkB;EAwClB,mBAvCc;AzBojFlB;AyB3gFI;EAGI,kDACE;AzB0gFV;;AwB5/EE;ECzDA,WAAA;EFFE,uBlBsEW;EoBlEb,mBpBkEa;EO5DT,2EaLJ;AzByjFF;AMxjFE;EmBEE,WAAA;EFRA,uBEHiB;EAajB,mBAZa;AzBqkFjB;AyBtjFE;EAII,uGACE;AzBojFR;AyB9iFE;EAEE,WAAA;EACA,uBpB2CW;EoB1CX,mBpB0CW;ALqgFf;AyB5iFE;EAGE,WAAA;EACA,uBApCkB;EAwClB,mBAvCc;AzBglFlB;AyBviFI;EAGI,4CACE;AzBsiFV;;AwBlhFE;ECLA,cpBUa;EoBTb,6BAAA;EACA,sBAAA;EACA,qBpBOa;ALohFf;AyBzhFE;EACE,WAVY;EAWZ,yBpBGW;EoBFX,qBpBEW;ALyhFf;AyBxhFE;EAEE,2CAAA;AzByhFJ;AyBthFE;EAEE,cpBRW;EoBSX,6BAAA;AzBuhFJ;AyBphFE;EAGE,WAAA;EACA,yBpBhBW;EoBiBX,qBpBjBW;ALqiFf;AyBlhFI;EAOI,2CAAA;AzB8gFR;;AwB7iFE;ECLA,cpBUa;EoBTb,6BAAA;EACA,sBAAA;EACA,qBpBOa;AL+iFf;AyBpjFE;EACE,cAVY;EAWZ,yBpBGW;EoBFX,qBpBEW;ALojFf;AyBnjFE;EAEE,4CAAA;AzBojFJ;AyBjjFE;EAEE,cpBRW;EoBSX,6BAAA;AzBkjFJ;AyB/iFE;EAGE,cAAA;EACA,yBpBhBW;EoBiBX,qBpBjBW;ALgkFf;AyB7iFI;EAOI,4CAAA;AzByiFR;;AwBxkFE;ECLA,cpBUa;EoBTb,6BAAA;EACA,sBAAA;EACA,qBpBOa;AL0kFf;AyB/kFE;EACE,WAVY;EAWZ,yBpBGW;EoBFX,qBpBEW;AL+kFf;AyB9kFE;EAEE,2CAAA;AzB+kFJ;AyB5kFE;EAEE,cpBRW;EoBSX,6BAAA;AzB6kFJ;AyB1kFE;EAGE,WAAA;EACA,yBpBhBW;EoBiBX,qBpBjBW;AL2lFf;AyBxkFI;EAOI,2CAAA;AzBokFR;;AwBnmFE;ECLA,cpBUa;EoBTb,6BAAA;EACA,sBAAA;EACA,qBpBOa;ALqmFf;AyB1mFE;EACE,WAVY;EAWZ,yBpBGW;EoBFX,qBpBEW;AL0mFf;AyBzmFE;EAEE,2CAAA;AzB0mFJ;AyBvmFE;EAEE,cpBRW;EoBSX,6BAAA;AzBwmFJ;AyBrmFE;EAGE,WAAA;EACA,yBpBhBW;EoBiBX,qBpBjBW;ALsnFf;AyBnmFI;EAOI,2CAAA;AzB+lFR;;AwB9nFE;ECLA,cpBUa;EoBTb,6BAAA;EACA,sBAAA;EACA,qBpBOa;ALgoFf;AyBroFE;EACE,WAVY;EAWZ,yBpBGW;EoBFX,qBpBEW;ALqoFf;AyBpoFE;EAEE,0CAAA;AzBqoFJ;AyBloFE;EAEE,cpBRW;EoBSX,6BAAA;AzBmoFJ;AyBhoFE;EAGE,WAAA;EACA,yBpBhBW;EoBiBX,qBpBjBW;ALipFf;AyB9nFI;EAOI,0CAAA;AzB0nFR;;AwBzpFE;ECLA,cpBUa;EoBTb,6BAAA;EACA,sBAAA;EACA,qBpBOa;AL2pFf;AyBhqFE;EACE,WAVY;EAWZ,yBpBGW;EoBFX,qBpBEW;ALgqFf;AyB/pFE;EAEE,0CAAA;AzBgqFJ;AyB7pFE;EAEE,cpBRW;EoBSX,6BAAA;AzB8pFJ;AyB3pFE;EAGE,WAAA;EACA,yBpBhBW;EoBiBX,qBpBjBW;AL4qFf;AyBzpFI;EAOI,0CAAA;AzBqpFR;;AwBprFE;ECLA,cpBUa;EoBTb,6BAAA;EACA,sBAAA;EACA,qBpBOa;ALsrFf;AyB3rFE;EACE,WAVY;EAWZ,yBpBGW;EoBFX,qBpBEW;AL2rFf;AyB1rFE;EAEE,4CAAA;AzB2rFJ;AyBxrFE;EAEE,cpBRW;EoBSX,6BAAA;AzByrFJ;AyBtrFE;EAGE,WAAA;EACA,yBpBhBW;EoBiBX,qBpBjBW;ALusFf;AyBprFI;EAOI,4CAAA;AzBgrFR;;AwB/sFE;ECLA,cpBUa;EoBTb,6BAAA;EACA,sBAAA;EACA,qBpBOa;ALitFf;AyBttFE;EACE,WAVY;EAWZ,yBpBGW;EoBFX,qBpBEW;ALstFf;AyBrtFE;EAEE,yCAAA;AzBstFJ;AyBntFE;EAEE,cpBRW;EoBSX,6BAAA;AzBotFJ;AyBjtFE;EAGE,WAAA;EACA,yBpBhBW;EoBiBX,qBpBjBW;ALkuFf;AyB/sFI;EAOI,yCAAA;AzB2sFR;;AwB1uFE;ECLA,cpBUa;EoBTb,6BAAA;EACA,sBAAA;EACA,qBpBOa;AL4uFf;AyBjvFE;EACE,cAVY;EAWZ,yBpBGW;EoBFX,qBpBEW;ALivFf;AyBhvFE;EAEE,4CAAA;AzBivFJ;AyB9uFE;EAEE,cpBRW;EoBSX,6BAAA;AzB+uFJ;AyB5uFE;EAGE,cAAA;EACA,yBpBhBW;EoBiBX,qBpBjBW;AL6vFf;AyB1uFI;EAOI,4CAAA;AzBsuFR;;AwBrwFE;ECLA,WpBUa;EoBTb,6BAAA;EACA,sBAAA;EACA,kBpBOa;ALuwFf;AyB5wFE;EACE,cAVY;EAWZ,sBpBGW;EoBFX,kBpBEW;AL4wFf;AyB3wFE;EAEE,4CAAA;AzB4wFJ;AyBzwFE;EAEE,WpBRW;EoBSX,6BAAA;AzB0wFJ;AyBvwFE;EAGE,cAAA;EACA,sBpBhBW;EoBiBX,kBpBjBW;ALwxFf;AyBrwFI;EAOI,4CAAA;AzBiwFR;;AwBhyFE;ECLA,WpBUa;EoBTb,6BAAA;EACA,sBAAA;EACA,kBpBOa;ALkyFf;AyBvyFE;EACE,cAVY;EAWZ,sBpBGW;EoBFX,kBpBEW;ALuyFf;AyBtyFE;EAEE,4CAAA;AzBuyFJ;AyBpyFE;EAEE,WpBRW;EoBSX,6BAAA;AzBqyFJ;AyBlyFE;EAGE,cAAA;EACA,sBpBhBW;EoBiBX,kBpBjBW;ALmzFf;AyBhyFI;EAOI,4CAAA;AzB4xFR;;AwB3zFE;ECLA,YpBUa;EoBTb,6BAAA;EACA,sBAAA;EACA,mBpBOa;AL6zFf;AyBl0FE;EACE,WAVY;EAWZ,uBpBGW;EoBFX,mBpBEW;ALk0Ff;AyBj0FE;EAEE,sCAAA;AzBk0FJ;AyB/zFE;EAEE,YpBRW;EoBSX,6BAAA;AzBg0FJ;AyB7zFE;EAGE,WAAA;EACA,uBpBhBW;EoBiBX,mBpBjBW;AL80Ff;AyB3zFI;EAOI,sCAAA;AzBuzFR;;AwB30FA;EACE,gBrBmRmB;EqBlRnB,crBLQ;EqBMR,qBrBoKgB;AH0qFlB;AMv5FE;EkB4EE,wDrBkKe;EqBjKf,qBrBkKoB;AH4qFxB;AwB30FE;EAEE,qBrB6JoB;AH+qFxB;AwBz0FE;EAEE,crB7EO;EqB8EP,oBAAA;AxB00FJ;;AwB/zFA;ECKE,sBAAA;EACA,mBtByXuB;EsBxXvB,gBtBqMgB;EsBnMd,wBtB2Me;AHknFnB;;AwBl0FA;ECCE,uBAAA;EACA,kBtBuXuB;EsBtXvB,gBtBsMgB;EsBpMd,uBtByMY;AH2nFhB;;AwBh0FA;EACE,cAAA;EACA,WAAA;AxBm0FF;AwBh0FE;EACE,kBnBuT0B;AL2gF9B;;AwB1zFE;;;EACE,WAAA;AxB+zFJ;;A0B18FA;ELgBM,gCKfJ;A1B68FF;AqB17FM;EKpBN;ILqBQ,gBAAA;ErB67FN;AACF;A0Bh9FE;EACE,UAAA;A1Bk9FJ;;A0B78FE;EACE,aAAA;A1Bg9FJ;;A0B58FA;EACE,kBAAA;EACA,SAAA;EACA,gBAAA;ELDI,6BKEJ;A1B+8FF;AqB78FM;EKNN;ILOQ,gBAAA;ErBg9FN;AACF;;A2Br+FA;;;;EAIE,kBAAA;A3Bw+FF;;A2Br+FA;EACE,mBAAA;A3Bw+FF;A4Bp9FI;EACE,qBAAA;EACA,oBvB+NwB;EuB9NxB,uBvB6NwB;EuB5NxB,WAAA;EAhCJ,uBAAA;EACA,qCAAA;EACA,gBAAA;EACA,oCAAA;A5Bu/FF;A4Bl8FI;EACE,cAAA;A5Bo8FN;;A2B9+FA;EACE,kBAAA;EACA,SAAA;EACA,OAAA;EACA,atBwpBkC;EsBvpBlC,aAAA;EACA,WAAA;EACA,gBtBguBkC;EsB/tBlC,iBAAA;EACA,oBAAA;EvBsGI,eAtCa;EuB9DjB,cxBJS;EwBKT,gBAAA;EACA,gBAAA;EACA,sBxBdM;EwBeN,4BAAA;EACA,mCAAA;EhBdE,wBAAA;ECFE,iHekBJ;A3Bi/FF;;A2B1+FI;EACE,WAAA;EACA,OAAA;A3B6+FN;;A2B1+FI;EACE,QAAA;EACA,UAAA;A3B6+FN;;AgBj+FI;EWnBA;IACE,WAAA;IACA,OAAA;E3Bw/FJ;E2Br/FE;IACE,QAAA;IACA,UAAA;E3Bu/FJ;AACF;AgB5+FI;EWnBA;IACE,WAAA;IACA,OAAA;E3BkgGJ;E2B//FE;IACE,QAAA;IACA,UAAA;E3BigGJ;AACF;AgBt/FI;EWnBA;IACE,WAAA;IACA,OAAA;E3B4gGJ;E2BzgGE;IACE,QAAA;IACA,UAAA;E3B2gGJ;AACF;AgBhgGI;EWnBA;IACE,WAAA;IACA,OAAA;E3BshGJ;E2BnhGE;IACE,QAAA;IACA,UAAA;E3BqhGJ;AACF;A2B9gGE;EACE,SAAA;EACA,YAAA;EACA,aAAA;EACA,uBtB8rBgC;ALk1EpC;A4B/iGI;EACE,qBAAA;EACA,oBvB+NwB;EuB9NxB,uBvB6NwB;EuB5NxB,WAAA;EAzBJ,aAAA;EACA,qCAAA;EACA,0BAAA;EACA,oCAAA;A5B2kGF;A4B7hGI;EACE,cAAA;A5B+hGN;;A2BphGE;EACE,MAAA;EACA,WAAA;EACA,UAAA;EACA,aAAA;EACA,qBtBgrBgC;ALu2EpC;A4BpkGI;EACE,qBAAA;EACA,oBvB+NwB;EuB9NxB,uBvB6NwB;EuB5NxB,WAAA;EAlBJ,mCAAA;EACA,eAAA;EACA,sCAAA;EACA,wBAAA;A5BylGF;A4BljGI;EACE,cAAA;A5BojGN;A2B/hGI;EACE,iBAAA;A3BiiGN;;A2B3hGE;EACE,MAAA;EACA,WAAA;EACA,UAAA;EACA,aAAA;EACA,sBtB+pBgC;AL+3EpC;A4B5lGI;EACE,qBAAA;EACA,oBvB+NwB;EuB9NxB,uBvB6NwB;EuB5NxB,WAAA;A5B8lGN;A4BnlGM;EACE,aAAA;A5BqlGR;A4BllGM;EACE,qBAAA;EACA,qBvB4MsB;EuB3MtB,uBvB0MsB;EuBzMtB,WAAA;EA9BN,mCAAA;EACA,yBAAA;EACA,sCAAA;A5BmnGF;A4BllGI;EACE,cAAA;A5BolGN;A2B9iGI;EACE,iBAAA;A3BgjGN;;A2BxiGE;EAIE,WAAA;EACA,YAAA;A3BwiGJ;;A2BniGA;EE9GE,SAAA;EACA,gBAAA;EACA,gBAAA;EACA,6BAAA;A7BqpGF;;A2BniGA;EACE,cAAA;EACA,WAAA;EACA,uBAAA;EACA,WAAA;EACA,gBxBuOmB;EwBtOnB,cxBvGS;EwBwGT,mBAAA;EAEA,mBAAA;EACA,6BAAA;EACA,SAAA;A3BqiGF;AM1pGE;EqBoIE,+CtBmnBgC;EsBlnBhC,qBAAA;EJ/IA,yBpBYO;AH6pGX;A2BthGE;EAEE,WxB3II;EwB4IJ,qBAAA;EJtJA,yBpBqUkB;AHy2FtB;A2BphGE;EAEE,cxB7IO;EwB8IP,oBAAA;EACA,6BAAA;A3BqhGJ;;A2B7gGA;EACE,cAAA;A3BghGF;;A2B5gGA;EACE,cAAA;EACA,sBtBgmBkC;EsB/lBlC,gBAAA;EvBrDI,mBAtCa;EuB6FjB,cxBhKS;EwBiKT,mBAAA;A3B+gGF;;A2B3gGA;EACE,cAAA;EACA,uBAAA;EACA,cxBrKS;AHmrGX;;A8BzsGA;;EAEE,kBAAA;EACA,oBAAA;EACA,sBAAA;A9B4sGF;A8B1sGE;;EACE,kBAAA;EACA,cAAA;A9B6sGJ;AM5sGE;;EwBII,UAAA;A9B4sGN;A8B1sGI;;;;EAGE,UAAA;A9B6sGN;;A8BvsGA;EACE,aAAA;EACA,eAAA;EACA,2BAAA;A9B0sGF;A8BxsGE;EACE,WAAA;A9B0sGJ;;A8BpsGE;;EAEE,iBAAA;A9BusGJ;A8BnsGE;;EnBXE,0BAAA;EACA,6BAAA;AXktGJ;A8BnsGE;;EnBFE,yBAAA;EACA,4BAAA;AXysGJ;;A8BtrGA;EACE,wBAAA;EACA,uBAAA;A9ByrGF;A8BvrGE;EAGE,cAAA;A9BurGJ;A8BprGE;EACE,eAAA;A9BsrGJ;;A8BlrGA;EACE,uBAAA;EACA,sBAAA;A9BqrGF;;A8BlrGA;EACE,sBAAA;EACA,qBAAA;A9BqrGF;;A8B/qGA;ElBhFM,gBkBiFJ;A9BkrGF;A8B/qGE;ElBpFI,gBkBqFF;A9BirGJ;;A8BxqGA;EACE,sBAAA;EACA,uBAAA;EACA,uBAAA;A9B2qGF;A8BzqGE;;EAEE,WAAA;A9B2qGJ;A8BxqGE;;EAEE,gBAAA;A9B0qGJ;A8BtqGE;;EnBrFE,6BAAA;EACA,4BAAA;AX+vGJ;A8BtqGE;;EnBxGE,yBAAA;EACA,0BAAA;AXkxGJ;;A8BvpGE;;EAEE,gBAAA;A9B0pGJ;A8BxpGI;;;;EAEE,kBAAA;EACA,sBAAA;EACA,oBAAA;A9B4pGN;;A+BrzGA;EACE,kBAAA;EACA,aAAA;EACA,eAAA;EACA,oBAAA;EACA,WAAA;A/BwzGF;A+BtzGE;;;;EAIE,kBAAA;EACA,cAAA;EACA,SAAA;EACA,YAAA;EACA,gBAAA;A/BwzGJ;A+BtzGI;;;;;;;;;;;;EAGE,iBAAA;A/Bi0GN;A+B5zGE;;;EAGE,UAAA;A/B8zGJ;A+B1zGE;EACE,UAAA;A/B4zGJ;A+BvzGI;;EpBIA,yBAAA;EACA,4BAAA;AXuzGJ;A+BvzGE;EACE,aAAA;EACA,mBAAA;A/ByzGJ;A+BvzGI;EpBLA,yBAAA;EACA,4BAAA;AX+zGJ;A+BtzGI;;;EpBxBA,0BAAA;EACA,6BAAA;AXm1GJ;A+BpzGI;;;EpBhCA,0BAAA;EACA,6BAAA;AXy1GJ;;A+B3yGA;;EAEE,aAAA;A/B8yGF;A+BzyGE;;EACE,kBAAA;EACA,UAAA;A/B4yGJ;A+B1yGI;;EACE,UAAA;A/B6yGN;A+BzyGE;;;;;;;;EAIE,iBAAA;A/B+yGJ;;A+B3yGA;EAAuB,kBAAA;A/B+yGvB;;A+B9yGA;EAAsB,iBAAA;A/BkzGtB;;A+B1yGA;EACE,aAAA;EACA,mBAAA;EACA,yBAAA;EACA,gBAAA;E3BSI,mBAtCa;E2B+BjB,gB5B8OmB;E4B7OnB,gB5BmPkB;E4BlPlB,c5BrGS;E4BsGT,kBAAA;EACA,mBAAA;EACA,sB5B7GM;E4B8GN,yBAAA;EpB5GE,uBAAA;AX05GJ;A+B1yGE;;EAEE,aAAA;A/B4yGJ;;A+BlyGA;;EAEE,mC1BqWsC;ALg8FxC;;A+BlyGA;;;;;;EAME,sBAAA;E3B1BI,mBAtCa;E2BkEjB,gB5BgKgB;EQzSd,wBAAA;AX+6GJ;;A+BlyGA;;EAEE,kC1BmVsC;ALk9FxC;;A+BlyGA;;;;;;EAME,uBAAA;E3B3CI,kBAtCa;E2BmFjB,gB5BgJgB;EQ1Sd,sBAAA;AXg8GJ;;A+BlyGA;;EAEE,sBAAA;A/BqyGF;;A+B1xGA;;;;;;;;EpB3JI,0BAAA;EACA,6BAAA;AXg8GJ;;A+B3xGA;;;;;;EpBxJI,yBAAA;EACA,4BAAA;AX47GJ;;AgCp+GA;EACE,kBAAA;EACA,UAAA;EACA,cAAA;EACA,kBAAA;EACA,kBAAA;EACA,mBAAA;AhCu+GF;;AgCp+GA;EACE,oBAAA;EACA,kB7BgkBwB;AHu6F1B;;AgCp+GA;EACE,kBAAA;EACA,OAAA;EACA,WAAA;EACA,c7B0jB8B;E6BzjB9B,gBAAA;EACA,UAAA;AhCu+GF;AgCr+GE;EACE,W7BhBI;E6BiBJ,qB7B2S4B;EoBtU5B,yBpBqUkB;ES3ThB,gBoBmBF;AhCu+GJ;AgCp+GE;EAGI,sBAAA;AhCo+GN;AgC99GE;EACE,sC7BugBuB;AHy9F3B;AgC79GE;EACE,W7BpCI;E6BqCJ,yB7BsRkB;E6BrRlB,qB7BsR4B;ES5T1B,gBoBuCF;AhC+9GJ;AgCz9GI;EACE,c7BxCK;AHmgHX;AgCz9GM;EACE,yB7B/CG;AH0gHX;;AgCj9GA;EACE,kBAAA;EACA,gBAAA;EAEA,mBAAA;AhCm9GF;AgC/8GE;EACE,kBAAA;EACA,aAAA;EACA,WAAA;EACA,cAAA;EACA,c7B6f4B;E6B5f5B,e7B4f4B;E6B3f5B,oBAAA;EACA,WAAA;EACA,sB7B5EI;E6B6EJ,yBAAA;EpB7EE,gBoB8EF;AhCi9GJ;AgC78GE;EACE,kBAAA;EACA,aAAA;EACA,WAAA;EACA,cAAA;EACA,c7B8e4B;E6B7e5B,e7B6e4B;E6B5e5B,WAAA;EACA,iCAAA;AhC+8GJ;;AgCr8GE;ErBlGE,sBAAA;AX2iHJ;AgCp8GI;EACE,yDAAA;AhCs8GN;AgCj8GI;EACE,qB7B2MgB;EoBrUlB,yBpBqUkB;AHyvGtB;AgCh8GI;EACE,yDAAA;AhCk8GN;AgC77GI;ETpIA,yCpBqmB2C;AH+9F/C;AgC77GI;ETvIA,yCpBqmB2C;AHk+F/C;;AgCr7GE;EAEE,kB3ByZ4C;AL8hGhD;AgCn7GI;EACE,yDAAA;AhCq7GN;AgCh7GI;ET9JA,yCpBqmB2C;AH4+F/C;;AgCx6GA;EACE,uBAAA;AhC26GF;AgCx6GI;EACE,gBAAA;EACA,gB3BiY0C;E2BhY1C,mBAAA;EAEA,uB3B+X0C;AL0iGhD;AgCt6GI;EACE,yBAAA;EACA,4BAAA;EACA,0B3B0X0C;E2BzX1C,2B3ByX0C;E2BxX1C,yB7BkXe;E6BhXf,uB3BqX0C;EgBviB1C,yIWmLA;AhCu6GN;AqBtlHM;EWuKF;IXtKI,gBAAA;ErBylHN;AACF;AgCv6GI;EACE,sB7BzLE;E6B0LF,gCAAA;AhCy6GN;AgCp6GI;ETzMA,yCpBqmB2C;AH2gG/C;;AgC15GA;EACE,qBAAA;EACA,WAAA;EACA,mC3BoRsC;E2BnRtC,0CAAA;E5BjGI,mBAtCa;E4B0IjB,gB7BmImB;E6BlInB,gB7BwIkB;E6BvIlB,c7B/MS;E6BgNT,sBAAA;EACA,gGAAA;EACA,yBAAA;ErBtNE,uBAAA;ECFE,gDoB0NJ;EACA,gBAAA;AhC45GF;AgC15GE;EACE,sC7ByUuB;E6BxUvB,UAAA;EpB/NE,iEALa;AZioHnB;AgCr5GI;EAME,c7BvOK;E6BwOL,sB7B9OE;AHgoHR;AgC94GE;EAEE,YAAA;EACA,sB7BsNkB;E6BrNlB,sBAAA;AhC+4GJ;AgC54GE;EACE,c7BpPO;E6BqPP,yB7BzPO;AHuoHX;AgC14GE;EACE,aAAA;AhC44GJ;AgCx4GE;EACE,kBAAA;EACA,0BAAA;AhC04GJ;;AgCt4GA;EACE,kC3ByNsC;E2BxNtC,oB7BsMuB;E6BrMvB,uB7BqMuB;E6BpMvB,oB7BqMuB;ECpWnB,kBAtCa;AJ+kHnB;;AgCt4GA;EACE,mC3BkNsC;E2BjNtC,qB7BkMuB;E6BjMvB,wB7BiMuB;E6BhMvB,kB7BiMuB;ECxWnB,mBAtCa;AJulHnB;;AgCj4GA;EACE,kBAAA;EACA,qBAAA;EACA,WAAA;EACA,mC3BgMsC;E2B/LtC,gBAAA;AhCo4GF;;AgCj4GA;EACE,kBAAA;EACA,UAAA;EACA,WAAA;EACA,mC3BwLsC;E2BvLtC,SAAA;EACA,gBAAA;EACA,UAAA;AhCo4GF;AgCl4GE;EACE,sC7BsPuB;E6BrPvB,gB7BwPqB;AH4oGzB;AgCh4GE;EAEE,yB7BtTO;AHurHX;AgC73GI;EACE,iB3B0Ta;ALqkGnB;AgC33GE;EACE,0BAAA;AhC63GJ;;AgCz3GA;EACE,kBAAA;EACA,MAAA;EACA,QAAA;EACA,OAAA;EACA,UAAA;EACA,mC3BuJsC;E2BtJtC,yBAAA;EACA,gBAAA;EAEA,gB7BMmB;E6BLnB,gB7BWkB;E6BVlB,c7B5US;E6B6UT,sB7BnVM;E6BoVN,yBAAA;ErBlVE,uBAAA;ECFE,gBoBsVJ;AhC23GF;AgCz3GE;EACE,kBAAA;EACA,MAAA;EACA,QAAA;EACA,SAAA;EACA,UAAA;EACA,cAAA;EACA,6B3BgIoC;E2B/HpC,yBAAA;EACA,gB7BLgB;E6BMhB,c7B5VO;E6B6VP,iBAAA;ET7WA,sBpBUI;E6BqWJ,oBAAA;ErBnWA,oCAAA;AX+tHJ;;AgCj3GA;EACE,WAAA;EACA,YAAA;EACA,UAAA;EACA,6BAAA;EACA,gBAAA;AhCo3GF;AgCl3GE;EACE,UAAA;AhCo3GJ;AgCh3GI;EAA0B,mC3BmOe;ALgpG7C;AgCl3GI;EAA0B,mC3BkOe;ALmpG7C;AgCp3GI;EAA0B,mC3BiOe;ALspG7C;AgCp3GE;EACE,SAAA;AhCs3GJ;AgCn3GE;EACE,W3BmNyC;E2BlNzC,Y3BkNyC;E2BjNzC,oBAAA;ETlZA,yBpBqUkB;E6B+ElB,S3BkNyC;EM1lBzC,mBAAA;ECFE,+CoB4YF;EX5YE,oHW6YF;EX7YE,4GW6YF;EACA,gBAAA;AhCq3GJ;AqB/vHM;EWiYJ;IXhYM,wBAAA;IAAA,gBAAA;ErBkwHN;AACF;AgCx3GI;ET1ZA,qElB2mByC;AL0qG7C;AgCt3GE;EACE,W3B4LgC;E2B3LhC,c3B4LgC;E2B3LhC,kBAAA;EACA,e3B2LgC;E2B1LhC,yB7BvZO;E6BwZP,yBAAA;ErBzZA,mBAAA;ECFE,sDoB6ZF;AhCw3GJ;AgCr3GE;EACE,W3BwLyC;E2BvLzC,Y3BuLyC;EkBnmBzC,yBpBqUkB;E6ByGlB,S3BwLyC;EM1lBzC,mBAAA;ECFE,+CoBsaF;EXtaE,iHWuaF;EXvaE,4GWuaF;EACA,gBAAA;AhCu3GJ;AqB3xHM;EW4ZJ;IX3ZM,qBAAA;IAAA,gBAAA;ErB8xHN;AACF;AgC13GI;ETpbA,qElB2mByC;ALssG7C;AgCx3GE;EACE,W3BkKgC;E2BjKhC,c3BkKgC;E2BjKhC,kBAAA;EACA,e3BiKgC;E2BhKhC,yB7BjbO;E6BkbP,yBAAA;ErBnbA,mBAAA;ECFE,sDoBubF;AhC03GJ;AgCv3GE;EACE,W3B8JyC;E2B7JzC,Y3B6JyC;E2B5JzC,aAAA;EACA,e7B2GgB;E6B1GhB,c7B0GgB;EoBnjBhB,yBpBqUkB;E6BsIlB,S3B2JyC;EM1lBzC,mBAAA;ECFE,+CoBmcF;EXncE,gHWocF;EXpcE,4GWocF;EACA,gBAAA;AhCy3GJ;AqB1zHM;EWsbJ;IXrbM,oBAAA;IAAA,gBAAA;ErB6zHN;AACF;AgC53GI;ETjdA,qElB2mByC;ALquG7C;AgC13GE;EACE,W3BqIgC;E2BpIhC,c3BqIgC;E2BpIhC,kBAAA;EACA,e3BoIgC;E2BnIhC,6BAAA;EACA,yBAAA;EACA,oBAAA;EpBndE,sDoBodF;AhC43GJ;AgCz3GE;EACE,yB7BrdO;EQDP,mBAAA;AXk1HJ;AgCx3GE;EACE,kBAAA;EACA,yB7B3dO;EQDP,mBAAA;AXu1HJ;AgCt3GI;EACE,yB7B/dK;AHu1HX;AgCr3GI;EACE,eAAA;AhCu3GN;AgCp3GI;EACE,yB7BveK;AH61HX;AgCn3GI;EACE,eAAA;AhCq3GN;AgCl3GI;EACE,yB7B/eK;AHm2HX;;AgC/2GA;;;EXzfM,4GW4fJ;AhCk3GF;AqB12HM;EWqfN;;;IXpfQ,gBAAA;ErB+2HN;AACF;;AiCh4HA;EACE,aAAA;EACA,eAAA;EACA,eAAA;EACA,gBAAA;EACA,gBAAA;AjCm4HF;;AiCh4HA;EACE,cAAA;EACA,wBAAA;AjCm4HF;AMl4HE;E2BGE,qBAAA;AjCk4HJ;AiC93HE;EACE,c9BFO;E8BGP,oBAAA;EACA,eAAA;AjCg4HJ;;AiCx3HA;EACE,gCAAA;AjC23HF;AiCz3HE;EACE,mBAAA;EACA,6BAAA;EtBZA,gCAAA;EACA,iCAAA;AXw4HJ;AMp5HE;E2B2BI,qC5BmpB8B;ALyuGpC;AiCz3HI;EACE,c9BzBK;E8B0BL,6BAAA;EACA,yBAAA;AjC23HN;AiCv3HE;;EAEE,c9BhCO;E8BiCP,yB9B6KM;E8B5KN,qC5BwoBgC;ALivGpC;AiCt3HE;EAEE,gBAAA;EtBnCA,yBAAA;EACA,0BAAA;AX25HJ;;AiC72HE;EtBxDE,uBAAA;AXy6HJ;AiC72HE;;EAEE,W9BunB0B;E8BtnB1B,yB9BunBuB;AHwvG3B;;AiCr2HE;;EAEE,cAAA;EACA,kBAAA;AjCw2HJ;;AiCn2HE;;EAEE,aAAA;EACA,YAAA;EACA,kBAAA;AjCs2HJ;;AiC51HE;EACE,aAAA;AjC+1HJ;AiC71HE;EACE,cAAA;AjC+1HJ;;AkCn8HA;EACE,kBAAA;EACA,aAAA;EACA,eAAA;EACA,mBAAA;EACA,8BAAA;EACA,kBAAA;AlCs8HF;AkCl8HE;;;;;;EACE,aAAA;EACA,eAAA;EACA,mBAAA;EACA,8BAAA;AlCy8HJ;AkCr7HA;EACE,qBAAA;EACA,sB7BiqBkC;E6BhqBlC,yB7BgqBkC;E6B/pBlC,kB/BwpBiB;EChlBb,kBAtCa;E8BhCjB,oBAAA;EACA,mBAAA;AlCu7HF;AMj+HE;E4B6CE,qBAAA;AlCu7HJ;;AkC96HA;EACE,aAAA;EACA,sBAAA;EACA,eAAA;EACA,gBAAA;EACA,gBAAA;AlCi7HF;AkC/6HE;EACE,gBAAA;EACA,eAAA;AlCi7HJ;AkC96HE;EACE,gBAAA;EACA,WAAA;AlCg7HJ;;AkCv6HA;EACE,qBAAA;EACA,oB/BslBmB;E+BrlBnB,uB/BqlBmB;AHq1GrB;;AkC95HA;EACE,gBAAA;EACA,YAAA;EAGA,mBAAA;AlC+5HF;;AkC35HA;EACE,wBAAA;E9BSI,kBAtCa;E8B+BjB,cAAA;EACA,6BAAA;EACA,6BAAA;EvBxGE,uBAAA;AXugIJ;AMzgIE;E4B8GE,qBAAA;AlC85HJ;;AkCx5HA;EACE,qBAAA;EACA,YAAA;EACA,aAAA;EACA,sBAAA;EACA,WAAA;EACA,mCAAA;AlC25HF;;AkCx5HA;EACE,gB7B+kBkC;E6B9kBlC,gBAAA;AlC25HF;;AgBj+HI;EkBkFI;;;;;;IACE,gBAAA;IACA,eAAA;ElCw5HR;AACF;AgB1/HI;EkB6FA;IAoBI,qBAAA;IACA,2BAAA;ElC64HN;EkC34HM;IACE,mBAAA;ElC64HR;EkC34HQ;IACE,kBAAA;ElC64HV;EkC14HQ;IACE,mB/ByhBgB;I+BxhBhB,kB/BwhBgB;EHo3G1B;EkCv4HM;;;;;;IACE,iBAAA;ElC84HR;EkCh4HM;IACE,iBAAA;ElCk4HR;EkC/3HM;IACE,wBAAA;IAGA,gBAAA;ElC+3HR;EkC53HM;IACE,aAAA;ElC83HR;AACF;AgB/gII;EkBkFI;;;;;;IACE,gBAAA;IACA,eAAA;ElCq8HR;AACF;AgBviII;EkB6FA;IAoBI,qBAAA;IACA,2BAAA;ElC07HN;EkCx7HM;IACE,mBAAA;ElC07HR;EkCx7HQ;IACE,kBAAA;ElC07HV;EkCv7HQ;IACE,mB/ByhBgB;I+BxhBhB,kB/BwhBgB;EHi6G1B;EkCp7HM;;;;;;IACE,iBAAA;ElC27HR;EkC76HM;IACE,iBAAA;ElC+6HR;EkC56HM;IACE,wBAAA;IAGA,gBAAA;ElC46HR;EkCz6HM;IACE,aAAA;ElC26HR;AACF;AgB5jII;EkBkFI;;;;;;IACE,gBAAA;IACA,eAAA;ElCk/HR;AACF;AgBplII;EkB6FA;IAoBI,qBAAA;IACA,2BAAA;ElCu+HN;EkCr+HM;IACE,mBAAA;ElCu+HR;EkCr+HQ;IACE,kBAAA;ElCu+HV;EkCp+HQ;IACE,mB/ByhBgB;I+BxhBhB,kB/BwhBgB;EH88G1B;EkCj+HM;;;;;;IACE,iBAAA;ElCw+HR;EkC19HM;IACE,iBAAA;ElC49HR;EkCz9HM;IACE,wBAAA;IAGA,gBAAA;ElCy9HR;EkCt9HM;IACE,aAAA;ElCw9HR;AACF;AgBzmII;EkBkFI;;;;;;IACE,gBAAA;IACA,eAAA;ElC+hIR;AACF;AgBjoII;EkB6FA;IAoBI,qBAAA;IACA,2BAAA;ElCohIN;EkClhIM;IACE,mBAAA;ElCohIR;EkClhIQ;IACE,kBAAA;ElCohIV;EkCjhIQ;IACE,mB/ByhBgB;I+BxhBhB,kB/BwhBgB;EH2/G1B;EkC9gIM;;;;;;IACE,iBAAA;ElCqhIR;EkCvgIM;IACE,iBAAA;ElCygIR;EkCtgIM;IACE,wBAAA;IAGA,gBAAA;ElCsgIR;EkCngIM;IACE,aAAA;ElCqgIR;AACF;AkCtkII;EAoBI,qBAAA;EACA,2BAAA;AlCqjIR;AkCxkIQ;;;;;;EACE,gBAAA;EACA,eAAA;AlC+kIV;AkC5jIQ;EACE,mBAAA;AlC8jIV;AkC5jIU;EACE,kBAAA;AlC8jIZ;AkC3jIU;EACE,mB/ByhBgB;E+BxhBhB,kB/BwhBgB;AHqiH5B;AkCxjIQ;;;;;;EACE,iBAAA;AlC+jIV;AkCjjIQ;EACE,iBAAA;AlCmjIV;AkChjIQ;EACE,wBAAA;EAGA,gBAAA;AlCgjIV;AkC7iIQ;EACE,aAAA;AlC+iIV;;AkCjiIE;EACE,yB/B4gBwB;AHwhH5B;AM5vIE;E4B2NI,yB/BygBsB;AH2hH5B;AkC/hII;EACE,yB/BigBe;AHgiHrB;AMlwIE;E4BoOM,yB/B+fmB;AHkiH3B;AkC9hIM;EACE,yB/B6fsB;AHmiH9B;AkC5hII;;;;EAIE,yB/BofsB;AH0iH5B;AkC1hIE;EACE,yB/B6eiB;E+B5ejB,yB/BgfgC;AH4iHpC;AkCzhIE;EACE,yDAAA;AlC2hIJ;AkCxhIE;EACE,yB/BoeiB;AHsjHrB;AkCzhII;EACE,yB/BoesB;AHujH5B;AM3xIE;E4BmQM,yB/BieoB;AH0jH5B;;AkCnhIE;EACE,gC/BycuB;AH6kH3B;AMlyIE;E4B+QI,gC/BscqB;AHglH3B;AkCjhII;EACE,gC/B8bc;AHqlHpB;AMxyIE;E4BwRM,gC/B4bkB;AHulH1B;AkChhIM;EACE,gC/B0bqB;AHwlH7B;AkC9gII;;;;EAIE,gC/BibqB;AH+lH3B;AkC5gIE;EACE,gC/B0agB;E+BzahB,yB/B6a+B;AHimHnC;AkC3gIE;EACE,yDAAA;AlC6gIJ;AkC1gIE;EACE,gC/BiagB;AH2mHpB;AkC3gII;EACE,gC/BiaqB;AH4mH3B;AMj0IE;E4BuTM,gC/B8ZmB;AH+mH3B;;AmCh1IA;EACE,kBAAA;EACA,aAAA;EACA,sBAAA;EACA,YAAA;EAEA,qBAAA;EACA,sBhCKM;EgCJN,2BAAA;EACA,qCAAA;ExBKE,uBAAA;AX80IJ;AmCh1IE;EACE,eAAA;EACA,cAAA;AnCk1IJ;AmC/0IE;EACE,mBAAA;EACA,sBAAA;AnCi1IJ;AmC/0II;EACE,mBAAA;ExBCF,4CAAA;EACA,6CAAA;AXi1IJ;AmC/0II;EACE,sBAAA;ExBUF,gDAAA;EACA,+CAAA;AXw0IJ;AmC50IE;;EAEE,aAAA;AnC80IJ;;AmC10IA;EAGE,cAAA;EAGA,eAAA;EACA,ehCk1Bc;AHu/GhB;;AmCr0IA;EACE,sBhC40Bc;AH4/GhB;;AmCr0IA;EACE,qBAAA;EACA,gBAAA;AnCw0IF;;AmCr0IA;EACE,gBAAA;AnCw0IF;;AM73IE;E6B0DE,qBAAA;AnCu0IJ;AmCp0IE;EACE,mBhC2zBY;AH2gHhB;;AmC9zIA;EACE,uBAAA;EACA,gBAAA;EAEA,sBhCtEM;EgCuEN,4CAAA;AnCg0IF;AmC9zIE;ExBvEE,4DAAA;AXw4IJ;;AmC5zIA;EACE,uBAAA;EAEA,sBhCjFM;EgCkFN,yCAAA;AnC8zIF;AmC5zIE;ExBlFE,4DAAA;AXi5IJ;;AmCrzIA;EACE,sBAAA;EACA,uBAAA;EACA,qBAAA;EACA,gBAAA;AnCwzIF;;AmCrzIA;EACE,sBAAA;EACA,qBAAA;AnCwzIF;;AmCpzIA;EACE,kBAAA;EACA,MAAA;EACA,QAAA;EACA,SAAA;EACA,OAAA;EACA,gBhC8wByB;EQ73BvB,mCAAA;AXu6IJ;;AmCpzIA;;;EAGE,cAAA;EACA,WAAA;AnCuzIF;;AmCpzIA;;ExBjHI,4CAAA;EACA,6CAAA;AX06IJ;;AmCrzIA;;ExBxGI,gDAAA;EACA,+CAAA;AXk6IJ;;AmClzIE;EACE,mB9BmrBgC;ALkoHpC;AgBp5II;EmB6FJ;IAMI,aAAA;IACA,mBAAA;IACA,mBAAA;IACA,kBAAA;EnCqzIF;EmCnzIE;IAEE,SAAA;IACA,kB9BuqB8B;I8BtqB9B,gBAAA;IACA,iB9BqqB8B;EL+oHlC;AACF;;AmCxyIE;EACE,mB9BupBgC;ALopHpC;AgBt6II;EmBuHJ;IAQI,aAAA;IACA,mBAAA;EnC2yIF;EmCxyIE;IAEE,SAAA;IACA,gBAAA;EnCyyIJ;EmCvyII;IACE,cAAA;IACA,cAAA;EnCyyIN;EmCpyIM;IxBzKJ,0BAAA;IACA,6BAAA;EXg9IF;EmCryIQ;;IAGE,0BAAA;EnCsyIV;EmCpyIQ;;IAGE,6BAAA;EnCqyIV;EmCjyIM;IxB1KJ,yBAAA;IACA,4BAAA;EX88IF;EmClyIQ;;IAGE,yBAAA;EnCmyIV;EmCjyIQ;;IAGE,4BAAA;EnCkyIV;AACF;;AmCrxIE;EACE,sBhCgpBY;AHwoHhB;AgBh9II;EmBsLJ;IAMI,ehC4pBiB;IgC3pBjB,mBhC4pBe;IgC3pBf,UAAA;IACA,SAAA;EnCwxIF;EmCtxIE;IACE,qBAAA;IACA,WAAA;EnCwxIJ;AACF;;AmC/wIA;EACE,qBAAA;AnCkxIF;AmChxIE;EACE,gBAAA;AnCkxIJ;AmChxII;EACE,gBAAA;ExBvOF,6BAAA;EACA,4BAAA;AX0/IJ;AmChxII;ExBzPA,yBAAA;EACA,0BAAA;AX4gJJ;AmChxII;ExBtQA,gBAAA;EwBwQE,mBAAA;AnCkxIN;;AoC5iJA;EACE,aAAA;EACA,eAAA;EACA,qBAAA;EACA,mB/BmiCkC;E+BjiClC,gBAAA;EACA,yBjCWS;EQAP,uBAAA;AXoiJJ;;AoCziJE;EACE,oB/BuhCgC;ALqhHpC;AoC1iJI;EACE,WAAA;EACA,qB/BmhC8B;E+BlhC9B,cjCGK;EiCFL,YAAA;ApC4iJN;AoCliJE;EACE,0BAAA;ApCoiJJ;AoCjiJE;EACE,qBAAA;ApCmiJJ;AoChiJE;EACE,cjCjBO;AHmjJX;;AqCzkJA;EACE,aAAA;E7BGA,eAAA;EACA,gBAAA;EGaE,uBAAA;AX8jJJ;;AqC1kJA;EACE,kBAAA;EACA,cAAA;EACA,uBAAA;EACA,iBAAA;EACA,iBhCmxBkC;EgClxBlC,clCUS;EkCRT,sBlCEM;EkCDN,yBAAA;ArC4kJF;AqC1kJE;EACE,UAAA;EACA,clCGO;EkCFP,qBAAA;EACA,yBlCFO;EkCGP,qBlCHO;AH+kJX;AqCzkJE;EACE,UAAA;EACA,UhC2wBgC;EgC1wBhC,gBlCocyB;AHuoI7B;;AqCrkJI;EACE,cAAA;E1BaF,gCAAA;EACA,mCAAA;AX4jJJ;AqCrkJI;E1BNA,iCAAA;EACA,oCAAA;AX8kJJ;AqCpkJE;EACE,UAAA;EACA,WlC/BI;EkCgCJ,yBlC2RkB;EkC1RlB,qBlC0RkB;AH4yItB;AqCnkJE;EACE,clC/BO;EkCgCP,oBAAA;EAEA,YAAA;EACA,sBlCzCI;EkC0CJ,qBlCvCO;AH2mJX;;AsC3nJE;EACE,uBAAA;ElC2HE,kBAtCa;EkCnFf,gBjCmO0B;AL25I9B;AsCznJM;E3BqCF,iCAAA;EACA,oCAAA;AXulJJ;AsCxnJM;E3BkBF,kCAAA;EACA,qCAAA;AXymJJ;;AsCzoJE;EACE,uBAAA;ElC2HE,mBAtCa;EkCnFf,gBjCoO0B;ALw6I9B;AsCvoJM;E3BqCF,+BAAA;EACA,kCAAA;AXqmJJ;AsCtoJM;E3BkBF,gCAAA;EACA,mCAAA;AXunJJ;;AuCrpJA;EACE,qBAAA;EACA,yBAAA;EnCiEE,cAAA;EmC/DF,gBpC8ViB;EoC7VjB,cAAA;EACA,kBAAA;EACA,mBAAA;EACA,wBAAA;E5BKE,uBAAA;EUFE,qIkBDJ;AvCwpJF;AqBnpJM;EkBfN;IlBgBQ,gBAAA;ErBspJN;AACF;AM5pJE;EiCGI,qBAAA;AvC4pJN;;AuCvpJE;EACE,aAAA;AvC0pJJ;;AuCrpJA;EACE,kBAAA;EACA,SAAA;AvCwpJF;;AuCjpJA;EACE,sBpCuzBqB;EoCtzBrB,qBpCszBqB;EQ70BnB,oBAAA;AX4qJJ;;AuC5oJE;ECjDA,wDAAA;EACA,2EAAA;AxCisJF;AMnrJE;EkCVI,WAAA;EACA,qBAAA;EACA,mEAAA;AxCgsJN;;AuCtpJE;ECjDA,0DAAA;EACA,0CAAA;AxC2sJF;AM7rJE;EkCVI,cAAA;EACA,qBAAA;EACA,qEAAA;AxC0sJN;;AuChqJE;ECjDA,wDAAA;EACA,yEAAA;AxCqtJF;AMvsJE;EkCVI,WAAA;EACA,qBAAA;EACA,mEAAA;AxCotJN;;AuC1qJE;ECjDA,wDAAA;EACA,0EAAA;AxC+tJF;AMjtJE;EkCVI,WAAA;EACA,qBAAA;EACA,mEAAA;AxC8tJN;;AuCprJE;ECjDA,iCAAA;EACA,gEAAA;AxCyuJF;AM3tJE;EkCVI,WAAA;EACA,qBAAA;EACA,0DAAA;AxCwuJN;;AuC9rJE;ECjDA,iCAAA;EACA,2EAAA;AxCmvJF;AMruJE;EkCVI,WAAA;EACA,qBAAA;EACA,mEAAA;AxCkvJN;;AuCxsJE;ECjDA,iDAAA;EACA,mEAAA;AxC6vJF;AM/uJE;EkCVI,WAAA;EACA,qBAAA;EACA,4DAAA;AxC4vJN;;AuCltJE;ECjDA,6CAAA;EACA,kEAAA;AxCuwJF;AMzvJE;EkCVI,WAAA;EACA,qBAAA;EACA,yDAAA;AxCswJN;;AuC5tJE;ECjDA,mCAAA;EACA,0CAAA;AxCixJF;AMnwJE;EkCVI,cAAA;EACA,qBAAA;EACA,8CAAA;AxCgxJN;;AuCtuJE;ECjDA,kCAAA;EACA,0CAAA;AxC2xJF;AM7wJE;EkCVI,cAAA;EACA,qBAAA;EACA,0CAAA;AxC0xJN;;AuChvJE;ECjDA,kCAAA;EACA,0CAAA;AxCqyJF;AMvxJE;EkCVI,cAAA;EACA,qBAAA;EACA,0CAAA;AxCoyJN;;AuC1vJE;ECjDA,YAAA;EACA,gDAAA;AxC+yJF;AMjyJE;EkCVI,WAAA;EACA,qBAAA;EACA,uBAAA;AxC8yJN;;AyCtzJA;EACE,kBAAA;EACA,mBpCuzBkC;EoCrzBlC,yBtCcS;EQAP,wBAAA;AX2yJJ;AgBjwJI;EyB5DJ;IAQI,kBAAA;EzCyzJF;AACF;;AyCtzJA;EACE,gBAAA;EACA,eAAA;E9BIE,gBAAA;AXszJJ;;A0Cp0JA;EACE,kBAAA;EACA,oBAAA;EACA,mBrCu9BkC;EqCt9BlC,6BAAA;E/BUE,uBAAA;AX8zJJ;;A0Cn0JA;EAEE,cAAA;A1Cq0JF;;A0Cj0JA;EACE,gBvCmViB;AHi/InB;;A0C5zJA;EACE,qBAAA;A1C+zJF;A0C5zJE;EACE,kBAAA;EACA,MAAA;EACA,QAAA;EACA,UAAA;EACA,oBAAA;EACA,cAAA;A1C8zJJ;;A0CpzJE;EC/CA,WAAA;EpBKE,4CmB2CuB;EC9CzB,wCD8CqE;A1CyzJvE;A2Cr2JE;EACE,oEAAA;A3Cu2JJ;A2Cp2JE;EACE,wDAAA;A3Cs2JJ;;A0Ch0JE;EC/CA,cAAA;EpBKE,4CmB2CuB;EC9CzB,wCD8CqE;A1Cq0JvE;A2Cj3JE;EACE,qEAAA;A3Cm3JJ;A2Ch3JE;EACE,0DAAA;A3Ck3JJ;;A0C50JE;EC/CA,WAAA;EpBKE,4CmB2CuB;EC9CzB,wCD8CqE;A1Ci1JvE;A2C73JE;EACE,mEAAA;A3C+3JJ;A2C53JE;EACE,wDAAA;A3C83JJ;;A0Cx1JE;EC/CA,WAAA;EpBKE,yCmB2CuB;EC9CzB,qCD8CqE;A1C61JvE;A2Cz4JE;EACE,oEAAA;A3C24JJ;A2Cx4JE;EACE,wDAAA;A3C04JJ;;A0Cp2JE;EC/CA,WAAA;EpBKE,4CmB2CuB;EC9CzB,wCD8CqE;A1Cy2JvE;A2Cr5JE;EACE,4DAAA;A3Cu5JJ;A2Cp5JE;EACE,+CAAA;A3Cs5JJ;;A0Ch3JE;EC/CA,WAAA;EpBKE,2CmB2CuB;EC9CzB,uCD8CqE;A1Cq3JvE;A2Cj6JE;EACE,mEAAA;A3Cm6JJ;A2Ch6JE;EACE,wDAAA;A3Ck6JJ;;A0C53JE;EC/CA,WAAA;EpBKE,6CmB2CuB;EC9CzB,yCD8CqE;A1Ci4JvE;A2C76JE;EACE,6DAAA;A3C+6JJ;A2C56JE;EACE,iDAAA;A3C86JJ;;A0Cx4JE;EC/CA,WAAA;EpBKE,0CmB2CuB;EC9CzB,sCD8CqE;A1C64JvE;A2Cz7JE;EACE,0DAAA;A3C27JJ;A2Cx7JE;EACE,8CAAA;A3C07JJ;;A0Cp5JE;EC/CA,cAAA;EpBKE,yCmB2CuB;EC9CzB,qCD8CqE;A1Cy5JvE;A2Cr8JE;EACE,gDAAA;A3Cu8JJ;A2Cp8JE;EACE,mCAAA;A3Cs8JJ;;A0Ch6JE;EC/CA,cAAA;EpBKE,uBmB2CuB;EC9CzB,mBD8CqE;A1Cq6JvE;A2Cj9JE;EACE,6CAAA;A3Cm9JJ;A2Ch9JE;EACE,+BAAA;A3Ck9JJ;;A0C56JE;EC/CA,cAAA;EpBKE,uBmB2CuB;EC9CzB,mBD8CqE;A1Ci7JvE;A2C79JE;EACE,6CAAA;A3C+9JJ;A2C59JE;EACE,+BAAA;A3C89JJ;;A0Cx7JE;EC/CA,WAAA;EpBKE,uCmB2CuB;EC9CzB,mCD8CqE;A1C67JvE;A2Cz+JE;EACE,0CAAA;A3C2+JJ;A2Cx+JE;EACE,YAAA;A3C0+JJ;;A4Cl/JE;EACE;IAAO,2BAAA;E5Cs/JT;E4Cr/JE;IAAK,wBAAA;E5Cw/JP;AACF;A4Cr/JA;EACE,aAAA;EACA,YvCg+BkC;EuC/9BlC,gBAAA;EACA,cAAA;ExCmHI,kBAtCa;EwC3EjB,yBzCIS;EQAP,uBAAA;ECFE,oDAAA;AZu/JN;;A4Cp/JA;EACE,aAAA;EACA,sBAAA;EACA,uBAAA;EACA,gBAAA;EACA,WzCRM;EyCSN,kBAAA;EACA,mBAAA;EACA,yBvCq9BkC;EgBh+B9B,2BuBYJ;A5Cu/JF;AqB//JM;EuBDN;IvBEQ,gBAAA;ErBkgKN;AACF;;A4Cz/JA;ErBYE,qMAAA;EqBVA,0BAAA;A5C4/JF;;A4Cx/JE;EACE,kDAAA;A5C2/JJ;A4Cx/JM;EAJJ;IAKM,eAAA;E5C2/JN;AACF;;A6CtiKA;EACE,aAAA;EACA,uBAAA;A7CyiKF;;A6CtiKA;EACE,SAAA;A7CyiKF;;A8C3iKA;EACE,aAAA;EACA,sBAAA;EAGA,eAAA;EACA,gBAAA;EnCQE,uBAAA;AXqiKJ;;A8CniKA;EACE,WAAA;EACA,c3CCS;E2CAT,mBAAA;A9CsiKF;AM7iKE;EwCWE,UAAA;EACA,c3CLO;E2CMP,qBAAA;EACA,yB3CbO;AHkjKX;A8CliKE;EACE,c3CXO;E2CYP,yB3CjBO;AHqjKX;;A8C3hKA;EACE,kBAAA;EACA,cAAA;EACA,kBAAA;EAGA,sB3ClCM;E2CmCN,yBAAA;A9C4hKF;A8C1hKE;EnC1BE,+BAAA;EACA,gCAAA;AXujKJ;A8C1hKE;EnChBE,mCAAA;EACA,kCAAA;AX6iKJ;A8C1hKE;EAEE,c3CzCO;E2C0CP,oBAAA;EACA,sB3CjDI;AH4kKR;A8CvhKE;EACE,UAAA;EACA,W3CvDI;E2CwDJ,yB3CmQkB;E2ClQlB,qB3CkQkB;AHuxJtB;A8CthKE;EACE,mBAAA;A9CwhKJ;A8CthKI;EACE,gBAAA;EACA,qB3C6OS;AH2yJf;;A8C1gKI;EACE,mBAAA;A9C6gKN;A8C1gKQ;EnC1BJ,mCAAA;EAZA,0BAAA;AXojKJ;A8CzgKQ;EnC3CJ,iCAAA;EAYA,4BAAA;AX4iKJ;A8CxgKQ;EACE,aAAA;A9C0gKV;A8CvgKQ;EACE,qB3C4MK;E2C3ML,oBAAA;A9CygKV;A8CvgKU;EACE,iBAAA;EACA,sB3CuMG;AHk0Jf;;AgBpkKI;E8BmCA;IACE,mBAAA;E9CqiKJ;E8CliKM;InC1BJ,mCAAA;IAZA,0BAAA;EX4kKF;E8CjiKM;InC3CJ,iCAAA;IAYA,4BAAA;EXokKF;E8ChiKM;IACE,aAAA;E9CkiKR;E8C/hKM;IACE,qB3C4MK;I2C3ML,oBAAA;E9CiiKR;E8C/hKQ;IACE,iBAAA;IACA,sB3CuMG;EH01Jb;AACF;AgB7lKI;E8BmCA;IACE,mBAAA;E9C6jKJ;E8C1jKM;InC1BJ,mCAAA;IAZA,0BAAA;EXomKF;E8CzjKM;InC3CJ,iCAAA;IAYA,4BAAA;EX4lKF;E8CxjKM;IACE,aAAA;E9C0jKR;E8CvjKM;IACE,qB3C4MK;I2C3ML,oBAAA;E9CyjKR;E8CvjKQ;IACE,iBAAA;IACA,sB3CuMG;EHk3Jb;AACF;AgBrnKI;E8BmCA;IACE,mBAAA;E9CqlKJ;E8CllKM;InC1BJ,mCAAA;IAZA,0BAAA;EX4nKF;E8CjlKM;InC3CJ,iCAAA;IAYA,4BAAA;EXonKF;E8ChlKM;IACE,aAAA;E9CklKR;E8C/kKM;IACE,qB3C4MK;I2C3ML,oBAAA;E9CilKR;E8C/kKQ;IACE,iBAAA;IACA,sB3CuMG;EH04Jb;AACF;AgB7oKI;E8BmCA;IACE,mBAAA;E9C6mKJ;E8C1mKM;InC1BJ,mCAAA;IAZA,0BAAA;EXopKF;E8CzmKM;InC3CJ,iCAAA;IAYA,4BAAA;EX4oKF;E8CxmKM;IACE,aAAA;E9C0mKR;E8CvmKM;IACE,qB3C4MK;I2C3ML,oBAAA;E9CymKR;E8CvmKQ;IACE,iBAAA;IACA,sB3CuMG;EHk6Jb;AACF;A8C5lKA;EnCnHI,gBAAA;AXktKJ;A8C5lKE;EACE,qBAAA;A9C8lKJ;A8C5lKI;EACE,sBAAA;A9C8lKN;;A+CvuKE;EACE,+BDoJsE;ECnJtE,6CDmJuC;A9CulK3C;AM/tKE;EyCPM,+BD+IkE;EC9IlE,qEAAA;A/CyuKR;A+CtuKM;EACE,W5CEA;E4CDA,0CDyIkE;ECxIlE,sCDwIkE;A9CgmK1E;;A+CrvKE;EACE,+BDoJsE;ECnJtE,4CDmJuC;A9CqmK3C;AM7uKE;EyCPM,+BD+IkE;EC9IlE,qEAAA;A/CuvKR;A+CpvKM;EACE,W5CEA;E4CDA,0CDyIkE;ECxIlE,sCDwIkE;A9C8mK1E;;A+CnwKE;EACE,+BDoJsE;ECnJtE,6CDmJuC;A9CmnK3C;AM3vKE;EyCPM,+BD+IkE;EC9IlE,qEAAA;A/CqwKR;A+ClwKM;EACE,W5CEA;E4CDA,0CDyIkE;ECxIlE,sCDwIkE;A9C4nK1E;;A+CjxKE;EACE,8BDoJsE;ECnJtE,0CDmJuC;A9CioK3C;AMzwKE;EyCPM,8BD+IkE;EC9IlE,qEAAA;A/CmxKR;A+ChxKM;EACE,W5CEA;E4CDA,yCDyIkE;ECxIlE,qCDwIkE;A9C0oK1E;;A+C/xKE;EACE,gCDoJsE;ECnJtE,6CDmJuC;A9C+oK3C;AMvxKE;EyCPM,gCD+IkE;EC9IlE,6DAAA;A/CiyKR;A+C9xKM;EACE,W5CEA;E4CDA,2CDyIkE;ECxIlE,uCDwIkE;A9CwpK1E;;A+C7yKE;EACE,+BDoJsE;ECnJtE,4CDmJuC;A9C6pK3C;AMryKE;EyCPM,+BD+IkE;EC9IlE,qEAAA;A/C+yKR;A+C5yKM;EACE,W5CEA;E4CDA,0CDyIkE;ECxIlE,sCDwIkE;A9CsqK1E;;A+C3zKE;EACE,+BDoJsE;ECnJtE,6CDmJuC;A9C2qK3C;AMnzKE;EyCPM,+BD+IkE;EC9IlE,6DAAA;A/C6zKR;A+C1zKM;EACE,W5CEA;E4CDA,0CDyIkE;ECxIlE,sCDwIkE;A9CorK1E;;A+Cz0KE;EACE,+BDoJsE;ECnJtE,6CDmJuC;A9CyrK3C;AMj0KE;EyCPM,+BD+IkE;EC9IlE,6DAAA;A/C20KR;A+Cx0KM;EACE,W5CEA;E4CDA,0CDyIkE;ECxIlE,sCDwIkE;A9CksK1E;;A+Cv1KE;EACE,+BDoJsE;ECnJtE,yCDmJuC;A9CusK3C;AM/0KE;EyCPM,+BD+IkE;EC9IlE,gDAAA;A/Cy1KR;A+Ct1KM;EACE,W5CEA;E4CDA,0CDyIkE;ECxIlE,sCDwIkE;A9CgtK1E;;A+Cr2KE;EACE,+BDoJsE;ECnJtE,uBDmJuC;A9CqtK3C;AM71KE;EyCPM,+BD+IkE;EC9IlE,6CAAA;A/Cu2KR;A+Cp2KM;EACE,W5CEA;E4CDA,0CDyIkE;ECxIlE,sCDwIkE;A9C8tK1E;;A+Cn3KE;EACE,+BDoJsE;ECnJtE,uBDmJuC;A9CmuK3C;AM32KE;EyCPM,+BD+IkE;EC9IlE,6CAAA;A/Cq3KR;A+Cl3KM;EACE,W5CEA;E4CDA,0CDyIkE;ECxIlE,sCDwIkE;A9C4uK1E;;A+Cj4KE;EACE,YDoJsE;ECnJtE,0CDmJuC;A9CivK3C;AMz3KE;EyCPM,YD+IkE;EC9IlE,6CAAA;A/Cm4KR;A+Ch4KM;EACE,W5CEA;E4CDA,uBDyIkE;ECxIlE,mBDwIkE;A9C0vK1E;;AgDl5KA;EACE,YAAA;E5C8HI,iBAtCa;E4CtFjB,gB7CoWiB;E6CnWjB,cAAA;EACA,yB7CozBY;E6CnzBZ,iB7CqzBkB;E6CpzBlB,YAAA;AhDq5KF;AMh5KE;E0CDE,yB7C8yBU;E6C7yBV,qBAAA;AhDo5KJ;AMh5KE;E0CCI,aAAA;AhDk5KN;;AgDv4KA;EACE,UAAA;EACA,6BAAA;EACA,SAAA;AhD04KF;;AgDp4KA;EACE,oBAAA;AhDu4KF;;AiDv6KA;EAEE,gBAAA;AjDy6KF;AiDv6KE;EACE,kBAAA;EACA,gBAAA;AjDy6KJ;;AiDp6KA;EACE,eAAA;EACA,MAAA;EACA,OAAA;EACA,a5C2pBkC;E4C1pBlC,aAAA;EACA,WAAA;EACA,YAAA;EACA,gBAAA;EAGA,UAAA;AjDq6KF;;AiD95KA;EACE,kBAAA;EACA,WAAA;EACA,c5C+4BkC;E4C74BlC,oBAAA;AjDg6KF;AiD75KE;E5B3BI,mC4B4BF;EACA,8B5Cq6BgC;AL0/IpC;AqBx7KM;E4BuBJ;I5BtBM,gBAAA;ErB27KN;AACF;AiDl6KE;EACE,e5Cm6BgC;ALigJpC;AiDh6KE;EACE,sB5Cg6BgC;ALkgJpC;;AiD95KA;EACE,aAAA;EACA,6BAAA;AjDi6KF;AiD/5KE;EACE,8BAAA;EACA,gBAAA;AjDi6KJ;AiD95KE;;EAEE,cAAA;AjDg6KJ;AiD75KE;EACE,gBAAA;AjD+5KJ;;AiD35KA;EACE,aAAA;EACA,mBAAA;EACA,6BAAA;AjD85KF;AiD35KE;EACE,cAAA;EACA,0BAAA;EACA,mBAAA;EACA,WAAA;AjD65KJ;AiDz5KE;EACE,sBAAA;EACA,uBAAA;EACA,YAAA;AjD25KJ;AiDz5KI;EACE,gBAAA;AjD25KN;AiDx5KI;EACE,aAAA;AjD05KN;;AiDp5KA;EACE,kBAAA;EACA,aAAA;EACA,sBAAA;EACA,WAAA;EAGA,oBAAA;EACA,sB9ClGM;E8CmGN,4BAAA;EACA,kCAAA;EtClGE,wBAAA;ECFE,6EqCsGJ;EAEA,UAAA;AjDo5KF;;AiDh5KA;EACE,eAAA;EACA,MAAA;EACA,OAAA;EACA,a5C+iBkC;E4C9iBlC,YAAA;EACA,aAAA;EACA,sB9CzGM;AH4/KR;AiDh5KE;EAAS,UAAA;AjDm5KX;AiDl5KE;EAAS,a9C2yBc;AH0mJzB;;AiDh5KA;EACE,aAAA;EACA,uBAAA;EACA,8BAAA;EACA,gB9CuyBqB;E8CtyBrB,8BAAA;EtCtHE,iCAAA;EACA,kCAAA;AX0gLJ;AiDl5KE;EACE,gB9CkyBmB;E8ChyBnB,8BAAA;AjDm5KJ;;AiD94KA;EACE,gBAAA;EACA,gB9CswBwB;AH2oJ1B;;AiD54KA;EACE,kBAAA;EAGA,cAAA;EACA,e9CsvBoB;AHupJtB;;AiDz4KA;EACE,aAAA;EACA,eAAA;EACA,mBAAA;EACA,yBAAA;EACA,gBAAA;EACA,2BAAA;EtCzIE,qCAAA;EACA,oCAAA;AXshLJ;AiDx4KE;EACE,eAAA;AjD04KJ;;AiDr4KA;EACE,kBAAA;EACA,YAAA;EACA,WAAA;EACA,YAAA;EACA,gBAAA;AjDw4KF;;AgB/gLI;EiC6IF;IACE,gB9CutBO;I8CttBP,oBAAA;EjDs4KF;EiDn4KA;IACE,+BAAA;EjDq4KF;EiDn4KE;IACE,gCAAA;EjDq4KJ;EiDj4KA;IACE,+BAAA;EjDm4KF;EiDj4KE;IACE,4BAAA;IACA,mBAAA;EjDm4KJ;EiD/3KA;IrC/MI,6EqCgNF;EjDi4KF;EiD93KA;IAAY,gB9C+rBH;EHksJT;AACF;AgBziLI;EiC2KF;;IAEE,gB9CurBO;EH0sJT;AACF;AgB/iLI;EiCkLF;IAAY,iB5C+tBsB;ELkqJlC;AACF;AkD/mLA;EACE,kBAAA;EACA,a7C+qBkC;E6C9qBlC,cAAA;EACA,S7C21BkC;E8C/1BlC,kChD0VA;EgDxVA,kBAAA;EACA,gBhDkWmB;EgDjWnB,gBhDsWiB;EgDrWjB,gBAAA;EACA,iBAAA;EACA,qBAAA;EACA,iBAAA;EACA,oBAAA;EACA,sBAAA;EACA,kBAAA;EACA,oBAAA;EACA,mBAAA;EACA,gBAAA;E/CgHI,mBAtCa;E8C9EjB,qBAAA;EACA,UAAA;AlD2nLF;AkDznLE;EAAS,Y7C+0ByB;AL6yJpC;AkD1nLE;EACE,kBAAA;EACA,cAAA;EACA,a7C+0BgC;E6C90BhC,c7C+0BgC;AL6yJpC;AkD1nLI;EACE,kBAAA;EACA,WAAA;EACA,yBAAA;EACA,mBAAA;AlD4nLN;;AkDvnLA;EACE,iBAAA;AlD0nLF;AkDxnLE;EACE,SAAA;AlD0nLJ;AkDxnLI;EACE,MAAA;EACA,6BAAA;EACA,sB/CdE;AHwoLR;;AkDrnLA;EACE,iBAAA;AlDwnLF;AkDtnLE;EACE,OAAA;EACA,a7CizBgC;E6ChzBhC,c7C+yBgC;ALy0JpC;AkDtnLI;EACE,QAAA;EACA,oCAAA;EACA,wB/C9BE;AHspLR;;AkDnnLA;EACE,iBAAA;AlDsnLF;AkDpnLE;EACE,MAAA;AlDsnLJ;AkDpnLI;EACE,SAAA;EACA,6BAAA;EACA,yB/C5CE;AHkqLR;;AkDjnLA;EACE,iBAAA;AlDonLF;AkDlnLE;EACE,QAAA;EACA,a7CmxBgC;E6ClxBhC,c7CixBgC;ALm2JpC;AkDlnLI;EACE,OAAA;EACA,oCAAA;EACA,uB/C5DE;AHgrLR;;AkD/lLA;EACE,gB7C6uBkC;E6C5uBlC,uBAAA;EACA,W/C9FM;E+C+FN,kBAAA;EACA,sB/CtFM;EQRJ,uBAAA;AXisLJ;;AoDntLA;EACE,kBAAA;EACA,MAAA;EACA,OAAA;EACA,a/C6qBkC;E+C5qBlC,cAAA;EACA,gBjD2zBkB;EgDh0BlB,kChD0VA;EgDxVA,kBAAA;EACA,gBhDkWmB;EgDjWnB,gBhDsWiB;EgDrWjB,gBAAA;EACA,iBAAA;EACA,qBAAA;EACA,iBAAA;EACA,oBAAA;EACA,sBAAA;EACA,kBAAA;EACA,oBAAA;EACA,mBAAA;EACA,gBAAA;E/CgHI,mBAtCa;EgD7EjB,qBAAA;EACA,sBjDGM;EiDFN,4BAAA;EACA,qCAAA;EzCGE,wBAAA;ECFE,kDwCCJ;ApDguLF;AoD9tLE;EACE,kBAAA;EACA,cAAA;EACA,ajD0zBkB;EiDzzBlB,ejD0zBmB;EiDzzBnB,mBAAA;ApDguLJ;AoD9tLI;EAEE,kBAAA;EACA,cAAA;EACA,WAAA;EACA,yBAAA;EACA,mBAAA;ApD+tLN;;AoD1tLA;EACE,sBjD2yBqB;AHk7JvB;AoD3tLE;EACE,4BAAA;ApD6tLJ;AoD3tLI;EACE,SAAA;EACA,+BAAA;EACA,6BjDsyBsB;AHu7J5B;AoD1tLI;EACE,WjDgxBiB;EiD/wBjB,+BAAA;EACA,sBjDpCE;AHgwLR;;AoDvtLA;EACE,oBjDuxBqB;AHm8JvB;AoDxtLE;EACE,0BAAA;EACA,cjDmxBmB;EiDlxBnB,cjDixBkB;EiDhxBlB,mBAAA;ApD0tLJ;AoDxtLI;EACE,OAAA;EACA,uCAAA;EACA,+BjD+wBsB;AH28J5B;AoDvtLI;EACE,SjDyvBiB;EiDxvBjB,uCAAA;EACA,wBjD3DE;AHoxLR;;AoDptLA;EACE,mBjDgwBqB;AHu9JvB;AoDrtLE;EACE,yBAAA;ApDutLJ;AoDrtLI;EACE,MAAA;EACA,uCAAA;EACA,gCjD2vBsB;AH49J5B;AoDptLI;EACE,QjDquBiB;EiDpuBjB,uCAAA;EACA,yBjD/EE;AHqyLR;AoDjtLE;EACE,kBAAA;EACA,MAAA;EACA,SAAA;EACA,cAAA;EACA,ajDuuBkB;EiDtuBlB,qBAAA;EACA,WAAA;EACA,6BAAA;ApDmtLJ;;AoD/sLA;EACE,qBjDguBqB;AHk/JvB;AoDhtLE;EACE,2BAAA;EACA,cjD4tBmB;EiD3tBnB,cjD0tBkB;EiDztBlB,mBAAA;ApDktLJ;AoDhtLI;EACE,QAAA;EACA,uCAAA;EACA,8BjDwtBsB;AH0/J5B;AoD/sLI;EACE,UjDksBiB;EiDjsBjB,uCAAA;EACA,uBjDlHE;AHm0LR;;AoD3rLA;EACE,uBAAA;EACA,gBAAA;EhD3BI,eAtCa;EgDmEjB,cjDpIS;EiDqIT,sBjD7IM;EiD8IN,oDAAA;EzCnIE,6CAAA;EACA,8CAAA;AXk0LJ;AoD7rLE;EACE,aAAA;ApD+rLJ;;AoD3rLA;EACE,uBAAA;EACA,cjDjJS;AH+0LX;;AqDz1LA;EACE,kBAAA;ArD41LF;;AqDz1LA;EACE,mBAAA;ArD41LF;;AqDz1LA;EACE,kBAAA;EACA,WAAA;EACA,gBAAA;ArD41LF;AsDn3LE;EACE,cAAA;EACA,WAAA;EACA,WAAA;AtDq3LJ;;AqD71LA;EACE,kBAAA;EACA,aAAA;EACA,WAAA;EACA,WAAA;EACA,mBAAA;EACA,2BAAA;EhClBI,sCgCmBJ;ArDg2LF;AqB/2LM;EgCQN;IhCPQ,gBAAA;ErBk3LN;AACF;;AqDl2LA;;;EAGE,cAAA;ArDq2LF;;AqDl2LA;;EAEE,2BAAA;ArDq2LF;;AqDl2LA;;EAEE,4BAAA;ArDq2LF;;AqD51LE;EACE,UAAA;EACA,4BAAA;EACA,eAAA;ArD+1LJ;AqD51LE;;;EAGE,UAAA;EACA,UAAA;ArD81LJ;AqD31LE;;EAEE,UAAA;EACA,UAAA;EhC5DE,2BgC6DF;ArD61LJ;AqBt5LM;EgCqDJ;;IhCpDM,gBAAA;ErB05LN;AACF;;AqD11LA;;EAEE,kBAAA;EACA,MAAA;EACA,SAAA;EACA,UAAA;EAEA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,UhDo9BmC;EgDn9BnC,WlDjFM;EkDkFN,kBAAA;EACA,YhDk9BmC;EgBriC/B,8BgCoFJ;ArD41LF;AqB56LM;EgCkEN;;IhCjEQ,gBAAA;ErBg7LN;AACF;AMt7LE;;;E+CwFE,WlDxFI;EkDyFJ,qBAAA;EACA,UAAA;EACA,YhD28BiC;ALw5JrC;;AqDh2LA;EACE,OAAA;ArDm2LF;;AqD91LA;EACE,QAAA;ArDi2LF;;AqD11LA;;EAEE,qBAAA;EACA,WhDo8BmC;EgDn8BnC,YhDm8BmC;EgDl8BnC,mCAAA;ArD61LF;;AqD31LA;EACE,yDAAA;ArD81LF;;AqD51LA;EACE,yDAAA;ArD+1LF;;AqDt1LA;EACE,kBAAA;EACA,QAAA;EACA,SAAA;EACA,OAAA;EACA,WAAA;EACA,aAAA;EACA,uBAAA;EACA,eAAA;EAEA,iBhD05BmC;EgDz5BnC,gBhDy5BmC;EgDx5BnC,gBAAA;ArDw1LF;AqDt1LE;EACE,uBAAA;EACA,cAAA;EACA,WhDw5BiC;EgDv5BjC,WhDw5BiC;EgDv5BjC,iBhDy5BiC;EgDx5BjC,gBhDw5BiC;EgDv5BjC,mBAAA;EACA,eAAA;EACA,sBlDvJI;EkDwJJ,4BAAA;EAEA,kCAAA;EACA,qCAAA;EACA,YAAA;EhC5JE,6BgC6JF;ArDu1LJ;AqBh/LM;EgC0IJ;IhCzIM,gBAAA;ErBm/LN;AACF;AqDz1LE;EACE,UAAA;ArD21LJ;;AqDl1LA;EACE,kBAAA;EACA,UAAA;EACA,YAAA;EACA,SAAA;EACA,WAAA;EACA,iBAAA;EACA,oBAAA;EACA,WlDlLM;EkDmLN,kBAAA;ArDq1LF;;AuDthMA;EAAqB,mCAAA;AvD0hMrB;;AuDzhMA;EAAqB,8BAAA;AvD6hMrB;;AuD5hMA;EAAqB,iCAAA;AvDgiMrB;;AuD/hMA;EAAqB,iCAAA;AvDmiMrB;;AuDliMA;EAAqB,sCAAA;AvDsiMrB;;AuDriMA;EAAqB,mCAAA;AvDyiMrB;;AwD9iME;EACE,oCAAA;AxDijMJ;;AMpiME;;;EkDRI,8EAAA;AxDkjMN;;AwDxjME;EACE,oCAAA;AxD2jMJ;;AM9iME;;;EkDRI,gFAAA;AxD4jMN;;AwDlkME;EACE,oCAAA;AxDqkMJ;;AMxjME;;;EkDRI,8EAAA;AxDskMN;;AwD5kME;EACE,oCAAA;AxD+kMJ;;AMlkME;;;EkDRI,8EAAA;AxDglMN;;AwDtlME;EACE,oCAAA;AxDylMJ;;AM5kME;;;EkDRI,qEAAA;AxD0lMN;;AwDhmME;EACE,oCAAA;AxDmmMJ;;AMtlME;;;EkDRI,8EAAA;AxDomMN;;AwD1mME;EACE,oCAAA;AxD6mMJ;;AMhmME;;;EkDRI,uEAAA;AxD8mMN;;AwDpnME;EACE,oCAAA;AxDunMJ;;AM1mME;;;EkDRI,oEAAA;AxDwnMN;;AwD9nME;EACE,oCAAA;AxDioMJ;;AMpnME;;;EkDRI,yDAAA;AxDkoMN;;AwDxoME;EACE,iCAAA;AxD2oMJ;;AM9nME;;;EkDRI,qDAAA;AxD4oMN;;AwDlpME;EACE,iCAAA;AxDqpMJ;;AMxoME;;;EkDRI,qDAAA;AxDspMN;;AwD5pME;EACE,kCAAA;AxD+pMJ;;AMlpME;;;EkDRI,kCAAA;AxDgqMN;;AyD5pMA;EACE,iCAAA;AzD+pMF;;AyD5pMA;EACE,wCAAA;AzD+pMF;;A0D1qMA;EAAkB,oCAAA;A1D8qMlB;;A0D7qMA;EAAkB,wCAAA;A1DirMlB;;A0DhrMA;EAAkB,0CAAA;A1DorMlB;;A0DnrMA;EAAkB,2CAAA;A1DurMlB;;A0DtrMA;EAAkB,yCAAA;A1D0rMlB;;A0DxrMA;EAAmB,oBAAA;A1D4rMnB;;A0D3rMA;EAAmB,wBAAA;A1D+rMnB;;A0D9rMA;EAAmB,0BAAA;A1DksMnB;;A0DjsMA;EAAmB,2BAAA;A1DqsMnB;;A0DpsMA;EAAmB,yBAAA;A1DwsMnB;;A0DrsME;EACE,gCAAA;A1DwsMJ;;A0DzsME;EACE,gCAAA;A1D4sMJ;;A0D7sME;EACE,gCAAA;A1DgtMJ;;A0DjtME;EACE,gCAAA;A1DotMJ;;A0DrtME;EACE,gCAAA;A1DwtMJ;;A0DztME;EACE,gCAAA;A1D4tMJ;;A0D7tME;EACE,gCAAA;A1DguMJ;;A0DjuME;EACE,gCAAA;A1DouMJ;;A0DruME;EACE,gCAAA;A1DwuMJ;;A0DzuME;EACE,6BAAA;A1D4uMJ;;A0D7uME;EACE,6BAAA;A1DgvMJ;;A0DjvME;EACE,8BAAA;A1DovMJ;;A0DhvMA;EACE,6BAAA;A1DmvMF;;A0D5uMA;EACE,iCAAA;A1D+uMF;;A0D5uMA;EACE,kCAAA;A1D+uMF;;A0D5uMA;EACE,2CAAA;EACA,4CAAA;A1D+uMF;;A0D5uMA;EACE,4CAAA;EACA,+CAAA;A1D+uMF;;A0D5uMA;EACE,+CAAA;EACA,8CAAA;A1D+uMF;;A0D5uMA;EACE,2CAAA;EACA,8CAAA;A1D+uMF;;A0D5uMA;EACE,mCAAA;A1D+uMF;;A0D5uMA;EACE,6BAAA;A1D+uMF;;A0D5uMA;EACE,+BAAA;A1D+uMF;;A0D5uMA;EACE,2BAAA;A1D+uMF;;AsDvzME;EACE,cAAA;EACA,WAAA;EACA,WAAA;AtD0zMJ;;A2DnzMM;EAAwB,wBAAA;A3DuzM9B;;A2DvzMM;EAAwB,0BAAA;A3D2zM9B;;A2D3zMM;EAAwB,gCAAA;A3D+zM9B;;A2D/zMM;EAAwB,yBAAA;A3Dm0M9B;;A2Dn0MM;EAAwB,yBAAA;A3Du0M9B;;A2Dv0MM;EAAwB,6BAAA;A3D20M9B;;A2D30MM;EAAwB,8BAAA;A3D+0M9B;;A2D/0MM;EAAwB,wBAAA;A3Dm1M9B;;A2Dn1MM;EAAwB,+BAAA;A3Du1M9B;;AgBtyMI;E2CjDE;IAAwB,wBAAA;E3D41M5B;E2D51MI;IAAwB,0BAAA;E3D+1M5B;E2D/1MI;IAAwB,gCAAA;E3Dk2M5B;E2Dl2MI;IAAwB,yBAAA;E3Dq2M5B;E2Dr2MI;IAAwB,yBAAA;E3Dw2M5B;E2Dx2MI;IAAwB,6BAAA;E3D22M5B;E2D32MI;IAAwB,8BAAA;E3D82M5B;E2D92MI;IAAwB,wBAAA;E3Di3M5B;E2Dj3MI;IAAwB,+BAAA;E3Do3M5B;AACF;AgBp0MI;E2CjDE;IAAwB,wBAAA;E3Dy3M5B;E2Dz3MI;IAAwB,0BAAA;E3D43M5B;E2D53MI;IAAwB,gCAAA;E3D+3M5B;E2D/3MI;IAAwB,yBAAA;E3Dk4M5B;E2Dl4MI;IAAwB,yBAAA;E3Dq4M5B;E2Dr4MI;IAAwB,6BAAA;E3Dw4M5B;E2Dx4MI;IAAwB,8BAAA;E3D24M5B;E2D34MI;IAAwB,wBAAA;E3D84M5B;E2D94MI;IAAwB,+BAAA;E3Di5M5B;AACF;AgBj2MI;E2CjDE;IAAwB,wBAAA;E3Ds5M5B;E2Dt5MI;IAAwB,0BAAA;E3Dy5M5B;E2Dz5MI;IAAwB,gCAAA;E3D45M5B;E2D55MI;IAAwB,yBAAA;E3D+5M5B;E2D/5MI;IAAwB,yBAAA;E3Dk6M5B;E2Dl6MI;IAAwB,6BAAA;E3Dq6M5B;E2Dr6MI;IAAwB,8BAAA;E3Dw6M5B;E2Dx6MI;IAAwB,wBAAA;E3D26M5B;E2D36MI;IAAwB,+BAAA;E3D86M5B;AACF;AgB93MI;E2CjDE;IAAwB,wBAAA;E3Dm7M5B;E2Dn7MI;IAAwB,0BAAA;E3Ds7M5B;E2Dt7MI;IAAwB,gCAAA;E3Dy7M5B;E2Dz7MI;IAAwB,yBAAA;E3D47M5B;E2D57MI;IAAwB,yBAAA;E3D+7M5B;E2D/7MI;IAAwB,6BAAA;E3Dk8M5B;E2Dl8MI;IAAwB,8BAAA;E3Dq8M5B;E2Dr8MI;IAAwB,wBAAA;E3Dw8M5B;E2Dx8MI;IAAwB,+BAAA;E3D28M5B;AACF;A2Dl8MA;EAEI;IAAqB,wBAAA;E3Do8MvB;E2Dp8ME;IAAqB,0BAAA;E3Du8MvB;E2Dv8ME;IAAqB,gCAAA;E3D08MvB;E2D18ME;IAAqB,yBAAA;E3D68MvB;E2D78ME;IAAqB,yBAAA;E3Dg9MvB;E2Dh9ME;IAAqB,6BAAA;E3Dm9MvB;E2Dn9ME;IAAqB,8BAAA;E3Ds9MvB;E2Dt9ME;IAAqB,wBAAA;E3Dy9MvB;E2Dz9ME;IAAqB,+BAAA;E3D49MvB;AACF;A4Dl/MA;EACE,kBAAA;EACA,cAAA;EACA,WAAA;EACA,UAAA;EACA,gBAAA;A5Do/MF;A4Dl/ME;EACE,cAAA;EACA,WAAA;A5Do/MJ;A4Dj/ME;;;;;EAKE,kBAAA;EACA,MAAA;EACA,SAAA;EACA,OAAA;EACA,WAAA;EACA,YAAA;EACA,SAAA;A5Dm/MJ;;A4D1+MI;EACE,2BAAA;A5D6+MN;;A4D9+MI;EACE,mBAAA;A5Di/MN;;A4Dl/MI;EACE,gBAAA;A5Dq/MN;;A4Dt/MI;EACE,iBAAA;A5Dy/MN;;A6DlhNI;EAAgC,8BAAA;A7DshNpC;;A6DrhNI;EAAgC,iCAAA;A7DyhNpC;;A6DxhNI;EAAgC,sCAAA;A7D4hNpC;;A6D3hNI;EAAgC,yCAAA;A7D+hNpC;;A6D7hNI;EAA8B,0BAAA;A7DiiNlC;;A6DhiNI;EAA8B,4BAAA;A7DoiNlC;;A6DniNI;EAA8B,kCAAA;A7DuiNlC;;A6DtiNI;EAA8B,yBAAA;A7D0iNlC;;A6DziNI;EAA8B,uBAAA;A7D6iNlC;;A6D5iNI;EAA8B,uBAAA;A7DgjNlC;;A6D/iNI;EAA8B,yBAAA;A7DmjNlC;;A6DljNI;EAA8B,yBAAA;A7DsjNlC;;A6DpjNI;EAAoC,sCAAA;A7DwjNxC;;A6DvjNI;EAAoC,oCAAA;A7D2jNxC;;A6D1jNI;EAAoC,kCAAA;A7D8jNxC;;A6D7jNI;EAAoC,yCAAA;A7DikNxC;;A6DhkNI;EAAoC,wCAAA;A7DokNxC;;A6DlkNI;EAAiC,kCAAA;A7DskNrC;;A6DrkNI;EAAiC,gCAAA;A7DykNrC;;A6DxkNI;EAAiC,8BAAA;A7D4kNrC;;A6D3kNI;EAAiC,gCAAA;A7D+kNrC;;A6D9kNI;EAAiC,+BAAA;A7DklNrC;;A6DhlNI;EAAkC,oCAAA;A7DolNtC;;A6DnlNI;EAAkC,kCAAA;A7DulNtC;;A6DtlNI;EAAkC,gCAAA;A7D0lNtC;;A6DzlNI;EAAkC,uCAAA;A7D6lNtC;;A6D5lNI;EAAkC,sCAAA;A7DgmNtC;;A6D/lNI;EAAkC,iCAAA;A7DmmNtC;;A6DjmNI;EAAgC,2BAAA;A7DqmNpC;;A6DpmNI;EAAgC,iCAAA;A7DwmNpC;;A6DvmNI;EAAgC,+BAAA;A7D2mNpC;;A6D1mNI;EAAgC,6BAAA;A7D8mNpC;;A6D7mNI;EAAgC,+BAAA;A7DinNpC;;A6DhnNI;EAAgC,8BAAA;A7DonNpC;;AgBxmNI;E6ClDA;IAAgC,8BAAA;E7D+pNlC;E6D9pNE;IAAgC,iCAAA;E7DiqNlC;E6DhqNE;IAAgC,sCAAA;E7DmqNlC;E6DlqNE;IAAgC,yCAAA;E7DqqNlC;E6DnqNE;IAA8B,0BAAA;E7DsqNhC;E6DrqNE;IAA8B,4BAAA;E7DwqNhC;E6DvqNE;IAA8B,kCAAA;E7D0qNhC;E6DzqNE;IAA8B,yBAAA;E7D4qNhC;E6D3qNE;IAA8B,uBAAA;E7D8qNhC;E6D7qNE;IAA8B,uBAAA;E7DgrNhC;E6D/qNE;IAA8B,yBAAA;E7DkrNhC;E6DjrNE;IAA8B,yBAAA;E7DorNhC;E6DlrNE;IAAoC,sCAAA;E7DqrNtC;E6DprNE;IAAoC,oCAAA;E7DurNtC;E6DtrNE;IAAoC,kCAAA;E7DyrNtC;E6DxrNE;IAAoC,yCAAA;E7D2rNtC;E6D1rNE;IAAoC,wCAAA;E7D6rNtC;E6D3rNE;IAAiC,kCAAA;E7D8rNnC;E6D7rNE;IAAiC,gCAAA;E7DgsNnC;E6D/rNE;IAAiC,8BAAA;E7DksNnC;E6DjsNE;IAAiC,gCAAA;E7DosNnC;E6DnsNE;IAAiC,+BAAA;E7DssNnC;E6DpsNE;IAAkC,oCAAA;E7DusNpC;E6DtsNE;IAAkC,kCAAA;E7DysNpC;E6DxsNE;IAAkC,gCAAA;E7D2sNpC;E6D1sNE;IAAkC,uCAAA;E7D6sNpC;E6D5sNE;IAAkC,sCAAA;E7D+sNpC;E6D9sNE;IAAkC,iCAAA;E7DitNpC;E6D/sNE;IAAgC,2BAAA;E7DktNlC;E6DjtNE;IAAgC,iCAAA;E7DotNlC;E6DntNE;IAAgC,+BAAA;E7DstNlC;E6DrtNE;IAAgC,6BAAA;E7DwtNlC;E6DvtNE;IAAgC,+BAAA;E7D0tNlC;E6DztNE;IAAgC,8BAAA;E7D4tNlC;AACF;AgBjtNI;E6ClDA;IAAgC,8BAAA;E7DuwNlC;E6DtwNE;IAAgC,iCAAA;E7DywNlC;E6DxwNE;IAAgC,sCAAA;E7D2wNlC;E6D1wNE;IAAgC,yCAAA;E7D6wNlC;E6D3wNE;IAA8B,0BAAA;E7D8wNhC;E6D7wNE;IAA8B,4BAAA;E7DgxNhC;E6D/wNE;IAA8B,kCAAA;E7DkxNhC;E6DjxNE;IAA8B,yBAAA;E7DoxNhC;E6DnxNE;IAA8B,uBAAA;E7DsxNhC;E6DrxNE;IAA8B,uBAAA;E7DwxNhC;E6DvxNE;IAA8B,yBAAA;E7D0xNhC;E6DzxNE;IAA8B,yBAAA;E7D4xNhC;E6D1xNE;IAAoC,sCAAA;E7D6xNtC;E6D5xNE;IAAoC,oCAAA;E7D+xNtC;E6D9xNE;IAAoC,kCAAA;E7DiyNtC;E6DhyNE;IAAoC,yCAAA;E7DmyNtC;E6DlyNE;IAAoC,wCAAA;E7DqyNtC;E6DnyNE;IAAiC,kCAAA;E7DsyNnC;E6DryNE;IAAiC,gCAAA;E7DwyNnC;E6DvyNE;IAAiC,8BAAA;E7D0yNnC;E6DzyNE;IAAiC,gCAAA;E7D4yNnC;E6D3yNE;IAAiC,+BAAA;E7D8yNnC;E6D5yNE;IAAkC,oCAAA;E7D+yNpC;E6D9yNE;IAAkC,kCAAA;E7DizNpC;E6DhzNE;IAAkC,gCAAA;E7DmzNpC;E6DlzNE;IAAkC,uCAAA;E7DqzNpC;E6DpzNE;IAAkC,sCAAA;E7DuzNpC;E6DtzNE;IAAkC,iCAAA;E7DyzNpC;E6DvzNE;IAAgC,2BAAA;E7D0zNlC;E6DzzNE;IAAgC,iCAAA;E7D4zNlC;E6D3zNE;IAAgC,+BAAA;E7D8zNlC;E6D7zNE;IAAgC,6BAAA;E7Dg0NlC;E6D/zNE;IAAgC,+BAAA;E7Dk0NlC;E6Dj0NE;IAAgC,8BAAA;E7Do0NlC;AACF;AgBzzNI;E6ClDA;IAAgC,8BAAA;E7D+2NlC;E6D92NE;IAAgC,iCAAA;E7Di3NlC;E6Dh3NE;IAAgC,sCAAA;E7Dm3NlC;E6Dl3NE;IAAgC,yCAAA;E7Dq3NlC;E6Dn3NE;IAA8B,0BAAA;E7Ds3NhC;E6Dr3NE;IAA8B,4BAAA;E7Dw3NhC;E6Dv3NE;IAA8B,kCAAA;E7D03NhC;E6Dz3NE;IAA8B,yBAAA;E7D43NhC;E6D33NE;IAA8B,uBAAA;E7D83NhC;E6D73NE;IAA8B,uBAAA;E7Dg4NhC;E6D/3NE;IAA8B,yBAAA;E7Dk4NhC;E6Dj4NE;IAA8B,yBAAA;E7Do4NhC;E6Dl4NE;IAAoC,sCAAA;E7Dq4NtC;E6Dp4NE;IAAoC,oCAAA;E7Du4NtC;E6Dt4NE;IAAoC,kCAAA;E7Dy4NtC;E6Dx4NE;IAAoC,yCAAA;E7D24NtC;E6D14NE;IAAoC,wCAAA;E7D64NtC;E6D34NE;IAAiC,kCAAA;E7D84NnC;E6D74NE;IAAiC,gCAAA;E7Dg5NnC;E6D/4NE;IAAiC,8BAAA;E7Dk5NnC;E6Dj5NE;IAAiC,gCAAA;E7Do5NnC;E6Dn5NE;IAAiC,+BAAA;E7Ds5NnC;E6Dp5NE;IAAkC,oCAAA;E7Du5NpC;E6Dt5NE;IAAkC,kCAAA;E7Dy5NpC;E6Dx5NE;IAAkC,gCAAA;E7D25NpC;E6D15NE;IAAkC,uCAAA;E7D65NpC;E6D55NE;IAAkC,sCAAA;E7D+5NpC;E6D95NE;IAAkC,iCAAA;E7Di6NpC;E6D/5NE;IAAgC,2BAAA;E7Dk6NlC;E6Dj6NE;IAAgC,iCAAA;E7Do6NlC;E6Dn6NE;IAAgC,+BAAA;E7Ds6NlC;E6Dr6NE;IAAgC,6BAAA;E7Dw6NlC;E6Dv6NE;IAAgC,+BAAA;E7D06NlC;E6Dz6NE;IAAgC,8BAAA;E7D46NlC;AACF;AgBj6NI;E6ClDA;IAAgC,8BAAA;E7Du9NlC;E6Dt9NE;IAAgC,iCAAA;E7Dy9NlC;E6Dx9NE;IAAgC,sCAAA;E7D29NlC;E6D19NE;IAAgC,yCAAA;E7D69NlC;E6D39NE;IAA8B,0BAAA;E7D89NhC;E6D79NE;IAA8B,4BAAA;E7Dg+NhC;E6D/9NE;IAA8B,kCAAA;E7Dk+NhC;E6Dj+NE;IAA8B,yBAAA;E7Do+NhC;E6Dn+NE;IAA8B,uBAAA;E7Ds+NhC;E6Dr+NE;IAA8B,uBAAA;E7Dw+NhC;E6Dv+NE;IAA8B,yBAAA;E7D0+NhC;E6Dz+NE;IAA8B,yBAAA;E7D4+NhC;E6D1+NE;IAAoC,sCAAA;E7D6+NtC;E6D5+NE;IAAoC,oCAAA;E7D++NtC;E6D9+NE;IAAoC,kCAAA;E7Di/NtC;E6Dh/NE;IAAoC,yCAAA;E7Dm/NtC;E6Dl/NE;IAAoC,wCAAA;E7Dq/NtC;E6Dn/NE;IAAiC,kCAAA;E7Ds/NnC;E6Dr/NE;IAAiC,gCAAA;E7Dw/NnC;E6Dv/NE;IAAiC,8BAAA;E7D0/NnC;E6Dz/NE;IAAiC,gCAAA;E7D4/NnC;E6D3/NE;IAAiC,+BAAA;E7D8/NnC;E6D5/NE;IAAkC,oCAAA;E7D+/NpC;E6D9/NE;IAAkC,kCAAA;E7DigOpC;E6DhgOE;IAAkC,gCAAA;E7DmgOpC;E6DlgOE;IAAkC,uCAAA;E7DqgOpC;E6DpgOE;IAAkC,sCAAA;E7DugOpC;E6DtgOE;IAAkC,iCAAA;E7DygOpC;E6DvgOE;IAAgC,2BAAA;E7D0gOlC;E6DzgOE;IAAgC,iCAAA;E7D4gOlC;E6D3gOE;IAAgC,+BAAA;E7D8gOlC;E6D7gOE;IAAgC,6BAAA;E7DghOlC;E6D/gOE;IAAgC,+BAAA;E7DkhOlC;E6DjhOE;IAAgC,8BAAA;E7DohOlC;AACF;A8D/jOI;EAAwB,sBAAA;A9DkkO5B;;A8DjkOI;EAAwB,uBAAA;A9DqkO5B;;A8DpkOI;EAAwB,sBAAA;A9DwkO5B;;AgBphOI;E8CtDA;IAAwB,sBAAA;E9D+kO1B;E8D9kOE;IAAwB,uBAAA;E9DilO1B;E8DhlOE;IAAwB,sBAAA;E9DmlO1B;AACF;AgBhiOI;E8CtDA;IAAwB,sBAAA;E9D0lO1B;E8DzlOE;IAAwB,uBAAA;E9D4lO1B;E8D3lOE;IAAwB,sBAAA;E9D8lO1B;AACF;AgB3iOI;E8CtDA;IAAwB,sBAAA;E9DqmO1B;E8DpmOE;IAAwB,uBAAA;E9DumO1B;E8DtmOE;IAAwB,sBAAA;E9DymO1B;AACF;AgBtjOI;E8CtDA;IAAwB,sBAAA;E9DgnO1B;E8D/mOE;IAAwB,uBAAA;E9DknO1B;E8DjnOE;IAAwB,sBAAA;E9DonO1B;AACF;A+D1nOE;EAAyB,mCAAA;UAAA,2BAAA;A/D6nO3B;;A+D7nOE;EAAyB,oCAAA;UAAA,4BAAA;A/DioO3B;;A+DjoOE;EAAyB,oCAAA;UAAA,4BAAA;A/DqoO3B;;AgEroOE;EAAsB,yBAAA;AhEyoOxB;;AgEzoOE;EAAsB,2BAAA;AhE6oOxB;;AiE5oOE;EAAyB,2BAAA;AjEgpO3B;;AiEhpOE;EAAyB,6BAAA;AjEopO3B;;AiEppOE;EAAyB,6BAAA;AjEwpO3B;;AiExpOE;EAAyB,0BAAA;AjE4pO3B;;AiE5pOE;EAAyB,2BAAA;AjEgqO3B;;AiE3pOA;EACE,eAAA;EACA,MAAA;EACA,QAAA;EACA,OAAA;EACA,a5DgqBkC;AL8/MpC;;AiE3pOA;EACE,eAAA;EACA,QAAA;EACA,SAAA;EACA,OAAA;EACA,a5DwpBkC;ALsgNpC;;AiE1pOE;EADF;IAEI,gBAAA;IACA,MAAA;IACA,a5DgpBgC;EL8gNlC;AACF;;AkExrOA;ECEE,kBAAA;EACA,UAAA;EACA,WAAA;EACA,UAAA;EACA,YAAA;EACA,gBAAA;EACA,sBAAA;EACA,mBAAA;EACA,SAAA;AnE0rOF;;AmEhrOE;EAEE,gBAAA;EACA,WAAA;EACA,YAAA;EACA,iBAAA;EACA,UAAA;EACA,mBAAA;AnEkrOJ;;AoE/sOA;EAAa,4DAAA;ApEmtOb;;AoEltOA;EAAU,2DAAA;ApEstOV;;AoErtOA;EAAa,0DAAA;ApEytOb;;AoExtOA;EAAe,2BAAA;ApE4tOf;;AqE3tOI;EAAuB,qBAAA;ArE+tO3B;;AqE/tOI;EAAuB,qBAAA;ArEmuO3B;;AqEnuOI;EAAuB,qBAAA;ArEuuO3B;;AqEvuOI;EAAuB,sBAAA;ArE2uO3B;;AqE3uOI;EAAuB,sBAAA;ArE+uO3B;;AqE/uOI;EAAuB,sBAAA;ArEmvO3B;;AqEnvOI;EAAuB,sBAAA;ArEuvO3B;;AqEvvOI;EAAuB,sBAAA;ArE2vO3B;;AqE3vOI;EAAuB,uBAAA;ArE+vO3B;;AqE/vOI;EAAuB,uBAAA;ArEmwO3B;;AqE/vOA;EAAU,0BAAA;ArEmwOV;;AqElwOA;EAAU,2BAAA;ArEswOV;;AqElwOA;EAAc,2BAAA;ArEswOd;;AqErwOA;EAAc,4BAAA;ArEywOd;;AqEvwOA;EAAU,uBAAA;ArE2wOV;;AqE1wOA;EAAU,wBAAA;ArE8wOV;;AsEvxOQ;EAAgC,oBAAA;AtE2xOxC;;AsE1xOQ;;EAEE,wBAAA;AtE6xOV;;AsE3xOQ;;EAEE,0BAAA;AtE8xOV;;AsE5xOQ;;EAEE,2BAAA;AtE+xOV;;AsE7xOQ;;EAEE,yBAAA;AtEgyOV;;AsE/yOQ;EAAgC,0BAAA;AtEmzOxC;;AsElzOQ;;EAEE,8BAAA;AtEqzOV;;AsEnzOQ;;EAEE,gCAAA;AtEszOV;;AsEpzOQ;;EAEE,iCAAA;AtEuzOV;;AsErzOQ;;EAEE,+BAAA;AtEwzOV;;AsEv0OQ;EAAgC,yBAAA;AtE20OxC;;AsE10OQ;;EAEE,6BAAA;AtE60OV;;AsE30OQ;;EAEE,+BAAA;AtE80OV;;AsE50OQ;;EAEE,gCAAA;AtE+0OV;;AsE70OQ;;EAEE,8BAAA;AtEg1OV;;AsE/1OQ;EAAgC,uBAAA;AtEm2OxC;;AsEl2OQ;;EAEE,2BAAA;AtEq2OV;;AsEn2OQ;;EAEE,6BAAA;AtEs2OV;;AsEp2OQ;;EAEE,8BAAA;AtEu2OV;;AsEr2OQ;;EAEE,4BAAA;AtEw2OV;;AsEv3OQ;EAAgC,yBAAA;AtE23OxC;;AsE13OQ;;EAEE,6BAAA;AtE63OV;;AsE33OQ;;EAEE,+BAAA;AtE83OV;;AsE53OQ;;EAEE,gCAAA;AtE+3OV;;AsE73OQ;;EAEE,8BAAA;AtEg4OV;;AsE/4OQ;EAAgC,uBAAA;AtEm5OxC;;AsEl5OQ;;EAEE,2BAAA;AtEq5OV;;AsEn5OQ;;EAEE,6BAAA;AtEs5OV;;AsEp5OQ;;EAEE,8BAAA;AtEu5OV;;AsEr5OQ;;EAEE,4BAAA;AtEw5OV;;AsEv6OQ;EAAgC,yBAAA;AtE26OxC;;AsE16OQ;;EAEE,6BAAA;AtE66OV;;AsE36OQ;;EAEE,+BAAA;AtE86OV;;AsE56OQ;;EAEE,gCAAA;AtE+6OV;;AsE76OQ;;EAEE,8BAAA;AtEg7OV;;AsE/7OQ;EAAgC,wBAAA;AtEm8OxC;;AsEl8OQ;;EAEE,4BAAA;AtEq8OV;;AsEn8OQ;;EAEE,8BAAA;AtEs8OV;;AsEp8OQ;;EAEE,+BAAA;AtEu8OV;;AsEr8OQ;;EAEE,6BAAA;AtEw8OV;;AsEv9OQ;EAAgC,wBAAA;AtE29OxC;;AsE19OQ;;EAEE,4BAAA;AtE69OV;;AsE39OQ;;EAEE,8BAAA;AtE89OV;;AsE59OQ;;EAEE,+BAAA;AtE+9OV;;AsE79OQ;;EAEE,6BAAA;AtEg+OV;;AsE/+OQ;EAAgC,0BAAA;AtEm/OxC;;AsEl/OQ;;EAEE,8BAAA;AtEq/OV;;AsEn/OQ;;EAEE,gCAAA;AtEs/OV;;AsEp/OQ;;EAEE,iCAAA;AtEu/OV;;AsEr/OQ;;EAEE,+BAAA;AtEw/OV;;AsEvgPQ;EAAgC,wBAAA;AtE2gPxC;;AsE1gPQ;;EAEE,4BAAA;AtE6gPV;;AsE3gPQ;;EAEE,8BAAA;AtE8gPV;;AsE5gPQ;;EAEE,+BAAA;AtE+gPV;;AsE7gPQ;;EAEE,6BAAA;AtEghPV;;AsE/hPQ;EAAgC,0BAAA;AtEmiPxC;;AsEliPQ;;EAEE,8BAAA;AtEqiPV;;AsEniPQ;;EAEE,gCAAA;AtEsiPV;;AsEpiPQ;;EAEE,iCAAA;AtEuiPV;;AsEriPQ;;EAEE,+BAAA;AtEwiPV;;AsEvjPQ;EAAgC,wBAAA;AtE2jPxC;;AsE1jPQ;;EAEE,4BAAA;AtE6jPV;;AsE3jPQ;;EAEE,8BAAA;AtE8jPV;;AsE5jPQ;;EAEE,+BAAA;AtE+jPV;;AsE7jPQ;;EAEE,6BAAA;AtEgkPV;;AsE/kPQ;EAAgC,0BAAA;AtEmlPxC;;AsEllPQ;;EAEE,8BAAA;AtEqlPV;;AsEnlPQ;;EAEE,gCAAA;AtEslPV;;AsEplPQ;;EAEE,iCAAA;AtEulPV;;AsErlPQ;;EAEE,+BAAA;AtEwlPV;;AsEvmPQ;EAAgC,2BAAA;AtE2mPxC;;AsE1mPQ;;EAEE,+BAAA;AtE6mPV;;AsE3mPQ;;EAEE,iCAAA;AtE8mPV;;AsE5mPQ;;EAEE,kCAAA;AtE+mPV;;AsE7mPQ;;EAEE,gCAAA;AtEgnPV;;AsE/nPQ;EAAgC,yBAAA;AtEmoPxC;;AsEloPQ;;EAEE,6BAAA;AtEqoPV;;AsEnoPQ;;EAEE,+BAAA;AtEsoPV;;AsEpoPQ;;EAEE,gCAAA;AtEuoPV;;AsEroPQ;;EAEE,8BAAA;AtEwoPV;;AsEvpPQ;EAAgC,uBAAA;AtE2pPxC;;AsE1pPQ;;EAEE,2BAAA;AtE6pPV;;AsE3pPQ;;EAEE,6BAAA;AtE8pPV;;AsE5pPQ;;EAEE,8BAAA;AtE+pPV;;AsE7pPQ;;EAEE,4BAAA;AtEgqPV;;AsE/qPQ;EAAgC,uBAAA;AtEmrPxC;;AsElrPQ;;EAEE,2BAAA;AtEqrPV;;AsEnrPQ;;EAEE,6BAAA;AtEsrPV;;AsEprPQ;;EAEE,8BAAA;AtEurPV;;AsErrPQ;;EAEE,4BAAA;AtEwrPV;;AsEvsPQ;EAAgC,wBAAA;AtE2sPxC;;AsE1sPQ;;EAEE,4BAAA;AtE6sPV;;AsE3sPQ;;EAEE,8BAAA;AtE8sPV;;AsE5sPQ;;EAEE,+BAAA;AtE+sPV;;AsE7sPQ;;EAEE,6BAAA;AtEgtPV;;AsE/tPQ;EAAgC,qBAAA;AtEmuPxC;;AsEluPQ;;EAEE,yBAAA;AtEquPV;;AsEnuPQ;;EAEE,2BAAA;AtEsuPV;;AsEpuPQ;;EAEE,4BAAA;AtEuuPV;;AsEruPQ;;EAEE,0BAAA;AtEwuPV;;AsEvvPQ;EAAgC,2BAAA;AtE2vPxC;;AsE1vPQ;;EAEE,+BAAA;AtE6vPV;;AsE3vPQ;;EAEE,iCAAA;AtE8vPV;;AsE5vPQ;;EAEE,kCAAA;AtE+vPV;;AsE7vPQ;;EAEE,gCAAA;AtEgwPV;;AsE/wPQ;EAAgC,0BAAA;AtEmxPxC;;AsElxPQ;;EAEE,8BAAA;AtEqxPV;;AsEnxPQ;;EAEE,gCAAA;AtEsxPV;;AsEpxPQ;;EAEE,iCAAA;AtEuxPV;;AsErxPQ;;EAEE,+BAAA;AtEwxPV;;AsEvyPQ;EAAgC,wBAAA;AtE2yPxC;;AsE1yPQ;;EAEE,4BAAA;AtE6yPV;;AsE3yPQ;;EAEE,8BAAA;AtE8yPV;;AsE5yPQ;;EAEE,+BAAA;AtE+yPV;;AsE7yPQ;;EAEE,6BAAA;AtEgzPV;;AsE/zPQ;EAAgC,0BAAA;AtEm0PxC;;AsEl0PQ;;EAEE,8BAAA;AtEq0PV;;AsEn0PQ;;EAEE,gCAAA;AtEs0PV;;AsEp0PQ;;EAEE,iCAAA;AtEu0PV;;AsEr0PQ;;EAEE,+BAAA;AtEw0PV;;AsEv1PQ;EAAgC,wBAAA;AtE21PxC;;AsE11PQ;;EAEE,4BAAA;AtE61PV;;AsE31PQ;;EAEE,8BAAA;AtE81PV;;AsE51PQ;;EAEE,+BAAA;AtE+1PV;;AsE71PQ;;EAEE,6BAAA;AtEg2PV;;AsE/2PQ;EAAgC,0BAAA;AtEm3PxC;;AsEl3PQ;;EAEE,8BAAA;AtEq3PV;;AsEn3PQ;;EAEE,gCAAA;AtEs3PV;;AsEp3PQ;;EAEE,iCAAA;AtEu3PV;;AsEr3PQ;;EAEE,+BAAA;AtEw3PV;;AsEv4PQ;EAAgC,yBAAA;AtE24PxC;;AsE14PQ;;EAEE,6BAAA;AtE64PV;;AsE34PQ;;EAEE,+BAAA;AtE84PV;;AsE54PQ;;EAEE,gCAAA;AtE+4PV;;AsE74PQ;;EAEE,8BAAA;AtEg5PV;;AsE/5PQ;EAAgC,yBAAA;AtEm6PxC;;AsEl6PQ;;EAEE,6BAAA;AtEq6PV;;AsEn6PQ;;EAEE,+BAAA;AtEs6PV;;AsEp6PQ;;EAEE,gCAAA;AtEu6PV;;AsEr6PQ;;EAEE,8BAAA;AtEw6PV;;AsEv7PQ;EAAgC,2BAAA;AtE27PxC;;AsE17PQ;;EAEE,+BAAA;AtE67PV;;AsE37PQ;;EAEE,iCAAA;AtE87PV;;AsE57PQ;;EAEE,kCAAA;AtE+7PV;;AsE77PQ;;EAEE,gCAAA;AtEg8PV;;AsE/8PQ;EAAgC,yBAAA;AtEm9PxC;;AsEl9PQ;;EAEE,6BAAA;AtEq9PV;;AsEn9PQ;;EAEE,+BAAA;AtEs9PV;;AsEp9PQ;;EAEE,gCAAA;AtEu9PV;;AsEr9PQ;;EAEE,8BAAA;AtEw9PV;;AsEv+PQ;EAAgC,2BAAA;AtE2+PxC;;AsE1+PQ;;EAEE,+BAAA;AtE6+PV;;AsE3+PQ;;EAEE,iCAAA;AtE8+PV;;AsE5+PQ;;EAEE,kCAAA;AtE++PV;;AsE7+PQ;;EAEE,gCAAA;AtEg/PV;;AsE//PQ;EAAgC,yBAAA;AtEmgQxC;;AsElgQQ;;EAEE,6BAAA;AtEqgQV;;AsEngQQ;;EAEE,+BAAA;AtEsgQV;;AsEpgQQ;;EAEE,gCAAA;AtEugQV;;AsErgQQ;;EAEE,8BAAA;AtEwgQV;;AsEvhQQ;EAAgC,2BAAA;AtE2hQxC;;AsE1hQQ;;EAEE,+BAAA;AtE6hQV;;AsE3hQQ;;EAEE,iCAAA;AtE8hQV;;AsE5hQQ;;EAEE,kCAAA;AtE+hQV;;AsE7hQQ;;EAEE,gCAAA;AtEgiQV;;AsE/iQQ;EAAgC,4BAAA;AtEmjQxC;;AsEljQQ;;EAEE,gCAAA;AtEqjQV;;AsEnjQQ;;EAEE,kCAAA;AtEsjQV;;AsEpjQQ;;EAEE,mCAAA;AtEujQV;;AsErjQQ;;EAEE,iCAAA;AtEwjQV;;AsEvkQQ;EAAgC,0BAAA;AtE2kQxC;;AsE1kQQ;;EAEE,8BAAA;AtE6kQV;;AsE3kQQ;;EAEE,gCAAA;AtE8kQV;;AsE5kQQ;;EAEE,iCAAA;AtE+kQV;;AsE7kQQ;;EAEE,+BAAA;AtEglQV;;AsE/lQQ;EAAgC,wBAAA;AtEmmQxC;;AsElmQQ;;EAEE,4BAAA;AtEqmQV;;AsEnmQQ;;EAEE,8BAAA;AtEsmQV;;AsEpmQQ;;EAEE,+BAAA;AtEumQV;;AsErmQQ;;EAEE,6BAAA;AtEwmQV;;AsEvnQQ;EAAgC,wBAAA;AtE2nQxC;;AsE1nQQ;;EAEE,4BAAA;AtE6nQV;;AsE3nQQ;;EAEE,8BAAA;AtE8nQV;;AsE5nQQ;;EAEE,+BAAA;AtE+nQV;;AsE7nQQ;;EAEE,6BAAA;AtEgoQV;;AsE/oQQ;EAAgC,yBAAA;AtEmpQxC;;AsElpQQ;;EAEE,6BAAA;AtEqpQV;;AsEnpQQ;;EAEE,+BAAA;AtEspQV;;AsEppQQ;;EAEE,gCAAA;AtEupQV;;AsErpQQ;;EAEE,8BAAA;AtEwpQV;;AsEhpQQ;EAAwB,2BAAA;AtEopQhC;;AsEnpQQ;;EAEE,+BAAA;AtEspQV;;AsEppQQ;;EAEE,iCAAA;AtEupQV;;AsErpQQ;;EAEE,kCAAA;AtEwpQV;;AsEtpQQ;;EAEE,gCAAA;AtEypQV;;AsExqQQ;EAAwB,0BAAA;AtE4qQhC;;AsE3qQQ;;EAEE,8BAAA;AtE8qQV;;AsE5qQQ;;EAEE,gCAAA;AtE+qQV;;AsE7qQQ;;EAEE,iCAAA;AtEgrQV;;AsE9qQQ;;EAEE,+BAAA;AtEirQV;;AsEhsQQ;EAAwB,wBAAA;AtEosQhC;;AsEnsQQ;;EAEE,4BAAA;AtEssQV;;AsEpsQQ;;EAEE,8BAAA;AtEusQV;;AsErsQQ;;EAEE,+BAAA;AtEwsQV;;AsEtsQQ;;EAEE,6BAAA;AtEysQV;;AsExtQQ;EAAwB,0BAAA;AtE4tQhC;;AsE3tQQ;;EAEE,8BAAA;AtE8tQV;;AsE5tQQ;;EAEE,gCAAA;AtE+tQV;;AsE7tQQ;;EAEE,iCAAA;AtEguQV;;AsE9tQQ;;EAEE,+BAAA;AtEiuQV;;AsEhvQQ;EAAwB,wBAAA;AtEovQhC;;AsEnvQQ;;EAEE,4BAAA;AtEsvQV;;AsEpvQQ;;EAEE,8BAAA;AtEuvQV;;AsErvQQ;;EAEE,+BAAA;AtEwvQV;;AsEtvQQ;;EAEE,6BAAA;AtEyvQV;;AsExwQQ;EAAwB,wBAAA;AtE4wQhC;;AsE3wQQ;;EAEE,4BAAA;AtE8wQV;;AsE5wQQ;;EAEE,8BAAA;AtE+wQV;;AsE7wQQ;;EAEE,+BAAA;AtEgxQV;;AsE9wQQ;;EAEE,6BAAA;AtEixQV;;AsEhyQQ;EAAwB,uBAAA;AtEoyQhC;;AsEnyQQ;;EAEE,2BAAA;AtEsyQV;;AsEpyQQ;;EAEE,6BAAA;AtEuyQV;;AsEryQQ;;EAEE,8BAAA;AtEwyQV;;AsEtyQQ;;EAEE,4BAAA;AtEyyQV;;AsExzQQ;EAAwB,uBAAA;AtE4zQhC;;AsE3zQQ;;EAEE,2BAAA;AtE8zQV;;AsE5zQQ;;EAEE,6BAAA;AtE+zQV;;AsE7zQQ;;EAEE,8BAAA;AtEg0QV;;AsE9zQQ;;EAEE,4BAAA;AtEi0QV;;AsEh1QQ;EAAwB,yBAAA;AtEo1QhC;;AsEn1QQ;;EAEE,6BAAA;AtEs1QV;;AsEp1QQ;;EAEE,+BAAA;AtEu1QV;;AsEr1QQ;;EAEE,gCAAA;AtEw1QV;;AsEt1QQ;;EAEE,8BAAA;AtEy1QV;;AsEx2QQ;EAAwB,uBAAA;AtE42QhC;;AsE32QQ;;EAEE,2BAAA;AtE82QV;;AsE52QQ;;EAEE,6BAAA;AtE+2QV;;AsE72QQ;;EAEE,8BAAA;AtEg3QV;;AsE92QQ;;EAEE,4BAAA;AtEi3QV;;AsEh4QQ;EAAwB,yBAAA;AtEo4QhC;;AsEn4QQ;;EAEE,6BAAA;AtEs4QV;;AsEp4QQ;;EAEE,+BAAA;AtEu4QV;;AsEr4QQ;;EAEE,gCAAA;AtEw4QV;;AsEt4QQ;;EAEE,8BAAA;AtEy4QV;;AsEx5QQ;EAAwB,uBAAA;AtE45QhC;;AsE35QQ;;EAEE,2BAAA;AtE85QV;;AsE55QQ;;EAEE,6BAAA;AtE+5QV;;AsE75QQ;;EAEE,8BAAA;AtEg6QV;;AsE95QQ;;EAEE,4BAAA;AtEi6QV;;AsEh7QQ;EAAwB,yBAAA;AtEo7QhC;;AsEn7QQ;;EAEE,6BAAA;AtEs7QV;;AsEp7QQ;;EAEE,+BAAA;AtEu7QV;;AsEr7QQ;;EAEE,gCAAA;AtEw7QV;;AsEt7QQ;;EAEE,8BAAA;AtEy7QV;;AsEx8QQ;EAAwB,0BAAA;AtE48QhC;;AsE38QQ;;EAEE,8BAAA;AtE88QV;;AsE58QQ;;EAEE,gCAAA;AtE+8QV;;AsE78QQ;;EAEE,iCAAA;AtEg9QV;;AsE98QQ;;EAEE,+BAAA;AtEi9QV;;AsEh+QQ;EAAwB,0BAAA;AtEo+QhC;;AsEn+QQ;;EAEE,8BAAA;AtEs+QV;;AsEp+QQ;;EAEE,gCAAA;AtEu+QV;;AsEr+QQ;;EAEE,iCAAA;AtEw+QV;;AsEt+QQ;;EAEE,+BAAA;AtEy+QV;;AsEx/QQ;EAAwB,wBAAA;AtE4/QhC;;AsE3/QQ;;EAEE,4BAAA;AtE8/QV;;AsE5/QQ;;EAEE,8BAAA;AtE+/QV;;AsE7/QQ;;EAEE,+BAAA;AtEggRV;;AsE9/QQ;;EAEE,6BAAA;AtEigRV;;AsEhhRQ;EAAwB,wBAAA;AtEohRhC;;AsEnhRQ;;EAEE,4BAAA;AtEshRV;;AsEphRQ;;EAEE,8BAAA;AtEuhRV;;AsErhRQ;;EAEE,+BAAA;AtEwhRV;;AsEthRQ;;EAEE,6BAAA;AtEyhRV;;AsExiRQ;EAAwB,yBAAA;AtE4iRhC;;AsE3iRQ;;EAEE,6BAAA;AtE8iRV;;AsE5iRQ;;EAEE,+BAAA;AtE+iRV;;AsE7iRQ;;EAEE,gCAAA;AtEgjRV;;AsE9iRQ;;EAEE,8BAAA;AtEijRV;;AsE3iRI;EAAmB,uBAAA;AtE+iRvB;;AsE9iRI;;EAEE,2BAAA;AtEijRN;;AsE/iRI;;EAEE,6BAAA;AtEkjRN;;AsEhjRI;;EAEE,8BAAA;AtEmjRN;;AsEjjRI;;EAEE,4BAAA;AtEojRN;;AgB7jRI;EsDlDI;IAAgC,oBAAA;EtEonRtC;EsEnnRM;;IAEE,wBAAA;EtEqnRR;EsEnnRM;;IAEE,0BAAA;EtEqnRR;EsEnnRM;;IAEE,2BAAA;EtEqnRR;EsEnnRM;;IAEE,yBAAA;EtEqnRR;EsEpoRM;IAAgC,0BAAA;EtEuoRtC;EsEtoRM;;IAEE,8BAAA;EtEwoRR;EsEtoRM;;IAEE,gCAAA;EtEwoRR;EsEtoRM;;IAEE,iCAAA;EtEwoRR;EsEtoRM;;IAEE,+BAAA;EtEwoRR;EsEvpRM;IAAgC,yBAAA;EtE0pRtC;EsEzpRM;;IAEE,6BAAA;EtE2pRR;EsEzpRM;;IAEE,+BAAA;EtE2pRR;EsEzpRM;;IAEE,gCAAA;EtE2pRR;EsEzpRM;;IAEE,8BAAA;EtE2pRR;EsE1qRM;IAAgC,uBAAA;EtE6qRtC;EsE5qRM;;IAEE,2BAAA;EtE8qRR;EsE5qRM;;IAEE,6BAAA;EtE8qRR;EsE5qRM;;IAEE,8BAAA;EtE8qRR;EsE5qRM;;IAEE,4BAAA;EtE8qRR;EsE7rRM;IAAgC,yBAAA;EtEgsRtC;EsE/rRM;;IAEE,6BAAA;EtEisRR;EsE/rRM;;IAEE,+BAAA;EtEisRR;EsE/rRM;;IAEE,gCAAA;EtEisRR;EsE/rRM;;IAEE,8BAAA;EtEisRR;EsEhtRM;IAAgC,uBAAA;EtEmtRtC;EsEltRM;;IAEE,2BAAA;EtEotRR;EsEltRM;;IAEE,6BAAA;EtEotRR;EsEltRM;;IAEE,8BAAA;EtEotRR;EsEltRM;;IAEE,4BAAA;EtEotRR;EsEnuRM;IAAgC,yBAAA;EtEsuRtC;EsEruRM;;IAEE,6BAAA;EtEuuRR;EsEruRM;;IAEE,+BAAA;EtEuuRR;EsEruRM;;IAEE,gCAAA;EtEuuRR;EsEruRM;;IAEE,8BAAA;EtEuuRR;EsEtvRM;IAAgC,wBAAA;EtEyvRtC;EsExvRM;;IAEE,4BAAA;EtE0vRR;EsExvRM;;IAEE,8BAAA;EtE0vRR;EsExvRM;;IAEE,+BAAA;EtE0vRR;EsExvRM;;IAEE,6BAAA;EtE0vRR;EsEzwRM;IAAgC,wBAAA;EtE4wRtC;EsE3wRM;;IAEE,4BAAA;EtE6wRR;EsE3wRM;;IAEE,8BAAA;EtE6wRR;EsE3wRM;;IAEE,+BAAA;EtE6wRR;EsE3wRM;;IAEE,6BAAA;EtE6wRR;EsE5xRM;IAAgC,0BAAA;EtE+xRtC;EsE9xRM;;IAEE,8BAAA;EtEgyRR;EsE9xRM;;IAEE,gCAAA;EtEgyRR;EsE9xRM;;IAEE,iCAAA;EtEgyRR;EsE9xRM;;IAEE,+BAAA;EtEgyRR;EsE/yRM;IAAgC,wBAAA;EtEkzRtC;EsEjzRM;;IAEE,4BAAA;EtEmzRR;EsEjzRM;;IAEE,8BAAA;EtEmzRR;EsEjzRM;;IAEE,+BAAA;EtEmzRR;EsEjzRM;;IAEE,6BAAA;EtEmzRR;EsEl0RM;IAAgC,0BAAA;EtEq0RtC;EsEp0RM;;IAEE,8BAAA;EtEs0RR;EsEp0RM;;IAEE,gCAAA;EtEs0RR;EsEp0RM;;IAEE,iCAAA;EtEs0RR;EsEp0RM;;IAEE,+BAAA;EtEs0RR;EsEr1RM;IAAgC,wBAAA;EtEw1RtC;EsEv1RM;;IAEE,4BAAA;EtEy1RR;EsEv1RM;;IAEE,8BAAA;EtEy1RR;EsEv1RM;;IAEE,+BAAA;EtEy1RR;EsEv1RM;;IAEE,6BAAA;EtEy1RR;EsEx2RM;IAAgC,0BAAA;EtE22RtC;EsE12RM;;IAEE,8BAAA;EtE42RR;EsE12RM;;IAEE,gCAAA;EtE42RR;EsE12RM;;IAEE,iCAAA;EtE42RR;EsE12RM;;IAEE,+BAAA;EtE42RR;EsE33RM;IAAgC,2BAAA;EtE83RtC;EsE73RM;;IAEE,+BAAA;EtE+3RR;EsE73RM;;IAEE,iCAAA;EtE+3RR;EsE73RM;;IAEE,kCAAA;EtE+3RR;EsE73RM;;IAEE,gCAAA;EtE+3RR;EsE94RM;IAAgC,yBAAA;EtEi5RtC;EsEh5RM;;IAEE,6BAAA;EtEk5RR;EsEh5RM;;IAEE,+BAAA;EtEk5RR;EsEh5RM;;IAEE,gCAAA;EtEk5RR;EsEh5RM;;IAEE,8BAAA;EtEk5RR;EsEj6RM;IAAgC,uBAAA;EtEo6RtC;EsEn6RM;;IAEE,2BAAA;EtEq6RR;EsEn6RM;;IAEE,6BAAA;EtEq6RR;EsEn6RM;;IAEE,8BAAA;EtEq6RR;EsEn6RM;;IAEE,4BAAA;EtEq6RR;EsEp7RM;IAAgC,uBAAA;EtEu7RtC;EsEt7RM;;IAEE,2BAAA;EtEw7RR;EsEt7RM;;IAEE,6BAAA;EtEw7RR;EsEt7RM;;IAEE,8BAAA;EtEw7RR;EsEt7RM;;IAEE,4BAAA;EtEw7RR;EsEv8RM;IAAgC,wBAAA;EtE08RtC;EsEz8RM;;IAEE,4BAAA;EtE28RR;EsEz8RM;;IAEE,8BAAA;EtE28RR;EsEz8RM;;IAEE,+BAAA;EtE28RR;EsEz8RM;;IAEE,6BAAA;EtE28RR;EsE19RM;IAAgC,qBAAA;EtE69RtC;EsE59RM;;IAEE,yBAAA;EtE89RR;EsE59RM;;IAEE,2BAAA;EtE89RR;EsE59RM;;IAEE,4BAAA;EtE89RR;EsE59RM;;IAEE,0BAAA;EtE89RR;EsE7+RM;IAAgC,2BAAA;EtEg/RtC;EsE/+RM;;IAEE,+BAAA;EtEi/RR;EsE/+RM;;IAEE,iCAAA;EtEi/RR;EsE/+RM;;IAEE,kCAAA;EtEi/RR;EsE/+RM;;IAEE,gCAAA;EtEi/RR;EsEhgSM;IAAgC,0BAAA;EtEmgStC;EsElgSM;;IAEE,8BAAA;EtEogSR;EsElgSM;;IAEE,gCAAA;EtEogSR;EsElgSM;;IAEE,iCAAA;EtEogSR;EsElgSM;;IAEE,+BAAA;EtEogSR;EsEnhSM;IAAgC,wBAAA;EtEshStC;EsErhSM;;IAEE,4BAAA;EtEuhSR;EsErhSM;;IAEE,8BAAA;EtEuhSR;EsErhSM;;IAEE,+BAAA;EtEuhSR;EsErhSM;;IAEE,6BAAA;EtEuhSR;EsEtiSM;IAAgC,0BAAA;EtEyiStC;EsExiSM;;IAEE,8BAAA;EtE0iSR;EsExiSM;;IAEE,gCAAA;EtE0iSR;EsExiSM;;IAEE,iCAAA;EtE0iSR;EsExiSM;;IAEE,+BAAA;EtE0iSR;EsEzjSM;IAAgC,wBAAA;EtE4jStC;EsE3jSM;;IAEE,4BAAA;EtE6jSR;EsE3jSM;;IAEE,8BAAA;EtE6jSR;EsE3jSM;;IAEE,+BAAA;EtE6jSR;EsE3jSM;;IAEE,6BAAA;EtE6jSR;EsE5kSM;IAAgC,0BAAA;EtE+kStC;EsE9kSM;;IAEE,8BAAA;EtEglSR;EsE9kSM;;IAEE,gCAAA;EtEglSR;EsE9kSM;;IAEE,iCAAA;EtEglSR;EsE9kSM;;IAEE,+BAAA;EtEglSR;EsE/lSM;IAAgC,yBAAA;EtEkmStC;EsEjmSM;;IAEE,6BAAA;EtEmmSR;EsEjmSM;;IAEE,+BAAA;EtEmmSR;EsEjmSM;;IAEE,gCAAA;EtEmmSR;EsEjmSM;;IAEE,8BAAA;EtEmmSR;EsElnSM;IAAgC,yBAAA;EtEqnStC;EsEpnSM;;IAEE,6BAAA;EtEsnSR;EsEpnSM;;IAEE,+BAAA;EtEsnSR;EsEpnSM;;IAEE,gCAAA;EtEsnSR;EsEpnSM;;IAEE,8BAAA;EtEsnSR;EsEroSM;IAAgC,2BAAA;EtEwoStC;EsEvoSM;;IAEE,+BAAA;EtEyoSR;EsEvoSM;;IAEE,iCAAA;EtEyoSR;EsEvoSM;;IAEE,kCAAA;EtEyoSR;EsEvoSM;;IAEE,gCAAA;EtEyoSR;EsExpSM;IAAgC,yBAAA;EtE2pStC;EsE1pSM;;IAEE,6BAAA;EtE4pSR;EsE1pSM;;IAEE,+BAAA;EtE4pSR;EsE1pSM;;IAEE,gCAAA;EtE4pSR;EsE1pSM;;IAEE,8BAAA;EtE4pSR;EsE3qSM;IAAgC,2BAAA;EtE8qStC;EsE7qSM;;IAEE,+BAAA;EtE+qSR;EsE7qSM;;IAEE,iCAAA;EtE+qSR;EsE7qSM;;IAEE,kCAAA;EtE+qSR;EsE7qSM;;IAEE,gCAAA;EtE+qSR;EsE9rSM;IAAgC,yBAAA;EtEisStC;EsEhsSM;;IAEE,6BAAA;EtEksSR;EsEhsSM;;IAEE,+BAAA;EtEksSR;EsEhsSM;;IAEE,gCAAA;EtEksSR;EsEhsSM;;IAEE,8BAAA;EtEksSR;EsEjtSM;IAAgC,2BAAA;EtEotStC;EsEntSM;;IAEE,+BAAA;EtEqtSR;EsEntSM;;IAEE,iCAAA;EtEqtSR;EsEntSM;;IAEE,kCAAA;EtEqtSR;EsEntSM;;IAEE,gCAAA;EtEqtSR;EsEpuSM;IAAgC,4BAAA;EtEuuStC;EsEtuSM;;IAEE,gCAAA;EtEwuSR;EsEtuSM;;IAEE,kCAAA;EtEwuSR;EsEtuSM;;IAEE,mCAAA;EtEwuSR;EsEtuSM;;IAEE,iCAAA;EtEwuSR;EsEvvSM;IAAgC,0BAAA;EtE0vStC;EsEzvSM;;IAEE,8BAAA;EtE2vSR;EsEzvSM;;IAEE,gCAAA;EtE2vSR;EsEzvSM;;IAEE,iCAAA;EtE2vSR;EsEzvSM;;IAEE,+BAAA;EtE2vSR;EsE1wSM;IAAgC,wBAAA;EtE6wStC;EsE5wSM;;IAEE,4BAAA;EtE8wSR;EsE5wSM;;IAEE,8BAAA;EtE8wSR;EsE5wSM;;IAEE,+BAAA;EtE8wSR;EsE5wSM;;IAEE,6BAAA;EtE8wSR;EsE7xSM;IAAgC,wBAAA;EtEgyStC;EsE/xSM;;IAEE,4BAAA;EtEiySR;EsE/xSM;;IAEE,8BAAA;EtEiySR;EsE/xSM;;IAEE,+BAAA;EtEiySR;EsE/xSM;;IAEE,6BAAA;EtEiySR;EsEhzSM;IAAgC,yBAAA;EtEmzStC;EsElzSM;;IAEE,6BAAA;EtEozSR;EsElzSM;;IAEE,+BAAA;EtEozSR;EsElzSM;;IAEE,gCAAA;EtEozSR;EsElzSM;;IAEE,8BAAA;EtEozSR;EsE5ySM;IAAwB,2BAAA;EtE+yS9B;EsE9ySM;;IAEE,+BAAA;EtEgzSR;EsE9ySM;;IAEE,iCAAA;EtEgzSR;EsE9ySM;;IAEE,kCAAA;EtEgzSR;EsE9ySM;;IAEE,gCAAA;EtEgzSR;EsE/zSM;IAAwB,0BAAA;EtEk0S9B;EsEj0SM;;IAEE,8BAAA;EtEm0SR;EsEj0SM;;IAEE,gCAAA;EtEm0SR;EsEj0SM;;IAEE,iCAAA;EtEm0SR;EsEj0SM;;IAEE,+BAAA;EtEm0SR;EsEl1SM;IAAwB,wBAAA;EtEq1S9B;EsEp1SM;;IAEE,4BAAA;EtEs1SR;EsEp1SM;;IAEE,8BAAA;EtEs1SR;EsEp1SM;;IAEE,+BAAA;EtEs1SR;EsEp1SM;;IAEE,6BAAA;EtEs1SR;EsEr2SM;IAAwB,0BAAA;EtEw2S9B;EsEv2SM;;IAEE,8BAAA;EtEy2SR;EsEv2SM;;IAEE,gCAAA;EtEy2SR;EsEv2SM;;IAEE,iCAAA;EtEy2SR;EsEv2SM;;IAEE,+BAAA;EtEy2SR;EsEx3SM;IAAwB,wBAAA;EtE23S9B;EsE13SM;;IAEE,4BAAA;EtE43SR;EsE13SM;;IAEE,8BAAA;EtE43SR;EsE13SM;;IAEE,+BAAA;EtE43SR;EsE13SM;;IAEE,6BAAA;EtE43SR;EsE34SM;IAAwB,wBAAA;EtE84S9B;EsE74SM;;IAEE,4BAAA;EtE+4SR;EsE74SM;;IAEE,8BAAA;EtE+4SR;EsE74SM;;IAEE,+BAAA;EtE+4SR;EsE74SM;;IAEE,6BAAA;EtE+4SR;EsE95SM;IAAwB,uBAAA;EtEi6S9B;EsEh6SM;;IAEE,2BAAA;EtEk6SR;EsEh6SM;;IAEE,6BAAA;EtEk6SR;EsEh6SM;;IAEE,8BAAA;EtEk6SR;EsEh6SM;;IAEE,4BAAA;EtEk6SR;EsEj7SM;IAAwB,uBAAA;EtEo7S9B;EsEn7SM;;IAEE,2BAAA;EtEq7SR;EsEn7SM;;IAEE,6BAAA;EtEq7SR;EsEn7SM;;IAEE,8BAAA;EtEq7SR;EsEn7SM;;IAEE,4BAAA;EtEq7SR;EsEp8SM;IAAwB,yBAAA;EtEu8S9B;EsEt8SM;;IAEE,6BAAA;EtEw8SR;EsEt8SM;;IAEE,+BAAA;EtEw8SR;EsEt8SM;;IAEE,gCAAA;EtEw8SR;EsEt8SM;;IAEE,8BAAA;EtEw8SR;EsEv9SM;IAAwB,uBAAA;EtE09S9B;EsEz9SM;;IAEE,2BAAA;EtE29SR;EsEz9SM;;IAEE,6BAAA;EtE29SR;EsEz9SM;;IAEE,8BAAA;EtE29SR;EsEz9SM;;IAEE,4BAAA;EtE29SR;EsE1+SM;IAAwB,yBAAA;EtE6+S9B;EsE5+SM;;IAEE,6BAAA;EtE8+SR;EsE5+SM;;IAEE,+BAAA;EtE8+SR;EsE5+SM;;IAEE,gCAAA;EtE8+SR;EsE5+SM;;IAEE,8BAAA;EtE8+SR;EsE7/SM;IAAwB,uBAAA;EtEggT9B;EsE//SM;;IAEE,2BAAA;EtEigTR;EsE//SM;;IAEE,6BAAA;EtEigTR;EsE//SM;;IAEE,8BAAA;EtEigTR;EsE//SM;;IAEE,4BAAA;EtEigTR;EsEhhTM;IAAwB,yBAAA;EtEmhT9B;EsElhTM;;IAEE,6BAAA;EtEohTR;EsElhTM;;IAEE,+BAAA;EtEohTR;EsElhTM;;IAEE,gCAAA;EtEohTR;EsElhTM;;IAEE,8BAAA;EtEohTR;EsEniTM;IAAwB,0BAAA;EtEsiT9B;EsEriTM;;IAEE,8BAAA;EtEuiTR;EsEriTM;;IAEE,gCAAA;EtEuiTR;EsEriTM;;IAEE,iCAAA;EtEuiTR;EsEriTM;;IAEE,+BAAA;EtEuiTR;EsEtjTM;IAAwB,0BAAA;EtEyjT9B;EsExjTM;;IAEE,8BAAA;EtE0jTR;EsExjTM;;IAEE,gCAAA;EtE0jTR;EsExjTM;;IAEE,iCAAA;EtE0jTR;EsExjTM;;IAEE,+BAAA;EtE0jTR;EsEzkTM;IAAwB,wBAAA;EtE4kT9B;EsE3kTM;;IAEE,4BAAA;EtE6kTR;EsE3kTM;;IAEE,8BAAA;EtE6kTR;EsE3kTM;;IAEE,+BAAA;EtE6kTR;EsE3kTM;;IAEE,6BAAA;EtE6kTR;EsE5lTM;IAAwB,wBAAA;EtE+lT9B;EsE9lTM;;IAEE,4BAAA;EtEgmTR;EsE9lTM;;IAEE,8BAAA;EtEgmTR;EsE9lTM;;IAEE,+BAAA;EtEgmTR;EsE9lTM;;IAEE,6BAAA;EtEgmTR;EsE/mTM;IAAwB,yBAAA;EtEknT9B;EsEjnTM;;IAEE,6BAAA;EtEmnTR;EsEjnTM;;IAEE,+BAAA;EtEmnTR;EsEjnTM;;IAEE,gCAAA;EtEmnTR;EsEjnTM;;IAEE,8BAAA;EtEmnTR;EsE7mTE;IAAmB,uBAAA;EtEgnTrB;EsE/mTE;;IAEE,2BAAA;EtEinTJ;EsE/mTE;;IAEE,6BAAA;EtEinTJ;EsE/mTE;;IAEE,8BAAA;EtEinTJ;EsE/mTE;;IAEE,4BAAA;EtEinTJ;AACF;AgB3nTI;EsDlDI;IAAgC,oBAAA;EtEirTtC;EsEhrTM;;IAEE,wBAAA;EtEkrTR;EsEhrTM;;IAEE,0BAAA;EtEkrTR;EsEhrTM;;IAEE,2BAAA;EtEkrTR;EsEhrTM;;IAEE,yBAAA;EtEkrTR;EsEjsTM;IAAgC,0BAAA;EtEosTtC;EsEnsTM;;IAEE,8BAAA;EtEqsTR;EsEnsTM;;IAEE,gCAAA;EtEqsTR;EsEnsTM;;IAEE,iCAAA;EtEqsTR;EsEnsTM;;IAEE,+BAAA;EtEqsTR;EsEptTM;IAAgC,yBAAA;EtEutTtC;EsEttTM;;IAEE,6BAAA;EtEwtTR;EsEttTM;;IAEE,+BAAA;EtEwtTR;EsEttTM;;IAEE,gCAAA;EtEwtTR;EsEttTM;;IAEE,8BAAA;EtEwtTR;EsEvuTM;IAAgC,uBAAA;EtE0uTtC;EsEzuTM;;IAEE,2BAAA;EtE2uTR;EsEzuTM;;IAEE,6BAAA;EtE2uTR;EsEzuTM;;IAEE,8BAAA;EtE2uTR;EsEzuTM;;IAEE,4BAAA;EtE2uTR;EsE1vTM;IAAgC,yBAAA;EtE6vTtC;EsE5vTM;;IAEE,6BAAA;EtE8vTR;EsE5vTM;;IAEE,+BAAA;EtE8vTR;EsE5vTM;;IAEE,gCAAA;EtE8vTR;EsE5vTM;;IAEE,8BAAA;EtE8vTR;EsE7wTM;IAAgC,uBAAA;EtEgxTtC;EsE/wTM;;IAEE,2BAAA;EtEixTR;EsE/wTM;;IAEE,6BAAA;EtEixTR;EsE/wTM;;IAEE,8BAAA;EtEixTR;EsE/wTM;;IAEE,4BAAA;EtEixTR;EsEhyTM;IAAgC,yBAAA;EtEmyTtC;EsElyTM;;IAEE,6BAAA;EtEoyTR;EsElyTM;;IAEE,+BAAA;EtEoyTR;EsElyTM;;IAEE,gCAAA;EtEoyTR;EsElyTM;;IAEE,8BAAA;EtEoyTR;EsEnzTM;IAAgC,wBAAA;EtEszTtC;EsErzTM;;IAEE,4BAAA;EtEuzTR;EsErzTM;;IAEE,8BAAA;EtEuzTR;EsErzTM;;IAEE,+BAAA;EtEuzTR;EsErzTM;;IAEE,6BAAA;EtEuzTR;EsEt0TM;IAAgC,wBAAA;EtEy0TtC;EsEx0TM;;IAEE,4BAAA;EtE00TR;EsEx0TM;;IAEE,8BAAA;EtE00TR;EsEx0TM;;IAEE,+BAAA;EtE00TR;EsEx0TM;;IAEE,6BAAA;EtE00TR;EsEz1TM;IAAgC,0BAAA;EtE41TtC;EsE31TM;;IAEE,8BAAA;EtE61TR;EsE31TM;;IAEE,gCAAA;EtE61TR;EsE31TM;;IAEE,iCAAA;EtE61TR;EsE31TM;;IAEE,+BAAA;EtE61TR;EsE52TM;IAAgC,wBAAA;EtE+2TtC;EsE92TM;;IAEE,4BAAA;EtEg3TR;EsE92TM;;IAEE,8BAAA;EtEg3TR;EsE92TM;;IAEE,+BAAA;EtEg3TR;EsE92TM;;IAEE,6BAAA;EtEg3TR;EsE/3TM;IAAgC,0BAAA;EtEk4TtC;EsEj4TM;;IAEE,8BAAA;EtEm4TR;EsEj4TM;;IAEE,gCAAA;EtEm4TR;EsEj4TM;;IAEE,iCAAA;EtEm4TR;EsEj4TM;;IAEE,+BAAA;EtEm4TR;EsEl5TM;IAAgC,wBAAA;EtEq5TtC;EsEp5TM;;IAEE,4BAAA;EtEs5TR;EsEp5TM;;IAEE,8BAAA;EtEs5TR;EsEp5TM;;IAEE,+BAAA;EtEs5TR;EsEp5TM;;IAEE,6BAAA;EtEs5TR;EsEr6TM;IAAgC,0BAAA;EtEw6TtC;EsEv6TM;;IAEE,8BAAA;EtEy6TR;EsEv6TM;;IAEE,gCAAA;EtEy6TR;EsEv6TM;;IAEE,iCAAA;EtEy6TR;EsEv6TM;;IAEE,+BAAA;EtEy6TR;EsEx7TM;IAAgC,2BAAA;EtE27TtC;EsE17TM;;IAEE,+BAAA;EtE47TR;EsE17TM;;IAEE,iCAAA;EtE47TR;EsE17TM;;IAEE,kCAAA;EtE47TR;EsE17TM;;IAEE,gCAAA;EtE47TR;EsE38TM;IAAgC,yBAAA;EtE88TtC;EsE78TM;;IAEE,6BAAA;EtE+8TR;EsE78TM;;IAEE,+BAAA;EtE+8TR;EsE78TM;;IAEE,gCAAA;EtE+8TR;EsE78TM;;IAEE,8BAAA;EtE+8TR;EsE99TM;IAAgC,uBAAA;EtEi+TtC;EsEh+TM;;IAEE,2BAAA;EtEk+TR;EsEh+TM;;IAEE,6BAAA;EtEk+TR;EsEh+TM;;IAEE,8BAAA;EtEk+TR;EsEh+TM;;IAEE,4BAAA;EtEk+TR;EsEj/TM;IAAgC,uBAAA;EtEo/TtC;EsEn/TM;;IAEE,2BAAA;EtEq/TR;EsEn/TM;;IAEE,6BAAA;EtEq/TR;EsEn/TM;;IAEE,8BAAA;EtEq/TR;EsEn/TM;;IAEE,4BAAA;EtEq/TR;EsEpgUM;IAAgC,wBAAA;EtEugUtC;EsEtgUM;;IAEE,4BAAA;EtEwgUR;EsEtgUM;;IAEE,8BAAA;EtEwgUR;EsEtgUM;;IAEE,+BAAA;EtEwgUR;EsEtgUM;;IAEE,6BAAA;EtEwgUR;EsEvhUM;IAAgC,qBAAA;EtE0hUtC;EsEzhUM;;IAEE,yBAAA;EtE2hUR;EsEzhUM;;IAEE,2BAAA;EtE2hUR;EsEzhUM;;IAEE,4BAAA;EtE2hUR;EsEzhUM;;IAEE,0BAAA;EtE2hUR;EsE1iUM;IAAgC,2BAAA;EtE6iUtC;EsE5iUM;;IAEE,+BAAA;EtE8iUR;EsE5iUM;;IAEE,iCAAA;EtE8iUR;EsE5iUM;;IAEE,kCAAA;EtE8iUR;EsE5iUM;;IAEE,gCAAA;EtE8iUR;EsE7jUM;IAAgC,0BAAA;EtEgkUtC;EsE/jUM;;IAEE,8BAAA;EtEikUR;EsE/jUM;;IAEE,gCAAA;EtEikUR;EsE/jUM;;IAEE,iCAAA;EtEikUR;EsE/jUM;;IAEE,+BAAA;EtEikUR;EsEhlUM;IAAgC,wBAAA;EtEmlUtC;EsEllUM;;IAEE,4BAAA;EtEolUR;EsEllUM;;IAEE,8BAAA;EtEolUR;EsEllUM;;IAEE,+BAAA;EtEolUR;EsEllUM;;IAEE,6BAAA;EtEolUR;EsEnmUM;IAAgC,0BAAA;EtEsmUtC;EsErmUM;;IAEE,8BAAA;EtEumUR;EsErmUM;;IAEE,gCAAA;EtEumUR;EsErmUM;;IAEE,iCAAA;EtEumUR;EsErmUM;;IAEE,+BAAA;EtEumUR;EsEtnUM;IAAgC,wBAAA;EtEynUtC;EsExnUM;;IAEE,4BAAA;EtE0nUR;EsExnUM;;IAEE,8BAAA;EtE0nUR;EsExnUM;;IAEE,+BAAA;EtE0nUR;EsExnUM;;IAEE,6BAAA;EtE0nUR;EsEzoUM;IAAgC,0BAAA;EtE4oUtC;EsE3oUM;;IAEE,8BAAA;EtE6oUR;EsE3oUM;;IAEE,gCAAA;EtE6oUR;EsE3oUM;;IAEE,iCAAA;EtE6oUR;EsE3oUM;;IAEE,+BAAA;EtE6oUR;EsE5pUM;IAAgC,yBAAA;EtE+pUtC;EsE9pUM;;IAEE,6BAAA;EtEgqUR;EsE9pUM;;IAEE,+BAAA;EtEgqUR;EsE9pUM;;IAEE,gCAAA;EtEgqUR;EsE9pUM;;IAEE,8BAAA;EtEgqUR;EsE/qUM;IAAgC,yBAAA;EtEkrUtC;EsEjrUM;;IAEE,6BAAA;EtEmrUR;EsEjrUM;;IAEE,+BAAA;EtEmrUR;EsEjrUM;;IAEE,gCAAA;EtEmrUR;EsEjrUM;;IAEE,8BAAA;EtEmrUR;EsElsUM;IAAgC,2BAAA;EtEqsUtC;EsEpsUM;;IAEE,+BAAA;EtEssUR;EsEpsUM;;IAEE,iCAAA;EtEssUR;EsEpsUM;;IAEE,kCAAA;EtEssUR;EsEpsUM;;IAEE,gCAAA;EtEssUR;EsErtUM;IAAgC,yBAAA;EtEwtUtC;EsEvtUM;;IAEE,6BAAA;EtEytUR;EsEvtUM;;IAEE,+BAAA;EtEytUR;EsEvtUM;;IAEE,gCAAA;EtEytUR;EsEvtUM;;IAEE,8BAAA;EtEytUR;EsExuUM;IAAgC,2BAAA;EtE2uUtC;EsE1uUM;;IAEE,+BAAA;EtE4uUR;EsE1uUM;;IAEE,iCAAA;EtE4uUR;EsE1uUM;;IAEE,kCAAA;EtE4uUR;EsE1uUM;;IAEE,gCAAA;EtE4uUR;EsE3vUM;IAAgC,yBAAA;EtE8vUtC;EsE7vUM;;IAEE,6BAAA;EtE+vUR;EsE7vUM;;IAEE,+BAAA;EtE+vUR;EsE7vUM;;IAEE,gCAAA;EtE+vUR;EsE7vUM;;IAEE,8BAAA;EtE+vUR;EsE9wUM;IAAgC,2BAAA;EtEixUtC;EsEhxUM;;IAEE,+BAAA;EtEkxUR;EsEhxUM;;IAEE,iCAAA;EtEkxUR;EsEhxUM;;IAEE,kCAAA;EtEkxUR;EsEhxUM;;IAEE,gCAAA;EtEkxUR;EsEjyUM;IAAgC,4BAAA;EtEoyUtC;EsEnyUM;;IAEE,gCAAA;EtEqyUR;EsEnyUM;;IAEE,kCAAA;EtEqyUR;EsEnyUM;;IAEE,mCAAA;EtEqyUR;EsEnyUM;;IAEE,iCAAA;EtEqyUR;EsEpzUM;IAAgC,0BAAA;EtEuzUtC;EsEtzUM;;IAEE,8BAAA;EtEwzUR;EsEtzUM;;IAEE,gCAAA;EtEwzUR;EsEtzUM;;IAEE,iCAAA;EtEwzUR;EsEtzUM;;IAEE,+BAAA;EtEwzUR;EsEv0UM;IAAgC,wBAAA;EtE00UtC;EsEz0UM;;IAEE,4BAAA;EtE20UR;EsEz0UM;;IAEE,8BAAA;EtE20UR;EsEz0UM;;IAEE,+BAAA;EtE20UR;EsEz0UM;;IAEE,6BAAA;EtE20UR;EsE11UM;IAAgC,wBAAA;EtE61UtC;EsE51UM;;IAEE,4BAAA;EtE81UR;EsE51UM;;IAEE,8BAAA;EtE81UR;EsE51UM;;IAEE,+BAAA;EtE81UR;EsE51UM;;IAEE,6BAAA;EtE81UR;EsE72UM;IAAgC,yBAAA;EtEg3UtC;EsE/2UM;;IAEE,6BAAA;EtEi3UR;EsE/2UM;;IAEE,+BAAA;EtEi3UR;EsE/2UM;;IAEE,gCAAA;EtEi3UR;EsE/2UM;;IAEE,8BAAA;EtEi3UR;EsEz2UM;IAAwB,2BAAA;EtE42U9B;EsE32UM;;IAEE,+BAAA;EtE62UR;EsE32UM;;IAEE,iCAAA;EtE62UR;EsE32UM;;IAEE,kCAAA;EtE62UR;EsE32UM;;IAEE,gCAAA;EtE62UR;EsE53UM;IAAwB,0BAAA;EtE+3U9B;EsE93UM;;IAEE,8BAAA;EtEg4UR;EsE93UM;;IAEE,gCAAA;EtEg4UR;EsE93UM;;IAEE,iCAAA;EtEg4UR;EsE93UM;;IAEE,+BAAA;EtEg4UR;EsE/4UM;IAAwB,wBAAA;EtEk5U9B;EsEj5UM;;IAEE,4BAAA;EtEm5UR;EsEj5UM;;IAEE,8BAAA;EtEm5UR;EsEj5UM;;IAEE,+BAAA;EtEm5UR;EsEj5UM;;IAEE,6BAAA;EtEm5UR;EsEl6UM;IAAwB,0BAAA;EtEq6U9B;EsEp6UM;;IAEE,8BAAA;EtEs6UR;EsEp6UM;;IAEE,gCAAA;EtEs6UR;EsEp6UM;;IAEE,iCAAA;EtEs6UR;EsEp6UM;;IAEE,+BAAA;EtEs6UR;EsEr7UM;IAAwB,wBAAA;EtEw7U9B;EsEv7UM;;IAEE,4BAAA;EtEy7UR;EsEv7UM;;IAEE,8BAAA;EtEy7UR;EsEv7UM;;IAEE,+BAAA;EtEy7UR;EsEv7UM;;IAEE,6BAAA;EtEy7UR;EsEx8UM;IAAwB,wBAAA;EtE28U9B;EsE18UM;;IAEE,4BAAA;EtE48UR;EsE18UM;;IAEE,8BAAA;EtE48UR;EsE18UM;;IAEE,+BAAA;EtE48UR;EsE18UM;;IAEE,6BAAA;EtE48UR;EsE39UM;IAAwB,uBAAA;EtE89U9B;EsE79UM;;IAEE,2BAAA;EtE+9UR;EsE79UM;;IAEE,6BAAA;EtE+9UR;EsE79UM;;IAEE,8BAAA;EtE+9UR;EsE79UM;;IAEE,4BAAA;EtE+9UR;EsE9+UM;IAAwB,uBAAA;EtEi/U9B;EsEh/UM;;IAEE,2BAAA;EtEk/UR;EsEh/UM;;IAEE,6BAAA;EtEk/UR;EsEh/UM;;IAEE,8BAAA;EtEk/UR;EsEh/UM;;IAEE,4BAAA;EtEk/UR;EsEjgVM;IAAwB,yBAAA;EtEogV9B;EsEngVM;;IAEE,6BAAA;EtEqgVR;EsEngVM;;IAEE,+BAAA;EtEqgVR;EsEngVM;;IAEE,gCAAA;EtEqgVR;EsEngVM;;IAEE,8BAAA;EtEqgVR;EsEphVM;IAAwB,uBAAA;EtEuhV9B;EsEthVM;;IAEE,2BAAA;EtEwhVR;EsEthVM;;IAEE,6BAAA;EtEwhVR;EsEthVM;;IAEE,8BAAA;EtEwhVR;EsEthVM;;IAEE,4BAAA;EtEwhVR;EsEviVM;IAAwB,yBAAA;EtE0iV9B;EsEziVM;;IAEE,6BAAA;EtE2iVR;EsEziVM;;IAEE,+BAAA;EtE2iVR;EsEziVM;;IAEE,gCAAA;EtE2iVR;EsEziVM;;IAEE,8BAAA;EtE2iVR;EsE1jVM;IAAwB,uBAAA;EtE6jV9B;EsE5jVM;;IAEE,2BAAA;EtE8jVR;EsE5jVM;;IAEE,6BAAA;EtE8jVR;EsE5jVM;;IAEE,8BAAA;EtE8jVR;EsE5jVM;;IAEE,4BAAA;EtE8jVR;EsE7kVM;IAAwB,yBAAA;EtEglV9B;EsE/kVM;;IAEE,6BAAA;EtEilVR;EsE/kVM;;IAEE,+BAAA;EtEilVR;EsE/kVM;;IAEE,gCAAA;EtEilVR;EsE/kVM;;IAEE,8BAAA;EtEilVR;EsEhmVM;IAAwB,0BAAA;EtEmmV9B;EsElmVM;;IAEE,8BAAA;EtEomVR;EsElmVM;;IAEE,gCAAA;EtEomVR;EsElmVM;;IAEE,iCAAA;EtEomVR;EsElmVM;;IAEE,+BAAA;EtEomVR;EsEnnVM;IAAwB,0BAAA;EtEsnV9B;EsErnVM;;IAEE,8BAAA;EtEunVR;EsErnVM;;IAEE,gCAAA;EtEunVR;EsErnVM;;IAEE,iCAAA;EtEunVR;EsErnVM;;IAEE,+BAAA;EtEunVR;EsEtoVM;IAAwB,wBAAA;EtEyoV9B;EsExoVM;;IAEE,4BAAA;EtE0oVR;EsExoVM;;IAEE,8BAAA;EtE0oVR;EsExoVM;;IAEE,+BAAA;EtE0oVR;EsExoVM;;IAEE,6BAAA;EtE0oVR;EsEzpVM;IAAwB,wBAAA;EtE4pV9B;EsE3pVM;;IAEE,4BAAA;EtE6pVR;EsE3pVM;;IAEE,8BAAA;EtE6pVR;EsE3pVM;;IAEE,+BAAA;EtE6pVR;EsE3pVM;;IAEE,6BAAA;EtE6pVR;EsE5qVM;IAAwB,yBAAA;EtE+qV9B;EsE9qVM;;IAEE,6BAAA;EtEgrVR;EsE9qVM;;IAEE,+BAAA;EtEgrVR;EsE9qVM;;IAEE,gCAAA;EtEgrVR;EsE9qVM;;IAEE,8BAAA;EtEgrVR;EsE1qVE;IAAmB,uBAAA;EtE6qVrB;EsE5qVE;;IAEE,2BAAA;EtE8qVJ;EsE5qVE;;IAEE,6BAAA;EtE8qVJ;EsE5qVE;;IAEE,8BAAA;EtE8qVJ;EsE5qVE;;IAEE,4BAAA;EtE8qVJ;AACF;AgBxrVI;EsDlDI;IAAgC,oBAAA;EtE8uVtC;EsE7uVM;;IAEE,wBAAA;EtE+uVR;EsE7uVM;;IAEE,0BAAA;EtE+uVR;EsE7uVM;;IAEE,2BAAA;EtE+uVR;EsE7uVM;;IAEE,yBAAA;EtE+uVR;EsE9vVM;IAAgC,0BAAA;EtEiwVtC;EsEhwVM;;IAEE,8BAAA;EtEkwVR;EsEhwVM;;IAEE,gCAAA;EtEkwVR;EsEhwVM;;IAEE,iCAAA;EtEkwVR;EsEhwVM;;IAEE,+BAAA;EtEkwVR;EsEjxVM;IAAgC,yBAAA;EtEoxVtC;EsEnxVM;;IAEE,6BAAA;EtEqxVR;EsEnxVM;;IAEE,+BAAA;EtEqxVR;EsEnxVM;;IAEE,gCAAA;EtEqxVR;EsEnxVM;;IAEE,8BAAA;EtEqxVR;EsEpyVM;IAAgC,uBAAA;EtEuyVtC;EsEtyVM;;IAEE,2BAAA;EtEwyVR;EsEtyVM;;IAEE,6BAAA;EtEwyVR;EsEtyVM;;IAEE,8BAAA;EtEwyVR;EsEtyVM;;IAEE,4BAAA;EtEwyVR;EsEvzVM;IAAgC,yBAAA;EtE0zVtC;EsEzzVM;;IAEE,6BAAA;EtE2zVR;EsEzzVM;;IAEE,+BAAA;EtE2zVR;EsEzzVM;;IAEE,gCAAA;EtE2zVR;EsEzzVM;;IAEE,8BAAA;EtE2zVR;EsE10VM;IAAgC,uBAAA;EtE60VtC;EsE50VM;;IAEE,2BAAA;EtE80VR;EsE50VM;;IAEE,6BAAA;EtE80VR;EsE50VM;;IAEE,8BAAA;EtE80VR;EsE50VM;;IAEE,4BAAA;EtE80VR;EsE71VM;IAAgC,yBAAA;EtEg2VtC;EsE/1VM;;IAEE,6BAAA;EtEi2VR;EsE/1VM;;IAEE,+BAAA;EtEi2VR;EsE/1VM;;IAEE,gCAAA;EtEi2VR;EsE/1VM;;IAEE,8BAAA;EtEi2VR;EsEh3VM;IAAgC,wBAAA;EtEm3VtC;EsEl3VM;;IAEE,4BAAA;EtEo3VR;EsEl3VM;;IAEE,8BAAA;EtEo3VR;EsEl3VM;;IAEE,+BAAA;EtEo3VR;EsEl3VM;;IAEE,6BAAA;EtEo3VR;EsEn4VM;IAAgC,wBAAA;EtEs4VtC;EsEr4VM;;IAEE,4BAAA;EtEu4VR;EsEr4VM;;IAEE,8BAAA;EtEu4VR;EsEr4VM;;IAEE,+BAAA;EtEu4VR;EsEr4VM;;IAEE,6BAAA;EtEu4VR;EsEt5VM;IAAgC,0BAAA;EtEy5VtC;EsEx5VM;;IAEE,8BAAA;EtE05VR;EsEx5VM;;IAEE,gCAAA;EtE05VR;EsEx5VM;;IAEE,iCAAA;EtE05VR;EsEx5VM;;IAEE,+BAAA;EtE05VR;EsEz6VM;IAAgC,wBAAA;EtE46VtC;EsE36VM;;IAEE,4BAAA;EtE66VR;EsE36VM;;IAEE,8BAAA;EtE66VR;EsE36VM;;IAEE,+BAAA;EtE66VR;EsE36VM;;IAEE,6BAAA;EtE66VR;EsE57VM;IAAgC,0BAAA;EtE+7VtC;EsE97VM;;IAEE,8BAAA;EtEg8VR;EsE97VM;;IAEE,gCAAA;EtEg8VR;EsE97VM;;IAEE,iCAAA;EtEg8VR;EsE97VM;;IAEE,+BAAA;EtEg8VR;EsE/8VM;IAAgC,wBAAA;EtEk9VtC;EsEj9VM;;IAEE,4BAAA;EtEm9VR;EsEj9VM;;IAEE,8BAAA;EtEm9VR;EsEj9VM;;IAEE,+BAAA;EtEm9VR;EsEj9VM;;IAEE,6BAAA;EtEm9VR;EsEl+VM;IAAgC,0BAAA;EtEq+VtC;EsEp+VM;;IAEE,8BAAA;EtEs+VR;EsEp+VM;;IAEE,gCAAA;EtEs+VR;EsEp+VM;;IAEE,iCAAA;EtEs+VR;EsEp+VM;;IAEE,+BAAA;EtEs+VR;EsEr/VM;IAAgC,2BAAA;EtEw/VtC;EsEv/VM;;IAEE,+BAAA;EtEy/VR;EsEv/VM;;IAEE,iCAAA;EtEy/VR;EsEv/VM;;IAEE,kCAAA;EtEy/VR;EsEv/VM;;IAEE,gCAAA;EtEy/VR;EsExgWM;IAAgC,yBAAA;EtE2gWtC;EsE1gWM;;IAEE,6BAAA;EtE4gWR;EsE1gWM;;IAEE,+BAAA;EtE4gWR;EsE1gWM;;IAEE,gCAAA;EtE4gWR;EsE1gWM;;IAEE,8BAAA;EtE4gWR;EsE3hWM;IAAgC,uBAAA;EtE8hWtC;EsE7hWM;;IAEE,2BAAA;EtE+hWR;EsE7hWM;;IAEE,6BAAA;EtE+hWR;EsE7hWM;;IAEE,8BAAA;EtE+hWR;EsE7hWM;;IAEE,4BAAA;EtE+hWR;EsE9iWM;IAAgC,uBAAA;EtEijWtC;EsEhjWM;;IAEE,2BAAA;EtEkjWR;EsEhjWM;;IAEE,6BAAA;EtEkjWR;EsEhjWM;;IAEE,8BAAA;EtEkjWR;EsEhjWM;;IAEE,4BAAA;EtEkjWR;EsEjkWM;IAAgC,wBAAA;EtEokWtC;EsEnkWM;;IAEE,4BAAA;EtEqkWR;EsEnkWM;;IAEE,8BAAA;EtEqkWR;EsEnkWM;;IAEE,+BAAA;EtEqkWR;EsEnkWM;;IAEE,6BAAA;EtEqkWR;EsEplWM;IAAgC,qBAAA;EtEulWtC;EsEtlWM;;IAEE,yBAAA;EtEwlWR;EsEtlWM;;IAEE,2BAAA;EtEwlWR;EsEtlWM;;IAEE,4BAAA;EtEwlWR;EsEtlWM;;IAEE,0BAAA;EtEwlWR;EsEvmWM;IAAgC,2BAAA;EtE0mWtC;EsEzmWM;;IAEE,+BAAA;EtE2mWR;EsEzmWM;;IAEE,iCAAA;EtE2mWR;EsEzmWM;;IAEE,kCAAA;EtE2mWR;EsEzmWM;;IAEE,gCAAA;EtE2mWR;EsE1nWM;IAAgC,0BAAA;EtE6nWtC;EsE5nWM;;IAEE,8BAAA;EtE8nWR;EsE5nWM;;IAEE,gCAAA;EtE8nWR;EsE5nWM;;IAEE,iCAAA;EtE8nWR;EsE5nWM;;IAEE,+BAAA;EtE8nWR;EsE7oWM;IAAgC,wBAAA;EtEgpWtC;EsE/oWM;;IAEE,4BAAA;EtEipWR;EsE/oWM;;IAEE,8BAAA;EtEipWR;EsE/oWM;;IAEE,+BAAA;EtEipWR;EsE/oWM;;IAEE,6BAAA;EtEipWR;EsEhqWM;IAAgC,0BAAA;EtEmqWtC;EsElqWM;;IAEE,8BAAA;EtEoqWR;EsElqWM;;IAEE,gCAAA;EtEoqWR;EsElqWM;;IAEE,iCAAA;EtEoqWR;EsElqWM;;IAEE,+BAAA;EtEoqWR;EsEnrWM;IAAgC,wBAAA;EtEsrWtC;EsErrWM;;IAEE,4BAAA;EtEurWR;EsErrWM;;IAEE,8BAAA;EtEurWR;EsErrWM;;IAEE,+BAAA;EtEurWR;EsErrWM;;IAEE,6BAAA;EtEurWR;EsEtsWM;IAAgC,0BAAA;EtEysWtC;EsExsWM;;IAEE,8BAAA;EtE0sWR;EsExsWM;;IAEE,gCAAA;EtE0sWR;EsExsWM;;IAEE,iCAAA;EtE0sWR;EsExsWM;;IAEE,+BAAA;EtE0sWR;EsEztWM;IAAgC,yBAAA;EtE4tWtC;EsE3tWM;;IAEE,6BAAA;EtE6tWR;EsE3tWM;;IAEE,+BAAA;EtE6tWR;EsE3tWM;;IAEE,gCAAA;EtE6tWR;EsE3tWM;;IAEE,8BAAA;EtE6tWR;EsE5uWM;IAAgC,yBAAA;EtE+uWtC;EsE9uWM;;IAEE,6BAAA;EtEgvWR;EsE9uWM;;IAEE,+BAAA;EtEgvWR;EsE9uWM;;IAEE,gCAAA;EtEgvWR;EsE9uWM;;IAEE,8BAAA;EtEgvWR;EsE/vWM;IAAgC,2BAAA;EtEkwWtC;EsEjwWM;;IAEE,+BAAA;EtEmwWR;EsEjwWM;;IAEE,iCAAA;EtEmwWR;EsEjwWM;;IAEE,kCAAA;EtEmwWR;EsEjwWM;;IAEE,gCAAA;EtEmwWR;EsElxWM;IAAgC,yBAAA;EtEqxWtC;EsEpxWM;;IAEE,6BAAA;EtEsxWR;EsEpxWM;;IAEE,+BAAA;EtEsxWR;EsEpxWM;;IAEE,gCAAA;EtEsxWR;EsEpxWM;;IAEE,8BAAA;EtEsxWR;EsEryWM;IAAgC,2BAAA;EtEwyWtC;EsEvyWM;;IAEE,+BAAA;EtEyyWR;EsEvyWM;;IAEE,iCAAA;EtEyyWR;EsEvyWM;;IAEE,kCAAA;EtEyyWR;EsEvyWM;;IAEE,gCAAA;EtEyyWR;EsExzWM;IAAgC,yBAAA;EtE2zWtC;EsE1zWM;;IAEE,6BAAA;EtE4zWR;EsE1zWM;;IAEE,+BAAA;EtE4zWR;EsE1zWM;;IAEE,gCAAA;EtE4zWR;EsE1zWM;;IAEE,8BAAA;EtE4zWR;EsE30WM;IAAgC,2BAAA;EtE80WtC;EsE70WM;;IAEE,+BAAA;EtE+0WR;EsE70WM;;IAEE,iCAAA;EtE+0WR;EsE70WM;;IAEE,kCAAA;EtE+0WR;EsE70WM;;IAEE,gCAAA;EtE+0WR;EsE91WM;IAAgC,4BAAA;EtEi2WtC;EsEh2WM;;IAEE,gCAAA;EtEk2WR;EsEh2WM;;IAEE,kCAAA;EtEk2WR;EsEh2WM;;IAEE,mCAAA;EtEk2WR;EsEh2WM;;IAEE,iCAAA;EtEk2WR;EsEj3WM;IAAgC,0BAAA;EtEo3WtC;EsEn3WM;;IAEE,8BAAA;EtEq3WR;EsEn3WM;;IAEE,gCAAA;EtEq3WR;EsEn3WM;;IAEE,iCAAA;EtEq3WR;EsEn3WM;;IAEE,+BAAA;EtEq3WR;EsEp4WM;IAAgC,wBAAA;EtEu4WtC;EsEt4WM;;IAEE,4BAAA;EtEw4WR;EsEt4WM;;IAEE,8BAAA;EtEw4WR;EsEt4WM;;IAEE,+BAAA;EtEw4WR;EsEt4WM;;IAEE,6BAAA;EtEw4WR;EsEv5WM;IAAgC,wBAAA;EtE05WtC;EsEz5WM;;IAEE,4BAAA;EtE25WR;EsEz5WM;;IAEE,8BAAA;EtE25WR;EsEz5WM;;IAEE,+BAAA;EtE25WR;EsEz5WM;;IAEE,6BAAA;EtE25WR;EsE16WM;IAAgC,yBAAA;EtE66WtC;EsE56WM;;IAEE,6BAAA;EtE86WR;EsE56WM;;IAEE,+BAAA;EtE86WR;EsE56WM;;IAEE,gCAAA;EtE86WR;EsE56WM;;IAEE,8BAAA;EtE86WR;EsEt6WM;IAAwB,2BAAA;EtEy6W9B;EsEx6WM;;IAEE,+BAAA;EtE06WR;EsEx6WM;;IAEE,iCAAA;EtE06WR;EsEx6WM;;IAEE,kCAAA;EtE06WR;EsEx6WM;;IAEE,gCAAA;EtE06WR;EsEz7WM;IAAwB,0BAAA;EtE47W9B;EsE37WM;;IAEE,8BAAA;EtE67WR;EsE37WM;;IAEE,gCAAA;EtE67WR;EsE37WM;;IAEE,iCAAA;EtE67WR;EsE37WM;;IAEE,+BAAA;EtE67WR;EsE58WM;IAAwB,wBAAA;EtE+8W9B;EsE98WM;;IAEE,4BAAA;EtEg9WR;EsE98WM;;IAEE,8BAAA;EtEg9WR;EsE98WM;;IAEE,+BAAA;EtEg9WR;EsE98WM;;IAEE,6BAAA;EtEg9WR;EsE/9WM;IAAwB,0BAAA;EtEk+W9B;EsEj+WM;;IAEE,8BAAA;EtEm+WR;EsEj+WM;;IAEE,gCAAA;EtEm+WR;EsEj+WM;;IAEE,iCAAA;EtEm+WR;EsEj+WM;;IAEE,+BAAA;EtEm+WR;EsEl/WM;IAAwB,wBAAA;EtEq/W9B;EsEp/WM;;IAEE,4BAAA;EtEs/WR;EsEp/WM;;IAEE,8BAAA;EtEs/WR;EsEp/WM;;IAEE,+BAAA;EtEs/WR;EsEp/WM;;IAEE,6BAAA;EtEs/WR;EsErgXM;IAAwB,wBAAA;EtEwgX9B;EsEvgXM;;IAEE,4BAAA;EtEygXR;EsEvgXM;;IAEE,8BAAA;EtEygXR;EsEvgXM;;IAEE,+BAAA;EtEygXR;EsEvgXM;;IAEE,6BAAA;EtEygXR;EsExhXM;IAAwB,uBAAA;EtE2hX9B;EsE1hXM;;IAEE,2BAAA;EtE4hXR;EsE1hXM;;IAEE,6BAAA;EtE4hXR;EsE1hXM;;IAEE,8BAAA;EtE4hXR;EsE1hXM;;IAEE,4BAAA;EtE4hXR;EsE3iXM;IAAwB,uBAAA;EtE8iX9B;EsE7iXM;;IAEE,2BAAA;EtE+iXR;EsE7iXM;;IAEE,6BAAA;EtE+iXR;EsE7iXM;;IAEE,8BAAA;EtE+iXR;EsE7iXM;;IAEE,4BAAA;EtE+iXR;EsE9jXM;IAAwB,yBAAA;EtEikX9B;EsEhkXM;;IAEE,6BAAA;EtEkkXR;EsEhkXM;;IAEE,+BAAA;EtEkkXR;EsEhkXM;;IAEE,gCAAA;EtEkkXR;EsEhkXM;;IAEE,8BAAA;EtEkkXR;EsEjlXM;IAAwB,uBAAA;EtEolX9B;EsEnlXM;;IAEE,2BAAA;EtEqlXR;EsEnlXM;;IAEE,6BAAA;EtEqlXR;EsEnlXM;;IAEE,8BAAA;EtEqlXR;EsEnlXM;;IAEE,4BAAA;EtEqlXR;EsEpmXM;IAAwB,yBAAA;EtEumX9B;EsEtmXM;;IAEE,6BAAA;EtEwmXR;EsEtmXM;;IAEE,+BAAA;EtEwmXR;EsEtmXM;;IAEE,gCAAA;EtEwmXR;EsEtmXM;;IAEE,8BAAA;EtEwmXR;EsEvnXM;IAAwB,uBAAA;EtE0nX9B;EsEznXM;;IAEE,2BAAA;EtE2nXR;EsEznXM;;IAEE,6BAAA;EtE2nXR;EsEznXM;;IAEE,8BAAA;EtE2nXR;EsEznXM;;IAEE,4BAAA;EtE2nXR;EsE1oXM;IAAwB,yBAAA;EtE6oX9B;EsE5oXM;;IAEE,6BAAA;EtE8oXR;EsE5oXM;;IAEE,+BAAA;EtE8oXR;EsE5oXM;;IAEE,gCAAA;EtE8oXR;EsE5oXM;;IAEE,8BAAA;EtE8oXR;EsE7pXM;IAAwB,0BAAA;EtEgqX9B;EsE/pXM;;IAEE,8BAAA;EtEiqXR;EsE/pXM;;IAEE,gCAAA;EtEiqXR;EsE/pXM;;IAEE,iCAAA;EtEiqXR;EsE/pXM;;IAEE,+BAAA;EtEiqXR;EsEhrXM;IAAwB,0BAAA;EtEmrX9B;EsElrXM;;IAEE,8BAAA;EtEorXR;EsElrXM;;IAEE,gCAAA;EtEorXR;EsElrXM;;IAEE,iCAAA;EtEorXR;EsElrXM;;IAEE,+BAAA;EtEorXR;EsEnsXM;IAAwB,wBAAA;EtEssX9B;EsErsXM;;IAEE,4BAAA;EtEusXR;EsErsXM;;IAEE,8BAAA;EtEusXR;EsErsXM;;IAEE,+BAAA;EtEusXR;EsErsXM;;IAEE,6BAAA;EtEusXR;EsEttXM;IAAwB,wBAAA;EtEytX9B;EsExtXM;;IAEE,4BAAA;EtE0tXR;EsExtXM;;IAEE,8BAAA;EtE0tXR;EsExtXM;;IAEE,+BAAA;EtE0tXR;EsExtXM;;IAEE,6BAAA;EtE0tXR;EsEzuXM;IAAwB,yBAAA;EtE4uX9B;EsE3uXM;;IAEE,6BAAA;EtE6uXR;EsE3uXM;;IAEE,+BAAA;EtE6uXR;EsE3uXM;;IAEE,gCAAA;EtE6uXR;EsE3uXM;;IAEE,8BAAA;EtE6uXR;EsEvuXE;IAAmB,uBAAA;EtE0uXrB;EsEzuXE;;IAEE,2BAAA;EtE2uXJ;EsEzuXE;;IAEE,6BAAA;EtE2uXJ;EsEzuXE;;IAEE,8BAAA;EtE2uXJ;EsEzuXE;;IAEE,4BAAA;EtE2uXJ;AACF;AgBrvXI;EsDlDI;IAAgC,oBAAA;EtE2yXtC;EsE1yXM;;IAEE,wBAAA;EtE4yXR;EsE1yXM;;IAEE,0BAAA;EtE4yXR;EsE1yXM;;IAEE,2BAAA;EtE4yXR;EsE1yXM;;IAEE,yBAAA;EtE4yXR;EsE3zXM;IAAgC,0BAAA;EtE8zXtC;EsE7zXM;;IAEE,8BAAA;EtE+zXR;EsE7zXM;;IAEE,gCAAA;EtE+zXR;EsE7zXM;;IAEE,iCAAA;EtE+zXR;EsE7zXM;;IAEE,+BAAA;EtE+zXR;EsE90XM;IAAgC,yBAAA;EtEi1XtC;EsEh1XM;;IAEE,6BAAA;EtEk1XR;EsEh1XM;;IAEE,+BAAA;EtEk1XR;EsEh1XM;;IAEE,gCAAA;EtEk1XR;EsEh1XM;;IAEE,8BAAA;EtEk1XR;EsEj2XM;IAAgC,uBAAA;EtEo2XtC;EsEn2XM;;IAEE,2BAAA;EtEq2XR;EsEn2XM;;IAEE,6BAAA;EtEq2XR;EsEn2XM;;IAEE,8BAAA;EtEq2XR;EsEn2XM;;IAEE,4BAAA;EtEq2XR;EsEp3XM;IAAgC,yBAAA;EtEu3XtC;EsEt3XM;;IAEE,6BAAA;EtEw3XR;EsEt3XM;;IAEE,+BAAA;EtEw3XR;EsEt3XM;;IAEE,gCAAA;EtEw3XR;EsEt3XM;;IAEE,8BAAA;EtEw3XR;EsEv4XM;IAAgC,uBAAA;EtE04XtC;EsEz4XM;;IAEE,2BAAA;EtE24XR;EsEz4XM;;IAEE,6BAAA;EtE24XR;EsEz4XM;;IAEE,8BAAA;EtE24XR;EsEz4XM;;IAEE,4BAAA;EtE24XR;EsE15XM;IAAgC,yBAAA;EtE65XtC;EsE55XM;;IAEE,6BAAA;EtE85XR;EsE55XM;;IAEE,+BAAA;EtE85XR;EsE55XM;;IAEE,gCAAA;EtE85XR;EsE55XM;;IAEE,8BAAA;EtE85XR;EsE76XM;IAAgC,wBAAA;EtEg7XtC;EsE/6XM;;IAEE,4BAAA;EtEi7XR;EsE/6XM;;IAEE,8BAAA;EtEi7XR;EsE/6XM;;IAEE,+BAAA;EtEi7XR;EsE/6XM;;IAEE,6BAAA;EtEi7XR;EsEh8XM;IAAgC,wBAAA;EtEm8XtC;EsEl8XM;;IAEE,4BAAA;EtEo8XR;EsEl8XM;;IAEE,8BAAA;EtEo8XR;EsEl8XM;;IAEE,+BAAA;EtEo8XR;EsEl8XM;;IAEE,6BAAA;EtEo8XR;EsEn9XM;IAAgC,0BAAA;EtEs9XtC;EsEr9XM;;IAEE,8BAAA;EtEu9XR;EsEr9XM;;IAEE,gCAAA;EtEu9XR;EsEr9XM;;IAEE,iCAAA;EtEu9XR;EsEr9XM;;IAEE,+BAAA;EtEu9XR;EsEt+XM;IAAgC,wBAAA;EtEy+XtC;EsEx+XM;;IAEE,4BAAA;EtE0+XR;EsEx+XM;;IAEE,8BAAA;EtE0+XR;EsEx+XM;;IAEE,+BAAA;EtE0+XR;EsEx+XM;;IAEE,6BAAA;EtE0+XR;EsEz/XM;IAAgC,0BAAA;EtE4/XtC;EsE3/XM;;IAEE,8BAAA;EtE6/XR;EsE3/XM;;IAEE,gCAAA;EtE6/XR;EsE3/XM;;IAEE,iCAAA;EtE6/XR;EsE3/XM;;IAEE,+BAAA;EtE6/XR;EsE5gYM;IAAgC,wBAAA;EtE+gYtC;EsE9gYM;;IAEE,4BAAA;EtEghYR;EsE9gYM;;IAEE,8BAAA;EtEghYR;EsE9gYM;;IAEE,+BAAA;EtEghYR;EsE9gYM;;IAEE,6BAAA;EtEghYR;EsE/hYM;IAAgC,0BAAA;EtEkiYtC;EsEjiYM;;IAEE,8BAAA;EtEmiYR;EsEjiYM;;IAEE,gCAAA;EtEmiYR;EsEjiYM;;IAEE,iCAAA;EtEmiYR;EsEjiYM;;IAEE,+BAAA;EtEmiYR;EsEljYM;IAAgC,2BAAA;EtEqjYtC;EsEpjYM;;IAEE,+BAAA;EtEsjYR;EsEpjYM;;IAEE,iCAAA;EtEsjYR;EsEpjYM;;IAEE,kCAAA;EtEsjYR;EsEpjYM;;IAEE,gCAAA;EtEsjYR;EsErkYM;IAAgC,yBAAA;EtEwkYtC;EsEvkYM;;IAEE,6BAAA;EtEykYR;EsEvkYM;;IAEE,+BAAA;EtEykYR;EsEvkYM;;IAEE,gCAAA;EtEykYR;EsEvkYM;;IAEE,8BAAA;EtEykYR;EsExlYM;IAAgC,uBAAA;EtE2lYtC;EsE1lYM;;IAEE,2BAAA;EtE4lYR;EsE1lYM;;IAEE,6BAAA;EtE4lYR;EsE1lYM;;IAEE,8BAAA;EtE4lYR;EsE1lYM;;IAEE,4BAAA;EtE4lYR;EsE3mYM;IAAgC,uBAAA;EtE8mYtC;EsE7mYM;;IAEE,2BAAA;EtE+mYR;EsE7mYM;;IAEE,6BAAA;EtE+mYR;EsE7mYM;;IAEE,8BAAA;EtE+mYR;EsE7mYM;;IAEE,4BAAA;EtE+mYR;EsE9nYM;IAAgC,wBAAA;EtEioYtC;EsEhoYM;;IAEE,4BAAA;EtEkoYR;EsEhoYM;;IAEE,8BAAA;EtEkoYR;EsEhoYM;;IAEE,+BAAA;EtEkoYR;EsEhoYM;;IAEE,6BAAA;EtEkoYR;EsEjpYM;IAAgC,qBAAA;EtEopYtC;EsEnpYM;;IAEE,yBAAA;EtEqpYR;EsEnpYM;;IAEE,2BAAA;EtEqpYR;EsEnpYM;;IAEE,4BAAA;EtEqpYR;EsEnpYM;;IAEE,0BAAA;EtEqpYR;EsEpqYM;IAAgC,2BAAA;EtEuqYtC;EsEtqYM;;IAEE,+BAAA;EtEwqYR;EsEtqYM;;IAEE,iCAAA;EtEwqYR;EsEtqYM;;IAEE,kCAAA;EtEwqYR;EsEtqYM;;IAEE,gCAAA;EtEwqYR;EsEvrYM;IAAgC,0BAAA;EtE0rYtC;EsEzrYM;;IAEE,8BAAA;EtE2rYR;EsEzrYM;;IAEE,gCAAA;EtE2rYR;EsEzrYM;;IAEE,iCAAA;EtE2rYR;EsEzrYM;;IAEE,+BAAA;EtE2rYR;EsE1sYM;IAAgC,wBAAA;EtE6sYtC;EsE5sYM;;IAEE,4BAAA;EtE8sYR;EsE5sYM;;IAEE,8BAAA;EtE8sYR;EsE5sYM;;IAEE,+BAAA;EtE8sYR;EsE5sYM;;IAEE,6BAAA;EtE8sYR;EsE7tYM;IAAgC,0BAAA;EtEguYtC;EsE/tYM;;IAEE,8BAAA;EtEiuYR;EsE/tYM;;IAEE,gCAAA;EtEiuYR;EsE/tYM;;IAEE,iCAAA;EtEiuYR;EsE/tYM;;IAEE,+BAAA;EtEiuYR;EsEhvYM;IAAgC,wBAAA;EtEmvYtC;EsElvYM;;IAEE,4BAAA;EtEovYR;EsElvYM;;IAEE,8BAAA;EtEovYR;EsElvYM;;IAEE,+BAAA;EtEovYR;EsElvYM;;IAEE,6BAAA;EtEovYR;EsEnwYM;IAAgC,0BAAA;EtEswYtC;EsErwYM;;IAEE,8BAAA;EtEuwYR;EsErwYM;;IAEE,gCAAA;EtEuwYR;EsErwYM;;IAEE,iCAAA;EtEuwYR;EsErwYM;;IAEE,+BAAA;EtEuwYR;EsEtxYM;IAAgC,yBAAA;EtEyxYtC;EsExxYM;;IAEE,6BAAA;EtE0xYR;EsExxYM;;IAEE,+BAAA;EtE0xYR;EsExxYM;;IAEE,gCAAA;EtE0xYR;EsExxYM;;IAEE,8BAAA;EtE0xYR;EsEzyYM;IAAgC,yBAAA;EtE4yYtC;EsE3yYM;;IAEE,6BAAA;EtE6yYR;EsE3yYM;;IAEE,+BAAA;EtE6yYR;EsE3yYM;;IAEE,gCAAA;EtE6yYR;EsE3yYM;;IAEE,8BAAA;EtE6yYR;EsE5zYM;IAAgC,2BAAA;EtE+zYtC;EsE9zYM;;IAEE,+BAAA;EtEg0YR;EsE9zYM;;IAEE,iCAAA;EtEg0YR;EsE9zYM;;IAEE,kCAAA;EtEg0YR;EsE9zYM;;IAEE,gCAAA;EtEg0YR;EsE/0YM;IAAgC,yBAAA;EtEk1YtC;EsEj1YM;;IAEE,6BAAA;EtEm1YR;EsEj1YM;;IAEE,+BAAA;EtEm1YR;EsEj1YM;;IAEE,gCAAA;EtEm1YR;EsEj1YM;;IAEE,8BAAA;EtEm1YR;EsEl2YM;IAAgC,2BAAA;EtEq2YtC;EsEp2YM;;IAEE,+BAAA;EtEs2YR;EsEp2YM;;IAEE,iCAAA;EtEs2YR;EsEp2YM;;IAEE,kCAAA;EtEs2YR;EsEp2YM;;IAEE,gCAAA;EtEs2YR;EsEr3YM;IAAgC,yBAAA;EtEw3YtC;EsEv3YM;;IAEE,6BAAA;EtEy3YR;EsEv3YM;;IAEE,+BAAA;EtEy3YR;EsEv3YM;;IAEE,gCAAA;EtEy3YR;EsEv3YM;;IAEE,8BAAA;EtEy3YR;EsEx4YM;IAAgC,2BAAA;EtE24YtC;EsE14YM;;IAEE,+BAAA;EtE44YR;EsE14YM;;IAEE,iCAAA;EtE44YR;EsE14YM;;IAEE,kCAAA;EtE44YR;EsE14YM;;IAEE,gCAAA;EtE44YR;EsE35YM;IAAgC,4BAAA;EtE85YtC;EsE75YM;;IAEE,gCAAA;EtE+5YR;EsE75YM;;IAEE,kCAAA;EtE+5YR;EsE75YM;;IAEE,mCAAA;EtE+5YR;EsE75YM;;IAEE,iCAAA;EtE+5YR;EsE96YM;IAAgC,0BAAA;EtEi7YtC;EsEh7YM;;IAEE,8BAAA;EtEk7YR;EsEh7YM;;IAEE,gCAAA;EtEk7YR;EsEh7YM;;IAEE,iCAAA;EtEk7YR;EsEh7YM;;IAEE,+BAAA;EtEk7YR;EsEj8YM;IAAgC,wBAAA;EtEo8YtC;EsEn8YM;;IAEE,4BAAA;EtEq8YR;EsEn8YM;;IAEE,8BAAA;EtEq8YR;EsEn8YM;;IAEE,+BAAA;EtEq8YR;EsEn8YM;;IAEE,6BAAA;EtEq8YR;EsEp9YM;IAAgC,wBAAA;EtEu9YtC;EsEt9YM;;IAEE,4BAAA;EtEw9YR;EsEt9YM;;IAEE,8BAAA;EtEw9YR;EsEt9YM;;IAEE,+BAAA;EtEw9YR;EsEt9YM;;IAEE,6BAAA;EtEw9YR;EsEv+YM;IAAgC,yBAAA;EtE0+YtC;EsEz+YM;;IAEE,6BAAA;EtE2+YR;EsEz+YM;;IAEE,+BAAA;EtE2+YR;EsEz+YM;;IAEE,gCAAA;EtE2+YR;EsEz+YM;;IAEE,8BAAA;EtE2+YR;EsEn+YM;IAAwB,2BAAA;EtEs+Y9B;EsEr+YM;;IAEE,+BAAA;EtEu+YR;EsEr+YM;;IAEE,iCAAA;EtEu+YR;EsEr+YM;;IAEE,kCAAA;EtEu+YR;EsEr+YM;;IAEE,gCAAA;EtEu+YR;EsEt/YM;IAAwB,0BAAA;EtEy/Y9B;EsEx/YM;;IAEE,8BAAA;EtE0/YR;EsEx/YM;;IAEE,gCAAA;EtE0/YR;EsEx/YM;;IAEE,iCAAA;EtE0/YR;EsEx/YM;;IAEE,+BAAA;EtE0/YR;EsEzgZM;IAAwB,wBAAA;EtE4gZ9B;EsE3gZM;;IAEE,4BAAA;EtE6gZR;EsE3gZM;;IAEE,8BAAA;EtE6gZR;EsE3gZM;;IAEE,+BAAA;EtE6gZR;EsE3gZM;;IAEE,6BAAA;EtE6gZR;EsE5hZM;IAAwB,0BAAA;EtE+hZ9B;EsE9hZM;;IAEE,8BAAA;EtEgiZR;EsE9hZM;;IAEE,gCAAA;EtEgiZR;EsE9hZM;;IAEE,iCAAA;EtEgiZR;EsE9hZM;;IAEE,+BAAA;EtEgiZR;EsE/iZM;IAAwB,wBAAA;EtEkjZ9B;EsEjjZM;;IAEE,4BAAA;EtEmjZR;EsEjjZM;;IAEE,8BAAA;EtEmjZR;EsEjjZM;;IAEE,+BAAA;EtEmjZR;EsEjjZM;;IAEE,6BAAA;EtEmjZR;EsElkZM;IAAwB,wBAAA;EtEqkZ9B;EsEpkZM;;IAEE,4BAAA;EtEskZR;EsEpkZM;;IAEE,8BAAA;EtEskZR;EsEpkZM;;IAEE,+BAAA;EtEskZR;EsEpkZM;;IAEE,6BAAA;EtEskZR;EsErlZM;IAAwB,uBAAA;EtEwlZ9B;EsEvlZM;;IAEE,2BAAA;EtEylZR;EsEvlZM;;IAEE,6BAAA;EtEylZR;EsEvlZM;;IAEE,8BAAA;EtEylZR;EsEvlZM;;IAEE,4BAAA;EtEylZR;EsExmZM;IAAwB,uBAAA;EtE2mZ9B;EsE1mZM;;IAEE,2BAAA;EtE4mZR;EsE1mZM;;IAEE,6BAAA;EtE4mZR;EsE1mZM;;IAEE,8BAAA;EtE4mZR;EsE1mZM;;IAEE,4BAAA;EtE4mZR;EsE3nZM;IAAwB,yBAAA;EtE8nZ9B;EsE7nZM;;IAEE,6BAAA;EtE+nZR;EsE7nZM;;IAEE,+BAAA;EtE+nZR;EsE7nZM;;IAEE,gCAAA;EtE+nZR;EsE7nZM;;IAEE,8BAAA;EtE+nZR;EsE9oZM;IAAwB,uBAAA;EtEipZ9B;EsEhpZM;;IAEE,2BAAA;EtEkpZR;EsEhpZM;;IAEE,6BAAA;EtEkpZR;EsEhpZM;;IAEE,8BAAA;EtEkpZR;EsEhpZM;;IAEE,4BAAA;EtEkpZR;EsEjqZM;IAAwB,yBAAA;EtEoqZ9B;EsEnqZM;;IAEE,6BAAA;EtEqqZR;EsEnqZM;;IAEE,+BAAA;EtEqqZR;EsEnqZM;;IAEE,gCAAA;EtEqqZR;EsEnqZM;;IAEE,8BAAA;EtEqqZR;EsEprZM;IAAwB,uBAAA;EtEurZ9B;EsEtrZM;;IAEE,2BAAA;EtEwrZR;EsEtrZM;;IAEE,6BAAA;EtEwrZR;EsEtrZM;;IAEE,8BAAA;EtEwrZR;EsEtrZM;;IAEE,4BAAA;EtEwrZR;EsEvsZM;IAAwB,yBAAA;EtE0sZ9B;EsEzsZM;;IAEE,6BAAA;EtE2sZR;EsEzsZM;;IAEE,+BAAA;EtE2sZR;EsEzsZM;;IAEE,gCAAA;EtE2sZR;EsEzsZM;;IAEE,8BAAA;EtE2sZR;EsE1tZM;IAAwB,0BAAA;EtE6tZ9B;EsE5tZM;;IAEE,8BAAA;EtE8tZR;EsE5tZM;;IAEE,gCAAA;EtE8tZR;EsE5tZM;;IAEE,iCAAA;EtE8tZR;EsE5tZM;;IAEE,+BAAA;EtE8tZR;EsE7uZM;IAAwB,0BAAA;EtEgvZ9B;EsE/uZM;;IAEE,8BAAA;EtEivZR;EsE/uZM;;IAEE,gCAAA;EtEivZR;EsE/uZM;;IAEE,iCAAA;EtEivZR;EsE/uZM;;IAEE,+BAAA;EtEivZR;EsEhwZM;IAAwB,wBAAA;EtEmwZ9B;EsElwZM;;IAEE,4BAAA;EtEowZR;EsElwZM;;IAEE,8BAAA;EtEowZR;EsElwZM;;IAEE,+BAAA;EtEowZR;EsElwZM;;IAEE,6BAAA;EtEowZR;EsEnxZM;IAAwB,wBAAA;EtEsxZ9B;EsErxZM;;IAEE,4BAAA;EtEuxZR;EsErxZM;;IAEE,8BAAA;EtEuxZR;EsErxZM;;IAEE,+BAAA;EtEuxZR;EsErxZM;;IAEE,6BAAA;EtEuxZR;EsEtyZM;IAAwB,yBAAA;EtEyyZ9B;EsExyZM;;IAEE,6BAAA;EtE0yZR;EsExyZM;;IAEE,+BAAA;EtE0yZR;EsExyZM;;IAEE,gCAAA;EtE0yZR;EsExyZM;;IAEE,8BAAA;EtE0yZR;EsEpyZE;IAAmB,uBAAA;EtEuyZrB;EsEtyZE;;IAEE,2BAAA;EtEwyZJ;EsEtyZE;;IAEE,6BAAA;EtEwyZJ;EsEtyZE;;IAEE,8BAAA;EtEwyZJ;EsEtyZE;;IAEE,4BAAA;EtEwyZJ;AACF;AuEz2ZE;EACE,kBAAA;EACA,MAAA;EACA,QAAA;EACA,SAAA;EACA,OAAA;EACA,UAAA;EAEA,oBAAA;EACA,WAAA;EAEA,kCAAA;AvEy2ZJ;;AwEn3ZA;EAAkB,4GAAA;AxEu3ZlB;;AwEn3ZA;EAAiB,8BAAA;AxEu3ZjB;;AwEt3ZA;EAAiB,8BAAA;AxE03ZjB;;AwEz3ZA;EAAiB,8BAAA;AxE63ZjB;;AwE53ZA;ECTE,gBAAA;EACA,uBAAA;EACA,mBAAA;AzEy4ZF;;AwE13ZI;EAAwB,2BAAA;AxE83Z5B;;AwE73ZI;EAAwB,4BAAA;AxEi4Z5B;;AwEh4ZI;EAAwB,6BAAA;AxEo4Z5B;;AgB/1ZI;EwDvCA;IAAwB,2BAAA;ExE24Z1B;EwE14ZE;IAAwB,4BAAA;ExE64Z1B;EwE54ZE;IAAwB,6BAAA;ExE+4Z1B;AACF;AgB32ZI;EwDvCA;IAAwB,2BAAA;ExEs5Z1B;EwEr5ZE;IAAwB,4BAAA;ExEw5Z1B;EwEv5ZE;IAAwB,6BAAA;ExE05Z1B;AACF;AgBt3ZI;EwDvCA;IAAwB,2BAAA;ExEi6Z1B;EwEh6ZE;IAAwB,4BAAA;ExEm6Z1B;EwEl6ZE;IAAwB,6BAAA;ExEq6Z1B;AACF;AgBj4ZI;EwDvCA;IAAwB,2BAAA;ExE46Z1B;EwE36ZE;IAAwB,4BAAA;ExE86Z1B;EwE76ZE;IAAwB,6BAAA;ExEg7Z1B;AACF;AwE36ZA;EAAmB,oCAAA;AxE86ZnB;;AwE76ZA;EAAmB,oCAAA;AxEi7ZnB;;AwEh7ZA;EAAmB,qCAAA;AxEo7ZnB;;AwEh7ZA;EAAuB,2BAAA;AxEo7ZvB;;AwEn7ZA;EAAuB,+BAAA;AxEu7ZvB;;AwEt7ZA;EAAuB,2BAAA;AxE07ZvB;;AwEz7ZA;EAAuB,2BAAA;AxE67ZvB;;AwE57ZA;EAAuB,8BAAA;AxEg8ZvB;;AwE/7ZA;EAAuB,6BAAA;AxEm8ZvB;;AwE/7ZA;EAAc,sBAAA;AxEm8Zd;;A0E1+ZE;EACE,yBAAA;A1E6+ZJ;;AMn+ZE;EoELM,mEAAA;A1E4+ZR;;A0El/ZE;EACE,yBAAA;A1Eq/ZJ;;AM3+ZE;EoELM,qEAAA;A1Eo/ZR;;A0E1/ZE;EACE,yBAAA;A1E6/ZJ;;AMn/ZE;EoELM,mEAAA;A1E4/ZR;;A0ElgaE;EACE,yBAAA;A1EqgaJ;;AM3/ZE;EoELM,kEAAA;A1EogaR;;A0E1gaE;EACE,yBAAA;A1E6gaJ;;AMngaE;EoELM,yDAAA;A1E4gaR;;A0ElhaE;EACE,yBAAA;A1EqhaJ;;AM3gaE;EoELM,mEAAA;A1EohaR;;A0E1haE;EACE,yBAAA;A1E6haJ;;AMnhaE;EoELM,6DAAA;A1E4haR;;A0EliaE;EACE,yBAAA;A1EqiaJ;;AM3haE;EoELM,uBAAA;A1EoiaR;;A0E1iaE;EACE,yBAAA;A1E6iaJ;;AMniaE;EoELM,gDAAA;A1E4iaR;;A0EljaE;EACE,sBAAA;A1EqjaJ;;AM3iaE;EoELM,6CAAA;A1EojaR;;A0E1jaE;EACE,sBAAA;A1E6jaJ;;AMnjaE;EoELM,6CAAA;A1E4jaR;;A0ElkaE;EACE,uBAAA;A1EqkaJ;;AM3jaE;EoELM,uBAAA;A1EokaR;;AwE7haA;EAAa,yBAAA;AxEiiab;;AwEhiaA;EAAc,yBAAA;AxEoiad;;AwEliaA;EAAiB,oCAAA;AxEsiajB;;AwEriaA;EAAiB,0CAAA;AxEyiajB;;AwEriaA;EGvDE,WAAA;EACA,kBAAA;EACA,iBAAA;EACA,6BAAA;EACA,SAAA;A3EgmaF;;AwEziaA;EAAwB,gCAAA;AxE6iaxB;;AwE3iaA;EACE,iCAAA;EACA,gCAAA;AxE8iaF;;AwEziaA;EAAc,yBAAA;AxE6iad;;A4E9maA;EACE,8BAAA;A5EinaF;;A4E9maA;EACE,6BAAA;A5EinaF;;A6EjnaE;EACE;;;IAKE,4BAAA;IAEA,2BAAA;E7EinaJ;E6E7maI;IACE,0BAAA;E7E+maN;E6EtmaE;IACE,6BAAA;E7EwmaJ;E6E1laE;IACE,gCAAA;E7E4laJ;E6E1laE;;IAEE,yBAAA;IACA,wBAAA;E7E4laJ;E6EplaE;IACE,2BAAA;E7EslaJ;E6EnlaE;;IAEE,wBAAA;E7EqlaJ;E6EllaE;;;IAGE,UAAA;IACA,SAAA;E7EolaJ;E6EjlaE;;IAEE,uBAAA;E7EmlaJ;E6E3kaE;IACE,QxE+hC8B;EL8iYlC;E6E3kaE;IACE,2BAAA;E7E6kaJ;E6E3kaE;IACE,2BAAA;E7E6kaJ;E6EzkaE;IACE,aAAA;E7E2kaJ;E6EzkaE;IACE,sBAAA;E7E2kaJ;E6ExkaE;IACE,oCAAA;E7E0kaJ;E6ExkaI;;IAEE,iCAAA;E7E0kaN;E6ErkaI;;IAEE,oCAAA;E7EukaN;E6EnkaE;IACE,cAAA;E7EqkaJ;E6EnkaI;;;;IAIE,qB1E/GG;EHoraT;E6EjkaE;IACE,cAAA;IACA,qB1ErHK;EHwraT;AACF;A8E3saA;EACE,SAAA;A9E6saF;;A8E1saA;;;EAGE,cAAA;A9E6saF;;A8E1saA;EACE,gBAAA;A9E6saF;;AwDttaE;EACE,oCAAA;AxDytaJ;;AM5saE;;;EkDRI,8EAAA;AxD0taN;;AwDhuaE;EACE,oCAAA;AxDmuaJ;;AMttaE;;;EkDRI,6EAAA;AxDouaN;;AwD1uaE;EACE,oCAAA;AxD6uaJ;;AMhuaE;;;EkDRI,+EAAA;AxD8uaN;;AwDpvaE;EACE,oCAAA;AxDuvaJ;;AM1uaE;;;EkDRI,+EAAA;AxDwvaN;;AwD9vaE;EACE,oCAAA;AxDiwaJ;;AMpvaE;;;EkDRI,8EAAA;AxDkwaN;;AwDxwaE;EACE,oCAAA;AxD2waJ;;AM9vaE;;;EkDRI,qEAAA;AxD4waN;;AwDlxaE;EACE,oCAAA;AxDqxaJ;;AMxwaE;;;EkDRI,+CAAA;AxDsxaN;;AwD5xaE;EACE,oCAAA;AxD+xaJ;;AMlxaE;;;EkDRI,8EAAA;AxDgyaN;;AwDtyaE;EACE,oCAAA;AxDyyaJ;;AM5xaE;;;EkDRI,8EAAA;AxD0yaN;;AwDhzaE;EACE,oCAAA;AxDmzaJ;;AMtyaE;;;EkDRI,wDAAA;AxDozaN;;AwD1zaE;EACE,iCAAA;AxD6zaJ;;AMhzaE;;;EkDRI,qDAAA;AxD8zaN;;AwDp0aE;EACE,oCAAA;AxDu0aJ;;AM1zaE;;;EkDRI,wDAAA;AxDw0aN;;AwD90aE;EACE,oCAAA;AxDi1aJ;;AMp0aE;;;EkDRI,6EAAA;AxDk1aN;;AwDx1aE;EACE,oCAAA;AxD21aJ;;AM90aE;;;EkDRI,uEAAA;AxD41aN;;AwDl2aE;EACE,oCAAA;AxDq2aJ;;AMx1aE;;;EkDRI,uEAAA;AxDs2aN;;AwDh2aE;EACE,sEAAA;AxDm2aJ;;AwDp2aE;EACE,sEAAA;AxDu2aJ;;AwDx2aE;EACE,sEAAA;AxD22aJ;;AwD52aE;EACE,sEAAA;AxD+2aJ;;AwDh3aE;EACE,sEAAA;AxDm3aJ;;AwDp3aE;EACE,sEAAA;AxDu3aJ;;AwDx3aE;EACE,sEAAA;AxD23aJ;;AwD53aE;EACE,sEAAA;AxD+3aJ;;AwDh4aE;EACE,sEAAA;AxDm4aJ;;AwDp4aE;EACE,iEAAA;AxDu4aJ;;AwDx4aE;EACE,iEAAA;AxD24aJ;;AwD54aE;EACE,kEAAA;AxD+4aJ;;AwDh5aE;EACE,sEAAA;AxDm5aJ;;AwDp5aE;EACE,sEAAA;AxDu5aJ;;AwDx5aE;EACE,sEAAA;AxD25aJ;;AwD55aE;EACE,sEAAA;AxD+5aJ;;AwDh6aE;EACE,sEAAA;AxDm6aJ;;AwDp6aE;EACE,sEAAA;AxDu6aJ;;AwDx6aE;EACE,sEAAA;AxD26aJ;;AwD56aE;EACE,sEAAA;AxD+6aJ;;AwDh7aE;EACE,sEAAA;AxDm7aJ;;AwDp7aE;EACE,sEAAA;AxDu7aJ;;AwDx7aE;EACE,iEAAA;AxD27aJ;;AwD57aE;EACE,sEAAA;AxD+7aJ;;AwDh8aE;EACE,sEAAA;AxDm8aJ;;AwDp8aE;EACE,sEAAA;AxDu8aJ;;AwDx8aE;EACE,sEAAA;AxD28aJ;;AwDh7aE;EACE,wBAAA;AxDm7aJ;;AwDp7aE;EACE,wBAAA;AxDu7aJ;;AwDx7aE;EACE,wBAAA;AxD27aJ;;AwD57aE;EACE,wBAAA;AxD+7aJ;;AwDh8aE;EACE,wBAAA;AxDm8aJ;;AwDp8aE;EACE,wBAAA;AxDu8aJ;;AwDx8aE;EACE,wBAAA;AxD28aJ;;AwD58aE;EACE,wBAAA;AxD+8aJ;;AwDh9aE;EACE,wBAAA;AxDm9aJ;;AwDp9aE;EACE,qBAAA;AxDu9aJ;;AwDx9aE;EACE,qBAAA;AxD29aJ;;AwD59aE;EACE,sBAAA;AxD+9aJ;;AwDxgbE;EACE,oCAAA;AxD2gbJ;;AM9/aE;;;EkDRI,0DAAA;AxD4gbN;;AwDlhbE;EACE,oCAAA;AxDqhbJ;;AMxgbE;;;EkDRI,gFAAA;AxDshbN;;AwD5hbE;EACE,oCAAA;AxD+hbJ;;AMlhbE;;;EkDRI,uEAAA;AxDgibN;;AwDtibE;EACE,oCAAA;AxDyibJ;;AM5hbE;;;EkDRI,oEAAA;AxD0ibN;;AwDhjbE;EACE,kCAAA;AxDmjbJ;;AMtibE;;;EkDRI,kCAAA;AxDojbN;;AwD9ibE;EACE,sEAAA;AxDijbJ;;AwDljbE;EACE,sEAAA;AxDqjbJ;;AwDtjbE;EACE,sEAAA;AxDyjbJ;;AwD1jbE;EACE,sEAAA;AxD6jbJ;;AwD9jbE;EACE,sEAAA;AxDikbJ;;AwDlkbE;EACE,sEAAA;AxDqkbJ;;AwDtkbE;EACE,sEAAA;AxDykbJ;;AwD1kbE;EACE,sEAAA;AxD6kbJ;;AwD9kbE;EACE,sEAAA;AxDilbJ;;AwDllbE;EACE,iEAAA;AxDqlbJ;;AwDtlbE;EACE,iEAAA;AxDylbJ;;AwD1lbE;EACE,kEAAA;AxD6lbJ;;A+EzkbE;EACE,a1EwCW;ALoibf;;A+EzkbE;EACE,e1EoCW;ALwibf;;A+EjlbE;EACE,a1EwCW;AL4ibf;;A+EjlbE;EACE,e1EoCW;ALgjbf;;A+EzlbE;EACE,a1EwCW;ALojbf;;A+EzlbE;EACE,e1EoCW;ALwjbf;;A+EjmbE;EACE,a1EwCW;AL4jbf;;A+EjmbE;EACE,e1EoCW;ALgkbf;;A+EzmbE;EACE,a1EwCW;ALokbf;;A+EzmbE;EACE,e1EoCW;ALwkbf;;A+EjnbE;EACE,a1EwCW;AL4kbf;;A+EjnbE;EACE,e1EoCW;ALglbf;;A+EznbE;EACE,a1EwCW;ALolbf;;A+EznbE;EACE,e1EoCW;ALwlbf;;A+EjobE;EACE,a1EwCW;AL4lbf;;A+EjobE;EACE,e1EoCW;ALgmbf;;A+EzobE;EACE,a1EwCW;ALombf;;A+EzobE;EACE,e1EoCW;ALwmbf;;A+EjpbE;EACE,U1EwCW;AL4mbf;;A+EjpbE;EACE,Y1EoCW;ALgnbf;;A+EzpbE;EACE,U1EwCW;ALonbf;;A+EzpbE;EACE,Y1EoCW;ALwnbf;;A+EjqbE;EACE,W1EwCW;AL4nbf;;A+EjqbE;EACE,a1EoCW;ALgobf;;A+EhqbA;EACE,iBAAA;A/EmqbF;;AgF3sbA;EACE,oCAAA;EACA,sBAAA;AhF8sbF;AgF5sbE;EACE,4BAAA;AhF8sbJ;;AgFxsbA;EACE,uCAAA;AhF2sbF;;AgFxsbA;EACE,uCAAA;AhF2sbF;;AgFtsbA;EACE;IACE,0BAAA;EhFysbF;EgFvsbA;IACE,2BAAA;EhFysbF;EgFvsbA;IACE,0BAAA;EhFysbF;AACF;AgFtsbA;EACE;IACE,0BAAA;EhFwsbF;EgFtsbA;IACE,2BAAA;EhFwsbF;EgFtsbA;IACE,0BAAA;EhFwsbF;AACF;AgFrsbA;EACE;IACE,0BAAA;EhFusbF;EgFrsbA;IACE,0BAAA;EhFusbF;EgFrsbA;IACE,0BAAA;EhFusbF;AACF;AiF1vbE;EAEE,WAAA;EACA,cAAA;AjF2vbJ;AiFzvbE;EACE,WAAA;AjF2vbJ;;AkFrwbA;EACE,cAAA;EACA,iBAAA;EACA,kBAAA;AlFwwbF;;AmF1wbA;EACE,uBAAA;AnF6wbF;;AmF3wbA;EACE,uBAAA;AnF8wbF;;AmF5wbA;EACE,uBAAA;AnF+wbF;;AmF7wbA;EACE,uBAAA;AnFgxbF;;AmF9wbA;EACE,uBAAA;AnFixbF;;AmF/wbA;EACE,uBAAA;AnFkxbF;;AmFhxbA;EACE,uBAAA;AnFmxbF;;AmFjxbA;EACE,uBAAA;AnFoxbF;;AmFlxbA;EACE,uBAAA;AnFqxbF;;AmFnxbA;EACE,qBAAA;AnFsxbF;;AoFnzbA;EACE,4BAAA;ApFszbF;;AoFnzbA;EACE,2BAAA;ApFszbF;;AqFxzbE;EACE,MhFiIM;AL0rbV;;AqFzzbE;EACE,QhF8HM;AL8rbV;;AqF1zbE;EACE,ShF2HM;ALksbV;;AqF3zbE;EACE,OhFwHM;ALssbV;;AqFx0bE;EACE,YhFiIM;AL0sbV;;AqFz0bE;EACE,chF8HM;AL8sbV;;AqF10bE;EACE,ehF2HM;ALktbV;;AqF30bE;EACE,ahFwHM;ALstbV;;AqFx1bE;EACE,WhFiIM;AL0tbV;;AqFz1bE;EACE,ahF8HM;AL8tbV;;AqF11bE;EACE,chF2HM;ALkubV;;AqF31bE;EACE,YhFwHM;ALsubV;;AqFx2bE;EACE,ShFiIM;AL0ubV;;AqFz2bE;EACE,WhF8HM;AL8ubV;;AqF12bE;EACE,YhF2HM;ALkvbV;;AqF32bE;EACE,UhFwHM;ALsvbV;;AqFx3bE;EACE,WhFiIM;AL0vbV;;AqFz3bE;EACE,ahF8HM;AL8vbV;;AqF13bE;EACE,chF2HM;ALkwbV;;AqF33bE;EACE,YhFwHM;ALswbV;;AqFx4bE;EACE,ShFiIM;AL0wbV;;AqFz4bE;EACE,WhF8HM;AL8wbV;;AqF14bE;EACE,YhF2HM;ALkxbV;;AqF34bE;EACE,UhFwHM;ALsxbV;;AqFx5bE;EACE,WhFiIM;AL0xbV;;AqFz5bE;EACE,ahF8HM;AL8xbV;;AqF15bE;EACE,chF2HM;ALkybV;;AqF35bE;EACE,YhFwHM;ALsybV;;AqFx6bE;EACE,UhFiIM;AL0ybV;;AqFz6bE;EACE,YhF8HM;AL8ybV;;AqF16bE;EACE,ahF2HM;ALkzbV;;AqF36bE;EACE,WhFwHM;ALszbV;;AqFx7bE;EACE,UhFiIM;AL0zbV;;AqFz7bE;EACE,YhF8HM;AL8zbV;;AqF17bE;EACE,ahF2HM;ALk0bV;;AqF37bE;EACE,WhFwHM;ALs0bV;;AqFx8bE;EACE,YhFiIM;AL00bV;;AqFz8bE;EACE,chF8HM;AL80bV;;AqF18bE;EACE,ehF2HM;ALk1bV;;AqF38bE;EACE,ahFwHM;ALs1bV;;AqFx9bE;EACE,UhFiIM;AL01bV;;AqFz9bE;EACE,YhF8HM;AL81bV;;AqF19bE;EACE,ahF2HM;ALk2bV;;AqF39bE;EACE,WhFwHM;ALs2bV;;AqFx+bE;EACE,YhFiIM;AL02bV;;AqFz+bE;EACE,chF8HM;AL82bV;;AqF1+bE;EACE,ehF2HM;ALk3bV;;AqF3+bE;EACE,ahFwHM;ALs3bV;;AqFx/bE;EACE,UhFiIM;AL03bV;;AqFz/bE;EACE,YhF8HM;AL83bV;;AqF1/bE;EACE,ahF2HM;ALk4bV;;AqF3/bE;EACE,WhFwHM;ALs4bV;;AqFxgcE;EACE,YhFiIM;AL04bV;;AqFzgcE;EACE,chF8HM;AL84bV;;AqF1gcE;EACE,ehF2HM;ALk5bV;;AqF3gcE;EACE,ahFwHM;ALs5bV;;AqFxhcE;EACE,ahFiIM;AL05bV;;AqFzhcE;EACE,ehF8HM;AL85bV;;AqF1hcE;EACE,gBhF2HM;ALk6bV;;AqF3hcE;EACE,chFwHM;ALs6bV;;AqFxicE;EACE,WhFiIM;AL06bV;;AqFzicE;EACE,ahF8HM;AL86bV;;AqF1icE;EACE,chF2HM;ALk7bV;;AqF3icE;EACE,YhFwHM;ALs7bV;;AqFxjcE;EACE,ShFiIM;AL07bV;;AqFzjcE;EACE,WhF8HM;AL87bV;;AqF1jcE;EACE,YhF2HM;ALk8bV;;AqF3jcE;EACE,UhFwHM;ALs8bV;;AqFxkcE;EACE,ShFiIM;AL08bV;;AqFzkcE;EACE,WhF8HM;AL88bV;;AqF1kcE;EACE,YhF2HM;ALk9bV;;AqF3kcE;EACE,UhFwHM;ALs9bV;;AqFxlcE;EACE,UhFiIM;AL09bV;;AqFzlcE;EACE,YhF8HM;AL89bV;;AqF1lcE;EACE,ahF2HM;ALk+bV;;AqF3lcE;EACE,WhFwHM;ALs+bV;;AqF1lcA;EACE,SAAA;EACA,2BAAA;ArF6lcF;;AsFhncA;EACE,wBAAA;AtFmncF;;AuFpncA;EACE,gBAAA;AvFuncF;;AgBhkcI;EuEnDF;IACE,aAAA;EvFuncF;AACF;AgBtkcI;EuE9CF;IACE,aAAA;EvFuncF;AACF;AgB3kcI;EuEzCF;IACE,aAAA;EvFuncF;AACF;AuFpncA;EACE,gBAAA;AvFsncF;;AuFjncA;EASE;IACE,6BAAA;EvF4mcF;EuF1mcA;IACE,+BAAA;EvF4mcF;EuF1mcA;IACE,gCAAA;EvF4mcF;EuF1mcA;IACE,8BAAA;EvF4mcF;EuF1mcA;IACE,6BAAA;EvF4mcF;EuF1mcA;IACE,gCAAA;EvF4mcF;EuF1mcA;IACE,6BAAA;EvF4mcF;EuF1mcA;IACE,gCAAA;EvF4mcF;EuF1mcA;IACE,6BAAA;EvF4mcF;EuF1mcA;IACE,gCAAA;EvF4mcF;EuFvmcA;IACE,6BAAA;EvFymcF;EuFvmcA;IACE,gCAAA;EvFymcF;EuFvmcA;IACE,6BAAA;EvFymcF;EuFvmcA;IACE,gCAAA;EvFymcF;EuFvmcA;IACE,6BAAA;EvFymcF;EuFvmcA;IACE,gCAAA;EvFymcF;EuFvmcA;IACE,6BAAA;EvFymcF;EuFvmcA;IACE,gCAAA;EvFymcF;EuFvmcA;IACE,6BAAA;EvFymcF;EuFvmcA;IACE,gCAAA;EvFymcF;AACF;AwFzscA;EAEI,0BrF6Uc;AH63blB;;AwFrscA;EACE,4DAAA;AxFwscF;;AwFrscA;EACE,2DAAA;AxFwscF;;AwFrscA;EACE,0DAAA;AxFwscF;;AwFrscA;EACE,2BAAA;AxFwscF;;AyF/tcA;EACE,2BAAA;AzFkucF;;AyFhucA;EACE,2BAAA;AzFmucF;;AyFjucA;EACE,2BAAA;AzFoucF;;AyFlucA;EACE,2BAAA;AzFqucF;;AyFnucA;EACE,2BAAA;AzFsucF;;AyFpucA;EACE,2BAAA;AzFuucF;;AyFrucA;EACE,2BAAA;AzFwucF;;AyFnucA;EACE,0BAAA;AzFsucF;;AyFpucA;EACE,6BAAA;AzFuucF;;AyFlucA;EACE,6BAAA;AzFqucF;;AyFnucA;EACE,8BAAA;AzFsucF;;AyFpucA;EACE,6BAAA;AzFuucF;;AyFrucA;EACE,4BAAA;AzFwucF;;AyFnucA;EACE,cAAA;AzFsucF;;AyFpucA;EACE,gBAAA;AzFuucF;;AyFrucA;EACE,gBAAA;AzFwucF;;AyFtucA;EACE,gBAAA;AzFyucF;;AyFvucA;EACE,gBAAA;AzF0ucF;;AyFxucA;EACE,gBAAA;AzF2ucF;;AyFzucA;EACE,gBAAA;AzF4ucF;;AyF1ucA;EACE,gBAAA;AzF6ucF;;AyF3ucA;EACE,gBAAA;AzF8ucF;;AyFzucA;EACE,yBAAA;AzF4ucF;;AyF1ucA;EACE,0BAAA;AzF6ucF;;AyF3ucA;EACE,wBAAA;AzF8ucF;;A0Eh0cE;EACE,yBAAA;A1Em0cJ;;AMzzcE;EoELM,mEAAA;A1Ek0cR;;A0Ex0cE;EACE,yBAAA;A1E20cJ;;AMj0cE;EoELM,iEAAA;A1E00cR;;A0Eh1cE;EACE,yBAAA;A1Em1cJ;;AMz0cE;EoELM,mEAAA;A1Ek1cR;;A0Ex1cE;EACE,yBAAA;A1E21cJ;;AMj1cE;EoELM,oEAAA;A1E01cR;;A0Eh2cE;EACE,yBAAA;A1Em2cJ;;AMz1cE;EoELM,mEAAA;A1Ek2cR;;A0Ex2cE;EACE,yBAAA;A1E22cJ;;AMj2cE;EoELM,yDAAA;A1E02cR;;A0Eh3cE;EACE,yBAAA;A1Em3cJ;;AMz2cE;EoELM,sCAAA;A1Ek3cR;;A0Ex3cE;EACE,yBAAA;A1E23cJ;;AMj3cE;EoELM,mEAAA;A1E03cR;;A0Eh4cE;EACE,yBAAA;A1Em4cJ;;AMz3cE;EoELM,kEAAA;A1Ek4cR;;A0Ex4cE;EACE,yBAAA;A1E24cJ;;AMj4cE;EoELM,8CAAA;A1E04cR;;A0Eh5cE;EACE,sBAAA;A1Em5cJ;;AMz4cE;EoELM,6CAAA;A1Ek5cR;;A0Ex5cE;EACE,yBAAA;A1E25cJ;;AMj5cE;EoELM,+CAAA;A1E05cR;;A0Eh6cE;EACE,yBAAA;A1Em6cJ;;AMz5cE;EoELM,kEAAA;A1Ek6cR;;A0Ex6cE;EACE,yBAAA;A1E26cJ;;AMj6cE;EoELM,6DAAA;A1E06cR;;A0Eh7cE;EACE,yBAAA;A1Em7cJ;;AMz6cE;EoELM,6DAAA;A1Ek7cR;;AgBj4cI;E0EvDF;IACE,kFAAA;E1F47cF;E0Fz7cA;IACE,kFAAA;E1F27cF;AACF;A2Fl8cA;EACE,mBxF6Va;AHumcf;;A2F/7cA;EACE,gBxF4ViB;EwF3VjB,oBxFqWa;EwFpWb,mBAAA;A3Fk8cF;;A2F97cA;EACE,kBAAA;EACA,qBAAA;EACA,qBAAA;EACA,sBAAA;A3Fi8cF;A2F/7cE;EACE,kBAAA;EACA,QAAA;A3Fi8cJ;;A2F57cA;EACE,qBAAA;EACA,sBAAA;A3F+7cF;;A2Fz7cE;EACE,WxFvBI;EwFwBJ,kDAAA;A3F47cJ;;A4F/9cE;EACE,QAAA;EACA,azF6wBc;EyF5wBd,UAAA;EACA,2BAAA;EACA,+BAAA;EACA,UAAA;A5Fk+cJ;A4Fh+cI;EAEE,+BAAA;EACA,qBAAA;A5Fi+cN;AgBx6cI;E4EpEF;IAeI,SAAA;IACA,aAAA;E5Fi+cJ;AACF;A4F/9cI;EACE,iBAAA;EACA,6BAAA;EACA,+BAAA;A5Fi+cN;A4F59cM;EACE,6BAAA;EACA,+BAAA;A5F89cR;;A6Ft9cA;EACE,WAAA;EACA,YAAA;EACA,kBAAA;EACA,yBAAA;EACA,gBAAA;A7Fy9cF;A6Fx9cE;EACE,WAAA;EACA,YAAA;A7F09cJ;;A8FtgdA;EACE,yB3Fs1BoB;AHmrbtB;A8FvgdE;EACE,W3FMI;AHmgdR;;A8FngdA;EACE,mBAAA;A9FsgdF;;A8FngdA;EACE,uBAAA;A9FsgdF;;A8FjgdA;EACE,sBAAA;A9FogdF;A8FlgdE;EACE,QAAA;EACA,kBAAA;A9FogdJ;A8FlgdI;EACE,0BAAA;A9FogdN;;A8F3/cI;EACE,mBAAA;A9F8/cN;A8F5/cI;EACE,oBAAA;A9F8/cN;;A+FvidA;EACE,kBAAA;EACA,oBAAA;EACA,mBAAA;EACA,uBAAA;EACA,kBAAA;EACA,WAAA;EACA,YAAA;EACA,mBAAA;A/F0idF;;AgGljdA;EACE,eAAA;EACA,gBAAA;EACA,uBAAA;EACA,gB7F4VmB;E6F3VnB,mB7FuVa;E6FtVb,oBAAA;AhGqjdF;AgGnjdE;EACE,c7FSO;AH4idX;AgGljdE;EACE,qBAAA;EACA,sBAAA;EACA,eAAA;EACA,gBAAA;EACA,kBAAA;EACA,sBAAA;AhGojdJ;AgGhjdI;EACE,aAAA;EACA,cAAA;AhGkjdN;AgG7idI;EACE,eAAA;EACA,gBAAA;AhG+idN;;AiG9kdA;EACE,kBAAA;EACA,oB9F0fmB;E8FzfnB,0B9F2UgB;E8F1UhB,uB9F0fmB;E8FzfnB,mB9FkeoB;E8FjepB,sBAAA;AjGildF;AiG/kdE;ErFEI,2EqFDF;AjGildJ;AiG7kdE;EACE,oBAAA;AjG+kdJ;AiG1kdE;;EAEE,mBAAA;AjG4kdJ;AiGzkdE;;EAEE,oBAAA;AjG2kdJ;;AiGnkdE;;EACE,eAAA;EACA,wBAAA;AjGukdJ;;AiGjkdA;EACE,kB9F2buB;AHyoczB;;AiGjkdA;EACE,mB9FybuB;AH2oczB;;AiG9jdA;EACE,iBAAA;AjGikdF;;AiG9jdA;EACE,yDAAA;AjGikdF;;AiG7jdE;EACE,kBAAA;EACA,QAAA;AjGgkdJ;;AiG5jdA;EACE,gB9FqbgB;E8FpbhB,gBAAA;AjG+jdF;AiG7jdE;EACE,gBAAA;EACA,eAAA;AjG+jdJ;;AiG3jdA;EACE,cAAA;AjG8jdF;;AkG7odI;EACE,WAAA;AlGgpdN;AkG5odE;EACE,mBAAA;AlG8odJ;AkG3odE;EACE,oBAAA;AlG6odJ;;AkGvodA;EACE,eAAA;EACA,gBAAA;EACA,UAAA;AlG0odF;;AkGvodA;EACE,gBAAA;AlG0odF;;AkGvodA;EACE,WAAA;EACA,YAAA;AlG0odF;;AkGlodA;EACE,SAAA;EACA,eAAA;EACA,e/FkTe;E+FjTf,gB/FwTmB;E+FvTnB,iBAAA;EACA,c/FxBS;E+FyBT,yB/FhCS;E+FiCT,uB/F+Qc;E+F9Qd,SAAA;EACA,gBAAA;EACA,oBAAA;EACA,qBAAA;EACA,sBAAA;EACA,qBAAA;EACA,qBAAA;EACA,eAAA;EACA,WAAA;EACA,gBAAA;AlGqodF;AkGnodE;EACE,sB/F/CI;E+FgDJ,uEACE;AlGoodN;AkGhodE;EACE,mBAAA;EACA,aAAA;AlGkodJ;AkG/ndE;EACE,uBAAA;EACA,cAAA;EACA,sBAAA;EACA,iBAAA;AlGiodJ;AkG9ndE;EACE,qBAAA;EACA,mBAAA;EACA,gBAAA;EACA,iBAAA;EACA,gBAAA;EACA,mBAAA;EACA,uBAAA;EACA,sBAAA;AlGgodJ;;AmGltdE;E1ECA,WAAA;EFFE,yBpBgHW;EsB5Gb,qBtB4Ga;EStGT,2EaLJ;AzBqtdF;AMptdE;EmBEE,WAAA;EFRA,yBEHiB;EAajB,qBAZa;AzBiudjB;AyBltdE;EAII,2GACE;AzBgtdR;AyB1sdE;EAEE,WAAA;EACA,yBtBqFW;EsBpFX,qBtBoFW;AHundf;AyBxsdE;EAGE,WAAA;EACA,mEApCkB;EAwClB,qBAvCc;AzB4udlB;AyBnsdI;EAGI,gDACE;AzBksdV;;AmG9udE;E1ECA,WAAA;EFFE,yBpBgHW;EsB5Gb,qBtB4Ga;EStGT,2EaLJ;AzBivdF;AMhvdE;EmBEE,WAAA;EFRA,yBEHiB;EAajB,qBAZa;AzB6vdjB;AyB9udE;EAII,4GACE;AzB4udR;AyBtudE;EAEE,WAAA;EACA,yBtBqFW;EsBpFX,qBtBoFW;AHmpdf;AyBpudE;EAGE,WAAA;EACA,oEApCkB;EAwClB,qBAvCc;AzBwwdlB;AyB/tdI;EAGI,iDACE;AzB8tdV;;AmG1wdE;E1ECA,WAAA;EFFE,yBpBgHW;EsB5Gb,qBtB4Ga;EStGT,2EaLJ;AzB6wdF;AM5wdE;EmBEE,WAAA;EFRA,yBEHiB;EAajB,qBAZa;AzByxdjB;AyB1wdE;EAII,2GACE;AzBwwdR;AyBlwdE;EAEE,WAAA;EACA,yBtBqFW;EsBpFX,qBtBoFW;AH+qdf;AyBhwdE;EAGE,WAAA;EACA,mEApCkB;EAwClB,qBAvCc;AzBoydlB;AyB3vdI;EAGI,gDACE;AzB0vdV;;AmGtydE;E1ECA,WAAA;EFFE,yBpBgHW;EsB5Gb,qBtB4Ga;EStGT,2EaLJ;AzByydF;AMxydE;EmBEE,WAAA;EFRA,yBEHiB;EAajB,qBAZa;AzBqzdjB;AyBtydE;EAII,2GACE;AzBoydR;AyB9xdE;EAEE,WAAA;EACA,yBtBqFW;EsBpFX,qBtBoFW;AH2sdf;AyB5xdE;EAGE,WAAA;EACA,kEApCkB;EAwClB,qBAvCc;AzBg0dlB;AyBvxdI;EAGI,gDACE;AzBsxdV;;AmGl0dE;E1ECA,WAAA;EFFE,yBpBgHW;EsB5Gb,qBtB4Ga;EStGT,2EaLJ;AzBq0dF;AMp0dE;EmBEE,WAAA;EFRA,yBEHiB;EAajB,qBAZa;AzBi1djB;AyBl0dE;EAII,0GACE;AzBg0dR;AyB1zdE;EAEE,WAAA;EACA,yBtBqFW;EsBpFX,qBtBoFW;AHuudf;AyBxzdE;EAGE,WAAA;EACA,kEApCkB;EAwClB,qBAvCc;AzB41dlB;AyBnzdI;EAGI,+CACE;AzBkzdV;;AmG91dE;E1ECA,WAAA;EFFE,yBpBgHW;EsB5Gb,qBtB4Ga;EStGT,2EaLJ;AzBi2dF;AMh2dE;EmBEE,WAAA;EFRA,yBEHiB;EAajB,qBAZa;AzB62djB;AyB91dE;EAII,2GACE;AzB41dR;AyBt1dE;EAEE,WAAA;EACA,yBtBqFW;EsBpFX,qBtBoFW;AHmwdf;AyBp1dE;EAGE,WAAA;EACA,mEApCkB;EAwClB,qBAvCc;AzBw3dlB;AyB/0dI;EAGI,gDACE;AzB80dV;;AmG13dE;E1ECA,WAAA;EFFE,yBpBgHW;EsB5Gb,qBtB4Ga;EStGT,2EaLJ;AzB63dF;AM53dE;EmBEE,WAAA;EFRA,yBEHiB;EAajB,qBAZa;AzBy4djB;AyB13dE;EAII,4GACE;AzBw3dR;AyBl3dE;EAEE,WAAA;EACA,yBtBqFW;EsBpFX,qBtBoFW;AH+xdf;AyBh3dE;EAGE,WAAA;EACA,gEApCkB;EAwClB,qBAvCc;AzBo5dlB;AyB32dI;EAGI,iDACE;AzB02dV;;AmGt5dE;E1ECA,WAAA;EFFE,yBpBgHW;EsB5Gb,qBtB4Ga;EStGT,2EaLJ;AzBy5dF;AMx5dE;EmBEE,WAAA;EFRA,yBEHiB;EAajB,qBAZa;AzBq6djB;AyBt5dE;EAII,4GACE;AzBo5dR;AyB94dE;EAEE,WAAA;EACA,yBtBqFW;EsBpFX,qBtBoFW;AH2zdf;AyB54dE;EAGE,WAAA;EACA,8CApCkB;EAwClB,qBAvCc;AzBg7dlB;AyBv4dI;EAGI,iDACE;AzBs4dV;;AmGl7dE;E1ECA,WAAA;EFFE,yBpBgHW;EsB5Gb,qBtB4Ga;EStGT,2EaLJ;AzBq7dF;AMp7dE;EmBEE,WAAA;EFRA,yBEHiB;EAajB,qBAZa;AzBi8djB;AyBl7dE;EAII,0GACE;AzBg7dR;AyB16dE;EAEE,WAAA;EACA,yBtBqFW;EsBpFX,qBtBoFW;AHu1df;AyBx6dE;EAGE,WAAA;EACA,oCApCkB;EAwClB,qBAvCc;AzB48dlB;AyBn6dI;EAGI,+CACE;AzBk6dV;;AoGj9dA;EACE,yCAAA;ApGo9dF;;AqGr9dA;EACE,kBAAA;ArGw9dF;AqGt9dE;EACE,gBAAA;EACA,uBlGwTY;EkGtTZ,gCAAA;EACA,kBAAA;EACA,SAAA;EACA,0BlGsUc;AHipdlB;AqGr9dI;EACE,gCAAA;ArGu9dN;;AqGl9dA;EACE,eAAA;ArGq9dF;AqGn9dE;EACE,kBAAA;EACA,kBAAA;EACA,iBAAA;ArGq9dJ;AqGn9dI;EACE,eAAA;ArGq9dN;AqGl9dI;EACE,iBAAA;EACA,iBAAA;EACA,cAAA;ArGo9dN;AqGl9dI;EACE,mBAAA;EACA,clGpBK;AHw+dX;;AqG/8dA;EACE,iBAAA;ArGk9dF;;AsG5/dE;EACE,4BAAA;EjFUE,0BiFTF;AtG+/dJ;AqBl/dM;EiFfJ;IjFgBM,gBAAA;ErBq/dN;AACF;;AuGtgeE;EACE,oBAAA;AvGygeJ;AuGtgeE;EACE,kBAAA;EACA,MAAA;EACA,QAAA;EACA,+BAAA;AvGwgeJ;;AwGjheA;EACE,kBAAA;EACA,arGooBa;AHg5cf;;AwG/geA;EACE,arG+nBgB;AHm5clB;;AwG7geA;EACE,aAAA;EACA,uBAAA;EACA,kBrGynBwB;EqGxnBxB,mBrG6Ua;EqG5Ub,kBAAA;EACA,crGDS;AHiheX;;AwG7geA;EACE,oBAAA;EACA,mBAAA;AxGgheF;AwG9geE;EACE,iBAAA;AxGgheJ;;AwG5geA;EACE,qBAAA;EACA,aAAA;EACA,cAAA;EACA,sBAAA;EACA,kBAAA;AxG+geF;;AwG1geA;EACE,UAAA;AxG6geF;AwG3geE;EACE,SAAA;EACA,SAAA;EACA,+CAAA;AxG6geJ;;AwGvgeA;EACE,kBAAA;EACA,MAAA;EACA,QAAA;EACA,gBAAA;EACA,aAAA;EACA,UAAA;AxG0geF;;AyGrkeA;EAEI,0BtG8Uc;AHyvdlB;AyGpkeE;EACE,6BtG6yBO;EsG5yBP,yBtG8yBU;EsG7yBV,iBAAA;EACA,eAAA;EACA,cAAA;EACA,kBAAA;EACA,kBAAA;EACA,cAAA;EAEE,0BtGiUY;AHowdlB;AyGjkeE;EAEE,6BtG+xBa;EsG9xBb,yBtGgyBgB;EsG/xBhB,aAAA;AzGkkeJ;AyGhkeI;EACE,6BtG0xBW;AHwycjB;;AyG9jeA;EACE,eAAA;AzGikeF;;AyG9jeA;EACE,kBAAA;EACA,UAAA;AzGikeF;;AyG9jeA;EACE,kBAAA;EACA,eAAA;EACA,UAAA;AzGikeF;;AyG9jeA;EACE,WAAA;EACA,kBAAA;EACA,qBAAA;EACA,wBAAA;EACA,WAAA;EACA,YAAA;EACA,iBAAA;EACA,sBAAA;AzGikeF;;AyG9jeA;EACE,mBAAA;AzGikeF;;AyG9jeA;EACE,mBAAA;AzGikeF;;AyG9jeA;EACE,cAAA;EACA,YAAA;AzGikeF;;AyG9jeA;EACE,gBAAA;EACA,gBAAA;AzGikeF;;AyG9jeA;EACE,WAAA;EACA,kBAAA;EACA,SAAA;EACA,QAAA;EACA,iBAAA;EACA,UAAA;EACA,WAAA;EACA,gHACE;EAMF,wBAAA;AzG2jeF;;A0GtpeA;EACE,kBAAA;EACA,sBCDS;EDET,kBAAA;A1GypeF;A0GxpeE;EACE,kBAAA;EACA,OAAA;EACA,MAAA;EACA,WAAA;EACA,UAAA;EACA,sBCTO;EDUP,0BAAA;EACA,2BAAA;A1G0peJ;A0GzpeI;EACE,eAAA;EACA,gBAAA;EACA,mBAAA;EACA,cCjBO;A3G4qeb;A0GvpeQ;EACE,eAAA;EACA,gBAAA;EACA,iBAAA;EACA,cCzBG;A3Gkreb;A0GnpeE;EAGE,uBAAA;EACA,kBAAA;EACA,kBAAA;A1GmpeJ;A0GlpeI;EACE,cAAA;EACA,gBAAA;EACA,WAAA;A1GopeN;A0GnpeM;EACE,WAAA;A1GqpeR;A0GppeQ;EACE,WAAA;EACA,cAAA;EACA,eAAA;A1GspeV;A0GlpeI;EACE,yBAAA;A1GopeN;A0GlpeI;EACE,yBAAA;A1GopeN;A0GlpeI;EACE,6BAAA;EACA,WAAA;EACA,SAAA;A1GopeN;A0GlpeI;EACE,eAAA;EACA,gBAAA;EACA,iBAAA;EACA,WChEK;A3GoteX;A0GlpeI;EACE,eAAA;EACA,gBAAA;EACA,iBAAA;EACA,WCtEK;A3G0teX;A0GjpeM;EACE,UC1EG;ED2EH,WAAA;EACA,YAAA;A1GmpeR;A0G9oeE;EACE,qDAAA;EACA,kBAAA;EACA,iBAAA;EACA,oBAAA;EAEA,iBAAA;EACA,uBAAA;EACA,iBAAA;EACA,2CAAA;A1G+oeJ;A0G5oeQ;EACE,eAAA;EACA,gBAAA;EACA,iBAAA;EACA,cClGG;A3Ggveb;A0G5oeQ;EACE,eAAA;EACA,gBAAA;EACA,iBAAA;EACA,cCjGG;A3G+ueb;A0GxoeE;EACE,UAAA;A1G0oeJ;A0GxoeE;EACE,SAAA;A1G0oeJ;A0GxoeE;EACE,eAAA;EACA,gBAAA;EACA,mBAAA;EACA,cCxHS;A3Gkweb;AgBxseI;E0FsEF;IAEI,6BAAA;IAGA,8BAAA;E1GkoeJ;AACF;;A4GrweE;EACE,eAAA;EACA,mBzG2VW;AH66df;A4GlweQ;EACE,qBzG8TsB;AHs8dhC;A4GlweQ;EACE,yDvG0hBsC;AL0udhD;A4G7veQ;EACE,qBzGPC;AHsweX;A4G1veQ;EACE,qCzG4kBqC;AHgrd/C;;A6GpxeE;EACE,yBAAA;EAGE,2D1GsjBa;AH+tdnB;A6GjxeE;EACE,kBAAA;EACA,QAAA;A7GmxeJ;;A6G/weA;EACE,gBAAA;A7GkxeF;;A6G1weI;EACE,SAAA;EACA,yE1G2gBJ;AHkwdF;A6GtweQ;EACE,2E1GsgBR;AHkwdF;A6GnweI;EAEE,yE1G4fJ;AHwwdF;;A8G9yeE;EACE,eAAA;EACA,mB3G2VW;AHs9df;A8G3yeQ;EACE,qB3G8TsB;AH++dhC;A8G3yeQ;EACE,yDzG0hBsC;ALmxdhD;A8GtyeQ;EACE,qB3GPC;AH+yeX;A8GnyeQ;EACE,qC3G4kBqC;AHytd/C;;A+G/zeE;EACE,eAAA;EACA,mB5G2VW;AHu+df;A+G5zeQ;EACE,qB5G8TsB;AHggehC;A+G5zeQ;EACE,yD1GmiBsC;AL2xdhD;A+GvzeQ;EACE,qB5GPC;AHg0eX;A+GpzeQ;EACE,qC5G4kBqC;AH0ud/C;;AgHj1eA;EACE,kBAAA;EACA,qBAAA;EACA,W7GinBoB;E6GhnBpB,cAAA;AhHo1eF;AgHl1eE;EACE,aAAA;AhHo1eJ;AgHj1eM;EACE,yBAAA;AhHm1eR;AgHh1eQ;EACE,mB7GumBiB;E6GtmBjB,+BAAA;AhHk1eV;AgH50eM;EACE,yBAAA;AhH80eR;AgHz0eQ;EACE,yBAAA;AhH20eV;AgHx0eU;EACE,oEAAA;AhH00eZ;;AgH/zeA;EACE,kBAAA;EACA,eAAA;EACA,MAAA;EACA,OAAA;EACA,QAAA;EACA,SAAA;EACA,yBAAA;EACA,8BAAA;EACA,6BAAA;AhHk0eF;AgHh0eE;EACE,kBAAA;EACA,WAAA;EACA,YAAA;EACA,WAAA;EACA,SAAA;EACA,WAAA;EACA,6BAAA;EACA,yB7GjDO;E6GkDP,2D7G6fe;AHq0dnB;;AiHh4eA;;;;EAIE,qBAAA;AjHm4eF;;AiHh4eA;EACE,gBAAA;AjHm4eF;AiHj4eE;EACE,oBAAA;EACA,mB9GgVW;AHmjef;AiHl4eI;;EAEE,kBAAA;EACA,eAAA;EACA,oBAAA;AjHo4eN;;AiH/3eA;EACE,kBAAA;EACA,mBAAA;EACA,c9GdS;E8GeT,mBAAA;EACA,yBAAA;EACA,gBAAA;AjHk4eF;;AiH13eM;EACE,cAAA;AjH63eR;AiHz3eI;EACE,c9G1BK;AHq5eX;AiHv3eM;;EAEE,yBAAA;AjHy3eR;;AiHj3eA;EACE,gBAAA;EACA,iB9GmQiB;AHinenB;;AiHj3eA;EACE,gBAAA;EACA,wB9G8PiB;AHsnenB;;AiHj3eA;EACE,gBAAA;EACA,wB9GyPiB;AH2nenB;;AkHx7eA;EAEE,iBAAA;AlH07eF;AkHv7eI;EACE,c/GUK;E+GTL,iBAAA;EACA,mB/GoVS;E+GnVT,yBAAA;EACA,gB/GuVa;E+GtVb,mBAAA;AlHy7eN;AkHr7eE;;EAEE,yBAAA;AlHu7eJ;AkHr7eI;;EACE,yBAAA;AlHw7eN;AkHp7eE;EACE,qBAAA;EACA,mBAAA;EACA,c/GXO;E+GYP,kB/G47BoB;AH0/cxB;AkHp7eI;EACE,c/GdK;AHo8eX;AkHl7eE;EACE,mB/GwTW;AH4nef;;AkH76eE;EACE,W/GlCI;AHk9eR;;AkHz6eE;EACE,mB/GwSW;AHooef;AkHx6eI;EACE,gBAAA;AlH06eN;;AkHn6eA;EACE,gBAAA;EACA,kBAAA;EACA,kBAAA;EACA,kBAAA;EACA,uBAAA;EACA,oBAAA;AlHs6eF;AkHp6eE;EACE,WAAA;EACA,kBAAA;EACA,OAAA;EACA,QAAA;EACA,UAAA;EACA,cAAA;EACA,mBAAA;EACA,yBAAA;AlHs6eJ;AkHn6eE;EACE,oBAAA;EACA,kBAAA;AlHq6eJ;;AmH1/eA;EACE,chHgBS;EgHfT,mBhH0Va;EgHzVb,gBhH8ViB;AH+penB;;AmHx/eA;EACE,mBhH8doB;AH6hetB;AmHx/eI;EACE,chHEK;AHw/eX;;AmHn/eA;EACE,uBAAA;AnHs/eF;;AmHn/eA;EACE,uBAAA;AnHs/eF;;AmHn/eA;EACE,2BAAA;AnHs/eF;;AmHn/eA;EACE,6BAAA;AnHs/eF;;AmH/+eA;EACE,yBhHwfe;EgHvff,qBhHufe;EgHtff,gBAAA;AnHk/eF;AmHh/eE;EACE,qEhHofmB;AH8/dvB;;AmH5+eA;EACE,yEhHgfA;EgH/eA,SAAA;EACA,iCAAA;AnH++eF;AmH7+eE;EACE,2EhH8eF;AHigeF;;AmHz+eA;EACE,ehHwRe;AHotejB;;AoH7ifA;;EAEE,kBAAA;ApHgjfF;AoH9ifE;;EACE,WAAA;EACA,YAAA;EACA,iBAAA;EACA,kBAAA;EACA,0BAAA;EACA,qBAAA;EACA,kBAAA;EACA,WAAA;EACA,QAAA;EACA,0BAAA;EACA,kBAAA;EACA,cAAA;EACA,UAAA;ApHijfJ;;AoH5ifE;EACE,gBAAA;EACA,0BAAA;EACA,mEjH+lBqB;AHg9dzB;AoH5ifE;EACE,sBjHnBI;AHikfR;AoH5ifI;EACE,sCjHihBqB;AH6he3B;AoHzifI;EACE,cjHmlBsB;AHw9d5B;;AoHrifE;EACE,gBAAA;EACA,0BAAA;EACA,4DjH2kBuB;AH69d3B;AoHrifE;EACE,sBjHzCI;AHglfR;AoHrifI;EACE,sCjH2fqB;AH4ie3B;AoHlifI;EACE,cjH+jBwB;AHq+d9B;;AqHlmfA;EACE,gBlH+iBiB;EkH9iBjB,uBlH2Tc;EkH1Td,0BlH6UgB;AHwxelB;AqHnmfE;EACE,gBAAA;ArHqmfJ;AqHnmfI;EACE,cAAA;EACA,eAAA;ArHqmfN;AqHnmfI;EACE,eAAA;EACA,gBAAA;ArHqmfN;AqHnmfI;EACE,gBAAA;ArHqmfN;;AqHhmfA;EACE,2DlHsiBiB;AH6jenB;;AqH9lfA;EACE,yElH0gBA;EkHzgBA,SAAA;EACA,iCAAA;ArHimfF;AqH/lfE;;EAEE,SAAA;EACA,gBAAA;ArHimfJ;;AqH5lfE;EACE,sFAAA;ArH+lfJ;;AqHxlfE;EACE,gBlHogBqB;AHulezB;AqHxlfE;EACE,clHpCO;EkHqCP,sBlH3CI;EkH4CJ,sClH2fuB;AH+le3B;AqHvlfE;EACE,sClHufuB;AHkme3B;;AsHrpfA;EACE,kBAAA;AtHwpfF;;AuHzpfA;EACE,WpH6aU;EoH5aV,YpH4aU;AHgveZ;AuH1pfE;;EAEE,kBAAA;AvH4pfJ;AuHzpfE;EACE,kBAAA;EACA,4BAAA;AvH2pfJ;;AuHrpfA;EACE,WpH6Za;EoH5Zb,YpH4Za;AH4vef;AuHtpfE;;EAEE,kBAAA;AvHwpfJ;AuHrpfE;EACE,4BAAA;AvHupfJ;;AuHjpfA;EACE,WpH8Ya;EoH7Yb,YpH6Ya;AHuwef;AuHlpfE;;EAEE,kBAAA;AvHopfJ;AuHjpfE;EACE,4BAAA;AvHmpfJ;;AuH7ofA;EACE,WpH+Xa;EoH9Xb,YpH8Xa;AHkxef;AuH9ofE;;EAEE,kBAAA;AvHgpfJ;AuH7ofE;EACE,4BAAA;AvH+ofJ;;AwH1sfA;EACE,aAAA;EACA,kBAAA;EACA,oBAAA;EACA,mBAAA;EACA,uBAAA;EACA,kBAAA;AxH6sfF;AwH3sfE;;EAEE,kBAAA;AxH6sfJ;AwHzsfI;;EAEE,mBAAA;AxH2sfN;AwHtsfI;;EAEE,mBAAA;AxHwsfN;AwHpsfE;EACE,WAAA;EACA,YAAA;AxHssfJ;;AwHjsfE;ECrCA,wDAAA;EACA,0EAAA;AzH0ufF;;AwHtsfE;ECrCA,0DAAA;EACA,0CAAA;AzH+ufF;;AwH3sfE;ECrCA,wDAAA;EACA,0EAAA;AzHovfF;;AwHhtfE;ECrCA,wDAAA;EACA,0EAAA;AzHyvfF;;AwHrtfE;ECrCA,iCAAA;EACA,kEAAA;AzH8vfF;;AwH1tfE;ECrCA,iCAAA;EACA,2EAAA;AzHmwfF;;AwH/tfE;ECrCA,iDAAA;EACA,kEAAA;AzHwwfF;;AwHpufE;ECrCA,6CAAA;EACA,+DAAA;AzH6wfF;;AwHzufE;ECrCA,mCAAA;EACA,qDAAA;AzHkxfF;;AwH9ufE;ECrCA,kCAAA;EACA,0CAAA;AzHuxfF;;AwHnvfE;ECrCA,kCAAA;EACA,0CAAA;AzH4xfF;;AwHxvfE;ECrCA,YAAA;EACA,6CAAA;AzHiyfF;;AqH/xfA;EACE,gBlH+iBiB;EkH9iBjB,uBlH2Tc;EkH1Td,0BlH6UgB;AHq9elB;AqHhyfE;EACE,gBAAA;ArHkyfJ;AqHhyfI;EACE,cAAA;EACA,eAAA;ArHkyfN;AqHhyfI;EACE,eAAA;EACA,gBAAA;ArHkyfN;AqHhyfI;EACE,gBAAA;ArHkyfN;;AqH7xfA;EACE,2DlHsiBiB;AH0venB;;AqH3xfA;EACE,yElH0gBA;EkHzgBA,SAAA;EACA,iCAAA;ArH8xfF;AqH5xfE;;EAEE,SAAA;EACA,gBAAA;ArH8xfJ;;AqHzxfE;EACE,sFAAA;ArH4xfJ;;AqHrxfE;EACE,gBlHogBqB;AHoxezB;AqHrxfE;EACE,clHpCO;EkHqCP,sBlH3CI;EkH4CJ,sClH2fuB;AH4xe3B;AqHpxfE;EACE,sClHufuB;AH+xe3B;;A0H/0fE;EACE,qBAAA;E/GUA,uBAAA;AXy0fJ;;A0H50fA;EACE,WAAA;EACA,YAAA;EACA,kBAAA;EACA,mBAAA;EACA,gCAAA;A1H+0fF;;A0H50fA;EACE,SAAA;EACA,YAAA;A1H+0fF;A0H70fE;EACE,cvHPO;EuHQP,gBAAA;EACA,kBAAA;A1H+0fJ;;A0H30fA;EACE,evH4Te;EuH3Tf,cvHZS;AH01fX;A0H50fE;EACE,YAAA;EACA,cvHnBO;EuHoBP,gBAAA;A1H80fJ;;A2Hn3fA;EACE,kBAAA;EACA,WAAA;EACA,axH6oBW;EwH5oBX,uBxHyTc;AH6jfhB;;A4H13fA;EACE,kBAAA;EACA,MAAA;EACA,OAAA;EACA,WAAA;EACA,YAAA;EvGOI,0BuGNJ;A5H63fF;AqBn3fM;EuGhBN;IvGiBQ,gBAAA;ErBs3fN;AACF;;A6Hr4fE;EACE,aAAA;EACA,gBAAA;A7Hw4fJ;A6Ht4fE;EACE,gBAAA;A7Hw4fJ;;A8Hn5fE;EACE,WAAA;A9Hs5fJ;A8Hp5fE;;EAEE,wCAAA;A9Hs5fJ;A8Hp5fE;EACE,yBzHmEW;EyHlEX,WAAA;A9Hs5fJ;A8Hp5fI;EACE,WAAA;A9Hs5fN;A8Hj5fI;EACE,W3HHE;AHs5fR;;A8Hr6fE;EACE,cAAA;A9Hw6fJ;A8Ht6fE;;EAEE,qCAAA;A9Hw6fJ;A8Ht6fE;EACE,yBzHmEW;EyHlEX,cAAA;A9Hw6fJ;A8Ht6fI;EACE,cAAA;A9Hw6fN;A8Hn6fI;EACE,W3HHE;AHw6fR;;A8Hv7fE;EACE,WAAA;A9H07fJ;A8Hx7fE;;EAEE,wCAAA;A9H07fJ;A8Hx7fE;EACE,yBzHmEW;EyHlEX,WAAA;A9H07fJ;A8Hx7fI;EACE,WAAA;A9H07fN;A8Hr7fI;EACE,W3HHE;AH07fR;;A8Hz8fE;EACE,WAAA;A9H48fJ;A8H18fE;;EAEE,wCAAA;A9H48fJ;A8H18fE;EACE,yBzHmEW;EyHlEX,WAAA;A9H48fJ;A8H18fI;EACE,WAAA;A9H48fN;A8Hv8fI;EACE,W3HHE;AH48fR;;A8H39fE;EACE,WAAA;A9H89fJ;A8H59fE;;EAEE,wCAAA;A9H89fJ;A8H59fE;EACE,yBzHmEW;EyHlEX,WAAA;A9H89fJ;A8H59fI;EACE,WAAA;A9H89fN;A8Hz9fI;EACE,W3HHE;AH89fR;;A8H7+fE;EACE,WAAA;A9Hg/fJ;A8H9+fE;;EAEE,wCAAA;A9Hg/fJ;A8H9+fE;EACE,yBzHmEW;EyHlEX,WAAA;A9Hg/fJ;A8H9+fI;EACE,WAAA;A9Hg/fN;A8H3+fI;EACE,W3HHE;AHg/fR;;A8H//fE;EACE,WAAA;A9HkggBJ;A8HhggBE;;EAEE,wCAAA;A9HkggBJ;A8HhggBE;EACE,yBzHmEW;EyHlEX,WAAA;A9HkggBJ;A8HhggBI;EACE,WAAA;A9HkggBN;A8H7/fI;EACE,W3HHE;AHkggBR;;A8HjhgBE;EACE,WAAA;A9HohgBJ;A8HlhgBE;;EAEE,wCAAA;A9HohgBJ;A8HlhgBE;EACE,yBzHmEW;EyHlEX,WAAA;A9HohgBJ;A8HlhgBI;EACE,WAAA;A9HohgBN;A8H/ggBI;EACE,W3HHE;AHohgBR;;A8HnigBE;EACE,cAAA;A9HsigBJ;A8HpigBE;;EAEE,qCAAA;A9HsigBJ;A8HpigBE;EACE,yBzHmEW;EyHlEX,cAAA;A9HsigBJ;A8HpigBI;EACE,cAAA;A9HsigBN;A8HjigBI;EACE,W3HHE;AHsigBR;;A8HrjgBE;EACE,cAAA;A9HwjgBJ;A8HtjgBE;;EAEE,qCAAA;A9HwjgBJ;A8HtjgBE;EACE,sBzHmEW;EyHlEX,cAAA;A9HwjgBJ;A8HtjgBI;EACE,cAAA;A9HwjgBN;A8HnjgBI;EACE,W3HHE;AHwjgBR;;A8HvkgBE;EACE,cAAA;A9H0kgBJ;A8HxkgBE;;EAEE,qCAAA;A9H0kgBJ;A8HxkgBE;EACE,sBzHmEW;EyHlEX,cAAA;A9H0kgBJ;A8HxkgBI;EACE,cAAA;A9H0kgBN;A8HrkgBI;EACE,W3HHE;AH0kgBR;;A8HzlgBE;EACE,WAAA;A9H4lgBJ;A8H1lgBE;;EAEE,wCAAA;A9H4lgBJ;A8H1lgBE;EACE,uBzHmEW;EyHlEX,WAAA;A9H4lgBJ;A8H1lgBI;EACE,WAAA;A9H4lgBN;A8HvlgBI;EACE,W3HHE;AH4lgBR;;A+HrmgBA;EACE,eAAA;EpHmBE,gCAAA;EACA,iCAAA;AXslgBJ;A+HvmgBE;EpHgBE,yBAAA;EACA,0BAAA;EAaA,oCAAA;EACA,mCAAA;AX8kgBJ;;A+HrmgBA;EACE,c5HGS;AHqmgBX;A+HtmgBE;EACE,c5HiqBmB;AHu8evB;A+HrmgBE;EACE,kBAAA;EACA,QAAA;A/HumgBJ;;A+HnmgBA;EACE;IACE,kBAAA;IACA,WAAA;IACA,YAAA;IACA,mB5HpBO;EH0ngBT;AACF;AgIrogBE;EACE,mB7HsrBgB;AHi9epB;AgIpogBE;EACE,qBAAA;EACA,c7HwrBmB;E6HvrBnB,gBAAA;EACA,mB7HmVW;E6HlVX,2E7HsfF;E6HrfE,sB7HDI;E6HEJ,0B7HkUc;AHo0flB;AgIpogBI;EACE,uD7HirBuB;AHq9e7B;AgIlogBE;;EAEE,W7H4qB0B;E6H3qB1B,yB7H4qBuB;AHw9e3B;AgBvlgBI;EgHzCA;IACE,mB7H+OG;EHo5fP;AACF;;AgB5lgBI;EgHjCA;IACE,gBAAA;EhIiogBJ;AACF;AgI1ngBE;EACE,kBAAA;EACA,YAAA;EACA,WAAA;EACA,UAAA;EACA,iBAAA;EACA,kBAAA;AhI4ngBJ;AgIxngBI;;EAEE,eAAA;AhI0ngBN;;AiI/qgBI;EACE,iB9H2sBsB;E8H1sBtB,gB9H2sBwB;E8H1sBxB,sB9H2sB2B;E8H1sB3B,iB9H2sB2B;EkBvsB3B,4B4GHA;AjIkrgBN;AqB3qgBM;E4GZF;I5GaI,gBAAA;ErB8qgBN;AACF;AiIrrgBM;EACE,oBAAA;AjIurgBR;AiIhrgBE;EACE,mB9H0UW;E8HzUX,gBAAA;EACA,yBAAA;EACA,mBAAA;EACA,sBAAA;AjIkrgBJ;AiIhrgBI;EACE,YAAA;AjIkrgBN;AiI7qgBI;EACE,W9HrBE;AHosgBR;AiI1qgBI;EACE,c9HnBK;AH+rgBX;AiItqgBM;EACE,qBAAA;AjIwqgBR;AgB9pgBI;EiHHE;IACE,oBAAA;EjIoqgBN;EiIlqgBM;IACE,0B9HuRQ;EH64fhB;EiIhqgBQ;IACE,yBAAA;EjIkqgBV;EiI9pgBI;IACE,iB9H2oBoB;I8H1oBpB,oB9H0oBoB;I8HzoBpB,uB9HwPQ;EHw6fd;EiI9pgBM;IACE,sBAAA;EjIgqgBR;EiI5pgBI;IACE,+BAAA;IACA,gCAAA;IACA,eAAA;IACA,uB9H6OQ;EHi7fd;EiI5pgBM;IACE,eAAA;EjI8pgBR;AACF;AiIvpgBE;EACE,kBAAA;EACA,MAAA;EACA,WAAA;EACA,YAAA;EACA,6BAAA;EACA,SAAA;EACA,gBAAA;AjIypgBJ;AiIvpgBI;EACE,yBAAA;AjIypgBN;AiItpgBI;EACE,yBAAA;AjIwpgBN;AiIrpgBI;EACE,0D5HknB8B;ALqifpC;AgB5sgBI;EiH4DI;IACE,gC9H0mBU;EHyiflB;EM5vgBA;I2H4GU,gC9HwmBc;EH2ifxB;EiIhpgBQ;IACE,gC9HsmBiB;EH4if3B;EiI9ogBM;;;;IAIE,gC9H6lBiB;EHmjfzB;EiI5ogBI;IACE,gC9HslBY;EHwjflB;EM3wgBA;I2HgIQ,gC9HmlBU;EH2jflB;AACF;;AgBnugBI;EkH3DF;IACE,yBAAA;IACA,YAAA;IACA,eAAA;IACA,aAAA;IACA,UAAA;IACA,gBAAA;IACA,kBAAA;ElIkygBF;EkIhygBE;IACE,eAAA;IACA,YAAA;IACA,aAAA;IACA,uBAAA;IACA,uBAAA;ElIkygBJ;EkI/xgBI;IACE,iBAAA;IACA,gBAAA;IACA,WAAA;IACA,YAAA;ElIiygBN;EkI7xgBE;IACE,aAAA;IACA,sBAAA;IACA,uBAAA;IACA,WAAA;IACA,YAAA;ElI+xgBJ;EkI5xgBE;IACE,sBAAA;IACA,kBAAA;IACA,WAAA;IACA,gBAAA;IACA,oBAAA;ElI8xgBJ;EkI7xgBI;IACE,oBAAA;IACA,WAAA;IACA,iBAAA;IACA,eAAA;IACA,gBAAA;IACA,iBAAA;IACA,WvB5CG;IuB6CH,6BAAA;ElI+xgBN;EkI7xgBM;IACE,WvBhDC;E3G+0gBT;EkI5xgBM;IACE,yBAAA;ElI8xgBR;EkI5xgBQ;IACE,cAAA;ElI8xgBV;AACF;AmIp1gBE;EACE,mBhIutB0B;EgIttB1B,iBAAA;EACA,6BAAA;AnIs1gBJ;AmIp1gBI;EACE,6BAAA;EACA,kBAAA;AnIs1gBN;AmIl1gBE;EACE,YhIysBkB;EgIxsBlB,6BAAA;AnIo1gBJ;;AmI/0gBE;EACE,sChIitB8B;AHioflC;AmI/0gBE;EACE,+BhI8sBuB;AHmof3B;AmI90gBE;EACE,+BhI4sB6B;AHoofjC;AmI90gBI;EACE,+BhIusBqB;AHyof3B;AmI30gBI;EACE,sChIksBkC;AH2ofxC;;AmIv0gBE;EACE,gChIwsB+B;AHkofnC;AmIv0gBE;EACE,yBhIqsBwB;AHoof5B;AmIt0gBE;EACE,yBhImsB8B;AHqoflC;AmIt0gBI;EACE,yBhI8rBsB;AH0of5B;AmIn0gBI;EACE,gChIyrBmC;AH4ofzC;;AgB10gBI;EoHxDA;IACE,UAAA;IACA,oBAAA;IACA,SAAA;EpIs4gBJ;EoIl4gBI;IACE,gBjIIA;IiIHA,gBAAA;IACA,WAAA;IACA,cAAA;IACA,YAAA;IACA,WAAA;IACA,WAAA;IACA,kBAAA;IACA,YAAA;IACA,0CAAA;IACA,WAAA;IACA,kBAAA;EpIo4gBN;EoI/3gBI;IACE,WAAA;IACA,UAAA;EpIi4gBN;EoI33gBM;IACE,UAAA;IACA,oBAAA;IACA,mDAAA;EpI63gBR;EoI13gBM;IACE,cAAA;IACA,oDAAA;EpI43gBR;EoIt3gBI;IACE,UAAA;IACA,cAAA;IACA,oBAAA;IACA,+DAAA;IACA,4DACE;EpIu3gBR;EoIl3gBI;IACE,cAAA;IACA,UAAA;IACA,oBAAA;IACA,mBAAA;IACA,0BAAA;IACA,eAAA;EpIo3gBN;EoIh3gBE;IACE,kBAAA;IACA,aAAA;EpIk3gBJ;EoI72gBE;IACE;MACE,UAAA;MACA,+DAAA;MACA,4DACE;IpI82gBN;IoIz2gBE;MACE,0BAAA;MACA,UAAA;IpI22gBJ;EACF;EoIx2gBE;IACE;MACE,UAAA;IpI02gBJ;IoIv2gBE;MACE,UAAA;MACA,6BAAA;IpIy2gBJ;EACF;AACF;AqI18gBA;EACE,aAAA;ArI48gBF;;AgB14gBI;EqH7DA;IACE,mBAAA;IACA,yBAAA;ErI28gBJ;EqIx8gBE;IACE,gBAAA;IACA,eAAA;ErI08gBJ;EqIv8gBM;IACE,WAAA;ErIy8gBR;EqIn8gBA;IACE,0BAAA;IACA,kBAAA;IACA,MAAA;IACA,OAAA;IACA,QAAA;IACA,aAAA;IACA,cAAA;IACA,gBAAA;IACA,uBAAA;IACA,UAAA;ErIq8gBF;EqIn8gBE;IACE,WAAA;IACA,YAAA;IACA,kBAAA;IACA,eAAA;IACA,qBAAA;IACA,UAAA;ErIq8gBJ;EqIn8gBI;IACE,cAAA;IACA,kBAAA;IACA,WAAA;IACA,WAAA;IACA,kBAAA;IACA,UAAA;IACA,mBAAA;ErIq8gBN;EqIl8gBI;IACE,yBAAA;ErIo8gBN;EqIj8gBI;IACE,0BAAA;ErIm8gBN;EqI/7gBE;IACE,cAAA;IACA,oBAAA;IACA,mBAAA;IACA,2CAAA;ErIi8gBJ;EqI77gBI;IACE,YAAA;ErI+7gBN;EqI37gBE;IACE,iBAAA;ErI67gBJ;EqIz7gBA;;IAEE,eAAA;IACA,uBlIwOY;IkIvOZ,gBAAA;IACA,iHACE;IAGF,kDAAA;ErIw7gBF;EqIr7gBA;IACE,kDAAA;ErIu7gBF;AACF;AqIp7gBA;EACE;IACE,UAAA;IACA,sBAAA;IACA,wBAAA;ErIs7gBF;EqIn7gBA;IACE,UAAA;IACA,mBAAA;ErIq7gBF;AACF;AqIl7gBA;EACE;IACE,UAAA;IACA,mBAAA;IACA,wBAAA;ErIo7gBF;EqIj7gBA;IACE,UAAA;IACA,sBAAA;ErIm7gBF;AACF;AsI5ihBE;EACE,2EnImgBF;AH2igBF;AsI3ihBE;;EAEE,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,UAAA;EACA,aAAA;EACA,6BAAA;EACA,WAAA;EACA,YAAA;EACA,mBnI+UW;AH8tgBf;;AsIrihBI;;EAEE,WAAA;EACA,YAAA;EACA,iBAAA;AtIwihBN;;AsIjihBI;;EAEE,WAAA;EACA,YAAA;EACA,iBAAA;AtIoihBN;;AuI1khBA;EACE,SAAA;AvI6khBF;;AuI1khBA;EACE,gBpI8ViB;AH+ugBnB;;AuIvkhBE;ECdA,yBnI2Ea;AL8ghBf;AwIvlhBE;EACE,yBnIwEW;EmIvEX,WAAA;AxIylhBJ;AwItlhBE;EACE,WAAA;AxIwlhBJ;AwItlhBE;EACE,sCAAA;AxIwlhBJ;AwIrlhBI;EACE,yBnI4DS;AL2hhBf;AwInlhBI;EACE,2BnIuDS;AL8hhBf;AwIjlhBI;EACE,4BnIkDS;ALiihBf;AwI/khBI;EACE,0BnI6CS;ALoihBf;;AuIjmhBE;ECdA,yBnI2Ea;ALwihBf;AwIjnhBE;EACE,yBnIwEW;EmIvEX,cAAA;AxImnhBJ;AwIhnhBE;EACE,cAAA;AxIknhBJ;AwIhnhBE;EACE,mCAAA;AxIknhBJ;AwI/mhBI;EACE,yBnI4DS;ALqjhBf;AwI7mhBI;EACE,2BnIuDS;ALwjhBf;AwI3mhBI;EACE,4BnIkDS;AL2jhBf;AwIzmhBI;EACE,0BnI6CS;AL8jhBf;;AuI3nhBE;ECdA,yBnI2Ea;ALkkhBf;AwI3ohBE;EACE,yBnIwEW;EmIvEX,WAAA;AxI6ohBJ;AwI1ohBE;EACE,WAAA;AxI4ohBJ;AwI1ohBE;EACE,sCAAA;AxI4ohBJ;AwIzohBI;EACE,yBnI4DS;AL+khBf;AwIvohBI;EACE,2BnIuDS;ALklhBf;AwIrohBI;EACE,4BnIkDS;ALqlhBf;AwInohBI;EACE,0BnI6CS;ALwlhBf;;AuIrphBE;ECdA,yBnI2Ea;AL4lhBf;AwIrqhBE;EACE,yBnIwEW;EmIvEX,WAAA;AxIuqhBJ;AwIpqhBE;EACE,WAAA;AxIsqhBJ;AwIpqhBE;EACE,sCAAA;AxIsqhBJ;AwInqhBI;EACE,yBnI4DS;ALymhBf;AwIjqhBI;EACE,2BnIuDS;AL4mhBf;AwI/phBI;EACE,4BnIkDS;AL+mhBf;AwI7phBI;EACE,0BnI6CS;ALknhBf;;AuI/qhBE;ECdA,yBnI2Ea;ALsnhBf;AwI/rhBE;EACE,yBnIwEW;EmIvEX,WAAA;AxIishBJ;AwI9rhBE;EACE,WAAA;AxIgshBJ;AwI9rhBE;EACE,sCAAA;AxIgshBJ;AwI7rhBI;EACE,yBnI4DS;ALmohBf;AwI3rhBI;EACE,2BnIuDS;ALsohBf;AwIzrhBI;EACE,4BnIkDS;ALyohBf;AwIvrhBI;EACE,0BnI6CS;AL4ohBf;;AuIzshBE;ECdA,yBnI2Ea;ALgphBf;AwIzthBE;EACE,yBnIwEW;EmIvEX,WAAA;AxI2thBJ;AwIxthBE;EACE,WAAA;AxI0thBJ;AwIxthBE;EACE,sCAAA;AxI0thBJ;AwIvthBI;EACE,yBnI4DS;AL6phBf;AwIrthBI;EACE,2BnIuDS;ALgqhBf;AwInthBI;EACE,4BnIkDS;ALmqhBf;AwIjthBI;EACE,0BnI6CS;ALsqhBf;;AuInuhBE;ECdA,yBnI2Ea;AL0qhBf;AwInvhBE;EACE,yBnIwEW;EmIvEX,WAAA;AxIqvhBJ;AwIlvhBE;EACE,WAAA;AxIovhBJ;AwIlvhBE;EACE,sCAAA;AxIovhBJ;AwIjvhBI;EACE,yBnI4DS;ALurhBf;AwI/uhBI;EACE,2BnIuDS;AL0rhBf;AwI7uhBI;EACE,4BnIkDS;AL6rhBf;AwI3uhBI;EACE,0BnI6CS;ALgshBf;;AuI7vhBE;ECdA,yBnI2Ea;ALoshBf;AwI7whBE;EACE,yBnIwEW;EmIvEX,WAAA;AxI+whBJ;AwI5whBE;EACE,WAAA;AxI8whBJ;AwI5whBE;EACE,sCAAA;AxI8whBJ;AwI3whBI;EACE,yBnI4DS;ALithBf;AwIzwhBI;EACE,2BnIuDS;ALothBf;AwIvwhBI;EACE,4BnIkDS;ALuthBf;AwIrwhBI;EACE,0BnI6CS;AL0thBf;;AuIvxhBE;ECdA,yBnI2Ea;AL8thBf;AwIvyhBE;EACE,yBnIwEW;EmIvEX,cAAA;AxIyyhBJ;AwItyhBE;EACE,cAAA;AxIwyhBJ;AwItyhBE;EACE,mCAAA;AxIwyhBJ;AwIryhBI;EACE,yBnI4DS;AL2uhBf;AwInyhBI;EACE,2BnIuDS;AL8uhBf;AwIjyhBI;EACE,4BnIkDS;ALivhBf;AwI/xhBI;EACE,0BnI6CS;ALovhBf;;AuIjzhBE;ECdA,sBnI2Ea;ALwvhBf;AwIj0hBE;EACE,sBnIwEW;EmIvEX,cAAA;AxIm0hBJ;AwIh0hBE;EACE,cAAA;AxIk0hBJ;AwIh0hBE;EACE,mCAAA;AxIk0hBJ;AwI/zhBI;EACE,sBnI4DS;ALqwhBf;AwI7zhBI;EACE,wBnIuDS;ALwwhBf;AwI3zhBI;EACE,yBnIkDS;AL2whBf;AwIzzhBI;EACE,uBnI6CS;AL8whBf;;AuI30hBE;ECdA,sBnI2Ea;ALkxhBf;AwI31hBE;EACE,sBnIwEW;EmIvEX,cAAA;AxI61hBJ;AwI11hBE;EACE,cAAA;AxI41hBJ;AwI11hBE;EACE,mCAAA;AxI41hBJ;AwIz1hBI;EACE,sBnI4DS;AL+xhBf;AwIv1hBI;EACE,wBnIuDS;ALkyhBf;AwIr1hBI;EACE,yBnIkDS;ALqyhBf;AwIn1hBI;EACE,uBnI6CS;ALwyhBf;;AuIr2hBE;ECdA,uBnI2Ea;AL4yhBf;AwIr3hBE;EACE,uBnIwEW;EmIvEX,WAAA;AxIu3hBJ;AwIp3hBE;EACE,WAAA;AxIs3hBJ;AwIp3hBE;EACE,sCAAA;AxIs3hBJ;AwIn3hBI;EACE,uBnI4DS;ALyzhBf;AwIj3hBI;EACE,yBnIuDS;AL4zhBf;AwI/2hBI;EACE,0BnIkDS;AL+zhBf;AwI72hBI;EACE,wBnI6CS;ALk0hBf;;AyIx4hBA;EACE,kBAAA;EACA,mBAAA;AzI24hBF;;AyIt4hBA;EACE,WAAA;EACA,mBtIiQO;EsIhQP,gBAAA;EACA,sBtImTiB;EsIlTjB,yBAAA;EACA,8CAAA;AzIy4hBF;AyIv4hBE;EACE,WAAA;EACA,YAAA;EACA,kBAAA;EACA,OAAA;EACA,UAAA;EACA,iBAAA;EACA,eAAA;AzIy4hBJ;;AyIn4hBA;EACE,eAAA;EACA,gBAAA;EACA,eAAA;EACA,UAAA;AzIs4hBF;;AyIn4hBA;EACE,gBAAA;EACA,gBAAA;EACA,YAAA;AzIs4hBF;;AyIn4hBA;EACE,qBAAA;EACA,aAAA;EACA,mBAAA;EACA,8BAAA;AzIs4hBF;;AyIl4hBE;EACE,qBAAA;EACA,ctIsBM;EsIrBN,mBAAA;EACA,gBAAA;EACA,yBAAA;EACA,mCAAA;EACA,qBAAA;EACA,mBAAA;AzIq4hBJ;;AyIj4hBA;EACE,iBAAA;AzIo4hBF;AyIn4hBE;EACE,qBAAA;EACA,ctIjDO;EsIkDP,mBAAA;EACA,gBAAA;AzIq4hBJ;;A0Iz8hBA;EACE,kBAAA;EACA,SAAA;EACA,OAAA;EACA,QAAA;EACA,WAAA;EACA,aAAA;EACA,wBAAA;EACA,gBAAA;EACA,oBAAA;A1I48hBF;A0I18hBE;EACE,kBAAA;EACA,oBAAA;A1I48hBJ;;A0Ix8hBA;EACE,MAAA;EACA,YAAA;A1I28hBF;A0Iz8hBE;EACE,MAAA;A1I28hBJ;;A0Iv8hBA;EACE,SAAA;EACA,SAAA;A1I08hBF;A0Ix8hBE;EACE,SAAA;A1I08hBJ;;A0It8hBA;EACE,yBAAA;A1Iy8hBF;;A0Ip8hBA;EACE,YAAA;A1Iu8hBF;AgB17hBI;E0HdJ;IAII,YAAA;E1Iw8hBF;AACF;;A2Ip/hBE;EACE,eAAA;EACA,oBxI6bkB;EwI5blB,uBxI4bkB;EwI3blB,kBxI6bmB;EwI5bnB,yBxI8bwB;EwI7bxB,mBxI8bwB;EwI7bxB,gCAAA;A3Iu/hBJ;A2Ip/hBE;EACE,gBxIqVe;AHiqhBnB;A2Il/hBI;EACE,WAAA;EACA,YAAA;EACA,SAAA;A3Io/hBN;A2Ih/hBE;;EAEE,oBxI8amB;EwI7anB,mBAAA;A3Ik/hBJ;A2I5+hBI;;EAEE,sBAAA;A3I8+hBN;A2Iv+hBI;EACE,iDxIqae;EwIpaf,YxIqakB;AHokhBxB;A2Il+hBI;EACE,yBxIxCK;EwIyCL,cxIpCK;AHwgiBX;;A2I59hBE;EtHlDI,0BsHmDF;A3I+9hBJ;AqB9giBM;EsH8CJ;ItH7CM,gBAAA;ErBihiBN;AACF;;A2I79hBE;;EAEE,cAAA;EACA,eAAA;A3Ig+hBJ;A2I19hBQ;;EAEE,aAAA;A3I49hBV;A2Iv9hBQ;;EAEE,gBAAA;A3Iy9hBV;;A2I/8hBE;EACE,gBAAA;EACA,eAAA;A3Ik9hBJ;A2Ij9hBI;;EAEE,oBxI0xBU;EwIzxBV,qBxIyxBU;AH0rgBhB;;A4IzjiBA;EACE,ezI8YoB;EyI7YpB,gBzI8YsB;EyI7YtB,gBzI8YsB;AH8qhBxB;;A4IzjiBA;EACE,kBzI4Ye;EyI3Yf,gBzI4YiB;EyI3YjB,gBzIwYsB;EyIvYtB,kBAAA;A5I4jiBF;A4I1jiBE;EACE,gBAAA;A5I4jiBJ;;A4IxjiBA;EACE,mBzI0Ua;AHivhBf;;A6I7kiBA;EACE,uB1IoXuB;E0InXvB,kB1IoXkB;E0InXlB,yB1IoXuB;E0InXvB,gB1I6ViB;AHmvhBnB;;A6I3kiBA;EACE,oBAAA;EACA,uBAAA;EACA,kBAAA;EACA,yBAAA;EACA,sBAAA;A7I8kiBF;;A6I3kiBA;EACE,uB1IwW6B;E0IvW7B,mB1IwWwB;E0IvWxB,gB1I6UiB;E0I5UjB,yB1IwW6B;AHsuhB/B;;A6I3kiBA;EACE,uB1IsW+B;E0IrW/B,mB1IsW0B;E0IrW1B,gB1IsUiB;E0IrUjB,yB1IsW+B;AHwuhBjC;A6I5kiBE;EACE,cAAA;EACA,WAAA;EACA,YAAA;EACA,qBAAA;A7I8kiBJ;A6I1kiBI;EACE,iBAAA;EACA,kBAAA;A7I4kiBN;;A8IlniBE;;;;EACE,cAAA;EACA,gB3I2VgB;AH6xhBpB;;A+I7niBE;;EAEE,gBAAA;A/IgoiBJ;A+I7niBE;;EAEE,qBAAA;A/I+niBJ;A+I5niBE;EACE,cAAA;A/I8niBJ;A+I3niBE;EACE,aAAA;A/I6niBJ;;AgJ7oiBA;EACE,uB7I4Tc;E6ItTd,cAAA;AhJ2oiBF;AgJ/oiBE;EACE,YAAA;AhJipiBJ;AgJ5oiBE;EACE,cAAA;AhJ8oiBJ;AgJ7oiBI;EACE,UAAA;AhJ+oiBN;AgJ7oiBI;EACE,YAAA;AhJ+oiBN;AgJ3oiBE;EACE,MAAA;EACA,OAAA;EACA,kB7Ik6B0B;ES56BxB,iHoIWF;AhJ6oiBJ;AgJ3oiBI;EACE,SAAA;AhJ6oiBN;AgJ3oiBI;EACE,SAAA;AhJ6oiBN;AgJ3oiBI;EACE,UAAA;AhJ6oiBN;AgJ3oiBI;EACE,UAAA;AhJ6oiBN;AgJ3oiBI;EACE,SAAA;AhJ6oiBN;AgJ3oiBI;EACE,SAAA;AhJ6oiBN;AgJ1oiBI;EACE,YAAA;EACA,gBAAA;EACA,2BAAA;AhJ4oiBN;AgJzoiBI;EACE,YAAA;EACA,gBAAA;EACA,0BAAA;AhJ2oiBN;AgJvoiBE;EACE,SAAA;EACA,2BAAA;EACA,yBAAA;UAAA,iBAAA;AhJyoiBJ;AgJtoiBM;EACE,kB7I43BwB;AH4wgBhC;AgJroiBM;EACE,uB7IyPQ;E6IxPR,gBAAA;AhJuoiBR;AgJpoiBM;;EAEE,0B7IsQU;E6IrQV,W7Ik3BgB;E6Ij3BhB,Y7Ik3BiB;E6Ij3BjB,YAAA;EACA,kBAAA;EACA,mB7I+QO;AHu3hBf;AgJ9niBI;;EAEE,6BAAA;AhJgoiBN;AgJ3niBI;EAEE,c7I/EK;AH2siBX;AgJzniBI;EAEE,iB7Is1B6B;E6Ir1B7B,eAAA;AhJ0niBN;AgJvniBI;EAEE,gBAAA;EACA,c7I7FK;E6I8FL,eAAA;AhJwniBN;AgJrniBI;EACE,gBAAA;AhJuniBN;AgJrniBM;EACE,mB7Ik1BuB;AHqygB/B;AgJpniBM;EAEE,mB7I60BuB;E6I50BvB,c7I1GG;AH+tiBX;AgJjniBI;EACE,8DAAA;AhJmniBN;AgJlniBM;EACE,iBAAA;AhJoniBR;AgJjniBM;EAEE,iBAAA;EACA,c7IrHG;AHuuiBX;AgJ7miBI;EACE,mB7I4zBwB;E6I3zBxB,W7IlIE;E6ImIF,gBAAA;AhJ+miBN;AgJ7miBM;EACE,6DAAA;AhJ+miBR;AgJ5miBM;EAGE,6DAAA;EACA,yDAAA;AhJ4miBR;AgJvmiBM;EACE,sDAAA;AhJymiBR;AgJtmiBM;EAEE,mB7ItJG;E6IuJH,c7ItJG;AH6viBX;AgJlmiBM;EAEE,mB7IpID;E6IqIC,W7IjKA;AHowiBR;AgJ/liBI;EACE,0BAAA;EACA,6BAAA;AhJimiBN;AgJ9liBI;EACE,yBAAA;EACA,4BAAA;AhJgmiBN;AgJ7liBI;EACE,kB7IgwB0B;AH+1gBhC;AgJ5liBI;EAKE,mB7IkwByB;E6IjwBzB,W7IzLE;AHmxiBR;AgJvliBI;EAIE,mB7I0vByB;E6IzvBzB,W7IjME;E6IkMF,gB7IyvByB;AH61gB/B;AgJnliBI;EACE,cAAA;EACA,UAAA;EACA,YAAA;EACA,iBAAA;EACA,WAAA;EACA,UAAA;EACA,eAAA;EACA,kBAAA;AhJqliBN;AgJnliBM;EAEE,mB7I/MG;AHmyiBX;AgJjliBM;EAEE,gBAAA;EACA,c7IpNG;E6IqNH,eAAA;AhJkliBR;AgJ/kiBM;EAIE,yCAAA;AhJ8kiBR;AgJ3kiBM;EAEE,c7I9NG;AH0yiBX;AgJvkiBE;EACE,YAAA;AhJykiBJ;AgJtkiBE;;;;EAIE,eAAA;AhJwkiBJ;AgJvkiBI;;;;EACE,mB7IjPK;AH6ziBX;AgJtkiBI;;EACE,kBAAA;AhJykiBN;AgJpkiBE;EACE,eAAA;EACA,WAAA;EACA,oBAAA;EACA,sBAAA;AhJskiBJ;;AiJz1iBA,qCAAA;AACA;;;EAAA;AAIA;;EAEE,2BAAA;EACA,6CAAA;EACA,yBAAA;EAEA,kBAAA;EAGA,iBAAA;EAEA,sBAAA;AjJ41iBF;;AiJ11iBA;EACE,kBAAA;EACA,cAAA;AjJ61iBF;;AiJ31iBA;;EAEE,WAAA;EACA,YAAA;EACA,kBAAA;EACA,UAAA;AjJ81iBF;;AiJ51iBA;EAAA;AAEA;EACE,gBAAA;EACA,UAAA;AjJ+1iBF;;AiJ71iBA;;EAEE,sBAAA;EACA,kBAAA;EACA,UAAA;EACA,MAAA;EACA,OAAA;EACA,yBAAA;EACA,6BAAA;EACA,oCAAA;EACA,qBAAA;EACA,qBAAA;AjJg2iBF;;AiJ91iBA;EACE,YAAA;EACA,WAAA;AjJi2iBF;;AiJ/1iBA;EACE,WAAA;EACA,UAAA;AjJk2iBF;;AiJh2iBA;EAAA;AAEA;EACE,UAAA;EACA,QAAA;AjJm2iBF;;AiJj2iBA;;EAAA;AAGA;EACE,QAAA;AjJo2iBF;;AiJl2iBA;EACE,SAAA;AjJq2iBF;;AiJn2iBA;EAEE,2BAAA;EACA,kBAAA;AjJs2iBF;;AiJp2iBA;EACE,YAAA;EACA,WAAA;AjJu2iBF;;AiJr2iBA;;EAGE,0BAAA;AjJw2iBF;;AiJt2iBA;EACE,0BAAA;AjJy2iBF;;AiJv2iBA;EAAA;AAEA;EACE,YAAA;AjJ02iBF;;AiJx2iBA;EACE,WAAA;EACA,YAAA;EACA,WAAA;EACA,SAAA;AjJ22iBF;;AiJz2iBA;EACE,WAAA;AjJ42iBF;;AiJ12iBA;EACE,WAAA;EACA,YAAA;EACA,UAAA;EACA,UAAA;AjJ62iBF;;AiJ32iBA;EACE,YAAA;EACA,UAAA;AjJ82iBF;;AiJ52iBA;;EAAA;AAGA;EACE,mBAAA;EACA,kBAAA;EACA,yBAAA;EACA,wDACE;AjJ82iBJ;;AiJ32iBA;EACE,kBAAA;AjJ82iBF;;AiJ52iBA;EACE,mBAAA;AjJ+2iBF;;AiJ72iBA;EAAA;AAEA;EACE,iBAAA;AjJg3iBF;;AiJ92iBA;EACE,iBAAA;AjJi3iBF;;AiJ/2iBA;EACE,yBAAA;EACA,kBAAA;EACA,gBAAA;EACA,eAAA;EACA,4EACE;AjJi3iBJ;;AiJ72iBA;EACE,yEACE;AjJ+2iBJ;;AiJ32iBA;EAAA;AAEA;;EAEE,WAAA;EACA,cAAA;EACA,kBAAA;EACA,YAAA;EACA,UAAA;EACA,mBAAA;EACA,UAAA;EACA,QAAA;AjJ82iBF;;AiJ52iBA;EACE,UAAA;AjJ+2iBF;;AiJ72iBA;;EAEE,WAAA;EACA,WAAA;EACA,SAAA;EACA,SAAA;AjJg3iBF;;AiJ92iBA;EACE,SAAA;AjJi3iBF;;AiJ/2iBA;EAAA;AAEA;EACE,mBAAA;AjJk3iBF;;AiJh3iBA;;;EAGE,mBAAA;AjJm3iBF;;AiJj3iBA;;EAAA;AAGA;;EAGE,sBAAA;AjJo3iBF;;AiJl3iBA;EACE,kBAAA;EACA,WAAA;AjJq3iBF;;AiJn3iBA;;EAAA;AAGA;EACE,kBAAA;EACA,mBAAA;EACA,kBAAA;AjJs3iBF;;AiJp3iBA;EACE,WAAA;EACA,eAAA;AjJu3iBF;;AiJr3iBA;;EAAA;AAGA;EACE,kBAAA;EACA,gBAAA;AjJw3iBF;;AiJt3iBA;EACE,gBAAA;AjJy3iBF;;AiJv3iBA;EACE,gBAAA;AjJ03iBF;;AiJx3iBA;;EAAA;AAGA;EACE,eAAA;EACA,YAAA;EACA,SAAA;EACA,OAAA;EACA,WAAA;AjJ23iBF;;AiJz3iBA;EAEE,+BAAA;AjJ43iBF;;AiJ13iBA;EAEE,8BAAA;AjJ63iBF;;AiJ33iBA;EACE,iBAAA;EACA,UAAA;EACA,WAAA;AjJ83iBF;;AiJ53iBA;EACE,YAAA;AjJ+3iBF;;AiJ73iBA;EACE,YAAA;AjJg4iBF;;AiJ93iBA;;EAAA;AAGA;EACE,eAAA;EACA,YAAA;EACA,MAAA;EACA,UAAA;AjJi4iBF;;AiJ/3iBA;EAEE,6BAAA;EACA,kBAAA;AjJk4iBF;;AiJh4iBA;EAEE,4BAAA;AjJm4iBF;;AiJj4iBA;EACE,UAAA;EACA,WAAA;EACA,gBAAA;AjJo4iBF;;AiJl4iBA;EACE,WAAA;AjJq4iBF;;AiJn4iBA;EACE,WAAA;AjJs4iBF;;AiJp4iBA;EACE,cAAA;EACA,kBAAA;EACA,yBAAA;EACA,kBAAA;EACA,gBAAA;EACA,WAAA;EACA,YAAA;EACA,kBAAA;EACA,mBAAA;AjJu4iBF;;AiJr4iBA;EAEE,6BAAA;EACA,SAAA;EACA,YAAA;AjJw4iBF;;AiJt4iBA;EAEE,6BAAA;EACA,QAAA;EACA,WAAA;AjJy4iBF;;AiJp4iBA;EACE,mB9IiWe;E8IhWf,kB9IkW0B;E8IjW1B,SAAA;EACA,kD9IkWuB;E8IjWvB,cAAA;EACA,eAAA;AjJu4iBF;;AiJp4iBA;EACE,W9IyVsB;AH8iiBxB;;AiJp4iBA;EACE,YAAA;AjJu4iBF;;AiJp4iBA;EACE,U9IiVsB;AHsjiBxB;;AiJp4iBA;EACE,mBAAA;EACA,gBAAA;AjJu4iBF;;AiJn4iBE;EAEE,aAAA;AjJq4iBJ;AiJl4iBE;EACE,aAAA;AjJo4iBJ;;AiJh4iBA;;EAEE,SAAA;EACA,W9ImUkB;E8IlUlB,Y9IkUkB;E8IjUlB,mBAAA;EACA,gBAAA;EACA,eAAA;EACA,yB9I+Te;E8I9Tf,S9I+TmB;E8I9TnB,6CACE;AjJk4iBJ;;AiJ93iBA;;EAEE,mCAAA;AjJi4iBF;;AiJ93iBA;EACE,mB9I3TK;AH4rjBP;;AiJ93iBA,mBAAA;AAEA;;EAEE,mB9IwSgC;AHwliBlC;;AiJ73iBA;;EAEE,mBAAA;AjJg4iBF;;AiJ73iBA,8BAAA;AAEA;EACE,kB9I/Ba;E8IgCb,gBAAA;EACA,uCAAA;EACA,WAAA;EACA,mBAAA;EACA,iCAAA;AjJ+3iBF;;AiJ53iBA;EACE,gBAAA;EACA,kBAAA;AjJ+3iBF;;AiJ53iBA;EACE,gBAAA;EACA,WAAA;EACA,gBAAA;EACA,kBAAA;EACA,SAAA;EACA,eAAA;EACA,kBAAA;AjJ+3iBF;;AiJ53iBA;EACE,YAAA;EACA,UAAA;EACA,yBAAA;EACA,YAAA;EACA,SAAA;EACA,QAAA;EACA,kBAAA;EACA,oBAAA;EACA,oCAAA;EACA,yBAAA;EACA,iBAAA;EACA,iBAAA;AjJ+3iBF;;AiJ53iBA;EACE,UAAA;EACA,WAAA;AjJ+3iBF;;AiJ53iBA;EACE,WAAA;EACA,UAAA;AjJ+3iBF;;AkJ1yjBA;EACE,YAAA;AlJ6yjBF;AkJ3yjBE;EACE,UAAA;AlJ6yjBJ;AkJ1yjBE;EACE,yBAAA;EACA,iBAAA;AlJ4yjBJ;AkJ1yjBI;;EAEE,kCAAA;AlJ4yjBN;AkJzyjBI;EACE,6BAAA;AlJ2yjBN;AkJvyjBE;EACE,UAAA;EACA,QAAA;AlJyyjBJ;AkJtyjBE;EACE,WAAA;EACA,SAAA;AlJwyjBJ;;AmJr0jBA;EACE,yBCHW;EDIX,oDAAA;EACA,mBAAA;EACA,sBAAA;AnJw0jBF;AgBtwjBI;EmItEJ;IAOI,qBAAA;IACA,oBAAA;EnJy0jBF;EmJv0jBE;IACE,eAAA;IACA,cAAA;IACA,mBAAA;IACA,gBAAA;IACA,mBAAA;EnJy0jBJ;EmJv0jBI;IACE,oBAAA;IACA,gBAAA;IACA,mBAAA;IACA,iCAAA;EnJy0jBN;AACF;AgBtyjBI;EmI9BA;IA3BJ;MA4BM,gBAAA;MACA,MAAA;MACA,aAAA;InJw0jBF;EACF;AACF;AmJr0jBI;EACE,qBAAA;EACA,oBAAA;EACA,0CAAA;AnJu0jBN;AmJr0jBM;EAEE,sBAAA;EACA,wCAAA;AnJs0jBR;AmJn0jBM;EACE,gBAAA;AnJq0jBR;AmJh0jBE;EACE,qBAAA;EACA,WAAA;EACA,YAAA;EACA,wBAAA;AnJk0jBJ;AmJ/zjBE;EACE,mBAAA;AnJi0jBJ;AmJ9zjBE;EACE,gBAAA;EACA,chJ3CO;EgJ4CP,6BAAA;EACA,0DAAA;EACA,4BAAA;EACA,mCAAA;EACA,gCAAA;EACA,kBAAA;AnJg0jBJ;;AmJ3zjBA;EACE,eAAA;EACA,QAAA;EACA,aAAA;AnJ8zjBF;AmJ3zjBI;EACE,yCAAA;AnJ6zjBN;AmJzzjBE;EACE,UhJ3EI;EgJ4EJ,cC3FS;ApJs5jBb;;AmJvzjBA;EACE;IAEE,oBAAA;EnJyzjBF;EmJvzjBA;IAEE,yBAAA;EnJwzjBF;EmJtzjBA;IAEE,wBAAA;EnJuzjBF;AACF;AqJ/5jBA;EACE,kBAAA;EACA,aAAA;EACA,YAAA;ArJi6jBF;AqJ/5jBE;EACE,aAAA;ArJi6jBJ;;AqJ75jBA;EACE,kBAAA;EACA,SAAA;EACA,WAAA;EACA,WAAA;EACA,cAAA;EACA,uBAAA;EACA,cAAA;EACA,eAAA;EACA,6BAAA;EACA,SAAA;EACA,sBAAA;EACA,WAAA;EACA,yBD1BW;ApJ07jBb;AqJ95jBE;EACE,WAAA;EACA,mEAAA;ArJg6jBJ;;AqJ55jBA;EACE;IACE,cAAA;ErJ+5jBF;AACF;AsJ37jBM;;EACE,cAAA;EACA,gBAAA;EACA,sBAAA;EACA,oCAAA;EACA,+EACE;EAEF,mBnJgVO;EmJ/UP,sBAAA;EACA,cAAA;AtJ47jBR;AsJp7jBM;;EACE,gBAAA;AtJu7jBR;AsJl7jBE;;;EAGE,gBAAA;EACA,sCAAA;AtJo7jBJ;;AsJh7jBA;EACE,iBAAA;EACA,sCAAA;AtJm7jBF;AsJj7jBE;EACE,gBAAA;AtJm7jBJ;;AsJ/6jBA;EACE,0CAAA;EACA,0CAAA;AtJk7jBF;;AsJ96jBA;EACE,YAAA;EvIrDA,WAAA;EACA,mBAAA;EACA,kBAAA;EACA,kBAAA;EACA,iBAAA;Afu+jBF;;AsJl7jBA;EvIjDE,aAAA;EACA,eAAA;EACA,mBAAA;EACA,kBAAA;Afu+jBF;;AsJr7jBA;EvIpCE,kBAAA;EAIA,WAAA;EACA,mBAAA;EACA,kBAAA;Af09jBF;AgBl8jBI;EsIMJ;IvI1BE,aAAA;IAIA,cAAA;Efu9jBA;AACF;AgBx8jBI;EsIMJ;IvI1BE,wBAAA;IAIA,yBAAA;Ef69jBA;AACF;;AsJ57jBA;EvIhDE,kBAAA;EAIA,WAAA;EACA,mBAAA;EACA,kBAAA;Af6+jBF;AgBr9jBI;EsIkBJ;IvItCE,aAAA;IAIA,cAAA;Ef0+jBA;AACF;AgB39jBI;EsIkBJ;IvItCE,wBAAA;IAIA,yBAAA;Efg/jBA;AACF;;AsJ/7jBA;EACE,gBAAA;EACA,gBAAA;EACA,kBAAA;EACA,iBAAA;AtJk8jBF;;AsJ/7jBA;EACE,YAAA;EACA,qBAAA;EACA,qEAAA;EACA,sBAAA;AtJk8jBF;;AsJ/7jBA;EACE,YAAA;EACA,WAAA;EACA,YAAA;EACA,qEAAA;EACA,sBAAA;AtJk8jBF;;AsJ/7jBA;EACE,YAAA;EACA,oBAAA;EACA,qEAAA;EACA,sBAAA;AtJk8jBF;;AsJ/7jBA;EACE,eAAA;AtJk8jBF;;AsJ37jBA;EACE,kBAAA;EACA,oBAAA;AtJ87jBF;AsDlkkBE;EACE,cAAA;EACA,WAAA;EACA,WAAA;AtDokkBJ;AgB5gkBI;EsIuEJ;IAMI,eAAA;IACA,cAAA;EtJm8jBF;AACF;AsJj8jBE;;EAEE,aAAA;AtJm8jBJ;AsJh8jBE;EACE,gBAAA;AtJk8jBJ;AsJ/7jBE;EACE,kBAAA;EACA,aAAA;AtJi8jBJ;AgB7hkBI;EsI0FF;IAKI,eAAA;EtJk8jBJ;AACF;AsJ/7jBE;EACE,iBAAA;AtJi8jBJ;AsJ77jBI;EACE,kBAAA;AtJ+7jBN;AsJ37jBE;;;;;;;EAOE,kBAAA;EACA,qBAAA;AtJ67jBJ;AsJ17jBE;EACE,kBAAA;EACA,qBAAA;AtJ47jBJ;AsJ37jBI;EACE,SAAA;AtJ67jBN;AsJz7jBE;EACE,SAAA;AtJ27jBJ;AsJz7jBI;EACE,mBAAA;AtJ27jBN;AsJv7jBE;EACE,oBAAA;AtJy7jBJ;AsJt7jBE;EACE,gBAAA;EACA,cAAA;AtJw7jBJ;AsJr7jBE;EACE,gBAAA;AtJu7jBJ;AsJp7jBE;EACE,WAAA;AtJs7jBJ;;AsJ/6jBI;EACE,WAAA;EACA,sBAAA;AtJk7jBN;AsJh7jBI;EACE,eAAA;EACA,kBAAA;AtJk7jBN;AsJh7jBI;EACE,aAAA;AtJk7jBN;AsJ96jBE;;;;;;EAME,aAAA;EACA,gBAAA;AtJg7jBJ;;AsJ36jBA;EACE,aAAA;AtJ86jBF;;AsJz6jBE;EACE,mBAAA;AtJ46jBJ;;AsJt6jBE;EACE,mBAAA;EACA,sBAAA;AtJy6jBJ;AsJv6jBE;EACE,kBAAA;AtJy6jBJ;;AsJp6jBA;;EAEE,kBAAA;AtJu6jBF;;AsJr6jBA;EACE,qBAAA;AtJw6jBF;;AsJt6jBA;EACE,gBAAA;AtJy6jBF;;AsJr6jBA;EACE,gBAAA;AtJw6jBF;;AsJn6jBE;;EAEE,gBAAA;EACA,wBAAA;AtJs6jBJ;AsJp6jBE;EACE,gBAAA;EACA,wBAAA;AtJs6jBJ;AgB5okBI;EsI0OA;;IAEE,4BAAA;EtJq6jBJ;EsJn6jBE;IACE,4BAAA;EtJq6jBJ;AACF;;AsJh6jBA;EACE,kBAAA;EACA,qBAAA;AtJm6jBF;;AsJ/5jBA;EACE,aAAA;AtJk6jBF;AsJh6jBE;;EAEE,aAAA;AtJk6jBJ;;AsJ95jBA;EACE,aAAA;AtJi6jBF;;AsJ95jBA;EACE,yBAAA;AtJi6jBF;AsJ/5jBE;EACE,kBAAA;EACA,SAAA;EACA,WAAA;EACA,YAAA;EACA,UAAA;EACA,UAAA;EACA,cAAA;AtJi6jBJ;AsJ95jBE;EACE,UAAA;EACA,kBAAA;EACA,iBAAA;AtJg6jBJ;;AsJ35jBA;EACE,mBAAA;AtJ85jBF;;AsJ15jBA;EACE,sBAAA;EACA,yBAAA;AtJ65jBF;AsJ35jBE;EACE,kBAAA;EACA,cAAA;EACA,WAAA;EACA,YAAA;EACA,eAAA;AtJ65jBJ;;AsJx5jBA;EACE,mBAAA;AtJ25jBF;;AsJx5jBA;EACE,kBAAA;EACA,qBAAA;EACA,iBAAA;EACA,UAAA;AtJ25jBF;;AsJv5jBA;EACE,kBAAA;EACA,aAAA;EACA,kBAAA;EACA,cAAA;AtJ05jBF;;AsJv5jBA;EACE,kBAAA;EACA,aAAA;EACA,cAAA;AtJ05jBF;;AsJt5jBE;EACE,qBAAA;EACA,WAAA;EACA,YAAA;EACA,eAAA;EACA,yBAAA;AtJy5jBJ;;AsJp5jBE;EACE,yBAAA;AtJu5jBJ;;AsJ/4jBA;EACE,UAAA;EACA,gBAAA;EAGA,4CAAA;AtJg5jBF;AgBlvkBI;EsI6VJ;IAQI,UAAA;EtJi5jBF;AACF;;AsJ94jBA;EACE,mBAAA;EACA,kBAAA;AtJi5jBF;AgB5vkBI;EsIyWJ;IAKI,eAAA;IACA,cAAA;EtJk5jBF;AACF;;AsJ34jBA;EACE,mBAAA;EACA,oBAAA;EACA,gCAAA;AtJ84jBF;AsJ34jBI;EACE,yBAAA;EACA,yBAAA;EACA,gBAAA;EACA,sBAAA;AtJ64jBN;AsJz4jBE;EACE,uBAAA;AtJ24jBJ;AsJz4jBI;EACE,mBAAA;AtJ24jBN;AsJz4jBM;EAEE,cFxcK;ApJk1kBb;;AsJn4jBA;EACE,gBAAA;AtJs4jBF;;AsJp4jBA;EACE,WAAA;EACA,aAAA;EACA,eAAA;EACA,gBAAA;EACA,iBAAA;EACA,sBAAA;EACA,oCAAA;EACA,kBAAA;EACA,gBAAA;EACA,gBAAA;EACA,oBAAA;EACA,qBAAA;EACA,sBAAA;EACA,qBAAA;EACA,qBAAA;EACA,eAAA;EACA,WAAA;EACA,gBAAA;AtJu4jBF;AsJr4jBE;EACE,oCAAA;EACA,+EACE;AtJs4jBN;AsJl4jBE;EACE,mBAAA;EACA,aAAA;AtJo4jBJ;AsJj4jBE;EACE,uBAAA;EACA,sBAAA;EACA,sBAAA;EACA,iBAAA;AtJm4jBJ;AsJh4jBE;EACE,qBAAA;EACA,mBAAA;EACA,gBAAA;EACA,sBAAA;EACA,iBAAA;EACA,gBAAA;EACA,mBAAA;EACA,uBAAA;EACA,sBAAA;AtJk4jBJ;;AuJr4kBA;;EAEE,wOAAA;EAIA,eAAA;EACA,kBAAA;EACA,cAAA;EACA,gBAAA;EACA,gBAAA;EACA,oBAAA;EACA,kBAAA;EAGA,WAAA;EAIA,aAAA;EACA,mBAAA;EACA,cAAA;EACA,sBAAA;AvJq4kBF;;AuJ13kBA;;;;EAIE,iBAAA;EACA,mBAAA;AvJq4kBF;;AuJl4kBA,gBAAA;AAEA;EACE,gBAAA;EACA,SAAA;EACA,cAAA;AvJo4kBF;;AuJj4kBA,gBAAA;AAEA;EACE,cAAA;EACA,oBAAA;AvJm4kBF;;AuJh4kBA;;;;EAIE,cAAA;AvJm4kBF;;AuJh4kBA;EACE,cAAA;AvJm4kBF;;AuJh4kBA;EACE,YAAA;AvJm4kBF;;AuJh4kBA;;;EAGE,cAAA;AvJm4kBF;;AuJh4kBA;EACE,cAAA;AvJm4kBF;;AuJh4kBA;EACE,cAAA;AvJm4kBF;;AuJh4kBA;EACE,cAAA;AvJm4kBF;;AuJh4kBA;EACE,cAAA;AvJm4kBF;;AuJh4kBA;EACE,cAAA;AvJm4kBF;;AuJh4kBA;;;;EAIE,cAAA;AvJm4kBF;;AuJh4kBA;;;;;EAKE,cAAA;AvJm4kBF;;AuJh4kBA;;;EAGE,cAAA;AvJm4kBF;;AuJh4kBA;;EAEE,cAAA;AvJm4kBF;;AuJh4kBA;EACE,6BAAA;AvJm4kBF;;AuJh4kBA;EACE,iCAAA;EACA,qBAAA;AvJm4kBF;;AuJh4kBA;EACE,kBAAA;AvJm4kBF;;AuJh4kBA;;EAEE,iBAAA;AvJm4kBF;;AuJh4kBA;EACE,cAAA;AvJm4kBF;;AuJh4kBA;EACE,YAAA;AvJm4kBF;;AuJh4kBA;EACE,4BAAA;EACA,qBAAA;AvJm4kBF;;AuJh4kBA;;EAAA;AAIA;EACE,2BAAA;AvJk4kBF;;AuJ/3kBA;EACE,cAAA;AvJk4kBF;;AuJ/3kBA;;EAAA;AAIA;EACE,oCAAA;EAMA,2FAAA;AvJ63kBF;;AwJ9ilBA;EACE,gBAAA;AxJijlBF;AwJ/ilBE;EACE,eAAA;EACA,gBrJkWe;AH+skBnB;;AwJ7ilBA;EACE,QAAA;AxJgjlBF;AwJ9ilBE;;;EAGE,oBAAA;AxJgjlBJ;AwJ9ilBI;;;;;;EAEE,oBAAA;AxJojlBN;AwJjjlBI;;;EACE,cAAA;EACA,YAAA;EACA,iBAAA;EACA,kBAAA;EACA,WAAA;AxJqjlBN;AwJjjlBE;EACE,WAAA;EACA,eAAA;EACA,mBAAA;AxJmjlBJ;AgB5glBI;EwI1CF;IAMI,cAAA;IACA,gBAAA;IACA,4CAAA;ExJojlBJ;EwJnjlBI;IACE,SAAA;ExJqjlBN;AACF;AwJ/ilBQ;;;;;;EAEE,arJuYW;EqJtYX,mBAAA;EACA,yBAAA;AxJqjlBV;AwJnjlBU;;;;;;EACE,gBAAA;AxJ0jlBZ;AwJrjlBI;EACE,mBAAA;AxJujlBN;;AwJ9ilBE;EACE,gBAAA;EACA,iBAAA;EACA,gBrJ8Re;AHmxkBnB;AwJ9ilBE;EACE,kBAAA;EACA,kBAAA;EACA,gBrJwRe;AHwxkBnB;AwJ7ilBE;;EAEE,sBAAA;AxJ+ilBJ;AgBvklBI;EwI4BA;;;IAGE,cAAA;ExJ8ilBJ;AACF;;AwJ1ilBA;EACE,qBAAA;EACA,8BAAA;EACA,qBAAA;AxJ6ilBF;;AwJ1ilBA;EACE,gBAAA;EACA,qBAAA;EACA,gBAAA;AxJ6ilBF;AgB1llBI;EwI0CJ;IAMI,iBAAA;IACA,gBrJ0Pe;EHozkBjB;AACF;;AwJ3ilBA;EACE,sBAAA;EACA,gBAAA;AxJ8ilBF;AgBrmlBI;EwIqDJ;IAKI,cAAA;IACA,mBAAA;IACA,mBAAA;ExJ+ilBF;AACF;;AwJ5ilBA;EACE,cJ5HW;ApJ2qlBb;;AwJ5ilBA;EACE,uDJ/HkB;ApJ8qlBpB;;AwJ1ilBE;EACE,iBAAA;AxJ6ilBJ;;AwJxilBA;EACE,cAAA;EACA,sBAAA;EACA,yBAAA;AxJ2ilBF;;AwJxilBA;EACE,YAAA;EACA,cAAA;EACA,WAAA;AxJ2ilBF;;AwJxilBA;EACE,kBAAA;EACA,SAAA;EACA,mBAAA;EACA,kCAAA;EACA,6BAAA;AxJ2ilBF;;AwJxilBA;EACE,qBAAA;AxJ2ilBF;;AwJxilBA;EACE,kBAAA;EACA,WAAA;EACA,SAAA;AxJ2ilBF;;AwJxilBA;EACE,kBAAA;EACA,WAAA;EACA,SAAA;EAGA,2BAAA;AxJ2ilBF;;AwJxilBA;EACE,qBAAA;EACA,cAAA;AxJ2ilBF;;AwJxilBA;EACE,WAAA;EACA,qBAAA;EACA,kBAAA;EACA,YAAA;AxJ2ilBF;;AwJxilBA;EACE,WAAA;AxJ2ilBF;;AwJxilBA;EACE,eAAA;AxJ2ilBF;;AwJxilBA;EACE,eAAA;EACA,yBAAA;EACA,gBAAA;EACA,gBAAA;EACA,WAAA;EACA,gBAAA;EACA,iBAAA;EACA,kBAAA;EACA,sBAAA;AxJ2ilBF;;AwJxilBA;EACE,kBAAA;EACA,SAAA;EACA,WAAA;EACA,eAAA;EAGA,2BAAA;AxJ2ilBF;;AwJxilBA;EACE,WAAA;EACA,eAAA;EACA,eAAA;AxJ2ilBF;;AwJxilBA;EACE,eAAA;AxJ2ilBF;;AwJxilBA;EACE,eAAA;EACA,cAAA;EACA,yBAAA;EACA,iBAAA;AxJ2ilBF;;AwJxilBA;EACE,eAAA;AxJ2ilBF;;AwJxilBA;EACE,gBAAA;EACA,eAAA;EACA,WAAA;AxJ2ilBF;;AwJxilBA;;;;;;EAME,oCJ3PiB;EI4PjB,2CAAA;EACA,aAAA;AxJ2ilBF;;AwJxilBA;;EAEE,mBAAA;AxJ2ilBF;;AwJxilBA;;EAEE,iBAAA;AxJ2ilBF;;AwJxilBA;;EAEE,WAAA;EACA,YAAA;EACA,WAAA;EACA,kBAAA;EACA,qBAAA;EACA,kBAAA;EACA,6BAAA;AxJ2ilBF;;AwJxilBA;;EAEE,qBAAA;AxJ2ilBF;;AwJxilBA;;EAEE,WAAA;EACA,oBAAA;EACA,eAAA;EACA,qBAAA;EACA,yBAAA;EACA,gBAAA;EACA,mBAAA;EACA,cAAA;EACA,gBAAA;EACA,iBAAA;EACA,kBAAA;EACA,sBAAA;AxJ2ilBF;;AyJj1lBA;EAOE,QAAA;EACA,iBAAA;EACA,sBAAA;EACA,mBAAA;AzJ80lBF;AyJv1lBE;EADF;IAEI,gBAAA;IACA,SAAA;IACA,0BAAA;IACA,gBAAA;EzJ01lBF;AACF;;AyJn1lBA;EACE,eAAA;EACA,2BAAA;AzJs1lBF;AyJp1lBE;EACE,kBAAA;AzJs1lBJ;AyJp1lBI;EACE,aAAA;AzJs1lBN;;AyJj1lBA;EACE,cAAA;EACA,eAAA;AzJo1lBF;AyJl1lBE;EACE,cAAA;EACA,wBAAA;EACA,cAAA;EACA,cAAA;AzJo1lBJ;AyJl1lBI;EACE,ctJGC;EsJFD,qBAAA;AzJo1lBN;;AyJ50lBA;EACE,QAAA;EACA,gCAAA;EACA,yBL3Cc;ApJ03lBhB;AgBx0lBI;EyIVJ;IAYI,+BAAA;EzJ00lBF;EyJh1lBE;IANJ;MAOM,gBAAA;MACA,SAAA;MACA,aAAA;MACA,0BAAA;IzJm1lBF;EACF;AACF;AgBr1lBI;EyIVJ;IAgBI,eAAA;EzJm1lBF;AACF;;AyJh1lBA;EACE,iBAAA;EACA,oBAAA;EACA,mBAAA;EACA,kBAAA;AzJm1lBF;AgBj2lBI;EyIiBA;IAPJ;MAQM,8BAAA;MACA,gBAAA;IzJo1lBF;EACF;AACF;AgBz2lBI;EyIUJ;IAaI,yBAAA;EzJs1lBF;AACF;;AyJn1lBA;EACE,kBAAA;EACA,kBAAA;EACA,mBAAA;EACA,kBAAA;EACA,4CAAA;AzJs1lBF;AyJp1lBE;EACE,8DL7FgB;EK8FhB,6EAAA;AzJs1lBJ;;AyJl1lBA;EACE,cAAA;EACA,ctJ7ES;AHk6lBX;;AyJl1lBA;EACE,aAAA;AzJq1lBF;;AyJl1lBA;EACE,cAAA;EACA,uBAAA;EACA,gBAAA;EACA,mBAAA;EACA,cAAA;AzJq1lBF;AyJn1lBE;EACE,0BAAA;EACA,qBAAA;AzJq1lBJ;;AyJh1lBE;EACE,mBAAA;AzJm1lBJ;AyJj1lBI;EACE,gBAAA;AzJm1lBN;AyJh1lBI;EACE,0BAAA;AzJk1lBN;AyJh1lBM;EACE,6BAAA;AzJk1lBR;AyJ90lBI;EACE,cAAA;AzJg1lBN;;AyJ10lBA;EACE,cAAA;EACA,uBAAA;EACA,cAAA;EACA,cAAA;AzJ60lBF;;AyJ10lBA;EACE,0BAAA;EACA,qBAAA;EACA,6BAAA;AzJ60lBF;;AyJ10lBA;EACE,gBAAA;EACA,cAAA;EACA,6BAAA;EACA,kBAAA;EACA,kBAAA;AzJ60lBF;AyJ30lBE;EACE,WAAA;EACA,kBAAA;EACA,YAAA;EACA,UAAA;EACA,yBAAA;EACA,QAAA;EACA,YAAA;EACA,2BAAA;AzJ60lBJ;;AyJz0lBA;EACE,cAAA;AzJ40lBF;;AyJz0lBA;EACE,YAAA;AzJ40lBF;AyJ10lBE;EACE,UAAA;AzJ40lBJ;AyJz0lBE;EACE,yBAAA;EACA,iBAAA;AzJ20lBJ;AyJz0lBI;;EAEE,kCAAA;AzJ20lBN;AyJx0lBI;EACE,6BAAA;AzJ00lBN;AyJt0lBE;EACE,UAAA;EACA,QAAA;AzJw0lBJ;AyJr0lBE;EACE,WAAA;EACA,SAAA;AzJu0lBJ;;A0JrhmBA;EACE,cAAA;EACA,kBAAA;EACA,yBAAA;A1JwhmBF;A0JthmBE;EACE,gBAAA;EACA,cvJaO;AH2gmBX;A0JthmBI;EAEE,cvJiEI;AHs9lBV;A0JnhmBE;EACE,gBAAA;A1JqhmBJ;AgB5+lBI;E0IzDJ;IAoBI,gBAAA;E1JqhmBF;AACF;;A0JlhmBA;EACE,eAAA;EACA,mBAAA;A1JqhmBF;A0JnhmBE;EACE,qBAAA;A1JqhmBJ;A0JnhmBI;EACE,iBAAA;A1JqhmBN;;A2JpjmBA;EACE;IAAK,yBAAA;E3JwjmBL;AACF;A2JtjmBA;EACE,qBAAA;EACA,WtJokCsB;EsJnkCtB,YtJmkCsB;EsJlkCtB,2BAAA;EACA,iCAAA;EACA,+BAAA;EAEA,kBAAA;EACA,+CAAA;A3JujmBF;;A2JpjmBA;EACE,WtJ6jCwB;EsJ5jCxB,YtJ4jCwB;EsJ3jCxB,mBtJ6jCwB;AL0/jB1B;;A2JhjmBA;EACE;IACE,mBAAA;E3JmjmBF;E2JjjmBA;IACE,UAAA;IACA,eAAA;E3JmjmBF;AACF;A2JhjmBA;EACE,qBAAA;EACA,WtJoiCsB;EsJniCtB,YtJmiCsB;EsJliCtB,2BAAA;EACA,8BAAA;EAEA,kBAAA;EACA,UAAA;EACA,6CAAA;A3JijmBF;;A2J9imBA;EACE,WtJ6hCwB;EsJ5hCxB,YtJ4hCwB;ALqhkB1B;;A2J7imBE;EACE;;IAEE,wBAAA;E3JgjmBJ;AACF;A4J9mmBA;;CAAA;AAGA;EACE,kBAAA;A5JgnmBF;A4J9mmBE;EAKE,4BAAA;EACA,iBAAA;EACA,kBAAA;EACA,cAAA;EACA,UAAA;A5JgnmBJ;A4J7mmBI;EACE,UAAA;EACA,mBAAA;EACA,aAAA;A5J+mmBN;;A4J3mmBA;EACE,aAAA;EACA,kBAAA;EACA,aAAA;EACA,eAAA;EACA,yBAAA;EACA,gBAAA;EACA,uBAAA;EACA,gDAAA;EAEA,4BAAA;EACA,gBAAA;A5J8mmBF;A4J5mmBE;EACE,qBAAA;EACA,kBAAA;EACA,QAAA;EACA,SAAA;EACA,sBAAA;EACA,WAAA;EACA,SAAA;EACA,UAAA;EACA,WAAA;EACA,cAAA;EACA,0BAAA;EACA,qCAAA;EACA,oCAAA;A5J8mmBJ;A4J5mmBE;EACE,kCAAA;EACA,qCAAA;EACA,oCAAA;EACA,WAAA;EACA,qBAAA;EACA,kBAAA;EACA,SAAA;EACA,UAAA;A5J8mmBJ;;A4J1mmBA;EACE,cAAA;EACA,SAAA;A5J6mmBF;;A4J3mmBA;EACE,gBAAA;EACA,gBAAA;A5J8mmBF;;A4J3mmBA;EACE,kBAAA;EACA,aAAA;EACA,kBAAA;EACA,kBAAA;EACA,kBAAA;A5J8mmBF;A4J7mmBE;EACE,mBAAA;EACA,WAAA;EACA,YAAA;EACA,kBAAA;EACA,kBAAA;EACA,MAAA;EACA,OAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,yCAAA;EACA,eAAA;EACA,gBAAA;A5J+mmBJ;;A4J3mmBA;EACE,WAAA;EACA,SAAA;EACA,6BAAA;A5J8mmBF;;A4J5mmBA;;EAEE,kBAAA;EACA,YAAA;A5J+mmBF;;A4J7mmBA;EACE,eAAA;A5JgnmBF;;A4J9mmBA;EACE,mBAAA;EACA,WAAA;EACA,YAAA;EACA,0BAAA;EACA,kBAAA;EACA,YAAA;EACA,kBAAA;A5JinmBF;A4JhnmBE;EASE,oCAAA;EACA,sBAAA;A5J0mmBJ;A4JxmmBE;EACE,0BAAA;EACA,6BAAA;A5J0mmBJ;A4JxmmBE;EACE,gBAAA;A5J0mmBJ;A4JxmmBE;EACE,yBAAA;EACA,4BAAA;A5J0mmBJ;;A4JrmmBI;EACE,kBAAA;EACA,eAAA;EACA,oBAAA;EACA,mBAAA;EACA,iBAAA;EACA,gBAAA;EACA,mBAAA;EACA,WAAA;EACA,YAAA;A5JwmmBN;A4JtmmBI;EACE,czJrIK;EyJsIL,mBAAA;A5JwmmBN;A4JvmmBM;EAEE,czJ3IG;EyJ4IH,gBAAA;A5JwmmBR;;A4JlmmBA;;;;;;EAME,mBAAA;EACA,eAAA;A5JqmmBF;;A4JnmmBA;EACE,kBAAA;A5JsmmBF;;A4JpmmBA;EACE,yBAAA;A5JummBF;;A4JrmmBA;;EAEE,gBAAA;EACA,cAAA;EACA,mBAAA;A5JwmmBF;;A4JrmmBA;EACE,cAAA;A5JwmmBF;;A4JtmmBA;;EAEE,gBAAA;EACA,cAAA;EACA,mBAAA;A5JymmBF;;A4JvmmBA;EACE,eAAA;EACA,mBAAA;EACA,mBAAA;EACA,WAAA;EACA,YAAA;EACA,0BAAA;EACA,kBAAA;EACA,YAAA;EACA,gBAAA;EACA,uBAAA;A5J0mmBF;;A4JxmmBA;EACE,gBAAA;EACA,uBAAA;EACA,mBAAA;EACA,YAAA;EACA,YAAA;EACA,0BAAA;EACA,kBAAA;EACA,YAAA;A5J2mmBF;;A4JzmmBA;;EAEE,mBAAA;EACA,WAAA;EACA,YAAA;EACA,0BAAA;EACA,kBAAA;EACA,YAAA;EACA,uBAAA;EACA,eAAA;A5J4mmBF;;A4JxmmBE;;;;;EAKE,czJvNO;AHk0mBX;;A4JvmmBA;;EAEE,cAAA;EACA,2BAAA,EAAA,eAAA;EACA,yBAAA,EAAA,wBAAA,EACA,cAAA,EACA,YAAA,EACA,2BAAA;EACA,iBAAA;A5J0mmBF;;A4JvmmBA;;EAEE,gBAAA;EACA,cAAA;EACA,mBAAA;A5J0mmBF;;A4JxmmBA;EACE,eAAA;A5J2mmBF;;A4JzmmBA;EACE,mBAAA;A5J4mmBF;;A4JzmmBA;EACE,YAAA;EACA,gBAAA;EACA,eAAA;A5J4mmBF;;A4J1mmBA;EACE,sBAAA;A5J6mmBF;;A4J1mmBA;EACE,WAAA;EACA,YAAA;A5J6mmBF;;A4J1mmBA;;EAEE,YAAA;EACA,UAAA;EACA,eAAA;A5J6mmBF;;A4J3mmBA;;EAEE,gBAAA;A5J8mmBF;;A4J3mmBA;EACE,qBAAA;A5J8mmBF;;A4J1mmBE;EACE,WAAA;EACA,WAAA;EACA,oBAAA;EACA,WAAA;EACA,kBAAA;A5J6mmBJ;A4J3mmBE;EACE,QAAA;EACA,6BAAA;A5J6mmBJ;;A4JzmmBA;EACE,aAAA;A5J4mmBF;;A4JzmmBA;EACE,WAAA;A5J4mmBF;A4J3mmBE;EACE,YAAA;EACA,YAAA;EACA,6BAAA;A5J6mmBJ;;A4JxmmBI;EACE,czJhRC;EyJiRD,kBAAA;EACA,yBAAA;A5J2mmBN;;A4JtmmBA;EACE,YAAA;EACA,kBAAA;A5JymmBF;;A4JvmmBA;EACE,iBAAA;EACA,eAAA;EACA,cAAA;EACA,kBAAA;EACA,czJ/TS;EyJoUT,4BAAA;EAEA,2BAAA,EAAA,eAAA;EACA,yBAAA,EAAA,wBAAA,EACA,cAAA,EACA,YAAA,EACA,2BAAA;EACA,iBAAA;A5JymmBF;;A4JvmmBA;EACE,gBAAA;EACA,cAAA;A5J0mmBF;;A4JxmmBA;EACE,kBAAA;EACA,iBAAA;A5J2mmBF;;A4JxmmBA;EACE,sBAAA;EACA,iBAAA;EACA,WAAA;A5J2mmBF;;A4JxmmBA;EACE,WAAA;EACA,kBAAA;EACA,gBAAA;A5J2mmBF;;A4JzmmBA;;EAEE,oBAAA;A5J4mmBF;A4J3mmBE;;;;EAEE,qBAAA;EACA,WAAA;EACA,YAAA;EACA,iBAAA;EACA,eAAA;EACA,eAAA;EACA,kBAAA;EACA,kBAAA;A5J+mmBJ;A4J7mmBI;;;;;;;;;;;;;EAIE,oCAAA;EACA,WzJzXE;AHi/mBR;;A4JpnmBA;EACE,yBAAA;EACA,4BAAA;A5JunmBF;;A4JrnmBA;EACE,yBAAA;EACA,4BAAA;A5JwnmBF;;A4JtnmBA;EACE,0BAAA;EACA,6BAAA;A5JynmBF;;A4JtnmBA;EACE,SAAA;EACA,gBAAA;EACA,cAAA;A5JynmBF;;A6JrhnBE;EACE,iBAAA;A7JwhnBJ;;A6JrhnBA;EACE,gBAAA;A7JwhnBF;;A8J9hnBA;;EAEE,aAAA;A9JiinBF;;A+JninBA;EACE;IACE,UAAA;IACA,2CACE;E/JqinBJ;E+JlinBA;IACE,UAAA;E/JoinBF;AACF;AgK7inBA;EACE,oBAAA;AhK+inBF;;AgK7inBA;EACE,iBAAA;AhKgjnBF;;AiKnjnBE;EACE,iBAAA;AjKsjnBJ;AiKpjnBE;EACE,kBAAA;AjKsjnBJ;;AkKtjnBM;EACE,8BAAA;AlKyjnBR;;AmK5jnBE;EACE,eAAA;AnK+jnBJ;;AoK9jnBE;EACE,cAAA;ApKiknBJ;;AqKjknBE;EACE,mB1DNa;A3G0knBjB;;AsKxknBE;EACE,qBAAA;AtK2knBJ;;AuK5knBE;EACE,SAAA;AvK+knBJ;AuK7knBE;EACE,UAAA;AvK+knBJ;;AwKnlnBE;EACE,eAAA;AxKslnBJ;;AyKhjnBA;EAEI;IACE,kBAAA;EzKkjnBJ;AACF;A0K3lnBI;EACE,gBAAA;EACA,iBAAA;EACA,kBAAA;EACA,mBAAA;EACA,qBAAA;A1K6lnBN;A2K7jnBI;EDrCA;IAOI,iBAAA;IAGA,kBAAA;IACA,mBAAA;IACA,oBAAA;E1K6lnBN;AACF;A2KrknBI;EDvBE;IAEI,8BAAA;E1K8lnBR;AACF;A0K7lnBQ;EACE,kBAAA;A1K+lnBV;A0K7lnBQ;EACE,kBAAA;A1K+lnBV;A0K7lnBQ;EACE,c/D5BG;E+D6BH,eAAA;EACA,gBAAA;EACA,mBAAA;A1K+lnBV;A0K3lnBI;EACE,eAAA;EACA,gBAAA;EACA,iBAAA;EACA,c/DvCO;A3GoonBb;A0K5lnBM;EACE,eAAA;EACA,gBAAA;EACA,iBAAA;A1K8lnBR;A0KxlnBU;EACE,cAAA;EACA,SAAA;EACA,gCAAA;EACA,WAAA;EACA,uBAAA;EACA,kBAAA;A1K0lnBZ;A0KxlnBU;EACE,SAAA;EACA,gCAAA;EACA,uBAAA;EACA,UAAA;EACA,SAAA;A1K0lnBZ;A0KzlnBY;EACE,a/D7DC;A3GwpnBf;A0KtlnBM;EACE,c/DtEK;E+DuEL,eAAA;EACA,gBAAA;EACA,mBAAA;A1KwlnBR;A0KvlnBQ;EACE,gBAAA;EACA,WAAA;EACA,YAAA;A1KylnBV;A0KrlnBI;EACE,aAAA;EACA,mBAAA;A1KulnBN;A0KtlnBM;EACE,kBAAA;EACA,UAAA;EACA,QAAA;EACA,SAAA;A1KwlnBR;A0KrlnBQ;EACE,yB/DzFK;E+D0FL,qB/D1FK;A3GirnBf;A0KtlnBU;EACE,aAAA;A1KwlnBZ;A0KplnBM;EACE,WAAA;EACA,YAAA;EACA,yBAAA;EACA,gBAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,kBAAA;EACA,iBAAA;EACA,kBAAA;EACA,YAAA;EACA,sBAAA;EACA,sCAAA;EACA,eAAA;EACA,gBAAA;A1KslnBR;A0KplnBM;EACE,WAAA;EACA,eAAA;EACA,aAAA;A1KslnBR;A0KplnBM;EACE,gBAAA;EACA,c/D3HK;A3GitnBb;A0KrlnBQ;EACE,c/D1HK;A3GitnBf;A0KnlnBI;EACE,yBAAA;EACA,eAAA;EACA,gBAAA;EACA,iBAAA;EACA,eAAA;EACA,iBAAA;EACA,oBAAA;EACA,kBAAA;EACA,mBAAA;EACA,qBAAA;EACA,uBAAA;EACA,UAAA;EACA,c/D3IS;E+D4IT,gBAAA;A1KqlnBN;A0KnlnBI;EACE,eAAA;EACA,gBAAA;EACA,iBAAA;EACA,eAAA;EACA,iBAAA;EACA,oBAAA;EACA,kBAAA;EACA,mBAAA;EACA,qBAAA;EACA,mB/DxJS;E+DyJT,SAAA;EACA,UAAA;EACA,uDACE;EAEF,WAAA;EACA,gBAAA;A1KmlnBN;A0KllnBM;EACE,mBAAA;EACA,gBAAA;A1KolnBR;A0KhlnBM;EACE,eAAA;EACA,iBAAA;EACA,gBAAA;EACA,c/D7KK;A3G+vnBb;A0KhlnBM;EACE,gBAAA;EACA,c/D9KO;A3GgwnBf;A0K7knBI;EACE,WAAA;EACA,YAAA;EACA,iBAAA;A1K+knBN;;A4KzwnBE;EACE,aAAA;A5K4wnBJ;A4K3wnBI;EACE,yBAAA;EACA,6BAAA;EACA,gBAAA;A5K6wnBN;A4K5wnBM;EACE,cjEHO;A3GixnBf;A4K3wnBQ;EACE,yBjEPK;A3GoxnBf;A4KxwnBE;EACE,sBAAA;EACA,aAAA;EACA,mBAAA;EACA,sBAAA;EACA,6BAAA;EACA,qBAAA;EACA,kBAAA;EACA,6CAAA;EACA,eAAA;EACA,yBAAA;EACA,gBAAA;A5K0wnBJ;A4KxwnBM;EACE,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,WAAA;EACA,YAAA;EACA,yBAAA;EACA,kBAAA;EACA,iBAAA;EACA,kBAAA;EACA,kCAAA;A5K0wnBR;A4KzwnBQ;EACE,WAAA;EACA,YAAA;EACA,kBAAA;EACA,6BAAA;EACA,sCAAA;A5K2wnBV;A4KvwnBI;EACE,eAAA;EACA,gBAAA;EACA,mBAAA;EACA,cjElDO;A3G2znBb;A4KvwnBI;EAEE,yBAAA;EACA,6BAAA;EACA,gBAAA;A5KwwnBN;A4KvwnBM;EACE,cjEzDO;A3Gk0nBf;;A6Kp0nBA;EACE,SAAA;A7Ku0nBF;A6Kt0nBE;EACE,QAAA;A7Kw0nBJ;A6Kv0nBI;EACE,aAAA;EACA,gBAAA;A7Ky0nBN;A6Kv0nBI;EACE,WAAA;EACA,WAAA;EACA,kBAAA;EACA,yBlERQ;EkESR,iCAAA;EACA,gBAAA;EAEA,WAAA;EACA,WAAA;EACA,kBAAA;EACA,yBAAA,EAAA,kBAAA;EACA,iCAAA;A7Kw0nBN;A6Kv0nBM;EACE,yBlEnBM;A3G41nBd;A6Kt0nBI;EACE,mBAAA;EACA,clExBQ;A3Gg2nBd;;A8Kp2nBA;EACE,kBAAA;A9Ku2nBF;A8Kt2nBE;EACE,UAAA;EACA,kBAAA;EACA,iBAAA;A9Kw2nBJ;A8Kv2nBI;EACE,qBAAA;EACA,aAAA;A9Ky2nBN;A8Kx2nBM;EACE,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,YAAA;EACA,kBAAA;EACA,kBAAA;A9K02nBR;A8Kz2nBQ;EACE,WAAA;EACA,kBAAA;EACA,WAAA;EACA,WAAA;EACA,yBnEbG;EmEcH,QAAA;EACA,UAAA;EACA,WAAA;A9K22nBV;A8Kz2nBQ;EACE,aAAA;A9K22nBV;A8Kz2nBQ;EACE,WAAA;EACA,YAAA;EACA,yBAAA;EACA,yBAAA;EACA,0BAAA;EACA,kBAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;A9K22nBV;A8K12nBU;EACE,WAAA;EACA,YAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;A9K42nBZ;A8K32nBY;EACE,WAAA;EACA,YAAA;A9K62nBd;A8Kz2nBQ;EACE,cnElDG;A3G65nBb;A8Kx2nBU;EACE,yBnEjDC;A3G25nBb;A8Kx2nBU;EACE,yBnEpDC;A3G85nBb;A8Kx2nBc;EACE,YnE7DL;A3Gu6nBX;A8Kt2nBU;EACE,cnE5DC;A3Go6nBb;A8Kl2nBc;EACE,UnEzEL;A3G66nBX;;A+K76nBE;EACE,eAAA;A/Kg7nBJ;A+K96nBE;EACE,cAAA;A/Kg7nBJ;A+K96nBE;EACE,kBAAA;A/Kg7nBJ;A+K/6nBI;EACE,WAAA;A/Ki7nBN;A+Kh7nBM;EACE,uBAAA;EACA,cpEXK;EoEYL,SAAA;EACA,gCAAA;EACA,WAAA;EACA,uBAAA;EACA,kBAAA;A/Kk7nBR;A+K/6nBI;EACE,kBAAA;EACA,QAAA;EACA,QAAA;EACA,2BAAA;EACA,eAAA;EACA,eAAA;A/Ki7nBN;A+K/6nBI;EACE,apE3BS;A3G48nBf;;AgL/8nBA;EACE,aAAA;EACA,sBAAA;EACA,YAAA;AhLk9nBF;AgLj9nBE;EACE,crELS;EqEMT,eAAA;EACA,gBAAA;EACA,mBAAA;AhLm9nBJ;AgLj9nBE;EACE,kBAAA;EACA,aAAA;EACA,mBAAA;EACA,eAAA;EACA,uBAAA;EACA,crEdS;EqEeT,SAAA;EACA,gCAAA;EACA,WAAA;EACA,uBAAA;EACA,kBAAA;AhLm9nBJ;AgLl9nBI;EACE,SAAA;AhLo9nBN;AgLl9nBI;EACE,gBAAA;EACA,WAAA;EACA,YAAA;AhLo9nBN;AgLn9nBM;EACE,WAAA;EACA,YAAA;EACA,arEvBM;A3G4+nBd;AgLh9nBE;EACE,kBAAA;EACA,SAAA;EACA,OAAA;EACA,QAAA;EACA,sBAAA;EACA,gBAAA;EACA,sBAAA;EACA,0CAAA;EACA,kBAAA;EACA,aAAA;EACA,WAAA;AhLk9nBJ;AgLh9nBI;EACE,YAAA;EACA,eAAA;AhLk9nBN;AgLh9nBM;EACE,yBAAA;AhLk9nBR;;AiLzgoBA;EACE,aAAA;EACA,sBAAA;AjL4goBF;AiL1goBE;EACE,ctELS;EsEMT,eAAA;EACA,gBAAA;EACA,mBAAA;AjL4goBJ;AiL1goBE;EACE,kBAAA;EACA,aAAA;EACA,mBAAA;EACA,eAAA;EACA,uBAAA;EACA,ctEdS;EsEeT,SAAA;EACA,gCAAA;EACA,WAAA;EACA,uBAAA;EACA,kBAAA;AjL4goBJ;AiL3goBI;EACE,WAAA;EACA,YAAA;AjL6goBN;AiL5goBM;EACE,WAAA;EACA,YAAA;AjL8goBR;AiL3goBI;EACE,SAAA;AjL6goBN;AiL3goBI;EACE,cAAA;EACA,WAAA;EACA,YAAA;AjL6goBN;AiL5goBM;EACE,WAAA;EACA,YAAA;EACA,atE/BM;A3G6ioBd;AiLzgoBE;EACE,kBAAA;EACA,SAAA;EACA,OAAA;EACA,QAAA;EACA,sBAAA;EACA,gBAAA;EACA,sBAAA;EACA,0CAAA;EACA,kBAAA;EACA,aAAA;AjL2goBJ;AiLzgoBI;EACE,YAAA;EACA,eAAA;AjL2goBN;AiLzgoBM;EACE,yBAAA;AjL2goBR;;AiLrgoBA;;;EAGE,wBAAA;EACA,0BAAA;EACA,SAAA;EACA,SAAA;EACA,UAAA;EACA,gBAAA;EACA,6BAAA;EACA,eAAA;AjLwgoBF;;AkLrloBE;EACE,eAAA;EACA,gBAAA;EACA,mBAAA;EACA,gBAAA;EACA,cvENS;A3G8loBb;AkLtloBE;EACE,qbAAA;EAgCA,uDACE;EAIF,6CACE;EAIF,4BAAA;EACA,kBAAA;AlLijoBJ;AkLhjoBI;EACE,kBAAA;AlLkjoBN;AkLjjoBM;EACE,WAAA;EACA,YAAA;EACA,evEvDO;A3G0moBf;AkLhjoBQ;EACE,cvE9DG;A3GgnoBb;AkL/ioBM;EACE,UAAA;EACA,WAAA;EACA,YAAA;EACA,kBAAA;EACA,MAAA;EACA,OAAA;EACA,eAAA;AlLijoBR;AkL7ioBM;EACE,iBAAA;AlL+ioBR;AkL7ioBM;EACE,WAAA;EACA,YAAA;AlL+ioBR;;AmLhooBA;EACE,eAAA;EACA,MAAA;EACA,OAAA;EACA,OAAA;EACA,SAAA;EACA,YAAA;EACA,YAAA;EACA,8BAAA;EACA,aAAA;AnLmooBF;AmLlooBE;EACE,kBAAA;EACA,SAAA;EACA,WAAA;EACA,UAAA;AnLoooBJ;AmLnooBI;EACE,WAAA;EACA,YAAA;EACA,exElBO;EwEmBP,eAAA;AnLqooBN;AmLlooBE;EACE,gBAAA;EACA,iBAAA;EACA,mBAAA;EACA,sBxEzBO;EwE0BP,kBAAA;AnLoooBJ;AmLlooBM;EACE,yBxEvBK;EwEwBL,WAAA;EACA,YAAA;EACA,kBAAA;EACA,sBAAA;AnLoooBR;AmLnooBQ;EACE,YxEnCC;A3GwqoBX;AmLlooBM;EACE,eAAA;EACA,gBAAA;EACA,iBAAA;EACA,kBAAA;EACA,cxErCK;A3GyqoBb;AmLlooBM;EACE,eAAA;EACA,gBAAA;EACA,iBAAA;EACA,cxEhDK;EwEiDL,kBAAA;AnLoooBR;AmLlooBM;EACE,gBAAA;EACA,eAAA;EACA,gBAAA;EACA,iBAAA;EACA,cxE1DK;EwE2DL,kBAAA;AnLoooBR;AmLlooBM;EACE,gBAAA;EACA,eAAA;EACA,gBAAA;EACA,iBAAA;EACA,eAAA;EACA,iBAAA;EACA,oBAAA;EAGA,qBAAA;EACA,mBxErEO;EwEsEP,SAAA;EACA,UAAA;EACA,uDACE;EAEF,WAAA;EACA,gBAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;AnLgooBR;AmL/noBQ;EACE,mBAAA;EACA,gBAAA;AnLiooBV;AmL7noBQ;EACE,eAAA;EACA,iBAAA;EACA,gBAAA;EACA,cxE7FG;A3G4toBb;AmL7noBQ;EACE,gBAAA;EACA,cxE9FK;A3G6toBf;;AoLztoBI;EACE,oBAAA;ApL4toBN;AoL3toBM;EACE,eAAA;EACA,gBAAA;EACA,iBAAA;EACA,czEbK;A3G0uoBb;AoL3toBM;EACE,eAAA;EACA,gBAAA;EACA,mBAAA;EACA,czEVM;A3GuuoBd;AoL3toBM;EACE,kBAAA;EACA,mBAAA;EACA,gBAAA;ApL6toBR;AoLxtoBQ;EAKE,kBAAA;ApLstoBV;AoL1toBU;EACE,mBAAA;EACA,UAAA;ApL4toBZ;AoLztoBU;EACE,SAAA;EAEA,uBAAA;EACA,UAAA;EACA,SAAA;EAEA,kBAAA;EACA,QAAA;EACA,MAAA;EACA,eAAA;EACA,oBAAA;EACA,eAAA;ApLytoBZ;AoLxtoBY;EACE,azE9CC;A3GwwoBf;;AqL7woBA;EACE,yBAAA;EACA,eAAA;EACA,gBAAA;EACA,iBAAA;EACA,eAAA;EACA,iBAAA;EACA,oBAAA;EACA,kBAAA;EACA,mBAAA;EACA,qBAAA;EACA,uBAAA;EACA,UAAA;EACA,c1ERa;E0ESb,gBAAA;ArLgxoBF;AqL/woBE;EACE,mBAAA;EACA,gBAAA;EACA,W1EfO;A3GgyoBX;;AqL9woBA;EACE,eAAA;EACA,gBAAA;EACA,iBAAA;EACA,eAAA;EACA,iBAAA;EACA,oBAAA;EACA,kBAAA;EACA,mBAAA;EACA,qBAAA;EACA,mB1E1Ba;E0E2Bb,SAAA;EACA,UAAA;EACA,uDACE;EAEF,W1ElCS;E0EmCT,gBAAA;ArL+woBF;AqL9woBE;EACE,mBAAA;EACA,gBAAA;EACA,W1EvCO;A3GuzoBX;;AsL1zoBA;EACE,SAAA;EACA,UAAA;EACA,6BAAA;EACA,UAAA;AtL6zoBF;AsL5zoBE;EACE,eAAA;EACA,gBAAA;EACA,mBAAA;EACA,c3EJW;A3Gk0oBf;AsL5zoBE;EACE,WAAA;EACA,YAAA;EACA,a3ETW;A3Gu0oBf;;AuL50oBA;EACE,yB5EQW;E4EPX,gBAAA;EACA,eAAA;EACA,YAAA;EACA,aAAA;EACA,iBAAA;EACA,oBAAA;AvL+0oBF;AuL70oBI;EACE,gBAAA;AvL+0oBN;AuL50oBE;EACE,YAAA;EACA,gBAAA;AvL80oBJ;AuL50oBM;EACE,kBAAA;EACA,YAAA;EACA,eAAA;EACA,W5ElBG;A3Gg2oBX;AuL70oBQ;EACE,eAAA;EACA,gBAAA;EACA,iBAAA;AvL+0oBV;AuL70oBQ;EACE,e5EdI;E4EeJ,eAAA;EACA,WAAA;EACA,YAAA;AvL+0oBV;AuL70oBQ;EACE,WAAA;EACA,YAAA;EACA,kBAAA;EACA,SAAA;EACA,UAAA;AvL+0oBV;AuL70oBQ;EACE,yB5E5BI;A3G22oBd;AuL90oBU;EACE,Y5ExCD;A3Gw3oBX;AuL70oBQ;EACE,yB5ElCI;A3Gi3oBd;AuL90oBU;EACE,Y5E9CD;A3G83oBX;AuL90oBU;EACE,cAAA;EACA,gBAAA;AvLg1oBZ;AuL70oBQ;EACE,aAAA;AvL+0oBV;AuL90oBU;EACE,c5EtBc;E4EuBd,6BAAA;EACA,UAAA;EACA,YAAA;EACA,eAAA;AvLg1oBZ;AuL/0oBY;EACE,eAAA;EACA,gBAAA;EACA,mBAAA;AvLi1oBd;AuL/0oBY;EACE,eAAA;EACA,gBAAA;EACA,mBAAA;EACA,W5EtEH;A3Gu5oBX;AuL10oBE;EACE,kBAAA;EACA,MAAA;EACA,QAAA;EACA,wCAAA;EACA,UAAA;EACA,YAAA;EACA,eAAA;EACA,gBAAA;EACA,sBAAA;AvL40oBJ;AuL30oBI;EACE,WAAA;EACA,6BAAA;EACA,kBAAA;AvL60oBN;AuLr0oBY;EACE,eAAA;AvLu0oBd;AuLt0oBc;EACE,yBAAA;AvLw0oBhB;AuLv0oBgB;EACE,cAAA;EACA,mBAAA;EACA,0BAAA;EACA,kBAAA;AvLy0oBlB;;AwLn7oBE;EACE,eAAA;EACA,gBAAA;EACA,mBAAA;EACA,c7ELS;A3G27oBb;AwLn7oBI;EACE,WAAA;EACA,YAAA;EACA,e7EXO;A3Gg8oBb;AwLn7oBI;EACE,kBAAA;AxLq7oBN;AwLp7oBM;EACE,WAAA;EACA,UAAA;EACA,WAAA;EACA,kBAAA;EACA,yB7EPI;E6EQJ,kBAAA;EACA,QAAA;EACA,UAAA;EACA,sBAAA;AxLs7oBR;AwLp7oBM;EACE,WAAA;EACA,YAAA;EACA,a7E7BK;A3Gm9oBb;AwLn7oBI;EACE,eAAA;AxLq7oBN;AwLp7oBM;EACE,WAAA;EACA,YAAA;EACA,kBAAA;EACA,yBAAA;EACA,gBAAA;AxLs7oBR;AwLr7oBQ;EAKE,iBAAA;EACA,WAAA;EACA,YAAA;AxLm7oBV;AwLh7oBM;EACE,eAAA;EACA,gBAAA;EACA,iBAAA;EACA,c7EtDK;A3Gw+oBb;AwLh7oBM;EACE,e7EhDM;E6EiDN,WAAA;EACA,YAAA;AxLk7oBR;;AyL/+oBA;EACE,yB9Eea;E8Edb,kBAAA;AzLk/oBF;AyLj/oBE;EACE,eAAA;EACA,gBAAA;EACA,iBAAA;EACA,c9ELS;A3Gw/oBb;AyLl/oBI;EACE,gBAAA;AzLo/oBN;AyLj/oBE;EACE,qBAAA;AzLm/oBJ;AyK5+oBE;EgBRA;IAGI,SAAA;EzLq/oBJ;AACF;AyLp/oBI;EACE,eAAA;EACA,gBAAA;EACA,mBAAA;EACA,gBAAA;EACA,c9ElBO;A3GwgpBb;AyLp/oBI;EACE,eAAA;EACA,gBAAA;EACA,mBAAA;EACA,c9E1BO;A3GghpBb;AyLp/oBI;EACE,c9E1BS;E8E2BT,gBAAA;AzLs/oBN;AyL9+oBI;;EAEE,eAAA;EACA,gBAAA;EACA,YAAA;EACA,cAAA;EACA,yBAAA;AzLg/oBN;AyL9+oBI;EACE,eAAA;EACA,gBAAA;EACA,YAAA;EACA,eAAA;EACA,gBAAA;AzLg/oBN;;A0LripBA;EACE,kBAAA;A1LwipBF;AyKrhpBE;EiBpBF;IAGI,gBAAA;E1L0ipBF;AACF;A0LzipBE;EACE,yB/EWU;A3GgipBd;A0LzipBE;EACE,yB/ESS;A3GkipBb;A0LxipBI;EACE,kBAAA;A1L0ipBN;A0LzipBM;EACE,WAAA;EACA,YAAA;EACA,kBAAA;EACA,QAAA;EACA,QAAA;EACA,UAAA;A1L2ipBR;A0LxipBQ;EACE,W/ErBC;E+EsBD,eAAA;EACA,gBAAA;EACA,mBAAA;A1L0ipBV;A0LxipBQ;EACE,U/E3BC;E+E4BD,WAAA;EACA,YAAA;EACA,eAAA;A1L0ipBV;A0LripBE;EACE,eAAA;EACA,gBAAA;EACA,iBAAA;EACA,W/EvCO;A3G8kpBX;A0LripBE;EACE,eAAA;EACA,gBAAA;EACA,gBAAA;EACA,W/E7CO;A3GolpBX;AyK9jpBE;EiBmBA;IAMI,eAAA;IACA,gBAAA;E1LyipBJ;AACF;;A2L5lpBE;EACE,qDAAA;EACA,kBAAA;EACA,iBAAA;EACA,oBAAA;A3L+lpBJ;A2L9lpBI;EACE,eAAA;EACA,gBAAA;EACA,iBAAA;EACA,chFRO;A3GwmpBb;A2L9lpBI;EACE,eAAA;EACA,gBAAA;EACA,iBAAA;EACA,chFPO;A3GumpBb;A2L5lpBQ;EACE,uBAAA;EACA,iBAAA;EACA,iBAAA;A3L8lpBV;A2L7lpBU;EACE,oBAAA;EACA,iBAAA;A3L+lpBZ;A2L9lpBY;EACE,iBAAA;A3LgmpBd;A2L1lpBY;EACE,aAAA;A3L4lpBd;A2LxlpBgB;EACE,eAAA;EACA,gBAAA;EACA,iBAAA;EACA,chFxBL;A3GknpBb;A2LtlpBY;EACE,ahF3BK;EgF4BL,eAAA;EACA,gBAAA;EACA,mBAAA;EACA,mBAAA;EACA,6BAAA;EACA,uBAAA;A3LwlpBd;A2LtlpBY;EACE,ahFpCK;EgFqCL,eAAA;EACA,gBAAA;EACA,mBAAA;EACA,yBAAA;EACA,4BAAA;EACA,mBAAA;A3LwlpBd;;A4LvppBA,uBAAA;AACA;EACE,kBAAA;EACA,qBAAA;EACA,8BAAA;A5L0ppBF;;A4LvppBA;EACE,aAAA;EACA,mBAAA;EACA,eAAA;EACA,aAAA;EACA,sBAAA;EACA,kBAAA;EACA,sBAAA;A5L0ppBF;;A4LvppBA;EACE,gBAAA;EACA,WAAA;A5L0ppBF;;A4LvppBA;EACE,kBAAA;EACA,SAAA;EACA,OAAA;EACA,WAAA;EACA,sBAAA;EACA,kBAAA;EACA,sBAAA;EACA,aAAA;EACA,aAAA;A5L0ppBF;;A6LxrpBE;EACE,yBAAA;EACA,oBAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,kBAAA;EACA,sBAAA;EACA,gBAAA;EACA,eAAA;EACA,gBAAA;EACA,mBAAA;EACA,clFTS;A3GospBb;A6L1rpBI;EACE,aAAA;EACA,mBAAA;A7L4rpBN;;A8L1spBI;EACE,eAAA;EACA,gBAAA;EACA,mBAAA;EACA,cnFJO;A3GitpBb;A8L1spBE;EACE,SAAA;EACA,gCAAA;A9L4spBJ;AyKzrpBE;EqBrBA;IAII,gBAAA;E9L8spBJ;AACF;A8L7spBI;EACE,WAAA;EACA,YAAA;A9L+spBN;A8L7spBI;EACE,SAAA;EACA,UAAA;EACA,gBAAA;EACA,wBAAA;EACA,YAAA;EACA,eAAA;EACA,gBAAA;EACA,mBAAA;EACA,cnFNY;A3GqtpBlB;A8L9spBM;EACE,UAAA;EACA,aAAA;A9LgtpBR;A8LzspBI;EACE,eAAA;EACA,gBAAA;EACA,iBAAA;EACA,cnFxCO;A3GmvpBb;A8LzspBI;EAaE,sBAAA;A9L+rpBN;A8LxspBM;EACE,iBAAA;A9L0spBR;A8LzspBQ;EACE,eAAA;EACA,gBAAA;EACA,iBAAA;EACA,cnFpDG;A3G+vpBb;A8LpspBI;EACE,YAAA;EACA,kBAAA;EACA,mBAAA;EACA,eAAA;EACA,mBAAA;EACA,gBAAA;A9LsspBN;A8LlspBI;EAGE,qDAAA;A9LospBN;A8LnspBM;EACE,kBAAA;EACA,eAAA;EACA,gBAAA;EACA,mBAAA;EACA,cnF9EK;EmF+EL,0BAAA;A9LqspBR;A8LjspBM;EACE,gCAAA;A9LmspBR;A8LlspBQ;EACE,kBAAA;EACA,eAAA;EACA,gBAAA;EACA,mBAAA;EACA,cnF1FG;EmF2FH,sBAAA;EACA,gBAAA;EACA,aAAA;A9LospBV;A8LnspBU;EACE,cnFzEM;A3G8wpBlB;A8LnspBU;EACE,cnFhGC;A3GqypBb;A8LnspBU;EACE,WAAA;EACA,YAAA;A9LqspBZ;A8LnspBU;EACE,kBAAA;EACA,aAAA;EACA,uBAAA;A9LqspBZ;A8LlspBY;EACE,SAAA;EACA,UAAA;EACA,6BAAA;EACA,eAAA;A9LospBd;A8LnspBc;EACE,gBAAA;A9LqspBhB;A8L5rpBI;EACE,WAAA;EACA,YAAA;A9L8rpBN;A8L5rpBI;EACE,cnF/HS;A3G6zpBf;;A+Ll0pBA;EACE,oBAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,iBAAA;EACA,gBAAA;EACA,gBAAA;EACA,eAAA;A/Lq0pBF;A+Lp0pBE;EACE,yBAAA;EACA,yBpFee;EoFdf,cpFiBe;A3GqzpBnB;A+Lp0pBE;EACE,yBAAA;EACA,yBpFYY;EoFXZ,cpFUY;A3G4zpBhB;A+Lp0pBE;EACE,yBAAA;EACA,yBpFkBqB;EoFjBrB,cpFjBW;A3Gu1pBf;A+Lp0pBE;EACE,yBAAA;EACA,yBpFiBgB;EoFhBhB,cpFiBU;A3GqzpBd;;AgMj2pBA;EACE,aAAA;EACA,yBAAA;AhMo2pBF;AgMn2pBE;EACE,aAAA;EACA,yBAAA;AhMq2pBJ;AgMp2pBI;EACE,6BAAA;EACA,eAAA;EACA,WAAA;EACA,YAAA;EACA,SAAA;EACA,UAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,crFdO;A3Go3pBb;AgMr2pBM;EACE,yBrFbO;EqFcP,WAAA;EACA,YAAA;EACA,kBAAA;EACA,WrFnBG;A3G03pBX;AgMp2pBQ;EACE,arFrBK;A3G23pBf;AgMp2pBQ;EACE,arFzBG;A3G+3pBb;;AiMh4pBM;EACE,cAAA;EACA,SAAA;EACA,gCAAA;EACA,WAAA;EACA,uBAAA;EACA,kBAAA;AjMm4pBR;AiMj4pBM;EACE,SAAA;EACA,gCAAA;EACA,uBAAA;EACA,UAAA;EACA,SAAA;AjMm4pBR;AiMl4pBQ;EACE,atFbK;A3Gi5pBf;AiM/3pBE;EACE,ctFtBS;EsFuBT,eAAA;EACA,gBAAA;EACA,mBAAA;AjMi4pBJ;AiMh4pBI;EACE,gBAAA;EACA,WAAA;EACA,YAAA;AjMk4pBN;;AkMh6pBE;EACE,gBAAA;AlMm6pBJ;AkMh6pBI;EACE,SAAA;EACA,UAAA;EACA,gCAAA;EACA,gBAAA;EACA,kBAAA;EACA,mBAAA;EACA,cAAA;EACA,eAAA;EACA,gBAAA;EACA,iBAAA;EACA,mBAAA;EACA,cvFbO;EuFcP,uBAAA;AlMk6pBN;AkMj6pBM;EACE,kBAAA;AlMm6pBR;AkMj6pBM;EACE,cvFnBK;EuFoBL,eAAA;AlMm6pBR;;AmMx7pBA;EACE,kBAAA;EACA,mBAAA;AnM27pBF;AmMv7pBE;EACE,gCAAA;EACA,iBAAA;AnMy7pBJ;AmMx7pBI;EACE,SAAA;EACA,UAAA;EACA,6BAAA;EACA,eAAA;EACA,gBAAA;EACA,mBAAA;EACA,cxFfO;A3Gy8pBb;AmMz7pBM;EACE,cxFjBK;EwFkBL,cxFjBO;EwFkBP,gBAAA;AnM27pBR;AmMv7pBE;EACE,yBxFZW;EwFaX,kBAAA;EACA,kBAAA;AnMy7pBJ;AmMv7pBM;EACE,eAAA;EACA,gBAAA;EACA,iBAAA;EACA,cxFlCK;A3G29pBb;AmMv7pBM;EACE,eAAA;EACA,gBAAA;EACA,mBAAA;EACA,cxFtCK;A3G+9pBb;AmMr7pBM;EACE,eAAA;EACA,gBAAA;EACA,iBAAA;EACA,cxFzCK;EwF0CL,kBAAA;AnMu7pBR;AmMr7pBM;;EAEE,eAAA;EACA,gBAAA;EACA,YAAA;EACA,eAAA;EACA,gBAAA;EACA,yBAAA;AnMu7pBR;AmMr7pBM;EACE,eAAA;EACA,gBAAA;EACA,YAAA;EACA,eAAA;EACA,gBAAA;AnMu7pBR;AmMn7pBE;EACE,qDAAA;EACA,yBAAA;EACA,aAAA;EACA,sBAAA;EACA,kBAAA;EACA,gBAAA;AnMq7pBJ;AmMp7pBI;EACE,eAAA;EACA,gBAAA;EACA,iBAAA;EACA,cxFhFO;A3GsgqBb;AmMp7pBI;EACE,iBAAA;AnMs7pBN;AmMr7pBM;EACE,eAAA;EACA,gBAAA;EACA,mBAAA;EACA,cxFzDW;A3Gg/pBnB;AmMn7pBU;EACE,yBAAA;AnMq7pBZ;AmMp7pBY;EACE,yBAAA;AnMs7pBd;AmMj7pBM;EACE,yBxFpEY;EwFqEZ,aAAA;EACA,oBAAA;EACA,kBAAA;EACA,gBAAA;AnMm7pBR;AmMl7pBQ;EACE,eAAA;EACA,gBAAA;EACA,iBAAA;EACA,cxF9GG;A3GkiqBb;AmMl7pBQ;EACE,eAAA;EACA,gBAAA;EACA,mBAAA;EACA,cxFlHG;EwFmHH,gCAAA;AnMo7pBV;AmMl7pBQ;EAEE,cAAA;AnMm7pBV;AmMj7pBQ;EAEE,cAAA;AnMk7pBV;AmMh7pBY;EACE,cxFhID;EwFiIC,eAAA;EACA,gBAAA;EACA,mBAAA;AnMk7pBd;AmMh7pBY;EACE,kBAAA;EACA,gCAAA;AnMk7pBd;AmMj7pBc;EACE,WAAA;EACA,YAAA;AnMm7pBhB;AmMl7pBgB;EACE,eAAA;EACA,gBAAA;EACA,mBAAA;EACA,cxF7IL;EwF8IK,SAAA;EACA,UAAA;EACA,WAAA;EACA,YAAA;EACA,mBAAA;EACA,6BAAA;AnMo7pBlB;AmMj7pBc;EACE,WAAA;EACA,YAAA;EACA,kBAAA;EACA,MAAA;EACA,QAAA;AnMm7pBhB;AmM56pBI;EACE,gBAAA;AnM86pBN;AmM36pBE;EACE,eAAA;EACA,gBAAA;EACA,mBAAA;EACA,cxF1KS;A3GulqBb;AmM36pBE;EACE,aAAA;EACA,yBAAA;AnM66pBJ;AmM56pBI;EACE,aAAA;EACA,yBAAA;AnM86pBN;AmM76pBM;EACE,6BAAA;EACA,eAAA;EACA,WAAA;EACA,YAAA;EACA,SAAA;EACA,UAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,cxF9LK;A3G6mqBb;AmM96pBQ;EACE,yBxF7LK;EwF8LL,WAAA;EACA,YAAA;EACA,kBAAA;EACA,WxFnMC;A3GmnqBX;AmM76pBU;EACE,axFrMG;A3GonqBf;AmM76pBU;EACE,axFzMC;A3GwnqBb;;AmMx6pBA;EACE,gCAAA;AnM26pBF;;AoM9nqBI;EACE,kBAAA;EACA,eAAA;EACA,gCAAA;ApMioqBN;AoMhoqBM;EACE,eAAA;EACA,gBAAA;EACA,mBAAA;EACA,czFNK;A3GwoqBb;AoMhoqBM;EACE,yBzFCM;EyFAN,kBAAA;EACA,oCAAA;ApMkoqBR;AoMjoqBQ;EACE,gBAAA;EACA,czFhBG;A3GmpqBb;;AqMppqBE;EACE,kBAAA;EACA,gDAAA;EACA,yBAAA;ArMupqBJ;AqMtpqBI;EACE,gCAAA;EACA,kBAAA;EACA,eAAA;ArMwpqBN;AqMvpqBM;EACE,eAAA;EACA,gBAAA;EACA,iBAAA;EACA,c1FFM;A3G2pqBd;AqMrpqBM;EACE,4BAAA;ArMupqBR;AqMtpqBQ;EACE,gBAAA;EACA,gBAAA;EACA,kBAAA;ArMwpqBV;AqMvpqBU;EACE,YAAA;EACA,aAAA;EACA,kBAAA;EACA,iBAAA;ArMypqBZ;AqMvpqBU;EACE,kBAAA;EACA,WAAA;EACA,UAAA;EACA,WAAA;EACA,YAAA;EACA,kBAAA;EACA,yB1F/BG;E0FgCH,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,eAAA;EACA,UAAA;ArMypqBZ;AqMxpqBY;EACE,U1FxCH;A3GksqBX;AqMtpqBQ;EACE,kBAAA;ArMwpqBV;AqMtpqBY;EACE,gBAAA;ArMwpqBd;AqMtpqBY;EACE,gBAAA;ArMwpqBd;AqMrpqBU;EACE,mBAAA;ArMupqBZ;AqMtpqBY;EACE,kBAAA;ArMwpqBd;AqMtpqBY;EACE,eAAA;EACA,gBAAA;EACA,mBAAA;EACA,c1FhED;E0FiEC,gBAAA;ArMwpqBd;AqMvpqBc;EACE,eAAA;EACA,gBAAA;EACA,mBAAA;EACA,c1FpEH;A3G6tqBb;AqMtpqBY;EACE,c1FvEC;E0FwED,qBAAA;ArMwpqBd;AqMppqBQ;EACE,kBAAA;ArMspqBV;AqMppqBY;EACE,eAAA;EACA,gBAAA;EACA,mBAAA;EACA,c1FpFD;A3G0uqBb;AqMppqBY;EACE,eAAA;EACA,gBAAA;EACA,mBAAA;EACA,c1F5FD;A3GkvqBb;AqMppqBY;EACE,c1F5FC;A3GkvqBf;AqMnpqBU;EACE,gBAAA;ArMqpqBZ;;AsM1vqBA;EACE,kBAAA;EACA,kBAAA;EACA,gDAAA;EACA,yBAAA;AtM6vqBF;AsM5vqBE;EACE,eAAA;EACA,gBAAA;EACA,iBAAA;EACA,c3FPS;A3GqwqBb;AsM5vqBE;EACE,eAAA;EACA,gBAAA;EACA,mBAAA;EACA,c3FXS;A3GywqBb;AsM5vqBE;EACE,eAAA;EACA,gBAAA;EACA,mBAAA;EACA,c3FnBS;A3GixqBb;AsM5vqBE;EACE,gBAAA;EACA,kBAAA;EACA,mBAAA;AtM8vqBJ;;AsM1vqBE;EACE,gBAAA;AtM6vqBJ;AsM3vqBE;EACE,eAAA;EACA,a3F9BW;A3G2xqBf;AsM1vqBI;EACE,eAAA;EACA,c3FpCO;E2FqCP,kBAAA;AtM4vqBN;AsM3vqBM;EACE,kBAAA;EACA,UAAA;EAEA,UAAA;EACA,UAAA;EACA,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,sB3FhDG;E2FiDH,kBAAA;EACA,mBAAA;AtM4vqBR;AsM3vqBQ;EACE,WAAA;EACA,kBAAA;EACA,SAAA;EACA,OAAA;EACA,kBAAA;EACA,iBAAA;EACA,mBAAA;EACA,oEAAA;AtM6vqBV;AsM1vqBQ;EACE,c3FhEG;E2FiEH,eAAA;EACA,gBAAA;EACA,mBAAA;EACA,gBAAA;AtM4vqBV;AsM1vqBQ;EACE,kBAAA;AtM4vqBV;AsM3vqBU;EACE,c3FvEC;E2FwED,eAAA;EACA,gBAAA;EACA,iBAAA;EACA,gBAAA;AtM6vqBZ;AsM5vqBY;EACE,c3FxED;A3Gs0qBb;AsMxvqBI;EACE,eAAA;AtM0vqBN;AsMzvqBM;EACE,c3FtDiB;A3GizqBzB;AsMxvqBI;EACE,eAAA;AtM0vqBN;;AuMx1qBA;EAGE,gDAAA;EACA,yBAAA;EACA,kBAAA;EACA,kBAAA;AvM21qBF;AuM11qBE;EACE,eAAA;EACA,gBAAA;EACA,iBAAA;EACA,cAAA;AvM41qBJ;AuMx1qBM;EACE,eAAA;EACA,gBAAA;EACA,mBAAA;EACA,c5FjBK;E4FkBL,gBAAA;EACA,mBAAA;AvM01qBR;AuMv1qBQ;EACE,WAAA;EACA,YAAA;EACA,kBAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,kBAAA;EACA,eAAA;AvMy1qBV;AuMx1qBU;EACE,WAAA;EACA,YAAA;AvM01qBZ;AuMz1qBY;EACE,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,cAAA;EACA,eAAA;EACA,gBAAA;EACA,mBAAA;EACA,yBAAA;EACA,WAAA;EACA,YAAA;EACA,oBAAA;AvM21qBd;AuMz1qBY;EACE,WAAA;EACA,YAAA;EACA,kBAAA;EACA,kBAAA;AvM21qBd;AuMx1qBc;EACE,yBAAA;EACA,WAAA;AvM01qBhB;AuMn1qBI;EACE,gBAAA;AvMq1qBN;AuMp1qBM;;EAEE,eAAA;EACA,gBAAA;EACA,YAAA;AvMs1qBR;AuMp1qBM;EACE,gCAAA;AvMs1qBR;AuMp1qBM;EACE,eAAA;EACA,gBAAA;EACA,mBAAA;EACA,cAAA;EACA,UAAA;AvMs1qBR;AuMr1qBQ;EACE,eAAA;EACA,gBAAA;EACA,iBAAA;EACA,c5FpFG;E4FqFH,YAAA;AvMu1qBV;AuMr1qBQ;EACE,eAAA;EACA,gBAAA;EACA,iBAAA;EACA,cAAA;AvMu1qBV;AuMr1qBQ;EACE,eAAA;EACA,gBAAA;EACA,iBAAA;EACA,cAAA;AvMu1qBV;AuMp1qBU;EACE,gBAAA;AvMs1qBZ;AuMh1qBc;EACE,gBAAA;AvMk1qBhB;AuM70qBQ;EACE,c5FlHG;E4FmHH,kBAAA;EACA,mBAAA;AvM+0qBV;AuM70qBQ;EACE,cAAA;AvM+0qBV;AuM70qBQ;;EAEE,c5F3HG;A3G08qBb;AuMz0qBI;EACE,a5FlIO;A3G68qBb;;AwM18qBA;EACE,iBAAA;AxM68qBF;;AyMn9qBA;EACE,kBAAA;EACA,gDAAA;EACA,yBAAA;EACA,kBAAA;AzMs9qBF;AyMr9qBE;EACE,c9FJS;E8FKT,eAAA;EACA,gBAAA;EACA,iBAAA;AzMu9qBJ;AyMp9qBI;EACE,c9FJO;E8FKP,eAAA;EACA,gBAAA;EACA,iBAAA;EACA,gBAAA;AzMs9qBN;AyMl9qBI;EACE,SAAA;EACA,WAAA;AzMo9qBN;AyMl9qBI;EACE,YAAA;EACA,eAAA;AzMo9qBN;AyMn9qBM;EACE,kBAAA;AzMq9qBR;AyMp9qBQ;EACE,gBAAA;AzMs9qBV;AyMn9qBM;EACE,c9FjCK;E8FkCL,eAAA;EACA,gBAAA;EACA,iBAAA;AzMq9qBR;AyMp9qBQ;EACE,c9F/BG;A3Gq/qBb;AyMn9qBM;EACE,aAAA;EACA,mBAAA;AzMq9qBR;AyMp9qBQ;EACE,kBAAA;EACA,UAAA;EACA,QAAA;EACA,SAAA;AzMs9qBV;AyMn9qBU;EACE,yB9FjDG;E8FkDH,qB9FlDG;A3GugrBf;AyMp9qBY;EACE,aAAA;AzMs9qBd;AyMl9qBQ;EACE,WAAA;EACA,YAAA;EACA,yBAAA;EACA,gBAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,kBAAA;EACA,iBAAA;EACA,kBAAA;EACA,YAAA;EACA,sBAAA;EACA,sCAAA;EACA,eAAA;EACA,gBAAA;AzMo9qBV;AyMl9qBQ;EACE,WAAA;EACA,eAAA;EACA,aAAA;AzMo9qBV;AyMl9qBQ;EACE,gBAAA;EACA,c9FnFG;A3GuirBb;AyMn9qBU;EACE,c9FlFG;A3GuirBf;AyMh9qBQ;EACE,YAAA;AzMk9qBV;AyM98qBQ;EACE,YAAA;AzMg9qBV;AyM58qBQ;EACE,c9FlGK;E8FmGL,qBAAA;AzM88qBV;;A0MtjrBA;EACE,yBAAA;EACA,kBAAA;EACA,kBAAA;A1MyjrBF;A0MvjrBI;EACE,eAAA;EACA,gBAAA;EACA,mBAAA;EACA,c/FPO;A3GgkrBb;A0MvjrBI;EACE,eAAA;EACA,gBAAA;EACA,iBAAA;EACA,c/FNO;A3G+jrBb;;A2MtkrBI;EACE,yBAAA;EACA,kBAAA;EACA,chGHO;EgGIP,eAAA;EACA,gBAAA;EACA,iBAAA;EACA,iBAAA;EACA,cAAA;A3MykrBN;A2MxkrBM;EACE,iBAAA;A3M0krBR;A2MxkrBM;EACE,chGVO;EgGWP,yBAAA;A3M0krBR;A2MtkrBE;EACE,gBAAA;EACA,yBAAA;EACA,oBAAA;EAEA,iBAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,iBAAA;A3MukrBJ;A2MrkrBM;EACE,SAAA;EACA,gBAAA;EACA,UAAA;A3MukrBR;;A4MvmrBI;EACE,ajGYM;A3G8lrBZ;A4MxmrBI;EACE,aAAA;A5M0mrBN;A4MxmrBI;EACE,cjGMM;A3GomrBZ;A4MxmrBI;EACE,cjGPS;A3GinrBf;A4MvmrBE;EACE,WAAA;EACA,YAAA;EACA,kBAAA;EACA,yBjGVS;EiGWT,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,WjGpBO;EiGqBP,eAAA;EACA,gBAAA;A5MymrBJ;;A6MjorBE;EACE,eAAA;EACA,gBAAA;A7MoorBJ;A6MlorBE;EACE,qDAAA;EACA,yBAAA;EACA,kBAAA;EACA,sBAAA;EACA,kBAAA;EACA,gBAAA;A7MoorBJ;A6MlorBE;EACE,yBlGEW;EkGDX,kBAAA;EACA,4BAAA;A7MoorBJ;A6MjorBI;EACE,eAAA;EACA,gBAAA;EACA,iBAAA;EACA,clGrBO;A3GwprBb;A6M/nrBI;;EAEE,SAAA;EACA,gCAAA;EACA,eAAA;A7MiorBN;A6MhorBM;;EACE,WAAA;EACA,YAAA;A7MmorBR;A6MjorBM;;EACE,eAAA;EACA,gBAAA;EACA,mBAAA;EACA,clGtCK;A3G0qrBb;A6MlorBM;;EACE,SAAA;EACA,UAAA;EACA,gBAAA;EACA,wBAAA;EACA,YAAA;EACA,eAAA;EACA,gBAAA;EACA,mBAAA;EACA,clG7BU;A3GkqrBlB;A6MporBQ;;EACE,UAAA;EACA,aAAA;A7MuorBV;A6MlorBM;EACE,eAAA;EACA,gBAAA;EACA,iBAAA;EACA,clGrBW;A3GyprBnB;A6MlorBM;EACE,eAAA;EACA,sBAAA;A7MoorBR;A6MnorBQ;EACE,eAAA;A7MqorBV;A6MnorBQ;EACE,gBAAA;A7MqorBV;A6MnorBQ;EACE,+BAAA;A7MqorBV;A6MnorBQ;EACE,kBAAA;EACA,eAAA;EACA,gBAAA;EACA,mBAAA;EACA,clG9EG;A3GmtrBb;A6MnorBQ;EACE,eAAA;EACA,gBAAA;EACA,mBAAA;EACA,clG9CS;A3GmrrBnB;A6MnorBQ;EACE,clGtFK;A3G2trBf;A6MnorBQ;EACE,clGzFK;EkG0FL,gBAAA;A7MqorBV;A6MjorBI;;EAEE,kBAAA;EACA,mBAAA;A7MmorBN;A6M/nrBI;EACE,aAAA;A7MiorBN;A6MhorBM;EACE,YAAA;EACA,6BAAA;EACA,WAAA;A7MkorBR;A6MjorBQ;EACE,WAAA;EACA,YAAA;A7MmorBV;A6MhorBM;EACE,eAAA;EACA,gBAAA;EACA,iBAAA;EACA,clGvHK;A3GyvrBb;A6MhorBM;EACE,eAAA;EACA,gBAAA;EACA,iBAAA;EACA,clG7HK;A3G+vrBb;A6M/nrBQ;EACE,YAAA;A7MiorBV;A6M1nrBM;EACE,gCAAA;EACA,eAAA;A7M4nrBR;A6M1nrBM;EACE,UAAA;A7M4nrBR;A6M3nrBQ;EACE,eAAA;EACA,mBAAA;A7M6nrBV;;A8M/wrBA;EACE,kBAAA;EACA,WAAA,EAAA,8BAAA;EACA,YAAA,EAAA,8BAAA;EACA,YAAA;EACA,eAAA;A9MkxrBF;;A8M/wrBA;EACE,WAAA;EACA,YAAA;A9MkxrBF;;A8M/wrBA;EACE,kBAAA;EAKA,eAAA;A9M8wrBF;;A8M3wrBA;EACE,kBAAA;EACA,uBAAA;EACA,YAAA;EACA,kBAAA;EACA,kBAAA;EACA,YAAA;EACA,kBAAA;EACA,UAAA;EACA,YAAA,EAAA,wBAAA;EACA,SAAA;EACA,2BAAA;EACA,2BAAA;A9M8wrBF;;A8M3wrBA;EACE,mBAAA;A9M8wrBF;;A8M3wrBA;EACE,WAAA;EACA,YAAA;A9M8wrBF;;A+MxzrBE;EACE,yBAAA;EACA,kBAAA;EACA,4BAAA;EACA,mBAAA;A/M2zrBJ;A+M1zrBI;EACE,eAAA;EACA,gBAAA;EACA,iBAAA;EACA,cpGRO;A3Go0rBb;A+M1zrBI;EAGE,kBAAA;EACA,mBAAA;EACA,eAAA;A/M0zrBN;A+MpzrBQ;EACE,cpGnBK;A3Gy0rBf;A+MnzrBU;EACE,WAAA;EACA,YAAA;EACA,kBAAA;A/MqzrBZ;;AgNl1rBE;EACE,WAAA;EACA,aAAA;EACA,gBAAA;AhNq1rBJ;AgNn1rBM;EACE,WAAA;EACA,SAAA;AhNq1rBR;AgNp1rBQ;EACE,aAAA;AhNs1rBV;AgNj1rBE;EACE,eAAA;AhNm1rBJ;;AiNl2rBE;EACE,gBAAA;AjNq2rBJ;AiNn2rBE;EACE,UAAA;EACA,SAAA;EACA,UAAA;EACA,6BAAA;EACA,ctGJW;EsGKX,eAAA;EACA,eAAA;EACA,gBAAA;EACA,mBAAA;AjNq2rBJ;AiNl2rBI;EACE,eAAA;EACA,gBAAA;EACA,mBAAA;EACA,gBAAA;EACA,ctGnBO;A3Gu3rBb;AiNl2rBI;EACE,eAAA;EACA,gBAAA;EACA,mBAAA;EACA,ctGzBO;A3G63rBb;AiNn2rBM;EACE,eAAA;EACA,gBAAA;EACA,mBAAA;EACA,ctG9BK;A3Gm4rBb;AiNl2rBI;EACE,atGlCO;A3Gs4rBb;AiNj2rBE;EACE,gBAAA;AjNm2rBJ;AiNj2rBM;EACE,uBAAA;EACA,mBAAA;EACA,WAAA;AjNm2rBR;AiN91rBM;EACE,kBAAA;EACA,eAAA;EACA,gBAAA;EACA,mBAAA;EACA,ctG1BW;A3G03rBnB;AiN91rBM;EACE,eAAA;EACA,gBAAA;EACA,mBAAA;EACA,ctG3DK;A3G25rBb;AiN31rBI;EACE,gCAAA;EACA,eAAA;AjN61rBN;AiN31rBI;EACE,eAAA;EACA,gBAAA;EACA,iBAAA;EACA,ctGhCa;A3G63rBnB;AiN31rBI;EACE,UAAA;EACA,mBAAA;AjN61rBN;AiN51rBM;EACE,eAAA;AjN81rBR;AiN51rBM;EACE,gBAAA;AjN81rBR;AiN51rBM;EACE,mBAAA;AjN81rBR;AiN51rBM;EACE,kBAAA;EACA,eAAA;EACA,gBAAA;EACA,mBAAA;EACA,ctGzFK;A3Gu7rBb;AiN51rBM;EACE,eAAA;EACA,gBAAA;EACA,mBAAA;EACA,ctGzDW;A3Gu5rBnB;AiN51rBM;EACE,ctGjGO;A3G+7rBf;AiN51rBM;EACE,ctGpGO;EsGqGP,gBAAA;AjN81rBR;AiN11rBE;EACE,yBtG5EgB;EsG6EhB,kBAAA;EACA,kBAAA;AjN41rBJ;AiN11rBE;EACE,eAAA;EACA,gBAAA;EACA,mBAAA;EACA,ctGrHS;A3Gi9rBb;;AkNl9rBE;EACE,kBAAA;AlNq9rBJ;AkNn9rBM;EACE,aAAA;AlNq9rBR;AkNl9rBI;EACE,kBAAA;EACA,YAAA;EACA,SAAA;EACA,QAAA;EACA,gBvGVK;EuGWL,kBAAA;EACA,qDAAA;EACA,yBAAA;AlNo9rBN;AkNn9rBM;EACE,eAAA;EACA,gBAAA;EACA,iBAAA;EACA,cvG0BgB;EuGzBhB,gCAAA;EACA,kBAAA;AlNq9rBR;AkNn9rBM;EACE,kBAAA;AlNq9rBR;AkNp9rBQ;EACE,eAAA;AlNs9rBV;AkNr9rBU;EACE,eAAA;AlNu9rBZ;AkNp9rBQ;;EAEE,cvGcgB;A3Gw8rB1B;AkNp9rBQ;EACE,gBAAA;AlNs9rBV;AkNr9rBU;EACE,aAAA;AlNu9rBZ;AkNl9rBY;EACE,avGnCA;A3Gu/rBd;AkN/8rBM;EACE,kBAAA;EACA,SAAA;EACA,WAAA;EACA,UAAA;AlNi9rBR;AkNh9rBQ;EACE,avG9CI;EuG+CJ,WAAA;EACA,YAAA;EACA,evG1DG;EuG2DH,eAAA;EACA,UAAA;AlNk9rBV;AkN/8rBM;EACE,yBvGhBa;EuGiBb,kBAAA;AlNi9rBR;;AmNphsBA;EACE,qDAAA;EACA,yBAAA;EACA,sBAAA;EACA,kBAAA;EACA,gBAAA;EACA,gBAAA;AnNuhsBF;AmNrhsBI;EACE,gBAAA;EACA,eAAA;EACA,oBAAA;AnNuhsBN;AmNrhsBI;EACE,eAAA;EACA,gBAAA;EACA,iBAAA;EACA,cxGyBa;EwGxBb,gCAAA;EACA,oBAAA;EACA,mBAAA;AnNuhsBN;AmNrhsBI;EACE,UAAA;EACA,mBAAA;AnNuhsBN;AmNthsBM;EACE,eAAA;AnNwhsBR;AmNthsBM;EACE,gBAAA;AnNwhsBR;AmNthsBM;EACE,mBAAA;AnNwhsBR;AmNthsBM;EACE,kBAAA;EACA,eAAA;EACA,gBAAA;EACA,mBAAA;EACA,cxGnCK;A3G2jsBb;AmNthsBM;EACE,eAAA;EACA,gBAAA;EACA,mBAAA;EACA,cxGHW;A3G2hsBnB;AmNthsBM;EACE,cxG3CO;A3GmksBf;AmNthsBM;EACE,cxG9CO;EwG+CP,gBAAA;AnNwhsBR;AmNphsBE;EACE,iBAAA;AnNshsBJ;AmNphsBE;EACE,mBxG5CW;EwG6CX,2BAAA;EACA,4BAAA;EACA,gCAAA;EACA,kBAAA;AnNshsBJ;AmNrhsBI;EACE,eAAA;EACA,gBAAA;EACA,iBAAA;EACA,gBAAA;EACA,cxGvBkB;EwGwBlB,iBAAA;AnNuhsBN;AmNrhsBI;EACE,exG3BkB;EwG4BlB,WAAA;EACA,YAAA;EACA,eAAA;AnNuhsBN;AmNrhsBI;EACE,WAAA;EACA,YAAA;EACA,exG7ES;EwG8ET,iBAAA;EACA,eAAA;AnNuhsBN;AmNphsBE;EACE,yBxGtCiB;EwGuCjB,kBAAA;EACA,8BAAA;EACA,+BAAA;EACA,6BAAA;AnNshsBJ;AmNrhsBI;EACE,kBAAA;EACA,mBAAA;AnNuhsBN;AmNnhsBI;EACE,SAAA;EACA,WAAA;AnNqhsBN;AmNnhsBI;EACE,YAAA;EACA,eAAA;EACA,iBAAA;EACA,gBAAA;AnNqhsBN;AmNphsBM;EACE,UAAA;AnNshsBR;AmNphsBM;EACE,eAAA;EACA,gBAAA;EACA,iBAAA;EACA,cxGzEW;EwG0EX,gCAAA;AnNshsBR;AmNrhsBQ;EACE,cxG7GG;A3GoosBb;AmNphsBM;EACE,aAAA;EACA,mBAAA;AnNshsBR;AmNrhsBQ;EACE,kBAAA;EACA,UAAA;EACA,QAAA;EACA,SAAA;AnNuhsBV;AmNphsBU;EACE,yBxG/HG;EwGgIH,qBxGhIG;A3GspsBf;AmNrhsBY;EACE,aAAA;AnNuhsBd;AmNnhsBQ;EACE,WAAA;EACA,YAAA;EACA,yBAAA;EACA,gBAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,kBAAA;EACA,iBAAA;EACA,kBAAA;EACA,YAAA;EACA,sBAAA;EACA,sCAAA;EACA,eAAA;EACA,gBAAA;AnNqhsBV;AmNnhsBQ;EACE,WAAA;EACA,eAAA;EACA,aAAA;AnNqhsBV;AmNnhsBQ;EACE,gBAAA;EACA,cxGjKG;A3GsrsBb;AmNphsBU;EACE,cxGhKG;A3GsrsBf;AmNlhsBM;EACE,yBxGxHa;EwGyHb,kBAAA;AnNohsBR;AmNnhsBQ;EACE,SAAA;EACA,gBAAA;AnNqhsBV;AmNjhsBQ;EACE,YAAA;EACA,gBAAA;EACA,kBAAA;EACA,mBAAA;AnNmhsBV;AmN/gsBQ;EACE,cxGtLK;EwGuLL,qBAAA;AnNihsBV;AmN3gsBI;EACE,gBAAA;EACA,iBAAA;EACA,kBAAA;AnN6gsBN;AmN3gsBQ;EACE,cAAA;EACA,6BAAA;AnN6gsBV;AmN3gsBQ;EACE,cxGlKS;EwGmKT,eAAA;EACA,iBAAA;EACA,gBAAA;AnN6gsBV;AmN3gsBQ;EACE,cxGvMI;EwGwMJ,iBAAA;AnN6gsBV;;AoN/tsBE;EAGE,gDAAA;EACA,yBAAA;EACA,kBAAA;EACA,YAAA;ApNkusBJ;AoNjusBI;EACE,SAAA;EACA,gCAAA;EACA,eAAA;EACA,mBAAA;ApNmusBN;AoNlusBM;EACE,WAAA;EACA,YAAA;ApNousBR;AoNlusBM;EACE,eAAA;EACA,gBAAA;EACA,mBAAA;EACA,czGnBK;A3GuvsBb;AoNlusBM;EACE,SAAA;EACA,UAAA;EACA,gBAAA;EACA,wBAAA;EACA,YAAA;EACA,eAAA;EACA,gBAAA;EACA,mBAAA;EACA,czG1BM;A3G8vsBd;AoNnusBQ;EACE,UAAA;EACA,aAAA;ApNqusBV;AoNhusBM;EACE,gCAAA;EACA,eAAA;EACA,eAAA;ApNkusBR;AoNjusBQ;EACE,cAAA;ApNmusBV;AoNjusBQ;EACE,gBAAA;ApNmusBV;AoNhusBU;EACE,WAAA;EACA,YAAA;ApNkusBZ;AoN7tsBU;EACE,eAAA;EACA,gBAAA;EACA,mBAAA;EACA,czG5DC;A3G2xsBb;AoN7tsBU;EACE,eAAA;EACA,gBAAA;EACA,iBAAA;EACA,czG3DC;A3G0xsBb;AoN5tsBQ;EACE,eAAA;EACA,gBAAA;EACA,mBAAA;EACA,czGlEG;A3GgysBb;AoNztsBE;EACE,YAAA;EACA,kBAAA;ApN2tsBJ;AoN1tsBI;EACE,kBAAA;EACA,yBzG5EO;EyG6EP,kBAAA;ApN4tsBN;AoN1tsBQ;EACE,WAAA;EACA,YAAA;ApN4tsBV;AoNztsBM;EACE,iBAAA;ApN2tsBR;AoN1tsBQ;EACE,eAAA;EACA,gBAAA;EACA,mBAAA;EACA,WzGhGC;A3G4zsBX;AoN1tsBQ;EACE,eAAA;EACA,gBAAA;EACA,iBAAA;EACA,WzGtGC;A3Gk0sBX;AoNxtsBI;EACE,kBAAA;ApN0tsBN;AoNxtsBM;EACE,cAAA;ApN0tsBR;AoNztsBQ;EACE,WAAA;EACA,YAAA;ApN2tsBV;AoNztsBQ;EACE,yBAAA;EACA,iBAAA;EACA,mBAAA;EACA,aAAA;EACA,eAAA;EACA,gBAAA;EACA,iBAAA;EACA,czG5HG;A3Gu1sBb;AoNztsBQ;EACE,eAAA;EACA,gBAAA;EACA,mBAAA;EACA,czG9HI;EyG+HJ,iBAAA;EACA,eAAA;ApN2tsBV;AoNvtsBQ;EACE,WAAA;EACA,YAAA;EACA,iBAAA;ApNytsBV;AoNvtsBQ;EACE,yBzG3FkB;EyG4FlB,mBAAA;EACA,kBAAA;EACA,iBAAA;ApNytsBV;AoNvtsBQ;EACE,eAAA;ApNytsBV;AoNvtsBQ;EACE,eAAA;EACA,gBAAA;EACA,mBAAA;EACA,czGtJI;EyGuJJ,kBAAA;EACA,eAAA;ApNytsBV;AoNrtsBI;EACE,kBAAA;EACA,eAAA;ApNutsBN;AoNptsBI;EACE,WAAA;EACA,4BAAA,EAAA,uDAAA;EACA,mBAAA;EACA,yBAAA;EACA,aAAA;EACA,czGlKQ;A3Gw3sBd;AoNntsBI;EACE,sCAAA;EACA,aAAA;ApNqtsBN;AoNltsBI;EACE,oCAAA;ApNotsBN;AoNjtsBI;EACE,kBAAA;EACA,QAAA;EACA,WAAA,EAAA,gDAAA;EACA,2BAAA;EACA,WAAA,EAAA,0BAAA;EACA,YAAA;EACA,eAAA;ApNmtsBN;;AoN7ssBE;EACE,aAAA;ApNgtsBJ;AoN7ssBI;EACE,cAAA;ApN+ssBN;;A4Mx5sBI;EACE,ajGYM;A3G+4sBZ;A4Mz5sBI;EACE,aAAA;A5M25sBN;A4Mz5sBI;EACE,cjGMM;A3Gq5sBZ;A4Mz5sBI;EACE,cjGPS;A3Gk6sBf;A4Mx5sBE;EACE,WAAA;EACA,YAAA;EACA,kBAAA;EACA,yBjGVS;EiGWT,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,WjGpBO;EiGqBP,eAAA;EACA,gBAAA;A5M05sBJ;;AqNh7sBE;EACE,yB1GYW;E0GXX,kBAAA;EACA,kBAAA;ArNm7sBJ;AqNj7sBM;EACE,eAAA;EACA,gBAAA;EACA,iBAAA;EACA,c1GVK;A3G67sBb;AqNj7sBM;EACE,eAAA;EACA,gBAAA;EACA,mBAAA;EACA,c1GZM;A3G+7sBd;AqN/6sBM;EACE,eAAA;EACA,gBAAA;EACA,iBAAA;EACA,c1GjBK;E0GkBL,kBAAA;ArNi7sBR;AqN/6sBM;;EAEE,eAAA;EACA,gBAAA;EACA,YAAA;EACA,eAAA;EACA,gBAAA;EACA,yBAAA;ArNi7sBR;AqN/6sBM;EACE,eAAA;EACA,gBAAA;EACA,YAAA;EACA,eAAA;EACA,gBAAA;ArNi7sBR;AqN36sBM;EACE,eAAA;EACA,mBAAA;ArN66sBR;AqN16sBI;EACE,YAAA;ArN46sBN;AqNz6sBE;EACE,gBAAA;ArN26sBJ;;AsNr+sBE;EACE,gBAAA;EACA,kBAAA;AtNw+sBJ;AsNv+sBI;EACE,iBAAA;AtNy+sBN;AsNt+sBE;EACE,gBAAA;AtNw+sBJ;AsNt+sBE;EACE,UAAA;AtNw+sBJ;AsNv+sBI;EACE,kBAAA;AtNy+sBN;AsNv+sBI;EACE,eAAA;EACA,YAAA;AtNy+sBN;AsNx+sBM;EACE,WAAA;EACA,YAAA;EACA,kBAAA;EACA,mBAAA;EACA,gBAAA;EACA,mBAAA;EACA,eAAA;EACA,gBAAA;EACA,mBAAA;AtN0+sBR;AsNt+sBE;EACE,eAAA;AtNw+sBJ;;AuNngtBY;EACE,c5GED;A3GogtBb;AuN//sBE;EACE,yBAAA;AvNigtBJ;AuN//sBE;EACE,kBAAA;AvNigtBJ;AuN//sBE;EACE,yBAAA;EACA,uBAAA;EACA,kBAAA;EACA,kBAAA;EACA,mBAAA;AvNigtBJ;AuNhgtBI;EACE,WAAA;EACA,YAAA;AvNkgtBN;AuNhgtBI;EACE,YAAA;EACA,aAAA;AvNkgtBN;AuNjgtBM;EACE,WAAA;EACA,YAAA;EACA,eAAA;AvNmgtBR;AuNhgtBI;EACE,eAAA;EACA,gBAAA;EACA,mBAAA;EACA,c5GMoB;E4GLpB,iBAAA;AvNkgtBN;AuNhgtBI;EACE,WAAA;EACA,YAAA;EACA,kBAAA;EACA,iBAAA;EACA,eAAA;AvNkgtBN;AuN9/sBI;EACE,aAAA;AvNggtBN;AuN9/sBI;EACE,YAAA;EACA,kBAAA;EACA,yBAAA;EACA,c5GzDS;E4G0DT,eAAA;EACA,gBAAA;EACA,iBAAA;EACA,oBAAA;EACA,eAAA;AvNggtBN;;A8KjktBA;EACE,kBAAA;A9KoktBF;A8KnktBE;EACE,UAAA;EACA,kBAAA;EACA,iBAAA;A9KqktBJ;A8KpktBI;EACE,qBAAA;EACA,aAAA;A9KsktBN;A8KrktBM;EACE,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,YAAA;EACA,kBAAA;EACA,kBAAA;A9KuktBR;A8KtktBQ;EACE,WAAA;EACA,kBAAA;EACA,WAAA;EACA,WAAA;EACA,yBnEbG;EmEcH,QAAA;EACA,UAAA;EACA,WAAA;A9KwktBV;A8KtktBQ;EACE,aAAA;A9KwktBV;A8KtktBQ;EACE,WAAA;EACA,YAAA;EACA,yBAAA;EACA,yBAAA;EACA,0BAAA;EACA,kBAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;A9KwktBV;A8KvktBU;EACE,WAAA;EACA,YAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;A9KyktBZ;A8KxktBY;EACE,WAAA;EACA,YAAA;A9K0ktBd;A8KtktBQ;EACE,cnElDG;A3G0ntBb;A8KrktBU;EACE,yBnEjDC;A3GwntBb;A8KrktBU;EACE,yBnEpDC;A3G2ntBb;A8KrktBc;EACE,YnE7DL;A3GootBX;A8KnktBU;EACE,cnE5DC;A3GiotBb;A8K/jtBc;EACE,UnEzEL;A3G0otBX;;AwN1otBE;EACE,qDAAA;EACA,yBAAA;EACA,kBAAA;EACA,sBAAA;EACA,kBAAA;EACA,gBAAA;AxN6otBJ;AwN3otBE;EACE,yB7GIW;E6GHX,kBAAA;EACA,uBAAA;AxN6otBJ;AwN1otBI;EACE,eAAA;EACA,gBAAA;EACA,iBAAA;EACA,c7GnBO;A3G+ptBb;AwNzotBE;EACE,gBAAA;AxN2otBJ;AwN1otBI;;;EAGE,iBAAA;EACA,oBAAA;EACA,kBAAA;EACA,mBAAA;EACA,gBAAA;AxN4otBN;AwNtotBQ;EACE,6BAAA;AxNwotBV;AwNtotBQ;EACE,c7GzCG;A3GirtBb;;AyNzptBA;EACE,sB9GxBS;E8GyBT,iBAAA;EACA,kBAAA;EACA,oBAAA;AzN4ptBF;AyN3ptBE;EACE,kBAAA;EACA,mBAAA;AzN6ptBJ;AyN3ptBE;EAEE,mBAAA;EACA,kBAAA;EACA,yBAAA;EACA,kBAAA;EACA,MAAA;EACA,oBAAA;EACA,QAAA;AzN4ptBJ;AyNvptBE;EACE,oBAAA;EACA,WAAA;EACA,eAAA;EACA,SAAA;EACA,gBAAA;AzNyptBJ;AyK1rtBE;EgD4BA;IAOI,UAAA;IACA,oBAAA;EzN2ptBJ;AACF;AyN1ptBI;EACE,eAAA;EACA,gBAAA;EACA,gBAAA;EACA,c9G/BW;A3G2rtBjB;AyKtstBE;EgDsCE;IAMI,eAAA;EzN8ptBN;AACF;AyN7ptBM;EACE,c9GrCU;E8GsCV,aAAA;AzN+ptBR;AyN3ptBE;EACE,eAAA;EACA,YAAA;EACA,WAAA;EACA,WAAA;EACA,YAAA;EACA,kBAAA;EACA,eAAA;AzN6ptBJ;AyNvptBU;EACE,c9GjFG;A3G0utBf;AyNnptBE;EAEE,gBAAA;AzNoptBJ;AyNnptBI;EACE,eAAA;EACA,WAAA;AzNqptBN;;AyNhptBA;EACE,oBAAA;EACA,oCAAA;AzNmptBF;;AyNjptBA;EACE,oBAAA;EACA,2BAAA;AzNoptBF;;AyNjptBA;EACE,kBAAA;EACA,aAAA;AzNoptBF;;AyNjptBA;EACE,sBAAA;EACA,uBAAA;AzNoptBF;;AyNjptBA;EACE,kCAAA;AzNoptBF;;A0N9wtBA;EACE,kBAAA;EACA,kBAAA;EACA,+CAAA;A1NixtBF;;A2N9wtBM;EACE,eAAA;EACA,gBAAA;EACA,iBAAA;EACA,chHRK;A3GyxtBb;A2NxwtBgB;EACE,chHOF;A3GmwtBhB;A2NjwtBM;EACE,uBAAA;A3NmwtBR;A2NjwtBM;EACE,eAAA;EACA,gBAAA;EACA,mBAAA;EACA,chHlCK;EgHmCL,gBAAA;A3NmwtBR;;A2N5vtBE;EACE,eAAA;EACA,gBAAA;EACA,iBAAA;EACA,chH9CS;EgH+CT,eAAA;EACA,eAAA;A3N+vtBJ;A2N9vtBI;EACE,WAAA;EACA,YAAA;A3NgwtBN;A2N7vtBE;EACE,yBAAA;A3N+vtBJ;A2N7vtBE;EACE,kBAAA;A3N+vtBJ;A2N7vtBE;EACE,gCAAA;EACA,kBAAA;EACA,eAAA;EACA,mBAAA;A3N+vtBJ;A2N9vtBI;EACE,WAAA;EACA,YAAA;A3NgwtBN;A2N9vtBI;EACE,YAAA;EACA,aAAA;A3NgwtBN;A2N/vtBM;EACE,WAAA;EACA,YAAA;EACA,eAAA;A3NiwtBR;A2N9vtBI;EACE,eAAA;EACA,gBAAA;EACA,mBAAA;EACA,chHnCoB;EgHoCpB,iBAAA;A3NgwtBN;A2N9vtBI;EACE,WAAA;EACA,YAAA;EACA,kBAAA;EACA,iBAAA;EACA,eAAA;A3NgwtBN;A2N9vtBI;EACE,kBAAA;EACA,ahH3FS;EgH4FT,eAAA;A3NgwtBN;A2N5vtBI;EACE,aAAA;A3N8vtBN;A2N5vtBI;EACE,YAAA;EACA,kBAAA;EACA,yBAAA;EACA,chHvGS;EgHwGT,eAAA;EACA,gBAAA;EACA,iBAAA;EACA,oBAAA;EACA,eAAA;A3N8vtBN;A2N3vtBE;EACE,eAAA;EACA,gBAAA;EACA,mBAAA;EACA,chHtHS;A3Gm3tBb;A2N3vtBE;EACE,WAAA;A3N6vtBJ;A2N3vtBM;EACE,aAAA;EACA,8BAAA;EACA,WAAA;EACA,mBAAA;EACA,gCAAA;EACA,eAAA;A3N6vtBR;A2N5vtBQ;EACE,aAAA;A3N8vtBV;A2N7vtBU;EACE,chHhFE;A3G+0tBd;A2N7vtBU;EACE,WAAA;EACA,YAAA;EACA,kBAAA;A3N+vtBZ;A2N5vtBY;EACE,eAAA;EACA,gBAAA;EACA,iBAAA;EACA,chH/ID;A3G64tBb;A2N7vtBc;EACE,eAAA;EACA,gBAAA;EACA,mBAAA;EACA,chHtJH;A3Gq5tBb;A2N3vtBU;EACE,eAAA;EACA,gBAAA;EACA,iBAAA;EACA,chHxGgB;A3Gq2tB5B;A2N5vtBY;EACE,chHvJA;A3Gq5tBd;A2NrvtBM;EACE,WAAA;EACA,YAAA;A3NuvtBR;A2NrvtBM;EACE,eAAA;EACA,gBAAA;EACA,mBAAA;EACA,chH9KO;A3Gq6tBf;A2N7utBc;EACE,chHnKA;A3Gk5tBhB;A2NtutBI;EACE,uBAAA;A3NwutBN;A2NtutBI;EACE,eAAA;EACA,gBAAA;EACA,mBAAA;EACA,chH5MO;EgH6MP,gBAAA;A3NwutBN;A2NrutBE;EACE,YAAA;A3NuutBJ;;A4N17tBA;EACE,gCAAA;EACA,2CAAA;EACA,kBAAA;EACA,eAAA;A5N67tBF;A4N37tBI;EACE,eAAA;EACA,gBAAA;EACA,iBAAA;EACA,cjHCQ;A3G47tBd;A4N17tBE;EACE,SAAA;EACA,gCAAA;EACA,eAAA;EACA,YAAA;A5N47tBJ;A4N37tBI;EACE,WAAA;EACA,YAAA;A5N67tBN;A4N37tBI;EACE,eAAA;EACA,gBAAA;EACA,mBAAA;EACA,cjHxBO;A3Gq9tBb;A4N37tBI;EACE,SAAA;EACA,UAAA;EACA,gBAAA;EACA,WAAA;EACA,YAAA;EACA,eAAA;EACA,gBAAA;EACA,mBAAA;EACA,cjHfY;A3G48tBlB;A4N57tBM;EACE,UAAA;EACA,aAAA;A5N87tBR;A4N17tBE;;;EAEE,iBAAA;EACA,oBAAA;EACA,kBAAA;EACA,mBAAA;A5N67tBJ;A4N37tBE;EACE,gBAAA;A5N67tBJ;A4N57tBI;;;EAEE,cjHnDO;EiHoDP,SAAA;EACA,gCAAA;EACA,WAAA;EACA,uBAAA;EACA,kBAAA;EACA,gBAAA;EACA,gBAAA;A5N+7tBN;A4N77tBI;EACE,cjH/DO;EiHgEP,eAAA;EACA,gBAAA;EACA,mBAAA;EACA,gBAAA;A5N+7tBN;A4N57tBE;EACE,aAAA;EACA,mBAAA;A5N87tBJ;A4N77tBI;EACE,kBAAA;EACA,UAAA;EACA,WAAA;EACA,YAAA;EACA,UAAA;A5N+7tBN;A4N57tBM;EACE,yBjH/EO;EiHgFP,qBjHhFO;A3G8guBf;A4N77tBQ;EACE,aAAA;A5N+7tBV;A4N37tBI;EACE,WAAA;EACA,YAAA;EACA,yBAAA;EACA,gBAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,kBAAA;EACA,iBAAA;EACA,kBAAA;EACA,YAAA;EACA,sBAAA;EACA,sCAAA;EACA,eAAA;EACA,gBAAA;A5N67tBN;A4N37tBI;EACE,WAAA;EACA,eAAA;EACA,aAAA;A5N67tBN;A4N37tBI;EACE,gBAAA;EACA,cjHjHO;A3G8iuBb;A4N57tBM;EACE,cjHhHO;A3G8iuBf;A4Nz7tBI;EACE,aAAA;A5N27tBN;;A4Nr7tBE;EACE,gBAAA;A5Nw7tBJ;A4Nv7tBI;;EAEE,cjHjIO;EiHkIP,SAAA;EACA,gCAAA;EACA,WAAA;EACA,uBAAA;EACA,kBAAA;EACA,gBAAA;EACA,gBAAA;A5Ny7tBN;A4Nv7tBI;EACE,cjH7IO;EiH8IP,eAAA;EACA,gBAAA;EACA,mBAAA;EACA,gBAAA;A5Ny7tBN;A4Nt7tBE;EACE,aAAA;A5Nw7tBJ;A4Nv7tBI;EACE,eAAA;EACA,gBAAA;EACA,iBAAA;EACA,cjHjJQ;EiHkJR,kBAAA;EACA,WAAA;A5Ny7tBN;A4Nx7tBM;EACE,UAAA;EACA,kBAAA;EACA,WAAA;EACA,YAAA;EACA,MAAA;EACA,QAAA;EACA,SAAA;EACA,gBAAA;EACA,6BAAA;EACA,UAAA;A5N07tBR;A4Nz7tBQ;EACE,WAAA;EACA,YAAA;EACA,cjH3KG;A3GsmuBb;A4Np7tBM;EACE,gBAAA;EACA,UAAA;EACA,kBAAA;EACA,mBAAA;A5Ns7tBR;A4Np7tBM;EAIE,WAAA;EACA,cAAA;EACA,kBAAA;EACA,iBAAA;EACA,gBAAA;A5Nm7tBR;;A4Nz6tBM;;;;EAEE,6BAAA;EACA,aAAA;A5N86tBR;A4Nz6tBQ;EACE,cjHhNK;A3G2nuBf;A4Nz6tBQ;EACE,iBAAA;A5N26tBV;A4Nz6tBY;EACE,UAAA;A5N26tBd;A4N16tBc;EACE,cjHxND;A3GoouBf;A4N16tBc;EACE,gBAAA;A5N46tBhB;A4N16tBc;EAEE,gBAAA;A5N26tBhB;A4Nv6tBU;EACE,yBAAA;EACA,oBAAA;EACA,iBAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;A5Ny6tBZ","sourcesContent":["@charset \"UTF-8\";\n:root {\n  --blue: #3ba371;\n  --indigo: #5603ad;\n  --purple: #8965e0;\n  --pink: #f3a4b5;\n  --red: #f5365c;\n  --orange: #fb6340;\n  --yellow: #ffd600;\n  --green: #3aa170;\n  --teal: #278e69;\n  --cyan: #2bffc6;\n  --white: #fff;\n  --gray: #8898aa;\n  --gray-dark: #32325d;\n  --light: #ced4da;\n  --lighter: #e9ecef;\n  --primary: #3ba371;\n  --secondary: #f7fafc;\n  --success: #3aa170;\n  --info: #278e69;\n  --warning: #fb6340;\n  --danger: #f5365c;\n  --light: #adb5bd;\n  --dark: #212529;\n  --default: #ffd88c;\n  --white: #fff;\n  --neutral: #fff;\n  --darker: black;\n  --breakpoint-xs: 0;\n  --breakpoint-sm: 576px;\n  --breakpoint-md: 768px;\n  --breakpoint-lg: 992px;\n  --breakpoint-xl: 1200px;\n  --font-family-sans-serif: Open Sans, sans-serif;\n  --font-family-monospace: SFMono-Regular, Menlo, Monaco, Consolas, \"Liberation Mono\", \"Courier New\", monospace;\n}\n\n*,\n*::before,\n*::after {\n  box-sizing: border-box;\n}\n\nhtml {\n  font-family: sans-serif;\n  line-height: 1.15;\n  -webkit-text-size-adjust: 100%;\n  -webkit-tap-highlight-color: rgba(0, 0, 0, 0);\n}\n\narticle, aside, figcaption, figure, footer, header, hgroup, main, nav, section {\n  display: block;\n}\n\nbody {\n  margin: 0;\n  font-family: Open Sans, sans-serif;\n  font-size: 1rem;\n  font-weight: 400;\n  line-height: 1.5;\n  color: #525f7f;\n  text-align: left;\n  background-color: #f8f9fe;\n}\n\n[tabindex=\"-1\"]:focus:not(:focus-visible) {\n  outline: 0 !important;\n}\n\nhr {\n  box-sizing: content-box;\n  height: 0;\n  overflow: visible;\n}\n\nh1, h2, h3, h4, h5, h6 {\n  margin-top: 0;\n  margin-bottom: 0.5rem;\n}\n\np {\n  margin-top: 0;\n  margin-bottom: 1rem;\n}\n\nabbr[title],\nabbr[data-original-title] {\n  text-decoration: underline;\n  text-decoration: underline dotted;\n  cursor: help;\n  border-bottom: 0;\n  text-decoration-skip-ink: none;\n}\n\naddress {\n  margin-bottom: 1rem;\n  font-style: normal;\n  line-height: inherit;\n}\n\nol,\nul,\ndl {\n  margin-top: 0;\n  margin-bottom: 1rem;\n}\n\nol ol,\nul ul,\nol ul,\nul ol {\n  margin-bottom: 0;\n}\n\ndt {\n  font-weight: 600;\n}\n\ndd {\n  margin-bottom: 0.5rem;\n  margin-left: 0;\n}\n\nblockquote {\n  margin: 0 0 1rem;\n}\n\nb,\nstrong {\n  font-weight: bolder;\n}\n\nsmall {\n  font-size: 80%;\n}\n\nsub,\nsup {\n  position: relative;\n  font-size: 75%;\n  line-height: 0;\n  vertical-align: baseline;\n}\n\nsub {\n  bottom: -0.25em;\n}\n\nsup {\n  top: -0.5em;\n}\n\na {\n  color: #3ba371;\n  text-decoration: none;\n  background-color: transparent;\n}\na:hover {\n  color: rgb(38.6689189189, 106.8310810811, 74.0608108108);\n  text-decoration: none;\n}\n\na:not([href]):not([class]) {\n  color: inherit;\n  text-decoration: none;\n}\na:not([href]):not([class]):hover {\n  color: inherit;\n  text-decoration: none;\n}\n\npre,\ncode,\nkbd,\nsamp {\n  font-family: SFMono-Regular, Menlo, Monaco, Consolas, \"Liberation Mono\", \"Courier New\", monospace;\n  font-size: 1em;\n}\n\npre {\n  margin-top: 0;\n  margin-bottom: 1rem;\n  overflow: auto;\n  -ms-overflow-style: scrollbar;\n}\n\nfigure {\n  margin: 0 0 1rem;\n}\n\nimg {\n  vertical-align: middle;\n  border-style: none;\n}\n\nsvg {\n  overflow: hidden;\n  vertical-align: middle;\n}\n\ntable {\n  border-collapse: collapse;\n}\n\ncaption {\n  padding-top: 1rem;\n  padding-bottom: 1rem;\n  color: #8898aa;\n  text-align: left;\n  caption-side: bottom;\n}\n\nth {\n  text-align: inherit;\n  text-align: -webkit-match-parent;\n}\n\nlabel {\n  display: inline-block;\n  margin-bottom: 0.5rem;\n}\n\nbutton {\n  border-radius: 0;\n}\n\nbutton:focus:not(:focus-visible) {\n  outline: 0;\n}\n\ninput,\nbutton,\nselect,\noptgroup,\ntextarea {\n  margin: 0;\n  font-family: inherit;\n  font-size: inherit;\n  line-height: inherit;\n}\n\nbutton,\ninput {\n  overflow: visible;\n}\n\nbutton,\nselect {\n  text-transform: none;\n}\n\n[role=button] {\n  cursor: pointer;\n}\n\nselect {\n  word-wrap: normal;\n}\n\nbutton,\n[type=button],\n[type=reset],\n[type=submit] {\n  -webkit-appearance: button;\n}\n\nbutton:not(:disabled),\n[type=button]:not(:disabled),\n[type=reset]:not(:disabled),\n[type=submit]:not(:disabled) {\n  cursor: pointer;\n}\n\nbutton::-moz-focus-inner,\n[type=button]::-moz-focus-inner,\n[type=reset]::-moz-focus-inner,\n[type=submit]::-moz-focus-inner {\n  padding: 0;\n  border-style: none;\n}\n\ninput[type=radio],\ninput[type=checkbox] {\n  box-sizing: border-box;\n  padding: 0;\n}\n\ntextarea {\n  overflow: auto;\n  resize: vertical;\n}\n\nfieldset {\n  min-width: 0;\n  padding: 0;\n  margin: 0;\n  border: 0;\n}\n\nlegend {\n  display: block;\n  width: 100%;\n  max-width: 100%;\n  padding: 0;\n  margin-bottom: 0.5rem;\n  font-size: 1.5rem;\n  line-height: inherit;\n  color: inherit;\n  white-space: normal;\n}\n\nprogress {\n  vertical-align: baseline;\n}\n\n[type=number]::-webkit-inner-spin-button,\n[type=number]::-webkit-outer-spin-button {\n  height: auto;\n}\n\n[type=search] {\n  outline-offset: -2px;\n  -webkit-appearance: none;\n}\n\n[type=search]::-webkit-search-decoration {\n  -webkit-appearance: none;\n}\n\n::-webkit-file-upload-button {\n  font: inherit;\n  -webkit-appearance: button;\n}\n\noutput {\n  display: inline-block;\n}\n\nsummary {\n  display: list-item;\n  cursor: pointer;\n}\n\ntemplate {\n  display: none;\n}\n\n[hidden] {\n  display: none !important;\n}\n\nh1, h2, h3, h4, h5, h6,\n.h1, .h2, .h3, .h4, .h5, .h6 {\n  margin-bottom: 0.5rem;\n  font-family: inherit;\n  font-weight: 600;\n  line-height: 1.5;\n  color: #32325d;\n}\n\nh1, .h1 {\n  font-size: 1.625rem;\n}\n\nh2, .h2 {\n  font-size: 1.25rem;\n}\n\nh3, .h3 {\n  font-size: 1.0625rem;\n}\n\nh4, .h4 {\n  font-size: 0.9375rem;\n}\n\nh5, .h5 {\n  font-size: 0.8125rem;\n}\n\nh6, .h6 {\n  font-size: 0.625rem;\n}\n\n.lead {\n  font-size: 1.25rem;\n  font-weight: 300;\n}\n\n.display-1 {\n  font-size: 3.3rem;\n  font-weight: 600;\n  line-height: 1.5;\n}\n\n.display-2 {\n  font-size: 2.75rem;\n  font-weight: 600;\n  line-height: 1.5;\n}\n\n.display-3 {\n  font-size: 2.1875rem;\n  font-weight: 600;\n  line-height: 1.5;\n}\n\n.display-4 {\n  font-size: 1.6275rem;\n  font-weight: 600;\n  line-height: 1.5;\n}\n\nhr {\n  margin-top: 2rem;\n  margin-bottom: 2rem;\n  border: 0;\n  border-top: 1px solid rgba(0, 0, 0, 0.1);\n}\n\nsmall,\n.small {\n  font-size: 80%;\n  font-weight: 400;\n}\n\nmark,\n.mark {\n  padding: 0.2em;\n  background-color: #fcf8e3;\n}\n\n.list-unstyled {\n  padding-left: 0;\n  list-style: none;\n}\n\n.list-inline {\n  padding-left: 0;\n  list-style: none;\n}\n\n.list-inline-item {\n  display: inline-block;\n}\n.list-inline-item:not(:last-child) {\n  margin-right: 0.5rem;\n}\n\n.initialism {\n  font-size: 90%;\n  text-transform: uppercase;\n}\n\n.blockquote {\n  margin-bottom: 1rem;\n  font-size: 1.25rem;\n}\n\n.blockquote-footer {\n  display: block;\n  font-size: 80%;\n  color: #8898aa;\n}\n.blockquote-footer::before {\n  content: \"— \";\n}\n\n.img-fluid {\n  max-width: 100%;\n  height: auto;\n}\n\n.img-thumbnail {\n  padding: 0.25rem;\n  background-color: #f8f9fe;\n  border: 1px solid #dee2e6;\n  border-radius: 0.375rem;\n  box-shadow: 0 1px 2px rgba(0, 0, 0, 0.075);\n  max-width: 100%;\n  height: auto;\n}\n\n.figure {\n  display: inline-block;\n}\n\n.figure-img {\n  margin-bottom: 0.5rem;\n  line-height: 1;\n}\n\n.figure-caption {\n  font-size: 90%;\n  color: #8898aa;\n}\n\ncode {\n  font-size: 87.5%;\n  color: #f3a4b5;\n  word-wrap: break-word;\n}\na > code {\n  color: inherit;\n}\n\nkbd {\n  padding: 0.2rem 0.4rem;\n  font-size: 87.5%;\n  color: #fff;\n  background-color: #212529;\n  border-radius: 0.25rem;\n  box-shadow: inset 0 -0.1rem 0 rgba(0, 0, 0, 0.25);\n}\nkbd kbd {\n  padding: 0;\n  font-size: 100%;\n  font-weight: 600;\n  box-shadow: none;\n}\n\npre {\n  display: block;\n  font-size: 87.5%;\n  color: #212529;\n}\npre code {\n  font-size: inherit;\n  color: inherit;\n  word-break: normal;\n}\n\n.pre-scrollable {\n  max-height: 340px;\n  overflow-y: scroll;\n}\n\n.container,\n.container-fluid,\n.container-xl,\n.container-lg,\n.container-md,\n.container-sm {\n  width: 100%;\n  padding-right: 15px;\n  padding-left: 15px;\n  margin-right: auto;\n  margin-left: auto;\n}\n\n@media (min-width: 576px) {\n  .container-sm, .container {\n    max-width: 540px;\n  }\n}\n@media (min-width: 768px) {\n  .container-md, .container-sm, .container {\n    max-width: 720px;\n  }\n}\n@media (min-width: 992px) {\n  .container-lg, .container-md, .container-sm, .container {\n    max-width: 960px;\n  }\n}\n@media (min-width: 1200px) {\n  .container-xl, .container-lg, .container-md, .container-sm, .container {\n    max-width: 1140px;\n  }\n}\n.row {\n  display: flex;\n  flex-wrap: wrap;\n  margin-right: -15px;\n  margin-left: -15px;\n}\n\n.no-gutters {\n  margin-right: 0;\n  margin-left: 0;\n}\n.no-gutters > .col,\n.no-gutters > [class*=col-] {\n  padding-right: 0;\n  padding-left: 0;\n}\n\n.col-xl,\n.col-xl-auto, .col-xl-12, .col-xl-11, .col-xl-10, .col-xl-9, .col-xl-8, .col-xl-7, .col-xl-6, .col-xl-5, .col-xl-4, .col-xl-3, .col-xl-2, .col-xl-1, .col-lg,\n.col-lg-auto, .col-lg-12, .col-lg-11, .col-lg-10, .col-lg-9, .col-lg-8, .col-lg-7, .col-lg-6, .col-lg-5, .col-lg-4, .col-lg-3, .col-lg-2, .col-lg-1, .col-md,\n.col-md-auto, .col-md-12, .col-md-11, .col-md-10, .col-md-9, .col-md-8, .col-md-7, .col-md-6, .col-md-5, .col-md-4, .col-md-3, .col-md-2, .col-md-1, .col-sm,\n.col-sm-auto, .col-sm-12, .col-sm-11, .col-sm-10, .col-sm-9, .col-sm-8, .col-sm-7, .col-sm-6, .col-sm-5, .col-sm-4, .col-sm-3, .col-sm-2, .col-sm-1, .col,\n.col-auto, .col-12, .col-11, .col-10, .col-9, .col-8, .col-7, .col-6, .col-5, .col-4, .col-3, .col-2, .col-1 {\n  position: relative;\n  width: 100%;\n  padding-right: 15px;\n  padding-left: 15px;\n}\n\n.col {\n  flex-basis: 0;\n  flex-grow: 1;\n  max-width: 100%;\n}\n\n.row-cols-1 > * {\n  flex: 0 0 100%;\n  max-width: 100%;\n}\n\n.row-cols-2 > * {\n  flex: 0 0 50%;\n  max-width: 50%;\n}\n\n.row-cols-3 > * {\n  flex: 0 0 33.3333333333%;\n  max-width: 33.3333333333%;\n}\n\n.row-cols-4 > * {\n  flex: 0 0 25%;\n  max-width: 25%;\n}\n\n.row-cols-5 > * {\n  flex: 0 0 20%;\n  max-width: 20%;\n}\n\n.row-cols-6 > * {\n  flex: 0 0 16.6666666667%;\n  max-width: 16.6666666667%;\n}\n\n.col-auto {\n  flex: 0 0 auto;\n  width: auto;\n  max-width: 100%;\n}\n\n.col-1 {\n  flex: 0 0 8.3333333333%;\n  max-width: 8.3333333333%;\n}\n\n.col-2 {\n  flex: 0 0 16.6666666667%;\n  max-width: 16.6666666667%;\n}\n\n.col-3 {\n  flex: 0 0 25%;\n  max-width: 25%;\n}\n\n.col-4 {\n  flex: 0 0 33.3333333333%;\n  max-width: 33.3333333333%;\n}\n\n.col-5 {\n  flex: 0 0 41.6666666667%;\n  max-width: 41.6666666667%;\n}\n\n.col-6 {\n  flex: 0 0 50%;\n  max-width: 50%;\n}\n\n.col-7 {\n  flex: 0 0 58.3333333333%;\n  max-width: 58.3333333333%;\n}\n\n.col-8 {\n  flex: 0 0 66.6666666667%;\n  max-width: 66.6666666667%;\n}\n\n.col-9 {\n  flex: 0 0 75%;\n  max-width: 75%;\n}\n\n.col-10 {\n  flex: 0 0 83.3333333333%;\n  max-width: 83.3333333333%;\n}\n\n.col-11 {\n  flex: 0 0 91.6666666667%;\n  max-width: 91.6666666667%;\n}\n\n.col-12 {\n  flex: 0 0 100%;\n  max-width: 100%;\n}\n\n.order-first {\n  order: -1;\n}\n\n.order-last {\n  order: 13;\n}\n\n.order-0 {\n  order: 0;\n}\n\n.order-1 {\n  order: 1;\n}\n\n.order-2 {\n  order: 2;\n}\n\n.order-3 {\n  order: 3;\n}\n\n.order-4 {\n  order: 4;\n}\n\n.order-5 {\n  order: 5;\n}\n\n.order-6 {\n  order: 6;\n}\n\n.order-7 {\n  order: 7;\n}\n\n.order-8 {\n  order: 8;\n}\n\n.order-9 {\n  order: 9;\n}\n\n.order-10 {\n  order: 10;\n}\n\n.order-11 {\n  order: 11;\n}\n\n.order-12 {\n  order: 12;\n}\n\n.offset-1 {\n  margin-left: 8.3333333333%;\n}\n\n.offset-2 {\n  margin-left: 16.6666666667%;\n}\n\n.offset-3 {\n  margin-left: 25%;\n}\n\n.offset-4 {\n  margin-left: 33.3333333333%;\n}\n\n.offset-5 {\n  margin-left: 41.6666666667%;\n}\n\n.offset-6 {\n  margin-left: 50%;\n}\n\n.offset-7 {\n  margin-left: 58.3333333333%;\n}\n\n.offset-8 {\n  margin-left: 66.6666666667%;\n}\n\n.offset-9 {\n  margin-left: 75%;\n}\n\n.offset-10 {\n  margin-left: 83.3333333333%;\n}\n\n.offset-11 {\n  margin-left: 91.6666666667%;\n}\n\n@media (min-width: 576px) {\n  .col-sm {\n    flex-basis: 0;\n    flex-grow: 1;\n    max-width: 100%;\n  }\n  .row-cols-sm-1 > * {\n    flex: 0 0 100%;\n    max-width: 100%;\n  }\n  .row-cols-sm-2 > * {\n    flex: 0 0 50%;\n    max-width: 50%;\n  }\n  .row-cols-sm-3 > * {\n    flex: 0 0 33.3333333333%;\n    max-width: 33.3333333333%;\n  }\n  .row-cols-sm-4 > * {\n    flex: 0 0 25%;\n    max-width: 25%;\n  }\n  .row-cols-sm-5 > * {\n    flex: 0 0 20%;\n    max-width: 20%;\n  }\n  .row-cols-sm-6 > * {\n    flex: 0 0 16.6666666667%;\n    max-width: 16.6666666667%;\n  }\n  .col-sm-auto {\n    flex: 0 0 auto;\n    width: auto;\n    max-width: 100%;\n  }\n  .col-sm-1 {\n    flex: 0 0 8.3333333333%;\n    max-width: 8.3333333333%;\n  }\n  .col-sm-2 {\n    flex: 0 0 16.6666666667%;\n    max-width: 16.6666666667%;\n  }\n  .col-sm-3 {\n    flex: 0 0 25%;\n    max-width: 25%;\n  }\n  .col-sm-4 {\n    flex: 0 0 33.3333333333%;\n    max-width: 33.3333333333%;\n  }\n  .col-sm-5 {\n    flex: 0 0 41.6666666667%;\n    max-width: 41.6666666667%;\n  }\n  .col-sm-6 {\n    flex: 0 0 50%;\n    max-width: 50%;\n  }\n  .col-sm-7 {\n    flex: 0 0 58.3333333333%;\n    max-width: 58.3333333333%;\n  }\n  .col-sm-8 {\n    flex: 0 0 66.6666666667%;\n    max-width: 66.6666666667%;\n  }\n  .col-sm-9 {\n    flex: 0 0 75%;\n    max-width: 75%;\n  }\n  .col-sm-10 {\n    flex: 0 0 83.3333333333%;\n    max-width: 83.3333333333%;\n  }\n  .col-sm-11 {\n    flex: 0 0 91.6666666667%;\n    max-width: 91.6666666667%;\n  }\n  .col-sm-12 {\n    flex: 0 0 100%;\n    max-width: 100%;\n  }\n  .order-sm-first {\n    order: -1;\n  }\n  .order-sm-last {\n    order: 13;\n  }\n  .order-sm-0 {\n    order: 0;\n  }\n  .order-sm-1 {\n    order: 1;\n  }\n  .order-sm-2 {\n    order: 2;\n  }\n  .order-sm-3 {\n    order: 3;\n  }\n  .order-sm-4 {\n    order: 4;\n  }\n  .order-sm-5 {\n    order: 5;\n  }\n  .order-sm-6 {\n    order: 6;\n  }\n  .order-sm-7 {\n    order: 7;\n  }\n  .order-sm-8 {\n    order: 8;\n  }\n  .order-sm-9 {\n    order: 9;\n  }\n  .order-sm-10 {\n    order: 10;\n  }\n  .order-sm-11 {\n    order: 11;\n  }\n  .order-sm-12 {\n    order: 12;\n  }\n  .offset-sm-0 {\n    margin-left: 0;\n  }\n  .offset-sm-1 {\n    margin-left: 8.3333333333%;\n  }\n  .offset-sm-2 {\n    margin-left: 16.6666666667%;\n  }\n  .offset-sm-3 {\n    margin-left: 25%;\n  }\n  .offset-sm-4 {\n    margin-left: 33.3333333333%;\n  }\n  .offset-sm-5 {\n    margin-left: 41.6666666667%;\n  }\n  .offset-sm-6 {\n    margin-left: 50%;\n  }\n  .offset-sm-7 {\n    margin-left: 58.3333333333%;\n  }\n  .offset-sm-8 {\n    margin-left: 66.6666666667%;\n  }\n  .offset-sm-9 {\n    margin-left: 75%;\n  }\n  .offset-sm-10 {\n    margin-left: 83.3333333333%;\n  }\n  .offset-sm-11 {\n    margin-left: 91.6666666667%;\n  }\n}\n@media (min-width: 768px) {\n  .col-md {\n    flex-basis: 0;\n    flex-grow: 1;\n    max-width: 100%;\n  }\n  .row-cols-md-1 > * {\n    flex: 0 0 100%;\n    max-width: 100%;\n  }\n  .row-cols-md-2 > * {\n    flex: 0 0 50%;\n    max-width: 50%;\n  }\n  .row-cols-md-3 > * {\n    flex: 0 0 33.3333333333%;\n    max-width: 33.3333333333%;\n  }\n  .row-cols-md-4 > * {\n    flex: 0 0 25%;\n    max-width: 25%;\n  }\n  .row-cols-md-5 > * {\n    flex: 0 0 20%;\n    max-width: 20%;\n  }\n  .row-cols-md-6 > * {\n    flex: 0 0 16.6666666667%;\n    max-width: 16.6666666667%;\n  }\n  .col-md-auto {\n    flex: 0 0 auto;\n    width: auto;\n    max-width: 100%;\n  }\n  .col-md-1 {\n    flex: 0 0 8.3333333333%;\n    max-width: 8.3333333333%;\n  }\n  .col-md-2 {\n    flex: 0 0 16.6666666667%;\n    max-width: 16.6666666667%;\n  }\n  .col-md-3 {\n    flex: 0 0 25%;\n    max-width: 25%;\n  }\n  .col-md-4 {\n    flex: 0 0 33.3333333333%;\n    max-width: 33.3333333333%;\n  }\n  .col-md-5 {\n    flex: 0 0 41.6666666667%;\n    max-width: 41.6666666667%;\n  }\n  .col-md-6 {\n    flex: 0 0 50%;\n    max-width: 50%;\n  }\n  .col-md-7 {\n    flex: 0 0 58.3333333333%;\n    max-width: 58.3333333333%;\n  }\n  .col-md-8 {\n    flex: 0 0 66.6666666667%;\n    max-width: 66.6666666667%;\n  }\n  .col-md-9 {\n    flex: 0 0 75%;\n    max-width: 75%;\n  }\n  .col-md-10 {\n    flex: 0 0 83.3333333333%;\n    max-width: 83.3333333333%;\n  }\n  .col-md-11 {\n    flex: 0 0 91.6666666667%;\n    max-width: 91.6666666667%;\n  }\n  .col-md-12 {\n    flex: 0 0 100%;\n    max-width: 100%;\n  }\n  .order-md-first {\n    order: -1;\n  }\n  .order-md-last {\n    order: 13;\n  }\n  .order-md-0 {\n    order: 0;\n  }\n  .order-md-1 {\n    order: 1;\n  }\n  .order-md-2 {\n    order: 2;\n  }\n  .order-md-3 {\n    order: 3;\n  }\n  .order-md-4 {\n    order: 4;\n  }\n  .order-md-5 {\n    order: 5;\n  }\n  .order-md-6 {\n    order: 6;\n  }\n  .order-md-7 {\n    order: 7;\n  }\n  .order-md-8 {\n    order: 8;\n  }\n  .order-md-9 {\n    order: 9;\n  }\n  .order-md-10 {\n    order: 10;\n  }\n  .order-md-11 {\n    order: 11;\n  }\n  .order-md-12 {\n    order: 12;\n  }\n  .offset-md-0 {\n    margin-left: 0;\n  }\n  .offset-md-1 {\n    margin-left: 8.3333333333%;\n  }\n  .offset-md-2 {\n    margin-left: 16.6666666667%;\n  }\n  .offset-md-3 {\n    margin-left: 25%;\n  }\n  .offset-md-4 {\n    margin-left: 33.3333333333%;\n  }\n  .offset-md-5 {\n    margin-left: 41.6666666667%;\n  }\n  .offset-md-6 {\n    margin-left: 50%;\n  }\n  .offset-md-7 {\n    margin-left: 58.3333333333%;\n  }\n  .offset-md-8 {\n    margin-left: 66.6666666667%;\n  }\n  .offset-md-9 {\n    margin-left: 75%;\n  }\n  .offset-md-10 {\n    margin-left: 83.3333333333%;\n  }\n  .offset-md-11 {\n    margin-left: 91.6666666667%;\n  }\n}\n@media (min-width: 992px) {\n  .col-lg {\n    flex-basis: 0;\n    flex-grow: 1;\n    max-width: 100%;\n  }\n  .row-cols-lg-1 > * {\n    flex: 0 0 100%;\n    max-width: 100%;\n  }\n  .row-cols-lg-2 > * {\n    flex: 0 0 50%;\n    max-width: 50%;\n  }\n  .row-cols-lg-3 > * {\n    flex: 0 0 33.3333333333%;\n    max-width: 33.3333333333%;\n  }\n  .row-cols-lg-4 > * {\n    flex: 0 0 25%;\n    max-width: 25%;\n  }\n  .row-cols-lg-5 > * {\n    flex: 0 0 20%;\n    max-width: 20%;\n  }\n  .row-cols-lg-6 > * {\n    flex: 0 0 16.6666666667%;\n    max-width: 16.6666666667%;\n  }\n  .col-lg-auto {\n    flex: 0 0 auto;\n    width: auto;\n    max-width: 100%;\n  }\n  .col-lg-1 {\n    flex: 0 0 8.3333333333%;\n    max-width: 8.3333333333%;\n  }\n  .col-lg-2 {\n    flex: 0 0 16.6666666667%;\n    max-width: 16.6666666667%;\n  }\n  .col-lg-3 {\n    flex: 0 0 25%;\n    max-width: 25%;\n  }\n  .col-lg-4 {\n    flex: 0 0 33.3333333333%;\n    max-width: 33.3333333333%;\n  }\n  .col-lg-5 {\n    flex: 0 0 41.6666666667%;\n    max-width: 41.6666666667%;\n  }\n  .col-lg-6 {\n    flex: 0 0 50%;\n    max-width: 50%;\n  }\n  .col-lg-7 {\n    flex: 0 0 58.3333333333%;\n    max-width: 58.3333333333%;\n  }\n  .col-lg-8 {\n    flex: 0 0 66.6666666667%;\n    max-width: 66.6666666667%;\n  }\n  .col-lg-9 {\n    flex: 0 0 75%;\n    max-width: 75%;\n  }\n  .col-lg-10 {\n    flex: 0 0 83.3333333333%;\n    max-width: 83.3333333333%;\n  }\n  .col-lg-11 {\n    flex: 0 0 91.6666666667%;\n    max-width: 91.6666666667%;\n  }\n  .col-lg-12 {\n    flex: 0 0 100%;\n    max-width: 100%;\n  }\n  .order-lg-first {\n    order: -1;\n  }\n  .order-lg-last {\n    order: 13;\n  }\n  .order-lg-0 {\n    order: 0;\n  }\n  .order-lg-1 {\n    order: 1;\n  }\n  .order-lg-2 {\n    order: 2;\n  }\n  .order-lg-3 {\n    order: 3;\n  }\n  .order-lg-4 {\n    order: 4;\n  }\n  .order-lg-5 {\n    order: 5;\n  }\n  .order-lg-6 {\n    order: 6;\n  }\n  .order-lg-7 {\n    order: 7;\n  }\n  .order-lg-8 {\n    order: 8;\n  }\n  .order-lg-9 {\n    order: 9;\n  }\n  .order-lg-10 {\n    order: 10;\n  }\n  .order-lg-11 {\n    order: 11;\n  }\n  .order-lg-12 {\n    order: 12;\n  }\n  .offset-lg-0 {\n    margin-left: 0;\n  }\n  .offset-lg-1 {\n    margin-left: 8.3333333333%;\n  }\n  .offset-lg-2 {\n    margin-left: 16.6666666667%;\n  }\n  .offset-lg-3 {\n    margin-left: 25%;\n  }\n  .offset-lg-4 {\n    margin-left: 33.3333333333%;\n  }\n  .offset-lg-5 {\n    margin-left: 41.6666666667%;\n  }\n  .offset-lg-6 {\n    margin-left: 50%;\n  }\n  .offset-lg-7 {\n    margin-left: 58.3333333333%;\n  }\n  .offset-lg-8 {\n    margin-left: 66.6666666667%;\n  }\n  .offset-lg-9 {\n    margin-left: 75%;\n  }\n  .offset-lg-10 {\n    margin-left: 83.3333333333%;\n  }\n  .offset-lg-11 {\n    margin-left: 91.6666666667%;\n  }\n}\n@media (min-width: 1200px) {\n  .col-xl {\n    flex-basis: 0;\n    flex-grow: 1;\n    max-width: 100%;\n  }\n  .row-cols-xl-1 > * {\n    flex: 0 0 100%;\n    max-width: 100%;\n  }\n  .row-cols-xl-2 > * {\n    flex: 0 0 50%;\n    max-width: 50%;\n  }\n  .row-cols-xl-3 > * {\n    flex: 0 0 33.3333333333%;\n    max-width: 33.3333333333%;\n  }\n  .row-cols-xl-4 > * {\n    flex: 0 0 25%;\n    max-width: 25%;\n  }\n  .row-cols-xl-5 > * {\n    flex: 0 0 20%;\n    max-width: 20%;\n  }\n  .row-cols-xl-6 > * {\n    flex: 0 0 16.6666666667%;\n    max-width: 16.6666666667%;\n  }\n  .col-xl-auto {\n    flex: 0 0 auto;\n    width: auto;\n    max-width: 100%;\n  }\n  .col-xl-1 {\n    flex: 0 0 8.3333333333%;\n    max-width: 8.3333333333%;\n  }\n  .col-xl-2 {\n    flex: 0 0 16.6666666667%;\n    max-width: 16.6666666667%;\n  }\n  .col-xl-3 {\n    flex: 0 0 25%;\n    max-width: 25%;\n  }\n  .col-xl-4 {\n    flex: 0 0 33.3333333333%;\n    max-width: 33.3333333333%;\n  }\n  .col-xl-5 {\n    flex: 0 0 41.6666666667%;\n    max-width: 41.6666666667%;\n  }\n  .col-xl-6 {\n    flex: 0 0 50%;\n    max-width: 50%;\n  }\n  .col-xl-7 {\n    flex: 0 0 58.3333333333%;\n    max-width: 58.3333333333%;\n  }\n  .col-xl-8 {\n    flex: 0 0 66.6666666667%;\n    max-width: 66.6666666667%;\n  }\n  .col-xl-9 {\n    flex: 0 0 75%;\n    max-width: 75%;\n  }\n  .col-xl-10 {\n    flex: 0 0 83.3333333333%;\n    max-width: 83.3333333333%;\n  }\n  .col-xl-11 {\n    flex: 0 0 91.6666666667%;\n    max-width: 91.6666666667%;\n  }\n  .col-xl-12 {\n    flex: 0 0 100%;\n    max-width: 100%;\n  }\n  .order-xl-first {\n    order: -1;\n  }\n  .order-xl-last {\n    order: 13;\n  }\n  .order-xl-0 {\n    order: 0;\n  }\n  .order-xl-1 {\n    order: 1;\n  }\n  .order-xl-2 {\n    order: 2;\n  }\n  .order-xl-3 {\n    order: 3;\n  }\n  .order-xl-4 {\n    order: 4;\n  }\n  .order-xl-5 {\n    order: 5;\n  }\n  .order-xl-6 {\n    order: 6;\n  }\n  .order-xl-7 {\n    order: 7;\n  }\n  .order-xl-8 {\n    order: 8;\n  }\n  .order-xl-9 {\n    order: 9;\n  }\n  .order-xl-10 {\n    order: 10;\n  }\n  .order-xl-11 {\n    order: 11;\n  }\n  .order-xl-12 {\n    order: 12;\n  }\n  .offset-xl-0 {\n    margin-left: 0;\n  }\n  .offset-xl-1 {\n    margin-left: 8.3333333333%;\n  }\n  .offset-xl-2 {\n    margin-left: 16.6666666667%;\n  }\n  .offset-xl-3 {\n    margin-left: 25%;\n  }\n  .offset-xl-4 {\n    margin-left: 33.3333333333%;\n  }\n  .offset-xl-5 {\n    margin-left: 41.6666666667%;\n  }\n  .offset-xl-6 {\n    margin-left: 50%;\n  }\n  .offset-xl-7 {\n    margin-left: 58.3333333333%;\n  }\n  .offset-xl-8 {\n    margin-left: 66.6666666667%;\n  }\n  .offset-xl-9 {\n    margin-left: 75%;\n  }\n  .offset-xl-10 {\n    margin-left: 83.3333333333%;\n  }\n  .offset-xl-11 {\n    margin-left: 91.6666666667%;\n  }\n}\n.table {\n  width: 100%;\n  margin-bottom: 1rem;\n  color: #525f7f;\n  background-color: transparent;\n}\n.table th,\n.table td {\n  padding: 1rem;\n  vertical-align: top;\n  border-top: 1px solid #e9ecef;\n}\n.table thead th {\n  vertical-align: bottom;\n  border-bottom: 2px solid #e9ecef;\n}\n.table tbody + tbody {\n  border-top: 2px solid #e9ecef;\n}\n\n.table-sm th,\n.table-sm td {\n  padding: 0.5rem;\n}\n\n.table-bordered {\n  border: 1px solid #e9ecef;\n}\n.table-bordered th,\n.table-bordered td {\n  border: 1px solid #e9ecef;\n}\n.table-bordered thead th,\n.table-bordered thead td {\n  border-bottom-width: 2px;\n}\n\n.table-borderless th,\n.table-borderless td,\n.table-borderless thead th,\n.table-borderless tbody + tbody {\n  border: 0;\n}\n\n.table-striped tbody tr:nth-of-type(odd) {\n  background-color: rgba(0, 0, 0, 0.05);\n}\n\n.table-hover tbody tr:hover {\n  color: #525f7f;\n  background-color: #f6f9fc;\n}\n\n.table-primary,\n.table-primary > th,\n.table-primary > td {\n  background-color: rgb(200.12, 229.24, 215.24);\n}\n.table-primary th,\n.table-primary td,\n.table-primary thead th,\n.table-primary tbody + tbody {\n  border-color: rgb(153.08, 207.16, 181.16);\n}\n\n.table-hover .table-primary:hover {\n  background-color: rgb(182.7658333333, 221.0941666667, 202.6670833333);\n}\n.table-hover .table-primary:hover > td,\n.table-hover .table-primary:hover > th {\n  background-color: rgb(182.7658333333, 221.0941666667, 202.6670833333);\n}\n\n.table-secondary,\n.table-secondary > th,\n.table-secondary > td {\n  background-color: rgb(252.76, 253.6, 254.16);\n}\n.table-secondary th,\n.table-secondary td,\n.table-secondary thead th,\n.table-secondary tbody + tbody {\n  border-color: rgb(250.84, 252.4, 253.44);\n}\n\n.table-hover .table-secondary:hover {\n  background-color: rgb(234.2145454545, 242.0090909091, 247.2054545455);\n}\n.table-hover .table-secondary:hover > td,\n.table-hover .table-secondary:hover > th {\n  background-color: rgb(234.2145454545, 242.0090909091, 247.2054545455);\n}\n\n.table-success,\n.table-success > th,\n.table-success > td {\n  background-color: rgb(199.84, 228.68, 214.96);\n}\n.table-success th,\n.table-success td,\n.table-success thead th,\n.table-success tbody + tbody {\n  border-color: rgb(152.56, 206.12, 180.64);\n}\n\n.table-hover .table-success:hover {\n  background-color: rgb(182.5771134021, 220.4428865979, 202.4290721649);\n}\n.table-hover .table-success:hover > td,\n.table-hover .table-success:hover > th {\n  background-color: rgb(182.5771134021, 220.4428865979, 202.4290721649);\n}\n\n.table-info,\n.table-info > th,\n.table-info > td {\n  background-color: rgb(194.52, 223.36, 213);\n}\n.table-info th,\n.table-info td,\n.table-info thead th,\n.table-info tbody + tbody {\n  border-color: rgb(142.68, 196.24, 177);\n}\n\n.table-hover .table-info:hover {\n  background-color: rgb(177.7783586626, 214.6016413374, 201.3738601824);\n}\n.table-hover .table-info:hover > td,\n.table-hover .table-info:hover > th {\n  background-color: rgb(177.7783586626, 214.6016413374, 201.3738601824);\n}\n\n.table-warning,\n.table-warning > th,\n.table-warning > td {\n  background-color: rgb(253.88, 211.32, 201.52);\n}\n.table-warning th,\n.table-warning td,\n.table-warning thead th,\n.table-warning tbody + tbody {\n  border-color: rgb(252.92, 173.88, 155.68);\n}\n\n.table-hover .table-warning:hover {\n  background-color: rgb(253.3569230769, 190.92, 176.5430769231);\n}\n.table-hover .table-warning:hover > td,\n.table-hover .table-warning:hover > th {\n  background-color: rgb(253.3569230769, 190.92, 176.5430769231);\n}\n\n.table-danger,\n.table-danger > th,\n.table-danger > td {\n  background-color: rgb(252.2, 198.72, 209.36);\n}\n.table-danger th,\n.table-danger td,\n.table-danger thead th,\n.table-danger tbody + tbody {\n  border-color: rgb(249.8, 150.48, 170.24);\n}\n\n.table-hover .table-danger:hover {\n  background-color: rgb(250.9914691943, 174.4285308057, 189.6609478673);\n}\n.table-hover .table-danger:hover > td,\n.table-hover .table-danger:hover > th {\n  background-color: rgb(250.9914691943, 174.4285308057, 189.6609478673);\n}\n\n.table-light,\n.table-light > th,\n.table-light > td {\n  background-color: rgb(232.04, 234.28, 236.52);\n}\n.table-light th,\n.table-light td,\n.table-light thead th,\n.table-light tbody + tbody {\n  border-color: rgb(212.36, 216.52, 220.68);\n}\n\n.table-hover .table-light:hover {\n  background-color: rgb(217.9116216216, 221.53, 225.1483783784);\n}\n.table-hover .table-light:hover > td,\n.table-hover .table-light:hover > th {\n  background-color: rgb(217.9116216216, 221.53, 225.1483783784);\n}\n\n.table-dark,\n.table-dark > th,\n.table-dark > td {\n  background-color: rgb(192.84, 193.96, 195.08);\n}\n.table-dark th,\n.table-dark td,\n.table-dark thead th,\n.table-dark tbody + tbody {\n  border-color: rgb(139.56, 141.64, 143.72);\n}\n\n.table-hover .table-dark:hover {\n  background-color: rgb(179.8560550459, 181.21, 182.5639449541);\n}\n.table-hover .table-dark:hover > td,\n.table-hover .table-dark:hover > th {\n  background-color: rgb(179.8560550459, 181.21, 182.5639449541);\n}\n\n.table-default,\n.table-default > th,\n.table-default > td {\n  background-color: rgb(255, 244.08, 222.8);\n}\n.table-default th,\n.table-default td,\n.table-default thead th,\n.table-default tbody + tbody {\n  border-color: rgb(255, 234.72, 195.2);\n}\n\n.table-hover .table-default:hover {\n  background-color: rgb(255, 235.432173913, 197.3);\n}\n.table-hover .table-default:hover > td,\n.table-hover .table-default:hover > th {\n  background-color: rgb(255, 235.432173913, 197.3);\n}\n\n.table-white,\n.table-white > th,\n.table-white > td {\n  background-color: white;\n}\n.table-white th,\n.table-white td,\n.table-white thead th,\n.table-white tbody + tbody {\n  border-color: white;\n}\n\n.table-hover .table-white:hover {\n  background-color: rgb(242.25, 242.25, 242.25);\n}\n.table-hover .table-white:hover > td,\n.table-hover .table-white:hover > th {\n  background-color: rgb(242.25, 242.25, 242.25);\n}\n\n.table-neutral,\n.table-neutral > th,\n.table-neutral > td {\n  background-color: white;\n}\n.table-neutral th,\n.table-neutral td,\n.table-neutral thead th,\n.table-neutral tbody + tbody {\n  border-color: white;\n}\n\n.table-hover .table-neutral:hover {\n  background-color: rgb(242.25, 242.25, 242.25);\n}\n.table-hover .table-neutral:hover > td,\n.table-hover .table-neutral:hover > th {\n  background-color: rgb(242.25, 242.25, 242.25);\n}\n\n.table-darker,\n.table-darker > th,\n.table-darker > td {\n  background-color: rgb(183.6, 183.6, 183.6);\n}\n.table-darker th,\n.table-darker td,\n.table-darker thead th,\n.table-darker tbody + tbody {\n  border-color: rgb(122.4, 122.4, 122.4);\n}\n\n.table-hover .table-darker:hover {\n  background-color: rgb(170.85, 170.85, 170.85);\n}\n.table-hover .table-darker:hover > td,\n.table-hover .table-darker:hover > th {\n  background-color: rgb(170.85, 170.85, 170.85);\n}\n\n.table-active,\n.table-active > th,\n.table-active > td {\n  background-color: #f6f9fc;\n}\n\n.table-hover .table-active:hover {\n  background-color: rgb(226.875, 236.25, 245.625);\n}\n.table-hover .table-active:hover > td,\n.table-hover .table-active:hover > th {\n  background-color: rgb(226.875, 236.25, 245.625);\n}\n\n.table .thead-dark th {\n  color: #f8f9fe;\n  background-color: #ffd88c;\n  border-color: rgb(255, 228.1069565217, 175.7);\n}\n.table .thead-light th {\n  color: #8898aa;\n  background-color: #f6f9fc;\n  border-color: #e9ecef;\n}\n\n.table-dark {\n  color: #f8f9fe;\n  background-color: #ffd88c;\n}\n.table-dark th,\n.table-dark td,\n.table-dark thead th {\n  border-color: rgb(255, 228.1069565217, 175.7);\n}\n.table-dark.table-bordered {\n  border: 0;\n}\n.table-dark.table-striped tbody tr:nth-of-type(odd) {\n  background-color: rgba(255, 255, 255, 0.05);\n}\n.table-dark.table-hover tbody tr:hover {\n  color: #f8f9fe;\n  background-color: rgba(255, 255, 255, 0.075);\n}\n\n@media (max-width: 575.98px) {\n  .table-responsive-sm {\n    display: block;\n    width: 100%;\n    overflow-x: auto;\n    -webkit-overflow-scrolling: touch;\n  }\n  .table-responsive-sm > .table-bordered {\n    border: 0;\n  }\n}\n@media (max-width: 767.98px) {\n  .table-responsive-md {\n    display: block;\n    width: 100%;\n    overflow-x: auto;\n    -webkit-overflow-scrolling: touch;\n  }\n  .table-responsive-md > .table-bordered {\n    border: 0;\n  }\n}\n@media (max-width: 991.98px) {\n  .table-responsive-lg {\n    display: block;\n    width: 100%;\n    overflow-x: auto;\n    -webkit-overflow-scrolling: touch;\n  }\n  .table-responsive-lg > .table-bordered {\n    border: 0;\n  }\n}\n@media (max-width: 1199.98px) {\n  .table-responsive-xl {\n    display: block;\n    width: 100%;\n    overflow-x: auto;\n    -webkit-overflow-scrolling: touch;\n  }\n  .table-responsive-xl > .table-bordered {\n    border: 0;\n  }\n}\n.table-responsive {\n  display: block;\n  width: 100%;\n  overflow-x: auto;\n  -webkit-overflow-scrolling: touch;\n}\n.table-responsive > .table-bordered {\n  border: 0;\n}\n\n.form-control {\n  display: block;\n  width: 100%;\n  height: calc(1.5em + 1.25rem + 2px);\n  padding: 0.625rem 0.75rem;\n  font-size: 0.875rem;\n  font-weight: 400;\n  line-height: 1.5;\n  color: #8898aa;\n  background-color: #fff;\n  background-clip: padding-box;\n  border: 1px solid #cad1d7;\n  border-radius: 0.375rem;\n  box-shadow: none;\n  transition: all 0.2s cubic-bezier(0.68, -0.55, 0.265, 1.55);\n}\n@media (prefers-reduced-motion: reduce) {\n  .form-control {\n    transition: none;\n  }\n}\n.form-control::-ms-expand {\n  background-color: transparent;\n  border: 0;\n}\n.form-control:-moz-focusring {\n  color: transparent;\n  text-shadow: 0 0 0 #8898aa;\n}\n.form-control:focus {\n  color: #8898aa;\n  background-color: #fff;\n  border-color: rgba(50, 151, 211, 0.25);\n  outline: 0;\n  box-shadow: none, none;\n}\n.form-control::placeholder {\n  color: #adb5bd;\n  opacity: 1;\n}\n.form-control:disabled, .form-control[readonly] {\n  background-color: #e9ecef;\n  opacity: 1;\n}\n\ninput[type=date].form-control,\ninput[type=time].form-control,\ninput[type=datetime-local].form-control,\ninput[type=month].form-control {\n  appearance: none;\n}\n\nselect.form-control:focus::-ms-value {\n  color: #8898aa;\n  background-color: #fff;\n}\n\n.form-control-file,\n.form-control-range {\n  display: block;\n  width: 100%;\n}\n\n.col-form-label {\n  padding-top: calc(0.625rem + 1px);\n  padding-bottom: calc(0.625rem + 1px);\n  margin-bottom: 0;\n  font-size: inherit;\n  line-height: 1.5;\n}\n\n.col-form-label-lg {\n  padding-top: calc(0.875rem + 1px);\n  padding-bottom: calc(0.875rem + 1px);\n  font-size: 0.875rem;\n  line-height: 1.5;\n}\n\n.col-form-label-sm {\n  padding-top: calc(0.25rem + 1px);\n  padding-bottom: calc(0.25rem + 1px);\n  font-size: 0.75rem;\n  line-height: 1.5;\n}\n\n.form-control-plaintext {\n  display: block;\n  width: 100%;\n  padding: 0.625rem 0;\n  margin-bottom: 0;\n  font-size: 0.875rem;\n  line-height: 1.5;\n  color: #525f7f;\n  background-color: transparent;\n  border: solid transparent;\n  border-width: 1px 0;\n}\n.form-control-plaintext.form-control-sm, .form-control-plaintext.form-control-lg {\n  padding-right: 0;\n  padding-left: 0;\n}\n\n.form-control-sm {\n  height: calc(1.5em + 0.5rem + 2px);\n  padding: 0.25rem 0.5rem;\n  font-size: 0.75rem;\n  line-height: 1.5;\n  border-radius: 0.25rem;\n}\n\n.form-control-lg {\n  height: calc(1.5em + 1.75rem + 2px);\n  padding: 0.875rem 1rem;\n  font-size: 0.875rem;\n  line-height: 1.5;\n  border-radius: 0.4375rem;\n}\n\nselect.form-control[size], select.form-control[multiple] {\n  height: auto;\n}\n\ntextarea.form-control {\n  height: auto;\n}\n\n.form-group {\n  margin-bottom: 1.5rem;\n}\n\n.form-text {\n  display: block;\n  margin-top: 0.25rem;\n}\n\n.form-row {\n  display: flex;\n  flex-wrap: wrap;\n  margin-right: -5px;\n  margin-left: -5px;\n}\n.form-row > .col,\n.form-row > [class*=col-] {\n  padding-right: 5px;\n  padding-left: 5px;\n}\n\n.form-check {\n  position: relative;\n  display: block;\n  padding-left: 1.25rem;\n}\n\n.form-check-input {\n  position: absolute;\n  margin-top: 0.3rem;\n  margin-left: -1.25rem;\n}\n.form-check-input[disabled] ~ .form-check-label, .form-check-input:disabled ~ .form-check-label {\n  color: #8898aa;\n}\n\n.form-check-label {\n  margin-bottom: 0;\n}\n\n.form-check-inline {\n  display: inline-flex;\n  align-items: center;\n  padding-left: 0;\n  margin-right: 0.75rem;\n}\n.form-check-inline .form-check-input {\n  position: static;\n  margin-top: 0;\n  margin-right: 0.3125rem;\n  margin-left: 0;\n}\n\n.valid-feedback {\n  display: none;\n  width: 100%;\n  margin-top: 0.25rem;\n  font-size: 80%;\n  color: #3aa170;\n}\n\n.valid-tooltip {\n  position: absolute;\n  top: 100%;\n  z-index: 5;\n  display: none;\n  max-width: 100%;\n  padding: 0.5rem;\n  margin-top: 0.1rem;\n  font-size: 0.875rem;\n  line-height: 1;\n  color: #fff;\n  background-color: rgba(58, 161, 112, 0.8);\n  border-radius: 0.2rem;\n}\n\n.was-validated .form-control:valid, .form-control.is-valid,\n.was-validated .custom-select:valid,\n.custom-select.is-valid {\n  border-color: #3aa170;\n}\n.was-validated .form-control:valid:focus, .form-control.is-valid:focus,\n.was-validated .custom-select:valid:focus,\n.custom-select.is-valid:focus {\n  border-color: #3aa170;\n}\n.was-validated .form-control:valid ~ .valid-feedback,\n.was-validated .form-control:valid ~ .valid-tooltip, .form-control.is-valid ~ .valid-feedback,\n.form-control.is-valid ~ .valid-tooltip,\n.was-validated .custom-select:valid ~ .valid-feedback,\n.was-validated .custom-select:valid ~ .valid-tooltip,\n.custom-select.is-valid ~ .valid-feedback,\n.custom-select.is-valid ~ .valid-tooltip {\n  display: block;\n}\n\n.was-validated .form-check-input:valid ~ .form-check-label, .form-check-input.is-valid ~ .form-check-label {\n  color: #3aa170;\n}\n.was-validated .form-check-input:valid ~ .valid-feedback,\n.was-validated .form-check-input:valid ~ .valid-tooltip, .form-check-input.is-valid ~ .valid-feedback,\n.form-check-input.is-valid ~ .valid-tooltip {\n  display: block;\n}\n\n.was-validated .custom-control-input:valid ~ .custom-control-label, .custom-control-input.is-valid ~ .custom-control-label {\n  color: #3aa170;\n}\n.was-validated .custom-control-input:valid ~ .custom-control-label::before, .custom-control-input.is-valid ~ .custom-control-label::before {\n  background-color: rgb(134.801369863, 211.698630137, 175.1164383562);\n  border-color: rgb(134.801369863, 211.698630137, 175.1164383562);\n}\n.was-validated .custom-control-input:valid ~ .valid-feedback,\n.was-validated .custom-control-input:valid ~ .valid-tooltip, .custom-control-input.is-valid ~ .valid-feedback,\n.custom-control-input.is-valid ~ .valid-tooltip {\n  display: block;\n}\n.was-validated .custom-control-input:valid:checked ~ .custom-control-label::before, .custom-control-input.is-valid:checked ~ .custom-control-label::before {\n  background-color: rgb(78.5616438356, 191.4383561644, 137.7397260274);\n  border-color: rgb(134.801369863, 211.698630137, 175.1164383562);\n}\n.was-validated .custom-control-input:valid:focus ~ .custom-control-label::before, .custom-control-input.is-valid:focus ~ .custom-control-label::before {\n  box-shadow: 0 0 0 1px #f8f9fe, 0 0 0 0 rgba(58, 161, 112, 0.25);\n}\n\n.was-validated .custom-file-input:valid ~ .custom-file-label, .custom-file-input.is-valid ~ .custom-file-label {\n  border-color: #3aa170;\n}\n.was-validated .custom-file-input:valid ~ .custom-file-label::before, .custom-file-input.is-valid ~ .custom-file-label::before {\n  border-color: inherit;\n}\n.was-validated .custom-file-input:valid ~ .valid-feedback,\n.was-validated .custom-file-input:valid ~ .valid-tooltip, .custom-file-input.is-valid ~ .valid-feedback,\n.custom-file-input.is-valid ~ .valid-tooltip {\n  display: block;\n}\n.was-validated .custom-file-input:valid:focus ~ .custom-file-label, .custom-file-input.is-valid:focus ~ .custom-file-label {\n  box-shadow: 0 0 0 0 rgba(58, 161, 112, 0.25);\n}\n\n.invalid-feedback {\n  display: none;\n  width: 100%;\n  margin-top: 0.25rem;\n  font-size: 80%;\n  color: #fb6340;\n}\n\n.invalid-tooltip {\n  position: absolute;\n  top: 100%;\n  z-index: 5;\n  display: none;\n  max-width: 100%;\n  padding: 0.5rem;\n  margin-top: 0.1rem;\n  font-size: 0.875rem;\n  line-height: 1;\n  color: #fff;\n  background-color: rgba(251, 99, 64, 0.8);\n  border-radius: 0.2rem;\n}\n\n.was-validated .form-control:invalid, .form-control.is-invalid,\n.was-validated .custom-select:invalid,\n.custom-select.is-invalid {\n  border-color: #fb6340;\n}\n.was-validated .form-control:invalid:focus, .form-control.is-invalid:focus,\n.was-validated .custom-select:invalid:focus,\n.custom-select.is-invalid:focus {\n  border-color: #fb6340;\n}\n.was-validated .form-control:invalid ~ .invalid-feedback,\n.was-validated .form-control:invalid ~ .invalid-tooltip, .form-control.is-invalid ~ .invalid-feedback,\n.form-control.is-invalid ~ .invalid-tooltip,\n.was-validated .custom-select:invalid ~ .invalid-feedback,\n.was-validated .custom-select:invalid ~ .invalid-tooltip,\n.custom-select.is-invalid ~ .invalid-feedback,\n.custom-select.is-invalid ~ .invalid-tooltip {\n  display: block;\n}\n\n.was-validated .form-check-input:invalid ~ .form-check-label, .form-check-input.is-invalid ~ .form-check-label {\n  color: #fb6340;\n}\n.was-validated .form-check-input:invalid ~ .invalid-feedback,\n.was-validated .form-check-input:invalid ~ .invalid-tooltip, .form-check-input.is-invalid ~ .invalid-feedback,\n.form-check-input.is-invalid ~ .invalid-tooltip {\n  display: block;\n}\n\n.was-validated .custom-control-input:invalid ~ .custom-control-label, .custom-control-input.is-invalid ~ .custom-control-label {\n  color: #fb6340;\n}\n.was-validated .custom-control-input:invalid ~ .custom-control-label::before, .custom-control-input.is-invalid ~ .custom-control-label::before {\n  background-color: rgb(253.6153846154, 201, 188.8846153846);\n  border-color: rgb(253.6153846154, 201, 188.8846153846);\n}\n.was-validated .custom-control-input:invalid ~ .invalid-feedback,\n.was-validated .custom-control-input:invalid ~ .invalid-tooltip, .custom-control-input.is-invalid ~ .invalid-feedback,\n.custom-control-input.is-invalid ~ .invalid-tooltip {\n  display: block;\n}\n.was-validated .custom-control-input:invalid:checked ~ .custom-control-label::before, .custom-control-input.is-invalid:checked ~ .custom-control-label::before {\n  background-color: rgb(252.0461538462, 139.8, 113.9538461538);\n  border-color: rgb(253.6153846154, 201, 188.8846153846);\n}\n.was-validated .custom-control-input:invalid:focus ~ .custom-control-label::before, .custom-control-input.is-invalid:focus ~ .custom-control-label::before {\n  box-shadow: 0 0 0 1px #f8f9fe, 0 0 0 0 rgba(251, 99, 64, 0.25);\n}\n\n.was-validated .custom-file-input:invalid ~ .custom-file-label, .custom-file-input.is-invalid ~ .custom-file-label {\n  border-color: #fb6340;\n}\n.was-validated .custom-file-input:invalid ~ .custom-file-label::before, .custom-file-input.is-invalid ~ .custom-file-label::before {\n  border-color: inherit;\n}\n.was-validated .custom-file-input:invalid ~ .invalid-feedback,\n.was-validated .custom-file-input:invalid ~ .invalid-tooltip, .custom-file-input.is-invalid ~ .invalid-feedback,\n.custom-file-input.is-invalid ~ .invalid-tooltip {\n  display: block;\n}\n.was-validated .custom-file-input:invalid:focus ~ .custom-file-label, .custom-file-input.is-invalid:focus ~ .custom-file-label {\n  box-shadow: 0 0 0 0 rgba(251, 99, 64, 0.25);\n}\n\n.form-inline {\n  display: flex;\n  flex-flow: row wrap;\n  align-items: center;\n}\n.form-inline .form-check {\n  width: 100%;\n}\n@media (min-width: 576px) {\n  .form-inline label {\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    margin-bottom: 0;\n  }\n  .form-inline .form-group {\n    display: flex;\n    flex: 0 0 auto;\n    flex-flow: row wrap;\n    align-items: center;\n    margin-bottom: 0;\n  }\n  .form-inline .form-control {\n    display: inline-block;\n    width: auto;\n    vertical-align: middle;\n  }\n  .form-inline .form-control-plaintext {\n    display: inline-block;\n  }\n  .form-inline .input-group,\n  .form-inline .custom-select {\n    width: auto;\n  }\n  .form-inline .form-check {\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    width: auto;\n    padding-left: 0;\n  }\n  .form-inline .form-check-input {\n    position: relative;\n    flex-shrink: 0;\n    margin-top: 0;\n    margin-right: 0.25rem;\n    margin-left: 0;\n  }\n  .form-inline .custom-control {\n    align-items: center;\n    justify-content: center;\n  }\n  .form-inline .custom-control-label {\n    margin-bottom: 0;\n  }\n}\n\n.btn {\n  display: inline-block;\n  font-weight: 600;\n  color: #525f7f;\n  text-align: center;\n  vertical-align: middle;\n  user-select: none;\n  background-color: transparent;\n  border: 1px solid transparent;\n  padding: 0.625rem 1.25rem;\n  font-size: 0.875rem;\n  line-height: 1.5;\n  border-radius: 0.375rem;\n  transition: color 0.15s ease-in-out, background-color 0.15s ease-in-out, border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;\n}\n@media (prefers-reduced-motion: reduce) {\n  .btn {\n    transition: none;\n  }\n}\n.btn:hover {\n  color: #525f7f;\n  text-decoration: none;\n}\n.btn:focus, .btn.focus {\n  outline: 0;\n  box-shadow: 0 7px 14px rgba(50, 50, 93, 0.1), 0 3px 6px rgba(0, 0, 0, 0.08);\n}\n.btn.disabled, .btn:disabled {\n  opacity: 0.65;\n  box-shadow: none;\n}\n.btn:not(:disabled):not(.disabled) {\n  cursor: pointer;\n}\n.btn:not(:disabled):not(.disabled):active, .btn:not(:disabled):not(.disabled).active {\n  box-shadow: none;\n}\n.btn:not(:disabled):not(.disabled):active:focus, .btn:not(:disabled):not(.disabled).active:focus {\n  box-shadow: 0 7px 14px rgba(50, 50, 93, 0.1), 0 3px 6px rgba(0, 0, 0, 0.08);\n}\n\na.btn.disabled,\nfieldset:disabled a.btn {\n  pointer-events: none;\n}\n\n.btn-primary {\n  color: #fff;\n  background-color: #3ba371;\n  border-color: #3ba371;\n  box-shadow: 0 4px 6px rgba(50, 50, 93, 0.11), 0 1px 3px rgba(0, 0, 0, 0.08);\n}\n.btn-primary:hover {\n  color: #fff;\n  background-color: #3ba371;\n  border-color: #3ba371;\n}\n.btn-primary:focus, .btn-primary.focus {\n  box-shadow: 0 4px 6px rgba(50, 50, 93, 0.11), 0 1px 3px rgba(0, 0, 0, 0.08), 0 0 0 0 rgba(59, 163, 113, 0.5);\n}\n.btn-primary.disabled, .btn-primary:disabled {\n  color: #fff;\n  background-color: #3ba371;\n  border-color: #3ba371;\n}\n.btn-primary:not(:disabled):not(.disabled):active, .btn-primary:not(:disabled):not(.disabled).active, .show > .btn-primary.dropdown-toggle {\n  color: #fff;\n  background-color: rgb(45.4459459459, 125.5540540541, 87.0405405405);\n  border-color: #3ba371;\n}\n.btn-primary:not(:disabled):not(.disabled):active:focus, .btn-primary:not(:disabled):not(.disabled).active:focus, .show > .btn-primary.dropdown-toggle:focus {\n  box-shadow: none, 0 0 0 0 rgba(59, 163, 113, 0.5);\n}\n\n.btn-secondary {\n  color: #212529;\n  background-color: #f7fafc;\n  border-color: #f7fafc;\n  box-shadow: 0 4px 6px rgba(50, 50, 93, 0.11), 0 1px 3px rgba(0, 0, 0, 0.08);\n}\n.btn-secondary:hover {\n  color: #212529;\n  background-color: #f7fafc;\n  border-color: #f7fafc;\n}\n.btn-secondary:focus, .btn-secondary.focus {\n  box-shadow: 0 4px 6px rgba(50, 50, 93, 0.11), 0 1px 3px rgba(0, 0, 0, 0.08), 0 0 0 0 rgba(247, 250, 252, 0.5);\n}\n.btn-secondary.disabled, .btn-secondary:disabled {\n  color: #212529;\n  background-color: #f7fafc;\n  border-color: #f7fafc;\n}\n.btn-secondary:not(:disabled):not(.disabled):active, .btn-secondary:not(:disabled):not(.disabled).active, .show > .btn-secondary.dropdown-toggle {\n  color: #212529;\n  background-color: rgb(209.9090909091, 226.8181818182, 238.0909090909);\n  border-color: #f7fafc;\n}\n.btn-secondary:not(:disabled):not(.disabled):active:focus, .btn-secondary:not(:disabled):not(.disabled).active:focus, .show > .btn-secondary.dropdown-toggle:focus {\n  box-shadow: none, 0 0 0 0 rgba(247, 250, 252, 0.5);\n}\n\n.btn-success {\n  color: #fff;\n  background-color: #3aa170;\n  border-color: #3aa170;\n  box-shadow: 0 4px 6px rgba(50, 50, 93, 0.11), 0 1px 3px rgba(0, 0, 0, 0.08);\n}\n.btn-success:hover {\n  color: #fff;\n  background-color: #3aa170;\n  border-color: #3aa170;\n}\n.btn-success:focus, .btn-success.focus {\n  box-shadow: 0 4px 6px rgba(50, 50, 93, 0.11), 0 1px 3px rgba(0, 0, 0, 0.08), 0 0 0 0 rgba(58, 161, 112, 0.5);\n}\n.btn-success.disabled, .btn-success:disabled {\n  color: #fff;\n  background-color: #3aa170;\n  border-color: #3aa170;\n}\n.btn-success:not(:disabled):not(.disabled):active, .btn-success:not(:disabled):not(.disabled).active, .show > .btn-success.dropdown-toggle {\n  color: #fff;\n  background-color: rgb(44.4931506849, 123.5068493151, 85.9178082192);\n  border-color: #3aa170;\n}\n.btn-success:not(:disabled):not(.disabled):active:focus, .btn-success:not(:disabled):not(.disabled).active:focus, .show > .btn-success.dropdown-toggle:focus {\n  box-shadow: none, 0 0 0 0 rgba(58, 161, 112, 0.5);\n}\n\n.btn-info {\n  color: #fff;\n  background-color: #278e69;\n  border-color: #278e69;\n  box-shadow: 0 4px 6px rgba(50, 50, 93, 0.11), 0 1px 3px rgba(0, 0, 0, 0.08);\n}\n.btn-info:hover {\n  color: #fff;\n  background-color: #278e69;\n  border-color: #278e69;\n}\n.btn-info:focus, .btn-info.focus {\n  box-shadow: 0 4px 6px rgba(50, 50, 93, 0.11), 0 1px 3px rgba(0, 0, 0, 0.08), 0 0 0 0 rgba(39, 142, 105, 0.5);\n}\n.btn-info.disabled, .btn-info:disabled {\n  color: #fff;\n  background-color: #278e69;\n  border-color: #278e69;\n}\n.btn-info:not(:disabled):not(.disabled):active, .btn-info:not(:disabled):not(.disabled).active, .show > .btn-info.dropdown-toggle {\n  color: #fff;\n  background-color: rgb(28.0110497238, 101.9889502762, 75.4143646409);\n  border-color: #278e69;\n}\n.btn-info:not(:disabled):not(.disabled):active:focus, .btn-info:not(:disabled):not(.disabled).active:focus, .show > .btn-info.dropdown-toggle:focus {\n  box-shadow: none, 0 0 0 0 rgba(39, 142, 105, 0.5);\n}\n\n.btn-warning {\n  color: #fff;\n  background-color: #fb6340;\n  border-color: #fb6340;\n  box-shadow: 0 4px 6px rgba(50, 50, 93, 0.11), 0 1px 3px rgba(0, 0, 0, 0.08);\n}\n.btn-warning:hover {\n  color: #fff;\n  background-color: #fb6340;\n  border-color: #fb6340;\n}\n.btn-warning:focus, .btn-warning.focus {\n  box-shadow: 0 4px 6px rgba(50, 50, 93, 0.11), 0 1px 3px rgba(0, 0, 0, 0.08), 0 0 0 0 rgba(251, 99, 64, 0.5);\n}\n.btn-warning.disabled, .btn-warning:disabled {\n  color: #fff;\n  background-color: #fb6340;\n  border-color: #fb6340;\n}\n.btn-warning:not(:disabled):not(.disabled):active, .btn-warning:not(:disabled):not(.disabled).active, .show > .btn-warning.dropdown-toggle {\n  color: #fff;\n  background-color: rgb(249.9538461538, 58.2, 14.0461538462);\n  border-color: #fb6340;\n}\n.btn-warning:not(:disabled):not(.disabled):active:focus, .btn-warning:not(:disabled):not(.disabled).active:focus, .show > .btn-warning.dropdown-toggle:focus {\n  box-shadow: none, 0 0 0 0 rgba(251, 99, 64, 0.5);\n}\n\n.btn-danger {\n  color: #fff;\n  background-color: #f5365c;\n  border-color: #f5365c;\n  box-shadow: 0 4px 6px rgba(50, 50, 93, 0.11), 0 1px 3px rgba(0, 0, 0, 0.08);\n}\n.btn-danger:hover {\n  color: #fff;\n  background-color: #f5365c;\n  border-color: #f5365c;\n}\n.btn-danger:focus, .btn-danger.focus {\n  box-shadow: 0 4px 6px rgba(50, 50, 93, 0.11), 0 1px 3px rgba(0, 0, 0, 0.08), 0 0 0 0 rgba(245, 54, 92, 0.5);\n}\n.btn-danger.disabled, .btn-danger:disabled {\n  color: #fff;\n  background-color: #f5365c;\n  border-color: #f5365c;\n}\n.btn-danger:not(:disabled):not(.disabled):active, .btn-danger:not(:disabled):not(.disabled).active, .show > .btn-danger.dropdown-toggle {\n  color: #fff;\n  background-color: rgb(236.2464454976, 11.7535545024, 56.4170616114);\n  border-color: #f5365c;\n}\n.btn-danger:not(:disabled):not(.disabled):active:focus, .btn-danger:not(:disabled):not(.disabled).active:focus, .show > .btn-danger.dropdown-toggle:focus {\n  box-shadow: none, 0 0 0 0 rgba(245, 54, 92, 0.5);\n}\n\n.btn-light {\n  color: #fff;\n  background-color: #adb5bd;\n  border-color: #adb5bd;\n  box-shadow: 0 4px 6px rgba(50, 50, 93, 0.11), 0 1px 3px rgba(0, 0, 0, 0.08);\n}\n.btn-light:hover {\n  color: #fff;\n  background-color: #adb5bd;\n  border-color: #adb5bd;\n}\n.btn-light:focus, .btn-light.focus {\n  box-shadow: 0 4px 6px rgba(50, 50, 93, 0.11), 0 1px 3px rgba(0, 0, 0, 0.08), 0 0 0 0 rgba(173, 181, 189, 0.5);\n}\n.btn-light.disabled, .btn-light:disabled {\n  color: #fff;\n  background-color: #adb5bd;\n  border-color: #adb5bd;\n}\n.btn-light:not(:disabled):not(.disabled):active, .btn-light:not(:disabled):not(.disabled).active, .show > .btn-light.dropdown-toggle {\n  color: #fff;\n  background-color: rgb(144.7432432432, 155.5, 166.2567567568);\n  border-color: #adb5bd;\n}\n.btn-light:not(:disabled):not(.disabled):active:focus, .btn-light:not(:disabled):not(.disabled).active:focus, .show > .btn-light.dropdown-toggle:focus {\n  box-shadow: none, 0 0 0 0 rgba(173, 181, 189, 0.5);\n}\n\n.btn-dark {\n  color: #fff;\n  background-color: #212529;\n  border-color: #212529;\n  box-shadow: 0 4px 6px rgba(50, 50, 93, 0.11), 0 1px 3px rgba(0, 0, 0, 0.08);\n}\n.btn-dark:hover {\n  color: #fff;\n  background-color: #212529;\n  border-color: #212529;\n}\n.btn-dark:focus, .btn-dark.focus {\n  box-shadow: 0 4px 6px rgba(50, 50, 93, 0.11), 0 1px 3px rgba(0, 0, 0, 0.08), 0 0 0 0 rgba(33, 37, 41, 0.5);\n}\n.btn-dark.disabled, .btn-dark:disabled {\n  color: #fff;\n  background-color: #212529;\n  border-color: #212529;\n}\n.btn-dark:not(:disabled):not(.disabled):active, .btn-dark:not(:disabled):not(.disabled).active, .show > .btn-dark.dropdown-toggle {\n  color: #fff;\n  background-color: rgb(10.2567567568, 11.5, 12.7432432432);\n  border-color: #212529;\n}\n.btn-dark:not(:disabled):not(.disabled):active:focus, .btn-dark:not(:disabled):not(.disabled).active:focus, .show > .btn-dark.dropdown-toggle:focus {\n  box-shadow: none, 0 0 0 0 rgba(33, 37, 41, 0.5);\n}\n\n.btn-default {\n  color: #212529;\n  background-color: #ffd88c;\n  border-color: #ffd88c;\n  box-shadow: 0 4px 6px rgba(50, 50, 93, 0.11), 0 1px 3px rgba(0, 0, 0, 0.08);\n}\n.btn-default:hover {\n  color: #212529;\n  background-color: #ffd88c;\n  border-color: #ffd88c;\n}\n.btn-default:focus, .btn-default.focus {\n  box-shadow: 0 4px 6px rgba(50, 50, 93, 0.11), 0 1px 3px rgba(0, 0, 0, 0.08), 0 0 0 0 rgba(255, 216, 140, 0.5);\n}\n.btn-default.disabled, .btn-default:disabled {\n  color: #212529;\n  background-color: #ffd88c;\n  border-color: #ffd88c;\n}\n.btn-default:not(:disabled):not(.disabled):active, .btn-default:not(:disabled):not(.disabled).active, .show > .btn-default.dropdown-toggle {\n  color: #212529;\n  background-color: rgb(255, 198.7043478261, 89);\n  border-color: #ffd88c;\n}\n.btn-default:not(:disabled):not(.disabled):active:focus, .btn-default:not(:disabled):not(.disabled).active:focus, .show > .btn-default.dropdown-toggle:focus {\n  box-shadow: none, 0 0 0 0 rgba(255, 216, 140, 0.5);\n}\n\n.btn-white {\n  color: #212529;\n  background-color: #fff;\n  border-color: #fff;\n  box-shadow: 0 4px 6px rgba(50, 50, 93, 0.11), 0 1px 3px rgba(0, 0, 0, 0.08);\n}\n.btn-white:hover {\n  color: #212529;\n  background-color: white;\n  border-color: white;\n}\n.btn-white:focus, .btn-white.focus {\n  box-shadow: 0 4px 6px rgba(50, 50, 93, 0.11), 0 1px 3px rgba(0, 0, 0, 0.08), 0 0 0 0 rgba(255, 255, 255, 0.5);\n}\n.btn-white.disabled, .btn-white:disabled {\n  color: #212529;\n  background-color: #fff;\n  border-color: #fff;\n}\n.btn-white:not(:disabled):not(.disabled):active, .btn-white:not(:disabled):not(.disabled).active, .show > .btn-white.dropdown-toggle {\n  color: #212529;\n  background-color: rgb(229.5, 229.5, 229.5);\n  border-color: white;\n}\n.btn-white:not(:disabled):not(.disabled):active:focus, .btn-white:not(:disabled):not(.disabled).active:focus, .show > .btn-white.dropdown-toggle:focus {\n  box-shadow: none, 0 0 0 0 rgba(255, 255, 255, 0.5);\n}\n\n.btn-neutral {\n  color: #212529;\n  background-color: #fff;\n  border-color: #fff;\n  box-shadow: 0 4px 6px rgba(50, 50, 93, 0.11), 0 1px 3px rgba(0, 0, 0, 0.08);\n}\n.btn-neutral:hover {\n  color: #212529;\n  background-color: white;\n  border-color: white;\n}\n.btn-neutral:focus, .btn-neutral.focus {\n  box-shadow: 0 4px 6px rgba(50, 50, 93, 0.11), 0 1px 3px rgba(0, 0, 0, 0.08), 0 0 0 0 rgba(255, 255, 255, 0.5);\n}\n.btn-neutral.disabled, .btn-neutral:disabled {\n  color: #212529;\n  background-color: #fff;\n  border-color: #fff;\n}\n.btn-neutral:not(:disabled):not(.disabled):active, .btn-neutral:not(:disabled):not(.disabled).active, .show > .btn-neutral.dropdown-toggle {\n  color: #212529;\n  background-color: rgb(229.5, 229.5, 229.5);\n  border-color: white;\n}\n.btn-neutral:not(:disabled):not(.disabled):active:focus, .btn-neutral:not(:disabled):not(.disabled).active:focus, .show > .btn-neutral.dropdown-toggle:focus {\n  box-shadow: none, 0 0 0 0 rgba(255, 255, 255, 0.5);\n}\n\n.btn-darker {\n  color: #fff;\n  background-color: black;\n  border-color: black;\n  box-shadow: 0 4px 6px rgba(50, 50, 93, 0.11), 0 1px 3px rgba(0, 0, 0, 0.08);\n}\n.btn-darker:hover {\n  color: #fff;\n  background-color: black;\n  border-color: black;\n}\n.btn-darker:focus, .btn-darker.focus {\n  box-shadow: 0 4px 6px rgba(50, 50, 93, 0.11), 0 1px 3px rgba(0, 0, 0, 0.08), 0 0 0 0 rgba(0, 0, 0, 0.5);\n}\n.btn-darker.disabled, .btn-darker:disabled {\n  color: #fff;\n  background-color: black;\n  border-color: black;\n}\n.btn-darker:not(:disabled):not(.disabled):active, .btn-darker:not(:disabled):not(.disabled).active, .show > .btn-darker.dropdown-toggle {\n  color: #fff;\n  background-color: black;\n  border-color: black;\n}\n.btn-darker:not(:disabled):not(.disabled):active:focus, .btn-darker:not(:disabled):not(.disabled).active:focus, .show > .btn-darker.dropdown-toggle:focus {\n  box-shadow: none, 0 0 0 0 rgba(0, 0, 0, 0.5);\n}\n\n.btn-outline-primary {\n  color: #3ba371;\n  background-color: transparent;\n  background-image: none;\n  border-color: #3ba371;\n}\n.btn-outline-primary:hover {\n  color: #fff;\n  background-color: #3ba371;\n  border-color: #3ba371;\n}\n.btn-outline-primary:focus, .btn-outline-primary.focus {\n  box-shadow: 0 0 0 0 rgba(59, 163, 113, 0.5);\n}\n.btn-outline-primary.disabled, .btn-outline-primary:disabled {\n  color: #3ba371;\n  background-color: transparent;\n}\n.btn-outline-primary:not(:disabled):not(.disabled):active, .btn-outline-primary:not(:disabled):not(.disabled).active, .show > .btn-outline-primary.dropdown-toggle {\n  color: #fff;\n  background-color: #3ba371;\n  border-color: #3ba371;\n}\n.btn-outline-primary:not(:disabled):not(.disabled):active:focus, .btn-outline-primary:not(:disabled):not(.disabled).active:focus, .show > .btn-outline-primary.dropdown-toggle:focus {\n  box-shadow: 0 0 0 0 rgba(59, 163, 113, 0.5);\n}\n\n.btn-outline-secondary {\n  color: #f7fafc;\n  background-color: transparent;\n  background-image: none;\n  border-color: #f7fafc;\n}\n.btn-outline-secondary:hover {\n  color: #212529;\n  background-color: #f7fafc;\n  border-color: #f7fafc;\n}\n.btn-outline-secondary:focus, .btn-outline-secondary.focus {\n  box-shadow: 0 0 0 0 rgba(247, 250, 252, 0.5);\n}\n.btn-outline-secondary.disabled, .btn-outline-secondary:disabled {\n  color: #f7fafc;\n  background-color: transparent;\n}\n.btn-outline-secondary:not(:disabled):not(.disabled):active, .btn-outline-secondary:not(:disabled):not(.disabled).active, .show > .btn-outline-secondary.dropdown-toggle {\n  color: #212529;\n  background-color: #f7fafc;\n  border-color: #f7fafc;\n}\n.btn-outline-secondary:not(:disabled):not(.disabled):active:focus, .btn-outline-secondary:not(:disabled):not(.disabled).active:focus, .show > .btn-outline-secondary.dropdown-toggle:focus {\n  box-shadow: 0 0 0 0 rgba(247, 250, 252, 0.5);\n}\n\n.btn-outline-success {\n  color: #3aa170;\n  background-color: transparent;\n  background-image: none;\n  border-color: #3aa170;\n}\n.btn-outline-success:hover {\n  color: #fff;\n  background-color: #3aa170;\n  border-color: #3aa170;\n}\n.btn-outline-success:focus, .btn-outline-success.focus {\n  box-shadow: 0 0 0 0 rgba(58, 161, 112, 0.5);\n}\n.btn-outline-success.disabled, .btn-outline-success:disabled {\n  color: #3aa170;\n  background-color: transparent;\n}\n.btn-outline-success:not(:disabled):not(.disabled):active, .btn-outline-success:not(:disabled):not(.disabled).active, .show > .btn-outline-success.dropdown-toggle {\n  color: #fff;\n  background-color: #3aa170;\n  border-color: #3aa170;\n}\n.btn-outline-success:not(:disabled):not(.disabled):active:focus, .btn-outline-success:not(:disabled):not(.disabled).active:focus, .show > .btn-outline-success.dropdown-toggle:focus {\n  box-shadow: 0 0 0 0 rgba(58, 161, 112, 0.5);\n}\n\n.btn-outline-info {\n  color: #278e69;\n  background-color: transparent;\n  background-image: none;\n  border-color: #278e69;\n}\n.btn-outline-info:hover {\n  color: #fff;\n  background-color: #278e69;\n  border-color: #278e69;\n}\n.btn-outline-info:focus, .btn-outline-info.focus {\n  box-shadow: 0 0 0 0 rgba(39, 142, 105, 0.5);\n}\n.btn-outline-info.disabled, .btn-outline-info:disabled {\n  color: #278e69;\n  background-color: transparent;\n}\n.btn-outline-info:not(:disabled):not(.disabled):active, .btn-outline-info:not(:disabled):not(.disabled).active, .show > .btn-outline-info.dropdown-toggle {\n  color: #fff;\n  background-color: #278e69;\n  border-color: #278e69;\n}\n.btn-outline-info:not(:disabled):not(.disabled):active:focus, .btn-outline-info:not(:disabled):not(.disabled).active:focus, .show > .btn-outline-info.dropdown-toggle:focus {\n  box-shadow: 0 0 0 0 rgba(39, 142, 105, 0.5);\n}\n\n.btn-outline-warning {\n  color: #fb6340;\n  background-color: transparent;\n  background-image: none;\n  border-color: #fb6340;\n}\n.btn-outline-warning:hover {\n  color: #fff;\n  background-color: #fb6340;\n  border-color: #fb6340;\n}\n.btn-outline-warning:focus, .btn-outline-warning.focus {\n  box-shadow: 0 0 0 0 rgba(251, 99, 64, 0.5);\n}\n.btn-outline-warning.disabled, .btn-outline-warning:disabled {\n  color: #fb6340;\n  background-color: transparent;\n}\n.btn-outline-warning:not(:disabled):not(.disabled):active, .btn-outline-warning:not(:disabled):not(.disabled).active, .show > .btn-outline-warning.dropdown-toggle {\n  color: #fff;\n  background-color: #fb6340;\n  border-color: #fb6340;\n}\n.btn-outline-warning:not(:disabled):not(.disabled):active:focus, .btn-outline-warning:not(:disabled):not(.disabled).active:focus, .show > .btn-outline-warning.dropdown-toggle:focus {\n  box-shadow: 0 0 0 0 rgba(251, 99, 64, 0.5);\n}\n\n.btn-outline-danger {\n  color: #f5365c;\n  background-color: transparent;\n  background-image: none;\n  border-color: #f5365c;\n}\n.btn-outline-danger:hover {\n  color: #fff;\n  background-color: #f5365c;\n  border-color: #f5365c;\n}\n.btn-outline-danger:focus, .btn-outline-danger.focus {\n  box-shadow: 0 0 0 0 rgba(245, 54, 92, 0.5);\n}\n.btn-outline-danger.disabled, .btn-outline-danger:disabled {\n  color: #f5365c;\n  background-color: transparent;\n}\n.btn-outline-danger:not(:disabled):not(.disabled):active, .btn-outline-danger:not(:disabled):not(.disabled).active, .show > .btn-outline-danger.dropdown-toggle {\n  color: #fff;\n  background-color: #f5365c;\n  border-color: #f5365c;\n}\n.btn-outline-danger:not(:disabled):not(.disabled):active:focus, .btn-outline-danger:not(:disabled):not(.disabled).active:focus, .show > .btn-outline-danger.dropdown-toggle:focus {\n  box-shadow: 0 0 0 0 rgba(245, 54, 92, 0.5);\n}\n\n.btn-outline-light {\n  color: #adb5bd;\n  background-color: transparent;\n  background-image: none;\n  border-color: #adb5bd;\n}\n.btn-outline-light:hover {\n  color: #fff;\n  background-color: #adb5bd;\n  border-color: #adb5bd;\n}\n.btn-outline-light:focus, .btn-outline-light.focus {\n  box-shadow: 0 0 0 0 rgba(173, 181, 189, 0.5);\n}\n.btn-outline-light.disabled, .btn-outline-light:disabled {\n  color: #adb5bd;\n  background-color: transparent;\n}\n.btn-outline-light:not(:disabled):not(.disabled):active, .btn-outline-light:not(:disabled):not(.disabled).active, .show > .btn-outline-light.dropdown-toggle {\n  color: #fff;\n  background-color: #adb5bd;\n  border-color: #adb5bd;\n}\n.btn-outline-light:not(:disabled):not(.disabled):active:focus, .btn-outline-light:not(:disabled):not(.disabled).active:focus, .show > .btn-outline-light.dropdown-toggle:focus {\n  box-shadow: 0 0 0 0 rgba(173, 181, 189, 0.5);\n}\n\n.btn-outline-dark {\n  color: #212529;\n  background-color: transparent;\n  background-image: none;\n  border-color: #212529;\n}\n.btn-outline-dark:hover {\n  color: #fff;\n  background-color: #212529;\n  border-color: #212529;\n}\n.btn-outline-dark:focus, .btn-outline-dark.focus {\n  box-shadow: 0 0 0 0 rgba(33, 37, 41, 0.5);\n}\n.btn-outline-dark.disabled, .btn-outline-dark:disabled {\n  color: #212529;\n  background-color: transparent;\n}\n.btn-outline-dark:not(:disabled):not(.disabled):active, .btn-outline-dark:not(:disabled):not(.disabled).active, .show > .btn-outline-dark.dropdown-toggle {\n  color: #fff;\n  background-color: #212529;\n  border-color: #212529;\n}\n.btn-outline-dark:not(:disabled):not(.disabled):active:focus, .btn-outline-dark:not(:disabled):not(.disabled).active:focus, .show > .btn-outline-dark.dropdown-toggle:focus {\n  box-shadow: 0 0 0 0 rgba(33, 37, 41, 0.5);\n}\n\n.btn-outline-default {\n  color: #ffd88c;\n  background-color: transparent;\n  background-image: none;\n  border-color: #ffd88c;\n}\n.btn-outline-default:hover {\n  color: #212529;\n  background-color: #ffd88c;\n  border-color: #ffd88c;\n}\n.btn-outline-default:focus, .btn-outline-default.focus {\n  box-shadow: 0 0 0 0 rgba(255, 216, 140, 0.5);\n}\n.btn-outline-default.disabled, .btn-outline-default:disabled {\n  color: #ffd88c;\n  background-color: transparent;\n}\n.btn-outline-default:not(:disabled):not(.disabled):active, .btn-outline-default:not(:disabled):not(.disabled).active, .show > .btn-outline-default.dropdown-toggle {\n  color: #212529;\n  background-color: #ffd88c;\n  border-color: #ffd88c;\n}\n.btn-outline-default:not(:disabled):not(.disabled):active:focus, .btn-outline-default:not(:disabled):not(.disabled).active:focus, .show > .btn-outline-default.dropdown-toggle:focus {\n  box-shadow: 0 0 0 0 rgba(255, 216, 140, 0.5);\n}\n\n.btn-outline-white {\n  color: #fff;\n  background-color: transparent;\n  background-image: none;\n  border-color: #fff;\n}\n.btn-outline-white:hover {\n  color: #212529;\n  background-color: #fff;\n  border-color: #fff;\n}\n.btn-outline-white:focus, .btn-outline-white.focus {\n  box-shadow: 0 0 0 0 rgba(255, 255, 255, 0.5);\n}\n.btn-outline-white.disabled, .btn-outline-white:disabled {\n  color: #fff;\n  background-color: transparent;\n}\n.btn-outline-white:not(:disabled):not(.disabled):active, .btn-outline-white:not(:disabled):not(.disabled).active, .show > .btn-outline-white.dropdown-toggle {\n  color: #212529;\n  background-color: #fff;\n  border-color: #fff;\n}\n.btn-outline-white:not(:disabled):not(.disabled):active:focus, .btn-outline-white:not(:disabled):not(.disabled).active:focus, .show > .btn-outline-white.dropdown-toggle:focus {\n  box-shadow: 0 0 0 0 rgba(255, 255, 255, 0.5);\n}\n\n.btn-outline-neutral {\n  color: #fff;\n  background-color: transparent;\n  background-image: none;\n  border-color: #fff;\n}\n.btn-outline-neutral:hover {\n  color: #212529;\n  background-color: #fff;\n  border-color: #fff;\n}\n.btn-outline-neutral:focus, .btn-outline-neutral.focus {\n  box-shadow: 0 0 0 0 rgba(255, 255, 255, 0.5);\n}\n.btn-outline-neutral.disabled, .btn-outline-neutral:disabled {\n  color: #fff;\n  background-color: transparent;\n}\n.btn-outline-neutral:not(:disabled):not(.disabled):active, .btn-outline-neutral:not(:disabled):not(.disabled).active, .show > .btn-outline-neutral.dropdown-toggle {\n  color: #212529;\n  background-color: #fff;\n  border-color: #fff;\n}\n.btn-outline-neutral:not(:disabled):not(.disabled):active:focus, .btn-outline-neutral:not(:disabled):not(.disabled).active:focus, .show > .btn-outline-neutral.dropdown-toggle:focus {\n  box-shadow: 0 0 0 0 rgba(255, 255, 255, 0.5);\n}\n\n.btn-outline-darker {\n  color: black;\n  background-color: transparent;\n  background-image: none;\n  border-color: black;\n}\n.btn-outline-darker:hover {\n  color: #fff;\n  background-color: black;\n  border-color: black;\n}\n.btn-outline-darker:focus, .btn-outline-darker.focus {\n  box-shadow: 0 0 0 0 rgba(0, 0, 0, 0.5);\n}\n.btn-outline-darker.disabled, .btn-outline-darker:disabled {\n  color: black;\n  background-color: transparent;\n}\n.btn-outline-darker:not(:disabled):not(.disabled):active, .btn-outline-darker:not(:disabled):not(.disabled).active, .show > .btn-outline-darker.dropdown-toggle {\n  color: #fff;\n  background-color: black;\n  border-color: black;\n}\n.btn-outline-darker:not(:disabled):not(.disabled):active:focus, .btn-outline-darker:not(:disabled):not(.disabled).active:focus, .show > .btn-outline-darker.dropdown-toggle:focus {\n  box-shadow: 0 0 0 0 rgba(0, 0, 0, 0.5);\n}\n\n.btn-link {\n  font-weight: 400;\n  color: #3ba371;\n  text-decoration: none;\n}\n.btn-link:hover {\n  color: rgb(38.6689189189, 106.8310810811, 74.0608108108);\n  text-decoration: none;\n}\n.btn-link:focus, .btn-link.focus {\n  text-decoration: none;\n}\n.btn-link:disabled, .btn-link.disabled {\n  color: #8898aa;\n  pointer-events: none;\n}\n\n.btn-lg, .btn-group-lg > .btn {\n  padding: 0.875rem 1rem;\n  font-size: 0.875rem;\n  line-height: 1.5;\n  border-radius: 0.4375rem;\n}\n\n.btn-sm, .btn-group-sm > .btn {\n  padding: 0.25rem 0.5rem;\n  font-size: 0.75rem;\n  line-height: 1.5;\n  border-radius: 0.375rem;\n}\n\n.btn-block {\n  display: block;\n  width: 100%;\n}\n.btn-block + .btn-block {\n  margin-top: 0.5rem;\n}\n\ninput[type=submit].btn-block,\ninput[type=reset].btn-block,\ninput[type=button].btn-block {\n  width: 100%;\n}\n\n.fade {\n  transition: opacity 0.15s linear;\n}\n@media (prefers-reduced-motion: reduce) {\n  .fade {\n    transition: none;\n  }\n}\n.fade:not(.show) {\n  opacity: 0;\n}\n\n.collapse:not(.show) {\n  display: none;\n}\n\n.collapsing {\n  position: relative;\n  height: 0;\n  overflow: hidden;\n  transition: height 0.35s ease;\n}\n@media (prefers-reduced-motion: reduce) {\n  .collapsing {\n    transition: none;\n  }\n}\n\n.dropup,\n.dropright,\n.dropdown,\n.dropleft {\n  position: relative;\n}\n\n.dropdown-toggle {\n  white-space: nowrap;\n}\n.dropdown-toggle::after {\n  display: inline-block;\n  margin-left: 0.255em;\n  vertical-align: 0.255em;\n  content: \"\";\n  border-top: 0.3em solid;\n  border-right: 0.3em solid transparent;\n  border-bottom: 0;\n  border-left: 0.3em solid transparent;\n}\n.dropdown-toggle:empty::after {\n  margin-left: 0;\n}\n\n.dropdown-menu {\n  position: absolute;\n  top: 100%;\n  left: 0;\n  z-index: 1000;\n  display: none;\n  float: left;\n  min-width: 10rem;\n  padding: 0.5rem 0;\n  margin: 0.125rem 0 0;\n  font-size: 1rem;\n  color: #525f7f;\n  text-align: left;\n  list-style: none;\n  background-color: #fff;\n  background-clip: padding-box;\n  border: 0 solid rgba(0, 0, 0, 0.15);\n  border-radius: 0.4375rem;\n  box-shadow: 0 50px 100px rgba(50, 50, 93, 0.1), 0 15px 35px rgba(50, 50, 93, 0.15), 0 5px 15px rgba(0, 0, 0, 0.1);\n}\n\n.dropdown-menu-left {\n  right: auto;\n  left: 0;\n}\n\n.dropdown-menu-right {\n  right: 0;\n  left: auto;\n}\n\n@media (min-width: 576px) {\n  .dropdown-menu-sm-left {\n    right: auto;\n    left: 0;\n  }\n  .dropdown-menu-sm-right {\n    right: 0;\n    left: auto;\n  }\n}\n@media (min-width: 768px) {\n  .dropdown-menu-md-left {\n    right: auto;\n    left: 0;\n  }\n  .dropdown-menu-md-right {\n    right: 0;\n    left: auto;\n  }\n}\n@media (min-width: 992px) {\n  .dropdown-menu-lg-left {\n    right: auto;\n    left: 0;\n  }\n  .dropdown-menu-lg-right {\n    right: 0;\n    left: auto;\n  }\n}\n@media (min-width: 1200px) {\n  .dropdown-menu-xl-left {\n    right: auto;\n    left: 0;\n  }\n  .dropdown-menu-xl-right {\n    right: 0;\n    left: auto;\n  }\n}\n.dropup .dropdown-menu {\n  top: auto;\n  bottom: 100%;\n  margin-top: 0;\n  margin-bottom: 0.125rem;\n}\n.dropup .dropdown-toggle::after {\n  display: inline-block;\n  margin-left: 0.255em;\n  vertical-align: 0.255em;\n  content: \"\";\n  border-top: 0;\n  border-right: 0.3em solid transparent;\n  border-bottom: 0.3em solid;\n  border-left: 0.3em solid transparent;\n}\n.dropup .dropdown-toggle:empty::after {\n  margin-left: 0;\n}\n\n.dropright .dropdown-menu {\n  top: 0;\n  right: auto;\n  left: 100%;\n  margin-top: 0;\n  margin-left: 0.125rem;\n}\n.dropright .dropdown-toggle::after {\n  display: inline-block;\n  margin-left: 0.255em;\n  vertical-align: 0.255em;\n  content: \"\";\n  border-top: 0.3em solid transparent;\n  border-right: 0;\n  border-bottom: 0.3em solid transparent;\n  border-left: 0.3em solid;\n}\n.dropright .dropdown-toggle:empty::after {\n  margin-left: 0;\n}\n.dropright .dropdown-toggle::after {\n  vertical-align: 0;\n}\n\n.dropleft .dropdown-menu {\n  top: 0;\n  right: 100%;\n  left: auto;\n  margin-top: 0;\n  margin-right: 0.125rem;\n}\n.dropleft .dropdown-toggle::after {\n  display: inline-block;\n  margin-left: 0.255em;\n  vertical-align: 0.255em;\n  content: \"\";\n}\n.dropleft .dropdown-toggle::after {\n  display: none;\n}\n.dropleft .dropdown-toggle::before {\n  display: inline-block;\n  margin-right: 0.255em;\n  vertical-align: 0.255em;\n  content: \"\";\n  border-top: 0.3em solid transparent;\n  border-right: 0.3em solid;\n  border-bottom: 0.3em solid transparent;\n}\n.dropleft .dropdown-toggle:empty::after {\n  margin-left: 0;\n}\n.dropleft .dropdown-toggle::before {\n  vertical-align: 0;\n}\n\n.dropdown-menu[x-placement^=top], .dropdown-menu[x-placement^=right], .dropdown-menu[x-placement^=bottom], .dropdown-menu[x-placement^=left] {\n  right: auto;\n  bottom: auto;\n}\n\n.dropdown-divider {\n  height: 0;\n  margin: 0.5rem 0;\n  overflow: hidden;\n  border-top: 1px solid #e9ecef;\n}\n\n.dropdown-item {\n  display: block;\n  width: 100%;\n  padding: 0.25rem 1.5rem;\n  clear: both;\n  font-weight: 400;\n  color: #212529;\n  text-align: inherit;\n  white-space: nowrap;\n  background-color: transparent;\n  border: 0;\n}\n.dropdown-item:hover, .dropdown-item:focus {\n  color: rgb(21.6283783784, 24.25, 26.8716216216);\n  text-decoration: none;\n  background-color: #e9ecef;\n}\n.dropdown-item.active, .dropdown-item:active {\n  color: #fff;\n  text-decoration: none;\n  background-color: #3ba371;\n}\n.dropdown-item.disabled, .dropdown-item:disabled {\n  color: #adb5bd;\n  pointer-events: none;\n  background-color: transparent;\n}\n\n.dropdown-menu.show {\n  display: block;\n}\n\n.dropdown-header {\n  display: block;\n  padding: 0.5rem 1.5rem;\n  margin-bottom: 0;\n  font-size: 0.875rem;\n  color: #8898aa;\n  white-space: nowrap;\n}\n\n.dropdown-item-text {\n  display: block;\n  padding: 0.25rem 1.5rem;\n  color: #212529;\n}\n\n.btn-group,\n.btn-group-vertical {\n  position: relative;\n  display: inline-flex;\n  vertical-align: middle;\n}\n.btn-group > .btn,\n.btn-group-vertical > .btn {\n  position: relative;\n  flex: 1 1 auto;\n}\n.btn-group > .btn:hover,\n.btn-group-vertical > .btn:hover {\n  z-index: 1;\n}\n.btn-group > .btn:focus, .btn-group > .btn:active, .btn-group > .btn.active,\n.btn-group-vertical > .btn:focus,\n.btn-group-vertical > .btn:active,\n.btn-group-vertical > .btn.active {\n  z-index: 1;\n}\n\n.btn-toolbar {\n  display: flex;\n  flex-wrap: wrap;\n  justify-content: flex-start;\n}\n.btn-toolbar .input-group {\n  width: auto;\n}\n\n.btn-group > .btn:not(:first-child),\n.btn-group > .btn-group:not(:first-child) {\n  margin-left: -1px;\n}\n.btn-group > .btn:not(:last-child):not(.dropdown-toggle),\n.btn-group > .btn-group:not(:last-child) > .btn {\n  border-top-right-radius: 0;\n  border-bottom-right-radius: 0;\n}\n.btn-group > .btn:not(:first-child),\n.btn-group > .btn-group:not(:first-child) > .btn {\n  border-top-left-radius: 0;\n  border-bottom-left-radius: 0;\n}\n\n.dropdown-toggle-split {\n  padding-right: 0.9375rem;\n  padding-left: 0.9375rem;\n}\n.dropdown-toggle-split::after, .dropup .dropdown-toggle-split::after, .dropright .dropdown-toggle-split::after {\n  margin-left: 0;\n}\n.dropleft .dropdown-toggle-split::before {\n  margin-right: 0;\n}\n\n.btn-sm + .dropdown-toggle-split, .btn-group-sm > .btn + .dropdown-toggle-split {\n  padding-right: 0.375rem;\n  padding-left: 0.375rem;\n}\n\n.btn-lg + .dropdown-toggle-split, .btn-group-lg > .btn + .dropdown-toggle-split {\n  padding-right: 0.75rem;\n  padding-left: 0.75rem;\n}\n\n.btn-group.show .dropdown-toggle {\n  box-shadow: none;\n}\n.btn-group.show .dropdown-toggle.btn-link {\n  box-shadow: none;\n}\n\n.btn-group-vertical {\n  flex-direction: column;\n  align-items: flex-start;\n  justify-content: center;\n}\n.btn-group-vertical > .btn,\n.btn-group-vertical > .btn-group {\n  width: 100%;\n}\n.btn-group-vertical > .btn:not(:first-child),\n.btn-group-vertical > .btn-group:not(:first-child) {\n  margin-top: -1px;\n}\n.btn-group-vertical > .btn:not(:last-child):not(.dropdown-toggle),\n.btn-group-vertical > .btn-group:not(:last-child) > .btn {\n  border-bottom-right-radius: 0;\n  border-bottom-left-radius: 0;\n}\n.btn-group-vertical > .btn:not(:first-child),\n.btn-group-vertical > .btn-group:not(:first-child) > .btn {\n  border-top-left-radius: 0;\n  border-top-right-radius: 0;\n}\n\n.btn-group-toggle > .btn,\n.btn-group-toggle > .btn-group > .btn {\n  margin-bottom: 0;\n}\n.btn-group-toggle > .btn input[type=radio],\n.btn-group-toggle > .btn input[type=checkbox],\n.btn-group-toggle > .btn-group > .btn input[type=radio],\n.btn-group-toggle > .btn-group > .btn input[type=checkbox] {\n  position: absolute;\n  clip: rect(0, 0, 0, 0);\n  pointer-events: none;\n}\n\n.input-group {\n  position: relative;\n  display: flex;\n  flex-wrap: wrap;\n  align-items: stretch;\n  width: 100%;\n}\n.input-group > .form-control,\n.input-group > .form-control-plaintext,\n.input-group > .custom-select,\n.input-group > .custom-file {\n  position: relative;\n  flex: 1 1 auto;\n  width: 1%;\n  min-width: 0;\n  margin-bottom: 0;\n}\n.input-group > .form-control + .form-control,\n.input-group > .form-control + .custom-select,\n.input-group > .form-control + .custom-file,\n.input-group > .form-control-plaintext + .form-control,\n.input-group > .form-control-plaintext + .custom-select,\n.input-group > .form-control-plaintext + .custom-file,\n.input-group > .custom-select + .form-control,\n.input-group > .custom-select + .custom-select,\n.input-group > .custom-select + .custom-file,\n.input-group > .custom-file + .form-control,\n.input-group > .custom-file + .custom-select,\n.input-group > .custom-file + .custom-file {\n  margin-left: -1px;\n}\n.input-group > .form-control:focus,\n.input-group > .custom-select:focus,\n.input-group > .custom-file .custom-file-input:focus ~ .custom-file-label {\n  z-index: 3;\n}\n.input-group > .custom-file .custom-file-input:focus {\n  z-index: 4;\n}\n.input-group > .form-control:not(:first-child),\n.input-group > .custom-select:not(:first-child) {\n  border-top-left-radius: 0;\n  border-bottom-left-radius: 0;\n}\n.input-group > .custom-file {\n  display: flex;\n  align-items: center;\n}\n.input-group > .custom-file:not(:last-child) .custom-file-label, .input-group > .custom-file:not(:first-child) .custom-file-label {\n  border-top-left-radius: 0;\n  border-bottom-left-radius: 0;\n}\n.input-group:not(.has-validation) > .form-control:not(:last-child),\n.input-group:not(.has-validation) > .custom-select:not(:last-child),\n.input-group:not(.has-validation) > .custom-file:not(:last-child) .custom-file-label::after {\n  border-top-right-radius: 0;\n  border-bottom-right-radius: 0;\n}\n.input-group.has-validation > .form-control:nth-last-child(n+3),\n.input-group.has-validation > .custom-select:nth-last-child(n+3),\n.input-group.has-validation > .custom-file:nth-last-child(n+3) .custom-file-label::after {\n  border-top-right-radius: 0;\n  border-bottom-right-radius: 0;\n}\n\n.input-group-prepend,\n.input-group-append {\n  display: flex;\n}\n.input-group-prepend .btn,\n.input-group-append .btn {\n  position: relative;\n  z-index: 2;\n}\n.input-group-prepend .btn:focus,\n.input-group-append .btn:focus {\n  z-index: 3;\n}\n.input-group-prepend .btn + .btn,\n.input-group-prepend .btn + .input-group-text,\n.input-group-prepend .input-group-text + .input-group-text,\n.input-group-prepend .input-group-text + .btn,\n.input-group-append .btn + .btn,\n.input-group-append .btn + .input-group-text,\n.input-group-append .input-group-text + .input-group-text,\n.input-group-append .input-group-text + .btn {\n  margin-left: -1px;\n}\n\n.input-group-prepend {\n  margin-right: -1px;\n}\n\n.input-group-append {\n  margin-left: -1px;\n}\n\n.input-group-text {\n  display: flex;\n  align-items: center;\n  padding: 0.625rem 0.75rem;\n  margin-bottom: 0;\n  font-size: 0.875rem;\n  font-weight: 400;\n  line-height: 1.5;\n  color: #adb5bd;\n  text-align: center;\n  white-space: nowrap;\n  background-color: #fff;\n  border: 1px solid #cad1d7;\n  border-radius: 0.375rem;\n}\n.input-group-text input[type=radio],\n.input-group-text input[type=checkbox] {\n  margin-top: 0;\n}\n\n.input-group-lg > .form-control:not(textarea),\n.input-group-lg > .custom-select {\n  height: calc(1.5em + 1.75rem + 2px);\n}\n\n.input-group-lg > .form-control,\n.input-group-lg > .custom-select,\n.input-group-lg > .input-group-prepend > .input-group-text,\n.input-group-lg > .input-group-append > .input-group-text,\n.input-group-lg > .input-group-prepend > .btn,\n.input-group-lg > .input-group-append > .btn {\n  padding: 0.875rem 1rem;\n  font-size: 0.875rem;\n  line-height: 1.5;\n  border-radius: 0.4375rem;\n}\n\n.input-group-sm > .form-control:not(textarea),\n.input-group-sm > .custom-select {\n  height: calc(1.5em + 0.5rem + 2px);\n}\n\n.input-group-sm > .form-control,\n.input-group-sm > .custom-select,\n.input-group-sm > .input-group-prepend > .input-group-text,\n.input-group-sm > .input-group-append > .input-group-text,\n.input-group-sm > .input-group-prepend > .btn,\n.input-group-sm > .input-group-append > .btn {\n  padding: 0.25rem 0.5rem;\n  font-size: 0.75rem;\n  line-height: 1.5;\n  border-radius: 0.25rem;\n}\n\n.input-group-lg > .custom-select,\n.input-group-sm > .custom-select {\n  padding-right: 1.75rem;\n}\n\n.input-group > .input-group-prepend > .btn,\n.input-group > .input-group-prepend > .input-group-text,\n.input-group:not(.has-validation) > .input-group-append:not(:last-child) > .btn,\n.input-group:not(.has-validation) > .input-group-append:not(:last-child) > .input-group-text,\n.input-group.has-validation > .input-group-append:nth-last-child(n+3) > .btn,\n.input-group.has-validation > .input-group-append:nth-last-child(n+3) > .input-group-text,\n.input-group > .input-group-append:last-child > .btn:not(:last-child):not(.dropdown-toggle),\n.input-group > .input-group-append:last-child > .input-group-text:not(:last-child) {\n  border-top-right-radius: 0;\n  border-bottom-right-radius: 0;\n}\n\n.input-group > .input-group-append > .btn,\n.input-group > .input-group-append > .input-group-text,\n.input-group > .input-group-prepend:not(:first-child) > .btn,\n.input-group > .input-group-prepend:not(:first-child) > .input-group-text,\n.input-group > .input-group-prepend:first-child > .btn:not(:first-child),\n.input-group > .input-group-prepend:first-child > .input-group-text:not(:first-child) {\n  border-top-left-radius: 0;\n  border-bottom-left-radius: 0;\n}\n\n.custom-control {\n  position: relative;\n  z-index: 1;\n  display: block;\n  min-height: 1.5rem;\n  padding-left: 3rem;\n  color-adjust: exact;\n}\n\n.custom-control-inline {\n  display: inline-flex;\n  margin-right: 1rem;\n}\n\n.custom-control-input {\n  position: absolute;\n  left: 0;\n  z-index: -1;\n  width: 1.25rem;\n  height: 1.375rem;\n  opacity: 0;\n}\n.custom-control-input:checked ~ .custom-control-label::before {\n  color: #fff;\n  border-color: #3ba371;\n  background-color: #3ba371;\n  box-shadow: none;\n}\n.custom-control-input:focus ~ .custom-control-label::before {\n  box-shadow: none, none;\n}\n.custom-control-input:focus:not(:checked) ~ .custom-control-label::before {\n  border-color: rgba(50, 151, 211, 0.25);\n}\n.custom-control-input:not(:disabled):active ~ .custom-control-label::before {\n  color: #fff;\n  background-color: #3ba371;\n  border-color: #3ba371;\n  box-shadow: none;\n}\n.custom-control-input[disabled] ~ .custom-control-label, .custom-control-input:disabled ~ .custom-control-label {\n  color: #8898aa;\n}\n.custom-control-input[disabled] ~ .custom-control-label::before, .custom-control-input:disabled ~ .custom-control-label::before {\n  background-color: #e9ecef;\n}\n\n.custom-control-label {\n  position: relative;\n  margin-bottom: 0;\n  vertical-align: top;\n}\n.custom-control-label::before {\n  position: absolute;\n  top: 0.125rem;\n  left: -3rem;\n  display: block;\n  width: 1.25rem;\n  height: 1.25rem;\n  pointer-events: none;\n  content: \"\";\n  background-color: #fff;\n  border: #cad1d7 solid 1px;\n  box-shadow: none;\n}\n.custom-control-label::after {\n  position: absolute;\n  top: 0.125rem;\n  left: -3rem;\n  display: block;\n  width: 1.25rem;\n  height: 1.25rem;\n  content: \"\";\n  background: 50%/50% 50% no-repeat;\n}\n\n.custom-checkbox .custom-control-label::before {\n  border-radius: 0.25rem;\n}\n.custom-checkbox .custom-control-input:checked ~ .custom-control-label::after {\n  background-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' width='8' height='8' viewBox='0 0 8 8'%3e%3cpath fill='%23fff' d='M6.564.75l-3.59 3.612-1.538-1.55L0 4.26l2.974 2.99L8 2.193z'/%3e%3c/svg%3e\");\n}\n.custom-checkbox .custom-control-input:indeterminate ~ .custom-control-label::before {\n  border-color: #3ba371;\n  background-color: #3ba371;\n}\n.custom-checkbox .custom-control-input:indeterminate ~ .custom-control-label::after {\n  background-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' width='4' height='4' viewBox='0 0 4 4'%3e%3cpath stroke='%23fff' d='M0 2h4'/%3e%3c/svg%3e\");\n}\n.custom-checkbox .custom-control-input:disabled:checked ~ .custom-control-label::before {\n  background-color: rgba(59, 163, 113, 0.5);\n}\n.custom-checkbox .custom-control-input:disabled:indeterminate ~ .custom-control-label::before {\n  background-color: rgba(59, 163, 113, 0.5);\n}\n\n.custom-radio .custom-control-label::before {\n  border-radius: 50%;\n}\n.custom-radio .custom-control-input:checked ~ .custom-control-label::after {\n  background-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' width='12' height='12' viewBox='-4 -4 8 8'%3e%3ccircle r='3' fill='%23fff'/%3e%3c/svg%3e\");\n}\n.custom-radio .custom-control-input:disabled:checked ~ .custom-control-label::before {\n  background-color: rgba(59, 163, 113, 0.5);\n}\n\n.custom-switch {\n  padding-left: 3.9375rem;\n}\n.custom-switch .custom-control-label::before {\n  left: -3.9375rem;\n  width: 2.1875rem;\n  pointer-events: all;\n  border-radius: 0.625rem;\n}\n.custom-switch .custom-control-label::after {\n  top: calc(0.125rem + 2px);\n  left: calc(-3.9375rem + 2px);\n  width: calc(1.25rem - 4px);\n  height: calc(1.25rem - 4px);\n  background-color: #cad1d7;\n  border-radius: 0.625rem;\n  transition: transform 0.15s ease-in-out, background-color 0.15s ease-in-out, border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;\n}\n@media (prefers-reduced-motion: reduce) {\n  .custom-switch .custom-control-label::after {\n    transition: none;\n  }\n}\n.custom-switch .custom-control-input:checked ~ .custom-control-label::after {\n  background-color: #fff;\n  transform: translateX(0.9375rem);\n}\n.custom-switch .custom-control-input:disabled:checked ~ .custom-control-label::before {\n  background-color: rgba(59, 163, 113, 0.5);\n}\n\n.custom-select {\n  display: inline-block;\n  width: 100%;\n  height: calc(1.5em + 1.25rem + 2px);\n  padding: 0.625rem 1.75rem 0.625rem 0.75rem;\n  font-size: 0.875rem;\n  font-weight: 400;\n  line-height: 1.5;\n  color: #8898aa;\n  vertical-align: middle;\n  background: #fff url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' width='4' height='5' viewBox='0 0 4 5'%3e%3cpath fill='%2332325d' d='M2 0L0 2h4zm0 5L0 3h4z'/%3e%3c/svg%3e\") right 0.75rem center/8px 10px no-repeat;\n  border: 1px solid #cad1d7;\n  border-radius: 0.375rem;\n  box-shadow: inset 0 1px 2px rgba(0, 0, 0, 0.075);\n  appearance: none;\n}\n.custom-select:focus {\n  border-color: rgba(50, 151, 211, 0.25);\n  outline: 0;\n  box-shadow: inset 0 1px 2px rgba(0, 0, 0, 0.075), 0 0 0 0 #3ba371;\n}\n.custom-select:focus::-ms-value {\n  color: #8898aa;\n  background-color: #fff;\n}\n.custom-select[multiple], .custom-select[size]:not([size=\"1\"]) {\n  height: auto;\n  padding-right: 0.75rem;\n  background-image: none;\n}\n.custom-select:disabled {\n  color: #8898aa;\n  background-color: #e9ecef;\n}\n.custom-select::-ms-expand {\n  display: none;\n}\n.custom-select:-moz-focusring {\n  color: transparent;\n  text-shadow: 0 0 0 #8898aa;\n}\n\n.custom-select-sm {\n  height: calc(1.5em + 0.5rem + 2px);\n  padding-top: 0.25rem;\n  padding-bottom: 0.25rem;\n  padding-left: 0.5rem;\n  font-size: 0.75rem;\n}\n\n.custom-select-lg {\n  height: calc(1.5em + 1.75rem + 2px);\n  padding-top: 0.875rem;\n  padding-bottom: 0.875rem;\n  padding-left: 1rem;\n  font-size: 0.875rem;\n}\n\n.custom-file {\n  position: relative;\n  display: inline-block;\n  width: 100%;\n  height: calc(1.5em + 1.25rem + 2px);\n  margin-bottom: 0;\n}\n\n.custom-file-input {\n  position: relative;\n  z-index: 2;\n  width: 100%;\n  height: calc(1.5em + 1.25rem + 2px);\n  margin: 0;\n  overflow: hidden;\n  opacity: 0;\n}\n.custom-file-input:focus ~ .custom-file-label {\n  border-color: rgba(50, 151, 211, 0.25);\n  box-shadow: none;\n}\n.custom-file-input[disabled] ~ .custom-file-label, .custom-file-input:disabled ~ .custom-file-label {\n  background-color: #e9ecef;\n}\n.custom-file-input:lang(en) ~ .custom-file-label::after {\n  content: \"Browse\";\n}\n.custom-file-input ~ .custom-file-label[data-browse]::after {\n  content: attr(data-browse);\n}\n\n.custom-file-label {\n  position: absolute;\n  top: 0;\n  right: 0;\n  left: 0;\n  z-index: 1;\n  height: calc(1.5em + 1.25rem + 2px);\n  padding: 0.625rem 0.75rem;\n  overflow: hidden;\n  font-weight: 400;\n  line-height: 1.5;\n  color: #8898aa;\n  background-color: #fff;\n  border: 1px solid #cad1d7;\n  border-radius: 0.375rem;\n  box-shadow: none;\n}\n.custom-file-label::after {\n  position: absolute;\n  top: 0;\n  right: 0;\n  bottom: 0;\n  z-index: 3;\n  display: block;\n  height: calc(1.5em + 1.25rem);\n  padding: 0.625rem 0.75rem;\n  line-height: 1.5;\n  color: #8898aa;\n  content: \"Browse\";\n  background-color: #fff;\n  border-left: inherit;\n  border-radius: 0 0.375rem 0.375rem 0;\n}\n\n.custom-range {\n  width: 100%;\n  height: 1rem;\n  padding: 0;\n  background-color: transparent;\n  appearance: none;\n}\n.custom-range:focus {\n  outline: 0;\n}\n.custom-range:focus::-webkit-slider-thumb {\n  box-shadow: 0 0 0 1px #f8f9fe, none;\n}\n.custom-range:focus::-moz-range-thumb {\n  box-shadow: 0 0 0 1px #f8f9fe, none;\n}\n.custom-range:focus::-ms-thumb {\n  box-shadow: 0 0 0 1px #f8f9fe, none;\n}\n.custom-range::-moz-focus-outer {\n  border: 0;\n}\n.custom-range::-webkit-slider-thumb {\n  width: 1rem;\n  height: 1rem;\n  margin-top: -0.25rem;\n  background-color: #3ba371;\n  border: 0;\n  border-radius: 1rem;\n  box-shadow: 0 0.1rem 0.25rem rgba(0, 0, 0, 0.1);\n  transition: background-color 0.15s ease-in-out, border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;\n  appearance: none;\n}\n@media (prefers-reduced-motion: reduce) {\n  .custom-range::-webkit-slider-thumb {\n    transition: none;\n  }\n}\n.custom-range::-webkit-slider-thumb:active {\n  background-color: rgb(174.6013513514, 225.8986486486, 201.2364864865);\n}\n.custom-range::-webkit-slider-runnable-track {\n  width: 100%;\n  height: 0.5rem;\n  color: transparent;\n  cursor: pointer;\n  background-color: #dee2e6;\n  border-color: transparent;\n  border-radius: 1rem;\n  box-shadow: inset 0 0.25rem 0.25rem rgba(0, 0, 0, 0.1);\n}\n.custom-range::-moz-range-thumb {\n  width: 1rem;\n  height: 1rem;\n  background-color: #3ba371;\n  border: 0;\n  border-radius: 1rem;\n  box-shadow: 0 0.1rem 0.25rem rgba(0, 0, 0, 0.1);\n  transition: background-color 0.15s ease-in-out, border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;\n  appearance: none;\n}\n@media (prefers-reduced-motion: reduce) {\n  .custom-range::-moz-range-thumb {\n    transition: none;\n  }\n}\n.custom-range::-moz-range-thumb:active {\n  background-color: rgb(174.6013513514, 225.8986486486, 201.2364864865);\n}\n.custom-range::-moz-range-track {\n  width: 100%;\n  height: 0.5rem;\n  color: transparent;\n  cursor: pointer;\n  background-color: #dee2e6;\n  border-color: transparent;\n  border-radius: 1rem;\n  box-shadow: inset 0 0.25rem 0.25rem rgba(0, 0, 0, 0.1);\n}\n.custom-range::-ms-thumb {\n  width: 1rem;\n  height: 1rem;\n  margin-top: 0;\n  margin-right: 0;\n  margin-left: 0;\n  background-color: #3ba371;\n  border: 0;\n  border-radius: 1rem;\n  box-shadow: 0 0.1rem 0.25rem rgba(0, 0, 0, 0.1);\n  transition: background-color 0.15s ease-in-out, border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;\n  appearance: none;\n}\n@media (prefers-reduced-motion: reduce) {\n  .custom-range::-ms-thumb {\n    transition: none;\n  }\n}\n.custom-range::-ms-thumb:active {\n  background-color: rgb(174.6013513514, 225.8986486486, 201.2364864865);\n}\n.custom-range::-ms-track {\n  width: 100%;\n  height: 0.5rem;\n  color: transparent;\n  cursor: pointer;\n  background-color: transparent;\n  border-color: transparent;\n  border-width: 0.5rem;\n  box-shadow: inset 0 0.25rem 0.25rem rgba(0, 0, 0, 0.1);\n}\n.custom-range::-ms-fill-lower {\n  background-color: #dee2e6;\n  border-radius: 1rem;\n}\n.custom-range::-ms-fill-upper {\n  margin-right: 15px;\n  background-color: #dee2e6;\n  border-radius: 1rem;\n}\n.custom-range:disabled::-webkit-slider-thumb {\n  background-color: #adb5bd;\n}\n.custom-range:disabled::-webkit-slider-runnable-track {\n  cursor: default;\n}\n.custom-range:disabled::-moz-range-thumb {\n  background-color: #adb5bd;\n}\n.custom-range:disabled::-moz-range-track {\n  cursor: default;\n}\n.custom-range:disabled::-ms-thumb {\n  background-color: #adb5bd;\n}\n\n.custom-control-label::before,\n.custom-file-label,\n.custom-select {\n  transition: background-color 0.15s ease-in-out, border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;\n}\n@media (prefers-reduced-motion: reduce) {\n  .custom-control-label::before,\n  .custom-file-label,\n  .custom-select {\n    transition: none;\n  }\n}\n\n.nav {\n  display: flex;\n  flex-wrap: wrap;\n  padding-left: 0;\n  margin-bottom: 0;\n  list-style: none;\n}\n\n.nav-link {\n  display: block;\n  padding: 0.25rem 0.75rem;\n}\n.nav-link:hover, .nav-link:focus {\n  text-decoration: none;\n}\n.nav-link.disabled {\n  color: #8898aa;\n  pointer-events: none;\n  cursor: default;\n}\n\n.nav-tabs {\n  border-bottom: 1px solid #dee2e6;\n}\n.nav-tabs .nav-link {\n  margin-bottom: -1px;\n  border: 1px solid transparent;\n  border-top-left-radius: 0.375rem;\n  border-top-right-radius: 0.375rem;\n}\n.nav-tabs .nav-link:hover, .nav-tabs .nav-link:focus {\n  border-color: #e9ecef #e9ecef #dee2e6;\n}\n.nav-tabs .nav-link.disabled {\n  color: #8898aa;\n  background-color: transparent;\n  border-color: transparent;\n}\n.nav-tabs .nav-link.active,\n.nav-tabs .nav-item.show .nav-link {\n  color: #525f7f;\n  background-color: #f8f9fe;\n  border-color: #dee2e6 #dee2e6 #f8f9fe;\n}\n.nav-tabs .dropdown-menu {\n  margin-top: -1px;\n  border-top-left-radius: 0;\n  border-top-right-radius: 0;\n}\n\n.nav-pills .nav-link {\n  border-radius: 0.375rem;\n}\n.nav-pills .nav-link.active,\n.nav-pills .show > .nav-link {\n  color: #fff;\n  background-color: #3ba371;\n}\n\n.nav-fill > .nav-link,\n.nav-fill .nav-item {\n  flex: 1 1 auto;\n  text-align: center;\n}\n\n.nav-justified > .nav-link,\n.nav-justified .nav-item {\n  flex-basis: 0;\n  flex-grow: 1;\n  text-align: center;\n}\n\n.tab-content > .tab-pane {\n  display: none;\n}\n.tab-content > .active {\n  display: block;\n}\n\n.navbar {\n  position: relative;\n  display: flex;\n  flex-wrap: wrap;\n  align-items: center;\n  justify-content: space-between;\n  padding: 1rem 1rem;\n}\n.navbar .container,\n.navbar .container-fluid,\n.navbar .container-sm,\n.navbar .container-md,\n.navbar .container-lg,\n.navbar .container-xl {\n  display: flex;\n  flex-wrap: wrap;\n  align-items: center;\n  justify-content: space-between;\n}\n.navbar-brand {\n  display: inline-block;\n  padding-top: 0.0625rem;\n  padding-bottom: 0.0625rem;\n  margin-right: 1rem;\n  font-size: 1.25rem;\n  line-height: inherit;\n  white-space: nowrap;\n}\n.navbar-brand:hover, .navbar-brand:focus {\n  text-decoration: none;\n}\n\n.navbar-nav {\n  display: flex;\n  flex-direction: column;\n  padding-left: 0;\n  margin-bottom: 0;\n  list-style: none;\n}\n.navbar-nav .nav-link {\n  padding-right: 0;\n  padding-left: 0;\n}\n.navbar-nav .dropdown-menu {\n  position: static;\n  float: none;\n}\n\n.navbar-text {\n  display: inline-block;\n  padding-top: 0.25rem;\n  padding-bottom: 0.25rem;\n}\n\n.navbar-collapse {\n  flex-basis: 100%;\n  flex-grow: 1;\n  align-items: center;\n}\n\n.navbar-toggler {\n  padding: 0.25rem 0.75rem;\n  font-size: 1.25rem;\n  line-height: 1;\n  background-color: transparent;\n  border: 1px solid transparent;\n  border-radius: 0.375rem;\n}\n.navbar-toggler:hover, .navbar-toggler:focus {\n  text-decoration: none;\n}\n\n.navbar-toggler-icon {\n  display: inline-block;\n  width: 1.5em;\n  height: 1.5em;\n  vertical-align: middle;\n  content: \"\";\n  background: 50%/100% 100% no-repeat;\n}\n\n.navbar-nav-scroll {\n  max-height: 75vh;\n  overflow-y: auto;\n}\n\n@media (max-width: 575.98px) {\n  .navbar-expand-sm > .container,\n  .navbar-expand-sm > .container-fluid,\n  .navbar-expand-sm > .container-sm,\n  .navbar-expand-sm > .container-md,\n  .navbar-expand-sm > .container-lg,\n  .navbar-expand-sm > .container-xl {\n    padding-right: 0;\n    padding-left: 0;\n  }\n}\n@media (min-width: 576px) {\n  .navbar-expand-sm {\n    flex-flow: row nowrap;\n    justify-content: flex-start;\n  }\n  .navbar-expand-sm .navbar-nav {\n    flex-direction: row;\n  }\n  .navbar-expand-sm .navbar-nav .dropdown-menu {\n    position: absolute;\n  }\n  .navbar-expand-sm .navbar-nav .nav-link {\n    padding-right: 1rem;\n    padding-left: 1rem;\n  }\n  .navbar-expand-sm > .container,\n  .navbar-expand-sm > .container-fluid,\n  .navbar-expand-sm > .container-sm,\n  .navbar-expand-sm > .container-md,\n  .navbar-expand-sm > .container-lg,\n  .navbar-expand-sm > .container-xl {\n    flex-wrap: nowrap;\n  }\n  .navbar-expand-sm .navbar-nav-scroll {\n    overflow: visible;\n  }\n  .navbar-expand-sm .navbar-collapse {\n    display: flex !important;\n    flex-basis: auto;\n  }\n  .navbar-expand-sm .navbar-toggler {\n    display: none;\n  }\n}\n@media (max-width: 767.98px) {\n  .navbar-expand-md > .container,\n  .navbar-expand-md > .container-fluid,\n  .navbar-expand-md > .container-sm,\n  .navbar-expand-md > .container-md,\n  .navbar-expand-md > .container-lg,\n  .navbar-expand-md > .container-xl {\n    padding-right: 0;\n    padding-left: 0;\n  }\n}\n@media (min-width: 768px) {\n  .navbar-expand-md {\n    flex-flow: row nowrap;\n    justify-content: flex-start;\n  }\n  .navbar-expand-md .navbar-nav {\n    flex-direction: row;\n  }\n  .navbar-expand-md .navbar-nav .dropdown-menu {\n    position: absolute;\n  }\n  .navbar-expand-md .navbar-nav .nav-link {\n    padding-right: 1rem;\n    padding-left: 1rem;\n  }\n  .navbar-expand-md > .container,\n  .navbar-expand-md > .container-fluid,\n  .navbar-expand-md > .container-sm,\n  .navbar-expand-md > .container-md,\n  .navbar-expand-md > .container-lg,\n  .navbar-expand-md > .container-xl {\n    flex-wrap: nowrap;\n  }\n  .navbar-expand-md .navbar-nav-scroll {\n    overflow: visible;\n  }\n  .navbar-expand-md .navbar-collapse {\n    display: flex !important;\n    flex-basis: auto;\n  }\n  .navbar-expand-md .navbar-toggler {\n    display: none;\n  }\n}\n@media (max-width: 991.98px) {\n  .navbar-expand-lg > .container,\n  .navbar-expand-lg > .container-fluid,\n  .navbar-expand-lg > .container-sm,\n  .navbar-expand-lg > .container-md,\n  .navbar-expand-lg > .container-lg,\n  .navbar-expand-lg > .container-xl {\n    padding-right: 0;\n    padding-left: 0;\n  }\n}\n@media (min-width: 992px) {\n  .navbar-expand-lg {\n    flex-flow: row nowrap;\n    justify-content: flex-start;\n  }\n  .navbar-expand-lg .navbar-nav {\n    flex-direction: row;\n  }\n  .navbar-expand-lg .navbar-nav .dropdown-menu {\n    position: absolute;\n  }\n  .navbar-expand-lg .navbar-nav .nav-link {\n    padding-right: 1rem;\n    padding-left: 1rem;\n  }\n  .navbar-expand-lg > .container,\n  .navbar-expand-lg > .container-fluid,\n  .navbar-expand-lg > .container-sm,\n  .navbar-expand-lg > .container-md,\n  .navbar-expand-lg > .container-lg,\n  .navbar-expand-lg > .container-xl {\n    flex-wrap: nowrap;\n  }\n  .navbar-expand-lg .navbar-nav-scroll {\n    overflow: visible;\n  }\n  .navbar-expand-lg .navbar-collapse {\n    display: flex !important;\n    flex-basis: auto;\n  }\n  .navbar-expand-lg .navbar-toggler {\n    display: none;\n  }\n}\n@media (max-width: 1199.98px) {\n  .navbar-expand-xl > .container,\n  .navbar-expand-xl > .container-fluid,\n  .navbar-expand-xl > .container-sm,\n  .navbar-expand-xl > .container-md,\n  .navbar-expand-xl > .container-lg,\n  .navbar-expand-xl > .container-xl {\n    padding-right: 0;\n    padding-left: 0;\n  }\n}\n@media (min-width: 1200px) {\n  .navbar-expand-xl {\n    flex-flow: row nowrap;\n    justify-content: flex-start;\n  }\n  .navbar-expand-xl .navbar-nav {\n    flex-direction: row;\n  }\n  .navbar-expand-xl .navbar-nav .dropdown-menu {\n    position: absolute;\n  }\n  .navbar-expand-xl .navbar-nav .nav-link {\n    padding-right: 1rem;\n    padding-left: 1rem;\n  }\n  .navbar-expand-xl > .container,\n  .navbar-expand-xl > .container-fluid,\n  .navbar-expand-xl > .container-sm,\n  .navbar-expand-xl > .container-md,\n  .navbar-expand-xl > .container-lg,\n  .navbar-expand-xl > .container-xl {\n    flex-wrap: nowrap;\n  }\n  .navbar-expand-xl .navbar-nav-scroll {\n    overflow: visible;\n  }\n  .navbar-expand-xl .navbar-collapse {\n    display: flex !important;\n    flex-basis: auto;\n  }\n  .navbar-expand-xl .navbar-toggler {\n    display: none;\n  }\n}\n.navbar-expand {\n  flex-flow: row nowrap;\n  justify-content: flex-start;\n}\n.navbar-expand > .container,\n.navbar-expand > .container-fluid,\n.navbar-expand > .container-sm,\n.navbar-expand > .container-md,\n.navbar-expand > .container-lg,\n.navbar-expand > .container-xl {\n  padding-right: 0;\n  padding-left: 0;\n}\n.navbar-expand .navbar-nav {\n  flex-direction: row;\n}\n.navbar-expand .navbar-nav .dropdown-menu {\n  position: absolute;\n}\n.navbar-expand .navbar-nav .nav-link {\n  padding-right: 1rem;\n  padding-left: 1rem;\n}\n.navbar-expand > .container,\n.navbar-expand > .container-fluid,\n.navbar-expand > .container-sm,\n.navbar-expand > .container-md,\n.navbar-expand > .container-lg,\n.navbar-expand > .container-xl {\n  flex-wrap: nowrap;\n}\n.navbar-expand .navbar-nav-scroll {\n  overflow: visible;\n}\n.navbar-expand .navbar-collapse {\n  display: flex !important;\n  flex-basis: auto;\n}\n.navbar-expand .navbar-toggler {\n  display: none;\n}\n\n.navbar-light .navbar-brand {\n  color: rgba(0, 0, 0, 0.9);\n}\n.navbar-light .navbar-brand:hover, .navbar-light .navbar-brand:focus {\n  color: rgba(0, 0, 0, 0.9);\n}\n.navbar-light .navbar-nav .nav-link {\n  color: rgba(0, 0, 0, 0.5);\n}\n.navbar-light .navbar-nav .nav-link:hover, .navbar-light .navbar-nav .nav-link:focus {\n  color: rgba(0, 0, 0, 0.7);\n}\n.navbar-light .navbar-nav .nav-link.disabled {\n  color: rgba(0, 0, 0, 0.3);\n}\n.navbar-light .navbar-nav .show > .nav-link,\n.navbar-light .navbar-nav .active > .nav-link,\n.navbar-light .navbar-nav .nav-link.show,\n.navbar-light .navbar-nav .nav-link.active {\n  color: rgba(0, 0, 0, 0.9);\n}\n.navbar-light .navbar-toggler {\n  color: rgba(0, 0, 0, 0.5);\n  border-color: transparent;\n}\n.navbar-light .navbar-toggler-icon {\n  background-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' width='30' height='30' viewBox='0 0 30 30'%3e%3cpath stroke='rgba%280, 0, 0, 0.5%29' stroke-linecap='round' stroke-miterlimit='10' stroke-width='2' d='M4 7h22M4 15h22M4 23h22'/%3e%3c/svg%3e\");\n}\n.navbar-light .navbar-text {\n  color: rgba(0, 0, 0, 0.5);\n}\n.navbar-light .navbar-text a {\n  color: rgba(0, 0, 0, 0.9);\n}\n.navbar-light .navbar-text a:hover, .navbar-light .navbar-text a:focus {\n  color: rgba(0, 0, 0, 0.9);\n}\n\n.navbar-dark .navbar-brand {\n  color: rgba(255, 255, 255, 0.65);\n}\n.navbar-dark .navbar-brand:hover, .navbar-dark .navbar-brand:focus {\n  color: rgba(255, 255, 255, 0.65);\n}\n.navbar-dark .navbar-nav .nav-link {\n  color: rgba(255, 255, 255, 0.95);\n}\n.navbar-dark .navbar-nav .nav-link:hover, .navbar-dark .navbar-nav .nav-link:focus {\n  color: rgba(255, 255, 255, 0.65);\n}\n.navbar-dark .navbar-nav .nav-link.disabled {\n  color: rgba(255, 255, 255, 0.25);\n}\n.navbar-dark .navbar-nav .show > .nav-link,\n.navbar-dark .navbar-nav .active > .nav-link,\n.navbar-dark .navbar-nav .nav-link.show,\n.navbar-dark .navbar-nav .nav-link.active {\n  color: rgba(255, 255, 255, 0.65);\n}\n.navbar-dark .navbar-toggler {\n  color: rgba(255, 255, 255, 0.95);\n  border-color: transparent;\n}\n.navbar-dark .navbar-toggler-icon {\n  background-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' width='30' height='30' viewBox='0 0 30 30'%3e%3cpath stroke='rgba%28255, 255, 255, 0.95%29' stroke-linecap='round' stroke-miterlimit='10' stroke-width='2' d='M4 7h22M4 15h22M4 23h22'/%3e%3c/svg%3e\");\n}\n.navbar-dark .navbar-text {\n  color: rgba(255, 255, 255, 0.95);\n}\n.navbar-dark .navbar-text a {\n  color: rgba(255, 255, 255, 0.65);\n}\n.navbar-dark .navbar-text a:hover, .navbar-dark .navbar-text a:focus {\n  color: rgba(255, 255, 255, 0.65);\n}\n\n.card {\n  position: relative;\n  display: flex;\n  flex-direction: column;\n  min-width: 0;\n  word-wrap: break-word;\n  background-color: #fff;\n  background-clip: border-box;\n  border: 1px solid rgba(0, 0, 0, 0.05);\n  border-radius: 0.375rem;\n}\n.card > hr {\n  margin-right: 0;\n  margin-left: 0;\n}\n.card > .list-group {\n  border-top: inherit;\n  border-bottom: inherit;\n}\n.card > .list-group:first-child {\n  border-top-width: 0;\n  border-top-left-radius: calc(0.375rem - 1px);\n  border-top-right-radius: calc(0.375rem - 1px);\n}\n.card > .list-group:last-child {\n  border-bottom-width: 0;\n  border-bottom-right-radius: calc(0.375rem - 1px);\n  border-bottom-left-radius: calc(0.375rem - 1px);\n}\n.card > .card-header + .list-group,\n.card > .list-group + .card-footer {\n  border-top: 0;\n}\n\n.card-body {\n  flex: 1 1 auto;\n  min-height: 1px;\n  padding: 1.5rem;\n}\n\n.card-title {\n  margin-bottom: 1.25rem;\n}\n\n.card-subtitle {\n  margin-top: -0.625rem;\n  margin-bottom: 0;\n}\n\n.card-text:last-child {\n  margin-bottom: 0;\n}\n\n.card-link:hover {\n  text-decoration: none;\n}\n.card-link + .card-link {\n  margin-left: 1.5rem;\n}\n\n.card-header {\n  padding: 1.25rem 1.5rem;\n  margin-bottom: 0;\n  background-color: #fff;\n  border-bottom: 1px solid rgba(0, 0, 0, 0.05);\n}\n.card-header:first-child {\n  border-radius: calc(0.375rem - 1px) calc(0.375rem - 1px) 0 0;\n}\n\n.card-footer {\n  padding: 1.25rem 1.5rem;\n  background-color: #fff;\n  border-top: 1px solid rgba(0, 0, 0, 0.05);\n}\n.card-footer:last-child {\n  border-radius: 0 0 calc(0.375rem - 1px) calc(0.375rem - 1px);\n}\n\n.card-header-tabs {\n  margin-right: -0.75rem;\n  margin-bottom: -1.25rem;\n  margin-left: -0.75rem;\n  border-bottom: 0;\n}\n\n.card-header-pills {\n  margin-right: -0.75rem;\n  margin-left: -0.75rem;\n}\n\n.card-img-overlay {\n  position: absolute;\n  top: 0;\n  right: 0;\n  bottom: 0;\n  left: 0;\n  padding: 1.25rem;\n  border-radius: calc(0.375rem - 1px);\n}\n\n.card-img,\n.card-img-top,\n.card-img-bottom {\n  flex-shrink: 0;\n  width: 100%;\n}\n\n.card-img,\n.card-img-top {\n  border-top-left-radius: calc(0.375rem - 1px);\n  border-top-right-radius: calc(0.375rem - 1px);\n}\n\n.card-img,\n.card-img-bottom {\n  border-bottom-right-radius: calc(0.375rem - 1px);\n  border-bottom-left-radius: calc(0.375rem - 1px);\n}\n\n.card-deck .card {\n  margin-bottom: 15px;\n}\n@media (min-width: 576px) {\n  .card-deck {\n    display: flex;\n    flex-flow: row wrap;\n    margin-right: -15px;\n    margin-left: -15px;\n  }\n  .card-deck .card {\n    flex: 1 0 0%;\n    margin-right: 15px;\n    margin-bottom: 0;\n    margin-left: 15px;\n  }\n}\n\n.card-group > .card {\n  margin-bottom: 15px;\n}\n@media (min-width: 576px) {\n  .card-group {\n    display: flex;\n    flex-flow: row wrap;\n  }\n  .card-group > .card {\n    flex: 1 0 0%;\n    margin-bottom: 0;\n  }\n  .card-group > .card + .card {\n    margin-left: 0;\n    border-left: 0;\n  }\n  .card-group > .card:not(:last-child) {\n    border-top-right-radius: 0;\n    border-bottom-right-radius: 0;\n  }\n  .card-group > .card:not(:last-child) .card-img-top,\n  .card-group > .card:not(:last-child) .card-header {\n    border-top-right-radius: 0;\n  }\n  .card-group > .card:not(:last-child) .card-img-bottom,\n  .card-group > .card:not(:last-child) .card-footer {\n    border-bottom-right-radius: 0;\n  }\n  .card-group > .card:not(:first-child) {\n    border-top-left-radius: 0;\n    border-bottom-left-radius: 0;\n  }\n  .card-group > .card:not(:first-child) .card-img-top,\n  .card-group > .card:not(:first-child) .card-header {\n    border-top-left-radius: 0;\n  }\n  .card-group > .card:not(:first-child) .card-img-bottom,\n  .card-group > .card:not(:first-child) .card-footer {\n    border-bottom-left-radius: 0;\n  }\n}\n\n.card-columns .card {\n  margin-bottom: 1.25rem;\n}\n@media (min-width: 576px) {\n  .card-columns {\n    column-count: 3;\n    column-gap: 1.25rem;\n    orphans: 1;\n    widows: 1;\n  }\n  .card-columns .card {\n    display: inline-block;\n    width: 100%;\n  }\n}\n\n.accordion {\n  overflow-anchor: none;\n}\n.accordion > .card {\n  overflow: hidden;\n}\n.accordion > .card:not(:last-of-type) {\n  border-bottom: 0;\n  border-bottom-right-radius: 0;\n  border-bottom-left-radius: 0;\n}\n.accordion > .card:not(:first-of-type) {\n  border-top-left-radius: 0;\n  border-top-right-radius: 0;\n}\n.accordion > .card > .card-header {\n  border-radius: 0;\n  margin-bottom: -1px;\n}\n\n.breadcrumb {\n  display: flex;\n  flex-wrap: wrap;\n  padding: 0.75rem 1rem;\n  margin-bottom: 1rem;\n  list-style: none;\n  background-color: #e9ecef;\n  border-radius: 0.375rem;\n}\n\n.breadcrumb-item + .breadcrumb-item {\n  padding-left: 0.5rem;\n}\n.breadcrumb-item + .breadcrumb-item::before {\n  float: left;\n  padding-right: 0.5rem;\n  color: #8898aa;\n  content: \"/\";\n}\n.breadcrumb-item + .breadcrumb-item:hover::before {\n  text-decoration: underline;\n}\n.breadcrumb-item + .breadcrumb-item:hover::before {\n  text-decoration: none;\n}\n.breadcrumb-item.active {\n  color: #8898aa;\n}\n\n.pagination {\n  display: flex;\n  padding-left: 0;\n  list-style: none;\n  border-radius: 0.375rem;\n}\n\n.page-link {\n  position: relative;\n  display: block;\n  padding: 0.5rem 0.75rem;\n  margin-left: -1px;\n  line-height: 1.25;\n  color: #8898aa;\n  background-color: #fff;\n  border: 1px solid #dee2e6;\n}\n.page-link:hover {\n  z-index: 2;\n  color: #8898aa;\n  text-decoration: none;\n  background-color: #dee2e6;\n  border-color: #dee2e6;\n}\n.page-link:focus {\n  z-index: 3;\n  outline: 0;\n  box-shadow: none;\n}\n\n.page-item:first-child .page-link {\n  margin-left: 0;\n  border-top-left-radius: 0.375rem;\n  border-bottom-left-radius: 0.375rem;\n}\n.page-item:last-child .page-link {\n  border-top-right-radius: 0.375rem;\n  border-bottom-right-radius: 0.375rem;\n}\n.page-item.active .page-link {\n  z-index: 3;\n  color: #fff;\n  background-color: #3ba371;\n  border-color: #3ba371;\n}\n.page-item.disabled .page-link {\n  color: #8898aa;\n  pointer-events: none;\n  cursor: auto;\n  background-color: #fff;\n  border-color: #dee2e6;\n}\n\n.pagination-lg .page-link {\n  padding: 0.75rem 1.5rem;\n  font-size: 1.25rem;\n  line-height: 1.5;\n}\n.pagination-lg .page-item:first-child .page-link {\n  border-top-left-radius: 0.4375rem;\n  border-bottom-left-radius: 0.4375rem;\n}\n.pagination-lg .page-item:last-child .page-link {\n  border-top-right-radius: 0.4375rem;\n  border-bottom-right-radius: 0.4375rem;\n}\n\n.pagination-sm .page-link {\n  padding: 0.25rem 0.5rem;\n  font-size: 0.875rem;\n  line-height: 1.5;\n}\n.pagination-sm .page-item:first-child .page-link {\n  border-top-left-radius: 0.25rem;\n  border-bottom-left-radius: 0.25rem;\n}\n.pagination-sm .page-item:last-child .page-link {\n  border-top-right-radius: 0.25rem;\n  border-bottom-right-radius: 0.25rem;\n}\n\n.badge {\n  display: inline-block;\n  padding: 0.35rem 0.375rem;\n  font-size: 66%;\n  font-weight: 600;\n  line-height: 1;\n  text-align: center;\n  white-space: nowrap;\n  vertical-align: baseline;\n  border-radius: 0.375rem;\n  transition: color 0.15s ease-in-out, background-color 0.15s ease-in-out, border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;\n}\n@media (prefers-reduced-motion: reduce) {\n  .badge {\n    transition: none;\n  }\n}\na.badge:hover, a.badge:focus {\n  text-decoration: none;\n}\n\n.badge:empty {\n  display: none;\n}\n\n.btn .badge {\n  position: relative;\n  top: -1px;\n}\n\n.badge-pill {\n  padding-right: 0.875em;\n  padding-left: 0.875em;\n  border-radius: 10rem;\n}\n\n.badge-primary {\n  color: rgb(36.8959459459, 134.1040540541, 87.3693866944);\n  background-color: rgba(137.1554054054, 212.3445945946, 176.1959459459, 0.5);\n}\n.badge-primary[href]:hover, .badge-primary[href]:focus {\n  color: #fff;\n  text-decoration: none;\n  background-color: rgb(45.4459459459, 125.5540540541, 87.0405405405);\n}\n\n.badge-secondary {\n  color: rgb(206.8090909091, 227.4381818182, 241.1909090909);\n  background-color: rgba(255, 255, 255, 0.5);\n}\n.badge-secondary[href]:hover, .badge-secondary[href]:focus {\n  color: #212529;\n  text-decoration: none;\n  background-color: rgb(209.9090909091, 226.8181818182, 238.0909090909);\n}\n\n.badge-success {\n  color: rgb(36.0931506849, 131.9068493151, 86.3255752095);\n  background-color: rgba(134.801369863, 211.698630137, 175.1164383562, 0.5);\n}\n.badge-success[href]:hover, .badge-success[href]:focus {\n  color: #fff;\n  text-decoration: none;\n  background-color: rgb(44.4931506849, 123.5068493151, 85.9178082192);\n}\n\n.badge-info {\n  color: rgb(21.5110497238, 108.4889502762, 77.2444617283);\n  background-color: rgba(96.9171270718, 211.5828729282, 170.3922651934, 0.5);\n}\n.badge-info[href]:hover, .badge-info[href]:focus {\n  color: #fff;\n  text-decoration: none;\n  background-color: rgb(28.0110497238, 101.9889502762, 75.4143646409);\n}\n\n.badge-warning {\n  color: rgb(255, 55.0427807487, 9);\n  background-color: rgba(253.6153846154, 201, 188.8846153846, 0.5);\n}\n.badge-warning[href]:hover, .badge-warning[href]:focus {\n  color: #fff;\n  text-decoration: none;\n  background-color: rgb(249.9538461538, 58.2, 14.0461538462);\n}\n\n.badge-danger {\n  color: rgb(248, 0, 49.3403141361);\n  background-color: rgba(251.0426540284, 175.4573459716, 190.4952606635, 0.5);\n}\n.badge-danger[href]:hover, .badge-danger[href]:focus {\n  color: #fff;\n  text-decoration: none;\n  background-color: rgb(236.2464454976, 11.7535545024, 56.4170616114);\n}\n\n.badge-light {\n  color: rgb(134.7932432432, 155.5, 176.2067567568);\n  background-color: rgba(243.6418918919, 244.75, 245.8581081081, 0.5);\n}\n.badge-light[href]:hover, .badge-light[href]:focus {\n  color: #fff;\n  text-decoration: none;\n  background-color: rgb(144.7432432432, 155.5, 166.2567567568);\n}\n\n.badge-dark {\n  color: rgb(9.1067567568, 11.5, 13.8932432432);\n  background-color: rgba(89.8581081081, 100.75, 111.6418918919, 0.5);\n}\n.badge-dark[href]:hover, .badge-dark[href]:focus {\n  color: #fff;\n  text-decoration: none;\n  background-color: rgb(10.2567567568, 11.5, 12.7432432432);\n}\n\n.badge-default {\n  color: rgb(255, 198.7043478261, 89);\n  background-color: rgba(255, 255, 255, 0.5);\n}\n.badge-default[href]:hover, .badge-default[href]:focus {\n  color: #212529;\n  text-decoration: none;\n  background-color: rgb(255, 198.7043478261, 89);\n}\n\n.badge-white {\n  color: rgb(232.05, 226.95, 226.95);\n  background-color: rgba(255, 255, 255, 0.5);\n}\n.badge-white[href]:hover, .badge-white[href]:focus {\n  color: #212529;\n  text-decoration: none;\n  background-color: rgb(229.5, 229.5, 229.5);\n}\n\n.badge-neutral {\n  color: rgb(232.05, 226.95, 226.95);\n  background-color: rgba(255, 255, 255, 0.5);\n}\n.badge-neutral[href]:hover, .badge-neutral[href]:focus {\n  color: #212529;\n  text-decoration: none;\n  background-color: rgb(229.5, 229.5, 229.5);\n}\n\n.badge-darker {\n  color: black;\n  background-color: rgba(63.75, 63.75, 63.75, 0.5);\n}\n.badge-darker[href]:hover, .badge-darker[href]:focus {\n  color: #fff;\n  text-decoration: none;\n  background-color: black;\n}\n\n.jumbotron {\n  padding: 2rem 1rem;\n  margin-bottom: 2rem;\n  background-color: #e9ecef;\n  border-radius: 0.4375rem;\n}\n@media (min-width: 576px) {\n  .jumbotron {\n    padding: 4rem 2rem;\n  }\n}\n\n.jumbotron-fluid {\n  padding-right: 0;\n  padding-left: 0;\n  border-radius: 0;\n}\n\n.alert {\n  position: relative;\n  padding: 1rem 1.5rem;\n  margin-bottom: 1rem;\n  border: 1px solid transparent;\n  border-radius: 0.375rem;\n}\n\n.alert-heading {\n  color: inherit;\n}\n\n.alert-link {\n  font-weight: 600;\n}\n\n.alert-dismissible {\n  padding-right: 4.5rem;\n}\n.alert-dismissible .close {\n  position: absolute;\n  top: 0;\n  right: 0;\n  z-index: 2;\n  padding: 1rem 1.5rem;\n  color: inherit;\n}\n\n.alert-primary {\n  color: #fff;\n  background-color: rgb(90.36, 177.72, 135.72);\n  border-color: rgb(90.36, 177.72, 135.72);\n}\n.alert-primary hr {\n  border-top-color: rgb(77.4908333333, 165.0891666667, 122.9745833333);\n}\n.alert-primary .alert-link {\n  color: rgb(45.4459459459, 125.5540540541, 87.0405405405);\n}\n\n.alert-secondary {\n  color: #212529;\n  background-color: rgb(248.28, 250.8, 252.48);\n  border-color: rgb(248.28, 250.8, 252.48);\n}\n.alert-secondary hr {\n  border-top-color: rgb(229.7345454545, 239.2090909091, 245.5254545455);\n}\n.alert-secondary .alert-link {\n  color: rgb(209.9090909091, 226.8181818182, 238.0909090909);\n}\n\n.alert-success {\n  color: #fff;\n  background-color: rgb(89.52, 176.04, 134.88);\n  border-color: rgb(89.52, 176.04, 134.88);\n}\n.alert-success hr {\n  border-top-color: rgb(77.5451546392, 162.5148453608, 122.092371134);\n}\n.alert-success .alert-link {\n  color: rgb(44.4931506849, 123.5068493151, 85.9178082192);\n}\n\n.alert-info {\n  color: #fff;\n  background-color: rgb(73.56, 160.08, 129);\n  border-color: rgb(73.56, 160.08, 129);\n}\n.alert-info hr {\n  border-top-color: rgb(65.5314946071, 142.6085053929, 114.9206471495);\n}\n.alert-info .alert-link {\n  color: rgb(28.0110497238, 101.9889502762, 75.4143646409);\n}\n\n.alert-warning {\n  color: #fff;\n  background-color: rgb(251.64, 123.96, 94.56);\n  border-color: rgb(251.64, 123.96, 94.56);\n}\n.alert-warning hr {\n  border-top-color: rgb(251.1169230769, 103.56, 69.5830769231);\n}\n.alert-warning .alert-link {\n  color: rgb(249.9538461538, 58.2, 14.0461538462);\n}\n\n.alert-danger {\n  color: #fff;\n  background-color: rgb(246.6, 86.16, 118.08);\n  border-color: rgb(246.6, 86.16, 118.08);\n}\n.alert-danger hr {\n  border-top-color: rgb(245.3914691943, 61.8685308057, 98.3809478673);\n}\n.alert-danger .alert-link {\n  color: rgb(236.2464454976, 11.7535545024, 56.4170616114);\n}\n\n.alert-light {\n  color: #fff;\n  background-color: rgb(186.12, 192.84, 199.56);\n  border-color: rgb(186.12, 192.84, 199.56);\n}\n.alert-light hr {\n  border-top-color: rgb(171.9916216216, 180.09, 188.1883783784);\n}\n.alert-light .alert-link {\n  color: rgb(144.7432432432, 155.5, 166.2567567568);\n}\n\n.alert-dark {\n  color: #fff;\n  background-color: rgb(68.52, 71.88, 75.24);\n  border-color: rgb(68.52, 71.88, 75.24);\n}\n.alert-dark hr {\n  border-top-color: rgb(56.3659933222, 59.13, 61.8940066778);\n}\n.alert-dark .alert-link {\n  color: rgb(10.2567567568, 11.5, 12.7432432432);\n}\n\n.alert-default {\n  color: #212529;\n  background-color: rgb(255, 222.24, 158.4);\n  border-color: rgb(255, 222.24, 158.4);\n}\n.alert-default hr {\n  border-top-color: rgb(255, 213.592173913, 132.9);\n}\n.alert-default .alert-link {\n  color: rgb(255, 198.7043478261, 89);\n}\n\n.alert-white {\n  color: #212529;\n  background-color: white;\n  border-color: white;\n}\n.alert-white hr {\n  border-top-color: rgb(242.25, 242.25, 242.25);\n}\n.alert-white .alert-link {\n  color: rgb(229.5, 229.5, 229.5);\n}\n\n.alert-neutral {\n  color: #212529;\n  background-color: white;\n  border-color: white;\n}\n.alert-neutral hr {\n  border-top-color: rgb(242.25, 242.25, 242.25);\n}\n.alert-neutral .alert-link {\n  color: rgb(229.5, 229.5, 229.5);\n}\n\n.alert-darker {\n  color: #fff;\n  background-color: rgb(40.8, 40.8, 40.8);\n  border-color: rgb(40.8, 40.8, 40.8);\n}\n.alert-darker hr {\n  border-top-color: rgb(28.05, 28.05, 28.05);\n}\n.alert-darker .alert-link {\n  color: black;\n}\n\n@keyframes progress-bar-stripes {\n  from {\n    background-position: 1rem 0;\n  }\n  to {\n    background-position: 0 0;\n  }\n}\n.progress {\n  display: flex;\n  height: 1rem;\n  overflow: hidden;\n  line-height: 0;\n  font-size: 0.75rem;\n  background-color: #e9ecef;\n  border-radius: 0.375rem;\n  box-shadow: inset 0 0.1rem 0.1rem rgba(0, 0, 0, 0.1);\n}\n\n.progress-bar {\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  overflow: hidden;\n  color: #fff;\n  text-align: center;\n  white-space: nowrap;\n  background-color: #3ba371;\n  transition: width 0.6s ease;\n}\n@media (prefers-reduced-motion: reduce) {\n  .progress-bar {\n    transition: none;\n  }\n}\n\n.progress-bar-striped {\n  background-image: linear-gradient(45deg, rgba(255, 255, 255, 0.15) 25%, transparent 25%, transparent 50%, rgba(255, 255, 255, 0.15) 50%, rgba(255, 255, 255, 0.15) 75%, transparent 75%, transparent);\n  background-size: 1rem 1rem;\n}\n\n.progress-bar-animated {\n  animation: 1s linear infinite progress-bar-stripes;\n}\n@media (prefers-reduced-motion: reduce) {\n  .progress-bar-animated {\n    animation: none;\n  }\n}\n\n.media {\n  display: flex;\n  align-items: flex-start;\n}\n\n.media-body {\n  flex: 1;\n}\n\n.list-group {\n  display: flex;\n  flex-direction: column;\n  padding-left: 0;\n  margin-bottom: 0;\n  border-radius: 0.375rem;\n}\n\n.list-group-item-action {\n  width: 100%;\n  color: #525f7f;\n  text-align: inherit;\n}\n.list-group-item-action:hover, .list-group-item-action:focus {\n  z-index: 1;\n  color: #525f7f;\n  text-decoration: none;\n  background-color: #f6f9fc;\n}\n.list-group-item-action:active {\n  color: #525f7f;\n  background-color: #e9ecef;\n}\n\n.list-group-item {\n  position: relative;\n  display: block;\n  padding: 1rem 1rem;\n  background-color: #fff;\n  border: 1px solid #e9ecef;\n}\n.list-group-item:first-child {\n  border-top-left-radius: inherit;\n  border-top-right-radius: inherit;\n}\n.list-group-item:last-child {\n  border-bottom-right-radius: inherit;\n  border-bottom-left-radius: inherit;\n}\n.list-group-item.disabled, .list-group-item:disabled {\n  color: #8898aa;\n  pointer-events: none;\n  background-color: #fff;\n}\n.list-group-item.active {\n  z-index: 2;\n  color: #fff;\n  background-color: #3ba371;\n  border-color: #3ba371;\n}\n.list-group-item + .list-group-item {\n  border-top-width: 0;\n}\n.list-group-item + .list-group-item.active {\n  margin-top: -1px;\n  border-top-width: 1px;\n}\n\n.list-group-horizontal {\n  flex-direction: row;\n}\n.list-group-horizontal > .list-group-item:first-child {\n  border-bottom-left-radius: 0.375rem;\n  border-top-right-radius: 0;\n}\n.list-group-horizontal > .list-group-item:last-child {\n  border-top-right-radius: 0.375rem;\n  border-bottom-left-radius: 0;\n}\n.list-group-horizontal > .list-group-item.active {\n  margin-top: 0;\n}\n.list-group-horizontal > .list-group-item + .list-group-item {\n  border-top-width: 1px;\n  border-left-width: 0;\n}\n.list-group-horizontal > .list-group-item + .list-group-item.active {\n  margin-left: -1px;\n  border-left-width: 1px;\n}\n\n@media (min-width: 576px) {\n  .list-group-horizontal-sm {\n    flex-direction: row;\n  }\n  .list-group-horizontal-sm > .list-group-item:first-child {\n    border-bottom-left-radius: 0.375rem;\n    border-top-right-radius: 0;\n  }\n  .list-group-horizontal-sm > .list-group-item:last-child {\n    border-top-right-radius: 0.375rem;\n    border-bottom-left-radius: 0;\n  }\n  .list-group-horizontal-sm > .list-group-item.active {\n    margin-top: 0;\n  }\n  .list-group-horizontal-sm > .list-group-item + .list-group-item {\n    border-top-width: 1px;\n    border-left-width: 0;\n  }\n  .list-group-horizontal-sm > .list-group-item + .list-group-item.active {\n    margin-left: -1px;\n    border-left-width: 1px;\n  }\n}\n@media (min-width: 768px) {\n  .list-group-horizontal-md {\n    flex-direction: row;\n  }\n  .list-group-horizontal-md > .list-group-item:first-child {\n    border-bottom-left-radius: 0.375rem;\n    border-top-right-radius: 0;\n  }\n  .list-group-horizontal-md > .list-group-item:last-child {\n    border-top-right-radius: 0.375rem;\n    border-bottom-left-radius: 0;\n  }\n  .list-group-horizontal-md > .list-group-item.active {\n    margin-top: 0;\n  }\n  .list-group-horizontal-md > .list-group-item + .list-group-item {\n    border-top-width: 1px;\n    border-left-width: 0;\n  }\n  .list-group-horizontal-md > .list-group-item + .list-group-item.active {\n    margin-left: -1px;\n    border-left-width: 1px;\n  }\n}\n@media (min-width: 992px) {\n  .list-group-horizontal-lg {\n    flex-direction: row;\n  }\n  .list-group-horizontal-lg > .list-group-item:first-child {\n    border-bottom-left-radius: 0.375rem;\n    border-top-right-radius: 0;\n  }\n  .list-group-horizontal-lg > .list-group-item:last-child {\n    border-top-right-radius: 0.375rem;\n    border-bottom-left-radius: 0;\n  }\n  .list-group-horizontal-lg > .list-group-item.active {\n    margin-top: 0;\n  }\n  .list-group-horizontal-lg > .list-group-item + .list-group-item {\n    border-top-width: 1px;\n    border-left-width: 0;\n  }\n  .list-group-horizontal-lg > .list-group-item + .list-group-item.active {\n    margin-left: -1px;\n    border-left-width: 1px;\n  }\n}\n@media (min-width: 1200px) {\n  .list-group-horizontal-xl {\n    flex-direction: row;\n  }\n  .list-group-horizontal-xl > .list-group-item:first-child {\n    border-bottom-left-radius: 0.375rem;\n    border-top-right-radius: 0;\n  }\n  .list-group-horizontal-xl > .list-group-item:last-child {\n    border-top-right-radius: 0.375rem;\n    border-bottom-left-radius: 0;\n  }\n  .list-group-horizontal-xl > .list-group-item.active {\n    margin-top: 0;\n  }\n  .list-group-horizontal-xl > .list-group-item + .list-group-item {\n    border-top-width: 1px;\n    border-left-width: 0;\n  }\n  .list-group-horizontal-xl > .list-group-item + .list-group-item.active {\n    margin-left: -1px;\n    border-left-width: 1px;\n  }\n}\n.list-group-flush {\n  border-radius: 0;\n}\n.list-group-flush > .list-group-item {\n  border-width: 0 0 1px;\n}\n.list-group-flush > .list-group-item:last-child {\n  border-bottom-width: 0;\n}\n\n.list-group-item-primary {\n  color: rgb(30.68, 84.76, 58.76);\n  background-color: rgb(200.12, 229.24, 215.24);\n}\n.list-group-item-primary.list-group-item-action:hover, .list-group-item-primary.list-group-item-action:focus {\n  color: rgb(30.68, 84.76, 58.76);\n  background-color: rgb(182.7658333333, 221.0941666667, 202.6670833333);\n}\n.list-group-item-primary.list-group-item-action.active {\n  color: #fff;\n  background-color: rgb(30.68, 84.76, 58.76);\n  border-color: rgb(30.68, 84.76, 58.76);\n}\n\n.list-group-item-secondary {\n  color: rgb(128.44, 130, 131.04);\n  background-color: rgb(252.76, 253.6, 254.16);\n}\n.list-group-item-secondary.list-group-item-action:hover, .list-group-item-secondary.list-group-item-action:focus {\n  color: rgb(128.44, 130, 131.04);\n  background-color: rgb(234.2145454545, 242.0090909091, 247.2054545455);\n}\n.list-group-item-secondary.list-group-item-action.active {\n  color: #fff;\n  background-color: rgb(128.44, 130, 131.04);\n  border-color: rgb(128.44, 130, 131.04);\n}\n\n.list-group-item-success {\n  color: rgb(30.16, 83.72, 58.24);\n  background-color: rgb(199.84, 228.68, 214.96);\n}\n.list-group-item-success.list-group-item-action:hover, .list-group-item-success.list-group-item-action:focus {\n  color: rgb(30.16, 83.72, 58.24);\n  background-color: rgb(182.5771134021, 220.4428865979, 202.4290721649);\n}\n.list-group-item-success.list-group-item-action.active {\n  color: #fff;\n  background-color: rgb(30.16, 83.72, 58.24);\n  border-color: rgb(30.16, 83.72, 58.24);\n}\n\n.list-group-item-info {\n  color: rgb(20.28, 73.84, 54.6);\n  background-color: rgb(194.52, 223.36, 213);\n}\n.list-group-item-info.list-group-item-action:hover, .list-group-item-info.list-group-item-action:focus {\n  color: rgb(20.28, 73.84, 54.6);\n  background-color: rgb(177.7783586626, 214.6016413374, 201.3738601824);\n}\n.list-group-item-info.list-group-item-action.active {\n  color: #fff;\n  background-color: rgb(20.28, 73.84, 54.6);\n  border-color: rgb(20.28, 73.84, 54.6);\n}\n\n.list-group-item-warning {\n  color: rgb(130.52, 51.48, 33.28);\n  background-color: rgb(253.88, 211.32, 201.52);\n}\n.list-group-item-warning.list-group-item-action:hover, .list-group-item-warning.list-group-item-action:focus {\n  color: rgb(130.52, 51.48, 33.28);\n  background-color: rgb(253.3569230769, 190.92, 176.5430769231);\n}\n.list-group-item-warning.list-group-item-action.active {\n  color: #fff;\n  background-color: rgb(130.52, 51.48, 33.28);\n  border-color: rgb(130.52, 51.48, 33.28);\n}\n\n.list-group-item-danger {\n  color: rgb(127.4, 28.08, 47.84);\n  background-color: rgb(252.2, 198.72, 209.36);\n}\n.list-group-item-danger.list-group-item-action:hover, .list-group-item-danger.list-group-item-action:focus {\n  color: rgb(127.4, 28.08, 47.84);\n  background-color: rgb(250.9914691943, 174.4285308057, 189.6609478673);\n}\n.list-group-item-danger.list-group-item-action.active {\n  color: #fff;\n  background-color: rgb(127.4, 28.08, 47.84);\n  border-color: rgb(127.4, 28.08, 47.84);\n}\n\n.list-group-item-light {\n  color: rgb(89.96, 94.12, 98.28);\n  background-color: rgb(232.04, 234.28, 236.52);\n}\n.list-group-item-light.list-group-item-action:hover, .list-group-item-light.list-group-item-action:focus {\n  color: rgb(89.96, 94.12, 98.28);\n  background-color: rgb(217.9116216216, 221.53, 225.1483783784);\n}\n.list-group-item-light.list-group-item-action.active {\n  color: #fff;\n  background-color: rgb(89.96, 94.12, 98.28);\n  border-color: rgb(89.96, 94.12, 98.28);\n}\n\n.list-group-item-dark {\n  color: rgb(17.16, 19.24, 21.32);\n  background-color: rgb(192.84, 193.96, 195.08);\n}\n.list-group-item-dark.list-group-item-action:hover, .list-group-item-dark.list-group-item-action:focus {\n  color: rgb(17.16, 19.24, 21.32);\n  background-color: rgb(179.8560550459, 181.21, 182.5639449541);\n}\n.list-group-item-dark.list-group-item-action.active {\n  color: #fff;\n  background-color: rgb(17.16, 19.24, 21.32);\n  border-color: rgb(17.16, 19.24, 21.32);\n}\n\n.list-group-item-default {\n  color: rgb(132.6, 112.32, 72.8);\n  background-color: rgb(255, 244.08, 222.8);\n}\n.list-group-item-default.list-group-item-action:hover, .list-group-item-default.list-group-item-action:focus {\n  color: rgb(132.6, 112.32, 72.8);\n  background-color: rgb(255, 235.432173913, 197.3);\n}\n.list-group-item-default.list-group-item-action.active {\n  color: #fff;\n  background-color: rgb(132.6, 112.32, 72.8);\n  border-color: rgb(132.6, 112.32, 72.8);\n}\n\n.list-group-item-white {\n  color: rgb(132.6, 132.6, 132.6);\n  background-color: white;\n}\n.list-group-item-white.list-group-item-action:hover, .list-group-item-white.list-group-item-action:focus {\n  color: rgb(132.6, 132.6, 132.6);\n  background-color: rgb(242.25, 242.25, 242.25);\n}\n.list-group-item-white.list-group-item-action.active {\n  color: #fff;\n  background-color: rgb(132.6, 132.6, 132.6);\n  border-color: rgb(132.6, 132.6, 132.6);\n}\n\n.list-group-item-neutral {\n  color: rgb(132.6, 132.6, 132.6);\n  background-color: white;\n}\n.list-group-item-neutral.list-group-item-action:hover, .list-group-item-neutral.list-group-item-action:focus {\n  color: rgb(132.6, 132.6, 132.6);\n  background-color: rgb(242.25, 242.25, 242.25);\n}\n.list-group-item-neutral.list-group-item-action.active {\n  color: #fff;\n  background-color: rgb(132.6, 132.6, 132.6);\n  border-color: rgb(132.6, 132.6, 132.6);\n}\n\n.list-group-item-darker {\n  color: black;\n  background-color: rgb(183.6, 183.6, 183.6);\n}\n.list-group-item-darker.list-group-item-action:hover, .list-group-item-darker.list-group-item-action:focus {\n  color: black;\n  background-color: rgb(170.85, 170.85, 170.85);\n}\n.list-group-item-darker.list-group-item-action.active {\n  color: #fff;\n  background-color: black;\n  border-color: black;\n}\n\n.close {\n  float: right;\n  font-size: 1.5rem;\n  font-weight: 600;\n  line-height: 1;\n  color: rgba(0, 0, 0, 0.6);\n  text-shadow: none;\n  opacity: 0.5;\n}\n.close:hover {\n  color: rgba(0, 0, 0, 0.6);\n  text-decoration: none;\n}\n.close:not(:disabled):not(.disabled):hover, .close:not(:disabled):not(.disabled):focus {\n  opacity: 0.75;\n}\n\nbutton.close {\n  padding: 0;\n  background-color: transparent;\n  border: 0;\n}\n\na.close.disabled {\n  pointer-events: none;\n}\n\n.modal-open {\n  overflow: hidden;\n}\n.modal-open .modal {\n  overflow-x: hidden;\n  overflow-y: auto;\n}\n\n.modal {\n  position: fixed;\n  top: 0;\n  left: 0;\n  z-index: 1050;\n  display: none;\n  width: 100%;\n  height: 100%;\n  overflow: hidden;\n  outline: 0;\n}\n\n.modal-dialog {\n  position: relative;\n  width: auto;\n  margin: 0.5rem;\n  pointer-events: none;\n}\n.modal.fade .modal-dialog {\n  transition: transform 0.3s ease-out;\n  transform: translate(0, -50px);\n}\n@media (prefers-reduced-motion: reduce) {\n  .modal.fade .modal-dialog {\n    transition: none;\n  }\n}\n.modal.show .modal-dialog {\n  transform: none;\n}\n.modal.modal-static .modal-dialog {\n  transform: scale(1.02);\n}\n\n.modal-dialog-scrollable {\n  display: flex;\n  max-height: calc(100% - 1rem);\n}\n.modal-dialog-scrollable .modal-content {\n  max-height: calc(100vh - 1rem);\n  overflow: hidden;\n}\n.modal-dialog-scrollable .modal-header,\n.modal-dialog-scrollable .modal-footer {\n  flex-shrink: 0;\n}\n.modal-dialog-scrollable .modal-body {\n  overflow-y: auto;\n}\n\n.modal-dialog-centered {\n  display: flex;\n  align-items: center;\n  min-height: calc(100% - 1rem);\n}\n.modal-dialog-centered::before {\n  display: block;\n  height: calc(100vh - 1rem);\n  height: min-content;\n  content: \"\";\n}\n.modal-dialog-centered.modal-dialog-scrollable {\n  flex-direction: column;\n  justify-content: center;\n  height: 100%;\n}\n.modal-dialog-centered.modal-dialog-scrollable .modal-content {\n  max-height: none;\n}\n.modal-dialog-centered.modal-dialog-scrollable::before {\n  content: none;\n}\n\n.modal-content {\n  position: relative;\n  display: flex;\n  flex-direction: column;\n  width: 100%;\n  pointer-events: auto;\n  background-color: #fff;\n  background-clip: padding-box;\n  border: 0 solid rgba(0, 0, 0, 0.2);\n  border-radius: 0.4375rem;\n  box-shadow: 0 15px 35px rgba(50, 50, 93, 0.2), 0 5px 15px rgba(0, 0, 0, 0.17);\n  outline: 0;\n}\n\n.modal-backdrop {\n  position: fixed;\n  top: 0;\n  left: 0;\n  z-index: 1040;\n  width: 100vw;\n  height: 100vh;\n  background-color: #000;\n}\n.modal-backdrop.fade {\n  opacity: 0;\n}\n.modal-backdrop.show {\n  opacity: 0.16;\n}\n\n.modal-header {\n  display: flex;\n  align-items: flex-start;\n  justify-content: space-between;\n  padding: 1.25rem;\n  border-bottom: 0 solid #e9ecef;\n  border-top-left-radius: 0.4375rem;\n  border-top-right-radius: 0.4375rem;\n}\n.modal-header .close {\n  padding: 1.25rem;\n  margin: -1rem -1rem -1rem auto;\n}\n\n.modal-title {\n  margin-bottom: 0;\n  line-height: 1.1;\n}\n\n.modal-body {\n  position: relative;\n  flex: 1 1 auto;\n  padding: 1.5rem;\n}\n\n.modal-footer {\n  display: flex;\n  flex-wrap: wrap;\n  align-items: center;\n  justify-content: flex-end;\n  padding: 1.25rem;\n  border-top: 0 solid #e9ecef;\n  border-bottom-right-radius: 0.4375rem;\n  border-bottom-left-radius: 0.4375rem;\n}\n.modal-footer > * {\n  margin: 0.25rem;\n}\n\n.modal-scrollbar-measure {\n  position: absolute;\n  top: -9999px;\n  width: 50px;\n  height: 50px;\n  overflow: scroll;\n}\n\n@media (min-width: 576px) {\n  .modal-dialog {\n    max-width: 500px;\n    margin: 1.75rem auto;\n  }\n  .modal-dialog-scrollable {\n    max-height: calc(100% - 3.5rem);\n  }\n  .modal-dialog-scrollable .modal-content {\n    max-height: calc(100vh - 3.5rem);\n  }\n  .modal-dialog-centered {\n    min-height: calc(100% - 3.5rem);\n  }\n  .modal-dialog-centered::before {\n    height: calc(100vh - 3.5rem);\n    height: min-content;\n  }\n  .modal-content {\n    box-shadow: 0 15px 35px rgba(50, 50, 93, 0.2), 0 5px 15px rgba(0, 0, 0, 0.17);\n  }\n  .modal-sm {\n    max-width: 380px;\n  }\n}\n@media (min-width: 992px) {\n  .modal-lg,\n  .modal-xl {\n    max-width: 800px;\n  }\n}\n@media (min-width: 1200px) {\n  .modal-xl {\n    max-width: 1140px;\n  }\n}\n.tooltip {\n  position: absolute;\n  z-index: 1070;\n  display: block;\n  margin: 0;\n  font-family: Open Sans, sans-serif;\n  font-style: normal;\n  font-weight: 400;\n  line-height: 1.5;\n  text-align: left;\n  text-align: start;\n  text-decoration: none;\n  text-shadow: none;\n  text-transform: none;\n  letter-spacing: normal;\n  word-break: normal;\n  word-spacing: normal;\n  white-space: normal;\n  line-break: auto;\n  font-size: 0.875rem;\n  word-wrap: break-word;\n  opacity: 0;\n}\n.tooltip.show {\n  opacity: 0.9;\n}\n.tooltip .arrow {\n  position: absolute;\n  display: block;\n  width: 0.8rem;\n  height: 0.4rem;\n}\n.tooltip .arrow::before {\n  position: absolute;\n  content: \"\";\n  border-color: transparent;\n  border-style: solid;\n}\n\n.bs-tooltip-top, .bs-tooltip-auto[x-placement^=top] {\n  padding: 0.4rem 0;\n}\n.bs-tooltip-top .arrow, .bs-tooltip-auto[x-placement^=top] .arrow {\n  bottom: 0;\n}\n.bs-tooltip-top .arrow::before, .bs-tooltip-auto[x-placement^=top] .arrow::before {\n  top: 0;\n  border-width: 0.4rem 0.4rem 0;\n  border-top-color: #000;\n}\n\n.bs-tooltip-right, .bs-tooltip-auto[x-placement^=right] {\n  padding: 0 0.4rem;\n}\n.bs-tooltip-right .arrow, .bs-tooltip-auto[x-placement^=right] .arrow {\n  left: 0;\n  width: 0.4rem;\n  height: 0.8rem;\n}\n.bs-tooltip-right .arrow::before, .bs-tooltip-auto[x-placement^=right] .arrow::before {\n  right: 0;\n  border-width: 0.4rem 0.4rem 0.4rem 0;\n  border-right-color: #000;\n}\n\n.bs-tooltip-bottom, .bs-tooltip-auto[x-placement^=bottom] {\n  padding: 0.4rem 0;\n}\n.bs-tooltip-bottom .arrow, .bs-tooltip-auto[x-placement^=bottom] .arrow {\n  top: 0;\n}\n.bs-tooltip-bottom .arrow::before, .bs-tooltip-auto[x-placement^=bottom] .arrow::before {\n  bottom: 0;\n  border-width: 0 0.4rem 0.4rem;\n  border-bottom-color: #000;\n}\n\n.bs-tooltip-left, .bs-tooltip-auto[x-placement^=left] {\n  padding: 0 0.4rem;\n}\n.bs-tooltip-left .arrow, .bs-tooltip-auto[x-placement^=left] .arrow {\n  right: 0;\n  width: 0.4rem;\n  height: 0.8rem;\n}\n.bs-tooltip-left .arrow::before, .bs-tooltip-auto[x-placement^=left] .arrow::before {\n  left: 0;\n  border-width: 0.4rem 0 0.4rem 0.4rem;\n  border-left-color: #000;\n}\n\n.tooltip-inner {\n  max-width: 200px;\n  padding: 0.25rem 0.5rem;\n  color: #fff;\n  text-align: center;\n  background-color: #000;\n  border-radius: 0.375rem;\n}\n\n.popover {\n  position: absolute;\n  top: 0;\n  left: 0;\n  z-index: 1060;\n  display: block;\n  max-width: 276px;\n  font-family: Open Sans, sans-serif;\n  font-style: normal;\n  font-weight: 400;\n  line-height: 1.5;\n  text-align: left;\n  text-align: start;\n  text-decoration: none;\n  text-shadow: none;\n  text-transform: none;\n  letter-spacing: normal;\n  word-break: normal;\n  word-spacing: normal;\n  white-space: normal;\n  line-break: auto;\n  font-size: 0.875rem;\n  word-wrap: break-word;\n  background-color: #fff;\n  background-clip: padding-box;\n  border: 1px solid rgba(0, 0, 0, 0.05);\n  border-radius: 0.4375rem;\n  box-shadow: 0px 0.5rem 2rem 0px rgba(0, 0, 0, 0.2);\n}\n.popover .arrow {\n  position: absolute;\n  display: block;\n  width: 1.5rem;\n  height: 0.75rem;\n  margin: 0 0.4375rem;\n}\n.popover .arrow::before, .popover .arrow::after {\n  position: absolute;\n  display: block;\n  content: \"\";\n  border-color: transparent;\n  border-style: solid;\n}\n\n.bs-popover-top, .bs-popover-auto[x-placement^=top] {\n  margin-bottom: 0.75rem;\n}\n.bs-popover-top > .arrow, .bs-popover-auto[x-placement^=top] > .arrow {\n  bottom: calc(-0.75rem - 1px);\n}\n.bs-popover-top > .arrow::before, .bs-popover-auto[x-placement^=top] > .arrow::before {\n  bottom: 0;\n  border-width: 0.75rem 0.75rem 0;\n  border-top-color: transparent;\n}\n.bs-popover-top > .arrow::after, .bs-popover-auto[x-placement^=top] > .arrow::after {\n  bottom: 1px;\n  border-width: 0.75rem 0.75rem 0;\n  border-top-color: #fff;\n}\n\n.bs-popover-right, .bs-popover-auto[x-placement^=right] {\n  margin-left: 0.75rem;\n}\n.bs-popover-right > .arrow, .bs-popover-auto[x-placement^=right] > .arrow {\n  left: calc(-0.75rem - 1px);\n  width: 0.75rem;\n  height: 1.5rem;\n  margin: 0.4375rem 0;\n}\n.bs-popover-right > .arrow::before, .bs-popover-auto[x-placement^=right] > .arrow::before {\n  left: 0;\n  border-width: 0.75rem 0.75rem 0.75rem 0;\n  border-right-color: transparent;\n}\n.bs-popover-right > .arrow::after, .bs-popover-auto[x-placement^=right] > .arrow::after {\n  left: 1px;\n  border-width: 0.75rem 0.75rem 0.75rem 0;\n  border-right-color: #fff;\n}\n\n.bs-popover-bottom, .bs-popover-auto[x-placement^=bottom] {\n  margin-top: 0.75rem;\n}\n.bs-popover-bottom > .arrow, .bs-popover-auto[x-placement^=bottom] > .arrow {\n  top: calc(-0.75rem - 1px);\n}\n.bs-popover-bottom > .arrow::before, .bs-popover-auto[x-placement^=bottom] > .arrow::before {\n  top: 0;\n  border-width: 0 0.75rem 0.75rem 0.75rem;\n  border-bottom-color: transparent;\n}\n.bs-popover-bottom > .arrow::after, .bs-popover-auto[x-placement^=bottom] > .arrow::after {\n  top: 1px;\n  border-width: 0 0.75rem 0.75rem 0.75rem;\n  border-bottom-color: #fff;\n}\n.bs-popover-bottom .popover-header::before, .bs-popover-auto[x-placement^=bottom] .popover-header::before {\n  position: absolute;\n  top: 0;\n  left: 50%;\n  display: block;\n  width: 1.5rem;\n  margin-left: -0.75rem;\n  content: \"\";\n  border-bottom: 1px solid #fff;\n}\n\n.bs-popover-left, .bs-popover-auto[x-placement^=left] {\n  margin-right: 0.75rem;\n}\n.bs-popover-left > .arrow, .bs-popover-auto[x-placement^=left] > .arrow {\n  right: calc(-0.75rem - 1px);\n  width: 0.75rem;\n  height: 1.5rem;\n  margin: 0.4375rem 0;\n}\n.bs-popover-left > .arrow::before, .bs-popover-auto[x-placement^=left] > .arrow::before {\n  right: 0;\n  border-width: 0.75rem 0 0.75rem 0.75rem;\n  border-left-color: transparent;\n}\n.bs-popover-left > .arrow::after, .bs-popover-auto[x-placement^=left] > .arrow::after {\n  right: 1px;\n  border-width: 0.75rem 0 0.75rem 0.75rem;\n  border-left-color: #fff;\n}\n\n.popover-header {\n  padding: 0.5rem 0.95rem;\n  margin-bottom: 0;\n  font-size: 1rem;\n  color: #32325d;\n  background-color: #fff;\n  border-bottom: 1px solid rgb(242.25, 242.25, 242.25);\n  border-top-left-radius: calc(0.4375rem - 1px);\n  border-top-right-radius: calc(0.4375rem - 1px);\n}\n.popover-header:empty {\n  display: none;\n}\n\n.popover-body {\n  padding: 0.5rem 0.95rem;\n  color: #525f7f;\n}\n\n.carousel {\n  position: relative;\n}\n\n.carousel.pointer-event {\n  touch-action: pan-y;\n}\n\n.carousel-inner {\n  position: relative;\n  width: 100%;\n  overflow: hidden;\n}\n.carousel-inner::after {\n  display: block;\n  clear: both;\n  content: \"\";\n}\n\n.carousel-item {\n  position: relative;\n  display: none;\n  float: left;\n  width: 100%;\n  margin-right: -100%;\n  backface-visibility: hidden;\n  transition: transform 0.6s ease-in-out;\n}\n@media (prefers-reduced-motion: reduce) {\n  .carousel-item {\n    transition: none;\n  }\n}\n\n.carousel-item.active,\n.carousel-item-next,\n.carousel-item-prev {\n  display: block;\n}\n\n.carousel-item-next:not(.carousel-item-left),\n.active.carousel-item-right {\n  transform: translateX(100%);\n}\n\n.carousel-item-prev:not(.carousel-item-right),\n.active.carousel-item-left {\n  transform: translateX(-100%);\n}\n\n.carousel-fade .carousel-item {\n  opacity: 0;\n  transition-property: opacity;\n  transform: none;\n}\n.carousel-fade .carousel-item.active,\n.carousel-fade .carousel-item-next.carousel-item-left,\n.carousel-fade .carousel-item-prev.carousel-item-right {\n  z-index: 1;\n  opacity: 1;\n}\n.carousel-fade .active.carousel-item-left,\n.carousel-fade .active.carousel-item-right {\n  z-index: 0;\n  opacity: 0;\n  transition: opacity 0s 0.6s;\n}\n@media (prefers-reduced-motion: reduce) {\n  .carousel-fade .active.carousel-item-left,\n  .carousel-fade .active.carousel-item-right {\n    transition: none;\n  }\n}\n\n.carousel-control-prev,\n.carousel-control-next {\n  position: absolute;\n  top: 0;\n  bottom: 0;\n  z-index: 1;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  width: 15%;\n  color: #fff;\n  text-align: center;\n  opacity: 0.5;\n  transition: opacity 0.15s ease;\n}\n@media (prefers-reduced-motion: reduce) {\n  .carousel-control-prev,\n  .carousel-control-next {\n    transition: none;\n  }\n}\n.carousel-control-prev:hover, .carousel-control-prev:focus,\n.carousel-control-next:hover,\n.carousel-control-next:focus {\n  color: #fff;\n  text-decoration: none;\n  outline: 0;\n  opacity: 0.9;\n}\n\n.carousel-control-prev {\n  left: 0;\n}\n\n.carousel-control-next {\n  right: 0;\n}\n\n.carousel-control-prev-icon,\n.carousel-control-next-icon {\n  display: inline-block;\n  width: 20px;\n  height: 20px;\n  background: 50%/100% 100% no-repeat;\n}\n\n.carousel-control-prev-icon {\n  background-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' fill='%23fff' width='8' height='8' viewBox='0 0 8 8'%3e%3cpath d='M5.25 0l-4 4 4 4 1.5-1.5L4.25 4l2.5-2.5L5.25 0z'/%3e%3c/svg%3e\");\n}\n\n.carousel-control-next-icon {\n  background-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' fill='%23fff' width='8' height='8' viewBox='0 0 8 8'%3e%3cpath d='M2.75 0l-1.5 1.5L3.75 4l-2.5 2.5L2.75 8l4-4-4-4z'/%3e%3c/svg%3e\");\n}\n\n.carousel-indicators {\n  position: absolute;\n  right: 0;\n  bottom: 0;\n  left: 0;\n  z-index: 15;\n  display: flex;\n  justify-content: center;\n  padding-left: 0;\n  margin-right: 15%;\n  margin-left: 15%;\n  list-style: none;\n}\n.carousel-indicators li {\n  box-sizing: content-box;\n  flex: 0 1 auto;\n  width: 30px;\n  height: 3px;\n  margin-right: 3px;\n  margin-left: 3px;\n  text-indent: -999px;\n  cursor: pointer;\n  background-color: #fff;\n  background-clip: padding-box;\n  border-top: 10px solid transparent;\n  border-bottom: 10px solid transparent;\n  opacity: 0.5;\n  transition: opacity 0.6s ease;\n}\n@media (prefers-reduced-motion: reduce) {\n  .carousel-indicators li {\n    transition: none;\n  }\n}\n.carousel-indicators .active {\n  opacity: 1;\n}\n\n.carousel-caption {\n  position: absolute;\n  right: 15%;\n  bottom: 20px;\n  left: 15%;\n  z-index: 10;\n  padding-top: 20px;\n  padding-bottom: 20px;\n  color: #fff;\n  text-align: center;\n}\n\n.align-baseline {\n  vertical-align: baseline !important;\n}\n\n.align-top {\n  vertical-align: top !important;\n}\n\n.align-middle {\n  vertical-align: middle !important;\n}\n\n.align-bottom {\n  vertical-align: bottom !important;\n}\n\n.align-text-bottom {\n  vertical-align: text-bottom !important;\n}\n\n.align-text-top {\n  vertical-align: text-top !important;\n}\n\n.bg-primary {\n  background-color: #3ba371 !important;\n}\n\na.bg-primary:hover, a.bg-primary:focus,\nbutton.bg-primary:hover,\nbutton.bg-primary:focus {\n  background-color: rgb(45.4459459459, 125.5540540541, 87.0405405405) !important;\n}\n\n.bg-secondary {\n  background-color: #f7fafc !important;\n}\n\na.bg-secondary:hover, a.bg-secondary:focus,\nbutton.bg-secondary:hover,\nbutton.bg-secondary:focus {\n  background-color: rgb(209.9090909091, 226.8181818182, 238.0909090909) !important;\n}\n\n.bg-success {\n  background-color: #3aa170 !important;\n}\n\na.bg-success:hover, a.bg-success:focus,\nbutton.bg-success:hover,\nbutton.bg-success:focus {\n  background-color: rgb(44.4931506849, 123.5068493151, 85.9178082192) !important;\n}\n\n.bg-info {\n  background-color: #278e69 !important;\n}\n\na.bg-info:hover, a.bg-info:focus,\nbutton.bg-info:hover,\nbutton.bg-info:focus {\n  background-color: rgb(28.0110497238, 101.9889502762, 75.4143646409) !important;\n}\n\n.bg-warning {\n  background-color: #fb6340 !important;\n}\n\na.bg-warning:hover, a.bg-warning:focus,\nbutton.bg-warning:hover,\nbutton.bg-warning:focus {\n  background-color: rgb(249.9538461538, 58.2, 14.0461538462) !important;\n}\n\n.bg-danger {\n  background-color: #f5365c !important;\n}\n\na.bg-danger:hover, a.bg-danger:focus,\nbutton.bg-danger:hover,\nbutton.bg-danger:focus {\n  background-color: rgb(236.2464454976, 11.7535545024, 56.4170616114) !important;\n}\n\n.bg-light {\n  background-color: #adb5bd !important;\n}\n\na.bg-light:hover, a.bg-light:focus,\nbutton.bg-light:hover,\nbutton.bg-light:focus {\n  background-color: rgb(144.7432432432, 155.5, 166.2567567568) !important;\n}\n\n.bg-dark {\n  background-color: #212529 !important;\n}\n\na.bg-dark:hover, a.bg-dark:focus,\nbutton.bg-dark:hover,\nbutton.bg-dark:focus {\n  background-color: rgb(10.2567567568, 11.5, 12.7432432432) !important;\n}\n\n.bg-default {\n  background-color: #ffd88c !important;\n}\n\na.bg-default:hover, a.bg-default:focus,\nbutton.bg-default:hover,\nbutton.bg-default:focus {\n  background-color: rgb(255, 198.7043478261, 89) !important;\n}\n\n.bg-white {\n  background-color: #fff !important;\n}\n\na.bg-white:hover, a.bg-white:focus,\nbutton.bg-white:hover,\nbutton.bg-white:focus {\n  background-color: rgb(229.5, 229.5, 229.5) !important;\n}\n\n.bg-neutral {\n  background-color: #fff !important;\n}\n\na.bg-neutral:hover, a.bg-neutral:focus,\nbutton.bg-neutral:hover,\nbutton.bg-neutral:focus {\n  background-color: rgb(229.5, 229.5, 229.5) !important;\n}\n\n.bg-darker {\n  background-color: black !important;\n}\n\na.bg-darker:hover, a.bg-darker:focus,\nbutton.bg-darker:hover,\nbutton.bg-darker:focus {\n  background-color: black !important;\n}\n\n.bg-white {\n  background-color: #fff !important;\n}\n\n.bg-transparent {\n  background-color: transparent !important;\n}\n\n.border {\n  border: 1px solid #b1b1b1 !important;\n}\n\n.border-top {\n  border-top: 1px solid #b1b1b1 !important;\n}\n\n.border-right {\n  border-right: 1px solid #b1b1b1 !important;\n}\n\n.border-bottom {\n  border-bottom: 1px solid #b1b1b1 !important;\n}\n\n.border-left {\n  border-left: 1px solid #b1b1b1 !important;\n}\n\n.border-0 {\n  border: 0 !important;\n}\n\n.border-top-0 {\n  border-top: 0 !important;\n}\n\n.border-right-0 {\n  border-right: 0 !important;\n}\n\n.border-bottom-0 {\n  border-bottom: 0 !important;\n}\n\n.border-left-0 {\n  border-left: 0 !important;\n}\n\n.border-primary {\n  border-color: #3ba371 !important;\n}\n\n.border-secondary {\n  border-color: #f7fafc !important;\n}\n\n.border-success {\n  border-color: #3aa170 !important;\n}\n\n.border-info {\n  border-color: #278e69 !important;\n}\n\n.border-warning {\n  border-color: #fb6340 !important;\n}\n\n.border-danger {\n  border-color: #f5365c !important;\n}\n\n.border-light {\n  border-color: #adb5bd !important;\n}\n\n.border-dark {\n  border-color: #212529 !important;\n}\n\n.border-default {\n  border-color: #ffd88c !important;\n}\n\n.border-white {\n  border-color: #fff !important;\n}\n\n.border-neutral {\n  border-color: #fff !important;\n}\n\n.border-darker {\n  border-color: black !important;\n}\n\n.border-white {\n  border-color: #fff !important;\n}\n\n.rounded-sm {\n  border-radius: 0.25rem !important;\n}\n\n.rounded {\n  border-radius: 0.375rem !important;\n}\n\n.rounded-top {\n  border-top-left-radius: 0.375rem !important;\n  border-top-right-radius: 0.375rem !important;\n}\n\n.rounded-right {\n  border-top-right-radius: 0.375rem !important;\n  border-bottom-right-radius: 0.375rem !important;\n}\n\n.rounded-bottom {\n  border-bottom-right-radius: 0.375rem !important;\n  border-bottom-left-radius: 0.375rem !important;\n}\n\n.rounded-left {\n  border-top-left-radius: 0.375rem !important;\n  border-bottom-left-radius: 0.375rem !important;\n}\n\n.rounded-lg {\n  border-radius: 0.4375rem !important;\n}\n\n.rounded-circle {\n  border-radius: 50% !important;\n}\n\n.rounded-pill {\n  border-radius: 50rem !important;\n}\n\n.rounded-0 {\n  border-radius: 0 !important;\n}\n\n.clearfix::after {\n  display: block;\n  clear: both;\n  content: \"\";\n}\n\n.d-none {\n  display: none !important;\n}\n\n.d-inline {\n  display: inline !important;\n}\n\n.d-inline-block {\n  display: inline-block !important;\n}\n\n.d-block {\n  display: block !important;\n}\n\n.d-table {\n  display: table !important;\n}\n\n.d-table-row {\n  display: table-row !important;\n}\n\n.d-table-cell {\n  display: table-cell !important;\n}\n\n.d-flex {\n  display: flex !important;\n}\n\n.d-inline-flex {\n  display: inline-flex !important;\n}\n\n@media (min-width: 576px) {\n  .d-sm-none {\n    display: none !important;\n  }\n  .d-sm-inline {\n    display: inline !important;\n  }\n  .d-sm-inline-block {\n    display: inline-block !important;\n  }\n  .d-sm-block {\n    display: block !important;\n  }\n  .d-sm-table {\n    display: table !important;\n  }\n  .d-sm-table-row {\n    display: table-row !important;\n  }\n  .d-sm-table-cell {\n    display: table-cell !important;\n  }\n  .d-sm-flex {\n    display: flex !important;\n  }\n  .d-sm-inline-flex {\n    display: inline-flex !important;\n  }\n}\n@media (min-width: 768px) {\n  .d-md-none {\n    display: none !important;\n  }\n  .d-md-inline {\n    display: inline !important;\n  }\n  .d-md-inline-block {\n    display: inline-block !important;\n  }\n  .d-md-block {\n    display: block !important;\n  }\n  .d-md-table {\n    display: table !important;\n  }\n  .d-md-table-row {\n    display: table-row !important;\n  }\n  .d-md-table-cell {\n    display: table-cell !important;\n  }\n  .d-md-flex {\n    display: flex !important;\n  }\n  .d-md-inline-flex {\n    display: inline-flex !important;\n  }\n}\n@media (min-width: 992px) {\n  .d-lg-none {\n    display: none !important;\n  }\n  .d-lg-inline {\n    display: inline !important;\n  }\n  .d-lg-inline-block {\n    display: inline-block !important;\n  }\n  .d-lg-block {\n    display: block !important;\n  }\n  .d-lg-table {\n    display: table !important;\n  }\n  .d-lg-table-row {\n    display: table-row !important;\n  }\n  .d-lg-table-cell {\n    display: table-cell !important;\n  }\n  .d-lg-flex {\n    display: flex !important;\n  }\n  .d-lg-inline-flex {\n    display: inline-flex !important;\n  }\n}\n@media (min-width: 1200px) {\n  .d-xl-none {\n    display: none !important;\n  }\n  .d-xl-inline {\n    display: inline !important;\n  }\n  .d-xl-inline-block {\n    display: inline-block !important;\n  }\n  .d-xl-block {\n    display: block !important;\n  }\n  .d-xl-table {\n    display: table !important;\n  }\n  .d-xl-table-row {\n    display: table-row !important;\n  }\n  .d-xl-table-cell {\n    display: table-cell !important;\n  }\n  .d-xl-flex {\n    display: flex !important;\n  }\n  .d-xl-inline-flex {\n    display: inline-flex !important;\n  }\n}\n@media print {\n  .d-print-none {\n    display: none !important;\n  }\n  .d-print-inline {\n    display: inline !important;\n  }\n  .d-print-inline-block {\n    display: inline-block !important;\n  }\n  .d-print-block {\n    display: block !important;\n  }\n  .d-print-table {\n    display: table !important;\n  }\n  .d-print-table-row {\n    display: table-row !important;\n  }\n  .d-print-table-cell {\n    display: table-cell !important;\n  }\n  .d-print-flex {\n    display: flex !important;\n  }\n  .d-print-inline-flex {\n    display: inline-flex !important;\n  }\n}\n.embed-responsive {\n  position: relative;\n  display: block;\n  width: 100%;\n  padding: 0;\n  overflow: hidden;\n}\n.embed-responsive::before {\n  display: block;\n  content: \"\";\n}\n.embed-responsive .embed-responsive-item,\n.embed-responsive iframe,\n.embed-responsive embed,\n.embed-responsive object,\n.embed-responsive video {\n  position: absolute;\n  top: 0;\n  bottom: 0;\n  left: 0;\n  width: 100%;\n  height: 100%;\n  border: 0;\n}\n\n.embed-responsive-21by9::before {\n  padding-top: 42.8571428571%;\n}\n\n.embed-responsive-16by9::before {\n  padding-top: 56.25%;\n}\n\n.embed-responsive-4by3::before {\n  padding-top: 75%;\n}\n\n.embed-responsive-1by1::before {\n  padding-top: 100%;\n}\n\n.flex-row {\n  flex-direction: row !important;\n}\n\n.flex-column {\n  flex-direction: column !important;\n}\n\n.flex-row-reverse {\n  flex-direction: row-reverse !important;\n}\n\n.flex-column-reverse {\n  flex-direction: column-reverse !important;\n}\n\n.flex-wrap {\n  flex-wrap: wrap !important;\n}\n\n.flex-nowrap {\n  flex-wrap: nowrap !important;\n}\n\n.flex-wrap-reverse {\n  flex-wrap: wrap-reverse !important;\n}\n\n.flex-fill {\n  flex: 1 1 auto !important;\n}\n\n.flex-grow-0 {\n  flex-grow: 0 !important;\n}\n\n.flex-grow-1 {\n  flex-grow: 1 !important;\n}\n\n.flex-shrink-0 {\n  flex-shrink: 0 !important;\n}\n\n.flex-shrink-1 {\n  flex-shrink: 1 !important;\n}\n\n.justify-content-start {\n  justify-content: flex-start !important;\n}\n\n.justify-content-end {\n  justify-content: flex-end !important;\n}\n\n.justify-content-center {\n  justify-content: center !important;\n}\n\n.justify-content-between {\n  justify-content: space-between !important;\n}\n\n.justify-content-around {\n  justify-content: space-around !important;\n}\n\n.align-items-start {\n  align-items: flex-start !important;\n}\n\n.align-items-end {\n  align-items: flex-end !important;\n}\n\n.align-items-center {\n  align-items: center !important;\n}\n\n.align-items-baseline {\n  align-items: baseline !important;\n}\n\n.align-items-stretch {\n  align-items: stretch !important;\n}\n\n.align-content-start {\n  align-content: flex-start !important;\n}\n\n.align-content-end {\n  align-content: flex-end !important;\n}\n\n.align-content-center {\n  align-content: center !important;\n}\n\n.align-content-between {\n  align-content: space-between !important;\n}\n\n.align-content-around {\n  align-content: space-around !important;\n}\n\n.align-content-stretch {\n  align-content: stretch !important;\n}\n\n.align-self-auto {\n  align-self: auto !important;\n}\n\n.align-self-start {\n  align-self: flex-start !important;\n}\n\n.align-self-end {\n  align-self: flex-end !important;\n}\n\n.align-self-center {\n  align-self: center !important;\n}\n\n.align-self-baseline {\n  align-self: baseline !important;\n}\n\n.align-self-stretch {\n  align-self: stretch !important;\n}\n\n@media (min-width: 576px) {\n  .flex-sm-row {\n    flex-direction: row !important;\n  }\n  .flex-sm-column {\n    flex-direction: column !important;\n  }\n  .flex-sm-row-reverse {\n    flex-direction: row-reverse !important;\n  }\n  .flex-sm-column-reverse {\n    flex-direction: column-reverse !important;\n  }\n  .flex-sm-wrap {\n    flex-wrap: wrap !important;\n  }\n  .flex-sm-nowrap {\n    flex-wrap: nowrap !important;\n  }\n  .flex-sm-wrap-reverse {\n    flex-wrap: wrap-reverse !important;\n  }\n  .flex-sm-fill {\n    flex: 1 1 auto !important;\n  }\n  .flex-sm-grow-0 {\n    flex-grow: 0 !important;\n  }\n  .flex-sm-grow-1 {\n    flex-grow: 1 !important;\n  }\n  .flex-sm-shrink-0 {\n    flex-shrink: 0 !important;\n  }\n  .flex-sm-shrink-1 {\n    flex-shrink: 1 !important;\n  }\n  .justify-content-sm-start {\n    justify-content: flex-start !important;\n  }\n  .justify-content-sm-end {\n    justify-content: flex-end !important;\n  }\n  .justify-content-sm-center {\n    justify-content: center !important;\n  }\n  .justify-content-sm-between {\n    justify-content: space-between !important;\n  }\n  .justify-content-sm-around {\n    justify-content: space-around !important;\n  }\n  .align-items-sm-start {\n    align-items: flex-start !important;\n  }\n  .align-items-sm-end {\n    align-items: flex-end !important;\n  }\n  .align-items-sm-center {\n    align-items: center !important;\n  }\n  .align-items-sm-baseline {\n    align-items: baseline !important;\n  }\n  .align-items-sm-stretch {\n    align-items: stretch !important;\n  }\n  .align-content-sm-start {\n    align-content: flex-start !important;\n  }\n  .align-content-sm-end {\n    align-content: flex-end !important;\n  }\n  .align-content-sm-center {\n    align-content: center !important;\n  }\n  .align-content-sm-between {\n    align-content: space-between !important;\n  }\n  .align-content-sm-around {\n    align-content: space-around !important;\n  }\n  .align-content-sm-stretch {\n    align-content: stretch !important;\n  }\n  .align-self-sm-auto {\n    align-self: auto !important;\n  }\n  .align-self-sm-start {\n    align-self: flex-start !important;\n  }\n  .align-self-sm-end {\n    align-self: flex-end !important;\n  }\n  .align-self-sm-center {\n    align-self: center !important;\n  }\n  .align-self-sm-baseline {\n    align-self: baseline !important;\n  }\n  .align-self-sm-stretch {\n    align-self: stretch !important;\n  }\n}\n@media (min-width: 768px) {\n  .flex-md-row {\n    flex-direction: row !important;\n  }\n  .flex-md-column {\n    flex-direction: column !important;\n  }\n  .flex-md-row-reverse {\n    flex-direction: row-reverse !important;\n  }\n  .flex-md-column-reverse {\n    flex-direction: column-reverse !important;\n  }\n  .flex-md-wrap {\n    flex-wrap: wrap !important;\n  }\n  .flex-md-nowrap {\n    flex-wrap: nowrap !important;\n  }\n  .flex-md-wrap-reverse {\n    flex-wrap: wrap-reverse !important;\n  }\n  .flex-md-fill {\n    flex: 1 1 auto !important;\n  }\n  .flex-md-grow-0 {\n    flex-grow: 0 !important;\n  }\n  .flex-md-grow-1 {\n    flex-grow: 1 !important;\n  }\n  .flex-md-shrink-0 {\n    flex-shrink: 0 !important;\n  }\n  .flex-md-shrink-1 {\n    flex-shrink: 1 !important;\n  }\n  .justify-content-md-start {\n    justify-content: flex-start !important;\n  }\n  .justify-content-md-end {\n    justify-content: flex-end !important;\n  }\n  .justify-content-md-center {\n    justify-content: center !important;\n  }\n  .justify-content-md-between {\n    justify-content: space-between !important;\n  }\n  .justify-content-md-around {\n    justify-content: space-around !important;\n  }\n  .align-items-md-start {\n    align-items: flex-start !important;\n  }\n  .align-items-md-end {\n    align-items: flex-end !important;\n  }\n  .align-items-md-center {\n    align-items: center !important;\n  }\n  .align-items-md-baseline {\n    align-items: baseline !important;\n  }\n  .align-items-md-stretch {\n    align-items: stretch !important;\n  }\n  .align-content-md-start {\n    align-content: flex-start !important;\n  }\n  .align-content-md-end {\n    align-content: flex-end !important;\n  }\n  .align-content-md-center {\n    align-content: center !important;\n  }\n  .align-content-md-between {\n    align-content: space-between !important;\n  }\n  .align-content-md-around {\n    align-content: space-around !important;\n  }\n  .align-content-md-stretch {\n    align-content: stretch !important;\n  }\n  .align-self-md-auto {\n    align-self: auto !important;\n  }\n  .align-self-md-start {\n    align-self: flex-start !important;\n  }\n  .align-self-md-end {\n    align-self: flex-end !important;\n  }\n  .align-self-md-center {\n    align-self: center !important;\n  }\n  .align-self-md-baseline {\n    align-self: baseline !important;\n  }\n  .align-self-md-stretch {\n    align-self: stretch !important;\n  }\n}\n@media (min-width: 992px) {\n  .flex-lg-row {\n    flex-direction: row !important;\n  }\n  .flex-lg-column {\n    flex-direction: column !important;\n  }\n  .flex-lg-row-reverse {\n    flex-direction: row-reverse !important;\n  }\n  .flex-lg-column-reverse {\n    flex-direction: column-reverse !important;\n  }\n  .flex-lg-wrap {\n    flex-wrap: wrap !important;\n  }\n  .flex-lg-nowrap {\n    flex-wrap: nowrap !important;\n  }\n  .flex-lg-wrap-reverse {\n    flex-wrap: wrap-reverse !important;\n  }\n  .flex-lg-fill {\n    flex: 1 1 auto !important;\n  }\n  .flex-lg-grow-0 {\n    flex-grow: 0 !important;\n  }\n  .flex-lg-grow-1 {\n    flex-grow: 1 !important;\n  }\n  .flex-lg-shrink-0 {\n    flex-shrink: 0 !important;\n  }\n  .flex-lg-shrink-1 {\n    flex-shrink: 1 !important;\n  }\n  .justify-content-lg-start {\n    justify-content: flex-start !important;\n  }\n  .justify-content-lg-end {\n    justify-content: flex-end !important;\n  }\n  .justify-content-lg-center {\n    justify-content: center !important;\n  }\n  .justify-content-lg-between {\n    justify-content: space-between !important;\n  }\n  .justify-content-lg-around {\n    justify-content: space-around !important;\n  }\n  .align-items-lg-start {\n    align-items: flex-start !important;\n  }\n  .align-items-lg-end {\n    align-items: flex-end !important;\n  }\n  .align-items-lg-center {\n    align-items: center !important;\n  }\n  .align-items-lg-baseline {\n    align-items: baseline !important;\n  }\n  .align-items-lg-stretch {\n    align-items: stretch !important;\n  }\n  .align-content-lg-start {\n    align-content: flex-start !important;\n  }\n  .align-content-lg-end {\n    align-content: flex-end !important;\n  }\n  .align-content-lg-center {\n    align-content: center !important;\n  }\n  .align-content-lg-between {\n    align-content: space-between !important;\n  }\n  .align-content-lg-around {\n    align-content: space-around !important;\n  }\n  .align-content-lg-stretch {\n    align-content: stretch !important;\n  }\n  .align-self-lg-auto {\n    align-self: auto !important;\n  }\n  .align-self-lg-start {\n    align-self: flex-start !important;\n  }\n  .align-self-lg-end {\n    align-self: flex-end !important;\n  }\n  .align-self-lg-center {\n    align-self: center !important;\n  }\n  .align-self-lg-baseline {\n    align-self: baseline !important;\n  }\n  .align-self-lg-stretch {\n    align-self: stretch !important;\n  }\n}\n@media (min-width: 1200px) {\n  .flex-xl-row {\n    flex-direction: row !important;\n  }\n  .flex-xl-column {\n    flex-direction: column !important;\n  }\n  .flex-xl-row-reverse {\n    flex-direction: row-reverse !important;\n  }\n  .flex-xl-column-reverse {\n    flex-direction: column-reverse !important;\n  }\n  .flex-xl-wrap {\n    flex-wrap: wrap !important;\n  }\n  .flex-xl-nowrap {\n    flex-wrap: nowrap !important;\n  }\n  .flex-xl-wrap-reverse {\n    flex-wrap: wrap-reverse !important;\n  }\n  .flex-xl-fill {\n    flex: 1 1 auto !important;\n  }\n  .flex-xl-grow-0 {\n    flex-grow: 0 !important;\n  }\n  .flex-xl-grow-1 {\n    flex-grow: 1 !important;\n  }\n  .flex-xl-shrink-0 {\n    flex-shrink: 0 !important;\n  }\n  .flex-xl-shrink-1 {\n    flex-shrink: 1 !important;\n  }\n  .justify-content-xl-start {\n    justify-content: flex-start !important;\n  }\n  .justify-content-xl-end {\n    justify-content: flex-end !important;\n  }\n  .justify-content-xl-center {\n    justify-content: center !important;\n  }\n  .justify-content-xl-between {\n    justify-content: space-between !important;\n  }\n  .justify-content-xl-around {\n    justify-content: space-around !important;\n  }\n  .align-items-xl-start {\n    align-items: flex-start !important;\n  }\n  .align-items-xl-end {\n    align-items: flex-end !important;\n  }\n  .align-items-xl-center {\n    align-items: center !important;\n  }\n  .align-items-xl-baseline {\n    align-items: baseline !important;\n  }\n  .align-items-xl-stretch {\n    align-items: stretch !important;\n  }\n  .align-content-xl-start {\n    align-content: flex-start !important;\n  }\n  .align-content-xl-end {\n    align-content: flex-end !important;\n  }\n  .align-content-xl-center {\n    align-content: center !important;\n  }\n  .align-content-xl-between {\n    align-content: space-between !important;\n  }\n  .align-content-xl-around {\n    align-content: space-around !important;\n  }\n  .align-content-xl-stretch {\n    align-content: stretch !important;\n  }\n  .align-self-xl-auto {\n    align-self: auto !important;\n  }\n  .align-self-xl-start {\n    align-self: flex-start !important;\n  }\n  .align-self-xl-end {\n    align-self: flex-end !important;\n  }\n  .align-self-xl-center {\n    align-self: center !important;\n  }\n  .align-self-xl-baseline {\n    align-self: baseline !important;\n  }\n  .align-self-xl-stretch {\n    align-self: stretch !important;\n  }\n}\n.float-left {\n  float: left !important;\n}\n\n.float-right {\n  float: right !important;\n}\n\n.float-none {\n  float: none !important;\n}\n\n@media (min-width: 576px) {\n  .float-sm-left {\n    float: left !important;\n  }\n  .float-sm-right {\n    float: right !important;\n  }\n  .float-sm-none {\n    float: none !important;\n  }\n}\n@media (min-width: 768px) {\n  .float-md-left {\n    float: left !important;\n  }\n  .float-md-right {\n    float: right !important;\n  }\n  .float-md-none {\n    float: none !important;\n  }\n}\n@media (min-width: 992px) {\n  .float-lg-left {\n    float: left !important;\n  }\n  .float-lg-right {\n    float: right !important;\n  }\n  .float-lg-none {\n    float: none !important;\n  }\n}\n@media (min-width: 1200px) {\n  .float-xl-left {\n    float: left !important;\n  }\n  .float-xl-right {\n    float: right !important;\n  }\n  .float-xl-none {\n    float: none !important;\n  }\n}\n.user-select-all {\n  user-select: all !important;\n}\n\n.user-select-auto {\n  user-select: auto !important;\n}\n\n.user-select-none {\n  user-select: none !important;\n}\n\n.overflow-auto {\n  overflow: auto !important;\n}\n\n.overflow-hidden {\n  overflow: hidden !important;\n}\n\n.position-static {\n  position: static !important;\n}\n\n.position-relative {\n  position: relative !important;\n}\n\n.position-absolute {\n  position: absolute !important;\n}\n\n.position-fixed {\n  position: fixed !important;\n}\n\n.position-sticky {\n  position: sticky !important;\n}\n\n.fixed-top {\n  position: fixed;\n  top: 0;\n  right: 0;\n  left: 0;\n  z-index: 1030;\n}\n\n.fixed-bottom {\n  position: fixed;\n  right: 0;\n  bottom: 0;\n  left: 0;\n  z-index: 1030;\n}\n\n@supports (position: sticky) {\n  .sticky-top {\n    position: sticky;\n    top: 0;\n    z-index: 1020;\n  }\n}\n\n.sr-only {\n  position: absolute;\n  width: 1px;\n  height: 1px;\n  padding: 0;\n  margin: -1px;\n  overflow: hidden;\n  clip: rect(0, 0, 0, 0);\n  white-space: nowrap;\n  border: 0;\n}\n\n.sr-only-focusable:active, .sr-only-focusable:focus {\n  position: static;\n  width: auto;\n  height: auto;\n  overflow: visible;\n  clip: auto;\n  white-space: normal;\n}\n\n.shadow-sm {\n  box-shadow: 0 0 0.5rem rgba(136, 152, 170, 0.075) !important;\n}\n\n.shadow, .card-profile-image img {\n  box-shadow: 0 0 2rem 0 rgba(136, 152, 170, 0.15) !important;\n}\n\n.shadow-lg {\n  box-shadow: 0 0 3rem rgba(136, 152, 170, 0.175) !important;\n}\n\n.shadow-none {\n  box-shadow: none !important;\n}\n\n.w-25 {\n  width: 25% !important;\n}\n\n.w-50 {\n  width: 50% !important;\n}\n\n.w-75 {\n  width: 75% !important;\n}\n\n.w-100 {\n  width: 100% !important;\n}\n\n.w-auto {\n  width: auto !important;\n}\n\n.h-25 {\n  height: 25% !important;\n}\n\n.h-50 {\n  height: 50% !important;\n}\n\n.h-75 {\n  height: 75% !important;\n}\n\n.h-100 {\n  height: 100% !important;\n}\n\n.h-auto {\n  height: auto !important;\n}\n\n.mw-100 {\n  max-width: 100% !important;\n}\n\n.mh-100 {\n  max-height: 100% !important;\n}\n\n.min-vw-100 {\n  min-width: 100vw !important;\n}\n\n.min-vh-100 {\n  min-height: 100vh !important;\n}\n\n.vw-100 {\n  width: 100vw !important;\n}\n\n.vh-100 {\n  height: 100vh !important;\n}\n\n.m-0 {\n  margin: 0 !important;\n}\n\n.mt-0,\n.my-0 {\n  margin-top: 0 !important;\n}\n\n.mr-0,\n.mx-0 {\n  margin-right: 0 !important;\n}\n\n.mb-0,\n.my-0 {\n  margin-bottom: 0 !important;\n}\n\n.ml-0,\n.mx-0 {\n  margin-left: 0 !important;\n}\n\n.m-1 {\n  margin: 0.25rem !important;\n}\n\n.mt-1,\n.my-1 {\n  margin-top: 0.25rem !important;\n}\n\n.mr-1,\n.mx-1 {\n  margin-right: 0.25rem !important;\n}\n\n.mb-1,\n.my-1 {\n  margin-bottom: 0.25rem !important;\n}\n\n.ml-1,\n.mx-1 {\n  margin-left: 0.25rem !important;\n}\n\n.m-2 {\n  margin: 0.5rem !important;\n}\n\n.mt-2,\n.my-2 {\n  margin-top: 0.5rem !important;\n}\n\n.mr-2,\n.mx-2 {\n  margin-right: 0.5rem !important;\n}\n\n.mb-2,\n.my-2 {\n  margin-bottom: 0.5rem !important;\n}\n\n.ml-2,\n.mx-2 {\n  margin-left: 0.5rem !important;\n}\n\n.m-3 {\n  margin: 1rem !important;\n}\n\n.mt-3,\n.my-3 {\n  margin-top: 1rem !important;\n}\n\n.mr-3,\n.mx-3 {\n  margin-right: 1rem !important;\n}\n\n.mb-3,\n.my-3 {\n  margin-bottom: 1rem !important;\n}\n\n.ml-3,\n.mx-3 {\n  margin-left: 1rem !important;\n}\n\n.m-4 {\n  margin: 1.5rem !important;\n}\n\n.mt-4,\n.my-4 {\n  margin-top: 1.5rem !important;\n}\n\n.mr-4,\n.mx-4 {\n  margin-right: 1.5rem !important;\n}\n\n.mb-4,\n.my-4 {\n  margin-bottom: 1.5rem !important;\n}\n\n.ml-4,\n.mx-4 {\n  margin-left: 1.5rem !important;\n}\n\n.m-5 {\n  margin: 3rem !important;\n}\n\n.mt-5,\n.my-5 {\n  margin-top: 3rem !important;\n}\n\n.mr-5,\n.mx-5 {\n  margin-right: 3rem !important;\n}\n\n.mb-5,\n.my-5 {\n  margin-bottom: 3rem !important;\n}\n\n.ml-5,\n.mx-5 {\n  margin-left: 3rem !important;\n}\n\n.m--9 {\n  margin: -10rem !important;\n}\n\n.mt--9,\n.my--9 {\n  margin-top: -10rem !important;\n}\n\n.mr--9,\n.mx--9 {\n  margin-right: -10rem !important;\n}\n\n.mb--9,\n.my--9 {\n  margin-bottom: -10rem !important;\n}\n\n.ml--9,\n.mx--9 {\n  margin-left: -10rem !important;\n}\n\n.m--8 {\n  margin: -8rem !important;\n}\n\n.mt--8,\n.my--8 {\n  margin-top: -8rem !important;\n}\n\n.mr--8,\n.mx--8 {\n  margin-right: -8rem !important;\n}\n\n.mb--8,\n.my--8 {\n  margin-bottom: -8rem !important;\n}\n\n.ml--8,\n.mx--8 {\n  margin-left: -8rem !important;\n}\n\n.m--7 {\n  margin: -6rem !important;\n}\n\n.mt--7,\n.my--7 {\n  margin-top: -6rem !important;\n}\n\n.mr--7,\n.mx--7 {\n  margin-right: -6rem !important;\n}\n\n.mb--7,\n.my--7 {\n  margin-bottom: -6rem !important;\n}\n\n.ml--7,\n.mx--7 {\n  margin-left: -6rem !important;\n}\n\n.m--6 {\n  margin: -4.5rem !important;\n}\n\n.mt--6,\n.my--6 {\n  margin-top: -4.5rem !important;\n}\n\n.mr--6,\n.mx--6 {\n  margin-right: -4.5rem !important;\n}\n\n.mb--6,\n.my--6 {\n  margin-bottom: -4.5rem !important;\n}\n\n.ml--6,\n.mx--6 {\n  margin-left: -4.5rem !important;\n}\n\n.m--5 {\n  margin: -3rem !important;\n}\n\n.mt--5,\n.my--5 {\n  margin-top: -3rem !important;\n}\n\n.mr--5,\n.mx--5 {\n  margin-right: -3rem !important;\n}\n\n.mb--5,\n.my--5 {\n  margin-bottom: -3rem !important;\n}\n\n.ml--5,\n.mx--5 {\n  margin-left: -3rem !important;\n}\n\n.m--4 {\n  margin: -1.5rem !important;\n}\n\n.mt--4,\n.my--4 {\n  margin-top: -1.5rem !important;\n}\n\n.mr--4,\n.mx--4 {\n  margin-right: -1.5rem !important;\n}\n\n.mb--4,\n.my--4 {\n  margin-bottom: -1.5rem !important;\n}\n\n.ml--4,\n.mx--4 {\n  margin-left: -1.5rem !important;\n}\n\n.m--3 {\n  margin: -1rem !important;\n}\n\n.mt--3,\n.my--3 {\n  margin-top: -1rem !important;\n}\n\n.mr--3,\n.mx--3 {\n  margin-right: -1rem !important;\n}\n\n.mb--3,\n.my--3 {\n  margin-bottom: -1rem !important;\n}\n\n.ml--3,\n.mx--3 {\n  margin-left: -1rem !important;\n}\n\n.m--2 {\n  margin: -0.5rem !important;\n}\n\n.mt--2,\n.my--2 {\n  margin-top: -0.5rem !important;\n}\n\n.mr--2,\n.mx--2 {\n  margin-right: -0.5rem !important;\n}\n\n.mb--2,\n.my--2 {\n  margin-bottom: -0.5rem !important;\n}\n\n.ml--2,\n.mx--2 {\n  margin-left: -0.5rem !important;\n}\n\n.m--1 {\n  margin: -0.25rem !important;\n}\n\n.mt--1,\n.my--1 {\n  margin-top: -0.25rem !important;\n}\n\n.mr--1,\n.mx--1 {\n  margin-right: -0.25rem !important;\n}\n\n.mb--1,\n.my--1 {\n  margin-bottom: -0.25rem !important;\n}\n\n.ml--1,\n.mx--1 {\n  margin-left: -0.25rem !important;\n}\n\n.m-6 {\n  margin: 4.5rem !important;\n}\n\n.mt-6,\n.my-6 {\n  margin-top: 4.5rem !important;\n}\n\n.mr-6,\n.mx-6 {\n  margin-right: 4.5rem !important;\n}\n\n.mb-6,\n.my-6 {\n  margin-bottom: 4.5rem !important;\n}\n\n.ml-6,\n.mx-6 {\n  margin-left: 4.5rem !important;\n}\n\n.m-7 {\n  margin: 6rem !important;\n}\n\n.mt-7,\n.my-7 {\n  margin-top: 6rem !important;\n}\n\n.mr-7,\n.mx-7 {\n  margin-right: 6rem !important;\n}\n\n.mb-7,\n.my-7 {\n  margin-bottom: 6rem !important;\n}\n\n.ml-7,\n.mx-7 {\n  margin-left: 6rem !important;\n}\n\n.m-8 {\n  margin: 8rem !important;\n}\n\n.mt-8,\n.my-8 {\n  margin-top: 8rem !important;\n}\n\n.mr-8,\n.mx-8 {\n  margin-right: 8rem !important;\n}\n\n.mb-8,\n.my-8 {\n  margin-bottom: 8rem !important;\n}\n\n.ml-8,\n.mx-8 {\n  margin-left: 8rem !important;\n}\n\n.m-9 {\n  margin: 10rem !important;\n}\n\n.mt-9,\n.my-9 {\n  margin-top: 10rem !important;\n}\n\n.mr-9,\n.mx-9 {\n  margin-right: 10rem !important;\n}\n\n.mb-9,\n.my-9 {\n  margin-bottom: 10rem !important;\n}\n\n.ml-9,\n.mx-9 {\n  margin-left: 10rem !important;\n}\n\n.p-0 {\n  padding: 0 !important;\n}\n\n.pt-0,\n.py-0 {\n  padding-top: 0 !important;\n}\n\n.pr-0,\n.px-0 {\n  padding-right: 0 !important;\n}\n\n.pb-0,\n.py-0 {\n  padding-bottom: 0 !important;\n}\n\n.pl-0,\n.px-0 {\n  padding-left: 0 !important;\n}\n\n.p-1 {\n  padding: 0.25rem !important;\n}\n\n.pt-1,\n.py-1 {\n  padding-top: 0.25rem !important;\n}\n\n.pr-1,\n.px-1 {\n  padding-right: 0.25rem !important;\n}\n\n.pb-1,\n.py-1 {\n  padding-bottom: 0.25rem !important;\n}\n\n.pl-1,\n.px-1 {\n  padding-left: 0.25rem !important;\n}\n\n.p-2 {\n  padding: 0.5rem !important;\n}\n\n.pt-2,\n.py-2 {\n  padding-top: 0.5rem !important;\n}\n\n.pr-2,\n.px-2 {\n  padding-right: 0.5rem !important;\n}\n\n.pb-2,\n.py-2 {\n  padding-bottom: 0.5rem !important;\n}\n\n.pl-2,\n.px-2 {\n  padding-left: 0.5rem !important;\n}\n\n.p-3 {\n  padding: 1rem !important;\n}\n\n.pt-3,\n.py-3 {\n  padding-top: 1rem !important;\n}\n\n.pr-3,\n.px-3 {\n  padding-right: 1rem !important;\n}\n\n.pb-3,\n.py-3 {\n  padding-bottom: 1rem !important;\n}\n\n.pl-3,\n.px-3 {\n  padding-left: 1rem !important;\n}\n\n.p-4 {\n  padding: 1.5rem !important;\n}\n\n.pt-4,\n.py-4 {\n  padding-top: 1.5rem !important;\n}\n\n.pr-4,\n.px-4 {\n  padding-right: 1.5rem !important;\n}\n\n.pb-4,\n.py-4 {\n  padding-bottom: 1.5rem !important;\n}\n\n.pl-4,\n.px-4 {\n  padding-left: 1.5rem !important;\n}\n\n.p-5 {\n  padding: 3rem !important;\n}\n\n.pt-5,\n.py-5 {\n  padding-top: 3rem !important;\n}\n\n.pr-5,\n.px-5 {\n  padding-right: 3rem !important;\n}\n\n.pb-5,\n.py-5 {\n  padding-bottom: 3rem !important;\n}\n\n.pl-5,\n.px-5 {\n  padding-left: 3rem !important;\n}\n\n.p--9 {\n  padding: -10rem !important;\n}\n\n.pt--9,\n.py--9 {\n  padding-top: -10rem !important;\n}\n\n.pr--9,\n.px--9 {\n  padding-right: -10rem !important;\n}\n\n.pb--9,\n.py--9 {\n  padding-bottom: -10rem !important;\n}\n\n.pl--9,\n.px--9 {\n  padding-left: -10rem !important;\n}\n\n.p--8 {\n  padding: -8rem !important;\n}\n\n.pt--8,\n.py--8 {\n  padding-top: -8rem !important;\n}\n\n.pr--8,\n.px--8 {\n  padding-right: -8rem !important;\n}\n\n.pb--8,\n.py--8 {\n  padding-bottom: -8rem !important;\n}\n\n.pl--8,\n.px--8 {\n  padding-left: -8rem !important;\n}\n\n.p--7 {\n  padding: -6rem !important;\n}\n\n.pt--7,\n.py--7 {\n  padding-top: -6rem !important;\n}\n\n.pr--7,\n.px--7 {\n  padding-right: -6rem !important;\n}\n\n.pb--7,\n.py--7 {\n  padding-bottom: -6rem !important;\n}\n\n.pl--7,\n.px--7 {\n  padding-left: -6rem !important;\n}\n\n.p--6 {\n  padding: -4.5rem !important;\n}\n\n.pt--6,\n.py--6 {\n  padding-top: -4.5rem !important;\n}\n\n.pr--6,\n.px--6 {\n  padding-right: -4.5rem !important;\n}\n\n.pb--6,\n.py--6 {\n  padding-bottom: -4.5rem !important;\n}\n\n.pl--6,\n.px--6 {\n  padding-left: -4.5rem !important;\n}\n\n.p--5 {\n  padding: -3rem !important;\n}\n\n.pt--5,\n.py--5 {\n  padding-top: -3rem !important;\n}\n\n.pr--5,\n.px--5 {\n  padding-right: -3rem !important;\n}\n\n.pb--5,\n.py--5 {\n  padding-bottom: -3rem !important;\n}\n\n.pl--5,\n.px--5 {\n  padding-left: -3rem !important;\n}\n\n.p--4 {\n  padding: -1.5rem !important;\n}\n\n.pt--4,\n.py--4 {\n  padding-top: -1.5rem !important;\n}\n\n.pr--4,\n.px--4 {\n  padding-right: -1.5rem !important;\n}\n\n.pb--4,\n.py--4 {\n  padding-bottom: -1.5rem !important;\n}\n\n.pl--4,\n.px--4 {\n  padding-left: -1.5rem !important;\n}\n\n.p--3 {\n  padding: -1rem !important;\n}\n\n.pt--3,\n.py--3 {\n  padding-top: -1rem !important;\n}\n\n.pr--3,\n.px--3 {\n  padding-right: -1rem !important;\n}\n\n.pb--3,\n.py--3 {\n  padding-bottom: -1rem !important;\n}\n\n.pl--3,\n.px--3 {\n  padding-left: -1rem !important;\n}\n\n.p--2 {\n  padding: -0.5rem !important;\n}\n\n.pt--2,\n.py--2 {\n  padding-top: -0.5rem !important;\n}\n\n.pr--2,\n.px--2 {\n  padding-right: -0.5rem !important;\n}\n\n.pb--2,\n.py--2 {\n  padding-bottom: -0.5rem !important;\n}\n\n.pl--2,\n.px--2 {\n  padding-left: -0.5rem !important;\n}\n\n.p--1 {\n  padding: -0.25rem !important;\n}\n\n.pt--1,\n.py--1 {\n  padding-top: -0.25rem !important;\n}\n\n.pr--1,\n.px--1 {\n  padding-right: -0.25rem !important;\n}\n\n.pb--1,\n.py--1 {\n  padding-bottom: -0.25rem !important;\n}\n\n.pl--1,\n.px--1 {\n  padding-left: -0.25rem !important;\n}\n\n.p-6 {\n  padding: 4.5rem !important;\n}\n\n.pt-6,\n.py-6 {\n  padding-top: 4.5rem !important;\n}\n\n.pr-6,\n.px-6 {\n  padding-right: 4.5rem !important;\n}\n\n.pb-6,\n.py-6 {\n  padding-bottom: 4.5rem !important;\n}\n\n.pl-6,\n.px-6 {\n  padding-left: 4.5rem !important;\n}\n\n.p-7 {\n  padding: 6rem !important;\n}\n\n.pt-7,\n.py-7 {\n  padding-top: 6rem !important;\n}\n\n.pr-7,\n.px-7 {\n  padding-right: 6rem !important;\n}\n\n.pb-7,\n.py-7 {\n  padding-bottom: 6rem !important;\n}\n\n.pl-7,\n.px-7 {\n  padding-left: 6rem !important;\n}\n\n.p-8 {\n  padding: 8rem !important;\n}\n\n.pt-8,\n.py-8 {\n  padding-top: 8rem !important;\n}\n\n.pr-8,\n.px-8 {\n  padding-right: 8rem !important;\n}\n\n.pb-8,\n.py-8 {\n  padding-bottom: 8rem !important;\n}\n\n.pl-8,\n.px-8 {\n  padding-left: 8rem !important;\n}\n\n.p-9 {\n  padding: 10rem !important;\n}\n\n.pt-9,\n.py-9 {\n  padding-top: 10rem !important;\n}\n\n.pr-9,\n.px-9 {\n  padding-right: 10rem !important;\n}\n\n.pb-9,\n.py-9 {\n  padding-bottom: 10rem !important;\n}\n\n.pl-9,\n.px-9 {\n  padding-left: 10rem !important;\n}\n\n.m-n1 {\n  margin: -0.25rem !important;\n}\n\n.mt-n1,\n.my-n1 {\n  margin-top: -0.25rem !important;\n}\n\n.mr-n1,\n.mx-n1 {\n  margin-right: -0.25rem !important;\n}\n\n.mb-n1,\n.my-n1 {\n  margin-bottom: -0.25rem !important;\n}\n\n.ml-n1,\n.mx-n1 {\n  margin-left: -0.25rem !important;\n}\n\n.m-n2 {\n  margin: -0.5rem !important;\n}\n\n.mt-n2,\n.my-n2 {\n  margin-top: -0.5rem !important;\n}\n\n.mr-n2,\n.mx-n2 {\n  margin-right: -0.5rem !important;\n}\n\n.mb-n2,\n.my-n2 {\n  margin-bottom: -0.5rem !important;\n}\n\n.ml-n2,\n.mx-n2 {\n  margin-left: -0.5rem !important;\n}\n\n.m-n3 {\n  margin: -1rem !important;\n}\n\n.mt-n3,\n.my-n3 {\n  margin-top: -1rem !important;\n}\n\n.mr-n3,\n.mx-n3 {\n  margin-right: -1rem !important;\n}\n\n.mb-n3,\n.my-n3 {\n  margin-bottom: -1rem !important;\n}\n\n.ml-n3,\n.mx-n3 {\n  margin-left: -1rem !important;\n}\n\n.m-n4 {\n  margin: -1.5rem !important;\n}\n\n.mt-n4,\n.my-n4 {\n  margin-top: -1.5rem !important;\n}\n\n.mr-n4,\n.mx-n4 {\n  margin-right: -1.5rem !important;\n}\n\n.mb-n4,\n.my-n4 {\n  margin-bottom: -1.5rem !important;\n}\n\n.ml-n4,\n.mx-n4 {\n  margin-left: -1.5rem !important;\n}\n\n.m-n5 {\n  margin: -3rem !important;\n}\n\n.mt-n5,\n.my-n5 {\n  margin-top: -3rem !important;\n}\n\n.mr-n5,\n.mx-n5 {\n  margin-right: -3rem !important;\n}\n\n.mb-n5,\n.my-n5 {\n  margin-bottom: -3rem !important;\n}\n\n.ml-n5,\n.mx-n5 {\n  margin-left: -3rem !important;\n}\n\n.m-n-9 {\n  margin: 10rem !important;\n}\n\n.mt-n-9,\n.my-n-9 {\n  margin-top: 10rem !important;\n}\n\n.mr-n-9,\n.mx-n-9 {\n  margin-right: 10rem !important;\n}\n\n.mb-n-9,\n.my-n-9 {\n  margin-bottom: 10rem !important;\n}\n\n.ml-n-9,\n.mx-n-9 {\n  margin-left: 10rem !important;\n}\n\n.m-n-8 {\n  margin: 8rem !important;\n}\n\n.mt-n-8,\n.my-n-8 {\n  margin-top: 8rem !important;\n}\n\n.mr-n-8,\n.mx-n-8 {\n  margin-right: 8rem !important;\n}\n\n.mb-n-8,\n.my-n-8 {\n  margin-bottom: 8rem !important;\n}\n\n.ml-n-8,\n.mx-n-8 {\n  margin-left: 8rem !important;\n}\n\n.m-n-7 {\n  margin: 6rem !important;\n}\n\n.mt-n-7,\n.my-n-7 {\n  margin-top: 6rem !important;\n}\n\n.mr-n-7,\n.mx-n-7 {\n  margin-right: 6rem !important;\n}\n\n.mb-n-7,\n.my-n-7 {\n  margin-bottom: 6rem !important;\n}\n\n.ml-n-7,\n.mx-n-7 {\n  margin-left: 6rem !important;\n}\n\n.m-n-6 {\n  margin: 4.5rem !important;\n}\n\n.mt-n-6,\n.my-n-6 {\n  margin-top: 4.5rem !important;\n}\n\n.mr-n-6,\n.mx-n-6 {\n  margin-right: 4.5rem !important;\n}\n\n.mb-n-6,\n.my-n-6 {\n  margin-bottom: 4.5rem !important;\n}\n\n.ml-n-6,\n.mx-n-6 {\n  margin-left: 4.5rem !important;\n}\n\n.m-n-5 {\n  margin: 3rem !important;\n}\n\n.mt-n-5,\n.my-n-5 {\n  margin-top: 3rem !important;\n}\n\n.mr-n-5,\n.mx-n-5 {\n  margin-right: 3rem !important;\n}\n\n.mb-n-5,\n.my-n-5 {\n  margin-bottom: 3rem !important;\n}\n\n.ml-n-5,\n.mx-n-5 {\n  margin-left: 3rem !important;\n}\n\n.m-n-4 {\n  margin: 1.5rem !important;\n}\n\n.mt-n-4,\n.my-n-4 {\n  margin-top: 1.5rem !important;\n}\n\n.mr-n-4,\n.mx-n-4 {\n  margin-right: 1.5rem !important;\n}\n\n.mb-n-4,\n.my-n-4 {\n  margin-bottom: 1.5rem !important;\n}\n\n.ml-n-4,\n.mx-n-4 {\n  margin-left: 1.5rem !important;\n}\n\n.m-n-3 {\n  margin: 1rem !important;\n}\n\n.mt-n-3,\n.my-n-3 {\n  margin-top: 1rem !important;\n}\n\n.mr-n-3,\n.mx-n-3 {\n  margin-right: 1rem !important;\n}\n\n.mb-n-3,\n.my-n-3 {\n  margin-bottom: 1rem !important;\n}\n\n.ml-n-3,\n.mx-n-3 {\n  margin-left: 1rem !important;\n}\n\n.m-n-2 {\n  margin: 0.5rem !important;\n}\n\n.mt-n-2,\n.my-n-2 {\n  margin-top: 0.5rem !important;\n}\n\n.mr-n-2,\n.mx-n-2 {\n  margin-right: 0.5rem !important;\n}\n\n.mb-n-2,\n.my-n-2 {\n  margin-bottom: 0.5rem !important;\n}\n\n.ml-n-2,\n.mx-n-2 {\n  margin-left: 0.5rem !important;\n}\n\n.m-n-1 {\n  margin: 0.25rem !important;\n}\n\n.mt-n-1,\n.my-n-1 {\n  margin-top: 0.25rem !important;\n}\n\n.mr-n-1,\n.mx-n-1 {\n  margin-right: 0.25rem !important;\n}\n\n.mb-n-1,\n.my-n-1 {\n  margin-bottom: 0.25rem !important;\n}\n\n.ml-n-1,\n.mx-n-1 {\n  margin-left: 0.25rem !important;\n}\n\n.m-n6 {\n  margin: -4.5rem !important;\n}\n\n.mt-n6,\n.my-n6 {\n  margin-top: -4.5rem !important;\n}\n\n.mr-n6,\n.mx-n6 {\n  margin-right: -4.5rem !important;\n}\n\n.mb-n6,\n.my-n6 {\n  margin-bottom: -4.5rem !important;\n}\n\n.ml-n6,\n.mx-n6 {\n  margin-left: -4.5rem !important;\n}\n\n.m-n7 {\n  margin: -6rem !important;\n}\n\n.mt-n7,\n.my-n7 {\n  margin-top: -6rem !important;\n}\n\n.mr-n7,\n.mx-n7 {\n  margin-right: -6rem !important;\n}\n\n.mb-n7,\n.my-n7 {\n  margin-bottom: -6rem !important;\n}\n\n.ml-n7,\n.mx-n7 {\n  margin-left: -6rem !important;\n}\n\n.m-n8 {\n  margin: -8rem !important;\n}\n\n.mt-n8,\n.my-n8 {\n  margin-top: -8rem !important;\n}\n\n.mr-n8,\n.mx-n8 {\n  margin-right: -8rem !important;\n}\n\n.mb-n8,\n.my-n8 {\n  margin-bottom: -8rem !important;\n}\n\n.ml-n8,\n.mx-n8 {\n  margin-left: -8rem !important;\n}\n\n.m-n9 {\n  margin: -10rem !important;\n}\n\n.mt-n9,\n.my-n9 {\n  margin-top: -10rem !important;\n}\n\n.mr-n9,\n.mx-n9 {\n  margin-right: -10rem !important;\n}\n\n.mb-n9,\n.my-n9 {\n  margin-bottom: -10rem !important;\n}\n\n.ml-n9,\n.mx-n9 {\n  margin-left: -10rem !important;\n}\n\n.m-auto {\n  margin: auto !important;\n}\n\n.mt-auto,\n.my-auto {\n  margin-top: auto !important;\n}\n\n.mr-auto,\n.mx-auto {\n  margin-right: auto !important;\n}\n\n.mb-auto,\n.my-auto {\n  margin-bottom: auto !important;\n}\n\n.ml-auto,\n.mx-auto {\n  margin-left: auto !important;\n}\n\n@media (min-width: 576px) {\n  .m-sm-0 {\n    margin: 0 !important;\n  }\n  .mt-sm-0,\n  .my-sm-0 {\n    margin-top: 0 !important;\n  }\n  .mr-sm-0,\n  .mx-sm-0 {\n    margin-right: 0 !important;\n  }\n  .mb-sm-0,\n  .my-sm-0 {\n    margin-bottom: 0 !important;\n  }\n  .ml-sm-0,\n  .mx-sm-0 {\n    margin-left: 0 !important;\n  }\n  .m-sm-1 {\n    margin: 0.25rem !important;\n  }\n  .mt-sm-1,\n  .my-sm-1 {\n    margin-top: 0.25rem !important;\n  }\n  .mr-sm-1,\n  .mx-sm-1 {\n    margin-right: 0.25rem !important;\n  }\n  .mb-sm-1,\n  .my-sm-1 {\n    margin-bottom: 0.25rem !important;\n  }\n  .ml-sm-1,\n  .mx-sm-1 {\n    margin-left: 0.25rem !important;\n  }\n  .m-sm-2 {\n    margin: 0.5rem !important;\n  }\n  .mt-sm-2,\n  .my-sm-2 {\n    margin-top: 0.5rem !important;\n  }\n  .mr-sm-2,\n  .mx-sm-2 {\n    margin-right: 0.5rem !important;\n  }\n  .mb-sm-2,\n  .my-sm-2 {\n    margin-bottom: 0.5rem !important;\n  }\n  .ml-sm-2,\n  .mx-sm-2 {\n    margin-left: 0.5rem !important;\n  }\n  .m-sm-3 {\n    margin: 1rem !important;\n  }\n  .mt-sm-3,\n  .my-sm-3 {\n    margin-top: 1rem !important;\n  }\n  .mr-sm-3,\n  .mx-sm-3 {\n    margin-right: 1rem !important;\n  }\n  .mb-sm-3,\n  .my-sm-3 {\n    margin-bottom: 1rem !important;\n  }\n  .ml-sm-3,\n  .mx-sm-3 {\n    margin-left: 1rem !important;\n  }\n  .m-sm-4 {\n    margin: 1.5rem !important;\n  }\n  .mt-sm-4,\n  .my-sm-4 {\n    margin-top: 1.5rem !important;\n  }\n  .mr-sm-4,\n  .mx-sm-4 {\n    margin-right: 1.5rem !important;\n  }\n  .mb-sm-4,\n  .my-sm-4 {\n    margin-bottom: 1.5rem !important;\n  }\n  .ml-sm-4,\n  .mx-sm-4 {\n    margin-left: 1.5rem !important;\n  }\n  .m-sm-5 {\n    margin: 3rem !important;\n  }\n  .mt-sm-5,\n  .my-sm-5 {\n    margin-top: 3rem !important;\n  }\n  .mr-sm-5,\n  .mx-sm-5 {\n    margin-right: 3rem !important;\n  }\n  .mb-sm-5,\n  .my-sm-5 {\n    margin-bottom: 3rem !important;\n  }\n  .ml-sm-5,\n  .mx-sm-5 {\n    margin-left: 3rem !important;\n  }\n  .m-sm--9 {\n    margin: -10rem !important;\n  }\n  .mt-sm--9,\n  .my-sm--9 {\n    margin-top: -10rem !important;\n  }\n  .mr-sm--9,\n  .mx-sm--9 {\n    margin-right: -10rem !important;\n  }\n  .mb-sm--9,\n  .my-sm--9 {\n    margin-bottom: -10rem !important;\n  }\n  .ml-sm--9,\n  .mx-sm--9 {\n    margin-left: -10rem !important;\n  }\n  .m-sm--8 {\n    margin: -8rem !important;\n  }\n  .mt-sm--8,\n  .my-sm--8 {\n    margin-top: -8rem !important;\n  }\n  .mr-sm--8,\n  .mx-sm--8 {\n    margin-right: -8rem !important;\n  }\n  .mb-sm--8,\n  .my-sm--8 {\n    margin-bottom: -8rem !important;\n  }\n  .ml-sm--8,\n  .mx-sm--8 {\n    margin-left: -8rem !important;\n  }\n  .m-sm--7 {\n    margin: -6rem !important;\n  }\n  .mt-sm--7,\n  .my-sm--7 {\n    margin-top: -6rem !important;\n  }\n  .mr-sm--7,\n  .mx-sm--7 {\n    margin-right: -6rem !important;\n  }\n  .mb-sm--7,\n  .my-sm--7 {\n    margin-bottom: -6rem !important;\n  }\n  .ml-sm--7,\n  .mx-sm--7 {\n    margin-left: -6rem !important;\n  }\n  .m-sm--6 {\n    margin: -4.5rem !important;\n  }\n  .mt-sm--6,\n  .my-sm--6 {\n    margin-top: -4.5rem !important;\n  }\n  .mr-sm--6,\n  .mx-sm--6 {\n    margin-right: -4.5rem !important;\n  }\n  .mb-sm--6,\n  .my-sm--6 {\n    margin-bottom: -4.5rem !important;\n  }\n  .ml-sm--6,\n  .mx-sm--6 {\n    margin-left: -4.5rem !important;\n  }\n  .m-sm--5 {\n    margin: -3rem !important;\n  }\n  .mt-sm--5,\n  .my-sm--5 {\n    margin-top: -3rem !important;\n  }\n  .mr-sm--5,\n  .mx-sm--5 {\n    margin-right: -3rem !important;\n  }\n  .mb-sm--5,\n  .my-sm--5 {\n    margin-bottom: -3rem !important;\n  }\n  .ml-sm--5,\n  .mx-sm--5 {\n    margin-left: -3rem !important;\n  }\n  .m-sm--4 {\n    margin: -1.5rem !important;\n  }\n  .mt-sm--4,\n  .my-sm--4 {\n    margin-top: -1.5rem !important;\n  }\n  .mr-sm--4,\n  .mx-sm--4 {\n    margin-right: -1.5rem !important;\n  }\n  .mb-sm--4,\n  .my-sm--4 {\n    margin-bottom: -1.5rem !important;\n  }\n  .ml-sm--4,\n  .mx-sm--4 {\n    margin-left: -1.5rem !important;\n  }\n  .m-sm--3 {\n    margin: -1rem !important;\n  }\n  .mt-sm--3,\n  .my-sm--3 {\n    margin-top: -1rem !important;\n  }\n  .mr-sm--3,\n  .mx-sm--3 {\n    margin-right: -1rem !important;\n  }\n  .mb-sm--3,\n  .my-sm--3 {\n    margin-bottom: -1rem !important;\n  }\n  .ml-sm--3,\n  .mx-sm--3 {\n    margin-left: -1rem !important;\n  }\n  .m-sm--2 {\n    margin: -0.5rem !important;\n  }\n  .mt-sm--2,\n  .my-sm--2 {\n    margin-top: -0.5rem !important;\n  }\n  .mr-sm--2,\n  .mx-sm--2 {\n    margin-right: -0.5rem !important;\n  }\n  .mb-sm--2,\n  .my-sm--2 {\n    margin-bottom: -0.5rem !important;\n  }\n  .ml-sm--2,\n  .mx-sm--2 {\n    margin-left: -0.5rem !important;\n  }\n  .m-sm--1 {\n    margin: -0.25rem !important;\n  }\n  .mt-sm--1,\n  .my-sm--1 {\n    margin-top: -0.25rem !important;\n  }\n  .mr-sm--1,\n  .mx-sm--1 {\n    margin-right: -0.25rem !important;\n  }\n  .mb-sm--1,\n  .my-sm--1 {\n    margin-bottom: -0.25rem !important;\n  }\n  .ml-sm--1,\n  .mx-sm--1 {\n    margin-left: -0.25rem !important;\n  }\n  .m-sm-6 {\n    margin: 4.5rem !important;\n  }\n  .mt-sm-6,\n  .my-sm-6 {\n    margin-top: 4.5rem !important;\n  }\n  .mr-sm-6,\n  .mx-sm-6 {\n    margin-right: 4.5rem !important;\n  }\n  .mb-sm-6,\n  .my-sm-6 {\n    margin-bottom: 4.5rem !important;\n  }\n  .ml-sm-6,\n  .mx-sm-6 {\n    margin-left: 4.5rem !important;\n  }\n  .m-sm-7 {\n    margin: 6rem !important;\n  }\n  .mt-sm-7,\n  .my-sm-7 {\n    margin-top: 6rem !important;\n  }\n  .mr-sm-7,\n  .mx-sm-7 {\n    margin-right: 6rem !important;\n  }\n  .mb-sm-7,\n  .my-sm-7 {\n    margin-bottom: 6rem !important;\n  }\n  .ml-sm-7,\n  .mx-sm-7 {\n    margin-left: 6rem !important;\n  }\n  .m-sm-8 {\n    margin: 8rem !important;\n  }\n  .mt-sm-8,\n  .my-sm-8 {\n    margin-top: 8rem !important;\n  }\n  .mr-sm-8,\n  .mx-sm-8 {\n    margin-right: 8rem !important;\n  }\n  .mb-sm-8,\n  .my-sm-8 {\n    margin-bottom: 8rem !important;\n  }\n  .ml-sm-8,\n  .mx-sm-8 {\n    margin-left: 8rem !important;\n  }\n  .m-sm-9 {\n    margin: 10rem !important;\n  }\n  .mt-sm-9,\n  .my-sm-9 {\n    margin-top: 10rem !important;\n  }\n  .mr-sm-9,\n  .mx-sm-9 {\n    margin-right: 10rem !important;\n  }\n  .mb-sm-9,\n  .my-sm-9 {\n    margin-bottom: 10rem !important;\n  }\n  .ml-sm-9,\n  .mx-sm-9 {\n    margin-left: 10rem !important;\n  }\n  .p-sm-0 {\n    padding: 0 !important;\n  }\n  .pt-sm-0,\n  .py-sm-0 {\n    padding-top: 0 !important;\n  }\n  .pr-sm-0,\n  .px-sm-0 {\n    padding-right: 0 !important;\n  }\n  .pb-sm-0,\n  .py-sm-0 {\n    padding-bottom: 0 !important;\n  }\n  .pl-sm-0,\n  .px-sm-0 {\n    padding-left: 0 !important;\n  }\n  .p-sm-1 {\n    padding: 0.25rem !important;\n  }\n  .pt-sm-1,\n  .py-sm-1 {\n    padding-top: 0.25rem !important;\n  }\n  .pr-sm-1,\n  .px-sm-1 {\n    padding-right: 0.25rem !important;\n  }\n  .pb-sm-1,\n  .py-sm-1 {\n    padding-bottom: 0.25rem !important;\n  }\n  .pl-sm-1,\n  .px-sm-1 {\n    padding-left: 0.25rem !important;\n  }\n  .p-sm-2 {\n    padding: 0.5rem !important;\n  }\n  .pt-sm-2,\n  .py-sm-2 {\n    padding-top: 0.5rem !important;\n  }\n  .pr-sm-2,\n  .px-sm-2 {\n    padding-right: 0.5rem !important;\n  }\n  .pb-sm-2,\n  .py-sm-2 {\n    padding-bottom: 0.5rem !important;\n  }\n  .pl-sm-2,\n  .px-sm-2 {\n    padding-left: 0.5rem !important;\n  }\n  .p-sm-3 {\n    padding: 1rem !important;\n  }\n  .pt-sm-3,\n  .py-sm-3 {\n    padding-top: 1rem !important;\n  }\n  .pr-sm-3,\n  .px-sm-3 {\n    padding-right: 1rem !important;\n  }\n  .pb-sm-3,\n  .py-sm-3 {\n    padding-bottom: 1rem !important;\n  }\n  .pl-sm-3,\n  .px-sm-3 {\n    padding-left: 1rem !important;\n  }\n  .p-sm-4 {\n    padding: 1.5rem !important;\n  }\n  .pt-sm-4,\n  .py-sm-4 {\n    padding-top: 1.5rem !important;\n  }\n  .pr-sm-4,\n  .px-sm-4 {\n    padding-right: 1.5rem !important;\n  }\n  .pb-sm-4,\n  .py-sm-4 {\n    padding-bottom: 1.5rem !important;\n  }\n  .pl-sm-4,\n  .px-sm-4 {\n    padding-left: 1.5rem !important;\n  }\n  .p-sm-5 {\n    padding: 3rem !important;\n  }\n  .pt-sm-5,\n  .py-sm-5 {\n    padding-top: 3rem !important;\n  }\n  .pr-sm-5,\n  .px-sm-5 {\n    padding-right: 3rem !important;\n  }\n  .pb-sm-5,\n  .py-sm-5 {\n    padding-bottom: 3rem !important;\n  }\n  .pl-sm-5,\n  .px-sm-5 {\n    padding-left: 3rem !important;\n  }\n  .p-sm--9 {\n    padding: -10rem !important;\n  }\n  .pt-sm--9,\n  .py-sm--9 {\n    padding-top: -10rem !important;\n  }\n  .pr-sm--9,\n  .px-sm--9 {\n    padding-right: -10rem !important;\n  }\n  .pb-sm--9,\n  .py-sm--9 {\n    padding-bottom: -10rem !important;\n  }\n  .pl-sm--9,\n  .px-sm--9 {\n    padding-left: -10rem !important;\n  }\n  .p-sm--8 {\n    padding: -8rem !important;\n  }\n  .pt-sm--8,\n  .py-sm--8 {\n    padding-top: -8rem !important;\n  }\n  .pr-sm--8,\n  .px-sm--8 {\n    padding-right: -8rem !important;\n  }\n  .pb-sm--8,\n  .py-sm--8 {\n    padding-bottom: -8rem !important;\n  }\n  .pl-sm--8,\n  .px-sm--8 {\n    padding-left: -8rem !important;\n  }\n  .p-sm--7 {\n    padding: -6rem !important;\n  }\n  .pt-sm--7,\n  .py-sm--7 {\n    padding-top: -6rem !important;\n  }\n  .pr-sm--7,\n  .px-sm--7 {\n    padding-right: -6rem !important;\n  }\n  .pb-sm--7,\n  .py-sm--7 {\n    padding-bottom: -6rem !important;\n  }\n  .pl-sm--7,\n  .px-sm--7 {\n    padding-left: -6rem !important;\n  }\n  .p-sm--6 {\n    padding: -4.5rem !important;\n  }\n  .pt-sm--6,\n  .py-sm--6 {\n    padding-top: -4.5rem !important;\n  }\n  .pr-sm--6,\n  .px-sm--6 {\n    padding-right: -4.5rem !important;\n  }\n  .pb-sm--6,\n  .py-sm--6 {\n    padding-bottom: -4.5rem !important;\n  }\n  .pl-sm--6,\n  .px-sm--6 {\n    padding-left: -4.5rem !important;\n  }\n  .p-sm--5 {\n    padding: -3rem !important;\n  }\n  .pt-sm--5,\n  .py-sm--5 {\n    padding-top: -3rem !important;\n  }\n  .pr-sm--5,\n  .px-sm--5 {\n    padding-right: -3rem !important;\n  }\n  .pb-sm--5,\n  .py-sm--5 {\n    padding-bottom: -3rem !important;\n  }\n  .pl-sm--5,\n  .px-sm--5 {\n    padding-left: -3rem !important;\n  }\n  .p-sm--4 {\n    padding: -1.5rem !important;\n  }\n  .pt-sm--4,\n  .py-sm--4 {\n    padding-top: -1.5rem !important;\n  }\n  .pr-sm--4,\n  .px-sm--4 {\n    padding-right: -1.5rem !important;\n  }\n  .pb-sm--4,\n  .py-sm--4 {\n    padding-bottom: -1.5rem !important;\n  }\n  .pl-sm--4,\n  .px-sm--4 {\n    padding-left: -1.5rem !important;\n  }\n  .p-sm--3 {\n    padding: -1rem !important;\n  }\n  .pt-sm--3,\n  .py-sm--3 {\n    padding-top: -1rem !important;\n  }\n  .pr-sm--3,\n  .px-sm--3 {\n    padding-right: -1rem !important;\n  }\n  .pb-sm--3,\n  .py-sm--3 {\n    padding-bottom: -1rem !important;\n  }\n  .pl-sm--3,\n  .px-sm--3 {\n    padding-left: -1rem !important;\n  }\n  .p-sm--2 {\n    padding: -0.5rem !important;\n  }\n  .pt-sm--2,\n  .py-sm--2 {\n    padding-top: -0.5rem !important;\n  }\n  .pr-sm--2,\n  .px-sm--2 {\n    padding-right: -0.5rem !important;\n  }\n  .pb-sm--2,\n  .py-sm--2 {\n    padding-bottom: -0.5rem !important;\n  }\n  .pl-sm--2,\n  .px-sm--2 {\n    padding-left: -0.5rem !important;\n  }\n  .p-sm--1 {\n    padding: -0.25rem !important;\n  }\n  .pt-sm--1,\n  .py-sm--1 {\n    padding-top: -0.25rem !important;\n  }\n  .pr-sm--1,\n  .px-sm--1 {\n    padding-right: -0.25rem !important;\n  }\n  .pb-sm--1,\n  .py-sm--1 {\n    padding-bottom: -0.25rem !important;\n  }\n  .pl-sm--1,\n  .px-sm--1 {\n    padding-left: -0.25rem !important;\n  }\n  .p-sm-6 {\n    padding: 4.5rem !important;\n  }\n  .pt-sm-6,\n  .py-sm-6 {\n    padding-top: 4.5rem !important;\n  }\n  .pr-sm-6,\n  .px-sm-6 {\n    padding-right: 4.5rem !important;\n  }\n  .pb-sm-6,\n  .py-sm-6 {\n    padding-bottom: 4.5rem !important;\n  }\n  .pl-sm-6,\n  .px-sm-6 {\n    padding-left: 4.5rem !important;\n  }\n  .p-sm-7 {\n    padding: 6rem !important;\n  }\n  .pt-sm-7,\n  .py-sm-7 {\n    padding-top: 6rem !important;\n  }\n  .pr-sm-7,\n  .px-sm-7 {\n    padding-right: 6rem !important;\n  }\n  .pb-sm-7,\n  .py-sm-7 {\n    padding-bottom: 6rem !important;\n  }\n  .pl-sm-7,\n  .px-sm-7 {\n    padding-left: 6rem !important;\n  }\n  .p-sm-8 {\n    padding: 8rem !important;\n  }\n  .pt-sm-8,\n  .py-sm-8 {\n    padding-top: 8rem !important;\n  }\n  .pr-sm-8,\n  .px-sm-8 {\n    padding-right: 8rem !important;\n  }\n  .pb-sm-8,\n  .py-sm-8 {\n    padding-bottom: 8rem !important;\n  }\n  .pl-sm-8,\n  .px-sm-8 {\n    padding-left: 8rem !important;\n  }\n  .p-sm-9 {\n    padding: 10rem !important;\n  }\n  .pt-sm-9,\n  .py-sm-9 {\n    padding-top: 10rem !important;\n  }\n  .pr-sm-9,\n  .px-sm-9 {\n    padding-right: 10rem !important;\n  }\n  .pb-sm-9,\n  .py-sm-9 {\n    padding-bottom: 10rem !important;\n  }\n  .pl-sm-9,\n  .px-sm-9 {\n    padding-left: 10rem !important;\n  }\n  .m-sm-n1 {\n    margin: -0.25rem !important;\n  }\n  .mt-sm-n1,\n  .my-sm-n1 {\n    margin-top: -0.25rem !important;\n  }\n  .mr-sm-n1,\n  .mx-sm-n1 {\n    margin-right: -0.25rem !important;\n  }\n  .mb-sm-n1,\n  .my-sm-n1 {\n    margin-bottom: -0.25rem !important;\n  }\n  .ml-sm-n1,\n  .mx-sm-n1 {\n    margin-left: -0.25rem !important;\n  }\n  .m-sm-n2 {\n    margin: -0.5rem !important;\n  }\n  .mt-sm-n2,\n  .my-sm-n2 {\n    margin-top: -0.5rem !important;\n  }\n  .mr-sm-n2,\n  .mx-sm-n2 {\n    margin-right: -0.5rem !important;\n  }\n  .mb-sm-n2,\n  .my-sm-n2 {\n    margin-bottom: -0.5rem !important;\n  }\n  .ml-sm-n2,\n  .mx-sm-n2 {\n    margin-left: -0.5rem !important;\n  }\n  .m-sm-n3 {\n    margin: -1rem !important;\n  }\n  .mt-sm-n3,\n  .my-sm-n3 {\n    margin-top: -1rem !important;\n  }\n  .mr-sm-n3,\n  .mx-sm-n3 {\n    margin-right: -1rem !important;\n  }\n  .mb-sm-n3,\n  .my-sm-n3 {\n    margin-bottom: -1rem !important;\n  }\n  .ml-sm-n3,\n  .mx-sm-n3 {\n    margin-left: -1rem !important;\n  }\n  .m-sm-n4 {\n    margin: -1.5rem !important;\n  }\n  .mt-sm-n4,\n  .my-sm-n4 {\n    margin-top: -1.5rem !important;\n  }\n  .mr-sm-n4,\n  .mx-sm-n4 {\n    margin-right: -1.5rem !important;\n  }\n  .mb-sm-n4,\n  .my-sm-n4 {\n    margin-bottom: -1.5rem !important;\n  }\n  .ml-sm-n4,\n  .mx-sm-n4 {\n    margin-left: -1.5rem !important;\n  }\n  .m-sm-n5 {\n    margin: -3rem !important;\n  }\n  .mt-sm-n5,\n  .my-sm-n5 {\n    margin-top: -3rem !important;\n  }\n  .mr-sm-n5,\n  .mx-sm-n5 {\n    margin-right: -3rem !important;\n  }\n  .mb-sm-n5,\n  .my-sm-n5 {\n    margin-bottom: -3rem !important;\n  }\n  .ml-sm-n5,\n  .mx-sm-n5 {\n    margin-left: -3rem !important;\n  }\n  .m-sm-n-9 {\n    margin: 10rem !important;\n  }\n  .mt-sm-n-9,\n  .my-sm-n-9 {\n    margin-top: 10rem !important;\n  }\n  .mr-sm-n-9,\n  .mx-sm-n-9 {\n    margin-right: 10rem !important;\n  }\n  .mb-sm-n-9,\n  .my-sm-n-9 {\n    margin-bottom: 10rem !important;\n  }\n  .ml-sm-n-9,\n  .mx-sm-n-9 {\n    margin-left: 10rem !important;\n  }\n  .m-sm-n-8 {\n    margin: 8rem !important;\n  }\n  .mt-sm-n-8,\n  .my-sm-n-8 {\n    margin-top: 8rem !important;\n  }\n  .mr-sm-n-8,\n  .mx-sm-n-8 {\n    margin-right: 8rem !important;\n  }\n  .mb-sm-n-8,\n  .my-sm-n-8 {\n    margin-bottom: 8rem !important;\n  }\n  .ml-sm-n-8,\n  .mx-sm-n-8 {\n    margin-left: 8rem !important;\n  }\n  .m-sm-n-7 {\n    margin: 6rem !important;\n  }\n  .mt-sm-n-7,\n  .my-sm-n-7 {\n    margin-top: 6rem !important;\n  }\n  .mr-sm-n-7,\n  .mx-sm-n-7 {\n    margin-right: 6rem !important;\n  }\n  .mb-sm-n-7,\n  .my-sm-n-7 {\n    margin-bottom: 6rem !important;\n  }\n  .ml-sm-n-7,\n  .mx-sm-n-7 {\n    margin-left: 6rem !important;\n  }\n  .m-sm-n-6 {\n    margin: 4.5rem !important;\n  }\n  .mt-sm-n-6,\n  .my-sm-n-6 {\n    margin-top: 4.5rem !important;\n  }\n  .mr-sm-n-6,\n  .mx-sm-n-6 {\n    margin-right: 4.5rem !important;\n  }\n  .mb-sm-n-6,\n  .my-sm-n-6 {\n    margin-bottom: 4.5rem !important;\n  }\n  .ml-sm-n-6,\n  .mx-sm-n-6 {\n    margin-left: 4.5rem !important;\n  }\n  .m-sm-n-5 {\n    margin: 3rem !important;\n  }\n  .mt-sm-n-5,\n  .my-sm-n-5 {\n    margin-top: 3rem !important;\n  }\n  .mr-sm-n-5,\n  .mx-sm-n-5 {\n    margin-right: 3rem !important;\n  }\n  .mb-sm-n-5,\n  .my-sm-n-5 {\n    margin-bottom: 3rem !important;\n  }\n  .ml-sm-n-5,\n  .mx-sm-n-5 {\n    margin-left: 3rem !important;\n  }\n  .m-sm-n-4 {\n    margin: 1.5rem !important;\n  }\n  .mt-sm-n-4,\n  .my-sm-n-4 {\n    margin-top: 1.5rem !important;\n  }\n  .mr-sm-n-4,\n  .mx-sm-n-4 {\n    margin-right: 1.5rem !important;\n  }\n  .mb-sm-n-4,\n  .my-sm-n-4 {\n    margin-bottom: 1.5rem !important;\n  }\n  .ml-sm-n-4,\n  .mx-sm-n-4 {\n    margin-left: 1.5rem !important;\n  }\n  .m-sm-n-3 {\n    margin: 1rem !important;\n  }\n  .mt-sm-n-3,\n  .my-sm-n-3 {\n    margin-top: 1rem !important;\n  }\n  .mr-sm-n-3,\n  .mx-sm-n-3 {\n    margin-right: 1rem !important;\n  }\n  .mb-sm-n-3,\n  .my-sm-n-3 {\n    margin-bottom: 1rem !important;\n  }\n  .ml-sm-n-3,\n  .mx-sm-n-3 {\n    margin-left: 1rem !important;\n  }\n  .m-sm-n-2 {\n    margin: 0.5rem !important;\n  }\n  .mt-sm-n-2,\n  .my-sm-n-2 {\n    margin-top: 0.5rem !important;\n  }\n  .mr-sm-n-2,\n  .mx-sm-n-2 {\n    margin-right: 0.5rem !important;\n  }\n  .mb-sm-n-2,\n  .my-sm-n-2 {\n    margin-bottom: 0.5rem !important;\n  }\n  .ml-sm-n-2,\n  .mx-sm-n-2 {\n    margin-left: 0.5rem !important;\n  }\n  .m-sm-n-1 {\n    margin: 0.25rem !important;\n  }\n  .mt-sm-n-1,\n  .my-sm-n-1 {\n    margin-top: 0.25rem !important;\n  }\n  .mr-sm-n-1,\n  .mx-sm-n-1 {\n    margin-right: 0.25rem !important;\n  }\n  .mb-sm-n-1,\n  .my-sm-n-1 {\n    margin-bottom: 0.25rem !important;\n  }\n  .ml-sm-n-1,\n  .mx-sm-n-1 {\n    margin-left: 0.25rem !important;\n  }\n  .m-sm-n6 {\n    margin: -4.5rem !important;\n  }\n  .mt-sm-n6,\n  .my-sm-n6 {\n    margin-top: -4.5rem !important;\n  }\n  .mr-sm-n6,\n  .mx-sm-n6 {\n    margin-right: -4.5rem !important;\n  }\n  .mb-sm-n6,\n  .my-sm-n6 {\n    margin-bottom: -4.5rem !important;\n  }\n  .ml-sm-n6,\n  .mx-sm-n6 {\n    margin-left: -4.5rem !important;\n  }\n  .m-sm-n7 {\n    margin: -6rem !important;\n  }\n  .mt-sm-n7,\n  .my-sm-n7 {\n    margin-top: -6rem !important;\n  }\n  .mr-sm-n7,\n  .mx-sm-n7 {\n    margin-right: -6rem !important;\n  }\n  .mb-sm-n7,\n  .my-sm-n7 {\n    margin-bottom: -6rem !important;\n  }\n  .ml-sm-n7,\n  .mx-sm-n7 {\n    margin-left: -6rem !important;\n  }\n  .m-sm-n8 {\n    margin: -8rem !important;\n  }\n  .mt-sm-n8,\n  .my-sm-n8 {\n    margin-top: -8rem !important;\n  }\n  .mr-sm-n8,\n  .mx-sm-n8 {\n    margin-right: -8rem !important;\n  }\n  .mb-sm-n8,\n  .my-sm-n8 {\n    margin-bottom: -8rem !important;\n  }\n  .ml-sm-n8,\n  .mx-sm-n8 {\n    margin-left: -8rem !important;\n  }\n  .m-sm-n9 {\n    margin: -10rem !important;\n  }\n  .mt-sm-n9,\n  .my-sm-n9 {\n    margin-top: -10rem !important;\n  }\n  .mr-sm-n9,\n  .mx-sm-n9 {\n    margin-right: -10rem !important;\n  }\n  .mb-sm-n9,\n  .my-sm-n9 {\n    margin-bottom: -10rem !important;\n  }\n  .ml-sm-n9,\n  .mx-sm-n9 {\n    margin-left: -10rem !important;\n  }\n  .m-sm-auto {\n    margin: auto !important;\n  }\n  .mt-sm-auto,\n  .my-sm-auto {\n    margin-top: auto !important;\n  }\n  .mr-sm-auto,\n  .mx-sm-auto {\n    margin-right: auto !important;\n  }\n  .mb-sm-auto,\n  .my-sm-auto {\n    margin-bottom: auto !important;\n  }\n  .ml-sm-auto,\n  .mx-sm-auto {\n    margin-left: auto !important;\n  }\n}\n@media (min-width: 768px) {\n  .m-md-0 {\n    margin: 0 !important;\n  }\n  .mt-md-0,\n  .my-md-0 {\n    margin-top: 0 !important;\n  }\n  .mr-md-0,\n  .mx-md-0 {\n    margin-right: 0 !important;\n  }\n  .mb-md-0,\n  .my-md-0 {\n    margin-bottom: 0 !important;\n  }\n  .ml-md-0,\n  .mx-md-0 {\n    margin-left: 0 !important;\n  }\n  .m-md-1 {\n    margin: 0.25rem !important;\n  }\n  .mt-md-1,\n  .my-md-1 {\n    margin-top: 0.25rem !important;\n  }\n  .mr-md-1,\n  .mx-md-1 {\n    margin-right: 0.25rem !important;\n  }\n  .mb-md-1,\n  .my-md-1 {\n    margin-bottom: 0.25rem !important;\n  }\n  .ml-md-1,\n  .mx-md-1 {\n    margin-left: 0.25rem !important;\n  }\n  .m-md-2 {\n    margin: 0.5rem !important;\n  }\n  .mt-md-2,\n  .my-md-2 {\n    margin-top: 0.5rem !important;\n  }\n  .mr-md-2,\n  .mx-md-2 {\n    margin-right: 0.5rem !important;\n  }\n  .mb-md-2,\n  .my-md-2 {\n    margin-bottom: 0.5rem !important;\n  }\n  .ml-md-2,\n  .mx-md-2 {\n    margin-left: 0.5rem !important;\n  }\n  .m-md-3 {\n    margin: 1rem !important;\n  }\n  .mt-md-3,\n  .my-md-3 {\n    margin-top: 1rem !important;\n  }\n  .mr-md-3,\n  .mx-md-3 {\n    margin-right: 1rem !important;\n  }\n  .mb-md-3,\n  .my-md-3 {\n    margin-bottom: 1rem !important;\n  }\n  .ml-md-3,\n  .mx-md-3 {\n    margin-left: 1rem !important;\n  }\n  .m-md-4 {\n    margin: 1.5rem !important;\n  }\n  .mt-md-4,\n  .my-md-4 {\n    margin-top: 1.5rem !important;\n  }\n  .mr-md-4,\n  .mx-md-4 {\n    margin-right: 1.5rem !important;\n  }\n  .mb-md-4,\n  .my-md-4 {\n    margin-bottom: 1.5rem !important;\n  }\n  .ml-md-4,\n  .mx-md-4 {\n    margin-left: 1.5rem !important;\n  }\n  .m-md-5 {\n    margin: 3rem !important;\n  }\n  .mt-md-5,\n  .my-md-5 {\n    margin-top: 3rem !important;\n  }\n  .mr-md-5,\n  .mx-md-5 {\n    margin-right: 3rem !important;\n  }\n  .mb-md-5,\n  .my-md-5 {\n    margin-bottom: 3rem !important;\n  }\n  .ml-md-5,\n  .mx-md-5 {\n    margin-left: 3rem !important;\n  }\n  .m-md--9 {\n    margin: -10rem !important;\n  }\n  .mt-md--9,\n  .my-md--9 {\n    margin-top: -10rem !important;\n  }\n  .mr-md--9,\n  .mx-md--9 {\n    margin-right: -10rem !important;\n  }\n  .mb-md--9,\n  .my-md--9 {\n    margin-bottom: -10rem !important;\n  }\n  .ml-md--9,\n  .mx-md--9 {\n    margin-left: -10rem !important;\n  }\n  .m-md--8 {\n    margin: -8rem !important;\n  }\n  .mt-md--8,\n  .my-md--8 {\n    margin-top: -8rem !important;\n  }\n  .mr-md--8,\n  .mx-md--8 {\n    margin-right: -8rem !important;\n  }\n  .mb-md--8,\n  .my-md--8 {\n    margin-bottom: -8rem !important;\n  }\n  .ml-md--8,\n  .mx-md--8 {\n    margin-left: -8rem !important;\n  }\n  .m-md--7 {\n    margin: -6rem !important;\n  }\n  .mt-md--7,\n  .my-md--7 {\n    margin-top: -6rem !important;\n  }\n  .mr-md--7,\n  .mx-md--7 {\n    margin-right: -6rem !important;\n  }\n  .mb-md--7,\n  .my-md--7 {\n    margin-bottom: -6rem !important;\n  }\n  .ml-md--7,\n  .mx-md--7 {\n    margin-left: -6rem !important;\n  }\n  .m-md--6 {\n    margin: -4.5rem !important;\n  }\n  .mt-md--6,\n  .my-md--6 {\n    margin-top: -4.5rem !important;\n  }\n  .mr-md--6,\n  .mx-md--6 {\n    margin-right: -4.5rem !important;\n  }\n  .mb-md--6,\n  .my-md--6 {\n    margin-bottom: -4.5rem !important;\n  }\n  .ml-md--6,\n  .mx-md--6 {\n    margin-left: -4.5rem !important;\n  }\n  .m-md--5 {\n    margin: -3rem !important;\n  }\n  .mt-md--5,\n  .my-md--5 {\n    margin-top: -3rem !important;\n  }\n  .mr-md--5,\n  .mx-md--5 {\n    margin-right: -3rem !important;\n  }\n  .mb-md--5,\n  .my-md--5 {\n    margin-bottom: -3rem !important;\n  }\n  .ml-md--5,\n  .mx-md--5 {\n    margin-left: -3rem !important;\n  }\n  .m-md--4 {\n    margin: -1.5rem !important;\n  }\n  .mt-md--4,\n  .my-md--4 {\n    margin-top: -1.5rem !important;\n  }\n  .mr-md--4,\n  .mx-md--4 {\n    margin-right: -1.5rem !important;\n  }\n  .mb-md--4,\n  .my-md--4 {\n    margin-bottom: -1.5rem !important;\n  }\n  .ml-md--4,\n  .mx-md--4 {\n    margin-left: -1.5rem !important;\n  }\n  .m-md--3 {\n    margin: -1rem !important;\n  }\n  .mt-md--3,\n  .my-md--3 {\n    margin-top: -1rem !important;\n  }\n  .mr-md--3,\n  .mx-md--3 {\n    margin-right: -1rem !important;\n  }\n  .mb-md--3,\n  .my-md--3 {\n    margin-bottom: -1rem !important;\n  }\n  .ml-md--3,\n  .mx-md--3 {\n    margin-left: -1rem !important;\n  }\n  .m-md--2 {\n    margin: -0.5rem !important;\n  }\n  .mt-md--2,\n  .my-md--2 {\n    margin-top: -0.5rem !important;\n  }\n  .mr-md--2,\n  .mx-md--2 {\n    margin-right: -0.5rem !important;\n  }\n  .mb-md--2,\n  .my-md--2 {\n    margin-bottom: -0.5rem !important;\n  }\n  .ml-md--2,\n  .mx-md--2 {\n    margin-left: -0.5rem !important;\n  }\n  .m-md--1 {\n    margin: -0.25rem !important;\n  }\n  .mt-md--1,\n  .my-md--1 {\n    margin-top: -0.25rem !important;\n  }\n  .mr-md--1,\n  .mx-md--1 {\n    margin-right: -0.25rem !important;\n  }\n  .mb-md--1,\n  .my-md--1 {\n    margin-bottom: -0.25rem !important;\n  }\n  .ml-md--1,\n  .mx-md--1 {\n    margin-left: -0.25rem !important;\n  }\n  .m-md-6 {\n    margin: 4.5rem !important;\n  }\n  .mt-md-6,\n  .my-md-6 {\n    margin-top: 4.5rem !important;\n  }\n  .mr-md-6,\n  .mx-md-6 {\n    margin-right: 4.5rem !important;\n  }\n  .mb-md-6,\n  .my-md-6 {\n    margin-bottom: 4.5rem !important;\n  }\n  .ml-md-6,\n  .mx-md-6 {\n    margin-left: 4.5rem !important;\n  }\n  .m-md-7 {\n    margin: 6rem !important;\n  }\n  .mt-md-7,\n  .my-md-7 {\n    margin-top: 6rem !important;\n  }\n  .mr-md-7,\n  .mx-md-7 {\n    margin-right: 6rem !important;\n  }\n  .mb-md-7,\n  .my-md-7 {\n    margin-bottom: 6rem !important;\n  }\n  .ml-md-7,\n  .mx-md-7 {\n    margin-left: 6rem !important;\n  }\n  .m-md-8 {\n    margin: 8rem !important;\n  }\n  .mt-md-8,\n  .my-md-8 {\n    margin-top: 8rem !important;\n  }\n  .mr-md-8,\n  .mx-md-8 {\n    margin-right: 8rem !important;\n  }\n  .mb-md-8,\n  .my-md-8 {\n    margin-bottom: 8rem !important;\n  }\n  .ml-md-8,\n  .mx-md-8 {\n    margin-left: 8rem !important;\n  }\n  .m-md-9 {\n    margin: 10rem !important;\n  }\n  .mt-md-9,\n  .my-md-9 {\n    margin-top: 10rem !important;\n  }\n  .mr-md-9,\n  .mx-md-9 {\n    margin-right: 10rem !important;\n  }\n  .mb-md-9,\n  .my-md-9 {\n    margin-bottom: 10rem !important;\n  }\n  .ml-md-9,\n  .mx-md-9 {\n    margin-left: 10rem !important;\n  }\n  .p-md-0 {\n    padding: 0 !important;\n  }\n  .pt-md-0,\n  .py-md-0 {\n    padding-top: 0 !important;\n  }\n  .pr-md-0,\n  .px-md-0 {\n    padding-right: 0 !important;\n  }\n  .pb-md-0,\n  .py-md-0 {\n    padding-bottom: 0 !important;\n  }\n  .pl-md-0,\n  .px-md-0 {\n    padding-left: 0 !important;\n  }\n  .p-md-1 {\n    padding: 0.25rem !important;\n  }\n  .pt-md-1,\n  .py-md-1 {\n    padding-top: 0.25rem !important;\n  }\n  .pr-md-1,\n  .px-md-1 {\n    padding-right: 0.25rem !important;\n  }\n  .pb-md-1,\n  .py-md-1 {\n    padding-bottom: 0.25rem !important;\n  }\n  .pl-md-1,\n  .px-md-1 {\n    padding-left: 0.25rem !important;\n  }\n  .p-md-2 {\n    padding: 0.5rem !important;\n  }\n  .pt-md-2,\n  .py-md-2 {\n    padding-top: 0.5rem !important;\n  }\n  .pr-md-2,\n  .px-md-2 {\n    padding-right: 0.5rem !important;\n  }\n  .pb-md-2,\n  .py-md-2 {\n    padding-bottom: 0.5rem !important;\n  }\n  .pl-md-2,\n  .px-md-2 {\n    padding-left: 0.5rem !important;\n  }\n  .p-md-3 {\n    padding: 1rem !important;\n  }\n  .pt-md-3,\n  .py-md-3 {\n    padding-top: 1rem !important;\n  }\n  .pr-md-3,\n  .px-md-3 {\n    padding-right: 1rem !important;\n  }\n  .pb-md-3,\n  .py-md-3 {\n    padding-bottom: 1rem !important;\n  }\n  .pl-md-3,\n  .px-md-3 {\n    padding-left: 1rem !important;\n  }\n  .p-md-4 {\n    padding: 1.5rem !important;\n  }\n  .pt-md-4,\n  .py-md-4 {\n    padding-top: 1.5rem !important;\n  }\n  .pr-md-4,\n  .px-md-4 {\n    padding-right: 1.5rem !important;\n  }\n  .pb-md-4,\n  .py-md-4 {\n    padding-bottom: 1.5rem !important;\n  }\n  .pl-md-4,\n  .px-md-4 {\n    padding-left: 1.5rem !important;\n  }\n  .p-md-5 {\n    padding: 3rem !important;\n  }\n  .pt-md-5,\n  .py-md-5 {\n    padding-top: 3rem !important;\n  }\n  .pr-md-5,\n  .px-md-5 {\n    padding-right: 3rem !important;\n  }\n  .pb-md-5,\n  .py-md-5 {\n    padding-bottom: 3rem !important;\n  }\n  .pl-md-5,\n  .px-md-5 {\n    padding-left: 3rem !important;\n  }\n  .p-md--9 {\n    padding: -10rem !important;\n  }\n  .pt-md--9,\n  .py-md--9 {\n    padding-top: -10rem !important;\n  }\n  .pr-md--9,\n  .px-md--9 {\n    padding-right: -10rem !important;\n  }\n  .pb-md--9,\n  .py-md--9 {\n    padding-bottom: -10rem !important;\n  }\n  .pl-md--9,\n  .px-md--9 {\n    padding-left: -10rem !important;\n  }\n  .p-md--8 {\n    padding: -8rem !important;\n  }\n  .pt-md--8,\n  .py-md--8 {\n    padding-top: -8rem !important;\n  }\n  .pr-md--8,\n  .px-md--8 {\n    padding-right: -8rem !important;\n  }\n  .pb-md--8,\n  .py-md--8 {\n    padding-bottom: -8rem !important;\n  }\n  .pl-md--8,\n  .px-md--8 {\n    padding-left: -8rem !important;\n  }\n  .p-md--7 {\n    padding: -6rem !important;\n  }\n  .pt-md--7,\n  .py-md--7 {\n    padding-top: -6rem !important;\n  }\n  .pr-md--7,\n  .px-md--7 {\n    padding-right: -6rem !important;\n  }\n  .pb-md--7,\n  .py-md--7 {\n    padding-bottom: -6rem !important;\n  }\n  .pl-md--7,\n  .px-md--7 {\n    padding-left: -6rem !important;\n  }\n  .p-md--6 {\n    padding: -4.5rem !important;\n  }\n  .pt-md--6,\n  .py-md--6 {\n    padding-top: -4.5rem !important;\n  }\n  .pr-md--6,\n  .px-md--6 {\n    padding-right: -4.5rem !important;\n  }\n  .pb-md--6,\n  .py-md--6 {\n    padding-bottom: -4.5rem !important;\n  }\n  .pl-md--6,\n  .px-md--6 {\n    padding-left: -4.5rem !important;\n  }\n  .p-md--5 {\n    padding: -3rem !important;\n  }\n  .pt-md--5,\n  .py-md--5 {\n    padding-top: -3rem !important;\n  }\n  .pr-md--5,\n  .px-md--5 {\n    padding-right: -3rem !important;\n  }\n  .pb-md--5,\n  .py-md--5 {\n    padding-bottom: -3rem !important;\n  }\n  .pl-md--5,\n  .px-md--5 {\n    padding-left: -3rem !important;\n  }\n  .p-md--4 {\n    padding: -1.5rem !important;\n  }\n  .pt-md--4,\n  .py-md--4 {\n    padding-top: -1.5rem !important;\n  }\n  .pr-md--4,\n  .px-md--4 {\n    padding-right: -1.5rem !important;\n  }\n  .pb-md--4,\n  .py-md--4 {\n    padding-bottom: -1.5rem !important;\n  }\n  .pl-md--4,\n  .px-md--4 {\n    padding-left: -1.5rem !important;\n  }\n  .p-md--3 {\n    padding: -1rem !important;\n  }\n  .pt-md--3,\n  .py-md--3 {\n    padding-top: -1rem !important;\n  }\n  .pr-md--3,\n  .px-md--3 {\n    padding-right: -1rem !important;\n  }\n  .pb-md--3,\n  .py-md--3 {\n    padding-bottom: -1rem !important;\n  }\n  .pl-md--3,\n  .px-md--3 {\n    padding-left: -1rem !important;\n  }\n  .p-md--2 {\n    padding: -0.5rem !important;\n  }\n  .pt-md--2,\n  .py-md--2 {\n    padding-top: -0.5rem !important;\n  }\n  .pr-md--2,\n  .px-md--2 {\n    padding-right: -0.5rem !important;\n  }\n  .pb-md--2,\n  .py-md--2 {\n    padding-bottom: -0.5rem !important;\n  }\n  .pl-md--2,\n  .px-md--2 {\n    padding-left: -0.5rem !important;\n  }\n  .p-md--1 {\n    padding: -0.25rem !important;\n  }\n  .pt-md--1,\n  .py-md--1 {\n    padding-top: -0.25rem !important;\n  }\n  .pr-md--1,\n  .px-md--1 {\n    padding-right: -0.25rem !important;\n  }\n  .pb-md--1,\n  .py-md--1 {\n    padding-bottom: -0.25rem !important;\n  }\n  .pl-md--1,\n  .px-md--1 {\n    padding-left: -0.25rem !important;\n  }\n  .p-md-6 {\n    padding: 4.5rem !important;\n  }\n  .pt-md-6,\n  .py-md-6 {\n    padding-top: 4.5rem !important;\n  }\n  .pr-md-6,\n  .px-md-6 {\n    padding-right: 4.5rem !important;\n  }\n  .pb-md-6,\n  .py-md-6 {\n    padding-bottom: 4.5rem !important;\n  }\n  .pl-md-6,\n  .px-md-6 {\n    padding-left: 4.5rem !important;\n  }\n  .p-md-7 {\n    padding: 6rem !important;\n  }\n  .pt-md-7,\n  .py-md-7 {\n    padding-top: 6rem !important;\n  }\n  .pr-md-7,\n  .px-md-7 {\n    padding-right: 6rem !important;\n  }\n  .pb-md-7,\n  .py-md-7 {\n    padding-bottom: 6rem !important;\n  }\n  .pl-md-7,\n  .px-md-7 {\n    padding-left: 6rem !important;\n  }\n  .p-md-8 {\n    padding: 8rem !important;\n  }\n  .pt-md-8,\n  .py-md-8 {\n    padding-top: 8rem !important;\n  }\n  .pr-md-8,\n  .px-md-8 {\n    padding-right: 8rem !important;\n  }\n  .pb-md-8,\n  .py-md-8 {\n    padding-bottom: 8rem !important;\n  }\n  .pl-md-8,\n  .px-md-8 {\n    padding-left: 8rem !important;\n  }\n  .p-md-9 {\n    padding: 10rem !important;\n  }\n  .pt-md-9,\n  .py-md-9 {\n    padding-top: 10rem !important;\n  }\n  .pr-md-9,\n  .px-md-9 {\n    padding-right: 10rem !important;\n  }\n  .pb-md-9,\n  .py-md-9 {\n    padding-bottom: 10rem !important;\n  }\n  .pl-md-9,\n  .px-md-9 {\n    padding-left: 10rem !important;\n  }\n  .m-md-n1 {\n    margin: -0.25rem !important;\n  }\n  .mt-md-n1,\n  .my-md-n1 {\n    margin-top: -0.25rem !important;\n  }\n  .mr-md-n1,\n  .mx-md-n1 {\n    margin-right: -0.25rem !important;\n  }\n  .mb-md-n1,\n  .my-md-n1 {\n    margin-bottom: -0.25rem !important;\n  }\n  .ml-md-n1,\n  .mx-md-n1 {\n    margin-left: -0.25rem !important;\n  }\n  .m-md-n2 {\n    margin: -0.5rem !important;\n  }\n  .mt-md-n2,\n  .my-md-n2 {\n    margin-top: -0.5rem !important;\n  }\n  .mr-md-n2,\n  .mx-md-n2 {\n    margin-right: -0.5rem !important;\n  }\n  .mb-md-n2,\n  .my-md-n2 {\n    margin-bottom: -0.5rem !important;\n  }\n  .ml-md-n2,\n  .mx-md-n2 {\n    margin-left: -0.5rem !important;\n  }\n  .m-md-n3 {\n    margin: -1rem !important;\n  }\n  .mt-md-n3,\n  .my-md-n3 {\n    margin-top: -1rem !important;\n  }\n  .mr-md-n3,\n  .mx-md-n3 {\n    margin-right: -1rem !important;\n  }\n  .mb-md-n3,\n  .my-md-n3 {\n    margin-bottom: -1rem !important;\n  }\n  .ml-md-n3,\n  .mx-md-n3 {\n    margin-left: -1rem !important;\n  }\n  .m-md-n4 {\n    margin: -1.5rem !important;\n  }\n  .mt-md-n4,\n  .my-md-n4 {\n    margin-top: -1.5rem !important;\n  }\n  .mr-md-n4,\n  .mx-md-n4 {\n    margin-right: -1.5rem !important;\n  }\n  .mb-md-n4,\n  .my-md-n4 {\n    margin-bottom: -1.5rem !important;\n  }\n  .ml-md-n4,\n  .mx-md-n4 {\n    margin-left: -1.5rem !important;\n  }\n  .m-md-n5 {\n    margin: -3rem !important;\n  }\n  .mt-md-n5,\n  .my-md-n5 {\n    margin-top: -3rem !important;\n  }\n  .mr-md-n5,\n  .mx-md-n5 {\n    margin-right: -3rem !important;\n  }\n  .mb-md-n5,\n  .my-md-n5 {\n    margin-bottom: -3rem !important;\n  }\n  .ml-md-n5,\n  .mx-md-n5 {\n    margin-left: -3rem !important;\n  }\n  .m-md-n-9 {\n    margin: 10rem !important;\n  }\n  .mt-md-n-9,\n  .my-md-n-9 {\n    margin-top: 10rem !important;\n  }\n  .mr-md-n-9,\n  .mx-md-n-9 {\n    margin-right: 10rem !important;\n  }\n  .mb-md-n-9,\n  .my-md-n-9 {\n    margin-bottom: 10rem !important;\n  }\n  .ml-md-n-9,\n  .mx-md-n-9 {\n    margin-left: 10rem !important;\n  }\n  .m-md-n-8 {\n    margin: 8rem !important;\n  }\n  .mt-md-n-8,\n  .my-md-n-8 {\n    margin-top: 8rem !important;\n  }\n  .mr-md-n-8,\n  .mx-md-n-8 {\n    margin-right: 8rem !important;\n  }\n  .mb-md-n-8,\n  .my-md-n-8 {\n    margin-bottom: 8rem !important;\n  }\n  .ml-md-n-8,\n  .mx-md-n-8 {\n    margin-left: 8rem !important;\n  }\n  .m-md-n-7 {\n    margin: 6rem !important;\n  }\n  .mt-md-n-7,\n  .my-md-n-7 {\n    margin-top: 6rem !important;\n  }\n  .mr-md-n-7,\n  .mx-md-n-7 {\n    margin-right: 6rem !important;\n  }\n  .mb-md-n-7,\n  .my-md-n-7 {\n    margin-bottom: 6rem !important;\n  }\n  .ml-md-n-7,\n  .mx-md-n-7 {\n    margin-left: 6rem !important;\n  }\n  .m-md-n-6 {\n    margin: 4.5rem !important;\n  }\n  .mt-md-n-6,\n  .my-md-n-6 {\n    margin-top: 4.5rem !important;\n  }\n  .mr-md-n-6,\n  .mx-md-n-6 {\n    margin-right: 4.5rem !important;\n  }\n  .mb-md-n-6,\n  .my-md-n-6 {\n    margin-bottom: 4.5rem !important;\n  }\n  .ml-md-n-6,\n  .mx-md-n-6 {\n    margin-left: 4.5rem !important;\n  }\n  .m-md-n-5 {\n    margin: 3rem !important;\n  }\n  .mt-md-n-5,\n  .my-md-n-5 {\n    margin-top: 3rem !important;\n  }\n  .mr-md-n-5,\n  .mx-md-n-5 {\n    margin-right: 3rem !important;\n  }\n  .mb-md-n-5,\n  .my-md-n-5 {\n    margin-bottom: 3rem !important;\n  }\n  .ml-md-n-5,\n  .mx-md-n-5 {\n    margin-left: 3rem !important;\n  }\n  .m-md-n-4 {\n    margin: 1.5rem !important;\n  }\n  .mt-md-n-4,\n  .my-md-n-4 {\n    margin-top: 1.5rem !important;\n  }\n  .mr-md-n-4,\n  .mx-md-n-4 {\n    margin-right: 1.5rem !important;\n  }\n  .mb-md-n-4,\n  .my-md-n-4 {\n    margin-bottom: 1.5rem !important;\n  }\n  .ml-md-n-4,\n  .mx-md-n-4 {\n    margin-left: 1.5rem !important;\n  }\n  .m-md-n-3 {\n    margin: 1rem !important;\n  }\n  .mt-md-n-3,\n  .my-md-n-3 {\n    margin-top: 1rem !important;\n  }\n  .mr-md-n-3,\n  .mx-md-n-3 {\n    margin-right: 1rem !important;\n  }\n  .mb-md-n-3,\n  .my-md-n-3 {\n    margin-bottom: 1rem !important;\n  }\n  .ml-md-n-3,\n  .mx-md-n-3 {\n    margin-left: 1rem !important;\n  }\n  .m-md-n-2 {\n    margin: 0.5rem !important;\n  }\n  .mt-md-n-2,\n  .my-md-n-2 {\n    margin-top: 0.5rem !important;\n  }\n  .mr-md-n-2,\n  .mx-md-n-2 {\n    margin-right: 0.5rem !important;\n  }\n  .mb-md-n-2,\n  .my-md-n-2 {\n    margin-bottom: 0.5rem !important;\n  }\n  .ml-md-n-2,\n  .mx-md-n-2 {\n    margin-left: 0.5rem !important;\n  }\n  .m-md-n-1 {\n    margin: 0.25rem !important;\n  }\n  .mt-md-n-1,\n  .my-md-n-1 {\n    margin-top: 0.25rem !important;\n  }\n  .mr-md-n-1,\n  .mx-md-n-1 {\n    margin-right: 0.25rem !important;\n  }\n  .mb-md-n-1,\n  .my-md-n-1 {\n    margin-bottom: 0.25rem !important;\n  }\n  .ml-md-n-1,\n  .mx-md-n-1 {\n    margin-left: 0.25rem !important;\n  }\n  .m-md-n6 {\n    margin: -4.5rem !important;\n  }\n  .mt-md-n6,\n  .my-md-n6 {\n    margin-top: -4.5rem !important;\n  }\n  .mr-md-n6,\n  .mx-md-n6 {\n    margin-right: -4.5rem !important;\n  }\n  .mb-md-n6,\n  .my-md-n6 {\n    margin-bottom: -4.5rem !important;\n  }\n  .ml-md-n6,\n  .mx-md-n6 {\n    margin-left: -4.5rem !important;\n  }\n  .m-md-n7 {\n    margin: -6rem !important;\n  }\n  .mt-md-n7,\n  .my-md-n7 {\n    margin-top: -6rem !important;\n  }\n  .mr-md-n7,\n  .mx-md-n7 {\n    margin-right: -6rem !important;\n  }\n  .mb-md-n7,\n  .my-md-n7 {\n    margin-bottom: -6rem !important;\n  }\n  .ml-md-n7,\n  .mx-md-n7 {\n    margin-left: -6rem !important;\n  }\n  .m-md-n8 {\n    margin: -8rem !important;\n  }\n  .mt-md-n8,\n  .my-md-n8 {\n    margin-top: -8rem !important;\n  }\n  .mr-md-n8,\n  .mx-md-n8 {\n    margin-right: -8rem !important;\n  }\n  .mb-md-n8,\n  .my-md-n8 {\n    margin-bottom: -8rem !important;\n  }\n  .ml-md-n8,\n  .mx-md-n8 {\n    margin-left: -8rem !important;\n  }\n  .m-md-n9 {\n    margin: -10rem !important;\n  }\n  .mt-md-n9,\n  .my-md-n9 {\n    margin-top: -10rem !important;\n  }\n  .mr-md-n9,\n  .mx-md-n9 {\n    margin-right: -10rem !important;\n  }\n  .mb-md-n9,\n  .my-md-n9 {\n    margin-bottom: -10rem !important;\n  }\n  .ml-md-n9,\n  .mx-md-n9 {\n    margin-left: -10rem !important;\n  }\n  .m-md-auto {\n    margin: auto !important;\n  }\n  .mt-md-auto,\n  .my-md-auto {\n    margin-top: auto !important;\n  }\n  .mr-md-auto,\n  .mx-md-auto {\n    margin-right: auto !important;\n  }\n  .mb-md-auto,\n  .my-md-auto {\n    margin-bottom: auto !important;\n  }\n  .ml-md-auto,\n  .mx-md-auto {\n    margin-left: auto !important;\n  }\n}\n@media (min-width: 992px) {\n  .m-lg-0 {\n    margin: 0 !important;\n  }\n  .mt-lg-0,\n  .my-lg-0 {\n    margin-top: 0 !important;\n  }\n  .mr-lg-0,\n  .mx-lg-0 {\n    margin-right: 0 !important;\n  }\n  .mb-lg-0,\n  .my-lg-0 {\n    margin-bottom: 0 !important;\n  }\n  .ml-lg-0,\n  .mx-lg-0 {\n    margin-left: 0 !important;\n  }\n  .m-lg-1 {\n    margin: 0.25rem !important;\n  }\n  .mt-lg-1,\n  .my-lg-1 {\n    margin-top: 0.25rem !important;\n  }\n  .mr-lg-1,\n  .mx-lg-1 {\n    margin-right: 0.25rem !important;\n  }\n  .mb-lg-1,\n  .my-lg-1 {\n    margin-bottom: 0.25rem !important;\n  }\n  .ml-lg-1,\n  .mx-lg-1 {\n    margin-left: 0.25rem !important;\n  }\n  .m-lg-2 {\n    margin: 0.5rem !important;\n  }\n  .mt-lg-2,\n  .my-lg-2 {\n    margin-top: 0.5rem !important;\n  }\n  .mr-lg-2,\n  .mx-lg-2 {\n    margin-right: 0.5rem !important;\n  }\n  .mb-lg-2,\n  .my-lg-2 {\n    margin-bottom: 0.5rem !important;\n  }\n  .ml-lg-2,\n  .mx-lg-2 {\n    margin-left: 0.5rem !important;\n  }\n  .m-lg-3 {\n    margin: 1rem !important;\n  }\n  .mt-lg-3,\n  .my-lg-3 {\n    margin-top: 1rem !important;\n  }\n  .mr-lg-3,\n  .mx-lg-3 {\n    margin-right: 1rem !important;\n  }\n  .mb-lg-3,\n  .my-lg-3 {\n    margin-bottom: 1rem !important;\n  }\n  .ml-lg-3,\n  .mx-lg-3 {\n    margin-left: 1rem !important;\n  }\n  .m-lg-4 {\n    margin: 1.5rem !important;\n  }\n  .mt-lg-4,\n  .my-lg-4 {\n    margin-top: 1.5rem !important;\n  }\n  .mr-lg-4,\n  .mx-lg-4 {\n    margin-right: 1.5rem !important;\n  }\n  .mb-lg-4,\n  .my-lg-4 {\n    margin-bottom: 1.5rem !important;\n  }\n  .ml-lg-4,\n  .mx-lg-4 {\n    margin-left: 1.5rem !important;\n  }\n  .m-lg-5 {\n    margin: 3rem !important;\n  }\n  .mt-lg-5,\n  .my-lg-5 {\n    margin-top: 3rem !important;\n  }\n  .mr-lg-5,\n  .mx-lg-5 {\n    margin-right: 3rem !important;\n  }\n  .mb-lg-5,\n  .my-lg-5 {\n    margin-bottom: 3rem !important;\n  }\n  .ml-lg-5,\n  .mx-lg-5 {\n    margin-left: 3rem !important;\n  }\n  .m-lg--9 {\n    margin: -10rem !important;\n  }\n  .mt-lg--9,\n  .my-lg--9 {\n    margin-top: -10rem !important;\n  }\n  .mr-lg--9,\n  .mx-lg--9 {\n    margin-right: -10rem !important;\n  }\n  .mb-lg--9,\n  .my-lg--9 {\n    margin-bottom: -10rem !important;\n  }\n  .ml-lg--9,\n  .mx-lg--9 {\n    margin-left: -10rem !important;\n  }\n  .m-lg--8 {\n    margin: -8rem !important;\n  }\n  .mt-lg--8,\n  .my-lg--8 {\n    margin-top: -8rem !important;\n  }\n  .mr-lg--8,\n  .mx-lg--8 {\n    margin-right: -8rem !important;\n  }\n  .mb-lg--8,\n  .my-lg--8 {\n    margin-bottom: -8rem !important;\n  }\n  .ml-lg--8,\n  .mx-lg--8 {\n    margin-left: -8rem !important;\n  }\n  .m-lg--7 {\n    margin: -6rem !important;\n  }\n  .mt-lg--7,\n  .my-lg--7 {\n    margin-top: -6rem !important;\n  }\n  .mr-lg--7,\n  .mx-lg--7 {\n    margin-right: -6rem !important;\n  }\n  .mb-lg--7,\n  .my-lg--7 {\n    margin-bottom: -6rem !important;\n  }\n  .ml-lg--7,\n  .mx-lg--7 {\n    margin-left: -6rem !important;\n  }\n  .m-lg--6 {\n    margin: -4.5rem !important;\n  }\n  .mt-lg--6,\n  .my-lg--6 {\n    margin-top: -4.5rem !important;\n  }\n  .mr-lg--6,\n  .mx-lg--6 {\n    margin-right: -4.5rem !important;\n  }\n  .mb-lg--6,\n  .my-lg--6 {\n    margin-bottom: -4.5rem !important;\n  }\n  .ml-lg--6,\n  .mx-lg--6 {\n    margin-left: -4.5rem !important;\n  }\n  .m-lg--5 {\n    margin: -3rem !important;\n  }\n  .mt-lg--5,\n  .my-lg--5 {\n    margin-top: -3rem !important;\n  }\n  .mr-lg--5,\n  .mx-lg--5 {\n    margin-right: -3rem !important;\n  }\n  .mb-lg--5,\n  .my-lg--5 {\n    margin-bottom: -3rem !important;\n  }\n  .ml-lg--5,\n  .mx-lg--5 {\n    margin-left: -3rem !important;\n  }\n  .m-lg--4 {\n    margin: -1.5rem !important;\n  }\n  .mt-lg--4,\n  .my-lg--4 {\n    margin-top: -1.5rem !important;\n  }\n  .mr-lg--4,\n  .mx-lg--4 {\n    margin-right: -1.5rem !important;\n  }\n  .mb-lg--4,\n  .my-lg--4 {\n    margin-bottom: -1.5rem !important;\n  }\n  .ml-lg--4,\n  .mx-lg--4 {\n    margin-left: -1.5rem !important;\n  }\n  .m-lg--3 {\n    margin: -1rem !important;\n  }\n  .mt-lg--3,\n  .my-lg--3 {\n    margin-top: -1rem !important;\n  }\n  .mr-lg--3,\n  .mx-lg--3 {\n    margin-right: -1rem !important;\n  }\n  .mb-lg--3,\n  .my-lg--3 {\n    margin-bottom: -1rem !important;\n  }\n  .ml-lg--3,\n  .mx-lg--3 {\n    margin-left: -1rem !important;\n  }\n  .m-lg--2 {\n    margin: -0.5rem !important;\n  }\n  .mt-lg--2,\n  .my-lg--2 {\n    margin-top: -0.5rem !important;\n  }\n  .mr-lg--2,\n  .mx-lg--2 {\n    margin-right: -0.5rem !important;\n  }\n  .mb-lg--2,\n  .my-lg--2 {\n    margin-bottom: -0.5rem !important;\n  }\n  .ml-lg--2,\n  .mx-lg--2 {\n    margin-left: -0.5rem !important;\n  }\n  .m-lg--1 {\n    margin: -0.25rem !important;\n  }\n  .mt-lg--1,\n  .my-lg--1 {\n    margin-top: -0.25rem !important;\n  }\n  .mr-lg--1,\n  .mx-lg--1 {\n    margin-right: -0.25rem !important;\n  }\n  .mb-lg--1,\n  .my-lg--1 {\n    margin-bottom: -0.25rem !important;\n  }\n  .ml-lg--1,\n  .mx-lg--1 {\n    margin-left: -0.25rem !important;\n  }\n  .m-lg-6 {\n    margin: 4.5rem !important;\n  }\n  .mt-lg-6,\n  .my-lg-6 {\n    margin-top: 4.5rem !important;\n  }\n  .mr-lg-6,\n  .mx-lg-6 {\n    margin-right: 4.5rem !important;\n  }\n  .mb-lg-6,\n  .my-lg-6 {\n    margin-bottom: 4.5rem !important;\n  }\n  .ml-lg-6,\n  .mx-lg-6 {\n    margin-left: 4.5rem !important;\n  }\n  .m-lg-7 {\n    margin: 6rem !important;\n  }\n  .mt-lg-7,\n  .my-lg-7 {\n    margin-top: 6rem !important;\n  }\n  .mr-lg-7,\n  .mx-lg-7 {\n    margin-right: 6rem !important;\n  }\n  .mb-lg-7,\n  .my-lg-7 {\n    margin-bottom: 6rem !important;\n  }\n  .ml-lg-7,\n  .mx-lg-7 {\n    margin-left: 6rem !important;\n  }\n  .m-lg-8 {\n    margin: 8rem !important;\n  }\n  .mt-lg-8,\n  .my-lg-8 {\n    margin-top: 8rem !important;\n  }\n  .mr-lg-8,\n  .mx-lg-8 {\n    margin-right: 8rem !important;\n  }\n  .mb-lg-8,\n  .my-lg-8 {\n    margin-bottom: 8rem !important;\n  }\n  .ml-lg-8,\n  .mx-lg-8 {\n    margin-left: 8rem !important;\n  }\n  .m-lg-9 {\n    margin: 10rem !important;\n  }\n  .mt-lg-9,\n  .my-lg-9 {\n    margin-top: 10rem !important;\n  }\n  .mr-lg-9,\n  .mx-lg-9 {\n    margin-right: 10rem !important;\n  }\n  .mb-lg-9,\n  .my-lg-9 {\n    margin-bottom: 10rem !important;\n  }\n  .ml-lg-9,\n  .mx-lg-9 {\n    margin-left: 10rem !important;\n  }\n  .p-lg-0 {\n    padding: 0 !important;\n  }\n  .pt-lg-0,\n  .py-lg-0 {\n    padding-top: 0 !important;\n  }\n  .pr-lg-0,\n  .px-lg-0 {\n    padding-right: 0 !important;\n  }\n  .pb-lg-0,\n  .py-lg-0 {\n    padding-bottom: 0 !important;\n  }\n  .pl-lg-0,\n  .px-lg-0 {\n    padding-left: 0 !important;\n  }\n  .p-lg-1 {\n    padding: 0.25rem !important;\n  }\n  .pt-lg-1,\n  .py-lg-1 {\n    padding-top: 0.25rem !important;\n  }\n  .pr-lg-1,\n  .px-lg-1 {\n    padding-right: 0.25rem !important;\n  }\n  .pb-lg-1,\n  .py-lg-1 {\n    padding-bottom: 0.25rem !important;\n  }\n  .pl-lg-1,\n  .px-lg-1 {\n    padding-left: 0.25rem !important;\n  }\n  .p-lg-2 {\n    padding: 0.5rem !important;\n  }\n  .pt-lg-2,\n  .py-lg-2 {\n    padding-top: 0.5rem !important;\n  }\n  .pr-lg-2,\n  .px-lg-2 {\n    padding-right: 0.5rem !important;\n  }\n  .pb-lg-2,\n  .py-lg-2 {\n    padding-bottom: 0.5rem !important;\n  }\n  .pl-lg-2,\n  .px-lg-2 {\n    padding-left: 0.5rem !important;\n  }\n  .p-lg-3 {\n    padding: 1rem !important;\n  }\n  .pt-lg-3,\n  .py-lg-3 {\n    padding-top: 1rem !important;\n  }\n  .pr-lg-3,\n  .px-lg-3 {\n    padding-right: 1rem !important;\n  }\n  .pb-lg-3,\n  .py-lg-3 {\n    padding-bottom: 1rem !important;\n  }\n  .pl-lg-3,\n  .px-lg-3 {\n    padding-left: 1rem !important;\n  }\n  .p-lg-4 {\n    padding: 1.5rem !important;\n  }\n  .pt-lg-4,\n  .py-lg-4 {\n    padding-top: 1.5rem !important;\n  }\n  .pr-lg-4,\n  .px-lg-4 {\n    padding-right: 1.5rem !important;\n  }\n  .pb-lg-4,\n  .py-lg-4 {\n    padding-bottom: 1.5rem !important;\n  }\n  .pl-lg-4,\n  .px-lg-4 {\n    padding-left: 1.5rem !important;\n  }\n  .p-lg-5 {\n    padding: 3rem !important;\n  }\n  .pt-lg-5,\n  .py-lg-5 {\n    padding-top: 3rem !important;\n  }\n  .pr-lg-5,\n  .px-lg-5 {\n    padding-right: 3rem !important;\n  }\n  .pb-lg-5,\n  .py-lg-5 {\n    padding-bottom: 3rem !important;\n  }\n  .pl-lg-5,\n  .px-lg-5 {\n    padding-left: 3rem !important;\n  }\n  .p-lg--9 {\n    padding: -10rem !important;\n  }\n  .pt-lg--9,\n  .py-lg--9 {\n    padding-top: -10rem !important;\n  }\n  .pr-lg--9,\n  .px-lg--9 {\n    padding-right: -10rem !important;\n  }\n  .pb-lg--9,\n  .py-lg--9 {\n    padding-bottom: -10rem !important;\n  }\n  .pl-lg--9,\n  .px-lg--9 {\n    padding-left: -10rem !important;\n  }\n  .p-lg--8 {\n    padding: -8rem !important;\n  }\n  .pt-lg--8,\n  .py-lg--8 {\n    padding-top: -8rem !important;\n  }\n  .pr-lg--8,\n  .px-lg--8 {\n    padding-right: -8rem !important;\n  }\n  .pb-lg--8,\n  .py-lg--8 {\n    padding-bottom: -8rem !important;\n  }\n  .pl-lg--8,\n  .px-lg--8 {\n    padding-left: -8rem !important;\n  }\n  .p-lg--7 {\n    padding: -6rem !important;\n  }\n  .pt-lg--7,\n  .py-lg--7 {\n    padding-top: -6rem !important;\n  }\n  .pr-lg--7,\n  .px-lg--7 {\n    padding-right: -6rem !important;\n  }\n  .pb-lg--7,\n  .py-lg--7 {\n    padding-bottom: -6rem !important;\n  }\n  .pl-lg--7,\n  .px-lg--7 {\n    padding-left: -6rem !important;\n  }\n  .p-lg--6 {\n    padding: -4.5rem !important;\n  }\n  .pt-lg--6,\n  .py-lg--6 {\n    padding-top: -4.5rem !important;\n  }\n  .pr-lg--6,\n  .px-lg--6 {\n    padding-right: -4.5rem !important;\n  }\n  .pb-lg--6,\n  .py-lg--6 {\n    padding-bottom: -4.5rem !important;\n  }\n  .pl-lg--6,\n  .px-lg--6 {\n    padding-left: -4.5rem !important;\n  }\n  .p-lg--5 {\n    padding: -3rem !important;\n  }\n  .pt-lg--5,\n  .py-lg--5 {\n    padding-top: -3rem !important;\n  }\n  .pr-lg--5,\n  .px-lg--5 {\n    padding-right: -3rem !important;\n  }\n  .pb-lg--5,\n  .py-lg--5 {\n    padding-bottom: -3rem !important;\n  }\n  .pl-lg--5,\n  .px-lg--5 {\n    padding-left: -3rem !important;\n  }\n  .p-lg--4 {\n    padding: -1.5rem !important;\n  }\n  .pt-lg--4,\n  .py-lg--4 {\n    padding-top: -1.5rem !important;\n  }\n  .pr-lg--4,\n  .px-lg--4 {\n    padding-right: -1.5rem !important;\n  }\n  .pb-lg--4,\n  .py-lg--4 {\n    padding-bottom: -1.5rem !important;\n  }\n  .pl-lg--4,\n  .px-lg--4 {\n    padding-left: -1.5rem !important;\n  }\n  .p-lg--3 {\n    padding: -1rem !important;\n  }\n  .pt-lg--3,\n  .py-lg--3 {\n    padding-top: -1rem !important;\n  }\n  .pr-lg--3,\n  .px-lg--3 {\n    padding-right: -1rem !important;\n  }\n  .pb-lg--3,\n  .py-lg--3 {\n    padding-bottom: -1rem !important;\n  }\n  .pl-lg--3,\n  .px-lg--3 {\n    padding-left: -1rem !important;\n  }\n  .p-lg--2 {\n    padding: -0.5rem !important;\n  }\n  .pt-lg--2,\n  .py-lg--2 {\n    padding-top: -0.5rem !important;\n  }\n  .pr-lg--2,\n  .px-lg--2 {\n    padding-right: -0.5rem !important;\n  }\n  .pb-lg--2,\n  .py-lg--2 {\n    padding-bottom: -0.5rem !important;\n  }\n  .pl-lg--2,\n  .px-lg--2 {\n    padding-left: -0.5rem !important;\n  }\n  .p-lg--1 {\n    padding: -0.25rem !important;\n  }\n  .pt-lg--1,\n  .py-lg--1 {\n    padding-top: -0.25rem !important;\n  }\n  .pr-lg--1,\n  .px-lg--1 {\n    padding-right: -0.25rem !important;\n  }\n  .pb-lg--1,\n  .py-lg--1 {\n    padding-bottom: -0.25rem !important;\n  }\n  .pl-lg--1,\n  .px-lg--1 {\n    padding-left: -0.25rem !important;\n  }\n  .p-lg-6 {\n    padding: 4.5rem !important;\n  }\n  .pt-lg-6,\n  .py-lg-6 {\n    padding-top: 4.5rem !important;\n  }\n  .pr-lg-6,\n  .px-lg-6 {\n    padding-right: 4.5rem !important;\n  }\n  .pb-lg-6,\n  .py-lg-6 {\n    padding-bottom: 4.5rem !important;\n  }\n  .pl-lg-6,\n  .px-lg-6 {\n    padding-left: 4.5rem !important;\n  }\n  .p-lg-7 {\n    padding: 6rem !important;\n  }\n  .pt-lg-7,\n  .py-lg-7 {\n    padding-top: 6rem !important;\n  }\n  .pr-lg-7,\n  .px-lg-7 {\n    padding-right: 6rem !important;\n  }\n  .pb-lg-7,\n  .py-lg-7 {\n    padding-bottom: 6rem !important;\n  }\n  .pl-lg-7,\n  .px-lg-7 {\n    padding-left: 6rem !important;\n  }\n  .p-lg-8 {\n    padding: 8rem !important;\n  }\n  .pt-lg-8,\n  .py-lg-8 {\n    padding-top: 8rem !important;\n  }\n  .pr-lg-8,\n  .px-lg-8 {\n    padding-right: 8rem !important;\n  }\n  .pb-lg-8,\n  .py-lg-8 {\n    padding-bottom: 8rem !important;\n  }\n  .pl-lg-8,\n  .px-lg-8 {\n    padding-left: 8rem !important;\n  }\n  .p-lg-9 {\n    padding: 10rem !important;\n  }\n  .pt-lg-9,\n  .py-lg-9 {\n    padding-top: 10rem !important;\n  }\n  .pr-lg-9,\n  .px-lg-9 {\n    padding-right: 10rem !important;\n  }\n  .pb-lg-9,\n  .py-lg-9 {\n    padding-bottom: 10rem !important;\n  }\n  .pl-lg-9,\n  .px-lg-9 {\n    padding-left: 10rem !important;\n  }\n  .m-lg-n1 {\n    margin: -0.25rem !important;\n  }\n  .mt-lg-n1,\n  .my-lg-n1 {\n    margin-top: -0.25rem !important;\n  }\n  .mr-lg-n1,\n  .mx-lg-n1 {\n    margin-right: -0.25rem !important;\n  }\n  .mb-lg-n1,\n  .my-lg-n1 {\n    margin-bottom: -0.25rem !important;\n  }\n  .ml-lg-n1,\n  .mx-lg-n1 {\n    margin-left: -0.25rem !important;\n  }\n  .m-lg-n2 {\n    margin: -0.5rem !important;\n  }\n  .mt-lg-n2,\n  .my-lg-n2 {\n    margin-top: -0.5rem !important;\n  }\n  .mr-lg-n2,\n  .mx-lg-n2 {\n    margin-right: -0.5rem !important;\n  }\n  .mb-lg-n2,\n  .my-lg-n2 {\n    margin-bottom: -0.5rem !important;\n  }\n  .ml-lg-n2,\n  .mx-lg-n2 {\n    margin-left: -0.5rem !important;\n  }\n  .m-lg-n3 {\n    margin: -1rem !important;\n  }\n  .mt-lg-n3,\n  .my-lg-n3 {\n    margin-top: -1rem !important;\n  }\n  .mr-lg-n3,\n  .mx-lg-n3 {\n    margin-right: -1rem !important;\n  }\n  .mb-lg-n3,\n  .my-lg-n3 {\n    margin-bottom: -1rem !important;\n  }\n  .ml-lg-n3,\n  .mx-lg-n3 {\n    margin-left: -1rem !important;\n  }\n  .m-lg-n4 {\n    margin: -1.5rem !important;\n  }\n  .mt-lg-n4,\n  .my-lg-n4 {\n    margin-top: -1.5rem !important;\n  }\n  .mr-lg-n4,\n  .mx-lg-n4 {\n    margin-right: -1.5rem !important;\n  }\n  .mb-lg-n4,\n  .my-lg-n4 {\n    margin-bottom: -1.5rem !important;\n  }\n  .ml-lg-n4,\n  .mx-lg-n4 {\n    margin-left: -1.5rem !important;\n  }\n  .m-lg-n5 {\n    margin: -3rem !important;\n  }\n  .mt-lg-n5,\n  .my-lg-n5 {\n    margin-top: -3rem !important;\n  }\n  .mr-lg-n5,\n  .mx-lg-n5 {\n    margin-right: -3rem !important;\n  }\n  .mb-lg-n5,\n  .my-lg-n5 {\n    margin-bottom: -3rem !important;\n  }\n  .ml-lg-n5,\n  .mx-lg-n5 {\n    margin-left: -3rem !important;\n  }\n  .m-lg-n-9 {\n    margin: 10rem !important;\n  }\n  .mt-lg-n-9,\n  .my-lg-n-9 {\n    margin-top: 10rem !important;\n  }\n  .mr-lg-n-9,\n  .mx-lg-n-9 {\n    margin-right: 10rem !important;\n  }\n  .mb-lg-n-9,\n  .my-lg-n-9 {\n    margin-bottom: 10rem !important;\n  }\n  .ml-lg-n-9,\n  .mx-lg-n-9 {\n    margin-left: 10rem !important;\n  }\n  .m-lg-n-8 {\n    margin: 8rem !important;\n  }\n  .mt-lg-n-8,\n  .my-lg-n-8 {\n    margin-top: 8rem !important;\n  }\n  .mr-lg-n-8,\n  .mx-lg-n-8 {\n    margin-right: 8rem !important;\n  }\n  .mb-lg-n-8,\n  .my-lg-n-8 {\n    margin-bottom: 8rem !important;\n  }\n  .ml-lg-n-8,\n  .mx-lg-n-8 {\n    margin-left: 8rem !important;\n  }\n  .m-lg-n-7 {\n    margin: 6rem !important;\n  }\n  .mt-lg-n-7,\n  .my-lg-n-7 {\n    margin-top: 6rem !important;\n  }\n  .mr-lg-n-7,\n  .mx-lg-n-7 {\n    margin-right: 6rem !important;\n  }\n  .mb-lg-n-7,\n  .my-lg-n-7 {\n    margin-bottom: 6rem !important;\n  }\n  .ml-lg-n-7,\n  .mx-lg-n-7 {\n    margin-left: 6rem !important;\n  }\n  .m-lg-n-6 {\n    margin: 4.5rem !important;\n  }\n  .mt-lg-n-6,\n  .my-lg-n-6 {\n    margin-top: 4.5rem !important;\n  }\n  .mr-lg-n-6,\n  .mx-lg-n-6 {\n    margin-right: 4.5rem !important;\n  }\n  .mb-lg-n-6,\n  .my-lg-n-6 {\n    margin-bottom: 4.5rem !important;\n  }\n  .ml-lg-n-6,\n  .mx-lg-n-6 {\n    margin-left: 4.5rem !important;\n  }\n  .m-lg-n-5 {\n    margin: 3rem !important;\n  }\n  .mt-lg-n-5,\n  .my-lg-n-5 {\n    margin-top: 3rem !important;\n  }\n  .mr-lg-n-5,\n  .mx-lg-n-5 {\n    margin-right: 3rem !important;\n  }\n  .mb-lg-n-5,\n  .my-lg-n-5 {\n    margin-bottom: 3rem !important;\n  }\n  .ml-lg-n-5,\n  .mx-lg-n-5 {\n    margin-left: 3rem !important;\n  }\n  .m-lg-n-4 {\n    margin: 1.5rem !important;\n  }\n  .mt-lg-n-4,\n  .my-lg-n-4 {\n    margin-top: 1.5rem !important;\n  }\n  .mr-lg-n-4,\n  .mx-lg-n-4 {\n    margin-right: 1.5rem !important;\n  }\n  .mb-lg-n-4,\n  .my-lg-n-4 {\n    margin-bottom: 1.5rem !important;\n  }\n  .ml-lg-n-4,\n  .mx-lg-n-4 {\n    margin-left: 1.5rem !important;\n  }\n  .m-lg-n-3 {\n    margin: 1rem !important;\n  }\n  .mt-lg-n-3,\n  .my-lg-n-3 {\n    margin-top: 1rem !important;\n  }\n  .mr-lg-n-3,\n  .mx-lg-n-3 {\n    margin-right: 1rem !important;\n  }\n  .mb-lg-n-3,\n  .my-lg-n-3 {\n    margin-bottom: 1rem !important;\n  }\n  .ml-lg-n-3,\n  .mx-lg-n-3 {\n    margin-left: 1rem !important;\n  }\n  .m-lg-n-2 {\n    margin: 0.5rem !important;\n  }\n  .mt-lg-n-2,\n  .my-lg-n-2 {\n    margin-top: 0.5rem !important;\n  }\n  .mr-lg-n-2,\n  .mx-lg-n-2 {\n    margin-right: 0.5rem !important;\n  }\n  .mb-lg-n-2,\n  .my-lg-n-2 {\n    margin-bottom: 0.5rem !important;\n  }\n  .ml-lg-n-2,\n  .mx-lg-n-2 {\n    margin-left: 0.5rem !important;\n  }\n  .m-lg-n-1 {\n    margin: 0.25rem !important;\n  }\n  .mt-lg-n-1,\n  .my-lg-n-1 {\n    margin-top: 0.25rem !important;\n  }\n  .mr-lg-n-1,\n  .mx-lg-n-1 {\n    margin-right: 0.25rem !important;\n  }\n  .mb-lg-n-1,\n  .my-lg-n-1 {\n    margin-bottom: 0.25rem !important;\n  }\n  .ml-lg-n-1,\n  .mx-lg-n-1 {\n    margin-left: 0.25rem !important;\n  }\n  .m-lg-n6 {\n    margin: -4.5rem !important;\n  }\n  .mt-lg-n6,\n  .my-lg-n6 {\n    margin-top: -4.5rem !important;\n  }\n  .mr-lg-n6,\n  .mx-lg-n6 {\n    margin-right: -4.5rem !important;\n  }\n  .mb-lg-n6,\n  .my-lg-n6 {\n    margin-bottom: -4.5rem !important;\n  }\n  .ml-lg-n6,\n  .mx-lg-n6 {\n    margin-left: -4.5rem !important;\n  }\n  .m-lg-n7 {\n    margin: -6rem !important;\n  }\n  .mt-lg-n7,\n  .my-lg-n7 {\n    margin-top: -6rem !important;\n  }\n  .mr-lg-n7,\n  .mx-lg-n7 {\n    margin-right: -6rem !important;\n  }\n  .mb-lg-n7,\n  .my-lg-n7 {\n    margin-bottom: -6rem !important;\n  }\n  .ml-lg-n7,\n  .mx-lg-n7 {\n    margin-left: -6rem !important;\n  }\n  .m-lg-n8 {\n    margin: -8rem !important;\n  }\n  .mt-lg-n8,\n  .my-lg-n8 {\n    margin-top: -8rem !important;\n  }\n  .mr-lg-n8,\n  .mx-lg-n8 {\n    margin-right: -8rem !important;\n  }\n  .mb-lg-n8,\n  .my-lg-n8 {\n    margin-bottom: -8rem !important;\n  }\n  .ml-lg-n8,\n  .mx-lg-n8 {\n    margin-left: -8rem !important;\n  }\n  .m-lg-n9 {\n    margin: -10rem !important;\n  }\n  .mt-lg-n9,\n  .my-lg-n9 {\n    margin-top: -10rem !important;\n  }\n  .mr-lg-n9,\n  .mx-lg-n9 {\n    margin-right: -10rem !important;\n  }\n  .mb-lg-n9,\n  .my-lg-n9 {\n    margin-bottom: -10rem !important;\n  }\n  .ml-lg-n9,\n  .mx-lg-n9 {\n    margin-left: -10rem !important;\n  }\n  .m-lg-auto {\n    margin: auto !important;\n  }\n  .mt-lg-auto,\n  .my-lg-auto {\n    margin-top: auto !important;\n  }\n  .mr-lg-auto,\n  .mx-lg-auto {\n    margin-right: auto !important;\n  }\n  .mb-lg-auto,\n  .my-lg-auto {\n    margin-bottom: auto !important;\n  }\n  .ml-lg-auto,\n  .mx-lg-auto {\n    margin-left: auto !important;\n  }\n}\n@media (min-width: 1200px) {\n  .m-xl-0 {\n    margin: 0 !important;\n  }\n  .mt-xl-0,\n  .my-xl-0 {\n    margin-top: 0 !important;\n  }\n  .mr-xl-0,\n  .mx-xl-0 {\n    margin-right: 0 !important;\n  }\n  .mb-xl-0,\n  .my-xl-0 {\n    margin-bottom: 0 !important;\n  }\n  .ml-xl-0,\n  .mx-xl-0 {\n    margin-left: 0 !important;\n  }\n  .m-xl-1 {\n    margin: 0.25rem !important;\n  }\n  .mt-xl-1,\n  .my-xl-1 {\n    margin-top: 0.25rem !important;\n  }\n  .mr-xl-1,\n  .mx-xl-1 {\n    margin-right: 0.25rem !important;\n  }\n  .mb-xl-1,\n  .my-xl-1 {\n    margin-bottom: 0.25rem !important;\n  }\n  .ml-xl-1,\n  .mx-xl-1 {\n    margin-left: 0.25rem !important;\n  }\n  .m-xl-2 {\n    margin: 0.5rem !important;\n  }\n  .mt-xl-2,\n  .my-xl-2 {\n    margin-top: 0.5rem !important;\n  }\n  .mr-xl-2,\n  .mx-xl-2 {\n    margin-right: 0.5rem !important;\n  }\n  .mb-xl-2,\n  .my-xl-2 {\n    margin-bottom: 0.5rem !important;\n  }\n  .ml-xl-2,\n  .mx-xl-2 {\n    margin-left: 0.5rem !important;\n  }\n  .m-xl-3 {\n    margin: 1rem !important;\n  }\n  .mt-xl-3,\n  .my-xl-3 {\n    margin-top: 1rem !important;\n  }\n  .mr-xl-3,\n  .mx-xl-3 {\n    margin-right: 1rem !important;\n  }\n  .mb-xl-3,\n  .my-xl-3 {\n    margin-bottom: 1rem !important;\n  }\n  .ml-xl-3,\n  .mx-xl-3 {\n    margin-left: 1rem !important;\n  }\n  .m-xl-4 {\n    margin: 1.5rem !important;\n  }\n  .mt-xl-4,\n  .my-xl-4 {\n    margin-top: 1.5rem !important;\n  }\n  .mr-xl-4,\n  .mx-xl-4 {\n    margin-right: 1.5rem !important;\n  }\n  .mb-xl-4,\n  .my-xl-4 {\n    margin-bottom: 1.5rem !important;\n  }\n  .ml-xl-4,\n  .mx-xl-4 {\n    margin-left: 1.5rem !important;\n  }\n  .m-xl-5 {\n    margin: 3rem !important;\n  }\n  .mt-xl-5,\n  .my-xl-5 {\n    margin-top: 3rem !important;\n  }\n  .mr-xl-5,\n  .mx-xl-5 {\n    margin-right: 3rem !important;\n  }\n  .mb-xl-5,\n  .my-xl-5 {\n    margin-bottom: 3rem !important;\n  }\n  .ml-xl-5,\n  .mx-xl-5 {\n    margin-left: 3rem !important;\n  }\n  .m-xl--9 {\n    margin: -10rem !important;\n  }\n  .mt-xl--9,\n  .my-xl--9 {\n    margin-top: -10rem !important;\n  }\n  .mr-xl--9,\n  .mx-xl--9 {\n    margin-right: -10rem !important;\n  }\n  .mb-xl--9,\n  .my-xl--9 {\n    margin-bottom: -10rem !important;\n  }\n  .ml-xl--9,\n  .mx-xl--9 {\n    margin-left: -10rem !important;\n  }\n  .m-xl--8 {\n    margin: -8rem !important;\n  }\n  .mt-xl--8,\n  .my-xl--8 {\n    margin-top: -8rem !important;\n  }\n  .mr-xl--8,\n  .mx-xl--8 {\n    margin-right: -8rem !important;\n  }\n  .mb-xl--8,\n  .my-xl--8 {\n    margin-bottom: -8rem !important;\n  }\n  .ml-xl--8,\n  .mx-xl--8 {\n    margin-left: -8rem !important;\n  }\n  .m-xl--7 {\n    margin: -6rem !important;\n  }\n  .mt-xl--7,\n  .my-xl--7 {\n    margin-top: -6rem !important;\n  }\n  .mr-xl--7,\n  .mx-xl--7 {\n    margin-right: -6rem !important;\n  }\n  .mb-xl--7,\n  .my-xl--7 {\n    margin-bottom: -6rem !important;\n  }\n  .ml-xl--7,\n  .mx-xl--7 {\n    margin-left: -6rem !important;\n  }\n  .m-xl--6 {\n    margin: -4.5rem !important;\n  }\n  .mt-xl--6,\n  .my-xl--6 {\n    margin-top: -4.5rem !important;\n  }\n  .mr-xl--6,\n  .mx-xl--6 {\n    margin-right: -4.5rem !important;\n  }\n  .mb-xl--6,\n  .my-xl--6 {\n    margin-bottom: -4.5rem !important;\n  }\n  .ml-xl--6,\n  .mx-xl--6 {\n    margin-left: -4.5rem !important;\n  }\n  .m-xl--5 {\n    margin: -3rem !important;\n  }\n  .mt-xl--5,\n  .my-xl--5 {\n    margin-top: -3rem !important;\n  }\n  .mr-xl--5,\n  .mx-xl--5 {\n    margin-right: -3rem !important;\n  }\n  .mb-xl--5,\n  .my-xl--5 {\n    margin-bottom: -3rem !important;\n  }\n  .ml-xl--5,\n  .mx-xl--5 {\n    margin-left: -3rem !important;\n  }\n  .m-xl--4 {\n    margin: -1.5rem !important;\n  }\n  .mt-xl--4,\n  .my-xl--4 {\n    margin-top: -1.5rem !important;\n  }\n  .mr-xl--4,\n  .mx-xl--4 {\n    margin-right: -1.5rem !important;\n  }\n  .mb-xl--4,\n  .my-xl--4 {\n    margin-bottom: -1.5rem !important;\n  }\n  .ml-xl--4,\n  .mx-xl--4 {\n    margin-left: -1.5rem !important;\n  }\n  .m-xl--3 {\n    margin: -1rem !important;\n  }\n  .mt-xl--3,\n  .my-xl--3 {\n    margin-top: -1rem !important;\n  }\n  .mr-xl--3,\n  .mx-xl--3 {\n    margin-right: -1rem !important;\n  }\n  .mb-xl--3,\n  .my-xl--3 {\n    margin-bottom: -1rem !important;\n  }\n  .ml-xl--3,\n  .mx-xl--3 {\n    margin-left: -1rem !important;\n  }\n  .m-xl--2 {\n    margin: -0.5rem !important;\n  }\n  .mt-xl--2,\n  .my-xl--2 {\n    margin-top: -0.5rem !important;\n  }\n  .mr-xl--2,\n  .mx-xl--2 {\n    margin-right: -0.5rem !important;\n  }\n  .mb-xl--2,\n  .my-xl--2 {\n    margin-bottom: -0.5rem !important;\n  }\n  .ml-xl--2,\n  .mx-xl--2 {\n    margin-left: -0.5rem !important;\n  }\n  .m-xl--1 {\n    margin: -0.25rem !important;\n  }\n  .mt-xl--1,\n  .my-xl--1 {\n    margin-top: -0.25rem !important;\n  }\n  .mr-xl--1,\n  .mx-xl--1 {\n    margin-right: -0.25rem !important;\n  }\n  .mb-xl--1,\n  .my-xl--1 {\n    margin-bottom: -0.25rem !important;\n  }\n  .ml-xl--1,\n  .mx-xl--1 {\n    margin-left: -0.25rem !important;\n  }\n  .m-xl-6 {\n    margin: 4.5rem !important;\n  }\n  .mt-xl-6,\n  .my-xl-6 {\n    margin-top: 4.5rem !important;\n  }\n  .mr-xl-6,\n  .mx-xl-6 {\n    margin-right: 4.5rem !important;\n  }\n  .mb-xl-6,\n  .my-xl-6 {\n    margin-bottom: 4.5rem !important;\n  }\n  .ml-xl-6,\n  .mx-xl-6 {\n    margin-left: 4.5rem !important;\n  }\n  .m-xl-7 {\n    margin: 6rem !important;\n  }\n  .mt-xl-7,\n  .my-xl-7 {\n    margin-top: 6rem !important;\n  }\n  .mr-xl-7,\n  .mx-xl-7 {\n    margin-right: 6rem !important;\n  }\n  .mb-xl-7,\n  .my-xl-7 {\n    margin-bottom: 6rem !important;\n  }\n  .ml-xl-7,\n  .mx-xl-7 {\n    margin-left: 6rem !important;\n  }\n  .m-xl-8 {\n    margin: 8rem !important;\n  }\n  .mt-xl-8,\n  .my-xl-8 {\n    margin-top: 8rem !important;\n  }\n  .mr-xl-8,\n  .mx-xl-8 {\n    margin-right: 8rem !important;\n  }\n  .mb-xl-8,\n  .my-xl-8 {\n    margin-bottom: 8rem !important;\n  }\n  .ml-xl-8,\n  .mx-xl-8 {\n    margin-left: 8rem !important;\n  }\n  .m-xl-9 {\n    margin: 10rem !important;\n  }\n  .mt-xl-9,\n  .my-xl-9 {\n    margin-top: 10rem !important;\n  }\n  .mr-xl-9,\n  .mx-xl-9 {\n    margin-right: 10rem !important;\n  }\n  .mb-xl-9,\n  .my-xl-9 {\n    margin-bottom: 10rem !important;\n  }\n  .ml-xl-9,\n  .mx-xl-9 {\n    margin-left: 10rem !important;\n  }\n  .p-xl-0 {\n    padding: 0 !important;\n  }\n  .pt-xl-0,\n  .py-xl-0 {\n    padding-top: 0 !important;\n  }\n  .pr-xl-0,\n  .px-xl-0 {\n    padding-right: 0 !important;\n  }\n  .pb-xl-0,\n  .py-xl-0 {\n    padding-bottom: 0 !important;\n  }\n  .pl-xl-0,\n  .px-xl-0 {\n    padding-left: 0 !important;\n  }\n  .p-xl-1 {\n    padding: 0.25rem !important;\n  }\n  .pt-xl-1,\n  .py-xl-1 {\n    padding-top: 0.25rem !important;\n  }\n  .pr-xl-1,\n  .px-xl-1 {\n    padding-right: 0.25rem !important;\n  }\n  .pb-xl-1,\n  .py-xl-1 {\n    padding-bottom: 0.25rem !important;\n  }\n  .pl-xl-1,\n  .px-xl-1 {\n    padding-left: 0.25rem !important;\n  }\n  .p-xl-2 {\n    padding: 0.5rem !important;\n  }\n  .pt-xl-2,\n  .py-xl-2 {\n    padding-top: 0.5rem !important;\n  }\n  .pr-xl-2,\n  .px-xl-2 {\n    padding-right: 0.5rem !important;\n  }\n  .pb-xl-2,\n  .py-xl-2 {\n    padding-bottom: 0.5rem !important;\n  }\n  .pl-xl-2,\n  .px-xl-2 {\n    padding-left: 0.5rem !important;\n  }\n  .p-xl-3 {\n    padding: 1rem !important;\n  }\n  .pt-xl-3,\n  .py-xl-3 {\n    padding-top: 1rem !important;\n  }\n  .pr-xl-3,\n  .px-xl-3 {\n    padding-right: 1rem !important;\n  }\n  .pb-xl-3,\n  .py-xl-3 {\n    padding-bottom: 1rem !important;\n  }\n  .pl-xl-3,\n  .px-xl-3 {\n    padding-left: 1rem !important;\n  }\n  .p-xl-4 {\n    padding: 1.5rem !important;\n  }\n  .pt-xl-4,\n  .py-xl-4 {\n    padding-top: 1.5rem !important;\n  }\n  .pr-xl-4,\n  .px-xl-4 {\n    padding-right: 1.5rem !important;\n  }\n  .pb-xl-4,\n  .py-xl-4 {\n    padding-bottom: 1.5rem !important;\n  }\n  .pl-xl-4,\n  .px-xl-4 {\n    padding-left: 1.5rem !important;\n  }\n  .p-xl-5 {\n    padding: 3rem !important;\n  }\n  .pt-xl-5,\n  .py-xl-5 {\n    padding-top: 3rem !important;\n  }\n  .pr-xl-5,\n  .px-xl-5 {\n    padding-right: 3rem !important;\n  }\n  .pb-xl-5,\n  .py-xl-5 {\n    padding-bottom: 3rem !important;\n  }\n  .pl-xl-5,\n  .px-xl-5 {\n    padding-left: 3rem !important;\n  }\n  .p-xl--9 {\n    padding: -10rem !important;\n  }\n  .pt-xl--9,\n  .py-xl--9 {\n    padding-top: -10rem !important;\n  }\n  .pr-xl--9,\n  .px-xl--9 {\n    padding-right: -10rem !important;\n  }\n  .pb-xl--9,\n  .py-xl--9 {\n    padding-bottom: -10rem !important;\n  }\n  .pl-xl--9,\n  .px-xl--9 {\n    padding-left: -10rem !important;\n  }\n  .p-xl--8 {\n    padding: -8rem !important;\n  }\n  .pt-xl--8,\n  .py-xl--8 {\n    padding-top: -8rem !important;\n  }\n  .pr-xl--8,\n  .px-xl--8 {\n    padding-right: -8rem !important;\n  }\n  .pb-xl--8,\n  .py-xl--8 {\n    padding-bottom: -8rem !important;\n  }\n  .pl-xl--8,\n  .px-xl--8 {\n    padding-left: -8rem !important;\n  }\n  .p-xl--7 {\n    padding: -6rem !important;\n  }\n  .pt-xl--7,\n  .py-xl--7 {\n    padding-top: -6rem !important;\n  }\n  .pr-xl--7,\n  .px-xl--7 {\n    padding-right: -6rem !important;\n  }\n  .pb-xl--7,\n  .py-xl--7 {\n    padding-bottom: -6rem !important;\n  }\n  .pl-xl--7,\n  .px-xl--7 {\n    padding-left: -6rem !important;\n  }\n  .p-xl--6 {\n    padding: -4.5rem !important;\n  }\n  .pt-xl--6,\n  .py-xl--6 {\n    padding-top: -4.5rem !important;\n  }\n  .pr-xl--6,\n  .px-xl--6 {\n    padding-right: -4.5rem !important;\n  }\n  .pb-xl--6,\n  .py-xl--6 {\n    padding-bottom: -4.5rem !important;\n  }\n  .pl-xl--6,\n  .px-xl--6 {\n    padding-left: -4.5rem !important;\n  }\n  .p-xl--5 {\n    padding: -3rem !important;\n  }\n  .pt-xl--5,\n  .py-xl--5 {\n    padding-top: -3rem !important;\n  }\n  .pr-xl--5,\n  .px-xl--5 {\n    padding-right: -3rem !important;\n  }\n  .pb-xl--5,\n  .py-xl--5 {\n    padding-bottom: -3rem !important;\n  }\n  .pl-xl--5,\n  .px-xl--5 {\n    padding-left: -3rem !important;\n  }\n  .p-xl--4 {\n    padding: -1.5rem !important;\n  }\n  .pt-xl--4,\n  .py-xl--4 {\n    padding-top: -1.5rem !important;\n  }\n  .pr-xl--4,\n  .px-xl--4 {\n    padding-right: -1.5rem !important;\n  }\n  .pb-xl--4,\n  .py-xl--4 {\n    padding-bottom: -1.5rem !important;\n  }\n  .pl-xl--4,\n  .px-xl--4 {\n    padding-left: -1.5rem !important;\n  }\n  .p-xl--3 {\n    padding: -1rem !important;\n  }\n  .pt-xl--3,\n  .py-xl--3 {\n    padding-top: -1rem !important;\n  }\n  .pr-xl--3,\n  .px-xl--3 {\n    padding-right: -1rem !important;\n  }\n  .pb-xl--3,\n  .py-xl--3 {\n    padding-bottom: -1rem !important;\n  }\n  .pl-xl--3,\n  .px-xl--3 {\n    padding-left: -1rem !important;\n  }\n  .p-xl--2 {\n    padding: -0.5rem !important;\n  }\n  .pt-xl--2,\n  .py-xl--2 {\n    padding-top: -0.5rem !important;\n  }\n  .pr-xl--2,\n  .px-xl--2 {\n    padding-right: -0.5rem !important;\n  }\n  .pb-xl--2,\n  .py-xl--2 {\n    padding-bottom: -0.5rem !important;\n  }\n  .pl-xl--2,\n  .px-xl--2 {\n    padding-left: -0.5rem !important;\n  }\n  .p-xl--1 {\n    padding: -0.25rem !important;\n  }\n  .pt-xl--1,\n  .py-xl--1 {\n    padding-top: -0.25rem !important;\n  }\n  .pr-xl--1,\n  .px-xl--1 {\n    padding-right: -0.25rem !important;\n  }\n  .pb-xl--1,\n  .py-xl--1 {\n    padding-bottom: -0.25rem !important;\n  }\n  .pl-xl--1,\n  .px-xl--1 {\n    padding-left: -0.25rem !important;\n  }\n  .p-xl-6 {\n    padding: 4.5rem !important;\n  }\n  .pt-xl-6,\n  .py-xl-6 {\n    padding-top: 4.5rem !important;\n  }\n  .pr-xl-6,\n  .px-xl-6 {\n    padding-right: 4.5rem !important;\n  }\n  .pb-xl-6,\n  .py-xl-6 {\n    padding-bottom: 4.5rem !important;\n  }\n  .pl-xl-6,\n  .px-xl-6 {\n    padding-left: 4.5rem !important;\n  }\n  .p-xl-7 {\n    padding: 6rem !important;\n  }\n  .pt-xl-7,\n  .py-xl-7 {\n    padding-top: 6rem !important;\n  }\n  .pr-xl-7,\n  .px-xl-7 {\n    padding-right: 6rem !important;\n  }\n  .pb-xl-7,\n  .py-xl-7 {\n    padding-bottom: 6rem !important;\n  }\n  .pl-xl-7,\n  .px-xl-7 {\n    padding-left: 6rem !important;\n  }\n  .p-xl-8 {\n    padding: 8rem !important;\n  }\n  .pt-xl-8,\n  .py-xl-8 {\n    padding-top: 8rem !important;\n  }\n  .pr-xl-8,\n  .px-xl-8 {\n    padding-right: 8rem !important;\n  }\n  .pb-xl-8,\n  .py-xl-8 {\n    padding-bottom: 8rem !important;\n  }\n  .pl-xl-8,\n  .px-xl-8 {\n    padding-left: 8rem !important;\n  }\n  .p-xl-9 {\n    padding: 10rem !important;\n  }\n  .pt-xl-9,\n  .py-xl-9 {\n    padding-top: 10rem !important;\n  }\n  .pr-xl-9,\n  .px-xl-9 {\n    padding-right: 10rem !important;\n  }\n  .pb-xl-9,\n  .py-xl-9 {\n    padding-bottom: 10rem !important;\n  }\n  .pl-xl-9,\n  .px-xl-9 {\n    padding-left: 10rem !important;\n  }\n  .m-xl-n1 {\n    margin: -0.25rem !important;\n  }\n  .mt-xl-n1,\n  .my-xl-n1 {\n    margin-top: -0.25rem !important;\n  }\n  .mr-xl-n1,\n  .mx-xl-n1 {\n    margin-right: -0.25rem !important;\n  }\n  .mb-xl-n1,\n  .my-xl-n1 {\n    margin-bottom: -0.25rem !important;\n  }\n  .ml-xl-n1,\n  .mx-xl-n1 {\n    margin-left: -0.25rem !important;\n  }\n  .m-xl-n2 {\n    margin: -0.5rem !important;\n  }\n  .mt-xl-n2,\n  .my-xl-n2 {\n    margin-top: -0.5rem !important;\n  }\n  .mr-xl-n2,\n  .mx-xl-n2 {\n    margin-right: -0.5rem !important;\n  }\n  .mb-xl-n2,\n  .my-xl-n2 {\n    margin-bottom: -0.5rem !important;\n  }\n  .ml-xl-n2,\n  .mx-xl-n2 {\n    margin-left: -0.5rem !important;\n  }\n  .m-xl-n3 {\n    margin: -1rem !important;\n  }\n  .mt-xl-n3,\n  .my-xl-n3 {\n    margin-top: -1rem !important;\n  }\n  .mr-xl-n3,\n  .mx-xl-n3 {\n    margin-right: -1rem !important;\n  }\n  .mb-xl-n3,\n  .my-xl-n3 {\n    margin-bottom: -1rem !important;\n  }\n  .ml-xl-n3,\n  .mx-xl-n3 {\n    margin-left: -1rem !important;\n  }\n  .m-xl-n4 {\n    margin: -1.5rem !important;\n  }\n  .mt-xl-n4,\n  .my-xl-n4 {\n    margin-top: -1.5rem !important;\n  }\n  .mr-xl-n4,\n  .mx-xl-n4 {\n    margin-right: -1.5rem !important;\n  }\n  .mb-xl-n4,\n  .my-xl-n4 {\n    margin-bottom: -1.5rem !important;\n  }\n  .ml-xl-n4,\n  .mx-xl-n4 {\n    margin-left: -1.5rem !important;\n  }\n  .m-xl-n5 {\n    margin: -3rem !important;\n  }\n  .mt-xl-n5,\n  .my-xl-n5 {\n    margin-top: -3rem !important;\n  }\n  .mr-xl-n5,\n  .mx-xl-n5 {\n    margin-right: -3rem !important;\n  }\n  .mb-xl-n5,\n  .my-xl-n5 {\n    margin-bottom: -3rem !important;\n  }\n  .ml-xl-n5,\n  .mx-xl-n5 {\n    margin-left: -3rem !important;\n  }\n  .m-xl-n-9 {\n    margin: 10rem !important;\n  }\n  .mt-xl-n-9,\n  .my-xl-n-9 {\n    margin-top: 10rem !important;\n  }\n  .mr-xl-n-9,\n  .mx-xl-n-9 {\n    margin-right: 10rem !important;\n  }\n  .mb-xl-n-9,\n  .my-xl-n-9 {\n    margin-bottom: 10rem !important;\n  }\n  .ml-xl-n-9,\n  .mx-xl-n-9 {\n    margin-left: 10rem !important;\n  }\n  .m-xl-n-8 {\n    margin: 8rem !important;\n  }\n  .mt-xl-n-8,\n  .my-xl-n-8 {\n    margin-top: 8rem !important;\n  }\n  .mr-xl-n-8,\n  .mx-xl-n-8 {\n    margin-right: 8rem !important;\n  }\n  .mb-xl-n-8,\n  .my-xl-n-8 {\n    margin-bottom: 8rem !important;\n  }\n  .ml-xl-n-8,\n  .mx-xl-n-8 {\n    margin-left: 8rem !important;\n  }\n  .m-xl-n-7 {\n    margin: 6rem !important;\n  }\n  .mt-xl-n-7,\n  .my-xl-n-7 {\n    margin-top: 6rem !important;\n  }\n  .mr-xl-n-7,\n  .mx-xl-n-7 {\n    margin-right: 6rem !important;\n  }\n  .mb-xl-n-7,\n  .my-xl-n-7 {\n    margin-bottom: 6rem !important;\n  }\n  .ml-xl-n-7,\n  .mx-xl-n-7 {\n    margin-left: 6rem !important;\n  }\n  .m-xl-n-6 {\n    margin: 4.5rem !important;\n  }\n  .mt-xl-n-6,\n  .my-xl-n-6 {\n    margin-top: 4.5rem !important;\n  }\n  .mr-xl-n-6,\n  .mx-xl-n-6 {\n    margin-right: 4.5rem !important;\n  }\n  .mb-xl-n-6,\n  .my-xl-n-6 {\n    margin-bottom: 4.5rem !important;\n  }\n  .ml-xl-n-6,\n  .mx-xl-n-6 {\n    margin-left: 4.5rem !important;\n  }\n  .m-xl-n-5 {\n    margin: 3rem !important;\n  }\n  .mt-xl-n-5,\n  .my-xl-n-5 {\n    margin-top: 3rem !important;\n  }\n  .mr-xl-n-5,\n  .mx-xl-n-5 {\n    margin-right: 3rem !important;\n  }\n  .mb-xl-n-5,\n  .my-xl-n-5 {\n    margin-bottom: 3rem !important;\n  }\n  .ml-xl-n-5,\n  .mx-xl-n-5 {\n    margin-left: 3rem !important;\n  }\n  .m-xl-n-4 {\n    margin: 1.5rem !important;\n  }\n  .mt-xl-n-4,\n  .my-xl-n-4 {\n    margin-top: 1.5rem !important;\n  }\n  .mr-xl-n-4,\n  .mx-xl-n-4 {\n    margin-right: 1.5rem !important;\n  }\n  .mb-xl-n-4,\n  .my-xl-n-4 {\n    margin-bottom: 1.5rem !important;\n  }\n  .ml-xl-n-4,\n  .mx-xl-n-4 {\n    margin-left: 1.5rem !important;\n  }\n  .m-xl-n-3 {\n    margin: 1rem !important;\n  }\n  .mt-xl-n-3,\n  .my-xl-n-3 {\n    margin-top: 1rem !important;\n  }\n  .mr-xl-n-3,\n  .mx-xl-n-3 {\n    margin-right: 1rem !important;\n  }\n  .mb-xl-n-3,\n  .my-xl-n-3 {\n    margin-bottom: 1rem !important;\n  }\n  .ml-xl-n-3,\n  .mx-xl-n-3 {\n    margin-left: 1rem !important;\n  }\n  .m-xl-n-2 {\n    margin: 0.5rem !important;\n  }\n  .mt-xl-n-2,\n  .my-xl-n-2 {\n    margin-top: 0.5rem !important;\n  }\n  .mr-xl-n-2,\n  .mx-xl-n-2 {\n    margin-right: 0.5rem !important;\n  }\n  .mb-xl-n-2,\n  .my-xl-n-2 {\n    margin-bottom: 0.5rem !important;\n  }\n  .ml-xl-n-2,\n  .mx-xl-n-2 {\n    margin-left: 0.5rem !important;\n  }\n  .m-xl-n-1 {\n    margin: 0.25rem !important;\n  }\n  .mt-xl-n-1,\n  .my-xl-n-1 {\n    margin-top: 0.25rem !important;\n  }\n  .mr-xl-n-1,\n  .mx-xl-n-1 {\n    margin-right: 0.25rem !important;\n  }\n  .mb-xl-n-1,\n  .my-xl-n-1 {\n    margin-bottom: 0.25rem !important;\n  }\n  .ml-xl-n-1,\n  .mx-xl-n-1 {\n    margin-left: 0.25rem !important;\n  }\n  .m-xl-n6 {\n    margin: -4.5rem !important;\n  }\n  .mt-xl-n6,\n  .my-xl-n6 {\n    margin-top: -4.5rem !important;\n  }\n  .mr-xl-n6,\n  .mx-xl-n6 {\n    margin-right: -4.5rem !important;\n  }\n  .mb-xl-n6,\n  .my-xl-n6 {\n    margin-bottom: -4.5rem !important;\n  }\n  .ml-xl-n6,\n  .mx-xl-n6 {\n    margin-left: -4.5rem !important;\n  }\n  .m-xl-n7 {\n    margin: -6rem !important;\n  }\n  .mt-xl-n7,\n  .my-xl-n7 {\n    margin-top: -6rem !important;\n  }\n  .mr-xl-n7,\n  .mx-xl-n7 {\n    margin-right: -6rem !important;\n  }\n  .mb-xl-n7,\n  .my-xl-n7 {\n    margin-bottom: -6rem !important;\n  }\n  .ml-xl-n7,\n  .mx-xl-n7 {\n    margin-left: -6rem !important;\n  }\n  .m-xl-n8 {\n    margin: -8rem !important;\n  }\n  .mt-xl-n8,\n  .my-xl-n8 {\n    margin-top: -8rem !important;\n  }\n  .mr-xl-n8,\n  .mx-xl-n8 {\n    margin-right: -8rem !important;\n  }\n  .mb-xl-n8,\n  .my-xl-n8 {\n    margin-bottom: -8rem !important;\n  }\n  .ml-xl-n8,\n  .mx-xl-n8 {\n    margin-left: -8rem !important;\n  }\n  .m-xl-n9 {\n    margin: -10rem !important;\n  }\n  .mt-xl-n9,\n  .my-xl-n9 {\n    margin-top: -10rem !important;\n  }\n  .mr-xl-n9,\n  .mx-xl-n9 {\n    margin-right: -10rem !important;\n  }\n  .mb-xl-n9,\n  .my-xl-n9 {\n    margin-bottom: -10rem !important;\n  }\n  .ml-xl-n9,\n  .mx-xl-n9 {\n    margin-left: -10rem !important;\n  }\n  .m-xl-auto {\n    margin: auto !important;\n  }\n  .mt-xl-auto,\n  .my-xl-auto {\n    margin-top: auto !important;\n  }\n  .mr-xl-auto,\n  .mx-xl-auto {\n    margin-right: auto !important;\n  }\n  .mb-xl-auto,\n  .my-xl-auto {\n    margin-bottom: auto !important;\n  }\n  .ml-xl-auto,\n  .mx-xl-auto {\n    margin-left: auto !important;\n  }\n}\n.stretched-link::after {\n  position: absolute;\n  top: 0;\n  right: 0;\n  bottom: 0;\n  left: 0;\n  z-index: 1;\n  pointer-events: auto;\n  content: \"\";\n  background-color: rgba(0, 0, 0, 0);\n}\n\n.text-monospace {\n  font-family: SFMono-Regular, Menlo, Monaco, Consolas, \"Liberation Mono\", \"Courier New\", monospace !important;\n}\n\n.text-justify {\n  text-align: justify !important;\n}\n\n.text-wrap {\n  white-space: normal !important;\n}\n\n.text-nowrap {\n  white-space: nowrap !important;\n}\n\n.text-truncate {\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n}\n\n.text-left {\n  text-align: left !important;\n}\n\n.text-right {\n  text-align: right !important;\n}\n\n.text-center {\n  text-align: center !important;\n}\n\n@media (min-width: 576px) {\n  .text-sm-left {\n    text-align: left !important;\n  }\n  .text-sm-right {\n    text-align: right !important;\n  }\n  .text-sm-center {\n    text-align: center !important;\n  }\n}\n@media (min-width: 768px) {\n  .text-md-left {\n    text-align: left !important;\n  }\n  .text-md-right {\n    text-align: right !important;\n  }\n  .text-md-center {\n    text-align: center !important;\n  }\n}\n@media (min-width: 992px) {\n  .text-lg-left {\n    text-align: left !important;\n  }\n  .text-lg-right {\n    text-align: right !important;\n  }\n  .text-lg-center {\n    text-align: center !important;\n  }\n}\n@media (min-width: 1200px) {\n  .text-xl-left {\n    text-align: left !important;\n  }\n  .text-xl-right {\n    text-align: right !important;\n  }\n  .text-xl-center {\n    text-align: center !important;\n  }\n}\n.text-lowercase {\n  text-transform: lowercase !important;\n}\n\n.text-uppercase {\n  text-transform: uppercase !important;\n}\n\n.text-capitalize {\n  text-transform: capitalize !important;\n}\n\n.font-weight-light {\n  font-weight: 300 !important;\n}\n\n.font-weight-lighter {\n  font-weight: lighter !important;\n}\n\n.font-weight-normal {\n  font-weight: 400 !important;\n}\n\n.font-weight-bold {\n  font-weight: 600 !important;\n}\n\n.font-weight-bolder {\n  font-weight: bolder !important;\n}\n\n.font-italic {\n  font-style: italic !important;\n}\n\n.text-white {\n  color: #fff !important;\n}\n\n.text-primary {\n  color: #3ba371 !important;\n}\n\na.text-primary:hover, a.text-primary:focus {\n  color: rgb(38.6689189189, 106.8310810811, 74.0608108108) !important;\n}\n\n.text-secondary {\n  color: #f7fafc !important;\n}\n\na.text-secondary:hover, a.text-secondary:focus {\n  color: rgb(191.3636363636, 215.2272727273, 231.1363636364) !important;\n}\n\n.text-success {\n  color: #3aa170 !important;\n}\n\na.text-success:hover, a.text-success:focus {\n  color: rgb(37.7397260274, 104.7602739726, 72.8767123288) !important;\n}\n\n.text-info {\n  color: #278e69 !important;\n}\n\na.text-info:hover, a.text-info:focus {\n  color: rgb(22.5165745856, 81.9834254144, 60.6215469613) !important;\n}\n\n.text-warning {\n  color: #fb6340 !important;\n}\n\na.text-warning:hover, a.text-warning:focus {\n  color: rgb(233.6076923077, 47.7, 4.8923076923) !important;\n}\n\n.text-danger {\n  color: #f5365c !important;\n}\n\na.text-danger:hover, a.text-danger:focus {\n  color: rgb(211.9549763033, 10.5450236967, 50.6161137441) !important;\n}\n\n.text-light {\n  color: #adb5bd !important;\n}\n\na.text-light:hover, a.text-light:focus {\n  color: rgb(130.6148648649, 142.75, 154.8851351351) !important;\n}\n\n.text-dark {\n  color: #212529 !important;\n}\n\na.text-dark:hover, a.text-dark:focus {\n  color: black !important;\n}\n\n.text-default {\n  color: #ffd88c !important;\n}\n\na.text-default:hover, a.text-default:focus {\n  color: rgb(255, 190.0565217391, 63.5) !important;\n}\n\n.text-white {\n  color: #fff !important;\n}\n\na.text-white:hover, a.text-white:focus {\n  color: rgb(216.75, 216.75, 216.75) !important;\n}\n\n.text-neutral {\n  color: #fff !important;\n}\n\na.text-neutral:hover, a.text-neutral:focus {\n  color: rgb(216.75, 216.75, 216.75) !important;\n}\n\n.text-darker {\n  color: black !important;\n}\n\na.text-darker:hover, a.text-darker:focus {\n  color: black !important;\n}\n\n.text-body {\n  color: #525f7f !important;\n}\n\n.text-muted {\n  color: #8898aa !important;\n}\n\n.text-black-50 {\n  color: rgba(0, 0, 0, 0.5) !important;\n}\n\n.text-white-50 {\n  color: rgba(255, 255, 255, 0.5) !important;\n}\n\n.text-hide {\n  font: 0/0 a;\n  color: transparent;\n  text-shadow: none;\n  background-color: transparent;\n  border: 0;\n}\n\n.text-decoration-none {\n  text-decoration: none !important;\n}\n\n.text-break {\n  word-break: break-word !important;\n  word-wrap: break-word !important;\n}\n\n.text-reset {\n  color: inherit !important;\n}\n\n.visible {\n  visibility: visible !important;\n}\n\n.invisible {\n  visibility: hidden !important;\n}\n\n@media print {\n  *,\n  *::before,\n  *::after {\n    text-shadow: none !important;\n    box-shadow: none !important;\n  }\n  a:not(.btn) {\n    text-decoration: underline;\n  }\n  abbr[title]::after {\n    content: \" (\" attr(title) \")\";\n  }\n  pre {\n    white-space: pre-wrap !important;\n  }\n  pre,\n  blockquote {\n    border: 1px solid #adb5bd;\n    page-break-inside: avoid;\n  }\n  thead {\n    display: table-header-group;\n  }\n  tr,\n  img {\n    page-break-inside: avoid;\n  }\n  p,\n  h2,\n  h3 {\n    orphans: 3;\n    widows: 3;\n  }\n  h2,\n  h3 {\n    page-break-after: avoid;\n  }\n  @page {\n    size: a3;\n  }\n  body {\n    min-width: 992px !important;\n  }\n  .container {\n    min-width: 992px !important;\n  }\n  .navbar {\n    display: none;\n  }\n  .badge {\n    border: 1px solid #000;\n  }\n  .table {\n    border-collapse: collapse !important;\n  }\n  .table td,\n  .table th {\n    background-color: #fff !important;\n  }\n  .table-bordered th,\n  .table-bordered td {\n    border: 1px solid #dee2e6 !important;\n  }\n  .table-dark {\n    color: inherit;\n  }\n  .table-dark th,\n  .table-dark td,\n  .table-dark thead th,\n  .table-dark tbody + tbody {\n    border-color: #e9ecef;\n  }\n  .table .thead-dark th {\n    color: inherit;\n    border-color: #e9ecef;\n  }\n}\niframe {\n  border: 0;\n}\n\nfigcaption,\nfigure,\nmain {\n  display: block;\n}\n\nmain {\n  overflow: hidden;\n}\n\n.bg-blue {\n  background-color: #3ba371 !important;\n}\n\na.bg-blue:hover, a.bg-blue:focus,\nbutton.bg-blue:hover,\nbutton.bg-blue:focus {\n  background-color: rgb(45.4459459459, 125.5540540541, 87.0405405405) !important;\n}\n\n.bg-indigo {\n  background-color: #5603ad !important;\n}\n\na.bg-indigo:hover, a.bg-indigo:focus,\nbutton.bg-indigo:hover,\nbutton.bg-indigo:focus {\n  background-color: rgb(61.0795454545, 2.1306818182, 122.8693181818) !important;\n}\n\n.bg-purple {\n  background-color: #8965e0 !important;\n}\n\na.bg-purple:hover, a.bg-purple:focus,\nbutton.bg-purple:hover,\nbutton.bg-purple:focus {\n  background-color: rgb(104.4702702703, 58.5459459459, 215.4540540541) !important;\n}\n\n.bg-pink {\n  background-color: #f3a4b5 !important;\n}\n\na.bg-pink:hover, a.bg-pink:focus,\nbutton.bg-pink:hover,\nbutton.bg-pink:focus {\n  background-color: rgb(237.0582524272, 118.9417475728, 144.359223301) !important;\n}\n\n.bg-red {\n  background-color: #f5365c !important;\n}\n\na.bg-red:hover, a.bg-red:focus,\nbutton.bg-red:hover,\nbutton.bg-red:focus {\n  background-color: rgb(236.2464454976, 11.7535545024, 56.4170616114) !important;\n}\n\n.bg-orange {\n  background-color: #fb6340 !important;\n}\n\na.bg-orange:hover, a.bg-orange:focus,\nbutton.bg-orange:hover,\nbutton.bg-orange:focus {\n  background-color: rgb(249.9538461538, 58.2, 14.0461538462) !important;\n}\n\n.bg-yellow {\n  background-color: #ffd600 !important;\n}\n\na.bg-yellow:hover, a.bg-yellow:focus,\nbutton.bg-yellow:hover,\nbutton.bg-yellow:focus {\n  background-color: rgb(204, 171.2, 0) !important;\n}\n\n.bg-green {\n  background-color: #3aa170 !important;\n}\n\na.bg-green:hover, a.bg-green:focus,\nbutton.bg-green:hover,\nbutton.bg-green:focus {\n  background-color: rgb(44.4931506849, 123.5068493151, 85.9178082192) !important;\n}\n\n.bg-teal {\n  background-color: #278e69 !important;\n}\n\na.bg-teal:hover, a.bg-teal:focus,\nbutton.bg-teal:hover,\nbutton.bg-teal:focus {\n  background-color: rgb(28.0110497238, 101.9889502762, 75.4143646409) !important;\n}\n\n.bg-cyan {\n  background-color: #2bffc6 !important;\n}\n\na.bg-cyan:hover, a.bg-cyan:focus,\nbutton.bg-cyan:hover,\nbutton.bg-cyan:focus {\n  background-color: rgb(0, 247, 180.5896226415) !important;\n}\n\n.bg-white {\n  background-color: #fff !important;\n}\n\na.bg-white:hover, a.bg-white:focus,\nbutton.bg-white:hover,\nbutton.bg-white:focus {\n  background-color: rgb(229.5, 229.5, 229.5) !important;\n}\n\n.bg-gray {\n  background-color: #8898aa !important;\n}\n\na.bg-gray:hover, a.bg-gray:focus,\nbutton.bg-gray:hover,\nbutton.bg-gray:focus {\n  background-color: rgb(106.25, 126.25, 148.75) !important;\n}\n\n.bg-gray-dark {\n  background-color: #32325d !important;\n}\n\na.bg-gray-dark:hover, a.bg-gray-dark:focus,\nbutton.bg-gray-dark:hover,\nbutton.bg-gray-dark:focus {\n  background-color: rgb(32.1678321678, 32.1678321678, 59.8321678322) !important;\n}\n\n.bg-light {\n  background-color: #ced4da !important;\n}\n\na.bg-light:hover, a.bg-light:focus,\nbutton.bg-light:hover,\nbutton.bg-light:focus {\n  background-color: rgb(176.9418604651, 186.5, 196.0581395349) !important;\n}\n\n.bg-lighter {\n  background-color: #e9ecef !important;\n}\n\na.bg-lighter:hover, a.bg-lighter:focus,\nbutton.bg-lighter:hover,\nbutton.bg-lighter:focus {\n  background-color: rgb(203.4736842105, 210.5, 217.5263157895) !important;\n}\n\n.bg-gradient-primary {\n  background: linear-gradient(87deg, #3ba371 0, #3ba371 100%) !important;\n}\n\n.bg-gradient-secondary {\n  background: linear-gradient(87deg, #f7fafc 0, #f7fafc 100%) !important;\n}\n\n.bg-gradient-success {\n  background: linear-gradient(87deg, #3aa170 0, #3aa170 100%) !important;\n}\n\n.bg-gradient-info {\n  background: linear-gradient(87deg, #278e69 0, #278e69 100%) !important;\n}\n\n.bg-gradient-warning {\n  background: linear-gradient(87deg, #fb6340 0, #fb6340 100%) !important;\n}\n\n.bg-gradient-danger {\n  background: linear-gradient(87deg, #f5365c 0, #f5365c 100%) !important;\n}\n\n.bg-gradient-light {\n  background: linear-gradient(87deg, #adb5bd 0, #adb5bd 100%) !important;\n}\n\n.bg-gradient-dark {\n  background: linear-gradient(87deg, #212529 0, #212529 100%) !important;\n}\n\n.bg-gradient-default {\n  background: linear-gradient(87deg, #ffd88c 0, #ffd88c 100%) !important;\n}\n\n.bg-gradient-white {\n  background: linear-gradient(87deg, #fff 0, white 100%) !important;\n}\n\n.bg-gradient-neutral {\n  background: linear-gradient(87deg, #fff 0, white 100%) !important;\n}\n\n.bg-gradient-darker {\n  background: linear-gradient(87deg, black 0, black 100%) !important;\n}\n\n.bg-gradient-blue {\n  background: linear-gradient(87deg, #3ba371 0, #3ba371 100%) !important;\n}\n\n.bg-gradient-indigo {\n  background: linear-gradient(87deg, #5603ad 0, #5603ad 100%) !important;\n}\n\n.bg-gradient-purple {\n  background: linear-gradient(87deg, #8965e0 0, #8965e0 100%) !important;\n}\n\n.bg-gradient-pink {\n  background: linear-gradient(87deg, #f3a4b5 0, #f3a4b5 100%) !important;\n}\n\n.bg-gradient-red {\n  background: linear-gradient(87deg, #f5365c 0, #f5365c 100%) !important;\n}\n\n.bg-gradient-orange {\n  background: linear-gradient(87deg, #fb6340 0, #fb6340 100%) !important;\n}\n\n.bg-gradient-yellow {\n  background: linear-gradient(87deg, #ffd600 0, #ffd600 100%) !important;\n}\n\n.bg-gradient-green {\n  background: linear-gradient(87deg, #3aa170 0, #3aa170 100%) !important;\n}\n\n.bg-gradient-teal {\n  background: linear-gradient(87deg, #278e69 0, #278e69 100%) !important;\n}\n\n.bg-gradient-cyan {\n  background: linear-gradient(87deg, #2bffc6 0, #2bffc6 100%) !important;\n}\n\n.bg-gradient-white {\n  background: linear-gradient(87deg, #fff 0, white 100%) !important;\n}\n\n.bg-gradient-gray {\n  background: linear-gradient(87deg, #8898aa 0, #8898aa 100%) !important;\n}\n\n.bg-gradient-gray-dark {\n  background: linear-gradient(87deg, #32325d 0, #32325d 100%) !important;\n}\n\n.bg-gradient-light {\n  background: linear-gradient(87deg, #ced4da 0, #ced4da 100%) !important;\n}\n\n.bg-gradient-lighter {\n  background: linear-gradient(87deg, #e9ecef 0, #e9ecef 100%) !important;\n}\n\n.bg-translucent-primary {\n  fill: #3ba371 !important;\n}\n\n.bg-translucent-secondary {\n  fill: #f7fafc !important;\n}\n\n.bg-translucent-success {\n  fill: #3aa170 !important;\n}\n\n.bg-translucent-info {\n  fill: #278e69 !important;\n}\n\n.bg-translucent-warning {\n  fill: #fb6340 !important;\n}\n\n.bg-translucent-danger {\n  fill: #f5365c !important;\n}\n\n.bg-translucent-light {\n  fill: #adb5bd !important;\n}\n\n.bg-translucent-dark {\n  fill: #212529 !important;\n}\n\n.bg-translucent-default {\n  fill: #ffd88c !important;\n}\n\n.bg-translucent-white {\n  fill: #fff !important;\n}\n\n.bg-translucent-neutral {\n  fill: #fff !important;\n}\n\n.bg-translucent-darker {\n  fill: black !important;\n}\n\n.section-primary {\n  background-color: #f8f9fe !important;\n}\n\na.section-primary:hover, a.section-primary:focus,\nbutton.section-primary:hover,\nbutton.section-primary:focus {\n  background-color: rgb(203.375, 210.75, 247.625) !important;\n}\n\n.section-secondary {\n  background-color: #f7fafc !important;\n}\n\na.section-secondary:hover, a.section-secondary:focus,\nbutton.section-secondary:hover,\nbutton.section-secondary:focus {\n  background-color: rgb(209.9090909091, 226.8181818182, 238.0909090909) !important;\n}\n\n.section-light {\n  background-color: #ced4da !important;\n}\n\na.section-light:hover, a.section-light:focus,\nbutton.section-light:hover,\nbutton.section-light:focus {\n  background-color: rgb(176.9418604651, 186.5, 196.0581395349) !important;\n}\n\n.section-dark {\n  background-color: #212529 !important;\n}\n\na.section-dark:hover, a.section-dark:focus,\nbutton.section-dark:hover,\nbutton.section-dark:focus {\n  background-color: rgb(10.2567567568, 11.5, 12.7432432432) !important;\n}\n\n.section-darker {\n  background-color: black !important;\n}\n\na.section-darker:hover, a.section-darker:focus,\nbutton.section-darker:hover,\nbutton.section-darker:focus {\n  background-color: black !important;\n}\n\n.bg-gradient-primary {\n  background: linear-gradient(87deg, #3ba371 0, #3ba371 100%) !important;\n}\n\n.bg-gradient-secondary {\n  background: linear-gradient(87deg, #f7fafc 0, #f7fafc 100%) !important;\n}\n\n.bg-gradient-success {\n  background: linear-gradient(87deg, #3aa170 0, #3aa170 100%) !important;\n}\n\n.bg-gradient-info {\n  background: linear-gradient(87deg, #278e69 0, #278e69 100%) !important;\n}\n\n.bg-gradient-warning {\n  background: linear-gradient(87deg, #fb6340 0, #fb6340 100%) !important;\n}\n\n.bg-gradient-danger {\n  background: linear-gradient(87deg, #f5365c 0, #f5365c 100%) !important;\n}\n\n.bg-gradient-light {\n  background: linear-gradient(87deg, #adb5bd 0, #adb5bd 100%) !important;\n}\n\n.bg-gradient-dark {\n  background: linear-gradient(87deg, #212529 0, #212529 100%) !important;\n}\n\n.bg-gradient-default {\n  background: linear-gradient(87deg, #ffd88c 0, #ffd88c 100%) !important;\n}\n\n.bg-gradient-white {\n  background: linear-gradient(87deg, #fff 0, white 100%) !important;\n}\n\n.bg-gradient-neutral {\n  background: linear-gradient(87deg, #fff 0, white 100%) !important;\n}\n\n.bg-gradient-darker {\n  background: linear-gradient(87deg, black 0, black 100%) !important;\n}\n\n.fill-primary {\n  fill: #3ba371;\n}\n\n.stroke-primary {\n  stroke: #3ba371;\n}\n\n.fill-secondary {\n  fill: #f7fafc;\n}\n\n.stroke-secondary {\n  stroke: #f7fafc;\n}\n\n.fill-success {\n  fill: #3aa170;\n}\n\n.stroke-success {\n  stroke: #3aa170;\n}\n\n.fill-info {\n  fill: #278e69;\n}\n\n.stroke-info {\n  stroke: #278e69;\n}\n\n.fill-warning {\n  fill: #fb6340;\n}\n\n.stroke-warning {\n  stroke: #fb6340;\n}\n\n.fill-danger {\n  fill: #f5365c;\n}\n\n.stroke-danger {\n  stroke: #f5365c;\n}\n\n.fill-light {\n  fill: #adb5bd;\n}\n\n.stroke-light {\n  stroke: #adb5bd;\n}\n\n.fill-dark {\n  fill: #212529;\n}\n\n.stroke-dark {\n  stroke: #212529;\n}\n\n.fill-default {\n  fill: #ffd88c;\n}\n\n.stroke-default {\n  stroke: #ffd88c;\n}\n\n.fill-white {\n  fill: #fff;\n}\n\n.stroke-white {\n  stroke: #fff;\n}\n\n.fill-neutral {\n  fill: #fff;\n}\n\n.stroke-neutral {\n  stroke: #fff;\n}\n\n.fill-darker {\n  fill: black;\n}\n\n.stroke-darker {\n  stroke: black;\n}\n\n.fill-opacity-8 {\n  fill-opacity: 0.8;\n}\n\n.floating {\n  animation: floating 3s ease infinite;\n  will-change: transform;\n}\n.floating:hover {\n  animation-play-state: paused;\n}\n\n.floating-lg {\n  animation: floating-lg 3s ease infinite;\n}\n\n.floating-sm {\n  animation: floating-sm 3s ease infinite;\n}\n\n@keyframes floating-lg {\n  0% {\n    transform: translateY(0px);\n  }\n  50% {\n    transform: translateY(15px);\n  }\n  100% {\n    transform: translateY(0px);\n  }\n}\n@keyframes floating {\n  0% {\n    transform: translateY(0px);\n  }\n  50% {\n    transform: translateY(10px);\n  }\n  100% {\n    transform: translateY(0px);\n  }\n}\n@keyframes floating-sm {\n  0% {\n    transform: translateY(0px);\n  }\n  50% {\n    transform: translateY(5px);\n  }\n  100% {\n    transform: translateY(0px);\n  }\n}\n.floatfix:before, .floatfix:after {\n  content: \"\";\n  display: table;\n}\n.floatfix:after {\n  clear: both;\n}\n\n.img-center {\n  display: block;\n  margin-left: auto;\n  margin-right: auto;\n}\n\n.opacity-1 {\n  opacity: 0.1 !important;\n}\n\n.opacity-2 {\n  opacity: 0.2 !important;\n}\n\n.opacity-3 {\n  opacity: 0.3 !important;\n}\n\n.opacity-4 {\n  opacity: 0.4 !important;\n}\n\n.opacity-5 {\n  opacity: 0.5 !important;\n}\n\n.opacity-6 {\n  opacity: 0.6 !important;\n}\n\n.opacity-7 {\n  opacity: 0.7 !important;\n}\n\n.opacity-8 {\n  opacity: 0.8 !important;\n}\n\n.opacity-8 {\n  opacity: 0.9 !important;\n}\n\n.opacity-10 {\n  opacity: 1 !important;\n}\n\n.overflow-visible {\n  overflow: visible !important;\n}\n\n.overflow-hidden {\n  overflow: hidden !important;\n}\n\n.top-0 {\n  top: 0;\n}\n\n.right-0 {\n  right: 0;\n}\n\n.bottom-0 {\n  bottom: 0;\n}\n\n.left-0 {\n  left: 0;\n}\n\n.top-1 {\n  top: 0.25rem;\n}\n\n.right-1 {\n  right: 0.25rem;\n}\n\n.bottom-1 {\n  bottom: 0.25rem;\n}\n\n.left-1 {\n  left: 0.25rem;\n}\n\n.top-2 {\n  top: 0.5rem;\n}\n\n.right-2 {\n  right: 0.5rem;\n}\n\n.bottom-2 {\n  bottom: 0.5rem;\n}\n\n.left-2 {\n  left: 0.5rem;\n}\n\n.top-3 {\n  top: 1rem;\n}\n\n.right-3 {\n  right: 1rem;\n}\n\n.bottom-3 {\n  bottom: 1rem;\n}\n\n.left-3 {\n  left: 1rem;\n}\n\n.top-4 {\n  top: 1.5rem;\n}\n\n.right-4 {\n  right: 1.5rem;\n}\n\n.bottom-4 {\n  bottom: 1.5rem;\n}\n\n.left-4 {\n  left: 1.5rem;\n}\n\n.top-5 {\n  top: 3rem;\n}\n\n.right-5 {\n  right: 3rem;\n}\n\n.bottom-5 {\n  bottom: 3rem;\n}\n\n.left-5 {\n  left: 3rem;\n}\n\n.top--9 {\n  top: -10rem;\n}\n\n.right--9 {\n  right: -10rem;\n}\n\n.bottom--9 {\n  bottom: -10rem;\n}\n\n.left--9 {\n  left: -10rem;\n}\n\n.top--8 {\n  top: -8rem;\n}\n\n.right--8 {\n  right: -8rem;\n}\n\n.bottom--8 {\n  bottom: -8rem;\n}\n\n.left--8 {\n  left: -8rem;\n}\n\n.top--7 {\n  top: -6rem;\n}\n\n.right--7 {\n  right: -6rem;\n}\n\n.bottom--7 {\n  bottom: -6rem;\n}\n\n.left--7 {\n  left: -6rem;\n}\n\n.top--6 {\n  top: -4.5rem;\n}\n\n.right--6 {\n  right: -4.5rem;\n}\n\n.bottom--6 {\n  bottom: -4.5rem;\n}\n\n.left--6 {\n  left: -4.5rem;\n}\n\n.top--5 {\n  top: -3rem;\n}\n\n.right--5 {\n  right: -3rem;\n}\n\n.bottom--5 {\n  bottom: -3rem;\n}\n\n.left--5 {\n  left: -3rem;\n}\n\n.top--4 {\n  top: -1.5rem;\n}\n\n.right--4 {\n  right: -1.5rem;\n}\n\n.bottom--4 {\n  bottom: -1.5rem;\n}\n\n.left--4 {\n  left: -1.5rem;\n}\n\n.top--3 {\n  top: -1rem;\n}\n\n.right--3 {\n  right: -1rem;\n}\n\n.bottom--3 {\n  bottom: -1rem;\n}\n\n.left--3 {\n  left: -1rem;\n}\n\n.top--2 {\n  top: -0.5rem;\n}\n\n.right--2 {\n  right: -0.5rem;\n}\n\n.bottom--2 {\n  bottom: -0.5rem;\n}\n\n.left--2 {\n  left: -0.5rem;\n}\n\n.top--1 {\n  top: -0.25rem;\n}\n\n.right--1 {\n  right: -0.25rem;\n}\n\n.bottom--1 {\n  bottom: -0.25rem;\n}\n\n.left--1 {\n  left: -0.25rem;\n}\n\n.top-6 {\n  top: 4.5rem;\n}\n\n.right-6 {\n  right: 4.5rem;\n}\n\n.bottom-6 {\n  bottom: 4.5rem;\n}\n\n.left-6 {\n  left: 4.5rem;\n}\n\n.top-7 {\n  top: 6rem;\n}\n\n.right-7 {\n  right: 6rem;\n}\n\n.bottom-7 {\n  bottom: 6rem;\n}\n\n.left-7 {\n  left: 6rem;\n}\n\n.top-8 {\n  top: 8rem;\n}\n\n.right-8 {\n  right: 8rem;\n}\n\n.bottom-8 {\n  bottom: 8rem;\n}\n\n.left-8 {\n  left: 8rem;\n}\n\n.top-9 {\n  top: 10rem;\n}\n\n.right-9 {\n  right: 10rem;\n}\n\n.bottom-9 {\n  bottom: 10rem;\n}\n\n.left-9 {\n  left: 10rem;\n}\n\n.center {\n  left: 50%;\n  transform: translateX(-50%);\n}\n\n.h-100vh {\n  height: 100vh !important;\n}\n\n.row.row-grid > [class*=col-] + [class*=col-] {\n  margin-top: 3rem;\n}\n\n@media (min-width: 992px) {\n  .row.row-grid > [class*=col-lg-] + [class*=col-lg-] {\n    margin-top: 0;\n  }\n}\n@media (min-width: 768px) {\n  .row.row-grid > [class*=col-md-] + [class*=col-md-] {\n    margin-top: 0;\n  }\n}\n@media (min-width: 576px) {\n  .row.row-grid > [class*=col-sm-] + [class*=col-sm-] {\n    margin-top: 0;\n  }\n}\n.row-grid + .row-grid {\n  margin-top: 3rem;\n}\n\n@media (min-width: 992px) {\n  .mt--100 {\n    margin-top: -100px !important;\n  }\n  .mr--100 {\n    margin-right: -100px !important;\n  }\n  .mb--100 {\n    margin-bottom: -100px !important;\n  }\n  .ml--100 {\n    margin-left: -100px !important;\n  }\n  .mt--150 {\n    margin-top: -150px !important;\n  }\n  .mb--150 {\n    margin-bottom: -150px !important;\n  }\n  .mt--200 {\n    margin-top: -200px !important;\n  }\n  .mb--200 {\n    margin-bottom: -200px !important;\n  }\n  .mt--300 {\n    margin-top: -300px !important;\n  }\n  .mb--300 {\n    margin-bottom: -300px !important;\n  }\n  .pt-100 {\n    padding-top: 100px !important;\n  }\n  .pb-100 {\n    padding-bottom: 100px !important;\n  }\n  .pt-150 {\n    padding-top: 150px !important;\n  }\n  .pb-150 {\n    padding-bottom: 150px !important;\n  }\n  .pt-200 {\n    padding-top: 200px !important;\n  }\n  .pb-200 {\n    padding-bottom: 200px !important;\n  }\n  .pt-250 {\n    padding-top: 250px !important;\n  }\n  .pb-250 {\n    padding-bottom: 250px !important;\n  }\n  .pt-300 {\n    padding-top: 300px !important;\n  }\n  .pb-300 {\n    padding-bottom: 300px !important;\n  }\n}\n[class*=shadow] {\n  transition: all 0.15s ease;\n}\n\n.shadow-sm--hover:hover {\n  box-shadow: 0 0 0.5rem rgba(136, 152, 170, 0.075) !important;\n}\n\n.shadow--hover:hover {\n  box-shadow: 0 0 2rem 0 rgba(136, 152, 170, 0.15) !important;\n}\n\n.shadow-lg--hover:hover {\n  box-shadow: 0 0 3rem rgba(136, 152, 170, 0.175) !important;\n}\n\n.shadow-none--hover:hover {\n  box-shadow: none !important;\n}\n\n.font-weight-300 {\n  font-weight: 300 !important;\n}\n\n.font-weight-400 {\n  font-weight: 400 !important;\n}\n\n.font-weight-500 {\n  font-weight: 500 !important;\n}\n\n.font-weight-600 {\n  font-weight: 600 !important;\n}\n\n.font-weight-700 {\n  font-weight: 700 !important;\n}\n\n.font-weight-800 {\n  font-weight: 800 !important;\n}\n\n.font-weight-900 {\n  font-weight: 900 !important;\n}\n\n.text-underline {\n  text-decoration: underline;\n}\n\n.text-through {\n  text-decoration: line-through;\n}\n\n.text-xs {\n  font-size: 0.75rem !important;\n}\n\n.text-sm {\n  font-size: 0.875rem !important;\n}\n\n.text-lg {\n  font-size: 1.25rem !important;\n}\n\n.text-xl {\n  font-size: 1.5rem !important;\n}\n\n.lh-100 {\n  line-height: 1;\n}\n\n.lh-110 {\n  line-height: 1.1;\n}\n\n.lh-120 {\n  line-height: 1.2;\n}\n\n.lh-130 {\n  line-height: 1.3;\n}\n\n.lh-140 {\n  line-height: 1.4;\n}\n\n.lh-150 {\n  line-height: 1.5;\n}\n\n.lh-160 {\n  line-height: 1.6;\n}\n\n.lh-170 {\n  line-height: 1.7;\n}\n\n.lh-180 {\n  line-height: 1.8;\n}\n\n.ls-1 {\n  letter-spacing: 0.0625rem;\n}\n\n.ls-15 {\n  letter-spacing: 0.09375rem;\n}\n\n.ls-2 {\n  letter-spacing: 0.125rem;\n}\n\n.text-blue {\n  color: #3ba371 !important;\n}\n\na.text-blue:hover, a.text-blue:focus {\n  color: rgb(38.6689189189, 106.8310810811, 74.0608108108) !important;\n}\n\n.text-indigo {\n  color: #5603ad !important;\n}\n\na.text-indigo:hover, a.text-indigo:focus {\n  color: rgb(48.6193181818, 1.6960227273, 97.8039772727) !important;\n}\n\n.text-purple {\n  color: #8965e0 !important;\n}\n\na.text-purple:hover, a.text-purple:focus {\n  color: rgb(89.9972972973, 41.6405405405, 206.8594594595) !important;\n}\n\n.text-pink {\n  color: #f3a4b5 !important;\n}\n\na.text-pink:hover, a.text-pink:focus {\n  color: rgb(234.0873786408, 96.4126213592, 126.0388349515) !important;\n}\n\n.text-red {\n  color: #f5365c !important;\n}\n\na.text-red:hover, a.text-red:focus {\n  color: rgb(211.9549763033, 10.5450236967, 50.6161137441) !important;\n}\n\n.text-orange {\n  color: #fb6340 !important;\n}\n\na.text-orange:hover, a.text-orange:focus {\n  color: rgb(233.6076923077, 47.7, 4.8923076923) !important;\n}\n\n.text-yellow {\n  color: #ffd600 !important;\n}\n\na.text-yellow:hover, a.text-yellow:focus {\n  color: rgb(178.5, 149.8, 0) !important;\n}\n\n.text-green {\n  color: #3aa170 !important;\n}\n\na.text-green:hover, a.text-green:focus {\n  color: rgb(37.7397260274, 104.7602739726, 72.8767123288) !important;\n}\n\n.text-teal {\n  color: #278e69 !important;\n}\n\na.text-teal:hover, a.text-teal:focus {\n  color: rgb(22.5165745856, 81.9834254144, 60.6215469613) !important;\n}\n\n.text-cyan {\n  color: #2bffc6 !important;\n}\n\na.text-cyan:hover, a.text-cyan:focus {\n  color: rgb(0, 221.5, 161.945754717) !important;\n}\n\n.text-white {\n  color: #fff !important;\n}\n\na.text-white:hover, a.text-white:focus {\n  color: rgb(216.75, 216.75, 216.75) !important;\n}\n\n.text-gray {\n  color: #8898aa !important;\n}\n\na.text-gray:hover, a.text-gray:focus {\n  color: rgb(95.625, 113.625, 133.875) !important;\n}\n\n.text-gray-dark {\n  color: #32325d !important;\n}\n\na.text-gray-dark:hover, a.text-gray-dark:focus {\n  color: rgb(23.2517482517, 23.2517482517, 43.2482517483) !important;\n}\n\n.text-light {\n  color: #ced4da !important;\n}\n\na.text-light:hover, a.text-light:focus {\n  color: rgb(162.4127906977, 173.75, 185.0872093023) !important;\n}\n\n.text-lighter {\n  color: #e9ecef !important;\n}\n\na.text-lighter:hover, a.text-lighter:focus {\n  color: rgb(188.7105263158, 197.75, 206.7894736842) !important;\n}\n\n@media (min-width: 992px) {\n  .transform-perspective-right {\n    transform: scale(1) perspective(1040px) rotateY(-11deg) rotateX(2deg) rotate(2deg);\n  }\n  .transform-perspective-left {\n    transform: scale(1) perspective(2000px) rotateY(11deg) rotateX(2deg) rotate(-2deg);\n  }\n}\n.alert {\n  font-size: 0.875rem;\n}\n\n.alert-heading {\n  font-weight: 600;\n  font-size: 0.9375rem;\n  margin-top: 0.15rem;\n}\n\n.alert-icon {\n  font-size: 1.25rem;\n  margin-right: 1.25rem;\n  display: inline-block;\n  vertical-align: middle;\n}\n.alert-icon i.ni {\n  position: relative;\n  top: 1px;\n}\n\n.alert-text {\n  display: inline-block;\n  vertical-align: middle;\n}\n\n[class*=alert-] .alert-link {\n  color: #fff;\n  border-bottom: 1px dotted rgba(255, 255, 255, 0.5);\n}\n\n.alert-dismissible .close {\n  top: 50%;\n  right: 1.5rem;\n  padding: 0;\n  transform: translateY(-50%);\n  color: rgba(255, 255, 255, 0.6);\n  opacity: 1;\n}\n.alert-dismissible .close:hover, .alert-dismissible .close:focus {\n  color: rgba(255, 255, 255, 0.9);\n  opacity: 1 !important;\n}\n@media (max-width: 575.98px) {\n  .alert-dismissible .close {\n    top: 1rem;\n    right: 0.5rem;\n  }\n}\n.alert-dismissible .close > span:not(.sr-only) {\n  font-size: 1.5rem;\n  background-color: transparent;\n  color: rgba(255, 255, 255, 0.6);\n}\n.alert-dismissible .close:hover > span:not(.sr-only), .alert-dismissible .close:focus > span:not(.sr-only) {\n  background-color: transparent;\n  color: rgba(255, 255, 255, 0.9);\n}\n\n.avatar {\n  width: 34px;\n  height: 34px;\n  border-radius: 50%;\n  border: 2px solid #42826c;\n  overflow: hidden;\n}\n.avatar img {\n  width: 100%;\n  height: 100%;\n}\n\n.badge {\n  text-transform: uppercase;\n}\n.badge a {\n  color: #fff;\n}\n\n.badge-md {\n  padding: 0.65em 1em;\n}\n\n.badge-lg {\n  padding: 0.85em 1.375em;\n}\n\n.badge-inline {\n  margin-right: 0.625rem;\n}\n.badge-inline + span {\n  top: 2px;\n  position: relative;\n}\n.badge-inline + span > a {\n  text-decoration: underline;\n}\n\n.btn .badge:not(:first-child) {\n  margin-left: 0.5rem;\n}\n.btn .badge:not(:last-child) {\n  margin-right: 0.5rem;\n}\n\n.badge-circle {\n  text-align: center;\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  border-radius: 50%;\n  width: 2rem;\n  height: 2rem;\n  font-size: 0.875rem;\n}\n\n.badge-dot {\n  padding-left: 0;\n  padding-right: 0;\n  background: transparent;\n  font-weight: 400;\n  font-size: 0.875rem;\n  text-transform: none;\n}\n.badge-dot strong {\n  color: #32325d;\n}\n.badge-dot i {\n  display: inline-block;\n  vertical-align: middle;\n  width: 0.375rem;\n  height: 0.375rem;\n  border-radius: 50%;\n  margin-right: 0.375rem;\n}\n.badge-dot.badge-md i {\n  width: 0.5rem;\n  height: 0.5rem;\n}\n.badge-dot.badge-lg i {\n  width: 0.625rem;\n  height: 0.625rem;\n}\n\n.btn {\n  position: relative;\n  text-transform: none;\n  transition: all 0.15s ease;\n  letter-spacing: 0.025em;\n  font-size: 0.875rem;\n  will-change: transform;\n}\n.btn:hover {\n  box-shadow: 0 7px 14px rgba(50, 50, 93, 0.1), 0 3px 6px rgba(0, 0, 0, 0.08);\n}\n.btn:not(:last-child) {\n  margin-right: 0.5rem;\n}\n.btn i:not(:first-child),\n.btn svg:not(:first-child) {\n  margin-left: 0.5rem;\n}\n.btn i:not(:last-child),\n.btn svg:not(:last-child) {\n  margin-right: 0.5rem;\n}\n\n.btn-group .btn,\n.input-group .btn {\n  margin-right: 0;\n  transform: translateY(0);\n}\n\n.btn-sm, .btn-group-sm > .btn {\n  font-size: 0.75rem;\n}\n\n.btn-lg, .btn-group-lg > .btn {\n  font-size: 0.875rem;\n}\n\n[class*=btn-outline-] {\n  border-width: 1px;\n}\n\n.btn-outline-secondary {\n  color: rgb(66.5454545455, 133.0909090909, 177.4545454545);\n}\n\n.btn-inner--icon i:not(.fa) {\n  position: relative;\n  top: 2px;\n}\n\n.btn-link {\n  font-weight: 600;\n  box-shadow: none;\n}\n.btn-link:hover {\n  box-shadow: none;\n  transform: none;\n}\n\n.btn-neutral {\n  color: #3ba371;\n}\n\n.btn-icon .btn-inner--icon img {\n  width: 20px;\n}\n.btn-icon .btn-inner--text:not(:first-child) {\n  margin-left: 0.75em;\n}\n.btn-icon .btn-inner--text:not(:last-child) {\n  margin-right: 0.75em;\n}\n\n.btn-icon-only {\n  width: 2.375rem;\n  height: 2.375rem;\n  padding: 0;\n}\n\na.btn-icon-only {\n  line-height: 2.5;\n}\n\n.btn-icon-only.btn-sm, .btn-group-sm > .btn-icon-only.btn {\n  width: 2rem;\n  height: 2rem;\n}\n\n.btn-icon-clipboard {\n  margin: 0;\n  padding: 1.5rem;\n  font-size: 1rem;\n  font-weight: 400;\n  line-height: 1.25;\n  color: #32325d;\n  background-color: #f6f9fc;\n  border-radius: 0.375rem;\n  border: 0;\n  text-align: left;\n  font-family: inherit;\n  display: inline-block;\n  vertical-align: middle;\n  text-decoration: none;\n  -moz-appearance: none;\n  cursor: pointer;\n  width: 100%;\n  margin: 0.5rem 0;\n}\n.btn-icon-clipboard:hover {\n  background-color: #fff;\n  box-shadow: rgba(0, 0, 0, 0.1) 0 0 0 1px, rgba(0, 0, 0, 0.1) 0 4px 16px;\n}\n.btn-icon-clipboard > div {\n  align-items: center;\n  display: flex;\n}\n.btn-icon-clipboard i {\n  box-sizing: content-box;\n  color: #3ba371;\n  vertical-align: middle;\n  font-size: 1.5rem;\n}\n.btn-icon-clipboard span {\n  display: inline-block;\n  font-size: 0.875rem;\n  line-height: 1.5;\n  margin-left: 16px;\n  overflow: hidden;\n  white-space: nowrap;\n  text-overflow: ellipsis;\n  vertical-align: middle;\n}\n\n.btn-facebook {\n  color: #fff;\n  background-color: #3b5999;\n  border-color: #3b5999;\n  box-shadow: 0 4px 6px rgba(50, 50, 93, 0.11), 0 1px 3px rgba(0, 0, 0, 0.08);\n}\n.btn-facebook:hover {\n  color: #fff;\n  background-color: #3b5999;\n  border-color: #3b5999;\n}\n.btn-facebook:focus, .btn-facebook.focus {\n  box-shadow: 0 4px 6px rgba(50, 50, 93, 0.11), 0 1px 3px rgba(0, 0, 0, 0.08), 0 0 0 0 rgba(59, 89, 153, 0.5);\n}\n.btn-facebook.disabled, .btn-facebook:disabled {\n  color: #fff;\n  background-color: #3b5999;\n  border-color: #3b5999;\n}\n.btn-facebook:not(:disabled):not(.disabled):active, .btn-facebook:not(:disabled):not(.disabled).active, .show > .btn-facebook.dropdown-toggle {\n  color: #fff;\n  background-color: rgb(44.8066037736, 67.5896226415, 116.1933962264);\n  border-color: #3b5999;\n}\n.btn-facebook:not(:disabled):not(.disabled):active:focus, .btn-facebook:not(:disabled):not(.disabled).active:focus, .show > .btn-facebook.dropdown-toggle:focus {\n  box-shadow: none, 0 0 0 0 rgba(59, 89, 153, 0.5);\n}\n\n.btn-twitter {\n  color: #fff;\n  background-color: #1da1f2;\n  border-color: #1da1f2;\n  box-shadow: 0 4px 6px rgba(50, 50, 93, 0.11), 0 1px 3px rgba(0, 0, 0, 0.08);\n}\n.btn-twitter:hover {\n  color: #fff;\n  background-color: #1da1f2;\n  border-color: #1da1f2;\n}\n.btn-twitter:focus, .btn-twitter.focus {\n  box-shadow: 0 4px 6px rgba(50, 50, 93, 0.11), 0 1px 3px rgba(0, 0, 0, 0.08), 0 0 0 0 rgba(29, 161, 242, 0.5);\n}\n.btn-twitter.disabled, .btn-twitter:disabled {\n  color: #fff;\n  background-color: #1da1f2;\n  border-color: #1da1f2;\n}\n.btn-twitter:not(:disabled):not(.disabled):active, .btn-twitter:not(:disabled):not(.disabled).active, .show > .btn-twitter.dropdown-toggle {\n  color: #fff;\n  background-color: rgb(11.9665271967, 133.4728033473, 208.0334728033);\n  border-color: #1da1f2;\n}\n.btn-twitter:not(:disabled):not(.disabled):active:focus, .btn-twitter:not(:disabled):not(.disabled).active:focus, .show > .btn-twitter.dropdown-toggle:focus {\n  box-shadow: none, 0 0 0 0 rgba(29, 161, 242, 0.5);\n}\n\n.btn-google-plus {\n  color: #fff;\n  background-color: #dd4b39;\n  border-color: #dd4b39;\n  box-shadow: 0 4px 6px rgba(50, 50, 93, 0.11), 0 1px 3px rgba(0, 0, 0, 0.08);\n}\n.btn-google-plus:hover {\n  color: #fff;\n  background-color: #dd4b39;\n  border-color: #dd4b39;\n}\n.btn-google-plus:focus, .btn-google-plus.focus {\n  box-shadow: 0 4px 6px rgba(50, 50, 93, 0.11), 0 1px 3px rgba(0, 0, 0, 0.08), 0 0 0 0 rgba(221, 75, 57, 0.5);\n}\n.btn-google-plus.disabled, .btn-google-plus:disabled {\n  color: #fff;\n  background-color: #dd4b39;\n  border-color: #dd4b39;\n}\n.btn-google-plus:not(:disabled):not(.disabled):active, .btn-google-plus:not(:disabled):not(.disabled).active, .show > .btn-google-plus.dropdown-toggle {\n  color: #fff;\n  background-color: rgb(193.7327586207, 50.8793103448, 33.2672413793);\n  border-color: #dd4b39;\n}\n.btn-google-plus:not(:disabled):not(.disabled):active:focus, .btn-google-plus:not(:disabled):not(.disabled).active:focus, .show > .btn-google-plus.dropdown-toggle:focus {\n  box-shadow: none, 0 0 0 0 rgba(221, 75, 57, 0.5);\n}\n\n.btn-instagram {\n  color: #fff;\n  background-color: #e4405f;\n  border-color: #e4405f;\n  box-shadow: 0 4px 6px rgba(50, 50, 93, 0.11), 0 1px 3px rgba(0, 0, 0, 0.08);\n}\n.btn-instagram:hover {\n  color: #fff;\n  background-color: #e4405f;\n  border-color: #e4405f;\n}\n.btn-instagram:focus, .btn-instagram.focus {\n  box-shadow: 0 4px 6px rgba(50, 50, 93, 0.11), 0 1px 3px rgba(0, 0, 0, 0.08), 0 0 0 0 rgba(228, 64, 95, 0.5);\n}\n.btn-instagram.disabled, .btn-instagram:disabled {\n  color: #fff;\n  background-color: #e4405f;\n  border-color: #e4405f;\n}\n.btn-instagram:not(:disabled):not(.disabled):active, .btn-instagram:not(:disabled):not(.disabled).active, .show > .btn-instagram.dropdown-toggle {\n  color: #fff;\n  background-color: rgb(211.1513761468, 29.8486238532, 64.119266055);\n  border-color: #e4405f;\n}\n.btn-instagram:not(:disabled):not(.disabled):active:focus, .btn-instagram:not(:disabled):not(.disabled).active:focus, .show > .btn-instagram.dropdown-toggle:focus {\n  box-shadow: none, 0 0 0 0 rgba(228, 64, 95, 0.5);\n}\n\n.btn-pinterest {\n  color: #fff;\n  background-color: #bd081c;\n  border-color: #bd081c;\n  box-shadow: 0 4px 6px rgba(50, 50, 93, 0.11), 0 1px 3px rgba(0, 0, 0, 0.08);\n}\n.btn-pinterest:hover {\n  color: #fff;\n  background-color: #bd081c;\n  border-color: #bd081c;\n}\n.btn-pinterest:focus, .btn-pinterest.focus {\n  box-shadow: 0 4px 6px rgba(50, 50, 93, 0.11), 0 1px 3px rgba(0, 0, 0, 0.08), 0 0 0 0 rgba(189, 8, 28, 0.5);\n}\n.btn-pinterest.disabled, .btn-pinterest:disabled {\n  color: #fff;\n  background-color: #bd081c;\n  border-color: #bd081c;\n}\n.btn-pinterest:not(:disabled):not(.disabled):active, .btn-pinterest:not(:disabled):not(.disabled).active, .show > .btn-pinterest.dropdown-toggle {\n  color: #fff;\n  background-color: rgb(140.0710659898, 5.9289340102, 20.7512690355);\n  border-color: #bd081c;\n}\n.btn-pinterest:not(:disabled):not(.disabled):active:focus, .btn-pinterest:not(:disabled):not(.disabled).active:focus, .show > .btn-pinterest.dropdown-toggle:focus {\n  box-shadow: none, 0 0 0 0 rgba(189, 8, 28, 0.5);\n}\n\n.btn-youtube {\n  color: #fff;\n  background-color: #cd201f;\n  border-color: #cd201f;\n  box-shadow: 0 4px 6px rgba(50, 50, 93, 0.11), 0 1px 3px rgba(0, 0, 0, 0.08);\n}\n.btn-youtube:hover {\n  color: #fff;\n  background-color: #cd201f;\n  border-color: #cd201f;\n}\n.btn-youtube:focus, .btn-youtube.focus {\n  box-shadow: 0 4px 6px rgba(50, 50, 93, 0.11), 0 1px 3px rgba(0, 0, 0, 0.08), 0 0 0 0 rgba(205, 32, 31, 0.5);\n}\n.btn-youtube.disabled, .btn-youtube:disabled {\n  color: #fff;\n  background-color: #cd201f;\n  border-color: #cd201f;\n}\n.btn-youtube:not(:disabled):not(.disabled):active, .btn-youtube:not(:disabled):not(.disabled).active, .show > .btn-youtube.dropdown-toggle {\n  color: #fff;\n  background-color: rgb(160.6991525424, 25.0847457627, 24.3008474576);\n  border-color: #cd201f;\n}\n.btn-youtube:not(:disabled):not(.disabled):active:focus, .btn-youtube:not(:disabled):not(.disabled).active:focus, .show > .btn-youtube.dropdown-toggle:focus {\n  box-shadow: none, 0 0 0 0 rgba(205, 32, 31, 0.5);\n}\n\n.btn-slack {\n  color: #fff;\n  background-color: #3aaf85;\n  border-color: #3aaf85;\n  box-shadow: 0 4px 6px rgba(50, 50, 93, 0.11), 0 1px 3px rgba(0, 0, 0, 0.08);\n}\n.btn-slack:hover {\n  color: #fff;\n  background-color: #3aaf85;\n  border-color: #3aaf85;\n}\n.btn-slack:focus, .btn-slack.focus {\n  box-shadow: 0 4px 6px rgba(50, 50, 93, 0.11), 0 1px 3px rgba(0, 0, 0, 0.08), 0 0 0 0 rgba(58, 175, 133, 0.5);\n}\n.btn-slack.disabled, .btn-slack:disabled {\n  color: #fff;\n  background-color: #3aaf85;\n  border-color: #3aaf85;\n}\n.btn-slack:not(:disabled):not(.disabled):active, .btn-slack:not(:disabled):not(.disabled).active, .show > .btn-slack.dropdown-toggle {\n  color: #fff;\n  background-color: rgb(45.30472103, 136.69527897, 103.8884120172);\n  border-color: #3aaf85;\n}\n.btn-slack:not(:disabled):not(.disabled):active:focus, .btn-slack:not(:disabled):not(.disabled).active:focus, .show > .btn-slack.dropdown-toggle:focus {\n  box-shadow: none, 0 0 0 0 rgba(58, 175, 133, 0.5);\n}\n\n.btn-dribbble {\n  color: #fff;\n  background-color: #ea4c89;\n  border-color: #ea4c89;\n  box-shadow: 0 4px 6px rgba(50, 50, 93, 0.11), 0 1px 3px rgba(0, 0, 0, 0.08);\n}\n.btn-dribbble:hover {\n  color: #fff;\n  background-color: #ea4c89;\n  border-color: #ea4c89;\n}\n.btn-dribbble:focus, .btn-dribbble.focus {\n  box-shadow: 0 4px 6px rgba(50, 50, 93, 0.11), 0 1px 3px rgba(0, 0, 0, 0.08), 0 0 0 0 rgba(234, 76, 137, 0.5);\n}\n.btn-dribbble.disabled, .btn-dribbble:disabled {\n  color: #fff;\n  background-color: #ea4c89;\n  border-color: #ea4c89;\n}\n.btn-dribbble:not(:disabled):not(.disabled):active, .btn-dribbble:not(:disabled):not(.disabled).active, .show > .btn-dribbble.dropdown-toggle {\n  color: #fff;\n  background-color: rgb(228.645, 30.355, 106.91);\n  border-color: #ea4c89;\n}\n.btn-dribbble:not(:disabled):not(.disabled):active:focus, .btn-dribbble:not(:disabled):not(.disabled).active:focus, .show > .btn-dribbble.dropdown-toggle:focus {\n  box-shadow: none, 0 0 0 0 rgba(234, 76, 137, 0.5);\n}\n\n.btn-github {\n  color: #fff;\n  background-color: #222222;\n  border-color: #222222;\n  box-shadow: 0 4px 6px rgba(50, 50, 93, 0.11), 0 1px 3px rgba(0, 0, 0, 0.08);\n}\n.btn-github:hover {\n  color: #fff;\n  background-color: #222222;\n  border-color: #222222;\n}\n.btn-github:focus, .btn-github.focus {\n  box-shadow: 0 4px 6px rgba(50, 50, 93, 0.11), 0 1px 3px rgba(0, 0, 0, 0.08), 0 0 0 0 rgba(34, 34, 34, 0.5);\n}\n.btn-github.disabled, .btn-github:disabled {\n  color: #fff;\n  background-color: #222222;\n  border-color: #222222;\n}\n.btn-github:not(:disabled):not(.disabled):active, .btn-github:not(:disabled):not(.disabled).active, .show > .btn-github.dropdown-toggle {\n  color: #fff;\n  background-color: rgb(8.5, 8.5, 8.5);\n  border-color: #222222;\n}\n.btn-github:not(:disabled):not(.disabled):active:focus, .btn-github:not(:disabled):not(.disabled).active:focus, .show > .btn-github.dropdown-toggle:focus {\n  box-shadow: none, 0 0 0 0 rgba(34, 34, 34, 0.5);\n}\n\n.card-translucent {\n  background-color: rgba(18, 91, 152, 0.08);\n}\n\n.card-profile-image {\n  position: relative;\n}\n.card-profile-image img {\n  max-width: 180px;\n  border-radius: 0.375rem;\n  transform: translate(-50%, -30%);\n  position: absolute;\n  left: 50%;\n  transition: all 0.15s ease;\n}\n.card-profile-image img:hover {\n  transform: translate(-50%, -33%);\n}\n\n.card-profile-stats {\n  padding: 1rem 0;\n}\n.card-profile-stats > div {\n  text-align: center;\n  margin-right: 1rem;\n  padding: 0.875rem;\n}\n.card-profile-stats > div:last-child {\n  margin-right: 0;\n}\n.card-profile-stats > div .heading {\n  font-size: 1.1rem;\n  font-weight: bold;\n  display: block;\n}\n.card-profile-stats > div .description {\n  font-size: 0.875rem;\n  color: #adb5bd;\n}\n\n.card-profile-actions {\n  padding: 0.875rem;\n}\n\n.card-lift--hover:hover {\n  transform: translateY(-20px);\n  transition: all 0.15s ease;\n}\n@media (prefers-reduced-motion: reduce) {\n  .card-lift--hover:hover {\n    transition: none;\n  }\n}\n\n.card-stats .card-body {\n  padding: 1rem 1.5rem;\n}\n.card-stats .card-status-bullet {\n  position: absolute;\n  top: 0;\n  right: 0;\n  transform: translate(50%, -50%);\n}\n\n.chart {\n  position: relative;\n  height: 350px;\n}\n\n.chart-sm {\n  height: 230px;\n}\n\n.chart-legend {\n  display: flex;\n  justify-content: center;\n  margin-top: 2.5rem;\n  font-size: 0.875rem;\n  text-align: center;\n  color: #8898aa;\n}\n\n.chart-legend-item {\n  display: inline-flex;\n  align-items: center;\n}\n.chart-legend-item + .chart-legend-item {\n  margin-left: 1rem;\n}\n\n.chart-legend-indicator {\n  display: inline-block;\n  width: 0.5rem;\n  height: 0.5rem;\n  margin-right: 0.375rem;\n  border-radius: 50%;\n}\n\n#chart-tooltip {\n  z-index: 0;\n}\n#chart-tooltip .arrow {\n  top: 100%;\n  left: 50%;\n  transform: translateX(-50%) translateX(-0.5rem);\n}\n\n.chart-info-overlay {\n  position: absolute;\n  top: 0;\n  left: 5%;\n  max-width: 350px;\n  padding: 20px;\n  z-index: 1;\n}\n\n.close {\n  transition: all 0.15s ease;\n}\n.close > span:not(.sr-only) {\n  background-color: transparent;\n  color: rgba(0, 0, 0, 0.6);\n  line-height: 17px;\n  height: 1.25rem;\n  width: 1.25rem;\n  border-radius: 50%;\n  font-size: 1.25rem;\n  display: block;\n  transition: all 0.15s ease;\n}\n.close:hover, .close:focus {\n  background-color: transparent;\n  color: rgba(0, 0, 0, 0.9);\n  outline: none;\n}\n.close:hover span:not(.sr-only), .close:focus span:not(.sr-only) {\n  background-color: transparent;\n}\n\n.checkbox-design {\n  margin: 0 0 5px;\n}\n\n.styled-checkbox {\n  position: absolute;\n  opacity: 0;\n}\n\n.styled-checkbox + label {\n  position: relative;\n  cursor: pointer;\n  padding: 0;\n}\n\n.styled-checkbox + label:before {\n  content: \"\";\n  margin-right: 10px;\n  display: inline-block;\n  vertical-align: text-top;\n  width: 20px;\n  height: 20px;\n  background: white;\n  border: 1px solid gray;\n}\n\n.styled-checkbox:hover + label:before {\n  background: #f35429;\n}\n\n.styled-checkbox:checked + label:before {\n  background: #f35429;\n}\n\n.styled-checkbox:disabled + label {\n  color: #b8b8b8;\n  cursor: auto;\n}\n\n.styled-checkbox:disabled + label:before {\n  box-shadow: none;\n  background: #ddd;\n}\n\n.styled-checkbox:checked + label:after {\n  content: \"\";\n  position: absolute;\n  left: 5px;\n  top: 9px;\n  background: white;\n  width: 2px;\n  height: 2px;\n  box-shadow: 2px 0 0 white, 4px 0 0 white, 4px -2px 0 white, 4px -4px 0 white, 4px -6px 0 white, 4px -8px 0 white;\n  transform: rotate(45deg);\n}\n\n.main-content {\n  position: relative;\n  background-color: #fff;\n  margin-left: 258px;\n}\n.main-content .navbar-top {\n  position: absolute;\n  left: 0;\n  top: 0;\n  width: 100%;\n  z-index: 1;\n  background-color: #fff;\n  padding-left: 0 !important;\n  padding-right: 0 !important;\n}\n.main-content .navbar-top .page-title {\n  font-size: 25px;\n  font-weight: 600;\n  line-height: 37.5px;\n  color: #393939;\n}\n.main-content .navbar-top .navbar-nav .media p {\n  font-size: 13px;\n  font-weight: 400;\n  line-height: 24px;\n  color: #393939;\n}\n.main-content .dashboard-card-colored {\n  width: calc(50% - 30px);\n  border-radius: 4px;\n  margin-right: 15px;\n}\n.main-content .dashboard-card-colored a {\n  display: block;\n  overflow: hidden;\n  width: 100%;\n}\n.main-content .dashboard-card-colored a .card-body {\n  width: 100%;\n}\n.main-content .dashboard-card-colored a .card-body .inner-body {\n  width: 100%;\n  margin-left: 0;\n  margin-right: 0;\n}\n.main-content .dashboard-card-colored.green {\n  background-color: #008983;\n}\n.main-content .dashboard-card-colored.blue {\n  background-color: #0f7db5;\n}\n.main-content .dashboard-card-colored .card-stats {\n  background-color: transparent;\n  width: 100%;\n  border: 0;\n}\n.main-content .dashboard-card-colored .card-title {\n  font-size: 14px;\n  font-weight: 400;\n  line-height: 21px;\n  color: #fff;\n}\n.main-content .dashboard-card-colored .large-font {\n  font-size: 50px;\n  font-weight: 700;\n  line-height: 75px;\n  color: #fff;\n}\n.main-content .dashboard-card-colored .icon svg {\n  fill: #fff;\n  width: 50px;\n  height: 50px;\n}\n.main-content .bordered-box {\n  box-shadow: 0px 2px 8px 0px rgba(156, 156, 156, 0.25);\n  border-radius: 5px;\n  padding-top: 20px;\n  padding-bottom: 20px;\n  margin-left: 15px;\n  width: calc(50% - 30px);\n  margin-left: 15px;\n  border: 1px solid rgba(156, 156, 156, 0.35);\n}\n.main-content .bordered-box .card-stats .card-body .card-title {\n  font-size: 16px;\n  font-weight: 400;\n  line-height: 24px;\n  color: #393939;\n}\n.main-content .bordered-box .card-stats .card-body .large-font {\n  font-size: 28px;\n  font-weight: 700;\n  line-height: 42px;\n  color: #42826c;\n}\n.main-content .box-50 {\n  width: 50%;\n}\n.main-content .card {\n  border: 0;\n}\n.main-content .dashboard-title {\n  font-size: 25px;\n  font-weight: 600;\n  line-height: 37.5px;\n  color: #393939;\n}\n@media (min-width: 768px) {\n  .main-content .container-fluid, .main-content .container-sm, .main-content .container-md, .main-content .container-lg, .main-content .container-xl {\n    padding-left: 27px !important;\n    padding-right: 27px !important;\n  }\n}\n\n.custom-checkbox .custom-control-input ~ .custom-control-label {\n  cursor: pointer;\n  font-size: 0.875rem;\n}\n.custom-checkbox .custom-control-input:checked ~ .custom-control-label::before {\n  border-color: #3ba371;\n}\n.custom-checkbox .custom-control-input:checked ~ .custom-control-label::after {\n  background-image: url(\"data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg' width='8' height='8' viewBox='0 0 8 8'><path fill='#fff' d='M6.564.75l-3.59 3.612-1.538-1.55L0 4.26l2.974 2.99L8 2.193z'/></svg>\");\n}\n.custom-checkbox .custom-control-input:disabled ~ .custom-control-label::before {\n  border-color: #e9ecef;\n}\n.custom-checkbox .custom-control-input:disabled:checked::before {\n  border-color: rgba(59, 163, 113, 0.5);\n}\n\n.custom-control-label::before {\n  border: 1px solid #cad1d7;\n  transition: all 0.2s cubic-bezier(0.68, -0.55, 0.265, 1.55);\n}\n.custom-control-label span {\n  position: relative;\n  top: 2px;\n}\n\n.custom-control-label {\n  margin-bottom: 0;\n}\n\n.custom-control-alternative .custom-control-label::before {\n  border: 0;\n  box-shadow: 0 1px 3px rgba(50, 50, 93, 0.15), 0 1px 0 rgba(0, 0, 0, 0.02);\n}\n.custom-control-alternative .custom-control-input:checked ~ .custom-control-label::before {\n  box-shadow: 0 4px 6px rgba(50, 50, 93, 0.11), 0 1px 3px rgba(0, 0, 0, 0.08);\n}\n.custom-control-alternative .custom-control-input:active ~ .custom-control-label::before, .custom-control-alternative .custom-control-input:focus ~ .custom-control-label::before {\n  box-shadow: 0 1px 3px rgba(50, 50, 93, 0.15), 0 1px 0 rgba(0, 0, 0, 0.02);\n}\n\n.custom-checkbox .custom-control-input ~ .custom-control-label {\n  cursor: pointer;\n  font-size: 0.875rem;\n}\n.custom-checkbox .custom-control-input:checked ~ .custom-control-label::before {\n  border-color: #3ba371;\n}\n.custom-checkbox .custom-control-input:checked ~ .custom-control-label::after {\n  background-image: url(\"data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg' width='8' height='8' viewBox='0 0 8 8'><path fill='#fff' d='M6.564.75l-3.59 3.612-1.538-1.55L0 4.26l2.974 2.99L8 2.193z'/></svg>\");\n}\n.custom-checkbox .custom-control-input:disabled ~ .custom-control-label::before {\n  border-color: #e9ecef;\n}\n.custom-checkbox .custom-control-input:disabled:checked::before {\n  border-color: rgba(59, 163, 113, 0.5);\n}\n\n.custom-radio .custom-control-input ~ .custom-control-label {\n  cursor: pointer;\n  font-size: 0.875rem;\n}\n.custom-radio .custom-control-input:checked ~ .custom-control-label::before {\n  border-color: #3ba371;\n}\n.custom-radio .custom-control-input:checked ~ .custom-control-label::after {\n  background-image: url(\"data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg' width='12' height='12' viewBox='-4 -4 8 8'><circle r='3' fill='#fff'/></svg>\");\n}\n.custom-radio .custom-control-input:disabled ~ .custom-control-label::before {\n  border-color: #e9ecef;\n}\n.custom-radio .custom-control-input:disabled:checked::before {\n  border-color: rgba(59, 163, 113, 0.5);\n}\n\n.custom-toggle {\n  position: relative;\n  display: inline-block;\n  width: 50px;\n  height: 1.5rem;\n}\n.custom-toggle input {\n  display: none;\n}\n.custom-toggle input:checked + .custom-toggle-slider {\n  border: 1px solid #3ba371;\n}\n.custom-toggle input:checked + .custom-toggle-slider:before {\n  background: #3ba371;\n  transform: translateX(1.625rem);\n}\n.custom-toggle input:disabled + .custom-toggle-slider {\n  border: 1px solid #e9ecef;\n}\n.custom-toggle input:disabled:checked + .custom-toggle-slider {\n  border: 1px solid #e9ecef;\n}\n.custom-toggle input:disabled:checked + .custom-toggle-slider:before {\n  background-color: rgb(80.9864864865, 192.0135135135, 138.6351351351);\n}\n\n.custom-toggle-slider {\n  position: absolute;\n  cursor: pointer;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  border: 1px solid #cad1d7;\n  border-radius: 34px !important;\n  background-color: transparent;\n}\n.custom-toggle-slider:before {\n  position: absolute;\n  content: \"\";\n  height: 18px;\n  width: 18px;\n  left: 2px;\n  bottom: 2px;\n  border-radius: 50% !important;\n  background-color: #e9ecef;\n  transition: all 0.2s cubic-bezier(0.68, -0.55, 0.265, 1.55);\n}\n\n.dropdown,\n.dropup,\n.dropright,\n.dropleft {\n  display: inline-block;\n}\n\n.dropdown-menu {\n  min-width: 12rem;\n}\n.dropdown-menu .dropdown-item {\n  padding: 0.5rem 1rem;\n  font-size: 0.875rem;\n}\n.dropdown-menu .dropdown-item > i,\n.dropdown-menu .dropdown-item > svg {\n  margin-right: 1rem;\n  font-size: 1rem;\n  vertical-align: -17%;\n}\n\n.dropdown-header {\n  padding-left: 1rem;\n  padding-right: 1rem;\n  color: #f6f9fc;\n  font-size: 0.625rem;\n  text-transform: uppercase;\n  font-weight: 700;\n}\n\n.dropdown-menu a.media > div:first-child {\n  line-height: 1;\n}\n.dropdown-menu a.media p {\n  color: #8898aa;\n}\n.dropdown-menu a.media:hover .heading,\n.dropdown-menu a.media:hover p {\n  color: #ffd88c !important;\n}\n\n.dropdown-menu-sm {\n  min-width: 100px;\n  border: 0.4375rem;\n}\n\n.dropdown-menu-lg {\n  min-width: 260px;\n  border-radius: 0.4375rem;\n}\n\n.dropdown-menu-xl {\n  min-width: 450px;\n  border-radius: 0.4375rem;\n}\n\n.footer {\n  padding: 2.5rem 0;\n}\n.footer .col-footer .heading {\n  color: #8898aa;\n  letter-spacing: 0;\n  font-size: 0.875rem;\n  text-transform: uppercase;\n  font-weight: 600;\n  margin-bottom: 1rem;\n}\n.footer .nav .nav-item .nav-link,\n.footer .footer-link {\n  color: #8898aa !important;\n}\n.footer .nav .nav-item .nav-link:hover,\n.footer .footer-link:hover {\n  color: #525f7f !important;\n}\n.footer .list-unstyled li a {\n  display: inline-block;\n  padding: 0.125rem 0;\n  color: #8898aa;\n  font-size: 0.85rem;\n}\n.footer .list-unstyled li a:hover {\n  color: #525f7f;\n}\n.footer .copyright {\n  font-size: 0.875rem;\n}\n\n.footer-dark .col-footer .heading {\n  color: #fff;\n}\n\n.nav-footer .nav-link {\n  font-size: 0.875rem;\n}\n.nav-footer .nav-item:last-child .nav-link {\n  padding-right: 0;\n}\n\n.footer.has-cards {\n  overflow: hidden;\n  padding-top: 500px;\n  margin-top: -420px;\n  position: relative;\n  background: transparent;\n  pointer-events: none;\n}\n.footer.has-cards:before {\n  content: \"\";\n  position: absolute;\n  left: 0;\n  right: 0;\n  top: 600px;\n  height: 2000px;\n  background: #f7fafc;\n  transform: skew(0, -8deg);\n}\n.footer.has-cards .container {\n  pointer-events: auto;\n  position: relative;\n}\n\n.form-control-label {\n  color: #525f7f;\n  font-size: 0.875rem;\n  font-weight: 600;\n}\n\n.form-control {\n  font-size: 0.875rem;\n}\n.form-control:focus::placeholder {\n  color: #adb5bd;\n}\n\ntextarea[resize=none] {\n  resize: none !important;\n}\n\ntextarea[resize=both] {\n  resize: both !important;\n}\n\ntextarea[resize=vertical] {\n  resize: vertical !important;\n}\n\ntextarea[resize=horizontal] {\n  resize: horizontal !important;\n}\n\n.form-control-muted {\n  background-color: #f7fafe;\n  border-color: #f7fafe;\n  box-shadow: none;\n}\n.form-control-muted:focus {\n  background-color: rgb(251.5333333333, 252.8333333333, 254.5666666667);\n}\n\n.form-control-alternative {\n  box-shadow: 0 1px 3px rgba(50, 50, 93, 0.15), 0 1px 0 rgba(0, 0, 0, 0.02);\n  border: 0;\n  transition: box-shadow 0.15s ease;\n}\n.form-control-alternative:focus {\n  box-shadow: 0 4px 6px rgba(50, 50, 93, 0.11), 0 1px 3px rgba(0, 0, 0, 0.08);\n}\n\n.form-control-lg {\n  font-size: 1rem;\n}\n\n.has-success,\n.has-danger {\n  position: relative;\n}\n.has-success:after,\n.has-danger:after {\n  width: 19px;\n  height: 19px;\n  line-height: 19px;\n  text-align: center;\n  font-family: \"NucleoIcons\";\n  display: inline-block;\n  position: absolute;\n  right: 15px;\n  top: 2px;\n  transform: translateY(50%);\n  border-radius: 50%;\n  font-size: 9px;\n  opacity: 1;\n}\n\n.has-success:after {\n  content: \"\\ea26\";\n  color: daken(#3aa170, 18%);\n  background-color: rgb(97.3082191781, 198.1917808219, 150.198630137);\n}\n.has-success .form-control {\n  background-color: #fff;\n}\n.has-success .form-control:focus {\n  border-color: rgba(50, 151, 211, 0.25);\n}\n.has-success .form-control::placeholder {\n  color: #3aa170;\n}\n\n.has-danger:after {\n  content: \"\\ea53\";\n  color: daken(#fb6340, 18%);\n  background-color: rgb(252.5692307692, 160.2, 138.9307692308);\n}\n.has-danger .form-control {\n  background-color: #fff;\n}\n.has-danger .form-control:focus {\n  border-color: rgba(50, 151, 211, 0.25);\n}\n.has-danger .form-control::placeholder {\n  color: #fb6340;\n}\n\n.input-group {\n  box-shadow: none;\n  border-radius: 0.375rem;\n  transition: all 0.15s ease;\n}\n.input-group .form-control {\n  box-shadow: none;\n}\n.input-group .form-control:not(:first-child) {\n  border-left: 0;\n  padding-left: 0;\n}\n.input-group .form-control:not(:last-child) {\n  border-right: 0;\n  padding-right: 0;\n}\n.input-group .form-control:focus {\n  box-shadow: none;\n}\n\n.input-group-text {\n  transition: all 0.2s cubic-bezier(0.68, -0.55, 0.265, 1.55);\n}\n\n.input-group-alternative {\n  box-shadow: 0 1px 3px rgba(50, 50, 93, 0.15), 0 1px 0 rgba(0, 0, 0, 0.02);\n  border: 0;\n  transition: box-shadow 0.15s ease;\n}\n.input-group-alternative .form-control,\n.input-group-alternative .input-group-text {\n  border: 0;\n  box-shadow: none;\n}\n\n.focused .input-group-alternative {\n  box-shadow: 0 4px 6px rgba(50, 50, 93, 0.11), 0 1px 3px rgba(0, 0, 0, 0.08) !important;\n}\n\n.focused .input-group {\n  box-shadow: none;\n}\n.focused .input-group-text {\n  color: #8898aa;\n  background-color: #fff;\n  border-color: rgba(50, 151, 211, 0.25);\n}\n.focused .form-control {\n  border-color: rgba(50, 151, 211, 0.25);\n}\n\n.header {\n  position: relative;\n}\n\n.icon {\n  width: 3rem;\n  height: 3rem;\n}\n.icon i,\n.icon svg {\n  font-size: 2.25rem;\n}\n.icon + .icon-text {\n  padding-left: 1rem;\n  width: calc(100% - 3rem - 1);\n}\n\n.icon-xl {\n  width: 5rem;\n  height: 5rem;\n}\n.icon-xl i,\n.icon-xl svg {\n  font-size: 4.25rem;\n}\n.icon-xl + .icon-text {\n  width: calc(100% - 5rem - 1);\n}\n\n.icon-lg {\n  width: 4rem;\n  height: 4rem;\n}\n.icon-lg i,\n.icon-lg svg {\n  font-size: 3.25rem;\n}\n.icon-lg + .icon-text {\n  width: calc(100% - 4rem - 1);\n}\n\n.icon-sm {\n  width: 2rem;\n  height: 2rem;\n}\n.icon-sm i,\n.icon-sm svg {\n  font-size: 1.25rem;\n}\n.icon-sm + .icon-text {\n  width: calc(100% - 2rem - 1);\n}\n\n.icon-shape {\n  padding: 12px;\n  text-align: center;\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  border-radius: 50%;\n}\n.icon-shape i,\n.icon-shape svg {\n  font-size: 1.25rem;\n}\n.icon-shape.icon-lg i,\n.icon-shape.icon-lg svg {\n  font-size: 1.625rem;\n}\n.icon-shape.icon-sm i,\n.icon-shape.icon-sm svg {\n  font-size: 0.875rem;\n}\n.icon-shape svg {\n  width: 30px;\n  height: 30px;\n}\n\n.icon-shape-primary {\n  color: rgb(36.8959459459, 134.1040540541, 87.3693866944);\n  background-color: rgba(80.9864864865, 192.0135135135, 138.6351351351, 0.5);\n}\n\n.icon-shape-secondary {\n  color: rgb(206.8090909091, 227.4381818182, 241.1909090909);\n  background-color: rgba(255, 255, 255, 0.5);\n}\n\n.icon-shape-success {\n  color: rgb(36.0931506849, 131.9068493151, 86.3255752095);\n  background-color: rgba(78.5616438356, 191.4383561644, 137.7397260274, 0.5);\n}\n\n.icon-shape-info {\n  color: rgb(21.5110497238, 108.4889502762, 77.2444617283);\n  background-color: rgba(49.9889502762, 182.0110497238, 134.5856353591, 0.5);\n}\n\n.icon-shape-warning {\n  color: rgb(255, 55.0427807487, 9);\n  background-color: rgba(252.0461538462, 139.8, 113.9538461538, 0.5);\n}\n\n.icon-shape-danger {\n  color: rgb(248, 0, 49.3403141361);\n  background-color: rgba(247.4170616114, 102.5829383886, 131.3981042654, 0.5);\n}\n\n.icon-shape-light {\n  color: rgb(134.7932432432, 155.5, 176.2067567568);\n  background-color: rgba(201.2567567568, 206.5, 211.7432432432, 0.5);\n}\n\n.icon-shape-dark {\n  color: rgb(9.1067567568, 11.5, 13.8932432432);\n  background-color: rgba(55.7432432432, 62.5, 69.2567567568, 0.5);\n}\n\n.icon-shape-default {\n  color: rgb(255, 198.7043478261, 89);\n  background-color: rgba(255, 233.2956521739, 191, 0.5);\n}\n\n.icon-shape-white {\n  color: rgb(232.05, 226.95, 226.95);\n  background-color: rgba(255, 255, 255, 0.5);\n}\n\n.icon-shape-neutral {\n  color: rgb(232.05, 226.95, 226.95);\n  background-color: rgba(255, 255, 255, 0.5);\n}\n\n.icon-shape-darker {\n  color: black;\n  background-color: rgba(25.5, 25.5, 25.5, 0.5);\n}\n\n.input-group {\n  box-shadow: none;\n  border-radius: 0.375rem;\n  transition: all 0.15s ease;\n}\n.input-group .form-control {\n  box-shadow: none;\n}\n.input-group .form-control:not(:first-child) {\n  border-left: 0;\n  padding-left: 0;\n}\n.input-group .form-control:not(:last-child) {\n  border-right: 0;\n  padding-right: 0;\n}\n.input-group .form-control:focus {\n  box-shadow: none;\n}\n\n.input-group-text {\n  transition: all 0.2s cubic-bezier(0.68, -0.55, 0.265, 1.55);\n}\n\n.input-group-alternative {\n  box-shadow: 0 1px 3px rgba(50, 50, 93, 0.15), 0 1px 0 rgba(0, 0, 0, 0.02);\n  border: 0;\n  transition: box-shadow 0.15s ease;\n}\n.input-group-alternative .form-control,\n.input-group-alternative .input-group-text {\n  border: 0;\n  box-shadow: none;\n}\n\n.focused .input-group-alternative {\n  box-shadow: 0 4px 6px rgba(50, 50, 93, 0.11), 0 1px 3px rgba(0, 0, 0, 0.08) !important;\n}\n\n.focused .input-group {\n  box-shadow: none;\n}\n.focused .input-group-text {\n  color: #8898aa;\n  background-color: #fff;\n  border-color: rgba(50, 151, 211, 0.25);\n}\n.focused .form-control {\n  border-color: rgba(50, 151, 211, 0.25);\n}\n\n.list-group-space .list-group-item {\n  margin-bottom: 1.5rem;\n  border-radius: 0.375rem;\n}\n\n.list-group-img {\n  width: 3rem;\n  height: 3rem;\n  border-radius: 50%;\n  vertical-align: top;\n  margin: -0.1rem 1.2rem 0 -0.2rem;\n}\n\n.list-group-content {\n  flex: 1;\n  min-width: 0;\n}\n.list-group-content > p {\n  color: #adb5bd;\n  line-height: 1.5;\n  margin: 0.2rem 0 0;\n}\n\n.list-group-heading {\n  font-size: 1rem;\n  color: #32325d;\n}\n.list-group-heading > small {\n  float: right;\n  color: #adb5bd;\n  font-weight: 500;\n}\n\n.map-canvas {\n  position: relative;\n  width: 100%;\n  height: 500px;\n  border-radius: 0.375rem;\n}\n\n.mask {\n  position: absolute;\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: 100%;\n  transition: all 0.15s ease;\n}\n@media (prefers-reduced-motion: reduce) {\n  .mask {\n    transition: none;\n  }\n}\n\n.modal-fluid .modal-dialog {\n  margin-top: 0;\n  margin-bottom: 0;\n}\n.modal-fluid .modal-content {\n  border-radius: 0;\n}\n\n.modal-primary .modal-title {\n  color: #fff;\n}\n.modal-primary .modal-header,\n.modal-primary .modal-footer {\n  border-color: rgba(255, 255, 255, 0.075);\n}\n.modal-primary .modal-content {\n  background-color: #3ba371;\n  color: #fff;\n}\n.modal-primary .modal-content .heading {\n  color: #fff;\n}\n.modal-primary .close > span:not(.sr-only) {\n  color: #fff;\n}\n\n.modal-secondary .modal-title {\n  color: #212529;\n}\n.modal-secondary .modal-header,\n.modal-secondary .modal-footer {\n  border-color: rgba(33, 37, 41, 0.075);\n}\n.modal-secondary .modal-content {\n  background-color: #f7fafc;\n  color: #212529;\n}\n.modal-secondary .modal-content .heading {\n  color: #212529;\n}\n.modal-secondary .close > span:not(.sr-only) {\n  color: #fff;\n}\n\n.modal-success .modal-title {\n  color: #fff;\n}\n.modal-success .modal-header,\n.modal-success .modal-footer {\n  border-color: rgba(255, 255, 255, 0.075);\n}\n.modal-success .modal-content {\n  background-color: #3aa170;\n  color: #fff;\n}\n.modal-success .modal-content .heading {\n  color: #fff;\n}\n.modal-success .close > span:not(.sr-only) {\n  color: #fff;\n}\n\n.modal-info .modal-title {\n  color: #fff;\n}\n.modal-info .modal-header,\n.modal-info .modal-footer {\n  border-color: rgba(255, 255, 255, 0.075);\n}\n.modal-info .modal-content {\n  background-color: #278e69;\n  color: #fff;\n}\n.modal-info .modal-content .heading {\n  color: #fff;\n}\n.modal-info .close > span:not(.sr-only) {\n  color: #fff;\n}\n\n.modal-warning .modal-title {\n  color: #fff;\n}\n.modal-warning .modal-header,\n.modal-warning .modal-footer {\n  border-color: rgba(255, 255, 255, 0.075);\n}\n.modal-warning .modal-content {\n  background-color: #fb6340;\n  color: #fff;\n}\n.modal-warning .modal-content .heading {\n  color: #fff;\n}\n.modal-warning .close > span:not(.sr-only) {\n  color: #fff;\n}\n\n.modal-danger .modal-title {\n  color: #fff;\n}\n.modal-danger .modal-header,\n.modal-danger .modal-footer {\n  border-color: rgba(255, 255, 255, 0.075);\n}\n.modal-danger .modal-content {\n  background-color: #f5365c;\n  color: #fff;\n}\n.modal-danger .modal-content .heading {\n  color: #fff;\n}\n.modal-danger .close > span:not(.sr-only) {\n  color: #fff;\n}\n\n.modal-light .modal-title {\n  color: #fff;\n}\n.modal-light .modal-header,\n.modal-light .modal-footer {\n  border-color: rgba(255, 255, 255, 0.075);\n}\n.modal-light .modal-content {\n  background-color: #adb5bd;\n  color: #fff;\n}\n.modal-light .modal-content .heading {\n  color: #fff;\n}\n.modal-light .close > span:not(.sr-only) {\n  color: #fff;\n}\n\n.modal-dark .modal-title {\n  color: #fff;\n}\n.modal-dark .modal-header,\n.modal-dark .modal-footer {\n  border-color: rgba(255, 255, 255, 0.075);\n}\n.modal-dark .modal-content {\n  background-color: #212529;\n  color: #fff;\n}\n.modal-dark .modal-content .heading {\n  color: #fff;\n}\n.modal-dark .close > span:not(.sr-only) {\n  color: #fff;\n}\n\n.modal-default .modal-title {\n  color: #212529;\n}\n.modal-default .modal-header,\n.modal-default .modal-footer {\n  border-color: rgba(33, 37, 41, 0.075);\n}\n.modal-default .modal-content {\n  background-color: #ffd88c;\n  color: #212529;\n}\n.modal-default .modal-content .heading {\n  color: #212529;\n}\n.modal-default .close > span:not(.sr-only) {\n  color: #fff;\n}\n\n.modal-white .modal-title {\n  color: #212529;\n}\n.modal-white .modal-header,\n.modal-white .modal-footer {\n  border-color: rgba(33, 37, 41, 0.075);\n}\n.modal-white .modal-content {\n  background-color: #fff;\n  color: #212529;\n}\n.modal-white .modal-content .heading {\n  color: #212529;\n}\n.modal-white .close > span:not(.sr-only) {\n  color: #fff;\n}\n\n.modal-neutral .modal-title {\n  color: #212529;\n}\n.modal-neutral .modal-header,\n.modal-neutral .modal-footer {\n  border-color: rgba(33, 37, 41, 0.075);\n}\n.modal-neutral .modal-content {\n  background-color: #fff;\n  color: #212529;\n}\n.modal-neutral .modal-content .heading {\n  color: #212529;\n}\n.modal-neutral .close > span:not(.sr-only) {\n  color: #fff;\n}\n\n.modal-darker .modal-title {\n  color: #fff;\n}\n.modal-darker .modal-header,\n.modal-darker .modal-footer {\n  border-color: rgba(255, 255, 255, 0.075);\n}\n.modal-darker .modal-content {\n  background-color: black;\n  color: #fff;\n}\n.modal-darker .modal-content .heading {\n  color: #fff;\n}\n.modal-darker .close > span:not(.sr-only) {\n  color: #fff;\n}\n\n.nav-wrapper {\n  padding: 1rem 0;\n  border-top-left-radius: 0.375rem;\n  border-top-right-radius: 0.375rem;\n}\n.nav-wrapper + .card {\n  border-top-left-radius: 0;\n  border-top-right-radius: 0;\n  border-bottom-right-radius: 0.375rem;\n  border-bottom-left-radius: 0.375rem;\n}\n\n.nav-link {\n  color: #525f7f;\n}\n.nav-link:hover {\n  color: #3ba371;\n}\n.nav-link i.ni {\n  position: relative;\n  top: 2px;\n}\n\n@media (min-width: 992px) {\n  .nav-item.active-pro {\n    position: absolute;\n    width: 100%;\n    bottom: 10px;\n    background: #f6f9fc;\n  }\n}\n.nav-pills .nav-item:not(:last-child) {\n  padding-right: 1rem;\n}\n.nav-pills .nav-link {\n  padding: 0.75rem 1rem;\n  color: #3ba371;\n  font-weight: 500;\n  font-size: 0.875rem;\n  box-shadow: 0 4px 6px rgba(50, 50, 93, 0.11), 0 1px 3px rgba(0, 0, 0, 0.08);\n  background-color: #fff;\n  transition: all 0.15s ease;\n}\n.nav-pills .nav-link:hover {\n  color: rgb(52.222972973, 144.277027027, 100.0202702703);\n}\n.nav-pills .nav-link.active,\n.nav-pills .show > .nav-link {\n  color: #fff;\n  background-color: #3ba371;\n}\n@media (max-width: 575.98px) {\n  .nav-pills .nav-item {\n    margin-bottom: 1rem;\n  }\n}\n\n@media (max-width: 767.98px) {\n  .nav-pills:not(.nav-pills-circle) .nav-item {\n    padding-right: 0;\n  }\n}\n.nav-pills-circle .nav-link {\n  text-align: center;\n  height: 60px;\n  width: 60px;\n  padding: 0;\n  line-height: 60px;\n  border-radius: 50%;\n}\n.nav-pills-circle .nav-link-icon i,\n.nav-pills-circle .nav-link-icon svg {\n  font-size: 1rem;\n}\n\n.navbar-horizontal .navbar-nav .nav-link {\n  font-size: 0.9rem;\n  font-weight: 400;\n  text-transform: normal;\n  letter-spacing: 0;\n  transition: all 0.15s linear;\n}\n@media (prefers-reduced-motion: reduce) {\n  .navbar-horizontal .navbar-nav .nav-link {\n    transition: none;\n  }\n}\n.navbar-horizontal .navbar-nav .nav-link .nav-link-inner--text {\n  margin-left: 0.25rem;\n}\n.navbar-horizontal .navbar-brand {\n  font-size: 0.875rem;\n  font-weight: 600;\n  text-transform: uppercase;\n  font-size: 0.875rem;\n  letter-spacing: 0.05px;\n}\n.navbar-horizontal .navbar-brand img {\n  height: 30px;\n}\n.navbar-horizontal .navbar-dark .navbar-brand {\n  color: #fff;\n}\n.navbar-horizontal .navbar-light .navbar-brand {\n  color: #32325d;\n}\n.navbar-horizontal .navbar-nav .nav-item .media:not(:last-child) {\n  margin-bottom: 1.5rem;\n}\n@media (min-width: 992px) {\n  .navbar-horizontal .navbar-nav .nav-item {\n    margin-right: 0.5rem;\n  }\n  .navbar-horizontal .navbar-nav .nav-item [data-toggle=dropdown]::after {\n    transition: all 0.15s ease;\n  }\n  .navbar-horizontal .navbar-nav .nav-item.show [data-toggle=dropdown]::after {\n    transform: rotate(180deg);\n  }\n  .navbar-horizontal .navbar-nav .nav-link {\n    padding-top: 1rem;\n    padding-bottom: 1rem;\n    border-radius: 0.375rem;\n  }\n  .navbar-horizontal .navbar-nav .nav-link i {\n    margin-right: 0.625rem;\n  }\n  .navbar-horizontal .navbar-nav .nav-link-icon {\n    padding-left: 0.5rem !important;\n    padding-right: 0.5rem !important;\n    font-size: 1rem;\n    border-radius: 0.375rem;\n  }\n  .navbar-horizontal .navbar-nav .nav-link-icon i {\n    margin-right: 0;\n  }\n}\n.navbar-horizontal .navbar-transparent {\n  position: absolute;\n  top: 0;\n  width: 100%;\n  z-index: 100;\n  background-color: transparent;\n  border: 0;\n  box-shadow: none;\n}\n.navbar-horizontal .navbar-transparent .navbar-brand {\n  color: rgb(255, 255, 255);\n}\n.navbar-horizontal .navbar-transparent .navbar-toggler {\n  color: rgb(255, 255, 255);\n}\n.navbar-horizontal .navbar-transparent .navbar-toggler-icon {\n  background-image: url(\"data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg' width='30' height='30' viewBox='0 0 30 30'><path stroke='rgba(255, 255, 255, 0.95)' stroke-linecap='round' stroke-miterlimit='10' stroke-width='2' d='M4 7h22M4 15h22M4 23h22'/></svg>\");\n}\n@media (min-width: 768px) {\n  .navbar-horizontal .navbar-transparent .navbar-nav .nav-link {\n    color: rgba(255, 255, 255, 0.95);\n  }\n  .navbar-horizontal .navbar-transparent .navbar-nav .nav-link:hover, .navbar-horizontal .navbar-transparent .navbar-nav .nav-link:focus {\n    color: rgba(255, 255, 255, 0.65);\n  }\n  .navbar-horizontal .navbar-transparent .navbar-nav .nav-link.disabled {\n    color: rgba(255, 255, 255, 0.25);\n  }\n  .navbar-horizontal .navbar-transparent .navbar-nav .show > .nav-link,\n  .navbar-horizontal .navbar-transparent .navbar-nav .active > .nav-link,\n  .navbar-horizontal .navbar-transparent .navbar-nav .nav-link.show,\n  .navbar-horizontal .navbar-transparent .navbar-nav .nav-link.active {\n    color: rgba(255, 255, 255, 0.65);\n  }\n  .navbar-horizontal .navbar-transparent .navbar-brand {\n    color: rgba(255, 255, 255, 0.95);\n  }\n  .navbar-horizontal .navbar-transparent .navbar-brand:hover, .navbar-horizontal .navbar-transparent .navbar-brand:focus {\n    color: rgba(255, 255, 255, 0.95);\n  }\n}\n\n@media (min-width: 768px) {\n  .navbar-vertical {\n    background-color: #42826c;\n    width: 258px;\n    position: fixed;\n    height: 100vh;\n    padding: 0;\n    padding-top: 8px;\n    overflow-y: hidden;\n  }\n  .navbar-vertical .navbar-brand {\n    margin-right: 0;\n    width: 123px;\n    display: flex;\n    justify-content: center;\n    align-items: flex-start;\n  }\n  .navbar-vertical .navbar-brand img {\n    min-height: unset;\n    max-width: 123px;\n    width: 100%;\n    height: auto;\n  }\n  .navbar-vertical .container-fluid, .navbar-vertical .container-sm, .navbar-vertical .container-md, .navbar-vertical .container-lg, .navbar-vertical .container-xl {\n    display: flex;\n    flex-direction: column;\n    justify-content: center;\n    width: 100%;\n    height: 100%;\n  }\n  .navbar-vertical .navbar-collapse {\n    flex-direction: column;\n    align-items: start;\n    width: 100%;\n    overflow: scroll;\n    padding-bottom: 15px;\n  }\n  .navbar-vertical .navbar-collapse .navbar-nav {\n    padding-bottom: 30px;\n    width: 100%;\n    padding: 14px 8px;\n    font-size: 15px;\n    font-weight: 400;\n    line-height: 24px;\n    color: #fff;\n    background-color: transparent;\n  }\n  .navbar-vertical .navbar-collapse .navbar-nav i {\n    color: #fff;\n  }\n  .navbar-vertical .navbar-collapse .navbar-nav.bg-green-color {\n    background-color: #36745e;\n  }\n  .navbar-vertical .navbar-collapse .navbar-nav.bg-green-color i {\n    color: #eed7b9;\n  }\n}\n.navbar-search .input-group {\n  border-radius: 2rem;\n  border: 2px solid;\n  background-color: transparent;\n}\n.navbar-search .input-group .input-group-text {\n  background-color: transparent;\n  padding-left: 1rem;\n}\n.navbar-search .form-control {\n  width: 270px;\n  background-color: transparent;\n}\n\n.navbar-search-dark .input-group {\n  border-color: rgba(255, 255, 255, 0.6);\n}\n.navbar-search-dark .input-group-text {\n  color: rgba(255, 255, 255, 0.6);\n}\n.navbar-search-dark .form-control {\n  color: rgba(255, 255, 255, 0.9);\n}\n.navbar-search-dark .form-control::placeholder {\n  color: rgba(255, 255, 255, 0.6);\n}\n.navbar-search-dark .focused .input-group {\n  border-color: rgba(255, 255, 255, 0.9);\n}\n\n.navbar-search-light .input-group {\n  border-color: rgba(0, 0, 0, 0.6);\n}\n.navbar-search-light .input-group-text {\n  color: rgba(0, 0, 0, 0.6);\n}\n.navbar-search-light .form-control {\n  color: rgba(0, 0, 0, 0.9);\n}\n.navbar-search-light .form-control::placeholder {\n  color: rgba(0, 0, 0, 0.6);\n}\n.navbar-search-light .focused .input-group {\n  border-color: rgba(0, 0, 0, 0.9);\n}\n\n@media (min-width: 768px) {\n  .navbar .dropdown-menu {\n    opacity: 0;\n    pointer-events: none;\n    margin: 0;\n  }\n  .navbar .dropdown-menu-arrow:before {\n    background: #fff;\n    box-shadow: none;\n    content: \"\";\n    display: block;\n    height: 12px;\n    width: 12px;\n    right: 20px;\n    position: absolute;\n    bottom: 100%;\n    transform: rotate(-45deg) translateY(12px);\n    z-index: -5;\n    border-radius: 2px;\n  }\n  .navbar .dropdown-menu-right:before {\n    right: 20px;\n    left: auto;\n  }\n  .navbar:not(.navbar-nav-hover) .dropdown-menu.show {\n    opacity: 1;\n    pointer-events: auto;\n    animation: show-navbar-dropdown 0.25s ease forwards;\n  }\n  .navbar:not(.navbar-nav-hover) .dropdown-menu.close {\n    display: block;\n    animation: hide-navbar-dropdown 0.15s ease backwards;\n  }\n  .navbar.navbar-nav-hover .dropdown-menu {\n    opacity: 0;\n    display: block;\n    pointer-events: none;\n    transform: translate(0, 10px) perspective(200px) rotateX(-2deg);\n    transition: visibility 0.25s, opacity 0.25s, transform 0.25s;\n  }\n  .navbar.navbar-nav-hover .nav-item.dropdown:hover > .dropdown-menu {\n    display: block;\n    opacity: 1;\n    pointer-events: auto;\n    visibility: visible;\n    transform: translate(0, 0);\n    animation: none;\n  }\n  .navbar .dropdown-menu-inner {\n    position: relative;\n    padding: 1rem;\n  }\n  @keyframes show-navbar-dropdown {\n    0% {\n      opacity: 0;\n      transform: translate(0, 10px) perspective(200px) rotateX(-2deg);\n      transition: visibility 0.25s, opacity 0.25s, transform 0.25s;\n    }\n    100% {\n      transform: translate(0, 0);\n      opacity: 1;\n    }\n  }\n  @keyframes hide-navbar-dropdown {\n    from {\n      opacity: 1;\n    }\n    to {\n      opacity: 0;\n      transform: translate(0, 10px);\n    }\n  }\n}\n.navbar-collapse-header {\n  display: none;\n}\n\n@media (max-width: 767.98px) {\n  .navbar-nav .nav-link {\n    padding: 0.625rem 0;\n    color: #ffd88c !important;\n  }\n  .navbar-nav .dropdown-menu {\n    box-shadow: none;\n    min-width: auto;\n  }\n  .navbar-nav .dropdown-menu .media svg {\n    width: 30px;\n  }\n  .navbar-collapse {\n    width: calc(100% - 1.4rem);\n    position: absolute;\n    top: 0;\n    left: 0;\n    right: 0;\n    z-index: 1050;\n    margin: 0.7rem;\n    overflow-y: auto;\n    height: auto !important;\n    opacity: 0;\n  }\n  .navbar-collapse .navbar-toggler {\n    width: 20px;\n    height: 20px;\n    position: relative;\n    cursor: pointer;\n    display: inline-block;\n    padding: 0;\n  }\n  .navbar-collapse .navbar-toggler span {\n    display: block;\n    position: absolute;\n    width: 100%;\n    height: 2px;\n    border-radius: 2px;\n    opacity: 1;\n    background: #283448;\n  }\n  .navbar-collapse .navbar-toggler :nth-child(1) {\n    transform: rotate(135deg);\n  }\n  .navbar-collapse .navbar-toggler :nth-child(2) {\n    transform: rotate(-135deg);\n  }\n  .navbar-collapse .navbar-collapse-header {\n    display: block;\n    padding-bottom: 1rem;\n    margin-bottom: 1rem;\n    border-bottom: 1px solid rgba(0, 0, 0, 0.1);\n  }\n  .navbar-collapse .collapse-brand img {\n    height: 36px;\n  }\n  .navbar-collapse .collapse-close {\n    text-align: right;\n  }\n  .navbar-collapse.collapsing,\n  .navbar-collapse.show {\n    padding: 1.5rem;\n    border-radius: 0.375rem;\n    background: #fff;\n    box-shadow: 0 50px 100px rgba(50, 50, 93, 0.1), 0 15px 35px rgba(50, 50, 93, 0.15), 0 5px 15px rgba(0, 0, 0, 0.1);\n    animation: show-navbar-collapse 0.2s ease forwards;\n  }\n  .navbar-collapse.collapsing-out {\n    animation: hide-navbar-collapse 0.2s ease forwards;\n  }\n}\n@keyframes show-navbar-collapse {\n  0% {\n    opacity: 0;\n    transform: scale(0.95);\n    transform-origin: 100% 0;\n  }\n  100% {\n    opacity: 1;\n    transform: scale(1);\n  }\n}\n@keyframes hide-navbar-collapse {\n  from {\n    opacity: 1;\n    transform: scale(1);\n    transform-origin: 100% 0;\n  }\n  to {\n    opacity: 0;\n    transform: scale(0.95);\n  }\n}\n.page-item.active .page-link {\n  box-shadow: 0 7px 14px rgba(50, 50, 93, 0.1), 0 3px 6px rgba(0, 0, 0, 0.08);\n}\n.page-item .page-link,\n.page-item span {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  padding: 0;\n  margin: 0 3px;\n  border-radius: 50% !important;\n  width: 36px;\n  height: 36px;\n  font-size: 0.875rem;\n}\n\n.pagination-lg .page-item .page-link,\n.pagination-lg .page-item span {\n  width: 46px;\n  height: 46px;\n  line-height: 46px;\n}\n\n.pagination-sm .page-item .page-link,\n.pagination-sm .page-item span {\n  width: 30px;\n  height: 30px;\n  line-height: 30px;\n}\n\n.popover {\n  border: 0;\n}\n\n.popover-header {\n  font-weight: 600;\n}\n\n.popover-primary {\n  background-color: #3ba371;\n}\n.popover-primary .popover-header {\n  background-color: #3ba371;\n  color: #fff;\n}\n.popover-primary .popover-body {\n  color: #fff;\n}\n.popover-primary .popover-header {\n  border-color: rgba(255, 255, 255, 0.2);\n}\n.popover-primary.bs-popover-top .arrow::after, .popover-primary.bs-popover-auto[x-placement^=top] .arrow::after {\n  border-top-color: #3ba371;\n}\n.popover-primary.bs-popover-right .arrow::after, .popover-primary.bs-popover-auto[x-placement^=right] .arrow::after {\n  border-right-color: #3ba371;\n}\n.popover-primary.bs-popover-bottom .arrow::after, .popover-primary.bs-popover-auto[x-placement^=bottom] .arrow::after {\n  border-bottom-color: #3ba371;\n}\n.popover-primary.bs-popover-left .arrow::after, .popover-primary.bs-popover-auto[x-placement^=left] .arrow::after {\n  border-left-color: #3ba371;\n}\n\n.popover-secondary {\n  background-color: #f7fafc;\n}\n.popover-secondary .popover-header {\n  background-color: #f7fafc;\n  color: #212529;\n}\n.popover-secondary .popover-body {\n  color: #212529;\n}\n.popover-secondary .popover-header {\n  border-color: rgba(33, 37, 41, 0.2);\n}\n.popover-secondary.bs-popover-top .arrow::after, .popover-secondary.bs-popover-auto[x-placement^=top] .arrow::after {\n  border-top-color: #f7fafc;\n}\n.popover-secondary.bs-popover-right .arrow::after, .popover-secondary.bs-popover-auto[x-placement^=right] .arrow::after {\n  border-right-color: #f7fafc;\n}\n.popover-secondary.bs-popover-bottom .arrow::after, .popover-secondary.bs-popover-auto[x-placement^=bottom] .arrow::after {\n  border-bottom-color: #f7fafc;\n}\n.popover-secondary.bs-popover-left .arrow::after, .popover-secondary.bs-popover-auto[x-placement^=left] .arrow::after {\n  border-left-color: #f7fafc;\n}\n\n.popover-success {\n  background-color: #3aa170;\n}\n.popover-success .popover-header {\n  background-color: #3aa170;\n  color: #fff;\n}\n.popover-success .popover-body {\n  color: #fff;\n}\n.popover-success .popover-header {\n  border-color: rgba(255, 255, 255, 0.2);\n}\n.popover-success.bs-popover-top .arrow::after, .popover-success.bs-popover-auto[x-placement^=top] .arrow::after {\n  border-top-color: #3aa170;\n}\n.popover-success.bs-popover-right .arrow::after, .popover-success.bs-popover-auto[x-placement^=right] .arrow::after {\n  border-right-color: #3aa170;\n}\n.popover-success.bs-popover-bottom .arrow::after, .popover-success.bs-popover-auto[x-placement^=bottom] .arrow::after {\n  border-bottom-color: #3aa170;\n}\n.popover-success.bs-popover-left .arrow::after, .popover-success.bs-popover-auto[x-placement^=left] .arrow::after {\n  border-left-color: #3aa170;\n}\n\n.popover-info {\n  background-color: #278e69;\n}\n.popover-info .popover-header {\n  background-color: #278e69;\n  color: #fff;\n}\n.popover-info .popover-body {\n  color: #fff;\n}\n.popover-info .popover-header {\n  border-color: rgba(255, 255, 255, 0.2);\n}\n.popover-info.bs-popover-top .arrow::after, .popover-info.bs-popover-auto[x-placement^=top] .arrow::after {\n  border-top-color: #278e69;\n}\n.popover-info.bs-popover-right .arrow::after, .popover-info.bs-popover-auto[x-placement^=right] .arrow::after {\n  border-right-color: #278e69;\n}\n.popover-info.bs-popover-bottom .arrow::after, .popover-info.bs-popover-auto[x-placement^=bottom] .arrow::after {\n  border-bottom-color: #278e69;\n}\n.popover-info.bs-popover-left .arrow::after, .popover-info.bs-popover-auto[x-placement^=left] .arrow::after {\n  border-left-color: #278e69;\n}\n\n.popover-warning {\n  background-color: #fb6340;\n}\n.popover-warning .popover-header {\n  background-color: #fb6340;\n  color: #fff;\n}\n.popover-warning .popover-body {\n  color: #fff;\n}\n.popover-warning .popover-header {\n  border-color: rgba(255, 255, 255, 0.2);\n}\n.popover-warning.bs-popover-top .arrow::after, .popover-warning.bs-popover-auto[x-placement^=top] .arrow::after {\n  border-top-color: #fb6340;\n}\n.popover-warning.bs-popover-right .arrow::after, .popover-warning.bs-popover-auto[x-placement^=right] .arrow::after {\n  border-right-color: #fb6340;\n}\n.popover-warning.bs-popover-bottom .arrow::after, .popover-warning.bs-popover-auto[x-placement^=bottom] .arrow::after {\n  border-bottom-color: #fb6340;\n}\n.popover-warning.bs-popover-left .arrow::after, .popover-warning.bs-popover-auto[x-placement^=left] .arrow::after {\n  border-left-color: #fb6340;\n}\n\n.popover-danger {\n  background-color: #f5365c;\n}\n.popover-danger .popover-header {\n  background-color: #f5365c;\n  color: #fff;\n}\n.popover-danger .popover-body {\n  color: #fff;\n}\n.popover-danger .popover-header {\n  border-color: rgba(255, 255, 255, 0.2);\n}\n.popover-danger.bs-popover-top .arrow::after, .popover-danger.bs-popover-auto[x-placement^=top] .arrow::after {\n  border-top-color: #f5365c;\n}\n.popover-danger.bs-popover-right .arrow::after, .popover-danger.bs-popover-auto[x-placement^=right] .arrow::after {\n  border-right-color: #f5365c;\n}\n.popover-danger.bs-popover-bottom .arrow::after, .popover-danger.bs-popover-auto[x-placement^=bottom] .arrow::after {\n  border-bottom-color: #f5365c;\n}\n.popover-danger.bs-popover-left .arrow::after, .popover-danger.bs-popover-auto[x-placement^=left] .arrow::after {\n  border-left-color: #f5365c;\n}\n\n.popover-light {\n  background-color: #adb5bd;\n}\n.popover-light .popover-header {\n  background-color: #adb5bd;\n  color: #fff;\n}\n.popover-light .popover-body {\n  color: #fff;\n}\n.popover-light .popover-header {\n  border-color: rgba(255, 255, 255, 0.2);\n}\n.popover-light.bs-popover-top .arrow::after, .popover-light.bs-popover-auto[x-placement^=top] .arrow::after {\n  border-top-color: #adb5bd;\n}\n.popover-light.bs-popover-right .arrow::after, .popover-light.bs-popover-auto[x-placement^=right] .arrow::after {\n  border-right-color: #adb5bd;\n}\n.popover-light.bs-popover-bottom .arrow::after, .popover-light.bs-popover-auto[x-placement^=bottom] .arrow::after {\n  border-bottom-color: #adb5bd;\n}\n.popover-light.bs-popover-left .arrow::after, .popover-light.bs-popover-auto[x-placement^=left] .arrow::after {\n  border-left-color: #adb5bd;\n}\n\n.popover-dark {\n  background-color: #212529;\n}\n.popover-dark .popover-header {\n  background-color: #212529;\n  color: #fff;\n}\n.popover-dark .popover-body {\n  color: #fff;\n}\n.popover-dark .popover-header {\n  border-color: rgba(255, 255, 255, 0.2);\n}\n.popover-dark.bs-popover-top .arrow::after, .popover-dark.bs-popover-auto[x-placement^=top] .arrow::after {\n  border-top-color: #212529;\n}\n.popover-dark.bs-popover-right .arrow::after, .popover-dark.bs-popover-auto[x-placement^=right] .arrow::after {\n  border-right-color: #212529;\n}\n.popover-dark.bs-popover-bottom .arrow::after, .popover-dark.bs-popover-auto[x-placement^=bottom] .arrow::after {\n  border-bottom-color: #212529;\n}\n.popover-dark.bs-popover-left .arrow::after, .popover-dark.bs-popover-auto[x-placement^=left] .arrow::after {\n  border-left-color: #212529;\n}\n\n.popover-default {\n  background-color: #ffd88c;\n}\n.popover-default .popover-header {\n  background-color: #ffd88c;\n  color: #212529;\n}\n.popover-default .popover-body {\n  color: #212529;\n}\n.popover-default .popover-header {\n  border-color: rgba(33, 37, 41, 0.2);\n}\n.popover-default.bs-popover-top .arrow::after, .popover-default.bs-popover-auto[x-placement^=top] .arrow::after {\n  border-top-color: #ffd88c;\n}\n.popover-default.bs-popover-right .arrow::after, .popover-default.bs-popover-auto[x-placement^=right] .arrow::after {\n  border-right-color: #ffd88c;\n}\n.popover-default.bs-popover-bottom .arrow::after, .popover-default.bs-popover-auto[x-placement^=bottom] .arrow::after {\n  border-bottom-color: #ffd88c;\n}\n.popover-default.bs-popover-left .arrow::after, .popover-default.bs-popover-auto[x-placement^=left] .arrow::after {\n  border-left-color: #ffd88c;\n}\n\n.popover-white {\n  background-color: #fff;\n}\n.popover-white .popover-header {\n  background-color: #fff;\n  color: #212529;\n}\n.popover-white .popover-body {\n  color: #212529;\n}\n.popover-white .popover-header {\n  border-color: rgba(33, 37, 41, 0.2);\n}\n.popover-white.bs-popover-top .arrow::after, .popover-white.bs-popover-auto[x-placement^=top] .arrow::after {\n  border-top-color: #fff;\n}\n.popover-white.bs-popover-right .arrow::after, .popover-white.bs-popover-auto[x-placement^=right] .arrow::after {\n  border-right-color: #fff;\n}\n.popover-white.bs-popover-bottom .arrow::after, .popover-white.bs-popover-auto[x-placement^=bottom] .arrow::after {\n  border-bottom-color: #fff;\n}\n.popover-white.bs-popover-left .arrow::after, .popover-white.bs-popover-auto[x-placement^=left] .arrow::after {\n  border-left-color: #fff;\n}\n\n.popover-neutral {\n  background-color: #fff;\n}\n.popover-neutral .popover-header {\n  background-color: #fff;\n  color: #212529;\n}\n.popover-neutral .popover-body {\n  color: #212529;\n}\n.popover-neutral .popover-header {\n  border-color: rgba(33, 37, 41, 0.2);\n}\n.popover-neutral.bs-popover-top .arrow::after, .popover-neutral.bs-popover-auto[x-placement^=top] .arrow::after {\n  border-top-color: #fff;\n}\n.popover-neutral.bs-popover-right .arrow::after, .popover-neutral.bs-popover-auto[x-placement^=right] .arrow::after {\n  border-right-color: #fff;\n}\n.popover-neutral.bs-popover-bottom .arrow::after, .popover-neutral.bs-popover-auto[x-placement^=bottom] .arrow::after {\n  border-bottom-color: #fff;\n}\n.popover-neutral.bs-popover-left .arrow::after, .popover-neutral.bs-popover-auto[x-placement^=left] .arrow::after {\n  border-left-color: #fff;\n}\n\n.popover-darker {\n  background-color: black;\n}\n.popover-darker .popover-header {\n  background-color: black;\n  color: #fff;\n}\n.popover-darker .popover-body {\n  color: #fff;\n}\n.popover-darker .popover-header {\n  border-color: rgba(255, 255, 255, 0.2);\n}\n.popover-darker.bs-popover-top .arrow::after, .popover-darker.bs-popover-auto[x-placement^=top] .arrow::after {\n  border-top-color: black;\n}\n.popover-darker.bs-popover-right .arrow::after, .popover-darker.bs-popover-auto[x-placement^=right] .arrow::after {\n  border-right-color: black;\n}\n.popover-darker.bs-popover-bottom .arrow::after, .popover-darker.bs-popover-auto[x-placement^=bottom] .arrow::after {\n  border-bottom-color: black;\n}\n.popover-darker.bs-popover-left .arrow::after, .popover-darker.bs-popover-auto[x-placement^=left] .arrow::after {\n  border-left-color: black;\n}\n\n.progress-wrapper {\n  position: relative;\n  padding-top: 1.5rem;\n}\n\n.progress {\n  height: 8px;\n  margin-bottom: 1rem;\n  overflow: hidden;\n  border-radius: 0.25rem;\n  background-color: #e9ecef;\n  box-shadow: inset 0 1px 2px rgba(0, 0, 0, 0.1);\n}\n.progress .sr-only {\n  width: auto;\n  height: 20px;\n  margin: 0 0 0 30px;\n  left: 0;\n  clip: auto;\n  line-height: 20px;\n  font-size: 13px;\n}\n\n.progress-heading {\n  font-size: 14px;\n  font-weight: 500;\n  margin: 0 0 2px;\n  padding: 0;\n}\n\n.progress-bar {\n  box-shadow: none;\n  border-radius: 0;\n  height: auto;\n}\n\n.progress-info {\n  margin-bottom: 0.5rem;\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n}\n\n.progress-label span {\n  display: inline-block;\n  color: #3ba371;\n  font-size: 0.625rem;\n  font-weight: 600;\n  text-transform: uppercase;\n  background: rgba(59, 163, 113, 0.1);\n  padding: 0.25rem 1rem;\n  border-radius: 30px;\n}\n\n.progress-percentage {\n  text-align: right;\n}\n.progress-percentage span {\n  display: inline-block;\n  color: #8898aa;\n  font-size: 0.875rem;\n  font-weight: 600;\n}\n\n.separator {\n  position: absolute;\n  top: auto;\n  left: 0;\n  right: 0;\n  width: 100%;\n  height: 150px;\n  transform: translateZ(0);\n  overflow: hidden;\n  pointer-events: none;\n}\n.separator svg {\n  position: absolute;\n  pointer-events: none;\n}\n\n.separator-top {\n  top: 0;\n  bottom: auto;\n}\n.separator-top svg {\n  top: 0;\n}\n\n.separator-bottom {\n  top: auto;\n  bottom: 0;\n}\n.separator-bottom svg {\n  bottom: 0;\n}\n\n.separator-inverse {\n  transform: rotate(180deg);\n}\n\n.separator-skew {\n  height: 60px;\n}\n@media (min-width: 1200px) {\n  .separator-skew {\n    height: 70px;\n  }\n}\n\n.table thead th {\n  cursor: pointer;\n  padding-top: 0.75rem;\n  padding-bottom: 0.75rem;\n  font-size: 0.65rem;\n  text-transform: uppercase;\n  letter-spacing: 1px;\n  border-bottom: 1px solid #e9ecef;\n}\n.table th {\n  font-weight: 600;\n}\n.table td .progress {\n  height: 3px;\n  width: 120px;\n  margin: 0;\n}\n.table td,\n.table th {\n  font-size: 0.8125rem;\n  white-space: nowrap;\n}\n.table.align-items-center td,\n.table.align-items-center th {\n  vertical-align: middle;\n}\n.table .thead-dark th {\n  background-color: rgb(255, 222.9182608696, 160.4);\n  color: white;\n}\n.table .thead-light th {\n  background-color: #f6f9fc;\n  color: #8898aa;\n}\n\n.table-hover tr {\n  transition: all 0.15s ease;\n}\n@media (prefers-reduced-motion: reduce) {\n  .table-hover tr {\n    transition: none;\n  }\n}\n\n.table-flush td,\n.table-flush th {\n  border-left: 0;\n  border-right: 0;\n}\n.table-flush tbody tr:first-child td,\n.table-flush tbody tr:first-child th {\n  border-top: 0;\n}\n.table-flush tbody tr:last-child td,\n.table-flush tbody tr:last-child th {\n  border-bottom: 0;\n}\n\n.card .table {\n  margin-bottom: 0;\n  cursor: pointer;\n}\n.card .table td,\n.card .table th {\n  padding-left: 1.5rem;\n  padding-right: 1.5rem;\n}\n\np {\n  font-size: 1rem;\n  font-weight: 300;\n  line-height: 1.7;\n}\n\n.lead {\n  font-size: 1.25rem;\n  font-weight: 300;\n  line-height: 1.7;\n  margin-top: 1.5rem;\n}\n.lead + .btn-wrapper {\n  margin-top: 3rem;\n}\n\n.description {\n  font-size: 0.875rem;\n}\n\n.heading {\n  letter-spacing: 0.025em;\n  font-size: 0.95rem;\n  text-transform: uppercase;\n  font-weight: 600;\n}\n\n.heading-small {\n  padding-top: 0.25rem;\n  padding-bottom: 0.25rem;\n  font-size: 0.75rem;\n  text-transform: uppercase;\n  letter-spacing: 0.04em;\n}\n\n.heading-title {\n  letter-spacing: 0.025em;\n  font-size: 1.375rem;\n  font-weight: 600;\n  text-transform: uppercase;\n}\n\n.heading-section {\n  letter-spacing: 0.025em;\n  font-size: 1.375rem;\n  font-weight: 600;\n  text-transform: uppercase;\n}\n.heading-section img {\n  display: block;\n  width: 72px;\n  height: 72px;\n  margin-bottom: 1.5rem;\n}\n.heading-section.text-center img {\n  margin-left: auto;\n  margin-right: auto;\n}\n\n.display-1 span,\n.display-2 span,\n.display-3 span,\n.display-4 span {\n  display: block;\n  font-weight: 300;\n}\n\narticle h4:not(:first-child),\narticle h5:not(:first-child) {\n  margin-top: 3rem;\n}\narticle h4,\narticle h5 {\n  margin-bottom: 1.5rem;\n}\narticle figure {\n  margin: 3rem 0;\n}\narticle h5 + figure {\n  margin-top: 0;\n}\n\n.datepicker {\n  border-radius: 0.375rem;\n  direction: ltr;\n}\n.datepicker-inline {\n  width: 220px;\n}\n.datepicker-rtl {\n  direction: rtl;\n}\n.datepicker-rtl.dropdown-menu {\n  left: auto;\n}\n.datepicker-rtl table tr td span {\n  float: right;\n}\n.datepicker-dropdown {\n  top: 0;\n  left: 0;\n  padding: 20px 22px;\n  box-shadow: 0 50px 100px rgba(50, 50, 93, 0.1), 0 15px 35px rgba(50, 50, 93, 0.15), 0 5px 15px rgba(0, 0, 0, 0.1);\n}\n.datepicker-dropdown.datepicker-orient-left:before {\n  left: 6px;\n}\n.datepicker-dropdown.datepicker-orient-left:after {\n  left: 7px;\n}\n.datepicker-dropdown.datepicker-orient-right:before {\n  right: 6px;\n}\n.datepicker-dropdown.datepicker-orient-right:after {\n  right: 7px;\n}\n.datepicker-dropdown.datepicker-orient-bottom:before {\n  top: -7px;\n}\n.datepicker-dropdown.datepicker-orient-bottom:after {\n  top: -6px;\n}\n.datepicker-dropdown.datepicker-orient-top:before {\n  bottom: -7px;\n  border-bottom: 0;\n  border-top: 7px solid white;\n}\n.datepicker-dropdown.datepicker-orient-top:after {\n  bottom: -6px;\n  border-bottom: 0;\n  border-top: 6px solid #fff;\n}\n.datepicker table {\n  margin: 0;\n  -webkit-touch-callout: none;\n  user-select: none;\n}\n.datepicker table tr td {\n  border-radius: 50%;\n}\n.datepicker table tr th {\n  border-radius: 0.375rem;\n  font-weight: 500;\n}\n.datepicker table tr td,\n.datepicker table tr th {\n  transition: all 0.15s ease;\n  width: 36px;\n  height: 36px;\n  border: none;\n  text-align: center;\n  font-size: 0.875rem;\n}\n.table-striped .datepicker table tr td,\n.table-striped .datepicker table tr th {\n  background-color: transparent;\n}\n.datepicker table tr td.old, .datepicker table tr td.new {\n  color: #adb5bd;\n}\n.datepicker table tr td.day:hover, .datepicker table tr td.focused {\n  background: white;\n  cursor: pointer;\n}\n.datepicker table tr td.disabled, .datepicker table tr td.disabled:hover {\n  background: none;\n  color: #dee2e6;\n  cursor: default;\n}\n.datepicker table tr td.highlighted {\n  border-radius: 0;\n}\n.datepicker table tr td.highlighted.focused {\n  background: #3ba371;\n}\n.datepicker table tr td.highlighted.disabled, .datepicker table tr td.highlighted.disabled:active {\n  background: #3ba371;\n  color: #ced4da;\n}\n.datepicker table tr td.today {\n  background: rgb(212.0472972973, 239.4527027027, 226.277027027);\n}\n.datepicker table tr td.today.focused {\n  background: white;\n}\n.datepicker table tr td.today.disabled, .datepicker table tr td.today.disabled:active {\n  background: white;\n  color: #8898aa;\n}\n.datepicker table tr td.range {\n  background: #3ba371;\n  color: #fff;\n  border-radius: 0;\n}\n.datepicker table tr td.range.focused {\n  background: rgb(48.1567567568, 133.0432432432, 92.2324324324);\n}\n.datepicker table tr td.range.disabled, .datepicker table tr td.range.disabled:active, .datepicker table tr td.range.day.disabled:hover {\n  background: rgb(45.4459459459, 125.5540540541, 87.0405405405);\n  color: rgb(80.9864864865, 192.0135135135, 138.6351351351);\n}\n.datepicker table tr td.range.highlighted.focused {\n  background: rgb(203.4736842105, 210.5, 217.5263157895);\n}\n.datepicker table tr td.range.highlighted.disabled, .datepicker table tr td.range.highlighted.disabled:active {\n  background: #e9ecef;\n  color: #dee2e6;\n}\n.datepicker table tr td.range.today.disabled, .datepicker table tr td.range.today.disabled:active {\n  background: #3ba371;\n  color: #fff;\n}\n.datepicker table tr td.day.range-start {\n  border-top-right-radius: 0;\n  border-bottom-right-radius: 0;\n}\n.datepicker table tr td.day.range-end {\n  border-top-left-radius: 0;\n  border-bottom-left-radius: 0;\n}\n.datepicker table tr td.day.range-start.range-end {\n  border-radius: 50%;\n}\n.datepicker table tr td.selected, .datepicker table tr td.selected.highlighted, .datepicker table tr td.selected:hover, .datepicker table tr td.selected.highlighted:hover, .datepicker table tr td.day.range:hover {\n  background: #3ba371;\n  color: #fff;\n}\n.datepicker table tr td.active, .datepicker table tr td.active.highlighted, .datepicker table tr td.active:hover, .datepicker table tr td.active.highlighted:hover {\n  background: #3ba371;\n  color: #fff;\n  box-shadow: none;\n}\n.datepicker table tr td span {\n  display: block;\n  width: 23%;\n  height: 54px;\n  line-height: 54px;\n  float: left;\n  margin: 1%;\n  cursor: pointer;\n  border-radius: 4px;\n}\n.datepicker table tr td span:hover, .datepicker table tr td span.focused {\n  background: #e9ecef;\n}\n.datepicker table tr td span.disabled, .datepicker table tr td span.disabled:hover {\n  background: none;\n  color: #dee2e6;\n  cursor: default;\n}\n.datepicker table tr td span.active, .datepicker table tr td span.active:hover, .datepicker table tr td span.active.disabled, .datepicker table tr td span.active.disabled:hover {\n  text-shadow: 0 -1px 0 rgba(0, 0, 0, 0.25);\n}\n.datepicker table tr td span.old, .datepicker table tr td span.new {\n  color: #8898aa;\n}\n.datepicker .datepicker-switch {\n  width: 145px;\n}\n.datepicker .datepicker-switch,\n.datepicker .prev,\n.datepicker .next,\n.datepicker tfoot tr th {\n  cursor: pointer;\n}\n.datepicker .datepicker-switch:hover,\n.datepicker .prev:hover,\n.datepicker .next:hover,\n.datepicker tfoot tr th:hover {\n  background: #e9ecef;\n}\n.datepicker .prev.disabled,\n.datepicker .next.disabled {\n  visibility: hidden;\n}\n.datepicker .cw {\n  font-size: 10px;\n  width: 12px;\n  padding: 0 2px 0 5px;\n  vertical-align: middle;\n}\n\n/*! nouislider - 14.0.1 - 6/21/2019 */\n/* Functional styling;\n * These styles are required for noUiSlider to function.\n * You don't need to change these rules to apply your design.\n */\n.noUi-target,\n.noUi-target * {\n  -webkit-touch-callout: none;\n  -webkit-tap-highlight-color: rgba(0, 0, 0, 0);\n  -webkit-user-select: none;\n  -ms-touch-action: none;\n  touch-action: none;\n  -ms-user-select: none;\n  -moz-user-select: none;\n  user-select: none;\n  -moz-box-sizing: border-box;\n  box-sizing: border-box;\n}\n\n.noUi-target {\n  position: relative;\n  direction: ltr;\n}\n\n.noUi-base,\n.noUi-connects {\n  width: 100%;\n  height: 100%;\n  position: relative;\n  z-index: 1;\n}\n\n/* Wrapper for all connect elements.\n */\n.noUi-connects {\n  overflow: hidden;\n  z-index: 0;\n}\n\n.noUi-connect,\n.noUi-origin {\n  will-change: transform;\n  position: absolute;\n  z-index: 1;\n  top: 0;\n  left: 0;\n  -ms-transform-origin: 0 0;\n  -webkit-transform-origin: 0 0;\n  -webkit-transform-style: preserve-3d;\n  transform-origin: 0 0;\n  transform-style: flat;\n}\n\n.noUi-connect {\n  height: 100%;\n  width: 100%;\n}\n\n.noUi-origin {\n  height: 10%;\n  width: 10%;\n}\n\n/* Offset direction\n */\nhtml:not([dir=rtl]) .noUi-horizontal .noUi-origin {\n  left: auto;\n  right: 0;\n}\n\n/* Give origins 0 height/width so they don't interfere with clicking the\n * connect elements.\n */\n.noUi-vertical .noUi-origin {\n  width: 0;\n}\n\n.noUi-horizontal .noUi-origin {\n  height: 0;\n}\n\n.noUi-handle {\n  -webkit-backface-visibility: hidden;\n  backface-visibility: hidden;\n  position: absolute;\n}\n\n.noUi-touch-area {\n  height: 100%;\n  width: 100%;\n}\n\n.noUi-state-tap .noUi-connect,\n.noUi-state-tap .noUi-origin {\n  -webkit-transition: transform 0.3s;\n  transition: transform 0.3s;\n}\n\n.noUi-state-drag * {\n  cursor: inherit !important;\n}\n\n/* Slider size and handle placement;\n */\n.noUi-horizontal {\n  height: 18px;\n}\n\n.noUi-horizontal .noUi-handle {\n  width: 34px;\n  height: 28px;\n  left: -17px;\n  top: -6px;\n}\n\n.noUi-vertical {\n  width: 18px;\n}\n\n.noUi-vertical .noUi-handle {\n  width: 28px;\n  height: 34px;\n  left: -6px;\n  top: -17px;\n}\n\nhtml:not([dir=rtl]) .noUi-horizontal .noUi-handle {\n  right: -17px;\n  left: auto;\n}\n\n/* Styling;\n * Giving the connect element a border radius causes issues with using transform: scale\n */\n.noUi-target {\n  background: #fafafa;\n  border-radius: 4px;\n  border: 1px solid #d3d3d3;\n  box-shadow: inset 0 1px 1px #f0f0f0, 0 3px 6px -5px #bbb;\n}\n\n.noUi-connects {\n  border-radius: 3px;\n}\n\n.noUi-connect {\n  background: #3fb8af;\n}\n\n/* Handles and cursors;\n */\n.noUi-draggable {\n  cursor: ew-resize;\n}\n\n.noUi-vertical .noUi-draggable {\n  cursor: ns-resize;\n}\n\n.noUi-handle {\n  border: 1px solid #d9d9d9;\n  border-radius: 3px;\n  background: #fff;\n  cursor: default;\n  box-shadow: inset 0 0 1px #fff, inset 0 1px 7px #ebebeb, 0 3px 6px -3px #bbb;\n}\n\n.noUi-active {\n  box-shadow: inset 0 0 1px #fff, inset 0 1px 7px #ddd, 0 3px 6px -3px #bbb;\n}\n\n/* Handle stripes;\n */\n.noUi-handle:before,\n.noUi-handle:after {\n  content: \"\";\n  display: block;\n  position: absolute;\n  height: 14px;\n  width: 1px;\n  background: #e8e7e6;\n  left: 14px;\n  top: 6px;\n}\n\n.noUi-handle:after {\n  left: 17px;\n}\n\n.noUi-vertical .noUi-handle:before,\n.noUi-vertical .noUi-handle:after {\n  width: 14px;\n  height: 1px;\n  left: 6px;\n  top: 14px;\n}\n\n.noUi-vertical .noUi-handle:after {\n  top: 17px;\n}\n\n/* Disabled state;\n */\n[disabled] .noUi-connect {\n  background: #b8b8b8;\n}\n\n[disabled].noUi-target,\n[disabled].noUi-handle,\n[disabled] .noUi-handle {\n  cursor: not-allowed;\n}\n\n/* Base;\n *\n */\n.noUi-pips,\n.noUi-pips * {\n  -moz-box-sizing: border-box;\n  box-sizing: border-box;\n}\n\n.noUi-pips {\n  position: absolute;\n  color: #999;\n}\n\n/* Values;\n *\n */\n.noUi-value {\n  position: absolute;\n  white-space: nowrap;\n  text-align: center;\n}\n\n.noUi-value-sub {\n  color: #ccc;\n  font-size: 10px;\n}\n\n/* Markings;\n *\n */\n.noUi-marker {\n  position: absolute;\n  background: #ccc;\n}\n\n.noUi-marker-sub {\n  background: #aaa;\n}\n\n.noUi-marker-large {\n  background: #aaa;\n}\n\n/* Horizontal layout;\n *\n */\n.noUi-pips-horizontal {\n  padding: 10px 0;\n  height: 80px;\n  top: 100%;\n  left: 0;\n  width: 100%;\n}\n\n.noUi-value-horizontal {\n  -webkit-transform: translate(-50%, 50%);\n  transform: translate(-50%, 50%);\n}\n\n.noUi-rtl .noUi-value-horizontal {\n  -webkit-transform: translate(50%, 50%);\n  transform: translate(50%, 50%);\n}\n\n.noUi-marker-horizontal.noUi-marker {\n  margin-left: -1px;\n  width: 2px;\n  height: 5px;\n}\n\n.noUi-marker-horizontal.noUi-marker-sub {\n  height: 10px;\n}\n\n.noUi-marker-horizontal.noUi-marker-large {\n  height: 15px;\n}\n\n/* Vertical layout;\n *\n */\n.noUi-pips-vertical {\n  padding: 0 10px;\n  height: 100%;\n  top: 0;\n  left: 100%;\n}\n\n.noUi-value-vertical {\n  -webkit-transform: translate(0, -50%);\n  transform: translate(0, -50%);\n  padding-left: 25px;\n}\n\n.noUi-rtl .noUi-value-vertical {\n  -webkit-transform: translate(0, 50%);\n  transform: translate(0, 50%);\n}\n\n.noUi-marker-vertical.noUi-marker {\n  width: 5px;\n  height: 2px;\n  margin-top: -1px;\n}\n\n.noUi-marker-vertical.noUi-marker-sub {\n  width: 10px;\n}\n\n.noUi-marker-vertical.noUi-marker-large {\n  width: 15px;\n}\n\n.noUi-tooltip {\n  display: block;\n  position: absolute;\n  border: 1px solid #d9d9d9;\n  border-radius: 3px;\n  background: #fff;\n  color: #000;\n  padding: 5px;\n  text-align: center;\n  white-space: nowrap;\n}\n\n.noUi-horizontal .noUi-tooltip {\n  -webkit-transform: translate(-50%, 0);\n  transform: translate(-50%, 0);\n  left: 50%;\n  bottom: 120%;\n}\n\n.noUi-vertical .noUi-tooltip {\n  -webkit-transform: translate(0, -50%);\n  transform: translate(0, -50%);\n  top: 50%;\n  right: 120%;\n}\n\n.noUi-target {\n  background: #eceeef;\n  border-radius: 5px;\n  border: 0;\n  box-shadow: inset 0 1px 2px rgba(90, 97, 105, 0.1);\n  margin: 15px 0;\n  cursor: pointer;\n}\n\n.noUi-horizontal {\n  height: 5px;\n}\n\nhtml:not([dir=rtl]) .noUi-horizontal .noUi-handle {\n  right: -10px;\n}\n\n.noUi-vertical {\n  width: 5px;\n}\n\n.noUi-connect {\n  background: #3ba371;\n  box-shadow: none;\n}\n\n.noUi-handle:after, .noUi-handle:before {\n  content: none;\n}\n.noUi-handle:focus {\n  outline: none;\n}\n\n.noUi-horizontal .noUi-handle,\n.noUi-vertical .noUi-handle {\n  top: -5px;\n  width: 15px;\n  height: 15px;\n  border-radius: 100%;\n  box-shadow: none;\n  cursor: pointer;\n  background-color: #3ba371;\n  border: 0;\n  transition: box-shadow 0.15s, transform 0.15s;\n}\n\n.noUi-horizontal .noUi-handle.noUi-active,\n.noUi-vertical .noUi-handle.noUi-active {\n  box-shadow: 0px 0px 0px 2px #3ba371;\n}\n\n.input-slider--cyan .noUi-connect {\n  background: #2bffc6;\n}\n\n/* Disabled state */\n[disabled] .noUi-connect,\n[disabled].noUi-connect {\n  background: #b2b2b2;\n}\n\n[disabled] .noUi-handle,\n[disabled].noUi-origin {\n  cursor: not-allowed;\n}\n\n/* Range slider value labels */\n.range-slider-value {\n  font-size: 0.75rem;\n  font-weight: 500;\n  background-color: rgba(33, 37, 41, 0.7);\n  color: #fff;\n  border-radius: 10px;\n  padding: 0.4em 0.8em 0.3em 0.85em;\n}\n\n.range-slider-wrapper .upper-info {\n  font-weight: 400;\n  margin-bottom: 5px;\n}\n\n.input-slider-value-output {\n  background: #333;\n  color: #fff;\n  padding: 4px 8px;\n  position: relative;\n  top: 12px;\n  font-size: 11px;\n  border-radius: 2px;\n}\n\n.input-slider-value-output:after {\n  bottom: 100%;\n  left: 10px;\n  border: solid transparent;\n  content: \" \";\n  height: 0;\n  width: 0;\n  position: absolute;\n  pointer-events: none;\n  border-color: rgba(136, 183, 213, 0);\n  border-bottom-color: #333;\n  border-width: 4px;\n  margin-left: -4px;\n}\n\n.input-slider-value-output.left:after {\n  left: 10px;\n  right: auto;\n}\n\n.input-slider-value-output.right:after {\n  right: 10px;\n  left: auto;\n}\n\n.scrollbar-inner {\n  height: 100%;\n}\n.scrollbar-inner:not(:hover) .scroll-element {\n  opacity: 0;\n}\n.scrollbar-inner .scroll-element {\n  transition: opacity 300ms;\n  margin-right: 2px;\n}\n.scrollbar-inner .scroll-element .scroll-bar,\n.scrollbar-inner .scroll-element .scroll-element_track {\n  transition: background-color 300ms;\n}\n.scrollbar-inner .scroll-element .scroll-element_track {\n  background-color: transparent;\n}\n.scrollbar-inner .scroll-element.scroll-y {\n  width: 3px;\n  right: 0;\n}\n.scrollbar-inner .scroll-element.scroll-x {\n  height: 3px;\n  bottom: 0;\n}\n\n.ct-navbar {\n  background-color: #3ba371;\n  box-shadow: rgba(116, 129, 141, 0.1) 0px 1px 1px 0px;\n  padding-top: 0.5rem;\n  padding-bottom: 0.5rem;\n}\n@media (max-width: 991.98px) {\n  .ct-navbar {\n    padding-right: 0.5rem;\n    padding-left: 0.5rem;\n  }\n  .ct-navbar .navbar-nav-scroll {\n    max-width: 100%;\n    height: 2.5rem;\n    margin-top: 0.25rem;\n    overflow: hidden;\n    font-size: 0.875rem;\n  }\n  .ct-navbar .navbar-nav-scroll .navbar-nav {\n    padding-bottom: 2rem;\n    overflow-x: auto;\n    white-space: nowrap;\n    -webkit-overflow-scrolling: touch;\n  }\n}\n@media (min-width: 768px) {\n  @supports (position: sticky) {\n    .ct-navbar {\n      position: sticky;\n      top: 0;\n      z-index: 1071;\n    }\n  }\n}\n.ct-navbar .navbar-nav .nav-link {\n  padding-right: 0.5rem;\n  padding-left: 0.5rem;\n  color: rgba(255, 255, 255, 0.9) !important;\n}\n.ct-navbar .navbar-nav .nav-link.active, .ct-navbar .navbar-nav .nav-link:hover {\n  color: #fff !important;\n  background-color: transparent !important;\n}\n.ct-navbar .navbar-nav .nav-link.active {\n  font-weight: 500;\n}\n.ct-navbar .navbar-nav-svg {\n  display: inline-block;\n  width: 1rem;\n  height: 1rem;\n  vertical-align: text-top;\n}\n.ct-navbar .dropdown-menu {\n  font-size: 0.875rem;\n}\n.ct-navbar .dropdown-item.active {\n  font-weight: 500;\n  color: #212529;\n  background-color: transparent;\n  background-image: url(\"data:image/svg+xml;charset=utf8,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 8 8'%3E%3Cpath fill='%23292b2c' d='M2.3 6.73L.6 4.53c-.4-1.04.46-1.4 1.1-.8l1.1 1.4 3.4-3.8c.6-.63 1.6-.27 1.2.7l-4 4.6c-.43.5-.8.4-1.1.1z'/%3E%3C/svg%3E\");\n  background-repeat: no-repeat;\n  background-position: 0.4rem 0.87rem;\n  background-size: 0.75rem 0.75rem;\n  padding-left: 25px;\n}\n\n.github-corner {\n  position: fixed;\n  right: 0;\n  z-index: 1080;\n}\n.github-corner:hover .octo-arm {\n  animation: octocat-wave 560ms ease-in-out;\n}\n.github-corner svg {\n  fill: #fff;\n  color: #3ba371;\n}\n\n@keyframes octocat-wave {\n  0%, 100% {\n    transform: rotate(0);\n  }\n  20%, 60% {\n    transform: rotate(-25deg);\n  }\n  40%, 80% {\n    transform: rotate(10deg);\n  }\n}\n.ct-clipboard {\n  position: relative;\n  display: none;\n  float: right;\n}\n.ct-clipboard + .highlight {\n  margin-top: 0;\n}\n\n.btn-clipboard {\n  position: absolute;\n  top: 1rem;\n  right: 1rem;\n  z-index: 10;\n  display: block;\n  padding: 0.25rem 0.5rem;\n  font-size: 75%;\n  cursor: pointer;\n  background-color: transparent;\n  border: 0;\n  border-radius: 0.25rem;\n  color: #fff;\n  background-color: #3ba371;\n}\n.btn-clipboard:hover {\n  color: #fff;\n  background-color: rgb(45.4459459459, 125.5540540541, 87.0405405405);\n}\n\n@media (min-width: 768px) {\n  .ct-clipboard {\n    display: block;\n  }\n}\n.ct-example-row .row > .col span,\n.ct-example-row .row > [class^=col-] span {\n  display: block;\n  padding: 0.75rem;\n  color: rgb(57, 63, 73);\n  background-color: rgb(255, 255, 255);\n  box-shadow: rgba(0, 0, 0, 0.1) 0px 0px 0px 1px, rgba(0, 0, 0, 0.1) 0px 4px 16px;\n  font-size: 0.875rem;\n  border-radius: 0.25rem;\n  margin: 1rem 0;\n}\n.ct-example-row .no-gutters > .col span,\n.ct-example-row .no-gutters > [class^=col-] span {\n  border-radius: 0;\n}\n.ct-example-row .flex-items-top,\n.ct-example-row .flex-items-middle,\n.ct-example-row .flex-items-bottom {\n  min-height: 6rem;\n  background-color: rgba(255, 0, 0, 0.1);\n}\n\n.ct-example-row-flex-cols .row {\n  min-height: 10rem;\n  background-color: rgba(255, 0, 0, 0.1);\n}\n.ct-example-row-flex-cols .row + .row {\n  margin-top: 1rem;\n}\n\n.ct-highlight {\n  background-color: rgba(59, 163, 113, 0.15);\n  border: 1px solid rgba(59, 163, 113, 0.15);\n}\n\n.example-container {\n  width: 800px;\n  width: 100%;\n  padding-right: 15px;\n  padding-left: 15px;\n  margin-right: auto;\n  margin-left: auto;\n}\n\n.example-row {\n  display: flex;\n  flex-wrap: wrap;\n  margin-right: -15px;\n  margin-left: -15px;\n}\n\n.example-content-main {\n  position: relative;\n  width: 100%;\n  padding-right: 15px;\n  padding-left: 15px;\n}\n@media (min-width: 576px) {\n  .example-content-main {\n    flex: 0 0 50%;\n    max-width: 50%;\n  }\n}\n@media (min-width: 992px) {\n  .example-content-main {\n    flex: 0 0 66.6666666667%;\n    max-width: 66.6666666667%;\n  }\n}\n\n.example-content-secondary {\n  position: relative;\n  width: 100%;\n  padding-right: 15px;\n  padding-left: 15px;\n}\n@media (min-width: 576px) {\n  .example-content-secondary {\n    flex: 0 0 50%;\n    max-width: 50%;\n  }\n}\n@media (min-width: 992px) {\n  .example-content-secondary {\n    flex: 0 0 33.3333333333%;\n    max-width: 33.3333333333%;\n  }\n}\n\n.ct-example-container {\n  min-width: 16rem;\n  max-width: 25rem;\n  margin-right: auto;\n  margin-left: auto;\n}\n\n.ct-example-container-header {\n  height: 3rem;\n  margin-bottom: 0.5rem;\n  background-color: rgb(230.7702702703, 246.2297297297, 238.7972972973);\n  border-radius: 0.25rem;\n}\n\n.ct-example-container-sidebar {\n  float: right;\n  width: 4rem;\n  height: 8rem;\n  background-color: rgb(137.1554054054, 212.3445945946, 176.1959459459);\n  border-radius: 0.25rem;\n}\n\n.ct-example-container-body {\n  height: 8rem;\n  margin-right: 4.5rem;\n  background-color: rgb(137.1554054054, 212.3445945946, 176.1959459459);\n  border-radius: 0.25rem;\n}\n\n.ct-example-container-fluid {\n  max-width: none;\n}\n\n.ct-example {\n  position: relative;\n  margin: 1rem -15px 0;\n}\n.ct-example::after {\n  display: block;\n  clear: both;\n  content: \"\";\n}\n@media (min-width: 576px) {\n  .ct-example {\n    margin-right: 0;\n    margin-left: 0;\n  }\n}\n.ct-example + .highlight,\n.ct-example + .clipboard + .highlight {\n  margin-top: 0;\n}\n.ct-example + p {\n  margin-top: 2rem;\n}\n.ct-example .pos-f-t {\n  position: relative;\n  margin: -1rem;\n}\n@media (min-width: 576px) {\n  .ct-example .pos-f-t {\n    margin: -1.5rem;\n  }\n}\n.ct-example .custom-file-input:lang(es) ~ .custom-file-label::after {\n  content: \"Elegir\";\n}\n.ct-example > .form-control + .form-control {\n  margin-top: 0.5rem;\n}\n.ct-example > .nav + .nav,\n.ct-example > .alert + .alert,\n.ct-example > .navbar + .navbar,\n.ct-example > .progress + .progress,\n.ct-example > .progress + .btn,\n.ct-example .badge,\n.ct-example .btn {\n  margin-top: 0.5rem;\n  margin-bottom: 0.5rem;\n}\n.ct-example .btn-group {\n  margin-top: 0.5rem;\n  margin-bottom: 0.5rem;\n}\n.ct-example .btn-group .btn {\n  margin: 0;\n}\n.ct-example .alert {\n  margin: 0;\n}\n.ct-example .alert + .alert {\n  margin-top: 1.25rem;\n}\n.ct-example .badge {\n  margin-right: 0.5rem;\n}\n.ct-example > .dropdown-menu:first-child {\n  position: static;\n  display: block;\n}\n.ct-example > .form-group:last-child {\n  margin-bottom: 0;\n}\n.ct-example > .close {\n  float: none;\n}\n\n.ct-example-type .table .type-info {\n  color: #999;\n  vertical-align: middle;\n}\n.ct-example-type .table td {\n  padding: 1rem 0;\n  border-color: #eee;\n}\n.ct-example-type .table tr:first-child td {\n  border-top: 0;\n}\n.ct-example-type h1,\n.ct-example-type h2,\n.ct-example-type h3,\n.ct-example-type h4,\n.ct-example-type h5,\n.ct-example-type h6 {\n  margin-top: 0;\n  margin-bottom: 0;\n}\n\n.ct-example-bg-classes p {\n  padding: 1rem;\n}\n\n.ct-example > img + img {\n  margin-left: 0.5rem;\n}\n\n.ct-example > .btn-group {\n  margin-top: 0.25rem;\n  margin-bottom: 0.25rem;\n}\n.ct-example > .btn-toolbar + .btn-toolbar {\n  margin-top: 0.5rem;\n}\n\n.ct-example-control-sizing select,\n.ct-example-control-sizing input[type=text] + input[type=text] {\n  margin-top: 0.5rem;\n}\n\n.ct-example-form .input-group {\n  margin-bottom: 0.5rem;\n}\n\n.ct-example > textarea.form-control {\n  resize: vertical;\n}\n\n.ct-example > .list-group {\n  max-width: 400px;\n}\n\n.ct-example .fixed-top,\n.ct-example .sticky-top {\n  position: static;\n  margin: -1rem -1rem 1rem;\n}\n.ct-example .fixed-bottom {\n  position: static;\n  margin: 1rem -1rem -1rem;\n}\n@media (min-width: 576px) {\n  .ct-example .fixed-top,\n  .ct-example .sticky-top {\n    margin: -1.5rem -1.5rem 1rem;\n  }\n  .ct-example .fixed-bottom {\n    margin: 1rem -1.5rem -1.5rem;\n  }\n}\n\n.ct-example .pagination {\n  margin-top: 0.5rem;\n  margin-bottom: 0.5rem;\n}\n\n.modal {\n  z-index: 1072;\n}\n.modal .tooltip,\n.modal .popover {\n  z-index: 1073;\n}\n\n.modal-backdrop {\n  z-index: 1071;\n}\n\n.ct-example-modal {\n  background-color: #fafafa;\n}\n.ct-example-modal .modal {\n  position: relative;\n  top: auto;\n  right: auto;\n  bottom: auto;\n  left: auto;\n  z-index: 1;\n  display: block;\n}\n.ct-example-modal .modal-dialog {\n  left: auto;\n  margin-right: auto;\n  margin-left: auto;\n}\n\n.ct-example-tabs .nav-tabs {\n  margin-bottom: 1rem;\n}\n\n.ct-example-popover-static {\n  padding-bottom: 1.5rem;\n  background-color: #f9f9f9;\n}\n.ct-example-popover-static .popover {\n  position: relative;\n  display: block;\n  float: left;\n  width: 260px;\n  margin: 1.25rem;\n}\n\n.tooltip-demo a {\n  white-space: nowrap;\n}\n\n.ct-example-tooltip-static .tooltip {\n  position: relative;\n  display: inline-block;\n  margin: 10px 20px;\n  opacity: 1;\n}\n\n.scrollspy-example {\n  position: relative;\n  height: 200px;\n  margin-top: 0.5rem;\n  overflow: auto;\n}\n\n.scrollspy-example-2 {\n  position: relative;\n  height: 350px;\n  overflow: auto;\n}\n\n.ct-example-border-utils [class^=border] {\n  display: inline-block;\n  width: 5rem;\n  height: 5rem;\n  margin: 0.25rem;\n  background-color: #f5f5f5;\n}\n\n.ct-example-border-utils-0 [class^=border] {\n  border: 1px solid #b1b1b1;\n}\n\n.highlight {\n  padding: 0;\n  margin-top: 1rem;\n  -ms-overflow-style: -ms-autohiding-scrollbar;\n}\n@media (min-width: 576px) {\n  .highlight {\n    padding: 0;\n  }\n}\n\n.ct-content .highlight {\n  margin-right: -15px;\n  margin-left: -15px;\n}\n@media (min-width: 576px) {\n  .ct-content .highlight {\n    margin-right: 0;\n    margin-left: 0;\n  }\n}\n\n.ct-example {\n  margin-bottom: 2rem;\n  padding-bottom: 2rem;\n  border-bottom: 1px solid #e9ecef;\n}\n.ct-example .tab-content .tab-example-result {\n  background-color: #f5f7f9;\n  border: 1px solid #e6ecf1;\n  padding: 1.25rem;\n  border-radius: 0.25rem;\n}\n.ct-example .nav-tabs-code {\n  margin-bottom: 0.375rem;\n}\n.ct-example .nav-tabs-code .nav-link {\n  font-size: 0.875rem;\n}\n.ct-example .nav-tabs-code .nav-link:active, .ct-example .nav-tabs-code .nav-link.active {\n  color: #3ba371;\n}\n\n.icon-examples {\n  margin-top: 1rem;\n}\n\n.btn-icon-clipboard {\n  margin: 0px;\n  padding: 24px;\n  font-size: 16px;\n  font-weight: 400;\n  line-height: 1.25;\n  color: rgb(57, 63, 73);\n  background-color: rgb(248, 249, 250);\n  border-radius: 4px;\n  border: 0px none;\n  text-align: left;\n  font-family: inherit;\n  display: inline-block;\n  vertical-align: middle;\n  text-decoration: none;\n  -moz-appearance: none;\n  cursor: pointer;\n  width: 100%;\n  margin: 0.5rem 0;\n}\n.btn-icon-clipboard:hover {\n  background-color: rgb(255, 255, 255);\n  box-shadow: rgba(0, 0, 0, 0.1) 0px 0px 0px 1px, rgba(0, 0, 0, 0.1) 0px 4px 16px;\n}\n.btn-icon-clipboard > div {\n  align-items: center;\n  display: flex;\n}\n.btn-icon-clipboard i {\n  box-sizing: content-box;\n  color: rgb(57, 63, 73);\n  vertical-align: middle;\n  font-size: 1.5rem;\n}\n.btn-icon-clipboard span {\n  display: inline-block;\n  font-size: 0.875rem;\n  line-height: 1.5;\n  color: rgb(57, 63, 73);\n  margin-left: 16px;\n  overflow: hidden;\n  white-space: nowrap;\n  text-overflow: ellipsis;\n  vertical-align: middle;\n}\n\ncode[class*=language-],\npre[class*=language-] {\n  font-family: Consolas, Menlo, Monaco, \"Andale Mono WT\", \"Andale Mono\", \"Lucida Console\", \"Lucida Sans Typewriter\", \"DejaVu Sans Mono\", \"Bitstream Vera Sans Mono\", \"Liberation Mono\", \"Nimbus Mono L\", \"Courier New\", Courier, monospace;\n  font-size: 14px;\n  line-height: 1.375;\n  direction: ltr;\n  text-align: left;\n  white-space: pre;\n  word-spacing: normal;\n  word-break: normal;\n  -moz-tab-size: 4;\n  -o-tab-size: 4;\n  tab-size: 4;\n  -webkit-hyphens: none;\n  -moz-hyphens: none;\n  -ms-hyphens: none;\n  hyphens: none;\n  background: #f5f7ff;\n  color: #5e6687;\n  border-radius: 0.25rem;\n}\n\npre[class*=language-]::-moz-selection,\npre[class*=language-] ::-moz-selection,\ncode[class*=language-]::-moz-selection,\ncode[class*=language-] ::-moz-selection {\n  text-shadow: none;\n  background: #dfe2f1;\n}\n\npre[class*=language-]::selection,\npre[class*=language-] ::selection,\ncode[class*=language-]::selection,\ncode[class*=language-] ::selection {\n  text-shadow: none;\n  background: #dfe2f1;\n}\n\n/* Code blocks */\npre[class*=language-] {\n  padding: 1.25rem;\n  margin: 0;\n  overflow: auto;\n}\n\n/* Inline code */\n:not(pre) > code[class*=language-] {\n  padding: 0.1em;\n  border-radius: 0.3em;\n}\n\n.token.comment,\n.token.prolog,\n.token.doctype,\n.token.cdata {\n  color: #898ea4;\n}\n\n.token.punctuation {\n  color: #5e6687;\n}\n\n.token.namespace {\n  opacity: 0.7;\n}\n\n.token.operator,\n.token.boolean,\n.token.number {\n  color: #c76b29;\n}\n\n.token.property {\n  color: #c08b30;\n}\n\n.token.tag {\n  color: #3d8fd1;\n}\n\n.token.string {\n  color: #22a2c9;\n}\n\n.token.selector {\n  color: #6679cc;\n}\n\n.token.attr-name {\n  color: #c76b29;\n}\n\n.token.entity,\n.token.url,\n.language-css .token.string,\n.style .token.string {\n  color: #22a2c9;\n}\n\n.token.attr-value,\n.token.keyword,\n.token.control,\n.token.directive,\n.token.unit {\n  color: #ac9739;\n}\n\n.token.statement,\n.token.regex,\n.token.atrule {\n  color: #22a2c9;\n}\n\n.token.placeholder,\n.token.variable {\n  color: #3d8fd1;\n}\n\n.token.deleted {\n  text-decoration: line-through;\n}\n\n.token.inserted {\n  border-bottom: 1px dotted #202746;\n  text-decoration: none;\n}\n\n.token.italic {\n  font-style: italic;\n}\n\n.token.important,\n.token.bold {\n  font-weight: bold;\n}\n\n.token.important {\n  color: #c94922;\n}\n\n.token.entity {\n  cursor: help;\n}\n\npre > code.highlight {\n  outline: 0.4em solid #c94922;\n  outline-offset: 0.4em;\n}\n\n/* overrides color-values for the Line Numbers plugin\n * http://prismjs.com/plugins/line-numbers/\n */\n.line-numbers .line-numbers-rows {\n  border-right-color: #dfe2f1;\n}\n\n.line-numbers-rows > span:before {\n  color: #979db4;\n}\n\n/* overrides color-values for the Line Highlight plugin\n * http://prismjs.com/plugins/line-highlight/\n */\n.line-highlight {\n  background: rgba(107, 115, 148, 0.2);\n  background: -webkit-linear-gradient(left, rgba(107, 115, 148, 0.2) 70%, rgba(107, 115, 148, 0));\n  background: linear-gradient(to right, rgba(107, 115, 148, 0.2) 70%, rgba(107, 115, 148, 0));\n}\n\n.docs {\n  background: #fff;\n}\n.docs h6 {\n  font-size: 1rem;\n  font-weight: 600;\n}\n\n.ct-content {\n  order: 1;\n}\n.ct-content > h2[id],\n.ct-content > h3[id],\n.ct-content > h4[id] {\n  pointer-events: none;\n}\n.ct-content > h2[id] > div,\n.ct-content > h2[id] > a,\n.ct-content > h3[id] > div,\n.ct-content > h3[id] > a,\n.ct-content > h4[id] > div,\n.ct-content > h4[id] > a {\n  pointer-events: auto;\n}\n.ct-content > h2[id]::before,\n.ct-content > h3[id]::before,\n.ct-content > h4[id]::before {\n  display: block;\n  height: 6rem;\n  margin-top: -6rem;\n  visibility: hidden;\n  content: \"\";\n}\n.ct-content > table {\n  width: 100%;\n  max-width: 100%;\n  margin-bottom: 1rem;\n}\n@media (max-width: 991.98px) {\n  .ct-content > table {\n    display: block;\n    overflow-x: auto;\n    -ms-overflow-style: -ms-autohiding-scrollbar;\n  }\n  .ct-content > table.table-bordered {\n    border: 0;\n  }\n}\n.ct-content > table > thead > tr > th,\n.ct-content > table > thead > tr > td,\n.ct-content > table > tbody > tr > th,\n.ct-content > table > tbody > tr > td,\n.ct-content > table > tfoot > tr > th,\n.ct-content > table > tfoot > tr > td {\n  padding: 1rem;\n  vertical-align: top;\n  border: 1px solid #e9ecef;\n}\n.ct-content > table > thead > tr > th > p:last-child,\n.ct-content > table > thead > tr > td > p:last-child,\n.ct-content > table > tbody > tr > th > p:last-child,\n.ct-content > table > tbody > tr > td > p:last-child,\n.ct-content > table > tfoot > tr > th > p:last-child,\n.ct-content > table > tfoot > tr > td > p:last-child {\n  margin-bottom: 0;\n}\n.ct-content > table td:first-child > code {\n  white-space: nowrap;\n}\n\n.ct-content > h2:not(:first-child) {\n  margin-top: 3rem;\n  font-size: 1.5rem;\n  font-weight: 600;\n}\n.ct-content > h3 {\n  margin-top: 2.5rem;\n  font-size: 1.25rem;\n  font-weight: 600;\n}\n.ct-content > ul li,\n.ct-content > ol li {\n  margin-bottom: 0.25rem;\n}\n@media (min-width: 992px) {\n  .ct-content > ul,\n  .ct-content > ol,\n  .ct-content > p {\n    max-width: 80%;\n  }\n}\n\n.ct-page-title {\n  padding-left: 1.25rem;\n  border-left: 2px solid #3ba371;\n  margin-bottom: 1.5rem;\n}\n\n.ct-title {\n  margin-top: 1rem;\n  margin-bottom: 0.5rem;\n  font-weight: 300;\n}\n@media (min-width: 576px) {\n  .ct-title {\n    font-size: 1.5rem;\n    font-weight: 600;\n  }\n}\n\n.ct-lead {\n  color: rgb(59, 69, 78);\n  font-weight: 500;\n}\n@media (min-width: 576px) {\n  .ct-lead {\n    max-width: 80%;\n    margin-bottom: 1rem;\n    font-size: 0.875rem;\n  }\n}\n\n.ct-text-purple {\n  color: #3ba371;\n}\n\n.ct-text-purple-bright {\n  color: rgb(94.4219594595, 204.0780405405, 151.35877079);\n}\n\n.ct-tabs-example .nav-link i {\n  margin-right: 5px;\n}\n\n.color-swatch {\n  margin: 1rem 0;\n  border-radius: 0.25rem;\n  background-color: #f4f5f7;\n}\n\n.color-swatch:after {\n  content: \" \";\n  display: table;\n  clear: both;\n}\n\n.color-swatch-header {\n  position: relative;\n  height: 0;\n  padding-bottom: 50%;\n  border-radius: 0.25rem 0.25rem 0 0;\n  border: 1px solid transparent;\n}\n\n.color-swatch-header.is-light {\n  border-color: #c1c7d0;\n}\n\n.color-swatch-header .pass-fail {\n  position: absolute;\n  width: 100%;\n  bottom: 0;\n}\n\n.color-swatch-header .pass-fail-item-wrap {\n  position: relative;\n  float: left;\n  left: 50%;\n  -webkit-transform: translateX(-50%);\n  -ms-transform: translateX(-50%);\n  transform: translateX(-50%);\n}\n\n.color-swatch-header .pass-fail-item-group {\n  display: inline-block;\n  padding: 0 5px;\n}\n\n.color-swatch-header .pass-fail-item {\n  float: left;\n  display: inline-block;\n  text-align: center;\n  padding: 2px;\n}\n\n.color-swatch-header .pass-fail-item.white .example {\n  color: #fff;\n}\n\n.color-swatch-header .pass-fail-item.small .example {\n  font-size: 10px;\n}\n\n.color-swatch-header .pass-fail-item .lozenge {\n  font-size: 11px;\n  text-transform: uppercase;\n  font-weight: 600;\n  background: #000;\n  color: #fff;\n  padding: 2px 4px;\n  line-height: 10px;\n  border-radius: 4px;\n  letter-spacing: 0.05em;\n}\n\n.color-swatch-body {\n  position: relative;\n  left: 50%;\n  float: left;\n  padding: 10px 0;\n  -webkit-transform: translateX(-50%);\n  -ms-transform: translateX(-50%);\n  transform: translateX(-50%);\n}\n\n.color-swatch-body .prop-item-wrap {\n  float: left;\n  padding: 0 15px;\n  min-width: 65px;\n}\n\n.color-swatch-body .prop-item {\n  padding: 15px 0;\n}\n\n.color-swatch-body .prop-item .label {\n  font-size: 11px;\n  color: #62748c;\n  text-transform: uppercase;\n  line-height: 16px;\n}\n\n.color-swatch-body .prop-item .value {\n  font-size: 14px;\n}\n\n.table-colors {\n  font-weight: 600;\n  font-size: 16px;\n  width: 100%;\n}\n\n.table-colors td,\n.table-colors:first-child td,\n.table-colors td:first-child,\n.table-colors:first-child td:first-child,\n.table-colors td:last-child,\n.table-colors:first-child td:last-child {\n  background: rgba(255, 255, 255, 0.9);\n  border-bottom: 1px solid rgba(0, 0, 0, 0.1);\n  padding: 10px;\n}\n\n.table-colors tr:last-child td,\n.table-colors:first-child tr:last-child td {\n  border-bottom: none;\n}\n\n.table-colors td:nth-child(1),\n.table-colors:first-child td:nth-child(1) {\n  line-height: 40px;\n}\n\n.table-colors .swatch,\n.table-colors:first-child .swatch {\n  float: left;\n  height: 40px;\n  width: 40px;\n  margin-right: 20px;\n  display: inline-block;\n  border-radius: 4px;\n  border: 1px solid transparent;\n}\n\n.table-colors .swatch.is-light,\n.table-colors:first-child .swatch.is-light {\n  border-color: #c1c7d0;\n}\n\n.table-colors .lozenge,\n.table-colors:first-child .lozenge {\n  float: left;\n  margin: 5px 10px 0 0;\n  font-size: 10px;\n  display: inline-block;\n  text-transform: uppercase;\n  font-weight: 600;\n  background: #97a0af;\n  color: #042a53;\n  padding: 2px 4px;\n  line-height: 10px;\n  border-radius: 4px;\n  letter-spacing: 0.05em;\n}\n\n.ct-toc {\n  order: 2;\n  padding-top: 2rem;\n  padding-bottom: 1.5rem;\n  font-size: 0.875rem;\n}\n@supports (position: sticky) {\n  .ct-toc {\n    position: sticky;\n    top: 4rem;\n    height: calc(100vh - 4rem);\n    overflow-y: auto;\n  }\n}\n\n.section-nav {\n  padding-left: 0;\n  border-left: 1px solid #eee;\n}\n.section-nav ul {\n  padding-left: 1rem;\n}\n.section-nav ul ul {\n  display: none;\n}\n\n.toc-entry {\n  display: block;\n  font-size: 1rem;\n}\n.toc-entry a {\n  display: block;\n  padding: 0.125rem 1.5rem;\n  color: #99979c;\n  font-size: 90%;\n}\n.toc-entry a:hover {\n  color: #3ba371;\n  text-decoration: none;\n}\n\n.ct-sidebar {\n  order: 0;\n  border-bottom: 1px solid #e6ecf1;\n  background-color: #f5f7f9;\n}\n@media (min-width: 768px) {\n  .ct-sidebar {\n    border-right: 1px solid #e6ecf1;\n  }\n  @supports (position: sticky) {\n    .ct-sidebar {\n      position: sticky;\n      top: 4rem;\n      z-index: 1000;\n      height: calc(100vh - 4rem);\n    }\n  }\n}\n@media (min-width: 1200px) {\n  .ct-sidebar {\n    flex: 0 1 320px;\n  }\n}\n\n.ct-links {\n  padding-top: 2rem;\n  padding-bottom: 1rem;\n  margin-right: -15px;\n  margin-left: -15px;\n}\n@media (min-width: 768px) {\n  @supports (position: sticky) {\n    .ct-links {\n      max-height: calc(100vh - 5rem);\n      overflow-y: auto;\n    }\n  }\n}\n@media (min-width: 768px) {\n  .ct-links {\n    display: block !important;\n  }\n}\n\n.ct-search {\n  position: relative;\n  padding: 1rem 15px;\n  margin-right: -15px;\n  margin-left: -15px;\n  border-bottom: 1px solid rgba(0, 0, 0, 0.05);\n}\n.ct-search .form-control:focus {\n  border-color: rgb(94.4219594595, 204.0780405405, 151.35877079);\n  box-shadow: 0 0 0 3px rgba(94.4219594595, 204.0780405405, 151.35877079, 0.25);\n}\n\n.ct-search-docs-toggle {\n  line-height: 1;\n  color: #212529;\n}\n\n.ct-sidenav {\n  display: none;\n}\n\n.ct-toc-link {\n  display: block;\n  padding: 0.25rem 1.5rem;\n  font-weight: 600;\n  font-size: 0.875rem;\n  color: #0d2b3e;\n}\n.ct-toc-link:hover {\n  color: rgba(0, 0, 0, 0.85);\n  text-decoration: none;\n}\n\n.ct-toc-item.active {\n  margin-bottom: 1rem;\n}\n.ct-toc-item.active:not(:first-child) {\n  margin-top: 1rem;\n}\n.ct-toc-item.active > .ct-toc-link {\n  color: rgba(0, 0, 0, 0.85);\n}\n.ct-toc-item.active > .ct-toc-link:hover {\n  background-color: transparent;\n}\n.ct-toc-item.active > .ct-sidenav {\n  display: block;\n}\n\n.ct-sidebar .nav > li > a {\n  display: block;\n  padding: 0.25rem 1.5rem;\n  font-size: 84%;\n  color: #4c555a;\n}\n\n.ct-sidebar .nav > li > a:hover {\n  color: rgba(0, 0, 0, 0.85);\n  text-decoration: none;\n  background-color: transparent;\n}\n\n.ct-sidebar .nav > .active > a {\n  font-weight: 500;\n  color: #0099e5;\n  background-color: transparent;\n  padding-left: 2rem;\n  position: relative;\n}\n.ct-sidebar .nav > .active > a:before {\n  content: \"\";\n  position: absolute;\n  height: 16px;\n  width: 2px;\n  background-color: #0099e5;\n  top: 50%;\n  left: 1.5rem;\n  transform: translateY(-50%);\n}\n\n.ct-sidebar .nav > .active:hover > a {\n  color: #0099e5;\n}\n\n.scrollbar-inner {\n  height: 100%;\n}\n.scrollbar-inner:not(:hover) .scroll-element {\n  opacity: 0;\n}\n.scrollbar-inner .scroll-element {\n  transition: opacity 300ms;\n  margin-right: 2px;\n}\n.scrollbar-inner .scroll-element .scroll-bar,\n.scrollbar-inner .scroll-element .scroll-element_track {\n  transition: background-color 300ms;\n}\n.scrollbar-inner .scroll-element .scroll-element_track {\n  background-color: transparent;\n}\n.scrollbar-inner .scroll-element.scroll-y {\n  width: 3px;\n  right: 0;\n}\n.scrollbar-inner .scroll-element.scroll-x {\n  height: 3px;\n  bottom: 0;\n}\n\n.ct-footer {\n  font-size: 85%;\n  text-align: center;\n  background-color: #f7f7f7;\n}\n.ct-footer a {\n  font-weight: 500;\n  color: #525f7f;\n}\n.ct-footer a:hover, .ct-footer a:focus {\n  color: #3ba371;\n}\n.ct-footer p {\n  margin-bottom: 0;\n}\n@media (min-width: 576px) {\n  .ct-footer {\n    text-align: left;\n  }\n}\n\n.ct-footer-links {\n  padding-left: 0;\n  margin-bottom: 1rem;\n}\n.ct-footer-links li {\n  display: inline-block;\n}\n.ct-footer-links li + li {\n  margin-left: 1rem;\n}\n\n@keyframes spinner-border {\n  to {\n    transform: rotate(360deg);\n  }\n}\n.spinner-border {\n  display: inline-block;\n  width: 2rem;\n  height: 2rem;\n  vertical-align: text-bottom;\n  border: 0.25em solid currentColor;\n  border-right-color: transparent;\n  border-radius: 50%;\n  animation: 0.75s linear infinite spinner-border;\n}\n\n.spinner-border-sm {\n  width: 1rem;\n  height: 1rem;\n  border-width: 0.2em;\n}\n\n@keyframes spinner-grow {\n  0% {\n    transform: scale(0);\n  }\n  50% {\n    opacity: 1;\n    transform: none;\n  }\n}\n.spinner-grow {\n  display: inline-block;\n  width: 2rem;\n  height: 2rem;\n  vertical-align: text-bottom;\n  background-color: currentColor;\n  border-radius: 50%;\n  opacity: 0;\n  animation: 0.75s linear infinite spinner-grow;\n}\n\n.spinner-grow-sm {\n  width: 1rem;\n  height: 1rem;\n}\n\n@media (prefers-reduced-motion: reduce) {\n  .spinner-border,\n  .spinner-grow {\n    animation-duration: 1.5s;\n  }\n}\n/*!\n* https://github.com/YouCanBookMe/react-datetime\n*/\n.rdt {\n  position: relative;\n}\n.rdt .rdtPicker {\n  -webkit-transition: all 150ms linear;\n  -moz-transition: all 150ms linear;\n  -o-transition: all 150ms linear;\n  -ms-transition: all 150ms linear;\n  transition: all 150ms linear;\n  margin-top: -20px;\n  visibility: hidden;\n  display: block;\n  opacity: 0;\n}\n.rdt.rdtOpen .rdtPicker {\n  opacity: 1;\n  visibility: visible;\n  margin-top: 0;\n}\n\n.rdtPicker {\n  display: none;\n  position: absolute;\n  padding: 20px;\n  margin-top: 1px;\n  z-index: 99999 !important;\n  background: #fff;\n  border-radius: 0.375rem;\n  box-shadow: 0px 10px 50px 0px rgba(0, 0, 0, 0.2);\n  -webkit-background-clip: padding-box;\n  background-clip: padding-box;\n  min-width: 160px;\n}\n.rdtPicker:before {\n  display: inline-block;\n  position: absolute;\n  width: 0;\n  height: 0;\n  vertical-align: middle;\n  content: \"\";\n  top: -5px;\n  left: 10px;\n  right: auto;\n  color: #ffffff;\n  border-bottom: 0.4em solid;\n  border-right: 0.4em solid transparent;\n  border-left: 0.4em solid transparent;\n}\n.rdtPicker:after {\n  border-bottom: 0.4em solid #ffffff;\n  border-right: 0.4em solid transparent;\n  border-left: 0.4em solid transparent;\n  content: \"\";\n  display: inline-block;\n  position: absolute;\n  top: -5px;\n  left: 10px;\n}\n\n.rdtPicker {\n  display: block;\n  top: 40px;\n}\n\n.rdtStatic .rdtPicker {\n  box-shadow: none;\n  position: static;\n}\n\n.rdtPicker .rdtTimeToggle {\n  text-align: center;\n  padding: 10px;\n  border-radius: 4px;\n  visibility: hidden;\n  position: relative;\n}\n.rdtPicker .rdtTimeToggle:before {\n  visibility: visible;\n  width: 100%;\n  height: 100%;\n  border-radius: 3px;\n  position: absolute;\n  top: 0;\n  left: 0;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  font: normal normal normal 1em/1 \"Nucleo\";\n  font-size: 18px;\n  content: \"\\ea5e\";\n}\n\n.rdtPicker table {\n  width: 100%;\n  margin: 0;\n  border-color: #fff !important;\n}\n\n.rdtPicker td,\n.rdtPicker th {\n  text-align: center;\n  padding: 1px;\n}\n\n.rdtPicker td {\n  cursor: pointer;\n}\n\n.rdtDay {\n  font-size: 0.875rem;\n  width: 36px;\n  height: 36px;\n  transition: all 0.15s ease;\n  text-align: center;\n  border: none;\n  border-radius: 50%;\n}\n.rdtDay.rdtToday.rdtActive, .rdtDay.rdtActive, .rdtDay.rdtActive:hover, .rdtDay.start-date, .rdtDay.end-date, .rdtDay.middle-date, .rdtDay.start-date:hover, .rdtDay.end-date:hover, .rdtDay.middle-date:hover {\n  background-color: #278e69 !important;\n  color: #fff !important;\n}\n.rdtDay.start-date {\n  border-top-right-radius: 0;\n  border-bottom-right-radius: 0;\n}\n.rdtDay.middle-date {\n  border-radius: 0;\n}\n.rdtDay.end-date {\n  border-top-left-radius: 0;\n  border-bottom-left-radius: 0;\n}\n\n.rdtDays tr .dow {\n  text-align: center;\n  font-size: 12px;\n  font-weight: inherit;\n  padding-bottom: 5px;\n  padding-top: 10px;\n  font-weight: 300;\n  font-size: 0.875rem;\n  width: 20px;\n  height: 20px;\n}\n.rdtDays tr .rdtDay {\n  color: #525f7f;\n  font-size: 0.875rem;\n}\n.rdtDays tr .rdtDay.rdtOld, .rdtDays tr .rdtDay.rdtNew {\n  color: #adb5bd;\n  font-weight: 300;\n}\n\n.rdtPicker td.rdtDay:hover,\n.rdtPicker td.rdtHour:hover,\n.rdtPicker td.rdtMinute:hover,\n.rdtPicker td.rdtSecond:hover,\n.rdtPicker .rdtTimeToggle:hover,\n.rdtPicker .rdtTimeToggle:hover:before {\n  background: #eeeeee;\n  cursor: pointer;\n}\n\n.rdtPicker td.rdtToday {\n  position: relative;\n}\n\n.rdtPicker td.rdtActive.rdtToday:before {\n  border-bottom-color: #fff;\n}\n\n.rdtPicker td.rdtDisabled,\n.rdtPicker td.rdtDisabled:hover {\n  background: none;\n  color: #999999;\n  cursor: not-allowed;\n}\n\n.rdtPicker td span.rdtOld {\n  color: #999999;\n}\n\n.rdtPicker td span.rdtDisabled,\n.rdtPicker td span.rdtDisabled:hover {\n  background: none;\n  color: #999999;\n  cursor: not-allowed;\n}\n\n.rdtPicker tr .dow {\n  width: 14.2857%;\n  border-bottom: none;\n  font-size: 0.875rem;\n  width: 36px;\n  height: 36px;\n  transition: all 0.15s ease;\n  text-align: center;\n  border: none;\n  font-weight: 500;\n  border-radius: 0.375rem;\n}\n\n.rdtPicker th.rdtSwitch {\n  font-weight: 500;\n  border-radius: 0.375rem;\n  font-size: 0.875rem;\n  width: 145px;\n  height: 36px;\n  transition: all 0.15s ease;\n  text-align: center;\n  border: none;\n}\n\n.rdtPicker th.rdtNext,\n.rdtPicker th.rdtPrev {\n  font-size: 0.875rem;\n  width: 36px;\n  height: 36px;\n  transition: all 0.15s ease;\n  text-align: center;\n  border: none;\n  border-radius: 0.375rem;\n  cursor: pointer;\n}\n\n.rdtPicker .dow,\n.rdtPicker th.rdtSwitch,\n.rdtPicker th.rdtNext,\n.rdtPicker th.rdtPrev,\n.rdtPicker .rdtTimeToggle {\n  color: #525f7f;\n}\n\n.rdtPrev span,\n.rdtNext span {\n  display: block;\n  -webkit-touch-callout: none; /* iOS Safari */\n  -webkit-user-select: none; /* Chrome/Safari/Opera */\n  -khtml-user-select: none; /* Konqueror */\n  -moz-user-select: none; /* Firefox */\n  -ms-user-select: none; /* Internet Explorer/Edge */\n  user-select: none;\n}\n\n.rdtPicker th.rdtDisabled,\n.rdtPicker th.rdtDisabled:hover {\n  background: none;\n  color: #999999;\n  cursor: not-allowed;\n}\n\n.rdtPicker thead tr:first-child th {\n  cursor: pointer;\n}\n\n.rdtPicker thead tr:first-child th:hover {\n  background: #eeeeee;\n}\n\n.rdtPicker button {\n  border: none;\n  background: none;\n  cursor: pointer;\n}\n\n.rdtPicker button:hover {\n  background-color: #eee;\n}\n\n.rdtPicker thead button {\n  width: 100%;\n  height: 100%;\n}\n\ntd.rdtMonth,\ntd.rdtYear {\n  height: 50px;\n  width: 25%;\n  cursor: pointer;\n}\n\ntd.rdtMonth:hover,\ntd.rdtYear:hover {\n  background: #eee;\n}\n\n.rdtCounters {\n  display: inline-block;\n}\n\n.rdtCounters > div {\n  float: left;\n  width: 40px;\n  font-weight: inherit;\n  margin: 3px;\n  border-radius: 50%;\n}\n.rdtCounters .rdtCounterSeparator {\n  width: 0;\n  border: 1px solid transparent;\n}\n\n.rdtCounter {\n  height: 100px;\n}\n\n.rdtCounter {\n  width: 40px;\n}\n.rdtCounter .rdtCount {\n  padding: 7px;\n  height: 40px;\n  border: 1px solid transparent;\n}\n\n.rdtCounters .rdtCounter:last-child .rdtCount {\n  color: #278e69;\n  border-radius: 50%;\n  border: 1px solid #278e69;\n}\n\n.rdtCounterSeparator {\n  padding: 7px;\n  line-height: 100px;\n}\n\n.rdtCounter .rdtBtn {\n  line-height: 40px;\n  cursor: pointer;\n  display: block;\n  border-radius: 50%;\n  color: #adb5bd;\n  -webkit-transition: all 60ms ease-in;\n  -moz-transition: all 60ms ease-in;\n  -o-transition: all 60ms ease-in;\n  -ms-transition: all 60ms ease-in;\n  transition: all 60ms ease-in;\n  -webkit-touch-callout: none; /* iOS Safari */\n  -webkit-user-select: none; /* Chrome/Safari/Opera */\n  -khtml-user-select: none; /* Konqueror */\n  -moz-user-select: none; /* Firefox */\n  -ms-user-select: none; /* Internet Explorer/Edge */\n  user-select: none;\n}\n\n.rdtCounter .rdtBtn:hover {\n  background: #eee;\n  color: #797979;\n}\n\n.rdtCounter .rdtCount {\n  font-size: inherit;\n  line-height: 25px;\n}\n\n.rdtMilli {\n  vertical-align: middle;\n  padding-left: 8px;\n  width: 48px;\n}\n\n.rdtMilli input {\n  width: 100%;\n  font-size: inherit;\n  margin-top: 37px;\n}\n\n.rdtMonths,\n.rdtYears {\n  padding-bottom: 10px;\n}\n.rdtMonths .rdtMonth,\n.rdtMonths .rdtYear,\n.rdtYears .rdtMonth,\n.rdtYears .rdtYear {\n  display: inline-block;\n  width: 56px;\n  height: 56px;\n  line-height: 56px;\n  margin: 3px 3px;\n  cursor: pointer;\n  border-radius: 50%;\n  text-align: center;\n}\n.rdtMonths .rdtMonth.rdtActive, .rdtMonths .rdtMonth.start-date, .rdtMonths .rdtMonth.end-date, .rdtMonths .rdtMonth.middle-date,\n.rdtMonths .rdtYear.rdtActive,\n.rdtMonths .rdtYear.start-date,\n.rdtMonths .rdtYear.end-date,\n.rdtMonths .rdtYear.middle-date,\n.rdtYears .rdtMonth.rdtActive,\n.rdtYears .rdtMonth.start-date,\n.rdtYears .rdtMonth.end-date,\n.rdtYears .rdtMonth.middle-date,\n.rdtYears .rdtYear.rdtActive,\n.rdtYears .rdtYear.start-date,\n.rdtYears .rdtYear.end-date,\n.rdtYears .rdtYear.middle-date {\n  background-color: #278e69 !important;\n  color: #fff;\n}\n\n.input-group .input-group-prepend + .rdt .form-control {\n  border-top-left-radius: 0;\n  border-bottom-left-radius: 0;\n}\n\n.input-group .input-group-prepend + .rdt .form-control {\n  border-top-left-radius: 0;\n  border-bottom-left-radius: 0;\n}\n\n.input-group > .rdt:not(:last-child) .form-control {\n  border-top-right-radius: 0;\n  border-bottom-right-radius: 0;\n}\n\n.form-group .rdt {\n  width: 1%;\n  margin-bottom: 0;\n  flex: 1 1 auto;\n}\n\n.btn .btn-inner--icon {\n  margin-right: 4px;\n}\n\n.btn + .btn {\n  margin-left: 4px;\n}\n\nbutton:focus,\n:focus {\n  outline: none;\n}\n\n@keyframes show-navbar-dropdown {\n  0% {\n    opacity: 0;\n    transition: visibility 0.25s, opacity 0.25s;\n  }\n  100% {\n    opacity: 1;\n  }\n}\n.navbar .collapsing .navbar-toggler {\n  pointer-events: none;\n}\n\n.navbar .nav-item .nav-link-icon.nav-link i {\n  margin-right: 4px;\n}\n\n.table .avatar-group .avatar {\n  margin-right: 4px;\n}\n.table .badge i {\n  margin-right: 10px;\n}\n\n.s-table--content-list tr:last-child {\n  border-bottom: none !important;\n}\n\n.u-max-width--16 {\n  max-width: 1rem;\n}\n\n.u-flex--16 {\n  flex: 0 0 1rem;\n}\n\n.u-background--color-blue-1-1 {\n  background: #f3f9ff;\n}\n\n.u-min-height--53 {\n  min-height: 3.3125rem;\n}\n\n.u-width--5-p {\n  width: 5%;\n}\n.u-width--95-p {\n  width: 95%;\n}\n\n.u-cursor--pointer {\n  cursor: pointer;\n}\n\n@media all and (max-width: 1366px) {\n  ._u-font-size--12 {\n    font-size: 0.75rem;\n  }\n}\n.normal-user .left-column .left-inner {\n  max-width: 749px;\n  padding-top: 70px;\n  padding-left: 66px;\n  padding-right: 66px;\n  padding-bottom: 130px;\n}\n@media all and (max-width: 991px) {\n  .normal-user .left-column .left-inner {\n    padding-top: 35px;\n    padding-left: 16px;\n    padding-right: 16px;\n    padding-bottom: 65px;\n  }\n}\n@media all and (max-width: 991px) {\n  .normal-user .left-column .left-inner .radio-btn-wrap {\n    justify-content: space-between;\n  }\n}\n.normal-user .left-column .left-inner .radio-btn-wrap .mr-18 {\n  margin-right: 18px;\n}\n.normal-user .left-column .left-inner .radio-btn-wrap .mr-10 {\n  margin-right: 10px;\n}\n.normal-user .left-column .left-inner .radio-btn-wrap p {\n  color: #393939;\n  font-size: 15px;\n  font-weight: 400;\n  line-height: 22.5px;\n}\n.normal-user .left-column h2 {\n  font-size: 45px;\n  font-weight: 600;\n  line-height: 57px;\n  color: #393939;\n}\n.normal-user .left-column h2 span {\n  font-size: 18px;\n  font-weight: 400;\n  line-height: 27px;\n}\n.normal-user .left-column .form-inputs .input-field .input-wrapper input {\n  color: #717171;\n  border: 0;\n  border-bottom: 1px solid #b1b1b1;\n  width: 100%;\n  background: transparent;\n  padding: 0 0 8px 0;\n}\n.normal-user .left-column .form-inputs .input-field .input-wrapper .toggle-password-btn {\n  border: 0;\n  border-bottom: 1px solid #b1b1b1;\n  background: transparent;\n  padding: 0;\n  margin: 0;\n}\n.normal-user .left-column .form-inputs .input-field .input-wrapper .toggle-password-btn svg {\n  fill: #cc9752;\n}\n.normal-user .left-column .form-inputs label {\n  color: #393939;\n  font-size: 15px;\n  font-weight: 400;\n  line-height: 22.5px;\n}\n.normal-user .left-column .form-inputs label .image-container {\n  margin-left: 8px;\n  width: 14px;\n  height: 14px;\n}\n.normal-user .left-column .custom-checkbox {\n  display: flex;\n  align-items: center;\n}\n.normal-user .left-column .custom-checkbox input[type=checkbox] {\n  position: absolute;\n  opacity: 0;\n  width: 0;\n  height: 0;\n}\n.normal-user .left-column .custom-checkbox input[type=checkbox]:checked + .custom-checkbox-box {\n  background-color: #cc9752;\n  border-color: #cc9752;\n}\n.normal-user .left-column .custom-checkbox input[type=checkbox]:checked + .custom-checkbox-box .checkbox-icon {\n  display: flex;\n}\n.normal-user .left-column .custom-checkbox .custom-checkbox-box {\n  width: 18px;\n  height: 18px;\n  border: 1px solid #cc9752;\n  background: #fff;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  position: relative;\n  margin-right: 8px;\n  border-radius: 2px;\n  padding: 3px;\n  box-sizing: border-box;\n  transition: background-color 0.2s ease;\n  cursor: pointer;\n  margin-bottom: 0;\n}\n.normal-user .left-column .custom-checkbox .checkbox-icon {\n  color: #fff;\n  font-size: 14px;\n  display: none;\n}\n.normal-user .left-column .custom-checkbox .checkbox-label {\n  margin-left: 8px;\n  color: #393939;\n}\n.normal-user .left-column .custom-checkbox .checkbox-label .highlighted-text {\n  color: #cc9752;\n}\n.normal-user .left-column .btn.bordered {\n  border: 1px solid #cc9752;\n  font-size: 18px;\n  font-weight: 500;\n  line-height: 27px;\n  cursor: pointer;\n  padding-top: 13px;\n  padding-bottom: 13px;\n  padding-left: 50px;\n  padding-right: 50px;\n  border-radius: 24.5px;\n  background: transparent;\n  outline: 0;\n  color: #cc9752;\n  box-shadow: none;\n}\n.normal-user .left-column .btn.no-bordered.custom-btn-primary {\n  font-size: 18px;\n  font-weight: 500;\n  line-height: 27px;\n  cursor: pointer;\n  padding-top: 13px;\n  padding-bottom: 13px;\n  padding-left: 50px;\n  padding-right: 50px;\n  border-radius: 24.5px;\n  background: #cc9752;\n  border: 0;\n  outline: 0;\n  transition: background-color 0.3s ease, color 0.3s ease;\n  color: #fff;\n  box-shadow: none;\n}\n.normal-user .left-column .btn.no-bordered.custom-btn-primary:hover {\n  background: #cc9752;\n  box-shadow: none;\n}\n.normal-user .left-column .signup-link p {\n  font-size: 14px;\n  line-height: 21px;\n  font-weight: 400;\n  color: #393939;\n}\n.normal-user .left-column .signup-link a {\n  font-weight: 500;\n  color: #cc9752;\n}\n.normal-user .right-column img {\n  width: 100%;\n  height: 100%;\n  object-fit: cover;\n}\n\n.radio-button-container .custom-radio-input {\n  display: none;\n}\n.radio-button-container .custom-radio-input:checked + .custom-radio-label {\n  border: 2px solid #cc9752;\n  background-color: transparent;\n  box-shadow: none;\n}\n.radio-button-container .custom-radio-input:checked + .custom-radio-label .radio-button-text {\n  color: #cc9752;\n}\n.radio-button-container .custom-radio-input:checked + .custom-radio-label .outer-circle .inner-circle {\n  background-color: #cc9752;\n}\n.radio-button-container .custom-radio-label {\n  max-width: fit-content;\n  display: flex;\n  align-items: center;\n  background-color: #fff;\n  border: 2px solid transparent;\n  border-radius: 24.5px;\n  padding: 10px 32px;\n  box-shadow: 0 2px 4px rgba(127, 17, 224, 0.2);\n  cursor: pointer;\n  transition: all 0.2s ease;\n  margin-bottom: 0;\n}\n.radio-button-container .custom-radio-label .radio-button .outer-circle {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  width: 20px;\n  height: 20px;\n  border: 2px solid #cc9752;\n  border-radius: 50%;\n  margin-right: 8px;\n  position: relative;\n  transition: border-color 0.2s ease;\n}\n.radio-button-container .custom-radio-label .radio-button .outer-circle .inner-circle {\n  width: 10px;\n  height: 10px;\n  border-radius: 50%;\n  background-color: transparent;\n  transition: background-color 0.2s ease;\n}\n.radio-button-container .custom-radio-label .radio-button-text {\n  font-size: 15px;\n  font-weight: 400;\n  line-height: 22.5px;\n  color: #717171;\n}\n.radio-button-container .custom-radio-label:hover, .radio-button-container .custom-radio-label:active {\n  border: 2px solid #cc9752;\n  background-color: transparent;\n  box-shadow: none;\n}\n.radio-button-container .custom-radio-label:hover .radio-button-text, .radio-button-container .custom-radio-label:active .radio-button-text {\n  color: #cc9752;\n}\n\n.password-strength-container {\n  gap: 10px;\n}\n.password-strength-container .password-strength-indicator {\n  gap: 5px;\n}\n.password-strength-container .password-strength-indicator label {\n  display: flex;\n  margin-bottom: 0;\n}\n.password-strength-container .password-strength-indicator .line {\n  width: 40px;\n  height: 5px;\n  border-radius: 2px;\n  background-color: #c6bdaf;\n  transition: background-color 0.3s;\n  margin-left: 5px;\n  width: 40px;\n  height: 5px;\n  border-radius: 2px;\n  background-color: #c6bdaf; /* Default color */\n  transition: background-color 0.3s;\n}\n.password-strength-container .password-strength-indicator .line.filled {\n  background-color: #19b25f;\n}\n.password-strength-container .password-strength-indicator .strength-text {\n  font-weight: normal;\n  color: #19b25f;\n}\n\n.progress-container {\n  padding: 45px 33px;\n}\n.progress-container .step-wrapper {\n  z-index: 1;\n  position: relative;\n  margin-top: -21px;\n}\n.progress-container .step-wrapper ul {\n  list-style-type: none;\n  display: flex;\n}\n.progress-container .step-wrapper ul li {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  width: 236px;\n  text-align: center;\n  position: relative;\n}\n.progress-container .step-wrapper ul li::after {\n  content: \"\";\n  position: absolute;\n  width: 100%;\n  height: 2px;\n  background-color: #d9d9d9;\n  top: 24%;\n  left: -50%;\n  z-index: -1;\n}\n.progress-container .step-wrapper ul li:first-child::after {\n  content: none;\n}\n.progress-container .step-wrapper ul li .icon {\n  width: 40px;\n  height: 40px;\n  background-color: #f9f5ef;\n  border: 1px solid #717171;\n  outline: 5px solid #f9f5ef;\n  border-radius: 50%;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n}\n.progress-container .step-wrapper ul li .icon span {\n  width: 100%;\n  height: 100%;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n}\n.progress-container .step-wrapper ul li .icon span svg {\n  width: 14px;\n  height: auto;\n}\n.progress-container .step-wrapper ul li .text {\n  color: #717171;\n}\n.progress-container .step-wrapper ul li.active::after {\n  background-color: #42826c;\n}\n.progress-container .step-wrapper ul li.active .icon {\n  background-color: #42826c;\n}\n.progress-container .step-wrapper ul li.active .icon span svg {\n  stroke: #fff;\n}\n.progress-container .step-wrapper ul li.active .text {\n  color: #42826c;\n}\n.progress-container .step-wrapper ul li:nth-child(1) .icon span svg {\n  fill: #fff;\n}\n\n.dob-picker-container h2.react-datepicker__current-month {\n  font-size: 16px;\n}\n.dob-picker-container .dob-picker-label {\n  display: block;\n}\n.dob-picker-container .dob-picker-input-wrapper {\n  position: relative;\n}\n.dob-picker-container .dob-picker-input-wrapper .react-datepicker-wrapper {\n  width: 100%;\n}\n.dob-picker-container .dob-picker-input-wrapper .react-datepicker-wrapper .dob-picker-input {\n  background: transparent;\n  color: #717171;\n  border: 0;\n  border-bottom: 1px solid #b1b1b1;\n  width: 100%;\n  background: transparent;\n  padding: 0 0 8px 0;\n}\n.dob-picker-container .dob-picker-input-wrapper .dob-picker-icon {\n  position: absolute;\n  right: 0;\n  top: 45%;\n  transform: translateY(-50%);\n  font-size: 18px;\n  cursor: pointer;\n}\n.dob-picker-container .dob-picker-input-wrapper svg {\n  fill: #cc9752;\n}\n\n.dropdown-custom {\n  display: flex;\n  flex-direction: column;\n  width: 200px;\n}\n.dropdown-custom .dropdown-title-custom {\n  color: #393939;\n  font-size: 15px;\n  font-weight: 400;\n  line-height: 22.5px;\n}\n.dropdown-custom .dropdown-container-custom {\n  position: relative;\n  display: flex;\n  align-items: center;\n  cursor: pointer;\n  background: transparent;\n  color: #717171;\n  border: 0;\n  border-bottom: 1px solid #b1b1b1;\n  width: 100%;\n  background: transparent;\n  padding: 0 0 8px 0;\n}\n.dropdown-custom .dropdown-container-custom .dropdown-selected-custom {\n  flex: 1;\n}\n.dropdown-custom .dropdown-container-custom .dropdown-arrow {\n  margin-left: 8px;\n  width: 18px;\n  height: 18px;\n}\n.dropdown-custom .dropdown-container-custom .dropdown-arrow svg {\n  width: 18px;\n  height: 18px;\n  fill: #333333;\n}\n.dropdown-custom .dropdown-menu-custom {\n  position: absolute;\n  top: 40px;\n  left: 0;\n  right: 0;\n  border: 1px solid #ccc;\n  border-top: none;\n  background-color: #fff;\n  box-shadow: 0px 4px 8px rgba(0, 0, 0, 0.1);\n  border-radius: 4px;\n  z-index: 1000;\n  width: 100%;\n}\n.dropdown-custom .dropdown-menu-custom .dropdown-option-custom {\n  padding: 8px;\n  cursor: pointer;\n}\n.dropdown-custom .dropdown-menu-custom .dropdown-option-custom:hover {\n  background-color: #f0f0f0;\n}\n\n.dropdown-numbers {\n  display: flex;\n  flex-direction: column;\n}\n.dropdown-numbers .dropdown-title-custom {\n  color: #393939;\n  font-size: 15px;\n  font-weight: 400;\n  line-height: 22.5px;\n}\n.dropdown-numbers .dropdown-container-custom {\n  position: relative;\n  display: flex;\n  align-items: center;\n  cursor: pointer;\n  background: transparent;\n  color: #717171;\n  border: 0;\n  border-bottom: 1px solid #b1b1b1;\n  width: 100%;\n  background: transparent;\n  padding: 0 0 8px 0;\n}\n.dropdown-numbers .dropdown-container-custom .input {\n  width: 100%;\n  cursor: text;\n}\n.dropdown-numbers .dropdown-container-custom .input input {\n  width: 100%;\n  cursor: text;\n}\n.dropdown-numbers .dropdown-container-custom .dropdown-selected-custom {\n  flex: 1;\n}\n.dropdown-numbers .dropdown-container-custom .dropdown-arrow {\n  margin-left: 0;\n  width: 18px;\n  height: 18px;\n}\n.dropdown-numbers .dropdown-container-custom .dropdown-arrow svg {\n  width: 18px;\n  height: 18px;\n  fill: #333333;\n}\n.dropdown-numbers .dropdown-menu-custom {\n  position: absolute;\n  top: 100%;\n  left: 0;\n  right: 0;\n  border: 1px solid #ccc;\n  border-top: none;\n  background-color: #fff;\n  box-shadow: 0px 4px 8px rgba(0, 0, 0, 0.1);\n  border-radius: 4px;\n  z-index: 1000;\n}\n.dropdown-numbers .dropdown-menu-custom .dropdown-option-custom {\n  padding: 8px;\n  cursor: pointer;\n}\n.dropdown-numbers .dropdown-menu-custom .dropdown-option-custom:hover {\n  background-color: #f0f0f0;\n}\n\ninput[type=number]::-webkit-inner-spin-button,\ninput[type=number]::-webkit-outer-spin-button,\ninput[type=number] {\n  -webkit-appearance: none;\n  -moz-appearance: textfield;\n  margin: 0;\n  border: 0;\n  outline: 0;\n  box-shadow: none;\n  background-color: transparent;\n  cursor: default;\n}\n\n.upload-btn .title {\n  font-size: 15px;\n  font-weight: 400;\n  line-height: 22.5px;\n  text-align: left;\n  color: #393939;\n}\n.upload-btn .upload-box {\n  background-image: repeating-linear-gradient(0deg, #beb5a6, #beb5a6 6px, transparent 6px, transparent 12px, #beb5a6 12px), repeating-linear-gradient(90deg, #beb5a6, #beb5a6 6px, transparent 6px, transparent 12px, #beb5a6 12px), repeating-linear-gradient(180deg, #beb5a6, #beb5a6 6px, transparent 6px, transparent 12px, #beb5a6 12px), repeating-linear-gradient(270deg, #beb5a6, #beb5a6 6px, transparent 6px, transparent 12px, #beb5a6 12px);\n  background-size: 2px 100%, 100% 2px, 2px 100%, 100% 2px;\n  background-position: 0 0, 0 0, 100% 0, 0 100%;\n  background-repeat: no-repeat;\n  border-radius: 4px;\n}\n.upload-btn .upload-box .upload-wrapper {\n  position: relative;\n}\n.upload-btn .upload-box .upload-wrapper svg {\n  width: 22px;\n  height: 22px;\n  stroke: #cc9752;\n}\n.upload-btn .upload-box .upload-wrapper p span {\n  color: #393939;\n}\n.upload-btn .upload-box .upload-wrapper input.hidden-file {\n  opacity: 0;\n  width: 1005;\n  height: 100%;\n  position: absolute;\n  top: 0;\n  left: 0;\n  cursor: pointer;\n}\n.upload-btn .upload-box .signature-wrap .container {\n  max-height: 108px;\n}\n.upload-btn .upload-box .signature-wrap canvas {\n  width: 100%;\n  height: 100%;\n}\n\n.popup-container {\n  position: fixed;\n  top: 0;\n  left: 0;\n  left: 0;\n  bottom: 0;\n  width: 100vw;\n  height: 100%;\n  background: rgba(0, 0, 0, 0.5);\n  z-index: 1000;\n}\n.popup-container .close {\n  position: absolute;\n  top: 24px;\n  right: 34px;\n  opacity: 1;\n}\n.popup-container .close svg {\n  width: 34px;\n  height: 34px;\n  stroke: #393939;\n  cursor: pointer;\n}\n.popup-container .popupWrapper {\n  max-width: 525px;\n  max-height: 422px;\n  border-radius: 10px;\n  background-color: #fff;\n  position: relative;\n}\n.popup-container .popupWrapper .popup .icon {\n  background-color: #42826c;\n  width: 54px;\n  height: 54px;\n  border-radius: 50%;\n  box-sizing: border-box;\n}\n.popup-container .popupWrapper .popup .icon svg {\n  stroke: #fff;\n}\n.popup-container .popupWrapper .popup h2 {\n  font-size: 28px;\n  font-weight: 700;\n  line-height: 42px;\n  text-align: center;\n  color: #42826c;\n}\n.popup-container .popupWrapper .popup .light-text {\n  font-size: 15px;\n  font-weight: 400;\n  line-height: 26px;\n  color: #717171;\n  text-align: center;\n}\n.popup-container .popupWrapper .popup .dark-text {\n  max-width: 427px;\n  font-size: 15px;\n  font-weight: 400;\n  line-height: 26px;\n  color: #393939;\n  text-align: center;\n}\n.popup-container .popupWrapper .popup .btn.no-bordered.custom-btn-primary {\n  max-width: 318px;\n  font-size: 18px;\n  font-weight: 500;\n  line-height: 27px;\n  cursor: pointer;\n  padding-top: 13px;\n  padding-bottom: 13px;\n  border-radius: 24.5px;\n  background: #cc9752;\n  border: 0;\n  outline: 0;\n  transition: background-color 0.3s ease, color 0.3s ease;\n  color: #fff;\n  box-shadow: none;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n}\n.popup-container .popupWrapper .popup .btn.no-bordered.custom-btn-primary:hover {\n  background: #cc9752;\n  box-shadow: none;\n}\n.popup-container .popupWrapper .popup .signup-link p {\n  font-size: 14px;\n  line-height: 21px;\n  font-weight: 400;\n  color: #393939;\n}\n.popup-container .popupWrapper .popup .signup-link a {\n  font-weight: 500;\n  color: #cc9752;\n}\n\n.normal-user.signup-user .left-column .left-inner {\n  padding-bottom: 70px;\n}\n.normal-user.signup-user .left-column .left-inner h3 {\n  font-size: 18px;\n  font-weight: 600;\n  line-height: 27px;\n  color: #393939;\n}\n.normal-user.signup-user .left-column .left-inner .sub-head {\n  font-size: 15px;\n  font-weight: 600;\n  line-height: 22.5px;\n  color: #333333;\n}\n.normal-user.signup-user .left-column .left-inner .mdl {\n  padding-left: 15px;\n  padding-right: 15px;\n  margin-top: 35px;\n}\n.normal-user.signup-user .left-column .form-inputs .input-field .input-wrapper {\n  position: relative;\n}\n.normal-user.signup-user .left-column .form-inputs .input-field .input-wrapper input[type=date]::-webkit-calendar-picker-indicator {\n  visibility: visible;\n  opacity: 0;\n}\n.normal-user.signup-user .left-column .form-inputs .input-field .input-wrapper .date-btn {\n  border: 0;\n  background: transparent;\n  padding: 0;\n  margin: 0;\n  position: absolute;\n  right: 0;\n  top: 0;\n  font-size: 18px;\n  pointer-events: none;\n  cursor: pointer;\n}\n.normal-user.signup-user .left-column .form-inputs .input-field .input-wrapper .date-btn svg {\n  fill: #cc9752;\n}\n\n.bordered {\n  border: 1px solid #cc9752;\n  font-size: 16px;\n  font-weight: 500;\n  line-height: 27px;\n  cursor: pointer;\n  padding-top: 13px;\n  padding-bottom: 13px;\n  padding-left: 38px;\n  padding-right: 38px;\n  border-radius: 24.5px;\n  background: transparent;\n  outline: 0;\n  color: #cc9752;\n  box-shadow: none;\n}\n.bordered:hover {\n  background: #cc9752;\n  box-shadow: none;\n  color: #fff;\n}\n\n.no-bordered {\n  font-size: 16px;\n  font-weight: 500;\n  line-height: 27px;\n  cursor: pointer;\n  padding-top: 13px;\n  padding-bottom: 13px;\n  padding-left: 20px;\n  padding-right: 20px;\n  border-radius: 24.5px;\n  background: #cc9752;\n  border: 0;\n  outline: 0;\n  transition: background-color 0.3s ease, color 0.3s ease;\n  color: #fff;\n  box-shadow: none;\n}\n.no-bordered:hover {\n  background: #cc9752;\n  box-shadow: none;\n  color: #fff;\n}\n\n.update {\n  border: 0;\n  outline: 0;\n  background-color: transparent;\n  padding: 0;\n}\n.update p {\n  font-size: 15px;\n  font-weight: 500;\n  line-height: 22.5px;\n  color: #cc9752;\n}\n.update svg {\n  width: 14px;\n  height: 14px;\n  fill: #cc9752;\n}\n\n.dashboard-sidebar {\n  background-color: #42826c;\n  max-width: 258px;\n  position: fixed;\n  width: 258px;\n  height: 100vh;\n  padding-top: 30px;\n  transition: 0.5s all;\n}\n.dashboard-sidebar .logo img {\n  max-width: 123px;\n}\n.dashboard-sidebar .dashboard-items {\n  height: 100%;\n  overflow-y: auto;\n}\n.dashboard-sidebar .dashboard-items ul li {\n  position: relative;\n  height: 55px;\n  cursor: pointer;\n  color: #fff;\n}\n.dashboard-sidebar .dashboard-items ul li p {\n  font-size: 15px;\n  font-weight: 400;\n  line-height: 24px;\n}\n.dashboard-sidebar .dashboard-items ul li svg {\n  stroke: #eed7b9;\n  stroke: #eed7b9;\n  width: 16px;\n  height: 16px;\n}\n.dashboard-sidebar .dashboard-items ul li .drop-icon {\n  width: 20px;\n  height: 20px;\n  position: absolute;\n  top: 18px;\n  right: 5px;\n}\n.dashboard-sidebar .dashboard-items ul li:hover {\n  background-color: #36745e;\n}\n.dashboard-sidebar .dashboard-items ul li:hover svg {\n  stroke: #fff;\n}\n.dashboard-sidebar .dashboard-items ul li.active {\n  background-color: #36745e;\n}\n.dashboard-sidebar .dashboard-items ul li.active svg {\n  stroke: #fff;\n}\n.dashboard-sidebar .dashboard-items ul li.active ul.sub-menu {\n  display: block;\n  margin-top: 10px;\n}\n.dashboard-sidebar .dashboard-items ul li ul.sub-menu {\n  display: none;\n}\n.dashboard-sidebar .dashboard-items ul li ul.sub-menu li {\n  color: #9cdac4;\n  background-color: transparent;\n  padding: 0;\n  height: auto;\n  padding: 10px 0;\n}\n.dashboard-sidebar .dashboard-items ul li ul.sub-menu li p {\n  font-size: 13px;\n  font-weight: 400;\n  line-height: 19.5px;\n}\n.dashboard-sidebar .dashboard-items ul li ul.sub-menu li.active {\n  font-size: 13px;\n  font-weight: 400;\n  line-height: 19.5px;\n  color: #fff;\n}\n.dashboard-sidebar .expand-btn {\n  position: absolute;\n  top: 0;\n  right: 0;\n  background-color: transparent !important;\n  padding: 0;\n  border: none;\n  font-size: 26px;\n  box-shadow: none;\n  color: #fff !important;\n}\n.dashboard-sidebar .expand-btn:active {\n  color: #fff;\n  background-color: transparent;\n  border-color: none;\n}\n.dashboard-sidebar.halfsidebar .dashboard-items ul li.active ul.sub-menu {\n  margin-top: 5px;\n}\n.dashboard-sidebar.halfsidebar .dashboard-items ul li.active ul.sub-menu li {\n  padding: 5px 0 !important;\n}\n.dashboard-sidebar.halfsidebar .dashboard-items ul li.active ul.sub-menu li p {\n  display: block;\n  visibility: visible;\n  padding-left: 0 !important;\n  text-align: center;\n}\n\n.topbar .left {\n  font-size: 25px;\n  font-weight: 600;\n  line-height: 37.5px;\n  color: #393939;\n}\n.topbar .right .wallet > svg {\n  width: 18px;\n  height: 18px;\n  stroke: #393939;\n}\n.topbar .right .notified {\n  position: relative;\n}\n.topbar .right .notified::after {\n  content: \"\";\n  width: 6px;\n  height: 6px;\n  border-radius: 50%;\n  background-color: #ff0000;\n  position: absolute;\n  top: 5px;\n  right: 3px;\n  border: 1px solid #fff;\n}\n.topbar .right .notified svg {\n  width: 18px;\n  height: 18px;\n  fill: #393939;\n}\n.topbar .right .user {\n  cursor: pointer;\n}\n.topbar .right .user .user-pic {\n  width: 34px;\n  height: 34px;\n  border-radius: 50%;\n  border: 2px solid #42826c;\n  overflow: hidden;\n}\n.topbar .right .user .user-pic img {\n  object-fit: cover;\n  width: 30px;\n  height: 30px;\n}\n.topbar .right .user p {\n  font-size: 13px;\n  font-weight: 400;\n  line-height: 24px;\n  color: #393939;\n}\n.topbar .right .user .icon {\n  stroke: #333333;\n  width: 36px;\n  height: 20px;\n}\n\n.user-bar {\n  background-color: #f9f5ef;\n  border-radius: 4px;\n}\n.user-bar .title {\n  font-size: 20px;\n  font-weight: 400;\n  line-height: 30px;\n  color: #393939;\n}\n.user-bar .title span {\n  font-weight: 600;\n}\n.user-bar .item {\n  margin: 0 10px 10px 0;\n}\n@media (min-width: 768px) {\n  .user-bar .item {\n    margin: 0;\n  }\n}\n.user-bar .item .title {\n  font-size: 13px;\n  font-weight: 400;\n  line-height: 19.5px;\n  text-align: left;\n  color: #717171;\n}\n.user-bar .item .text {\n  font-size: 15px;\n  font-weight: 600;\n  line-height: 22.5px;\n  color: #393939;\n}\n.user-bar .item .text.email {\n  color: #cc9752;\n  font-weight: 400;\n}\n.user-bar .buttons .bordered,\n.user-bar .buttons .thick-border {\n  font-size: 14px;\n  font-weight: 500;\n  width: 141px;\n  padding: 8px 0;\n  border: 2px solid #cc9752;\n}\n.user-bar .buttons .no-bordered {\n  font-size: 15px;\n  font-weight: 500;\n  width: 159px;\n  padding-left: 0;\n  padding-right: 0;\n}\n\n.card-box {\n  border-radius: 4px;\n}\n@media (min-width: 768px) {\n  .card-box {\n    max-width: 360px;\n  }\n}\n.card-box.shade-green {\n  background-color: #008983;\n}\n.card-box.shade-blue {\n  background-color: #0f7db5;\n}\n.card-box .date-dropdown .date-btn {\n  position: relative;\n}\n.card-box .date-dropdown .date-btn input {\n  width: 20px;\n  height: 20px;\n  position: absolute;\n  top: 4px;\n  right: 0;\n  opacity: 0;\n}\n.card-box .date-dropdown .date-btn .date-output p {\n  color: #fff;\n  font-size: 13px;\n  font-weight: 500;\n  line-height: 19.5px;\n}\n.card-box .date-dropdown .date-btn .date-output svg {\n  fill: #fff;\n  width: 18px;\n  height: 18px;\n  cursor: pointer;\n}\n.card-box .title {\n  font-size: 14px;\n  font-weight: 400;\n  line-height: 21px;\n  color: #fff;\n}\n.card-box .content {\n  font-size: 30px;\n  font-weight: 700;\n  line-height: 1.2;\n  color: #fff;\n}\n@media (min-width: 992px) {\n  .card-box .content {\n    font-size: 40px;\n    line-height: 1.5;\n  }\n}\n\n.chart-graph .chart-inner {\n  box-shadow: 0px 2px 8px 0px rgba(156, 156, 156, 0.25);\n  border-radius: 5px;\n  padding-top: 20px;\n  padding-bottom: 20px;\n}\n.chart-graph .chart-inner .title {\n  font-size: 16px;\n  font-weight: 400;\n  line-height: 24px;\n  color: #393939;\n}\n.chart-graph .chart-inner .ammount {\n  font-size: 28px;\n  font-weight: 700;\n  line-height: 42px;\n  color: #42826c;\n}\n.chart-graph .chart-inner .recharts-responsive-container .recharts-wrapper .recharts-surface {\n  width: unset !important;\n  max-height: 178px;\n  overflow: visible;\n}\n.chart-graph .chart-inner .recharts-responsive-container .recharts-wrapper .recharts-surface .recharts-rectangle {\n  pointer-events: none;\n  fill: transparent;\n}\n.chart-graph .chart-inner .recharts-responsive-container .recharts-wrapper .recharts-surface .recharts-rectangle:hover {\n  fill: transparent;\n}\n.chart-graph .chart-inner .recharts-responsive-container .recharts-wrapper .recharts-surface .recharts-layer line {\n  display: none;\n}\n.chart-graph .chart-inner .recharts-responsive-container .recharts-wrapper .recharts-surface .recharts-layer .recharts-cartesian-axis-ticks .recharts-layer text {\n  font-size: 12px;\n  font-weight: 300;\n  line-height: 18px;\n  color: #777777;\n}\n.chart-graph .chart-inner .recharts-responsive-container .recharts-wrapper .recharts-surface .recharts-layer .xAxisLabel {\n  fill: #353535;\n  font-size: 13px;\n  font-weight: 400;\n  line-height: 19.5px;\n  text-anchor: middle;\n  transform-origin: 332px 210px;\n  transform: rotate(0deg);\n}\n.chart-graph .chart-inner .recharts-responsive-container .recharts-wrapper .recharts-surface .recharts-layer .yAxisLabel {\n  fill: #353535;\n  font-size: 13px;\n  font-weight: 400;\n  line-height: 19.5px;\n  transform: rotate(-90deg);\n  transform-origin: 29px 102px;\n  text-anchor: middle;\n}\n\n/* src/DatePicker.css */\n.datepicker {\n  position: relative;\n  display: inline-block;\n  font-family: Arial, sans-serif;\n}\n\n.datepicker-display {\n  display: flex;\n  align-items: center;\n  cursor: pointer;\n  padding: 10px;\n  border: 1px solid #ccc;\n  border-radius: 4px;\n  background-color: #fff;\n}\n\n.dropdown-icon {\n  margin-left: 8px;\n  color: #333;\n}\n\n.datepicker-calendar {\n  position: absolute;\n  top: 100%;\n  left: 0;\n  width: 100%;\n  border: 1px solid #ccc;\n  border-radius: 4px;\n  background-color: #fff;\n  z-index: 1000;\n  padding: 10px;\n}\n\n.dashboard-drop .dropdown-container-custom {\n  border: 2px solid #d9d9d9;\n  border-radius: 500px;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  padding: 10px 20px;\n  box-sizing: border-box;\n  max-width: 169px;\n  font-size: 13px;\n  font-weight: 400;\n  line-height: 19.5px;\n  color: #717171;\n}\n.dashboard-drop .dropdown-container-custom .dropdown-arrow {\n  display: flex;\n  align-items: center;\n}\n\n.dashboard-table .dashboard-table-title p {\n  font-size: 25px;\n  font-weight: 600;\n  line-height: 37.5px;\n  color: #393939;\n}\n.dashboard-table .search-group {\n  border: 0;\n  border-bottom: 1px solid #717171;\n}\n@media (min-width: 1200px) {\n  .dashboard-table .search-group {\n    max-width: 309px;\n  }\n}\n.dashboard-table .search-group svg {\n  width: 13px;\n  height: 13px;\n}\n.dashboard-table .search-group input {\n  border: 0;\n  outline: 0;\n  box-shadow: none;\n  width: calc(100% - 13px);\n  height: 100%;\n  font-size: 13px;\n  font-weight: 400;\n  line-height: 19.5px;\n  color: #797979;\n}\n.dashboard-table .search-group input:focus {\n  outline: 0;\n  box-shadow: 0;\n}\n.dashboard-table .sort label {\n  font-size: 13px;\n  font-weight: 400;\n  line-height: 23px;\n  color: #393939;\n}\n.dashboard-table .sort .dark-text {\n  max-width: fit-content;\n}\n.dashboard-table .sort .dark-text .dropdown-container-custom {\n  padding: 8px 15px;\n}\n.dashboard-table .sort .dark-text .dropdown-container-custom .dropdown-selected-custom {\n  font-size: 13px;\n  font-weight: 700;\n  line-height: 23px;\n  color: #393939;\n}\n.dashboard-table .btn-teller .no-bordered {\n  width: 119px;\n  padding-left: 26px;\n  padding-right: 26px;\n  font-size: 13px;\n  line-height: 19.5px;\n  font-weight: 500;\n}\n.dashboard-table .table thead {\n  -webkit-box-shadow: 0px 2px 9px 0px rgba(154, 154, 154, 0.25);\n  -moz-box-shadow: 0px 2px 9px 0px rgba(154, 154, 154, 0.25);\n  box-shadow: 0px 2px 9px 0px rgba(154, 154, 154, 0.25);\n}\n.dashboard-table .table thead th {\n  text-align: center;\n  font-size: 15px;\n  font-weight: 600;\n  line-height: 22.5px;\n  color: #393939;\n  text-transform: capitalize;\n}\n.dashboard-table .table tbody tr {\n  border-bottom: 1px solid #e6e6e6;\n}\n.dashboard-table .table tbody tr td {\n  text-align: center;\n  font-size: 15px;\n  font-weight: 400;\n  line-height: 22.5px;\n  color: #393939;\n  vertical-align: middle;\n  border-top: none;\n  padding: 10px;\n}\n.dashboard-table .table tbody tr td.green-color {\n  color: #06b863;\n}\n.dashboard-table .table tbody tr td.grey-color {\n  color: #717171;\n}\n.dashboard-table .table tbody tr td svg {\n  width: 17px;\n  height: 17px;\n}\n.dashboard-table .table tbody tr td.text-center {\n  text-align: center;\n  display: flex;\n  justify-content: center;\n}\n.dashboard-table .table tbody tr td.action button {\n  border: 0;\n  outline: 0;\n  background-color: transparent;\n  cursor: pointer;\n}\n.dashboard-table .table tbody tr td.action button:nth-child(2) {\n  margin-left: 4px;\n}\n.dashboard-table .teller-table img.name-img {\n  width: 31px;\n  height: 31px;\n}\n.dashboard-table .teller-table .colored {\n  color: #cc9752;\n}\n\n.btn-status {\n  border-radius: 500px;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  padding: 7px 21px;\n  max-width: 126px;\n  min-width: 126px;\n  cursor: pointer;\n}\n.btn-status.btn-green {\n  border: 1px solid #6ab199;\n  background-color: #dcf4ec;\n  color: #656565;\n}\n.btn-status.btn-red {\n  border: 1px solid #d65d43;\n  background-color: #f4e3dc;\n  color: #d65d43;\n}\n.btn-status.btn-orange {\n  border: 1px solid #cc9752;\n  background-color: #f4f3e5;\n  color: #cc9752;\n}\n.btn-status.btn-olive {\n  border: 1px solid #757536;\n  background-color: #f2fcd3;\n  color: #757536;\n}\n\n.pagination {\n  display: flex;\n  justify-content: flex-end;\n}\n.pagination .paginate-inner {\n  display: flex;\n  justify-content: flex-end;\n}\n.pagination .paginate-inner button.paginateButton {\n  background-color: transparent;\n  cursor: pointer;\n  width: 30px;\n  height: 30px;\n  border: 0;\n  outline: 0;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  color: #393939;\n}\n.pagination .paginate-inner button.paginateButton.active {\n  background-color: #cc9752;\n  width: 30px;\n  height: 30px;\n  border-radius: 3px;\n  color: #fff;\n}\n.pagination .paginate-inner button.paginateButton svg.orange-class {\n  fill: #cc9752;\n}\n.pagination .paginate-inner button.paginateButton svg.grey-class {\n  fill: #717171;\n}\n\n.form-inputs .input-field .input-wrapper input {\n  color: #717171;\n  border: 0;\n  border-bottom: 1px solid #b1b1b1;\n  width: 100%;\n  background: transparent;\n  padding: 0 0 8px 0;\n}\n.form-inputs .input-field .input-wrapper .toggle-password-btn {\n  border: 0;\n  border-bottom: 1px solid #b1b1b1;\n  background: transparent;\n  padding: 0;\n  margin: 0;\n}\n.form-inputs .input-field .input-wrapper .toggle-password-btn svg {\n  fill: #cc9752;\n}\n.form-inputs label {\n  color: #393939;\n  font-size: 15px;\n  font-weight: 400;\n  line-height: 22.5px;\n}\n.form-inputs label .image-container {\n  margin-left: 8px;\n  width: 14px;\n  height: 14px;\n}\n\n.card-number-input label {\n  margin-bottom: 0;\n}\n.card-number-input .card-number-fields input {\n  border: 0;\n  outline: 0;\n  border-bottom: 1px solid #7e8f8a;\n  border-radius: 0;\n  text-align: center;\n  padding-bottom: 9px;\n  padding-top: 0;\n  font-size: 14px;\n  font-weight: 400;\n  line-height: 21px;\n  letter-spacing: 3px;\n  color: #717171;\n  background: transparent;\n}\n.card-number-input .card-number-fields input:not(:last-child) {\n  margin-right: 16px;\n}\n.card-number-input .card-number-fields input::placeholder {\n  color: #717171;\n  font-size: 14px;\n}\n\n.recharge-account {\n  padding-left: 15px;\n  padding-right: 15px;\n}\n.recharge-account .tabs {\n  border-bottom: 1px solid #d8d8d8;\n  padding-top: 20px;\n}\n.recharge-account .tabs button {\n  border: 0;\n  outline: 0;\n  background-color: transparent;\n  font-size: 15px;\n  font-weight: 400;\n  line-height: 22.5px;\n  color: #717171;\n}\n.recharge-account .tabs button.active {\n  color: #717171;\n  color: #cc9752;\n  font-weight: 500;\n}\n.recharge-account .recharge-bar {\n  background-color: #f9f5ef;\n  border-radius: 4px;\n  padding: 24px 33px;\n}\n.recharge-account .recharge-bar .item .title {\n  font-size: 20px;\n  font-weight: 600;\n  line-height: 30px;\n  color: #393939;\n}\n.recharge-account .recharge-bar .item .text {\n  font-size: 13px;\n  font-weight: 400;\n  line-height: 19.5px;\n  color: #717171;\n}\n.recharge-account .recharge-bar .buttons .price {\n  font-size: 30px;\n  font-weight: 700;\n  line-height: 45px;\n  color: #42826c;\n  margin-right: 26px;\n}\n.recharge-account .recharge-bar .buttons .bordered,\n.recharge-account .recharge-bar .buttons .thick-border {\n  font-size: 15px;\n  font-weight: 500;\n  width: 141px;\n  padding-left: 0;\n  padding-right: 0;\n  border: 2px solid #cc9752;\n}\n.recharge-account .recharge-bar .buttons .no-bordered {\n  font-size: 15px;\n  font-weight: 500;\n  width: 159px;\n  padding-left: 0;\n  padding-right: 0;\n}\n.recharge-account .recharge-form {\n  box-shadow: 0px 2px 8px 0px rgba(156, 156, 156, 0.25);\n  border: 1px solid #e3e3e3;\n  padding: 40px;\n  box-sizing: border-box;\n  border-radius: 5px;\n  margin-top: 29px;\n}\n.recharge-account .recharge-form p.title {\n  font-size: 20px;\n  font-weight: 600;\n  line-height: 30px;\n  color: #393939;\n}\n.recharge-account .recharge-form .methods {\n  padding-top: 32px;\n}\n.recharge-account .recharge-form .methods p {\n  font-size: 15px;\n  font-weight: 400;\n  line-height: 22.5px;\n  color: #5e5e5e;\n}\n.recharge-account .recharge-form .methods .recharge-radio .radio-button .outer-circle {\n  border: 1px solid #717171;\n}\n.recharge-account .recharge-form .methods .recharge-radio .radio-button .outer-circle.checked {\n  border: 1px solid #cc9752;\n}\n.recharge-account .recharge-form .methods .green-box {\n  background-color: #edf9f5;\n  padding: 33px;\n  padding-bottom: 44px;\n  border-radius: 5px;\n  margin-top: 32px;\n}\n.recharge-account .recharge-form .methods .green-box .sub-title {\n  font-size: 18px;\n  font-weight: 600;\n  line-height: 27px;\n  color: #393939;\n}\n.recharge-account .recharge-form .methods .green-box input {\n  font-size: 13px;\n  font-weight: 300;\n  line-height: 19.5px;\n  color: #717171;\n  border-bottom: 1px solid #7e8f8a;\n}\n.recharge-account .recharge-form .methods .green-box .left {\n  max-width: 75%;\n}\n.recharge-account .recharge-form .methods .green-box .right {\n  max-width: 25%;\n}\n.recharge-account .recharge-form .methods .green-box .right .date-picker label {\n  color: #393939;\n  font-size: 15px;\n  font-weight: 400;\n  line-height: 22.5px;\n}\n.recharge-account .recharge-form .methods .green-box .right .date-picker .date-input {\n  position: relative;\n  border-bottom: 1px solid #7e8f8a;\n}\n.recharge-account .recharge-form .methods .green-box .right .date-picker .date-input .react-datepicker-wrapper {\n  width: 100%;\n  height: 100%;\n}\n.recharge-account .recharge-form .methods .green-box .right .date-picker .date-input .react-datepicker-wrapper input {\n  font-size: 13px;\n  font-weight: 300;\n  line-height: 19.5px;\n  color: #717171;\n  border: 0;\n  outline: 0;\n  width: 100%;\n  height: 100%;\n  padding-bottom: 9px;\n  background-color: transparent;\n}\n.recharge-account .recharge-form .methods .green-box .right .date-picker .date-input svg {\n  width: 16px;\n  height: 16px;\n  position: absolute;\n  top: 0;\n  right: 0;\n}\n.recharge-account .recharge-form .buttons {\n  margin-top: 33px;\n}\n.recharge-account .faded {\n  font-size: 15px;\n  font-weight: 400;\n  line-height: 22.5px;\n  color: #717171;\n}\n.recharge-account .pagination {\n  display: flex;\n  justify-content: flex-end;\n}\n.recharge-account .pagination .paginate-inner {\n  display: flex;\n  justify-content: flex-end;\n}\n.recharge-account .pagination .paginate-inner button.paginateButton {\n  background-color: transparent;\n  cursor: pointer;\n  width: 30px;\n  height: 30px;\n  border: 0;\n  outline: 0;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  color: #393939;\n}\n.recharge-account .pagination .paginate-inner button.paginateButton.active {\n  background-color: #cc9752;\n  width: 30px;\n  height: 30px;\n  border-radius: 3px;\n  color: #fff;\n}\n.recharge-account .pagination .paginate-inner button.paginateButton svg.orange-class {\n  fill: #cc9752;\n}\n.recharge-account .pagination .paginate-inner button.paginateButton svg.grey-class {\n  fill: #717171;\n}\n\n.tabs button.active {\n  border-bottom: 3px solid #cc9752;\n}\n\n.sidebar-items ul li {\n  padding: 20px 18px;\n  cursor: pointer;\n  border-bottom: 1px solid #e6e6e6;\n}\n.sidebar-items ul li p {\n  font-size: 15px;\n  font-weight: 400;\n  line-height: 22.5px;\n  color: #717171;\n}\n.sidebar-items ul li.active {\n  background-color: #eed7b9;\n  border-radius: 3px;\n  border-bottom: 1px solid transparent;\n}\n.sidebar-items ul li.active p {\n  font-weight: 500;\n  color: #393939;\n}\n\n.general-information .profile-box {\n  border-radius: 5px;\n  box-shadow: 0px 4px 30px 0px rgba(0, 0, 0, 0.08);\n  border: 1px solid #e6e6e6;\n}\n.general-information .profile-box .header-title {\n  border-bottom: 1px solid #e6e6e6;\n  padding: 21px 30px;\n  cursor: pointer;\n}\n.general-information .profile-box .header-title p {\n  font-size: 18px;\n  font-weight: 600;\n  line-height: 27px;\n  color: #333333;\n}\n.general-information .profile-box .content-wrapper .content {\n  padding: 30px 30px 30px 30px;\n}\n.general-information .profile-box .content-wrapper .content .image {\n  min-width: 139px;\n  overflow: hidden;\n  position: relative;\n}\n.general-information .profile-box .content-wrapper .content .image img {\n  width: 139px;\n  height: 139px;\n  border-radius: 50%;\n  object-fit: cover;\n}\n.general-information .profile-box .content-wrapper .content .image span {\n  position: absolute;\n  bottom: 4px;\n  right: 5px;\n  width: 35px;\n  height: 35px;\n  border-radius: 50%;\n  background-color: #cc9752;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  cursor: pointer;\n  z-index: 1;\n}\n.general-information .profile-box .content-wrapper .content .image span svg {\n  fill: #fff;\n}\n.general-information .profile-box .content-wrapper .content .items {\n  padding-left: 50px;\n}\n.general-information .profile-box .content-wrapper .content .items .col:nth-child(1) {\n  min-width: 233px;\n}\n.general-information .profile-box .content-wrapper .content .items .col:nth-child(2) {\n  min-width: 145px;\n}\n.general-information .profile-box .content-wrapper .content .items .item {\n  margin-bottom: 28px;\n}\n.general-information .profile-box .content-wrapper .content .items .item.address {\n  width: fit-content;\n}\n.general-information .profile-box .content-wrapper .content .items .item p {\n  font-size: 15px;\n  font-weight: 500;\n  line-height: 22.5px;\n  color: #393939;\n  margin-bottom: 0;\n}\n.general-information .profile-box .content-wrapper .content .items .item p.title {\n  font-size: 13px;\n  font-weight: 400;\n  line-height: 19.5px;\n  color: #717171;\n}\n.general-information .profile-box .content-wrapper .content .items .item a {\n  color: #cc9752;\n  text-decoration: none;\n}\n.general-information .profile-box .content-wrapper .content .profile-form {\n  padding-left: 50px;\n}\n.general-information .profile-box .content-wrapper .content .profile-form .form-inputs label {\n  font-size: 13px;\n  font-weight: 400;\n  line-height: 19.5px;\n  color: #717171;\n}\n.general-information .profile-box .content-wrapper .content .profile-form .form-inputs input {\n  font-size: 14px;\n  font-weight: 500;\n  line-height: 22.5px;\n  color: #393939;\n}\n.general-information .profile-box .content-wrapper .content .profile-form .form-inputs input[type=email] {\n  color: #cc9752;\n}\n.general-information .profile-box .content-wrapper .content .profile-form button {\n  max-width: 145px;\n}\n\n.password {\n  padding: 30px 34px;\n  border-radius: 5px;\n  box-shadow: 0px 4px 30px 0px rgba(0, 0, 0, 0.08);\n  border: 1px solid #e6e6e6;\n}\n.password .title {\n  font-size: 18px;\n  font-weight: 600;\n  line-height: 27px;\n  color: #393939;\n}\n.password .text {\n  font-size: 13px;\n  font-weight: 400;\n  line-height: 19.5px;\n  color: #717171;\n}\n.password .h-pass {\n  font-size: 15px;\n  font-weight: 500;\n  line-height: 22.5px;\n  color: #393939;\n}\n.password button {\n  max-width: 246px;\n  padding-left: 40px;\n  padding-right: 40px;\n}\n\n.password-form .title {\n  font-weight: 600;\n}\n.password-form .back-btn {\n  cursor: pointer;\n  fill: #cc9752;\n}\n.password-form .form-inputs label {\n  font-size: 13px;\n  color: #717171;\n  position: relative;\n}\n.password-form .form-inputs label .tooltip {\n  position: absolute;\n  top: -18px;\n  left: 208%;\n  opacity: 1;\n  display: flex;\n  flex-direction: column;\n  visibility: visible;\n  background-color: #fff;\n  width: max-content;\n  height: fit-content;\n}\n.password-form .form-inputs label .tooltip ::before {\n  content: \"\";\n  position: absolute;\n  top: 24px;\n  left: 0;\n  margin-left: -12px;\n  border-width: 6px;\n  border-style: solid;\n  border-color: transparent rgb(255, 255, 255) transparent transparent;\n}\n.password-form .form-inputs label .tooltip p.t-title {\n  color: #393939;\n  font-size: 15px;\n  font-weight: 500;\n  line-height: 22.5px;\n  text-align: left;\n}\n.password-form .form-inputs label .tooltip ul.list {\n  padding-left: 15px;\n}\n.password-form .form-inputs label .tooltip ul.list li {\n  color: #717171;\n  font-size: 13px;\n  font-weight: 400;\n  line-height: 24px;\n  text-align: left;\n}\n.password-form .form-inputs label .tooltip ul.list li span.green {\n  color: #42826c;\n}\n.password-form .form-inputs input {\n  font-size: 13px;\n}\n.password-form .form-inputs input::placeholder {\n  color: #a7a7a7;\n}\n.password-form .form-inputs .icon-info {\n  cursor: pointer;\n}\n\n.Availability {\n  -webkit-box-shadow: 0px 4px 30px 0px rgba(0, 0, 0, 0.08);\n  -moz-box-shadow: 0px 4px 30px 0px rgba(0, 0, 0, 0.08);\n  box-shadow: 0px 4px 30px 0px rgba(0, 0, 0, 0.08);\n  border: 1px solid #e6e6e6;\n  padding: 21px 30px;\n  border-radius: 5px;\n}\n.Availability .title {\n  font-size: 18px;\n  font-weight: 600;\n  line-height: 27px;\n  color: #333333;\n}\n.Availability .time-table .sub-text p {\n  font-size: 13px;\n  font-weight: 400;\n  line-height: 19.5px;\n  color: #393939;\n  margin-top: 20px;\n  margin-bottom: 17px;\n}\n.Availability .time-table .sub-text ul li {\n  width: 56px;\n  height: 52px;\n  border-radius: 4px;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  position: relative;\n  cursor: pointer;\n}\n.Availability .time-table .sub-text ul li .checkbox-container {\n  width: 100%;\n  height: 100%;\n}\n.Availability .time-table .sub-text ul li .checkbox-container .checkbox-text {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  color: #1d1d1d;\n  font-size: 13px;\n  font-weight: 500;\n  line-height: 19.5px;\n  background-color: #e6e7e6;\n  width: 100%;\n  height: 100%;\n  transition: all 0.2s;\n}\n.Availability .time-table .sub-text ul li .checkbox-container input {\n  width: 100%;\n  height: 100%;\n  position: absolute;\n  visibility: hidden;\n}\n.Availability .time-table .sub-text ul li .checkbox-container.checked .checkbox-text {\n  background-color: #cc9752;\n  color: #fff;\n}\n.Availability .time-table table {\n  margin-top: 34px;\n}\n.Availability .time-table table th,\n.Availability .time-table table td {\n  padding-left: 0;\n  padding-right: 0;\n  border: none;\n}\n.Availability .time-table table th {\n  border-bottom: 2px solid #e1e1e1;\n}\n.Availability .time-table table td {\n  font-size: 13px;\n  font-weight: 400;\n  line-height: 19.5px;\n  color: #5e5e5e;\n  padding: 0;\n}\n.Availability .time-table table td.day {\n  font-size: 15px;\n  font-weight: 500;\n  line-height: 50px;\n  color: #393939;\n  width: 200px;\n}\n.Availability .time-table table td.green-color {\n  font-size: 15px;\n  font-weight: 500;\n  line-height: 50px;\n  color: #42826c;\n}\n.Availability .time-table table td.red-color {\n  font-size: 15px;\n  font-weight: 500;\n  line-height: 50px;\n  color: #dd0303;\n}\n.Availability .time-table table td .dob-picker-container .dob-picker-label {\n  margin-bottom: 0;\n}\n.Availability .time-table table td .dob-picker-container .dob-picker-input-wrapper .react-datepicker-wrapper .dob-picker-input {\n  padding: 0 0 0 0;\n}\n.Availability .time-table table td .to {\n  color: #393939;\n  padding-left: 32px;\n  padding-right: 32px;\n}\n.Availability .time-table table td .working-time-green {\n  color: #42826c;\n}\n.Availability .time-table table td .working-time-black,\n.Availability .time-table table td .working-time-text {\n  color: #393939;\n}\n.Availability .dob-picker-input-wrapper svg {\n  fill: #393939;\n}\n\n.profile-management {\n  padding-top: 30px;\n}\n\n.account-type {\n  border-radius: 5px;\n  box-shadow: 0px 4px 30px 0px rgba(0, 0, 0, 0.08);\n  border: 1px solid #e6e6e6;\n  padding: 21px 30px;\n}\n.account-type .title {\n  color: #393939;\n  font-size: 18px;\n  font-weight: 600;\n  line-height: 27px;\n}\n.account-type .type p {\n  color: #42826c;\n  font-size: 20px;\n  font-weight: 500;\n  line-height: 30px;\n  margin-top: 28px;\n}\n.account-type .popup-container .close {\n  top: 20px;\n  right: 22px;\n}\n.account-type .popup-container .popupWrapper {\n  width: 592px;\n  max-width: 100%;\n}\n.account-type .popup-container .popupWrapper .popup {\n  padding: 39px 50px;\n}\n.account-type .popup-container .popupWrapper .popup .form-input {\n  max-width: 491px;\n}\n.account-type .popup-container .popupWrapper .titles {\n  color: #393939;\n  font-size: 20px;\n  font-weight: 600;\n  line-height: 30px;\n}\n.account-type .popup-container .popupWrapper .titles span {\n  color: #42826c;\n}\n.account-type .popup-container .popupWrapper .custom-checkbox {\n  display: flex;\n  align-items: center;\n}\n.account-type .popup-container .popupWrapper .custom-checkbox input[type=checkbox] {\n  position: absolute;\n  opacity: 0;\n  width: 0;\n  height: 0;\n}\n.account-type .popup-container .popupWrapper .custom-checkbox input[type=checkbox]:checked + .custom-checkbox-box {\n  background-color: #cc9752;\n  border-color: #cc9752;\n}\n.account-type .popup-container .popupWrapper .custom-checkbox input[type=checkbox]:checked + .custom-checkbox-box .checkbox-icon {\n  display: flex;\n}\n.account-type .popup-container .popupWrapper .custom-checkbox .custom-checkbox-box {\n  width: 18px;\n  height: 18px;\n  border: 1px solid #cc9752;\n  background: #fff;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  position: relative;\n  margin-right: 8px;\n  border-radius: 2px;\n  padding: 3px;\n  box-sizing: border-box;\n  transition: background-color 0.2s ease;\n  cursor: pointer;\n  margin-bottom: 0;\n}\n.account-type .popup-container .popupWrapper .custom-checkbox .checkbox-icon {\n  color: #fff;\n  font-size: 14px;\n  display: none;\n}\n.account-type .popup-container .popupWrapper .custom-checkbox .checkbox-label {\n  margin-left: 8px;\n  color: #393939;\n}\n.account-type .popup-container .popupWrapper .custom-checkbox .checkbox-label .highlighted-text {\n  color: #cc9752;\n}\n.account-type .popup-container .popupWrapper .btn-wrap button {\n  width: 145px;\n}\n.account-type .popup-container .popupWrapper .popup .btn.no-bordered.custom-btn-primary {\n  width: 145px;\n}\n.account-type .popup-container .popupWrapper .checkbox a {\n  color: #cc9752;\n  text-decoration: none;\n}\n\n.transfer-bar {\n  background-color: #f9f5ef;\n  border-radius: 4px;\n  padding: 24px 33px;\n}\n.transfer-bar .item .title {\n  font-size: 15px;\n  font-weight: 400;\n  line-height: 22.5px;\n  color: #393939;\n}\n.transfer-bar .item .price {\n  font-size: 30px;\n  font-weight: 700;\n  line-height: 45px;\n  color: #42826c;\n}\n\n.transfer-table .filter-btn-group .btn-border {\n  border: 1px solid #bfbfbf;\n  border-radius: 5px;\n  color: #393939;\n  font-size: 13px;\n  font-weight: 400;\n  line-height: 23px;\n  padding: 7px 17px;\n  margin-left: 0;\n}\n.transfer-table .filter-btn-group .btn-border:not(:last-child) {\n  margin-right: 4px;\n}\n.transfer-table .filter-btn-group .btn-border.active {\n  color: #cc9752;\n  border: 1px solid #cc9752;\n}\n.transfer-table .border-sorting {\n  max-width: 200px;\n  border: 2px solid #d9d9d9;\n  border-radius: 500px;\n  padding: 10px 7px;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  margin-left: 10px;\n}\n.transfer-table .border-sorting .dashboard-drop .dropdown-container-custom {\n  border: 0;\n  border-radius: 0;\n  padding: 0;\n}\n\n.transfer-table .table-data .red {\n  fill: #ff0000;\n}\n.transfer-table .table-data .green {\n  fill: #19b25f;\n}\n.transfer-table .table-data .red-color {\n  color: #ff0000;\n}\n.transfer-table .table-data .orange {\n  color: #cc9752;\n}\n.transfer-table .counter {\n  width: 18px;\n  height: 18px;\n  border-radius: 50%;\n  background-color: #42826c;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  color: #fff;\n  font-size: 13px;\n  font-weight: 400;\n}\n\n.register .form-inputs {\n  padding-left: 0;\n  padding-right: 0;\n}\n.register .register-wrap {\n  box-shadow: 0px 2px 8px 0px rgba(156, 156, 156, 0.25);\n  border: 1px solid #e3e3e3;\n  padding: 35px 20px;\n  box-sizing: border-box;\n  border-radius: 5px;\n  margin-top: 29px;\n}\n.register .moneytransfer-progress {\n  background-color: #f9f5ef;\n  border-radius: 4px;\n  padding: 44px 33px 14px 33px;\n}\n.register .recipient-details p {\n  font-size: 18px;\n  font-weight: 600;\n  line-height: 27px;\n  color: #393939;\n}\n.register .registered-user .search-group,\n.register .registered-user .input-group-label {\n  border: 0;\n  border-bottom: 1px solid #bababa;\n  max-width: none;\n}\n.register .registered-user .search-group svg,\n.register .registered-user .input-group-label svg {\n  width: 13px;\n  height: 13px;\n}\n.register .registered-user .search-group label,\n.register .registered-user .input-group-label label {\n  font-size: 15px;\n  font-weight: 400;\n  line-height: 22.5px;\n  color: #393939;\n}\n.register .registered-user .search-group input,\n.register .registered-user .input-group-label input {\n  border: 0;\n  outline: 0;\n  box-shadow: none;\n  width: calc(100% - 13px);\n  height: 100%;\n  font-size: 13px;\n  font-weight: 400;\n  line-height: 19.5px;\n  color: #797979;\n}\n.register .registered-user .search-group input:focus,\n.register .registered-user .input-group-label input:focus {\n  outline: 0;\n  box-shadow: 0;\n}\n.register .registered-user .preview-wrapper .title-top {\n  font-size: 18px;\n  font-weight: 600;\n  line-height: 27px;\n  color: #1d1d1d;\n}\n.register .registered-user .preview-wrapper .item {\n  padding: 0 57px;\n  box-sizing: border-box;\n}\n.register .registered-user .preview-wrapper .item:first-child {\n  padding-left: 0;\n}\n.register .registered-user .preview-wrapper .item:last-child {\n  padding-right: 0;\n}\n.register .registered-user .preview-wrapper .item:not(:last-child) {\n  border-right: 1px solid #dbdbdb;\n}\n.register .registered-user .preview-wrapper .item .title {\n  width: max-content;\n  font-size: 13px;\n  font-weight: 400;\n  line-height: 19.5px;\n  color: #717171;\n}\n.register .registered-user .preview-wrapper .item .description {\n  font-size: 15px;\n  font-weight: 500;\n  line-height: 22.5px;\n  color: #1d1d1d;\n}\n.register .registered-user .preview-wrapper .item .colored {\n  color: #cc9752;\n}\n.register .registered-user .preview-wrapper .item .mail-id {\n  color: #cc9752;\n  font-weight: 500;\n}\n.register .registered-user .no-bordered,\n.register .registered-user .bordered {\n  padding-left: 10px;\n  padding-right: 10px;\n}\n.register .popupWrapper .popup {\n  padding: 52px;\n}\n.register .popupWrapper .popup .icon {\n  height: 80px;\n  background-color: transparent;\n  width: 100%;\n}\n.register .popupWrapper .popup .icon img {\n  width: 80px;\n  height: 80px;\n}\n.register .popupWrapper .popup h2 {\n  font-size: 26px;\n  font-weight: 600;\n  line-height: 39px;\n  color: #393939;\n}\n.register .popupWrapper .popup .light-text {\n  font-size: 15px;\n  font-weight: 400;\n  line-height: 24px;\n  color: #393939;\n}\n.register .popupWrapper .popup .btn-wrap .btn-mt {\n  width: 274px;\n}\n.register .unregistered-form-preview .preview-wrapper .section {\n  border-bottom: 1px solid #dbdbdb;\n  padding: 20px 0;\n}\n.register .unregistered-form-preview .preview-wrapper .item {\n  padding: 0;\n}\n.register .unregistered-form-preview .preview-wrapper .item:not(:last-child) {\n  border-right: 0;\n  padding-right: 32px;\n}\n\n.world-map {\n  position: relative;\n  width: 100%; /* Adjust the size as needed */\n  height: 100%; /* Adjust the size as needed */\n  margin: auto;\n  padding: 30px 0;\n}\n\n.map {\n  width: 100%;\n  height: auto;\n}\n\n.pin {\n  position: absolute;\n  cursor: pointer;\n}\n\n.tooltip {\n  visibility: hidden;\n  background-color: black;\n  color: white;\n  text-align: center;\n  border-radius: 5px;\n  padding: 5px;\n  position: absolute;\n  z-index: 1;\n  bottom: 20px; /* Positioning tooltip */\n  left: 50%;\n  transform: translateX(-50%);\n  transition: visibility 0.2s;\n}\n\n.pin:hover .tooltip {\n  visibility: visible;\n}\n\n.pin-image {\n  width: 22px;\n  height: 28px;\n}\n\n.invite-table .form-bar {\n  background-color: #f9f5ef;\n  border-radius: 4px;\n  padding: 24px 33px 26px 33px;\n  margin-bottom: 28px;\n}\n.invite-table .form-bar .title {\n  font-size: 18px;\n  font-weight: 600;\n  line-height: 27px;\n  color: #393939;\n}\n.invite-table .form-bar .invite-btn {\n  padding-left: 11px;\n  padding-right: 11px;\n  font-size: 15px;\n}\n.invite-table .table tbody tr td.orange {\n  color: #cc9752;\n}\n.invite-table .table tbody tr td img.pic {\n  width: 31px;\n  height: 31px;\n  border-radius: 50%;\n}\n\n.time-picker-container .react-datepicker__time-container {\n  width: 100%;\n  height: 150px;\n  overflow: hidden;\n}\n.time-picker-container .react-datepicker__time-container .react-datepicker__time .react-datepicker__time-box {\n  width: 100%;\n  margin: 0;\n}\n.time-picker-container .react-datepicker__time-container .react-datepicker__time .react-datepicker__time-box ul.react-datepicker__time-list {\n  height: 100px;\n}\n.time-picker-container .react-datepicker-time__header {\n  font-size: 11px;\n}\n\n.assoicate-user .f-w-270 {\n  max-width: 270px;\n}\n.assoicate-user .btn-otp {\n  padding: 0;\n  border: 0;\n  outline: 0;\n  background-color: transparent;\n  color: #cc9752;\n  cursor: pointer;\n  font-size: 13px;\n  font-weight: 400;\n  line-height: 19.5px;\n}\n.assoicate-user .search-group label {\n  font-size: 15px;\n  font-weight: 400;\n  line-height: 22.5px;\n  text-align: left;\n  color: #393939;\n}\n.assoicate-user .search-group input {\n  font-size: 13px;\n  font-weight: 300;\n  line-height: 19.5px;\n  color: #393939;\n}\n.assoicate-user .search-group input::placeholder {\n  font-size: 13px;\n  font-weight: 300;\n  line-height: 19.5px;\n  color: #393939;\n}\n.assoicate-user .search-group svg {\n  fill: #393939;\n}\n.assoicate-user .preview-wrapper-associate {\n  margin-top: 34px;\n}\n.assoicate-user .preview-wrapper-associate .item:not(:last-child) {\n  border-right: 1px solid;\n  padding-right: 34px;\n  margin: 6px;\n}\n.assoicate-user .preview-wrapper-associate .item .title {\n  width: max-content;\n  font-size: 13px;\n  font-weight: 400;\n  line-height: 19.5px;\n  color: #656565;\n}\n.assoicate-user .preview-wrapper-associate .item .description {\n  font-size: 15px;\n  font-weight: 500;\n  line-height: 22.5px;\n  color: #393939;\n}\n.assoicate-user .associate-preview .section {\n  border-bottom: 1px solid #dbdbdb;\n  padding: 20px 0;\n}\n.assoicate-user .associate-preview .title-top {\n  font-size: 18px;\n  font-weight: 600;\n  line-height: 27px;\n  color: #1d1d1d;\n}\n.assoicate-user .associate-preview .item {\n  padding: 0;\n  margin-bottom: 16px;\n}\n.assoicate-user .associate-preview .item:first-child {\n  padding-left: 0;\n}\n.assoicate-user .associate-preview .item:last-child {\n  padding-right: 0;\n}\n.assoicate-user .associate-preview .item:not(:last-child) {\n  padding-right: 95px;\n}\n.assoicate-user .associate-preview .item .title {\n  width: max-content;\n  font-size: 13px;\n  font-weight: 400;\n  line-height: 19.5px;\n  color: #717171;\n}\n.assoicate-user .associate-preview .item .description {\n  font-size: 15px;\n  font-weight: 500;\n  line-height: 22.5px;\n  color: #1d1d1d;\n}\n.assoicate-user .associate-preview .item .colored {\n  color: #cc9752;\n}\n.assoicate-user .associate-preview .item .mail-id {\n  color: #cc9752;\n  font-weight: 500;\n}\n.assoicate-user .green-box {\n  background-color: #edf9f5;\n  border-radius: 2px;\n  padding: 30px 36px;\n}\n.assoicate-user .font-small {\n  font-size: 15px;\n  font-weight: 400;\n  line-height: 22.5px;\n  color: #393939;\n}\n\n.transfer-table .border-sorting {\n  position: relative;\n}\n.transfer-table .border-sorting .filter .dropdown-menu-custom {\n  display: none;\n}\n.transfer-table .border-sorting .filter-popup {\n  position: absolute;\n  width: 403px;\n  top: 48px;\n  right: 0;\n  background: #fff;\n  border-radius: 5px;\n  box-shadow: 0px 2px 8px 0px rgba(156, 156, 156, 0.35);\n  border: 1px solid #e3e3e3;\n}\n.transfer-table .border-sorting .filter-popup .title {\n  font-size: 20px;\n  font-weight: 600;\n  line-height: 30px;\n  color: #161616;\n  border-bottom: 1px solid #cfcfcf;\n  padding: 20px 30px;\n}\n.transfer-table .border-sorting .filter-popup .inner {\n  padding: 20px 30px;\n}\n.transfer-table .border-sorting .filter-popup .inner .input {\n  font-size: 14px;\n}\n.transfer-table .border-sorting .filter-popup .inner .input::placeholder {\n  font-size: 14px;\n}\n.transfer-table .border-sorting .filter-popup .inner label,\n.transfer-table .border-sorting .filter-popup .inner .dropdown-title {\n  color: #3f3f3f;\n}\n.transfer-table .border-sorting .filter-popup .inner .form-inputs {\n  margin-top: 24px;\n}\n.transfer-table .border-sorting .filter-popup .inner .form-inputs:first-child {\n  margin-top: 0;\n}\n.transfer-table .border-sorting .filter-popup .inner .dob-picker-container .dob-picker-input-wrapper svg {\n  font: #333333;\n}\n.transfer-table .border-sorting .filter-popup .close {\n  position: absolute;\n  top: 20px;\n  right: 29px;\n  opacity: 1;\n}\n.transfer-table .border-sorting .filter-popup .close svg {\n  fill: #333333;\n  width: 32px;\n  height: 32px;\n  stroke: #393939;\n  cursor: pointer;\n  opacity: 1;\n}\n.transfer-table .border-sorting .filter-popup .btn-group-filter {\n  background-color: #fffaf4;\n  padding: 15px 30px;\n}\n\n.tDetails {\n  box-shadow: 0px 2px 8px 0px rgba(156, 156, 156, 0.25);\n  border: 1px solid #e3e3e3;\n  box-sizing: border-box;\n  border-radius: 9px;\n  margin-top: 29px;\n  overflow: hidden;\n}\n.tDetails .tDetails-preview .section {\n  border-bottom: 0;\n  padding: 20px 0;\n  padding-bottom: 10px;\n}\n.tDetails .tDetails-preview .title-top {\n  font-size: 18px;\n  font-weight: 600;\n  line-height: 27px;\n  color: #1d1d1d;\n  border-bottom: 1px solid #dbdbdb;\n  padding-bottom: 20px;\n  margin-bottom: 20px;\n}\n.tDetails .tDetails-preview .item {\n  padding: 0;\n  margin-bottom: 16px;\n}\n.tDetails .tDetails-preview .item:first-child {\n  padding-left: 0;\n}\n.tDetails .tDetails-preview .item:last-child {\n  padding-right: 0;\n}\n.tDetails .tDetails-preview .item:not(:last-child) {\n  padding-right: 95px;\n}\n.tDetails .tDetails-preview .item .title {\n  width: max-content;\n  font-size: 13px;\n  font-weight: 400;\n  line-height: 19.5px;\n  color: #717171;\n}\n.tDetails .tDetails-preview .item .description {\n  font-size: 15px;\n  font-weight: 500;\n  line-height: 22.5px;\n  color: #1d1d1d;\n}\n.tDetails .tDetails-preview .item .colored {\n  color: #cc9752;\n}\n.tDetails .tDetails-preview .item .mail-id {\n  color: #cc9752;\n  font-weight: 500;\n}\n.tDetails .form-inputs {\n  padding: 9px 36px;\n}\n.tDetails .top-bar {\n  background: #f9f5ef;\n  border-top-left-radius: 9px;\n  border-top-right-radius: 9px;\n  border-bottom: 1px solid #dbdada;\n  padding: 18px 38px;\n}\n.tDetails .top-bar .title {\n  font-size: 18px;\n  font-weight: 600;\n  line-height: 27px;\n  text-align: left;\n  color: #161616;\n  margin-left: 14px;\n}\n.tDetails .top-bar svg.back {\n  stroke: #161616;\n  width: 36px;\n  height: 24px;\n  cursor: pointer;\n}\n.tDetails .top-bar svg.download {\n  width: 21px;\n  height: 21px;\n  stroke: #cc9752;\n  margin-left: 27px;\n  cursor: pointer;\n}\n.tDetails .tDetails-btn-group {\n  background-color: #fffaf4;\n  padding: 24px 36px;\n  border-bottom-left-radius: 9px;\n  border-bottom-right-radius: 9px;\n  border-top: 1px solid #dbdada;\n}\n.tDetails .tDetails-btn-group .btn {\n  padding-left: 38px;\n  padding-right: 38px;\n}\n.tDetails .tDetails-popup.popup-container .close {\n  top: 20px;\n  right: 22px;\n}\n.tDetails .tDetails-popup.popup-container .popupWrapper {\n  width: 459px;\n  max-width: 100%;\n  max-height: unset;\n  overflow: hidden;\n}\n.tDetails .tDetails-popup.popup-container .popupWrapper .popup {\n  padding: 0;\n}\n.tDetails .tDetails-popup.popup-container .popupWrapper .titles {\n  font-size: 20px;\n  font-weight: 600;\n  line-height: 30px;\n  color: #1d1d1d;\n  border-bottom: 1px solid #cfcfcf;\n}\n.tDetails .tDetails-popup.popup-container .popupWrapper .titles span {\n  color: #42826c;\n}\n.tDetails .tDetails-popup.popup-container .popupWrapper .custom-checkbox {\n  display: flex;\n  align-items: center;\n}\n.tDetails .tDetails-popup.popup-container .popupWrapper .custom-checkbox input[type=checkbox] {\n  position: absolute;\n  opacity: 0;\n  width: 0;\n  height: 0;\n}\n.tDetails .tDetails-popup.popup-container .popupWrapper .custom-checkbox input[type=checkbox]:checked + .custom-checkbox-box {\n  background-color: #cc9752;\n  border-color: #cc9752;\n}\n.tDetails .tDetails-popup.popup-container .popupWrapper .custom-checkbox input[type=checkbox]:checked + .custom-checkbox-box .checkbox-icon {\n  display: flex;\n}\n.tDetails .tDetails-popup.popup-container .popupWrapper .custom-checkbox .custom-checkbox-box {\n  width: 18px;\n  height: 18px;\n  border: 1px solid #cc9752;\n  background: #fff;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  position: relative;\n  margin-right: 8px;\n  border-radius: 2px;\n  padding: 3px;\n  box-sizing: border-box;\n  transition: background-color 0.2s ease;\n  cursor: pointer;\n  margin-bottom: 0;\n}\n.tDetails .tDetails-popup.popup-container .popupWrapper .custom-checkbox .checkbox-icon {\n  color: #fff;\n  font-size: 14px;\n  display: none;\n}\n.tDetails .tDetails-popup.popup-container .popupWrapper .custom-checkbox .checkbox-label {\n  margin-left: 8px;\n  color: #393939;\n}\n.tDetails .tDetails-popup.popup-container .popupWrapper .custom-checkbox .checkbox-label .highlighted-text {\n  color: #cc9752;\n}\n.tDetails .tDetails-popup.popup-container .popupWrapper .pop-btn-wrap {\n  background-color: #fffaf4;\n  padding: 15px 30px;\n}\n.tDetails .tDetails-popup.popup-container .popupWrapper .pop-btn-wrap button {\n  width: \"\";\n  max-width: unset;\n}\n.tDetails .tDetails-popup.popup-container .popupWrapper .popup .btn.no-bordered.custom-btn-primary {\n  width: unset;\n  max-width: unset;\n  padding-left: 31px;\n  padding-right: 31px;\n}\n.tDetails .tDetails-popup.popup-container .popupWrapper .checkbox a {\n  color: #cc9752;\n  text-decoration: none;\n}\n.tDetails .successful.popup-container .popupWrapper {\n  max-width: 598px;\n  max-height: unset;\n  padding: 46px 55px;\n}\n.tDetails .successful.popup-container .popupWrapper .popup .icon {\n  margin: 0 auto;\n  background-color: transparent;\n}\n.tDetails .successful.popup-container .popupWrapper .popup h2 {\n  color: #1d1d1d;\n  font-size: 26px;\n  line-height: 39px;\n  font-weight: 600;\n}\n.tDetails .successful.popup-container .popupWrapper .popup .light-text {\n  color: #333333;\n  line-height: 24px;\n}\n\n.message-container .sidebar-message {\n  -webkit-box-shadow: 0px 4px 13px 0px rgba(0, 0, 0, 0.08);\n  -moz-box-shadow: 0px 4px 13px 0px rgba(0, 0, 0, 0.08);\n  box-shadow: 0px 4px 13px 0px rgba(0, 0, 0, 0.08);\n  border: 1px solid #e6e6e6;\n  padding: 40px 20px;\n  width: 369px;\n}\n.message-container .sidebar-message .search-group {\n  border: 0;\n  border-bottom: 1px solid #717171;\n  max-width: none;\n  margin-bottom: 27px;\n}\n.message-container .sidebar-message .search-group svg {\n  width: 13px;\n  height: 13px;\n}\n.message-container .sidebar-message .search-group label {\n  font-size: 15px;\n  font-weight: 400;\n  line-height: 22.5px;\n  color: #393939;\n}\n.message-container .sidebar-message .search-group input {\n  border: 0;\n  outline: 0;\n  box-shadow: none;\n  width: calc(100% - 13px);\n  height: 100%;\n  font-size: 13px;\n  font-weight: 400;\n  line-height: 19.5px;\n  color: #19b25f;\n}\n.message-container .sidebar-message .search-group input:focus {\n  outline: 0;\n  box-shadow: 0;\n}\n.message-container .sidebar-message ul li {\n  border-bottom: 1px solid #dfdfdf;\n  padding: 16px 0;\n  cursor: pointer;\n}\n.message-container .sidebar-message ul li:first-child {\n  padding-top: 0;\n}\n.message-container .sidebar-message ul li:last-child {\n  border-bottom: 0;\n}\n.message-container .sidebar-message ul li .user-image img {\n  width: 37px;\n  height: 37px;\n}\n.message-container .sidebar-message ul li .user .user-name {\n  font-size: 15px;\n  font-weight: 500;\n  line-height: 22.5px;\n  color: #393939;\n}\n.message-container .sidebar-message ul li .user .user-message {\n  font-size: 12px;\n  font-weight: 300;\n  line-height: 18px;\n  color: #42826c;\n}\n.message-container .sidebar-message ul li .message-date {\n  font-size: 13px;\n  font-weight: 500;\n  line-height: 19.5px;\n  color: #42826c;\n}\n.message-container .chat-box {\n  width: 729px;\n  position: relative;\n}\n.message-container .chat-box .user-info {\n  border-radius: 5px;\n  background-color: #42826c;\n  padding: 19px 17px;\n}\n.message-container .chat-box .user-info .user-image img {\n  width: 37px;\n  height: 37px;\n}\n.message-container .chat-box .user-info .user {\n  margin-left: 13px;\n}\n.message-container .chat-box .user-info .user .user-name {\n  font-size: 15px;\n  font-weight: 500;\n  line-height: 22.5px;\n  color: #fff;\n}\n.message-container .chat-box .user-info .user .user-message {\n  font-size: 12px;\n  font-weight: 300;\n  line-height: 18px;\n  color: #fff;\n}\n.message-container .chat-box .message-box {\n  padding-left: 20px;\n}\n.message-container .chat-box .message-box .left-align {\n  margin: 17px 0;\n}\n.message-container .chat-box .message-box .left-align img {\n  width: 40px;\n  height: 40px;\n}\n.message-container .chat-box .message-box .left-align .mesg-field {\n  border: 1px solid #cbcbcb;\n  margin-left: 22px;\n  border-radius: 10px;\n  padding: 26px;\n  font-size: 15px;\n  font-weight: 400;\n  line-height: 24px;\n  color: #393939;\n}\n.message-container .chat-box .message-box .left-align .time {\n  font-size: 13px;\n  font-weight: 400;\n  line-height: 19.5px;\n  color: #19b25f;\n  margin-left: 61px;\n  margin-top: 8px;\n}\n.message-container .chat-box .message-box .right-align img {\n  width: 40px;\n  height: 40px;\n  margin-left: 18px;\n}\n.message-container .chat-box .message-box .right-align .mesg-field {\n  background-color: #eeeeee;\n  border-radius: 10px;\n  padding: 21px 22px;\n  margin-left: 13px;\n}\n.message-container .chat-box .message-box .right-align svg {\n  cursor: pointer;\n}\n.message-container .chat-box .message-box .right-align .time {\n  font-size: 10px;\n  font-weight: 400;\n  line-height: 19.5px;\n  color: #19b25f;\n  margin-left: 216px;\n  margin-top: 8px;\n}\n.message-container .chat-box .input-box {\n  position: relative;\n  padding: 0 20px;\n}\n.message-container .chat-box .input-box input {\n  width: 100%;\n  padding: 15px 50px 15px 18px; /* Adjust right padding for space for the send button */\n  border-radius: 25px;\n  border: 1px solid #bfbfbf;\n  outline: none;\n  color: #333333;\n}\n.message-container .chat-box .input-box input:focus {\n  border-color: var(--green-shade-eight);\n  outline: none;\n}\n.message-container .chat-box .input-box input::placeholder {\n  color: var(--light-grey-shade-three);\n}\n.message-container .chat-box .input-box .send-button {\n  position: absolute;\n  top: 50%;\n  right: 12px; /* Adjust to align perfectly inside the border */\n  transform: translateY(-50%);\n  width: 40px; /* Adjust size as needed */\n  height: 40px;\n  cursor: pointer;\n}\n\n.message-main .fa-trash {\n  display: none;\n}\n.message-main:hover .fa-trash {\n  display: block;\n}\n\n.transfer-table .table-data .red {\n  fill: #ff0000;\n}\n.transfer-table .table-data .green {\n  fill: #19b25f;\n}\n.transfer-table .table-data .red-color {\n  color: #ff0000;\n}\n.transfer-table .table-data .orange {\n  color: #cc9752;\n}\n.transfer-table .counter {\n  width: 18px;\n  height: 18px;\n  border-radius: 50%;\n  background-color: #42826c;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  color: #fff;\n  font-size: 13px;\n  font-weight: 400;\n}\n\n.my-account .my-account-bar {\n  background-color: #f9f5ef;\n  border-radius: 4px;\n  padding: 24px 33px;\n}\n.my-account .my-account-bar .item .title {\n  font-size: 20px;\n  font-weight: 600;\n  line-height: 30px;\n  color: #393939;\n}\n.my-account .my-account-bar .item .text {\n  font-size: 13px;\n  font-weight: 600;\n  line-height: 19.5px;\n  color: #19b25f;\n}\n.my-account .my-account-bar .buttons .price {\n  font-size: 30px;\n  font-weight: 700;\n  line-height: 45px;\n  color: #42826c;\n  margin-right: 26px;\n}\n.my-account .my-account-bar .buttons .bordered,\n.my-account .my-account-bar .buttons .thick-border {\n  font-size: 15px;\n  font-weight: 500;\n  width: 141px;\n  padding-left: 0;\n  padding-right: 0;\n  border: 2px solid #cc9752;\n}\n.my-account .my-account-bar .buttons .no-bordered {\n  font-size: 15px;\n  font-weight: 500;\n  width: 159px;\n  padding-left: 0;\n  padding-right: 0;\n}\n.my-account .dashboard-table .dashboard-table-title p {\n  font-size: 15px;\n  line-height: 22.5px;\n}\n.my-account .dashboard-table .search-group {\n  width: 309px;\n}\n.my-account .mx-fix {\n  max-width: 313px;\n}\n\n.teller-table-all .filter-btn-group {\n  max-width: 275px;\n  margin-right: 15px;\n}\n.teller-table-all .filter-btn-group .btn-border {\n  padding: 7px 13px;\n}\n.teller-table-all .search-group-btn {\n  max-width: 178px;\n}\n.teller-table-all .sorting-btn-group {\n  width: 54%;\n}\n.teller-table-all .sorting-btn-group .m-10 {\n  margin-right: 13px;\n}\n.teller-table-all .sorting-btn-group .create-btn-wrap {\n  max-width: 97px;\n  height: 47px;\n}\n.teller-table-all .sorting-btn-group .create-btn-wrap .create-btn {\n  width: 100%;\n  height: 100%;\n  padding-left: 13px;\n  padding-right: 13px;\n  padding-top: 8px;\n  padding-bottom: 8px;\n  font-size: 13px;\n  font-weight: 500;\n  line-height: 19.5px;\n}\n.teller-table-all .details-btn {\n  cursor: pointer;\n}\n\n.teller-information .profile-box .content-wrapper .content .items .item p.green-color {\n  color: #42826c;\n}\n.teller-information .content-boxx {\n  width: calc(100% - 139px);\n}\n.teller-information .upload-container {\n  padding: 36px 30px;\n}\n.teller-information .upload-wrap {\n  border: 1px solid #e6e6e6;\n  width: calc(50% - 15px);\n  border-radius: 2px;\n  padding: 14px 22px;\n  margin-bottom: 30px;\n}\n.teller-information .upload-wrap .file {\n  width: 17px;\n  height: 21px;\n}\n.teller-information .upload-wrap .delete-wrap {\n  height: 16px;\n  display: flex;\n}\n.teller-information .upload-wrap .delete-wrap .delete {\n  width: 16px;\n  height: 16px;\n  cursor: pointer;\n}\n.teller-information .upload-wrap .filename {\n  font-size: 15px;\n  font-weight: 400;\n  line-height: 22.5px;\n  color: #3f3f3f;\n  margin-left: 14px;\n}\n.teller-information .upload-wrap .view {\n  width: 16px;\n  height: 16px;\n  margin-right: 25px;\n  margin-left: 14px;\n  cursor: pointer;\n}\n.teller-information .add-btn input {\n  display: none;\n}\n.teller-information .add-btn .add-btn-btn {\n  width: 121px;\n  padding: 13px 30px;\n  border: 2px solid #cc9752;\n  color: #cc9752;\n  font-size: 18px;\n  font-weight: 500;\n  line-height: 27px;\n  border-radius: 100px;\n  cursor: pointer;\n}\n\n.progress-container {\n  padding: 45px 33px;\n}\n.progress-container .step-wrapper {\n  z-index: 1;\n  position: relative;\n  margin-top: -21px;\n}\n.progress-container .step-wrapper ul {\n  list-style-type: none;\n  display: flex;\n}\n.progress-container .step-wrapper ul li {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  width: 236px;\n  text-align: center;\n  position: relative;\n}\n.progress-container .step-wrapper ul li::after {\n  content: \"\";\n  position: absolute;\n  width: 100%;\n  height: 2px;\n  background-color: #d9d9d9;\n  top: 24%;\n  left: -50%;\n  z-index: -1;\n}\n.progress-container .step-wrapper ul li:first-child::after {\n  content: none;\n}\n.progress-container .step-wrapper ul li .icon {\n  width: 40px;\n  height: 40px;\n  background-color: #f9f5ef;\n  border: 1px solid #717171;\n  outline: 5px solid #f9f5ef;\n  border-radius: 50%;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n}\n.progress-container .step-wrapper ul li .icon span {\n  width: 100%;\n  height: 100%;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n}\n.progress-container .step-wrapper ul li .icon span svg {\n  width: 14px;\n  height: auto;\n}\n.progress-container .step-wrapper ul li .text {\n  color: #717171;\n}\n.progress-container .step-wrapper ul li.active::after {\n  background-color: #42826c;\n}\n.progress-container .step-wrapper ul li.active .icon {\n  background-color: #42826c;\n}\n.progress-container .step-wrapper ul li.active .icon span svg {\n  stroke: #fff;\n}\n.progress-container .step-wrapper ul li.active .text {\n  color: #42826c;\n}\n.progress-container .step-wrapper ul li:nth-child(1) .icon span svg {\n  fill: #fff;\n}\n\n.create-account-container .shadow-box {\n  box-shadow: 0px 2px 8px 0px rgba(156, 156, 156, 0.25);\n  border: 1px solid #e3e3e3;\n  padding: 35px 20px;\n  box-sizing: border-box;\n  border-radius: 5px;\n  margin-top: 29px;\n}\n.create-account-container .teller-progress {\n  background-color: #f9f5ef;\n  border-radius: 4px;\n  padding: 64px 33px 34px;\n}\n.create-account-container .form-inputs h3 {\n  font-size: 18px;\n  font-weight: 600;\n  line-height: 27px;\n  color: #393939;\n}\n.create-account-container .btn-teller-group {\n  margin-top: 34px;\n}\n.create-account-container .btn-teller-group .btn,\n.create-account-container .btn-teller-group .bordered,\n.create-account-container .btn-teller-group .no-bordered {\n  padding-top: 13px;\n  padding-bottom: 13px;\n  padding-left: 38px;\n  padding-right: 38px;\n  max-width: 160px;\n}\n.create-account-container .popup-container .popupWrapper .popup .icon {\n  background-color: transparent;\n}\n.create-account-container .popup-container .popupWrapper .popup h2 {\n  color: #393939;\n}\n\n.normal-dashboard {\n  background-color: #fff;\n  min-height: 100vh;\n  position: relative;\n  transition: 0.5s all;\n}\n.normal-dashboard .p-15 {\n  padding-left: 15px;\n  padding-right: 15px;\n}\n.normal-dashboard .dashboard-main-content {\n  padding-right: 15px;\n  padding-left: 15px;\n  width: calc(100% - 258px);\n  position: absolute;\n  top: 0;\n  transition: 0.5s all;\n  right: 0;\n}\n.normal-dashboard .copyright-footer {\n  padding: 15px 0 12px;\n  width: auto;\n  position: fixed;\n  bottom: 0;\n  background: #fff;\n}\n@media (min-width: 768px) {\n  .normal-dashboard .copyright-footer {\n    width: 85%;\n    padding: 25px 0 22px;\n  }\n}\n.normal-dashboard .copyright-footer p {\n  font-size: 12px;\n  font-weight: 400;\n  line-height: 1.6;\n  color: #454545;\n}\n@media (min-width: 768px) {\n  .normal-dashboard .copyright-footer p {\n    font-size: 14px;\n  }\n}\n.normal-dashboard .copyright-footer p a {\n  color: #848484;\n  margin: 0 5px;\n}\n.normal-dashboard .chat-icon {\n  position: fixed;\n  bottom: 30px;\n  right: 30px;\n  width: 66px;\n  height: 66px;\n  border-radius: 50%;\n  cursor: pointer;\n}\n.normal-dashboard .dashboard-table .table tbody tr td.orange {\n  color: #cc9752;\n}\n.normal-dashboard .table-responsive {\n  overflow-x: auto;\n}\n.normal-dashboard .table-responsive table {\n  max-width: 100%;\n  width: 100%;\n}\n\n.full-width {\n  transition: 0.2s all;\n  width: calc(100% - 110px) !important;\n}\n\n.halfsidebar {\n  transition: 0.5s all;\n  max-width: 100px !important;\n}\n\n.halfsidebar p {\n  visibility: hidden;\n  display: none;\n}\n\n.halfsidebar svg {\n  width: 25px !important;\n  height: 25px !important;\n}\n\n.halfsidebar .list-box {\n  justify-content: center !important;\n}\n\n.tooltip {\n  padding: 24px 27px;\n  border-radius: 5px;\n  box-shadow: 0px 4px 20px 0px rgba(0, 0, 0, 0.2);\n}\n\n.manage-user .admin-um-multistep .form-inputs .sub-head {\n  font-size: 18px;\n  font-weight: 600;\n  line-height: 27px;\n  color: #393939;\n}\n.manage-user .admin-um-multistep .profile-box .content-wrapper .content .items .item .btn-red p {\n  color: #d65d43;\n}\n.manage-user .admin-um-multistep .upload-container .doc-wrap {\n  width: calc(50% - 15px);\n}\n.manage-user .admin-um-multistep .upload-container .doc-title {\n  font-size: 15px;\n  font-weight: 400;\n  line-height: 22.5px;\n  color: #393939;\n  margin-bottom: 0;\n}\n\n.admin-um-ud .back-btn {\n  font-size: 18px;\n  font-weight: 600;\n  line-height: 27px;\n  color: #393939;\n  cursor: pointer;\n  padding: 20px 0;\n}\n.admin-um-ud .back-btn svg {\n  width: 24px;\n  height: 16px;\n}\n.admin-um-ud .content-boxx {\n  width: calc(100% - 139px);\n}\n.admin-um-ud .upload-container {\n  padding: 36px 30px;\n}\n.admin-um-ud .upload-wrap {\n  border-bottom: 2px solid #e6e6e6;\n  border-radius: 2px;\n  padding: 14px 0;\n  margin-bottom: 30px;\n}\n.admin-um-ud .upload-wrap .file {\n  width: 17px;\n  height: 21px;\n}\n.admin-um-ud .upload-wrap .delete-wrap {\n  height: 16px;\n  display: flex;\n}\n.admin-um-ud .upload-wrap .delete-wrap .delete {\n  width: 16px;\n  height: 16px;\n  cursor: pointer;\n}\n.admin-um-ud .upload-wrap .filename {\n  font-size: 15px;\n  font-weight: 400;\n  line-height: 22.5px;\n  color: #3f3f3f;\n  margin-left: 14px;\n}\n.admin-um-ud .upload-wrap .view {\n  width: 16px;\n  height: 16px;\n  margin-right: 14px;\n  margin-left: 14px;\n  cursor: pointer;\n}\n.admin-um-ud .upload-wrap svg.download {\n  margin-right: 14px;\n  fill: #cc9752;\n  cursor: pointer;\n}\n.admin-um-ud .add-btn input {\n  display: none;\n}\n.admin-um-ud .add-btn .add-btn-btn {\n  width: 121px;\n  padding: 13px 30px;\n  border: 2px solid #cc9752;\n  color: #cc9752;\n  font-size: 18px;\n  font-weight: 500;\n  line-height: 27px;\n  border-radius: 100px;\n  cursor: pointer;\n}\n.admin-um-ud .date {\n  font-size: 15px;\n  font-weight: 700;\n  line-height: 22.5px;\n  color: #393939;\n}\n.admin-um-ud table.table-activity {\n  width: 100%;\n}\n.admin-um-ud table.table-activity tbody tr {\n  display: flex;\n  justify-content: space-between;\n  width: 100%;\n  align-items: center;\n  border-bottom: 1px solid #e6e6e6;\n  padding: 14px 0;\n}\n.admin-um-ud table.table-activity tbody tr td {\n  display: flex;\n}\n.admin-um-ud table.table-activity tbody tr td span {\n  color: #00a879;\n}\n.admin-um-ud table.table-activity tbody tr td img {\n  width: 36px;\n  height: 36px;\n  border-radius: 50%;\n}\n.admin-um-ud table.table-activity tbody tr td .user-name p {\n  font-size: 14px;\n  font-weight: 400;\n  line-height: 21px;\n  color: #717171;\n}\n.admin-um-ud table.table-activity tbody tr td .user-name p.title {\n  font-size: 15px;\n  font-weight: 600;\n  line-height: 22.5px;\n  color: #393939;\n}\n.admin-um-ud table.table-activity tbody tr td .long-text {\n  font-size: 14px;\n  font-weight: 500;\n  line-height: 21px;\n  color: #646464;\n}\n.admin-um-ud table.table-activity tbody tr td .long-text b {\n  color: #333333;\n}\n.admin-um-ud .header-title .header-btn svg {\n  width: 17px;\n  height: 17px;\n}\n.admin-um-ud .header-title .header-btn p {\n  font-size: 15px;\n  font-weight: 500;\n  line-height: 22.5px;\n  color: #cc9752;\n}\n.admin-um-ud .profile-box .content-wrapper .content .items .item .btn-red p {\n  color: #d65d43;\n}\n.admin-um-ud .upload-container .doc-wrap {\n  width: calc(50% - 15px);\n}\n.admin-um-ud .upload-container .doc-title {\n  font-size: 15px;\n  font-weight: 400;\n  line-height: 22.5px;\n  color: #393939;\n  margin-bottom: 0;\n}\n.admin-um-ud .search-group {\n  width: 209px;\n}\n\n.shadow, .card-profile-image img {\n  border-bottom: 1px solid #e6e6e6;\n  border: 1px solid rgba(156, 156, 156, 0.35);\n  padding: 21px 30px;\n  cursor: pointer;\n}\n.shadow .card-header h1, .card-profile-image img .card-header h1 {\n  font-size: 18px;\n  font-weight: 600;\n  line-height: 27px;\n  color: #333333;\n}\n.shadow .search-group, .card-profile-image img .search-group {\n  border: 0;\n  border-bottom: 2px solid #bababa;\n  max-width: none;\n  width: 230px;\n}\n.shadow .search-group svg, .card-profile-image img .search-group svg {\n  width: 13px;\n  height: 13px;\n}\n.shadow .search-group label, .card-profile-image img .search-group label {\n  font-size: 15px;\n  font-weight: 400;\n  line-height: 22.5px;\n  color: #393939;\n}\n.shadow .search-group input, .card-profile-image img .search-group input {\n  border: 0;\n  outline: 0;\n  box-shadow: none;\n  width: 100%;\n  height: 100%;\n  font-size: 13px;\n  font-weight: 400;\n  line-height: 19.5px;\n  color: #797979;\n}\n.shadow .search-group input:focus, .card-profile-image img .search-group input:focus {\n  outline: 0;\n  box-shadow: 0;\n}\n.shadow .no-bordered, .card-profile-image img .no-bordered,\n.shadow .bordered,\n.card-profile-image img .bordered {\n  padding-top: 10px;\n  padding-bottom: 10px;\n  padding-left: 20px;\n  padding-right: 20px;\n}\n.shadow .input-field, .card-profile-image img .input-field {\n  border-radius: 0;\n}\n.shadow .input-field input, .card-profile-image img .input-field input,\n.shadow .input-field select,\n.card-profile-image img .input-field select {\n  color: #717171;\n  border: 0;\n  border-bottom: 1px solid #b1b1b1;\n  width: 100%;\n  background: transparent;\n  padding: 0 0 8px 0;\n  border-radius: 0;\n  box-shadow: none;\n}\n.shadow .input-field label, .card-profile-image img .input-field label {\n  color: #393939;\n  font-size: 15px;\n  font-weight: 400;\n  line-height: 22.5px;\n  margin-bottom: 0;\n}\n.shadow .custom-checkbox, .card-profile-image img .custom-checkbox {\n  display: flex;\n  align-items: center;\n}\n.shadow .custom-checkbox input[type=checkbox], .card-profile-image img .custom-checkbox input[type=checkbox] {\n  position: absolute;\n  opacity: 0;\n  width: 18px;\n  height: 18px;\n  z-index: 1;\n}\n.shadow .custom-checkbox input[type=checkbox]:checked + .custom-checkbox-box, .card-profile-image img .custom-checkbox input[type=checkbox]:checked + .custom-checkbox-box {\n  background-color: #cc9752;\n  border-color: #cc9752;\n}\n.shadow .custom-checkbox input[type=checkbox]:checked + .custom-checkbox-box .checkbox-icon, .card-profile-image img .custom-checkbox input[type=checkbox]:checked + .custom-checkbox-box .checkbox-icon {\n  display: flex;\n}\n.shadow .custom-checkbox .custom-checkbox-box, .card-profile-image img .custom-checkbox .custom-checkbox-box {\n  width: 18px;\n  height: 18px;\n  border: 1px solid #cc9752;\n  background: #fff;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  position: relative;\n  margin-right: 8px;\n  border-radius: 2px;\n  padding: 3px;\n  box-sizing: border-box;\n  transition: background-color 0.2s ease;\n  cursor: pointer;\n  margin-bottom: 0;\n}\n.shadow .custom-checkbox .checkbox-icon, .card-profile-image img .custom-checkbox .checkbox-icon {\n  color: #fff;\n  font-size: 14px;\n  display: none;\n}\n.shadow .custom-checkbox .checkbox-label, .card-profile-image img .custom-checkbox .checkbox-label {\n  margin-left: 8px;\n  color: #393939;\n}\n.shadow .custom-checkbox .checkbox-label .highlighted-text, .card-profile-image img .custom-checkbox .checkbox-label .highlighted-text {\n  color: #cc9752;\n}\n.shadow .no-text p, .card-profile-image img .no-text p {\n  display: none;\n}\n\n.modal-popup .input-field {\n  border-radius: 0;\n}\n.modal-popup .input-field input,\n.modal-popup .input-field select {\n  color: #717171;\n  border: 0;\n  border-bottom: 1px solid #b1b1b1;\n  width: 100%;\n  background: transparent;\n  padding: 0 0 8px 0;\n  border-radius: 0;\n  box-shadow: none;\n}\n.modal-popup .input-field label {\n  color: #393939;\n  font-size: 15px;\n  font-weight: 400;\n  line-height: 22.5px;\n  margin-bottom: 0;\n}\n.modal-popup .modal-content {\n  padding: 30px;\n}\n.modal-popup .modal-content .modal-title {\n  font-size: 18px;\n  font-weight: 600;\n  line-height: 27px;\n  color: #333333;\n  position: relative;\n  width: 100%;\n}\n.modal-popup .modal-content .modal-title .close {\n  padding: 0;\n  position: absolute;\n  width: 30px;\n  height: 30px;\n  top: 0;\n  right: 0;\n  border: 0;\n  box-shadow: none;\n  background-color: transparent;\n  opacity: 1;\n}\n.modal-popup .modal-content .modal-title .close svg {\n  width: 20px;\n  height: 20px;\n  color: #393939;\n}\n.modal-popup .assoicate-user .associate-preview .section {\n  border-bottom: 0;\n  padding: 0;\n  margin-left: -20px;\n  margin-right: -20px;\n}\n.modal-popup .assoicate-user .associate-preview .item {\n  width: auto;\n  min-width: 25%;\n  margin-right: 20px;\n  margin-left: 20px;\n  padding-right: 0;\n}\n\n.custom-table .table thead th,\n.custom-table .table thead td,\n.custom-table .table tbody th,\n.custom-table .table tbody td {\n  background-color: transparent;\n  padding: 14px;\n}\n.custom-table .table tbody tr td.orange {\n  color: #cc9752;\n}\n.custom-table .table tbody tr td {\n  padding: 12px 8px;\n}\n.custom-table .table tbody tr td .dropdown a {\n  padding: 0;\n}\n.custom-table .table tbody tr td .dropdown a i {\n  color: #cc9752;\n}\n.custom-table .table tbody tr td .dropdown a:hover {\n  box-shadow: none;\n}\n.custom-table .table tbody tr td .dropdown a.text-light:hover, .custom-table .table tbody tr td .dropdown a.text-light:focus {\n  box-shadow: none;\n}\n.custom-table .table tbody tr td p.role-button {\n  border: 2px solid #d9d9d9;\n  border-radius: 500px;\n  padding: 7px 12px;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n}",":root {\n  // Custom variable values only support SassScript inside `#{}`.\n  @each $color, $value in $colors {\n    --#{$color}: #{$value};\n  }\n\n  @each $color, $value in $theme-colors {\n    --#{$color}: #{$value};\n  }\n\n  @each $bp, $value in $grid-breakpoints {\n    --breakpoint-#{$bp}: #{$value};\n  }\n\n  // Use `inspect` for lists so that quoted items keep the quotes.\n  // See https://github.com/sass/sass/issues/2383#issuecomment-336349172\n  --font-family-sans-serif: #{inspect($font-family-sans-serif)};\n  --font-family-monospace: #{inspect($font-family-monospace)};\n}\n","// stylelint-disable declaration-no-important, selector-no-qualifying-type, property-no-vendor-prefix\n\n// Reboot\n//\n// Normalization of HTML elements, manually forked from Normalize.css to remove\n// styles targeting irrelevant browsers while applying new styles.\n//\n// Normalize is licensed MIT. https://github.com/necolas/normalize.css\n\n\n// Document\n//\n// 1. Change from `box-sizing: content-box` so that `width` is not affected by `padding` or `border`.\n// 2. Change the default font family in all browsers.\n// 3. Correct the line height in all browsers.\n// 4. Prevent adjustments of font size after orientation changes in IE on Windows Phone and in iOS.\n// 5. Change the default tap highlight to be completely transparent in iOS.\n\n*,\n*::before,\n*::after {\n  box-sizing: border-box; // 1\n}\n\nhtml {\n  font-family: sans-serif; // 2\n  line-height: 1.15; // 3\n  -webkit-text-size-adjust: 100%; // 4\n  -webkit-tap-highlight-color: rgba($black, 0); // 5\n}\n\n// Shim for \"new\" HTML5 structural elements to display correctly (IE10, older browsers)\n// TODO: remove in v5\n// stylelint-disable-next-line selector-list-comma-newline-after\narticle, aside, figcaption, figure, footer, header, hgroup, main, nav, section {\n  display: block;\n}\n\n// Body\n//\n// 1. Remove the margin in all browsers.\n// 2. As a best practice, apply a default `background-color`.\n// 3. Set an explicit initial text-align value so that we can later use\n//    the `inherit` value on things like `<th>` elements.\n\nbody {\n  margin: 0; // 1\n  font-family: $font-family-base;\n  @include font-size($font-size-base);\n  font-weight: $font-weight-base;\n  line-height: $line-height-base;\n  color: $body-color;\n  text-align: left; // 3\n  background-color: $body-bg; // 2\n}\n\n// Future-proof rule: in browsers that support :focus-visible, suppress the focus outline\n// on elements that programmatically receive focus but wouldn't normally show a visible\n// focus outline. In general, this would mean that the outline is only applied if the\n// interaction that led to the element receiving programmatic focus was a keyboard interaction,\n// or the browser has somehow determined that the user is primarily a keyboard user and/or\n// wants focus outlines to always be presented.\n//\n// See https://developer.mozilla.org/en-US/docs/Web/CSS/:focus-visible\n// and https://developer.paciellogroup.com/blog/2018/03/focus-visible-and-backwards-compatibility/\n[tabindex=\"-1\"]:focus:not(:focus-visible) {\n  outline: 0 !important;\n}\n\n\n// Content grouping\n//\n// 1. Add the correct box sizing in Firefox.\n// 2. Show the overflow in Edge and IE.\n\nhr {\n  box-sizing: content-box; // 1\n  height: 0; // 1\n  overflow: visible; // 2\n}\n\n\n//\n// Typography\n//\n\n// Remove top margins from headings\n//\n// By default, `<h1>`-`<h6>` all receive top and bottom margins. We nuke the top\n// margin for easier control within type scales as it avoids margin collapsing.\n// stylelint-disable-next-line selector-list-comma-newline-after\nh1, h2, h3, h4, h5, h6 {\n  margin-top: 0;\n  margin-bottom: $headings-margin-bottom;\n}\n\n// Reset margins on paragraphs\n//\n// Similarly, the top margin on `<p>`s get reset. However, we also reset the\n// bottom margin to use `rem` units instead of `em`.\np {\n  margin-top: 0;\n  margin-bottom: $paragraph-margin-bottom;\n}\n\n// Abbreviations\n//\n// 1. Duplicate behavior to the data-* attribute for our tooltip plugin\n// 2. Add the correct text decoration in Chrome, Edge, IE, Opera, and Safari.\n// 3. Add explicit cursor to indicate changed behavior.\n// 4. Remove the bottom border in Firefox 39-.\n// 5. Prevent the text-decoration to be skipped.\n\nabbr[title],\nabbr[data-original-title] { // 1\n  text-decoration: underline; // 2\n  text-decoration: underline dotted; // 2\n  cursor: help; // 3\n  border-bottom: 0; // 4\n  text-decoration-skip-ink: none; // 5\n}\n\naddress {\n  margin-bottom: 1rem;\n  font-style: normal;\n  line-height: inherit;\n}\n\nol,\nul,\ndl {\n  margin-top: 0;\n  margin-bottom: 1rem;\n}\n\nol ol,\nul ul,\nol ul,\nul ol {\n  margin-bottom: 0;\n}\n\ndt {\n  font-weight: $dt-font-weight;\n}\n\ndd {\n  margin-bottom: .5rem;\n  margin-left: 0; // Undo browser default\n}\n\nblockquote {\n  margin: 0 0 1rem;\n}\n\nb,\nstrong {\n  font-weight: $font-weight-bolder; // Add the correct font weight in Chrome, Edge, and Safari\n}\n\nsmall {\n  @include font-size(80%); // Add the correct font size in all browsers\n}\n\n//\n// Prevent `sub` and `sup` elements from affecting the line height in\n// all browsers.\n//\n\nsub,\nsup {\n  position: relative;\n  @include font-size(75%);\n  line-height: 0;\n  vertical-align: baseline;\n}\n\nsub { bottom: -.25em; }\nsup { top: -.5em; }\n\n\n//\n// Links\n//\n\na {\n  color: $link-color;\n  text-decoration: $link-decoration;\n  background-color: transparent; // Remove the gray background on active links in IE 10.\n\n  @include hover() {\n    color: $link-hover-color;\n    text-decoration: $link-hover-decoration;\n  }\n}\n\n// And undo these styles for placeholder links/named anchors (without href).\n// It would be more straightforward to just use a[href] in previous block, but that\n// causes specificity issues in many other styles that are too complex to fix.\n// See https://github.com/twbs/bootstrap/issues/19402\n\na:not([href]):not([class]) {\n  color: inherit;\n  text-decoration: none;\n\n  @include hover() {\n    color: inherit;\n    text-decoration: none;\n  }\n}\n\n\n//\n// Code\n//\n\npre,\ncode,\nkbd,\nsamp {\n  font-family: $font-family-monospace;\n  @include font-size(1em); // Correct the odd `em` font sizing in all browsers.\n}\n\npre {\n  // Remove browser default top margin\n  margin-top: 0;\n  // Reset browser default of `1em` to use `rem`s\n  margin-bottom: 1rem;\n  // Don't allow content to break outside\n  overflow: auto;\n  // Disable auto-hiding scrollbar in IE & legacy Edge to avoid overlap,\n  // making it impossible to interact with the content\n  -ms-overflow-style: scrollbar;\n}\n\n\n//\n// Figures\n//\n\nfigure {\n  // Apply a consistent margin strategy (matches our type styles).\n  margin: 0 0 1rem;\n}\n\n\n//\n// Images and content\n//\n\nimg {\n  vertical-align: middle;\n  border-style: none; // Remove the border on images inside links in IE 10-.\n}\n\nsvg {\n  // Workaround for the SVG overflow bug in IE10/11 is still required.\n  // See https://github.com/twbs/bootstrap/issues/26878\n  overflow: hidden;\n  vertical-align: middle;\n}\n\n\n//\n// Tables\n//\n\ntable {\n  border-collapse: collapse; // Prevent double borders\n}\n\ncaption {\n  padding-top: $table-cell-padding;\n  padding-bottom: $table-cell-padding;\n  color: $table-caption-color;\n  text-align: left;\n  caption-side: bottom;\n}\n\n// 1. Removes font-weight bold by inheriting\n// 2. Matches default `<td>` alignment by inheriting `text-align`.\n// 3. Fix alignment for Safari\n\nth {\n  font-weight: $table-th-font-weight; // 1\n  text-align: inherit; // 2\n  text-align: -webkit-match-parent; // 3\n}\n\n\n//\n// Forms\n//\n\nlabel {\n  // Allow labels to use `margin` for spacing.\n  display: inline-block;\n  margin-bottom: $label-margin-bottom;\n}\n\n// Remove the default `border-radius` that macOS Chrome adds.\n//\n// Details at https://github.com/twbs/bootstrap/issues/24093\nbutton {\n  // stylelint-disable-next-line property-disallowed-list\n  border-radius: 0;\n}\n\n// Explicitly remove focus outline in Chromium when it shouldn't be\n// visible (e.g. as result of mouse click or touch tap). It already\n// should be doing this automatically, but seems to currently be\n// confused and applies its very visible two-tone outline anyway.\n\nbutton:focus:not(:focus-visible) {\n  outline: 0;\n}\n\ninput,\nbutton,\nselect,\noptgroup,\ntextarea {\n  margin: 0; // Remove the margin in Firefox and Safari\n  font-family: inherit;\n  @include font-size(inherit);\n  line-height: inherit;\n}\n\nbutton,\ninput {\n  overflow: visible; // Show the overflow in Edge\n}\n\nbutton,\nselect {\n  text-transform: none; // Remove the inheritance of text transform in Firefox\n}\n\n// Set the cursor for non-`<button>` buttons\n//\n// Details at https://github.com/twbs/bootstrap/pull/30562\n[role=\"button\"] {\n  cursor: pointer;\n}\n\n// Remove the inheritance of word-wrap in Safari.\n//\n// Details at https://github.com/twbs/bootstrap/issues/24990\nselect {\n  word-wrap: normal;\n}\n\n\n// 1. Prevent a WebKit bug where (2) destroys native `audio` and `video`\n//    controls in Android 4.\n// 2. Correct the inability to style clickable types in iOS and Safari.\nbutton,\n[type=\"button\"], // 1\n[type=\"reset\"],\n[type=\"submit\"] {\n  -webkit-appearance: button; // 2\n}\n\n// Opinionated: add \"hand\" cursor to non-disabled button elements.\n@if $enable-pointer-cursor-for-buttons {\n  button,\n  [type=\"button\"],\n  [type=\"reset\"],\n  [type=\"submit\"] {\n    &:not(:disabled) {\n      cursor: pointer;\n    }\n  }\n}\n\n// Remove inner border and padding from Firefox, but don't restore the outline like Normalize.\nbutton::-moz-focus-inner,\n[type=\"button\"]::-moz-focus-inner,\n[type=\"reset\"]::-moz-focus-inner,\n[type=\"submit\"]::-moz-focus-inner {\n  padding: 0;\n  border-style: none;\n}\n\ninput[type=\"radio\"],\ninput[type=\"checkbox\"] {\n  box-sizing: border-box; // 1. Add the correct box sizing in IE 10-\n  padding: 0; // 2. Remove the padding in IE 10-\n}\n\n\ntextarea {\n  overflow: auto; // Remove the default vertical scrollbar in IE.\n  // Textareas should really only resize vertically so they don't break their (horizontal) containers.\n  resize: vertical;\n}\n\nfieldset {\n  // Browsers set a default `min-width: min-content;` on fieldsets,\n  // unlike e.g. `<div>`s, which have `min-width: 0;` by default.\n  // So we reset that to ensure fieldsets behave more like a standard block element.\n  // See https://github.com/twbs/bootstrap/issues/12359\n  // and https://html.spec.whatwg.org/multipage/#the-fieldset-and-legend-elements\n  min-width: 0;\n  // Reset the default outline behavior of fieldsets so they don't affect page layout.\n  padding: 0;\n  margin: 0;\n  border: 0;\n}\n\n// 1. Correct the text wrapping in Edge and IE.\n// 2. Correct the color inheritance from `fieldset` elements in IE.\nlegend {\n  display: block;\n  width: 100%;\n  max-width: 100%; // 1\n  padding: 0;\n  margin-bottom: .5rem;\n  @include font-size(1.5rem);\n  line-height: inherit;\n  color: inherit; // 2\n  white-space: normal; // 1\n}\n\nprogress {\n  vertical-align: baseline; // Add the correct vertical alignment in Chrome, Firefox, and Opera.\n}\n\n// Correct the cursor style of increment and decrement buttons in Chrome.\n[type=\"number\"]::-webkit-inner-spin-button,\n[type=\"number\"]::-webkit-outer-spin-button {\n  height: auto;\n}\n\n[type=\"search\"] {\n  // This overrides the extra rounded corners on search inputs in iOS so that our\n  // `.form-control` class can properly style them. Note that this cannot simply\n  // be added to `.form-control` as it's not specific enough. For details, see\n  // https://github.com/twbs/bootstrap/issues/11586.\n  outline-offset: -2px; // 2. Correct the outline style in Safari.\n  -webkit-appearance: none;\n}\n\n//\n// Remove the inner padding in Chrome and Safari on macOS.\n//\n\n[type=\"search\"]::-webkit-search-decoration {\n  -webkit-appearance: none;\n}\n\n//\n// 1. Correct the inability to style clickable types in iOS and Safari.\n// 2. Change font properties to `inherit` in Safari.\n//\n\n::-webkit-file-upload-button {\n  font: inherit; // 2\n  -webkit-appearance: button; // 1\n}\n\n//\n// Correct element displays\n//\n\noutput {\n  display: inline-block;\n}\n\nsummary {\n  display: list-item; // Add the correct display in all browsers\n  cursor: pointer;\n}\n\ntemplate {\n  display: none; // Add the correct display in IE\n}\n\n// Always hide an element with the `hidden` HTML attribute (from PureCSS).\n// Needed for proper display in IE 10-.\n[hidden] {\n  display: none !important;\n}\n","//\n// Variables\n//\n\n// Global settings\n\n$enable-caret: true !default;\n$enable-rounded: true !default;\n$enable-shadows: true !default;\n$enable-gradients: false !default;\n$enable-transitions: true !default;\n$enable-grid-classes: true !default;\n$enable-print-styles: true !default;\n\n// Color system\n\n$white: #fff !default;\n$gray-100: #f6f9fc !default;\n$gray-200: #e9ecef !default;\n$gray-300: #dee2e6 !default;\n$gray-400: #ced4da !default;\n$gray-500: #adb5bd !default;\n$gray-600: #8898aa !default; // Line footer color\n$gray-700: #525f7f !default; // Line p color\n$gray-800: #32325d !default; // Line heading color\n$gray-900: #212529 !default;\n$black: #000 !default;\n\n$grays: () !default;\n$grays: map-merge(\n  (\n    \"100\": $gray-100,\n    \"200\": $gray-200,\n    \"300\": $gray-300,\n    \"400\": $gray-400,\n    \"500\": $gray-500,\n    \"600\": $gray-600,\n    \"700\": $gray-700,\n    \"800\": $gray-800,\n    \"900\": $gray-900,\n  ),\n  $grays\n);\n\n$blue: #3ba371 !default;\n$indigo: #5603ad !default;\n$purple: #8965e0 !default;\n$pink: #f3a4b5 !default;\n$red: #f5365c !default;\n$orange: #fb6340 !default;\n$yellow: #ffd600 !default;\n$green: #3aa170 !default;\n$teal: #278e69 !default;\n$cyan: #2bffc6 !default;\n\n$colors: () !default;\n$colors: map-merge(\n  (\n    \"blue\": $blue,\n    \"indigo\": $indigo,\n    \"purple\": $purple,\n    \"pink\": $pink,\n    \"red\": $red,\n    \"orange\": $orange,\n    \"yellow\": $yellow,\n    \"green\": $green,\n    \"teal\": $teal,\n    \"cyan\": $cyan,\n    \"white\": $white,\n    \"gray\": $gray-600,\n    \"light\": $gray-400,\n    \"lighter\": $gray-200,\n    \"gray-dark\": $gray-800,\n  ),\n  $colors\n);\n\n$default: #ffd88c !default;\n$yellow_cus: #fe7650 !default;\n$primary: #3ba371 !default;\n$secondary: #f7fafc !default;\n$success: $green !default;\n$info: $teal !default;\n$warning: $orange !default;\n$danger: $red !default;\n$light: $gray-500 !default;\n$dark: $gray-900 !default;\n$darker: darken($gray-900, 15%) !default;\n\n$facebook: #3b5999 !default;\n$twitter: #1da1f2 !default;\n$google-plus: #dd4b39 !default;\n$instagram: #e4405f !default;\n$pinterest: #bd081c !default;\n$youtube: #cd201f !default;\n$slack: #3aaf85 !default;\n$dribbble: #ea4c89 !default;\n$github: #222222 !default;\n\n$theme-colors: () !default;\n$theme-colors: map-merge(\n  (\n    \"default\": $default,\n    \"primary\": $primary,\n    \"secondary\": $secondary,\n    \"success\": $success,\n    \"info\": $info,\n    \"warning\": $warning,\n    \"danger\": $danger,\n    \"white\": $white,\n    \"neutral\": $white,\n    \"dark\": $dark,\n    \"darker\": $darker,\n  ),\n  $theme-colors\n);\n\n$brand-colors: () !default;\n$brand-colors: map-merge(\n  (\n    \"facebook\": $facebook,\n    \"twitter\": $twitter,\n    \"google-plus\": $google-plus,\n    \"instagram\": $instagram,\n    \"pinterest\": $pinterest,\n    \"youtube\": $youtube,\n    \"slack\": $slack,\n    \"dribbble\": $dribbble,\n    \"github\": $github,\n  ),\n  $brand-colors\n);\n\n$shape-colors: () !default;\n$shape-colors: map-merge(\n  (\n    \"default\": #32325d,\n    \"primary\": #5533ff,\n    \"secondary\": #24b47e,\n    \"neutral\": #e9ecef,\n    \"blue-gray\": #b2cbe1,\n  ),\n  $shape-colors\n);\n\n$shapes-primary-colors: () !default;\n$shapes-primary-colors: map-merge(\n  (\n    \"step-1-gradient-bg\": #281483,\n    \"step-2-gradient-bg\": #8f6ed5,\n    \"step-3-gradient-bg\": #d782d9,\n    \"span-1-bg\": #53f,\n    \"span-2-bg\": #4553ff,\n    \"span-3-bg\": #4f40ff,\n    \"span-4-bg\": #25ddf5,\n    \"span-5-bg\": #1fa2ff,\n  ),\n  $shapes-primary-colors\n);\n\n$shapes-default-colors: () !default;\n$shapes-default-colors: map-merge(\n  (\n    \"step-1-gradient-bg\": #7795f8,\n    \"step-2-gradient-bg\": #6772e5,\n    \"step-3-gradient-bg\": #555abf,\n    \"span-1-bg\": #7795f8,\n    \"span-2-bg\": #7b9aff,\n    \"span-3-bg\": #6f8ff8,\n    \"span-4-bg\": #76eea7,\n    \"span-5-bg\": #6adaff,\n  ),\n  $shapes-default-colors\n);\n\n$shapes-light-colors: () !default;\n$shapes-light-colors: map-merge(\n  (\n    \"step-1-gradient-bg\": #b2cbe1,\n    \"step-2-gradient-bg\": #f6f9fc,\n    \"step-3-gradient-bg\": #f6f9fc,\n    \"span-1-bg\": #b4cce1,\n    \"span-2-bg\": #c5dbef,\n    \"span-3-bg\": #b9d5ed,\n    \"span-4-bg\": #74e4a2,\n    \"span-5-bg\": #008169,\n  ),\n  $shapes-light-colors\n);\n\n$shapes-dark-colors: () !default;\n$shapes-dark-colors: map-merge(\n  (\n    \"step-1-gradient-bg\": #32325d,\n    \"step-2-gradient-bg\": #32325d,\n    \"step-3-gradient-bg\": #32325d,\n    \"span-1-bg\": #2e2e57,\n    \"span-2-bg\": #2b2b58,\n    \"span-3-bg\": #25254d,\n    \"span-4-bg\": #d782d9,\n    \"span-5-bg\": #008169,\n  ),\n  $shapes-dark-colors\n);\n\n// Translucent color variations\n$translucent-color-opacity: 0.6 !default;\n\n// Set a specific jump point for requesting color jumps\n$theme-color-interval: 8% !default;\n\n// The yiq lightness value that determines when the lightness of color changes from \"dark\" to \"light\". Acceptable values are between 0 and 255.\n$yiq-contrasted-threshold: 200 !default;\n\n// Customize the light and dark text colors for use in our YIQ color contrast function.\n$yiq-text-dark: $gray-900 !default;\n$yiq-text-light: $white !default;\n\n// Action colors\n\n$star-rating-color: $gray-400 !default;\n$star-rating-color-active: $yellow !default;\n\n$favorite-color: $yellow !default;\n$like-color: $blue !default;\n$love-color: $red !default;\n\n// Body\n\n$body-bg: #f8f9fe !default;\n$body-color: $gray-700 !default;\n\n// Sections\n\n$section-colors: () !default;\n$section-colors: map-merge(\n  (\n    \"primary\": $body-bg,\n    \"secondary\": $secondary,\n    \"light\": $gray-400,\n    \"dark\": $dark,\n    \"darker\": $darker,\n  ),\n  $section-colors\n);\n\n// Links\n\n$link-color: $primary !default;\n$link-decoration: none !default;\n$link-hover-color: darken($link-color, 15%) !default;\n$link-hover-decoration: none !default;\n\n// Grid breakpoints\n\n$grid-breakpoints: (\n  xs: 0,\n  sm: 576px,\n  md: 768px,\n  lg: 992px,\n  xl: 1200px,\n);\n\n@include _assert-ascending($grid-breakpoints, \"$grid-breakpoints\");\n@include _assert-starts-at-zero($grid-breakpoints);\n\n// Grid containers\n//\n// Define the maximum width of `.container` for different screen sizes.\n\n// Spacing\n\n$spacer: 1rem !default;\n$spacers: () !default;\n$spacers: map-merge(\n  (\n    -9: -($spacer * 10),\n    -8: -($spacer * 8),\n    -7: -($spacer * 6),\n    -6: -($spacer * 4.5),\n    -5: -($spacer * 3),\n    -4: -($spacer * 1.5),\n    -3: -$spacer,\n    -2: -($spacer * 0.5),\n    -1: -($spacer * 0.25),\n    0: 0,\n    1: ($spacer * 0.25),\n    2: ($spacer * 0.5),\n    3: $spacer,\n    4: ($spacer * 1.5),\n    5: ($spacer * 3),\n    6: ($spacer * 4.5),\n    7: ($spacer * 6),\n    8: ($spacer * 8),\n    9: ($spacer * 10)\n  ),\n  $spacers\n);\n\n// This variable affects the `.h-*` and `.w-*` classes.\n\n$sizes: () !default;\n$sizes: map-merge(\n  (\n    25: 25%,\n    50: 50%,\n    75: 75%,\n    100: 100%,\n  ),\n  $sizes\n);\n\n// Components\n\n$shape-height-xl: 1.5 !default;\n$shape-height-lg: 1.5 !default;\n$shape-height-sm: 1.5 !default;\n\n$border-width: 1px !default;\n$border-color: $gray-200 !default;\n\n$border-radius: 0.375rem !default;\n$border-radius-xl: 0.5rem !default;\n$border-radius-lg: 0.4375rem !default;\n$border-radius-sm: 0.25rem !default;\n\n$box-shadow-sm: 0 0 0.5rem rgba($gray-600, 0.075) !default;\n$box-shadow: 0 0 2rem 0 rgba($gray-600, 0.15) !default;\n$box-shadow-lg: 0 0 3rem rgba($gray-600, 0.175) !default;\n\n$component-active-color: $white !default;\n$component-active-bg: theme-color(\"primary\") !default;\n$component-active-border-color: theme-color(\"primary\") !default;\n\n$component-hover-color: $gray-300 !default;\n$component-hover-bg: $gray-300 !default;\n$component-hover-border-color: $gray-300 !default;\n\n$caret-width: 0.3em !default;\n\n$transition-base: all 0.15s ease !default;\n$transition-fade: opacity 0.15s linear !default;\n$transition-collapse: height 0.35s ease !default;\n\n// Fonts\n\n$font-family-sans-serif:\n  Open Sans,\n  sans-serif !default;\n$font-family-base: $font-family-sans-serif !default;\n\n$font-size-base: 1rem !default; // Assumes the browser default, typically `16px`\n$font-size-xl: ($font-size-base * 1.5);\n$font-size-lg: ($font-size-base * 1.25);\n$font-size-sm: ($font-size-base * 0.875);\n$font-size-xs: ($font-size-base * 0.75);\n\n$font-weight-light: 300 !default;\n$font-weight-normal: 400 !default;\n$font-weight-bold: 600 !default;\n$font-weight-extra-bold: 700 !default;\n\n$font-weight-base: $font-weight-normal !default;\n$line-height-base: 1.5 !default;\n$shape-height-base: 1.5 !default;\n\n$h1-font-size: $font-size-base * 1.625 !default;\n$h2-font-size: $font-size-base * 1.25 !default;\n$h3-font-size: $font-size-base * 1.0625 !default;\n$h4-font-size: $font-size-base * 0.9375 !default;\n$h5-font-size: $font-size-base * 0.8125 !default;\n$h6-font-size: $font-size-base * 0.625 !default;\n\n$headings-margin-bottom: ($spacer / 2);\n$headings-font-family: inherit !default;\n$headings-font-weight: $font-weight-bold !default;\n$headings-line-height: 1.5 !default;\n$headings-color: $gray-800 !default;\n\n$heading-letter-spacing: 0.025em !default;\n$heading-font-size: 0.95rem !default;\n$heading-text-transform: uppercase !default;\n$heading-font-weight: $headings-font-weight !default;\n\n$heading-title-letter-spacing: 0.025em !default;\n$heading-title-font-size: 1.375rem !default;\n$heading-title-font-weight: $font-weight-bold !default;\n$heading-title-text-transform: uppercase !default;\n\n$heading-section-letter-spacing: 0.025em !default;\n$heading-section-font-size: 1.375rem !default;\n$heading-section-font-weight: $font-weight-bold !default;\n$heading-section-text-transform: uppercase !default;\n\n$display1-size: 3.3rem !default;\n$display2-size: 2.75rem !default;\n$display3-size: 2.1875rem !default;\n$display4-size: 1.6275rem !default;\n\n$display1-weight: $font-weight-bold !default;\n$display2-weight: $font-weight-bold !default;\n$display3-weight: $font-weight-bold !default;\n$display4-weight: $font-weight-bold !default;\n$display-line-height: $headings-line-height !default;\n\n$paragraph-font-size: 1rem !default;\n$paragraph-font-weight: 300 !default;\n$paragraph-line-height: 1.7 !default;\n\n$lead-font-size: ($paragraph-font-size * 1.25) !default;\n$lead-font-weight: 300 !default;\n\n$small-font-size: 80% !default;\n\n$text-muted: $gray-600 !default;\n\n$blockquote-small-color: $gray-600 !default;\n$blockquote-font-size: ($font-size-base * 1.25) !default;\n\n$hr-border-color: rgba($black, 0.1);\n$hr-border-width: $border-width !default;\n\n$mark-padding: 0.2em !default;\n\n$dt-font-weight: $font-weight-bold !default;\n\n$list-inline-padding: 0.5rem !default;\n\n$mark-bg: #fcf8e3 !default;\n\n$hr-margin-y: $spacer * 2 !default;\n\n// Icons\n\n$icon-size: 3rem !default;\n$icon-size-xl: 5rem !default;\n$icon-size-lg: 4rem !default;\n$icon-size-sm: 2rem !default;\n\n// Tables\n\n$table-cell-padding: 1rem !default;\n$table-cell-padding-sm: 0.5rem !default;\n\n$table-bg: transparent !default;\n$table-accent-bg: rgba($black, 0.05) !default;\n$table-hover-bg: $gray-100 !default;\n$table-active-bg: $table-hover-bg !default;\n\n$table-border-width: $border-width !default;\n$table-border-color: $gray-200 !default;\n\n$table-head-bg: $gray-100 !default;\n$table-head-color: $gray-600 !default;\n$table-head-spacer-y: 0.75rem !default;\n\n$table-head-font-size: 0.65rem !default;\n$table-head-font-weight: $font-weight-bold !default;\n$table-head-text-transform: uppercase !default;\n$table-head-letter-spacing: 1px !default;\n\n$table-body-font-size: 0.8125rem !default;\n\n$table-dark-bg: theme-color(\"default\") !default;\n$table-dark-accent-bg: rgba($white, 0.05) !default;\n$table-dark-hover-bg: rgba($white, 0.075) !default;\n$table-dark-border-color: lighten(theme-color(\"default\"), 7%) !default;\n$table-dark-color: $body-bg !default;\n\n$table-dark-head-bg: lighten(theme-color(\"default\"), 4%) !default;\n$table-dark-head-color: lighten(theme-color(\"default\"), 35%) !default;\n\n// Buttons + Forms\n\n$input-btn-padding-y: 0.625rem !default;\n$input-btn-padding-x: 0.75rem !default;\n$input-btn-line-height: $shape-height-base !default;\n\n$input-btn-focus-width: 0 !default;\n$input-btn-focus-color: rgba($component-active-bg, 1) !default;\n$input-btn-focus-box-shadow: none !default;\n\n$input-btn-padding-y-sm: 0.25rem !default;\n$input-btn-padding-x-sm: 0.5rem !default;\n$input-btn-line-height-sm: $shape-height-sm !default;\n\n$input-btn-padding-y-lg: 0.875rem !default;\n$input-btn-padding-x-lg: 1rem !default;\n$input-btn-line-height-lg: $shape-height-lg !default;\n\n$input-btn-border-width: 1px !default;\n\n$input-btn-font-size-sm: 0.75rem !default;\n$input-btn-font-size: 0.875rem !default;\n$input-btn-font-size-lg: 0.875rem !default;\n\n// Buttons\n\n$btn-padding-y: $input-btn-padding-y !default;\n$btn-padding-x: $input-btn-padding-x + 0.5 !default;\n$btn-line-height: $input-btn-line-height !default;\n\n$btn-padding-y-sm: $input-btn-padding-y-sm !default;\n$btn-padding-x-sm: $input-btn-padding-x-sm !default;\n$btn-line-height-sm: $input-btn-line-height-sm !default;\n\n$btn-padding-y-lg: $input-btn-padding-y-lg !default;\n$btn-padding-x-lg: $input-btn-padding-x-lg !default;\n$btn-line-height-lg: $input-btn-line-height-lg !default;\n\n$btn-border-width: $input-btn-border-width !default;\n\n$btn-font-weight: 600 !default;\n\n$btn-text-transform: none !default;\n\n$btn-letter-spacing: 0.025em !default;\n$btn-box-shadow:\n  0 4px 6px rgba(50, 50, 93, 0.11),\n  0 1px 3px rgba(0, 0, 0, 0.08) !default;\n$btn-hover-box-shadow:\n  0 7px 14px rgba(50, 50, 93, 0.1),\n  0 3px 6px rgba(0, 0, 0, 0.08) !default;\n$btn-focus-box-shadow: $btn-hover-box-shadow !default;\n$btn-focus-width: $input-btn-focus-width !default;\n$btn-active-box-shadow: none !default;\n\n$btn-hover-translate-y: -1px !default;\n\n// Forms\n\n$input-padding-y: $input-btn-padding-y !default;\n$input-padding-x: $input-btn-padding-x !default;\n$input-line-height: $input-btn-line-height !default;\n\n$input-padding-y-sm: $input-btn-padding-y-sm !default;\n$input-padding-x-sm: $input-btn-padding-x-sm !default;\n$input-line-height-sm: $input-btn-line-height-sm !default;\n\n$input-padding-y-lg: $input-btn-padding-y-lg !default;\n$input-padding-x-lg: $input-btn-padding-x-lg !default;\n$input-line-height-lg: $input-btn-line-height-lg !default;\n\n$input-border-radius: $border-radius !default;\n$input-border-radius-xl: $border-radius-xl !default;\n$input-border-radius-lg: $border-radius-lg !default;\n$input-border-radius-sm: $border-radius-sm !default;\n\n$input-bg: $white !default;\n$input-disabled-bg: $gray-200 !default;\n\n$input-muted-bg: #f7fafe !default;\n$input-focus-muted-bg: lighten($input-muted-bg, 1%) !default;\n\n$input-alternative-box-shadow:\n  0 1px 3px rgba(50, 50, 93, 0.15),\n  0 1px 0 rgba(0, 0, 0, 0.02) !default;\n$input-focus-alternative-box-shadow:\n  0 4px 6px rgba(50, 50, 93, 0.11),\n  0 1px 3px rgba(0, 0, 0, 0.08) !default;\n\n$input-color: $gray-600 !default;\n$input-border-color: #cad1d7 !default;\n$input-border-width: $input-btn-border-width !default;\n$input-box-shadow: none !default; // 0 1px 3px 0 $gray-400 !default;\n\n$input-focus-bg: $white !default;\n$input-focus-border-color: rgba(50, 151, 211, 0.25) !default;\n$input-focus-color: $input-color !default;\n$input-focus-width: 0 !default;\n$input-focus-box-shadow: none !default; //0 1px 3px 0 $gray-500 !default;\n\n$input-placeholder-color: $gray-500 !default;\n$input-focus-placeholder-color: $gray-500 !default;\n\n$input-height-border: $input-border-width * 2 !default;\n\n$input-transition: all 0.2s cubic-bezier(0.68, -0.55, 0.265, 1.55) !default;\n\n// Input groups\n\n$input-group-addon-color: $input-placeholder-color !default;\n$input-group-addon-bg: $input-bg !default;\n$input-group-addon-border-color: $input-border-color !default;\n\n$input-group-addon-focus-color: $input-focus-color !default;\n$input-group-addon-focus-bg: $input-focus-bg !default;\n$input-group-addon-focus-border-color: $input-focus-border-color !default;\n\n// Form group\n\n$form-group-margin-bottom: 1.5rem !default;\n\n// Custom forms\n\n$custom-control-gutter: 1.75rem !default;\n$custom-control-spacer-x: 1rem !default;\n$custom-control-indicator-size: 1.25rem !default;\n\n$custom-control-indicator-bg: $input-bg !default;\n$custom-control-indicator-border-width: 1px !default;\n$custom-control-indicator-border-color: $input-border-color !default;\n$custom-control-indicator-box-shadow: none !default;\n\n$custom-control-indicator-focus-box-shadow: $custom-control-indicator-box-shadow !default;\n\n$custom-control-indicator-hover-color: $component-hover-color !default;\n$custom-control-indicator-hover-bg: $component-hover-bg !default;\n$custom-control-indicator-hover-border-color: $component-hover-border-color !default;\n\n$custom-control-indicator-active-color: $component-active-color !default;\n$custom-control-indicator-active-bg: $component-active-bg !default;\n$custom-control-indicator-active-border-color: $component-active-border-color !default;\n$custom-control-indicator-active-box-shadow: $custom-control-indicator-box-shadow !default;\n\n$custom-control-indicator-checked-color: $component-active-color !default;\n$custom-control-indicator-checked-bg: $component-active-bg !default;\n$custom-control-indicator-checked-border-color: $component-active-border-color !default;\n$custom-control-indicator-checked-box-shadow: $custom-control-indicator-box-shadow !default;\n$custom-control-indicator-checked-disabled-bg: rgba(\n  theme-color(\"primary\"),\n  0.5\n) !default;\n\n$custom-control-indicator-disabled-bg: $gray-200 !default;\n$custom-control-label-disabled-color: $gray-600 !default;\n\n$custom-checkbox-indicator-border-radius: $border-radius-sm !default;\n//$custom-checkbox-indicator-icon-checked:        str-replace(url(\"data:image/svg+xml !default;charset=utf8,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 8 8'%3E%3Cpath fill='%23fff' d='M6.564.75l-3.59 3.612-1.538-1.55L0 4.26 2.974 7.25 8 2.193z'/%3E%3C/svg%3E\"), \"#\", \"%23\") !default;\n\n// Custom toggle\n\n$custom-toggle-width: 50px !default;\n$custom-toggle-slider-bg: $gray-200 !default;\n$custom-toggle-checked-bg: theme-color(\"primary\") !default;\n\n// Form validation\n\n$form-feedback-valid-bg: lighten($success, 15%) !default;\n$form-feedback-valid-color: theme-color(\"success\") !default;\n$form-feedback-invalid-bg: lighten($warning, 15%) !default;\n$form-feedback-invalid-color: theme-color(\"warning\") !default;\n\n// Allows for customizing button radius independently from global border radius\n\n$btn-border-radius: $input-border-radius !default;\n$btn-border-radius-xl: $input-border-radius-xl !default;\n$btn-border-radius-lg: $input-border-radius-lg !default;\n$btn-border-radius-sm: $input-border-radius !default;\n\n$chart-height: 350px !default;\n$chart-height-sm: 230px !default;\n\n$chart-legend-margin-top: 2.5rem !default;\n$chart-legend-font-size: $font-size-sm !default;\n$chart-legend-color: $text-muted !default;\n$chart-legend-height: $chart-legend-margin-top + $chart-legend-font-size *\n  $line-height-base !default;\n\n// Map\n$map-height: 500px !default;\n\n// No UI Slider\n\n$noui-target-bg: #eceeef !default;\n$noui-target-thickness: 5px !default;\n$noui-target-border-radius: 5px !default;\n$noui-target-border-color: 0 !default;\n$noui-target-box-shadow: inset 0 1px 2px rgba(90, 97, 105, 0.1) !default;\n\n$noui-slider-connect-bg: $primary !default;\n$noui-slider-connect-disabled-bg: #b2b2b2 !default;\n\n$noui-handle-width: 15px !default;\n$noui-handle-bg: theme-color(\"primary\") !default;\n$noui-handle-border: 0 !default;\n$noui-handle-border-radius: 100% !default;\n\n$noui-origin-border-radius: 2px !default;\n\n// Dropdown\n\n$dropdown-bg: $white !default;\n$dropdown-border-width: 0 !default;\n$dropdown-border-color: rgba($black, 0.15) !default;\n$dropdown-border-radius: $border-radius-lg !default;\n$dropdown-box-shadow:\n  0 50px 100px rgba(50, 50, 93, 0.1),\n  0 15px 35px rgba(50, 50, 93, 0.15),\n  0 5px 15px rgba(0, 0, 0, 0.1) !default;\n\n// Navs\n\n$nav-link-padding-y: 0.25rem !default;\n$nav-link-padding-x: 0.75rem !default;\n$nav-link-color: $gray-700 !default;\n$nav-link-hover-color: theme-color(\"primary\") !default;\n$nav-link-disabled-color: $gray-600 !default;\n\n$nav-pills-padding-y: 0.75rem !default;\n$nav-pills-padding-x: 1rem !default;\n\n$nav-pills-space-x: 1rem !default;\n\n$nav-pills-bg: $white !default;\n$nav-pills-border-width: 1px !default;\n$nav-pills-border-color: theme-color(\"primary\") !default;\n$nav-pills-border-radius: $border-radius !default;\n\n$nav-pills-link-color: theme-color(\"primary\") !default;\n$nav-pills-link-hover-color: darken(theme-color(\"primary\"), 5%) !default;\n$nav-pills-link-active-color: color-yiq(theme-color(\"primary\")) !default;\n$nav-pills-link-active-bg: theme-color(\"primary\") !default;\n$nav-pills-box-shadow: $btn-box-shadow !default;\n\n// Navbar\n\n$navbar-transition: all 0.15s linear !default;\n$navbar-padding-y: 1rem !default;\n$navbar-padding-x: 1rem !default;\n\n$navbar-nav-link-padding-x: 1rem !default;\n$navbar-nav-link-padding-y: 1rem !default;\n\n$navbar-nav-link-font-size: 0.9rem !default;\n$navbar-nav-link-font-weight: 400 !default;\n$navbar-nav-link-text-transform: normal !default;\n$navbar-nav-link-letter-spacing: 0 !default;\n$navbar-nav-link-border-radius: $border-radius !default;\n\n$navbar-search-width: 270px !default;\n$navbar-search-bg: transparent !default;\n\n$navbar-search-border-radius: 2rem !default;\n$navbar-search-border-width: 2px !default;\n\n$navbar-dark-bg: transparent !default;\n$navbar-dark-hover-bg: rgba(255, 255, 255, 0.1) !default;\n$navbar-dark-active-bg: rgba(255, 255, 255, 0.1) !default;\n$navbar-dark-color: rgba($white, 0.95) !default;\n$navbar-dark-hover-color: rgba($white, 0.65) !default;\n$navbar-dark-active-color: rgba($white, 0.65) !default;\n$navbar-dark-disabled-color: rgba($white, 0.25) !default;\n$navbar-dark-toggler-border-color: transparent !default;\n\n$navbar-search-dark-border-color: rgba(255, 255, 255, 0.6) !default;\n$navbar-search-dark-color: rgba(255, 255, 255, 0.6) !default;\n$navbar-search-dark-focus-border-color: rgba(255, 255, 255, 0.9) !default;\n$navbar-search-dark-focus-color: rgba(255, 255, 255, 0.9) !default;\n\n$navbar-light-bg: transparent !default;\n$navbar-light-hover-bg: rgba(0, 0, 0, 0.1) !default;\n$navbar-light-active-bg: rgba(0, 0, 0, 0.1) !default;\n$navbar-light-border-color: $gray-100 !default;\n$navbar-light-color: rgba($black, 0.5) !default;\n$navbar-light-hover-color: rgba($black, 0.7) !default;\n$navbar-light-active-color: rgba($black, 0.9) !default;\n$navbar-light-disabled-color: rgba($black, 0.3) !default;\n$navbar-light-toggler-border-color: transparent !default;\n\n$navbar-search-light-border-color: rgba(0, 0, 0, 0.6) !default;\n$navbar-search-light-color: rgba(0, 0, 0, 0.6) !default;\n$navbar-search-light-focus-border-color: rgba(0, 0, 0, 0.9) !default;\n$navbar-search-light-focus-color: rgba(0, 0, 0, 0.9) !default;\n\n// Vertical navbar\n$navbar-vertical-box-shadow: 0 0 2rem 0 rgba(136, 152, 170, 0.15) !important;\n$navbar-vertical-width: 250px !default;\n$navbar-vertical-padding-x: 1.5rem !default;\n$navbar-vertical-nav-link-padding-x: 1.5rem !default;\n$navbar-vertical-nav-link-padding-y: 0.65rem !default;\n\n$navbar-icon-min-width: 2.25rem !default;\n\n$navbar-breadcrumb-padding-y: $nav-link-padding-y !default;\n$navbar-breadcrumb-padding-x: 0 !default;\n\n$navbar-light-bg: $white !default;\n$navbar-light-border-color: $border-color !default;\n\n// Main content\n\n$main-content-padding-y: 40px !default;\n$main-content-padding-x: 24px !default; // in px to combine with $grid-gutter-width\n\n// Alerts\n\n$alert-padding-y: 1rem !default;\n$alert-padding-x: 1.5rem !default;\n$alert-border-radius: $border-radius !default;\n\n$alert-bg-level: -2 !default;\n$alert-border-level: -2 !default;\n$alert-color-level: 0 !default;\n\n// List group\n\n$list-group-bg: $white !default;\n$list-group-border-color: $border-color !default; //rgba($black, .125);\n$list-group-border-width: $border-width !default;\n$list-group-border-radius: $border-radius !default;\n\n$list-group-item-padding-y: 1rem !default;\n$list-group-item-padding-x: 1rem !default;\n\n$list-group-hover-bg: $gray-100 !default;\n$list-group-active-color: $component-active-color !default;\n$list-group-active-bg: $component-active-bg !default;\n$list-group-active-border-color: $list-group-active-bg !default;\n\n$list-group-disabled-color: $gray-600 !default;\n$list-group-disabled-bg: $list-group-bg !default;\n\n$list-group-action-color: $gray-700 !default;\n$list-group-action-hover-color: $list-group-action-color !default;\n\n$list-group-action-active-color: $list-group-action-color !default;\n$list-group-action-active-bg: $gray-200 !default;\n\n// Close\n\n$close-font-size: $font-size-base * 1.5 !default;\n$close-font-weight: $font-weight-bold !default;\n$close-bg: transparent !default;\n$close-hover-bg: transparent !default;\n$close-color: rgba(0, 0, 0, 0.6) !default !default;\n$close-hover-color: rgba(0, 0, 0, 0.9) !default;\n$close-text-shadow: none !default;\n\n// Popovers\n\n$popover-font-size: $font-size-sm !default;\n$popover-bg: $white !default;\n$popover-max-width: 276px !default;\n$popover-border-width: 1px !default;\n$popover-border-color: rgba($black, 0.05) !default;\n$popover-border-radius: $border-radius-lg !default;\n$popover-box-shadow: 0px 0.5rem 2rem 0px rgba($black, 0.2) !default;\n\n$popover-header-bg: $popover-bg !default;\n$popover-header-color: $headings-color !default;\n$popover-header-padding-y: 0.5rem !default;\n$popover-header-padding-x: 0.95rem !default;\n\n$popover-body-color: $body-color !default;\n$popover-body-padding-y: $popover-header-padding-y !default;\n$popover-body-padding-x: $popover-header-padding-x !default;\n\n$popover-arrow-width: 1.5rem !default;\n$popover-arrow-height: 0.75rem !default;\n$popover-arrow-color: $popover-bg !default;\n\n$popover-arrow-outer-color: transparent !default;\n\n// Badges\n\n$badge-font-size: 66% !default;\n$badge-font-weight: $font-weight-bold !default;\n$badge-padding-y: 0.35rem !default;\n$badge-padding-x: 0.375rem !default;\n$badge-border-radius: $border-radius !default;\n$badge-text-transfom: uppercase;\n\n$badge-pill-padding-x: 0.875em !default;\n$badge-pill-border-radius: 10rem !default;\n\n$badge-circle-size: 2rem !default;\n\n// Pagination\n\n// $pagination-padding-y:              .5rem !default;\n// $pagination-padding-x:              .75rem !default;\n// $pagination-padding-y-sm:           .25rem !default;\n// $pagination-padding-x-sm:           .5rem !default;\n// $pagination-padding-y-lg:           .75rem !default;\n// $pagination-padding-x-lg:           1.5rem !default;\n// $pagination-line-height:            1.25 !default;\n\n$pagination-color: $gray-600 !default;\n$pagination-bg: $white !default;\n$pagination-border-width: $border-width !default;\n$pagination-border-color: $gray-300 !default;\n\n//$pagination-focus-box-shadow:       $btn-hover-box-shadow !default;\n\n$pagination-hover-color: $gray-600 !default;\n$pagination-hover-bg: $gray-300 !default;\n$pagination-hover-border-color: $gray-300 !default;\n\n$pagination-active-color: $component-active-color !default;\n$pagination-active-bg: $component-active-bg !default;\n$pagination-active-border-color: $pagination-active-bg !default;\n$pagination-active-box-shadow: $btn-hover-box-shadow !default;\n\n$pagination-disabled-color: $gray-600 !default;\n$pagination-disabled-bg: $white !default;\n$pagination-disabled-border-color: $gray-300 !default;\n\n// Cards\n\n$card-spacer-y: 1.25rem !default;\n$card-spacer-x: 1.5rem !default;\n$card-border-width: $border-width !default;\n$card-border-radius: $border-radius !default;\n$card-border-color: rgba($black, 0.05) !default;\n$card-inner-border-radius: calc(\n  #{$card-border-radius} - #{$card-border-width}\n) !default;\n$card-cap-bg: $white !default;\n$card-bg: $white !default;\n\n$card-img-overlay-padding: 1.25rem !default;\n\n//$card-group-margin:                 ($grid-gutter-width / 2);\n//$card-deck-margin:                  $card-group-margin !default;\n\n$card-columns-count: 3 !default;\n$card-columns-gap: 1.25rem !default;\n$card-columns-margin: $card-spacer-y !default;\n\n// Tooltips\n\n$tooltip-font-size: $font-size-sm !default;\n\n// Modals\n\n$modal-inner-padding: 1.5rem !default;\n\n$modal-lg: 800px !default;\n$modal-md: 500px !default;\n$modal-sm: 380px !default;\n\n$modal-title-line-height: 1.1;\n\n$modal-content-bg: $white !default;\n$modal-content-border-color: rgba($black, 0.2) !default;\n$modal-content-border-width: 0 !default;\n$modal-content-border-radius: $border-radius-lg !default;\n$modal-content-box-shadow-xs:\n  0 15px 35px rgba(50, 50, 93, 0.2),\n  0 5px 15px rgba(0, 0, 0, 0.17);\n$modal-content-box-shadow-sm-up:\n  0 15px 35px rgba(50, 50, 93, 0.2),\n  0 5px 15px rgba(0, 0, 0, 0.17);\n\n$modal-backdrop-bg: $black !default;\n$modal-backdrop-opacity: 0.16 !default;\n$modal-header-border-color: $gray-200 !default;\n$modal-footer-border-color: $modal-header-border-color !default;\n$modal-header-border-width: $modal-content-border-width !default;\n$modal-footer-border-width: $modal-header-border-width !default;\n$modal-header-padding: 1.25rem !default;\n\n// Datepicker\n\n$datepicker-border-radius: $card-border-radius !default;\n$datepicker-dropdown-padding: 20px 22px !default;\n\n$datepicker-cell-transition: $transition-base !default;\n$datepicker-cell-hover-background: lighten($gray-400, 55%);\n$datepicker-cell-border-radius: 50% !default;\n$datepicker-cell-width: 36px !default;\n$datepicker-cell-height: 36px !default;\n\n$datepicker-disabled-cell-color: $gray-300 !default;\n$datepicker-disabled-old-new-color: $gray-500 !default;\n\n$datepicker-header-cell-border-radius: $border-radius !default;\n\n$datepicker-active-color: $white !default;\n$datepicker-active-background: theme-color(\"primary\") !default;\n$datepicker-active-box-shadow: none !default;\n\n$datepicker-range-background: theme-color(\"primary\") !default;\n$datepicker-range-cell-focused-background: darken(\n  $datepicker-range-background,\n  5%\n);\n$datepicker-range-color: $white !default;\n$datepicker-range-highlighted-bg: $gray-200 !default;\n\n$datepicker-dropdown-border: lighten($gray-400, 40%);\n$datepicker-dropdown-bg: $white !default;\n$datepicker-highlighted-bg: $datepicker-active-background !default;\n\n// Footer\n\n$footer-padding-y: 2.5rem;\n$footer-padding-x: 0;\n\n$footer-link-font-size: 0.85rem !default;\n$footer-bg: theme-color(\"secondary\") !default;\n$footer-color: $gray-600 !default;\n$footer-link-color: $gray-600 !default;\n$footer-link-hover-color: $gray-700 !default;\n$footer-heading-color: $gray-600 !default;\n$footer-heading-font-size: $font-size-sm !default;\n\n// Import Bootstrap variable defaults\n\n@import \"~bootstrap/scss/variables\";\n\n// Theme color variables\n$color-blue-1-1: #f3f9ff;\n$dark-black: #393939;\n$bg-white: #fff;\n$grey-color: #717171;\n$orange-color: #cc9752;\n$green-color: #19b25f;\n$biege-color: #c6bdaf;\n$border-color: #b1b1b1;\n$dark-green: #42826c;\n$light-grey: #d9d9d9;\n$darken-grey: #333333;\n$border-color-dashed: #beb5a6;\n$green-shade: #36745e;\n$light-beige: #eed7b9;\n$color-red: #ff0000;\n$light-yellow: #f9f5ef;\n$shade-green: #008983;\n$shade-blue: #0f7db5;\n$grey-shade: #777777;\n$grey-shade-two: #dddddd;\n$grey-shade-three: #353535;\n$grey-shade-four: #797979;\n$light-grey-shade: #e6e6e6;\n$green-shade-two: #06b863;\n$green-shade-three: #6ab199;\n$green-shade-four: #dcf4ec;\n$red-shade-one: #d65d43;\n$red-shade-two: #f4e3dc;\n$green-shade-five: #656565;\n$grey-shade-five: #848484;\n$grey-shade-six: #454545;\n$grey-shade-seven: #d8d8d8;\n$grey-shade-eight: #5e5e5e;\n$green-shade-six: #7e8f8a;\n$green-shade-seven: #edf9f5;\n$grey-shade-light-color: #a7a7a7;\n$green-color-shade-light: #9cdac4;\n$orange-color-shade: #deb887;\n$orange-color-shade-two: #f4f3e5;\n$grey-shade-nine: #bababa;\n$grey-shade-ten: #dbdbdb;\n$dark-black-shade: #1d1d1d;\n$light-olive-color: #f2fcd3;\n$olive-color: #757536;\n$green-shade-eight: #bfbfbf;\n$grey-shade-light-color-two: #e3e3e3;\n$dark-black-dark-shade: #161616;\n$grey-shade-eleven-shade: #cfcfcf;\n$grey-shade-twelve-shade: #3f3f3f;\n$light-yellow-shade: #fffaf4;\n$light-yellow-shade-two: #dbdada;\n$light-grey-shade-lihgt: #cbcbcb;\n$light-grey-shade-light-bg: #eeeeee;\n$light-grey-shade-three: #a1a1a1;\n","// stylelint-disable property-blacklist, scss/dollar-variable-default\n\n// SCSS RFS mixin\n//\n// Automated font-resizing\n//\n// See https://github.com/twbs/rfs\n\n// Configuration\n\n// Base font size\n$rfs-base-font-size: 1.25rem !default;\n$rfs-font-size-unit: rem !default;\n\n// Breakpoint at where font-size starts decreasing if screen width is smaller\n$rfs-breakpoint: 1200px !default;\n$rfs-breakpoint-unit: px !default;\n\n// Resize font-size based on screen height and width\n$rfs-two-dimensional: false !default;\n\n// Factor of decrease\n$rfs-factor: 10 !default;\n\n@if type-of($rfs-factor) != \"number\" or $rfs-factor <= 1 {\n  @error \"`#{$rfs-factor}` is not a valid  $rfs-factor, it must be greater than 1.\";\n}\n\n// Generate enable or disable classes. Possibilities: false, \"enable\" or \"disable\"\n$rfs-class: false !default;\n\n// 1 rem = $rfs-rem-value px\n$rfs-rem-value: 16 !default;\n\n// Safari iframe resize bug: https://github.com/twbs/rfs/issues/14\n$rfs-safari-iframe-resize-bug-fix: false !default;\n\n// Disable RFS by setting $enable-responsive-font-sizes to false\n$enable-responsive-font-sizes: true !default;\n\n// Cache $rfs-base-font-size unit\n$rfs-base-font-size-unit: unit($rfs-base-font-size);\n\n// Remove px-unit from $rfs-base-font-size for calculations\n@if $rfs-base-font-size-unit == \"px\" {\n  $rfs-base-font-size: $rfs-base-font-size / ($rfs-base-font-size * 0 + 1);\n}\n@else if $rfs-base-font-size-unit == \"rem\" {\n  $rfs-base-font-size: $rfs-base-font-size / ($rfs-base-font-size * 0 + 1 / $rfs-rem-value);\n}\n\n// Cache $rfs-breakpoint unit to prevent multiple calls\n$rfs-breakpoint-unit-cache: unit($rfs-breakpoint);\n\n// Remove unit from $rfs-breakpoint for calculations\n@if $rfs-breakpoint-unit-cache == \"px\" {\n  $rfs-breakpoint: $rfs-breakpoint / ($rfs-breakpoint * 0 + 1);\n}\n@else if $rfs-breakpoint-unit-cache == \"rem\" or $rfs-breakpoint-unit-cache == \"em\" {\n  $rfs-breakpoint: $rfs-breakpoint / ($rfs-breakpoint * 0 + 1 / $rfs-rem-value);\n}\n\n// Responsive font-size mixin\n@mixin rfs($fs, $important: false) {\n  // Cache $fs unit\n  $fs-unit: if(type-of($fs) == \"number\", unit($fs), false);\n\n  // Add !important suffix if needed\n  $rfs-suffix: if($important, \" !important\", \"\");\n\n  // If $fs isn't a number (like inherit) or $fs has a unit (not px or rem, like 1.5em) or $ is 0, just print the value\n  @if not $fs-unit or $fs-unit != \"\" and $fs-unit != \"px\" and $fs-unit != \"rem\" or $fs == 0 {\n    font-size: #{$fs}#{$rfs-suffix};\n  }\n  @else {\n    // Variables for storing static and fluid rescaling\n    $rfs-static: null;\n    $rfs-fluid: null;\n\n    // Remove px-unit from $fs for calculations\n    @if $fs-unit == \"px\" {\n      $fs: $fs / ($fs * 0 + 1);\n    }\n    @else if $fs-unit == \"rem\" {\n      $fs: $fs / ($fs * 0 + 1 / $rfs-rem-value);\n    }\n\n    // Set default font-size\n    @if $rfs-font-size-unit == rem {\n      $rfs-static: #{$fs / $rfs-rem-value}rem#{$rfs-suffix};\n    }\n    @else if $rfs-font-size-unit == px {\n      $rfs-static: #{$fs}px#{$rfs-suffix};\n    }\n    @else {\n      @error \"`#{$rfs-font-size-unit}` is not a valid unit for $rfs-font-size-unit. Use `px` or `rem`.\";\n    }\n\n    // Only add media query if font-size is bigger as the minimum font-size\n    // If $rfs-factor == 1, no rescaling will take place\n    @if $fs > $rfs-base-font-size and $enable-responsive-font-sizes {\n      $min-width: null;\n      $variable-unit: null;\n\n      // Calculate minimum font-size for given font-size\n      $fs-min: $rfs-base-font-size + ($fs - $rfs-base-font-size) / $rfs-factor;\n\n      // Calculate difference between given font-size and minimum font-size for given font-size\n      $fs-diff: $fs - $fs-min;\n\n      // Base font-size formatting\n      // No need to check if the unit is valid, because we did that before\n      $min-width: if($rfs-font-size-unit == rem, #{$fs-min / $rfs-rem-value}rem, #{$fs-min}px);\n\n      // If two-dimensional, use smallest of screen width and height\n      $variable-unit: if($rfs-two-dimensional, vmin, vw);\n\n      // Calculate the variable width between 0 and $rfs-breakpoint\n      $variable-width: #{$fs-diff * 100 / $rfs-breakpoint}#{$variable-unit};\n\n      // Set the calculated font-size.\n      $rfs-fluid: calc(#{$min-width} + #{$variable-width}) #{$rfs-suffix};\n    }\n\n    // Rendering\n    @if $rfs-fluid == null {\n      // Only render static font-size if no fluid font-size is available\n      font-size: $rfs-static;\n    }\n    @else {\n      $mq-value: null;\n\n      // RFS breakpoint formatting\n      @if $rfs-breakpoint-unit == em or $rfs-breakpoint-unit == rem {\n        $mq-value: #{$rfs-breakpoint / $rfs-rem-value}#{$rfs-breakpoint-unit};\n      }\n      @else if $rfs-breakpoint-unit == px {\n        $mq-value: #{$rfs-breakpoint}px;\n      }\n      @else {\n        @error \"`#{$rfs-breakpoint-unit}` is not a valid unit for $rfs-breakpoint-unit. Use `px`, `em` or `rem`.\";\n      }\n\n      @if $rfs-class == \"disable\" {\n        // Adding an extra class increases specificity,\n        // which prevents the media query to override the font size\n        &,\n        .disable-responsive-font-size &,\n        &.disable-responsive-font-size {\n          font-size: $rfs-static;\n        }\n      }\n      @else {\n        font-size: $rfs-static;\n      }\n\n      @if $rfs-two-dimensional {\n        @media (max-width: #{$mq-value}), (max-height: #{$mq-value}) {\n          @if $rfs-class == \"enable\" {\n            .enable-responsive-font-size &,\n            &.enable-responsive-font-size {\n              font-size: $rfs-fluid;\n            }\n          }\n          @else {\n            font-size: $rfs-fluid;\n          }\n\n          @if $rfs-safari-iframe-resize-bug-fix {\n            // stylelint-disable-next-line length-zero-no-unit\n            min-width: 0vw;\n          }\n        }\n      }\n      @else {\n        @media (max-width: #{$mq-value}) {\n          @if $rfs-class == \"enable\" {\n            .enable-responsive-font-size &,\n            &.enable-responsive-font-size {\n              font-size: $rfs-fluid;\n            }\n          }\n          @else {\n            font-size: $rfs-fluid;\n          }\n\n          @if $rfs-safari-iframe-resize-bug-fix {\n            // stylelint-disable-next-line length-zero-no-unit\n            min-width: 0vw;\n          }\n        }\n      }\n    }\n  }\n}\n\n// The font-size & responsive-font-size mixin uses RFS to rescale font sizes\n@mixin font-size($fs, $important: false) {\n  @include rfs($fs, $important);\n}\n\n@mixin responsive-font-size($fs, $important: false) {\n  @include rfs($fs, $important);\n}\n","// Variables\n//\n// Variables should follow the `$component-state-property-size` formula for\n// consistent naming. Ex: $nav-link-disabled-color and $modal-content-box-shadow-xs.\n\n// Color system\n\n$white:    #fff !default;\n$gray-100: #f8f9fa !default;\n$gray-200: #e9ecef !default;\n$gray-300: #dee2e6 !default;\n$gray-400: #ced4da !default;\n$gray-500: #adb5bd !default;\n$gray-600: #6c757d !default;\n$gray-700: #495057 !default;\n$gray-800: #343a40 !default;\n$gray-900: #212529 !default;\n$black:    #000 !default;\n\n$grays: () !default;\n$grays: map-merge(\n  (\n    \"100\": $gray-100,\n    \"200\": $gray-200,\n    \"300\": $gray-300,\n    \"400\": $gray-400,\n    \"500\": $gray-500,\n    \"600\": $gray-600,\n    \"700\": $gray-700,\n    \"800\": $gray-800,\n    \"900\": $gray-900\n  ),\n  $grays\n);\n\n$blue:    #007bff !default;\n$indigo:  #6610f2 !default;\n$purple:  #6f42c1 !default;\n$pink:    #e83e8c !default;\n$red:     #dc3545 !default;\n$orange:  #fd7e14 !default;\n$yellow:  #ffc107 !default;\n$green:   #28a745 !default;\n$teal:    #20c997 !default;\n$cyan:    #17a2b8 !default;\n\n$colors: () !default;\n$colors: map-merge(\n  (\n    \"blue\":       $blue,\n    \"indigo\":     $indigo,\n    \"purple\":     $purple,\n    \"pink\":       $pink,\n    \"red\":        $red,\n    \"orange\":     $orange,\n    \"yellow\":     $yellow,\n    \"green\":      $green,\n    \"teal\":       $teal,\n    \"cyan\":       $cyan,\n    \"white\":      $white,\n    \"gray\":       $gray-600,\n    \"gray-dark\":  $gray-800\n  ),\n  $colors\n);\n\n$primary:       $blue !default;\n$secondary:     $gray-600 !default;\n$success:       $green !default;\n$info:          $cyan !default;\n$warning:       $yellow !default;\n$danger:        $red !default;\n$light:         $gray-100 !default;\n$dark:          $gray-800 !default;\n\n$theme-colors: () !default;\n$theme-colors: map-merge(\n  (\n    \"primary\":    $primary,\n    \"secondary\":  $secondary,\n    \"success\":    $success,\n    \"info\":       $info,\n    \"warning\":    $warning,\n    \"danger\":     $danger,\n    \"light\":      $light,\n    \"dark\":       $dark\n  ),\n  $theme-colors\n);\n\n// Set a specific jump point for requesting color jumps\n$theme-color-interval:      8% !default;\n\n// The yiq lightness value that determines when the lightness of color changes from \"dark\" to \"light\". Acceptable values are between 0 and 255.\n$yiq-contrasted-threshold:  150 !default;\n\n// Customize the light and dark text colors for use in our YIQ color contrast function.\n$yiq-text-dark:             $gray-900 !default;\n$yiq-text-light:            $white !default;\n\n// Characters which are escaped by the escape-svg function\n$escaped-characters: (\n  (\"<\", \"%3c\"),\n  (\">\", \"%3e\"),\n  (\"#\", \"%23\"),\n  (\"(\", \"%28\"),\n  (\")\", \"%29\"),\n) !default;\n\n\n// Options\n//\n// Quickly modify global styling by enabling or disabling optional features.\n\n$enable-caret:                                true !default;\n$enable-rounded:                              true !default;\n$enable-shadows:                              false !default;\n$enable-gradients:                            false !default;\n$enable-transitions:                          true !default;\n$enable-prefers-reduced-motion-media-query:   true !default;\n$enable-hover-media-query:                    false !default; // Deprecated, no longer affects any compiled CSS\n$enable-grid-classes:                         true !default;\n$enable-pointer-cursor-for-buttons:           true !default;\n$enable-print-styles:                         true !default;\n$enable-responsive-font-sizes:                false !default;\n$enable-validation-icons:                     true !default;\n$enable-deprecation-messages:                 true !default;\n\n\n// Spacing\n//\n// Control the default styling of most Bootstrap elements by modifying these\n// variables. Mostly focused on spacing.\n// You can add more entries to the $spacers map, should you need more variation.\n\n$spacer: 1rem !default;\n$spacers: () !default;\n$spacers: map-merge(\n  (\n    0: 0,\n    1: ($spacer * .25),\n    2: ($spacer * .5),\n    3: $spacer,\n    4: ($spacer * 1.5),\n    5: ($spacer * 3)\n  ),\n  $spacers\n);\n\n// This variable affects the `.h-*` and `.w-*` classes.\n$sizes: () !default;\n$sizes: map-merge(\n  (\n    25: 25%,\n    50: 50%,\n    75: 75%,\n    100: 100%,\n    auto: auto\n  ),\n  $sizes\n);\n\n\n// Body\n//\n// Settings for the `<body>` element.\n\n$body-bg:                   $white !default;\n$body-color:                $gray-900 !default;\n\n\n// Links\n//\n// Style anchor elements.\n\n$link-color:                              theme-color(\"primary\") !default;\n$link-decoration:                         none !default;\n$link-hover-color:                        darken($link-color, 15%) !default;\n$link-hover-decoration:                   underline !default;\n// Darken percentage for links with `.text-*` class (e.g. `.text-success`)\n$emphasized-link-hover-darken-percentage: 15% !default;\n\n// Paragraphs\n//\n// Style p element.\n\n$paragraph-margin-bottom:   1rem !default;\n\n\n// Grid breakpoints\n//\n// Define the minimum dimensions at which your layout will change,\n// adapting to different screen sizes, for use in media queries.\n\n$grid-breakpoints: (\n  xs: 0,\n  sm: 576px,\n  md: 768px,\n  lg: 992px,\n  xl: 1200px\n) !default;\n\n@include _assert-ascending($grid-breakpoints, \"$grid-breakpoints\");\n@include _assert-starts-at-zero($grid-breakpoints, \"$grid-breakpoints\");\n\n\n// Grid containers\n//\n// Define the maximum width of `.container` for different screen sizes.\n\n$container-max-widths: (\n  sm: 540px,\n  md: 720px,\n  lg: 960px,\n  xl: 1140px\n) !default;\n\n@include _assert-ascending($container-max-widths, \"$container-max-widths\");\n\n\n// Grid columns\n//\n// Set the number of columns and specify the width of the gutters.\n\n$grid-columns:                12 !default;\n$grid-gutter-width:           30px !default;\n$grid-row-columns:            6 !default;\n\n\n// Components\n//\n// Define common padding and border radius sizes and more.\n\n$line-height-lg:              1.5 !default;\n$line-height-sm:              1.5 !default;\n\n$border-width:                1px !default;\n$border-color:                $gray-300 !default;\n\n$border-radius:               .25rem !default;\n$border-radius-lg:            .3rem !default;\n$border-radius-sm:            .2rem !default;\n\n$rounded-pill:                50rem !default;\n\n$box-shadow-sm:               0 .125rem .25rem rgba($black, .075) !default;\n$box-shadow:                  0 .5rem 1rem rgba($black, .15) !default;\n$box-shadow-lg:               0 1rem 3rem rgba($black, .175) !default;\n\n$component-active-color:      $white !default;\n$component-active-bg:         theme-color(\"primary\") !default;\n\n$caret-width:                 .3em !default;\n$caret-vertical-align:        $caret-width * .85 !default;\n$caret-spacing:               $caret-width * .85 !default;\n\n$transition-base:             all .2s ease-in-out !default;\n$transition-fade:             opacity .15s linear !default;\n$transition-collapse:         height .35s ease !default;\n\n$embed-responsive-aspect-ratios: () !default;\n$embed-responsive-aspect-ratios: join(\n  (\n    (21 9),\n    (16 9),\n    (4 3),\n    (1 1),\n  ),\n  $embed-responsive-aspect-ratios\n);\n\n// Typography\n//\n// Font, line-height, and color for body text, headings, and more.\n\n// stylelint-disable value-keyword-case\n$font-family-sans-serif:      -apple-system, BlinkMacSystemFont, \"Segoe UI\", Roboto, \"Helvetica Neue\", Arial, \"Noto Sans\", \"Liberation Sans\", sans-serif, \"Apple Color Emoji\", \"Segoe UI Emoji\", \"Segoe UI Symbol\", \"Noto Color Emoji\" !default;\n$font-family-monospace:       SFMono-Regular, Menlo, Monaco, Consolas, \"Liberation Mono\", \"Courier New\", monospace !default;\n$font-family-base:            $font-family-sans-serif !default;\n// stylelint-enable value-keyword-case\n\n$font-size-base:              1rem !default; // Assumes the browser default, typically `16px`\n$font-size-lg:                $font-size-base * 1.25 !default;\n$font-size-sm:                $font-size-base * .875 !default;\n\n$font-weight-lighter:         lighter !default;\n$font-weight-light:           300 !default;\n$font-weight-normal:          400 !default;\n$font-weight-bold:            700 !default;\n$font-weight-bolder:          bolder !default;\n\n$font-weight-base:            $font-weight-normal !default;\n$line-height-base:            1.5 !default;\n\n$h1-font-size:                $font-size-base * 2.5 !default;\n$h2-font-size:                $font-size-base * 2 !default;\n$h3-font-size:                $font-size-base * 1.75 !default;\n$h4-font-size:                $font-size-base * 1.5 !default;\n$h5-font-size:                $font-size-base * 1.25 !default;\n$h6-font-size:                $font-size-base !default;\n\n$headings-margin-bottom:      $spacer / 2 !default;\n$headings-font-family:        null !default;\n$headings-font-weight:        500 !default;\n$headings-line-height:        1.2 !default;\n$headings-color:              null !default;\n\n$display1-size:               6rem !default;\n$display2-size:               5.5rem !default;\n$display3-size:               4.5rem !default;\n$display4-size:               3.5rem !default;\n\n$display1-weight:             300 !default;\n$display2-weight:             300 !default;\n$display3-weight:             300 !default;\n$display4-weight:             300 !default;\n$display-line-height:         $headings-line-height !default;\n\n$lead-font-size:              $font-size-base * 1.25 !default;\n$lead-font-weight:            300 !default;\n\n$small-font-size:             80% !default;\n\n$text-muted:                  $gray-600 !default;\n\n$blockquote-small-color:      $gray-600 !default;\n$blockquote-small-font-size:  $small-font-size !default;\n$blockquote-font-size:        $font-size-base * 1.25 !default;\n\n$hr-border-color:             rgba($black, .1) !default;\n$hr-border-width:             $border-width !default;\n\n$mark-padding:                .2em !default;\n\n$dt-font-weight:              $font-weight-bold !default;\n\n$kbd-box-shadow:              inset 0 -.1rem 0 rgba($black, .25) !default;\n$nested-kbd-font-weight:      $font-weight-bold !default;\n\n$list-inline-padding:         .5rem !default;\n\n$mark-bg:                     #fcf8e3 !default;\n\n$hr-margin-y:                 $spacer !default;\n\n\n// Tables\n//\n// Customizes the `.table` component with basic values, each used across all table variations.\n\n$table-cell-padding:          .75rem !default;\n$table-cell-padding-sm:       .3rem !default;\n\n$table-color:                 $body-color !default;\n$table-bg:                    null !default;\n$table-accent-bg:             rgba($black, .05) !default;\n$table-hover-color:           $table-color !default;\n$table-hover-bg:              rgba($black, .075) !default;\n$table-active-bg:             $table-hover-bg !default;\n\n$table-border-width:          $border-width !default;\n$table-border-color:          $border-color !default;\n\n$table-head-bg:               $gray-200 !default;\n$table-head-color:            $gray-700 !default;\n$table-th-font-weight:        null !default;\n\n$table-dark-color:            $white !default;\n$table-dark-bg:               $gray-800 !default;\n$table-dark-accent-bg:        rgba($white, .05) !default;\n$table-dark-hover-color:      $table-dark-color !default;\n$table-dark-hover-bg:         rgba($white, .075) !default;\n$table-dark-border-color:     lighten($table-dark-bg, 7.5%) !default;\n\n$table-striped-order:         odd !default;\n\n$table-caption-color:         $text-muted !default;\n\n$table-bg-level:              -9 !default;\n$table-border-level:          -6 !default;\n\n\n// Buttons + Forms\n//\n// Shared variables that are reassigned to `$input-` and `$btn-` specific variables.\n\n$input-btn-padding-y:         .375rem !default;\n$input-btn-padding-x:         .75rem !default;\n$input-btn-font-family:       null !default;\n$input-btn-font-size:         $font-size-base !default;\n$input-btn-line-height:       $line-height-base !default;\n\n$input-btn-focus-width:       .2rem !default;\n$input-btn-focus-color:       rgba($component-active-bg, .25) !default;\n$input-btn-focus-box-shadow:  0 0 0 $input-btn-focus-width $input-btn-focus-color !default;\n\n$input-btn-padding-y-sm:      .25rem !default;\n$input-btn-padding-x-sm:      .5rem !default;\n$input-btn-font-size-sm:      $font-size-sm !default;\n$input-btn-line-height-sm:    $line-height-sm !default;\n\n$input-btn-padding-y-lg:      .5rem !default;\n$input-btn-padding-x-lg:      1rem !default;\n$input-btn-font-size-lg:      $font-size-lg !default;\n$input-btn-line-height-lg:    $line-height-lg !default;\n\n$input-btn-border-width:      $border-width !default;\n\n\n// Buttons\n//\n// For each of Bootstrap's buttons, define text, background, and border color.\n\n$btn-padding-y:               $input-btn-padding-y !default;\n$btn-padding-x:               $input-btn-padding-x !default;\n$btn-font-family:             $input-btn-font-family !default;\n$btn-font-size:               $input-btn-font-size !default;\n$btn-line-height:             $input-btn-line-height !default;\n$btn-white-space:             null !default; // Set to `nowrap` to prevent text wrapping\n\n$btn-padding-y-sm:            $input-btn-padding-y-sm !default;\n$btn-padding-x-sm:            $input-btn-padding-x-sm !default;\n$btn-font-size-sm:            $input-btn-font-size-sm !default;\n$btn-line-height-sm:          $input-btn-line-height-sm !default;\n\n$btn-padding-y-lg:            $input-btn-padding-y-lg !default;\n$btn-padding-x-lg:            $input-btn-padding-x-lg !default;\n$btn-font-size-lg:            $input-btn-font-size-lg !default;\n$btn-line-height-lg:          $input-btn-line-height-lg !default;\n\n$btn-border-width:            $input-btn-border-width !default;\n\n$btn-font-weight:             $font-weight-normal !default;\n$btn-box-shadow:              inset 0 1px 0 rgba($white, .15), 0 1px 1px rgba($black, .075) !default;\n$btn-focus-width:             $input-btn-focus-width !default;\n$btn-focus-box-shadow:        $input-btn-focus-box-shadow !default;\n$btn-disabled-opacity:        .65 !default;\n$btn-active-box-shadow:       inset 0 3px 5px rgba($black, .125) !default;\n\n$btn-link-disabled-color:     $gray-600 !default;\n\n$btn-block-spacing-y:         .5rem !default;\n\n// Allows for customizing button radius independently from global border radius\n$btn-border-radius:           $border-radius !default;\n$btn-border-radius-lg:        $border-radius-lg !default;\n$btn-border-radius-sm:        $border-radius-sm !default;\n\n$btn-transition:              color .15s ease-in-out, background-color .15s ease-in-out, border-color .15s ease-in-out, box-shadow .15s ease-in-out !default;\n\n\n// Forms\n\n$label-margin-bottom:                   .5rem !default;\n\n$input-padding-y:                       $input-btn-padding-y !default;\n$input-padding-x:                       $input-btn-padding-x !default;\n$input-font-family:                     $input-btn-font-family !default;\n$input-font-size:                       $input-btn-font-size !default;\n$input-font-weight:                     $font-weight-base !default;\n$input-line-height:                     $input-btn-line-height !default;\n\n$input-padding-y-sm:                    $input-btn-padding-y-sm !default;\n$input-padding-x-sm:                    $input-btn-padding-x-sm !default;\n$input-font-size-sm:                    $input-btn-font-size-sm !default;\n$input-line-height-sm:                  $input-btn-line-height-sm !default;\n\n$input-padding-y-lg:                    $input-btn-padding-y-lg !default;\n$input-padding-x-lg:                    $input-btn-padding-x-lg !default;\n$input-font-size-lg:                    $input-btn-font-size-lg !default;\n$input-line-height-lg:                  $input-btn-line-height-lg !default;\n\n$input-bg:                              $white !default;\n$input-disabled-bg:                     $gray-200 !default;\n\n$input-color:                           $gray-700 !default;\n$input-border-color:                    $gray-400 !default;\n$input-border-width:                    $input-btn-border-width !default;\n$input-box-shadow:                      inset 0 1px 1px rgba($black, .075) !default;\n\n$input-border-radius:                   $border-radius !default;\n$input-border-radius-lg:                $border-radius-lg !default;\n$input-border-radius-sm:                $border-radius-sm !default;\n\n$input-focus-bg:                        $input-bg !default;\n$input-focus-border-color:              lighten($component-active-bg, 25%) !default;\n$input-focus-color:                     $input-color !default;\n$input-focus-width:                     $input-btn-focus-width !default;\n$input-focus-box-shadow:                $input-btn-focus-box-shadow !default;\n\n$input-placeholder-color:               $gray-600 !default;\n$input-plaintext-color:                 $body-color !default;\n\n$input-height-border:                   $input-border-width * 2 !default;\n\n$input-height-inner:                    add($input-line-height * 1em, $input-padding-y * 2) !default;\n$input-height-inner-half:               add($input-line-height * .5em, $input-padding-y) !default;\n$input-height-inner-quarter:            add($input-line-height * .25em, $input-padding-y / 2) !default;\n\n$input-height:                          add($input-line-height * 1em, add($input-padding-y * 2, $input-height-border, false)) !default;\n$input-height-sm:                       add($input-line-height-sm * 1em, add($input-padding-y-sm * 2, $input-height-border, false)) !default;\n$input-height-lg:                       add($input-line-height-lg * 1em, add($input-padding-y-lg * 2, $input-height-border, false)) !default;\n\n$input-transition:                      border-color .15s ease-in-out, box-shadow .15s ease-in-out !default;\n\n$form-text-margin-top:                  .25rem !default;\n\n$form-check-input-gutter:               1.25rem !default;\n$form-check-input-margin-y:             .3rem !default;\n$form-check-input-margin-x:             .25rem !default;\n\n$form-check-inline-margin-x:            .75rem !default;\n$form-check-inline-input-margin-x:      .3125rem !default;\n\n$form-grid-gutter-width:                10px !default;\n$form-group-margin-bottom:              1rem !default;\n\n$input-group-addon-color:               $input-color !default;\n$input-group-addon-bg:                  $gray-200 !default;\n$input-group-addon-border-color:        $input-border-color !default;\n\n$custom-forms-transition:               background-color .15s ease-in-out, border-color .15s ease-in-out, box-shadow .15s ease-in-out !default;\n\n$custom-control-gutter:                 .5rem !default;\n$custom-control-spacer-x:               1rem !default;\n$custom-control-cursor:                 null !default;\n\n$custom-control-indicator-size:         1rem !default;\n$custom-control-indicator-bg:           $input-bg !default;\n\n$custom-control-indicator-bg-size:      50% 50% !default;\n$custom-control-indicator-box-shadow:   $input-box-shadow !default;\n$custom-control-indicator-border-color: $gray-500 !default;\n$custom-control-indicator-border-width: $input-border-width !default;\n\n$custom-control-label-color:            null !default;\n\n$custom-control-indicator-disabled-bg:          $input-disabled-bg !default;\n$custom-control-label-disabled-color:           $gray-600 !default;\n\n$custom-control-indicator-checked-color:        $component-active-color !default;\n$custom-control-indicator-checked-bg:           $component-active-bg !default;\n$custom-control-indicator-checked-disabled-bg:  rgba(theme-color(\"primary\"), .5) !default;\n$custom-control-indicator-checked-box-shadow:   null !default;\n$custom-control-indicator-checked-border-color: $custom-control-indicator-checked-bg !default;\n\n$custom-control-indicator-focus-box-shadow:     $input-focus-box-shadow !default;\n$custom-control-indicator-focus-border-color:   $input-focus-border-color !default;\n\n$custom-control-indicator-active-color:         $component-active-color !default;\n$custom-control-indicator-active-bg:            lighten($component-active-bg, 35%) !default;\n$custom-control-indicator-active-box-shadow:    null !default;\n$custom-control-indicator-active-border-color:  $custom-control-indicator-active-bg !default;\n\n$custom-checkbox-indicator-border-radius:       $border-radius !default;\n$custom-checkbox-indicator-icon-checked:        url(\"data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg' width='8' height='8' viewBox='0 0 8 8'><path fill='#{$custom-control-indicator-checked-color}' d='M6.564.75l-3.59 3.612-1.538-1.55L0 4.26l2.974 2.99L8 2.193z'/></svg>\") !default;\n\n$custom-checkbox-indicator-indeterminate-bg:           $component-active-bg !default;\n$custom-checkbox-indicator-indeterminate-color:        $custom-control-indicator-checked-color !default;\n$custom-checkbox-indicator-icon-indeterminate:         url(\"data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg' width='4' height='4' viewBox='0 0 4 4'><path stroke='#{$custom-checkbox-indicator-indeterminate-color}' d='M0 2h4'/></svg>\") !default;\n$custom-checkbox-indicator-indeterminate-box-shadow:   null !default;\n$custom-checkbox-indicator-indeterminate-border-color: $custom-checkbox-indicator-indeterminate-bg !default;\n\n$custom-radio-indicator-border-radius:          50% !default;\n$custom-radio-indicator-icon-checked:           url(\"data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg' width='12' height='12' viewBox='-4 -4 8 8'><circle r='3' fill='#{$custom-control-indicator-checked-color}'/></svg>\") !default;\n\n$custom-switch-width:                           $custom-control-indicator-size * 1.75 !default;\n$custom-switch-indicator-border-radius:         $custom-control-indicator-size / 2 !default;\n$custom-switch-indicator-size:                  subtract($custom-control-indicator-size, $custom-control-indicator-border-width * 4) !default;\n\n$custom-select-padding-y:           $input-padding-y !default;\n$custom-select-padding-x:           $input-padding-x !default;\n$custom-select-font-family:         $input-font-family !default;\n$custom-select-font-size:           $input-font-size !default;\n$custom-select-height:              $input-height !default;\n$custom-select-indicator-padding:   1rem !default; // Extra padding to account for the presence of the background-image based indicator\n$custom-select-font-weight:         $input-font-weight !default;\n$custom-select-line-height:         $input-line-height !default;\n$custom-select-color:               $input-color !default;\n$custom-select-disabled-color:      $gray-600 !default;\n$custom-select-bg:                  $input-bg !default;\n$custom-select-disabled-bg:         $gray-200 !default;\n$custom-select-bg-size:             8px 10px !default; // In pixels because image dimensions\n$custom-select-indicator-color:     $gray-800 !default;\n$custom-select-indicator:           url(\"data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg' width='4' height='5' viewBox='0 0 4 5'><path fill='#{$custom-select-indicator-color}' d='M2 0L0 2h4zm0 5L0 3h4z'/></svg>\") !default;\n$custom-select-background:          escape-svg($custom-select-indicator) right $custom-select-padding-x center / $custom-select-bg-size no-repeat !default; // Used so we can have multiple background elements (e.g., arrow and feedback icon)\n\n$custom-select-feedback-icon-padding-right: add(1em * .75, (2 * $custom-select-padding-y * .75) + $custom-select-padding-x + $custom-select-indicator-padding) !default;\n$custom-select-feedback-icon-position:      center right ($custom-select-padding-x + $custom-select-indicator-padding) !default;\n$custom-select-feedback-icon-size:          $input-height-inner-half $input-height-inner-half !default;\n\n$custom-select-border-width:        $input-border-width !default;\n$custom-select-border-color:        $input-border-color !default;\n$custom-select-border-radius:       $border-radius !default;\n$custom-select-box-shadow:          inset 0 1px 2px rgba($black, .075) !default;\n\n$custom-select-focus-border-color:  $input-focus-border-color !default;\n$custom-select-focus-width:         $input-focus-width !default;\n$custom-select-focus-box-shadow:    0 0 0 $custom-select-focus-width $input-btn-focus-color !default;\n\n$custom-select-padding-y-sm:        $input-padding-y-sm !default;\n$custom-select-padding-x-sm:        $input-padding-x-sm !default;\n$custom-select-font-size-sm:        $input-font-size-sm !default;\n$custom-select-height-sm:           $input-height-sm !default;\n\n$custom-select-padding-y-lg:        $input-padding-y-lg !default;\n$custom-select-padding-x-lg:        $input-padding-x-lg !default;\n$custom-select-font-size-lg:        $input-font-size-lg !default;\n$custom-select-height-lg:           $input-height-lg !default;\n\n$custom-range-track-width:          100% !default;\n$custom-range-track-height:         .5rem !default;\n$custom-range-track-cursor:         pointer !default;\n$custom-range-track-bg:             $gray-300 !default;\n$custom-range-track-border-radius:  1rem !default;\n$custom-range-track-box-shadow:     inset 0 .25rem .25rem rgba($black, .1) !default;\n\n$custom-range-thumb-width:                   1rem !default;\n$custom-range-thumb-height:                  $custom-range-thumb-width !default;\n$custom-range-thumb-bg:                      $component-active-bg !default;\n$custom-range-thumb-border:                  0 !default;\n$custom-range-thumb-border-radius:           1rem !default;\n$custom-range-thumb-box-shadow:              0 .1rem .25rem rgba($black, .1) !default;\n$custom-range-thumb-focus-box-shadow:        0 0 0 1px $body-bg, $input-focus-box-shadow !default;\n$custom-range-thumb-focus-box-shadow-width:  $input-focus-width !default; // For focus box shadow issue in IE/Edge\n$custom-range-thumb-active-bg:               lighten($component-active-bg, 35%) !default;\n$custom-range-thumb-disabled-bg:             $gray-500 !default;\n\n$custom-file-height:                $input-height !default;\n$custom-file-height-inner:          $input-height-inner !default;\n$custom-file-focus-border-color:    $input-focus-border-color !default;\n$custom-file-focus-box-shadow:      $input-focus-box-shadow !default;\n$custom-file-disabled-bg:           $input-disabled-bg !default;\n\n$custom-file-padding-y:             $input-padding-y !default;\n$custom-file-padding-x:             $input-padding-x !default;\n$custom-file-line-height:           $input-line-height !default;\n$custom-file-font-family:           $input-font-family !default;\n$custom-file-font-weight:           $input-font-weight !default;\n$custom-file-color:                 $input-color !default;\n$custom-file-bg:                    $input-bg !default;\n$custom-file-border-width:          $input-border-width !default;\n$custom-file-border-color:          $input-border-color !default;\n$custom-file-border-radius:         $input-border-radius !default;\n$custom-file-box-shadow:            $input-box-shadow !default;\n$custom-file-button-color:          $custom-file-color !default;\n$custom-file-button-bg:             $input-group-addon-bg !default;\n$custom-file-text: (\n  en: \"Browse\"\n) !default;\n\n\n// Form validation\n\n$form-feedback-margin-top:          $form-text-margin-top !default;\n$form-feedback-font-size:           $small-font-size !default;\n$form-feedback-valid-color:         theme-color(\"success\") !default;\n$form-feedback-invalid-color:       theme-color(\"danger\") !default;\n\n$form-feedback-icon-valid-color:    $form-feedback-valid-color !default;\n$form-feedback-icon-valid:          url(\"data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg' width='8' height='8' viewBox='0 0 8 8'><path fill='#{$form-feedback-icon-valid-color}' d='M2.3 6.73L.6 4.53c-.4-1.04.46-1.4 1.1-.8l1.1 1.4 3.4-3.8c.6-.63 1.6-.27 1.2.7l-4 4.6c-.43.5-.8.4-1.1.1z'/></svg>\") !default;\n$form-feedback-icon-invalid-color:  $form-feedback-invalid-color !default;\n$form-feedback-icon-invalid:        url(\"data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg' width='12' height='12' fill='none' stroke='#{$form-feedback-icon-invalid-color}' viewBox='0 0 12 12'><circle cx='6' cy='6' r='4.5'/><path stroke-linejoin='round' d='M5.8 3.6h.4L6 6.5z'/><circle cx='6' cy='8.2' r='.6' fill='#{$form-feedback-icon-invalid-color}' stroke='none'/></svg>\") !default;\n\n$form-validation-states: () !default;\n$form-validation-states: map-merge(\n  (\n    \"valid\": (\n      \"color\": $form-feedback-valid-color,\n      \"icon\": $form-feedback-icon-valid\n    ),\n    \"invalid\": (\n      \"color\": $form-feedback-invalid-color,\n      \"icon\": $form-feedback-icon-invalid\n    ),\n  ),\n  $form-validation-states\n);\n\n// Z-index master list\n//\n// Warning: Avoid customizing these values. They're used for a bird's eye view\n// of components dependent on the z-axis and are designed to all work together.\n\n$zindex-dropdown:                   1000 !default;\n$zindex-sticky:                     1020 !default;\n$zindex-fixed:                      1030 !default;\n$zindex-modal-backdrop:             1040 !default;\n$zindex-modal:                      1050 !default;\n$zindex-popover:                    1060 !default;\n$zindex-tooltip:                    1070 !default;\n\n\n// Navs\n\n$nav-link-padding-y:                .5rem !default;\n$nav-link-padding-x:                1rem !default;\n$nav-link-disabled-color:           $gray-600 !default;\n\n$nav-tabs-border-color:             $gray-300 !default;\n$nav-tabs-border-width:             $border-width !default;\n$nav-tabs-border-radius:            $border-radius !default;\n$nav-tabs-link-hover-border-color:  $gray-200 $gray-200 $nav-tabs-border-color !default;\n$nav-tabs-link-active-color:        $gray-700 !default;\n$nav-tabs-link-active-bg:           $body-bg !default;\n$nav-tabs-link-active-border-color: $gray-300 $gray-300 $nav-tabs-link-active-bg !default;\n\n$nav-pills-border-radius:           $border-radius !default;\n$nav-pills-link-active-color:       $component-active-color !default;\n$nav-pills-link-active-bg:          $component-active-bg !default;\n\n$nav-divider-color:                 $gray-200 !default;\n$nav-divider-margin-y:              $spacer / 2 !default;\n\n\n// Navbar\n\n$navbar-padding-y:                  $spacer / 2 !default;\n$navbar-padding-x:                  $spacer !default;\n\n$navbar-nav-link-padding-x:         .5rem !default;\n\n$navbar-brand-font-size:            $font-size-lg !default;\n// Compute the navbar-brand padding-y so the navbar-brand will have the same height as navbar-text and nav-link\n$nav-link-height:                   $font-size-base * $line-height-base + $nav-link-padding-y * 2 !default;\n$navbar-brand-height:               $navbar-brand-font-size * $line-height-base !default;\n$navbar-brand-padding-y:            ($nav-link-height - $navbar-brand-height) / 2 !default;\n\n$navbar-toggler-padding-y:          .25rem !default;\n$navbar-toggler-padding-x:          .75rem !default;\n$navbar-toggler-font-size:          $font-size-lg !default;\n$navbar-toggler-border-radius:      $btn-border-radius !default;\n\n$navbar-nav-scroll-max-height:      75vh !default;\n\n$navbar-dark-color:                 rgba($white, .5) !default;\n$navbar-dark-hover-color:           rgba($white, .75) !default;\n$navbar-dark-active-color:          $white !default;\n$navbar-dark-disabled-color:        rgba($white, .25) !default;\n$navbar-dark-toggler-icon-bg:       url(\"data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg' width='30' height='30' viewBox='0 0 30 30'><path stroke='#{$navbar-dark-color}' stroke-linecap='round' stroke-miterlimit='10' stroke-width='2' d='M4 7h22M4 15h22M4 23h22'/></svg>\") !default;\n$navbar-dark-toggler-border-color:  rgba($white, .1) !default;\n\n$navbar-light-color:                rgba($black, .5) !default;\n$navbar-light-hover-color:          rgba($black, .7) !default;\n$navbar-light-active-color:         rgba($black, .9) !default;\n$navbar-light-disabled-color:       rgba($black, .3) !default;\n$navbar-light-toggler-icon-bg:      url(\"data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg' width='30' height='30' viewBox='0 0 30 30'><path stroke='#{$navbar-light-color}' stroke-linecap='round' stroke-miterlimit='10' stroke-width='2' d='M4 7h22M4 15h22M4 23h22'/></svg>\") !default;\n$navbar-light-toggler-border-color: rgba($black, .1) !default;\n\n$navbar-light-brand-color:                $navbar-light-active-color !default;\n$navbar-light-brand-hover-color:          $navbar-light-active-color !default;\n$navbar-dark-brand-color:                 $navbar-dark-active-color !default;\n$navbar-dark-brand-hover-color:           $navbar-dark-active-color !default;\n\n\n// Dropdowns\n//\n// Dropdown menu container and contents.\n\n$dropdown-min-width:                10rem !default;\n$dropdown-padding-x:                0 !default;\n$dropdown-padding-y:                .5rem !default;\n$dropdown-spacer:                   .125rem !default;\n$dropdown-font-size:                $font-size-base !default;\n$dropdown-color:                    $body-color !default;\n$dropdown-bg:                       $white !default;\n$dropdown-border-color:             rgba($black, .15) !default;\n$dropdown-border-radius:            $border-radius !default;\n$dropdown-border-width:             $border-width !default;\n$dropdown-inner-border-radius:      subtract($dropdown-border-radius, $dropdown-border-width) !default;\n$dropdown-divider-bg:               $gray-200 !default;\n$dropdown-divider-margin-y:         $nav-divider-margin-y !default;\n$dropdown-box-shadow:               0 .5rem 1rem rgba($black, .175) !default;\n\n$dropdown-link-color:               $gray-900 !default;\n$dropdown-link-hover-color:         darken($gray-900, 5%) !default;\n$dropdown-link-hover-bg:            $gray-200 !default;\n\n$dropdown-link-active-color:        $component-active-color !default;\n$dropdown-link-active-bg:           $component-active-bg !default;\n\n$dropdown-link-disabled-color:      $gray-500 !default;\n\n$dropdown-item-padding-y:           .25rem !default;\n$dropdown-item-padding-x:           1.5rem !default;\n\n$dropdown-header-color:             $gray-600 !default;\n$dropdown-header-padding:           $dropdown-padding-y $dropdown-item-padding-x !default;\n\n\n// Pagination\n\n$pagination-padding-y:              .5rem !default;\n$pagination-padding-x:              .75rem !default;\n$pagination-padding-y-sm:           .25rem !default;\n$pagination-padding-x-sm:           .5rem !default;\n$pagination-padding-y-lg:           .75rem !default;\n$pagination-padding-x-lg:           1.5rem !default;\n$pagination-line-height:            1.25 !default;\n\n$pagination-color:                  $link-color !default;\n$pagination-bg:                     $white !default;\n$pagination-border-width:           $border-width !default;\n$pagination-border-color:           $gray-300 !default;\n\n$pagination-focus-box-shadow:       $input-btn-focus-box-shadow !default;\n$pagination-focus-outline:          0 !default;\n\n$pagination-hover-color:            $link-hover-color !default;\n$pagination-hover-bg:               $gray-200 !default;\n$pagination-hover-border-color:     $gray-300 !default;\n\n$pagination-active-color:           $component-active-color !default;\n$pagination-active-bg:              $component-active-bg !default;\n$pagination-active-border-color:    $pagination-active-bg !default;\n\n$pagination-disabled-color:         $gray-600 !default;\n$pagination-disabled-bg:            $white !default;\n$pagination-disabled-border-color:  $gray-300 !default;\n\n$pagination-border-radius-sm:       $border-radius-sm !default;\n$pagination-border-radius-lg:       $border-radius-lg !default;\n\n// Jumbotron\n\n$jumbotron-padding:                 2rem !default;\n$jumbotron-color:                   null !default;\n$jumbotron-bg:                      $gray-200 !default;\n\n\n// Cards\n\n$card-spacer-y:                     .75rem !default;\n$card-spacer-x:                     1.25rem !default;\n$card-border-width:                 $border-width !default;\n$card-border-radius:                $border-radius !default;\n$card-border-color:                 rgba($black, .125) !default;\n$card-inner-border-radius:          subtract($card-border-radius, $card-border-width) !default;\n$card-cap-bg:                       rgba($black, .03) !default;\n$card-cap-color:                    null !default;\n$card-height:                       null !default;\n$card-color:                        null !default;\n$card-bg:                           $white !default;\n\n$card-img-overlay-padding:          1.25rem !default;\n\n$card-group-margin:                 $grid-gutter-width / 2 !default;\n$card-deck-margin:                  $card-group-margin !default;\n\n$card-columns-count:                3 !default;\n$card-columns-gap:                  1.25rem !default;\n$card-columns-margin:               $card-spacer-y !default;\n\n\n// Tooltips\n\n$tooltip-font-size:                 $font-size-sm !default;\n$tooltip-max-width:                 200px !default;\n$tooltip-color:                     $white !default;\n$tooltip-bg:                        $black !default;\n$tooltip-border-radius:             $border-radius !default;\n$tooltip-opacity:                   .9 !default;\n$tooltip-padding-y:                 .25rem !default;\n$tooltip-padding-x:                 .5rem !default;\n$tooltip-margin:                    0 !default;\n\n$tooltip-arrow-width:               .8rem !default;\n$tooltip-arrow-height:              .4rem !default;\n$tooltip-arrow-color:               $tooltip-bg !default;\n\n// Form tooltips must come after regular tooltips\n$form-feedback-tooltip-padding-y:     $tooltip-padding-y !default;\n$form-feedback-tooltip-padding-x:     $tooltip-padding-x !default;\n$form-feedback-tooltip-font-size:     $tooltip-font-size !default;\n$form-feedback-tooltip-line-height:   $line-height-base !default;\n$form-feedback-tooltip-opacity:       $tooltip-opacity !default;\n$form-feedback-tooltip-border-radius: $tooltip-border-radius !default;\n\n\n// Popovers\n\n$popover-font-size:                 $font-size-sm !default;\n$popover-bg:                        $white !default;\n$popover-max-width:                 276px !default;\n$popover-border-width:              $border-width !default;\n$popover-border-color:              rgba($black, .2) !default;\n$popover-border-radius:             $border-radius-lg !default;\n$popover-inner-border-radius:       subtract($popover-border-radius, $popover-border-width) !default;\n$popover-box-shadow:                0 .25rem .5rem rgba($black, .2) !default;\n\n$popover-header-bg:                 darken($popover-bg, 3%) !default;\n$popover-header-color:              $headings-color !default;\n$popover-header-padding-y:          .5rem !default;\n$popover-header-padding-x:          .75rem !default;\n\n$popover-body-color:                $body-color !default;\n$popover-body-padding-y:            $popover-header-padding-y !default;\n$popover-body-padding-x:            $popover-header-padding-x !default;\n\n$popover-arrow-width:               1rem !default;\n$popover-arrow-height:              .5rem !default;\n$popover-arrow-color:               $popover-bg !default;\n\n$popover-arrow-outer-color:         fade-in($popover-border-color, .05) !default;\n\n\n// Toasts\n\n$toast-max-width:                   350px !default;\n$toast-padding-x:                   .75rem !default;\n$toast-padding-y:                   .25rem !default;\n$toast-font-size:                   .875rem !default;\n$toast-color:                       null !default;\n$toast-background-color:            rgba($white, .85) !default;\n$toast-border-width:                1px !default;\n$toast-border-color:                rgba(0, 0, 0, .1) !default;\n$toast-border-radius:               .25rem !default;\n$toast-box-shadow:                  0 .25rem .75rem rgba($black, .1) !default;\n\n$toast-header-color:                $gray-600 !default;\n$toast-header-background-color:     rgba($white, .85) !default;\n$toast-header-border-color:         rgba(0, 0, 0, .05) !default;\n\n\n// Badges\n\n$badge-font-size:                   75% !default;\n$badge-font-weight:                 $font-weight-bold !default;\n$badge-padding-y:                   .25em !default;\n$badge-padding-x:                   .4em !default;\n$badge-border-radius:               $border-radius !default;\n\n$badge-transition:                  $btn-transition !default;\n$badge-focus-width:                 $input-btn-focus-width !default;\n\n$badge-pill-padding-x:              .6em !default;\n// Use a higher than normal value to ensure completely rounded edges when\n// customizing padding or font-size on labels.\n$badge-pill-border-radius:          10rem !default;\n\n\n// Modals\n\n// Padding applied to the modal body\n$modal-inner-padding:               1rem !default;\n\n// Margin between elements in footer, must be lower than or equal to 2 * $modal-inner-padding\n$modal-footer-margin-between:       .5rem !default;\n\n$modal-dialog-margin:               .5rem !default;\n$modal-dialog-margin-y-sm-up:       1.75rem !default;\n\n$modal-title-line-height:           $line-height-base !default;\n\n$modal-content-color:               null !default;\n$modal-content-bg:                  $white !default;\n$modal-content-border-color:        rgba($black, .2) !default;\n$modal-content-border-width:        $border-width !default;\n$modal-content-border-radius:       $border-radius-lg !default;\n$modal-content-inner-border-radius: subtract($modal-content-border-radius, $modal-content-border-width) !default;\n$modal-content-box-shadow-xs:       0 .25rem .5rem rgba($black, .5) !default;\n$modal-content-box-shadow-sm-up:    0 .5rem 1rem rgba($black, .5) !default;\n\n$modal-backdrop-bg:                 $black !default;\n$modal-backdrop-opacity:            .5 !default;\n$modal-header-border-color:         $border-color !default;\n$modal-footer-border-color:         $modal-header-border-color !default;\n$modal-header-border-width:         $modal-content-border-width !default;\n$modal-footer-border-width:         $modal-header-border-width !default;\n$modal-header-padding-y:            1rem !default;\n$modal-header-padding-x:            1rem !default;\n$modal-header-padding:              $modal-header-padding-y $modal-header-padding-x !default; // Keep this for backwards compatibility\n\n$modal-xl:                          1140px !default;\n$modal-lg:                          800px !default;\n$modal-md:                          500px !default;\n$modal-sm:                          300px !default;\n\n$modal-fade-transform:              translate(0, -50px) !default;\n$modal-show-transform:              none !default;\n$modal-transition:                  transform .3s ease-out !default;\n$modal-scale-transform:             scale(1.02) !default;\n\n\n// Alerts\n//\n// Define alert colors, border radius, and padding.\n\n$alert-padding-y:                   .75rem !default;\n$alert-padding-x:                   1.25rem !default;\n$alert-margin-bottom:               1rem !default;\n$alert-border-radius:               $border-radius !default;\n$alert-link-font-weight:            $font-weight-bold !default;\n$alert-border-width:                $border-width !default;\n\n$alert-bg-level:                    -10 !default;\n$alert-border-level:                -9 !default;\n$alert-color-level:                 6 !default;\n\n\n// Progress bars\n\n$progress-height:                   1rem !default;\n$progress-font-size:                $font-size-base * .75 !default;\n$progress-bg:                       $gray-200 !default;\n$progress-border-radius:            $border-radius !default;\n$progress-box-shadow:               inset 0 .1rem .1rem rgba($black, .1) !default;\n$progress-bar-color:                $white !default;\n$progress-bar-bg:                   theme-color(\"primary\") !default;\n$progress-bar-animation-timing:     1s linear infinite !default;\n$progress-bar-transition:           width .6s ease !default;\n\n\n// List group\n\n$list-group-color:                  null !default;\n$list-group-bg:                     $white !default;\n$list-group-border-color:           rgba($black, .125) !default;\n$list-group-border-width:           $border-width !default;\n$list-group-border-radius:          $border-radius !default;\n\n$list-group-item-padding-y:         .75rem !default;\n$list-group-item-padding-x:         1.25rem !default;\n\n$list-group-hover-bg:               $gray-100 !default;\n$list-group-active-color:           $component-active-color !default;\n$list-group-active-bg:              $component-active-bg !default;\n$list-group-active-border-color:    $list-group-active-bg !default;\n\n$list-group-disabled-color:         $gray-600 !default;\n$list-group-disabled-bg:            $list-group-bg !default;\n\n$list-group-action-color:           $gray-700 !default;\n$list-group-action-hover-color:     $list-group-action-color !default;\n\n$list-group-action-active-color:    $body-color !default;\n$list-group-action-active-bg:       $gray-200 !default;\n\n\n// Image thumbnails\n\n$thumbnail-padding:                 .25rem !default;\n$thumbnail-bg:                      $body-bg !default;\n$thumbnail-border-width:            $border-width !default;\n$thumbnail-border-color:            $gray-300 !default;\n$thumbnail-border-radius:           $border-radius !default;\n$thumbnail-box-shadow:              0 1px 2px rgba($black, .075) !default;\n\n\n// Figures\n\n$figure-caption-font-size:          90% !default;\n$figure-caption-color:              $gray-600 !default;\n\n\n// Breadcrumbs\n\n$breadcrumb-font-size:              null !default;\n\n$breadcrumb-padding-y:              .75rem !default;\n$breadcrumb-padding-x:              1rem !default;\n$breadcrumb-item-padding:           .5rem !default;\n\n$breadcrumb-margin-bottom:          1rem !default;\n\n$breadcrumb-bg:                     $gray-200 !default;\n$breadcrumb-divider-color:          $gray-600 !default;\n$breadcrumb-active-color:           $gray-600 !default;\n$breadcrumb-divider:                quote(\"/\") !default;\n\n$breadcrumb-border-radius:          $border-radius !default;\n\n\n// Carousel\n\n$carousel-control-color:             $white !default;\n$carousel-control-width:             15% !default;\n$carousel-control-opacity:           .5 !default;\n$carousel-control-hover-opacity:     .9 !default;\n$carousel-control-transition:        opacity .15s ease !default;\n\n$carousel-indicator-width:           30px !default;\n$carousel-indicator-height:          3px !default;\n$carousel-indicator-hit-area-height: 10px !default;\n$carousel-indicator-spacer:          3px !default;\n$carousel-indicator-active-bg:       $white !default;\n$carousel-indicator-transition:      opacity .6s ease !default;\n\n$carousel-caption-width:             70% !default;\n$carousel-caption-color:             $white !default;\n\n$carousel-control-icon-width:        20px !default;\n\n$carousel-control-prev-icon-bg:      url(\"data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg' fill='#{$carousel-control-color}' width='8' height='8' viewBox='0 0 8 8'><path d='M5.25 0l-4 4 4 4 1.5-1.5L4.25 4l2.5-2.5L5.25 0z'/></svg>\") !default;\n$carousel-control-next-icon-bg:      url(\"data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg' fill='#{$carousel-control-color}' width='8' height='8' viewBox='0 0 8 8'><path d='M2.75 0l-1.5 1.5L3.75 4l-2.5 2.5L2.75 8l4-4-4-4z'/></svg>\") !default;\n\n$carousel-transition-duration:       .6s !default;\n$carousel-transition:                transform $carousel-transition-duration ease-in-out !default; // Define transform transition first if using multiple transitions (e.g., `transform 2s ease, opacity .5s ease-out`)\n\n\n// Spinners\n\n$spinner-width:         2rem !default;\n$spinner-height:        $spinner-width !default;\n$spinner-border-width:  .25em !default;\n\n$spinner-width-sm:        1rem !default;\n$spinner-height-sm:       $spinner-width-sm !default;\n$spinner-border-width-sm: .2em !default;\n\n\n// Close\n\n$close-font-size:                   $font-size-base * 1.5 !default;\n$close-font-weight:                 $font-weight-bold !default;\n$close-color:                       $black !default;\n$close-text-shadow:                 0 1px 0 $white !default;\n\n\n// Code\n\n$code-font-size:                    87.5% !default;\n$code-color:                        $pink !default;\n\n$kbd-padding-y:                     .2rem !default;\n$kbd-padding-x:                     .4rem !default;\n$kbd-font-size:                     $code-font-size !default;\n$kbd-color:                         $white !default;\n$kbd-bg:                            $gray-900 !default;\n\n$pre-color:                         $gray-900 !default;\n$pre-scrollable-max-height:         340px !default;\n\n\n// Utilities\n\n$displays: none, inline, inline-block, block, table, table-row, table-cell, flex, inline-flex !default;\n$overflows: auto, hidden !default;\n$positions: static, relative, absolute, fixed, sticky !default;\n$user-selects: all, auto, none !default;\n\n\n// Printing\n\n$print-page-size:                   a3 !default;\n$print-body-min-width:              map-get($grid-breakpoints, \"lg\") !default;\n","// Hover mixin and `$enable-hover-media-query` are deprecated.\n//\n// Originally added during our alphas and maintained during betas, this mixin was\n// designed to prevent `:hover` stickiness on iOS-an issue where hover styles\n// would persist after initial touch.\n//\n// For backward compatibility, we've kept these mixins and updated them to\n// always return their regular pseudo-classes instead of a shimmed media query.\n//\n// Issue: https://github.com/twbs/bootstrap/issues/25195\n\n@mixin hover() {\n  &:hover { @content; }\n}\n\n@mixin hover-focus() {\n  &:hover,\n  &:focus {\n    @content;\n  }\n}\n\n@mixin plain-hover-focus() {\n  &,\n  &:hover,\n  &:focus {\n    @content;\n  }\n}\n\n@mixin hover-focus-active() {\n  &:hover,\n  &:focus,\n  &:active {\n    @content;\n  }\n}\n","// stylelint-disable selector-list-comma-newline-after\n\n//\n// Headings\n//\n\nh1, h2, h3, h4, h5, h6,\n.h1, .h2, .h3, .h4, .h5, .h6 {\n  margin-bottom: $headings-margin-bottom;\n  font-family: $headings-font-family;\n  font-weight: $headings-font-weight;\n  line-height: $headings-line-height;\n  color: $headings-color;\n}\n\nh1, .h1 { @include font-size($h1-font-size); }\nh2, .h2 { @include font-size($h2-font-size); }\nh3, .h3 { @include font-size($h3-font-size); }\nh4, .h4 { @include font-size($h4-font-size); }\nh5, .h5 { @include font-size($h5-font-size); }\nh6, .h6 { @include font-size($h6-font-size); }\n\n.lead {\n  @include font-size($lead-font-size);\n  font-weight: $lead-font-weight;\n}\n\n// Type display classes\n.display-1 {\n  @include font-size($display1-size);\n  font-weight: $display1-weight;\n  line-height: $display-line-height;\n}\n.display-2 {\n  @include font-size($display2-size);\n  font-weight: $display2-weight;\n  line-height: $display-line-height;\n}\n.display-3 {\n  @include font-size($display3-size);\n  font-weight: $display3-weight;\n  line-height: $display-line-height;\n}\n.display-4 {\n  @include font-size($display4-size);\n  font-weight: $display4-weight;\n  line-height: $display-line-height;\n}\n\n\n//\n// Horizontal rules\n//\n\nhr {\n  margin-top: $hr-margin-y;\n  margin-bottom: $hr-margin-y;\n  border: 0;\n  border-top: $hr-border-width solid $hr-border-color;\n}\n\n\n//\n// Emphasis\n//\n\nsmall,\n.small {\n  @include font-size($small-font-size);\n  font-weight: $font-weight-normal;\n}\n\nmark,\n.mark {\n  padding: $mark-padding;\n  background-color: $mark-bg;\n}\n\n\n//\n// Lists\n//\n\n.list-unstyled {\n  @include list-unstyled();\n}\n\n// Inline turns list items into inline-block\n.list-inline {\n  @include list-unstyled();\n}\n.list-inline-item {\n  display: inline-block;\n\n  &:not(:last-child) {\n    margin-right: $list-inline-padding;\n  }\n}\n\n\n//\n// Misc\n//\n\n// Builds on `abbr`\n.initialism {\n  @include font-size(90%);\n  text-transform: uppercase;\n}\n\n// Blockquotes\n.blockquote {\n  margin-bottom: $spacer;\n  @include font-size($blockquote-font-size);\n}\n\n.blockquote-footer {\n  display: block;\n  @include font-size($blockquote-small-font-size);\n  color: $blockquote-small-color;\n\n  &::before {\n    content: \"\\2014\\00A0\"; // em dash, nbsp\n  }\n}\n","// Lists\n\n// Unstyled keeps list items block level, just removes default browser padding and list-style\n@mixin list-unstyled() {\n  padding-left: 0;\n  list-style: none;\n}\n","// Responsive images (ensure images don't scale beyond their parents)\n//\n// This is purposefully opt-in via an explicit class rather than being the default for all `<img>`s.\n// We previously tried the \"images are responsive by default\" approach in Bootstrap v2,\n// and abandoned it in Bootstrap v3 because it breaks lots of third-party widgets (including Google Maps)\n// which weren't expecting the images within themselves to be involuntarily resized.\n// See also https://github.com/twbs/bootstrap/issues/18178\n.img-fluid {\n  @include img-fluid();\n}\n\n\n// Image thumbnails\n.img-thumbnail {\n  padding: $thumbnail-padding;\n  background-color: $thumbnail-bg;\n  border: $thumbnail-border-width solid $thumbnail-border-color;\n  @include border-radius($thumbnail-border-radius);\n  @include box-shadow($thumbnail-box-shadow);\n\n  // Keep them at most 100% wide\n  @include img-fluid();\n}\n\n//\n// Figures\n//\n\n.figure {\n  // Ensures the caption's text aligns with the image.\n  display: inline-block;\n}\n\n.figure-img {\n  margin-bottom: $spacer / 2;\n  line-height: 1;\n}\n\n.figure-caption {\n  @include font-size($figure-caption-font-size);\n  color: $figure-caption-color;\n}\n","// Image Mixins\n// - Responsive image\n// - Retina image\n\n\n// Responsive image\n//\n// Keep images from scaling beyond the width of their parents.\n\n@mixin img-fluid() {\n  // Part 1: Set a maximum relative to the parent\n  max-width: 100%;\n  // Part 2: Override the height to auto, otherwise images will be stretched\n  // when setting a width and height attribute on the img element.\n  height: auto;\n}\n\n\n// Retina image\n//\n// Short retina mixin for setting background-image and -size.\n\n@mixin img-retina($file-1x, $file-2x, $width-1x, $height-1x) {\n  background-image: url($file-1x);\n\n  // Autoprefixer takes care of adding -webkit-min-device-pixel-ratio and -o-min-device-pixel-ratio,\n  // but doesn't convert dppx=>dpi.\n  // There's no such thing as unprefixed min-device-pixel-ratio since it's nonstandard.\n  // Compatibility info: https://caniuse.com/css-media-resolution\n  @media only screen and (min-resolution: 192dpi), // IE9-11 don't support dppx\n    only screen and (min-resolution: 2dppx) { // Standardized\n    background-image: url($file-2x);\n    background-size: $width-1x $height-1x;\n  }\n  @include deprecate(\"`img-retina()`\", \"v4.3.0\", \"v5\");\n}\n","// stylelint-disable property-disallowed-list\n// Single side border-radius\n\n// Helper function to replace negative values with 0\n@function valid-radius($radius) {\n  $return: ();\n  @each $value in $radius {\n    @if type-of($value) == number {\n      $return: append($return, max($value, 0));\n    } @else {\n      $return: append($return, $value);\n    }\n  }\n  @return $return;\n}\n\n@mixin border-radius($radius: $border-radius, $fallback-border-radius: false) {\n  @if $enable-rounded {\n    border-radius: valid-radius($radius);\n  }\n  @else if $fallback-border-radius != false {\n    border-radius: $fallback-border-radius;\n  }\n}\n\n@mixin border-top-radius($radius) {\n  @if $enable-rounded {\n    border-top-left-radius: valid-radius($radius);\n    border-top-right-radius: valid-radius($radius);\n  }\n}\n\n@mixin border-right-radius($radius) {\n  @if $enable-rounded {\n    border-top-right-radius: valid-radius($radius);\n    border-bottom-right-radius: valid-radius($radius);\n  }\n}\n\n@mixin border-bottom-radius($radius) {\n  @if $enable-rounded {\n    border-bottom-right-radius: valid-radius($radius);\n    border-bottom-left-radius: valid-radius($radius);\n  }\n}\n\n@mixin border-left-radius($radius) {\n  @if $enable-rounded {\n    border-top-left-radius: valid-radius($radius);\n    border-bottom-left-radius: valid-radius($radius);\n  }\n}\n\n@mixin border-top-left-radius($radius) {\n  @if $enable-rounded {\n    border-top-left-radius: valid-radius($radius);\n  }\n}\n\n@mixin border-top-right-radius($radius) {\n  @if $enable-rounded {\n    border-top-right-radius: valid-radius($radius);\n  }\n}\n\n@mixin border-bottom-right-radius($radius) {\n  @if $enable-rounded {\n    border-bottom-right-radius: valid-radius($radius);\n  }\n}\n\n@mixin border-bottom-left-radius($radius) {\n  @if $enable-rounded {\n    border-bottom-left-radius: valid-radius($radius);\n  }\n}\n","@mixin box-shadow($shadow...) {\n  @if $enable-shadows {\n    $result: ();\n\n    @if (length($shadow) == 1) {\n      // We can pass `@include box-shadow(none);`\n      $result: $shadow;\n    } @else {\n      // Filter to avoid invalid properties for example `box-shadow: none, 1px 1px black;`\n      @for $i from 1 through length($shadow) {\n        @if nth($shadow, $i) != \"none\" {\n          $result: append($result, nth($shadow, $i), \"comma\");\n        }\n      }\n    }\n    @if (length($result) > 0) {\n      box-shadow: $result;\n    }\n  }\n}\n","// Inline code\ncode {\n  @include font-size($code-font-size);\n  color: $code-color;\n  word-wrap: break-word;\n\n  // Streamline the style when inside anchors to avoid broken underline and more\n  a > & {\n    color: inherit;\n  }\n}\n\n// User input typically entered via keyboard\nkbd {\n  padding: $kbd-padding-y $kbd-padding-x;\n  @include font-size($kbd-font-size);\n  color: $kbd-color;\n  background-color: $kbd-bg;\n  @include border-radius($border-radius-sm);\n  @include box-shadow($kbd-box-shadow);\n\n  kbd {\n    padding: 0;\n    @include font-size(100%);\n    font-weight: $nested-kbd-font-weight;\n    @include box-shadow(none);\n  }\n}\n\n// Blocks of code\npre {\n  display: block;\n  @include font-size($code-font-size);\n  color: $pre-color;\n\n  // Account for some code outputs that place code tags in pre tags\n  code {\n    @include font-size(inherit);\n    color: inherit;\n    word-break: normal;\n  }\n}\n\n// Enable scrollable blocks of code\n.pre-scrollable {\n  max-height: $pre-scrollable-max-height;\n  overflow-y: scroll;\n}\n","// Container widths\n//\n// Set the container width, and override it for fixed navbars in media queries.\n\n@if $enable-grid-classes {\n  // Single container class with breakpoint max-widths\n  .container,\n  // 100% wide container at all breakpoints\n  .container-fluid {\n    @include make-container();\n  }\n\n  // Responsive containers that are 100% wide until a breakpoint\n  @each $breakpoint, $container-max-width in $container-max-widths {\n    .container-#{$breakpoint} {\n      @extend .container-fluid;\n    }\n\n    @include media-breakpoint-up($breakpoint, $grid-breakpoints) {\n      %responsive-container-#{$breakpoint} {\n        max-width: $container-max-width;\n      }\n\n      // Extend each breakpoint which is smaller or equal to the current breakpoint\n      $extend-breakpoint: true;\n\n      @each $name, $width in $grid-breakpoints {\n        @if ($extend-breakpoint) {\n          .container#{breakpoint-infix($name, $grid-breakpoints)} {\n            @extend %responsive-container-#{$breakpoint};\n          }\n\n          // Once the current breakpoint is reached, stop extending\n          @if ($breakpoint == $name) {\n            $extend-breakpoint: false;\n          }\n        }\n      }\n    }\n  }\n}\n\n\n// Row\n//\n// Rows contain your columns.\n\n@if $enable-grid-classes {\n  .row {\n    @include make-row();\n  }\n\n  // Remove the negative margin from default .row, then the horizontal padding\n  // from all immediate children columns (to prevent runaway style inheritance).\n  .no-gutters {\n    margin-right: 0;\n    margin-left: 0;\n\n    > .col,\n    > [class*=\"col-\"] {\n      padding-right: 0;\n      padding-left: 0;\n    }\n  }\n}\n\n// Columns\n//\n// Common styles for small and large grid columns\n\n@if $enable-grid-classes {\n  @include make-grid-columns();\n}\n","/// Grid system\n//\n// Generate semantic grid columns with these mixins.\n\n@mixin make-container($gutter: $grid-gutter-width) {\n  width: 100%;\n  padding-right: $gutter / 2;\n  padding-left: $gutter / 2;\n  margin-right: auto;\n  margin-left: auto;\n}\n\n@mixin make-row($gutter: $grid-gutter-width) {\n  display: flex;\n  flex-wrap: wrap;\n  margin-right: -$gutter / 2;\n  margin-left: -$gutter / 2;\n}\n\n// For each breakpoint, define the maximum width of the container in a media query\n@mixin make-container-max-widths($max-widths: $container-max-widths, $breakpoints: $grid-breakpoints) {\n  @each $breakpoint, $container-max-width in $max-widths {\n    @include media-breakpoint-up($breakpoint, $breakpoints) {\n      max-width: $container-max-width;\n    }\n  }\n  @include deprecate(\"The `make-container-max-widths` mixin\", \"v4.5.2\", \"v5\");\n}\n\n@mixin make-col-ready($gutter: $grid-gutter-width) {\n  position: relative;\n  // Prevent columns from becoming too narrow when at smaller grid tiers by\n  // always setting `width: 100%;`. This works because we use `flex` values\n  // later on to override this initial width.\n  width: 100%;\n  padding-right: $gutter / 2;\n  padding-left: $gutter / 2;\n}\n\n@mixin make-col($size, $columns: $grid-columns) {\n  flex: 0 0 percentage($size / $columns);\n  // Add a `max-width` to ensure content within each column does not blow out\n  // the width of the column. Applies to IE10+ and Firefox. Chrome and Safari\n  // do not appear to require this.\n  max-width: percentage($size / $columns);\n}\n\n@mixin make-col-auto() {\n  flex: 0 0 auto;\n  width: auto;\n  max-width: 100%; // Reset earlier grid tiers\n}\n\n@mixin make-col-offset($size, $columns: $grid-columns) {\n  $num: $size / $columns;\n  margin-left: if($num == 0, 0, percentage($num));\n}\n\n// Row columns\n//\n// Specify on a parent element(e.g., .row) to force immediate children into NN\n// numberof columns. Supports wrapping to new lines, but does not do a Masonry\n// style grid.\n@mixin row-cols($count) {\n  > * {\n    flex: 0 0 100% / $count;\n    max-width: 100% / $count;\n  }\n}\n","// Breakpoint viewport sizes and media queries.\n//\n// Breakpoints are defined as a map of (name: minimum width), order from small to large:\n//\n//    (xs: 0, sm: 576px, md: 768px, lg: 992px, xl: 1200px)\n//\n// The map defined in the `$grid-breakpoints` global variable is used as the `$breakpoints` argument by default.\n\n// Name of the next breakpoint, or null for the last breakpoint.\n//\n//    >> breakpoint-next(sm)\n//    md\n//    >> breakpoint-next(sm, (xs: 0, sm: 576px, md: 768px, lg: 992px, xl: 1200px))\n//    md\n//    >> breakpoint-next(sm, $breakpoint-names: (xs sm md lg xl))\n//    md\n@function breakpoint-next($name, $breakpoints: $grid-breakpoints, $breakpoint-names: map-keys($breakpoints)) {\n  $n: index($breakpoint-names, $name);\n  @return if($n != null and $n < length($breakpoint-names), nth($breakpoint-names, $n + 1), null);\n}\n\n// Minimum breakpoint width. Null for the smallest (first) breakpoint.\n//\n//    >> breakpoint-min(sm, (xs: 0, sm: 576px, md: 768px, lg: 992px, xl: 1200px))\n//    576px\n@function breakpoint-min($name, $breakpoints: $grid-breakpoints) {\n  $min: map-get($breakpoints, $name);\n  @return if($min != 0, $min, null);\n}\n\n// Maximum breakpoint width. Null for the largest (last) breakpoint.\n// The maximum value is calculated as the minimum of the next one less 0.02px\n// to work around the limitations of `min-` and `max-` prefixes and viewports with fractional widths.\n// See https://www.w3.org/TR/mediaqueries-4/#mq-min-max\n// Uses 0.02px rather than 0.01px to work around a current rounding bug in Safari.\n// See https://bugs.webkit.org/show_bug.cgi?id=178261\n//\n//    >> breakpoint-max(sm, (xs: 0, sm: 576px, md: 768px, lg: 992px, xl: 1200px))\n//    767.98px\n@function breakpoint-max($name, $breakpoints: $grid-breakpoints) {\n  $next: breakpoint-next($name, $breakpoints);\n  @return if($next, breakpoint-min($next, $breakpoints) - .02, null);\n}\n\n// Returns a blank string if smallest breakpoint, otherwise returns the name with a dash in front.\n// Useful for making responsive utilities.\n//\n//    >> breakpoint-infix(xs, (xs: 0, sm: 576px, md: 768px, lg: 992px, xl: 1200px))\n//    \"\"  (Returns a blank string)\n//    >> breakpoint-infix(sm, (xs: 0, sm: 576px, md: 768px, lg: 992px, xl: 1200px))\n//    \"-sm\"\n@function breakpoint-infix($name, $breakpoints: $grid-breakpoints) {\n  @return if(breakpoint-min($name, $breakpoints) == null, \"\", \"-#{$name}\");\n}\n\n// Media of at least the minimum breakpoint width. No query for the smallest breakpoint.\n// Makes the @content apply to the given breakpoint and wider.\n@mixin media-breakpoint-up($name, $breakpoints: $grid-breakpoints) {\n  $min: breakpoint-min($name, $breakpoints);\n  @if $min {\n    @media (min-width: $min) {\n      @content;\n    }\n  } @else {\n    @content;\n  }\n}\n\n// Media of at most the maximum breakpoint width. No query for the largest breakpoint.\n// Makes the @content apply to the given breakpoint and narrower.\n@mixin media-breakpoint-down($name, $breakpoints: $grid-breakpoints) {\n  $max: breakpoint-max($name, $breakpoints);\n  @if $max {\n    @media (max-width: $max) {\n      @content;\n    }\n  } @else {\n    @content;\n  }\n}\n\n// Media that spans multiple breakpoint widths.\n// Makes the @content apply between the min and max breakpoints\n@mixin media-breakpoint-between($lower, $upper, $breakpoints: $grid-breakpoints) {\n  $min: breakpoint-min($lower, $breakpoints);\n  $max: breakpoint-max($upper, $breakpoints);\n\n  @if $min != null and $max != null {\n    @media (min-width: $min) and (max-width: $max) {\n      @content;\n    }\n  } @else if $max == null {\n    @include media-breakpoint-up($lower, $breakpoints) {\n      @content;\n    }\n  } @else if $min == null {\n    @include media-breakpoint-down($upper, $breakpoints) {\n      @content;\n    }\n  }\n}\n\n// Media between the breakpoint's minimum and maximum widths.\n// No minimum for the smallest breakpoint, and no maximum for the largest one.\n// Makes the @content apply only to the given breakpoint, not viewports any wider or narrower.\n@mixin media-breakpoint-only($name, $breakpoints: $grid-breakpoints) {\n  $min: breakpoint-min($name, $breakpoints);\n  $max: breakpoint-max($name, $breakpoints);\n\n  @if $min != null and $max != null {\n    @media (min-width: $min) and (max-width: $max) {\n      @content;\n    }\n  } @else if $max == null {\n    @include media-breakpoint-up($name, $breakpoints) {\n      @content;\n    }\n  } @else if $min == null {\n    @include media-breakpoint-down($name, $breakpoints) {\n      @content;\n    }\n  }\n}\n","// Framework grid generation\n//\n// Used only by Bootstrap to generate the correct number of grid classes given\n// any value of `$grid-columns`.\n\n@mixin make-grid-columns($columns: $grid-columns, $gutter: $grid-gutter-width, $breakpoints: $grid-breakpoints) {\n  // Common properties for all breakpoints\n  %grid-column {\n    position: relative;\n    width: 100%;\n    padding-right: $gutter / 2;\n    padding-left: $gutter / 2;\n  }\n\n  @each $breakpoint in map-keys($breakpoints) {\n    $infix: breakpoint-infix($breakpoint, $breakpoints);\n\n    @if $columns > 0 {\n      // Allow columns to stretch full width below their breakpoints\n      @for $i from 1 through $columns {\n        .col#{$infix}-#{$i} {\n          @extend %grid-column;\n        }\n      }\n    }\n\n    .col#{$infix},\n    .col#{$infix}-auto {\n      @extend %grid-column;\n    }\n\n    @include media-breakpoint-up($breakpoint, $breakpoints) {\n      // Provide basic `.col-{bp}` classes for equal-width flexbox columns\n      .col#{$infix} {\n        flex-basis: 0;\n        flex-grow: 1;\n        max-width: 100%;\n      }\n\n      @if $grid-row-columns > 0 {\n        @for $i from 1 through $grid-row-columns {\n          .row-cols#{$infix}-#{$i} {\n            @include row-cols($i);\n          }\n        }\n      }\n\n      .col#{$infix}-auto {\n        @include make-col-auto();\n      }\n\n      @if $columns > 0 {\n        @for $i from 1 through $columns {\n          .col#{$infix}-#{$i} {\n            @include make-col($i, $columns);\n          }\n        }\n      }\n\n      .order#{$infix}-first { order: -1; }\n\n      .order#{$infix}-last { order: $columns + 1; }\n\n      @for $i from 0 through $columns {\n        .order#{$infix}-#{$i} { order: $i; }\n      }\n\n      @if $columns > 0 {\n        // `$columns - 1` because offsetting by the width of an entire row isn't possible\n        @for $i from 0 through ($columns - 1) {\n          @if not ($infix == \"\" and $i == 0) { // Avoid emitting useless .offset-0\n            .offset#{$infix}-#{$i} {\n              @include make-col-offset($i, $columns);\n            }\n          }\n        }\n      }\n    }\n  }\n}\n","//\n// Basic Bootstrap table\n//\n\n.table {\n  width: 100%;\n  margin-bottom: $spacer;\n  color: $table-color;\n  background-color: $table-bg; // Reset for nesting within parents with `background-color`.\n\n  th,\n  td {\n    padding: $table-cell-padding;\n    vertical-align: top;\n    border-top: $table-border-width solid $table-border-color;\n  }\n\n  thead th {\n    vertical-align: bottom;\n    border-bottom: (2 * $table-border-width) solid $table-border-color;\n  }\n\n  tbody + tbody {\n    border-top: (2 * $table-border-width) solid $table-border-color;\n  }\n}\n\n\n//\n// Condensed table w/ half padding\n//\n\n.table-sm {\n  th,\n  td {\n    padding: $table-cell-padding-sm;\n  }\n}\n\n\n// Border versions\n//\n// Add or remove borders all around the table and between all the columns.\n\n.table-bordered {\n  border: $table-border-width solid $table-border-color;\n\n  th,\n  td {\n    border: $table-border-width solid $table-border-color;\n  }\n\n  thead {\n    th,\n    td {\n      border-bottom-width: 2 * $table-border-width;\n    }\n  }\n}\n\n.table-borderless {\n  th,\n  td,\n  thead th,\n  tbody + tbody {\n    border: 0;\n  }\n}\n\n// Zebra-striping\n//\n// Default zebra-stripe styles (alternating gray and transparent backgrounds)\n\n.table-striped {\n  tbody tr:nth-of-type(#{$table-striped-order}) {\n    background-color: $table-accent-bg;\n  }\n}\n\n\n// Hover effect\n//\n// Placed here since it has to come after the potential zebra striping\n\n.table-hover {\n  tbody tr {\n    @include hover() {\n      color: $table-hover-color;\n      background-color: $table-hover-bg;\n    }\n  }\n}\n\n\n// Table backgrounds\n//\n// Exact selectors below required to override `.table-striped` and prevent\n// inheritance to nested tables.\n\n@each $color, $value in $theme-colors {\n  @include table-row-variant($color, theme-color-level($color, $table-bg-level), theme-color-level($color, $table-border-level));\n}\n\n@include table-row-variant(active, $table-active-bg);\n\n\n// Dark styles\n//\n// Same table markup, but inverted color scheme: dark background and light text.\n\n// stylelint-disable-next-line no-duplicate-selectors\n.table {\n  .thead-dark {\n    th {\n      color: $table-dark-color;\n      background-color: $table-dark-bg;\n      border-color: $table-dark-border-color;\n    }\n  }\n\n  .thead-light {\n    th {\n      color: $table-head-color;\n      background-color: $table-head-bg;\n      border-color: $table-border-color;\n    }\n  }\n}\n\n.table-dark {\n  color: $table-dark-color;\n  background-color: $table-dark-bg;\n\n  th,\n  td,\n  thead th {\n    border-color: $table-dark-border-color;\n  }\n\n  &.table-bordered {\n    border: 0;\n  }\n\n  &.table-striped {\n    tbody tr:nth-of-type(#{$table-striped-order}) {\n      background-color: $table-dark-accent-bg;\n    }\n  }\n\n  &.table-hover {\n    tbody tr {\n      @include hover() {\n        color: $table-dark-hover-color;\n        background-color: $table-dark-hover-bg;\n      }\n    }\n  }\n}\n\n\n// Responsive tables\n//\n// Generate series of `.table-responsive-*` classes for configuring the screen\n// size of where your table will overflow.\n\n.table-responsive {\n  @each $breakpoint in map-keys($grid-breakpoints) {\n    $next: breakpoint-next($breakpoint, $grid-breakpoints);\n    $infix: breakpoint-infix($next, $grid-breakpoints);\n\n    &#{$infix} {\n      @include media-breakpoint-down($breakpoint) {\n        display: block;\n        width: 100%;\n        overflow-x: auto;\n        -webkit-overflow-scrolling: touch;\n\n        // Prevent double border on horizontal scroll due to use of `display: block;`\n        > .table-bordered {\n          border: 0;\n        }\n      }\n    }\n  }\n}\n","// Tables\n\n@mixin table-row-variant($state, $background, $border: null) {\n  // Exact selectors below required to override `.table-striped` and prevent\n  // inheritance to nested tables.\n  .table-#{$state} {\n    &,\n    > th,\n    > td {\n      background-color: $background;\n    }\n\n    @if $border != null {\n      th,\n      td,\n      thead th,\n      tbody + tbody {\n        border-color: $border;\n      }\n    }\n  }\n\n  // Hover states for `.table-hover`\n  // Note: this is not available for cells or rows within `thead` or `tfoot`.\n  .table-hover {\n    $hover-background: darken($background, 5%);\n\n    .table-#{$state} {\n      @include hover() {\n        background-color: $hover-background;\n\n        > td,\n        > th {\n          background-color: $hover-background;\n        }\n      }\n    }\n  }\n}\n","// stylelint-disable selector-no-qualifying-type\n\n//\n// Textual form controls\n//\n\n.form-control {\n  display: block;\n  width: 100%;\n  height: $input-height;\n  padding: $input-padding-y $input-padding-x;\n  font-family: $input-font-family;\n  @include font-size($input-font-size);\n  font-weight: $input-font-weight;\n  line-height: $input-line-height;\n  color: $input-color;\n  background-color: $input-bg;\n  background-clip: padding-box;\n  border: $input-border-width solid $input-border-color;\n\n  // Note: This has no effect on <select>s in some browsers, due to the limited stylability of `<select>`s in CSS.\n  @include border-radius($input-border-radius, 0);\n\n  @include box-shadow($input-box-shadow);\n  @include transition($input-transition);\n\n  // Unstyle the caret on `<select>`s in IE10+.\n  &::-ms-expand {\n    background-color: transparent;\n    border: 0;\n  }\n\n  // Remove select outline from select box in FF\n  &:-moz-focusring {\n    color: transparent;\n    text-shadow: 0 0 0 $input-color;\n  }\n\n  // Customize the `:focus` state to imitate native WebKit styles.\n  @include form-control-focus($ignore-warning: true);\n\n  // Placeholder\n  &::placeholder {\n    color: $input-placeholder-color;\n    // Override Firefox's unusual default opacity; see https://github.com/twbs/bootstrap/pull/11526.\n    opacity: 1;\n  }\n\n  // Disabled and read-only inputs\n  //\n  // HTML5 says that controls under a fieldset > legend:first-child won't be\n  // disabled if the fieldset is disabled. Due to implementation difficulty, we\n  // don't honor that edge case; we style them as disabled anyway.\n  &:disabled,\n  &[readonly] {\n    background-color: $input-disabled-bg;\n    // iOS fix for unreadable disabled content; see https://github.com/twbs/bootstrap/issues/11655.\n    opacity: 1;\n  }\n}\n\ninput[type=\"date\"],\ninput[type=\"time\"],\ninput[type=\"datetime-local\"],\ninput[type=\"month\"] {\n  &.form-control {\n    appearance: none; // Fix appearance for date inputs in Safari\n  }\n}\n\nselect.form-control {\n  &:focus::-ms-value {\n    // Suppress the nested default white text on blue background highlight given to\n    // the selected option text when the (still closed) <select> receives focus\n    // in IE and (under certain conditions) Edge, as it looks bad and cannot be made to\n    // match the appearance of the native widget.\n    // See https://github.com/twbs/bootstrap/issues/19398.\n    color: $input-color;\n    background-color: $input-bg;\n  }\n}\n\n// Make file inputs better match text inputs by forcing them to new lines.\n.form-control-file,\n.form-control-range {\n  display: block;\n  width: 100%;\n}\n\n\n//\n// Labels\n//\n\n// For use with horizontal and inline forms, when you need the label (or legend)\n// text to align with the form controls.\n.col-form-label {\n  padding-top: add($input-padding-y, $input-border-width);\n  padding-bottom: add($input-padding-y, $input-border-width);\n  margin-bottom: 0; // Override the `<label>/<legend>` default\n  @include font-size(inherit); // Override the `<legend>` default\n  line-height: $input-line-height;\n}\n\n.col-form-label-lg {\n  padding-top: add($input-padding-y-lg, $input-border-width);\n  padding-bottom: add($input-padding-y-lg, $input-border-width);\n  @include font-size($input-font-size-lg);\n  line-height: $input-line-height-lg;\n}\n\n.col-form-label-sm {\n  padding-top: add($input-padding-y-sm, $input-border-width);\n  padding-bottom: add($input-padding-y-sm, $input-border-width);\n  @include font-size($input-font-size-sm);\n  line-height: $input-line-height-sm;\n}\n\n\n// Readonly controls as plain text\n//\n// Apply class to a readonly input to make it appear like regular plain\n// text (without any border, background color, focus indicator)\n\n.form-control-plaintext {\n  display: block;\n  width: 100%;\n  padding: $input-padding-y 0;\n  margin-bottom: 0; // match inputs if this class comes on inputs with default margins\n  @include font-size($input-font-size);\n  line-height: $input-line-height;\n  color: $input-plaintext-color;\n  background-color: transparent;\n  border: solid transparent;\n  border-width: $input-border-width 0;\n\n  &.form-control-sm,\n  &.form-control-lg {\n    padding-right: 0;\n    padding-left: 0;\n  }\n}\n\n\n// Form control sizing\n//\n// Build on `.form-control` with modifier classes to decrease or increase the\n// height and font-size of form controls.\n//\n// Repeated in `_input_group.scss` to avoid Sass extend issues.\n\n.form-control-sm {\n  height: $input-height-sm;\n  padding: $input-padding-y-sm $input-padding-x-sm;\n  @include font-size($input-font-size-sm);\n  line-height: $input-line-height-sm;\n  @include border-radius($input-border-radius-sm);\n}\n\n.form-control-lg {\n  height: $input-height-lg;\n  padding: $input-padding-y-lg $input-padding-x-lg;\n  @include font-size($input-font-size-lg);\n  line-height: $input-line-height-lg;\n  @include border-radius($input-border-radius-lg);\n}\n\n// stylelint-disable-next-line no-duplicate-selectors\nselect.form-control {\n  &[size],\n  &[multiple] {\n    height: auto;\n  }\n}\n\ntextarea.form-control {\n  height: auto;\n}\n\n// Form groups\n//\n// Designed to help with the organization and spacing of vertical forms. For\n// horizontal forms, use the predefined grid classes.\n\n.form-group {\n  margin-bottom: $form-group-margin-bottom;\n}\n\n.form-text {\n  display: block;\n  margin-top: $form-text-margin-top;\n}\n\n\n// Form grid\n//\n// Special replacement for our grid system's `.row` for tighter form layouts.\n\n.form-row {\n  display: flex;\n  flex-wrap: wrap;\n  margin-right: -$form-grid-gutter-width / 2;\n  margin-left: -$form-grid-gutter-width / 2;\n\n  > .col,\n  > [class*=\"col-\"] {\n    padding-right: $form-grid-gutter-width / 2;\n    padding-left: $form-grid-gutter-width / 2;\n  }\n}\n\n\n// Checkboxes and radios\n//\n// Indent the labels to position radios/checkboxes as hanging controls.\n\n.form-check {\n  position: relative;\n  display: block;\n  padding-left: $form-check-input-gutter;\n}\n\n.form-check-input {\n  position: absolute;\n  margin-top: $form-check-input-margin-y;\n  margin-left: -$form-check-input-gutter;\n\n  // Use [disabled] and :disabled for workaround https://github.com/twbs/bootstrap/issues/28247\n  &[disabled] ~ .form-check-label,\n  &:disabled ~ .form-check-label {\n    color: $text-muted;\n  }\n}\n\n.form-check-label {\n  margin-bottom: 0; // Override default `<label>` bottom margin\n}\n\n.form-check-inline {\n  display: inline-flex;\n  align-items: center;\n  padding-left: 0; // Override base .form-check\n  margin-right: $form-check-inline-margin-x;\n\n  // Undo .form-check-input defaults and add some `margin-right`.\n  .form-check-input {\n    position: static;\n    margin-top: 0;\n    margin-right: $form-check-inline-input-margin-x;\n    margin-left: 0;\n  }\n}\n\n\n// Form validation\n//\n// Provide feedback to users when form field values are valid or invalid. Works\n// primarily for client-side validation via scoped `:invalid` and `:valid`\n// pseudo-classes but also includes `.is-invalid` and `.is-valid` classes for\n// server side validation.\n\n@each $state, $data in $form-validation-states {\n  @include form-validation-state($state, map-get($data, color), map-get($data, icon));\n}\n\n// Inline forms\n//\n// Make forms appear inline(-block) by adding the `.form-inline` class. Inline\n// forms begin stacked on extra small (mobile) devices and then go inline when\n// viewports reach <768px.\n//\n// Requires wrapping inputs and labels with `.form-group` for proper display of\n// default HTML form controls and our custom form controls (e.g., input groups).\n\n.form-inline {\n  display: flex;\n  flex-flow: row wrap;\n  align-items: center; // Prevent shorter elements from growing to same height as others (e.g., small buttons growing to normal sized button height)\n\n  // Because we use flex, the initial sizing of checkboxes is collapsed and\n  // doesn't occupy the full-width (which is what we want for xs grid tier),\n  // so we force that here.\n  .form-check {\n    width: 100%;\n  }\n\n  // Kick in the inline\n  @include media-breakpoint-up(sm) {\n    label {\n      display: flex;\n      align-items: center;\n      justify-content: center;\n      margin-bottom: 0;\n    }\n\n    // Inline-block all the things for \"inline\"\n    .form-group {\n      display: flex;\n      flex: 0 0 auto;\n      flex-flow: row wrap;\n      align-items: center;\n      margin-bottom: 0;\n    }\n\n    // Allow folks to *not* use `.form-group`\n    .form-control {\n      display: inline-block;\n      width: auto; // Prevent labels from stacking above inputs in `.form-group`\n      vertical-align: middle;\n    }\n\n    // Make static controls behave like regular ones\n    .form-control-plaintext {\n      display: inline-block;\n    }\n\n    .input-group,\n    .custom-select {\n      width: auto;\n    }\n\n    // Remove default margin on radios/checkboxes that were used for stacking, and\n    // then undo the floating of radios and checkboxes to match.\n    .form-check {\n      display: flex;\n      align-items: center;\n      justify-content: center;\n      width: auto;\n      padding-left: 0;\n    }\n    .form-check-input {\n      position: relative;\n      flex-shrink: 0;\n      margin-top: 0;\n      margin-right: $form-check-input-margin-x;\n      margin-left: 0;\n    }\n\n    .custom-control {\n      align-items: center;\n      justify-content: center;\n    }\n    .custom-control-label {\n      margin-bottom: 0;\n    }\n  }\n}\n","// stylelint-disable property-disallowed-list\n@mixin transition($transition...) {\n  @if length($transition) == 0 {\n    $transition: $transition-base;\n  }\n\n  @if length($transition) > 1 {\n    @each $value in $transition {\n      @if $value == null or $value == none {\n        @warn \"The keyword 'none' or 'null' must be used as a single argument.\";\n      }\n    }\n  }\n\n  @if $enable-transitions {\n    @if nth($transition, 1) != null {\n      transition: $transition;\n    }\n\n    @if $enable-prefers-reduced-motion-media-query and nth($transition, 1) != null and nth($transition, 1) != none {\n      @media (prefers-reduced-motion: reduce) {\n        transition: none;\n      }\n    }\n  }\n}\n","@mixin form-control-focus($ignore-warning) {\n  &:focus {\n    color: $input-focus-color;\n    background-color: $input-focus-bg;\n    border-color: $input-focus-border-color;\n    outline: 0;\n    // Avoid using mixin so we can pass custom focus shadow properly\n    @if $enable-shadows {\n      box-shadow: $input-box-shadow, $input-focus-box-shadow;\n    } @else {\n      box-shadow: $input-focus-box-shadow;\n    }\n  }\n}\n\n@mixin form-validation-state($state, $color, $icon) {\n  .#{$state}-feedback {\n    display: none;\n    width: 100%;\n    margin-top: $form-feedback-margin-top;\n    font-size: $form-feedback-font-size;\n    color: $color;\n  }\n\n  .#{$state}-tooltip {\n    position: absolute;\n    top: 100%;\n    z-index: 5;\n    display: none;\n    max-width: 100%; // Contain to parent when possible\n    padding: 0.5rem;\n    margin-top: 0.1rem;\n    font-size: 0.875rem;\n    line-height: 1;\n    color: #fff;\n    background-color: rgba($color, 0.8);\n    border-radius: 0.2rem;\n  }\n\n  .form-control,\n  .custom-select {\n    .was-validated &:#{$state},\n    &.is-#{$state} {\n      border-color: $color;\n\n      &:focus {\n        border-color: $color;\n        //box-shadow: 0 1px $input-focus-width 0 rgba($color, .75);\n      }\n\n      ~ .#{$state}-feedback,\n      ~ .#{$state}-tooltip {\n        display: block;\n      }\n    }\n  }\n\n  .form-check-input {\n    .was-validated &:#{$state},\n    &.is-#{$state} {\n      ~ .form-check-label {\n        color: $color;\n      }\n\n      ~ .#{$state}-feedback,\n      ~ .#{$state}-tooltip {\n        display: block;\n      }\n    }\n  }\n\n  .custom-control-input {\n    .was-validated &:#{$state},\n    &.is-#{$state} {\n      ~ .custom-control-label {\n        color: $color;\n\n        &::before {\n          background-color: lighten($color, 25%);\n          border-color: lighten($color, 25%);\n        }\n      }\n\n      ~ .#{$state}-feedback,\n      ~ .#{$state}-tooltip {\n        display: block;\n      }\n\n      &:checked {\n        ~ .custom-control-label::before {\n          @include gradient-bg(lighten($color, 10%));\n          border-color: lighten($color, 25%);\n        }\n      }\n\n      &:focus {\n        ~ .custom-control-label::before {\n          box-shadow:\n            0 0 0 1px $body-bg,\n            0 0 0 $input-focus-width rgba($color, 0.25);\n        }\n      }\n    }\n  }\n\n  // custom file\n  .custom-file-input {\n    .was-validated &:#{$state},\n    &.is-#{$state} {\n      ~ .custom-file-label {\n        border-color: $color;\n\n        &::before {\n          border-color: inherit;\n        }\n      }\n\n      ~ .#{$state}-feedback,\n      ~ .#{$state}-tooltip {\n        display: block;\n      }\n\n      &:focus {\n        ~ .custom-file-label {\n          box-shadow: 0 0 0 $input-focus-width rgba($color, 0.25);\n        }\n      }\n    }\n  }\n}\n","// Gradients\n\n@mixin gradient-bg($color) {\n  @if $enable-gradients {\n    background: $color linear-gradient(180deg, mix($body-bg, $color, 15%), $color) repeat-x;\n  } @else {\n    background-color: $color;\n  }\n}\n\n// Horizontal gradient, from left to right\n//\n// Creates two color stops, start and end, by specifying a color and position for each color stop.\n@mixin gradient-x($start-color: $gray-700, $end-color: $gray-800, $start-percent: 0%, $end-percent: 100%) {\n  background-image: linear-gradient(to right, $start-color $start-percent, $end-color $end-percent);\n  background-repeat: repeat-x;\n}\n\n// Vertical gradient, from top to bottom\n//\n// Creates two color stops, start and end, by specifying a color and position for each color stop.\n@mixin gradient-y($start-color: $gray-700, $end-color: $gray-800, $start-percent: 0%, $end-percent: 100%) {\n  background-image: linear-gradient(to bottom, $start-color $start-percent, $end-color $end-percent);\n  background-repeat: repeat-x;\n}\n\n@mixin gradient-directional($start-color: $gray-700, $end-color: $gray-800, $deg: 45deg) {\n  background-image: linear-gradient($deg, $start-color, $end-color);\n  background-repeat: repeat-x;\n}\n@mixin gradient-x-three-colors($start-color: $blue, $mid-color: $purple, $color-stop: 50%, $end-color: $red) {\n  background-image: linear-gradient(to right, $start-color, $mid-color $color-stop, $end-color);\n  background-repeat: no-repeat;\n}\n@mixin gradient-y-three-colors($start-color: $blue, $mid-color: $purple, $color-stop: 50%, $end-color: $red) {\n  background-image: linear-gradient($start-color, $mid-color $color-stop, $end-color);\n  background-repeat: no-repeat;\n}\n@mixin gradient-radial($inner-color: $gray-700, $outer-color: $gray-800) {\n  background-image: radial-gradient(circle, $inner-color, $outer-color);\n  background-repeat: no-repeat;\n}\n@mixin gradient-striped($color: rgba($white, .15), $angle: 45deg) {\n  background-image: linear-gradient($angle, $color 25%, transparent 25%, transparent 50%, $color 50%, $color 75%, transparent 75%, transparent);\n}\n","// stylelint-disable selector-no-qualifying-type\n\n//\n// Base styles\n//\n\n.btn {\n  display: inline-block;\n  font-family: $btn-font-family;\n  font-weight: $btn-font-weight;\n  color: $body-color;\n  text-align: center;\n  text-decoration: if($link-decoration == none, null, none);\n  white-space: $btn-white-space;\n  vertical-align: middle;\n  user-select: none;\n  background-color: transparent;\n  border: $btn-border-width solid transparent;\n  @include button-size($btn-padding-y, $btn-padding-x, $btn-font-size, $btn-line-height, $btn-border-radius);\n  @include transition($btn-transition);\n\n  @include hover() {\n    color: $body-color;\n    text-decoration: none;\n  }\n\n  &:focus,\n  &.focus {\n    outline: 0;\n    box-shadow: $btn-focus-box-shadow;\n  }\n\n  // Disabled comes first so active can properly restyle\n  &.disabled,\n  &:disabled {\n    opacity: $btn-disabled-opacity;\n    @include box-shadow(none);\n  }\n\n  &:not(:disabled):not(.disabled) {\n    cursor: if($enable-pointer-cursor-for-buttons, pointer, null);\n\n    &:active,\n    &.active {\n      @include box-shadow($btn-active-box-shadow);\n\n      &:focus {\n        @include box-shadow($btn-focus-box-shadow, $btn-active-box-shadow);\n      }\n    }\n  }\n}\n\n// Future-proof disabling of clicks on `<a>` elements\na.btn.disabled,\nfieldset:disabled a.btn {\n  pointer-events: none;\n}\n\n\n//\n// Alternate buttons\n//\n\n@each $color, $value in $theme-colors {\n  .btn-#{$color} {\n    @include button-variant($value, $value);\n  }\n}\n\n@each $color, $value in $theme-colors {\n  .btn-outline-#{$color} {\n    @include button-outline-variant($value);\n  }\n}\n\n\n//\n// Link buttons\n//\n\n// Make a button look and behave like a link\n.btn-link {\n  font-weight: $font-weight-normal;\n  color: $link-color;\n  text-decoration: $link-decoration;\n\n  @include hover() {\n    color: $link-hover-color;\n    text-decoration: $link-hover-decoration;\n  }\n\n  &:focus,\n  &.focus {\n    text-decoration: $link-hover-decoration;\n  }\n\n  &:disabled,\n  &.disabled {\n    color: $btn-link-disabled-color;\n    pointer-events: none;\n  }\n\n  // No need for an active state here\n}\n\n\n//\n// Button Sizes\n//\n\n.btn-lg {\n  @include button-size($btn-padding-y-lg, $btn-padding-x-lg, $btn-font-size-lg, $btn-line-height-lg, $btn-border-radius-lg);\n}\n\n.btn-sm {\n  @include button-size($btn-padding-y-sm, $btn-padding-x-sm, $btn-font-size-sm, $btn-line-height-sm, $btn-border-radius-sm);\n}\n\n\n//\n// Block button\n//\n\n.btn-block {\n  display: block;\n  width: 100%;\n\n  // Vertically space out multiple block buttons\n  + .btn-block {\n    margin-top: $btn-block-spacing-y;\n  }\n}\n\n// Specificity overrides\ninput[type=\"submit\"],\ninput[type=\"reset\"],\ninput[type=\"button\"] {\n  &.btn-block {\n    width: 100%;\n  }\n}\n","@mixin button-variant(\n  $background,\n  $border,\n  $hover-background: darken($background, 0%),\n  $hover-border: darken($border, 0%),\n  $active-background: darken($background, 10%),\n  $active-border: darken($border, 0%)\n) {\n  color: color-yiq($background);\n  @include gradient-bg($background);\n  border-color: $border;\n  @include box-shadow($btn-box-shadow);\n\n  @include hover {\n    color: color-yiq($hover-background);\n    @include gradient-bg($hover-background);\n    border-color: $hover-border;\n  }\n\n  &:focus,\n  &.focus {\n    // Avoid using mixin so we can pass custom focus shadow properly\n    @if $enable-shadows {\n      box-shadow:\n        $btn-box-shadow,\n        0 0 0 $btn-focus-width rgba($border, 0.5);\n    } @else {\n      box-shadow: 0 0 0 $btn-focus-width rgba($border, 0.5);\n    }\n  } // Disabled comes first so active can properly restyle\n  &.disabled,\n  &:disabled {\n    color: color-yiq($background);\n    background-color: $background;\n    border-color: $border;\n  }\n\n  &:not(:disabled):not(.disabled):active,\n  &:not(:disabled):not(.disabled).active,\n  .show > &.dropdown-toggle {\n    color: color-yiq($active-background);\n    background-color: $active-background;\n    @if $enable-gradients {\n      background-image: none; // Remove the gradient for the pressed/active state\n    }\n    border-color: $active-border;\n\n    &:focus {\n      // Avoid using mixin so we can pass custom focus shadow properly\n      @if $enable-shadows {\n        box-shadow:\n          $btn-active-box-shadow,\n          0 0 0 $btn-focus-width rgba($border, 0.5);\n      } @else {\n        box-shadow: 0 0 0 $btn-focus-width rgba($border, 0.5);\n      }\n    }\n  }\n}\n\n@mixin button-outline-variant(\n  $color,\n  $color-hover: color-yiq($color),\n  $active-background: $color,\n  $active-border: $color\n) {\n  color: $color;\n  background-color: transparent;\n  background-image: none;\n  border-color: $color;\n\n  &:hover {\n    color: $color-hover;\n    background-color: $active-background;\n    border-color: $active-border;\n  }\n\n  &:focus,\n  &.focus {\n    box-shadow: 0 0 0 $btn-focus-width rgba($color, 0.5);\n  }\n\n  &.disabled,\n  &:disabled {\n    color: $color;\n    background-color: transparent;\n  }\n\n  &:not(:disabled):not(.disabled):active,\n  &:not(:disabled):not(.disabled).active,\n  .show > &.dropdown-toggle {\n    color: color-yiq($active-background);\n    background-color: $active-background;\n    border-color: $active-border;\n\n    &:focus {\n      // Avoid using mixin so we can pass custom focus shadow properly\n      @if $enable-shadows and $btn-active-box-shadow !=none {\n        box-shadow:\n          $btn-active-box-shadow,\n          0 0 0 $btn-focus-width rgba($color, 0.5);\n      } @else {\n        box-shadow: 0 0 0 $btn-focus-width rgba($color, 0.5);\n      }\n    }\n  }\n}\n\n// Button sizes\n@mixin button-size(\n  $padding-y,\n  $padding-x,\n  $font-size,\n  $line-height,\n  $border-radius\n) {\n  padding: $padding-y $padding-x;\n  font-size: $font-size;\n  line-height: $line-height; // Manually declare to provide an override to the browser default\n  @if $enable-rounded {\n    border-radius: $border-radius;\n  } @else {\n    border-radius: 0;\n  }\n}\n",".fade {\n  @include transition($transition-fade);\n\n  &:not(.show) {\n    opacity: 0;\n  }\n}\n\n.collapse {\n  &:not(.show) {\n    display: none;\n  }\n}\n\n.collapsing {\n  position: relative;\n  height: 0;\n  overflow: hidden;\n  @include transition($transition-collapse);\n}\n","// The dropdown wrapper (`<div>`)\n.dropup,\n.dropright,\n.dropdown,\n.dropleft {\n  position: relative;\n}\n\n.dropdown-toggle {\n  white-space: nowrap;\n\n  // Generate the caret automatically\n  @include caret();\n}\n\n// The dropdown menu\n.dropdown-menu {\n  position: absolute;\n  top: 100%;\n  left: 0;\n  z-index: $zindex-dropdown;\n  display: none; // none by default, but block on \"open\" of the menu\n  float: left;\n  min-width: $dropdown-min-width;\n  padding: $dropdown-padding-y $dropdown-padding-x;\n  margin: $dropdown-spacer 0 0; // override default ul\n  @include font-size($dropdown-font-size);\n  color: $dropdown-color;\n  text-align: left; // Ensures proper alignment if parent has it changed (e.g., modal footer)\n  list-style: none;\n  background-color: $dropdown-bg;\n  background-clip: padding-box;\n  border: $dropdown-border-width solid $dropdown-border-color;\n  @include border-radius($dropdown-border-radius);\n  @include box-shadow($dropdown-box-shadow);\n}\n\n@each $breakpoint in map-keys($grid-breakpoints) {\n  @include media-breakpoint-up($breakpoint) {\n    $infix: breakpoint-infix($breakpoint, $grid-breakpoints);\n\n    .dropdown-menu#{$infix}-left {\n      right: auto;\n      left: 0;\n    }\n\n    .dropdown-menu#{$infix}-right {\n      right: 0;\n      left: auto;\n    }\n  }\n}\n\n// Allow for dropdowns to go bottom up (aka, dropup-menu)\n// Just add .dropup after the standard .dropdown class and you're set.\n.dropup {\n  .dropdown-menu {\n    top: auto;\n    bottom: 100%;\n    margin-top: 0;\n    margin-bottom: $dropdown-spacer;\n  }\n\n  .dropdown-toggle {\n    @include caret(up);\n  }\n}\n\n.dropright {\n  .dropdown-menu {\n    top: 0;\n    right: auto;\n    left: 100%;\n    margin-top: 0;\n    margin-left: $dropdown-spacer;\n  }\n\n  .dropdown-toggle {\n    @include caret(right);\n    &::after {\n      vertical-align: 0;\n    }\n  }\n}\n\n.dropleft {\n  .dropdown-menu {\n    top: 0;\n    right: 100%;\n    left: auto;\n    margin-top: 0;\n    margin-right: $dropdown-spacer;\n  }\n\n  .dropdown-toggle {\n    @include caret(left);\n    &::before {\n      vertical-align: 0;\n    }\n  }\n}\n\n// When Popper is enabled, reset the basic dropdown position\n// stylelint-disable-next-line no-duplicate-selectors\n.dropdown-menu {\n  &[x-placement^=\"top\"],\n  &[x-placement^=\"right\"],\n  &[x-placement^=\"bottom\"],\n  &[x-placement^=\"left\"] {\n    right: auto;\n    bottom: auto;\n  }\n}\n\n// Dividers (basically an `<hr>`) within the dropdown\n.dropdown-divider {\n  @include nav-divider($dropdown-divider-bg, $dropdown-divider-margin-y, true);\n}\n\n// Links, buttons, and more within the dropdown menu\n//\n// `<button>`-specific styles are denoted with `// For <button>s`\n.dropdown-item {\n  display: block;\n  width: 100%; // For `<button>`s\n  padding: $dropdown-item-padding-y $dropdown-item-padding-x;\n  clear: both;\n  font-weight: $font-weight-normal;\n  color: $dropdown-link-color;\n  text-align: inherit; // For `<button>`s\n  text-decoration: if($link-decoration == none, null, none);\n  white-space: nowrap; // prevent links from randomly breaking onto new lines\n  background-color: transparent; // For `<button>`s\n  border: 0; // For `<button>`s\n\n  // Prevent dropdown overflow if there's no padding\n  // See https://github.com/twbs/bootstrap/pull/27703\n  @if $dropdown-padding-y == 0 {\n    &:first-child {\n      @include border-top-radius($dropdown-inner-border-radius);\n    }\n\n    &:last-child {\n      @include border-bottom-radius($dropdown-inner-border-radius);\n    }\n  }\n\n  @include hover-focus() {\n    color: $dropdown-link-hover-color;\n    text-decoration: none;\n    @include gradient-bg($dropdown-link-hover-bg);\n  }\n\n  &.active,\n  &:active {\n    color: $dropdown-link-active-color;\n    text-decoration: none;\n    @include gradient-bg($dropdown-link-active-bg);\n  }\n\n  &.disabled,\n  &:disabled {\n    color: $dropdown-link-disabled-color;\n    pointer-events: none;\n    background-color: transparent;\n    // Remove CSS gradients if they're enabled\n    @if $enable-gradients {\n      background-image: none;\n    }\n  }\n}\n\n.dropdown-menu.show {\n  display: block;\n}\n\n// Dropdown section headers\n.dropdown-header {\n  display: block;\n  padding: $dropdown-header-padding;\n  margin-bottom: 0; // for use with heading elements\n  @include font-size($font-size-sm);\n  color: $dropdown-header-color;\n  white-space: nowrap; // as with > li > a\n}\n\n// Dropdown text\n.dropdown-item-text {\n  display: block;\n  padding: $dropdown-item-padding-y $dropdown-item-padding-x;\n  color: $dropdown-link-color;\n}\n","@mixin caret-down() {\n  border-top: $caret-width solid;\n  border-right: $caret-width solid transparent;\n  border-bottom: 0;\n  border-left: $caret-width solid transparent;\n}\n\n@mixin caret-up() {\n  border-top: 0;\n  border-right: $caret-width solid transparent;\n  border-bottom: $caret-width solid;\n  border-left: $caret-width solid transparent;\n}\n\n@mixin caret-right() {\n  border-top: $caret-width solid transparent;\n  border-right: 0;\n  border-bottom: $caret-width solid transparent;\n  border-left: $caret-width solid;\n}\n\n@mixin caret-left() {\n  border-top: $caret-width solid transparent;\n  border-right: $caret-width solid;\n  border-bottom: $caret-width solid transparent;\n}\n\n@mixin caret($direction: down) {\n  @if $enable-caret {\n    &::after {\n      display: inline-block;\n      margin-left: $caret-spacing;\n      vertical-align: $caret-vertical-align;\n      content: \"\";\n      @if $direction == down {\n        @include caret-down();\n      } @else if $direction == up {\n        @include caret-up();\n      } @else if $direction == right {\n        @include caret-right();\n      }\n    }\n\n    @if $direction == left {\n      &::after {\n        display: none;\n      }\n\n      &::before {\n        display: inline-block;\n        margin-right: $caret-spacing;\n        vertical-align: $caret-vertical-align;\n        content: \"\";\n        @include caret-left();\n      }\n    }\n\n    &:empty::after {\n      margin-left: 0;\n    }\n  }\n}\n","// Horizontal dividers\n//\n// Dividers (basically an hr) within dropdowns and nav lists\n\n@mixin nav-divider($color: $nav-divider-color, $margin-y: $nav-divider-margin-y, $ignore-warning: false) {\n  height: 0;\n  margin: $margin-y 0;\n  overflow: hidden;\n  border-top: 1px solid $color;\n  @include deprecate(\"The `nav-divider()` mixin\", \"v4.4.0\", \"v5\", $ignore-warning);\n}\n","// stylelint-disable selector-no-qualifying-type\n\n// Make the div behave like a button\n.btn-group,\n.btn-group-vertical {\n  position: relative;\n  display: inline-flex;\n  vertical-align: middle; // match .btn alignment given font-size hack above\n\n  > .btn {\n    position: relative;\n    flex: 1 1 auto;\n\n    // Bring the hover, focused, and \"active\" buttons to the front to overlay\n    // the borders properly\n    @include hover() {\n      z-index: 1;\n    }\n    &:focus,\n    &:active,\n    &.active {\n      z-index: 1;\n    }\n  }\n}\n\n// Optional: Group multiple button groups together for a toolbar\n.btn-toolbar {\n  display: flex;\n  flex-wrap: wrap;\n  justify-content: flex-start;\n\n  .input-group {\n    width: auto;\n  }\n}\n\n.btn-group {\n  // Prevent double borders when buttons are next to each other\n  > .btn:not(:first-child),\n  > .btn-group:not(:first-child) {\n    margin-left: -$btn-border-width;\n  }\n\n  // Reset rounded corners\n  > .btn:not(:last-child):not(.dropdown-toggle),\n  > .btn-group:not(:last-child) > .btn {\n    @include border-right-radius(0);\n  }\n\n  > .btn:not(:first-child),\n  > .btn-group:not(:first-child) > .btn {\n    @include border-left-radius(0);\n  }\n}\n\n// Sizing\n//\n// Remix the default button sizing classes into new ones for easier manipulation.\n\n.btn-group-sm > .btn { @extend .btn-sm; }\n.btn-group-lg > .btn { @extend .btn-lg; }\n\n\n//\n// Split button dropdowns\n//\n\n.dropdown-toggle-split {\n  padding-right: $btn-padding-x * .75;\n  padding-left: $btn-padding-x * .75;\n\n  &::after,\n  .dropup &::after,\n  .dropright &::after {\n    margin-left: 0;\n  }\n\n  .dropleft &::before {\n    margin-right: 0;\n  }\n}\n\n.btn-sm + .dropdown-toggle-split {\n  padding-right: $btn-padding-x-sm * .75;\n  padding-left: $btn-padding-x-sm * .75;\n}\n\n.btn-lg + .dropdown-toggle-split {\n  padding-right: $btn-padding-x-lg * .75;\n  padding-left: $btn-padding-x-lg * .75;\n}\n\n\n// The clickable button for toggling the menu\n// Set the same inset shadow as the :active state\n.btn-group.show .dropdown-toggle {\n  @include box-shadow($btn-active-box-shadow);\n\n  // Show no shadow for `.btn-link` since it has no other button styles.\n  &.btn-link {\n    @include box-shadow(none);\n  }\n}\n\n\n//\n// Vertical button groups\n//\n\n.btn-group-vertical {\n  flex-direction: column;\n  align-items: flex-start;\n  justify-content: center;\n\n  > .btn,\n  > .btn-group {\n    width: 100%;\n  }\n\n  > .btn:not(:first-child),\n  > .btn-group:not(:first-child) {\n    margin-top: -$btn-border-width;\n  }\n\n  // Reset rounded corners\n  > .btn:not(:last-child):not(.dropdown-toggle),\n  > .btn-group:not(:last-child) > .btn {\n    @include border-bottom-radius(0);\n  }\n\n  > .btn:not(:first-child),\n  > .btn-group:not(:first-child) > .btn {\n    @include border-top-radius(0);\n  }\n}\n\n\n// Checkbox and radio options\n//\n// In order to support the browser's form validation feedback, powered by the\n// `required` attribute, we have to \"hide\" the inputs via `clip`. We cannot use\n// `display: none;` or `visibility: hidden;` as that also hides the popover.\n// Simply visually hiding the inputs via `opacity` would leave them clickable in\n// certain cases which is prevented by using `clip` and `pointer-events`.\n// This way, we ensure a DOM element is visible to position the popover from.\n//\n// See https://github.com/twbs/bootstrap/pull/12794 and\n// https://github.com/twbs/bootstrap/pull/14559 for more information.\n\n.btn-group-toggle {\n  > .btn,\n  > .btn-group > .btn {\n    margin-bottom: 0; // Override default `<label>` value\n\n    input[type=\"radio\"],\n    input[type=\"checkbox\"] {\n      position: absolute;\n      clip: rect(0, 0, 0, 0);\n      pointer-events: none;\n    }\n  }\n}\n","// stylelint-disable selector-no-qualifying-type\n\n//\n// Base styles\n//\n\n.input-group {\n  position: relative;\n  display: flex;\n  flex-wrap: wrap; // For form validation feedback\n  align-items: stretch;\n  width: 100%;\n\n  > .form-control,\n  > .form-control-plaintext,\n  > .custom-select,\n  > .custom-file {\n    position: relative; // For focus state's z-index\n    flex: 1 1 auto;\n    width: 1%;\n    min-width: 0; // https://stackoverflow.com/questions/36247140/why-dont-flex-items-shrink-past-content-size\n    margin-bottom: 0;\n\n    + .form-control,\n    + .custom-select,\n    + .custom-file {\n      margin-left: -$input-border-width;\n    }\n  }\n\n  // Bring the \"active\" form control to the top of surrounding elements\n  > .form-control:focus,\n  > .custom-select:focus,\n  > .custom-file .custom-file-input:focus ~ .custom-file-label {\n    z-index: 3;\n  }\n\n  // Bring the custom file input above the label\n  > .custom-file .custom-file-input:focus {\n    z-index: 4;\n  }\n\n  > .form-control,\n  > .custom-select {\n    &:not(:first-child) { @include border-left-radius(0); }\n  }\n\n  // Custom file inputs have more complex markup, thus requiring different\n  // border-radius overrides.\n  > .custom-file {\n    display: flex;\n    align-items: center;\n\n    &:not(:last-child) .custom-file-label,\n    &:not(:first-child) .custom-file-label { @include border-left-radius(0); }\n  }\n\n  &:not(.has-validation) {\n    > .form-control:not(:last-child),\n    > .custom-select:not(:last-child),\n    > .custom-file:not(:last-child) .custom-file-label::after {\n      @include border-right-radius(0);\n    }\n  }\n\n  &.has-validation {\n    > .form-control:nth-last-child(n + 3),\n    > .custom-select:nth-last-child(n + 3),\n    > .custom-file:nth-last-child(n + 3) .custom-file-label::after {\n      @include border-right-radius(0);\n    }\n  }\n}\n\n\n// Prepend and append\n//\n// While it requires one extra layer of HTML for each, dedicated prepend and\n// append elements allow us to 1) be less clever, 2) simplify our selectors, and\n// 3) support HTML5 form validation.\n\n.input-group-prepend,\n.input-group-append {\n  display: flex;\n\n  // Ensure buttons are always above inputs for more visually pleasing borders.\n  // This isn't needed for `.input-group-text` since it shares the same border-color\n  // as our inputs.\n  .btn {\n    position: relative;\n    z-index: 2;\n\n    &:focus {\n      z-index: 3;\n    }\n  }\n\n  .btn + .btn,\n  .btn + .input-group-text,\n  .input-group-text + .input-group-text,\n  .input-group-text + .btn {\n    margin-left: -$input-border-width;\n  }\n}\n\n.input-group-prepend { margin-right: -$input-border-width; }\n.input-group-append { margin-left: -$input-border-width; }\n\n\n// Textual addons\n//\n// Serves as a catch-all element for any text or radio/checkbox input you wish\n// to prepend or append to an input.\n\n.input-group-text {\n  display: flex;\n  align-items: center;\n  padding: $input-padding-y $input-padding-x;\n  margin-bottom: 0; // Allow use of <label> elements by overriding our default margin-bottom\n  @include font-size($input-font-size); // Match inputs\n  font-weight: $font-weight-normal;\n  line-height: $input-line-height;\n  color: $input-group-addon-color;\n  text-align: center;\n  white-space: nowrap;\n  background-color: $input-group-addon-bg;\n  border: $input-border-width solid $input-group-addon-border-color;\n  @include border-radius($input-border-radius);\n\n  // Nuke default margins from checkboxes and radios to vertically center within.\n  input[type=\"radio\"],\n  input[type=\"checkbox\"] {\n    margin-top: 0;\n  }\n}\n\n\n// Sizing\n//\n// Remix the default form control sizing classes into new ones for easier\n// manipulation.\n\n.input-group-lg > .form-control:not(textarea),\n.input-group-lg > .custom-select {\n  height: $input-height-lg;\n}\n\n.input-group-lg > .form-control,\n.input-group-lg > .custom-select,\n.input-group-lg > .input-group-prepend > .input-group-text,\n.input-group-lg > .input-group-append > .input-group-text,\n.input-group-lg > .input-group-prepend > .btn,\n.input-group-lg > .input-group-append > .btn {\n  padding: $input-padding-y-lg $input-padding-x-lg;\n  @include font-size($input-font-size-lg);\n  line-height: $input-line-height-lg;\n  @include border-radius($input-border-radius-lg);\n}\n\n.input-group-sm > .form-control:not(textarea),\n.input-group-sm > .custom-select {\n  height: $input-height-sm;\n}\n\n.input-group-sm > .form-control,\n.input-group-sm > .custom-select,\n.input-group-sm > .input-group-prepend > .input-group-text,\n.input-group-sm > .input-group-append > .input-group-text,\n.input-group-sm > .input-group-prepend > .btn,\n.input-group-sm > .input-group-append > .btn {\n  padding: $input-padding-y-sm $input-padding-x-sm;\n  @include font-size($input-font-size-sm);\n  line-height: $input-line-height-sm;\n  @include border-radius($input-border-radius-sm);\n}\n\n.input-group-lg > .custom-select,\n.input-group-sm > .custom-select {\n  padding-right: $custom-select-padding-x + $custom-select-indicator-padding;\n}\n\n\n// Prepend and append rounded corners\n//\n// These rulesets must come after the sizing ones to properly override sm and lg\n// border-radius values when extending. They're more specific than we'd like\n// with the `.input-group >` part, but without it, we cannot override the sizing.\n\n\n.input-group > .input-group-prepend > .btn,\n.input-group > .input-group-prepend > .input-group-text,\n.input-group:not(.has-validation) > .input-group-append:not(:last-child) > .btn,\n.input-group:not(.has-validation) > .input-group-append:not(:last-child) > .input-group-text,\n.input-group.has-validation > .input-group-append:nth-last-child(n + 3) > .btn,\n.input-group.has-validation > .input-group-append:nth-last-child(n + 3) > .input-group-text,\n.input-group > .input-group-append:last-child > .btn:not(:last-child):not(.dropdown-toggle),\n.input-group > .input-group-append:last-child > .input-group-text:not(:last-child) {\n  @include border-right-radius(0);\n}\n\n.input-group > .input-group-append > .btn,\n.input-group > .input-group-append > .input-group-text,\n.input-group > .input-group-prepend:not(:first-child) > .btn,\n.input-group > .input-group-prepend:not(:first-child) > .input-group-text,\n.input-group > .input-group-prepend:first-child > .btn:not(:first-child),\n.input-group > .input-group-prepend:first-child > .input-group-text:not(:first-child) {\n  @include border-left-radius(0);\n}\n","// Embedded icons from Open Iconic.\n// Released under MIT and copyright 2014 Waybury.\n// https://useiconic.com/open\n\n\n// Checkboxes and radios\n//\n// Base class takes care of all the key behavioral aspects.\n\n.custom-control {\n  position: relative;\n  z-index: 1;\n  display: block;\n  min-height: $font-size-base * $line-height-base;\n  padding-left: $custom-control-gutter + $custom-control-indicator-size;\n  color-adjust: exact; // Keep themed appearance for print\n}\n\n.custom-control-inline {\n  display: inline-flex;\n  margin-right: $custom-control-spacer-x;\n}\n\n.custom-control-input {\n  position: absolute;\n  left: 0;\n  z-index: -1; // Put the input behind the label so it doesn't overlay text\n  width: $custom-control-indicator-size;\n  height: ($font-size-base * $line-height-base + $custom-control-indicator-size) / 2;\n  opacity: 0;\n\n  &:checked ~ .custom-control-label::before {\n    color: $custom-control-indicator-checked-color;\n    border-color: $custom-control-indicator-checked-border-color;\n    @include gradient-bg($custom-control-indicator-checked-bg);\n    @include box-shadow($custom-control-indicator-checked-box-shadow);\n  }\n\n  &:focus ~ .custom-control-label::before {\n    // the mixin is not used here to make sure there is feedback\n    @if $enable-shadows {\n      box-shadow: $input-box-shadow, $custom-control-indicator-focus-box-shadow;\n    } @else {\n      box-shadow: $custom-control-indicator-focus-box-shadow;\n    }\n  }\n\n  &:focus:not(:checked) ~ .custom-control-label::before {\n    border-color: $custom-control-indicator-focus-border-color;\n  }\n\n  &:not(:disabled):active ~ .custom-control-label::before {\n    color: $custom-control-indicator-active-color;\n    background-color: $custom-control-indicator-active-bg;\n    border-color: $custom-control-indicator-active-border-color;\n    @include box-shadow($custom-control-indicator-active-box-shadow);\n  }\n\n  // Use [disabled] and :disabled to work around https://github.com/twbs/bootstrap/issues/28247\n  &[disabled],\n  &:disabled {\n    ~ .custom-control-label {\n      color: $custom-control-label-disabled-color;\n\n      &::before {\n        background-color: $custom-control-indicator-disabled-bg;\n      }\n    }\n  }\n}\n\n// Custom control indicators\n//\n// Build the custom controls out of pseudo-elements.\n\n.custom-control-label {\n  position: relative;\n  margin-bottom: 0;\n  color: $custom-control-label-color;\n  vertical-align: top;\n  cursor: $custom-control-cursor;\n\n  // Background-color and (when enabled) gradient\n  &::before {\n    position: absolute;\n    top: ($font-size-base * $line-height-base - $custom-control-indicator-size) / 2;\n    left: -($custom-control-gutter + $custom-control-indicator-size);\n    display: block;\n    width: $custom-control-indicator-size;\n    height: $custom-control-indicator-size;\n    pointer-events: none;\n    content: \"\";\n    background-color: $custom-control-indicator-bg;\n    border: $custom-control-indicator-border-color solid $custom-control-indicator-border-width;\n    @include box-shadow($custom-control-indicator-box-shadow);\n  }\n\n  // Foreground (icon)\n  &::after {\n    position: absolute;\n    top: ($font-size-base * $line-height-base - $custom-control-indicator-size) / 2;\n    left: -($custom-control-gutter + $custom-control-indicator-size);\n    display: block;\n    width: $custom-control-indicator-size;\n    height: $custom-control-indicator-size;\n    content: \"\";\n    background: 50% / #{$custom-control-indicator-bg-size} no-repeat;\n  }\n}\n\n\n// Checkboxes\n//\n// Tweak just a few things for checkboxes.\n\n.custom-checkbox {\n  .custom-control-label::before {\n    @include border-radius($custom-checkbox-indicator-border-radius);\n  }\n\n  .custom-control-input:checked ~ .custom-control-label {\n    &::after {\n      background-image: escape-svg($custom-checkbox-indicator-icon-checked);\n    }\n  }\n\n  .custom-control-input:indeterminate ~ .custom-control-label {\n    &::before {\n      border-color: $custom-checkbox-indicator-indeterminate-border-color;\n      @include gradient-bg($custom-checkbox-indicator-indeterminate-bg);\n      @include box-shadow($custom-checkbox-indicator-indeterminate-box-shadow);\n    }\n    &::after {\n      background-image: escape-svg($custom-checkbox-indicator-icon-indeterminate);\n    }\n  }\n\n  .custom-control-input:disabled {\n    &:checked ~ .custom-control-label::before {\n      @include gradient-bg($custom-control-indicator-checked-disabled-bg);\n    }\n    &:indeterminate ~ .custom-control-label::before {\n      @include gradient-bg($custom-control-indicator-checked-disabled-bg);\n    }\n  }\n}\n\n// Radios\n//\n// Tweak just a few things for radios.\n\n.custom-radio {\n  .custom-control-label::before {\n    // stylelint-disable-next-line property-disallowed-list\n    border-radius: $custom-radio-indicator-border-radius;\n  }\n\n  .custom-control-input:checked ~ .custom-control-label {\n    &::after {\n      background-image: escape-svg($custom-radio-indicator-icon-checked);\n    }\n  }\n\n  .custom-control-input:disabled {\n    &:checked ~ .custom-control-label::before {\n      @include gradient-bg($custom-control-indicator-checked-disabled-bg);\n    }\n  }\n}\n\n\n// switches\n//\n// Tweak a few things for switches\n\n.custom-switch {\n  padding-left: $custom-switch-width + $custom-control-gutter;\n\n  .custom-control-label {\n    &::before {\n      left: -($custom-switch-width + $custom-control-gutter);\n      width: $custom-switch-width;\n      pointer-events: all;\n      // stylelint-disable-next-line property-disallowed-list\n      border-radius: $custom-switch-indicator-border-radius;\n    }\n\n    &::after {\n      top: add(($font-size-base * $line-height-base - $custom-control-indicator-size) / 2, $custom-control-indicator-border-width * 2);\n      left: add(-($custom-switch-width + $custom-control-gutter), $custom-control-indicator-border-width * 2);\n      width: $custom-switch-indicator-size;\n      height: $custom-switch-indicator-size;\n      background-color: $custom-control-indicator-border-color;\n      // stylelint-disable-next-line property-disallowed-list\n      border-radius: $custom-switch-indicator-border-radius;\n      @include transition(transform .15s ease-in-out, $custom-forms-transition);\n    }\n  }\n\n  .custom-control-input:checked ~ .custom-control-label {\n    &::after {\n      background-color: $custom-control-indicator-bg;\n      transform: translateX($custom-switch-width - $custom-control-indicator-size);\n    }\n  }\n\n  .custom-control-input:disabled {\n    &:checked ~ .custom-control-label::before {\n      @include gradient-bg($custom-control-indicator-checked-disabled-bg);\n    }\n  }\n}\n\n\n// Select\n//\n// Replaces the browser default select with a custom one, mostly pulled from\n// https://primer.github.io/.\n//\n\n.custom-select {\n  display: inline-block;\n  width: 100%;\n  height: $custom-select-height;\n  padding: $custom-select-padding-y ($custom-select-padding-x + $custom-select-indicator-padding) $custom-select-padding-y $custom-select-padding-x;\n  font-family: $custom-select-font-family;\n  @include font-size($custom-select-font-size);\n  font-weight: $custom-select-font-weight;\n  line-height: $custom-select-line-height;\n  color: $custom-select-color;\n  vertical-align: middle;\n  background: $custom-select-bg $custom-select-background;\n  border: $custom-select-border-width solid $custom-select-border-color;\n  @include border-radius($custom-select-border-radius, 0);\n  @include box-shadow($custom-select-box-shadow);\n  appearance: none;\n\n  &:focus {\n    border-color: $custom-select-focus-border-color;\n    outline: 0;\n    @if $enable-shadows {\n      @include box-shadow($custom-select-box-shadow, $custom-select-focus-box-shadow);\n    } @else {\n      // Avoid using mixin so we can pass custom focus shadow properly\n      box-shadow: $custom-select-focus-box-shadow;\n    }\n\n    &::-ms-value {\n      // For visual consistency with other platforms/browsers,\n      // suppress the default white text on blue background highlight given to\n      // the selected option text when the (still closed) <select> receives focus\n      // in IE and (under certain conditions) Edge.\n      // See https://github.com/twbs/bootstrap/issues/19398.\n      color: $input-color;\n      background-color: $input-bg;\n    }\n  }\n\n  &[multiple],\n  &[size]:not([size=\"1\"]) {\n    height: auto;\n    padding-right: $custom-select-padding-x;\n    background-image: none;\n  }\n\n  &:disabled {\n    color: $custom-select-disabled-color;\n    background-color: $custom-select-disabled-bg;\n  }\n\n  // Hides the default caret in IE11\n  &::-ms-expand {\n    display: none;\n  }\n\n  // Remove outline from select box in FF\n  &:-moz-focusring {\n    color: transparent;\n    text-shadow: 0 0 0 $custom-select-color;\n  }\n}\n\n.custom-select-sm {\n  height: $custom-select-height-sm;\n  padding-top: $custom-select-padding-y-sm;\n  padding-bottom: $custom-select-padding-y-sm;\n  padding-left: $custom-select-padding-x-sm;\n  @include font-size($custom-select-font-size-sm);\n}\n\n.custom-select-lg {\n  height: $custom-select-height-lg;\n  padding-top: $custom-select-padding-y-lg;\n  padding-bottom: $custom-select-padding-y-lg;\n  padding-left: $custom-select-padding-x-lg;\n  @include font-size($custom-select-font-size-lg);\n}\n\n\n// File\n//\n// Custom file input.\n\n.custom-file {\n  position: relative;\n  display: inline-block;\n  width: 100%;\n  height: $custom-file-height;\n  margin-bottom: 0;\n}\n\n.custom-file-input {\n  position: relative;\n  z-index: 2;\n  width: 100%;\n  height: $custom-file-height;\n  margin: 0;\n  overflow: hidden;\n  opacity: 0;\n\n  &:focus ~ .custom-file-label {\n    border-color: $custom-file-focus-border-color;\n    box-shadow: $custom-file-focus-box-shadow;\n  }\n\n  // Use [disabled] and :disabled to work around https://github.com/twbs/bootstrap/issues/28247\n  &[disabled] ~ .custom-file-label,\n  &:disabled ~ .custom-file-label {\n    background-color: $custom-file-disabled-bg;\n  }\n\n  @each $lang, $value in $custom-file-text {\n    &:lang(#{$lang}) ~ .custom-file-label::after {\n      content: $value;\n    }\n  }\n\n  ~ .custom-file-label[data-browse]::after {\n    content: attr(data-browse);\n  }\n}\n\n.custom-file-label {\n  position: absolute;\n  top: 0;\n  right: 0;\n  left: 0;\n  z-index: 1;\n  height: $custom-file-height;\n  padding: $custom-file-padding-y $custom-file-padding-x;\n  overflow: hidden;\n  font-family: $custom-file-font-family;\n  font-weight: $custom-file-font-weight;\n  line-height: $custom-file-line-height;\n  color: $custom-file-color;\n  background-color: $custom-file-bg;\n  border: $custom-file-border-width solid $custom-file-border-color;\n  @include border-radius($custom-file-border-radius);\n  @include box-shadow($custom-file-box-shadow);\n\n  &::after {\n    position: absolute;\n    top: 0;\n    right: 0;\n    bottom: 0;\n    z-index: 3;\n    display: block;\n    height: $custom-file-height-inner;\n    padding: $custom-file-padding-y $custom-file-padding-x;\n    line-height: $custom-file-line-height;\n    color: $custom-file-button-color;\n    content: \"Browse\";\n    @include gradient-bg($custom-file-button-bg);\n    border-left: inherit;\n    @include border-radius(0 $custom-file-border-radius $custom-file-border-radius 0);\n  }\n}\n\n// Range\n//\n// Style range inputs the same across browsers. Vendor-specific rules for pseudo\n// elements cannot be mixed. As such, there are no shared styles for focus or\n// active states on prefixed selectors.\n\n.custom-range {\n  width: 100%;\n  height: add($custom-range-thumb-height, $custom-range-thumb-focus-box-shadow-width * 2);\n  padding: 0; // Need to reset padding\n  background-color: transparent;\n  appearance: none;\n\n  &:focus {\n    outline: 0;\n\n    // Pseudo-elements must be split across multiple rulesets to have an effect.\n    // No box-shadow() mixin for focus accessibility.\n    &::-webkit-slider-thumb { box-shadow: $custom-range-thumb-focus-box-shadow; }\n    &::-moz-range-thumb     { box-shadow: $custom-range-thumb-focus-box-shadow; }\n    &::-ms-thumb            { box-shadow: $custom-range-thumb-focus-box-shadow; }\n  }\n\n  &::-moz-focus-outer {\n    border: 0;\n  }\n\n  &::-webkit-slider-thumb {\n    width: $custom-range-thumb-width;\n    height: $custom-range-thumb-height;\n    margin-top: ($custom-range-track-height - $custom-range-thumb-height) / 2; // Webkit specific\n    @include gradient-bg($custom-range-thumb-bg);\n    border: $custom-range-thumb-border;\n    @include border-radius($custom-range-thumb-border-radius);\n    @include box-shadow($custom-range-thumb-box-shadow);\n    @include transition($custom-forms-transition);\n    appearance: none;\n\n    &:active {\n      @include gradient-bg($custom-range-thumb-active-bg);\n    }\n  }\n\n  &::-webkit-slider-runnable-track {\n    width: $custom-range-track-width;\n    height: $custom-range-track-height;\n    color: transparent; // Why?\n    cursor: $custom-range-track-cursor;\n    background-color: $custom-range-track-bg;\n    border-color: transparent;\n    @include border-radius($custom-range-track-border-radius);\n    @include box-shadow($custom-range-track-box-shadow);\n  }\n\n  &::-moz-range-thumb {\n    width: $custom-range-thumb-width;\n    height: $custom-range-thumb-height;\n    @include gradient-bg($custom-range-thumb-bg);\n    border: $custom-range-thumb-border;\n    @include border-radius($custom-range-thumb-border-radius);\n    @include box-shadow($custom-range-thumb-box-shadow);\n    @include transition($custom-forms-transition);\n    appearance: none;\n\n    &:active {\n      @include gradient-bg($custom-range-thumb-active-bg);\n    }\n  }\n\n  &::-moz-range-track {\n    width: $custom-range-track-width;\n    height: $custom-range-track-height;\n    color: transparent;\n    cursor: $custom-range-track-cursor;\n    background-color: $custom-range-track-bg;\n    border-color: transparent; // Firefox specific?\n    @include border-radius($custom-range-track-border-radius);\n    @include box-shadow($custom-range-track-box-shadow);\n  }\n\n  &::-ms-thumb {\n    width: $custom-range-thumb-width;\n    height: $custom-range-thumb-height;\n    margin-top: 0; // Edge specific\n    margin-right: $custom-range-thumb-focus-box-shadow-width; // Workaround that overflowed box-shadow is hidden.\n    margin-left: $custom-range-thumb-focus-box-shadow-width;  // Workaround that overflowed box-shadow is hidden.\n    @include gradient-bg($custom-range-thumb-bg);\n    border: $custom-range-thumb-border;\n    @include border-radius($custom-range-thumb-border-radius);\n    @include box-shadow($custom-range-thumb-box-shadow);\n    @include transition($custom-forms-transition);\n    appearance: none;\n\n    &:active {\n      @include gradient-bg($custom-range-thumb-active-bg);\n    }\n  }\n\n  &::-ms-track {\n    width: $custom-range-track-width;\n    height: $custom-range-track-height;\n    color: transparent;\n    cursor: $custom-range-track-cursor;\n    background-color: transparent;\n    border-color: transparent;\n    border-width: $custom-range-thumb-height / 2;\n    @include box-shadow($custom-range-track-box-shadow);\n  }\n\n  &::-ms-fill-lower {\n    background-color: $custom-range-track-bg;\n    @include border-radius($custom-range-track-border-radius);\n  }\n\n  &::-ms-fill-upper {\n    margin-right: 15px; // arbitrary?\n    background-color: $custom-range-track-bg;\n    @include border-radius($custom-range-track-border-radius);\n  }\n\n  &:disabled {\n    &::-webkit-slider-thumb {\n      background-color: $custom-range-thumb-disabled-bg;\n    }\n\n    &::-webkit-slider-runnable-track {\n      cursor: default;\n    }\n\n    &::-moz-range-thumb {\n      background-color: $custom-range-thumb-disabled-bg;\n    }\n\n    &::-moz-range-track {\n      cursor: default;\n    }\n\n    &::-ms-thumb {\n      background-color: $custom-range-thumb-disabled-bg;\n    }\n  }\n}\n\n.custom-control-label::before,\n.custom-file-label,\n.custom-select {\n  @include transition($custom-forms-transition);\n}\n","// Base class\n//\n// Kickstart any navigation component with a set of style resets. Works with\n// `<nav>`s, `<ul>`s or `<ol>`s.\n\n.nav {\n  display: flex;\n  flex-wrap: wrap;\n  padding-left: 0;\n  margin-bottom: 0;\n  list-style: none;\n}\n\n.nav-link {\n  display: block;\n  padding: $nav-link-padding-y $nav-link-padding-x;\n  text-decoration: if($link-decoration == none, null, none);\n\n  @include hover-focus() {\n    text-decoration: none;\n  }\n\n  // Disabled state lightens text\n  &.disabled {\n    color: $nav-link-disabled-color;\n    pointer-events: none;\n    cursor: default;\n  }\n}\n\n//\n// Tabs\n//\n\n.nav-tabs {\n  border-bottom: $nav-tabs-border-width solid $nav-tabs-border-color;\n\n  .nav-link {\n    margin-bottom: -$nav-tabs-border-width;\n    border: $nav-tabs-border-width solid transparent;\n    @include border-top-radius($nav-tabs-border-radius);\n\n    @include hover-focus() {\n      border-color: $nav-tabs-link-hover-border-color;\n    }\n\n    &.disabled {\n      color: $nav-link-disabled-color;\n      background-color: transparent;\n      border-color: transparent;\n    }\n  }\n\n  .nav-link.active,\n  .nav-item.show .nav-link {\n    color: $nav-tabs-link-active-color;\n    background-color: $nav-tabs-link-active-bg;\n    border-color: $nav-tabs-link-active-border-color;\n  }\n\n  .dropdown-menu {\n    // Make dropdown border overlap tab border\n    margin-top: -$nav-tabs-border-width;\n    // Remove the top rounded corners here since there is a hard edge above the menu\n    @include border-top-radius(0);\n  }\n}\n\n\n//\n// Pills\n//\n\n.nav-pills {\n  .nav-link {\n    @include border-radius($nav-pills-border-radius);\n  }\n\n  .nav-link.active,\n  .show > .nav-link {\n    color: $nav-pills-link-active-color;\n    background-color: $nav-pills-link-active-bg;\n  }\n}\n\n\n//\n// Justified variants\n//\n\n.nav-fill {\n  > .nav-link,\n  .nav-item {\n    flex: 1 1 auto;\n    text-align: center;\n  }\n}\n\n.nav-justified {\n  > .nav-link,\n  .nav-item {\n    flex-basis: 0;\n    flex-grow: 1;\n    text-align: center;\n  }\n}\n\n\n// Tabbable tabs\n//\n// Hide tabbable panes to start, show them when `.active`\n\n.tab-content {\n  > .tab-pane {\n    display: none;\n  }\n  > .active {\n    display: block;\n  }\n}\n","// Contents\n//\n// Navbar\n// Navbar brand\n// Navbar nav\n// Navbar text\n// Navbar divider\n// Responsive navbar\n// Navbar position\n// Navbar themes\n\n\n// Navbar\n//\n// Provide a static navbar from which we expand to create full-width, fixed, and\n// other navbar variations.\n\n.navbar {\n  position: relative;\n  display: flex;\n  flex-wrap: wrap; // allow us to do the line break for collapsing content\n  align-items: center;\n  justify-content: space-between; // space out brand from logo\n  padding: $navbar-padding-y $navbar-padding-x;\n\n  // Because flex properties aren't inherited, we need to redeclare these first\n  // few properties so that content nested within behave properly.\n  %container-flex-properties {\n    display: flex;\n    flex-wrap: wrap;\n    align-items: center;\n    justify-content: space-between;\n  }\n\n  .container,\n  .container-fluid {\n    @extend %container-flex-properties;\n  }\n\n  @each $breakpoint, $container-max-width in $container-max-widths {\n    > .container#{breakpoint-infix($breakpoint, $container-max-widths)} {\n      @extend %container-flex-properties;\n    }\n  }\n}\n\n\n// Navbar brand\n//\n// Used for brand, project, or site names.\n\n.navbar-brand {\n  display: inline-block;\n  padding-top: $navbar-brand-padding-y;\n  padding-bottom: $navbar-brand-padding-y;\n  margin-right: $navbar-padding-x;\n  @include font-size($navbar-brand-font-size);\n  line-height: inherit;\n  white-space: nowrap;\n\n  @include hover-focus() {\n    text-decoration: none;\n  }\n}\n\n\n// Navbar nav\n//\n// Custom navbar navigation (doesn't require `.nav`, but does make use of `.nav-link`).\n\n.navbar-nav {\n  display: flex;\n  flex-direction: column; // cannot use `inherit` to get the `.navbar`s value\n  padding-left: 0;\n  margin-bottom: 0;\n  list-style: none;\n\n  .nav-link {\n    padding-right: 0;\n    padding-left: 0;\n  }\n\n  .dropdown-menu {\n    position: static;\n    float: none;\n  }\n}\n\n\n// Navbar text\n//\n//\n\n.navbar-text {\n  display: inline-block;\n  padding-top: $nav-link-padding-y;\n  padding-bottom: $nav-link-padding-y;\n}\n\n\n// Responsive navbar\n//\n// Custom styles for responsive collapsing and toggling of navbar contents.\n// Powered by the collapse Bootstrap JavaScript plugin.\n\n// When collapsed, prevent the toggleable navbar contents from appearing in\n// the default flexbox row orientation. Requires the use of `flex-wrap: wrap`\n// on the `.navbar` parent.\n.navbar-collapse {\n  flex-basis: 100%;\n  flex-grow: 1;\n  // For always expanded or extra full navbars, ensure content aligns itself\n  // properly vertically. Can be easily overridden with flex utilities.\n  align-items: center;\n}\n\n// Button for toggling the navbar when in its collapsed state\n.navbar-toggler {\n  padding: $navbar-toggler-padding-y $navbar-toggler-padding-x;\n  @include font-size($navbar-toggler-font-size);\n  line-height: 1;\n  background-color: transparent; // remove default button style\n  border: $border-width solid transparent; // remove default button style\n  @include border-radius($navbar-toggler-border-radius);\n\n  @include hover-focus() {\n    text-decoration: none;\n  }\n}\n\n// Keep as a separate element so folks can easily override it with another icon\n// or image file as needed.\n.navbar-toggler-icon {\n  display: inline-block;\n  width: 1.5em;\n  height: 1.5em;\n  vertical-align: middle;\n  content: \"\";\n  background: 50% / 100% 100% no-repeat;\n}\n\n.navbar-nav-scroll {\n  max-height: $navbar-nav-scroll-max-height;\n  overflow-y: auto;\n}\n\n// Generate series of `.navbar-expand-*` responsive classes for configuring\n// where your navbar collapses.\n.navbar-expand {\n  @each $breakpoint in map-keys($grid-breakpoints) {\n    $next: breakpoint-next($breakpoint, $grid-breakpoints);\n    $infix: breakpoint-infix($next, $grid-breakpoints);\n\n    &#{$infix} {\n      @include media-breakpoint-down($breakpoint) {\n        %container-navbar-expand-#{$breakpoint} {\n          padding-right: 0;\n          padding-left: 0;\n        }\n\n        > .container,\n        > .container-fluid {\n          @extend %container-navbar-expand-#{$breakpoint};\n        }\n\n        @each $size, $container-max-width in $container-max-widths {\n          > .container#{breakpoint-infix($size, $container-max-widths)} {\n            @extend %container-navbar-expand-#{$breakpoint};\n          }\n        }\n      }\n\n      @include media-breakpoint-up($next) {\n        flex-flow: row nowrap;\n        justify-content: flex-start;\n\n        .navbar-nav {\n          flex-direction: row;\n\n          .dropdown-menu {\n            position: absolute;\n          }\n\n          .nav-link {\n            padding-right: $navbar-nav-link-padding-x;\n            padding-left: $navbar-nav-link-padding-x;\n          }\n        }\n\n        // For nesting containers, have to redeclare for alignment purposes\n        %container-nesting-#{$breakpoint} {\n          flex-wrap: nowrap;\n        }\n\n        > .container,\n        > .container-fluid {\n          @extend %container-nesting-#{$breakpoint};\n        }\n\n        @each $size, $container-max-width in $container-max-widths {\n          > .container#{breakpoint-infix($size, $container-max-widths)} {\n            @extend %container-nesting-#{$breakpoint};\n          }\n        }\n\n        .navbar-nav-scroll {\n          overflow: visible;\n        }\n\n        .navbar-collapse {\n          display: flex !important; // stylelint-disable-line declaration-no-important\n\n          // Changes flex-bases to auto because of an IE10 bug\n          flex-basis: auto;\n        }\n\n        .navbar-toggler {\n          display: none;\n        }\n      }\n    }\n  }\n}\n\n\n// Navbar themes\n//\n// Styles for switching between navbars with light or dark background.\n\n// Dark links against a light background\n.navbar-light {\n  .navbar-brand {\n    color: $navbar-light-brand-color;\n\n    @include hover-focus() {\n      color: $navbar-light-brand-hover-color;\n    }\n  }\n\n  .navbar-nav {\n    .nav-link {\n      color: $navbar-light-color;\n\n      @include hover-focus() {\n        color: $navbar-light-hover-color;\n      }\n\n      &.disabled {\n        color: $navbar-light-disabled-color;\n      }\n    }\n\n    .show > .nav-link,\n    .active > .nav-link,\n    .nav-link.show,\n    .nav-link.active {\n      color: $navbar-light-active-color;\n    }\n  }\n\n  .navbar-toggler {\n    color: $navbar-light-color;\n    border-color: $navbar-light-toggler-border-color;\n  }\n\n  .navbar-toggler-icon {\n    background-image: escape-svg($navbar-light-toggler-icon-bg);\n  }\n\n  .navbar-text {\n    color: $navbar-light-color;\n    a {\n      color: $navbar-light-active-color;\n\n      @include hover-focus() {\n        color: $navbar-light-active-color;\n      }\n    }\n  }\n}\n\n// White links against a dark background\n.navbar-dark {\n  .navbar-brand {\n    color: $navbar-dark-brand-color;\n\n    @include hover-focus() {\n      color: $navbar-dark-brand-hover-color;\n    }\n  }\n\n  .navbar-nav {\n    .nav-link {\n      color: $navbar-dark-color;\n\n      @include hover-focus() {\n        color: $navbar-dark-hover-color;\n      }\n\n      &.disabled {\n        color: $navbar-dark-disabled-color;\n      }\n    }\n\n    .show > .nav-link,\n    .active > .nav-link,\n    .nav-link.show,\n    .nav-link.active {\n      color: $navbar-dark-active-color;\n    }\n  }\n\n  .navbar-toggler {\n    color: $navbar-dark-color;\n    border-color: $navbar-dark-toggler-border-color;\n  }\n\n  .navbar-toggler-icon {\n    background-image: escape-svg($navbar-dark-toggler-icon-bg);\n  }\n\n  .navbar-text {\n    color: $navbar-dark-color;\n    a {\n      color: $navbar-dark-active-color;\n\n      @include hover-focus() {\n        color: $navbar-dark-active-color;\n      }\n    }\n  }\n}\n","//\n// Base styles\n//\n\n.card {\n  position: relative;\n  display: flex;\n  flex-direction: column;\n  min-width: 0; // See https://github.com/twbs/bootstrap/pull/22740#issuecomment-305868106\n  height: $card-height;\n  word-wrap: break-word;\n  background-color: $card-bg;\n  background-clip: border-box;\n  border: $card-border-width solid $card-border-color;\n  @include border-radius($card-border-radius);\n\n  > hr {\n    margin-right: 0;\n    margin-left: 0;\n  }\n\n  > .list-group {\n    border-top: inherit;\n    border-bottom: inherit;\n\n    &:first-child {\n      border-top-width: 0;\n      @include border-top-radius($card-inner-border-radius);\n    }\n\n    &:last-child  {\n      border-bottom-width: 0;\n      @include border-bottom-radius($card-inner-border-radius);\n    }\n  }\n\n  // Due to specificity of the above selector (`.card > .list-group`), we must\n  // use a child selector here to prevent double borders.\n  > .card-header + .list-group,\n  > .list-group + .card-footer {\n    border-top: 0;\n  }\n}\n\n.card-body {\n  // Enable `flex-grow: 1` for decks and groups so that card blocks take up\n  // as much space as possible, ensuring footers are aligned to the bottom.\n  flex: 1 1 auto;\n  // Workaround for the image size bug in IE\n  // See: https://github.com/twbs/bootstrap/pull/28855\n  min-height: 1px;\n  padding: $card-spacer-x;\n  color: $card-color;\n}\n\n.card-title {\n  margin-bottom: $card-spacer-y;\n}\n\n.card-subtitle {\n  margin-top: -$card-spacer-y / 2;\n  margin-bottom: 0;\n}\n\n.card-text:last-child {\n  margin-bottom: 0;\n}\n\n.card-link {\n  @include hover() {\n    text-decoration: none;\n  }\n\n  + .card-link {\n    margin-left: $card-spacer-x;\n  }\n}\n\n//\n// Optional textual caps\n//\n\n.card-header {\n  padding: $card-spacer-y $card-spacer-x;\n  margin-bottom: 0; // Removes the default margin-bottom of <hN>\n  color: $card-cap-color;\n  background-color: $card-cap-bg;\n  border-bottom: $card-border-width solid $card-border-color;\n\n  &:first-child {\n    @include border-radius($card-inner-border-radius $card-inner-border-radius 0 0);\n  }\n}\n\n.card-footer {\n  padding: $card-spacer-y $card-spacer-x;\n  color: $card-cap-color;\n  background-color: $card-cap-bg;\n  border-top: $card-border-width solid $card-border-color;\n\n  &:last-child {\n    @include border-radius(0 0 $card-inner-border-radius $card-inner-border-radius);\n  }\n}\n\n\n//\n// Header navs\n//\n\n.card-header-tabs {\n  margin-right: -$card-spacer-x / 2;\n  margin-bottom: -$card-spacer-y;\n  margin-left: -$card-spacer-x / 2;\n  border-bottom: 0;\n}\n\n.card-header-pills {\n  margin-right: -$card-spacer-x / 2;\n  margin-left: -$card-spacer-x / 2;\n}\n\n// Card image\n.card-img-overlay {\n  position: absolute;\n  top: 0;\n  right: 0;\n  bottom: 0;\n  left: 0;\n  padding: $card-img-overlay-padding;\n  @include border-radius($card-inner-border-radius);\n}\n\n.card-img,\n.card-img-top,\n.card-img-bottom {\n  flex-shrink: 0; // For IE: https://github.com/twbs/bootstrap/issues/29396\n  width: 100%; // Required because we use flexbox and this inherently applies align-self: stretch\n}\n\n.card-img,\n.card-img-top {\n  @include border-top-radius($card-inner-border-radius);\n}\n\n.card-img,\n.card-img-bottom {\n  @include border-bottom-radius($card-inner-border-radius);\n}\n\n\n// Card deck\n\n.card-deck {\n  .card {\n    margin-bottom: $card-deck-margin;\n  }\n\n  @include media-breakpoint-up(sm) {\n    display: flex;\n    flex-flow: row wrap;\n    margin-right: -$card-deck-margin;\n    margin-left: -$card-deck-margin;\n\n    .card {\n      // Flexbugs #4: https://github.com/philipwalton/flexbugs#flexbug-4\n      flex: 1 0 0%;\n      margin-right: $card-deck-margin;\n      margin-bottom: 0; // Override the default\n      margin-left: $card-deck-margin;\n    }\n  }\n}\n\n\n//\n// Card groups\n//\n\n.card-group {\n  // The child selector allows nested `.card` within `.card-group`\n  // to display properly.\n  > .card {\n    margin-bottom: $card-group-margin;\n  }\n\n  @include media-breakpoint-up(sm) {\n    display: flex;\n    flex-flow: row wrap;\n    // The child selector allows nested `.card` within `.card-group`\n    // to display properly.\n    > .card {\n      // Flexbugs #4: https://github.com/philipwalton/flexbugs#flexbug-4\n      flex: 1 0 0%;\n      margin-bottom: 0;\n\n      + .card {\n        margin-left: 0;\n        border-left: 0;\n      }\n\n      // Handle rounded corners\n      @if $enable-rounded {\n        &:not(:last-child) {\n          @include border-right-radius(0);\n\n          .card-img-top,\n          .card-header {\n            // stylelint-disable-next-line property-disallowed-list\n            border-top-right-radius: 0;\n          }\n          .card-img-bottom,\n          .card-footer {\n            // stylelint-disable-next-line property-disallowed-list\n            border-bottom-right-radius: 0;\n          }\n        }\n\n        &:not(:first-child) {\n          @include border-left-radius(0);\n\n          .card-img-top,\n          .card-header {\n            // stylelint-disable-next-line property-disallowed-list\n            border-top-left-radius: 0;\n          }\n          .card-img-bottom,\n          .card-footer {\n            // stylelint-disable-next-line property-disallowed-list\n            border-bottom-left-radius: 0;\n          }\n        }\n      }\n    }\n  }\n}\n\n\n//\n// Columns\n//\n\n.card-columns {\n  .card {\n    margin-bottom: $card-columns-margin;\n  }\n\n  @include media-breakpoint-up(sm) {\n    column-count: $card-columns-count;\n    column-gap: $card-columns-gap;\n    orphans: 1;\n    widows: 1;\n\n    .card {\n      display: inline-block; // Don't let them vertically span multiple columns\n      width: 100%; // Don't let their width change\n    }\n  }\n}\n\n\n//\n// Accordion\n//\n\n.accordion {\n  overflow-anchor: none;\n\n  > .card {\n    overflow: hidden;\n\n    &:not(:last-of-type) {\n      border-bottom: 0;\n      @include border-bottom-radius(0);\n    }\n\n    &:not(:first-of-type) {\n      @include border-top-radius(0);\n    }\n\n    > .card-header {\n      @include border-radius(0);\n      margin-bottom: -$card-border-width;\n    }\n  }\n}\n",".breadcrumb {\n  display: flex;\n  flex-wrap: wrap;\n  padding: $breadcrumb-padding-y $breadcrumb-padding-x;\n  margin-bottom: $breadcrumb-margin-bottom;\n  @include font-size($breadcrumb-font-size);\n  list-style: none;\n  background-color: $breadcrumb-bg;\n  @include border-radius($breadcrumb-border-radius);\n}\n\n.breadcrumb-item {\n  // The separator between breadcrumbs (by default, a forward-slash: \"/\")\n  + .breadcrumb-item {\n    padding-left: $breadcrumb-item-padding;\n\n    &::before {\n      float: left; // Suppress inline spacings and underlining of the separator\n      padding-right: $breadcrumb-item-padding;\n      color: $breadcrumb-divider-color;\n      content: escape-svg($breadcrumb-divider);\n    }\n  }\n\n  // IE9-11 hack to properly handle hyperlink underlines for breadcrumbs built\n  // without `<ul>`s. The `::before` pseudo-element generates an element\n  // *within* the .breadcrumb-item and thereby inherits the `text-decoration`.\n  //\n  // To trick IE into suppressing the underline, we give the pseudo-element an\n  // underline and then immediately remove it.\n  + .breadcrumb-item:hover::before {\n    text-decoration: underline;\n  }\n  // stylelint-disable-next-line no-duplicate-selectors\n  + .breadcrumb-item:hover::before {\n    text-decoration: none;\n  }\n\n  &.active {\n    color: $breadcrumb-active-color;\n  }\n}\n",".pagination {\n  display: flex;\n  @include list-unstyled();\n  @include border-radius();\n}\n\n.page-link {\n  position: relative;\n  display: block;\n  padding: $pagination-padding-y $pagination-padding-x;\n  margin-left: -$pagination-border-width;\n  line-height: $pagination-line-height;\n  color: $pagination-color;\n  text-decoration: if($link-decoration == none, null, none);\n  background-color: $pagination-bg;\n  border: $pagination-border-width solid $pagination-border-color;\n\n  &:hover {\n    z-index: 2;\n    color: $pagination-hover-color;\n    text-decoration: none;\n    background-color: $pagination-hover-bg;\n    border-color: $pagination-hover-border-color;\n  }\n\n  &:focus {\n    z-index: 3;\n    outline: $pagination-focus-outline;\n    box-shadow: $pagination-focus-box-shadow;\n  }\n}\n\n.page-item {\n  &:first-child {\n    .page-link {\n      margin-left: 0;\n      @include border-left-radius($border-radius);\n    }\n  }\n  &:last-child {\n    .page-link {\n      @include border-right-radius($border-radius);\n    }\n  }\n\n  &.active .page-link {\n    z-index: 3;\n    color: $pagination-active-color;\n    background-color: $pagination-active-bg;\n    border-color: $pagination-active-border-color;\n  }\n\n  &.disabled .page-link {\n    color: $pagination-disabled-color;\n    pointer-events: none;\n    // Opinionated: remove the \"hand\" cursor set previously for .page-link\n    cursor: auto;\n    background-color: $pagination-disabled-bg;\n    border-color: $pagination-disabled-border-color;\n  }\n}\n\n\n//\n// Sizing\n//\n\n.pagination-lg {\n  @include pagination-size($pagination-padding-y-lg, $pagination-padding-x-lg, $font-size-lg, $line-height-lg, $pagination-border-radius-lg);\n}\n\n.pagination-sm {\n  @include pagination-size($pagination-padding-y-sm, $pagination-padding-x-sm, $font-size-sm, $line-height-sm, $pagination-border-radius-sm);\n}\n","// Pagination\n\n@mixin pagination-size($padding-y, $padding-x, $font-size, $line-height, $border-radius) {\n  .page-link {\n    padding: $padding-y $padding-x;\n    @include font-size($font-size);\n    line-height: $line-height;\n  }\n\n  .page-item {\n    &:first-child {\n      .page-link {\n        @include border-left-radius($border-radius);\n      }\n    }\n    &:last-child {\n      .page-link {\n        @include border-right-radius($border-radius);\n      }\n    }\n  }\n}\n","// Base class\n//\n// Requires one of the contextual, color modifier classes for `color` and\n// `background-color`.\n\n.badge {\n  display: inline-block;\n  padding: $badge-padding-y $badge-padding-x;\n  @include font-size($badge-font-size);\n  font-weight: $badge-font-weight;\n  line-height: 1;\n  text-align: center;\n  white-space: nowrap;\n  vertical-align: baseline;\n  @include border-radius($badge-border-radius);\n  @include transition($badge-transition);\n\n  @at-root a#{&} {\n    @include hover-focus() {\n      text-decoration: none;\n    }\n  }\n\n  // Empty badges collapse automatically\n  &:empty {\n    display: none;\n  }\n}\n\n// Quick fix for badges in buttons\n.btn .badge {\n  position: relative;\n  top: -1px;\n}\n\n// Pill badges\n//\n// Make them extra rounded with a modifier to replace v3's badges.\n\n.badge-pill {\n  padding-right: $badge-pill-padding-x;\n  padding-left: $badge-pill-padding-x;\n  @include border-radius($badge-pill-border-radius);\n}\n\n// Colors\n//\n// Contextual variations (linked badges get darker on :hover).\n\n@each $color, $value in $theme-colors {\n  .badge-#{$color} {\n    @include badge-variant($value);\n  }\n}\n","@mixin badge-variant($bg) {\n  color: saturate(darken($bg, 10%), 10);\n  background-color: transparentize(lighten($bg, 25%), 0.5);\n\n  &[href] {\n    @include hover-focus {\n      color: color-yiq($bg);\n      text-decoration: none;\n      background-color: darken($bg, 10%);\n    }\n  }\n}\n",".jumbotron {\n  padding: $jumbotron-padding ($jumbotron-padding / 2);\n  margin-bottom: $jumbotron-padding;\n  color: $jumbotron-color;\n  background-color: $jumbotron-bg;\n  @include border-radius($border-radius-lg);\n\n  @include media-breakpoint-up(sm) {\n    padding: ($jumbotron-padding * 2) $jumbotron-padding;\n  }\n}\n\n.jumbotron-fluid {\n  padding-right: 0;\n  padding-left: 0;\n  @include border-radius(0);\n}\n","//\n// Base styles\n//\n\n.alert {\n  position: relative;\n  padding: $alert-padding-y $alert-padding-x;\n  margin-bottom: $alert-margin-bottom;\n  border: $alert-border-width solid transparent;\n  @include border-radius($alert-border-radius);\n}\n\n// Headings for larger alerts\n.alert-heading {\n  // Specified to prevent conflicts of changing $headings-color\n  color: inherit;\n}\n\n// Provide class for links that match alerts\n.alert-link {\n  font-weight: $alert-link-font-weight;\n}\n\n\n// Dismissible alerts\n//\n// Expand the right padding and account for the close button's positioning.\n\n.alert-dismissible {\n  padding-right: $close-font-size + $alert-padding-x * 2;\n\n  // Adjust close link position\n  .close {\n    position: absolute;\n    top: 0;\n    right: 0;\n    z-index: 2;\n    padding: $alert-padding-y $alert-padding-x;\n    color: inherit;\n  }\n}\n\n\n// Alternate styles\n//\n// Generate contextual modifier classes for colorizing the alert.\n\n@each $color, $value in $theme-colors {\n  .alert-#{$color} {\n    @include alert-variant(theme-color-level($color, $alert-bg-level), theme-color-level($color, $alert-border-level), theme-color-level($color, $alert-color-level));\n  }\n}\n","@mixin alert-variant($background, $border, $color) {\n  color: color-yiq($background);\n  @include gradient-bg($background);\n  border-color: $border;\n\n  hr {\n    border-top-color: darken($border, 5%);\n  }\n\n  .alert-link {\n    color: darken($color, 10%);\n  }\n}\n","// Disable animation if transitions are disabled\n@if $enable-transitions {\n  @keyframes progress-bar-stripes {\n    from { background-position: $progress-height 0; }\n    to { background-position: 0 0; }\n  }\n}\n\n.progress {\n  display: flex;\n  height: $progress-height;\n  overflow: hidden; // force rounded corners by cropping it\n  line-height: 0;\n  @include font-size($progress-font-size);\n  background-color: $progress-bg;\n  @include border-radius($progress-border-radius);\n  @include box-shadow($progress-box-shadow);\n}\n\n.progress-bar {\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  overflow: hidden;\n  color: $progress-bar-color;\n  text-align: center;\n  white-space: nowrap;\n  background-color: $progress-bar-bg;\n  @include transition($progress-bar-transition);\n}\n\n.progress-bar-striped {\n  @include gradient-striped();\n  background-size: $progress-height $progress-height;\n}\n\n@if $enable-transitions {\n  .progress-bar-animated {\n    animation: $progress-bar-animation-timing progress-bar-stripes;\n\n    @if $enable-prefers-reduced-motion-media-query {\n      @media (prefers-reduced-motion: reduce) {\n        animation: none;\n      }\n    }\n  }\n}\n",".media {\n  display: flex;\n  align-items: flex-start;\n}\n\n.media-body {\n  flex: 1;\n}\n","// Base class\n//\n// Easily usable on <ul>, <ol>, or <div>.\n\n.list-group {\n  display: flex;\n  flex-direction: column;\n\n  // No need to set list-style: none; since .list-group-item is block level\n  padding-left: 0; // reset padding because ul and ol\n  margin-bottom: 0;\n  @include border-radius($list-group-border-radius);\n}\n\n\n// Interactive list items\n//\n// Use anchor or button elements instead of `li`s or `div`s to create interactive\n// list items. Includes an extra `.active` modifier class for selected items.\n\n.list-group-item-action {\n  width: 100%; // For `<button>`s (anchors become 100% by default though)\n  color: $list-group-action-color;\n  text-align: inherit; // For `<button>`s (anchors inherit)\n\n  // Hover state\n  @include hover-focus() {\n    z-index: 1; // Place hover/focus items above their siblings for proper border styling\n    color: $list-group-action-hover-color;\n    text-decoration: none;\n    background-color: $list-group-hover-bg;\n  }\n\n  &:active {\n    color: $list-group-action-active-color;\n    background-color: $list-group-action-active-bg;\n  }\n}\n\n\n// Individual list items\n//\n// Use on `li`s or `div`s within the `.list-group` parent.\n\n.list-group-item {\n  position: relative;\n  display: block;\n  padding: $list-group-item-padding-y $list-group-item-padding-x;\n  color: $list-group-color;\n  text-decoration: if($link-decoration == none, null, none);\n  background-color: $list-group-bg;\n  border: $list-group-border-width solid $list-group-border-color;\n\n  &:first-child {\n    @include border-top-radius(inherit);\n  }\n\n  &:last-child {\n    @include border-bottom-radius(inherit);\n  }\n\n  &.disabled,\n  &:disabled {\n    color: $list-group-disabled-color;\n    pointer-events: none;\n    background-color: $list-group-disabled-bg;\n  }\n\n  // Include both here for `<a>`s and `<button>`s\n  &.active {\n    z-index: 2; // Place active items above their siblings for proper border styling\n    color: $list-group-active-color;\n    background-color: $list-group-active-bg;\n    border-color: $list-group-active-border-color;\n  }\n\n  & + & {\n    border-top-width: 0;\n\n    &.active {\n      margin-top: -$list-group-border-width;\n      border-top-width: $list-group-border-width;\n    }\n  }\n}\n\n\n// Horizontal\n//\n// Change the layout of list group items from vertical (default) to horizontal.\n\n@each $breakpoint in map-keys($grid-breakpoints) {\n  @include media-breakpoint-up($breakpoint) {\n    $infix: breakpoint-infix($breakpoint, $grid-breakpoints);\n\n    .list-group-horizontal#{$infix} {\n      flex-direction: row;\n\n      > .list-group-item {\n        &:first-child {\n          @include border-bottom-left-radius($list-group-border-radius);\n          @include border-top-right-radius(0);\n        }\n\n        &:last-child {\n          @include border-top-right-radius($list-group-border-radius);\n          @include border-bottom-left-radius(0);\n        }\n\n        &.active {\n          margin-top: 0;\n        }\n\n        + .list-group-item {\n          border-top-width: $list-group-border-width;\n          border-left-width: 0;\n\n          &.active {\n            margin-left: -$list-group-border-width;\n            border-left-width: $list-group-border-width;\n          }\n        }\n      }\n    }\n  }\n}\n\n\n// Flush list items\n//\n// Remove borders and border-radius to keep list group items edge-to-edge. Most\n// useful within other components (e.g., cards).\n\n.list-group-flush {\n  @include border-radius(0);\n\n  > .list-group-item {\n    border-width: 0 0 $list-group-border-width;\n\n    &:last-child {\n      border-bottom-width: 0;\n    }\n  }\n}\n\n\n// Contextual variants\n//\n// Add modifier classes to change text and background color on individual items.\n// Organizationally, this must come after the `:hover` states.\n\n@each $color, $value in $theme-colors {\n  @include list-group-item-variant($color, theme-color-level($color, -9), theme-color-level($color, 6));\n}\n","// List Groups\n\n@mixin list-group-item-variant($state, $background, $color) {\n  .list-group-item-#{$state} {\n    color: $color;\n    background-color: $background;\n\n    &.list-group-item-action {\n      @include hover-focus() {\n        color: $color;\n        background-color: darken($background, 5%);\n      }\n\n      &.active {\n        color: $white;\n        background-color: $color;\n        border-color: $color;\n      }\n    }\n  }\n}\n",".close {\n  float: right;\n  @include font-size($close-font-size);\n  font-weight: $close-font-weight;\n  line-height: 1;\n  color: $close-color;\n  text-shadow: $close-text-shadow;\n  opacity: .5;\n\n  // Override <a>'s hover style\n  @include hover() {\n    color: $close-color;\n    text-decoration: none;\n  }\n\n  &:not(:disabled):not(.disabled) {\n    @include hover-focus() {\n      opacity: .75;\n    }\n  }\n}\n\n// Additional properties for button version\n// iOS requires the button element instead of an anchor tag.\n// If you want the anchor version, it requires `href=\"#\"`.\n// See https://developer.mozilla.org/en-US/docs/Web/Events/click#Safari_Mobile\n\n// stylelint-disable-next-line selector-no-qualifying-type\nbutton.close {\n  padding: 0;\n  background-color: transparent;\n  border: 0;\n}\n\n// Future-proof disabling of clicks on `<a>` elements\n\n// stylelint-disable-next-line selector-no-qualifying-type\na.close.disabled {\n  pointer-events: none;\n}\n","// .modal-open      - body class for killing the scroll\n// .modal           - container to scroll within\n// .modal-dialog    - positioning shell for the actual modal\n// .modal-content   - actual modal w/ bg and corners and stuff\n\n\n.modal-open {\n  // Kill the scroll on the body\n  overflow: hidden;\n\n  .modal {\n    overflow-x: hidden;\n    overflow-y: auto;\n  }\n}\n\n// Container that the modal scrolls within\n.modal {\n  position: fixed;\n  top: 0;\n  left: 0;\n  z-index: $zindex-modal;\n  display: none;\n  width: 100%;\n  height: 100%;\n  overflow: hidden;\n  // Prevent Chrome on Windows from adding a focus outline. For details, see\n  // https://github.com/twbs/bootstrap/pull/10951.\n  outline: 0;\n  // We deliberately don't use `-webkit-overflow-scrolling: touch;` due to a\n  // gnarly iOS Safari bug: https://bugs.webkit.org/show_bug.cgi?id=158342\n  // See also https://github.com/twbs/bootstrap/issues/17695\n}\n\n// Shell div to position the modal with bottom padding\n.modal-dialog {\n  position: relative;\n  width: auto;\n  margin: $modal-dialog-margin;\n  // allow clicks to pass through for custom click handling to close modal\n  pointer-events: none;\n\n  // When fading in the modal, animate it to slide down\n  .modal.fade & {\n    @include transition($modal-transition);\n    transform: $modal-fade-transform;\n  }\n  .modal.show & {\n    transform: $modal-show-transform;\n  }\n\n  // When trying to close, animate focus to scale\n  .modal.modal-static & {\n    transform: $modal-scale-transform;\n  }\n}\n\n.modal-dialog-scrollable {\n  display: flex; // IE10/11\n  max-height: subtract(100%, $modal-dialog-margin * 2);\n\n  .modal-content {\n    max-height: subtract(100vh, $modal-dialog-margin * 2); // IE10/11\n    overflow: hidden;\n  }\n\n  .modal-header,\n  .modal-footer {\n    flex-shrink: 0;\n  }\n\n  .modal-body {\n    overflow-y: auto;\n  }\n}\n\n.modal-dialog-centered {\n  display: flex;\n  align-items: center;\n  min-height: subtract(100%, $modal-dialog-margin * 2);\n\n  // Ensure `modal-dialog-centered` extends the full height of the view (IE10/11)\n  &::before {\n    display: block; // IE10\n    height: subtract(100vh, $modal-dialog-margin * 2);\n    height: min-content; // Reset height to 0 except on IE\n    content: \"\";\n  }\n\n  // Ensure `.modal-body` shows scrollbar (IE10/11)\n  &.modal-dialog-scrollable {\n    flex-direction: column;\n    justify-content: center;\n    height: 100%;\n\n    .modal-content {\n      max-height: none;\n    }\n\n    &::before {\n      content: none;\n    }\n  }\n}\n\n// Actual modal\n.modal-content {\n  position: relative;\n  display: flex;\n  flex-direction: column;\n  width: 100%; // Ensure `.modal-content` extends the full width of the parent `.modal-dialog`\n  // counteract the pointer-events: none; in the .modal-dialog\n  color: $modal-content-color;\n  pointer-events: auto;\n  background-color: $modal-content-bg;\n  background-clip: padding-box;\n  border: $modal-content-border-width solid $modal-content-border-color;\n  @include border-radius($modal-content-border-radius);\n  @include box-shadow($modal-content-box-shadow-xs);\n  // Remove focus outline from opened modal\n  outline: 0;\n}\n\n// Modal background\n.modal-backdrop {\n  position: fixed;\n  top: 0;\n  left: 0;\n  z-index: $zindex-modal-backdrop;\n  width: 100vw;\n  height: 100vh;\n  background-color: $modal-backdrop-bg;\n\n  // Fade for backdrop\n  &.fade { opacity: 0; }\n  &.show { opacity: $modal-backdrop-opacity; }\n}\n\n// Modal header\n// Top section of the modal w/ title and dismiss\n.modal-header {\n  display: flex;\n  align-items: flex-start; // so the close btn always stays on the upper right corner\n  justify-content: space-between; // Put modal header elements (title and dismiss) on opposite ends\n  padding: $modal-header-padding;\n  border-bottom: $modal-header-border-width solid $modal-header-border-color;\n  @include border-top-radius($modal-content-inner-border-radius);\n\n  .close {\n    padding: $modal-header-padding;\n    // auto on the left force icon to the right even when there is no .modal-title\n    margin: (-$modal-header-padding-y) (-$modal-header-padding-x) (-$modal-header-padding-y) auto;\n  }\n}\n\n// Title text within header\n.modal-title {\n  margin-bottom: 0;\n  line-height: $modal-title-line-height;\n}\n\n// Modal body\n// Where all modal content resides (sibling of .modal-header and .modal-footer)\n.modal-body {\n  position: relative;\n  // Enable `flex-grow: 1` so that the body take up as much space as possible\n  // when there should be a fixed height on `.modal-dialog`.\n  flex: 1 1 auto;\n  padding: $modal-inner-padding;\n}\n\n// Footer (for actions)\n.modal-footer {\n  display: flex;\n  flex-wrap: wrap;\n  align-items: center; // vertically center\n  justify-content: flex-end; // Right align buttons with flex property because text-align doesn't work on flex items\n  padding: $modal-inner-padding - $modal-footer-margin-between / 2;\n  border-top: $modal-footer-border-width solid $modal-footer-border-color;\n  @include border-bottom-radius($modal-content-inner-border-radius);\n\n  // Place margin between footer elements\n  // This solution is far from ideal because of the universal selector usage,\n  // but is needed to fix https://github.com/twbs/bootstrap/issues/24800\n  > * {\n    margin: $modal-footer-margin-between / 2;\n  }\n}\n\n// Measure scrollbar width for padding body during modal show/hide\n.modal-scrollbar-measure {\n  position: absolute;\n  top: -9999px;\n  width: 50px;\n  height: 50px;\n  overflow: scroll;\n}\n\n// Scale up the modal\n@include media-breakpoint-up(sm) {\n  // Automatically set modal's width for larger viewports\n  .modal-dialog {\n    max-width: $modal-md;\n    margin: $modal-dialog-margin-y-sm-up auto;\n  }\n\n  .modal-dialog-scrollable {\n    max-height: subtract(100%, $modal-dialog-margin-y-sm-up * 2);\n\n    .modal-content {\n      max-height: subtract(100vh, $modal-dialog-margin-y-sm-up * 2);\n    }\n  }\n\n  .modal-dialog-centered {\n    min-height: subtract(100%, $modal-dialog-margin-y-sm-up * 2);\n\n    &::before {\n      height: subtract(100vh, $modal-dialog-margin-y-sm-up * 2);\n      height: min-content;\n    }\n  }\n\n  .modal-content {\n    @include box-shadow($modal-content-box-shadow-sm-up);\n  }\n\n  .modal-sm { max-width: $modal-sm; }\n}\n\n@include media-breakpoint-up(lg) {\n  .modal-lg,\n  .modal-xl {\n    max-width: $modal-lg;\n  }\n}\n\n@include media-breakpoint-up(xl) {\n  .modal-xl { max-width: $modal-xl; }\n}\n","// Base class\n.tooltip {\n  position: absolute;\n  z-index: $zindex-tooltip;\n  display: block;\n  margin: $tooltip-margin;\n  // Our parent element can be arbitrary since tooltips are by default inserted as a sibling of their target element.\n  // So reset our font and text properties to avoid inheriting weird values.\n  @include reset-text();\n  @include font-size($tooltip-font-size);\n  // Allow breaking very long words so they don't overflow the tooltip's bounds\n  word-wrap: break-word;\n  opacity: 0;\n\n  &.show { opacity: $tooltip-opacity; }\n\n  .arrow {\n    position: absolute;\n    display: block;\n    width: $tooltip-arrow-width;\n    height: $tooltip-arrow-height;\n\n    &::before {\n      position: absolute;\n      content: \"\";\n      border-color: transparent;\n      border-style: solid;\n    }\n  }\n}\n\n.bs-tooltip-top {\n  padding: $tooltip-arrow-height 0;\n\n  .arrow {\n    bottom: 0;\n\n    &::before {\n      top: 0;\n      border-width: $tooltip-arrow-height ($tooltip-arrow-width / 2) 0;\n      border-top-color: $tooltip-arrow-color;\n    }\n  }\n}\n\n.bs-tooltip-right {\n  padding: 0 $tooltip-arrow-height;\n\n  .arrow {\n    left: 0;\n    width: $tooltip-arrow-height;\n    height: $tooltip-arrow-width;\n\n    &::before {\n      right: 0;\n      border-width: ($tooltip-arrow-width / 2) $tooltip-arrow-height ($tooltip-arrow-width / 2) 0;\n      border-right-color: $tooltip-arrow-color;\n    }\n  }\n}\n\n.bs-tooltip-bottom {\n  padding: $tooltip-arrow-height 0;\n\n  .arrow {\n    top: 0;\n\n    &::before {\n      bottom: 0;\n      border-width: 0 ($tooltip-arrow-width / 2) $tooltip-arrow-height;\n      border-bottom-color: $tooltip-arrow-color;\n    }\n  }\n}\n\n.bs-tooltip-left {\n  padding: 0 $tooltip-arrow-height;\n\n  .arrow {\n    right: 0;\n    width: $tooltip-arrow-height;\n    height: $tooltip-arrow-width;\n\n    &::before {\n      left: 0;\n      border-width: ($tooltip-arrow-width / 2) 0 ($tooltip-arrow-width / 2) $tooltip-arrow-height;\n      border-left-color: $tooltip-arrow-color;\n    }\n  }\n}\n\n.bs-tooltip-auto {\n  &[x-placement^=\"top\"] {\n    @extend .bs-tooltip-top;\n  }\n  &[x-placement^=\"right\"] {\n    @extend .bs-tooltip-right;\n  }\n  &[x-placement^=\"bottom\"] {\n    @extend .bs-tooltip-bottom;\n  }\n  &[x-placement^=\"left\"] {\n    @extend .bs-tooltip-left;\n  }\n}\n\n// Wrapper for the tooltip content\n.tooltip-inner {\n  max-width: $tooltip-max-width;\n  padding: $tooltip-padding-y $tooltip-padding-x;\n  color: $tooltip-color;\n  text-align: center;\n  background-color: $tooltip-bg;\n  @include border-radius($tooltip-border-radius);\n}\n","@mixin reset-text() {\n  font-family: $font-family-base;\n  // We deliberately do NOT reset font-size or word-wrap.\n  font-style: normal;\n  font-weight: $font-weight-normal;\n  line-height: $line-height-base;\n  text-align: left; // Fallback for where `start` is not supported\n  text-align: start;\n  text-decoration: none;\n  text-shadow: none;\n  text-transform: none;\n  letter-spacing: normal;\n  word-break: normal;\n  word-spacing: normal;\n  white-space: normal;\n  line-break: auto;\n}\n",".popover {\n  position: absolute;\n  top: 0;\n  left: 0;\n  z-index: $zindex-popover;\n  display: block;\n  max-width: $popover-max-width;\n  // Our parent element can be arbitrary since tooltips are by default inserted as a sibling of their target element.\n  // So reset our font and text properties to avoid inheriting weird values.\n  @include reset-text();\n  @include font-size($popover-font-size);\n  // Allow breaking very long words so they don't overflow the popover's bounds\n  word-wrap: break-word;\n  background-color: $popover-bg;\n  background-clip: padding-box;\n  border: $popover-border-width solid $popover-border-color;\n  @include border-radius($popover-border-radius);\n  @include box-shadow($popover-box-shadow);\n\n  .arrow {\n    position: absolute;\n    display: block;\n    width: $popover-arrow-width;\n    height: $popover-arrow-height;\n    margin: 0 $popover-border-radius;\n\n    &::before,\n    &::after {\n      position: absolute;\n      display: block;\n      content: \"\";\n      border-color: transparent;\n      border-style: solid;\n    }\n  }\n}\n\n.bs-popover-top {\n  margin-bottom: $popover-arrow-height;\n\n  > .arrow {\n    bottom: subtract(-$popover-arrow-height, $popover-border-width);\n\n    &::before {\n      bottom: 0;\n      border-width: $popover-arrow-height ($popover-arrow-width / 2) 0;\n      border-top-color: $popover-arrow-outer-color;\n    }\n\n    &::after {\n      bottom: $popover-border-width;\n      border-width: $popover-arrow-height ($popover-arrow-width / 2) 0;\n      border-top-color: $popover-arrow-color;\n    }\n  }\n}\n\n.bs-popover-right {\n  margin-left: $popover-arrow-height;\n\n  > .arrow {\n    left: subtract(-$popover-arrow-height, $popover-border-width);\n    width: $popover-arrow-height;\n    height: $popover-arrow-width;\n    margin: $popover-border-radius 0; // make sure the arrow does not touch the popover's rounded corners\n\n    &::before {\n      left: 0;\n      border-width: ($popover-arrow-width / 2) $popover-arrow-height ($popover-arrow-width / 2) 0;\n      border-right-color: $popover-arrow-outer-color;\n    }\n\n    &::after {\n      left: $popover-border-width;\n      border-width: ($popover-arrow-width / 2) $popover-arrow-height ($popover-arrow-width / 2) 0;\n      border-right-color: $popover-arrow-color;\n    }\n  }\n}\n\n.bs-popover-bottom {\n  margin-top: $popover-arrow-height;\n\n  > .arrow {\n    top: subtract(-$popover-arrow-height, $popover-border-width);\n\n    &::before {\n      top: 0;\n      border-width: 0 ($popover-arrow-width / 2) $popover-arrow-height ($popover-arrow-width / 2);\n      border-bottom-color: $popover-arrow-outer-color;\n    }\n\n    &::after {\n      top: $popover-border-width;\n      border-width: 0 ($popover-arrow-width / 2) $popover-arrow-height ($popover-arrow-width / 2);\n      border-bottom-color: $popover-arrow-color;\n    }\n  }\n\n  // This will remove the popover-header's border just below the arrow\n  .popover-header::before {\n    position: absolute;\n    top: 0;\n    left: 50%;\n    display: block;\n    width: $popover-arrow-width;\n    margin-left: -$popover-arrow-width / 2;\n    content: \"\";\n    border-bottom: $popover-border-width solid $popover-header-bg;\n  }\n}\n\n.bs-popover-left {\n  margin-right: $popover-arrow-height;\n\n  > .arrow {\n    right: subtract(-$popover-arrow-height, $popover-border-width);\n    width: $popover-arrow-height;\n    height: $popover-arrow-width;\n    margin: $popover-border-radius 0; // make sure the arrow does not touch the popover's rounded corners\n\n    &::before {\n      right: 0;\n      border-width: ($popover-arrow-width / 2) 0 ($popover-arrow-width / 2) $popover-arrow-height;\n      border-left-color: $popover-arrow-outer-color;\n    }\n\n    &::after {\n      right: $popover-border-width;\n      border-width: ($popover-arrow-width / 2) 0 ($popover-arrow-width / 2) $popover-arrow-height;\n      border-left-color: $popover-arrow-color;\n    }\n  }\n}\n\n.bs-popover-auto {\n  &[x-placement^=\"top\"] {\n    @extend .bs-popover-top;\n  }\n  &[x-placement^=\"right\"] {\n    @extend .bs-popover-right;\n  }\n  &[x-placement^=\"bottom\"] {\n    @extend .bs-popover-bottom;\n  }\n  &[x-placement^=\"left\"] {\n    @extend .bs-popover-left;\n  }\n}\n\n\n// Offset the popover to account for the popover arrow\n.popover-header {\n  padding: $popover-header-padding-y $popover-header-padding-x;\n  margin-bottom: 0; // Reset the default from Reboot\n  @include font-size($font-size-base);\n  color: $popover-header-color;\n  background-color: $popover-header-bg;\n  border-bottom: $popover-border-width solid darken($popover-header-bg, 5%);\n  @include border-top-radius($popover-inner-border-radius);\n\n  &:empty {\n    display: none;\n  }\n}\n\n.popover-body {\n  padding: $popover-body-padding-y $popover-body-padding-x;\n  color: $popover-body-color;\n}\n","// Notes on the classes:\n//\n// 1. .carousel.pointer-event should ideally be pan-y (to allow for users to scroll vertically)\n//    even when their scroll action started on a carousel, but for compatibility (with Firefox)\n//    we're preventing all actions instead\n// 2. The .carousel-item-left and .carousel-item-right is used to indicate where\n//    the active slide is heading.\n// 3. .active.carousel-item is the current slide.\n// 4. .active.carousel-item-left and .active.carousel-item-right is the current\n//    slide in its in-transition state. Only one of these occurs at a time.\n// 5. .carousel-item-next.carousel-item-left and .carousel-item-prev.carousel-item-right\n//    is the upcoming slide in transition.\n\n.carousel {\n  position: relative;\n}\n\n.carousel.pointer-event {\n  touch-action: pan-y;\n}\n\n.carousel-inner {\n  position: relative;\n  width: 100%;\n  overflow: hidden;\n  @include clearfix();\n}\n\n.carousel-item {\n  position: relative;\n  display: none;\n  float: left;\n  width: 100%;\n  margin-right: -100%;\n  backface-visibility: hidden;\n  @include transition($carousel-transition);\n}\n\n.carousel-item.active,\n.carousel-item-next,\n.carousel-item-prev {\n  display: block;\n}\n\n.carousel-item-next:not(.carousel-item-left),\n.active.carousel-item-right {\n  transform: translateX(100%);\n}\n\n.carousel-item-prev:not(.carousel-item-right),\n.active.carousel-item-left {\n  transform: translateX(-100%);\n}\n\n\n//\n// Alternate transitions\n//\n\n.carousel-fade {\n  .carousel-item {\n    opacity: 0;\n    transition-property: opacity;\n    transform: none;\n  }\n\n  .carousel-item.active,\n  .carousel-item-next.carousel-item-left,\n  .carousel-item-prev.carousel-item-right {\n    z-index: 1;\n    opacity: 1;\n  }\n\n  .active.carousel-item-left,\n  .active.carousel-item-right {\n    z-index: 0;\n    opacity: 0;\n    @include transition(opacity 0s $carousel-transition-duration);\n  }\n}\n\n\n//\n// Left/right controls for nav\n//\n\n.carousel-control-prev,\n.carousel-control-next {\n  position: absolute;\n  top: 0;\n  bottom: 0;\n  z-index: 1;\n  // Use flex for alignment (1-3)\n  display: flex; // 1. allow flex styles\n  align-items: center; // 2. vertically center contents\n  justify-content: center; // 3. horizontally center contents\n  width: $carousel-control-width;\n  color: $carousel-control-color;\n  text-align: center;\n  opacity: $carousel-control-opacity;\n  @include transition($carousel-control-transition);\n\n  // Hover/focus state\n  @include hover-focus() {\n    color: $carousel-control-color;\n    text-decoration: none;\n    outline: 0;\n    opacity: $carousel-control-hover-opacity;\n  }\n}\n.carousel-control-prev {\n  left: 0;\n  @if $enable-gradients {\n    background-image: linear-gradient(90deg, rgba($black, .25), rgba($black, .001));\n  }\n}\n.carousel-control-next {\n  right: 0;\n  @if $enable-gradients {\n    background-image: linear-gradient(270deg, rgba($black, .25), rgba($black, .001));\n  }\n}\n\n// Icons for within\n.carousel-control-prev-icon,\n.carousel-control-next-icon {\n  display: inline-block;\n  width: $carousel-control-icon-width;\n  height: $carousel-control-icon-width;\n  background: 50% / 100% 100% no-repeat;\n}\n.carousel-control-prev-icon {\n  background-image: escape-svg($carousel-control-prev-icon-bg);\n}\n.carousel-control-next-icon {\n  background-image: escape-svg($carousel-control-next-icon-bg);\n}\n\n\n// Optional indicator pips\n//\n// Add an ordered list with the following class and add a list item for each\n// slide your carousel holds.\n\n.carousel-indicators {\n  position: absolute;\n  right: 0;\n  bottom: 0;\n  left: 0;\n  z-index: 15;\n  display: flex;\n  justify-content: center;\n  padding-left: 0; // override <ol> default\n  // Use the .carousel-control's width as margin so we don't overlay those\n  margin-right: $carousel-control-width;\n  margin-left: $carousel-control-width;\n  list-style: none;\n\n  li {\n    box-sizing: content-box;\n    flex: 0 1 auto;\n    width: $carousel-indicator-width;\n    height: $carousel-indicator-height;\n    margin-right: $carousel-indicator-spacer;\n    margin-left: $carousel-indicator-spacer;\n    text-indent: -999px;\n    cursor: pointer;\n    background-color: $carousel-indicator-active-bg;\n    background-clip: padding-box;\n    // Use transparent borders to increase the hit area by 10px on top and bottom.\n    border-top: $carousel-indicator-hit-area-height solid transparent;\n    border-bottom: $carousel-indicator-hit-area-height solid transparent;\n    opacity: .5;\n    @include transition($carousel-indicator-transition);\n  }\n\n  .active {\n    opacity: 1;\n  }\n}\n\n\n// Optional captions\n//\n//\n\n.carousel-caption {\n  position: absolute;\n  right: (100% - $carousel-caption-width) / 2;\n  bottom: 20px;\n  left: (100% - $carousel-caption-width) / 2;\n  z-index: 10;\n  padding-top: 20px;\n  padding-bottom: 20px;\n  color: $carousel-caption-color;\n  text-align: center;\n}\n","@mixin clearfix() {\n  &::after {\n    display: block;\n    clear: both;\n    content: \"\";\n  }\n}\n","// stylelint-disable declaration-no-important\n\n.align-baseline    { vertical-align: baseline !important; } // Browser default\n.align-top         { vertical-align: top !important; }\n.align-middle      { vertical-align: middle !important; }\n.align-bottom      { vertical-align: bottom !important; }\n.align-text-bottom { vertical-align: text-bottom !important; }\n.align-text-top    { vertical-align: text-top !important; }\n","// Contextual backgrounds\n@mixin bg-variant($parent, $color, $ignore-warning: true) {\n  #{$parent} {\n    background-color: $color !important;\n  }\n  a#{$parent},\n  button#{$parent} {\n    @include hover-focus {\n      background-color: darken($color, 10%) !important;\n    }\n  }\n}\n\n@mixin bg-gradient-variant($parent, $color) {\n  #{$parent} {\n    background: linear-gradient(\n      87deg,\n      $color 0,\n      adjust-hue($color, 0) 100%\n    ) !important;\n  }\n}\n\n@mixin bg-translucent-variant($parent, $color) {\n  #{$parent} {\n    background-color: darken(\n      rgba($color, $translucent-color-opacity),\n      7%\n    ) !important;\n  }\n  a#{$parent},\n  button#{$parent} {\n    @include hover-focus {\n      background-color: darken(\n        rgba($color, $translucent-color-opacity),\n        12%\n      ) !important;\n    }\n  }\n}\n\n@mixin bg-translucent-variant($parent, $color) {\n  #{$parent} {\n    fill: $color !important;\n  }\n}\n","// stylelint-disable declaration-no-important\n\n@each $color, $value in $theme-colors {\n  @include bg-variant(\".bg-#{$color}\", $value, true);\n}\n\n@if $enable-gradients {\n  @each $color, $value in $theme-colors {\n    @include bg-gradient-variant(\".bg-gradient-#{$color}\", $value, true);\n  }\n}\n\n.bg-white {\n  background-color: $white !important;\n}\n\n.bg-transparent {\n  background-color: transparent !important;\n}\n","// stylelint-disable property-disallowed-list, declaration-no-important\n\n//\n// Border\n//\n\n.border         { border: $border-width solid $border-color !important; }\n.border-top     { border-top: $border-width solid $border-color !important; }\n.border-right   { border-right: $border-width solid $border-color !important; }\n.border-bottom  { border-bottom: $border-width solid $border-color !important; }\n.border-left    { border-left: $border-width solid $border-color !important; }\n\n.border-0        { border: 0 !important; }\n.border-top-0    { border-top: 0 !important; }\n.border-right-0  { border-right: 0 !important; }\n.border-bottom-0 { border-bottom: 0 !important; }\n.border-left-0   { border-left: 0 !important; }\n\n@each $color, $value in $theme-colors {\n  .border-#{$color} {\n    border-color: $value !important;\n  }\n}\n\n.border-white {\n  border-color: $white !important;\n}\n\n//\n// Border-radius\n//\n\n.rounded-sm {\n  border-radius: $border-radius-sm !important;\n}\n\n.rounded {\n  border-radius: $border-radius !important;\n}\n\n.rounded-top {\n  border-top-left-radius: $border-radius !important;\n  border-top-right-radius: $border-radius !important;\n}\n\n.rounded-right {\n  border-top-right-radius: $border-radius !important;\n  border-bottom-right-radius: $border-radius !important;\n}\n\n.rounded-bottom {\n  border-bottom-right-radius: $border-radius !important;\n  border-bottom-left-radius: $border-radius !important;\n}\n\n.rounded-left {\n  border-top-left-radius: $border-radius !important;\n  border-bottom-left-radius: $border-radius !important;\n}\n\n.rounded-lg {\n  border-radius: $border-radius-lg !important;\n}\n\n.rounded-circle {\n  border-radius: 50% !important;\n}\n\n.rounded-pill {\n  border-radius: $rounded-pill !important;\n}\n\n.rounded-0 {\n  border-radius: 0 !important;\n}\n","// stylelint-disable declaration-no-important\n\n//\n// Utilities for common `display` values\n//\n\n@each $breakpoint in map-keys($grid-breakpoints) {\n  @include media-breakpoint-up($breakpoint) {\n    $infix: breakpoint-infix($breakpoint, $grid-breakpoints);\n\n    @each $value in $displays {\n      .d#{$infix}-#{$value} { display: $value !important; }\n    }\n  }\n}\n\n\n//\n// Utilities for toggling `display` in print\n//\n\n@media print {\n  @each $value in $displays {\n    .d-print-#{$value} { display: $value !important; }\n  }\n}\n","// Credit: Nicolas Gallagher and SUIT CSS.\n\n.embed-responsive {\n  position: relative;\n  display: block;\n  width: 100%;\n  padding: 0;\n  overflow: hidden;\n\n  &::before {\n    display: block;\n    content: \"\";\n  }\n\n  .embed-responsive-item,\n  iframe,\n  embed,\n  object,\n  video {\n    position: absolute;\n    top: 0;\n    bottom: 0;\n    left: 0;\n    width: 100%;\n    height: 100%;\n    border: 0;\n  }\n}\n\n@each $embed-responsive-aspect-ratio in $embed-responsive-aspect-ratios {\n  $embed-responsive-aspect-ratio-x: nth($embed-responsive-aspect-ratio, 1);\n  $embed-responsive-aspect-ratio-y: nth($embed-responsive-aspect-ratio, 2);\n\n  .embed-responsive-#{$embed-responsive-aspect-ratio-x}by#{$embed-responsive-aspect-ratio-y} {\n    &::before {\n      padding-top: percentage($embed-responsive-aspect-ratio-y / $embed-responsive-aspect-ratio-x);\n    }\n  }\n}\n","// stylelint-disable declaration-no-important\n\n// Flex variation\n//\n// Custom styles for additional flex alignment options.\n\n@each $breakpoint in map-keys($grid-breakpoints) {\n  @include media-breakpoint-up($breakpoint) {\n    $infix: breakpoint-infix($breakpoint, $grid-breakpoints);\n\n    .flex#{$infix}-row            { flex-direction: row !important; }\n    .flex#{$infix}-column         { flex-direction: column !important; }\n    .flex#{$infix}-row-reverse    { flex-direction: row-reverse !important; }\n    .flex#{$infix}-column-reverse { flex-direction: column-reverse !important; }\n\n    .flex#{$infix}-wrap         { flex-wrap: wrap !important; }\n    .flex#{$infix}-nowrap       { flex-wrap: nowrap !important; }\n    .flex#{$infix}-wrap-reverse { flex-wrap: wrap-reverse !important; }\n    .flex#{$infix}-fill         { flex: 1 1 auto !important; }\n    .flex#{$infix}-grow-0       { flex-grow: 0 !important; }\n    .flex#{$infix}-grow-1       { flex-grow: 1 !important; }\n    .flex#{$infix}-shrink-0     { flex-shrink: 0 !important; }\n    .flex#{$infix}-shrink-1     { flex-shrink: 1 !important; }\n\n    .justify-content#{$infix}-start   { justify-content: flex-start !important; }\n    .justify-content#{$infix}-end     { justify-content: flex-end !important; }\n    .justify-content#{$infix}-center  { justify-content: center !important; }\n    .justify-content#{$infix}-between { justify-content: space-between !important; }\n    .justify-content#{$infix}-around  { justify-content: space-around !important; }\n\n    .align-items#{$infix}-start    { align-items: flex-start !important; }\n    .align-items#{$infix}-end      { align-items: flex-end !important; }\n    .align-items#{$infix}-center   { align-items: center !important; }\n    .align-items#{$infix}-baseline { align-items: baseline !important; }\n    .align-items#{$infix}-stretch  { align-items: stretch !important; }\n\n    .align-content#{$infix}-start   { align-content: flex-start !important; }\n    .align-content#{$infix}-end     { align-content: flex-end !important; }\n    .align-content#{$infix}-center  { align-content: center !important; }\n    .align-content#{$infix}-between { align-content: space-between !important; }\n    .align-content#{$infix}-around  { align-content: space-around !important; }\n    .align-content#{$infix}-stretch { align-content: stretch !important; }\n\n    .align-self#{$infix}-auto     { align-self: auto !important; }\n    .align-self#{$infix}-start    { align-self: flex-start !important; }\n    .align-self#{$infix}-end      { align-self: flex-end !important; }\n    .align-self#{$infix}-center   { align-self: center !important; }\n    .align-self#{$infix}-baseline { align-self: baseline !important; }\n    .align-self#{$infix}-stretch  { align-self: stretch !important; }\n  }\n}\n","// stylelint-disable declaration-no-important\n\n@each $breakpoint in map-keys($grid-breakpoints) {\n  @include media-breakpoint-up($breakpoint) {\n    $infix: breakpoint-infix($breakpoint, $grid-breakpoints);\n\n    .float#{$infix}-left  { float: left !important; }\n    .float#{$infix}-right { float: right !important; }\n    .float#{$infix}-none  { float: none !important; }\n  }\n}\n","// stylelint-disable declaration-no-important\n\n@each $value in $user-selects {\n  .user-select-#{$value} { user-select: $value !important; }\n}\n","// stylelint-disable declaration-no-important\n\n@each $value in $overflows {\n  .overflow-#{$value} { overflow: $value !important; }\n}\n","// stylelint-disable declaration-no-important\n\n// Common values\n@each $position in $positions {\n  .position-#{$position} { position: $position !important; }\n}\n\n// Shorthand\n\n.fixed-top {\n  position: fixed;\n  top: 0;\n  right: 0;\n  left: 0;\n  z-index: $zindex-fixed;\n}\n\n.fixed-bottom {\n  position: fixed;\n  right: 0;\n  bottom: 0;\n  left: 0;\n  z-index: $zindex-fixed;\n}\n\n.sticky-top {\n  @supports (position: sticky) {\n    position: sticky;\n    top: 0;\n    z-index: $zindex-sticky;\n  }\n}\n","//\n// Screenreaders\n//\n\n.sr-only {\n  @include sr-only();\n}\n\n.sr-only-focusable {\n  @include sr-only-focusable();\n}\n","// Only display content to screen readers\n//\n// See: https://www.a11yproject.com/posts/2013-01-11-how-to-hide-content/\n// See: https://hugogiraudel.com/2016/10/13/css-hide-and-seek/\n\n@mixin sr-only() {\n  position: absolute;\n  width: 1px;\n  height: 1px;\n  padding: 0;\n  margin: -1px; // Fix for https://github.com/twbs/bootstrap/issues/25686\n  overflow: hidden;\n  clip: rect(0, 0, 0, 0);\n  white-space: nowrap;\n  border: 0;\n}\n\n// Use in conjunction with .sr-only to only display content when it's focused.\n//\n// Useful for \"Skip to main content\" links; see https://www.w3.org/TR/2013/NOTE-WCAG20-TECHS-20130905/G1\n//\n// Credit: HTML5 Boilerplate\n\n@mixin sr-only-focusable() {\n  &:active,\n  &:focus {\n    position: static;\n    width: auto;\n    height: auto;\n    overflow: visible;\n    clip: auto;\n    white-space: normal;\n  }\n}\n","// stylelint-disable declaration-no-important\n\n.shadow-sm { box-shadow: $box-shadow-sm !important; }\n.shadow { box-shadow: $box-shadow !important; }\n.shadow-lg { box-shadow: $box-shadow-lg !important; }\n.shadow-none { box-shadow: none !important; }\n","// stylelint-disable declaration-no-important\n\n// Width and height\n\n@each $prop, $abbrev in (width: w, height: h) {\n  @each $size, $length in $sizes {\n    .#{$abbrev}-#{$size} { #{$prop}: $length !important; }\n  }\n}\n\n.mw-100 { max-width: 100% !important; }\n.mh-100 { max-height: 100% !important; }\n\n// Viewport additional helpers\n\n.min-vw-100 { min-width: 100vw !important; }\n.min-vh-100 { min-height: 100vh !important; }\n\n.vw-100 { width: 100vw !important; }\n.vh-100 { height: 100vh !important; }\n","// stylelint-disable declaration-no-important\n\n// Margin and Padding\n\n@each $breakpoint in map-keys($grid-breakpoints) {\n  @include media-breakpoint-up($breakpoint) {\n    $infix: breakpoint-infix($breakpoint, $grid-breakpoints);\n\n    @each $prop, $abbrev in (margin: m, padding: p) {\n      @each $size, $length in $spacers {\n        .#{$abbrev}#{$infix}-#{$size} { #{$prop}: $length !important; }\n        .#{$abbrev}t#{$infix}-#{$size},\n        .#{$abbrev}y#{$infix}-#{$size} {\n          #{$prop}-top: $length !important;\n        }\n        .#{$abbrev}r#{$infix}-#{$size},\n        .#{$abbrev}x#{$infix}-#{$size} {\n          #{$prop}-right: $length !important;\n        }\n        .#{$abbrev}b#{$infix}-#{$size},\n        .#{$abbrev}y#{$infix}-#{$size} {\n          #{$prop}-bottom: $length !important;\n        }\n        .#{$abbrev}l#{$infix}-#{$size},\n        .#{$abbrev}x#{$infix}-#{$size} {\n          #{$prop}-left: $length !important;\n        }\n      }\n    }\n\n    // Negative margins (e.g., where `.mb-n1` is negative version of `.mb-1`)\n    @each $size, $length in $spacers {\n      @if $size != 0 {\n        .m#{$infix}-n#{$size} { margin: -$length !important; }\n        .mt#{$infix}-n#{$size},\n        .my#{$infix}-n#{$size} {\n          margin-top: -$length !important;\n        }\n        .mr#{$infix}-n#{$size},\n        .mx#{$infix}-n#{$size} {\n          margin-right: -$length !important;\n        }\n        .mb#{$infix}-n#{$size},\n        .my#{$infix}-n#{$size} {\n          margin-bottom: -$length !important;\n        }\n        .ml#{$infix}-n#{$size},\n        .mx#{$infix}-n#{$size} {\n          margin-left: -$length !important;\n        }\n      }\n    }\n\n    // Some special margin utils\n    .m#{$infix}-auto { margin: auto !important; }\n    .mt#{$infix}-auto,\n    .my#{$infix}-auto {\n      margin-top: auto !important;\n    }\n    .mr#{$infix}-auto,\n    .mx#{$infix}-auto {\n      margin-right: auto !important;\n    }\n    .mb#{$infix}-auto,\n    .my#{$infix}-auto {\n      margin-bottom: auto !important;\n    }\n    .ml#{$infix}-auto,\n    .mx#{$infix}-auto {\n      margin-left: auto !important;\n    }\n  }\n}\n","//\n// Stretched link\n//\n\n.stretched-link {\n  &::after {\n    position: absolute;\n    top: 0;\n    right: 0;\n    bottom: 0;\n    left: 0;\n    z-index: 1;\n    // Just in case `pointer-events: none` is set on a parent\n    pointer-events: auto;\n    content: \"\";\n    // IE10 bugfix, see https://stackoverflow.com/questions/16947967/ie10-hover-pseudo-class-doesnt-work-without-background-color\n    background-color: rgba(0, 0, 0, 0);\n  }\n}\n","// stylelint-disable declaration-no-important\n\n//\n// Text\n//\n\n.text-monospace { font-family: $font-family-monospace !important; }\n\n// Alignment\n\n.text-justify  { text-align: justify !important; }\n.text-wrap     { white-space: normal !important; }\n.text-nowrap   { white-space: nowrap !important; }\n.text-truncate { @include text-truncate(); }\n\n// Responsive alignment\n\n@each $breakpoint in map-keys($grid-breakpoints) {\n  @include media-breakpoint-up($breakpoint) {\n    $infix: breakpoint-infix($breakpoint, $grid-breakpoints);\n\n    .text#{$infix}-left   { text-align: left !important; }\n    .text#{$infix}-right  { text-align: right !important; }\n    .text#{$infix}-center { text-align: center !important; }\n  }\n}\n\n// Transformation\n\n.text-lowercase  { text-transform: lowercase !important; }\n.text-uppercase  { text-transform: uppercase !important; }\n.text-capitalize { text-transform: capitalize !important; }\n\n// Weight and italics\n\n.font-weight-light   { font-weight: $font-weight-light !important; }\n.font-weight-lighter { font-weight: $font-weight-lighter !important; }\n.font-weight-normal  { font-weight: $font-weight-normal !important; }\n.font-weight-bold    { font-weight: $font-weight-bold !important; }\n.font-weight-bolder  { font-weight: $font-weight-bolder !important; }\n.font-italic         { font-style: italic !important; }\n\n// Contextual colors\n\n.text-white { color: $white !important; }\n\n@each $color, $value in $theme-colors {\n  @include text-emphasis-variant(\".text-#{$color}\", $value, true);\n}\n\n.text-body { color: $body-color !important; }\n.text-muted { color: $text-muted !important; }\n\n.text-black-50 { color: rgba($black, .5) !important; }\n.text-white-50 { color: rgba($white, .5) !important; }\n\n// Misc\n\n.text-hide {\n  @include text-hide($ignore-warning: true);\n}\n\n.text-decoration-none { text-decoration: none !important; }\n\n.text-break {\n  word-break: break-word !important; // Deprecated, but avoids issues with flex containers\n  word-wrap: break-word !important; // Used instead of `overflow-wrap` for IE & Edge Legacy\n}\n\n// Reset\n\n.text-reset { color: inherit !important; }\n","// Text truncate\n// Requires inline-block or block for proper styling\n\n@mixin text-truncate() {\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n}\n","// stylelint-disable declaration-no-important\n\n// Typography\n\n@mixin text-emphasis-variant($parent, $color, $ignore-warning: false) {\n  #{$parent} {\n    color: $color !important;\n  }\n  @if $emphasized-link-hover-darken-percentage != 0 {\n    a#{$parent} {\n      @include hover-focus() {\n        color: darken($color, $emphasized-link-hover-darken-percentage) !important;\n      }\n    }\n  }\n  @include deprecate(\"`text-emphasis-variant()`\", \"v4.4.0\", \"v5\", $ignore-warning);\n}\n","// CSS image replacement\n@mixin text-hide($ignore-warning: false) {\n  // stylelint-disable-next-line font-family-no-missing-generic-family-keyword\n  font: 0/0 a;\n  color: transparent;\n  text-shadow: none;\n  background-color: transparent;\n  border: 0;\n\n  @include deprecate(\"`text-hide()`\", \"v4.1.0\", \"v5\", $ignore-warning);\n}\n","// stylelint-disable declaration-no-important\n\n//\n// Visibility utilities\n//\n\n.visible {\n  visibility: visible !important;\n}\n\n.invisible {\n  visibility: hidden !important;\n}\n","// stylelint-disable declaration-no-important, selector-no-qualifying-type\n\n// Source: https://github.com/h5bp/main.css/blob/master/src/_print.css\n\n// ==========================================================================\n// Print styles.\n// Inlined to avoid the additional HTTP request:\n// https://www.phpied.com/delay-loading-your-print-css/\n// ==========================================================================\n\n@if $enable-print-styles {\n  @media print {\n    *,\n    *::before,\n    *::after {\n      // Bootstrap specific; comment out `color` and `background`\n      //color: $black !important; // Black prints faster\n      text-shadow: none !important;\n      //background: transparent !important;\n      box-shadow: none !important;\n    }\n\n    a {\n      &:not(.btn) {\n        text-decoration: underline;\n      }\n    }\n\n    // Bootstrap specific; comment the following selector out\n    //a[href]::after {\n    //  content: \" (\" attr(href) \")\";\n    //}\n\n    abbr[title]::after {\n      content: \" (\" attr(title) \")\";\n    }\n\n    // Bootstrap specific; comment the following selector out\n    //\n    // Don't show links that are fragment identifiers,\n    // or use the `javascript:` pseudo protocol\n    //\n\n    //a[href^=\"#\"]::after,\n    //a[href^=\"javascript:\"]::after {\n    // content: \"\";\n    //}\n\n    pre {\n      white-space: pre-wrap !important;\n    }\n    pre,\n    blockquote {\n      border: $border-width solid $gray-500; // Bootstrap custom code; using `$border-width` instead of 1px\n      page-break-inside: avoid;\n    }\n\n    //\n    // Printing Tables:\n    // https://web.archive.org/web/20180815150934/http://css-discuss.incutio.com/wiki/Printing_Tables\n    //\n\n    thead {\n      display: table-header-group;\n    }\n\n    tr,\n    img {\n      page-break-inside: avoid;\n    }\n\n    p,\n    h2,\n    h3 {\n      orphans: 3;\n      widows: 3;\n    }\n\n    h2,\n    h3 {\n      page-break-after: avoid;\n    }\n\n    // Bootstrap specific changes start\n\n    // Specify a size and min-width to make printing closer across browsers.\n    // We don't set margin here because it breaks `size` in Chrome. We also\n    // don't use `!important` on `size` as it breaks in Chrome.\n    @page {\n      size: $print-page-size;\n    }\n    body {\n      min-width: $print-body-min-width !important;\n    }\n    .container {\n      min-width: $print-body-min-width !important;\n    }\n\n    // Bootstrap components\n    .navbar {\n      display: none;\n    }\n    .badge {\n      border: $border-width solid $black;\n    }\n\n    .table {\n      border-collapse: collapse !important;\n\n      td,\n      th {\n        background-color: $white !important;\n      }\n    }\n\n    .table-bordered {\n      th,\n      td {\n        border: 1px solid $gray-300 !important;\n      }\n    }\n\n    .table-dark {\n      color: inherit;\n\n      th,\n      td,\n      thead th,\n      tbody + tbody {\n        border-color: $table-border-color;\n      }\n    }\n\n    .table .thead-dark th {\n      color: inherit;\n      border-color: $table-border-color;\n    }\n\n    // Bootstrap specific changes end\n  }\n}\n","iframe {\n  border: 0;\n}\n\nfigcaption,\nfigure,\nmain {\n  display: block;\n}\n\nmain {\n  overflow: hidden;\n}\n","//\n// Backgrounds\n//\n\n@each $color, $value in $colors {\n  @include bg-variant(\".bg-#{$color}\", $value);\n}\n\n@each $color, $value in $theme-colors {\n  @include bg-gradient-variant(\".bg-gradient-#{$color}\", $value);\n}\n\n@each $color, $value in $colors {\n  @include bg-gradient-variant(\".bg-gradient-#{$color}\", $value);\n}\n\n// Background colors with transparency\n\n@each $color, $value in $theme-colors {\n  @include bg-translucent-variant(\".bg-translucent-#{$color}\", $value);\n}\n\n// Sections backgrounds\n\n@each $color, $value in $section-colors {\n  @include bg-variant(\".section-#{$color}\", $value);\n}\n\n@each $color, $value in $theme-colors {\n  @include bg-gradient-variant(\".bg-gradient-#{$color}\", $value);\n}\n\n// Shape (svg) fill colors\n\n@each $color, $value in $theme-colors {\n  .fill-#{$color} {\n    fill: $value;\n  }\n\n  .stroke-#{$color} {\n    stroke: $value;\n  }\n}\n\n.fill-opacity-8 {\n  fill-opacity: 0.8;\n}\n","//\n// Floating\n// floating animation utility class\n//\n\n.floating {\n  animation: floating 3s ease infinite;\n  will-change: transform;\n\n  &:hover {\n    animation-play-state: paused;\n  }\n}\n\n// Size variations\n\n.floating-lg {\n  animation: floating-lg 3s ease infinite;\n}\n\n.floating-sm {\n  animation: floating-sm 3s ease infinite;\n}\n\n// Keyframes\n\n@keyframes floating-lg {\n  0% {\n    transform: translateY(0px);\n  }\n  50% {\n    transform: translateY(15px);\n  }\n  100% {\n    transform: translateY(0px);\n  }\n}\n\n@keyframes floating {\n  0% {\n    transform: translateY(0px);\n  }\n  50% {\n    transform: translateY(10px);\n  }\n  100% {\n    transform: translateY(0px);\n  }\n}\n\n@keyframes floating-sm {\n  0% {\n    transform: translateY(0px);\n  }\n  50% {\n    transform: translateY(5px);\n  }\n  100% {\n    transform: translateY(0px);\n  }\n}\n","//\n// Helper\n// helper classes for different cases\n//\n\n// Clearfix for sections that use float property\n\n.floatfix {\n  &:before,\n  &:after {\n    content: \"\";\n    display: table;\n  }\n  &:after {\n    clear: both;\n  }\n}\n","//\n// Image\n//\n\n.img-center {\n  display: block;\n  margin-left: auto;\n  margin-right: auto;\n}\n","//\n// Opacity\n// modify the transparency of an element with this quick modifier classes\n//\n\n.opacity-1 {\n  opacity: 0.1 !important;\n}\n.opacity-2 {\n  opacity: 0.2 !important;\n}\n.opacity-3 {\n  opacity: 0.3 !important;\n}\n.opacity-4 {\n  opacity: 0.4 !important;\n}\n.opacity-5 {\n  opacity: 0.5 !important;\n}\n.opacity-6 {\n  opacity: 0.6 !important;\n}\n.opacity-7 {\n  opacity: 0.7 !important;\n}\n.opacity-8 {\n  opacity: 0.8 !important;\n}\n.opacity-8 {\n  opacity: 0.9 !important;\n}\n.opacity-10 {\n  opacity: 1 !important;\n}\n","//\n// Overflow\n//\n\n.overflow-visible {\n  overflow: visible !important;\n}\n\n.overflow-hidden {\n  overflow: hidden !important;\n}\n","//\n// Position\n// modifier classes to be applied on an abosolute positioned element\n// use it next to .position-absolute class\n//\n\n@each $size, $value in $spacers {\n  .top-#{$size} {\n    top: $value;\n  }\n  .right-#{$size} {\n    right: $value;\n  }\n  .bottom-#{$size} {\n    bottom: $value;\n  }\n  .left-#{$size} {\n    left: $value;\n  }\n}\n\n.center {\n  left: 50%;\n  transform: translateX(-50%);\n}\n","//\n// Height\n//\n\n.h-100vh {\n  height: 100vh !important;\n}\n","//\n// Spacing\n//\n\n.row.row-grid > [class*=\"col-\"] + [class*=\"col-\"] {\n  margin-top: 3rem;\n}\n\n@include media-breakpoint-up(lg) {\n  .row.row-grid > [class*=\"col-lg-\"] + [class*=\"col-lg-\"] {\n    margin-top: 0;\n  }\n}\n@include media-breakpoint-up(md) {\n  .row.row-grid > [class*=\"col-md-\"] + [class*=\"col-md-\"] {\n    margin-top: 0;\n  }\n}\n@include media-breakpoint-up(sm) {\n  .row.row-grid > [class*=\"col-sm-\"] + [class*=\"col-sm-\"] {\n    margin-top: 0;\n  }\n}\n\n.row-grid + .row-grid {\n  margin-top: 3rem;\n}\n\n// Negative margins and paddings\n\n@media (min-width: 992px) {\n  [class*=\"mt--\"],\n  [class*=\"mr--\"],\n  [class*=\"mb--\"],\n  [class*=\"ml--\"] {\n  }\n\n  // Large negative margins in pixels\n\n  .mt--100 {\n    margin-top: -100px !important;\n  }\n  .mr--100 {\n    margin-right: -100px !important;\n  }\n  .mb--100 {\n    margin-bottom: -100px !important;\n  }\n  .ml--100 {\n    margin-left: -100px !important;\n  }\n  .mt--150 {\n    margin-top: -150px !important;\n  }\n  .mb--150 {\n    margin-bottom: -150px !important;\n  }\n  .mt--200 {\n    margin-top: -200px !important;\n  }\n  .mb--200 {\n    margin-bottom: -200px !important;\n  }\n  .mt--300 {\n    margin-top: -300px !important;\n  }\n  .mb--300 {\n    margin-bottom: -300px !important;\n  }\n\n  // Large margins in pixels\n\n  .pt-100 {\n    padding-top: 100px !important;\n  }\n  .pb-100 {\n    padding-bottom: 100px !important;\n  }\n  .pt-150 {\n    padding-top: 150px !important;\n  }\n  .pb-150 {\n    padding-bottom: 150px !important;\n  }\n  .pt-200 {\n    padding-top: 200px !important;\n  }\n  .pb-200 {\n    padding-bottom: 200px !important;\n  }\n  .pt-250 {\n    padding-top: 250px !important;\n  }\n  .pb-250 {\n    padding-bottom: 250px !important;\n  }\n  .pt-300 {\n    padding-top: 300px !important;\n  }\n  .pb-300 {\n    padding-bottom: 300px !important;\n  }\n}\n","//\n// Shadows\n//\n\n// General styles\n[class*=\"shadow\"] {\n  @if $enable-transitions {\n    transition: $transition-base;\n  }\n}\n\n// Size variations\n.shadow-sm--hover:hover {\n  box-shadow: $box-shadow-sm !important;\n}\n\n.shadow--hover:hover {\n  box-shadow: $box-shadow !important;\n}\n\n.shadow-lg--hover:hover {\n  box-shadow: $box-shadow-lg !important;\n}\n\n.shadow-none--hover:hover {\n  box-shadow: none !important;\n}\n","// Weight and italics\n\n.font-weight-300 {\n  font-weight: 300 !important;\n}\n.font-weight-400 {\n  font-weight: 400 !important;\n}\n.font-weight-500 {\n  font-weight: 500 !important;\n}\n.font-weight-600 {\n  font-weight: 600 !important;\n}\n.font-weight-700 {\n  font-weight: 700 !important;\n}\n.font-weight-800 {\n  font-weight: 800 !important;\n}\n.font-weight-900 {\n  font-weight: 900 !important;\n}\n\n// Text decorations\n\n.text-underline {\n  text-decoration: underline;\n}\n.text-through {\n  text-decoration: line-through;\n}\n\n// Text size\n\n.text-xs {\n  font-size: $font-size-xs !important;\n}\n.text-sm {\n  font-size: $font-size-sm !important;\n}\n.text-lg {\n  font-size: $font-size-lg !important;\n}\n.text-xl {\n  font-size: $font-size-xl !important;\n}\n\n// Line heights\n\n.lh-100 {\n  line-height: 1;\n}\n.lh-110 {\n  line-height: 1.1;\n}\n.lh-120 {\n  line-height: 1.2;\n}\n.lh-130 {\n  line-height: 1.3;\n}\n.lh-140 {\n  line-height: 1.4;\n}\n.lh-150 {\n  line-height: 1.5;\n}\n.lh-160 {\n  line-height: 1.6;\n}\n.lh-170 {\n  line-height: 1.7;\n}\n.lh-180 {\n  line-height: 1.8;\n}\n\n// Letter spacings\n\n.ls-1 {\n  letter-spacing: 0.0625rem;\n}\n.ls-15 {\n  letter-spacing: 0.09375rem;\n}\n.ls-2 {\n  letter-spacing: 0.125rem;\n}\n\n// Color variations\n\n@each $color, $value in $colors {\n  @include text-emphasis-variant(\n    \".text-#{$color}\",\n    $value,\n    $ignore-warning: true\n  );\n}\n","//\n// Tranform\n//\n\n@include media-breakpoint-up(lg) {\n  .transform-perspective-right {\n    transform: scale(1) perspective(1040px) rotateY(-11deg) rotateX(2deg)\n      rotate(2deg);\n  }\n  .transform-perspective-left {\n    transform: scale(1) perspective(2000px) rotateY(11deg) rotateX(2deg)\n      rotate(-2deg);\n  }\n}\n","//\n// Alert\n//\n\n.alert {\n  font-size: $font-size-sm;\n}\n\n// Alert heading\n\n.alert-heading {\n  font-weight: $font-weight-bold;\n  font-size: $h4-font-size;\n  margin-top: 0.15rem;\n}\n\n// Alert icon\n.alert-icon {\n  font-size: 1.25rem;\n  margin-right: 1.25rem;\n  display: inline-block;\n  vertical-align: middle;\n\n  i.ni {\n    position: relative;\n    top: 1px;\n  }\n}\n\n// Alert text next to an alert icon\n.alert-text {\n  display: inline-block;\n  vertical-align: middle;\n}\n\n// Alert links\n\n[class*=\"alert-\"] {\n  .alert-link {\n    color: $white;\n    border-bottom: 1px dotted rgba($white, 0.5);\n  }\n}\n","//\n// Dismissible alert\n//\n\n.alert-dismissible {\n  .close {\n    top: 50%;\n    right: $alert-padding-x;\n    padding: 0;\n    transform: translateY(-50%);\n    color: rgba($white, 0.6);\n    opacity: 1;\n\n    &:hover,\n    &:focus {\n      color: rgba($white, 0.9);\n      opacity: 1 !important;\n    }\n\n    @include media-breakpoint-down(xs) {\n      top: 1rem;\n      right: 0.5rem;\n    }\n\n    & > span:not(.sr-only) {\n      font-size: 1.5rem;\n      background-color: transparent;\n      color: rgba($white, 0.6);\n    }\n\n    &:hover,\n    &:focus {\n      & > span:not(.sr-only) {\n        background-color: transparent;\n        color: rgba($white, 0.9);\n      }\n    }\n  }\n}\n","//\n// Avatar\n//\n\n// General styles\n\n// .avatar {\n// \tcolor: $white;\n// \tbackground-color: $gray-500;\n// \tdisplay: inline-flex;\n// \talign-items: center;\n// \tjustify-content: center;\n// \tfont-size: 1rem;\n// \tborder-radius: 50%;\n// \theight: 48px;\n// \twidth: 48px;\n\n//     img {\n//     \twidth: 100%;\n//     \tborder-radius: 50%;\n//     }\n\n//     + .avatar-content {\n//     \tdisplay: inline-block;\n//     \tmargin-left: .75rem;\n//     }\n// }\n\n// // Avatar size variations\n\n// .avatar-lg {\n// \twidth: 58px;\n// \theight: 58px;\n// \tfont-size: $font-size-sm;\n// }\n\n// .avatar-sm {\n// \twidth: 36px;\n// \theight: 36px;\n// \tfont-size: $font-size-sm;\n// }\n\n.avatar {\n  width: 34px;\n  height: 34px;\n  border-radius: 50%;\n  border: 2px solid $dark-green;\n  overflow: hidden;\n  img {\n    width: 100%;\n    height: 100%;\n  }\n}\n","//\n// Badge\n//\n\n// General styles\n\n.badge {\n  text-transform: $badge-text-transfom;\n\n  a {\n    color: $white;\n  }\n}\n\n// Size variations\n\n.badge-md {\n  padding: 0.65em 1em;\n}\n\n.badge-lg {\n  padding: 0.85em 1.375em;\n}\n\n// Multiple inline badges\n\n.badge-inline {\n  margin-right: 0.625rem;\n\n  + span {\n    top: 2px;\n    position: relative;\n\n    > a {\n      text-decoration: underline;\n    }\n  }\n}\n\n// Badge spacing inside a btn with some text\n\n.btn {\n  .badge {\n    &:not(:first-child) {\n      margin-left: 0.5rem;\n    }\n    &:not(:last-child) {\n      margin-right: 0.5rem;\n    }\n  }\n}\n","//\n// Circle badge\n//\n\n// General styles\n\n.badge-circle {\n  text-align: center;\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  border-radius: 50%;\n  width: 2rem;\n  height: 2rem;\n  font-size: 0.875rem;\n}\n","//\n// Dot badge\n//\n\n// General styles\n\n.badge-dot {\n  padding-left: 0;\n  padding-right: 0;\n  background: transparent;\n  font-weight: $font-weight-normal;\n  font-size: $font-size-sm;\n  text-transform: none;\n\n  strong {\n    color: $gray-800;\n  }\n\n  i {\n    display: inline-block;\n    vertical-align: middle;\n    width: 0.375rem;\n    height: 0.375rem;\n    border-radius: 50%;\n    margin-right: 0.375rem;\n  }\n\n  &.badge-md {\n    i {\n      width: 0.5rem;\n      height: 0.5rem;\n    }\n  }\n\n  &.badge-lg {\n    i {\n      width: 0.625rem;\n      height: 0.625rem;\n    }\n  }\n}\n","//\n// Icon buttons\n//\n\n// General styles\n\n.btn {\n  position: relative;\n  text-transform: $btn-text-transform;\n  transition: $transition-base;\n  letter-spacing: $btn-letter-spacing;\n  font-size: $input-btn-font-size;\n  will-change: transform;\n\n  &:hover {\n    @include box-shadow($btn-hover-box-shadow);\n    // transform: translateY($btn-hover-translate-y);\n  }\n\n  &:not(:last-child) {\n    margin-right: 0.5rem;\n  }\n\n  // Icons\n\n  i:not(:first-child),\n  svg:not(:first-child) {\n    margin-left: 0.5rem;\n  }\n\n  i:not(:last-child),\n  svg:not(:last-child) {\n    margin-right: 0.5rem;\n  }\n}\n\n// Remove translateY and margin animation when btn is included in a btn-group or input-group\n\n.btn-group,\n.input-group {\n  .btn {\n    margin-right: 0;\n    transform: translateY(0);\n  }\n}\n\n// Size variations\n\n.btn-sm {\n  font-size: $input-btn-font-size-sm;\n}\n\n.btn-lg {\n  font-size: $input-btn-font-size-lg;\n}\n\n// Some quick fixes (to revise)\n\n// Fixes\n[class*=\"btn-outline-\"] {\n  border-width: 1px;\n}\n\n.btn-outline-secondary {\n  color: darken(theme-color(\"secondary\"), 50%);\n}\n\n.btn-inner--icon {\n  i:not(.fa) {\n    position: relative;\n    top: 2px;\n  }\n}\n\n.btn-link {\n  font-weight: $btn-font-weight;\n  box-shadow: none;\n\n  &:hover {\n    box-shadow: none;\n    transform: none;\n  }\n}\n\n.btn-neutral {\n  color: theme-color(\"primary\");\n}\n","//\n// Icon buttons\n//\n\n.btn-icon {\n  .btn-inner--icon {\n    img {\n      width: 20px;\n    }\n  }\n\n  .btn-inner--text:not(:first-child) {\n    margin-left: 0.75em;\n  }\n\n  .btn-inner--text:not(:last-child) {\n    margin-right: 0.75em;\n  }\n}\n\n// Button only with icon and NO text\n\n.btn-icon-only {\n  width: 2.375rem;\n  height: 2.375rem;\n  padding: 0;\n}\n\na.btn-icon-only {\n  line-height: 2.5;\n}\n\n.btn-icon-only.btn-sm {\n  width: 2rem;\n  height: 2rem;\n}\n\n//\n// Clipboard button\n// dedicated element for copying icons\n//\n\n.btn-icon-clipboard {\n  margin: 0;\n  padding: 1.5rem;\n  font-size: $font-size-base;\n  font-weight: $font-weight-normal;\n  line-height: 1.25;\n  color: $gray-800;\n  background-color: $gray-100;\n  border-radius: $border-radius;\n  border: 0;\n  text-align: left;\n  font-family: inherit;\n  display: inline-block;\n  vertical-align: middle;\n  text-decoration: none;\n  -moz-appearance: none;\n  cursor: pointer;\n  width: 100%;\n  margin: 0.5rem 0;\n\n  &:hover {\n    background-color: $white;\n    box-shadow:\n      rgba(0, 0, 0, 0.1) 0 0 0 1px,\n      rgba(0, 0, 0, 0.1) 0 4px 16px;\n  }\n\n  > div {\n    align-items: center;\n    display: flex;\n  }\n\n  i {\n    box-sizing: content-box;\n    color: theme-color(\"primary\");\n    vertical-align: middle;\n    font-size: 1.5rem;\n  }\n\n  span {\n    display: inline-block;\n    font-size: 0.875rem;\n    line-height: 1.5;\n    margin-left: 16px;\n    overflow: hidden;\n    white-space: nowrap;\n    text-overflow: ellipsis;\n    vertical-align: middle;\n  }\n}\n","//\n// Brand buttons\n//\n\n// Color variations\n\n@each $color, $value in $brand-colors {\n  .btn-#{$color} {\n    @include button-variant($value, $value);\n  }\n}\n","//\n// Card\n//\n\n.card-translucent {\n  background-color: rgba(18, 91, 152, 0.08);\n}\n","//\n// Profile card\n//\n\n.card-profile-image {\n  position: relative;\n\n  img {\n    max-width: 180px;\n    border-radius: $border-radius;\n    @extend .shadow;\n    transform: translate(-50%, -30%);\n    position: absolute;\n    left: 50%;\n    transition: $transition-base;\n\n    &:hover {\n      transform: translate(-50%, -33%);\n    }\n  }\n}\n\n.card-profile-stats {\n  padding: 1rem 0;\n\n  > div {\n    text-align: center;\n    margin-right: 1rem;\n    padding: 0.875rem;\n\n    &:last-child {\n      margin-right: 0;\n    }\n\n    .heading {\n      font-size: 1.1rem;\n      font-weight: bold;\n      display: block;\n    }\n    .description {\n      font-size: 0.875rem;\n      color: $gray-500;\n    }\n  }\n}\n\n.card-profile-actions {\n  padding: 0.875rem;\n}\n","//\n// Card with hover animations\n//\n\n.card-lift--hover {\n  &:hover {\n    transform: translateY(-20px);\n    @include transition($transition-base);\n  }\n}\n","//\n// Card stats\n//\n\n.card-stats {\n  .card-body {\n    padding: 1rem 1.5rem;\n  }\n\n  .card-status-bullet {\n    position: absolute;\n    top: 0;\n    right: 0;\n    transform: translate(50%, -50%);\n  }\n}\n","//\n// Chart\n//\n\n.chart {\n  position: relative;\n  height: $chart-height;\n}\n\n// Size variations\n\n.chart-sm {\n  height: $chart-height-sm;\n}\n\n// Legend\n\n.chart-legend {\n  display: flex;\n  justify-content: center;\n  margin-top: $chart-legend-margin-top;\n  font-size: $chart-legend-font-size;\n  text-align: center;\n  color: $chart-legend-color;\n}\n\n.chart-legend-item {\n  display: inline-flex;\n  align-items: center;\n\n  + .chart-legend-item {\n    margin-left: 1rem;\n  }\n}\n\n.chart-legend-indicator {\n  display: inline-block;\n  width: 0.5rem;\n  height: 0.5rem;\n  margin-right: 0.375rem;\n  border-radius: 50%;\n}\n\n// Tooltip\n\n#chart-tooltip {\n  z-index: 0;\n\n  .arrow {\n    top: 100%;\n    left: 50%;\n    transform: translateX(-50%) translateX(-0.5rem);\n  }\n}\n\n// Chart info overlay\n\n.chart-info-overlay {\n  position: absolute;\n  top: 0;\n  left: 5%;\n  max-width: 350px;\n  padding: 20px;\n  z-index: 1;\n}\n","//\n// Close\n//\n\n.close {\n  @if $enable-transitions {\n    transition: $transition-base;\n  }\n\n  & > span:not(.sr-only) {\n    background-color: $close-bg;\n    color: $close-color;\n    line-height: 17px;\n    height: 1.25rem;\n    width: 1.25rem;\n    border-radius: 50%;\n    font-size: 1.25rem;\n    display: block;\n    @if $enable-transitions {\n      transition: $transition-base;\n    }\n  }\n\n  &:hover,\n  &:focus {\n    background-color: $close-hover-bg;\n    color: $close-hover-color;\n    outline: none;\n\n    span:not(.sr-only) {\n      background-color: $close-hover-bg;\n    }\n  }\n}\n.checkbox-design {\n  margin: 0 0 5px;\n}\n\n.styled-checkbox {\n  position: absolute;\n  opacity: 0;\n}\n\n.styled-checkbox + label {\n  position: relative;\n  cursor: pointer;\n  padding: 0;\n}\n\n.styled-checkbox + label:before {\n  content: \"\";\n  margin-right: 10px;\n  display: inline-block;\n  vertical-align: text-top;\n  width: 20px;\n  height: 20px;\n  background: white;\n  border: 1px solid gray;\n}\n\n.styled-checkbox:hover + label:before {\n  background: #f35429;\n}\n\n.styled-checkbox:checked + label:before {\n  background: #f35429;\n}\n\n.styled-checkbox:disabled + label {\n  color: #b8b8b8;\n  cursor: auto;\n}\n\n.styled-checkbox:disabled + label:before {\n  box-shadow: none;\n  background: #ddd;\n}\n\n.styled-checkbox:checked + label:after {\n  content: \"\";\n  position: absolute;\n  left: 5px;\n  top: 9px;\n  background: white;\n  width: 2px;\n  height: 2px;\n  box-shadow:\n    2px 0 0 white,\n    4px 0 0 white,\n    4px -2px 0 white,\n    4px -4px 0 white,\n    4px -6px 0 white,\n    4px -8px 0 white;\n  transform: rotate(45deg);\n}\n","@import \"../../abstracts/variables\";\n\n.main-content {\n  position: relative;\n  background-color: $bg-white;\n  margin-left: 258px;\n  .navbar-top {\n    position: absolute;\n    left: 0;\n    top: 0;\n    width: 100%;\n    z-index: 1;\n    background-color: $bg-white;\n    padding-left: 0 !important;\n    padding-right: 0 !important;\n    .page-title {\n      font-size: 25px;\n      font-weight: 600;\n      line-height: 37.5px;\n      color: $dark-black;\n    }\n    .navbar-nav {\n      .media {\n        p {\n          font-size: 13px;\n          font-weight: 400;\n          line-height: 24px;\n          color: $dark-black;\n        }\n      }\n    }\n  }\n\n  .dashboard-card-colored {\n    // max-width: 360px;\n    // border-radius: 4px;\n    width: calc(50% - 30px);\n    border-radius: 4px;\n    margin-right: 15px;\n    a {\n      display: block;\n      overflow: hidden;\n      width: 100%;\n      .card-body {\n        width: 100%;\n        .inner-body {\n          width: 100%;\n          margin-left: 0;\n          margin-right: 0;\n        }\n      }\n    }\n    &.green {\n      background-color: #008983;\n    }\n    &.blue {\n      background-color: #0f7db5;\n    }\n    .card-stats {\n      background-color: transparent;\n      width: 100%;\n      border: 0;\n    }\n    .card-title {\n      font-size: 14px;\n      font-weight: 400;\n      line-height: 21px;\n      color: $bg-white;\n    }\n    .large-font {\n      font-size: 50px;\n      font-weight: 700;\n      line-height: 75px;\n      color: $bg-white;\n    }\n    .icon {\n      svg {\n        fill: $bg-white;\n        width: 50px;\n        height: 50px;\n      }\n    }\n  }\n\n  .bordered-box {\n    box-shadow: 0px 2px 8px 0px rgba(156, 156, 156, 0.25);\n    border-radius: 5px;\n    padding-top: 20px;\n    padding-bottom: 20px;\n    // width: calc(100% - 390px);\n    margin-left: 15px;\n    width: calc(50% - 30px);\n    margin-left: 15px;\n    border: 1px solid rgba(156, 156, 156, 0.35);\n    .card-stats {\n      .card-body {\n        .card-title {\n          font-size: 16px;\n          font-weight: 400;\n          line-height: 24px;\n          color: $dark-black;\n        }\n        .large-font {\n          font-size: 28px;\n          font-weight: 700;\n          line-height: 42px;\n          color: $dark-green;\n        }\n      }\n    }\n  }\n\n  .box-50 {\n    width: 50%;\n  }\n  .card {\n    border: 0;\n  }\n  .dashboard-title {\n    font-size: 25px;\n    font-weight: 600;\n    line-height: 37.5px;\n    color: $dark-black;\n  }\n\n  // .container-fluid{\n  //     padding-left: 20px;\n  //     padding-right: 20px;\n  // }\n  // Container\n  .container-fluid {\n    @include media-breakpoint-up(md) {\n      padding-left: (\n        $main-content-padding-x + $grid-gutter-width / 10\n      ) !important;\n      padding-right: (\n        $main-content-padding-x + $grid-gutter-width / 10\n      ) !important;\n    }\n  }\n}\n\n// Offsets the main content depending on the sidebar positioning\n\n// .navbar-vertical.navbar-expand {\n\n//     @each $breakpoint,\n//     $dimension in $grid-breakpoints {\n\n//         &-#{$breakpoint} {\n\n//             @include media-breakpoint-up(#{$breakpoint}) {\n\n//                 // Left\n//                 &.fixed-left + .main-content {\n//                     margin-left: $navbar-vertical-width;\n//                 } // Right\n//                 &.fixed-right + .main-content {\n//                     margin-right: $navbar-vertical-width;\n//                 }\n//             }\n//         }\n//     }\n// }\n\nfooter {\n  // background: #ffd88c;\n}\n","// Theme color variables\n$color-blue-1-1: #f3f9ff;\n$dark-black: #393939;\n$bg-white: #fff;\n$grey-color: #717171;\n$orange-color: #cc9752;\n$green-color: #19b25f;\n$biege-color: #c6bdaf;\n$border-color: #b1b1b1;\n$dark-green: #42826c;\n$light-grey: #d9d9d9;\n$darken-grey: #333333;\n$border-color-dashed: #beb5a6;\n$green-shade: #36745e;\n$light-beige: #eed7b9;\n$color-red: #ff0000;\n$light-yellow: #f9f5ef;\n$shade-green: #008983;\n$shade-blue: #0f7db5;\n$grey-shade: #777777;\n$grey-shade-two: #dddddd;\n$grey-shade-three: #353535;\n$grey-shade-four: #797979;\n$light-grey-shade: #e6e6e6;\n$green-shade-two: #06b863;\n$green-shade-three: #6ab199;\n$green-shade-four: #dcf4ec;\n$red-shade-one: #d65d43;\n$red-shade-two: #f4e3dc;\n$green-shade-five: #656565;\n$grey-shade-five: #848484;\n$grey-shade-six: #454545;\n$grey-shade-seven: #d8d8d8;\n$grey-shade-eight: #5e5e5e;\n$green-shade-six: #7e8f8a;\n$green-shade-seven: #edf9f5;\n$grey-shade-light-color: #a7a7a7;\n$green-color-shade-light: #9cdac4;\n$orange-color-shade: #deb887;\n$orange-color-shade-two: #f4f3e5;\n$grey-shade-nine: #bababa;\n$grey-shade-ten: #dbdbdb;\n$dark-black-shade: #1d1d1d;\n$light-olive-color: #f2fcd3;\n$olive-color: #757536;\n$green-shade-eight: #bfbfbf;\n$grey-shade-light-color-two: #e3e3e3;\n$dark-black-dark-shade: #161616;\n$grey-shade-eleven-shade: #cfcfcf;\n$grey-shade-twelve-shade: #3f3f3f;\n$light-yellow-shade: #fffaf4;\n$light-yellow-shade-two: #dbdada;\n$light-grey-shade-lihgt: #cbcbcb;\n$light-grey-shade-light-bg: #eeeeee;\n$light-grey-shade-three: #a1a1a1;\n$brigh-green: #00a879;\n$grey-shade-thirteen-shade: #646464;\n","//\n// Custom checkbox\n//\n\n.custom-checkbox {\n  .custom-control-input ~ .custom-control-label {\n    cursor: pointer;\n    font-size: $font-size-sm;\n  }\n\n  .custom-control-input {\n    &:checked {\n      ~ .custom-control-label {\n        &::before {\n          border-color: $custom-control-indicator-checked-border-color;\n        }\n        &::after {\n          background-image: $custom-checkbox-indicator-icon-checked;\n        }\n      }\n    }\n\n    &:disabled {\n      ~ .custom-control-label {\n        &::before {\n          border-color: $custom-control-indicator-disabled-bg;\n        }\n      }\n\n      &:checked {\n        &::before {\n          border-color: $custom-control-indicator-checked-disabled-bg;\n        }\n      }\n    }\n  }\n}\n","//\n// Custom control\n// additional styles for custom checkboxes, radios and other\n//\n\n.custom-control-label {\n  // Background-color and (when enabled) gradient\n  &::before {\n    border: $custom-control-indicator-border-width solid\n      $custom-control-indicator-border-color;\n    @if $enable-transitions {\n      transition: $input-transition;\n    }\n  }\n\n  span {\n    position: relative;\n    top: 2px;\n  }\n}\n\n.custom-control-label {\n  margin-bottom: 0;\n}\n\n// Alternative style\n\n.custom-control-alternative {\n  .custom-control-label {\n    // Background-color and (when enabled) gradient\n    &::before {\n      border: 0;\n      box-shadow: $input-alternative-box-shadow;\n    }\n  }\n\n  .custom-control-input {\n    &:checked {\n      ~ .custom-control-label {\n        &::before {\n          box-shadow: $input-focus-alternative-box-shadow;\n        }\n      }\n    }\n\n    &:active ~ .custom-control-label::before,\n    &:focus ~ .custom-control-label::before {\n      box-shadow: $input-alternative-box-shadow;\n    }\n  }\n}\n","//\n// Custom checkbox\n//\n\n.custom-checkbox {\n  .custom-control-input ~ .custom-control-label {\n    cursor: pointer;\n    font-size: $font-size-sm;\n  }\n\n  .custom-control-input {\n    &:checked {\n      ~ .custom-control-label {\n        &::before {\n          border-color: $custom-control-indicator-checked-border-color;\n        }\n        &::after {\n          background-image: $custom-checkbox-indicator-icon-checked;\n        }\n      }\n    }\n\n    &:disabled {\n      ~ .custom-control-label {\n        &::before {\n          border-color: $custom-control-indicator-disabled-bg;\n        }\n      }\n\n      &:checked {\n        &::before {\n          border-color: $custom-control-indicator-checked-disabled-bg;\n        }\n      }\n    }\n  }\n}\n","//\n// Custom radio\n//\n\n.custom-radio {\n  .custom-control-input ~ .custom-control-label {\n    cursor: pointer;\n    font-size: $font-size-sm;\n  }\n\n  .custom-control-input {\n    &:checked {\n      ~ .custom-control-label {\n        &::before {\n          border-color: $custom-control-indicator-checked-border-color;\n        }\n        &::after {\n          background-image: $custom-radio-indicator-icon-checked;\n        }\n      }\n    }\n\n    &:disabled {\n      ~ .custom-control-label {\n        &::before {\n          border-color: $custom-control-indicator-disabled-bg;\n        }\n      }\n\n      &:checked {\n        &::before {\n          border-color: $custom-control-indicator-checked-disabled-bg;\n        }\n      }\n    }\n  }\n}\n","//\n// Custom toggle\n//\n\n.custom-toggle {\n  position: relative;\n  display: inline-block;\n  width: $custom-toggle-width;\n  height: 1.5rem;\n\n  input {\n    display: none;\n\n    &:checked {\n      + .custom-toggle-slider {\n        border: $custom-control-indicator-border-width solid\n          $custom-control-indicator-checked-border-color;\n\n        &:before {\n          background: $custom-toggle-checked-bg;\n          transform: translateX(1.625rem);\n        }\n      }\n    }\n\n    &:disabled {\n      + .custom-toggle-slider {\n        border: $custom-control-indicator-border-width solid\n          $custom-control-indicator-disabled-bg;\n      }\n\n      &:checked {\n        + .custom-toggle-slider {\n          border: $custom-control-indicator-border-width solid\n            $custom-control-indicator-disabled-bg;\n\n          &:before {\n            background-color: lighten(\n              $custom-control-indicator-checked-bg,\n              10%\n            );\n          }\n        }\n      }\n    }\n  }\n}\n\n.custom-toggle-slider {\n  position: absolute;\n  cursor: pointer;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  border: $custom-control-indicator-border-width solid $input-border-color;\n  border-radius: 34px !important;\n  background-color: transparent;\n\n  &:before {\n    position: absolute;\n    content: \"\";\n    height: 18px;\n    width: 18px;\n    left: 2px;\n    bottom: 2px;\n    border-radius: 50% !important;\n    background-color: $custom-toggle-slider-bg;\n    transition: $input-transition;\n  }\n}\n","//\n// Dropdown\n//\n\n// General styles\n\n.dropdown,\n.dropup,\n.dropright,\n.dropleft {\n  display: inline-block;\n}\n\n.dropdown-menu {\n  min-width: 12rem;\n\n  .dropdown-item {\n    padding: 0.5rem 1rem;\n    font-size: $font-size-sm;\n    > i,\n    > svg {\n      margin-right: 1rem;\n      font-size: 1rem;\n      vertical-align: -17%;\n    }\n  }\n}\n\n.dropdown-header {\n  padding-left: 1rem;\n  padding-right: 1rem;\n  color: $gray-100;\n  font-size: 0.625rem;\n  text-transform: uppercase;\n  font-weight: 700;\n}\n\n// Media components inside dropdown link\n\n.dropdown-menu {\n  a.media {\n    > div {\n      &:first-child {\n        line-height: 1;\n      }\n    }\n\n    p {\n      color: $gray-600;\n    }\n\n    &:hover {\n      .heading,\n      p {\n        color: theme-color(\"default\") !important;\n      }\n    }\n  }\n}\n\n// Size variations\n\n.dropdown-menu-sm {\n  min-width: 100px;\n  border: $border-radius-lg;\n}\n\n.dropdown-menu-lg {\n  min-width: 260px;\n  border-radius: $border-radius-lg;\n}\n\n.dropdown-menu-xl {\n  min-width: 450px;\n  border-radius: $border-radius-lg;\n}\n","//\n// Footer\n//\n\n// General styles\n\n.footer {\n  // background: $footer-bg;\n  padding: $footer-padding-y $footer-padding-x;\n\n  .col-footer {\n    .heading {\n      color: $footer-heading-color;\n      letter-spacing: 0;\n      font-size: $footer-heading-font-size;\n      text-transform: uppercase;\n      font-weight: $font-weight-bold;\n      margin-bottom: 1rem;\n    }\n  }\n\n  .nav .nav-item .nav-link,\n  .footer-link {\n    color: $footer-link-color !important;\n\n    &:hover {\n      color: $footer-link-hover-color !important;\n    }\n  }\n\n  .list-unstyled li a {\n    display: inline-block;\n    padding: 0.125rem 0;\n    color: $footer-link-color;\n    font-size: $footer-link-font-size;\n\n    &:hover {\n      color: $footer-link-hover-color;\n    }\n  }\n\n  .copyright {\n    font-size: $font-size-sm;\n  }\n}\n\n// Dark footer\n\n.footer-dark {\n  .col-footer .heading {\n    color: $white;\n  }\n}\n\n// Footer nav used for copyright and some links, but not limited to this\n\n.nav-footer {\n  .nav-link {\n    font-size: $font-size-sm;\n  }\n\n  .nav-item:last-child {\n    .nav-link {\n      padding-right: 0;\n    }\n  }\n}\n\n// Footer with cards over\n\n.footer.has-cards {\n  overflow: hidden;\n  padding-top: 500px;\n  margin-top: -420px;\n  position: relative;\n  background: transparent;\n  pointer-events: none;\n\n  &:before {\n    content: \"\";\n    position: absolute;\n    left: 0;\n    right: 0;\n    top: 600px;\n    height: 2000px;\n    background: theme-color(\"secondary\");\n    transform: skew(0, -8deg);\n  }\n\n  .container {\n    pointer-events: auto;\n    position: relative;\n  }\n}\n","//\n// Forms\n//\n\n// Labels\n\n.form-control-label {\n  color: $gray-700;\n  font-size: $font-size-sm;\n  font-weight: $font-weight-bold;\n}\n\n// Text inputs\n\n.form-control {\n  font-size: $input-btn-font-size;\n\n  &:focus {\n    &::placeholder {\n      color: $input-focus-placeholder-color;\n    }\n  }\n}\n\n// Textarea\n\ntextarea[resize=\"none\"] {\n  resize: none !important;\n}\n\ntextarea[resize=\"both\"] {\n  resize: both !important;\n}\n\ntextarea[resize=\"vertical\"] {\n  resize: vertical !important;\n}\n\ntextarea[resize=\"horizontal\"] {\n  resize: horizontal !important;\n}\n\n// Form input variations\n\n// Muted input\n\n.form-control-muted {\n  background-color: $input-muted-bg;\n  border-color: $input-muted-bg;\n  box-shadow: none;\n\n  &:focus {\n    background-color: $input-focus-muted-bg;\n  }\n}\n\n// Alternative input\n\n.form-control-alternative {\n  box-shadow: $input-alternative-box-shadow;\n  border: 0;\n  transition: box-shadow 0.15s ease;\n\n  &:focus {\n    box-shadow: $input-focus-alternative-box-shadow;\n  }\n}\n\n// Size variations: Fixes to the bootstrap defaults\n\n.form-control-lg {\n  font-size: $font-size-base;\n}\n","//\n// Form validation\n//\n\n// Validation\n\n.has-success,\n.has-danger {\n  position: relative;\n\n  &:after {\n    width: 19px;\n    height: 19px;\n    line-height: 19px;\n    text-align: center;\n    font-family: \"NucleoIcons\";\n    display: inline-block;\n    position: absolute;\n    right: 15px;\n    top: 2px;\n    transform: translateY(50%);\n    border-radius: 50%;\n    font-size: 9px;\n    opacity: 1;\n  }\n}\n\n.has-success {\n  &:after {\n    content: \"\\ea26\";\n    color: daken($form-feedback-valid-color, 18%);\n    background-color: $form-feedback-valid-bg;\n  }\n\n  .form-control {\n    background-color: $input-focus-bg;\n\n    &:focus {\n      border-color: $input-focus-border-color;\n    }\n\n    // Placeholder\n\n    &::placeholder {\n      color: $form-feedback-valid-color;\n    }\n  }\n}\n\n.has-danger {\n  &:after {\n    content: \"\\ea53\";\n    color: daken($form-feedback-invalid-color, 18%);\n    background-color: $form-feedback-invalid-bg;\n  }\n\n  .form-control {\n    background-color: $input-focus-bg;\n\n    &:focus {\n      border-color: $input-focus-border-color;\n    }\n\n    // Placeholder\n\n    &::placeholder {\n      color: $form-feedback-invalid-color;\n    }\n  }\n}\n","//\n// Input group\n//\n\n.input-group {\n  box-shadow: $input-box-shadow;\n  border-radius: $input-border-radius;\n  transition: $transition-base;\n\n  .form-control {\n    box-shadow: none;\n\n    &:not(:first-child) {\n      border-left: 0;\n      padding-left: 0;\n    }\n    &:not(:last-child) {\n      border-right: 0;\n      padding-right: 0;\n    }\n    &:focus {\n      box-shadow: none;\n    }\n  }\n}\n\n.input-group-text {\n  transition: $input-transition;\n}\n\n// Alternative input groups related to .form-control-alternative\n\n.input-group-alternative {\n  box-shadow: $input-alternative-box-shadow;\n  border: 0;\n  transition: box-shadow 0.15s ease;\n\n  .form-control,\n  .input-group-text {\n    border: 0;\n    box-shadow: none;\n  }\n}\n\n.focused {\n  .input-group-alternative {\n    box-shadow: $input-focus-alternative-box-shadow !important;\n  }\n}\n\n// .focus class is applied dinamycally from theme.js\n\n.focused {\n  .input-group {\n    box-shadow: $input-focus-box-shadow;\n  }\n\n  .input-group-text {\n    color: $input-group-addon-focus-color;\n    background-color: $input-group-addon-focus-bg;\n    border-color: $input-group-addon-focus-border-color;\n  }\n\n  .form-control {\n    border-color: $input-group-addon-focus-border-color;\n  }\n}\n","//\n// Header\n//\n\n.header {\n  position: relative;\n}\n","//\n// Icon\n//\n\n.icon {\n  width: $icon-size;\n  height: $icon-size;\n\n  i,\n  svg {\n    font-size: $icon-size - 0.75;\n  }\n\n  + .icon-text {\n    padding-left: 1rem;\n    width: calc(100% - #{$icon-size} - 1);\n  }\n}\n\n// Extra large icons\n\n.icon-xl {\n  width: $icon-size-xl;\n  height: $icon-size-xl;\n\n  i,\n  svg {\n    font-size: $icon-size-xl - 0.75;\n  }\n\n  + .icon-text {\n    width: calc(100% - #{$icon-size-xl} - 1);\n  }\n}\n\n// Large icons\n\n.icon-lg {\n  width: $icon-size-lg;\n  height: $icon-size-lg;\n\n  i,\n  svg {\n    font-size: $icon-size-lg - 0.75;\n  }\n\n  + .icon-text {\n    width: calc(100% - #{$icon-size-lg} - 1);\n  }\n}\n\n// Small icon\n\n.icon-sm {\n  width: $icon-size-sm;\n  height: $icon-size-sm;\n\n  i,\n  svg {\n    font-size: $icon-size-sm - 0.75;\n  }\n\n  + .icon-text {\n    width: calc(100% - #{$icon-size-sm} - 1);\n  }\n}\n","//\n// Icon shape\n//\n\n.icon-shape {\n  padding: 12px;\n  text-align: center;\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  border-radius: 50%;\n\n  i,\n  svg {\n    font-size: 1.25rem;\n  }\n\n  &.icon-lg {\n    i,\n    svg {\n      font-size: 1.625rem;\n    }\n  }\n\n  &.icon-sm {\n    i,\n    svg {\n      font-size: 0.875rem;\n    }\n  }\n\n  svg {\n    width: 30px;\n    height: 30px;\n  }\n}\n\n@each $color, $value in $theme-colors {\n  .icon-shape-#{$color} {\n    @include icon-shape-variant(theme-color($color));\n  }\n}\n","@mixin icon-shape-variant($color) {\n  color: saturate(darken($color, 10%), 10);\n  background-color: transparentize(lighten($color, 10%), 0.5);\n}\n","//\n// List group\n//\n\n// Space list items\n\n.list-group-space {\n  .list-group-item {\n    margin-bottom: 1.5rem;\n    @include border-radius($list-group-border-radius);\n  }\n}\n\n// Extended list group components\n\n.list-group-img {\n  width: 3rem;\n  height: 3rem;\n  border-radius: 50%;\n  vertical-align: top;\n  margin: -0.1rem 1.2rem 0 -0.2rem;\n}\n\n.list-group-content {\n  flex: 1;\n  min-width: 0;\n\n  > p {\n    color: $gray-500;\n    line-height: 1.5;\n    margin: 0.2rem 0 0;\n  }\n}\n\n.list-group-heading {\n  font-size: $font-size-base;\n  color: $gray-800;\n\n  > small {\n    float: right;\n    color: $gray-500;\n    font-weight: 500;\n  }\n}\n","//\n// Map\n//\n\n.map-canvas {\n  position: relative;\n  width: 100%;\n  height: $map-height;\n  border-radius: $border-radius;\n}\n","//\n// Mask\n//\n\n.mask {\n  position: absolute;\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: 100%;\n  @include transition($transition-base);\n}\n","//\n// Modal\n//\n\n// Fluid modal\n\n.modal-fluid {\n  .modal-dialog {\n    margin-top: 0;\n    margin-bottom: 0;\n  }\n  .modal-content {\n    border-radius: 0;\n  }\n}\n\n// Background color variations\n\n@each $color, $value in $theme-colors {\n  .modal-#{$color} {\n    @include modal-variant($value);\n  }\n}\n","@mixin modal-variant($background) {\n  .modal-title {\n    color: color-yiq($background);\n  }\n  .modal-header,\n  .modal-footer {\n    border-color: rgba(color-yiq($background), 0.075);\n  }\n  .modal-content {\n    background-color: $background;\n    color: color-yiq($background);\n\n    .heading {\n      color: color-yiq($background);\n    }\n  }\n\n  .close {\n    & > span:not(.sr-only) {\n      color: $white;\n    }\n  }\n}\n","//\n// Nav\n//\n\n// Nav wrapper (container)\n\n// Nav wrapper\n.nav-wrapper {\n  padding: 1rem 0;\n  @include border-top-radius($card-border-radius);\n\n  + .card {\n    @include border-top-radius(0);\n    @include border-bottom-radius($card-border-radius);\n  }\n}\n\n// Nav links\n\n.nav-link {\n  color: $nav-link-color;\n\n  &:hover {\n    color: $nav-link-hover-color;\n  }\n\n  i.ni {\n    position: relative;\n    top: 2px;\n  }\n}\n\n@media (min-width: 992px) {\n  .nav-item.active-pro {\n    position: absolute;\n    width: 100%;\n    bottom: 10px;\n    background: $table-head-bg;\n  }\n}\n","//\n// Nav pills\n//\n\n// General styles\n\n.nav-pills {\n  .nav-item:not(:last-child) {\n    padding-right: $nav-pills-space-x;\n  }\n\n  .nav-link {\n    padding: $nav-pills-padding-y $nav-pills-padding-x;\n    color: $nav-pills-link-color;\n    font-weight: 500;\n    font-size: $font-size-sm;\n    box-shadow: $nav-pills-box-shadow;\n    background-color: $nav-pills-bg;\n    transition: $transition-base;\n\n    &:hover {\n      color: $nav-pills-link-hover-color;\n    }\n  }\n\n  .nav-link.active,\n  .show > .nav-link {\n    color: $nav-pills-link-active-color;\n    background-color: $nav-pills-link-active-bg;\n  }\n\n  @include media-breakpoint-down(xs) {\n    .nav-item {\n      margin-bottom: $spacer;\n    }\n  }\n}\n\n@include media-breakpoint-down(sm) {\n  .nav-pills:not(.nav-pills-circle) {\n    .nav-item {\n      padding-right: 0;\n    }\n  }\n}\n\n// Rounded circle nav pills\n\n.nav-pills-circle {\n  .nav-link {\n    text-align: center;\n    height: 60px;\n    width: 60px;\n    padding: 0;\n    line-height: 60px;\n    border-radius: 50%;\n  }\n\n  .nav-link-icon {\n    i,\n    svg {\n      font-size: 1rem;\n    }\n  }\n}\n","//\n// Navbar\n//\n\n// Navbar links\n\n.navbar-horizontal {\n  .navbar-nav {\n    .nav-link {\n      font-size: $navbar-nav-link-font-size;\n      font-weight: $navbar-nav-link-font-weight;\n      text-transform: $navbar-nav-link-text-transform;\n      letter-spacing: $navbar-nav-link-letter-spacing;\n      @include transition($navbar-transition);\n\n      .nav-link-inner--text {\n        margin-left: 0.25rem;\n      }\n    }\n  }\n\n  // Navbar brand (logo)\n\n  .navbar-brand {\n    font-size: $font-size-sm;\n    font-weight: 600;\n    text-transform: uppercase;\n    font-size: 0.875rem;\n    letter-spacing: 0.05px;\n\n    img {\n      height: 30px;\n    }\n  }\n\n  .navbar-dark {\n    .navbar-brand {\n      color: $white;\n    }\n  }\n\n  .navbar-light {\n    .navbar-brand {\n      color: $gray-800;\n    }\n  }\n\n  .navbar-nav {\n    .nav-item {\n      .media:not(:last-child) {\n        margin-bottom: 1.5rem;\n      }\n    }\n  }\n\n  @include media-breakpoint-up(lg) {\n    .navbar-nav {\n      .nav-item {\n        margin-right: 0.5rem;\n\n        [data-toggle=\"dropdown\"]::after {\n          transition: $transition-base;\n        }\n\n        &.show {\n          [data-toggle=\"dropdown\"]::after {\n            transform: rotate(180deg);\n          }\n        }\n      }\n      .nav-link {\n        padding-top: $navbar-nav-link-padding-y;\n        padding-bottom: $navbar-nav-link-padding-y;\n        border-radius: $navbar-nav-link-border-radius;\n\n        i {\n          margin-right: 0.625rem;\n        }\n      }\n\n      .nav-link-icon {\n        padding-left: 0.5rem !important;\n        padding-right: 0.5rem !important;\n        font-size: 1rem;\n        border-radius: $navbar-nav-link-border-radius;\n\n        i {\n          margin-right: 0;\n        }\n      }\n    }\n  }\n\n  // Transparent navbar\n\n  .navbar-transparent {\n    position: absolute;\n    top: 0;\n    width: 100%;\n    z-index: 100;\n    background-color: transparent;\n    border: 0;\n    box-shadow: none;\n\n    .navbar-brand {\n      color: rgba(255, 255, 255, 1);\n    }\n\n    .navbar-toggler {\n      color: rgba(255, 255, 255, 1);\n    }\n\n    .navbar-toggler-icon {\n      background-image: $navbar-dark-toggler-icon-bg;\n    }\n  }\n\n  @include media-breakpoint-up(md) {\n    .navbar-transparent {\n      .navbar-nav {\n        .nav-link {\n          color: $navbar-dark-color;\n\n          @include hover-focus {\n            color: $navbar-dark-hover-color;\n          }\n\n          &.disabled {\n            color: $navbar-dark-disabled-color;\n          }\n        }\n\n        .show > .nav-link,\n        .active > .nav-link,\n        .nav-link.show,\n        .nav-link.active {\n          color: $navbar-dark-active-color;\n        }\n      }\n\n      .navbar-brand {\n        color: $navbar-dark-color;\n\n        @include hover-focus {\n          color: $navbar-dark-color;\n        }\n      }\n    }\n  }\n}\n","@include media-breakpoint-up(md) {\n  .navbar-vertical {\n    background-color: #42826c;\n    width: 258px;\n    position: fixed;\n    height: 100vh;\n    padding: 0;\n    padding-top: 8px;\n    overflow-y: hidden;\n\n    .navbar-brand {\n      margin-right: 0;\n      width: 123px;\n      display: flex;\n      justify-content: center;\n      align-items: flex-start;\n\n      // margin-top: 50px;\n      img {\n        min-height: unset;\n        max-width: 123px;\n        width: 100%;\n        height: auto;\n      }\n    }\n\n    .container-fluid {\n      display: flex;\n      flex-direction: column;\n      justify-content: center;\n      width: 100%;\n      height: 100%;\n    }\n\n    .navbar-collapse {\n      flex-direction: column;\n      align-items: start;\n      width: 100%;\n      overflow: scroll;\n      padding-bottom: 15px;\n      .navbar-nav {\n        padding-bottom: 30px;\n        width: 100%;\n        padding: 14px 8px;\n        font-size: 15px;\n        font-weight: 400;\n        line-height: 24px;\n        color: $bg-white;\n        background-color: transparent;\n\n        i {\n          color: $bg-white;\n        }\n\n        &.bg-green-color {\n          background-color: #36745e;\n\n          i {\n            color: #eed7b9;\n          }\n        }\n      }\n    }\n  }\n}\n\n// //\n// // Vertical navbar\n// //\n\n// // Vertical\n// //\n// // Creates a vertically aligned version of the navbar\n// .navbar-vertical {\n//     box-shadow: $navbar-vertical-box-shadow;\n\n//     .navbar {\n//         border-width: 0 0 1px 0;\n//         border-style: solid;\n//     }\n\n//     // Navbar light\n\n//     .navbar-light {\n//         background-color: $navbar-light-bg;\n//         border-color: $navbar-light-border-color;\n//     }\n\n//     // Navbar brand\n\n//     .navbar-brand {\n//         margin-right: 0;\n//     }\n\n//     .navbar-brand-img,\n//     .navbar-brand > img {\n//         max-width: 100%;\n//         max-height: 2rem;\n//     }\n\n//     // Navbar collapse\n\n//     @include media-breakpoint-up(md) {\n//         .navbar-collapse {\n//             margin-left: -$navbar-padding-x;\n//             margin-right: -$navbar-padding-x;\n//             padding-left: $navbar-padding-x;\n//             padding-right: $navbar-padding-x;\n\n//             &:before {\n//                 content: '';\n//                 display: block;\n//                 // margin: $navbar-padding-y (-$navbar-padding-x);\n//             }\n//         }\n//     }\n\n//     // Navbar navigaton\n\n//     .navbar-nav {\n//         margin-left: -$navbar-padding-x;\n//         margin-right: -$navbar-padding-x;\n\n//         // Navbar link\n\n//         .nav-link {\n//             padding-left: $navbar-padding-x;\n//             padding-right: $navbar-padding-x;\n//             font-size: $navbar-nav-link-font-size;\n\n//             &.active {\n//                 position: relative;\n\n//                 &:before {\n//                     content: '';\n//                     position: absolute;\n//                     left: 0;\n//                     top: $nav-link-padding-y;\n//                     bottom: $nav-link-padding-y;\n//                     border-left: 2px solid $primary;\n//                 }\n//             }\n\n//             // Icon\n\n//             > i {\n//                 min-width: $navbar-icon-min-width;\n//                 font-size: .9375rem;\n//                 line-height: ($font-size-base * $line-height-base);\n//             }\n\n//             // Dropdown\n\n//             .dropdown-menu {\n//                 border: none;\n\n//                 .dropdown-menu {\n//                     margin-left: $dropdown-item-padding-x / 2;\n//                 }\n//             }\n//         }\n//     }\n\n//     // Navbar navigation\n//     .navbar-nav .nav-link {\n//         display: flex;\n//         align-items: center;\n//     }\n\n//     .navbar-nav .nav-link[data-toggle=\"collapse\"] {\n//         &:after {\n//             display: inline-block;\n//             font-style: normal;\n//             font-variant: normal;\n//             text-rendering: auto;\n//             -webkit-font-smoothing: antialiased;\n//             font-family: 'Font Awesome 5 Free';\n//             font-weight: 700;\n//             content: \"\\f105\";\n//             margin-left: auto;\n//             color: $text-muted;\n//             transition: $transition-base;\n//         } // Expanded\n//         &[aria-expanded=\"true\"] {\n\n//             &:after {\n//                 transform: rotate(90deg);\n//             }\n//         }\n//     }\n\n//     // Second level\n//     .navbar-nav .nav .nav-link {\n//         padding-left: $navbar-padding-x + $navbar-icon-min-width;\n//     }\n\n//     // Third level\n//     .navbar-nav .nav .nav .nav-link {\n//         padding-left: $navbar-padding-x * 1.5 + $navbar-icon-min-width;\n//     }\n\n//     // Navbar heading\n//     .navbar-heading {\n//         padding-top: $nav-link-padding-y;\n//         padding-bottom: $nav-link-padding-y;\n//         font-size: $font-size-xs;\n//         text-transform: uppercase;\n//         letter-spacing: .04em;\n//     }\n\n//     // Expanded navbar specific styles\n//     &.navbar-expand {\n//         @each $breakpoint,\n//         $dimension in $grid-breakpoints {\n\n//             &-#{$breakpoint} {\n//                 @include media-breakpoint-up(#{$breakpoint}) {\n//                     display: block;\n//                     position: fixed;\n//                     top: 0;\n//                     bottom: 0;\n//                     width: 100%;\n//                     max-width: $navbar-vertical-width;\n//                     padding-left: $navbar-vertical-padding-x;\n//                     padding-right: $navbar-vertical-padding-x;\n\n//                     overflow-y: auto;\n\n//                     // Container\n//                     >[class*=\"container\"] {\n//                         flex-direction: column;\n//                         align-items: stretch;\n//                         min-height: 100%;\n//                         padding-left: 0;\n//                         padding-right: 0; // Target IE 10 & 11\n//                         @media all and (-ms-high-contrast: none), (-ms-high-contrast: active) {\n//                             min-height: none;\n//                             height: 100%;\n//                         }\n//                     }\n\n//                     // Fixes the vertical navbar to the left\n//                     &.fixed-left {\n//                         left: 0;\n//                         border-width: 0 1px 0 0;\n//                     }\n\n//                     // Fixed the vertical navbar to the right\n//                     &.fixed-right {\n//                         right: 0;\n//                         border-width: 0 0 0 1px;\n//                     }\n\n//                     // Navbar collapse\n//                     .navbar-collapse {\n//                         flex: 1;\n//                         display: flex;\n//                         flex-direction: column;\n//                         align-items: stretch;\n//                         margin-left: -$navbar-vertical-padding-x;\n//                         margin-right: -$navbar-vertical-padding-x;\n//                         padding-left: $navbar-vertical-padding-x;\n//                         padding-right: $navbar-vertical-padding-x;\n\n//                         > * {\n//                             min-width: 100%;\n//                         }\n//                     }\n\n//                     // Navbar navigation\n//                     .navbar-nav {\n//                         flex-direction: row;\n//                         margin-left: -$navbar-vertical-padding-x;\n//                         margin-right: -$navbar-vertical-padding-x;\n//                         padding: 0.5rem;\n\n//                         .fas{\n//                             margin-right: 0.5rem;\n//                         }\n//                     }\n\n//                     .navbar-nav .nav-link {\n//                         padding: $navbar-vertical-nav-link-padding-y $navbar-vertical-nav-link-padding-x;\n\n//                         &.active {\n//                             &:before {\n//                                 top: $nav-link-padding-y;\n//                                 bottom: $nav-link-padding-y;\n//                                 left: 0;\n//                                 right: auto;\n//                                 border-left: 2px solid $primary;\n//                                 border-bottom: 0;\n//                             }\n//                         }\n//                     }\n\n//                     // Second level\n//                     .navbar-nav .nav .nav-link {\n//                         padding-left: $navbar-vertical-padding-x + $navbar-icon-min-width;\n//                     }\n\n//                     // Third level\n//                     .navbar-nav .nav .nav .nav-link {\n//                         padding-left: $navbar-vertical-padding-x * 1.5 + $navbar-icon-min-width;\n//                     }\n\n//                     // Navbar brand\n//                     .navbar-brand {\n//                         display: block;\n//                         text-align: center;\n//                         padding-top: (2rem - $navbar-padding-y);\n//                         padding-bottom: (2rem - $navbar-padding-y);\n//                     }\n\n//                     .navbar-brand-img {\n//                         max-height: 2.5rem;\n//                     }\n\n//                     // Navbar user\n//                     .navbar-user {\n//                         margin-left: -$navbar-vertical-padding-x;\n//                         margin-right: -$navbar-vertical-padding-x;\n//                         padding-top: $spacer;\n//                         padding-bottom: $spacer - $navbar-padding-y;\n//                         padding-left: $navbar-vertical-padding-x;\n//                         padding-right: $navbar-vertical-padding-x;\n//                         border-top: 1px solid $border-color;\n\n//                         // Dropup menu\n//                         .dropup .dropdown-menu {\n//                             left: 50%;\n//                             transform: translateX(-50%);\n//                         }\n//                     }\n//                 }\n//             }\n//         }\n//     }\n// }","//\n// Navbar search\n//\n\n.navbar-search {\n  .input-group {\n    border-radius: $navbar-search-border-radius;\n    border: $navbar-search-border-width solid;\n    background-color: transparent;\n\n    .input-group-text {\n      background-color: transparent;\n      padding-left: 1rem;\n    }\n  }\n\n  .form-control {\n    width: $navbar-search-width;\n    background-color: transparent;\n  }\n}\n\n.navbar-search-dark {\n  .input-group {\n    border-color: $navbar-search-dark-border-color;\n  }\n\n  .input-group-text {\n    color: $navbar-search-dark-color;\n  }\n\n  .form-control {\n    color: $navbar-search-dark-focus-color;\n\n    &::placeholder {\n      color: $navbar-search-dark-color;\n    }\n  }\n\n  .focused {\n    .input-group {\n      border-color: $navbar-search-dark-focus-border-color;\n    }\n  }\n}\n\n.navbar-search-light {\n  .input-group {\n    border-color: $navbar-search-light-border-color;\n  }\n\n  .input-group-text {\n    color: $navbar-search-light-color;\n  }\n\n  .form-control {\n    color: $navbar-search-light-focus-color;\n\n    &::placeholder {\n      color: $navbar-search-light-color;\n    }\n  }\n\n  .focused {\n    .input-group {\n      border-color: $navbar-search-light-focus-border-color;\n    }\n  }\n}\n","// Dropdown menu\n\n@include media-breakpoint-up(md) {\n  .navbar {\n    .dropdown-menu {\n      opacity: 0;\n      pointer-events: none;\n      margin: 0;\n    }\n\n    .dropdown-menu-arrow {\n      &:before {\n        background: $dropdown-bg;\n        box-shadow: none;\n        content: \"\";\n        display: block;\n        height: 12px;\n        width: 12px;\n        right: 20px;\n        position: absolute;\n        bottom: 100%;\n        transform: rotate(-45deg) translateY(12px);\n        z-index: -5;\n        border-radius: 2px;\n      }\n    }\n\n    .dropdown-menu-right {\n      &:before {\n        right: 20px;\n        left: auto;\n      }\n    }\n\n    &:not(.navbar-nav-hover) {\n      .dropdown-menu {\n        &.show {\n          opacity: 1;\n          pointer-events: auto;\n          animation: show-navbar-dropdown 0.25s ease forwards;\n        }\n\n        &.close {\n          display: block;\n          animation: hide-navbar-dropdown 0.15s ease backwards;\n        }\n      }\n    }\n\n    &.navbar-nav-hover {\n      .dropdown-menu {\n        opacity: 0;\n        display: block;\n        pointer-events: none;\n        transform: translate(0, 10px) perspective(200px) rotateX(-2deg);\n        transition:\n          visibility 0.25s,\n          opacity 0.25s,\n          transform 0.25s;\n      }\n\n      .nav-item.dropdown:hover > .dropdown-menu {\n        display: block;\n        opacity: 1;\n        pointer-events: auto;\n        visibility: visible;\n        transform: translate(0, 0);\n        animation: none;\n      }\n    }\n\n    .dropdown-menu-inner {\n      position: relative;\n      padding: 1rem;\n    }\n\n    // Keyframes\n\n    @keyframes show-navbar-dropdown {\n      0% {\n        opacity: 0;\n        transform: translate(0, 10px) perspective(200px) rotateX(-2deg);\n        transition:\n          visibility 0.25s,\n          opacity 0.25s,\n          transform 0.25s;\n      }\n\n      100% {\n        transform: translate(0, 0);\n        opacity: 1;\n      }\n    }\n\n    @keyframes hide-navbar-dropdown {\n      from {\n        opacity: 1;\n      }\n\n      to {\n        opacity: 0;\n        transform: translate(0, 10px);\n      }\n    }\n  }\n}\n","//\n// Navabar collapse\n//\n\n// Collapse\n\n.navbar-collapse-header {\n  display: none;\n}\n\n@include media-breakpoint-down(sm) {\n  .navbar-nav {\n    .nav-link {\n      padding: 0.625rem 0;\n      color: theme-color(\"default\") !important;\n    }\n\n    .dropdown-menu {\n      box-shadow: none;\n      min-width: auto;\n\n      .media {\n        svg {\n          width: 30px;\n        }\n      }\n    }\n  }\n\n  .navbar-collapse {\n    width: calc(100% - 1.4rem);\n    position: absolute;\n    top: 0;\n    left: 0;\n    right: 0;\n    z-index: 1050;\n    margin: 0.7rem;\n    overflow-y: auto;\n    height: auto !important;\n    opacity: 0;\n\n    .navbar-toggler {\n      width: 20px;\n      height: 20px;\n      position: relative;\n      cursor: pointer;\n      display: inline-block;\n      padding: 0;\n\n      span {\n        display: block;\n        position: absolute;\n        width: 100%;\n        height: 2px;\n        border-radius: 2px;\n        opacity: 1;\n        background: #283448;\n      }\n\n      :nth-child(1) {\n        transform: rotate(135deg);\n      }\n\n      :nth-child(2) {\n        transform: rotate(-135deg);\n      }\n    }\n\n    .navbar-collapse-header {\n      display: block;\n      padding-bottom: 1rem;\n      margin-bottom: 1rem;\n      border-bottom: 1px solid rgba(0, 0, 0, 0.1);\n    }\n\n    .collapse-brand {\n      img {\n        height: 36px;\n      }\n    }\n\n    .collapse-close {\n      text-align: right;\n    }\n  }\n\n  .navbar-collapse.collapsing,\n  .navbar-collapse.show {\n    padding: 1.5rem;\n    border-radius: $border-radius;\n    background: #fff;\n    box-shadow:\n      0 50px 100px rgba(50, 50, 93, 0.1),\n      0 15px 35px rgba(50, 50, 93, 0.15),\n      0 5px 15px rgba(0, 0, 0, 0.1);\n    animation: show-navbar-collapse 0.2s ease forwards;\n  }\n\n  .navbar-collapse.collapsing-out {\n    animation: hide-navbar-collapse 0.2s ease forwards;\n  }\n}\n\n@keyframes show-navbar-collapse {\n  0% {\n    opacity: 0;\n    transform: scale(0.95);\n    transform-origin: 100% 0;\n  }\n\n  100% {\n    opacity: 1;\n    transform: scale(1);\n  }\n}\n\n@keyframes hide-navbar-collapse {\n  from {\n    opacity: 1;\n    transform: scale(1);\n    transform-origin: 100% 0;\n  }\n\n  to {\n    opacity: 0;\n    transform: scale(0.95);\n  }\n}\n","//\n// Pagination\n//\n\n.page-item {\n  &.active .page-link {\n    box-shadow: $pagination-active-box-shadow;\n  }\n\n  .page-link,\n  span {\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    padding: 0;\n    margin: 0 3px;\n    border-radius: 50% !important;\n    width: 36px;\n    height: 36px;\n    font-size: $font-size-sm;\n  }\n}\n\n// Size variations\n\n.pagination-lg {\n  .page-item {\n    .page-link,\n    span {\n      width: 46px;\n      height: 46px;\n      line-height: 46px;\n    }\n  }\n}\n\n.pagination-sm {\n  .page-item {\n    .page-link,\n    span {\n      width: 30px;\n      height: 30px;\n      line-height: 30px;\n    }\n  }\n}\n","//\n// Popover\n//\n\n.popover {\n  border: 0;\n}\n\n.popover-header {\n  font-weight: $font-weight-bold;\n}\n\n// Alternative colors\n\n@each $color, $value in $theme-colors {\n  .popover-#{$color} {\n    @include popover-variant($value);\n  }\n}\n","@mixin popover-variant($background) {\n  background-color: $background;\n\n  .popover-header {\n    background-color: $background;\n    color: color-yiq($background);\n  }\n\n  .popover-body {\n    color: color-yiq($background);\n  }\n  .popover-header {\n    border-color: rgba(color-yiq($background), 0.2);\n  }\n  &.bs-popover-top {\n    .arrow::after {\n      border-top-color: $background;\n    }\n  }\n  &.bs-popover-right {\n    .arrow::after {\n      border-right-color: $background;\n    }\n  }\n  &.bs-popover-bottom {\n    .arrow::after {\n      border-bottom-color: $background;\n    }\n  }\n  &.bs-popover-left {\n    .arrow::after {\n      border-left-color: $background;\n    }\n  }\n}\n","//\n// Progress\n//\n\n// Progress container\n\n.progress-wrapper {\n  position: relative;\n  padding-top: 1.5rem;\n}\n\n// General styles\n\n.progress {\n  height: 8px;\n  margin-bottom: $spacer;\n  overflow: hidden;\n  border-radius: $border-radius-sm;\n  background-color: $progress-bg;\n  box-shadow: inset 0 1px 2px rgba(0, 0, 0, 0.1);\n\n  .sr-only {\n    width: auto;\n    height: 20px;\n    margin: 0 0 0 30px;\n    left: 0;\n    clip: auto;\n    line-height: 20px;\n    font-size: 13px;\n  }\n}\n\n// Progress inner elements\n\n.progress-heading {\n  font-size: 14px;\n  font-weight: 500;\n  margin: 0 0 2px;\n  padding: 0;\n}\n\n.progress-bar {\n  box-shadow: none;\n  border-radius: 0;\n  height: auto;\n}\n\n.progress-info {\n  margin-bottom: 0.5rem;\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n}\n\n.progress-label {\n  span {\n    display: inline-block;\n    color: $primary;\n    font-size: 0.625rem;\n    font-weight: 600;\n    text-transform: uppercase;\n    background: rgba($primary, 0.1);\n    padding: 0.25rem 1rem;\n    border-radius: 30px;\n  }\n}\n\n.progress-percentage {\n  text-align: right;\n  span {\n    display: inline-block;\n    color: $gray-600;\n    font-size: 0.875rem;\n    font-weight: 600;\n  }\n}\n","//\n// Separator\n// add svg on top or bottom of a section for a more stylish visual\n//\n\n.separator {\n  position: absolute;\n  top: auto;\n  left: 0;\n  right: 0;\n  width: 100%;\n  height: 150px;\n  transform: translateZ(0);\n  overflow: hidden;\n  pointer-events: none;\n\n  svg {\n    position: absolute;\n    pointer-events: none;\n  }\n}\n\n.separator-top {\n  top: 0;\n  bottom: auto;\n\n  svg {\n    top: 0;\n  }\n}\n\n.separator-bottom {\n  top: auto;\n  bottom: 0;\n\n  svg {\n    bottom: 0;\n  }\n}\n\n.separator-inverse {\n  transform: rotate(180deg);\n}\n\n// Styles\n\n.separator-skew {\n  height: 60px;\n\n  @include media-breakpoint-up(xl) {\n    height: 70px;\n  }\n}\n","//\n// Table\n//\n\n// General styles\n\n.table {\n  thead th {\n    cursor: pointer;\n    padding-top: $table-head-spacer-y;\n    padding-bottom: $table-head-spacer-y;\n    font-size: $table-head-font-size;\n    text-transform: $table-head-text-transform;\n    letter-spacing: $table-head-letter-spacing;\n    border-bottom: $table-border-width solid $table-border-color;\n  }\n\n  th {\n    font-weight: $table-head-font-weight;\n  }\n\n  td {\n    .progress {\n      height: 3px;\n      width: 120px;\n      margin: 0;\n    }\n  }\n\n  td,\n  th {\n    font-size: $table-body-font-size;\n    white-space: nowrap;\n  }\n\n  // Vetical align table content\n\n  &.align-items-center {\n    td,\n    th {\n      vertical-align: middle;\n    }\n  }\n\n  // Styles for dark table\n\n  .thead-dark {\n    th {\n      background-color: $table-dark-head-bg;\n      color: $table-dark-head-color;\n    }\n  }\n\n  // Styles for light table\n\n  .thead-light {\n    th {\n      background-color: $table-head-bg;\n      color: $table-head-color;\n    }\n  }\n}\n\n// Add transition for hover state\n\n.table-hover {\n  tr {\n    @include transition($transition-base);\n  }\n}\n\n// Flush tables\n\n.table-flush {\n  td,\n  th {\n    border-left: 0;\n    border-right: 0;\n  }\n\n  tbody {\n    tr {\n      &:first-child {\n        td,\n        th {\n          border-top: 0;\n        }\n      }\n\n      &:last-child {\n        td,\n        th {\n          border-bottom: 0;\n        }\n      }\n    }\n  }\n}\n\n// Tables inside cards\n\n.card {\n  .table {\n    margin-bottom: 0;\n    cursor: pointer;\n    td,\n    th {\n      padding-left: $card-spacer-x;\n      padding-right: $card-spacer-x;\n    }\n  }\n}\n","//\n// Type\n//\n\n// Paragraphs\n\np {\n  font-size: $paragraph-font-size;\n  font-weight: $paragraph-font-weight;\n  line-height: $paragraph-line-height;\n}\n\n.lead {\n  font-size: $lead-font-size;\n  font-weight: $lead-font-weight;\n  line-height: $paragraph-line-height;\n  margin-top: 1.5rem;\n\n  + .btn-wrapper {\n    margin-top: 3rem;\n  }\n}\n\n.description {\n  font-size: $font-size-sm;\n}\n","//\n// Heading\n//\n\n// General styles\n\n.heading {\n  letter-spacing: $heading-letter-spacing;\n  font-size: $heading-font-size;\n  text-transform: $heading-text-transform;\n  font-weight: $heading-font-weight;\n}\n\n// Heading variations\n\n.heading-small {\n  padding-top: 0.25rem;\n  padding-bottom: 0.25rem;\n  font-size: 0.75rem;\n  text-transform: uppercase;\n  letter-spacing: 0.04em;\n}\n\n.heading-title {\n  letter-spacing: $heading-title-letter-spacing;\n  font-size: $heading-title-font-size;\n  font-weight: $heading-title-font-weight;\n  text-transform: $heading-title-text-transform;\n}\n\n.heading-section {\n  letter-spacing: $heading-section-letter-spacing;\n  font-size: $heading-section-font-size;\n  font-weight: $heading-section-font-weight;\n  text-transform: $heading-section-text-transform;\n\n  img {\n    display: block;\n    width: 72px;\n    height: 72px;\n    margin-bottom: 1.5rem;\n  }\n\n  &.text-center {\n    img {\n      margin-left: auto;\n      margin-right: auto;\n    }\n  }\n}\n","//\n// Display\n//\n\n.display-1,\n.display-2,\n.display-3,\n.display-4 {\n  span {\n    display: block;\n    font-weight: $font-weight-light;\n  }\n}\n","//\n// Article\n//\n\narticle {\n  h4:not(:first-child),\n  h5:not(:first-child) {\n    margin-top: 3rem;\n  }\n\n  h4,\n  h5 {\n    margin-bottom: 1.5rem;\n  }\n\n  figure {\n    margin: 3rem 0;\n  }\n\n  h5 + figure {\n    margin-top: 0;\n  }\n}\n","//\n// Bootstrap datepicker\n//\n\n.datepicker {\n  border-radius: $datepicker-border-radius;\n\n  &-inline {\n    width: 220px;\n  }\n\n  direction: ltr;\n\n  &-rtl {\n    direction: rtl;\n    &.dropdown-menu {\n      left: auto;\n    }\n    table tr td span {\n      float: right;\n    }\n  }\n\n  &-dropdown {\n    top: 0;\n    left: 0;\n    padding: $datepicker-dropdown-padding;\n    @include box-shadow($dropdown-box-shadow);\n\n    &.datepicker-orient-left:before {\n      left: 6px;\n    }\n    &.datepicker-orient-left:after {\n      left: 7px;\n    }\n    &.datepicker-orient-right:before {\n      right: 6px;\n    }\n    &.datepicker-orient-right:after {\n      right: 7px;\n    }\n    &.datepicker-orient-bottom:before {\n      top: -7px;\n    }\n    &.datepicker-orient-bottom:after {\n      top: -6px;\n    }\n\n    &.datepicker-orient-top:before {\n      bottom: -7px;\n      border-bottom: 0;\n      border-top: 7px solid $datepicker-dropdown-border;\n    }\n\n    &.datepicker-orient-top:after {\n      bottom: -6px;\n      border-bottom: 0;\n      border-top: 6px solid $datepicker-dropdown-bg;\n    }\n  }\n\n  table {\n    margin: 0;\n    -webkit-touch-callout: none;\n    user-select: none;\n\n    tr {\n      td {\n        border-radius: $datepicker-cell-border-radius;\n      }\n\n      th {\n        border-radius: $datepicker-header-cell-border-radius;\n        font-weight: 500;\n      }\n\n      td,\n      th {\n        transition: $datepicker-cell-transition;\n        width: $datepicker-cell-width;\n        height: $datepicker-cell-height;\n        border: none;\n        text-align: center;\n        font-size: $font-size-sm;\n      }\n    }\n  }\n\n  // Inline display inside a table presents some problems with\n  // border and background colors.\n  .table-striped & table tr {\n    td,\n    th {\n      background-color: transparent;\n    }\n  }\n\n  table tr td {\n    &.old,\n    &.new {\n      color: $datepicker-disabled-old-new-color;\n    }\n\n    &.day:hover,\n    &.focused {\n      background: $datepicker-cell-hover-background;\n      cursor: pointer;\n    }\n\n    &.disabled,\n    &.disabled:hover {\n      background: none;\n      color: $datepicker-disabled-cell-color;\n      cursor: default;\n    }\n\n    &.highlighted {\n      border-radius: 0;\n\n      &.focused {\n        background: $datepicker-highlighted-bg;\n      }\n\n      &.disabled,\n      &.disabled:active {\n        background: $datepicker-highlighted-bg;\n        color: $gray-400;\n      }\n    }\n\n    &.today {\n      background: lighten($datepicker-active-background, 45%);\n      &.focused {\n        background: lighten($gray-400, 58%);\n      }\n\n      &.disabled,\n      &.disabled:active {\n        background: lighten($gray-400, 58%);\n        color: $btn-link-disabled-color;\n      }\n    }\n\n    // Range selection\n    &.range {\n      background: $datepicker-range-background;\n      color: $datepicker-range-color;\n      border-radius: 0;\n\n      &.focused {\n        background: darken($datepicker-range-cell-focused-background, 3%);\n      }\n\n      &.disabled,\n      &.disabled:active,\n      &.day.disabled:hover {\n        background: darken($datepicker-active-background, 10%);\n        color: lighten($datepicker-active-background, 10%);\n      }\n    }\n\n    &.range.highlighted {\n      &.focused {\n        background: darken($datepicker-range-highlighted-bg, 10%);\n      }\n\n      &.disabled,\n      &.disabled:active {\n        background: $datepicker-range-highlighted-bg;\n        color: $datepicker-disabled-cell-color;\n      }\n    }\n\n    &.range.today {\n      &.disabled,\n      &.disabled:active {\n        background: $blue;\n        color: $white;\n      }\n    }\n\n    &.day.range-start {\n      border-top-right-radius: 0;\n      border-bottom-right-radius: 0;\n    }\n\n    &.day.range-end {\n      border-top-left-radius: 0;\n      border-bottom-left-radius: 0;\n    }\n\n    &.day.range-start.range-end {\n      border-radius: $datepicker-cell-border-radius;\n    }\n\n    &.selected,\n    &.selected.highlighted,\n    &.selected:hover,\n    &.selected.highlighted:hover,\n    &.day.range:hover {\n      background: $datepicker-active-background;\n      color: $datepicker-active-color;\n    }\n\n    &.active,\n    &.active.highlighted,\n    &.active:hover,\n    &.active.highlighted:hover {\n      background: $datepicker-active-background;\n      color: $datepicker-active-color;\n      box-shadow: $datepicker-active-box-shadow;\n    }\n\n    span {\n      display: block;\n      width: 23%;\n      height: 54px;\n      line-height: 54px;\n      float: left;\n      margin: 1%;\n      cursor: pointer;\n      border-radius: 4px;\n\n      &:hover,\n      &.focused {\n        background: $gray-200;\n      }\n\n      &.disabled,\n      &.disabled:hover {\n        background: none;\n        color: $datepicker-disabled-cell-color;\n        cursor: default;\n      }\n\n      &.active,\n      &.active:hover,\n      &.active.disabled,\n      &.active.disabled:hover {\n        text-shadow: 0 -1px 0 rgba(0, 0, 0, 0.25);\n      }\n\n      &.old,\n      &.new {\n        color: $btn-link-disabled-color;\n      }\n    }\n  }\n\n  .datepicker-switch {\n    width: 145px;\n  }\n\n  .datepicker-switch,\n  .prev,\n  .next,\n  tfoot tr th {\n    cursor: pointer;\n    &:hover {\n      background: $gray-200;\n    }\n  }\n\n  .prev,\n  .next {\n    &.disabled {\n      visibility: hidden;\n    }\n  }\n\n  // Basic styling for calendar-week cells\n  .cw {\n    font-size: 10px;\n    width: 12px;\n    padding: 0 2px 0 5px;\n    vertical-align: middle;\n  }\n}\n","/*! nouislider - 14.0.1 - 6/21/2019 */\n/* Functional styling;\n * These styles are required for noUiSlider to function.\n * You don't need to change these rules to apply your design.\n */\n.noUi-target,\n.noUi-target * {\n  -webkit-touch-callout: none;\n  -webkit-tap-highlight-color: rgba(0, 0, 0, 0);\n  -webkit-user-select: none;\n  -ms-touch-action: none;\n  touch-action: none;\n  -ms-user-select: none;\n  -moz-user-select: none;\n  user-select: none;\n  -moz-box-sizing: border-box;\n  box-sizing: border-box;\n}\n.noUi-target {\n  position: relative;\n  direction: ltr;\n}\n.noUi-base,\n.noUi-connects {\n  width: 100%;\n  height: 100%;\n  position: relative;\n  z-index: 1;\n}\n/* Wrapper for all connect elements.\n */\n.noUi-connects {\n  overflow: hidden;\n  z-index: 0;\n}\n.noUi-connect,\n.noUi-origin {\n  will-change: transform;\n  position: absolute;\n  z-index: 1;\n  top: 0;\n  left: 0;\n  -ms-transform-origin: 0 0;\n  -webkit-transform-origin: 0 0;\n  -webkit-transform-style: preserve-3d;\n  transform-origin: 0 0;\n  transform-style: flat;\n}\n.noUi-connect {\n  height: 100%;\n  width: 100%;\n}\n.noUi-origin {\n  height: 10%;\n  width: 10%;\n}\n/* Offset direction\n */\nhtml:not([dir=\"rtl\"]) .noUi-horizontal .noUi-origin {\n  left: auto;\n  right: 0;\n}\n/* Give origins 0 height/width so they don't interfere with clicking the\n * connect elements.\n */\n.noUi-vertical .noUi-origin {\n  width: 0;\n}\n.noUi-horizontal .noUi-origin {\n  height: 0;\n}\n.noUi-handle {\n  -webkit-backface-visibility: hidden;\n  backface-visibility: hidden;\n  position: absolute;\n}\n.noUi-touch-area {\n  height: 100%;\n  width: 100%;\n}\n.noUi-state-tap .noUi-connect,\n.noUi-state-tap .noUi-origin {\n  -webkit-transition: transform 0.3s;\n  transition: transform 0.3s;\n}\n.noUi-state-drag * {\n  cursor: inherit !important;\n}\n/* Slider size and handle placement;\n */\n.noUi-horizontal {\n  height: 18px;\n}\n.noUi-horizontal .noUi-handle {\n  width: 34px;\n  height: 28px;\n  left: -17px;\n  top: -6px;\n}\n.noUi-vertical {\n  width: 18px;\n}\n.noUi-vertical .noUi-handle {\n  width: 28px;\n  height: 34px;\n  left: -6px;\n  top: -17px;\n}\nhtml:not([dir=\"rtl\"]) .noUi-horizontal .noUi-handle {\n  right: -17px;\n  left: auto;\n}\n/* Styling;\n * Giving the connect element a border radius causes issues with using transform: scale\n */\n.noUi-target {\n  background: #fafafa;\n  border-radius: 4px;\n  border: 1px solid #d3d3d3;\n  box-shadow:\n    inset 0 1px 1px #f0f0f0,\n    0 3px 6px -5px #bbb;\n}\n.noUi-connects {\n  border-radius: 3px;\n}\n.noUi-connect {\n  background: #3fb8af;\n}\n/* Handles and cursors;\n */\n.noUi-draggable {\n  cursor: ew-resize;\n}\n.noUi-vertical .noUi-draggable {\n  cursor: ns-resize;\n}\n.noUi-handle {\n  border: 1px solid #d9d9d9;\n  border-radius: 3px;\n  background: #fff;\n  cursor: default;\n  box-shadow:\n    inset 0 0 1px #fff,\n    inset 0 1px 7px #ebebeb,\n    0 3px 6px -3px #bbb;\n}\n.noUi-active {\n  box-shadow:\n    inset 0 0 1px #fff,\n    inset 0 1px 7px #ddd,\n    0 3px 6px -3px #bbb;\n}\n/* Handle stripes;\n */\n.noUi-handle:before,\n.noUi-handle:after {\n  content: \"\";\n  display: block;\n  position: absolute;\n  height: 14px;\n  width: 1px;\n  background: #e8e7e6;\n  left: 14px;\n  top: 6px;\n}\n.noUi-handle:after {\n  left: 17px;\n}\n.noUi-vertical .noUi-handle:before,\n.noUi-vertical .noUi-handle:after {\n  width: 14px;\n  height: 1px;\n  left: 6px;\n  top: 14px;\n}\n.noUi-vertical .noUi-handle:after {\n  top: 17px;\n}\n/* Disabled state;\n */\n[disabled] .noUi-connect {\n  background: #b8b8b8;\n}\n[disabled].noUi-target,\n[disabled].noUi-handle,\n[disabled] .noUi-handle {\n  cursor: not-allowed;\n}\n/* Base;\n *\n */\n.noUi-pips,\n.noUi-pips * {\n  -moz-box-sizing: border-box;\n  box-sizing: border-box;\n}\n.noUi-pips {\n  position: absolute;\n  color: #999;\n}\n/* Values;\n *\n */\n.noUi-value {\n  position: absolute;\n  white-space: nowrap;\n  text-align: center;\n}\n.noUi-value-sub {\n  color: #ccc;\n  font-size: 10px;\n}\n/* Markings;\n *\n */\n.noUi-marker {\n  position: absolute;\n  background: #ccc;\n}\n.noUi-marker-sub {\n  background: #aaa;\n}\n.noUi-marker-large {\n  background: #aaa;\n}\n/* Horizontal layout;\n *\n */\n.noUi-pips-horizontal {\n  padding: 10px 0;\n  height: 80px;\n  top: 100%;\n  left: 0;\n  width: 100%;\n}\n.noUi-value-horizontal {\n  -webkit-transform: translate(-50%, 50%);\n  transform: translate(-50%, 50%);\n}\n.noUi-rtl .noUi-value-horizontal {\n  -webkit-transform: translate(50%, 50%);\n  transform: translate(50%, 50%);\n}\n.noUi-marker-horizontal.noUi-marker {\n  margin-left: -1px;\n  width: 2px;\n  height: 5px;\n}\n.noUi-marker-horizontal.noUi-marker-sub {\n  height: 10px;\n}\n.noUi-marker-horizontal.noUi-marker-large {\n  height: 15px;\n}\n/* Vertical layout;\n *\n */\n.noUi-pips-vertical {\n  padding: 0 10px;\n  height: 100%;\n  top: 0;\n  left: 100%;\n}\n.noUi-value-vertical {\n  -webkit-transform: translate(0, -50%);\n  transform: translate(0, -50%);\n  padding-left: 25px;\n}\n.noUi-rtl .noUi-value-vertical {\n  -webkit-transform: translate(0, 50%);\n  transform: translate(0, 50%);\n}\n.noUi-marker-vertical.noUi-marker {\n  width: 5px;\n  height: 2px;\n  margin-top: -1px;\n}\n.noUi-marker-vertical.noUi-marker-sub {\n  width: 10px;\n}\n.noUi-marker-vertical.noUi-marker-large {\n  width: 15px;\n}\n.noUi-tooltip {\n  display: block;\n  position: absolute;\n  border: 1px solid #d9d9d9;\n  border-radius: 3px;\n  background: #fff;\n  color: #000;\n  padding: 5px;\n  text-align: center;\n  white-space: nowrap;\n}\n.noUi-horizontal .noUi-tooltip {\n  -webkit-transform: translate(-50%, 0);\n  transform: translate(-50%, 0);\n  left: 50%;\n  bottom: 120%;\n}\n.noUi-vertical .noUi-tooltip {\n  -webkit-transform: translate(0, -50%);\n  transform: translate(0, -50%);\n  top: 50%;\n  right: 120%;\n}\n\n//  Custom styles\n\n.noUi-target {\n  background: $noui-target-bg;\n  border-radius: $noui-target-border-radius;\n  border: 0;\n  box-shadow: $noui-target-box-shadow;\n  margin: 15px 0;\n  cursor: pointer;\n}\n\n.noUi-horizontal {\n  height: $noui-target-thickness;\n}\n\nhtml:not([dir=\"rtl\"]) .noUi-horizontal .noUi-handle {\n  right: -10px;\n}\n\n.noUi-vertical {\n  width: $noui-target-thickness;\n}\n\n.noUi-connect {\n  background: theme-color(\"primary\");\n  box-shadow: none;\n}\n\n.noUi-handle {\n  &:after,\n  &:before {\n    content: none;\n  }\n\n  &:focus {\n    outline: none;\n  }\n}\n\n.noUi-horizontal .noUi-handle,\n.noUi-vertical .noUi-handle {\n  top: -$noui-target-thickness;\n  width: $noui-handle-width;\n  height: $noui-handle-width;\n  border-radius: 100%;\n  box-shadow: none;\n  cursor: pointer;\n  background-color: $noui-handle-bg;\n  border: $noui-handle-border;\n  transition:\n    box-shadow 0.15s,\n    transform 0.15s;\n}\n\n.noUi-horizontal .noUi-handle.noUi-active,\n.noUi-vertical .noUi-handle.noUi-active {\n  box-shadow: 0px 0px 0px 2px rgba($noui-handle-bg, 1);\n}\n\n.input-slider--cyan .noUi-connect {\n  background: $cyan;\n}\n\n/* Disabled state */\n\n[disabled] .noUi-connect,\n[disabled].noUi-connect {\n  background: $noui-slider-connect-disabled-bg;\n}\n\n[disabled] .noUi-handle,\n[disabled].noUi-origin {\n  cursor: not-allowed;\n}\n\n/* Range slider value labels */\n\n.range-slider-value {\n  font-size: $font-size-xs;\n  font-weight: 500;\n  background-color: rgba($dark, 0.7);\n  color: color-yiq($dark);\n  border-radius: 10px;\n  padding: 0.4em 0.8em 0.3em 0.85em;\n}\n\n.range-slider-wrapper .upper-info {\n  font-weight: 400;\n  margin-bottom: 5px;\n}\n\n.input-slider-value-output {\n  background: #333;\n  color: #fff;\n  padding: 4px 8px;\n  position: relative;\n  top: 12px;\n  font-size: 11px;\n  border-radius: 2px;\n}\n\n.input-slider-value-output:after {\n  bottom: 100%;\n  left: 10px;\n  border: solid transparent;\n  content: \" \";\n  height: 0;\n  width: 0;\n  position: absolute;\n  pointer-events: none;\n  border-color: rgba(136, 183, 213, 0);\n  border-bottom-color: #333;\n  border-width: 4px;\n  margin-left: -4px;\n}\n\n.input-slider-value-output.left:after {\n  left: 10px;\n  right: auto;\n}\n\n.input-slider-value-output.right:after {\n  right: 10px;\n  left: auto;\n}\n","//\n// Custom scrollbar\n//\n\n.scrollbar-inner {\n  height: 100%;\n\n  &:not(:hover) .scroll-element {\n    opacity: 0;\n  }\n\n  .scroll-element {\n    transition: opacity 300ms;\n    margin-right: 2px;\n\n    .scroll-bar,\n    .scroll-element_track {\n      transition: background-color 300ms;\n    }\n\n    .scroll-element_track {\n      background-color: transparent;\n    }\n  }\n\n  .scroll-element.scroll-y {\n    width: 3px;\n    right: 0;\n  }\n\n  .scroll-element.scroll-x {\n    height: 3px;\n    bottom: 0;\n  }\n}\n","//\n// Main navbar\n//\n.ct-navbar {\n  background-color: $ct-primary;\n  box-shadow: rgba(116, 129, 141, 0.1) 0px 1px 1px 0px;\n  padding-top: 0.5rem;\n  padding-bottom: 0.5rem;\n\n  @include media-breakpoint-down(md) {\n    padding-right: 0.5rem;\n    padding-left: 0.5rem;\n\n    .navbar-nav-scroll {\n      max-width: 100%;\n      height: 2.5rem;\n      margin-top: 0.25rem;\n      overflow: hidden;\n      font-size: 0.875rem;\n\n      .navbar-nav {\n        padding-bottom: 2rem;\n        overflow-x: auto;\n        white-space: nowrap;\n        -webkit-overflow-scrolling: touch;\n      }\n    }\n  }\n\n  @include media-breakpoint-up(md) {\n    @supports (position: sticky) {\n      position: sticky;\n      top: 0;\n      z-index: 1071; // over everything in bootstrap\n    }\n  }\n\n  .navbar-nav {\n    .nav-link {\n      padding-right: 0.5rem;\n      padding-left: 0.5rem;\n      color: $ct-primary-light !important;\n\n      &.active,\n      &:hover {\n        color: #fff !important;\n        background-color: transparent !important;\n      }\n\n      &.active {\n        font-weight: 500;\n      }\n    }\n  }\n\n  .navbar-nav-svg {\n    display: inline-block;\n    width: 1rem;\n    height: 1rem;\n    vertical-align: text-top;\n  }\n\n  .dropdown-menu {\n    font-size: 0.875rem;\n  }\n\n  .dropdown-item.active {\n    font-weight: 500;\n    color: $gray-900;\n    background-color: transparent;\n    background-image: url(\"data:image/svg+xml;charset=utf8,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 8 8'%3E%3Cpath fill='%23292b2c' d='M2.3 6.73L.6 4.53c-.4-1.04.46-1.4 1.1-.8l1.1 1.4 3.4-3.8c.6-.63 1.6-.27 1.2.7l-4 4.6c-.43.5-.8.4-1.1.1z'/%3E%3C/svg%3E\");\n    background-repeat: no-repeat;\n    background-position: 0.4rem 0.87rem;\n    background-size: 0.75rem 0.75rem;\n    padding-left: 25px;\n  }\n}\n\n// Github corner\n.github-corner {\n  position: fixed;\n  right: 0;\n  z-index: 1080;\n\n  &:hover {\n    .octo-arm {\n      animation: octocat-wave 560ms ease-in-out;\n    }\n  }\n\n  svg {\n    fill: $white;\n    color: $ct-primary;\n  }\n}\n\n@keyframes octocat-wave {\n  0%,\n  100% {\n    transform: rotate(0);\n  }\n  20%,\n  60% {\n    transform: rotate(-25deg);\n  }\n  40%,\n  80% {\n    transform: rotate(10deg);\n  }\n}\n","// Local docs variables\n$ct-primary: theme-color(\"primary\") !default;\n$ct-primary-bright: lighten(saturate($ct-primary, 5%), 15%) !default;\n$ct-primary-light: rgba(255, 255, 255, 0.9) !default;\n$ct-dark: #2a2730 !default;\n$ct-download: #ffe484 !default;\n$ct-info: #5bc0de !default;\n$ct-warning: #f0ad4e !default;\n$ct-danger: #d9534f !default;\n\n$ct-sidebar-bg: #f5f7f9;\n$ct-sidebar-border-color: #e6ecf1;\n","// clipboard.js\n//\n// JS-based `Copy` buttons for code snippets.\n\n.ct-clipboard {\n  position: relative;\n  display: none;\n  float: right;\n\n  + .highlight {\n    margin-top: 0;\n  }\n}\n\n.btn-clipboard {\n  position: absolute;\n  top: 1rem;\n  right: 1rem;\n  z-index: 10;\n  display: block;\n  padding: 0.25rem 0.5rem;\n  font-size: 75%;\n  cursor: pointer;\n  background-color: transparent;\n  border: 0;\n  border-radius: 0.25rem;\n  color: #fff;\n  background-color: $ct-primary;\n\n  &:hover {\n    color: #fff;\n    background-color: darken($ct-primary, 10%);\n  }\n}\n\n@media (min-width: 768px) {\n  .ct-clipboard {\n    display: block;\n  }\n}\n","// stylelint-disable no-duplicate-selectors, selector-no-qualifying-type\n\n//\n// Grid examples\n//\n\n.ct-example-row {\n  .row {\n    > .col,\n    > [class^=\"col-\"] {\n      span {\n        display: block;\n        padding: 0.75rem;\n        color: rgb(57, 63, 73);\n        background-color: rgb(255, 255, 255);\n        box-shadow:\n          rgba(0, 0, 0, 0.1) 0px 0px 0px 1px,\n          rgba(0, 0, 0, 0.1) 0px 4px 16px;\n        font-size: $font-size-sm;\n        border-radius: 0.25rem;\n        margin: 1rem 0;\n      }\n    }\n  }\n\n  .no-gutters {\n    > .col,\n    > [class^=\"col-\"] {\n      span {\n        border-radius: 0;\n      }\n    }\n  }\n\n  .flex-items-top,\n  .flex-items-middle,\n  .flex-items-bottom {\n    min-height: 6rem;\n    background-color: rgba(255, 0, 0, 0.1);\n  }\n}\n\n.ct-example-row-flex-cols .row {\n  min-height: 10rem;\n  background-color: rgba(255, 0, 0, 0.1);\n\n  & + .row {\n    margin-top: 1rem;\n  }\n}\n\n.ct-highlight {\n  background-color: rgba($ct-primary, 0.15);\n  border: 1px solid rgba($ct-primary, 0.15);\n}\n\n// Grid mixins\n.example-container {\n  width: 800px;\n  @include make-container();\n}\n\n.example-row {\n  @include make-row();\n}\n\n.example-content-main {\n  @include make-col-ready();\n\n  @include media-breakpoint-up(sm) {\n    @include make-col(6);\n  }\n\n  @include media-breakpoint-up(lg) {\n    @include make-col(8);\n  }\n}\n\n.example-content-secondary {\n  @include make-col-ready();\n\n  @include media-breakpoint-up(sm) {\n    @include make-col(6);\n  }\n\n  @include media-breakpoint-up(lg) {\n    @include make-col(4);\n  }\n}\n\n//\n// Container illustrations\n//\n\n.ct-example-container {\n  min-width: 16rem;\n  max-width: 25rem;\n  margin-right: auto;\n  margin-left: auto;\n}\n\n.ct-example-container-header {\n  height: 3rem;\n  margin-bottom: 0.5rem;\n  background-color: lighten($blue, 50%);\n  border-radius: 0.25rem;\n}\n\n.ct-example-container-sidebar {\n  float: right;\n  width: 4rem;\n  height: 8rem;\n  background-color: lighten($blue, 25%);\n  border-radius: 0.25rem;\n}\n\n.ct-example-container-body {\n  height: 8rem;\n  margin-right: 4.5rem;\n  background-color: lighten($ct-primary, 25%);\n  border-radius: 0.25rem;\n}\n\n.ct-example-container-fluid {\n  max-width: none;\n}\n\n//\n// Docs examples\n//\n\n.ct-example {\n  position: relative;\n  margin: 1rem (-$grid-gutter-width / 2) 0;\n  @include clearfix();\n\n  @include media-breakpoint-up(sm) {\n    margin-right: 0;\n    margin-left: 0;\n  }\n\n  + .highlight,\n  + .clipboard + .highlight {\n    margin-top: 0;\n  }\n\n  + p {\n    margin-top: 2rem;\n  }\n\n  .pos-f-t {\n    position: relative;\n    margin: -1rem;\n\n    @include media-breakpoint-up(sm) {\n      margin: -1.5rem;\n    }\n  }\n\n  .custom-file-input:lang(es) ~ .custom-file-label::after {\n    content: \"Elegir\";\n  }\n\n  > .form-control {\n    + .form-control {\n      margin-top: 0.5rem;\n    }\n  }\n\n  > .nav + .nav,\n  > .alert + .alert,\n  > .navbar + .navbar,\n  > .progress + .progress,\n  > .progress + .btn,\n  .badge,\n  .btn {\n    margin-top: 0.5rem;\n    margin-bottom: 0.5rem;\n  }\n\n  .btn-group {\n    margin-top: 0.5rem;\n    margin-bottom: 0.5rem;\n    .btn {\n      margin: 0;\n    }\n  }\n\n  .alert {\n    margin: 0;\n\n    + .alert {\n      margin-top: 1.25rem;\n    }\n  }\n\n  .badge {\n    margin-right: 0.5rem;\n  }\n\n  > .dropdown-menu:first-child {\n    position: static;\n    display: block;\n  }\n\n  > .form-group:last-child {\n    margin-bottom: 0;\n  }\n\n  > .close {\n    float: none;\n  }\n}\n\n// Typography\n.ct-example-type {\n  .table {\n    .type-info {\n      color: #999;\n      vertical-align: middle;\n    }\n    td {\n      padding: 1rem 0;\n      border-color: #eee;\n    }\n    tr:first-child td {\n      border-top: 0;\n    }\n  }\n\n  h1,\n  h2,\n  h3,\n  h4,\n  h5,\n  h6 {\n    margin-top: 0;\n    margin-bottom: 0;\n  }\n}\n\n// Contextual background colors\n.ct-example-bg-classes p {\n  padding: 1rem;\n}\n\n// Images\n.ct-example > img {\n  + img {\n    margin-left: 0.5rem;\n  }\n}\n\n// Buttons\n.ct-example {\n  > .btn-group {\n    margin-top: 0.25rem;\n    margin-bottom: 0.25rem;\n  }\n  > .btn-toolbar + .btn-toolbar {\n    margin-top: 0.5rem;\n  }\n}\n\n// Forms\n.ct-example-control-sizing select,\n.ct-example-control-sizing input[type=\"text\"] + input[type=\"text\"] {\n  margin-top: 0.5rem;\n}\n.ct-example-form .input-group {\n  margin-bottom: 0.5rem;\n}\n.ct-example > textarea.form-control {\n  resize: vertical;\n}\n\n// List groups\n.ct-example > .list-group {\n  max-width: 400px;\n}\n\n// Navbars\n.ct-example {\n  .fixed-top,\n  .sticky-top {\n    position: static;\n    margin: -1rem -1rem 1rem;\n  }\n  .fixed-bottom {\n    position: static;\n    margin: 1rem -1rem -1rem;\n  }\n\n  @include media-breakpoint-up(sm) {\n    .fixed-top,\n    .sticky-top {\n      margin: -1.5rem -1.5rem 1rem;\n    }\n    .fixed-bottom {\n      margin: 1rem -1.5rem -1.5rem;\n    }\n  }\n}\n\n// Pagination\n.ct-example .pagination {\n  margin-top: 0.5rem;\n  margin-bottom: 0.5rem;\n}\n\n// Example modals\n.modal {\n  z-index: 1072;\n\n  .tooltip,\n  .popover {\n    z-index: 1073;\n  }\n}\n\n.modal-backdrop {\n  z-index: 1071;\n}\n\n.ct-example-modal {\n  background-color: #fafafa;\n\n  .modal {\n    position: relative;\n    top: auto;\n    right: auto;\n    bottom: auto;\n    left: auto;\n    z-index: 1;\n    display: block;\n  }\n\n  .modal-dialog {\n    left: auto;\n    margin-right: auto;\n    margin-left: auto;\n  }\n}\n\n// Example tabbable tabs\n.ct-example-tabs .nav-tabs {\n  margin-bottom: 1rem;\n}\n\n// Popovers\n.ct-example-popover-static {\n  padding-bottom: 1.5rem;\n  background-color: #f9f9f9;\n\n  .popover {\n    position: relative;\n    display: block;\n    float: left;\n    width: 260px;\n    margin: 1.25rem;\n  }\n}\n\n// Tooltips\n.tooltip-demo a {\n  white-space: nowrap;\n}\n\n.ct-example-tooltip-static .tooltip {\n  position: relative;\n  display: inline-block;\n  margin: 10px 20px;\n  opacity: 1;\n}\n\n// Scrollspy demo on fixed height div\n.scrollspy-example {\n  position: relative;\n  height: 200px;\n  margin-top: 0.5rem;\n  overflow: auto;\n}\n\n.scrollspy-example-2 {\n  position: relative;\n  height: 350px;\n  overflow: auto;\n}\n\n.ct-example-border-utils {\n  [class^=\"border\"] {\n    display: inline-block;\n    width: 5rem;\n    height: 5rem;\n    margin: 0.25rem;\n    background-color: #f5f5f5;\n  }\n}\n\n.ct-example-border-utils-0 {\n  [class^=\"border\"] {\n    border: 1px solid $border-color;\n  }\n}\n\n//\n// Code snippets\n//\n\n.highlight {\n  padding: 0;\n  margin-top: 1rem;\n  //margin-bottom: 3rem;\n  //background-color: $gray-100;\n  -ms-overflow-style: -ms-autohiding-scrollbar;\n\n  @include media-breakpoint-up(sm) {\n    padding: 0;\n  }\n}\n\n.ct-content .highlight {\n  margin-right: (-$grid-gutter-width / 2);\n  margin-left: (-$grid-gutter-width / 2);\n\n  @include media-breakpoint-up(sm) {\n    margin-right: 0;\n    margin-left: 0;\n  }\n}\n\n//\n// Component-Code tabs\n//\n\n.ct-example {\n  margin-bottom: 2rem;\n  padding-bottom: 2rem;\n  border-bottom: 1px solid $gray-200;\n\n  .tab-content {\n    .tab-example-result {\n      background-color: #f5f7f9;\n      border: 1px solid #e6ecf1;\n      padding: 1.25rem;\n      border-radius: 0.25rem;\n    }\n  }\n\n  .nav-tabs-code {\n    margin-bottom: 0.375rem;\n\n    .nav-link {\n      font-size: 0.875rem;\n\n      &:active,\n      &.active {\n        color: $ct-primary;\n      }\n    }\n  }\n}\n\n// Icon examples\n.icon-examples {\n  margin-top: 1rem;\n}\n.btn-icon-clipboard {\n  margin: 0px;\n  padding: 24px;\n  font-size: 16px;\n  font-weight: 400;\n  line-height: 1.25;\n  color: rgb(57, 63, 73);\n  background-color: rgb(248, 249, 250);\n  border-radius: 4px;\n  border: 0px none;\n  text-align: left;\n  font-family: inherit;\n  display: inline-block;\n  vertical-align: middle;\n  text-decoration: none;\n  -moz-appearance: none;\n  cursor: pointer;\n  width: 100%;\n  margin: 0.5rem 0;\n\n  &:hover {\n    background-color: rgb(255, 255, 255);\n    box-shadow:\n      rgba(0, 0, 0, 0.1) 0px 0px 0px 1px,\n      rgba(0, 0, 0, 0.1) 0px 4px 16px;\n  }\n\n  > div {\n    align-items: center;\n    display: flex;\n  }\n\n  i {\n    box-sizing: content-box;\n    color: rgb(57, 63, 73);\n    vertical-align: middle;\n    font-size: 1.5rem;\n  }\n\n  span {\n    display: inline-block;\n    font-size: 0.875rem;\n    line-height: 1.5;\n    color: rgb(57, 63, 73);\n    margin-left: 16px;\n    overflow: hidden;\n    white-space: nowrap;\n    text-overflow: ellipsis;\n    vertical-align: middle;\n  }\n}\n","code[class*=\"language-\"],\npre[class*=\"language-\"] {\n  font-family: Consolas, Menlo, Monaco, \"Andale Mono WT\", \"Andale Mono\",\n    \"Lucida Console\", \"Lucida Sans Typewriter\", \"DejaVu Sans Mono\",\n    \"Bitstream Vera Sans Mono\", \"Liberation Mono\", \"Nimbus Mono L\",\n    \"Courier New\", Courier, monospace;\n  font-size: 14px;\n  line-height: 1.375;\n  direction: ltr;\n  text-align: left;\n  white-space: pre;\n  word-spacing: normal;\n  word-break: normal;\n  -moz-tab-size: 4;\n  -o-tab-size: 4;\n  tab-size: 4;\n  -webkit-hyphens: none;\n  -moz-hyphens: none;\n  -ms-hyphens: none;\n  hyphens: none;\n  background: #f5f7ff;\n  color: #5e6687;\n  border-radius: 0.25rem;\n}\n\npre[class*=\"language-\"]::-moz-selection,\npre[class*=\"language-\"] ::-moz-selection,\ncode[class*=\"language-\"]::-moz-selection,\ncode[class*=\"language-\"] ::-moz-selection {\n  text-shadow: none;\n  background: #dfe2f1;\n}\n\npre[class*=\"language-\"]::selection,\npre[class*=\"language-\"] ::selection,\ncode[class*=\"language-\"]::selection,\ncode[class*=\"language-\"] ::selection {\n  text-shadow: none;\n  background: #dfe2f1;\n}\n\n/* Code blocks */\n\npre[class*=\"language-\"] {\n  padding: 1.25rem;\n  margin: 0;\n  overflow: auto;\n}\n\n/* Inline code */\n\n:not(pre) > code[class*=\"language-\"] {\n  padding: 0.1em;\n  border-radius: 0.3em;\n}\n\n.token.comment,\n.token.prolog,\n.token.doctype,\n.token.cdata {\n  color: #898ea4;\n}\n\n.token.punctuation {\n  color: #5e6687;\n}\n\n.token.namespace {\n  opacity: 0.7;\n}\n\n.token.operator,\n.token.boolean,\n.token.number {\n  color: #c76b29;\n}\n\n.token.property {\n  color: #c08b30;\n}\n\n.token.tag {\n  color: #3d8fd1;\n}\n\n.token.string {\n  color: #22a2c9;\n}\n\n.token.selector {\n  color: #6679cc;\n}\n\n.token.attr-name {\n  color: #c76b29;\n}\n\n.token.entity,\n.token.url,\n.language-css .token.string,\n.style .token.string {\n  color: #22a2c9;\n}\n\n.token.attr-value,\n.token.keyword,\n.token.control,\n.token.directive,\n.token.unit {\n  color: #ac9739;\n}\n\n.token.statement,\n.token.regex,\n.token.atrule {\n  color: #22a2c9;\n}\n\n.token.placeholder,\n.token.variable {\n  color: #3d8fd1;\n}\n\n.token.deleted {\n  text-decoration: line-through;\n}\n\n.token.inserted {\n  border-bottom: 1px dotted #202746;\n  text-decoration: none;\n}\n\n.token.italic {\n  font-style: italic;\n}\n\n.token.important,\n.token.bold {\n  font-weight: bold;\n}\n\n.token.important {\n  color: #c94922;\n}\n\n.token.entity {\n  cursor: help;\n}\n\npre > code.highlight {\n  outline: 0.4em solid #c94922;\n  outline-offset: 0.4em;\n}\n\n/* overrides color-values for the Line Numbers plugin\n * http://prismjs.com/plugins/line-numbers/\n */\n\n.line-numbers .line-numbers-rows {\n  border-right-color: #dfe2f1;\n}\n\n.line-numbers-rows > span:before {\n  color: #979db4;\n}\n\n/* overrides color-values for the Line Highlight plugin\n * http://prismjs.com/plugins/line-highlight/\n */\n\n.line-highlight {\n  background: rgba(107, 115, 148, 0.2);\n  background: -webkit-linear-gradient(\n    left,\n    rgba(107, 115, 148, 0.2) 70%,\n    rgba(107, 115, 148, 0)\n  );\n  background: linear-gradient(\n    to right,\n    rgba(107, 115, 148, 0.2) 70%,\n    rgba(107, 115, 148, 0)\n  );\n}\n",".docs {\n  background: #fff;\n\n  h6 {\n    font-size: 1rem;\n    font-weight: $font-weight-bold;\n  }\n}\n\n.ct-content {\n  order: 1;\n\n  > h2[id],\n  > h3[id],\n  > h4[id] {\n    pointer-events: none;\n\n    > div,\n    > a {\n      pointer-events: auto;\n    }\n\n    &::before {\n      display: block;\n      height: 6rem;\n      margin-top: -6rem;\n      visibility: hidden;\n      content: \"\";\n    }\n  }\n\n  > table {\n    width: 100%;\n    max-width: 100%;\n    margin-bottom: 1rem;\n\n    @include media-breakpoint-down(md) {\n      display: block;\n      overflow-x: auto;\n      -ms-overflow-style: -ms-autohiding-scrollbar; // See https://github.com/twbs/bootstrap/pull/10057\n      &.table-bordered {\n        border: 0;\n      }\n    } // Cells\n    > thead,\n    > tbody,\n    > tfoot {\n      > tr {\n        > th,\n        > td {\n          padding: $table-cell-padding;\n          vertical-align: top;\n          border: 1px solid $table-border-color;\n\n          > p:last-child {\n            margin-bottom: 0;\n          }\n        }\n      }\n    } // Prevent breaking of code (e.g., Grunt tasks list)\n    td:first-child > code {\n      white-space: nowrap;\n    }\n  }\n}\n\n//\n// Docs sections\n//\n.ct-content {\n  > h2:not(:first-child) {\n    margin-top: 3rem;\n    font-size: 1.5rem;\n    font-weight: $font-weight-bold;\n  }\n\n  > h3 {\n    margin-top: 2.5rem;\n    font-size: 1.25rem;\n    font-weight: $font-weight-bold;\n  }\n\n  > ul li,\n  > ol li {\n    margin-bottom: 0.25rem;\n  }\n\n  @include media-breakpoint-up(lg) {\n    > ul,\n    > ol,\n    > p {\n      max-width: 80%;\n    }\n  }\n}\n\n.ct-page-title {\n  padding-left: 1.25rem;\n  border-left: 2px solid $ct-primary;\n  margin-bottom: 1.5rem;\n}\n\n.ct-title {\n  margin-top: 1rem;\n  margin-bottom: 0.5rem;\n  font-weight: 300;\n\n  @include media-breakpoint-up(sm) {\n    font-size: 1.5rem;\n    font-weight: $font-weight-bold;\n  }\n}\n\n.ct-lead {\n  color: rgb(59, 69, 78);\n  font-weight: 500;\n\n  @include media-breakpoint-up(sm) {\n    max-width: 80%;\n    margin-bottom: 1rem;\n    font-size: 0.875rem;\n  }\n}\n\n.ct-text-purple {\n  color: $ct-primary;\n}\n\n.ct-text-purple-bright {\n  color: $ct-primary-bright;\n}\n\n// Docs code example tabs\n.ct-tabs-example {\n  .nav-link i {\n    margin-right: 5px;\n  }\n}\n\n// Color swatches\n.color-swatch {\n  margin: 1rem 0;\n  border-radius: 0.25rem;\n  background-color: #f4f5f7;\n}\n\n.color-swatch:after {\n  content: \" \";\n  display: table;\n  clear: both;\n}\n\n.color-swatch-header {\n  position: relative;\n  height: 0;\n  padding-bottom: 50%;\n  border-radius: 0.25rem 0.25rem 0 0;\n  border: 1px solid transparent;\n}\n\n.color-swatch-header.is-light {\n  border-color: #c1c7d0;\n}\n\n.color-swatch-header .pass-fail {\n  position: absolute;\n  width: 100%;\n  bottom: 0;\n}\n\n.color-swatch-header .pass-fail-item-wrap {\n  position: relative;\n  float: left;\n  left: 50%;\n  -webkit-transform: translateX(-50%);\n  -ms-transform: translateX(-50%);\n  transform: translateX(-50%);\n}\n\n.color-swatch-header .pass-fail-item-group {\n  display: inline-block;\n  padding: 0 5px;\n}\n\n.color-swatch-header .pass-fail-item {\n  float: left;\n  display: inline-block;\n  text-align: center;\n  padding: 2px;\n}\n\n.color-swatch-header .pass-fail-item.white .example {\n  color: #fff;\n}\n\n.color-swatch-header .pass-fail-item.small .example {\n  font-size: 10px;\n}\n\n.color-swatch-header .pass-fail-item .lozenge {\n  font-size: 11px;\n  text-transform: uppercase;\n  font-weight: 600;\n  background: #000;\n  color: #fff;\n  padding: 2px 4px;\n  line-height: 10px;\n  border-radius: 4px;\n  letter-spacing: 0.05em;\n}\n\n.color-swatch-body {\n  position: relative;\n  left: 50%;\n  float: left;\n  padding: 10px 0;\n  -webkit-transform: translateX(-50%);\n  -ms-transform: translateX(-50%);\n  transform: translateX(-50%);\n}\n\n.color-swatch-body .prop-item-wrap {\n  float: left;\n  padding: 0 15px;\n  min-width: 65px;\n}\n\n.color-swatch-body .prop-item {\n  padding: 15px 0;\n}\n\n.color-swatch-body .prop-item .label {\n  font-size: 11px;\n  color: #62748c;\n  text-transform: uppercase;\n  line-height: 16px;\n}\n\n.color-swatch-body .prop-item .value {\n  font-size: 14px;\n}\n\n.table-colors {\n  font-weight: 600;\n  font-size: 16px;\n  width: 100%;\n}\n\n.table-colors td,\n.table-colors:first-child td,\n.table-colors td:first-child,\n.table-colors:first-child td:first-child,\n.table-colors td:last-child,\n.table-colors:first-child td:last-child {\n  background: $ct-primary-light;\n  border-bottom: 1px solid rgba(0, 0, 0, 0.1);\n  padding: 10px;\n}\n\n.table-colors tr:last-child td,\n.table-colors:first-child tr:last-child td {\n  border-bottom: none;\n}\n\n.table-colors td:nth-child(1),\n.table-colors:first-child td:nth-child(1) {\n  line-height: 40px;\n}\n\n.table-colors .swatch,\n.table-colors:first-child .swatch {\n  float: left;\n  height: 40px;\n  width: 40px;\n  margin-right: 20px;\n  display: inline-block;\n  border-radius: 4px;\n  border: 1px solid transparent;\n}\n\n.table-colors .swatch.is-light,\n.table-colors:first-child .swatch.is-light {\n  border-color: #c1c7d0;\n}\n\n.table-colors .lozenge,\n.table-colors:first-child .lozenge {\n  float: left;\n  margin: 5px 10px 0 0;\n  font-size: 10px;\n  display: inline-block;\n  text-transform: uppercase;\n  font-weight: 600;\n  background: #97a0af;\n  color: #042a53;\n  padding: 2px 4px;\n  line-height: 10px;\n  border-radius: 4px;\n  letter-spacing: 0.05em;\n}\n","// stylelint-disable declaration-no-important\n//\n// Right side table of contents\n//\n.ct-toc {\n  @supports (position: sticky) {\n    position: sticky;\n    top: 4rem;\n    height: calc(100vh - 4rem);\n    overflow-y: auto;\n  }\n  order: 2;\n  padding-top: 2rem;\n  padding-bottom: 1.5rem;\n  font-size: 0.875rem;\n}\n\n.section-nav {\n  padding-left: 0;\n  border-left: 1px solid #eee;\n\n  ul {\n    padding-left: 1rem;\n\n    ul {\n      display: none;\n    }\n  }\n}\n\n.toc-entry {\n  display: block;\n  font-size: 1rem;\n\n  a {\n    display: block;\n    padding: 0.125rem 1.5rem;\n    color: #99979c;\n    font-size: 90%;\n\n    &:hover {\n      color: $blue;\n      text-decoration: none;\n    }\n  }\n}\n\n//\n// Left side navigation\n//\n.ct-sidebar {\n  order: 0; // background-color: #f5f2f9;\n  border-bottom: 1px solid $ct-sidebar-border-color;\n  background-color: $ct-sidebar-bg;\n\n  @include media-breakpoint-up(md) {\n    @supports (position: sticky) {\n      position: sticky;\n      top: 4rem;\n      z-index: 1000;\n      height: calc(100vh - 4rem);\n    }\n    border-right: 1px solid $ct-sidebar-border-color;\n  }\n\n  @include media-breakpoint-up(xl) {\n    flex: 0 1 320px;\n  }\n}\n\n.ct-links {\n  padding-top: 2rem;\n  padding-bottom: 1rem;\n  margin-right: -15px;\n  margin-left: -15px;\n\n  @include media-breakpoint-up(md) {\n    @supports (position: sticky) {\n      max-height: calc(100vh - 5rem);\n      overflow-y: auto;\n    }\n  } // Override collapse behaviors\n  @include media-breakpoint-up(md) {\n    display: block !important;\n  }\n}\n\n.ct-search {\n  position: relative; // To contain the Algolia search\n  padding: 1rem 15px;\n  margin-right: -15px;\n  margin-left: -15px;\n  border-bottom: 1px solid rgba(0, 0, 0, 0.05);\n\n  .form-control:focus {\n    border-color: $ct-primary-bright;\n    box-shadow: 0 0 0 3px rgba($ct-primary-bright, 0.25);\n  }\n}\n\n.ct-search-docs-toggle {\n  line-height: 1;\n  color: $gray-900;\n}\n\n.ct-sidenav {\n  display: none;\n}\n\n.ct-toc-link {\n  display: block;\n  padding: 0.25rem 1.5rem;\n  font-weight: 600;\n  font-size: 0.875rem;\n  color: #0d2b3e;\n\n  &:hover {\n    color: rgba(0, 0, 0, 0.85);\n    text-decoration: none;\n  }\n}\n\n.ct-toc-item {\n  &.active {\n    margin-bottom: 1rem;\n\n    &:not(:first-child) {\n      margin-top: 1rem;\n    }\n\n    > .ct-toc-link {\n      color: rgba(0, 0, 0, 0.85);\n\n      &:hover {\n        background-color: transparent;\n      }\n    }\n\n    > .ct-sidenav {\n      display: block;\n    }\n  }\n}\n\n// All levels of nav\n.ct-sidebar .nav > li > a {\n  display: block;\n  padding: 0.25rem 1.5rem;\n  font-size: 84%;\n  color: #4c555a;\n}\n\n.ct-sidebar .nav > li > a:hover {\n  color: rgba(0, 0, 0, 0.85);\n  text-decoration: none;\n  background-color: transparent;\n}\n\n.ct-sidebar .nav > .active > a {\n  font-weight: 500;\n  color: #0099e5;\n  background-color: transparent;\n  padding-left: 2rem;\n  position: relative;\n\n  &:before {\n    content: \"\";\n    position: absolute;\n    height: 16px;\n    width: 2px;\n    background-color: #0099e5;\n    top: 50%;\n    left: 1.5rem;\n    transform: translateY(-50%);\n  }\n}\n\n.ct-sidebar .nav > .active:hover > a {\n  color: #0099e5;\n}\n\n.scrollbar-inner {\n  height: 100%;\n\n  &:not(:hover) .scroll-element {\n    opacity: 0;\n  }\n\n  .scroll-element {\n    transition: opacity 300ms;\n    margin-right: 2px;\n\n    .scroll-bar,\n    .scroll-element_track {\n      transition: background-color 300ms;\n    }\n\n    .scroll-element_track {\n      background-color: transparent;\n    }\n  }\n\n  .scroll-element.scroll-y {\n    width: 3px;\n    right: 0;\n  }\n\n  .scroll-element.scroll-x {\n    height: 3px;\n    bottom: 0;\n  }\n}\n","//\n// Footer\n//\n.ct-footer {\n  font-size: 85%;\n  text-align: center;\n  background-color: #f7f7f7;\n\n  a {\n    font-weight: 500;\n    color: $gray-700;\n\n    &:hover,\n    &:focus {\n      color: $link-color;\n    }\n  }\n\n  p {\n    margin-bottom: 0;\n  }\n\n  @include media-breakpoint-up(sm) {\n    text-align: left;\n  }\n}\n\n.ct-footer-links {\n  padding-left: 0;\n  margin-bottom: 1rem;\n\n  li {\n    display: inline-block;\n\n    + li {\n      margin-left: 1rem;\n    }\n  }\n}\n","//\n// Rotating border\n//\n\n@keyframes spinner-border {\n  to { transform: rotate(360deg); }\n}\n\n.spinner-border {\n  display: inline-block;\n  width: $spinner-width;\n  height: $spinner-height;\n  vertical-align: text-bottom;\n  border: $spinner-border-width solid currentColor;\n  border-right-color: transparent;\n  // stylelint-disable-next-line property-disallowed-list\n  border-radius: 50%;\n  animation: .75s linear infinite spinner-border;\n}\n\n.spinner-border-sm {\n  width: $spinner-width-sm;\n  height: $spinner-height-sm;\n  border-width: $spinner-border-width-sm;\n}\n\n//\n// Growing circle\n//\n\n@keyframes spinner-grow {\n  0% {\n    transform: scale(0);\n  }\n  50% {\n    opacity: 1;\n    transform: none;\n  }\n}\n\n.spinner-grow {\n  display: inline-block;\n  width: $spinner-width;\n  height: $spinner-height;\n  vertical-align: text-bottom;\n  background-color: currentColor;\n  // stylelint-disable-next-line property-disallowed-list\n  border-radius: 50%;\n  opacity: 0;\n  animation: .75s linear infinite spinner-grow;\n}\n\n.spinner-grow-sm {\n  width: $spinner-width-sm;\n  height: $spinner-height-sm;\n}\n\n@if $enable-prefers-reduced-motion-media-query {\n  @media (prefers-reduced-motion: reduce) {\n    .spinner-border,\n    .spinner-grow {\n      animation-duration: 1.5s;\n    }\n  }\n}\n","/*!\n* https://github.com/YouCanBookMe/react-datetime\n*/\n.rdt {\n  position: relative;\n\n  .rdtPicker {\n    -webkit-transition: all 150ms linear;\n    -moz-transition: all 150ms linear;\n    -o-transition: all 150ms linear;\n    -ms-transition: all 150ms linear;\n    transition: all 150ms linear;\n    margin-top: -20px;\n    visibility: hidden;\n    display: block;\n    opacity: 0;\n  }\n  &.rdtOpen {\n    .rdtPicker {\n      opacity: 1;\n      visibility: visible;\n      margin-top: 0;\n    }\n  }\n}\n.rdtPicker {\n  display: none;\n  position: absolute;\n  padding: 20px;\n  margin-top: 1px;\n  z-index: 99999 !important;\n  background: #fff;\n  border-radius: 0.375rem;\n  box-shadow: 0px 10px 50px 0px rgba(0, 0, 0, 0.2);\n  -webkit-background-clip: padding-box;\n  background-clip: padding-box;\n  min-width: 160px;\n\n  &:before {\n    display: inline-block;\n    position: absolute;\n    width: 0;\n    height: 0;\n    vertical-align: middle;\n    content: \"\";\n    top: -5px;\n    left: 10px;\n    right: auto;\n    color: #ffffff;\n    border-bottom: 0.4em solid;\n    border-right: 0.4em solid transparent;\n    border-left: 0.4em solid transparent;\n  }\n  &:after {\n    border-bottom: 0.4em solid #ffffff;\n    border-right: 0.4em solid transparent;\n    border-left: 0.4em solid transparent;\n    content: \"\";\n    display: inline-block;\n    position: absolute;\n    top: -5px;\n    left: 10px;\n  }\n}\n\n.rdtPicker {\n  display: block;\n  top: 40px;\n}\n.rdtStatic .rdtPicker {\n  box-shadow: none;\n  position: static;\n}\n\n.rdtPicker .rdtTimeToggle {\n  text-align: center;\n  padding: 10px;\n  border-radius: 4px;\n  visibility: hidden;\n  position: relative;\n  &:before {\n    visibility: visible;\n    width: 100%;\n    height: 100%;\n    border-radius: 3px;\n    position: absolute;\n    top: 0;\n    left: 0;\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    font: normal normal normal 1em/1 \"Nucleo\";\n    font-size: 18px;\n    content: \"\\EA5E\";\n  }\n}\n\n.rdtPicker table {\n  width: 100%;\n  margin: 0;\n  border-color: $white !important;\n}\n.rdtPicker td,\n.rdtPicker th {\n  text-align: center;\n  padding: 1px;\n}\n.rdtPicker td {\n  cursor: pointer;\n}\n.rdtDay {\n  font-size: 0.875rem;\n  width: 36px;\n  height: 36px;\n  transition: all 0.15s ease;\n  text-align: center;\n  border: none;\n  border-radius: 50%;\n  &.rdtToday.rdtActive,\n  &.rdtActive,\n  &.rdtActive:hover,\n  &.start-date,\n  &.end-date,\n  &.middle-date,\n  &.start-date:hover,\n  &.end-date:hover,\n  &.middle-date:hover {\n    background-color: $info !important;\n    color: $white !important;\n  }\n  &.start-date {\n    border-top-right-radius: 0;\n    border-bottom-right-radius: 0;\n  }\n  &.middle-date {\n    border-radius: 0;\n  }\n  &.end-date {\n    border-top-left-radius: 0;\n    border-bottom-left-radius: 0;\n  }\n}\n.rdtDays {\n  tr {\n    .dow {\n      text-align: center;\n      font-size: 12px;\n      font-weight: inherit;\n      padding-bottom: 5px;\n      padding-top: 10px;\n      font-weight: 300;\n      font-size: 0.875rem;\n      width: 20px;\n      height: 20px;\n    }\n    .rdtDay {\n      color: $gray-700;\n      font-size: 0.875rem;\n      &.rdtOld,\n      &.rdtNew {\n        color: $gray-500;\n        font-weight: 300;\n      }\n    }\n  }\n}\n\n.rdtPicker td.rdtDay:hover,\n.rdtPicker td.rdtHour:hover,\n.rdtPicker td.rdtMinute:hover,\n.rdtPicker td.rdtSecond:hover,\n.rdtPicker .rdtTimeToggle:hover,\n.rdtPicker .rdtTimeToggle:hover:before {\n  background: #eeeeee;\n  cursor: pointer;\n}\n.rdtPicker td.rdtToday {\n  position: relative;\n}\n.rdtPicker td.rdtActive.rdtToday:before {\n  border-bottom-color: #fff;\n}\n.rdtPicker td.rdtDisabled,\n.rdtPicker td.rdtDisabled:hover {\n  background: none;\n  color: #999999;\n  cursor: not-allowed;\n}\n\n.rdtPicker td span.rdtOld {\n  color: #999999;\n}\n.rdtPicker td span.rdtDisabled,\n.rdtPicker td span.rdtDisabled:hover {\n  background: none;\n  color: #999999;\n  cursor: not-allowed;\n}\n.rdtPicker tr .dow {\n  width: 14.2857%;\n  border-bottom: none;\n  font-size: 0.875rem;\n  width: 36px;\n  height: 36px;\n  transition: all 0.15s ease;\n  text-align: center;\n  border: none;\n  font-weight: 500;\n  border-radius: 0.375rem;\n}\n.rdtPicker th.rdtSwitch {\n  font-weight: 500;\n  border-radius: 0.375rem;\n  font-size: 0.875rem;\n  width: 145px;\n  height: 36px;\n  transition: all 0.15s ease;\n  text-align: center;\n  border: none;\n}\n.rdtPicker th.rdtNext,\n.rdtPicker th.rdtPrev {\n  font-size: 0.875rem;\n  width: 36px;\n  height: 36px;\n  transition: all 0.15s ease;\n  text-align: center;\n  border: none;\n  border-radius: 0.375rem;\n  cursor: pointer;\n}\n\n.rdtPicker {\n  .dow,\n  th.rdtSwitch,\n  th.rdtNext,\n  th.rdtPrev,\n  .rdtTimeToggle {\n    color: $gray-700;\n  }\n}\n\n.rdtPrev span,\n.rdtNext span {\n  display: block;\n  -webkit-touch-callout: none; /* iOS Safari */\n  -webkit-user-select: none; /* Chrome/Safari/Opera */\n  -khtml-user-select: none; /* Konqueror */\n  -moz-user-select: none; /* Firefox */\n  -ms-user-select: none; /* Internet Explorer/Edge */\n  user-select: none;\n}\n\n.rdtPicker th.rdtDisabled,\n.rdtPicker th.rdtDisabled:hover {\n  background: none;\n  color: #999999;\n  cursor: not-allowed;\n}\n.rdtPicker thead tr:first-child th {\n  cursor: pointer;\n}\n.rdtPicker thead tr:first-child th:hover {\n  background: #eeeeee;\n}\n\n.rdtPicker button {\n  border: none;\n  background: none;\n  cursor: pointer;\n}\n.rdtPicker button:hover {\n  background-color: #eee;\n}\n\n.rdtPicker thead button {\n  width: 100%;\n  height: 100%;\n}\n\ntd.rdtMonth,\ntd.rdtYear {\n  height: 50px;\n  width: 25%;\n  cursor: pointer;\n}\ntd.rdtMonth:hover,\ntd.rdtYear:hover {\n  background: #eee;\n}\n\n.rdtCounters {\n  display: inline-block;\n}\n\n.rdtCounters {\n  > div {\n    float: left;\n    width: 40px;\n    font-weight: inherit;\n    margin: 3px;\n    border-radius: 50%;\n  }\n  .rdtCounterSeparator {\n    width: 0;\n    border: 1px solid transparent;\n  }\n}\n\n.rdtCounter {\n  height: 100px;\n}\n\n.rdtCounter {\n  width: 40px;\n  .rdtCount {\n    padding: 7px;\n    height: 40px;\n    border: 1px solid transparent;\n  }\n}\n.rdtCounters {\n  .rdtCounter:last-child {\n    .rdtCount {\n      color: $info;\n      border-radius: 50%;\n      border: 1px solid $info;\n    }\n  }\n}\n\n.rdtCounterSeparator {\n  padding: 7px;\n  line-height: 100px;\n}\n.rdtCounter .rdtBtn {\n  line-height: 40px;\n  cursor: pointer;\n  display: block;\n  border-radius: 50%;\n  color: $gray-500;\n  -webkit-transition: all 60ms ease-in;\n  -moz-transition: all 60ms ease-in;\n  -o-transition: all 60ms ease-in;\n  -ms-transition: all 60ms ease-in;\n  transition: all 60ms ease-in;\n\n  -webkit-touch-callout: none; /* iOS Safari */\n  -webkit-user-select: none; /* Chrome/Safari/Opera */\n  -khtml-user-select: none; /* Konqueror */\n  -moz-user-select: none; /* Firefox */\n  -ms-user-select: none; /* Internet Explorer/Edge */\n  user-select: none;\n}\n.rdtCounter .rdtBtn:hover {\n  background: #eee;\n  color: #797979;\n}\n.rdtCounter .rdtCount {\n  font-size: inherit;\n  line-height: 25px;\n}\n\n.rdtMilli {\n  vertical-align: middle;\n  padding-left: 8px;\n  width: 48px;\n}\n\n.rdtMilli input {\n  width: 100%;\n  font-size: inherit;\n  margin-top: 37px;\n}\n.rdtMonths,\n.rdtYears {\n  padding-bottom: 10px;\n  .rdtMonth,\n  .rdtYear {\n    display: inline-block;\n    width: 56px;\n    height: 56px;\n    line-height: 56px;\n    margin: 3px 3px;\n    cursor: pointer;\n    border-radius: 50%;\n    text-align: center;\n\n    &.rdtActive,\n    &.start-date,\n    &.end-date,\n    &.middle-date {\n      background-color: $info !important;\n      color: $white;\n    }\n  }\n}\n.input-group .input-group-prepend + .rdt .form-control {\n  border-top-left-radius: 0;\n  border-bottom-left-radius: 0;\n}\n.input-group .input-group-prepend + .rdt .form-control {\n  border-top-left-radius: 0;\n  border-bottom-left-radius: 0;\n}\n.input-group > .rdt:not(:last-child) .form-control {\n  border-top-right-radius: 0;\n  border-bottom-right-radius: 0;\n}\n\n.form-group .rdt {\n  width: 1%;\n  margin-bottom: 0;\n  flex: 1 1 auto;\n}\n",".btn {\n  .btn-inner--icon {\n    margin-right: 4px;\n  }\n}\n.btn + .btn {\n  margin-left: 4px;\n}\n","button:focus,\n:focus {\n  outline: none;\n}\n","@keyframes show-navbar-dropdown {\n  0% {\n    opacity: 0;\n    transition:\n      visibility 0.25s,\n      opacity 0.25s;\n  }\n  100% {\n    opacity: 1;\n  }\n}\n",".navbar .collapsing .navbar-toggler {\n  pointer-events: none;\n}\n.navbar .nav-item .nav-link-icon.nav-link i {\n  margin-right: 4px;\n}\n",".table {\n  .avatar-group .avatar {\n    margin-right: 4px;\n  }\n  .badge i {\n    margin-right: 10px;\n  }\n}\n",".s-table {\n  $sTable: &;\n\n  &--content-list {\n    tr {\n      &:last-child {\n        border-bottom: none !important;\n      }\n    }\n  }\n}\n",".u-max-width {\n  $uMaxWidth: &;\n\n  &--16 {\n    max-width: map-get($map: $values, $key: 16);\n  }\n}\n","// @use '../abstracts/maps' as *;\n\n.u-flex {\n  $uFlex: &;\n\n  &--16 {\n    flex: map-get($map: $values, $key: 0) map-get($map: $values, $key: 0)\n      map-get($map: $values, $key: 16);\n  }\n}\n","// @use '../abstracts/variables' as *;\n// @use '../abstracts/mixins' as *;\n\n.u-background {\n  $uBackground: &;\n\n  &--color-blue-1-1 {\n    background: $color-blue-1-1;\n  }\n}\n",".u-min-height {\n  $uMinHeight: &;\n\n  &--53 {\n    min-height: map-get($map: $values, $key: 53);\n  }\n}\n",".u-width {\n  $uWidth: &;\n\n  &--5-p {\n    width: map-get($map: $values, $key: \"5%\");\n  }\n  &--95-p {\n    width: map-get($map: $values, $key: \"95%\");\n  }\n}\n",".u-cursor {\n  $uCursor: &;\n\n  &--pointer {\n    cursor: pointer;\n  }\n}\n","$breakpoints: (\n  \"xs\": 0,\n  \"sm\": 576px,\n  \"md\": 768px,\n  \"lg\": 992px,\n  \"xl\": 1200px,\n  \"xxl\": 1600px,\n);\n\n@mixin xs {\n  @media (min-width: map-get($breakpoints, \"xs\")) {\n    @content;\n  }\n}\n@mixin sm {\n  @media (min-width: map-get($breakpoints, \"sm\")) {\n    @content;\n  }\n}\n@mixin md {\n  @media (min-width: map-get($breakpoints, \"md\")) {\n    @content;\n  }\n}\n@mixin lg {\n  @media (min-width: map-get($breakpoints, \"lg\")) {\n    @content;\n  }\n}\n@mixin xl {\n  @media (min-width: map-get($breakpoints, \"xl\")) {\n    @content;\n  }\n}\n@mixin xxl {\n  @media (min-width: map-get($breakpoints, \"xxl\")) {\n    @content;\n  }\n}\n\n\n\n@media all and (max-width: 1366px) {\n  ._u-font-size {\n    &--12 {\n      font-size: map-get($map: $values, $key: 12);\n    }\n  }\n}\n","@import \"../abstracts/variables\";\n@import \"../abstracts/mixins\";\n\n.normal-user {\n  .left-column {\n    .left-inner {\n      max-width: 749px;\n      padding-top: 70px;\n      padding-left: calc(81px - 15px);\n      padding-right: calc(81px - 15px);\n      padding-bottom: 130px;\n      @include devices(max-w-991px) {\n        padding-top: 35px;\n        // padding-left: calc(41px - 15px);\n        // padding-right: calc(41px - 15px);\n        padding-left: 16px;\n        padding-right: 16px;\n        padding-bottom: 65px;\n      }\n      .radio-btn-wrap {\n        @include devices(max-w-991px) {\n          justify-content: space-between;\n        }\n        .mr-18 {\n          margin-right: 18px;\n        }\n        .mr-10 {\n          margin-right: 10px;\n        }\n        p {\n          color: $dark-black;\n          font-size: 15px;\n          font-weight: 400;\n          line-height: 22.5px;\n        }\n      }\n    }\n    h2 {\n      font-size: 45px;\n      font-weight: 600;\n      line-height: 57px;\n      color: $dark-black;\n      span {\n        font-size: 18px;\n        font-weight: 400;\n        line-height: 27px;\n      }\n    }\n    .form-inputs {\n      .input-field {\n        .input-wrapper {\n          input {\n            color: #717171;\n            border: 0;\n            border-bottom: 1px solid #b1b1b1;\n            width: 100%;\n            background: transparent;\n            padding: 0 0 8px 0;\n          }\n          .toggle-password-btn {\n            border: 0;\n            border-bottom: 1px solid #b1b1b1;\n            background: transparent;\n            padding: 0;\n            margin: 0;\n            svg {\n              fill: $orange-color;\n            }\n          }\n        }\n      }\n      label {\n        color: $dark-black;\n        font-size: 15px;\n        font-weight: 400;\n        line-height: 22.5px;\n        .image-container {\n          margin-left: 8px;\n          width: 14px;\n          height: 14px;\n        }\n      }\n    }\n    .custom-checkbox {\n      display: flex;\n      align-items: center;\n      input[type=\"checkbox\"] {\n        position: absolute;\n        opacity: 0;\n        width: 0;\n        height: 0;\n      }\n      input[type=\"checkbox\"]:checked {\n        & + .custom-checkbox-box {\n          background-color: $orange-color;\n          border-color: $orange-color;\n          .checkbox-icon {\n            display: flex;\n          }\n        }\n      }\n      .custom-checkbox-box {\n        width: 18px;\n        height: 18px;\n        border: 1px solid $orange-color;\n        background: #fff;\n        display: flex;\n        align-items: center;\n        justify-content: center;\n        position: relative;\n        margin-right: 8px;\n        border-radius: 2px;\n        padding: 3px;\n        box-sizing: border-box;\n        transition: background-color 0.2s ease;\n        cursor: pointer;\n        margin-bottom: 0;\n      }\n      .checkbox-icon {\n        color: #fff;\n        font-size: 14px;\n        display: none;\n      }\n      .checkbox-label {\n        margin-left: 8px;\n        color: $dark-black;\n        .highlighted-text {\n          color: $orange-color;\n        }\n      }\n    }\n    .btn.bordered {\n      border: 1px solid $orange-color;\n      font-size: 18px;\n      font-weight: 500;\n      line-height: 27px;\n      cursor: pointer;\n      padding-top: 13px;\n      padding-bottom: 13px;\n      padding-left: 50px;\n      padding-right: 50px;\n      border-radius: 24.5px;\n      background: transparent;\n      outline: 0;\n      color: $orange-color;\n      box-shadow: none;\n    }\n    .btn.no-bordered.custom-btn-primary {\n      font-size: 18px;\n      font-weight: 500;\n      line-height: 27px;\n      cursor: pointer;\n      padding-top: 13px;\n      padding-bottom: 13px;\n      padding-left: 50px;\n      padding-right: 50px;\n      border-radius: 24.5px;\n      background: $orange-color;\n      border: 0;\n      outline: 0;\n      transition:\n        background-color 0.3s ease,\n        color 0.3s ease;\n      color: #fff;\n      box-shadow: none;\n      &:hover {\n        background: #cc9752;\n        box-shadow: none;\n      }\n    }\n    .signup-link {\n      p {\n        font-size: 14px;\n        line-height: 21px;\n        font-weight: 400;\n        color: $dark-black;\n      }\n      a {\n        font-weight: 500;\n        color: $orange-color;\n      }\n    }\n  }\n  .right-column {\n    img {\n      width: 100%;\n      height: 100%;\n      object-fit: cover;\n    }\n  }\n}\n","@mixin devices($breakpoints) {\n  @if $breakpoints == \"min-w-1681px-and-max-w-1889px\" {\n    @media all and (min-width: 1681px) and (max-width: 1889px) {\n      @content;\n    }\n  }\n  @if $breakpoints == \"min-w-1367px-and-max-w-1440px\" {\n    @media all and (min-width: 1367px) and (max-width: 1440px) {\n      @content;\n    }\n  }\n  @if $breakpoints == \"min-w-1366px-and-max-w-1440px\" {\n    @media all and (min-width: 1366px) and (max-width: 1440px) {\n      @content;\n    }\n  }\n  @if $breakpoints == \"max-w-1366px\" {\n    @media all and (max-width: 1366px) {\n      @content;\n    }\n  }\n  @if $breakpoints == \"max-w-1366px-and-max-h-640px\" {\n    @media all and (max-width: 1366px) and (max-height: 640px) {\n      @content;\n    }\n  }\n  @if $breakpoints == \"max-w-1366px-and-min-h-1024px\" {\n    @media all and (max-width: 1366px) and (min-height: 1024px) and (orientation: landscape) {\n      @content;\n    }\n  }\n  @if $breakpoints == \"max-w-1024px\" {\n    @media all and (max-width: 1024px) {\n      @content;\n    }\n  }\n  @if $breakpoints == \"max-w-1024px-and-min-h-768px\" {\n    @media all and (max-width: 1024px) and (min-height: 768px) and (orientation: landscape) {\n      @content;\n    }\n  }\n  @if $breakpoints == \"max-w-991px\" {\n    @media all and (max-width: 991px) {\n      @content;\n    }\n  }\n  @if $breakpoints == \"min-w-0px-and-max-w-991px\" {\n    @media all and (min-width: 0px) and (max-width: 991px) {\n      @content;\n    }\n  }\n  @if $breakpoints == \"min-w-768px-and-max-w-1024px\" {\n    @media all and (min-width: 768px) and (max-width: 1024px) and (orientation: portrait) {\n      @content;\n    }\n  }\n  @if $breakpoints == \"min-w-769px\" {\n    @media all and (min-width: 769px) {\n      @content;\n    }\n  }\n  @if $breakpoints == \"max-w-768px\" {\n    @media all and (max-width: 768px) {\n      @content;\n    }\n  }\n  @if $breakpoints == \"max-w-576px\" {\n    @media all and (max-width: 576px) {\n      @content;\n    }\n  }\n  @if $breakpoints == \"min-w-0px-and-max-w-414px\" {\n    @media all and (min-width: 0px) and (max-width: 414px) {\n      @content;\n    }\n  }\n  @if $breakpoints == \"max-w-375px\" {\n    @media all and (max-width: 375px) {\n      @content;\n    }\n  }\n}\n",".radio-button-container {\n  .custom-radio-input {\n    display: none;\n    &:checked + .custom-radio-label {\n      border: 2px solid $orange-color;\n      background-color: transparent;\n      box-shadow: none;\n      .radio-button-text {\n        color: $orange-color;\n      }\n      .outer-circle {\n        .inner-circle {\n          background-color: $orange-color;\n        }\n      }\n    }\n  }\n  .custom-radio-label {\n    max-width: fit-content;\n    display: flex;\n    align-items: center;\n    background-color: #fff;\n    border: 2px solid transparent;\n    border-radius: 24.5px;\n    padding: 10px 32px;\n    box-shadow: 0 2px 4px rgba(127, 17, 224, 0.2);\n    cursor: pointer;\n    transition: all 0.2s ease;\n    margin-bottom: 0;\n    .radio-button {\n      .outer-circle {\n        display: flex;\n        align-items: center;\n        justify-content: center;\n        width: 20px;\n        height: 20px;\n        border: 2px solid #cc9752;\n        border-radius: 50%;\n        margin-right: 8px;\n        position: relative;\n        transition: border-color 0.2s ease;\n        .inner-circle {\n          width: 10px;\n          height: 10px;\n          border-radius: 50%;\n          background-color: transparent;\n          transition: background-color 0.2s ease;\n        }\n      }\n    }\n    .radio-button-text {\n      font-size: 15px;\n      font-weight: 400;\n      line-height: 22.5px;\n      color: $grey-color;\n    }\n    &:hover,\n    &:active {\n      border: 2px solid $orange-color;\n      background-color: transparent;\n      box-shadow: none;\n      .radio-button-text {\n        color: $orange-color;\n      }\n    }\n  }\n}\n","@import \"../abstracts/variables\";\n@import \"../abstracts/mixins\";\n\n.password-strength-container {\n  gap: 10px;\n  .password-strength-indicator {\n    gap: 5px;\n    label {\n      display: flex;\n      margin-bottom: 0;\n    }\n    .line {\n      width: 40px;\n      height: 5px;\n      border-radius: 2px;\n      background-color: $biege-color;\n      transition: background-color 0.3s;\n      margin-left: 5px;\n\n      width: 40px;\n      height: 5px;\n      border-radius: 2px;\n      background-color: #c6bdaf; /* Default color */\n      transition: background-color 0.3s;\n      &.filled {\n        background-color: $green-color;\n      }\n    }\n    .strength-text {\n      font-weight: normal;\n      color: $green-color;\n    }\n  }\n}\n","@import \"../abstracts/variables\";\n\n.progress-container {\n  padding: 45px 33px;\n  .step-wrapper {\n    z-index: 1;\n    position: relative;\n    margin-top: -21px;\n    ul {\n      list-style-type: none;\n      display: flex;\n      li {\n        display: flex;\n        flex-direction: column;\n        align-items: center;\n        width: 236px;\n        text-align: center;\n        position: relative;\n        &::after {\n          content: \"\";\n          position: absolute;\n          width: 100%;\n          height: 2px;\n          background-color: $light-grey;\n          top: 24%;\n          left: -50%;\n          z-index: -1;\n        }\n        &:first-child::after {\n          content: none;\n        }\n        .icon {\n          width: 40px;\n          height: 40px;\n          background-color: #f9f5ef;\n          border: 1px solid $grey-color;\n          outline: 5px solid #f9f5ef;\n          border-radius: 50%;\n          display: flex;\n          justify-content: center;\n          align-items: center;\n          span {\n            width: 100%;\n            height: 100%;\n            display: flex;\n            justify-content: center;\n            align-items: center;\n            svg {\n              width: 14px;\n              height: auto;\n            }\n          }\n        }\n        .text {\n          color: $grey-color;\n        }\n        &.active {\n          &::after {\n            background-color: $dark-green;\n          }\n          .icon {\n            background-color: $dark-green;\n            span {\n              svg {\n                stroke: $bg-white;\n              }\n            }\n          }\n          .text {\n            color: $dark-green;\n          }\n        }\n        &:nth-child(1) {\n          .icon {\n            span {\n              svg {\n                fill: $bg-white;\n              }\n            }\n          }\n        }\n      }\n    }\n  }\n}\n","@import \"../abstracts/variables\";\n\n.dob-picker-container {\n  h2.react-datepicker__current-month {\n    font-size: 16px;\n  }\n  .dob-picker-label {\n    display: block;\n  }\n  .dob-picker-input-wrapper {\n    position: relative;\n    .react-datepicker-wrapper {\n      width: 100%;\n      .dob-picker-input {\n        background: transparent;\n        color: $grey-color;\n        border: 0;\n        border-bottom: 1px solid #b1b1b1;\n        width: 100%;\n        background: transparent;\n        padding: 0 0 8px 0;\n      }\n    }\n    .dob-picker-icon {\n      position: absolute;\n      right: 0;\n      top: 45%;\n      transform: translateY(-50%);\n      font-size: 18px;\n      cursor: pointer;\n    }\n    svg {\n      fill: $orange-color;\n    }\n  }\n}\n","@import \"../abstracts/variables\";\n\n.dropdown-custom {\n  display: flex;\n  flex-direction: column;\n  width: 200px;\n  .dropdown-title-custom {\n    color: $dark-black;\n    font-size: 15px;\n    font-weight: 400;\n    line-height: 22.5px;\n  }\n  .dropdown-container-custom {\n    position: relative;\n    display: flex;\n    align-items: center;\n    cursor: pointer;\n    background: transparent;\n    color: $grey-color;\n    border: 0;\n    border-bottom: 1px solid #b1b1b1;\n    width: 100%;\n    background: transparent;\n    padding: 0 0 8px 0;\n    .dropdown-selected-custom {\n      flex: 1;\n    }\n    .dropdown-arrow {\n      margin-left: 8px;\n      width: 18px;\n      height: 18px;\n      svg {\n        width: 18px;\n        height: 18px;\n        fill: $darken-grey;\n      }\n    }\n  }\n\n  .dropdown-menu-custom {\n    position: absolute;\n    top: 40px;\n    left: 0;\n    right: 0;\n    border: 1px solid #ccc;\n    border-top: none;\n    background-color: #fff;\n    box-shadow: 0px 4px 8px rgba(0, 0, 0, 0.1);\n    border-radius: 4px;\n    z-index: 1000;\n    width: 100%;\n\n    .dropdown-option-custom {\n      padding: 8px;\n      cursor: pointer;\n\n      &:hover {\n        background-color: #f0f0f0;\n      }\n    }\n  }\n}\n","@import \"../abstracts/variables\";\n\n.dropdown-numbers {\n  display: flex;\n  flex-direction: column;\n  // width: 100;\n  .dropdown-title-custom {\n    color: $dark-black;\n    font-size: 15px;\n    font-weight: 400;\n    line-height: 22.5px;\n  }\n  .dropdown-container-custom {\n    position: relative;\n    display: flex;\n    align-items: center;\n    cursor: pointer;\n    background: transparent;\n    color: $grey-color;\n    border: 0;\n    border-bottom: 1px solid #b1b1b1;\n    width: 100%;\n    background: transparent;\n    padding: 0 0 8px 0;\n    .input {\n      width: 100%;\n      cursor: text;\n      input {\n        width: 100%;\n        cursor: text;\n      }\n    }\n    .dropdown-selected-custom {\n      flex: 1;\n    }\n    .dropdown-arrow {\n      margin-left: 0;\n      width: 18px;\n      height: 18px;\n      svg {\n        width: 18px;\n        height: 18px;\n        fill: $darken-grey;\n      }\n    }\n  }\n\n  .dropdown-menu-custom {\n    position: absolute;\n    top: 100%;\n    left: 0;\n    right: 0;\n    border: 1px solid #ccc;\n    border-top: none;\n    background-color: #fff;\n    box-shadow: 0px 4px 8px rgba(0, 0, 0, 0.1);\n    border-radius: 4px;\n    z-index: 1000;\n\n    .dropdown-option-custom {\n      padding: 8px;\n      cursor: pointer;\n\n      &:hover {\n        background-color: #f0f0f0;\n      }\n    }\n  }\n}\n\ninput[type=\"number\"]::-webkit-inner-spin-button,\ninput[type=\"number\"]::-webkit-outer-spin-button,\ninput[type=\"number\"] {\n  -webkit-appearance: none;\n  -moz-appearance: textfield;\n  margin: 0;\n  border: 0;\n  outline: 0;\n  box-shadow: none;\n  background-color: transparent;\n  cursor: default;\n}\n","@import \"../abstracts/variables\";\n\n.upload-btn {\n  .title {\n    font-size: 15px;\n    font-weight: 400;\n    line-height: 22.5px;\n    text-align: left;\n    color: $dark-black;\n  }\n  .upload-box {\n    background-image: repeating-linear-gradient(\n        0deg,\n        #beb5a6,\n        #beb5a6 6px,\n        transparent 6px,\n        transparent 12px,\n        #beb5a6 12px\n      ),\n      repeating-linear-gradient(\n        90deg,\n        #beb5a6,\n        #beb5a6 6px,\n        transparent 6px,\n        transparent 12px,\n        #beb5a6 12px\n      ),\n      repeating-linear-gradient(\n        180deg,\n        #beb5a6,\n        #beb5a6 6px,\n        transparent 6px,\n        transparent 12px,\n        #beb5a6 12px\n      ),\n      repeating-linear-gradient(\n        270deg,\n        #beb5a6,\n        #beb5a6 6px,\n        transparent 6px,\n        transparent 12px,\n        #beb5a6 12px\n      );\n    background-size:\n      2px 100%,\n      100% 2px,\n      2px 100%,\n      100% 2px;\n    background-position:\n      0 0,\n      0 0,\n      100% 0,\n      0 100%;\n    background-repeat: no-repeat;\n    border-radius: 4px;\n    .upload-wrapper {\n      position: relative;\n      svg {\n        width: 22px;\n        height: 22px;\n        stroke: $orange-color;\n      }\n      p {\n        span {\n          color: $dark-black;\n        }\n      }\n      input.hidden-file {\n        opacity: 0;\n        width: 1005;\n        height: 100%;\n        position: absolute;\n        top: 0;\n        left: 0;\n        cursor: pointer;\n      }\n    }\n    .signature-wrap {\n      .container {\n        max-height: 108px;\n      }\n      canvas {\n        width: 100%;\n        height: 100%;\n      }\n    }\n  }\n}\n","@import \"../abstracts/variables\";\n\n.popup-container {\n  position: fixed;\n  top: 0;\n  left: 0;\n  left: 0;\n  bottom: 0;\n  width: 100vw;\n  height: 100%;\n  background: rgba($color: #000000, $alpha: 0.5);\n  z-index: 1000;\n  .close {\n    position: absolute;\n    top: 24px;\n    right: 34px;\n    opacity: 1;\n    svg {\n      width: 34px;\n      height: 34px;\n      stroke: $dark-black;\n      cursor: pointer;\n    }\n  }\n  .popupWrapper {\n    max-width: 525px;\n    max-height: 422px;\n    border-radius: 10px;\n    background-color: $bg-white;\n    position: relative;\n    .popup {\n      .icon {\n        background-color: $dark-green;\n        width: 54px;\n        height: 54px;\n        border-radius: 50%;\n        box-sizing: border-box;\n        svg {\n          stroke: $bg-white;\n        }\n      }\n      h2 {\n        font-size: 28px;\n        font-weight: 700;\n        line-height: 42px;\n        text-align: center;\n        color: $dark-green;\n      }\n      .light-text {\n        font-size: 15px;\n        font-weight: 400;\n        line-height: 26px;\n        color: $grey-color;\n        text-align: center;\n      }\n      .dark-text {\n        max-width: 427px;\n        font-size: 15px;\n        font-weight: 400;\n        line-height: 26px;\n        color: $dark-black;\n        text-align: center;\n      }\n      .btn.no-bordered.custom-btn-primary {\n        max-width: 318px;\n        font-size: 18px;\n        font-weight: 500;\n        line-height: 27px;\n        cursor: pointer;\n        padding-top: 13px;\n        padding-bottom: 13px;\n        // padding-left: 50px;\n        // padding-right: 50px;\n        border-radius: 24.5px;\n        background: $orange-color;\n        border: 0;\n        outline: 0;\n        transition:\n          background-color 0.3s ease,\n          color 0.3s ease;\n        color: #fff;\n        box-shadow: none;\n        display: flex;\n        justify-content: center;\n        align-items: center;\n        &:hover {\n          background: #cc9752;\n          box-shadow: none;\n        }\n      }\n      .signup-link {\n        p {\n          font-size: 14px;\n          line-height: 21px;\n          font-weight: 400;\n          color: $dark-black;\n        }\n        a {\n          font-weight: 500;\n          color: $orange-color;\n        }\n      }\n    }\n  }\n}\n","@import \"../components/progress-bar\";\n@import \"../components/date-picker\";\n@import \"../components/dropdown-custom\";\n@import \"../components/dropdown-numbers\";\n@import \"../components/upload-btn\";\n@import \"../components/popus\";\n\n.normal-user.signup-user {\n  .left-column {\n    .left-inner {\n      padding-bottom: 70px;\n      h3 {\n        font-size: 18px;\n        font-weight: 600;\n        line-height: 27px;\n        color: $dark-black;\n      }\n      .sub-head {\n        font-size: 15px;\n        font-weight: 600;\n        line-height: 22.5px;\n        color: $darken-grey;\n      }\n      .mdl {\n        padding-left: 15px;\n        padding-right: 15px;\n        margin-top: 35px;\n      }\n    }\n    .form-inputs {\n      .input-field {\n        .input-wrapper {\n          input[type=\"date\"]::-webkit-calendar-picker-indicator {\n            visibility: visible;\n            opacity: 0;\n          }\n          position: relative;\n          .date-btn {\n            border: 0;\n            // border-bottom: 1px solid #B1B1B1;\n            background: transparent;\n            padding: 0;\n            margin: 0;\n\n            position: absolute;\n            right: 0;\n            top: 0;\n            font-size: 18px;\n            pointer-events: none;\n            cursor: pointer;\n            svg {\n              fill: $orange-color;\n            }\n          }\n        }\n      }\n    }\n  }\n}\n",".bordered {\n  border: 1px solid $orange-color;\n  font-size: 16px;\n  font-weight: 500;\n  line-height: 27px;\n  cursor: pointer;\n  padding-top: 13px;\n  padding-bottom: 13px;\n  padding-left: 38px;\n  padding-right: 38px;\n  border-radius: 24.5px;\n  background: transparent;\n  outline: 0;\n  color: $orange-color;\n  box-shadow: none;\n  &:hover {\n    background: #cc9752;\n    box-shadow: none;\n    color: $bg-white;\n  }\n}\n.no-bordered {\n  font-size: 16px;\n  font-weight: 500;\n  line-height: 27px;\n  cursor: pointer;\n  padding-top: 13px;\n  padding-bottom: 13px;\n  padding-left: 20px;\n  padding-right: 20px;\n  border-radius: 24.5px;\n  background: $orange-color;\n  border: 0;\n  outline: 0;\n  transition:\n    background-color 0.3s ease,\n    color 0.3s ease;\n  color: $bg-white;\n  box-shadow: none;\n  &:hover {\n    background: #cc9752;\n    box-shadow: none;\n    color: $bg-white;\n  }\n}\n",".update {\n  border: 0;\n  outline: 0;\n  background-color: transparent;\n  padding: 0;\n  p {\n    font-size: 15px;\n    font-weight: 500;\n    line-height: 22.5px;\n    color: $orange-color;\n  }\n  svg {\n    width: 14px;\n    height: 14px;\n    fill: $orange-color;\n  }\n}\n",".dashboard-sidebar {\n  background-color: $dark-green;\n  max-width: 258px;\n  position: fixed;\n  width: 258px;\n  height: 100vh;\n  padding-top: 30px;\n  transition: 0.5s all;  \n  .logo {\n    img {\n      max-width: 123px;\n    }\n  }\n  .dashboard-items {\n    height: 100%;\n    overflow-y: auto;\n    ul {\n      li {\n        position: relative;\n        height: 55px;\n        cursor: pointer;\n        color: $bg-white;\n        p {\n          font-size: 15px;\n          font-weight: 400;\n          line-height: 24px;\n        }\n        svg {\n          stroke: $light-beige;\n          stroke: #eed7b9;\n          width: 16px;\n          height: 16px;\n        }\n        .drop-icon {\n          width: 20px;\n          height: 20px;\n          position: absolute;\n          top: 18px;\n          right: 5px;\n        }\n        &:hover {\n          background-color: $green-shade;\n          svg {\n            stroke: $bg-white;\n          }\n        }\n        &.active {\n          background-color: $green-shade;\n          svg {\n            stroke: $bg-white;\n          }\n          ul.sub-menu {\n            display: block;\n            margin-top: 10px;\n          }\n        }\n        ul.sub-menu {\n          display: none;\n          li {\n            color: $green-color-shade-light;\n            background-color: transparent;\n            padding: 0;\n            height: auto;\n            padding: 10px 0;\n            p {\n              font-size: 13px;\n              font-weight: 400;\n              line-height: 19.5px;\n            }\n            &.active {\n              font-size: 13px;\n              font-weight: 400;\n              line-height: 19.5px;\n              color: $bg-white;\n            }\n          }\n        }\n      }\n    }\n  }\n  .expand-btn {\n    position: absolute;\n    top: 0;\n    right: 0;\n    background-color: transparent !important;\n    padding: 0;\n    border: none;\n    font-size: 26px;\n    box-shadow: none;\n    color: #fff !important;\n    &:active {\n      color: #fff;\n      background-color: transparent;\n      border-color: none;\n    }\n  }\n  &.halfsidebar {\n    .dashboard-items {\n      ul {\n        li {\n          &.active {\n            ul.sub-menu {\n              margin-top: 5px;\n              li {\n                padding: 5px 0 !important;\n                p {\n                  display: block;\n                  visibility: visible;\n                  padding-left: 0 !important;\n                  text-align: center;\n                }\n              }\n            }\n          }\n        }\n      }\n    }\n  }\n}\n","@import \"../abstracts/variables\";\n\n.topbar {\n  .left {\n    font-size: 25px;\n    font-weight: 600;\n    line-height: 37.5px;\n    color: $dark-black;\n  }\n  .right {\n    .wallet > svg {\n      width: 18px;\n      height: 18px;\n      stroke: $dark-black;\n    }\n    .notified {\n      position: relative;\n      &::after {\n        content: \"\";\n        width: 6px;\n        height: 6px;\n        border-radius: 50%;\n        background-color: $color-red;\n        position: absolute;\n        top: 5px;\n        right: 3px;\n        border: 1px solid $bg-white;\n      }\n      svg {\n        width: 18px;\n        height: 18px;\n        fill: $dark-black;\n      }\n    }\n    .user {\n      cursor: pointer;\n      .user-pic {\n        width: 34px;\n        height: 34px;\n        border-radius: 50%;\n        border: 2px solid $dark-green;\n        overflow: hidden;\n        img {\n          //     object-fit: contain;\n          //     width: 100%;\n          //     filter: grayscale(100%);\n          // }\n          object-fit: cover;\n          width: 30px;\n          height: 30px;\n        }\n      }\n      p {\n        font-size: 13px;\n        font-weight: 400;\n        line-height: 24px;\n        color: $dark-black;\n      }\n      .icon {\n        stroke: $darken-grey;\n        width: 36px;\n        height: 20px;\n      }\n    }\n  }\n}\n",".user-bar {\n  background-color: $light-yellow;\n  border-radius: 4px;\n  .title {\n    font-size: 20px;\n    font-weight: 400;\n    line-height: 30px;\n    color: $dark-black;\n    span {\n      font-weight: 600;\n    }\n  }\n  .item {\n    margin: 0 10px 10px 0;\n    @include md {\n      margin:0;\n    }\n    .title {\n      font-size: 13px;\n      font-weight: 400;\n      line-height: 19.5px;\n      text-align: left;\n      color: $grey-color;\n    }\n    .text {\n      font-size: 15px;\n      font-weight: 600;\n      line-height: 22.5px;\n      color: $dark-black;\n    }\n    .text.email {\n      color: $orange-color;\n      font-weight: 400;\n    }\n\n    // &:not(:last-child){\n    //     margin-right: 67px;\n    // }\n  }\n  .buttons {\n    .bordered,\n    .thick-border {\n      font-size: 14px;\n      font-weight: 500;\n      width: 141px;\n      padding: 8px 0;\n      border: 2px solid $orange-color;\n    }\n    .no-bordered {\n      font-size: 15px;\n      font-weight: 500;\n      width: 159px;\n      padding-left: 0;\n      padding-right: 0;\n    }\n  }\n}\n",".card-box {\n  border-radius: 4px;\n  @include md {\n    max-width: 360px;\n  }\n  &.shade-green {\n    background-color: $shade-green;\n  }\n  &.shade-blue {\n    background-color: $shade-blue;\n  }\n  .date-dropdown {\n    .date-btn {\n      position: relative;\n      input {\n        width: 20px;\n        height: 20px;\n        position: absolute;\n        top: 4px;\n        right: 0;\n        opacity: 0;\n      }\n      .date-output {\n        p {\n          color: $bg-white;\n          font-size: 13px;\n          font-weight: 500;\n          line-height: 19.5px;\n        }\n        svg {\n          fill: $bg-white;\n          width: 18px;\n          height: 18px;\n          cursor: pointer;\n        }\n      }\n    }\n  }\n  .title {\n    font-size: 14px;\n    font-weight: 400;\n    line-height: 21px;\n    color: $bg-white;\n  }\n  .content {\n    font-size: 30px;\n    font-weight: 700;\n    line-height: 1.2;\n    color: $bg-white;\n    @include lg {\n      font-size: 40px;\n      line-height: 1.5;\n    }\n  }\n}\n",".chart-graph {\n  .chart-inner {\n    box-shadow: 0px 2px 8px 0px rgba(156, 156, 156, 0.25);\n    border-radius: 5px;\n    padding-top: 20px;\n    padding-bottom: 20px;\n    .title {\n      font-size: 16px;\n      font-weight: 400;\n      line-height: 24px;\n      color: $dark-black;\n    }\n    .ammount {\n      font-size: 28px;\n      font-weight: 700;\n      line-height: 42px;\n      color: $dark-green;\n    }\n    .recharts-responsive-container {\n      .recharts-wrapper {\n        .recharts-surface {\n          width: unset !important;\n          max-height: 178px;\n          overflow: visible;\n          .recharts-rectangle {\n            pointer-events: none;\n            fill: transparent;\n            &:hover {\n              fill: transparent;\n            }\n          }\n          .recharts-cartesian-grid {\n          }\n          .recharts-layer {\n            line {\n              display: none;\n            }\n            .recharts-cartesian-axis-ticks {\n              .recharts-layer {\n                text {\n                  font-size: 12px;\n                  font-weight: 300;\n                  line-height: 18px;\n                  color: $grey-shade;\n                }\n              }\n            }\n            .xAxisLabel {\n              fill: $grey-shade-three;\n              font-size: 13px;\n              font-weight: 400;\n              line-height: 19.5px;\n              text-anchor: middle;\n              transform-origin: 332px 210px;\n              transform: rotate(0deg);\n            }\n            .yAxisLabel {\n              fill: $grey-shade-three;\n              font-size: 13px;\n              font-weight: 400;\n              line-height: 19.5px;\n              transform: rotate(-90deg);\n              transform-origin: 29px 102px;\n              text-anchor: middle;\n            }\n          }\n        }\n      }\n    }\n  }\n}\n","/* src/DatePicker.css */\n.datepicker {\n  position: relative;\n  display: inline-block;\n  font-family: Arial, sans-serif;\n}\n\n.datepicker-display {\n  display: flex;\n  align-items: center;\n  cursor: pointer;\n  padding: 10px;\n  border: 1px solid #ccc;\n  border-radius: 4px;\n  background-color: #fff;\n}\n\n.dropdown-icon {\n  margin-left: 8px;\n  color: #333;\n}\n\n.datepicker-calendar {\n  position: absolute;\n  top: 100%;\n  left: 0;\n  width: 100%;\n  border: 1px solid #ccc;\n  border-radius: 4px;\n  background-color: #fff;\n  z-index: 1000;\n  padding: 10px;\n}\n",".dashboard-drop {\n  .dropdown-container-custom {\n    border: 2px solid #d9d9d9;\n    border-radius: 500px;\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    padding: 10px 20px;\n    box-sizing: border-box;\n    max-width: 169px;\n    font-size: 13px;\n    font-weight: 400;\n    line-height: 19.5px;\n    color: $grey-color;\n    .dropdown-arrow {\n      display: flex;\n      align-items: center;\n    }\n  }\n}\n",".dashboard-table {\n  .dashboard-table-title {\n    p {\n      font-size: 25px;\n      font-weight: 600;\n      line-height: 37.5px;\n      color: $dark-black;\n    }\n  }\n  .search-group {\n    border: 0;\n    border-bottom: 1px solid $grey-color;\n    @include xl {\n      max-width: 309px;\n    }\n    svg {\n      width: 13px;\n      height: 13px;\n    }\n    input {\n      border: 0;\n      outline: 0;\n      box-shadow: none;\n      width: calc(100% - 13px);\n      height: 100%;\n      font-size: 13px;\n      font-weight: 400;\n      line-height: 19.5px;\n      color: $grey-shade-four;\n      &:focus {\n        outline: 0;\n        box-shadow: 0;\n      }\n    }\n  }\n  .sort {\n    img {\n    }\n    label {\n      font-size: 13px;\n      font-weight: 400;\n      line-height: 23px;\n      color: $dark-black;\n    }\n    .dark-text {\n        // .dropdown-title {\n        //   display: none;\n        // }\n      .dropdown-container-custom {\n        padding: 8px 15px;\n        .dropdown-selected-custom {\n          font-size: 13px;\n          font-weight: 700;\n          line-height: 23px;\n          color: $dark-black;\n        }\n      }\n      max-width: fit-content;\n    }\n  }\n  .btn-teller {\n    .no-bordered {\n      width: 119px;\n      padding-left: 26px;\n      padding-right: 26px;\n      font-size: 13px;\n      line-height: 19.5px;\n      font-weight: 500;\n    }\n  }\n  .table {\n    thead {\n      -webkit-box-shadow: 0px 2px 9px 0px rgba(154, 154, 154, 0.25);\n      -moz-box-shadow: 0px 2px 9px 0px rgba(154, 154, 154, 0.25);\n      box-shadow: 0px 2px 9px 0px rgba(154, 154, 154, 0.25);\n      th {\n        text-align: center;\n        font-size: 15px;\n        font-weight: 600;\n        line-height: 22.5px;\n        color: $dark-black;\n        text-transform: capitalize;\n      }\n    }\n    tbody {\n      tr {\n        border-bottom: 1px solid $light-grey-shade;\n        td {\n          text-align: center;\n          font-size: 15px;\n          font-weight: 400;\n          line-height: 22.5px;\n          color: $dark-black;\n          vertical-align: middle;\n          border-top:none;\n          padding: 10px;\n          &.green-color {\n            color: $green-shade-two;\n          }\n          &.grey-color {\n            color: $grey-color;\n          }\n          svg {\n            width: 17px;\n            height: 17px;\n          }\n          &.text-center {\n            text-align: center;\n            display: flex;\n            justify-content: center;\n          }\n          &.action {\n            button {\n              border: 0;\n              outline: 0;\n              background-color: transparent;\n              cursor: pointer;\n              &:nth-child(2) {\n                margin-left: 4px;\n              }\n            }\n          }\n        }\n      }\n    }\n  }\n  .teller-table {\n    img.name-img {\n      width: 31px;\n      height: 31px;\n    }\n    .colored {\n      color: $orange-color;\n    }\n  }\n}\n",".btn-status {\n  border-radius: 500px;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  padding: 7px 21px;\n  max-width: 126px;\n  min-width: 126px;\n  cursor: pointer;\n  &.btn-green {\n    border: 1px solid $green-shade-three;\n    background-color: $green-shade-four;\n    color: $green-shade-five;\n  }\n  &.btn-red {\n    border: 1px solid $red-shade-one;\n    background-color: $red-shade-two;\n    color: $red-shade-one;\n  }\n  &.btn-orange {\n    border: 1px solid $orange-color;\n    background-color: $orange-color-shade-two;\n    color: $orange-color;\n  }\n  &.btn-olive {\n    border: 1px solid $olive-color;\n    background-color: $light-olive-color;\n    color: $olive-color;\n  }\n}\n",".pagination {\n  display: flex;\n  justify-content: flex-end;\n  .paginate-inner {\n    display: flex;\n    justify-content: flex-end;\n    button.paginateButton {\n      background-color: transparent;\n      cursor: pointer;\n      width: 30px;\n      height: 30px;\n      border: 0;\n      outline: 0;\n      display: flex;\n      justify-content: center;\n      align-items: center;\n      color: $dark-black;\n      &.active {\n        background-color: $orange-color;\n        width: 30px;\n        height: 30px;\n        border-radius: 3px;\n        color: $bg-white;\n      }\n      svg {\n        &.orange-class {\n          fill: $orange-color;\n        }\n        &.grey-class {\n          fill: $grey-color;\n        }\n      }\n    }\n  }\n}\n",".form-inputs {\n  .input-field {\n    .input-wrapper {\n      input {\n        color: #717171;\n        border: 0;\n        border-bottom: 1px solid #b1b1b1;\n        width: 100%;\n        background: transparent;\n        padding: 0 0 8px 0;\n      }\n      .toggle-password-btn {\n        border: 0;\n        border-bottom: 1px solid #b1b1b1;\n        background: transparent;\n        padding: 0;\n        margin: 0;\n        svg {\n          fill: $orange-color;\n        }\n      }\n    }\n  }\n  label {\n    color: $dark-black;\n    font-size: 15px;\n    font-weight: 400;\n    line-height: 22.5px;\n    .image-container {\n      margin-left: 8px;\n      width: 14px;\n      height: 14px;\n    }\n  }\n}\n",".card-number-input {\n  label {\n    margin-bottom: 0;\n  }\n  .card-number-fields {\n    input {\n      border: 0;\n      outline: 0;\n      border-bottom: 1px solid $green-shade-six;\n      border-radius: 0;\n      text-align: center;\n      padding-bottom: 9px;\n      padding-top: 0;\n      font-size: 14px;\n      font-weight: 400;\n      line-height: 21px;\n      letter-spacing: 3px;\n      color: $grey-color;\n      background: transparent;\n      &:not(:last-child) {\n        margin-right: 16px;\n      }\n      &::placeholder {\n        color: $grey-color;\n        font-size: 14px;\n      }\n    }\n  }\n}\n","@import \"./inputField\";\n@import \"./card-input\";\n\n.recharge-account {\n  padding-left: 15px;\n  padding-right: 15px;\n  // &.container{\n  //     max-width: 986px;\n  // }\n  .tabs {\n    border-bottom: 1px solid $grey-shade-seven;\n    padding-top: 20px;\n    button {\n      border: 0;\n      outline: 0;\n      background-color: transparent;\n      font-size: 15px;\n      font-weight: 400;\n      line-height: 22.5px;\n      color: $grey-color;\n      &.active {\n        color: $grey-color;\n        color: $orange-color;\n        font-weight: 500;\n      }\n    }\n  }\n  .recharge-bar {\n    background-color: $light-yellow;\n    border-radius: 4px;\n    padding: 24px 33px;\n    .item {\n      .title {\n        font-size: 20px;\n        font-weight: 600;\n        line-height: 30px;\n        color: $dark-black;\n      }\n      .text {\n        font-size: 13px;\n        font-weight: 400;\n        line-height: 19.5px;\n        color: $grey-color;\n      }\n    }\n    .buttons {\n      .price {\n        font-size: 30px;\n        font-weight: 700;\n        line-height: 45px;\n        color: $dark-green;\n        margin-right: 26px;\n      }\n      .bordered,\n      .thick-border {\n        font-size: 15px;\n        font-weight: 500;\n        width: 141px;\n        padding-left: 0;\n        padding-right: 0;\n        border: 2px solid $orange-color;\n      }\n      .no-bordered {\n        font-size: 15px;\n        font-weight: 500;\n        width: 159px;\n        padding-left: 0;\n        padding-right: 0;\n      }\n    }\n  }\n  .recharge-form {\n    box-shadow: 0px 2px 8px 0px rgb(156, 156, 156, 0.25);\n    border: 1px solid #e3e3e3;\n    padding: 40px;\n    box-sizing: border-box;\n    border-radius: 5px;\n    margin-top: 29px;\n    p.title {\n      font-size: 20px;\n      font-weight: 600;\n      line-height: 30px;\n      color: $dark-black;\n    }\n    .methods {\n      padding-top: 32px;\n      p {\n        font-size: 15px;\n        font-weight: 400;\n        line-height: 22.5px;\n        color: $grey-shade-eight;\n      }\n      .recharge-radio {\n        .radio-button {\n          .outer-circle {\n            border: 1px solid $grey-color;\n            &.checked {\n              border: 1px solid $orange-color;\n            }\n          }\n        }\n      }\n      .green-box {\n        background-color: $green-shade-seven;\n        padding: 33px;\n        padding-bottom: 44px;\n        border-radius: 5px;\n        margin-top: 32px;\n        .sub-title {\n          font-size: 18px;\n          font-weight: 600;\n          line-height: 27px;\n          color: $dark-black;\n        }\n        input {\n          font-size: 13px;\n          font-weight: 300;\n          line-height: 19.5px;\n          color: $grey-color;\n          border-bottom: 1px solid $green-shade-six;\n        }\n        .left {\n          // max-width: 655px;\n          max-width: 75%;\n        }\n        .right {\n          // max-width: 278px;\n          max-width: 25%;\n          .date-picker {\n            label {\n              color: $dark-black;\n              font-size: 15px;\n              font-weight: 400;\n              line-height: 22.5px;\n            }\n            .date-input {\n              position: relative;\n              border-bottom: 1px solid $green-shade-six;\n              .react-datepicker-wrapper {\n                width: 100%;\n                height: 100%;\n                input {\n                  font-size: 13px;\n                  font-weight: 300;\n                  line-height: 19.5px;\n                  color: $grey-color;\n                  border: 0;\n                  outline: 0;\n                  width: 100%;\n                  height: 100%;\n                  padding-bottom: 9px;\n                  background-color: transparent;\n                }\n              }\n              svg {\n                width: 16px;\n                height: 16px;\n                position: absolute;\n                top: 0;\n                right: 0;\n              }\n            }\n          }\n        }\n      }\n    }\n    .buttons {\n      margin-top: 33px;\n    }\n  }\n  .faded {\n    font-size: 15px;\n    font-weight: 400;\n    line-height: 22.5px;\n    color: $grey-color;\n  }\n  .pagination {\n    display: flex;\n    justify-content: flex-end;\n    .paginate-inner {\n      display: flex;\n      justify-content: flex-end;\n      button.paginateButton {\n        background-color: transparent;\n        cursor: pointer;\n        width: 30px;\n        height: 30px;\n        border: 0;\n        outline: 0;\n        display: flex;\n        justify-content: center;\n        align-items: center;\n        color: $dark-black;\n        &.active {\n          background-color: $orange-color;\n          width: 30px;\n          height: 30px;\n          border-radius: 3px;\n          color: $bg-white;\n        }\n        svg {\n          &.orange-class {\n            fill: $orange-color;\n          }\n          &.grey-class {\n            fill: $grey-color;\n          }\n        }\n      }\n    }\n  }\n}\n.tabs button.active {\n  border-bottom: 3px solid #cc9752;\n}",".sidebar-items {\n  ul {\n    li {\n      padding: 20px 18px;\n      cursor: pointer;\n      border-bottom: 1px solid $light-grey-shade;\n      p {\n        font-size: 15px;\n        font-weight: 400;\n        line-height: 22.5px;\n        color: $grey-color;\n      }\n      &.active {\n        background-color: $light-beige;\n        border-radius: 3px;\n        border-bottom: 1px solid transparent;\n        p {\n          font-weight: 500;\n          color: $dark-black;\n        }\n      }\n    }\n  }\n}\n",".general-information {\n  .profile-box {\n    border-radius: 5px;\n    box-shadow: 0px 4px 30px 0px rgba(0, 0, 0, 0.08);\n    border: 1px solid $light-grey-shade;\n    .header-title {\n      border-bottom: 1px solid $light-grey-shade;\n      padding: 21px 30px;\n      cursor: pointer;\n      p {\n        font-size: 18px;\n        font-weight: 600;\n        line-height: 27px;\n        color: $darken-grey;\n      }\n    }\n    .content-wrapper {\n      .content {\n        padding: 30px 30px 30px 30px;\n        .image {\n          min-width: 139px;\n          overflow: hidden;\n          position: relative;\n          img {\n            width: 139px;\n            height: 139px;\n            border-radius: 50%;\n            object-fit: cover;\n          }\n          span {\n            position: absolute;\n            bottom: 4px;\n            right: 5px;\n            width: 35px;\n            height: 35px;\n            border-radius: 50%;\n            background-color: $orange-color;\n            display: flex;\n            justify-content: center;\n            align-items: center;\n            cursor: pointer;\n            z-index: 1;\n            svg {\n              fill: $bg-white;\n            }\n          }\n        }\n        .items {\n          padding-left: 50px;\n          .col {\n            &:nth-child(1) {\n              min-width: 233px;\n            }\n            &:nth-child(2) {\n              min-width: 145px;\n            }\n          }\n          .item {\n            margin-bottom: 28px;\n            &.address {\n              width: fit-content;\n            }\n            p {\n              font-size: 15px;\n              font-weight: 500;\n              line-height: 22.5px;\n              color: $dark-black;\n              margin-bottom: 0;\n              &.title {\n                font-size: 13px;\n                font-weight: 400;\n                line-height: 19.5px;\n                color: $grey-color;\n              }\n            }\n            a {\n              color: $orange-color;\n              text-decoration: none;\n            }\n          }\n        }\n        .profile-form {\n          padding-left: 50px;\n          .form-inputs {\n            label {\n              font-size: 13px;\n              font-weight: 400;\n              line-height: 19.5px;\n              color: $grey-color;\n            }\n            input {\n              font-size: 14px;\n              font-weight: 500;\n              line-height: 22.5px;\n              color: $dark-black;\n            }\n            input[type=\"email\"] {\n              color: $orange-color;\n            }\n          }\n          button {\n            max-width: 145px;\n          }\n        }\n      }\n      // .update{\n      //     border: 0;\n      //     outline: 0;\n      //     background-color: transparent;\n      //     padding: 0;\n      //     p{\n      //         font-size: 15px;\n      //         font-weight: 500;\n      //         line-height: 22.5px;\n      //         color: $orange-color;\n      //     }\n      //     svg{\n      //         width: 14px;\n      //         height: 14px;\n      //         fill: $orange-color;;\n      //     }\n      // }\n    }\n  }\n}\n",".password {\n  padding: 30px 34px;\n  border-radius: 5px;\n  box-shadow: 0px 4px 30px 0px rgba(0, 0, 0, 0.08);\n  border: 1px solid $light-grey-shade;\n  .title {\n    font-size: 18px;\n    font-weight: 600;\n    line-height: 27px;\n    color: $dark-black;\n  }\n  .text {\n    font-size: 13px;\n    font-weight: 400;\n    line-height: 19.5px;\n    color: $grey-color;\n  }\n  .h-pass {\n    font-size: 15px;\n    font-weight: 500;\n    line-height: 22.5px;\n    color: $dark-black;\n  }\n  button {\n    max-width: 246px;\n    padding-left: 40px;\n    padding-right: 40px;\n  }\n}\n.password-form {\n  .title {\n    font-weight: 600;\n  }\n  .back-btn {\n    cursor: pointer;\n    fill: $orange-color;\n  }\n  .form-inputs {\n    label {\n      font-size: 13px;\n      color: $grey-color;\n      position: relative;\n      .tooltip {\n        position: absolute;\n        top: -18px;\n        // left: 108%;\n        left: 208%;\n        opacity: 1;\n        display: flex;\n        flex-direction: column;\n        visibility: visible;\n        background-color: $bg-white;\n        width: max-content;\n        height: fit-content;\n        ::before {\n          content: \"\";\n          position: absolute;\n          top: 24px;\n          left: 0;\n          margin-left: -12px;\n          border-width: 6px;\n          border-style: solid;\n          border-color: transparent rgba(255, 255, 255, 1) transparent\n            transparent;\n        }\n        p.t-title {\n          color: $dark-black;\n          font-size: 15px;\n          font-weight: 500;\n          line-height: 22.5px;\n          text-align: left;\n        }\n        ul.list {\n          padding-left: 15px;\n          li {\n            color: $grey-color;\n            font-size: 13px;\n            font-weight: 400;\n            line-height: 24px;\n            text-align: left;\n            span.green {\n              color: $dark-green;\n            }\n          }\n        }\n      }\n    }\n    input {\n      font-size: 13px;\n      &::placeholder {\n        color: $grey-shade-light-color;\n      }\n    }\n    .icon-info {\n      cursor: pointer;\n    }\n  }\n}\n",".Availability {\n  -webkit-box-shadow: 0px 4px 30px 0px rgba(0, 0, 0, 0.08);\n  -moz-box-shadow: 0px 4px 30px 0px rgba(0, 0, 0, 0.08);\n  box-shadow: 0px 4px 30px 0px rgba(0, 0, 0, 0.08);\n  border: 1px solid #e6e6e6;\n  padding: 21px 30px;\n  border-radius: 5px;\n  .title {\n    font-size: 18px;\n    font-weight: 600;\n    line-height: 27px;\n    color: $darken-grey;\n  }\n  .time-table {\n    .sub-text {\n      p {\n        font-size: 13px;\n        font-weight: 400;\n        line-height: 19.5px;\n        color: $dark-black;\n        margin-top: 20px;\n        margin-bottom: 17px;\n      }\n      ul {\n        li {\n          width: 56px;\n          height: 52px;\n          border-radius: 4px;\n          display: flex;\n          justify-content: center;\n          align-items: center;\n          position: relative;\n          cursor: pointer;\n          .checkbox-container {\n            width: 100%;\n            height: 100%;\n            .checkbox-text {\n              display: flex;\n              justify-content: center;\n              align-items: center;\n              color: #1d1d1d;\n              font-size: 13px;\n              font-weight: 500;\n              line-height: 19.5px;\n              background-color: #e6e7e6;\n              width: 100%;\n              height: 100%;\n              transition: all 0.2s;\n            }\n            input {\n              width: 100%;\n              height: 100%;\n              position: absolute;\n              visibility: hidden;\n            }\n            &.checked {\n              .checkbox-text {\n                background-color: #cc9752;\n                color: #fff;\n              }\n            }\n          }\n        }\n      }\n    }\n    table {\n      margin-top: 34px;\n      th,\n      td {\n        padding-left: 0;\n        padding-right: 0;\n        border: none;\n      }\n      th {\n        border-bottom: 2px solid #e1e1e1;\n      }\n      td {\n        font-size: 13px;\n        font-weight: 400;\n        line-height: 19.5px;\n        color: #5e5e5e;\n        padding: 0;\n        &.day {\n          font-size: 15px;\n          font-weight: 500;\n          line-height: 50px;\n          color: $dark-black;\n          width: 200px;\n        }\n        &.green-color {\n          font-size: 15px;\n          font-weight: 500;\n          line-height: 50px;\n          color: #42826c;\n        }\n        &.red-color {\n          font-size: 15px;\n          font-weight: 500;\n          line-height: 50px;\n          color: #dd0303;\n        }\n        .dob-picker-container {\n          .dob-picker-label {\n            margin-bottom: 0;\n          }\n        }\n        .dob-picker-container {\n          .dob-picker-input-wrapper {\n            .react-datepicker-wrapper {\n              .dob-picker-input {\n                padding: 0 0 0 0;\n              }\n            }\n          }\n        }\n        .to {\n          color: $dark-black;\n          padding-left: 32px;\n          padding-right: 32px;\n        }\n        .working-time-green {\n          color: #42826c;\n        }\n        .working-time-black,\n        .working-time-text {\n          color: $dark-black;\n        }\n      }\n    }\n  }\n  .dob-picker-input-wrapper {\n    svg {\n      fill: $dark-black;\n    }\n  }\n}\n","@import \"./sidebar\";\n@import \"./accordion\";\n@import \"./password\";\n@import \"./availability\";\n\n.profile-management {\n  padding-top: 30px;\n}\n",".account-type {\n  border-radius: 5px;\n  box-shadow: 0px 4px 30px 0px rgba(0, 0, 0, 0.08);\n  border: 1px solid $light-grey-shade;\n  padding: 21px 30px;\n  .title {\n    color: $dark-black;\n    font-size: 18px;\n    font-weight: 600;\n    line-height: 27px;\n  }\n  .type {\n    p {\n      color: $dark-green;\n      font-size: 20px;\n      font-weight: 500;\n      line-height: 30px;\n      margin-top: 28px;\n    }\n  }\n  .popup-container {\n    .close {\n      top: 20px;\n      right: 22px;\n    }\n    .popupWrapper {\n      width: 592px;\n      max-width: 100%;\n      .popup {\n        padding: 39px 50px;\n        .form-input {\n          max-width: 491px;\n        }\n      }\n      .titles {\n        color: $dark-black;\n        font-size: 20px;\n        font-weight: 600;\n        line-height: 30px;\n        span {\n          color: $dark-green;\n        }\n      }\n      .custom-checkbox {\n        display: flex;\n        align-items: center;\n        input[type=\"checkbox\"] {\n          position: absolute;\n          opacity: 0;\n          width: 0;\n          height: 0;\n        }\n        input[type=\"checkbox\"]:checked {\n          & + .custom-checkbox-box {\n            background-color: $orange-color;\n            border-color: $orange-color;\n            .checkbox-icon {\n              display: flex;\n            }\n          }\n        }\n        .custom-checkbox-box {\n          width: 18px;\n          height: 18px;\n          border: 1px solid $orange-color;\n          background: #fff;\n          display: flex;\n          align-items: center;\n          justify-content: center;\n          position: relative;\n          margin-right: 8px;\n          border-radius: 2px;\n          padding: 3px;\n          box-sizing: border-box;\n          transition: background-color 0.2s ease;\n          cursor: pointer;\n          margin-bottom: 0;\n        }\n        .checkbox-icon {\n          color: #fff;\n          font-size: 14px;\n          display: none;\n        }\n        .checkbox-label {\n          margin-left: 8px;\n          color: $dark-black;\n          .highlighted-text {\n            color: $orange-color;\n          }\n        }\n      }\n      .btn-wrap {\n        button {\n          width: 145px;\n        }\n      }\n      .popup {\n        .btn.no-bordered.custom-btn-primary {\n          width: 145px;\n        }\n      }\n      .checkbox {\n        a {\n          color: $orange-color;\n          text-decoration: none;\n        }\n      }\n    }\n  }\n}\n",".transfer-bar {\n  background-color: #f9f5ef;\n  border-radius: 4px;\n  padding: 24px 33px;\n  .item {\n    .title {\n      font-size: 15px;\n      font-weight: 400;\n      line-height: 22.5px;\n      color: $dark-black;\n    }\n    .price {\n      font-size: 30px;\n      font-weight: 700;\n      line-height: 45px;\n      color: $dark-green;\n    }\n  }\n}\n",".transfer-table {\n  .filter-btn-group {\n    .btn-border {\n      border: 1px solid $green-shade-eight;\n      border-radius: 5px;\n      color: $dark-black;\n      font-size: 13px;\n      font-weight: 400;\n      line-height: 23px;\n      padding: 7px 17px;\n      margin-left: 0;\n      &:not(:last-child) {\n        margin-right: 4px;\n      }\n      &.active {\n        color: $orange-color;\n        border: 1px solid $orange-color;\n      }\n    }\n  }\n  .border-sorting {\n    max-width: 200px;\n    border: 2px solid $light-grey;\n    border-radius: 500px;\n    // padding: 10px 15px;\n    padding: 10px 7px;\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    margin-left: 10px;\n    .dashboard-drop {\n      .dropdown-container-custom {\n        border: 0;\n        border-radius: 0;\n        padding: 0;\n      }\n    }\n  }\n}\n",".transfer-table {\n  .table-data {\n    .red {\n      fill: $color-red;\n    }\n    .green {\n      fill: $green-color;\n    }\n    .red-color {\n      color: $color-red;\n    }\n    .orange {\n      color: $orange-color;\n    }\n  }\n  .counter {\n    width: 18px;\n    height: 18px;\n    border-radius: 50%;\n    background-color: $dark-green;\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    color: $bg-white;\n    font-size: 13px;\n    font-weight: 400;\n  }\n}\n",".register {\n  .form-inputs {\n    padding-left: 0;\n    padding-right: 0;\n  }\n  .register-wrap {\n    box-shadow: 0px 2px 8px 0px rgba(156, 156, 156, 0.25);\n    border: 1px solid $grey-shade-light-color-two;\n    padding: 35px 20px;\n    box-sizing: border-box;\n    border-radius: 5px;\n    margin-top: 29px;\n  }\n  .moneytransfer-progress {\n    background-color: $light-yellow;\n    border-radius: 4px;\n    padding: 44px 33px 14px 33px;\n  }\n  .recipient-details {\n    p {\n      font-size: 18px;\n      font-weight: 600;\n      line-height: 27px;\n      color: $dark-black;\n    }\n  }\n  .registered-user {\n    .search-group,\n    .input-group-label {\n      border: 0;\n      border-bottom: 1px solid $grey-shade-nine;\n      max-width: none;\n      svg {\n        width: 13px;\n        height: 13px;\n      }\n      label {\n        font-size: 15px;\n        font-weight: 400;\n        line-height: 22.5px;\n        color: $dark-black;\n      }\n      input {\n        border: 0;\n        outline: 0;\n        box-shadow: none;\n        width: calc(100% - 13px);\n        height: 100%;\n        font-size: 13px;\n        font-weight: 400;\n        line-height: 19.5px;\n        color: $grey-shade-four;\n        &:focus {\n          outline: 0;\n          box-shadow: 0;\n        }\n      }\n    }\n    .preview-wrapper {\n      .title-top {\n        font-size: 18px;\n        font-weight: 600;\n        line-height: 27px;\n        color: $dark-black-shade;\n      }\n      .item {\n        padding: 0 57px;\n        box-sizing: border-box;\n        &:first-child {\n          padding-left: 0;\n        }\n        &:last-child {\n          padding-right: 0;\n        }\n        &:not(:last-child) {\n          border-right: 1px solid $grey-shade-ten;\n        }\n        .title {\n          width: max-content;\n          font-size: 13px;\n          font-weight: 400;\n          line-height: 19.5px;\n          color: $grey-color;\n        }\n        .description {\n          font-size: 15px;\n          font-weight: 500;\n          line-height: 22.5px;\n          color: $dark-black-shade;\n        }\n        .colored {\n          color: $orange-color;\n        }\n        .mail-id {\n          color: $orange-color;\n          font-weight: 500;\n        }\n      }\n    }\n    .no-bordered,\n    .bordered {\n      padding-left: 10px;\n      padding-right: 10px;\n    }\n  }\n  .popupWrapper {\n    .popup {\n      padding: 52px;\n      .icon {\n        height: 80px;\n        background-color: transparent;\n        width: 100%;\n        img {\n          width: 80px;\n          height: 80px;\n        }\n      }\n      h2 {\n        font-size: 26px;\n        font-weight: 600;\n        line-height: 39px;\n        color: $dark-black;\n      }\n      .light-text {\n        font-size: 15px;\n        font-weight: 400;\n        line-height: 24px;\n        color: $dark-black;\n      }\n      .btn-wrap {\n        .btn-mt {\n          width: 274px;\n        }\n      }\n    }\n  }\n  .unregistered-form-preview {\n    .preview-wrapper {\n      .section {\n        border-bottom: 1px solid $grey-shade-ten;\n        padding: 20px 0;\n      }\n      .item {\n        padding: 0;\n        &:not(:last-child) {\n          border-right: 0;\n          padding-right: 32px;\n        }\n      }\n    }\n  }\n}\n",".world-map {\n  position: relative;\n  width: 100%; /* Adjust the size as needed */\n  height: 100%; /* Adjust the size as needed */\n  margin: auto;\n  padding: 30px 0;\n}\n\n.map {\n  width: 100%;\n  height: auto;\n}\n\n.pin {\n  position: absolute;\n  // width: 15px; /* Size of the pin */\n  // height: 15px; /* Size of the pin */\n  // background-color: red; /* Pin color */\n  // border-radius: 50%;\n  cursor: pointer;\n}\n\n.tooltip {\n  visibility: hidden;\n  background-color: black;\n  color: white;\n  text-align: center;\n  border-radius: 5px;\n  padding: 5px;\n  position: absolute;\n  z-index: 1;\n  bottom: 20px; /* Positioning tooltip */\n  left: 50%;\n  transform: translateX(-50%);\n  transition: visibility 0.2s;\n}\n\n.pin:hover .tooltip {\n  visibility: visible;\n}\n\n.pin-image {\n  width: 22px;\n  height: 28px;\n}\n",".invite-table {\n  .form-bar {\n    background-color: #f9f5ef;\n    border-radius: 4px;\n    padding: 24px 33px 26px 33px;\n    margin-bottom: 28px;\n    .title {\n      font-size: 18px;\n      font-weight: 600;\n      line-height: 27px;\n      color: $dark-black;\n    }\n    .invite-btn {\n      // padding-left: 12px;\n      // padding-right: 12px;\n      padding-left: 11px;\n      padding-right: 11px;\n      font-size: 15px;\n    }\n  }\n  .table {\n    tbody {\n      tr {\n        td.orange {\n          color: $orange-color;\n        }\n        td {\n          img.pic {\n            width: 31px;\n            height: 31px;\n            border-radius: 50%;\n          }\n        }\n      }\n    }\n  }\n}\n",".time-picker-container {\n  .react-datepicker__time-container {\n    width: 100%;\n    height: 150px;\n    overflow: hidden;\n    .react-datepicker__time {\n      .react-datepicker__time-box {\n        width: 100%;\n        margin: 0;\n        ul.react-datepicker__time-list {\n          height: 100px;\n        }\n      }\n    }\n  }\n  .react-datepicker-time__header {\n    font-size: 11px;\n  }\n}\n",".assoicate-user {\n  .f-w-270 {\n    max-width: 270px;\n  }\n  .btn-otp {\n    padding: 0;\n    border: 0;\n    outline: 0;\n    background-color: transparent;\n    color: $orange-color;\n    cursor: pointer;\n    font-size: 13px;\n    font-weight: 400;\n    line-height: 19.5px;\n  }\n  .search-group {\n    label {\n      font-size: 15px;\n      font-weight: 400;\n      line-height: 22.5px;\n      text-align: left;\n      color: $dark-black;\n    }\n    input {\n      font-size: 13px;\n      font-weight: 300;\n      line-height: 19.5px;\n      color: $dark-black;\n      &::placeholder {\n        font-size: 13px;\n        font-weight: 300;\n        line-height: 19.5px;\n        color: $dark-black;\n      }\n    }\n    svg {\n      fill: $dark-black;\n    }\n  }\n  .preview-wrapper-associate {\n    margin-top: 34px;\n    .item {\n      &:not(:last-child) {\n        border-right: 1px solid;\n        padding-right: 34px;\n        margin: 6px;\n      }\n      &:last-child {\n        // margin-top: 24px;\n      }\n      .title {\n        width: max-content;\n        font-size: 13px;\n        font-weight: 400;\n        line-height: 19.5px;\n        color: $green-shade-five;\n      }\n      .description {\n        font-size: 15px;\n        font-weight: 500;\n        line-height: 22.5px;\n        color: $dark-black;\n      }\n    }\n  }\n  .associate-preview {\n    .section {\n      border-bottom: 1px solid $grey-shade-ten;\n      padding: 20px 0;\n    }\n    .title-top {\n      font-size: 18px;\n      font-weight: 600;\n      line-height: 27px;\n      color: $dark-black-shade;\n    }\n    .item {\n      padding: 0;\n      margin-bottom: 16px;\n      &:first-child {\n        padding-left: 0;\n      }\n      &:last-child {\n        padding-right: 0;\n      }\n      &:not(:last-child) {\n        padding-right: 95px;\n      }\n      .title {\n        width: max-content;\n        font-size: 13px;\n        font-weight: 400;\n        line-height: 19.5px;\n        color: $grey-color;\n      }\n      .description {\n        font-size: 15px;\n        font-weight: 500;\n        line-height: 22.5px;\n        color: $dark-black-shade;\n      }\n      .colored {\n        color: $orange-color;\n      }\n      .mail-id {\n        color: $orange-color;\n        font-weight: 500;\n      }\n    }\n  }\n  .green-box {\n    background-color: $green-shade-seven;\n    border-radius: 2px;\n    padding: 30px 36px;\n  }\n  .font-small {\n    font-size: 15px;\n    font-weight: 400;\n    line-height: 22.5px;\n    color: $dark-black;\n  }\n}\n",".transfer-table {\n  .border-sorting {\n    position: relative;\n    .filter {\n      .dropdown-menu-custom {\n        display: none;\n      }\n    }\n    .filter-popup {\n      position: absolute;\n      width: 403px;\n      top: 48px;\n      right: 0;\n      background: $bg-white;\n      border-radius: 5px;\n      box-shadow: 0px 2px 8px 0px rgba(156, 156, 156, 0.35);\n      border: 1px solid $grey-shade-light-color-two;\n      .title {\n        font-size: 20px;\n        font-weight: 600;\n        line-height: 30px;\n        color: $dark-black-dark-shade;\n        border-bottom: 1px solid $grey-shade-eleven-shade;\n        padding: 20px 30px;\n      }\n      .inner {\n        padding: 20px 30px;\n        .input {\n          font-size: 14px;\n          &::placeholder {\n            font-size: 14px;\n          }\n        }\n        label,\n        .dropdown-title {\n          color: $grey-shade-twelve-shade;\n        }\n        .form-inputs {\n          margin-top: 24px;\n          &:first-child {\n            margin-top: 0;\n          }\n        }\n        .dob-picker-container {\n          .dob-picker-input-wrapper {\n            svg {\n              font: $darken-grey;\n            }\n          }\n        }\n      }\n      .close {\n        position: absolute;\n        top: 20px;\n        right: 29px;\n        opacity: 1;\n        svg {\n          fill: $darken-grey;\n          width: 32px;\n          height: 32px;\n          stroke: $dark-black;\n          cursor: pointer;\n          opacity: 1;\n        }\n      }\n      .btn-group-filter {\n        background-color: $light-yellow-shade;\n        padding: 15px 30px;\n      }\n    }\n  }\n}\n",".tDetails {\n  box-shadow: 0px 2px 8px 0px rgba(156, 156, 156, 0.25);\n  border: 1px solid $grey-shade-light-color-two;\n  box-sizing: border-box;\n  border-radius: 9px;\n  margin-top: 29px;\n  overflow: hidden;\n  .tDetails-preview {\n    .section {\n      border-bottom: 0;\n      padding: 20px 0;\n      padding-bottom: 10px;\n    }\n    .title-top {\n      font-size: 18px;\n      font-weight: 600;\n      line-height: 27px;\n      color: $dark-black-shade;\n      border-bottom: 1px solid $grey-shade-ten;\n      padding-bottom: 20px;\n      margin-bottom: 20px;\n    }\n    .item {\n      padding: 0;\n      margin-bottom: 16px;\n      &:first-child {\n        padding-left: 0;\n      }\n      &:last-child {\n        padding-right: 0;\n      }\n      &:not(:last-child) {\n        padding-right: 95px;\n      }\n      .title {\n        width: max-content;\n        font-size: 13px;\n        font-weight: 400;\n        line-height: 19.5px;\n        color: $grey-color;\n      }\n      .description {\n        font-size: 15px;\n        font-weight: 500;\n        line-height: 22.5px;\n        color: $dark-black-shade;\n      }\n      .colored {\n        color: $orange-color;\n      }\n      .mail-id {\n        color: $orange-color;\n        font-weight: 500;\n      }\n    }\n  }\n  .form-inputs {\n    padding: 9px 36px;\n  }\n  .top-bar {\n    background: $light-yellow;\n    border-top-left-radius: 9px;\n    border-top-right-radius: 9px;\n    border-bottom: 1px solid $light-yellow-shade-two;\n    padding: 18px 38px;\n    .title {\n      font-size: 18px;\n      font-weight: 600;\n      line-height: 27px;\n      text-align: left;\n      color: $dark-black-dark-shade;\n      margin-left: 14px;\n    }\n    svg.back {\n      stroke: $dark-black-dark-shade;\n      width: 36px;\n      height: 24px;\n      cursor: pointer;\n    }\n    svg.download {\n      width: 21px;\n      height: 21px;\n      stroke: $orange-color;\n      margin-left: 27px;\n      cursor: pointer;\n    }\n  }\n  .tDetails-btn-group {\n    background-color: $light-yellow-shade;\n    padding: 24px 36px;\n    border-bottom-left-radius: 9px;\n    border-bottom-right-radius: 9px;\n    border-top: 1px solid $light-yellow-shade-two;\n    .btn {\n      padding-left: 38px;\n      padding-right: 38px;\n    }\n  }\n  .tDetails-popup.popup-container {\n    .close {\n      top: 20px;\n      right: 22px;\n    }\n    .popupWrapper {\n      width: 459px;\n      max-width: 100%;\n      max-height: unset;\n      overflow: hidden;\n      .popup {\n        padding: 0;\n      }\n      .titles {\n        font-size: 20px;\n        font-weight: 600;\n        line-height: 30px;\n        color: $dark-black-shade;\n        border-bottom: 1px solid $grey-shade-eleven-shade;\n        span {\n          color: $dark-green;\n        }\n      }\n      .custom-checkbox {\n        display: flex;\n        align-items: center;\n        input[type=\"checkbox\"] {\n          position: absolute;\n          opacity: 0;\n          width: 0;\n          height: 0;\n        }\n        input[type=\"checkbox\"]:checked {\n          & + .custom-checkbox-box {\n            background-color: $orange-color;\n            border-color: $orange-color;\n            .checkbox-icon {\n              display: flex;\n            }\n          }\n        }\n        .custom-checkbox-box {\n          width: 18px;\n          height: 18px;\n          border: 1px solid $orange-color;\n          background: #fff;\n          display: flex;\n          align-items: center;\n          justify-content: center;\n          position: relative;\n          margin-right: 8px;\n          border-radius: 2px;\n          padding: 3px;\n          box-sizing: border-box;\n          transition: background-color 0.2s ease;\n          cursor: pointer;\n          margin-bottom: 0;\n        }\n        .checkbox-icon {\n          color: #fff;\n          font-size: 14px;\n          display: none;\n        }\n        .checkbox-label {\n          margin-left: 8px;\n          color: $dark-black;\n          .highlighted-text {\n            color: $orange-color;\n          }\n        }\n      }\n      .pop-btn-wrap {\n        background-color: $light-yellow-shade;\n        padding: 15px 30px;\n        button {\n          width: \"\";\n          max-width: unset;\n        }\n      }\n      .popup {\n        .btn.no-bordered.custom-btn-primary {\n          width: unset;\n          max-width: unset;\n          padding-left: 31px;\n          padding-right: 31px;\n        }\n      }\n      .checkbox {\n        a {\n          color: $orange-color;\n          text-decoration: none;\n        }\n      }\n    }\n  }\n  .successful.popup-container {\n    .popupWrapper {\n      max-width: 598px;\n      max-height: unset;\n      padding: 46px 55px;\n      .popup {\n        .icon {\n          margin: 0 auto;\n          background-color: transparent;\n        }\n        h2 {\n          color: $dark-black-shade;\n          font-size: 26px;\n          line-height: 39px;\n          font-weight: 600;\n        }\n        .light-text {\n          color: $darken-grey;\n          line-height: 24px;\n        }\n      }\n    }\n  }\n}\n",".message-container {\n  .sidebar-message {\n    -webkit-box-shadow: 0px 4px 13px 0px rgba(0, 0, 0, 0.08);\n    -moz-box-shadow: 0px 4px 13px 0px rgba(0, 0, 0, 0.08);\n    box-shadow: 0px 4px 13px 0px rgba(0, 0, 0, 0.08);\n    border: 1px solid $light-grey-shade;\n    padding: 40px 20px;\n    width: 369px;\n    .search-group {\n      border: 0;\n      border-bottom: 1px solid $grey-color;\n      max-width: none;\n      margin-bottom: 27px;\n      svg {\n        width: 13px;\n        height: 13px;\n      }\n      label {\n        font-size: 15px;\n        font-weight: 400;\n        line-height: 22.5px;\n        color: $dark-black;\n      }\n      input {\n        border: 0;\n        outline: 0;\n        box-shadow: none;\n        width: calc(100% - 13px);\n        height: 100%;\n        font-size: 13px;\n        font-weight: 400;\n        line-height: 19.5px;\n        color: $green-color;\n        &:focus {\n          outline: 0;\n          box-shadow: 0;\n        }\n      }\n    }\n    ul {\n      li {\n        border-bottom: 1px solid #dfdfdf;\n        padding: 16px 0;\n        cursor: pointer;\n        &:first-child {\n          padding-top: 0;\n        }\n        &:last-child {\n          border-bottom: 0;\n        }\n        .user-image {\n          img {\n            width: 37px;\n            height: 37px;\n          }\n        }\n        .user {\n          // margin-left: 13px;\n          .user-name {\n            font-size: 15px;\n            font-weight: 500;\n            line-height: 22.5px;\n            color: $dark-black;\n          }\n          .user-message {\n            font-size: 12px;\n            font-weight: 300;\n            line-height: 18px;\n            color: $dark-green;\n          }\n        }\n        .message-date {\n          font-size: 13px;\n          font-weight: 500;\n          line-height: 19.5px;\n          color: $dark-green;\n        }\n      }\n    }\n  }\n  .chat-box {\n    width: 729px;\n    position: relative;\n    .user-info {\n      border-radius: 5px;\n      background-color: $dark-green;\n      padding: 19px 17px;\n      .user-image {\n        img {\n          width: 37px;\n          height: 37px;\n        }\n      }\n      .user {\n        margin-left: 13px;\n        .user-name {\n          font-size: 15px;\n          font-weight: 500;\n          line-height: 22.5px;\n          color: $bg-white;\n        }\n        .user-message {\n          font-size: 12px;\n          font-weight: 300;\n          line-height: 18px;\n          color: $bg-white;\n        }\n      }\n    }\n    .message-box {\n      padding-left: 20px;\n\n      .left-align {\n        margin: 17px 0;\n        img {\n          width: 40px;\n          height: 40px;\n        }\n        .mesg-field {\n          border: 1px solid $light-grey-shade-lihgt;\n          margin-left: 22px;\n          border-radius: 10px;\n          padding: 26px;\n          font-size: 15px;\n          font-weight: 400;\n          line-height: 24px;\n          color: $dark-black;\n        }\n        .time {\n          font-size: 13px;\n          font-weight: 400;\n          line-height: 19.5px;\n          color: $green-color;\n          margin-left: 61px;\n          margin-top: 8px;\n        }\n      }\n      .right-align {\n        img {\n          width: 40px;\n          height: 40px;\n          margin-left: 18px;\n        }\n        .mesg-field {\n          background-color: $light-grey-shade-light-bg;\n          border-radius: 10px;\n          padding: 21px 22px;\n          margin-left: 13px;\n        }\n        svg {\n          cursor: pointer;\n        }\n        .time {\n          font-size: 10px;\n          font-weight: 400;\n          line-height: 19.5px;\n          color: $green-color;\n          margin-left: 216px;\n          margin-top: 8px;\n        }\n      }\n    }\n    .input-box {\n      position: relative;\n      padding: 0 20px;\n    }\n\n    .input-box input {\n      width: 100%;\n      padding: 15px 50px 15px 18px; /* Adjust right padding for space for the send button */\n      border-radius: 25px;\n      border: 1px solid $green-shade-eight;\n      outline: none;\n      color: $darken-grey;\n    }\n\n    .input-box input:focus {\n      border-color: var(--green-shade-eight);\n      outline: none;\n    }\n\n    .input-box input::placeholder {\n      color: var(--light-grey-shade-three);\n    }\n\n    .input-box .send-button {\n      position: absolute;\n      top: 50%;\n      right: 12px; /* Adjust to align perfectly inside the border */\n      transform: translateY(-50%);\n      width: 40px; /* Adjust size as needed */\n      height: 40px;\n      cursor: pointer;\n    }\n  }\n}\n\n.message-main {\n  .fa-trash {\n    display: none;\n  }\n  &:hover {\n    .fa-trash {\n      display: block;\n    }\n  }\n}","@import \"../DashbaordTransaction/money-transfer-table\";\n\n.my-account {\n  .my-account-bar {\n    background-color: $light-yellow;\n    border-radius: 4px;\n    padding: 24px 33px;\n    .item {\n      .title {\n        font-size: 20px;\n        font-weight: 600;\n        line-height: 30px;\n        color: $dark-black;\n      }\n      .text {\n        font-size: 13px;\n        font-weight: 600;\n        line-height: 19.5px;\n        color: $green-color;\n      }\n    }\n    .buttons {\n      .price {\n        font-size: 30px;\n        font-weight: 700;\n        line-height: 45px;\n        color: $dark-green;\n        margin-right: 26px;\n      }\n      .bordered,\n      .thick-border {\n        font-size: 15px;\n        font-weight: 500;\n        width: 141px;\n        padding-left: 0;\n        padding-right: 0;\n        border: 2px solid $orange-color;\n      }\n      .no-bordered {\n        font-size: 15px;\n        font-weight: 500;\n        width: 159px;\n        padding-left: 0;\n        padding-right: 0;\n      }\n    }\n  }\n  .dashboard-table {\n    .dashboard-table-title {\n      p {\n        font-size: 15px;\n        line-height: 22.5px;\n      }\n    }\n    .search-group {\n      width: 309px;\n    }\n  }\n  .mx-fix {\n    max-width: 313px;\n  }\n}\n",".teller-table-all {\n  .filter-btn-group {\n    max-width: 275px;\n    margin-right: 15px;\n    .btn-border {\n      padding: 7px 13px;\n    }\n  }\n  .search-group-btn {\n    max-width: 178px;\n  }\n  .sorting-btn-group {\n    width: 54%;\n    .m-10 {\n      margin-right: 13px;\n    }\n    .create-btn-wrap {\n      max-width: 97px;\n      height: 47px;\n      .create-btn {\n        width: 100%;\n        height: 100%;\n        padding-left: 13px;\n        padding-right: 13px;\n        padding-top: 8px;\n        padding-bottom: 8px;\n        font-size: 13px;\n        font-weight: 500;\n        line-height: 19.5px;\n      }\n    }\n  }\n  .details-btn {\n    cursor: pointer;\n  }\n}\n",".teller-information {\n  .profile-box {\n    .content-wrapper {\n      .content {\n        .items {\n          .item {\n            p.green-color {\n              color: $dark-green;\n            }\n          }\n        }\n      }\n    }\n  }\n  .content-boxx {\n    width: calc(100% - 139px);\n  }\n  .upload-container {\n    padding: 36px 30px;\n  }\n  .upload-wrap {\n    border: 1px solid $light-grey-shade;\n    width: calc(50% - 15px);\n    border-radius: 2px;\n    padding: 14px 22px;\n    margin-bottom: 30px;\n    .file {\n      width: 17px;\n      height: 21px;\n    }\n    .delete-wrap {\n      height: 16px;\n      display: flex;\n      .delete {\n        width: 16px;\n        height: 16px;\n        cursor: pointer;\n      }\n    }\n    .filename {\n      font-size: 15px;\n      font-weight: 400;\n      line-height: 22.5px;\n      color: $grey-shade-twelve-shade;\n      margin-left: 14px;\n    }\n    .view {\n      width: 16px;\n      height: 16px;\n      margin-right: 25px;\n      margin-left: 14px;\n      cursor: pointer;\n    }\n  }\n  .add-btn {\n    input {\n      display: none;\n    }\n    .add-btn-btn {\n      width: 121px;\n      padding: 13px 30px;\n      border: 2px solid $orange-color;\n      color: $orange-color;\n      font-size: 18px;\n      font-weight: 500;\n      line-height: 27px;\n      border-radius: 100px;\n      cursor: pointer;\n    }\n  }\n}\n","@import \"../../components/progress-bar\";\n\n.create-account-container {\n  .shadow-box {\n    box-shadow: 0px 2px 8px 0px rgba(156, 156, 156, 0.25);\n    border: 1px solid $grey-shade-light-color-two;\n    padding: 35px 20px;\n    box-sizing: border-box;\n    border-radius: 5px;\n    margin-top: 29px;\n  }\n  .teller-progress {\n    background-color: $light-yellow;\n    border-radius: 4px;\n    padding: 64px 33px 34px;\n  }\n  .form-inputs {\n    h3 {\n      font-size: 18px;\n      font-weight: 600;\n      line-height: 27px;\n      color: $dark-black;\n    }\n  }\n  .btn-teller-group {\n    margin-top: 34px;\n    .btn,\n    .bordered,\n    .no-bordered {\n      padding-top: 13px;\n      padding-bottom: 13px;\n      padding-left: 38px;\n      padding-right: 38px;\n      max-width: 160px;\n    }\n  }\n  .popup-container {\n    .popupWrapper {\n      .popup {\n        .icon {\n          background-color: transparent;\n        }\n        h2 {\n          color: $dark-black;\n        }\n      }\n    }\n  }\n}\n","@import \"./dashboard-sidebar\";\n@import \"./dashboard-topbar\";\n@import \"./dashboard-userbar\";\n@import \"./dashboard-card\";\n@import \"./barChart\";\n@import \"./dashboarDatepicker\";\n@import \"./dashboard-drop\";\n@import \"./dashboard-table\";\n@import \"./button-status\";\n@import \"./Pagination/pagination\";\n@import \"./dashboar-recharge/recharge-account\";\n@import \"./dashboard-profile/profile-management\";\n@import \"./dashboard-profile/account-type\";\n@import \"./DashbaordTransaction/tansaction\";\n@import \"./DashboardMap/dashboard-map\";\n@import \"./DashboardInviteUser/invite-user.scss\";\n@import \"./TimePickerCustom\";\n@import \"./DashboardAssociateUser/associateUser\";\n@import \"./DashbaordTransaction/filter-popup\";\n@import \"./DashbaordTransaction/transaction-details\";\n@import \"./dashboar-message/message\";\n@import \"./Dashbaord-myaccount/myaccount\";\n@import \"./TellerAccount/teller-account\";\n@import \"./TellerAccount/teller-info\";\n@import \"./TellerAccount/create-account\";\n\n.normal-dashboard {\n  background-color: $bg-white;\n  min-height: 100vh;\n  position: relative;\n  transition: 0.5s all;\n  .p-15 {\n    padding-left: 15px;\n    padding-right: 15px;\n  }\n  .dashboard-main-content {\n    // margin-left: 258px;\n    padding-right: 15px;\n    padding-left: 15px;\n    width: calc(100% - 258px);\n    position: absolute;\n    top: 0;\n    transition: 0.5s all;\n    right: 0;\n    // .container-fluid{\n    //     max-width: 986px;\n    // }\n  }\n  .copyright-footer {\n    padding: 15px 0 12px;\n    width: auto;   \n    position: fixed;\n    bottom: 0;\n    background: #fff;\n    @include md {\n      width: 85%;\n      padding: 25px 0 22px;\n    }\n    p {\n      font-size: 12px;\n      font-weight: 400;\n      line-height: 1.6;\n      color: $grey-shade-six;\n      @include md {\n        font-size: 14px;\n      }\n      a {\n        color: $grey-shade-five;\n        margin: 0 5px;\n      }\n    }    \n  }\n  .chat-icon {\n    position: fixed;\n    bottom: 30px;\n    right: 30px;\n    width: 66px;\n    height: 66px;\n    border-radius: 50%;\n    cursor: pointer;\n  }\n  .dashboard-table {\n    .table {\n      tbody {\n        tr {\n          td.orange {\n            color: $orange-color;\n          }\n        }\n      }\n    }\n  }\n  .table-responsive {\n    // max-width: 986px;\n    overflow-x: auto;\n    table {\n      max-width: 100%;\n      width: 100%;\n    }\n  }\n}\n\n.full-width {\n  transition: 0.2s all;\n  width: calc(100% - 110px) !important;\n}\n.halfsidebar {\n  transition: 0.5s all;\n  max-width: 100px !important;\n}\n\n.halfsidebar p {\n  visibility: hidden;\n  display: none;\n}\n\n.halfsidebar svg {\n  width: 25px !important;\n  height: 25px !important;\n}\n\n.halfsidebar .list-box {\n  justify-content: center !important;\n}\n",".tooltip {\n  padding: 24px 27px;\n  border-radius: 5px;\n  box-shadow: 0px 4px 20px 0px rgba(0, 0, 0, 0.2);\n}\n",".user-management {\n}\n\n.manage-user {\n  .admin-um-multistep {\n    .form-inputs {\n      .sub-head {\n        font-size: 18px;\n        font-weight: 600;\n        line-height: 27px;\n        color: $dark-black;\n      }\n    }\n    .profile-box {\n      .content-wrapper {\n        .content {\n          .items {\n            .item {\n              .btn-red {\n                p {\n                  color: $red-shade-one;\n                }\n              }\n            }\n          }\n        }\n      }\n    }\n    .upload-container {\n      .doc-wrap {\n        width: calc(50% - 15px);\n      }\n      .doc-title {\n        font-size: 15px;\n        font-weight: 400;\n        line-height: 22.5px;\n        color: $dark-black;\n        margin-bottom: 0;\n      }\n    }\n  }\n}\n\n.admin-um-ud {\n  .back-btn {\n    font-size: 18px;\n    font-weight: 600;\n    line-height: 27px;\n    color: $dark-black;\n    cursor: pointer;\n    padding: 20px 0;\n    svg {\n      width: 24px;\n      height: 16px;\n    }\n  }\n  .content-boxx {\n    width: calc(100% - 139px);\n  }\n  .upload-container {\n    padding: 36px 30px;\n  }\n  .upload-wrap {\n    border-bottom: 2px solid $light-grey-shade;\n    border-radius: 2px;\n    padding: 14px 0;\n    margin-bottom: 30px;\n    .file {\n      width: 17px;\n      height: 21px;\n    }\n    .delete-wrap {\n      height: 16px;\n      display: flex;\n      .delete {\n        width: 16px;\n        height: 16px;\n        cursor: pointer;\n      }\n    }\n    .filename {\n      font-size: 15px;\n      font-weight: 400;\n      line-height: 22.5px;\n      color: $grey-shade-twelve-shade;\n      margin-left: 14px;\n    }\n    .view {\n      width: 16px;\n      height: 16px;\n      margin-right: 14px;\n      margin-left: 14px;\n      cursor: pointer;\n    }\n    svg.download {\n      margin-right: 14px;\n      fill: $orange-color;\n      cursor: pointer;\n    }\n  }\n  .add-btn {\n    input {\n      display: none;\n    }\n    .add-btn-btn {\n      width: 121px;\n      padding: 13px 30px;\n      border: 2px solid $orange-color;\n      color: $orange-color;\n      font-size: 18px;\n      font-weight: 500;\n      line-height: 27px;\n      border-radius: 100px;\n      cursor: pointer;\n    }\n  }\n  .date {\n    font-size: 15px;\n    font-weight: 700;\n    line-height: 22.5px;\n    color: $dark-black;\n  }\n  table.table-activity {\n    width: 100%;\n    tbody {\n      tr {\n        display: flex;\n        justify-content: space-between;\n        width: 100%;\n        align-items: center;\n        border-bottom: 1px solid #e6e6e6;\n        padding: 14px 0;\n        td {\n          display: flex;\n          span {\n            color: $brigh-green;\n          }\n          img {\n            width: 36px;\n            height: 36px;\n            border-radius: 50%;\n          }\n          .user-name {\n            p {\n              font-size: 14px;\n              font-weight: 400;\n              line-height: 21px;\n              color: $grey-color;\n              &.title {\n                font-size: 15px;\n                font-weight: 600;\n                line-height: 22.5px;\n                color: $dark-black;\n              }\n            }\n          }\n          .long-text {\n            font-size: 14px;\n            font-weight: 500;\n            line-height: 21px;\n            color: $grey-shade-thirteen-shade;\n            b {\n              color: $darken-grey;\n            }\n          }\n        }\n      }\n    }\n  }\n  .header-title {\n    .header-btn {\n      svg {\n        width: 17px;\n        height: 17px;\n      }\n      p {\n        font-size: 15px;\n        font-weight: 500;\n        line-height: 22.5px;\n        color: $orange-color;\n      }\n    }\n  }\n  .profile-box {\n    .content-wrapper {\n      .content {\n        .items {\n          .item {\n            .btn-red {\n              p {\n                color: $red-shade-one;\n              }\n            }\n          }\n        }\n      }\n    }\n  }\n  .upload-container {\n    .doc-wrap {\n      width: calc(50% - 15px);\n    }\n    .doc-title {\n      font-size: 15px;\n      font-weight: 400;\n      line-height: 22.5px;\n      color: $dark-black;\n      margin-bottom: 0;\n    }\n  }\n  .search-group {\n    width: 209px;\n  }\n}\n",".shadow {\n  border-bottom: 1px solid $light-grey-shade;\n  border: 1px solid rgba(156, 156, 156, 0.35);\n  padding: 21px 30px;\n  cursor: pointer;\n  .card-header {\n    h1 {\n      font-size: 18px;\n      font-weight: 600;\n      line-height: 27px;\n      color: $darken-grey;\n    }\n  }\n  .search-group {\n    border: 0;\n    border-bottom: 2px solid $grey-shade-nine;\n    max-width: none;\n    width: 230px;\n    svg {\n      width: 13px;\n      height: 13px;\n    }\n    label {\n      font-size: 15px;\n      font-weight: 400;\n      line-height: 22.5px;\n      color: $dark-black;\n    }\n    input {\n      border: 0;\n      outline: 0;\n      box-shadow: none;\n      width: 100%;\n      height: 100%;\n      font-size: 13px;\n      font-weight: 400;\n      line-height: 19.5px;\n      color: $grey-shade-four;\n      &:focus {\n        outline: 0;\n        box-shadow: 0;\n      }\n    }\n  }\n  .no-bordered,\n  .bordered {\n    padding-top: 10px;\n    padding-bottom: 10px;\n    padding-left: 20px;\n    padding-right: 20px;\n  }\n  .input-field {\n    border-radius: 0;\n    input,\n    select {\n      color: $grey-color;\n      border: 0;\n      border-bottom: 1px solid $border-color;\n      width: 100%;\n      background: transparent;\n      padding: 0 0 8px 0;\n      border-radius: 0;\n      box-shadow: none;\n    }\n    label {\n      color: $dark-black;\n      font-size: 15px;\n      font-weight: 400;\n      line-height: 22.5px;\n      margin-bottom: 0;\n    }\n  }\n  .custom-checkbox {\n    display: flex;\n    align-items: center;\n    input[type=\"checkbox\"] {\n      position: absolute;\n      opacity: 0;\n      width: 18px;\n      height: 18px;\n      z-index: 1;\n    }\n    input[type=\"checkbox\"]:checked {\n      & + .custom-checkbox-box {\n        background-color: $orange-color;\n        border-color: $orange-color;\n        .checkbox-icon {\n          display: flex;\n        }\n      }\n    }\n    .custom-checkbox-box {\n      width: 18px;\n      height: 18px;\n      border: 1px solid $orange-color;\n      background: #fff;\n      display: flex;\n      align-items: center;\n      justify-content: center;\n      position: relative;\n      margin-right: 8px;\n      border-radius: 2px;\n      padding: 3px;\n      box-sizing: border-box;\n      transition: background-color 0.2s ease;\n      cursor: pointer;\n      margin-bottom: 0;\n    }\n    .checkbox-icon {\n      color: #fff;\n      font-size: 14px;\n      display: none;\n    }\n    .checkbox-label {\n      margin-left: 8px;\n      color: $dark-black;\n      .highlighted-text {\n        color: $orange-color;\n      }\n    }\n  }\n  .no-text {\n    p {\n      display: none;\n    }\n  }\n}\n\n.modal-popup {\n  .input-field {\n    border-radius: 0;\n    input,\n    select {\n      color: $grey-color;\n      border: 0;\n      border-bottom: 1px solid $border-color;\n      width: 100%;\n      background: transparent;\n      padding: 0 0 8px 0;\n      border-radius: 0;\n      box-shadow: none;\n    }\n    label {\n      color: $dark-black;\n      font-size: 15px;\n      font-weight: 400;\n      line-height: 22.5px;\n      margin-bottom: 0;\n    }\n  }\n  .modal-content {\n    padding: 30px;\n    .modal-title {\n      font-size: 18px;\n      font-weight: 600;\n      line-height: 27px;\n      color: $darken-grey;\n      position: relative;\n      width: 100%;\n      .close {\n        padding: 0;\n        position: absolute;\n        width: 30px;\n        height: 30px;\n        top: 0;\n        right: 0;\n        border: 0;\n        box-shadow: none;\n        background-color: transparent;\n        opacity: 1;\n        svg {\n          width: 20px;\n          height: 20px;\n          color: $dark-black;\n        }\n      }\n    }\n  }\n  .assoicate-user {\n    .associate-preview {\n      .section {\n        border-bottom: 0;\n        padding: 0;\n        margin-left: -20px;\n        margin-right: -20px;\n      }\n      .item {\n        // width: fit-content;\n        // min-width: 25%;\n        // padding-right: 38px;\n        width: auto;\n        min-width: 25%;\n        margin-right: 20px;\n        margin-left: 20px;\n        padding-right: 0;\n      }\n    }\n  }\n}\n\n.custom-table {\n  .table {\n    thead,\n    tbody {\n      th,\n      td {\n        background-color: transparent;\n        padding: 14px;\n      }\n    }\n    tbody {\n      tr {\n        td.orange {\n          color: $orange-color;\n        }\n        td {\n          padding: 12px 8px;\n          .dropdown {\n            a {\n              padding: 0;\n              i {\n                color: $orange-color;\n              }\n              &:hover {\n                box-shadow: none;\n              }\n              &.text-light:hover,\n              &.text-light:focus {\n                box-shadow: none;\n              }\n            }\n          }\n          p.role-button {\n            border: 2px solid $light-grey;\n            border-radius: 500px;\n            padding: 7px 12px;\n            display: flex;\n            justify-content: center;\n            align-items: center;\n          }\n        }\n      }\n    }\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
